'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var redux = require('redux');
var toolkit = require('@reduxjs/toolkit');
var es6Promise = require('es6-promise');
var moment = require('moment');
var uuid = require('uuid');
var jsonwebtoken = require('jsonwebtoken');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var jsonwebtoken__default = /*#__PURE__*/_interopDefaultLegacy(jsonwebtoken);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _readOnlyError(name) {
  throw new TypeError("\"" + name + "\" is read-only");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var httpMessage = {
  OkMessage: "200 Successful",
  ErroMessage: "500 Internal server error"
};
var defaultReject = {
  loading: false,
  error: true,
  message: "",
  data: {}
};
var defaultState = {
  List: {
    loading: false,
    error: false,
    data: [],
    message: ""
  },
  Info: {
    loading: false,
    error: false,
    data: {},
    message: ""
  }
};

var MedicationGenerateResponse = function MedicationGenerateResponse(TaskAgainstState) {
  var Data = TaskAgainstState === null || TaskAgainstState === void 0 ? void 0 : TaskAgainstState.map(function (val, i) {
    var _val$PH_OrderLineDisp, _val$disptype, _val$disptype2, _val$scenarioId, _val$scenarioId$, _val$drugPhoto, _val$drugPhoto$, _val$PH_OrderLineAler, _val$drugType, _val$drug_category, _val$formCode, _val$GenericDrug, _val$GenericDrug$, _val$presMode, _val$presNature, _val$encounter_Id$, _val$encounter_Id$$he, _val$requestor, _val$requestor$, _val$requestor$$pract, _val$requestor$$pract2, _val$requestor$$pract3, _val$encounter_Id, _val$encounter_Id$2, _val$encounter_Id$2$p, _val$encounter_Id$2$p2, _val$encounter_Id$2$p3, _val$encounter_Id$2$p4, _val$encounter_Id$2$p5, _val$encounter_Id$2$p6, _val$encounter_Id2, _val$encounter_Id2$, _val$encounter_Id2$$p, _val$encounter_Id2$$p2, _val$drugPhoto2, _val$drugPhoto2$, _val$encounter_Id3, _val$encounter_Id3$, _val$encounter_Id3$$p, _val$encounter_Id3$$p2, _val$encounter_Id3$$p3, _val$encounter_Id3$$p4, _val$encounter_Id3$$p5, _val$encounter_Id3$$p6, _val$requestor2, _val$requestor2$, _val$requestor2$$prac, _val$requestor2$$prac2, _val$requestor2$$prac3, _val$disptype3, _val$DrugCompoundDeta, _val$DrugCompoundDeta2, _NewSchedule$, _NewSchedule$0$return, _NewSchedule$2, _val$drugDetails, _val$drugDetails$, _val$drugDetails2, _val$drugDetails2$, _val$drugDetails3, _val$drugDetails3$, _NewSchedule$3, _NewSchedule$3$return, _NewSchedule$4, _NewSchedule$4$status, _NewSchedule$4$status2, _NewSchedule$5, _NewSchedule$5$status, _objectSpread2$1;

    var NewSchedule = val === null || val === void 0 ? void 0 : (_val$PH_OrderLineDisp = val.PH_OrderLineDispenseSchedule) === null || _val$PH_OrderLineDisp === void 0 ? void 0 : _val$PH_OrderLineDisp.sort(function (a, b) {
      return (b === null || b === void 0 ? void 0 : b.updatedate) - a.updatedate;
    });
    return _objectSpread2((_objectSpread2$1 = {
      uniqueId: uuid.v4(),
      id: val === null || val === void 0 ? void 0 : val._id,
      isIV: getDrugType(val === null || val === void 0 ? void 0 : (_val$disptype = val.disptype) === null || _val$disptype === void 0 ? void 0 : _val$disptype.code),
      isCompound: getisCompound(val === null || val === void 0 ? void 0 : (_val$disptype2 = val.disptype) === null || _val$disptype2 === void 0 ? void 0 : _val$disptype2.code),
      ScenarioName: val === null || val === void 0 ? void 0 : (_val$scenarioId = val.scenarioId) === null || _val$scenarioId === void 0 ? void 0 : (_val$scenarioId$ = _val$scenarioId[0]) === null || _val$scenarioId$ === void 0 ? void 0 : _val$scenarioId$.scenarioname,
      deliveringDispenseDuration: 0,
      Recievednextrefilldate: 0,
      elapsedTime: "00:12",
      delay: "2 days",
      drugPhotoId: val === null || val === void 0 ? void 0 : (_val$drugPhoto = val.drugPhoto) === null || _val$drugPhoto === void 0 ? void 0 : (_val$drugPhoto$ = _val$drugPhoto[0]) === null || _val$drugPhoto$ === void 0 ? void 0 : _val$drugPhoto$.fileid,
      dispenseStatus: "New",
      clinicalValidation: true,
      alertCount: val === null || val === void 0 ? void 0 : (_val$PH_OrderLineAler = val.PH_OrderLineAlertLogs) === null || _val$PH_OrderLineAler === void 0 ? void 0 : _val$PH_OrderLineAler.length,
      drugColor: "yellow",
      isHomeMedicationOrder: true,
      remarks: [{
        personName: "Dr. Roger Richards",
        type: "Verifier",
        role: "Consultant",
        addedOn: "24/02/2022 10:00",
        remark: "Instruction given by doctor in Rx"
      }],
      name: val === null || val === void 0 ? void 0 : val.orderdescription,
      doseStrength: "".concat(val === null || val === void 0 ? void 0 : val.dosageValue, "  ").concat(val === null || val === void 0 ? void 0 : val.dosageUOM),
      route: val === null || val === void 0 ? void 0 : val.routeCode,
      frequency: {
        code: val === null || val === void 0 ? void 0 : val.dosageFreqCode,
        unit: 3
      },
      orderinfo: {
        title: "Oder Info",
        drugtype: val === null || val === void 0 ? void 0 : (_val$drugType = val.drugType) === null || _val$drugType === void 0 ? void 0 : _val$drugType.longdesc,
        drugcode: val === null || val === void 0 ? void 0 : val.drugName,
        dosage: "".concat(val === null || val === void 0 ? void 0 : val.dosageValue).concat(val === null || val === void 0 ? void 0 : val.dosageUOM),
        catagory: val === null || val === void 0 ? void 0 : (_val$drug_category = val.drug_category) === null || _val$drug_category === void 0 ? void 0 : _val$drug_category.longdesc,
        route: val === null || val === void 0 ? void 0 : val.routeCode,
        form: val === null || val === void 0 ? void 0 : (_val$formCode = val.formCode) === null || _val$formCode === void 0 ? void 0 : _val$formCode.longdesc,
        generic: val === null || val === void 0 ? void 0 : (_val$GenericDrug = val.GenericDrug) === null || _val$GenericDrug === void 0 ? void 0 : (_val$GenericDrug$ = _val$GenericDrug[0]) === null || _val$GenericDrug$ === void 0 ? void 0 : _val$GenericDrug$.longdesc,
        mode: val === null || val === void 0 ? void 0 : (_val$presMode = val.presMode) === null || _val$presMode === void 0 ? void 0 : _val$presMode.display,
        nature: val === null || val === void 0 ? void 0 : (_val$presNature = val.presNature) === null || _val$presNature === void 0 ? void 0 : _val$presNature.display,
        duration: "".concat(val === null || val === void 0 ? void 0 : val.dosageDurationValue).concat(val === null || val === void 0 ? void 0 : val.dosageDurationUOM),
        startdate: moment__default["default"].unix(val === null || val === void 0 ? void 0 : val.occurStartDateTime).format("MM-DD-YYYY hh:mm"),
        enddate: moment__default["default"].unix(val === null || val === void 0 ? void 0 : val.occurEndDateTime).format("MM-DD-YYYY hh:mm"),
        diagnosis: val === null || val === void 0 ? void 0 : (_val$encounter_Id$ = val.encounter_Id[0]) === null || _val$encounter_Id$ === void 0 ? void 0 : (_val$encounter_Id$$he = _val$encounter_Id$.health_of_service) === null || _val$encounter_Id$$he === void 0 ? void 0 : _val$encounter_Id$$he.map(function (val) {
          return val === null || val === void 0 ? void 0 : val.name;
        }),
        doctorName: makeName(val === null || val === void 0 ? void 0 : (_val$requestor = val.requestor) === null || _val$requestor === void 0 ? void 0 : (_val$requestor$ = _val$requestor[0]) === null || _val$requestor$ === void 0 ? void 0 : (_val$requestor$$pract = _val$requestor$.practId) === null || _val$requestor$$pract === void 0 ? void 0 : (_val$requestor$$pract2 = _val$requestor$$pract[0]) === null || _val$requestor$$pract2 === void 0 ? void 0 : (_val$requestor$$pract3 = _val$requestor$$pract2.name) === null || _val$requestor$$pract3 === void 0 ? void 0 : _val$requestor$$pract3[0]),
        id: "34562",
        contactnumber: "",
        specialityname: val === null || val === void 0 ? void 0 : (_val$encounter_Id = val.encounter_Id) === null || _val$encounter_Id === void 0 ? void 0 : (_val$encounter_Id$2 = _val$encounter_Id[0]) === null || _val$encounter_Id$2 === void 0 ? void 0 : (_val$encounter_Id$2$p = _val$encounter_Id$2.practitioner_details) === null || _val$encounter_Id$2$p === void 0 ? void 0 : (_val$encounter_Id$2$p2 = _val$encounter_Id$2$p[0]) === null || _val$encounter_Id$2$p2 === void 0 ? void 0 : (_val$encounter_Id$2$p3 = _val$encounter_Id$2$p2.speciality) === null || _val$encounter_Id$2$p3 === void 0 ? void 0 : (_val$encounter_Id$2$p4 = _val$encounter_Id$2$p3[0]) === null || _val$encounter_Id$2$p4 === void 0 ? void 0 : (_val$encounter_Id$2$p5 = _val$encounter_Id$2$p4.coding) === null || _val$encounter_Id$2$p5 === void 0 ? void 0 : (_val$encounter_Id$2$p6 = _val$encounter_Id$2$p5[0]) === null || _val$encounter_Id$2$p6 === void 0 ? void 0 : _val$encounter_Id$2$p6.display,
        clinicname: val === null || val === void 0 ? void 0 : (_val$encounter_Id2 = val.encounter_Id) === null || _val$encounter_Id2 === void 0 ? void 0 : (_val$encounter_Id2$ = _val$encounter_Id2[0]) === null || _val$encounter_Id2$ === void 0 ? void 0 : (_val$encounter_Id2$$p = _val$encounter_Id2$.practitioner_details) === null || _val$encounter_Id2$$p === void 0 ? void 0 : (_val$encounter_Id2$$p2 = _val$encounter_Id2$$p[0]) === null || _val$encounter_Id2$$p2 === void 0 ? void 0 : _val$encounter_Id2$$p2.clinic,
        drugPhoto: val === null || val === void 0 ? void 0 : (_val$drugPhoto2 = val.drugPhoto) === null || _val$drugPhoto2 === void 0 ? void 0 : (_val$drugPhoto2$ = _val$drugPhoto2[0]) === null || _val$drugPhoto2$ === void 0 ? void 0 : _val$drugPhoto2$.fileid
      },
      duration: "".concat(val === null || val === void 0 ? void 0 : val.dosageDurationValue, " ").concat(val === null || val === void 0 ? void 0 : val.dosageDurationUOM),
      speciality: (val === null || val === void 0 ? void 0 : (_val$encounter_Id3 = val.encounter_Id) === null || _val$encounter_Id3 === void 0 ? void 0 : (_val$encounter_Id3$ = _val$encounter_Id3[0]) === null || _val$encounter_Id3$ === void 0 ? void 0 : (_val$encounter_Id3$$p = _val$encounter_Id3$.practitioner_details) === null || _val$encounter_Id3$$p === void 0 ? void 0 : (_val$encounter_Id3$$p2 = _val$encounter_Id3$$p[0]) === null || _val$encounter_Id3$$p2 === void 0 ? void 0 : (_val$encounter_Id3$$p3 = _val$encounter_Id3$$p2.speciality) === null || _val$encounter_Id3$$p3 === void 0 ? void 0 : (_val$encounter_Id3$$p4 = _val$encounter_Id3$$p3[0]) === null || _val$encounter_Id3$$p4 === void 0 ? void 0 : (_val$encounter_Id3$$p5 = _val$encounter_Id3$$p4.coding) === null || _val$encounter_Id3$$p5 === void 0 ? void 0 : (_val$encounter_Id3$$p6 = _val$encounter_Id3$$p5[0]) === null || _val$encounter_Id3$$p6 === void 0 ? void 0 : _val$encounter_Id3$$p6.display) || "",
      startDate: moment__default["default"].unix(val === null || val === void 0 ? void 0 : val.occurStartDateTime).format("MM/DD/YYYY, hh:mm"),
      endDate: moment__default["default"].unix(val === null || val === void 0 ? void 0 : val.occurEndDateTime).format("MM/DD/YYYY, hh:mm"),
      doctorName: makeName(val === null || val === void 0 ? void 0 : (_val$requestor2 = val.requestor) === null || _val$requestor2 === void 0 ? void 0 : (_val$requestor2$ = _val$requestor2[0]) === null || _val$requestor2$ === void 0 ? void 0 : (_val$requestor2$$prac = _val$requestor2$.practId) === null || _val$requestor2$$prac === void 0 ? void 0 : (_val$requestor2$$prac2 = _val$requestor2$$prac[0]) === null || _val$requestor2$$prac2 === void 0 ? void 0 : (_val$requestor2$$prac3 = _val$requestor2$$prac2.name) === null || _val$requestor2$$prac3 === void 0 ? void 0 : _val$requestor2$$prac3[0]),
      brands: getFillingBrands(val === null || val === void 0 ? void 0 : val.PH_OrderLineDispenseSchedule, true),
      additives: getFillingAdditives(val === null || val === void 0 ? void 0 : val.PH_OrderLineDispenseSchedule, true),
      compounds: getisCompound(val === null || val === void 0 ? void 0 : (_val$disptype3 = val.disptype) === null || _val$disptype3 === void 0 ? void 0 : _val$disptype3.code) ? getFillingCompounds(val === null || val === void 0 ? void 0 : val.PH_OrderLineDispenseSchedule, val === null || val === void 0 ? void 0 : (_val$DrugCompoundDeta = val.DrugCompoundDetails) === null || _val$DrugCompoundDeta === void 0 ? void 0 : (_val$DrugCompoundDeta2 = _val$DrugCompoundDeta[0]) === null || _val$DrugCompoundDeta2 === void 0 ? void 0 : _val$DrugCompoundDeta2.compondCompDTls) : [],
      dispenseDuration: NewSchedule === null || NewSchedule === void 0 ? void 0 : (_NewSchedule$ = NewSchedule[0]) === null || _NewSchedule$ === void 0 ? void 0 : _NewSchedule$.dispdurval,
      dispenseDurationValue: val === null || val === void 0 ? void 0 : val.totDispQtyUOM,
      returndate: (_NewSchedule$0$return = NewSchedule === null || NewSchedule === void 0 ? void 0 : (_NewSchedule$2 = NewSchedule[0]) === null || _NewSchedule$2 === void 0 ? void 0 : _NewSchedule$2.returndate) !== null && _NewSchedule$0$return !== void 0 ? _NewSchedule$0$return : ""
    }, _defineProperty(_objectSpread2$1, "dispenseDurationValue", val === null || val === void 0 ? void 0 : val.totDispQtyUOM), _defineProperty(_objectSpread2$1, "partialAllow", val === null || val === void 0 ? void 0 : (_val$drugDetails = val.drugDetails) === null || _val$drugDetails === void 0 ? void 0 : (_val$drugDetails$ = _val$drugDetails[0]) === null || _val$drugDetails$ === void 0 ? void 0 : _val$drugDetails$.partialQtyAllow), _defineProperty(_objectSpread2$1, "returnApplicable", val === null || val === void 0 ? void 0 : (_val$drugDetails2 = val.drugDetails) === null || _val$drugDetails2 === void 0 ? void 0 : (_val$drugDetails2$ = _val$drugDetails2[0]) === null || _val$drugDetails2$ === void 0 ? void 0 : _val$drugDetails2$.returnApplicable), _defineProperty(_objectSpread2$1, "returnPolicy", val === null || val === void 0 ? void 0 : (_val$drugDetails3 = val.drugDetails) === null || _val$drugDetails3 === void 0 ? void 0 : (_val$drugDetails3$ = _val$drugDetails3[0]) === null || _val$drugDetails3$ === void 0 ? void 0 : _val$drugDetails3$.returnPolicy), _defineProperty(_objectSpread2$1, "statusReason", (NewSchedule === null || NewSchedule === void 0 ? void 0 : (_NewSchedule$3 = NewSchedule[0]) === null || _NewSchedule$3 === void 0 ? void 0 : (_NewSchedule$3$return = _NewSchedule$3.returnreason) === null || _NewSchedule$3$return === void 0 ? void 0 : _NewSchedule$3$return.display) || (NewSchedule === null || NewSchedule === void 0 ? void 0 : (_NewSchedule$4 = NewSchedule[0]) === null || _NewSchedule$4 === void 0 ? void 0 : (_NewSchedule$4$status = _NewSchedule$4.statushistory) === null || _NewSchedule$4$status === void 0 ? void 0 : (_NewSchedule$4$status2 = _NewSchedule$4$status[(NewSchedule === null || NewSchedule === void 0 ? void 0 : (_NewSchedule$5 = NewSchedule[0]) === null || _NewSchedule$5 === void 0 ? void 0 : (_NewSchedule$5$status = _NewSchedule$5.statushistory) === null || _NewSchedule$5$status === void 0 ? void 0 : _NewSchedule$5$status.length) - 1]) === null || _NewSchedule$4$status2 === void 0 ? void 0 : _NewSchedule$4$status2.remarks) || ""), _objectSpread2$1), val);
  });
  return Data;
}; // Data construction

var GenerateResponse = function GenerateResponse(TaskAgainstState, dispenseDura, calculateDispenseStrength) {
  var Data = TaskAgainstState === null || TaskAgainstState === void 0 ? void 0 : TaskAgainstState.map(function (val, i) {
    var _val$scenarioId2, _val$scenarioId2$, _val$encounter_Id4, _val$encounter_Id4$, _val$encounter_Id4$$t, _val$disptype4, _val$disptype5, _val$drugPhoto3, _val$drugPhoto3$, _val$scenarioId4, _val$scenarioId4$, _val$drugType2, _val$drug_category2, _val$formCode2, _val$GenericDrug2, _val$GenericDrug2$, _val$presMode2, _val$presNature2, _val$encounter_Id$3, _val$encounter_Id$3$h, _val$requestor3, _val$requestor3$, _val$requestor3$$prac, _val$requestor3$$prac2, _val$requestor3$$prac3, _val$encounter_Id$4, _val$encounter_Id$4$p, _val$encounter_Id$4$p2, _val$encounter_Id$4$p3, _val$encounter_Id$4$p4, _val$encounter_Id$4$p5, _val$encounter_Id$5, _val$encounter_Id$5$p, _val$drugPhoto4, _val$drugPhoto4$, _val$encounter_Id5, _val$encounter_Id5$, _val$encounter_Id5$$p, _val$encounter_Id5$$p2, _val$encounter_Id5$$p3, _val$encounter_Id5$$p4, _val$encounter_Id5$$p5, _val$encounter_Id5$$p6, _val$requestor4, _val$requestor4$, _val$requestor4$$prac, _val$requestor4$$prac2, _val$requestor4$$prac3, _val$disptype6, _val$DrugCompoundDeta3, _val$DrugCompoundDeta4, _dispenseDura$i4, _dispenseDura$i5, _dispenseDura$i6;

    var obj = {};

    if ((val === null || val === void 0 ? void 0 : (_val$scenarioId2 = val.scenarioId) === null || _val$scenarioId2 === void 0 ? void 0 : (_val$scenarioId2$ = _val$scenarioId2[0]) === null || _val$scenarioId2$ === void 0 ? void 0 : _val$scenarioId2$.scenarioname) === "IP") {
      var _dispenseDura$i, _dispenseDura$i2, _val$scenarioId3, _val$scenarioId3$;

      // occurStartDateTime = dispenseDura?.[i]?.dispStartDate
      // occurEndDateTime = dispenseDura?.[i]?.dispEndDate
      obj = {
        Cartid: dispenseDura === null || dispenseDura === void 0 ? void 0 : (_dispenseDura$i = dispenseDura[i]) === null || _dispenseDura$i === void 0 ? void 0 : _dispenseDura$i.cartid,
        CartTransId: dispenseDura === null || dispenseDura === void 0 ? void 0 : (_dispenseDura$i2 = dispenseDura[i]) === null || _dispenseDura$i2 === void 0 ? void 0 : _dispenseDura$i2.cartTransId
      };

      if ((val === null || val === void 0 ? void 0 : (_val$scenarioId3 = val.scenarioId) === null || _val$scenarioId3 === void 0 ? void 0 : (_val$scenarioId3$ = _val$scenarioId3[0]) === null || _val$scenarioId3$ === void 0 ? void 0 : _val$scenarioId3$.scenarioname) === "IP") {
        var _dispenseDura$i3;

        val["dosageDurationUOMIp"] = //Suresh asked to add for IP Order alone
        (dispenseDura === null || dispenseDura === void 0 ? void 0 : (_dispenseDura$i3 = dispenseDura[i]) === null || _dispenseDura$i3 === void 0 ? void 0 : _dispenseDura$i3.dosageDurationUOM) || (val === null || val === void 0 ? void 0 : val.dosageDurationUOM) || "";
      }
    }

    return _objectSpread2(_objectSpread2(_objectSpread2({}, obj), {}, {
      uniqueId: uuid.v4(),
      EncounterType: val === null || val === void 0 ? void 0 : (_val$encounter_Id4 = val.encounter_Id) === null || _val$encounter_Id4 === void 0 ? void 0 : (_val$encounter_Id4$ = _val$encounter_Id4[0]) === null || _val$encounter_Id4$ === void 0 ? void 0 : (_val$encounter_Id4$$t = _val$encounter_Id4$.type) === null || _val$encounter_Id4$$t === void 0 ? void 0 : _val$encounter_Id4$$t.code,
      id: val === null || val === void 0 ? void 0 : val._id,
      isIV: getDrugType(val === null || val === void 0 ? void 0 : (_val$disptype4 = val.disptype) === null || _val$disptype4 === void 0 ? void 0 : _val$disptype4.code),
      isCompound: getisCompound(val === null || val === void 0 ? void 0 : (_val$disptype5 = val.disptype) === null || _val$disptype5 === void 0 ? void 0 : _val$disptype5.code),
      drugPhotoId: val === null || val === void 0 ? void 0 : (_val$drugPhoto3 = val.drugPhoto) === null || _val$drugPhoto3 === void 0 ? void 0 : (_val$drugPhoto3$ = _val$drugPhoto3[0]) === null || _val$drugPhoto3$ === void 0 ? void 0 : _val$drugPhoto3$.fileid,
      ScenarioName: val === null || val === void 0 ? void 0 : (_val$scenarioId4 = val.scenarioId) === null || _val$scenarioId4 === void 0 ? void 0 : (_val$scenarioId4$ = _val$scenarioId4[0]) === null || _val$scenarioId4$ === void 0 ? void 0 : _val$scenarioId4$.scenarioname,
      elapsedTime: "00:12",
      deliveringDispenseDuration: 0,
      delay: "2 days",
      dispenseStatus: "New",
      clinicalValidation: true,
      alerts: val === null || val === void 0 ? void 0 : val.PH_OrderLineAlertLogs,
      drugColor: "yellow",
      isHomeMedicationOrder: true,
      // remarks: [
      //   {
      //     personName: "Dr. Roger Richards",
      //     type: "Verifier",
      //     role: "Consultant",
      //     addedOn: "24/02/2022 10:00",
      //     remark: "Instruction given by doctor in Rx",
      //   },
      // ],
      name: val === null || val === void 0 ? void 0 : val.orderdescription,
      doseStrength: "".concat(val === null || val === void 0 ? void 0 : val.dosageValue, "  ").concat(val === null || val === void 0 ? void 0 : val.dosageUOM),
      route: val === null || val === void 0 ? void 0 : val.routeCode,
      frequency: {
        code: val === null || val === void 0 ? void 0 : val.dosageFreqCode,
        unit: 3
      },
      orderinfo: {
        title: "Oder Info",
        drugtype: val === null || val === void 0 ? void 0 : (_val$drugType2 = val.drugType) === null || _val$drugType2 === void 0 ? void 0 : _val$drugType2.longdesc,
        drugcode: val === null || val === void 0 ? void 0 : val.drugName,
        dosage: "".concat(val === null || val === void 0 ? void 0 : val.dosageValue).concat(val === null || val === void 0 ? void 0 : val.dosageUOM),
        catagory: val === null || val === void 0 ? void 0 : (_val$drug_category2 = val.drug_category) === null || _val$drug_category2 === void 0 ? void 0 : _val$drug_category2.longdesc,
        route: val === null || val === void 0 ? void 0 : val.routeCode,
        form: val === null || val === void 0 ? void 0 : (_val$formCode2 = val.formCode) === null || _val$formCode2 === void 0 ? void 0 : _val$formCode2.longdesc,
        generic: val === null || val === void 0 ? void 0 : (_val$GenericDrug2 = val.GenericDrug) === null || _val$GenericDrug2 === void 0 ? void 0 : (_val$GenericDrug2$ = _val$GenericDrug2[0]) === null || _val$GenericDrug2$ === void 0 ? void 0 : _val$GenericDrug2$.longdesc,
        mode: val === null || val === void 0 ? void 0 : (_val$presMode2 = val.presMode) === null || _val$presMode2 === void 0 ? void 0 : _val$presMode2.display,
        nature: val === null || val === void 0 ? void 0 : (_val$presNature2 = val.presNature) === null || _val$presNature2 === void 0 ? void 0 : _val$presNature2.display,
        duration: "".concat(val === null || val === void 0 ? void 0 : val.dosageDurationValue).concat(val === null || val === void 0 ? void 0 : val.dosageDurationUOM),
        startdate: moment__default["default"].unix(val === null || val === void 0 ? void 0 : val.occurStartDateTime).format("MM-DD-YYYY hh:mm"),
        enddate: moment__default["default"].unix(val === null || val === void 0 ? void 0 : val.occurEndDateTime).format("MM-DD-YYYY hh:mm"),
        diagnosis: val === null || val === void 0 ? void 0 : (_val$encounter_Id$3 = val.encounter_Id[0]) === null || _val$encounter_Id$3 === void 0 ? void 0 : (_val$encounter_Id$3$h = _val$encounter_Id$3.health_of_service) === null || _val$encounter_Id$3$h === void 0 ? void 0 : _val$encounter_Id$3$h.map(function (val) {
          return val === null || val === void 0 ? void 0 : val.name;
        }),
        doctorName: makeName(val === null || val === void 0 ? void 0 : (_val$requestor3 = val.requestor) === null || _val$requestor3 === void 0 ? void 0 : (_val$requestor3$ = _val$requestor3[0]) === null || _val$requestor3$ === void 0 ? void 0 : (_val$requestor3$$prac = _val$requestor3$.practId) === null || _val$requestor3$$prac === void 0 ? void 0 : (_val$requestor3$$prac2 = _val$requestor3$$prac[0]) === null || _val$requestor3$$prac2 === void 0 ? void 0 : (_val$requestor3$$prac3 = _val$requestor3$$prac2.name) === null || _val$requestor3$$prac3 === void 0 ? void 0 : _val$requestor3$$prac3[0]),
        id: "34562",
        contactnumber: "+91 95854 25622",
        specialityname: val === null || val === void 0 ? void 0 : (_val$encounter_Id$4 = val.encounter_Id[0]) === null || _val$encounter_Id$4 === void 0 ? void 0 : (_val$encounter_Id$4$p = _val$encounter_Id$4.practitioner_details[0]) === null || _val$encounter_Id$4$p === void 0 ? void 0 : (_val$encounter_Id$4$p2 = _val$encounter_Id$4$p.speciality) === null || _val$encounter_Id$4$p2 === void 0 ? void 0 : (_val$encounter_Id$4$p3 = _val$encounter_Id$4$p2[0]) === null || _val$encounter_Id$4$p3 === void 0 ? void 0 : (_val$encounter_Id$4$p4 = _val$encounter_Id$4$p3.coding) === null || _val$encounter_Id$4$p4 === void 0 ? void 0 : (_val$encounter_Id$4$p5 = _val$encounter_Id$4$p4[0]) === null || _val$encounter_Id$4$p5 === void 0 ? void 0 : _val$encounter_Id$4$p5.display,
        clinicname: val === null || val === void 0 ? void 0 : (_val$encounter_Id$5 = val.encounter_Id[0]) === null || _val$encounter_Id$5 === void 0 ? void 0 : (_val$encounter_Id$5$p = _val$encounter_Id$5.practitioner_details[0]) === null || _val$encounter_Id$5$p === void 0 ? void 0 : _val$encounter_Id$5$p.clinic,
        drugPhoto: val === null || val === void 0 ? void 0 : (_val$drugPhoto4 = val.drugPhoto) === null || _val$drugPhoto4 === void 0 ? void 0 : (_val$drugPhoto4$ = _val$drugPhoto4[0]) === null || _val$drugPhoto4$ === void 0 ? void 0 : _val$drugPhoto4$.fileid
      },
      duration: "".concat(val === null || val === void 0 ? void 0 : val.dosageDurationValue, " ").concat(val === null || val === void 0 ? void 0 : val.dosageDurationUOM),
      speciality: (val === null || val === void 0 ? void 0 : (_val$encounter_Id5 = val.encounter_Id) === null || _val$encounter_Id5 === void 0 ? void 0 : (_val$encounter_Id5$ = _val$encounter_Id5[0]) === null || _val$encounter_Id5$ === void 0 ? void 0 : (_val$encounter_Id5$$p = _val$encounter_Id5$.practitioner_details) === null || _val$encounter_Id5$$p === void 0 ? void 0 : (_val$encounter_Id5$$p2 = _val$encounter_Id5$$p[0]) === null || _val$encounter_Id5$$p2 === void 0 ? void 0 : (_val$encounter_Id5$$p3 = _val$encounter_Id5$$p2.speciality) === null || _val$encounter_Id5$$p3 === void 0 ? void 0 : (_val$encounter_Id5$$p4 = _val$encounter_Id5$$p3[0]) === null || _val$encounter_Id5$$p4 === void 0 ? void 0 : (_val$encounter_Id5$$p5 = _val$encounter_Id5$$p4.coding) === null || _val$encounter_Id5$$p5 === void 0 ? void 0 : (_val$encounter_Id5$$p6 = _val$encounter_Id5$$p5[0]) === null || _val$encounter_Id5$$p6 === void 0 ? void 0 : _val$encounter_Id5$$p6.display) || "",
      startDate: moment__default["default"].unix(val === null || val === void 0 ? void 0 : val.occurStartDateTime).format("MM/DD/YYYY, hh:mm"),
      endDate: moment__default["default"].unix(val === null || val === void 0 ? void 0 : val.occurEndDateTime).format("MM/DD/YYYY, hh:mm"),
      doctorName: makeName(val === null || val === void 0 ? void 0 : (_val$requestor4 = val.requestor) === null || _val$requestor4 === void 0 ? void 0 : (_val$requestor4$ = _val$requestor4[0]) === null || _val$requestor4$ === void 0 ? void 0 : (_val$requestor4$$prac = _val$requestor4$.practId) === null || _val$requestor4$$prac === void 0 ? void 0 : (_val$requestor4$$prac2 = _val$requestor4$$prac[0]) === null || _val$requestor4$$prac2 === void 0 ? void 0 : (_val$requestor4$$prac3 = _val$requestor4$$prac2.name) === null || _val$requestor4$$prac3 === void 0 ? void 0 : _val$requestor4$$prac3[0]),
      brands: getBrands(val === null || val === void 0 ? void 0 : val.mappedItems, calculateDispenseStrength, i, "dispenseDetails"),
      additives: getAttitive(val === null || val === void 0 ? void 0 : val.addtictive, calculateDispenseStrength, i),
      compounds: getisCompound(val === null || val === void 0 ? void 0 : (_val$disptype6 = val.disptype) === null || _val$disptype6 === void 0 ? void 0 : _val$disptype6.code) ? getCompound(val === null || val === void 0 ? void 0 : (_val$DrugCompoundDeta3 = val.DrugCompoundDetails) === null || _val$DrugCompoundDeta3 === void 0 ? void 0 : (_val$DrugCompoundDeta4 = _val$DrugCompoundDeta3[0]) === null || _val$DrugCompoundDeta4 === void 0 ? void 0 : _val$DrugCompoundDeta4.compondCompDTls) : [],
      dispenseDuration: dispenseDura === null || dispenseDura === void 0 ? void 0 : (_dispenseDura$i4 = dispenseDura[i]) === null || _dispenseDura$i4 === void 0 ? void 0 : _dispenseDura$i4.dispDuration,
      dispenseDurationValue: dispenseDura === null || dispenseDura === void 0 ? void 0 : dispenseDura[i],
      OrderId: val === null || val === void 0 ? void 0 : val._id,
      drug_id: val === null || val === void 0 ? void 0 : val.drug_id
    }, val), {}, {
      nextrefilldate: (dispenseDura === null || dispenseDura === void 0 ? void 0 : (_dispenseDura$i5 = dispenseDura[i]) === null || _dispenseDura$i5 === void 0 ? void 0 : _dispenseDura$i5.nextrefilldate) || (dispenseDura === null || dispenseDura === void 0 ? void 0 : (_dispenseDura$i6 = dispenseDura[i]) === null || _dispenseDura$i6 === void 0 ? void 0 : _dispenseDura$i6.nextRefillDate),
      Recievednextrefilldate: val === null || val === void 0 ? void 0 : val.nextrefilldate,
      isOnHold: isVridyHoldAllState(val === null || val === void 0 ? void 0 : val.statuscode)
    });
  });
  return Data;
}; //brands

var getBrands = function getBrands(Data, Dispensestrength, brandIndex, name, additiveIndex) {
  var SelectedBrandIndex = name === "additiveDetails" ? additiveIndex : 0;
  var SortedData = Data.sort(function (a, b) {
    return a.seqno - b.seqno;
  });
  var option = Data === null || Data === void 0 ? void 0 : Data.map(function (val) {
    return val;
  });
  var brands = Data === null || Data === void 0 ? void 0 : Data.map(function (item, i) {
    var _SortedData$;

    if ((item === null || item === void 0 ? void 0 : item.dispensedrugcode) === (SortedData === null || SortedData === void 0 ? void 0 : (_SortedData$ = SortedData[0]) === null || _SortedData$ === void 0 ? void 0 : _SortedData$.dispensedrugcode) && i === 0) {
      var _item$drugPhoto, _item$drugPhoto$, _Dispensestrength$bra, _Dispensestrength$bra2, _Dispensestrength$bra3, _Dispensestrength$bra4, _Dispensestrength$bra5, _Dispensestrength$bra6, _Dispensestrength$bra7, _Dispensestrength$bra8, _Dispensestrength$bra9, _Dispensestrength$bra10, _Dispensestrength$bra11, _Dispensestrength$bra12, _Dispensestrength$bra13, _Dispensestrength$bra14, _Dispensestrength$bra15, _item$drugreleasetype;

      return _objectSpread2({
        uniqueId: uuid.v4(),
        id: item === null || item === void 0 ? void 0 : item.dispensedrugcode,
        dispensedrugcode: item === null || item === void 0 ? void 0 : item.dispensedrugcode,
        drugPhotoId: item === null || item === void 0 ? void 0 : (_item$drugPhoto = item.drugPhoto) === null || _item$drugPhoto === void 0 ? void 0 : (_item$drugPhoto$ = _item$drugPhoto[0]) === null || _item$drugPhoto$ === void 0 ? void 0 : _item$drugPhoto$.fileid,
        name: item === null || item === void 0 ? void 0 : item.drugName,
        allStrength: Dispensestrength === null || Dispensestrength === void 0 ? void 0 : (_Dispensestrength$bra = Dispensestrength[brandIndex]) === null || _Dispensestrength$bra === void 0 ? void 0 : (_Dispensestrength$bra2 = _Dispensestrength$bra[name]) === null || _Dispensestrength$bra2 === void 0 ? void 0 : (_Dispensestrength$bra3 = _Dispensestrength$bra2[SelectedBrandIndex]) === null || _Dispensestrength$bra3 === void 0 ? void 0 : _Dispensestrength$bra3.dispenseStrength,
        strength: "".concat(Dispensestrength === null || Dispensestrength === void 0 ? void 0 : (_Dispensestrength$bra4 = Dispensestrength[brandIndex]) === null || _Dispensestrength$bra4 === void 0 ? void 0 : (_Dispensestrength$bra5 = _Dispensestrength$bra4[name]) === null || _Dispensestrength$bra5 === void 0 ? void 0 : (_Dispensestrength$bra6 = _Dispensestrength$bra5[SelectedBrandIndex]) === null || _Dispensestrength$bra6 === void 0 ? void 0 : _Dispensestrength$bra6.dispenseUOMText),
        route: "Oral",
        doseCount: 0,
        tabPerDose: 0,
        actualdoseCount: 0,
        batches: [],
        option: option,
        dosageValue: Dispensestrength === null || Dispensestrength === void 0 ? void 0 : (_Dispensestrength$bra7 = Dispensestrength[brandIndex]) === null || _Dispensestrength$bra7 === void 0 ? void 0 : (_Dispensestrength$bra8 = _Dispensestrength$bra7[name]) === null || _Dispensestrength$bra8 === void 0 ? void 0 : (_Dispensestrength$bra9 = _Dispensestrength$bra8[SelectedBrandIndex]) === null || _Dispensestrength$bra9 === void 0 ? void 0 : _Dispensestrength$bra9.dispenseStrength,
        dosageUOM: Dispensestrength === null || Dispensestrength === void 0 ? void 0 : (_Dispensestrength$bra10 = Dispensestrength[brandIndex]) === null || _Dispensestrength$bra10 === void 0 ? void 0 : (_Dispensestrength$bra11 = _Dispensestrength$bra10[name]) === null || _Dispensestrength$bra11 === void 0 ? void 0 : (_Dispensestrength$bra12 = _Dispensestrength$bra11[SelectedBrandIndex]) === null || _Dispensestrength$bra12 === void 0 ? void 0 : _Dispensestrength$bra12.dispenseUOMText,
        dosageUOM_id: Dispensestrength === null || Dispensestrength === void 0 ? void 0 : (_Dispensestrength$bra13 = Dispensestrength[brandIndex]) === null || _Dispensestrength$bra13 === void 0 ? void 0 : (_Dispensestrength$bra14 = _Dispensestrength$bra13[name]) === null || _Dispensestrength$bra14 === void 0 ? void 0 : (_Dispensestrength$bra15 = _Dispensestrength$bra14[SelectedBrandIndex]) === null || _Dispensestrength$bra15 === void 0 ? void 0 : _Dispensestrength$bra15.dispenseUOM,
        drugReleaseType: (_item$drugreleasetype = item === null || item === void 0 ? void 0 : item.drugreleasetype) !== null && _item$drugreleasetype !== void 0 ? _item$drugreleasetype : ""
      }, item);
    }
  }).filter(function (notUndefined) {
    return notUndefined !== undefined;
  });
  return brands;
}; //get Attitive


var getAttitive = function getAttitive(additives, Dispensestrength, brandIndex) {
  var Additives = additives === null || additives === void 0 ? void 0 : additives.map(function (item, additiveIndex) {
    return _objectSpread2({
      uniqueId: uuid.v4(),
      name: item === null || item === void 0 ? void 0 : item.adorderdescription,
      brands: getBrands(item === null || item === void 0 ? void 0 : item.mappedeItems, Dispensestrength, brandIndex, "additiveDetails", additiveIndex)
    }, item);
  });
  return Additives;
}; //batches


var getBatches = function getBatches(data, name) {
  var batches = data === null || data === void 0 ? void 0 : data.map(function (val) {
    if ((val === null || val === void 0 ? void 0 : val.itemcd) === name) {
      return _objectSpread2({
        uniqueId: uuid.v4(),
        id: val === null || val === void 0 ? void 0 : val.batchno,
        expiryDate: moment__default["default"](val === null || val === void 0 ? void 0 : val.expdate).format("MM/DD/YYYY"),
        bin: {
          number: val === null || val === void 0 ? void 0 : val.binlocty,
          aisle: val === null || val === void 0 ? void 0 : val.binname // shelf: val?.loccode,
          // level: val?.locrefno,

        },
        availableQuantity: val === null || val === void 0 ? void 0 : val.stockqty,
        availableQuantityUOM: val === null || val === void 0 ? void 0 : val.stockuom,
        heldQuantity: val === null || val === void 0 ? void 0 : val.blockqty,
        totalAmount: val === null || val === void 0 ? void 0 : val.chargeprice,
        Quantity: "".concat(val === null || val === void 0 ? void 0 : val.chargeqty, " ").concat(val === null || val === void 0 ? void 0 : val.chargeuom)
      }, val);
    }
  }).filter(function (notUndefined) {
    return notUndefined !== undefined;
  });
  return batches;
}; //get compound batch

var getCompoundBatch = function getCompoundBatch(data, days) {
  var _data$batchdeatils;

  var newDate = new Date();
  var date = newDate.setDate(newDate.getDate() + days);
  var batches = data === null || data === void 0 ? void 0 : (_data$batchdeatils = data.batchdeatils) === null || _data$batchdeatils === void 0 ? void 0 : _data$batchdeatils.map(function (val) {
    var _ref;

    return _ref = {
      uniqueId: uuid.v4(),
      id: "",
      expdate: moment__default["default"](date).format("MM/DD/YYYY"),
      issueqty: val === null || val === void 0 ? void 0 : val.issueqty,
      issueuom: data === null || data === void 0 ? void 0 : data.issueuomtext,
      stockqty: val === null || val === void 0 ? void 0 : val.stockqty,
      stockuom: data === null || data === void 0 ? void 0 : data.stockuomtext,
      blockqty: val === null || val === void 0 ? void 0 : val.blockqty,
      chargeprice: 0,
      binlocty: "",
      binname: "",
      costdisprice: 0
    }, _defineProperty(_ref, "binlocty", ""), _defineProperty(_ref, "chargeqty", ""), _defineProperty(_ref, "chargeuom", ""), _ref;
  });
  return batches;
}; //getCompound

var getCompound = function getCompound(data) {
  var Compound = [];

  if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
    data === null || data === void 0 ? void 0 : data.forEach(function (item, i) {
      var _item$mappedItems;

      item === null || item === void 0 ? void 0 : (_item$mappedItems = item.mappedItems) === null || _item$mappedItems === void 0 ? void 0 : _item$mappedItems.forEach(function (val) {
        var _val$drugPhoto5, _val$drugPhoto5$, _item$compReleaseType;

        Compound.push(_objectSpread2({
          uniqueId: uuid.v4(),
          id: val === null || val === void 0 ? void 0 : val.dispensedrugcode,
          drugPhotoId: val === null || val === void 0 ? void 0 : (_val$drugPhoto5 = val.drugPhoto) === null || _val$drugPhoto5 === void 0 ? void 0 : (_val$drugPhoto5$ = _val$drugPhoto5[0]) === null || _val$drugPhoto5$ === void 0 ? void 0 : _val$drugPhoto5$.fileid,
          dispensedrugcode: val === null || val === void 0 ? void 0 : val.dispensedrugcode,
          drugNameLong: val === null || val === void 0 ? void 0 : val.drugNameLong,
          name: val === null || val === void 0 ? void 0 : val.drugName,
          allStrength: "",
          strength: "",
          dosageValue: item === null || item === void 0 ? void 0 : item.compQty,
          dosageUOM: item === null || item === void 0 ? void 0 : item.compQtyUomText,
          dosageUOM_id: item === null || item === void 0 ? void 0 : item.compQtyUom,
          drugReleaseType: item === null || item === void 0 ? void 0 : (_item$compReleaseType = item.compReleaseType) === null || _item$compReleaseType === void 0 ? void 0 : _item$compReleaseType._id
        }, val));
      });
    });
  }

  return Compound;
}; //payload construction for verifier functionalities.


var generateVerifyData = function generateVerifyData(data, selectedState, patientId, action, status, practitionerData, reIssueReason, reIssue) {
  var _data$brands, _data$additives, _data$compounds, _practitionerData$org, _practitionerData$org2, _practitionerData$org3, _practitionerData$fac, _practitionerData$fac2, _practitionerData$fac3, _data$scenarioId, _data$scenarioId$, _practitionerData$fac4, _practitionerData$fac5, _data$encounter_Id$0$, _data$encounter_Id, _data$encounter_Id$, _data$encounter_Id$$t, _data$encounter_Id2, _data$encounter_Id2$, _data$encounter_Id2$$, _practitionerData$loc, _practitionerData$loc2, _practitionerData$loc3, _practitionerData$loc4, _timeFormat$orgdatefo, _timeFormat$orgdateti, _timeFormat$orgtimefo, _practitionerData$ent, _practitionerData$ent2, _practitionerData$org4, _practitionerData$org5, _practitionerData$loc5, _practitionerData$loc6, _data$encounter_Id3, _data$encounter_Id3$, _data$encounter_Id4, _data$encounter_Id4$, _data$verifyReason;

  var batches = [];
  data === null || data === void 0 ? void 0 : (_data$brands = data.brands) === null || _data$brands === void 0 ? void 0 : _data$brands.forEach(function (val) {
    batches.push(val.batches);
  });
  data === null || data === void 0 ? void 0 : (_data$additives = data.additives) === null || _data$additives === void 0 ? void 0 : _data$additives.forEach(function (val) {
    var _val$brands;

    (_val$brands = val.brands) === null || _val$brands === void 0 ? void 0 : _val$brands.forEach(function (item) {
      batches.push(item.batches);
    });
  });
  data === null || data === void 0 ? void 0 : (_data$compounds = data.compounds) === null || _data$compounds === void 0 ? void 0 : _data$compounds.forEach(function (val) {
    batches.push(val.batches);
  });
  var orgAlise = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$org = practitionerData.org) === null || _practitionerData$org === void 0 ? void 0 : (_practitionerData$org2 = _practitionerData$org.alias) === null || _practitionerData$org2 === void 0 ? void 0 : (_practitionerData$org3 = _practitionerData$org2.find(function (v) {
    var _v$aliasType;

    return (v === null || v === void 0 ? void 0 : (_v$aliasType = v.aliasType) === null || _v$aliasType === void 0 ? void 0 : _v$aliasType.code) === "EXQ";
  })) === null || _practitionerData$org3 === void 0 ? void 0 : _practitionerData$org3.aliasDesc;
  var facilityId = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$fac = practitionerData.facility) === null || _practitionerData$fac === void 0 ? void 0 : (_practitionerData$fac2 = _practitionerData$fac.alias) === null || _practitionerData$fac2 === void 0 ? void 0 : (_practitionerData$fac3 = _practitionerData$fac2.find(function (v) {
    var _v$aliasType2;

    return (v === null || v === void 0 ? void 0 : (_v$aliasType2 = v.aliasType) === null || _v$aliasType2 === void 0 ? void 0 : _v$aliasType2.code) === "EXQ";
  })) === null || _practitionerData$fac3 === void 0 ? void 0 : _practitionerData$fac3.aliasDesc;
  var timeFormat = JSON.parse(localStorage.getItem("orgFormat"));
  return {
    queueid: selectedState === null || selectedState === void 0 ? void 0 : selectedState.queueid,
    scenriodid: data === null || data === void 0 ? void 0 : (_data$scenarioId = data.scenarioId) === null || _data$scenarioId === void 0 ? void 0 : (_data$scenarioId$ = _data$scenarioId[0]) === null || _data$scenarioId$ === void 0 ? void 0 : _data$scenarioId$._id,
    org_Id: (_practitionerData$fac4 = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$fac5 = practitionerData.facility) === null || _practitionerData$fac5 === void 0 ? void 0 : _practitionerData$fac5._key) !== null && _practitionerData$fac4 !== void 0 ? _practitionerData$fac4 : "",
    //facility key
    drugCode: data === null || data === void 0 ? void 0 : data.drugCode,
    stateid: selectedState === null || selectedState === void 0 ? void 0 : selectedState.id,
    ticketid: data === null || data === void 0 ? void 0 : data.ticketId,
    actionid: action === null || action === void 0 ? void 0 : action.actionid,
    encountertype: (_data$encounter_Id$0$ = data === null || data === void 0 ? void 0 : (_data$encounter_Id = data.encounter_Id) === null || _data$encounter_Id === void 0 ? void 0 : (_data$encounter_Id$ = _data$encounter_Id[0]) === null || _data$encounter_Id$ === void 0 ? void 0 : (_data$encounter_Id$$t = _data$encounter_Id$.type) === null || _data$encounter_Id$$t === void 0 ? void 0 : _data$encounter_Id$$t.code) !== null && _data$encounter_Id$0$ !== void 0 ? _data$encounter_Id$0$ : "",
    //Newly added as prem asked
    encservicetype: data === null || data === void 0 ? void 0 : (_data$encounter_Id2 = data.encounter_Id) === null || _data$encounter_Id2 === void 0 ? void 0 : (_data$encounter_Id2$ = _data$encounter_Id2[0]) === null || _data$encounter_Id2$ === void 0 ? void 0 : (_data$encounter_Id2$$ = _data$encounter_Id2$.type) === null || _data$encounter_Id2$$ === void 0 ? void 0 : _data$encounter_Id2$$.code,
    //Newly added as prem asked
    facilityaliasid: facilityId || "",
    orgaliasid: orgAlise || "",
    invlocationcode: (practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$loc = practitionerData.location) === null || _practitionerData$loc === void 0 ? void 0 : (_practitionerData$loc2 = _practitionerData$loc.pharmacy) === null || _practitionerData$loc2 === void 0 ? void 0 : (_practitionerData$loc3 = _practitionerData$loc2[0]) === null || _practitionerData$loc3 === void 0 ? void 0 : (_practitionerData$loc4 = _practitionerData$loc3.inventorySubStore) === null || _practitionerData$loc4 === void 0 ? void 0 : _practitionerData$loc4.locationID) || "",
    // iventorty code
    orgdateformat: (timeFormat === null || timeFormat === void 0 ? void 0 : (_timeFormat$orgdatefo = timeFormat.orgdateformat) === null || _timeFormat$orgdatefo === void 0 ? void 0 : _timeFormat$orgdatefo.display) || "",
    //added on jun 30 asked by chinnu
    orgdatetimeformat: (timeFormat === null || timeFormat === void 0 ? void 0 : (_timeFormat$orgdateti = timeFormat.orgdatetimeformat) === null || _timeFormat$orgdateti === void 0 ? void 0 : _timeFormat$orgdateti.display) || "",
    //added on jun 30 asked by chinnu
    orgtimeformat: (timeFormat === null || timeFormat === void 0 ? void 0 : (_timeFormat$orgtimefo = timeFormat.orgtimeformat) === null || _timeFormat$orgtimefo === void 0 ? void 0 : _timeFormat$orgtimefo.display) || "",
    //added on jun 30 asked by chinnu
    enterprisekey: (_practitionerData$ent = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$ent2 = practitionerData.enterprise) === null || _practitionerData$ent2 === void 0 ? void 0 : _practitionerData$ent2._key) !== null && _practitionerData$ent !== void 0 ? _practitionerData$ent : "",
    //enterprise key
    orgkey: (_practitionerData$org4 = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$org5 = practitionerData.org) === null || _practitionerData$org5 === void 0 ? void 0 : _practitionerData$org5._key) !== null && _practitionerData$org4 !== void 0 ? _practitionerData$org4 : "",
    //organization key
    locationcode: (_practitionerData$loc5 = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$loc6 = practitionerData.location) === null || _practitionerData$loc6 === void 0 ? void 0 : _practitionerData$loc6.locationID) !== null && _practitionerData$loc5 !== void 0 ? _practitionerData$loc5 : "",
    //location code
    drugId: data === null || data === void 0 ? void 0 : data.drug_id,
    _id: data === null || data === void 0 ? void 0 : data._id,
    _key: data === null || data === void 0 ? void 0 : data._key,
    totalDose: 14,
    orderlineid: data === null || data === void 0 ? void 0 : data._id,
    status: data === null || data === void 0 ? void 0 : data.status_id,
    occurStartDateTime: data === null || data === void 0 ? void 0 : data.occurStartDateTime,
    occurEndDateTime: data === null || data === void 0 ? void 0 : data.occurEndDateTime,
    patient_Id: patientId,
    // encountertype: data?.encounter_Id?.[0]?.visit_type,
    encounter_Id: data === null || data === void 0 ? void 0 : (_data$encounter_Id3 = data.encounter_Id) === null || _data$encounter_Id3 === void 0 ? void 0 : (_data$encounter_Id3$ = _data$encounter_Id3[0]) === null || _data$encounter_Id3$ === void 0 ? void 0 : _data$encounter_Id3$._id,
    reasonCode: data === null || data === void 0 ? void 0 : (_data$encounter_Id4 = data.encounter_Id) === null || _data$encounter_Id4 === void 0 ? void 0 : (_data$encounter_Id4$ = _data$encounter_Id4[0]) === null || _data$encounter_Id4$ === void 0 ? void 0 : _data$encounter_Id4$.reasonCode,
    patientInstruction: "",
    notes: "",
    dispensing_pharmacy: "",
    statusreason: (_data$verifyReason = data === null || data === void 0 ? void 0 : data.verifyReason) !== null && _data$verifyReason !== void 0 ? _data$verifyReason : "",
    nextrefilldate: data === null || data === void 0 ? void 0 : data.nextrefilldate,
    pH_OrderLinePerdoseSchedule: getPH_OrderLinePerdoseSchedule(data.pH_OrderLinePerdoseSchedule || data.PH_OrderLinePerdoseSchedule, data === null || data === void 0 ? void 0 : data._id, data === null || data === void 0 ? void 0 : data.verifyReason),
    pH_OrderLineDispenseSchedule: getPH_OrderLineDispenseSchedule((data === null || data === void 0 ? void 0 : data.brands) || data.PH_OrderLineDispenseSchedule, selectedState === null || selectedState === void 0 ? void 0 : selectedState.label.toLowerCase(), data === null || data === void 0 ? void 0 : data.dispenseDurationValue, data === null || data === void 0 ? void 0 : data.verifyReason, batches, practitionerData, undefined, undefined, reIssueReason ? data : {}, reIssue)
  };
}; //to get perDoseSchedule

var getPH_OrderLinePerdoseSchedule = function getPH_OrderLinePerdoseSchedule(data, ph_orderlineID) {
  var schedule = [];
  data === null || data === void 0 ? void 0 : data.map(function (item) {
    var _item$dispenseitemcod;

    schedule.push({
      id: 0,
      PHorderline_id: ph_orderlineID,
      dispenseitemcode: (_item$dispenseitemcod = item === null || item === void 0 ? void 0 : item.dispenseitemcode) !== null && _item$dispenseitemcod !== void 0 ? _item$dispenseitemcod : "",
      dosedate: item === null || item === void 0 ? void 0 : item.dosedate,
      doseday: item === null || item === void 0 ? void 0 : item.doseday,
      dosetime: item === null || item === void 0 ? void 0 : item.dosetime,
      doseuom: item === null || item === void 0 ? void 0 : item.doseuom,
      dosedatetime: item === null || item === void 0 ? void 0 : item.dosedatetime,
      dose: item === null || item === void 0 ? void 0 : item.dose,
      status: item === null || item === void 0 ? void 0 : item.status,
      remarks: item === null || item === void 0 ? void 0 : item.remarks,
      admqty: item === null || item === void 0 ? void 0 : item.admqty,
      admuom: item === null || item === void 0 ? void 0 : item.admuom,
      stkqty: item === null || item === void 0 ? void 0 : item.stkqty,
      stkuom: item === null || item === void 0 ? void 0 : item.stkuom,
      billqty: item === null || item === void 0 ? void 0 : item.billqty,
      billuom: item === null || item === void 0 ? void 0 : item.billuom,
      issueqty: item === null || item === void 0 ? void 0 : item.issueqty,
      issueuom: item === null || item === void 0 ? void 0 : item.issueuom
    });
  });
  return schedule;
}; //To Get DispenseSchedule


var getPH_OrderLineDispenseSchedule = function getPH_OrderLineDispenseSchedule(data, _id, dispenseDurationValue, verifyReason, batches, practitionerData, isMedication, isApproval, Fulldata, reIssue) {
  var _fillterData$, _LineDispenseSchedule, _LineDispenseSchedule2, _LineDispenseSchedule3, _LineDispenseSchedule4, _LineDispenseSchedule5, _LineDispenseSchedule6, _LineDispenseSchedule7, _LineDispenseSchedule8, _LineDispenseSchedule9;

  var Data = JSON.parse(JSON.stringify(data));
  var fillterData = Data === null || Data === void 0 ? void 0 : Data.sort(function (a, b) {
    return (b === null || b === void 0 ? void 0 : b.updatedate) - (a === null || a === void 0 ? void 0 : a.updatedate);
  });
  var LineDispenseSchedule = (fillterData === null || fillterData === void 0 ? void 0 : (_fillterData$ = fillterData[0]) === null || _fillterData$ === void 0 ? void 0 : _fillterData$.pH_OrderLineDispenseSchedule) || (fillterData === null || fillterData === void 0 ? void 0 : fillterData[0]);
  return {
    id: 0,
    cartid: (_LineDispenseSchedule = LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.cartid) !== null && _LineDispenseSchedule !== void 0 ? _LineDispenseSchedule : "",
    carttrxid: (_LineDispenseSchedule2 = LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.carttrxid) !== null && _LineDispenseSchedule2 !== void 0 ? _LineDispenseSchedule2 : "",
    dispensethru: (_LineDispenseSchedule3 = LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.dispensethru) !== null && _LineDispenseSchedule3 !== void 0 ? _LineDispenseSchedule3 : "",
    returnreason: (Fulldata === null || Fulldata === void 0 ? void 0 : Fulldata.returnreason) || (LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : (_LineDispenseSchedule4 = LineDispenseSchedule.returnreason) === null || _LineDispenseSchedule4 === void 0 ? void 0 : _LineDispenseSchedule4._id) || (LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.returnreason) || "",
    dispdate: LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.dispdate,
    disptype: (_LineDispenseSchedule5 = LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.disptype) !== null && _LineDispenseSchedule5 !== void 0 ? _LineDispenseSchedule5 : "",
    dispfromdate: LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.dispfromdate,
    disptodate: LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.disptodate,
    nextrefilldate: LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.nextrefilldate,
    balanceduration: 0,
    ph_orderlineid: LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.ph_orderlineid,
    status: LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.status,
    _id: LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule._id,
    _key: LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule._key,
    practitioner: practitionerData === null || practitionerData === void 0 ? void 0 : practitionerData.practitionerid,
    practitionerRole: practitionerData === null || practitionerData === void 0 ? void 0 : practitionerData.roleid,
    totnoofdose: LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.totnoofdose,
    ivInfusionRateValue: (_LineDispenseSchedule6 = LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.ivInfusionRateValue) !== null && _LineDispenseSchedule6 !== void 0 ? _LineDispenseSchedule6 : "",
    //related to Iv
    ivInfusionRateUOM: (_LineDispenseSchedule7 = LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.ivInfusionRateUOM) !== null && _LineDispenseSchedule7 !== void 0 ? _LineDispenseSchedule7 : "",
    //related to Iv
    IVDosageDurationValue: (_LineDispenseSchedule8 = LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.ivInfusionTime) !== null && _LineDispenseSchedule8 !== void 0 ? _LineDispenseSchedule8 : "",
    //related to Iv
    IVDosageDurationUOM: (_LineDispenseSchedule9 = LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.ivInfusionTimeUom) !== null && _LineDispenseSchedule9 !== void 0 ? _LineDispenseSchedule9 : "",
    //related to Iv
    statushistory: _id === "verification" ? [{
      practitioner: practitionerData === null || practitionerData === void 0 ? void 0 : practitionerData.practitionerid,
      practitionerRole: practitionerData === null || practitionerData === void 0 ? void 0 : practitionerData.roleid,
      remarks: verifyReason !== null && verifyReason !== void 0 ? verifyReason : "",
      seqno: 1,
      status: LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.status,
      statusupdatetime: moment__default["default"]().unix()
    }] : LineDispenseSchedule.statushistory,
    dispdurval: (LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.dispdurval) || (dispenseDurationValue === null || dispenseDurationValue === void 0 ? void 0 : dispenseDurationValue.dispDuration),
    dispduruom: (LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.dispduruom) || (dispenseDurationValue === null || dispenseDurationValue === void 0 ? void 0 : dispenseDurationValue.dosageDurationUOM),
    dispensedetails: getdisPenseDetails(LineDispenseSchedule === null || LineDispenseSchedule === void 0 ? void 0 : LineDispenseSchedule.dispensedetails, batches, _id, isMedication, isApproval, reIssue)
  };
}; //To Get DispenseDetails


var getdisPenseDetails = function getdisPenseDetails(data, Batches, _id, isMedication, isApproval, reIssue) {
  return data === null || data === void 0 ? void 0 : data.map(function (dispense, i) {
    var _dispense$dispenseite, _dispense$direction, _dispense$nldirection, _Batches$i, _dispense$addrugcode;

    var obj = {};

    if (isMedication || reIssue) {
      var _dispense$_id, _dispense$_key;

      obj._id = (_dispense$_id = dispense === null || dispense === void 0 ? void 0 : dispense._id) !== null && _dispense$_id !== void 0 ? _dispense$_id : "";
      obj._key = (_dispense$_key = dispense === null || dispense === void 0 ? void 0 : dispense._key) !== null && _dispense$_key !== void 0 ? _dispense$_key : "";
    } // obj._id = dispense?._id ?? "";
    // obj._key = dispense?._key ?? "";


    return _objectSpread2(_objectSpread2({}, obj), {}, {
      id: 0,
      ph_orderlineid: dispense === null || dispense === void 0 ? void 0 : dispense.ph_orderlineid,
      dispenseitemcode: (_dispense$dispenseite = dispense === null || dispense === void 0 ? void 0 : dispense.dispenseitemcode) !== null && _dispense$dispenseite !== void 0 ? _dispense$dispenseite : "",
      dispdose: dispense === null || dispense === void 0 ? void 0 : dispense.dispdose,
      dispuom: dispense === null || dispense === void 0 ? void 0 : dispense.dispuom,
      totadmqty: dispense === null || dispense === void 0 ? void 0 : dispense.totadmqty,
      totadmuom: dispense === null || dispense === void 0 ? void 0 : dispense.totadmuom,
      totstkqty: dispense === null || dispense === void 0 ? void 0 : dispense.totstkqty,
      totstkuom: dispense === null || dispense === void 0 ? void 0 : dispense.totstkuom,
      totbillqty: dispense === null || dispense === void 0 ? void 0 : dispense.totbillqty,
      totbilluom: dispense === null || dispense === void 0 ? void 0 : dispense.totbilluom,
      totissueqty: dispense === null || dispense === void 0 ? void 0 : dispense.totissueqty,
      totissueuom: dispense === null || dispense === void 0 ? void 0 : dispense.totissueuom,
      direction: (_dispense$direction = dispense === null || dispense === void 0 ? void 0 : dispense.direction) !== null && _dispense$direction !== void 0 ? _dispense$direction : "",
      nldirection: (_dispense$nldirection = dispense === null || dispense === void 0 ? void 0 : dispense.nldirection) !== null && _dispense$nldirection !== void 0 ? _dispense$nldirection : "",
      status: dispense === null || dispense === void 0 ? void 0 : dispense.status,
      lblprintcnt: dispense === null || dispense === void 0 ? void 0 : dispense.lblprintcnt,
      splins: dispense === null || dispense === void 0 ? void 0 : dispense.splins,
      nlsplins: dispense === null || dispense === void 0 ? void 0 : dispense.nlsplins,
      activestatus: dispense === null || dispense === void 0 ? void 0 : dispense.activestatus,
      perdoseadminqty: dispense === null || dispense === void 0 ? void 0 : dispense.perdoseadminqty,
      totnoofdose: dispense === null || dispense === void 0 ? void 0 : dispense.totnoofdose,
      batchdeatils: getBatchDetails(Batches === null || Batches === void 0 ? void 0 : Batches[i], _id, isMedication) || (Batches === null || Batches === void 0 ? void 0 : (_Batches$i = Batches[i]) === null || _Batches$i === void 0 ? void 0 : _Batches$i.batchdeatils) || [],
      isadditive: dispense === null || dispense === void 0 ? void 0 : dispense.isAdditive,
      addrugcode: (_dispense$addrugcode = dispense === null || dispense === void 0 ? void 0 : dispense.addrugcode) !== null && _dispense$addrugcode !== void 0 ? _dispense$addrugcode : "",
      drugReleaseType: (dispense === null || dispense === void 0 ? void 0 : dispense.drugreleaseType) || (dispense === null || dispense === void 0 ? void 0 : dispense.drugReleaseType) || ""
    });
  });
};

var getBatchDetails = function getBatchDetails(data, _id, isMedication, isApproval) {
  return data === null || data === void 0 ? void 0 : data.map(function (batch) {
    // if (batch?.chargeqty === 0) {
    //   return;
    // }
    var obj = {};

    if ((_id === null || _id === void 0 ? void 0 : _id.toLowerCase()) === "filling" && !isMedication && batch !== null && batch !== void 0 && batch.isupdate) {
      obj.isupdate = batch === null || batch === void 0 ? void 0 : batch.isupdate;
    } else if ((_id === null || _id === void 0 ? void 0 : _id.toLowerCase()) === "filling" && !isMedication && batch !== null && batch !== void 0 && batch.isnew) {
      obj.isnew = batch === null || batch === void 0 ? void 0 : batch.isnew;
    } // if (_id?.toLowerCase() === "verification" && !isMedication) {
    //   obj.isnew = true;
    // }


    if (isMedication) {
      var _batch$returnqty, _batch$returnuom;

      obj.returnqty = (_batch$returnqty = batch === null || batch === void 0 ? void 0 : batch.returnqty) !== null && _batch$returnqty !== void 0 ? _batch$returnqty : 0;
      obj.returnuom = (_batch$returnuom = batch === null || batch === void 0 ? void 0 : batch.returnuom) !== null && _batch$returnuom !== void 0 ? _batch$returnuom : ""; // obj.isupdate = batch?.isupdate;
      // if (!isApproval) {
      //   obj.isstockupdate = true;
      //   obj.returnreasonid = batch?.returnreasonid ?? "";
      // }
    }

    return _objectSpread2(_objectSpread2({}, obj), {}, {
      batchno: batch === null || batch === void 0 ? void 0 : batch.id,
      expirydate: batch !== null && batch !== void 0 && batch.expdate ? batch === null || batch === void 0 ? void 0 : batch.expdate : batch === null || batch === void 0 ? void 0 : batch.expirydate,
      issueqty: (batch === null || batch === void 0 ? void 0 : batch.issueqty) || (batch === null || batch === void 0 ? void 0 : batch.chargeqty),
      issueuom: (batch === null || batch === void 0 ? void 0 : batch.issueuom) || (batch === null || batch === void 0 ? void 0 : batch.chargeuom),
      stockqty: batch === null || batch === void 0 ? void 0 : batch.stockqty,
      stockuom: batch === null || batch === void 0 ? void 0 : batch.stockuom,
      blockqty: batch === null || batch === void 0 ? void 0 : batch.blockqty,
      chargeprice: batch === null || batch === void 0 ? void 0 : batch.chargeprice,
      binlocty: batch === null || batch === void 0 ? void 0 : batch.binlocty,
      binname: batch === null || batch === void 0 ? void 0 : batch.binname,
      costdisprice: batch === null || batch === void 0 ? void 0 : batch.costdisprice
    });
  });
}; //fillng generate response


var GenerateFillingResponse = function GenerateFillingResponse(TaskAgainstState, reIssue) {
  var Data = TaskAgainstState === null || TaskAgainstState === void 0 ? void 0 : TaskAgainstState.map(function (val, i) {
    var _val$PH_OrderLineDisp2, _val$disptype7, _val$disptype8, _val$scenarioId5, _val$scenarioId5$, _val$drugPhoto6, _val$drugPhoto6$, _val$PH_OrderLineAler2, _val$drugType3, _val$drug_category3, _val$formCode3, _val$GenericDrug3, _val$GenericDrug3$, _val$presMode3, _val$presNature3, _val$encounter_Id6, _val$encounter_Id6$, _val$encounter_Id6$$h, _val$requestor5, _val$requestor5$, _val$requestor5$$prac, _val$requestor5$$prac2, _val$requestor5$$prac3, _val$encounter_Id7, _val$encounter_Id7$, _val$encounter_Id7$$p, _val$encounter_Id7$$p2, _val$encounter_Id7$$p3, _val$encounter_Id7$$p4, _val$encounter_Id7$$p5, _val$encounter_Id8, _val$encounter_Id8$, _val$encounter_Id8$$p, _val$drugPhoto7, _val$drugPhoto7$, _val$encounter_Id9, _val$encounter_Id9$, _val$encounter_Id9$$p, _val$encounter_Id9$$p2, _val$encounter_Id9$$p3, _val$encounter_Id9$$p4, _val$encounter_Id9$$p5, _val$encounter_Id9$$p6, _val$requestor6, _val$requestor6$, _val$requestor6$$prac, _val$requestor6$$prac2, _val$requestor6$$prac3, _val$disptype9, _val$DrugCompoundDeta5, _val$DrugCompoundDeta6, _NewSchedule$6, _val$PH_OrderLineDisp3, _val$PH_OrderLineDisp4, _val$PH_OrderLineDisp5, _val$PH_OrderLineDisp6, _val$PH_OrderLineDisp7, _val$PH_OrderLineDisp8, _val$PH_OrderLineDisp9, _val$PH_OrderLineDisp10, _val$PH_OrderLineDisp11, _val$PH_OrderLineDisp12, _val$PH_OrderLineDisp13, _val$PH_OrderLineDisp14, _NewSchedule$0$status, _NewSchedule$7;

    var NewSchedule = val === null || val === void 0 ? void 0 : (_val$PH_OrderLineDisp2 = val.PH_OrderLineDispenseSchedule) === null || _val$PH_OrderLineDisp2 === void 0 ? void 0 : _val$PH_OrderLineDisp2.sort(function (a, b) {
      return (b === null || b === void 0 ? void 0 : b.updatedate) - a.updatedate;
    });

    var a = _objectSpread2(_objectSpread2({
      uniqueId: uuid.v4(),
      id: val === null || val === void 0 ? void 0 : val._id,
      isIV: getDrugType(val === null || val === void 0 ? void 0 : (_val$disptype7 = val.disptype) === null || _val$disptype7 === void 0 ? void 0 : _val$disptype7.code),
      isCompound: getisCompound(val === null || val === void 0 ? void 0 : (_val$disptype8 = val.disptype) === null || _val$disptype8 === void 0 ? void 0 : _val$disptype8.code),
      ScenarioName: val === null || val === void 0 ? void 0 : (_val$scenarioId5 = val.scenarioId) === null || _val$scenarioId5 === void 0 ? void 0 : (_val$scenarioId5$ = _val$scenarioId5[0]) === null || _val$scenarioId5$ === void 0 ? void 0 : _val$scenarioId5$.scenarioname,
      deliveringDispenseDuration: 0,
      Recievednextrefilldate: 0,
      elapsedTime: "00:12",
      delay: "2 days",
      drugPhotoId: val === null || val === void 0 ? void 0 : (_val$drugPhoto6 = val.drugPhoto) === null || _val$drugPhoto6 === void 0 ? void 0 : (_val$drugPhoto6$ = _val$drugPhoto6[0]) === null || _val$drugPhoto6$ === void 0 ? void 0 : _val$drugPhoto6$.fileid,
      dispenseStatus: "New",
      clinicalValidation: true,
      alertCount: val === null || val === void 0 ? void 0 : (_val$PH_OrderLineAler2 = val.PH_OrderLineAlertLogs) === null || _val$PH_OrderLineAler2 === void 0 ? void 0 : _val$PH_OrderLineAler2.length,
      drugColor: "yellow",
      isHomeMedicationOrder: true,
      remarks: [{
        personName: "Dr. Roger Richards",
        type: "Verifier",
        role: "Consultant",
        addedOn: "24/02/2022 10:00",
        remark: "Instruction given by doctor in Rx"
      }],
      name: val === null || val === void 0 ? void 0 : val.orderdescription,
      doseStrength: "".concat(val === null || val === void 0 ? void 0 : val.dosageValue, "  ").concat(val === null || val === void 0 ? void 0 : val.dosageUOM),
      route: val === null || val === void 0 ? void 0 : val.routeCode,
      frequency: {
        code: val === null || val === void 0 ? void 0 : val.dosageFreqCode,
        unit: 3
      },
      orderinfo: {
        title: "Oder Info",
        drugtype: val === null || val === void 0 ? void 0 : (_val$drugType3 = val.drugType) === null || _val$drugType3 === void 0 ? void 0 : _val$drugType3.longdesc,
        drugcode: val === null || val === void 0 ? void 0 : val.drugName,
        dosage: "".concat(val === null || val === void 0 ? void 0 : val.dosageValue).concat(val === null || val === void 0 ? void 0 : val.dosageUOM),
        catagory: val === null || val === void 0 ? void 0 : (_val$drug_category3 = val.drug_category) === null || _val$drug_category3 === void 0 ? void 0 : _val$drug_category3.longdesc,
        route: val === null || val === void 0 ? void 0 : val.routeCode,
        form: val === null || val === void 0 ? void 0 : (_val$formCode3 = val.formCode) === null || _val$formCode3 === void 0 ? void 0 : _val$formCode3.longdesc,
        generic: val === null || val === void 0 ? void 0 : (_val$GenericDrug3 = val.GenericDrug) === null || _val$GenericDrug3 === void 0 ? void 0 : (_val$GenericDrug3$ = _val$GenericDrug3[0]) === null || _val$GenericDrug3$ === void 0 ? void 0 : _val$GenericDrug3$.longdesc,
        mode: val === null || val === void 0 ? void 0 : (_val$presMode3 = val.presMode) === null || _val$presMode3 === void 0 ? void 0 : _val$presMode3.display,
        nature: val === null || val === void 0 ? void 0 : (_val$presNature3 = val.presNature) === null || _val$presNature3 === void 0 ? void 0 : _val$presNature3.display,
        duration: "".concat(val === null || val === void 0 ? void 0 : val.dosageDurationValue).concat(val === null || val === void 0 ? void 0 : val.dosageDurationUOM),
        startdate: moment__default["default"].unix(val === null || val === void 0 ? void 0 : val.occurStartDateTime).format("MM-DD-YYYY hh:mm"),
        enddate: moment__default["default"].unix(val === null || val === void 0 ? void 0 : val.occurEndDateTime).format("MM-DD-YYYY hh:mm"),
        diagnosis: val === null || val === void 0 ? void 0 : (_val$encounter_Id6 = val.encounter_Id) === null || _val$encounter_Id6 === void 0 ? void 0 : (_val$encounter_Id6$ = _val$encounter_Id6[0]) === null || _val$encounter_Id6$ === void 0 ? void 0 : (_val$encounter_Id6$$h = _val$encounter_Id6$.health_of_service) === null || _val$encounter_Id6$$h === void 0 ? void 0 : _val$encounter_Id6$$h.map(function (val) {
          return val === null || val === void 0 ? void 0 : val.name;
        }),
        doctorName: makeName(val === null || val === void 0 ? void 0 : (_val$requestor5 = val.requestor) === null || _val$requestor5 === void 0 ? void 0 : (_val$requestor5$ = _val$requestor5[0]) === null || _val$requestor5$ === void 0 ? void 0 : (_val$requestor5$$prac = _val$requestor5$.practId) === null || _val$requestor5$$prac === void 0 ? void 0 : (_val$requestor5$$prac2 = _val$requestor5$$prac[0]) === null || _val$requestor5$$prac2 === void 0 ? void 0 : (_val$requestor5$$prac3 = _val$requestor5$$prac2.name) === null || _val$requestor5$$prac3 === void 0 ? void 0 : _val$requestor5$$prac3[0]),
        id: "34562",
        contactnumber: "",
        specialityname: val === null || val === void 0 ? void 0 : (_val$encounter_Id7 = val.encounter_Id) === null || _val$encounter_Id7 === void 0 ? void 0 : (_val$encounter_Id7$ = _val$encounter_Id7[0]) === null || _val$encounter_Id7$ === void 0 ? void 0 : (_val$encounter_Id7$$p = _val$encounter_Id7$.practitioner_details[0]) === null || _val$encounter_Id7$$p === void 0 ? void 0 : (_val$encounter_Id7$$p2 = _val$encounter_Id7$$p.speciality) === null || _val$encounter_Id7$$p2 === void 0 ? void 0 : (_val$encounter_Id7$$p3 = _val$encounter_Id7$$p2[0]) === null || _val$encounter_Id7$$p3 === void 0 ? void 0 : (_val$encounter_Id7$$p4 = _val$encounter_Id7$$p3.coding) === null || _val$encounter_Id7$$p4 === void 0 ? void 0 : (_val$encounter_Id7$$p5 = _val$encounter_Id7$$p4[0]) === null || _val$encounter_Id7$$p5 === void 0 ? void 0 : _val$encounter_Id7$$p5.display,
        clinicname: val === null || val === void 0 ? void 0 : (_val$encounter_Id8 = val.encounter_Id) === null || _val$encounter_Id8 === void 0 ? void 0 : (_val$encounter_Id8$ = _val$encounter_Id8[0]) === null || _val$encounter_Id8$ === void 0 ? void 0 : (_val$encounter_Id8$$p = _val$encounter_Id8$.practitioner_details[0]) === null || _val$encounter_Id8$$p === void 0 ? void 0 : _val$encounter_Id8$$p.clinic,
        drugPhoto: val === null || val === void 0 ? void 0 : (_val$drugPhoto7 = val.drugPhoto) === null || _val$drugPhoto7 === void 0 ? void 0 : (_val$drugPhoto7$ = _val$drugPhoto7[0]) === null || _val$drugPhoto7$ === void 0 ? void 0 : _val$drugPhoto7$.fileid
      },
      duration: "".concat(val === null || val === void 0 ? void 0 : val.dosageDurationValue, " ").concat(val === null || val === void 0 ? void 0 : val.dosageDurationUOM),
      speciality: (val === null || val === void 0 ? void 0 : (_val$encounter_Id9 = val.encounter_Id) === null || _val$encounter_Id9 === void 0 ? void 0 : (_val$encounter_Id9$ = _val$encounter_Id9[0]) === null || _val$encounter_Id9$ === void 0 ? void 0 : (_val$encounter_Id9$$p = _val$encounter_Id9$.practitioner_details) === null || _val$encounter_Id9$$p === void 0 ? void 0 : (_val$encounter_Id9$$p2 = _val$encounter_Id9$$p[0]) === null || _val$encounter_Id9$$p2 === void 0 ? void 0 : (_val$encounter_Id9$$p3 = _val$encounter_Id9$$p2.speciality) === null || _val$encounter_Id9$$p3 === void 0 ? void 0 : (_val$encounter_Id9$$p4 = _val$encounter_Id9$$p3[0]) === null || _val$encounter_Id9$$p4 === void 0 ? void 0 : (_val$encounter_Id9$$p5 = _val$encounter_Id9$$p4.coding) === null || _val$encounter_Id9$$p5 === void 0 ? void 0 : (_val$encounter_Id9$$p6 = _val$encounter_Id9$$p5[0]) === null || _val$encounter_Id9$$p6 === void 0 ? void 0 : _val$encounter_Id9$$p6.display) || "",
      startDate: moment__default["default"].unix(val === null || val === void 0 ? void 0 : val.occurStartDateTime).format("MM/DD/YYYY, hh:mm"),
      endDate: moment__default["default"].unix(val === null || val === void 0 ? void 0 : val.occurEndDateTime).format("MM/DD/YYYY, hh:mm"),
      doctorName: makeName(val === null || val === void 0 ? void 0 : (_val$requestor6 = val.requestor) === null || _val$requestor6 === void 0 ? void 0 : (_val$requestor6$ = _val$requestor6[0]) === null || _val$requestor6$ === void 0 ? void 0 : (_val$requestor6$$prac = _val$requestor6$.practId) === null || _val$requestor6$$prac === void 0 ? void 0 : (_val$requestor6$$prac2 = _val$requestor6$$prac[0]) === null || _val$requestor6$$prac2 === void 0 ? void 0 : (_val$requestor6$$prac3 = _val$requestor6$$prac2.name) === null || _val$requestor6$$prac3 === void 0 ? void 0 : _val$requestor6$$prac3[0]),
      brands: getFillingBrands(val === null || val === void 0 ? void 0 : val.PH_OrderLineDispenseSchedule, undefined, reIssue),
      additives: getFillingAdditives(val === null || val === void 0 ? void 0 : val.PH_OrderLineDispenseSchedule),
      compounds: getisCompound(val === null || val === void 0 ? void 0 : (_val$disptype9 = val.disptype) === null || _val$disptype9 === void 0 ? void 0 : _val$disptype9.code) ? getFillingCompounds(val === null || val === void 0 ? void 0 : val.PH_OrderLineDispenseSchedule, val === null || val === void 0 ? void 0 : (_val$DrugCompoundDeta5 = val.DrugCompoundDetails) === null || _val$DrugCompoundDeta5 === void 0 ? void 0 : (_val$DrugCompoundDeta6 = _val$DrugCompoundDeta5[0]) === null || _val$DrugCompoundDeta6 === void 0 ? void 0 : _val$DrugCompoundDeta6.compondCompDTls) : [],
      dispenseDuration: NewSchedule === null || NewSchedule === void 0 ? void 0 : (_NewSchedule$6 = NewSchedule[0]) === null || _NewSchedule$6 === void 0 ? void 0 : _NewSchedule$6.dispdurval,
      dispenseDurationValue: val === null || val === void 0 ? void 0 : val.totDispQtyUOM
    }, val), {}, {
      ivInfusionRateValue: (_val$PH_OrderLineDisp3 = val === null || val === void 0 ? void 0 : (_val$PH_OrderLineDisp4 = val.PH_OrderLineDispenseSchedule) === null || _val$PH_OrderLineDisp4 === void 0 ? void 0 : (_val$PH_OrderLineDisp5 = _val$PH_OrderLineDisp4[0]) === null || _val$PH_OrderLineDisp5 === void 0 ? void 0 : _val$PH_OrderLineDisp5.ivInfusionRateValue) !== null && _val$PH_OrderLineDisp3 !== void 0 ? _val$PH_OrderLineDisp3 : "",
      ivInfusionRatetext: (_val$PH_OrderLineDisp6 = val === null || val === void 0 ? void 0 : (_val$PH_OrderLineDisp7 = val.PH_OrderLineDispenseSchedule) === null || _val$PH_OrderLineDisp7 === void 0 ? void 0 : (_val$PH_OrderLineDisp8 = _val$PH_OrderLineDisp7[0]) === null || _val$PH_OrderLineDisp8 === void 0 ? void 0 : _val$PH_OrderLineDisp8.ivInfusionRateUOMtext) !== null && _val$PH_OrderLineDisp6 !== void 0 ? _val$PH_OrderLineDisp6 : "",
      ivInfusionTime: (_val$PH_OrderLineDisp9 = val === null || val === void 0 ? void 0 : (_val$PH_OrderLineDisp10 = val.PH_OrderLineDispenseSchedule) === null || _val$PH_OrderLineDisp10 === void 0 ? void 0 : (_val$PH_OrderLineDisp11 = _val$PH_OrderLineDisp10[0]) === null || _val$PH_OrderLineDisp11 === void 0 ? void 0 : _val$PH_OrderLineDisp11.IVDosageDurationValue) !== null && _val$PH_OrderLineDisp9 !== void 0 ? _val$PH_OrderLineDisp9 : "",
      ivInfusionTimeUomtext: (_val$PH_OrderLineDisp12 = val === null || val === void 0 ? void 0 : (_val$PH_OrderLineDisp13 = val.PH_OrderLineDispenseSchedule) === null || _val$PH_OrderLineDisp13 === void 0 ? void 0 : (_val$PH_OrderLineDisp14 = _val$PH_OrderLineDisp13[0]) === null || _val$PH_OrderLineDisp14 === void 0 ? void 0 : _val$PH_OrderLineDisp14.IVDosageDurationUOMtext) !== null && _val$PH_OrderLineDisp12 !== void 0 ? _val$PH_OrderLineDisp12 : "",
      isOnHold: isonHoldForAllState((_NewSchedule$0$status = NewSchedule === null || NewSchedule === void 0 ? void 0 : (_NewSchedule$7 = NewSchedule[0]) === null || _NewSchedule$7 === void 0 ? void 0 : _NewSchedule$7.statuscode) !== null && _NewSchedule$0$status !== void 0 ? _NewSchedule$0$status : "")
    });

    return a;
  });
  return Data;
};

var getFillingBrands = function getFillingBrands(data, isMedication, reIssue) {
  var _fillterData$2, _fillterData$2$dispen;

  //Schedule Can be multiple need to show only the new Schedule
  //As discussed with the client we need to show only the new Schedule
  var fillterData = data === null || data === void 0 ? void 0 : data.sort(function (a, b) {
    return (b === null || b === void 0 ? void 0 : b.updatedate) - a.updatedate;
  }); // const fillterData = [data[data?.length - 1]];

  var brands = fillterData === null || fillterData === void 0 ? void 0 : (_fillterData$2 = fillterData[0]) === null || _fillterData$2 === void 0 ? void 0 : (_fillterData$2$dispen = _fillterData$2.dispensedetails) === null || _fillterData$2$dispen === void 0 ? void 0 : _fillterData$2$dispen.map(function (item, i) {
    if (!(item !== null && item !== void 0 && item.isadditive) && (item === null || item === void 0 ? void 0 : item.drugreleaseTypeText) !== "INGREDIENT") {
      var _item$drugPhoto2, _item$drugPhoto2$;

      // if (isMedication && !pendingApprovel) {
      //   var num = item.totstkqty;
      //   const __ = getFillbatch(item?.batchdeatils, isMedication)?.map(v => {
      //     return num = v?.returnqty ?? 0
      //   })
      //   item.totstkqty = item.totstkqty - num
      // }
      return _objectSpread2(_objectSpread2({}, item), {}, {
        uniqueId: uuid.v4(),
        id: item === null || item === void 0 ? void 0 : item.dispensedrugcode,
        drugPhotoId: item === null || item === void 0 ? void 0 : (_item$drugPhoto2 = item.drugPhoto) === null || _item$drugPhoto2 === void 0 ? void 0 : (_item$drugPhoto2$ = _item$drugPhoto2[0]) === null || _item$drugPhoto2$ === void 0 ? void 0 : _item$drugPhoto2$.fileid,
        name: item === null || item === void 0 ? void 0 : item.drugName,
        drugNameLong: item === null || item === void 0 ? void 0 : item.drugNameLong,
        allStrength: Array.isArray(item === null || item === void 0 ? void 0 : item.dispdose) ? item === null || item === void 0 ? void 0 : item.dispdose : [item === null || item === void 0 ? void 0 : item.dispdose],
        strength: "".concat(item === null || item === void 0 ? void 0 : item.dispuomtext),
        route: "Oral",
        doseCount: item === null || item === void 0 ? void 0 : item.totnoofdose,
        tabPerDose: item === null || item === void 0 ? void 0 : item.totissueqty,
        actualdoseCount: item === null || item === void 0 ? void 0 : item.totbillqty,
        batches: reIssue ? item === null || item === void 0 ? void 0 : item.batchdeatils : getFillbatch(item === null || item === void 0 ? void 0 : item.batchdeatils, isMedication),
        dosageValue: Array.isArray(item === null || item === void 0 ? void 0 : item.dispdose) ? item === null || item === void 0 ? void 0 : item.dispdose : item === null || item === void 0 ? void 0 : item.dispdose,
        dosageUOM: item === null || item === void 0 ? void 0 : item.dispuom,
        totadmuom: item === null || item === void 0 ? void 0 : item.adminuomext,
        totstkuom: item === null || item === void 0 ? void 0 : item.stockuomtext,
        totbilluom: item === null || item === void 0 ? void 0 : item.billuomtext,
        totissueuom: item === null || item === void 0 ? void 0 : item.issueuomtext
      }, fillterData === null || fillterData === void 0 ? void 0 : fillterData[0]);
    }
  }).filter(function (notUndefined) {
    return notUndefined !== undefined;
  });
  return brands;
};

var getFillingAdditives = function getFillingAdditives(data, isMedication) {
  var _fillterData$3;

  var fillterData = data === null || data === void 0 ? void 0 : data.sort(function (a, b) {
    return (b === null || b === void 0 ? void 0 : b.updatedate) - a.updatedate;
  });
  var AttitiveDispense = fillterData === null || fillterData === void 0 ? void 0 : (_fillterData$3 = fillterData[0]) === null || _fillterData$3 === void 0 ? void 0 : _fillterData$3.dispensedetails.filter(function (val) {
    return val === null || val === void 0 ? void 0 : val.isadditive;
  });
  var obj = {};
  AttitiveDispense === null || AttitiveDispense === void 0 ? void 0 : AttitiveDispense.forEach(function (item, i) {
    var ID = item === null || item === void 0 ? void 0 : item.addrugcode;

    if (ID in obj) {
      return;
    } else {
      var addtitive = {
        name: item === null || item === void 0 ? void 0 : item.addrugcodename,
        uniqueId: uuid.v4(),
        // adddrugcode: item?.addrugcode,
        // addose: item?.addose,
        addoseuomtext: item === null || item === void 0 ? void 0 : item.addoseuomtext,
        brands: getAditiveBrands(AttitiveDispense, fillterData === null || fillterData === void 0 ? void 0 : fillterData[0], item === null || item === void 0 ? void 0 : item.addrugcode, isMedication)
      };
      obj[ID] = addtitive;
    }
  });
  var Attitives = Object.values(obj);
  return Attitives;
};

var getFillingCompounds = function getFillingCompounds(data, compound) {
  var _fillterData$4, _fillterData$4$dispen;

  var fillterData = data === null || data === void 0 ? void 0 : data.sort(function (a, b) {
    return (b === null || b === void 0 ? void 0 : b.updatedate) - a.updatedate;
  });
  var Data = fillterData === null || fillterData === void 0 ? void 0 : (_fillterData$4 = fillterData[0]) === null || _fillterData$4 === void 0 ? void 0 : (_fillterData$4$dispen = _fillterData$4.dispensedetails) === null || _fillterData$4$dispen === void 0 ? void 0 : _fillterData$4$dispen.filter(function (val) {
    return (val === null || val === void 0 ? void 0 : val.drugreleaseTypeText) === "INGREDIENT";
  });
  var brands = Data === null || Data === void 0 ? void 0 : Data.map(function (item, i) {
    if ((item === null || item === void 0 ? void 0 : item.drugreleaseTypeText) === "INGREDIENT") {
      var _item$drugPhoto3, _item$drugPhoto3$, _compound$i, _compound$i2;

      return _objectSpread2(_objectSpread2(_objectSpread2({}, item), {}, {
        uniqueId: uuid.v4(),
        id: item === null || item === void 0 ? void 0 : item.dispensedrugcode,
        name: item === null || item === void 0 ? void 0 : item.drugName,
        drugPhotoId: item === null || item === void 0 ? void 0 : (_item$drugPhoto3 = item.drugPhoto) === null || _item$drugPhoto3 === void 0 ? void 0 : (_item$drugPhoto3$ = _item$drugPhoto3[0]) === null || _item$drugPhoto3$ === void 0 ? void 0 : _item$drugPhoto3$.fileid,
        drugNameLong: item === null || item === void 0 ? void 0 : item.drugNameLong,
        allStrength: Array.isArray(item === null || item === void 0 ? void 0 : item.dispdose) ? item === null || item === void 0 ? void 0 : item.dispdose : [item === null || item === void 0 ? void 0 : item.dispdose],
        strength: "".concat(item === null || item === void 0 ? void 0 : item.dispuomtext),
        route: "Oral",
        doseCount: item === null || item === void 0 ? void 0 : item.totnoofdose,
        tabPerDose: item === null || item === void 0 ? void 0 : item.totissueqty,
        actualdoseCount: item === null || item === void 0 ? void 0 : item.totbillqty,
        batches: getFillbatch(item === null || item === void 0 ? void 0 : item.batchdeatils),
        // dosageValue: Array.isArray(item?.dispdose)
        //   ? item?.dispdose
        //   : item?.dispdose,
        totadmuom: item === null || item === void 0 ? void 0 : item.adminuomext,
        totstkuom: item === null || item === void 0 ? void 0 : item.stockuomtext,
        totbilluom: item === null || item === void 0 ? void 0 : item.billuomtext,
        totissueuom: item === null || item === void 0 ? void 0 : item.issueuomtext
      }, fillterData === null || fillterData === void 0 ? void 0 : fillterData[0]), {}, {
        dosageValue: (_compound$i = compound[i]) === null || _compound$i === void 0 ? void 0 : _compound$i.compQty,
        dosageUOM: (_compound$i2 = compound[i]) === null || _compound$i2 === void 0 ? void 0 : _compound$i2.compQtyUomText
      });
    }
  }).filter(function (notUndefined) {
    return notUndefined !== undefined;
  });
  return brands;
};

var getAditiveBrands = function getAditiveBrands(Dispense, Data, drugCode, isMedication) {
  var brands = Dispense.map(function (item, i) {
    if ((item === null || item === void 0 ? void 0 : item.addrugcode) === drugCode) {
      var _item$drugPhoto4, _item$drugPhoto4$;

      return _objectSpread2(_objectSpread2({}, item), {}, {
        uniqueId: uuid.v4(),
        id: item === null || item === void 0 ? void 0 : item.dispensedrugcode,
        drugPhotoId: item === null || item === void 0 ? void 0 : (_item$drugPhoto4 = item.drugPhoto) === null || _item$drugPhoto4 === void 0 ? void 0 : (_item$drugPhoto4$ = _item$drugPhoto4[0]) === null || _item$drugPhoto4$ === void 0 ? void 0 : _item$drugPhoto4$.fileid,
        name: item === null || item === void 0 ? void 0 : item.drugName,
        drugNameLong: item === null || item === void 0 ? void 0 : item.drugNameLong,
        allStrength: Array.isArray(item === null || item === void 0 ? void 0 : item.dispdose) ? item === null || item === void 0 ? void 0 : item.dispdose : [item === null || item === void 0 ? void 0 : item.dispdose],
        strength: "".concat(item === null || item === void 0 ? void 0 : item.dispuomtext),
        route: "Oral",
        doseCount: item === null || item === void 0 ? void 0 : item.totnoofdose,
        tabPerDose: item === null || item === void 0 ? void 0 : item.totissueqty,
        actualdoseCount: item === null || item === void 0 ? void 0 : item.totbillqty,
        batches: getFillbatch(item === null || item === void 0 ? void 0 : item.batchdeatils, isMedication),
        dosageValue: item === null || item === void 0 ? void 0 : item.dispdose,
        dosageUOM: item === null || item === void 0 ? void 0 : item.dispuom,
        totadmuom: item === null || item === void 0 ? void 0 : item.adminuomext,
        totstkuom: item === null || item === void 0 ? void 0 : item.stockuomtext,
        totbilluom: item === null || item === void 0 ? void 0 : item.billuomtext,
        totissueuom: item === null || item === void 0 ? void 0 : item.issueuomtext
      }, Data);
    }
  }).filter(function (notUndefined) {
    return notUndefined !== undefined;
  });
  return brands;
};

var getFillbatch = function getFillbatch(data, isMedication) {
  var batches = data === null || data === void 0 ? void 0 : data.map(function (val) {
    var _val$binname, _val$stockqty, _val$stockuom, _val$blockqty, _val$chargeprice;

    var obj = {};
    obj = _objectSpread2(_objectSpread2({}, val), {}, {
      uniqueId: uuid.v4(),
      id: val === null || val === void 0 ? void 0 : val.batchno,
      expiryDate: moment__default["default"](val === null || val === void 0 ? void 0 : val.expirydate).format("MM/DD/YYYY"),
      bin: {
        number: val === null || val === void 0 ? void 0 : val.binlocty,
        aisle: (_val$binname = val === null || val === void 0 ? void 0 : val.binname) !== null && _val$binname !== void 0 ? _val$binname : ""
      },
      availableQuantity: (_val$stockqty = val === null || val === void 0 ? void 0 : val.stockqty) !== null && _val$stockqty !== void 0 ? _val$stockqty : "",
      availableQuantityUOM: (_val$stockuom = val === null || val === void 0 ? void 0 : val.stockuom) !== null && _val$stockuom !== void 0 ? _val$stockuom : "",
      heldQuantity: (_val$blockqty = val === null || val === void 0 ? void 0 : val.blockqty) !== null && _val$blockqty !== void 0 ? _val$blockqty : "",
      totalAmount: (_val$chargeprice = val === null || val === void 0 ? void 0 : val.chargeprice) !== null && _val$chargeprice !== void 0 ? _val$chargeprice : "",
      Quantity: "".concat(val === null || val === void 0 ? void 0 : val.issueqty, " ").concat(val === null || val === void 0 ? void 0 : val.issueuom),
      chargeqty: val === null || val === void 0 ? void 0 : val.issueqty,
      chargeuom: val === null || val === void 0 ? void 0 : val.issueuom
    });

    if (isMedication) {
      var _val$returnqty, _val$returnuom, _val$returnreasonid;

      obj = _objectSpread2(_objectSpread2({}, obj), {}, {
        returnqty: (_val$returnqty = val === null || val === void 0 ? void 0 : val.returnqty) !== null && _val$returnqty !== void 0 ? _val$returnqty : val === null || val === void 0 ? void 0 : val.blockqty,
        returnuom: (_val$returnuom = val === null || val === void 0 ? void 0 : val.returnuom) !== null && _val$returnuom !== void 0 ? _val$returnuom : val === null || val === void 0 ? void 0 : val.issueuom,
        returnreasonid: (_val$returnreasonid = val === null || val === void 0 ? void 0 : val.returnreasonid) !== null && _val$returnreasonid !== void 0 ? _val$returnreasonid : ""
      });
    }

    return _objectSpread2({}, obj);
  });
  return batches;
}; //generateUpdateAddtive


var generateUpdateAdditive = function generateUpdateAdditive(selectedOrderData, scheduleGeneration, availableStock) {
  var _scheduleGeneration$p, _scheduleGeneration$p2, _selectedOrderData$ad;

  var dispensedetails = scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p === void 0 ? void 0 : (_scheduleGeneration$p2 = _scheduleGeneration$p.dispensedetails) === null || _scheduleGeneration$p2 === void 0 ? void 0 : _scheduleGeneration$p2.filter(function (val) {
    return val === null || val === void 0 ? void 0 : val.isAdditive;
  });
  /* Updating Addtive Value */

  var Additives = selectedOrderData === null || selectedOrderData === void 0 ? void 0 : (_selectedOrderData$ad = selectedOrderData.additives) === null || _selectedOrderData$ad === void 0 ? void 0 : _selectedOrderData$ad.map(function (additive, pIndex) {
    return _objectSpread2(_objectSpread2({}, additive), {}, {
      brands: additive === null || additive === void 0 ? void 0 : additive.brands.map(function (brnd, i) {
        var _dispensedetails$pInd;

        if ((additive === null || additive === void 0 ? void 0 : additive.addrugcode) === (dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd = dispensedetails[pIndex]) === null || _dispensedetails$pInd === void 0 ? void 0 : _dispensedetails$pInd.dispenseitemcode)) {
          var _brnd$alias, _brnd$alias$find, _ref2, _brnd$drugReleasetype, _dispensedetails$pInd2, _dispensedetails$pInd3, _dispensedetails$pInd4, _dispensedetails$pInd5, _dispensedetails$pInd6, _dispensedetails$pInd7, _dispensedetails$pInd8, _dispensedetails$pInd9, _dispensedetails$pInd10, _dispensedetails$pInd11, _dispensedetails$pInd12, _dispensedetails$pInd13, _dispensedetails$pInd14, _dispensedetails$pInd15;

          var alisName = brnd === null || brnd === void 0 ? void 0 : (_brnd$alias = brnd.alias) === null || _brnd$alias === void 0 ? void 0 : (_brnd$alias$find = _brnd$alias.find(function (v) {
            var _v$aliasType3;

            return (v === null || v === void 0 ? void 0 : (_v$aliasType3 = v.aliasType) === null || _v$aliasType3 === void 0 ? void 0 : _v$aliasType3.code) === "AM002";
          })) === null || _brnd$alias$find === void 0 ? void 0 : _brnd$alias$find.aliasCode;
          return {
            id: brnd === null || brnd === void 0 ? void 0 : brnd.id,
            uniqueId: brnd === null || brnd === void 0 ? void 0 : brnd.uniqueId,
            drugPhotoId: brnd === null || brnd === void 0 ? void 0 : brnd.drugPhotoId,
            alias: brnd === null || brnd === void 0 ? void 0 : brnd.alias,
            name: brnd === null || brnd === void 0 ? void 0 : brnd.name,
            drugreleasetype: (_ref2 = (_brnd$drugReleasetype = brnd === null || brnd === void 0 ? void 0 : brnd.drugReleasetype) !== null && _brnd$drugReleasetype !== void 0 ? _brnd$drugReleasetype : dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd2 = dispensedetails[pIndex]) === null || _dispensedetails$pInd2 === void 0 ? void 0 : _dispensedetails$pInd2.drugreleaseType) !== null && _ref2 !== void 0 ? _ref2 : "",
            drugNameLong: brnd === null || brnd === void 0 ? void 0 : brnd.drugNameLong,
            dispensedrugcode: brnd === null || brnd === void 0 ? void 0 : brnd.id,
            dosageUOM_id: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd3 = dispensedetails[pIndex]) === null || _dispensedetails$pInd3 === void 0 ? void 0 : _dispensedetails$pInd3.dispuom,
            strength: brnd === null || brnd === void 0 ? void 0 : brnd.strength,
            allStrength: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd4 = dispensedetails[pIndex]) === null || _dispensedetails$pInd4 === void 0 ? void 0 : _dispensedetails$pInd4.dispdose,
            route: "Oral",
            doseCount: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : scheduleGeneration.totalDose,
            tabPerDose: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd5 = dispensedetails[pIndex]) === null || _dispensedetails$pInd5 === void 0 ? void 0 : _dispensedetails$pInd5.totissueqty,
            actualdoseCount: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd6 = dispensedetails[pIndex]) === null || _dispensedetails$pInd6 === void 0 ? void 0 : _dispensedetails$pInd6.totbillqty,
            batches: getBatches(availableStock === null || availableStock === void 0 ? void 0 : availableStock.Data, alisName),
            option: brnd.option,
            dosageValue: brnd === null || brnd === void 0 ? void 0 : brnd.dosageValue,
            dosageUOM: brnd === null || brnd === void 0 ? void 0 : brnd.dosageUOM,
            packSizeApplicability: brnd === null || brnd === void 0 ? void 0 : brnd.packSizeApplicability,
            totadmqty: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd7 = dispensedetails[pIndex]) === null || _dispensedetails$pInd7 === void 0 ? void 0 : _dispensedetails$pInd7.totadmqty,
            totadmuom: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd8 = dispensedetails[pIndex]) === null || _dispensedetails$pInd8 === void 0 ? void 0 : _dispensedetails$pInd8.adminuomext,
            totstkqty: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd9 = dispensedetails[pIndex]) === null || _dispensedetails$pInd9 === void 0 ? void 0 : _dispensedetails$pInd9.totstkqty,
            totstkuom: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd10 = dispensedetails[pIndex]) === null || _dispensedetails$pInd10 === void 0 ? void 0 : _dispensedetails$pInd10.stockuomtext,
            totbillqty: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd11 = dispensedetails[pIndex]) === null || _dispensedetails$pInd11 === void 0 ? void 0 : _dispensedetails$pInd11.totbillqty,
            totbilluom: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd12 = dispensedetails[pIndex]) === null || _dispensedetails$pInd12 === void 0 ? void 0 : _dispensedetails$pInd12.billuomtext,
            totissueqty: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd13 = dispensedetails[pIndex]) === null || _dispensedetails$pInd13 === void 0 ? void 0 : _dispensedetails$pInd13.totissueqty,
            totissueuom: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd14 = dispensedetails[pIndex]) === null || _dispensedetails$pInd14 === void 0 ? void 0 : _dispensedetails$pInd14.issueuomtext,
            perdoseadminqty: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd15 = dispensedetails[pIndex]) === null || _dispensedetails$pInd15 === void 0 ? void 0 : _dispensedetails$pInd15.perdoseadminqty,
            pH_OrderLineDispenseSchedule: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : scheduleGeneration.pH_OrderLineDispenseSchedule
          };
        }
      }).filter(function (notUndefined) {
        return notUndefined !== undefined;
      })
    });
  });
  return Additives;
};
var generateMedicationData = function generateMedicationData(data, selectedState, patientId, action, status, practitionerData, isMedication, isApproval) {
  var _data$brands2, _data$additives2, _data$compounds2, _practitionerData$org6, _practitionerData$org7, _practitionerData$fac6, _practitionerData$fac7, _data$scenarioId2, _data$scenarioId2$, _practitionerData$fac8, _practitionerData$fac9, _data$encounter_Id5, _data$encounter_Id5$, _data$encounter_Id5$$, _data$encounter_Id6, _data$encounter_Id6$, _data$encounter_Id6$$, _practitionerData$loc7, _practitionerData$loc8, _practitionerData$loc9, _practitionerData$loc10, _practitionerData$ent3, _practitionerData$ent4, _practitionerData$org8, _practitionerData$org9, _practitionerData$loc11, _practitionerData$loc12, _data$encounter_Id7, _data$encounter_Id7$, _data$encounter_Id8, _data$encounter_Id8$, _data$encounter_Id9, _data$encounter_Id9$, _data$verifyReason2, _selectedState$label, _ref3;

  var batches = [];
  data === null || data === void 0 ? void 0 : (_data$brands2 = data.brands) === null || _data$brands2 === void 0 ? void 0 : _data$brands2.forEach(function (val) {
    batches.push(val.batches);
  });
  data === null || data === void 0 ? void 0 : (_data$additives2 = data.additives) === null || _data$additives2 === void 0 ? void 0 : _data$additives2.forEach(function (val) {
    var _val$brands2;

    (_val$brands2 = val.brands) === null || _val$brands2 === void 0 ? void 0 : _val$brands2.forEach(function (item) {
      batches.push(item.batches);
    });
  });
  data === null || data === void 0 ? void 0 : (_data$compounds2 = data.compounds) === null || _data$compounds2 === void 0 ? void 0 : _data$compounds2.forEach(function (val) {
    batches.push(val.batches);
  });
  var orgAlise = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$org6 = practitionerData.org.alias) === null || _practitionerData$org6 === void 0 ? void 0 : (_practitionerData$org7 = _practitionerData$org6.find(function (v) {
    return v.aliasType.code === "EXQ";
  })) === null || _practitionerData$org7 === void 0 ? void 0 : _practitionerData$org7.aliasDesc;
  var facilityId = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$fac6 = practitionerData.facility.alias) === null || _practitionerData$fac6 === void 0 ? void 0 : (_practitionerData$fac7 = _practitionerData$fac6.find(function (v) {
    return v.aliasType.code === "EXQ";
  })) === null || _practitionerData$fac7 === void 0 ? void 0 : _practitionerData$fac7.aliasDesc;
  return _ref3 = {
    isapproval: isApproval,
    queueid: selectedState === null || selectedState === void 0 ? void 0 : selectedState.queueid,
    scenriodid: data === null || data === void 0 ? void 0 : (_data$scenarioId2 = data.scenarioId) === null || _data$scenarioId2 === void 0 ? void 0 : (_data$scenarioId2$ = _data$scenarioId2[0]) === null || _data$scenarioId2$ === void 0 ? void 0 : _data$scenarioId2$._id,
    org_Id: (_practitionerData$fac8 = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$fac9 = practitionerData.facility) === null || _practitionerData$fac9 === void 0 ? void 0 : _practitionerData$fac9._key) !== null && _practitionerData$fac8 !== void 0 ? _practitionerData$fac8 : "",
    //facility key
    drugCode: data === null || data === void 0 ? void 0 : data.drugCode,
    stateid: selectedState === null || selectedState === void 0 ? void 0 : selectedState.id,
    ticketid: data === null || data === void 0 ? void 0 : data.ticketId,
    actionid: action === null || action === void 0 ? void 0 : action.actionid,
    encountertype: data === null || data === void 0 ? void 0 : (_data$encounter_Id5 = data.encounter_Id) === null || _data$encounter_Id5 === void 0 ? void 0 : (_data$encounter_Id5$ = _data$encounter_Id5[0]) === null || _data$encounter_Id5$ === void 0 ? void 0 : (_data$encounter_Id5$$ = _data$encounter_Id5$.type) === null || _data$encounter_Id5$$ === void 0 ? void 0 : _data$encounter_Id5$$._id,
    //Newly added as prem asked
    encservicetype: data === null || data === void 0 ? void 0 : (_data$encounter_Id6 = data.encounter_Id) === null || _data$encounter_Id6 === void 0 ? void 0 : (_data$encounter_Id6$ = _data$encounter_Id6[0]) === null || _data$encounter_Id6$ === void 0 ? void 0 : (_data$encounter_Id6$$ = _data$encounter_Id6$.type) === null || _data$encounter_Id6$$ === void 0 ? void 0 : _data$encounter_Id6$$.code,
    //Newly added as prem asked
    facilityaliasid: facilityId || "",
    orgaliasid: orgAlise || "",
    invlocationcode: (practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$loc7 = practitionerData.location) === null || _practitionerData$loc7 === void 0 ? void 0 : (_practitionerData$loc8 = _practitionerData$loc7.pharmacy) === null || _practitionerData$loc8 === void 0 ? void 0 : (_practitionerData$loc9 = _practitionerData$loc8[0]) === null || _practitionerData$loc9 === void 0 ? void 0 : (_practitionerData$loc10 = _practitionerData$loc9.inventorySubStore) === null || _practitionerData$loc10 === void 0 ? void 0 : _practitionerData$loc10.locationID) || "",
    // iventorty code
    enterprisekey: (_practitionerData$ent3 = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$ent4 = practitionerData.enterprise) === null || _practitionerData$ent4 === void 0 ? void 0 : _practitionerData$ent4._key) !== null && _practitionerData$ent3 !== void 0 ? _practitionerData$ent3 : "",
    //enterprise key
    orgkey: (_practitionerData$org8 = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$org9 = practitionerData.org) === null || _practitionerData$org9 === void 0 ? void 0 : _practitionerData$org9._key) !== null && _practitionerData$org8 !== void 0 ? _practitionerData$org8 : "",
    //organization key
    locationcode: (_practitionerData$loc11 = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$loc12 = practitionerData.location) === null || _practitionerData$loc12 === void 0 ? void 0 : _practitionerData$loc12.locationID) !== null && _practitionerData$loc11 !== void 0 ? _practitionerData$loc11 : "",
    //location code
    drugId: data === null || data === void 0 ? void 0 : data.drug_id,
    _id: data === null || data === void 0 ? void 0 : data._id,
    _key: data === null || data === void 0 ? void 0 : data._key,
    totalDose: 14,
    orderlineid: data === null || data === void 0 ? void 0 : data._id,
    status: data === null || data === void 0 ? void 0 : data.status_id,
    occurStartDateTime: data === null || data === void 0 ? void 0 : data.occurStartDateTime,
    occurEndDateTime: data === null || data === void 0 ? void 0 : data.occurEndDateTime,
    patient_Id: patientId
  }, _defineProperty(_ref3, "encountertype", data === null || data === void 0 ? void 0 : (_data$encounter_Id7 = data.encounter_Id) === null || _data$encounter_Id7 === void 0 ? void 0 : (_data$encounter_Id7$ = _data$encounter_Id7[0]) === null || _data$encounter_Id7$ === void 0 ? void 0 : _data$encounter_Id7$.visit_type), _defineProperty(_ref3, "encounter_Id", data === null || data === void 0 ? void 0 : (_data$encounter_Id8 = data.encounter_Id) === null || _data$encounter_Id8 === void 0 ? void 0 : (_data$encounter_Id8$ = _data$encounter_Id8[0]) === null || _data$encounter_Id8$ === void 0 ? void 0 : _data$encounter_Id8$._id), _defineProperty(_ref3, "reasonCode", data === null || data === void 0 ? void 0 : (_data$encounter_Id9 = data.encounter_Id) === null || _data$encounter_Id9 === void 0 ? void 0 : (_data$encounter_Id9$ = _data$encounter_Id9[0]) === null || _data$encounter_Id9$ === void 0 ? void 0 : _data$encounter_Id9$.reasonCode), _defineProperty(_ref3, "patientInstruction", ""), _defineProperty(_ref3, "notes", ""), _defineProperty(_ref3, "dispensing_pharmacy", ""), _defineProperty(_ref3, "statusreason", (_data$verifyReason2 = data === null || data === void 0 ? void 0 : data.verifyReason) !== null && _data$verifyReason2 !== void 0 ? _data$verifyReason2 : ""), _defineProperty(_ref3, "nextrefilldate", data === null || data === void 0 ? void 0 : data.nextrefilldate), _defineProperty(_ref3, "pH_OrderLinePerdoseSchedule", getPH_OrderLinePerdoseSchedule((data === null || data === void 0 ? void 0 : data.pH_OrderLinePerdoseSchedule) || (data === null || data === void 0 ? void 0 : data.PH_OrderLinePerdoseSchedule), data === null || data === void 0 ? void 0 : data._id, data === null || data === void 0 ? void 0 : data.verifyReason)), _defineProperty(_ref3, "pH_OrderLineDispenseSchedule", getPH_OrderLineDispenseSchedule((data === null || data === void 0 ? void 0 : data.brands) || (data === null || data === void 0 ? void 0 : data.PH_OrderLineDispenseSchedule), selectedState === null || selectedState === void 0 ? void 0 : (_selectedState$label = selectedState.label) === null || _selectedState$label === void 0 ? void 0 : _selectedState$label.toLowerCase(), data === null || data === void 0 ? void 0 : data.dispenseDurationValue, data === null || data === void 0 ? void 0 : data.verifyReason, batches, practitionerData, isMedication, isApproval, data)), _ref3;
}; //generated Updated Compound

var getUpdatedCompOrder = function getUpdatedCompOrder(Compound, scheduleGeneration, availableStock) {
  var compoundOrder = Compound === null || Compound === void 0 ? void 0 : Compound.map(function (cmp, i) {
    var _scheduleGeneration$p3, _scheduleGeneration$p4, _scheduleGeneration$p5, _scheduleGeneration$p6, _scheduleGeneration$p7;

    var index = scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p3 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p3 === void 0 ? void 0 : (_scheduleGeneration$p4 = _scheduleGeneration$p3.dispensedetails) === null || _scheduleGeneration$p4 === void 0 ? void 0 : _scheduleGeneration$p4.findIndex(function (val) {
      return (val === null || val === void 0 ? void 0 : val.dispenseitemcode) === (cmp === null || cmp === void 0 ? void 0 : cmp.dispensedrugcode);
    });

    if ((scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p5 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p5 === void 0 ? void 0 : (_scheduleGeneration$p6 = _scheduleGeneration$p5.dispensedetails) === null || _scheduleGeneration$p6 === void 0 ? void 0 : (_scheduleGeneration$p7 = _scheduleGeneration$p6[index]) === null || _scheduleGeneration$p7 === void 0 ? void 0 : _scheduleGeneration$p7.drugreleaseTypeText) === "INGREDIENT") {
      var _cmp$alias, _cmp$alias$find, _cmp$drugReleaseType, _scheduleGeneration$p8, _scheduleGeneration$p9, _scheduleGeneration$p10, _scheduleGeneration$p11, _scheduleGeneration$p12, _scheduleGeneration$p13, _scheduleGeneration$p14, _scheduleGeneration$p15, _scheduleGeneration$p16, _scheduleGeneration$p17, _scheduleGeneration$p18, _scheduleGeneration$p19, _scheduleGeneration$p20, _scheduleGeneration$p21, _scheduleGeneration$p22, _scheduleGeneration$p23, _scheduleGeneration$p24, _scheduleGeneration$p25, _scheduleGeneration$p26, _scheduleGeneration$p27, _scheduleGeneration$p28, _scheduleGeneration$p29, _scheduleGeneration$p30, _scheduleGeneration$p31, _scheduleGeneration$p32, _scheduleGeneration$p33, _scheduleGeneration$p34, _scheduleGeneration$p35, _scheduleGeneration$p36, _scheduleGeneration$p37, _scheduleGeneration$p38, _scheduleGeneration$p39, _scheduleGeneration$p40, _scheduleGeneration$p41, _scheduleGeneration$p42, _scheduleGeneration$p43, _scheduleGeneration$p44, _scheduleGeneration$p45, _scheduleGeneration$p46, _scheduleGeneration$p47, _scheduleGeneration$p48, _scheduleGeneration$p49;

      var alisName = cmp === null || cmp === void 0 ? void 0 : (_cmp$alias = cmp.alias) === null || _cmp$alias === void 0 ? void 0 : (_cmp$alias$find = _cmp$alias.find(function (v) {
        var _v$aliasType4;

        return (v === null || v === void 0 ? void 0 : (_v$aliasType4 = v.aliasType) === null || _v$aliasType4 === void 0 ? void 0 : _v$aliasType4.code) === "AM002";
      })) === null || _cmp$alias$find === void 0 ? void 0 : _cmp$alias$find.aliasCode;
      return {
        id: cmp === null || cmp === void 0 ? void 0 : cmp.id,
        uniqueId: cmp === null || cmp === void 0 ? void 0 : cmp.uniqueId,
        alias: cmp === null || cmp === void 0 ? void 0 : cmp.alias,
        drugPhotoId: cmp === null || cmp === void 0 ? void 0 : cmp.drugPhotoId,
        name: cmp === null || cmp === void 0 ? void 0 : cmp.name,
        drugreleasetype: (_cmp$drugReleaseType = cmp === null || cmp === void 0 ? void 0 : cmp.drugReleaseType) !== null && _cmp$drugReleaseType !== void 0 ? _cmp$drugReleaseType : cmp === null || cmp === void 0 ? void 0 : cmp.drugreleasetype,
        drugNameLong: cmp === null || cmp === void 0 ? void 0 : cmp.drugNameLong,
        allStrength: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p8 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p8 === void 0 ? void 0 : (_scheduleGeneration$p9 = _scheduleGeneration$p8.dispensedetails) === null || _scheduleGeneration$p9 === void 0 ? void 0 : (_scheduleGeneration$p10 = _scheduleGeneration$p9[index]) === null || _scheduleGeneration$p10 === void 0 ? void 0 : _scheduleGeneration$p10.dispdose,
        strength: cmp === null || cmp === void 0 ? void 0 : cmp.dosageUOM,
        dispensedrugcode: cmp === null || cmp === void 0 ? void 0 : cmp.id,
        dosageUOM_id: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p11 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p11 === void 0 ? void 0 : (_scheduleGeneration$p12 = _scheduleGeneration$p11.dispensedetails) === null || _scheduleGeneration$p12 === void 0 ? void 0 : (_scheduleGeneration$p13 = _scheduleGeneration$p12[index]) === null || _scheduleGeneration$p13 === void 0 ? void 0 : _scheduleGeneration$p13.dispuom,
        route: "Oral",
        doseCount: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p14 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p14 === void 0 ? void 0 : (_scheduleGeneration$p15 = _scheduleGeneration$p14.dispensedetails) === null || _scheduleGeneration$p15 === void 0 ? void 0 : (_scheduleGeneration$p16 = _scheduleGeneration$p15[index]) === null || _scheduleGeneration$p16 === void 0 ? void 0 : _scheduleGeneration$p16.totnoofdose,
        tabPerDose: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p17 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p17 === void 0 ? void 0 : (_scheduleGeneration$p18 = _scheduleGeneration$p17.dispensedetails) === null || _scheduleGeneration$p18 === void 0 ? void 0 : (_scheduleGeneration$p19 = _scheduleGeneration$p18[index]) === null || _scheduleGeneration$p19 === void 0 ? void 0 : _scheduleGeneration$p19.totissueqty,
        actualdoseCount: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p20 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p20 === void 0 ? void 0 : (_scheduleGeneration$p21 = _scheduleGeneration$p20.dispensedetails) === null || _scheduleGeneration$p21 === void 0 ? void 0 : (_scheduleGeneration$p22 = _scheduleGeneration$p21[index]) === null || _scheduleGeneration$p22 === void 0 ? void 0 : _scheduleGeneration$p22.totbillqty,
        batches: getBatches(availableStock === null || availableStock === void 0 ? void 0 : availableStock.Data, alisName !== null && alisName !== void 0 ? alisName : cmp === null || cmp === void 0 ? void 0 : cmp.name),
        dosageValue: cmp === null || cmp === void 0 ? void 0 : cmp.dosageValue,
        dosageUOM: cmp === null || cmp === void 0 ? void 0 : cmp.dosageUOM,
        packSizeApplicability: cmp === null || cmp === void 0 ? void 0 : cmp.packSizeApplicability,
        totadmqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p23 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p23 === void 0 ? void 0 : (_scheduleGeneration$p24 = _scheduleGeneration$p23.dispensedetails) === null || _scheduleGeneration$p24 === void 0 ? void 0 : (_scheduleGeneration$p25 = _scheduleGeneration$p24[index]) === null || _scheduleGeneration$p25 === void 0 ? void 0 : _scheduleGeneration$p25.totadmqty,
        totadmuom: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p26 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p26 === void 0 ? void 0 : (_scheduleGeneration$p27 = _scheduleGeneration$p26.dispensedetails) === null || _scheduleGeneration$p27 === void 0 ? void 0 : (_scheduleGeneration$p28 = _scheduleGeneration$p27[index]) === null || _scheduleGeneration$p28 === void 0 ? void 0 : _scheduleGeneration$p28.adminuomext,
        totstkqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p29 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p29 === void 0 ? void 0 : (_scheduleGeneration$p30 = _scheduleGeneration$p29.dispensedetails) === null || _scheduleGeneration$p30 === void 0 ? void 0 : (_scheduleGeneration$p31 = _scheduleGeneration$p30[index]) === null || _scheduleGeneration$p31 === void 0 ? void 0 : _scheduleGeneration$p31.totstkqty,
        totstkuom: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p32 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p32 === void 0 ? void 0 : (_scheduleGeneration$p33 = _scheduleGeneration$p32.dispensedetails) === null || _scheduleGeneration$p33 === void 0 ? void 0 : (_scheduleGeneration$p34 = _scheduleGeneration$p33[index]) === null || _scheduleGeneration$p34 === void 0 ? void 0 : _scheduleGeneration$p34.stockuomtext,
        totbillqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p35 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p35 === void 0 ? void 0 : (_scheduleGeneration$p36 = _scheduleGeneration$p35.dispensedetails) === null || _scheduleGeneration$p36 === void 0 ? void 0 : (_scheduleGeneration$p37 = _scheduleGeneration$p36[index]) === null || _scheduleGeneration$p37 === void 0 ? void 0 : _scheduleGeneration$p37.totbillqty,
        totbilluom: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p38 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p38 === void 0 ? void 0 : (_scheduleGeneration$p39 = _scheduleGeneration$p38.dispensedetails) === null || _scheduleGeneration$p39 === void 0 ? void 0 : (_scheduleGeneration$p40 = _scheduleGeneration$p39[index]) === null || _scheduleGeneration$p40 === void 0 ? void 0 : _scheduleGeneration$p40.billuomtext,
        totissueqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p41 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p41 === void 0 ? void 0 : (_scheduleGeneration$p42 = _scheduleGeneration$p41.dispensedetails) === null || _scheduleGeneration$p42 === void 0 ? void 0 : (_scheduleGeneration$p43 = _scheduleGeneration$p42[index]) === null || _scheduleGeneration$p43 === void 0 ? void 0 : _scheduleGeneration$p43.totissueqty,
        totissueuom: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p44 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p44 === void 0 ? void 0 : (_scheduleGeneration$p45 = _scheduleGeneration$p44.dispensedetails) === null || _scheduleGeneration$p45 === void 0 ? void 0 : (_scheduleGeneration$p46 = _scheduleGeneration$p45[index]) === null || _scheduleGeneration$p46 === void 0 ? void 0 : _scheduleGeneration$p46.issueuomtext,
        perdoseadminqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p47 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p47 === void 0 ? void 0 : (_scheduleGeneration$p48 = _scheduleGeneration$p47.dispensedetails) === null || _scheduleGeneration$p48 === void 0 ? void 0 : (_scheduleGeneration$p49 = _scheduleGeneration$p48[index]) === null || _scheduleGeneration$p49 === void 0 ? void 0 : _scheduleGeneration$p49.perdoseadminqty,
        pH_OrderLineDispenseSchedule: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : scheduleGeneration.pH_OrderLineDispenseSchedule
      };
    }
  }).filter(function (notUndefined) {
    return notUndefined !== undefined;
  });
  return compoundOrder;
};

var isonHoldForAllState = function isonHoldForAllState(id) {
  if (id === "HOLDF" || id === "HOLDC" || id === "HOLD" || id === "HOLDPREP" || id === "HOLDDISP" || id === "HOLDV" // id === "CodingMaster/11153" ||
  // id === "CodingMaster/11057" ||
  // id === "CodingMaster/10991" ||
  // id === "CodingMaster/10967" ||
  // id === "CodingMaster/10972" ||
  // id === "CodingMaster/10965" ||
  // id === "CodingMaster/10971" ||
  // id === "CodingMaster/10966" ||
  // id === "CodingMaster/10969" ||
  // id === "CodingMaster/10968"
  ) {
    return true;
  } else {
    return false;
  }
};
var isVridyHoldAllState = function isVridyHoldAllState(id) {
  if (id === "MEDREC008" || id === "MEDREC007") {
    return true;
  } else {
    return false;
  }
};
var getDayDiff = function getDayDiff(date1, date2) {
  var dayStart = moment__default["default"].unix(date1).startOf("day");
  var dayEnd = moment__default["default"].unix(date2).startOf("day");
  return dayEnd.diff(dayStart, "days");
};
var getDrugType = function getDrugType(drugType) {
  switch (drugType) {
    case "IV-SY":
    case "IV-LV":
    case "IV-PB":
      return true;

    default:
      return false;
  }
};
var getisCompound = function getisCompound(type) {
  switch (type) {
    case "COMPOUND":
      return true;

    default:
      return false;
  }
};
var TaskFetch = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(scenarioId, queueId, patientid, isCart) {
    var taskQuery, data;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            taskQuery = {
              db_name: dbName,
              filter: {
                // scenarioId: scenarioId,
                queueId: queueId,
                patientid: patientid
              },
              queryid: "f5c62a9e-0af2-4099-981e-a51e40ecf6f7"
            };

            if (isCart) {
              taskQuery.filter["scenarioid"] = scenarioId;
              taskQuery["queryid"] = "6f062fee-8e25-4bd7-a205-d4d423d7c54d";
            }

            _context2.next = 4;
            return fetchData({
              body: JSON.stringify(taskQuery)
            }, __baseUrl__);

          case 4:
            data = _context2.sent;
            return _context2.abrupt("return", data);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function TaskFetch(_x, _x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var TaskFetchByState = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(scenarioId, queueid, stateid, patientid, isCart) {
    var obj, taskagainstState, data;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            obj = {};
            taskagainstState = {
              db_name: dbName,
              queryid: isCart ? "69aaa18f-44f0-476e-a3c1-5c3291bb00b8" : "cfce738c-3820-4eba-a6f8-d18cfc4b222f",
              filter: {
                queueid: queueid,
                stateid: stateid,
                patientid: patientid,
                scenarioid: scenarioId
              }
            };

            if (isCart) {
              obj["scenarioId"] = "queuescenarios/10029";
              obj["queueid"] = queueid;
              obj["stateid"] = stateid;
              obj["patientid"] = patientid;
              taskagainstState.filter = obj;
            }

            _context3.next = 5;
            return fetchData({
              body: JSON.stringify(taskagainstState)
            }, __baseUrl__);

          case 5:
            data = _context3.sent;
            return _context3.abrupt("return", data);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function TaskFetchByState(_x5, _x6, _x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();
var GetDispenseDuration = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(orders, practitionerData) {
    var _practitionerData$loc, _practitionerData$loc2, _practitionerData$loc3;

    var latearrival, body, data;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            //to get considerlate interval value from location master
            latearrival = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$loc = practitionerData.location) === null || _practitionerData$loc === void 0 ? void 0 : (_practitionerData$loc2 = _practitionerData$loc.locconfig) === null || _practitionerData$loc2 === void 0 ? void 0 : (_practitionerData$loc3 = _practitionerData$loc2.find(function (val) {
              return (val === null || val === void 0 ? void 0 : val.code) === "considerlatearrival";
            })) === null || _practitionerData$loc3 === void 0 ? void 0 : _practitionerData$loc3.value;
            body = orders === null || orders === void 0 ? void 0 : orders.map(function (val) {
              var _val$disptype$code, _val$disptype;

              return {
                dosageDurationUOM: val === null || val === void 0 ? void 0 : val.dosageDurationUOM_id,
                dosageDurationValue: val !== null && val !== void 0 && val.nextrefilldate ? getDayDiff(val === null || val === void 0 ? void 0 : val.nextrefilldate, val === null || val === void 0 ? void 0 : val.occurEndDateTime) + 1 : val === null || val === void 0 ? void 0 : val.dosageDurationValue,
                drug_id: val === null || val === void 0 ? void 0 : val.drug_id,
                OrderStartDate: (val === null || val === void 0 ? void 0 : val.nextrefilldate) > 0 ? val === null || val === void 0 ? void 0 : val.nextrefilldate : val === null || val === void 0 ? void 0 : val.occurStartDateTime,
                OrderEndDate: val === null || val === void 0 ? void 0 : val.occurEndDateTime,
                OrderId: val === null || val === void 0 ? void 0 : val._id,
                DispenseDurationValue: 0,
                disptype: (_val$disptype$code = val === null || val === void 0 ? void 0 : (_val$disptype = val.disptype) === null || _val$disptype === void 0 ? void 0 : _val$disptype.code) !== null && _val$disptype$code !== void 0 ? _val$disptype$code : "",
                IsFirstDuration: true,
                considerlatearrival: latearrival === "true" ? true : false
              };
            });
            _context4.next = 4;
            return fetchData({
              body: JSON.stringify(body)
            }, __GetDispenseDuration__);

          case 4:
            data = _context4.sent;
            return _context4.abrupt("return", data);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function GetDispenseDuration(_x10, _x11) {
    return _ref4.apply(this, arguments);
  };
}();
var calculateDispenseDoseStrength = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(params, patientid, dispenseDuration, key) {
    var body, data;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            body = params === null || params === void 0 ? void 0 : params.map(function (val) {
              var _val$disptype2;

              return {
                OrderId: val._id,
                OrderItemcode: val === null || val === void 0 ? void 0 : val.drug_id,
                OrderStrength: val === null || val === void 0 ? void 0 : val.dosageValue,
                OrderUOM: val === null || val === void 0 ? void 0 : val.dosageUOM_id,
                PatientId: patientid,
                Startdate: val === null || val === void 0 ? void 0 : val.occurStartDateTime,
                Enddate: val === null || val === void 0 ? void 0 : val.occurEndDateTime,
                freqcode: val === null || val === void 0 ? void 0 : val.dosageFreqCode,
                dosageDurationValue: val === null || val === void 0 ? void 0 : val.dosageDurationValue,
                dosageDurationUOM: val === null || val === void 0 ? void 0 : val.dosageDurationUOM,
                Isfirstdose: false,
                disptype: val === null || val === void 0 ? void 0 : (_val$disptype2 = val.disptype) === null || _val$disptype2 === void 0 ? void 0 : _val$disptype2.code,
                DispenseDetails: getDispense(key ? val === null || val === void 0 ? void 0 : val.brands : val === null || val === void 0 ? void 0 : val.mappedItems, val, key),
                AdditiveDetails: getAdditive(key ? val === null || val === void 0 ? void 0 : val.additives : val === null || val === void 0 ? void 0 : val.addtictive, val, key)
              };
            });
            _context5.next = 3;
            return fetchData({
              body: JSON.stringify(body)
            }, __DispenseDoseStrength__);

          case 3:
            data = _context5.sent;
            return _context5.abrupt("return", data);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function calculateDispenseDoseStrength(_x12, _x13, _x14, _x15) {
    return _ref5.apply(this, arguments);
  };
}();
var getDispense = function getDispense(data, singleOrder, key) {
  var SortedData = data.sort(function (a, b) {
    return a.seqno - b.seqno;
  });
  var Dispense = data === null || data === void 0 ? void 0 : data.map(function (item) {
    var _SortedData$;

    if ((item === null || item === void 0 ? void 0 : item.dispensedrugcode) === (SortedData === null || SortedData === void 0 ? void 0 : (_SortedData$ = SortedData[0]) === null || _SortedData$ === void 0 ? void 0 : _SortedData$.dispensedrugcode) || key) {
      var _item$DrugType$drugty, _item$DrugType, _getSpecificUom, _getSpecificUom2, _getSpecificUom3, _getSpecificUom4, _getSpecificUom5, _getSpecificUom6, _getSpecificUom7, _getSpecificUom8;

      return {
        DispenseItemCode: item === null || item === void 0 ? void 0 : item.dispensedrugcode,
        DispenseStrength: [0],
        DispenseUOM: singleOrder === null || singleOrder === void 0 ? void 0 : singleOrder.dosageUOM_id,
        DispenseUOMText: singleOrder === null || singleOrder === void 0 ? void 0 : singleOrder.dosageUOM,
        DrugType: (_item$DrugType$drugty = item === null || item === void 0 ? void 0 : (_item$DrugType = item.DrugType) === null || _item$DrugType === void 0 ? void 0 : _item$DrugType.drugtype) !== null && _item$DrugType$drugty !== void 0 ? _item$DrugType$drugty : "",
        AdminUOM: (_getSpecificUom = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Admin")) === null || _getSpecificUom === void 0 ? void 0 : _getSpecificUom._id,
        IssueUOM: (_getSpecificUom2 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Issue")) === null || _getSpecificUom2 === void 0 ? void 0 : _getSpecificUom2._id,
        BillUOM: (_getSpecificUom3 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Bill")) === null || _getSpecificUom3 === void 0 ? void 0 : _getSpecificUom3._id,
        StockUOM: (_getSpecificUom4 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Stock")) === null || _getSpecificUom4 === void 0 ? void 0 : _getSpecificUom4._id,
        drugreleaseType: item === null || item === void 0 ? void 0 : item.drugreleasetype,
        AdminUOMText: (_getSpecificUom5 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Admin")) === null || _getSpecificUom5 === void 0 ? void 0 : _getSpecificUom5.UOM,
        IssueUOMText: (_getSpecificUom6 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Issue")) === null || _getSpecificUom6 === void 0 ? void 0 : _getSpecificUom6.UOM,
        StockUOMText: (_getSpecificUom7 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Stock")) === null || _getSpecificUom7 === void 0 ? void 0 : _getSpecificUom7.UOM,
        BillUOMText: (_getSpecificUom8 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Bill")) === null || _getSpecificUom8 === void 0 ? void 0 : _getSpecificUom8.UOM,
        addrugcode: ""
      };
    }
  }).filter(function (notUndefined) {
    return notUndefined !== undefined;
  });
  return Dispense;
};
var getAdditive = function getAdditive(data, singleOrder, key) {
  var name = key ? "brands" : "mappedeItems";
  var Attictives = [];
  data === null || data === void 0 ? void 0 : data.forEach(function (additive) {
    var _additive$name;

    var SortedData = additive === null || additive === void 0 ? void 0 : (_additive$name = additive[name]) === null || _additive$name === void 0 ? void 0 : _additive$name.sort(function (a, b) {
      return a.seqno - b.seqno;
    });
    additive === null || additive === void 0 ? void 0 : additive[name].forEach(function (item) {
      var _SortedData$2;

      if ((item === null || item === void 0 ? void 0 : item.dispensedrugcode) === (SortedData === null || SortedData === void 0 ? void 0 : (_SortedData$2 = SortedData[0]) === null || _SortedData$2 === void 0 ? void 0 : _SortedData$2.dispensedrugcode) || key) {
        var _item$DrugType$drugty2, _item$DrugType2, _getSpecificUom9, _getSpecificUom10, _getSpecificUom11, _getSpecificUom12, _getSpecificUom13, _getSpecificUom14, _getSpecificUom15, _getSpecificUom16;

        Attictives.push({
          DispenseItemCode: item === null || item === void 0 ? void 0 : item.dispensedrugcode,
          DispenseStrength: [0],
          baseStrength: additive === null || additive === void 0 ? void 0 : additive.addose,
          DispenseUOM: additive === null || additive === void 0 ? void 0 : additive.addoseuom,
          DrugType: (_item$DrugType$drugty2 = item === null || item === void 0 ? void 0 : (_item$DrugType2 = item.DrugType) === null || _item$DrugType2 === void 0 ? void 0 : _item$DrugType2.drugtype) !== null && _item$DrugType$drugty2 !== void 0 ? _item$DrugType$drugty2 : "",
          DispenseUOMText: additive === null || additive === void 0 ? void 0 : additive.addoseuomtext,
          AdminUOM: (_getSpecificUom9 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Admin")) === null || _getSpecificUom9 === void 0 ? void 0 : _getSpecificUom9._id,
          IssueUOM: (_getSpecificUom10 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Issue")) === null || _getSpecificUom10 === void 0 ? void 0 : _getSpecificUom10._id,
          BillUOM: (_getSpecificUom11 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Bill")) === null || _getSpecificUom11 === void 0 ? void 0 : _getSpecificUom11._id,
          StockUOM: (_getSpecificUom12 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Stock")) === null || _getSpecificUom12 === void 0 ? void 0 : _getSpecificUom12._id,
          AdminUOMText: (_getSpecificUom13 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Admin")) === null || _getSpecificUom13 === void 0 ? void 0 : _getSpecificUom13.UOM,
          IssueUOMText: (_getSpecificUom14 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Issue")) === null || _getSpecificUom14 === void 0 ? void 0 : _getSpecificUom14.UOM,
          StockUOMText: (_getSpecificUom15 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Stock")) === null || _getSpecificUom15 === void 0 ? void 0 : _getSpecificUom15.UOM,
          BillUOMText: (_getSpecificUom16 = getSpecificUom(item === null || item === void 0 ? void 0 : item.packSizeApplicability, "Bill")) === null || _getSpecificUom16 === void 0 ? void 0 : _getSpecificUom16.UOM,
          addrugcode: ""
        });
      }
    });
  });
  return Attictives;
};
var getSpecificUom = function getSpecificUom(data, type) {
  var _data$find;

  var uom = data === null || data === void 0 ? void 0 : (_data$find = data.find(function (item) {
    var _item$applicableInd;

    return (item === null || item === void 0 ? void 0 : (_item$applicableInd = item.applicableInd) === null || _item$applicableInd === void 0 ? void 0 : _item$applicableInd.display) === type;
  })) === null || _data$find === void 0 ? void 0 : _data$find.packSizeUoM;
  return uom;
};
var DoseScheduleGeneration = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(order, DoseStrength, isCart, isCartDetails) {
    var _order$additives, _order$brands, _order$compounds, _order$dispenseDurati, _order$dispenseDurati2, _order$dispenseDurati3, _order$dosageFreqCode, _order$dispenseDurati4, _order$dispenseDurati5, _order$routeCode_id, _order$disptype, _order$deliveringDisp, _order$dispenseDurati6;

    var Addictive, dispense, compound, payload, data;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            //To get Addictive
            Addictive = [];
            order === null || order === void 0 ? void 0 : (_order$additives = order.additives) === null || _order$additives === void 0 ? void 0 : _order$additives.forEach(function (va) {
              var _va$brands;

              va === null || va === void 0 ? void 0 : (_va$brands = va.brands) === null || _va$brands === void 0 ? void 0 : _va$brands.forEach(function (val, i) {
                var _getSpecificUom17, _getSpecificUom18, _getSpecificUom19, _getSpecificUom20, _getSpecificUom21, _getSpecificUom22, _getSpecificUom23, _getSpecificUom24, _val$drugReleaseType;

                Addictive.push({
                  DispenseItemCode: (val === null || val === void 0 ? void 0 : val.dispensedrugcode) || (val === null || val === void 0 ? void 0 : val.drugName),
                  DispenseStrength: val === null || val === void 0 ? void 0 : val.dosageValue,
                  DispenseUOM: val === null || val === void 0 ? void 0 : val.dosageUOM_id,
                  DispenseUOMText: val === null || val === void 0 ? void 0 : val.dosageUOM,
                  AdminUOM: (_getSpecificUom17 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Admin")) === null || _getSpecificUom17 === void 0 ? void 0 : _getSpecificUom17._id,
                  AdminUOMText: (_getSpecificUom18 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Admin")) === null || _getSpecificUom18 === void 0 ? void 0 : _getSpecificUom18.UOM,
                  IssueUOM: (_getSpecificUom19 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Issue")) === null || _getSpecificUom19 === void 0 ? void 0 : _getSpecificUom19._id,
                  IssueUOMText: (_getSpecificUom20 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Issue")) === null || _getSpecificUom20 === void 0 ? void 0 : _getSpecificUom20.UOM,
                  BillUOM: (_getSpecificUom21 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Bill")) === null || _getSpecificUom21 === void 0 ? void 0 : _getSpecificUom21._id,
                  BillUOMText: (_getSpecificUom22 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Bill")) === null || _getSpecificUom22 === void 0 ? void 0 : _getSpecificUom22.UOM,
                  StockUOM: (_getSpecificUom23 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Stock")) === null || _getSpecificUom23 === void 0 ? void 0 : _getSpecificUom23._id,
                  StockUOMText: (_getSpecificUom24 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Stock")) === null || _getSpecificUom24 === void 0 ? void 0 : _getSpecificUom24.UOM,
                  isAdditive: true,
                  addrugcode: va === null || va === void 0 ? void 0 : va.addrugcode,
                  drugreleaseType: (_val$drugReleaseType = val === null || val === void 0 ? void 0 : val.drugReleaseType) !== null && _val$drugReleaseType !== void 0 ? _val$drugReleaseType : val === null || val === void 0 ? void 0 : val.drugreleasetype
                });
              });
            }); //To get Dispense

            dispense = order === null || order === void 0 ? void 0 : (_order$brands = order.brands) === null || _order$brands === void 0 ? void 0 : _order$brands.map(function (val, i) {
              var _getSpecificUom25, _getSpecificUom26, _getSpecificUom27, _getSpecificUom28, _getSpecificUom29, _getSpecificUom30, _getSpecificUom31, _getSpecificUom32, _val$drugReleaseType2;

              return {
                DispenseItemCode: (val === null || val === void 0 ? void 0 : val.dispensedrugcode) || (val === null || val === void 0 ? void 0 : val.drugName),
                DispenseStrength: val === null || val === void 0 ? void 0 : val.dosageValue,
                DispenseUOM: val === null || val === void 0 ? void 0 : val.dosageUOM_id,
                DispenseUOMText: val === null || val === void 0 ? void 0 : val.dosageUOM,
                AdminUOM: (_getSpecificUom25 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Admin")) === null || _getSpecificUom25 === void 0 ? void 0 : _getSpecificUom25._id,
                AdminUOMText: (_getSpecificUom26 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Admin")) === null || _getSpecificUom26 === void 0 ? void 0 : _getSpecificUom26.UOM,
                IssueUOM: (_getSpecificUom27 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Issue")) === null || _getSpecificUom27 === void 0 ? void 0 : _getSpecificUom27._id,
                IssueUOMText: (_getSpecificUom28 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Issue")) === null || _getSpecificUom28 === void 0 ? void 0 : _getSpecificUom28.UOM,
                BillUOM: (_getSpecificUom29 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Bill")) === null || _getSpecificUom29 === void 0 ? void 0 : _getSpecificUom29._id,
                BillUOMText: (_getSpecificUom30 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Bill")) === null || _getSpecificUom30 === void 0 ? void 0 : _getSpecificUom30.UOM,
                StockUOM: (_getSpecificUom31 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Stock")) === null || _getSpecificUom31 === void 0 ? void 0 : _getSpecificUom31._id,
                StockUOMText: (_getSpecificUom32 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Stock")) === null || _getSpecificUom32 === void 0 ? void 0 : _getSpecificUom32.UOM,
                isAdditive: false,
                addrugcode: "",
                drugreleaseType: (_val$drugReleaseType2 = val === null || val === void 0 ? void 0 : val.drugReleaseType) !== null && _val$drugReleaseType2 !== void 0 ? _val$drugReleaseType2 : val === null || val === void 0 ? void 0 : val.drugreleasetype
              };
            }); //To get Compound

            compound = order === null || order === void 0 ? void 0 : (_order$compounds = order.compounds) === null || _order$compounds === void 0 ? void 0 : _order$compounds.map(function (val, i) {
              var _getSpecificUom33, _getSpecificUom34, _getSpecificUom35, _getSpecificUom36, _getSpecificUom37, _getSpecificUom38, _getSpecificUom39, _getSpecificUom40, _val$drugReleaseType3;

              return {
                DispenseItemCode: (val === null || val === void 0 ? void 0 : val.dispensedrugcode) || (val === null || val === void 0 ? void 0 : val.drugName),
                DispenseStrength: [val === null || val === void 0 ? void 0 : val.dosageValue],
                DispenseUOM: val === null || val === void 0 ? void 0 : val.dosageUOM_id,
                DispenseUOMText: val === null || val === void 0 ? void 0 : val.dosageUOM,
                AdminUOM: (_getSpecificUom33 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Admin")) === null || _getSpecificUom33 === void 0 ? void 0 : _getSpecificUom33._id,
                AdminUOMText: (_getSpecificUom34 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Admin")) === null || _getSpecificUom34 === void 0 ? void 0 : _getSpecificUom34.UOM,
                IssueUOM: (_getSpecificUom35 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Issue")) === null || _getSpecificUom35 === void 0 ? void 0 : _getSpecificUom35._id,
                IssueUOMText: (_getSpecificUom36 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Issue")) === null || _getSpecificUom36 === void 0 ? void 0 : _getSpecificUom36.UOM,
                BillUOM: (_getSpecificUom37 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Bill")) === null || _getSpecificUom37 === void 0 ? void 0 : _getSpecificUom37._id,
                BillUOMText: (_getSpecificUom38 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Bill")) === null || _getSpecificUom38 === void 0 ? void 0 : _getSpecificUom38.UOM,
                StockUOM: (_getSpecificUom39 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Stock")) === null || _getSpecificUom39 === void 0 ? void 0 : _getSpecificUom39._id,
                StockUOMText: (_getSpecificUom40 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Stock")) === null || _getSpecificUom40 === void 0 ? void 0 : _getSpecificUom40.UOM,
                isAdditive: false,
                addrugcode: "",
                drugreleaseType: (_val$drugReleaseType3 = val === null || val === void 0 ? void 0 : val.drugReleaseType) !== null && _val$drugReleaseType3 !== void 0 ? _val$drugReleaseType3 : val === null || val === void 0 ? void 0 : val.drugreleasetype //"RCOMPOUND"

              };
            }); //main Payload

            payload = {
              EncounterType: order === null || order === void 0 ? void 0 : order.EncounterType,
              OrderId: order === null || order === void 0 ? void 0 : order._id,
              OrderItemcode: order === null || order === void 0 ? void 0 : (_order$dispenseDurati = order.dispenseDurationValue) === null || _order$dispenseDurati === void 0 ? void 0 : _order$dispenseDurati.drug_id,
              OrderStrength: order === null || order === void 0 ? void 0 : order.dosageValue,
              OrderUOM: order === null || order === void 0 ? void 0 : order.dosageUOM_id,
              PatientId: order === null || order === void 0 ? void 0 : order.patient_Id,
              Startdate: order === null || order === void 0 ? void 0 : (_order$dispenseDurati2 = order.dispenseDurationValue) === null || _order$dispenseDurati2 === void 0 ? void 0 : _order$dispenseDurati2.dispStartDate,
              Enddate: order === null || order === void 0 ? void 0 : (_order$dispenseDurati3 = order.dispenseDurationValue) === null || _order$dispenseDurati3 === void 0 ? void 0 : _order$dispenseDurati3.dispEndDate,
              freqcode: (_order$dosageFreqCode = order === null || order === void 0 ? void 0 : order.dosageFreqCode_id) !== null && _order$dosageFreqCode !== void 0 ? _order$dosageFreqCode : "",
              dosageDurationValue: order === null || order === void 0 ? void 0 : (_order$dispenseDurati4 = order.dispenseDurationValue) === null || _order$dispenseDurati4 === void 0 ? void 0 : _order$dispenseDurati4.dispDuration,
              dosageDurationUOM: order === null || order === void 0 ? void 0 : (_order$dispenseDurati5 = order.dispenseDurationValue) === null || _order$dispenseDurati5 === void 0 ? void 0 : _order$dispenseDurati5.dosageDurationUOM,
              Isfirstdose: false,
              DispenseDetails: [].concat(_toConsumableArray(dispense || []), _toConsumableArray(Addictive || []), _toConsumableArray(compound || [])),
              ivInfusionRateValue: order.ivInfusionRateValue,
              ivInfusionRateUOM: order === null || order === void 0 ? void 0 : order.ivInfusionRateUOM,
              ivInfusionTime: order === null || order === void 0 ? void 0 : order.ivInfusionTime,
              ivInfusionTimeUom: order === null || order === void 0 ? void 0 : order.ivInfusionTimeUom,
              // AdditiveDetails: [],
              //AdditiveDetails: Addictive,
              routeCode: (_order$routeCode_id = order === null || order === void 0 ? void 0 : order.routeCode_id) !== null && _order$routeCode_id !== void 0 ? _order$routeCode_id : "",
              disptype: order === null || order === void 0 ? void 0 : (_order$disptype = order.disptype) === null || _order$disptype === void 0 ? void 0 : _order$disptype.code,
              dispenseDurationValue: (order === null || order === void 0 ? void 0 : (_order$deliveringDisp = order.deliveringDispenseDuration) === null || _order$deliveringDisp === void 0 ? void 0 : _order$deliveringDisp.length) > 0 ? parseInt(order === null || order === void 0 ? void 0 : order.deliveringDispenseDuration) : order === null || order === void 0 ? void 0 : (_order$dispenseDurati6 = order.dispenseDurationValue) === null || _order$dispenseDurati6 === void 0 ? void 0 : _order$dispenseDurati6.dispDuration,
              dispenseDurationUOM: order === null || order === void 0 ? void 0 : order.dosageUOM_id,
              dispenseDurationUOMText: order === null || order === void 0 ? void 0 : order.dosageDurationUOM,
              RefillDate: order === null || order === void 0 ? void 0 : order.nextrefilldate
            };

            if (isCart) {
              //payload["EncounterType"] = "IP";
              payload["Cartid"] = (order === null || order === void 0 ? void 0 : order.Cartid) || (isCartDetails === null || isCartDetails === void 0 ? void 0 : isCartDetails.Cartid) || "";
              payload["CartTransId"] = (order === null || order === void 0 ? void 0 : order.CartTransId) || (isCartDetails === null || isCartDetails === void 0 ? void 0 : isCartDetails.CartTransId) || "";
            }

            _context6.next = 8;
            return fetchData({
              body: JSON.stringify([payload])
            }, __DoseScheduleGeneration__);

          case 8:
            data = _context6.sent;
            return _context6.abrupt("return", data);

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function DoseScheduleGeneration(_x16, _x17, _x18, _x19) {
    return _ref6.apply(this, arguments);
  };
}();
var ptAvailStock = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(params, selectedOrder, scheduleGeneration, practitionerData) {
    var _practitionerData$org, _practitionerData$org2, _practitionerData$org3, _practitionerData$fac, _practitionerData$fac2, _practitionerData$fac3, _practitionerData$loc4, _practitionerData$loc5, _practitionerData$loc6, _practitionerData$loc7, _scheduleGeneration$p16, _scheduleGeneration$p17, _params$additives, _scheduleGeneration$p18, _scheduleGeneration$p19, _params$compounds;

    var selectedMedicine, compcdId, facilityId, SubstoreId, dispensedetails, CompundDispDetails, payload, data;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            selectedMedicine = [];
            compcdId = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$org = practitionerData.org) === null || _practitionerData$org === void 0 ? void 0 : (_practitionerData$org2 = _practitionerData$org.alias) === null || _practitionerData$org2 === void 0 ? void 0 : (_practitionerData$org3 = _practitionerData$org2.find(function (v) {
              return v.aliasType.code === "EXQ";
            })) === null || _practitionerData$org3 === void 0 ? void 0 : _practitionerData$org3.aliasDesc;
            facilityId = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$fac = practitionerData.facility) === null || _practitionerData$fac === void 0 ? void 0 : (_practitionerData$fac2 = _practitionerData$fac.alias) === null || _practitionerData$fac2 === void 0 ? void 0 : (_practitionerData$fac3 = _practitionerData$fac2.find(function (v) {
              return v.aliasType.code === "EXQ";
            })) === null || _practitionerData$fac3 === void 0 ? void 0 : _practitionerData$fac3.aliasDesc;
            SubstoreId = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$loc4 = practitionerData.location) === null || _practitionerData$loc4 === void 0 ? void 0 : (_practitionerData$loc5 = _practitionerData$loc4.pharmacy) === null || _practitionerData$loc5 === void 0 ? void 0 : (_practitionerData$loc6 = _practitionerData$loc5[0]) === null || _practitionerData$loc6 === void 0 ? void 0 : (_practitionerData$loc7 = _practitionerData$loc6.inventorySubStore) === null || _practitionerData$loc7 === void 0 ? void 0 : _practitionerData$loc7.locationID; //to get brand medicines

            params === null || params === void 0 ? void 0 : params.brands.forEach(function (val, i) {
              var _scheduleGeneration$p, _scheduleGeneration$p2, _scheduleGeneration$p3, _scheduleGeneration$p4, _scheduleGeneration$p5, _scheduleGeneration$p6, _scheduleGeneration$p7, _scheduleGeneration$p8, _scheduleGeneration$p9;

              if (!(scheduleGeneration !== null && scheduleGeneration !== void 0 && (_scheduleGeneration$p = scheduleGeneration.pH_OrderLineDispenseSchedule) !== null && _scheduleGeneration$p !== void 0 && (_scheduleGeneration$p2 = _scheduleGeneration$p.dispensedetails) !== null && _scheduleGeneration$p2 !== void 0 && (_scheduleGeneration$p3 = _scheduleGeneration$p2[i]) !== null && _scheduleGeneration$p3 !== void 0 && _scheduleGeneration$p3.isAdditive) && (scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p4 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p4 === void 0 ? void 0 : (_scheduleGeneration$p5 = _scheduleGeneration$p4.dispensedetails) === null || _scheduleGeneration$p5 === void 0 ? void 0 : (_scheduleGeneration$p6 = _scheduleGeneration$p5[i]) === null || _scheduleGeneration$p6 === void 0 ? void 0 : _scheduleGeneration$p6.drugreleaseTypeText) !== "INGREDIENT" && (scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p7 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p7 === void 0 ? void 0 : (_scheduleGeneration$p8 = _scheduleGeneration$p7.dispensedetails) === null || _scheduleGeneration$p8 === void 0 ? void 0 : (_scheduleGeneration$p9 = _scheduleGeneration$p8[i]) === null || _scheduleGeneration$p9 === void 0 ? void 0 : _scheduleGeneration$p9.drugreleaseTypeText) !== "RCOMPOUND") {
                var _val$alias, _val$alias$find, _scheduleGeneration$p10, _scheduleGeneration$p11, _scheduleGeneration$p12, _scheduleGeneration$p13, _scheduleGeneration$p14, _scheduleGeneration$p15;

                var alisName = val === null || val === void 0 ? void 0 : (_val$alias = val.alias) === null || _val$alias === void 0 ? void 0 : (_val$alias$find = _val$alias.find(function (v) {
                  var _v$aliasType;

                  return (v === null || v === void 0 ? void 0 : (_v$aliasType = v.aliasType) === null || _v$aliasType === void 0 ? void 0 : _v$aliasType.code) === "AM002";
                })) === null || _val$alias$find === void 0 ? void 0 : _val$alias$find.aliasCode;
                selectedMedicine.push({
                  compcd: parseInt(compcdId),
                  facilitycd: parseInt(facilityId),
                  uniquekey: alisName || (val === null || val === void 0 ? void 0 : val.name) || "",
                  attrcode: 0,
                  substore: SubstoreId,
                  uom: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p10 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p10 === void 0 ? void 0 : (_scheduleGeneration$p11 = _scheduleGeneration$p10.dispensedetails) === null || _scheduleGeneration$p11 === void 0 ? void 0 : (_scheduleGeneration$p12 = _scheduleGeneration$p11[i]) === null || _scheduleGeneration$p12 === void 0 ? void 0 : _scheduleGeneration$p12.stockuomtext,
                  reqdqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p13 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p13 === void 0 ? void 0 : (_scheduleGeneration$p14 = _scheduleGeneration$p13.dispensedetails) === null || _scheduleGeneration$p14 === void 0 ? void 0 : (_scheduleGeneration$p15 = _scheduleGeneration$p14[i]) === null || _scheduleGeneration$p15 === void 0 ? void 0 : _scheduleGeneration$p15.totstkqty,
                  isblock: "N",
                  isgtn: "N",
                  isallocated: "N"
                });
              }
            });
            dispensedetails = scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p16 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p16 === void 0 ? void 0 : (_scheduleGeneration$p17 = _scheduleGeneration$p16.dispensedetails) === null || _scheduleGeneration$p17 === void 0 ? void 0 : _scheduleGeneration$p17.filter(function (val) {
              return val === null || val === void 0 ? void 0 : val.isAdditive;
            }); //to get addictive medicines

            params === null || params === void 0 ? void 0 : (_params$additives = params.additives) === null || _params$additives === void 0 ? void 0 : _params$additives.forEach(function (v, pIndex) {
              var _v$brands;

              (_v$brands = v.brands) === null || _v$brands === void 0 ? void 0 : _v$brands.forEach(function (val, i) {
                var _val$alias2, _val$alias2$find, _dispensedetails$pInd;

                var alisName = val === null || val === void 0 ? void 0 : (_val$alias2 = val.alias) === null || _val$alias2 === void 0 ? void 0 : (_val$alias2$find = _val$alias2.find(function (v) {
                  var _v$aliasType2;

                  return (v === null || v === void 0 ? void 0 : (_v$aliasType2 = v.aliasType) === null || _v$aliasType2 === void 0 ? void 0 : _v$aliasType2.code) === "AM002";
                })) === null || _val$alias2$find === void 0 ? void 0 : _val$alias2$find.aliasCode;

                if ((v === null || v === void 0 ? void 0 : v.addrugcode) === (dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd = dispensedetails[pIndex]) === null || _dispensedetails$pInd === void 0 ? void 0 : _dispensedetails$pInd.dispenseitemcode)) {
                  var _dispensedetails$pInd2, _dispensedetails$pInd3;

                  selectedMedicine.push({
                    compcd: parseInt(compcdId),
                    facilitycd: parseInt(facilityId),
                    uniquekey: alisName || (val === null || val === void 0 ? void 0 : val.name),
                    attrcode: 0,
                    substore: SubstoreId,
                    uom: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd2 = dispensedetails[pIndex]) === null || _dispensedetails$pInd2 === void 0 ? void 0 : _dispensedetails$pInd2.stockuomtext,
                    reqdqty: dispensedetails === null || dispensedetails === void 0 ? void 0 : (_dispensedetails$pInd3 = dispensedetails[pIndex]) === null || _dispensedetails$pInd3 === void 0 ? void 0 : _dispensedetails$pInd3.totstkqty,
                    isblock: "N",
                    isgtn: "N",
                    isallocated: "N"
                  });
                }
              });
            }); //to get compound

            CompundDispDetails = scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p18 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p18 === void 0 ? void 0 : (_scheduleGeneration$p19 = _scheduleGeneration$p18.dispensedetails) === null || _scheduleGeneration$p19 === void 0 ? void 0 : _scheduleGeneration$p19.filter(function (val) {
              return (val === null || val === void 0 ? void 0 : val.drugreleaseTypeText) === "INGREDIENT";
            });
            params === null || params === void 0 ? void 0 : (_params$compounds = params.compounds) === null || _params$compounds === void 0 ? void 0 : _params$compounds.forEach(function (val, i) {
              var _CompundDispDetails$i;

              if ((val === null || val === void 0 ? void 0 : val.dispensedrugcode) === (CompundDispDetails === null || CompundDispDetails === void 0 ? void 0 : (_CompundDispDetails$i = CompundDispDetails[i]) === null || _CompundDispDetails$i === void 0 ? void 0 : _CompundDispDetails$i.dispenseitemcode)) {
                var _val$alias3, _val$alias3$find, _CompundDispDetails$i2, _CompundDispDetails$i3;

                var alisName = val === null || val === void 0 ? void 0 : (_val$alias3 = val.alias) === null || _val$alias3 === void 0 ? void 0 : (_val$alias3$find = _val$alias3.find(function (v) {
                  var _v$aliasType3;

                  return (v === null || v === void 0 ? void 0 : (_v$aliasType3 = v.aliasType) === null || _v$aliasType3 === void 0 ? void 0 : _v$aliasType3.code) === "AM002";
                })) === null || _val$alias3$find === void 0 ? void 0 : _val$alias3$find.aliasCode;
                selectedMedicine.push({
                  compcd: parseInt(compcdId),
                  facilitycd: parseInt(facilityId),
                  uniquekey: alisName || (val === null || val === void 0 ? void 0 : val.name),
                  attrcode: 0,
                  substore: SubstoreId,
                  uom: CompundDispDetails === null || CompundDispDetails === void 0 ? void 0 : (_CompundDispDetails$i2 = CompundDispDetails[i]) === null || _CompundDispDetails$i2 === void 0 ? void 0 : _CompundDispDetails$i2.stockuomtext,
                  reqdqty: CompundDispDetails === null || CompundDispDetails === void 0 ? void 0 : (_CompundDispDetails$i3 = CompundDispDetails[i]) === null || _CompundDispDetails$i3 === void 0 ? void 0 : _CompundDispDetails$i3.totstkqty,
                  isblock: "N",
                  isgtn: "N",
                  isallocated: "N"
                });
              }
            });
            payload = {
              ptAvailStock: selectedMedicine
            };
            _context7.next = 12;
            return fetchData({
              body: JSON.stringify(payload)
            }, __AvailableStock__, {
              APIKey: __AvailableApiKey__,
              SecretKey: __AvailableSecretKey__
            });

          case 12:
            data = _context7.sent;
            return _context7.abrupt("return", data);

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function ptAvailStock(_x20, _x21, _x22, _x23) {
    return _ref7.apply(this, arguments);
  };
}();
var ptAvailStockMultiBatch = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(params, selectedOrder, scheduleGeneration, practitionerData, isShowMulti, alisName, orderbatches) {
    var _practitionerData$org4, _practitionerData$org5, _practitionerData$org6, _practitionerData$fac4, _practitionerData$fac5, _practitionerData$fac6, _practitionerData$loc8, _practitionerData$loc9, _practitionerData$loc10, _practitionerData$loc11;

    var selectedMedicine, compcdId, facilityId, SubstoreId, payload, data;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            selectedMedicine = [];
            compcdId = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$org4 = practitionerData.org) === null || _practitionerData$org4 === void 0 ? void 0 : (_practitionerData$org5 = _practitionerData$org4.alias) === null || _practitionerData$org5 === void 0 ? void 0 : (_practitionerData$org6 = _practitionerData$org5.find(function (v) {
              return v.aliasType.code === "EXQ";
            })) === null || _practitionerData$org6 === void 0 ? void 0 : _practitionerData$org6.aliasDesc;
            facilityId = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$fac4 = practitionerData.facility) === null || _practitionerData$fac4 === void 0 ? void 0 : (_practitionerData$fac5 = _practitionerData$fac4.alias) === null || _practitionerData$fac5 === void 0 ? void 0 : (_practitionerData$fac6 = _practitionerData$fac5.find(function (v) {
              return v.aliasType.code === "EXQ";
            })) === null || _practitionerData$fac6 === void 0 ? void 0 : _practitionerData$fac6.aliasDesc;
            SubstoreId = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$loc8 = practitionerData.location) === null || _practitionerData$loc8 === void 0 ? void 0 : (_practitionerData$loc9 = _practitionerData$loc8.pharmacy) === null || _practitionerData$loc9 === void 0 ? void 0 : (_practitionerData$loc10 = _practitionerData$loc9[0]) === null || _practitionerData$loc10 === void 0 ? void 0 : (_practitionerData$loc11 = _practitionerData$loc10.inventorySubStore) === null || _practitionerData$loc11 === void 0 ? void 0 : _practitionerData$loc11.locationID;
            orderbatches.forEach(function (val, i) {
              var _val$availableQuantit;

              selectedMedicine.push({
                compcd: parseInt(compcdId),
                facilitycd: parseInt(facilityId),
                uniquekey: alisName || "",
                attrcode: 0,
                substore: SubstoreId,
                uom: (_val$availableQuantit = val === null || val === void 0 ? void 0 : val.availableQuantityUOM) !== null && _val$availableQuantit !== void 0 ? _val$availableQuantit : "",
                reqdqty: isShowMulti ? 0 : val === null || val === void 0 ? void 0 : val.chargeqty,
                isblock: "N",
                isgtn: "N",
                isallocated: "N"
              });
            });
            payload = {
              ptAvailStock: selectedMedicine
            };
            _context8.next = 8;
            return fetchData({
              body: JSON.stringify(payload)
            }, __AvailableStock__, {
              APIKey: __AvailableApiKey__,
              SecretKey: __AvailableSecretKey__
            });

          case 8:
            data = _context8.sent;
            return _context8.abrupt("return", data);

          case 10:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function ptAvailStockMultiBatch(_x24, _x25, _x26, _x27, _x28, _x29, _x30) {
    return _ref8.apply(this, arguments);
  };
}();
var reIssueMedicationAvailStock = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(orderbatches, practitionerData, alisName) {
    var _practitionerData$org7, _practitionerData$org8, _practitionerData$fac7, _practitionerData$fac8, _practitionerData$loc12, _practitionerData$loc13, _practitionerData$loc14, _practitionerData$loc15;

    var selectedMedicine, compcdId, facilityId, SubstoreId, payload, data;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            selectedMedicine = [];
            compcdId = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$org7 = practitionerData.org.alias) === null || _practitionerData$org7 === void 0 ? void 0 : (_practitionerData$org8 = _practitionerData$org7.find(function (v) {
              var _v$aliasType4;

              return ((_v$aliasType4 = v.aliasType) === null || _v$aliasType4 === void 0 ? void 0 : _v$aliasType4.code) === "EXQ";
            })) === null || _practitionerData$org8 === void 0 ? void 0 : _practitionerData$org8.aliasDesc;
            facilityId = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$fac7 = practitionerData.facility.alias) === null || _practitionerData$fac7 === void 0 ? void 0 : (_practitionerData$fac8 = _practitionerData$fac7.find(function (v) {
              var _v$aliasType5;

              return ((_v$aliasType5 = v.aliasType) === null || _v$aliasType5 === void 0 ? void 0 : _v$aliasType5.code) === "EXQ";
            })) === null || _practitionerData$fac8 === void 0 ? void 0 : _practitionerData$fac8.aliasDesc;
            SubstoreId = practitionerData === null || practitionerData === void 0 ? void 0 : (_practitionerData$loc12 = practitionerData.location) === null || _practitionerData$loc12 === void 0 ? void 0 : (_practitionerData$loc13 = _practitionerData$loc12.pharmacy) === null || _practitionerData$loc13 === void 0 ? void 0 : (_practitionerData$loc14 = _practitionerData$loc13[0]) === null || _practitionerData$loc14 === void 0 ? void 0 : (_practitionerData$loc15 = _practitionerData$loc14.inventorySubStore) === null || _practitionerData$loc15 === void 0 ? void 0 : _practitionerData$loc15.locationID;
            orderbatches === null || orderbatches === void 0 ? void 0 : orderbatches.forEach(function (val, i) {
              var _val$issueuom;

              selectedMedicine.push({
                compcd: parseInt(compcdId),
                facilitycd: parseInt(facilityId),
                uniquekey: alisName || "",
                attrcode: 0,
                substore: SubstoreId,
                uom: (_val$issueuom = val === null || val === void 0 ? void 0 : val.issueuom) !== null && _val$issueuom !== void 0 ? _val$issueuom : "",
                reqdqty: val === null || val === void 0 ? void 0 : val.issueqty,
                isblock: "N",
                isgtn: "N",
                isallocated: "N"
              });
            });
            payload = {
              ptAvailStock: selectedMedicine
            };
            _context9.next = 8;
            return fetchData({
              body: JSON.stringify(payload)
            }, __AvailableStock__, {
              APIKey: __AvailableApiKey__,
              SecretKey: __AvailableSecretKey__
            });

          case 8:
            data = _context9.sent;
            return _context9.abrupt("return", data);

          case 10:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function reIssueMedicationAvailStock(_x31, _x32, _x33) {
    return _ref9.apply(this, arguments);
  };
}();
var issueMedicationStockUpdate = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(data, state) {
    var _state$signInReducerA, _state$signInReducerA2;

    var updateSTOCK, res, practitionerData, i, v, newData, j, l, newInnerData, k, _c$batchdeatils, c, _data, newInnerDataBatch;

    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            updateSTOCK = /*#__PURE__*/function () {
              var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(a, b, c) {
                var _data$Data;

                var data, getBatchDetails;
                return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        _context10.next = 2;
                        return reIssueMedicationAvailStock(a, b, c);

                      case 2:
                        data = _context10.sent;
                        getBatchDetails = data === null || data === void 0 ? void 0 : (_data$Data = data.Data) === null || _data$Data === void 0 ? void 0 : _data$Data.map(function (val) {
                          return _objectSpread2({
                            id: val === null || val === void 0 ? void 0 : val.batchno,
                            expiryDate: moment__default["default"](val === null || val === void 0 ? void 0 : val.expdate).format("MM/DD/YYYY"),
                            bin: {
                              number: val === null || val === void 0 ? void 0 : val.binlocty,
                              aisle: val === null || val === void 0 ? void 0 : val.binname // shelf: val?.loccode,
                              // level: val?.locrefno,

                            },
                            availableQuantity: val === null || val === void 0 ? void 0 : val.stockqty,
                            availableQuantityUOM: val === null || val === void 0 ? void 0 : val.stockuom,
                            heldQuantity: val === null || val === void 0 ? void 0 : val.blockqty,
                            totalAmount: val === null || val === void 0 ? void 0 : val.chargeprice,
                            Quantity: "".concat(val === null || val === void 0 ? void 0 : val.chargeqty, " ").concat(val === null || val === void 0 ? void 0 : val.chargeuom)
                          }, val);
                        });
                        return _context10.abrupt("return", getBatchDetails);

                      case 5:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee10);
              }));

              return function updateSTOCK(_x36, _x37, _x38) {
                return _ref11.apply(this, arguments);
              };
            }();

            res = [];
            practitionerData = state === null || state === void 0 ? void 0 : (_state$signInReducerA = state.signInReducerApiSlice) === null || _state$signInReducerA === void 0 ? void 0 : (_state$signInReducerA2 = _state$signInReducerA.loggedUserInfo) === null || _state$signInReducerA2 === void 0 ? void 0 : _state$signInReducerA2.data;
            i = 0;

          case 4:
            if (!(i < data.length)) {
              _context11.next = 30;
              break;
            }

            v = data[i];
            newData = _objectSpread2(_objectSpread2({}, v), {}, {
              PH_OrderLineDispenseSchedule: []
            });
            j = 0;

          case 8:
            if (!(j < v.PH_OrderLineDispenseSchedule.length)) {
              _context11.next = 26;
              break;
            }

            l = v.PH_OrderLineDispenseSchedule[j];
            newInnerData = _objectSpread2(_objectSpread2({}, l), {}, {
              dispensedetails: []
            });
            k = 0;

          case 12:
            if (!(k < l.dispensedetails.length)) {
              _context11.next = 22;
              break;
            }

            c = l.dispensedetails[k];
            _context11.next = 16;
            return updateSTOCK((_c$batchdeatils = c === null || c === void 0 ? void 0 : c.batchdeatils) !== null && _c$batchdeatils !== void 0 ? _c$batchdeatils : [], practitionerData, c === null || c === void 0 ? void 0 : c.dispenseitemaliascode);

          case 16:
            _data = _context11.sent;
            newInnerDataBatch = _objectSpread2(_objectSpread2({}, c), {}, {
              batchdeatils: _data
            });
            newInnerData.dispensedetails.push(newInnerDataBatch);

          case 19:
            k++;
            _context11.next = 12;
            break;

          case 22:
            newData.PH_OrderLineDispenseSchedule.push(newInnerData);

          case 23:
            j++;
            _context11.next = 8;
            break;

          case 26:
            res.push(newData);

          case 27:
            i++;
            _context11.next = 4;
            break;

          case 30:
            return _context11.abrupt("return", res);

          case 31:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function issueMedicationStockUpdate(_x34, _x35) {
    return _ref10.apply(this, arguments);
  };
}();

var GetAllSchedule = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(orders, practitionerData, isCart) {
    var Addictive, addtictives, dispense, compound, SchedulePayload, data;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            //To get Addictive
            Addictive = [];

            addtictives = function addtictives(additives) {
              additives === null || additives === void 0 ? void 0 : additives.forEach(function (va) {
                var _va$brands2;

                va === null || va === void 0 ? void 0 : (_va$brands2 = va.brands) === null || _va$brands2 === void 0 ? void 0 : _va$brands2.forEach(function (val, i) {
                  var _getSpecificUom41, _getSpecificUom42, _getSpecificUom43, _getSpecificUom44, _getSpecificUom45, _getSpecificUom46, _getSpecificUom47, _getSpecificUom48, _val$drugReleaseType4;

                  Addictive.push({
                    DispenseItemCode: (val === null || val === void 0 ? void 0 : val.dispensedrugcode) || (val === null || val === void 0 ? void 0 : val.drugName),
                    DispenseStrength: val === null || val === void 0 ? void 0 : val.dosageValue,
                    DispenseUOM: val === null || val === void 0 ? void 0 : val.dosageUOM_id,
                    DispenseUOMText: val === null || val === void 0 ? void 0 : val.dosageUOM,
                    AdminUOM: (_getSpecificUom41 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Admin")) === null || _getSpecificUom41 === void 0 ? void 0 : _getSpecificUom41._id,
                    AdminUOMText: (_getSpecificUom42 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Admin")) === null || _getSpecificUom42 === void 0 ? void 0 : _getSpecificUom42.UOM,
                    IssueUOM: (_getSpecificUom43 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Issue")) === null || _getSpecificUom43 === void 0 ? void 0 : _getSpecificUom43._id,
                    IssueUOMText: (_getSpecificUom44 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Issue")) === null || _getSpecificUom44 === void 0 ? void 0 : _getSpecificUom44.UOM,
                    BillUOM: (_getSpecificUom45 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Bill")) === null || _getSpecificUom45 === void 0 ? void 0 : _getSpecificUom45._id,
                    BillUOMText: (_getSpecificUom46 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Bill")) === null || _getSpecificUom46 === void 0 ? void 0 : _getSpecificUom46.UOM,
                    StockUOM: (_getSpecificUom47 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Stock")) === null || _getSpecificUom47 === void 0 ? void 0 : _getSpecificUom47._id,
                    StockUOMText: (_getSpecificUom48 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Stock")) === null || _getSpecificUom48 === void 0 ? void 0 : _getSpecificUom48.UOM,
                    isAdditive: true,
                    addrugcode: va === null || va === void 0 ? void 0 : va.addrugcode,
                    drugreleaseType: (_val$drugReleaseType4 = val === null || val === void 0 ? void 0 : val.drugReleaseType) !== null && _val$drugReleaseType4 !== void 0 ? _val$drugReleaseType4 : val === null || val === void 0 ? void 0 : val.drugreleasetype
                  });
                });
              });
              return Addictive;
            }; //To get Dispense


            dispense = function dispense(brands) {
              return brands === null || brands === void 0 ? void 0 : brands.map(function (val, i) {
                var _getSpecificUom49, _getSpecificUom50, _getSpecificUom51, _getSpecificUom52, _getSpecificUom53, _getSpecificUom54, _getSpecificUom55, _getSpecificUom56, _val$drugReleaseType5;

                return {
                  DispenseItemCode: (val === null || val === void 0 ? void 0 : val.dispensedrugcode) || (val === null || val === void 0 ? void 0 : val.drugName),
                  DispenseStrength: val === null || val === void 0 ? void 0 : val.dosageValue,
                  DispenseUOM: val === null || val === void 0 ? void 0 : val.dosageUOM_id,
                  DispenseUOMText: val === null || val === void 0 ? void 0 : val.dosageUOM,
                  AdminUOM: (_getSpecificUom49 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Admin")) === null || _getSpecificUom49 === void 0 ? void 0 : _getSpecificUom49._id,
                  AdminUOMText: (_getSpecificUom50 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Admin")) === null || _getSpecificUom50 === void 0 ? void 0 : _getSpecificUom50.UOM,
                  IssueUOM: (_getSpecificUom51 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Issue")) === null || _getSpecificUom51 === void 0 ? void 0 : _getSpecificUom51._id,
                  IssueUOMText: (_getSpecificUom52 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Issue")) === null || _getSpecificUom52 === void 0 ? void 0 : _getSpecificUom52.UOM,
                  BillUOM: (_getSpecificUom53 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Bill")) === null || _getSpecificUom53 === void 0 ? void 0 : _getSpecificUom53._id,
                  BillUOMText: (_getSpecificUom54 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Bill")) === null || _getSpecificUom54 === void 0 ? void 0 : _getSpecificUom54.UOM,
                  StockUOM: (_getSpecificUom55 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Stock")) === null || _getSpecificUom55 === void 0 ? void 0 : _getSpecificUom55._id,
                  StockUOMText: (_getSpecificUom56 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Stock")) === null || _getSpecificUom56 === void 0 ? void 0 : _getSpecificUom56.UOM,
                  isAdditive: false,
                  addrugcode: "",
                  drugreleaseType: (_val$drugReleaseType5 = val === null || val === void 0 ? void 0 : val.drugReleaseType) !== null && _val$drugReleaseType5 !== void 0 ? _val$drugReleaseType5 : val === null || val === void 0 ? void 0 : val.drugreleasetype
                };
              });
            }; //To get Compound


            compound = function compound(compounds) {
              return compounds === null || compounds === void 0 ? void 0 : compounds.map(function (val, i) {
                var _getSpecificUom57, _getSpecificUom58, _getSpecificUom59, _getSpecificUom60, _getSpecificUom61, _getSpecificUom62, _getSpecificUom63, _getSpecificUom64, _val$drugReleaseType6;

                return {
                  DispenseItemCode: (val === null || val === void 0 ? void 0 : val.dispensedrugcode) || (val === null || val === void 0 ? void 0 : val.drugName),
                  DispenseStrength: [val === null || val === void 0 ? void 0 : val.dosageValue],
                  DispenseUOM: val === null || val === void 0 ? void 0 : val.dosageUOM_id,
                  DispenseUOMText: val === null || val === void 0 ? void 0 : val.dosageUOM,
                  AdminUOM: (_getSpecificUom57 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Admin")) === null || _getSpecificUom57 === void 0 ? void 0 : _getSpecificUom57._id,
                  AdminUOMText: (_getSpecificUom58 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Admin")) === null || _getSpecificUom58 === void 0 ? void 0 : _getSpecificUom58.UOM,
                  IssueUOM: (_getSpecificUom59 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Issue")) === null || _getSpecificUom59 === void 0 ? void 0 : _getSpecificUom59._id,
                  IssueUOMText: (_getSpecificUom60 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Issue")) === null || _getSpecificUom60 === void 0 ? void 0 : _getSpecificUom60.UOM,
                  BillUOM: (_getSpecificUom61 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Bill")) === null || _getSpecificUom61 === void 0 ? void 0 : _getSpecificUom61._id,
                  BillUOMText: (_getSpecificUom62 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Bill")) === null || _getSpecificUom62 === void 0 ? void 0 : _getSpecificUom62.UOM,
                  StockUOM: (_getSpecificUom63 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Stock")) === null || _getSpecificUom63 === void 0 ? void 0 : _getSpecificUom63._id,
                  StockUOMText: (_getSpecificUom64 = getSpecificUom(val === null || val === void 0 ? void 0 : val.packSizeApplicability, "Stock")) === null || _getSpecificUom64 === void 0 ? void 0 : _getSpecificUom64.UOM,
                  isAdditive: false,
                  addrugcode: "",
                  drugreleaseType: (_val$drugReleaseType6 = val === null || val === void 0 ? void 0 : val.drugReleaseType) !== null && _val$drugReleaseType6 !== void 0 ? _val$drugReleaseType6 : val === null || val === void 0 ? void 0 : val.drugreleasetype //"RCOMPOUND"

                };
              });
            }; //main Payload


            SchedulePayload = orders === null || orders === void 0 ? void 0 : orders.map(function (order) {
              var _order$dispenseDurati7, _order$dispenseDurati8, _order$dispenseDurati9, _order$dosageFreqCode2, _order$dispenseDurati10, _order$dispenseDurati11, _order$routeCode_id2, _order$disptype2, _order$deliveringDisp2, _order$dispenseDurati12;

              var obj = {};

              if (isCart) {
                obj["Cartid"] = (order === null || order === void 0 ? void 0 : order.Cartid) || "";
                obj["CartTransId"] = (order === null || order === void 0 ? void 0 : order.CartTransId) || "";
              }

              return _objectSpread2({
                EncounterType: order === null || order === void 0 ? void 0 : order.EncounterType,
                OrderId: order === null || order === void 0 ? void 0 : order._id,
                OrderItemcode: order === null || order === void 0 ? void 0 : (_order$dispenseDurati7 = order.dispenseDurationValue) === null || _order$dispenseDurati7 === void 0 ? void 0 : _order$dispenseDurati7.drug_id,
                OrderStrength: order === null || order === void 0 ? void 0 : order.dosageValue,
                OrderUOM: order === null || order === void 0 ? void 0 : order.dosageUOM_id,
                PatientId: order === null || order === void 0 ? void 0 : order.patient_Id,
                Startdate: order === null || order === void 0 ? void 0 : (_order$dispenseDurati8 = order.dispenseDurationValue) === null || _order$dispenseDurati8 === void 0 ? void 0 : _order$dispenseDurati8.dispStartDate,
                Enddate: order === null || order === void 0 ? void 0 : (_order$dispenseDurati9 = order.dispenseDurationValue) === null || _order$dispenseDurati9 === void 0 ? void 0 : _order$dispenseDurati9.dispEndDate,
                freqcode: (_order$dosageFreqCode2 = order === null || order === void 0 ? void 0 : order.dosageFreqCode_id) !== null && _order$dosageFreqCode2 !== void 0 ? _order$dosageFreqCode2 : "",
                dosageDurationValue: order === null || order === void 0 ? void 0 : (_order$dispenseDurati10 = order.dispenseDurationValue) === null || _order$dispenseDurati10 === void 0 ? void 0 : _order$dispenseDurati10.dispDuration,
                dosageDurationUOM: order === null || order === void 0 ? void 0 : (_order$dispenseDurati11 = order.dispenseDurationValue) === null || _order$dispenseDurati11 === void 0 ? void 0 : _order$dispenseDurati11.dosageDurationUOM,
                Isfirstdose: false,
                DispenseDetails: [].concat(_toConsumableArray(dispense(order === null || order === void 0 ? void 0 : order.brands) || []), _toConsumableArray(addtictives(order === null || order === void 0 ? void 0 : order.additives) || []), _toConsumableArray(compound(order === null || order === void 0 ? void 0 : order.compounds) || [])),
                ivInfusionRateValue: order.ivInfusionRateValue,
                ivInfusionRateUOM: order === null || order === void 0 ? void 0 : order.ivInfusionRateUOM,
                routeCode: (_order$routeCode_id2 = order === null || order === void 0 ? void 0 : order.routeCode_id) !== null && _order$routeCode_id2 !== void 0 ? _order$routeCode_id2 : "",
                disptype: order === null || order === void 0 ? void 0 : (_order$disptype2 = order.disptype) === null || _order$disptype2 === void 0 ? void 0 : _order$disptype2.code,
                dispenseDurationValue: (order === null || order === void 0 ? void 0 : (_order$deliveringDisp2 = order.deliveringDispenseDuration) === null || _order$deliveringDisp2 === void 0 ? void 0 : _order$deliveringDisp2.length) > 0 ? parseInt(order === null || order === void 0 ? void 0 : order.deliveringDispenseDuration) : order === null || order === void 0 ? void 0 : (_order$dispenseDurati12 = order.dispenseDurationValue) === null || _order$dispenseDurati12 === void 0 ? void 0 : _order$dispenseDurati12.dispDuration,
                dispenseDurationUOM: order === null || order === void 0 ? void 0 : order.dosageUOM_id,
                RefillDate: order === null || order === void 0 ? void 0 : order.nextrefilldate
              }, obj);
            });
            _context12.next = 7;
            return fetchData({
              body: JSON.stringify(SchedulePayload)
            }, __DoseScheduleGeneration__);

          case 7:
            data = _context12.sent;
            return _context12.abrupt("return", data);

          case 9:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function GetAllSchedule(_x39, _x40, _x41) {
    return _ref12.apply(this, arguments);
  };
}();

var brandScheduleGeneration = function brandScheduleGeneration(scheduleGeneration, brands, availableStock, order) {
  return brands.map(function (brnd, i) {
    var _scheduleGeneration$p20, _scheduleGeneration$p21, _scheduleGeneration$p22, _scheduleGeneration$p23, _scheduleGeneration$p24, _scheduleGeneration$p25;

    if (!(scheduleGeneration !== null && scheduleGeneration !== void 0 && (_scheduleGeneration$p20 = scheduleGeneration.pH_OrderLineDispenseSchedule) !== null && _scheduleGeneration$p20 !== void 0 && (_scheduleGeneration$p21 = _scheduleGeneration$p20.dispensedetails) !== null && _scheduleGeneration$p21 !== void 0 && (_scheduleGeneration$p22 = _scheduleGeneration$p21[i]) !== null && _scheduleGeneration$p22 !== void 0 && _scheduleGeneration$p22.isAdditive) && (scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p23 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p23 === void 0 ? void 0 : (_scheduleGeneration$p24 = _scheduleGeneration$p23.dispensedetails) === null || _scheduleGeneration$p24 === void 0 ? void 0 : (_scheduleGeneration$p25 = _scheduleGeneration$p24[i]) === null || _scheduleGeneration$p25 === void 0 ? void 0 : _scheduleGeneration$p25.drugreleaseTypeText) !== "INGREDIENT") {
      var _brnd$alias, _brnd$alias$find, _scheduleGeneration$p26, _scheduleGeneration$p27, _scheduleGeneration$p28, _scheduleGeneration$p29, _scheduleGeneration$p30, _scheduleGeneration$p31, _scheduleGeneration$p32, _scheduleGeneration$p33, _scheduleGeneration$p34, _scheduleGeneration$p35, _scheduleGeneration$p36, _scheduleGeneration$p37, _scheduleGeneration$p38, _scheduleGeneration$p39, _scheduleGeneration$p40, _scheduleGeneration$p41, _scheduleGeneration$p42, _scheduleGeneration$p43, _order$drugDetails, _order$drugDetails$, _scheduleGeneration$p44, _scheduleGeneration$p45, _scheduleGeneration$p46, _scheduleGeneration$p47, _scheduleGeneration$p48, _scheduleGeneration$p49, _scheduleGeneration$p50, _scheduleGeneration$p51, _scheduleGeneration$p52, _scheduleGeneration$p53, _scheduleGeneration$p54, _scheduleGeneration$p55, _scheduleGeneration$p56, _scheduleGeneration$p57, _scheduleGeneration$p58, _scheduleGeneration$p59, _scheduleGeneration$p60, _scheduleGeneration$p61, _scheduleGeneration$p62, _scheduleGeneration$p63, _scheduleGeneration$p64, _scheduleGeneration$p65, _scheduleGeneration$p66, _scheduleGeneration$p67, _scheduleGeneration$p68, _scheduleGeneration$p69, _scheduleGeneration$p70;

      var alisName = brnd === null || brnd === void 0 ? void 0 : (_brnd$alias = brnd.alias) === null || _brnd$alias === void 0 ? void 0 : (_brnd$alias$find = _brnd$alias.find(function (v) {
        var _v$aliasType6;

        return (v === null || v === void 0 ? void 0 : (_v$aliasType6 = v.aliasType) === null || _v$aliasType6 === void 0 ? void 0 : _v$aliasType6.code) === "AM002";
      })) === null || _brnd$alias$find === void 0 ? void 0 : _brnd$alias$find.aliasCode;
      var drugReleaseType = scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p26 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p26 === void 0 ? void 0 : (_scheduleGeneration$p27 = _scheduleGeneration$p26.dispensedetails) === null || _scheduleGeneration$p27 === void 0 ? void 0 : (_scheduleGeneration$p28 = _scheduleGeneration$p27[i]) === null || _scheduleGeneration$p28 === void 0 ? void 0 : _scheduleGeneration$p28.drugreleaseTypeText;
      return {
        id: brnd === null || brnd === void 0 ? void 0 : brnd.id,
        uniqueId: brnd === null || brnd === void 0 ? void 0 : brnd.uniqueId,
        alias: brnd === null || brnd === void 0 ? void 0 : brnd.alias,
        drugPhotoId: brnd === null || brnd === void 0 ? void 0 : brnd.drugPhotoId,
        drugreleasetype: brnd === null || brnd === void 0 ? void 0 : brnd.drugreleasetype,
        name: brnd === null || brnd === void 0 ? void 0 : brnd.name,
        DrugType: brnd === null || brnd === void 0 ? void 0 : brnd.DrugType,
        drugNameLong: brnd === null || brnd === void 0 ? void 0 : brnd.drugNameLong,
        dispensedrugcode: brnd === null || brnd === void 0 ? void 0 : brnd.id,
        dosageUOM_id: (_scheduleGeneration$p29 = scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p30 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p30 === void 0 ? void 0 : (_scheduleGeneration$p31 = _scheduleGeneration$p30.dispensedetails) === null || _scheduleGeneration$p31 === void 0 ? void 0 : (_scheduleGeneration$p32 = _scheduleGeneration$p31[i]) === null || _scheduleGeneration$p32 === void 0 ? void 0 : _scheduleGeneration$p32.dispuom) !== null && _scheduleGeneration$p29 !== void 0 ? _scheduleGeneration$p29 : brnd === null || brnd === void 0 ? void 0 : brnd.dosageUOM_id,
        strength: brnd === null || brnd === void 0 ? void 0 : brnd.strength,
        route: "Oral",
        doseCount: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p33 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p33 === void 0 ? void 0 : (_scheduleGeneration$p34 = _scheduleGeneration$p33.dispensedetails) === null || _scheduleGeneration$p34 === void 0 ? void 0 : (_scheduleGeneration$p35 = _scheduleGeneration$p34[i]) === null || _scheduleGeneration$p35 === void 0 ? void 0 : _scheduleGeneration$p35.totnoofdose,
        tabPerDose: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p36 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p36 === void 0 ? void 0 : (_scheduleGeneration$p37 = _scheduleGeneration$p36.dispensedetails) === null || _scheduleGeneration$p37 === void 0 ? void 0 : (_scheduleGeneration$p38 = _scheduleGeneration$p37[i]) === null || _scheduleGeneration$p38 === void 0 ? void 0 : _scheduleGeneration$p38.totissueqty,
        actualdoseCount: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p39 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p39 === void 0 ? void 0 : (_scheduleGeneration$p40 = _scheduleGeneration$p39.dispensedetails) === null || _scheduleGeneration$p40 === void 0 ? void 0 : (_scheduleGeneration$p41 = _scheduleGeneration$p40[i]) === null || _scheduleGeneration$p41 === void 0 ? void 0 : _scheduleGeneration$p41.totbillqty,
        batches: drugReleaseType === "RCOMPOUND" ? getCompoundBatch(scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p42 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p42 === void 0 ? void 0 : (_scheduleGeneration$p43 = _scheduleGeneration$p42.dispensedetails) === null || _scheduleGeneration$p43 === void 0 ? void 0 : _scheduleGeneration$p43[i], order === null || order === void 0 ? void 0 : (_order$drugDetails = order.drugDetails) === null || _order$drugDetails === void 0 ? void 0 : (_order$drugDetails$ = _order$drugDetails[0]) === null || _order$drugDetails$ === void 0 ? void 0 : _order$drugDetails$.stability) : getBatches(availableStock === null || availableStock === void 0 ? void 0 : availableStock.Data, alisName),
        option: brnd.option,
        dosageValue: brnd === null || brnd === void 0 ? void 0 : brnd.dosageValue,
        allStrength: brnd === null || brnd === void 0 ? void 0 : brnd.allStrength,
        dosageUOM: brnd === null || brnd === void 0 ? void 0 : brnd.dosageUOM,
        packSizeApplicability: brnd === null || brnd === void 0 ? void 0 : brnd.packSizeApplicability,
        totadmqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p44 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p44 === void 0 ? void 0 : (_scheduleGeneration$p45 = _scheduleGeneration$p44.dispensedetails) === null || _scheduleGeneration$p45 === void 0 ? void 0 : (_scheduleGeneration$p46 = _scheduleGeneration$p45[i]) === null || _scheduleGeneration$p46 === void 0 ? void 0 : _scheduleGeneration$p46.totadmqty,
        totadmuom: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p47 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p47 === void 0 ? void 0 : (_scheduleGeneration$p48 = _scheduleGeneration$p47.dispensedetails) === null || _scheduleGeneration$p48 === void 0 ? void 0 : (_scheduleGeneration$p49 = _scheduleGeneration$p48[i]) === null || _scheduleGeneration$p49 === void 0 ? void 0 : _scheduleGeneration$p49.adminuomext,
        totstkqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p50 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p50 === void 0 ? void 0 : (_scheduleGeneration$p51 = _scheduleGeneration$p50.dispensedetails) === null || _scheduleGeneration$p51 === void 0 ? void 0 : (_scheduleGeneration$p52 = _scheduleGeneration$p51[i]) === null || _scheduleGeneration$p52 === void 0 ? void 0 : _scheduleGeneration$p52.totstkqty,
        totstkuom: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p53 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p53 === void 0 ? void 0 : (_scheduleGeneration$p54 = _scheduleGeneration$p53.dispensedetails) === null || _scheduleGeneration$p54 === void 0 ? void 0 : (_scheduleGeneration$p55 = _scheduleGeneration$p54[i]) === null || _scheduleGeneration$p55 === void 0 ? void 0 : _scheduleGeneration$p55.stockuomtext,
        totbillqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p56 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p56 === void 0 ? void 0 : (_scheduleGeneration$p57 = _scheduleGeneration$p56.dispensedetails) === null || _scheduleGeneration$p57 === void 0 ? void 0 : (_scheduleGeneration$p58 = _scheduleGeneration$p57[i]) === null || _scheduleGeneration$p58 === void 0 ? void 0 : _scheduleGeneration$p58.totbillqty,
        totbilluom: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p59 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p59 === void 0 ? void 0 : (_scheduleGeneration$p60 = _scheduleGeneration$p59.dispensedetails) === null || _scheduleGeneration$p60 === void 0 ? void 0 : (_scheduleGeneration$p61 = _scheduleGeneration$p60[i]) === null || _scheduleGeneration$p61 === void 0 ? void 0 : _scheduleGeneration$p61.billuomtext,
        totissueqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p62 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p62 === void 0 ? void 0 : (_scheduleGeneration$p63 = _scheduleGeneration$p62.dispensedetails) === null || _scheduleGeneration$p63 === void 0 ? void 0 : (_scheduleGeneration$p64 = _scheduleGeneration$p63[i]) === null || _scheduleGeneration$p64 === void 0 ? void 0 : _scheduleGeneration$p64.totissueqty,
        totissueuom: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p65 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p65 === void 0 ? void 0 : (_scheduleGeneration$p66 = _scheduleGeneration$p65.dispensedetails) === null || _scheduleGeneration$p66 === void 0 ? void 0 : (_scheduleGeneration$p67 = _scheduleGeneration$p66[i]) === null || _scheduleGeneration$p67 === void 0 ? void 0 : _scheduleGeneration$p67.issueuomtext,
        perdoseadminqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p68 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p68 === void 0 ? void 0 : (_scheduleGeneration$p69 = _scheduleGeneration$p68.dispensedetails) === null || _scheduleGeneration$p69 === void 0 ? void 0 : (_scheduleGeneration$p70 = _scheduleGeneration$p69[i]) === null || _scheduleGeneration$p70 === void 0 ? void 0 : _scheduleGeneration$p70.perdoseadminqty,
        pH_OrderLineDispenseSchedule: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : scheduleGeneration.pH_OrderLineDispenseSchedule
      };
    }
  }).filter(function (notUndefined) {
    return notUndefined !== undefined;
  });
};

var getOrderSchedule = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(orders, practitionerData, isCart) {
    var Orders, getAllSchedule, index, order, schedule, brands, updatedAdditive, getCompOrder, availableStock;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            Orders = JSON.parse(JSON.stringify(orders));
            _context13.next = 3;
            return GetAllSchedule(orders, practitionerData, isCart);

          case 3:
            getAllSchedule = _context13.sent;
            index = 0;

          case 5:
            if (!(index < Orders.length)) {
              _context13.next = 29;
              break;
            }

            order = Orders[index];
            schedule = getAllSchedule[index];
            brands = void 0;
            updatedAdditive = void 0;
            getCompOrder = void 0;

            if (!schedule) {
              _context13.next = 26;
              break;
            }

            _context13.next = 14;
            return ptAvailStock(order, order, schedule, practitionerData);

          case 14:
            availableStock = _context13.sent;
            _context13.next = 17;
            return brandScheduleGeneration(schedule, order === null || order === void 0 ? void 0 : order.brands, availableStock, order);

          case 17:
            brands = _context13.sent;

            // constructing value for the Attictives
            if (schedule !== null && schedule !== void 0 && schedule.pH_OrderLineDispenseSchedule) {
              updatedAdditive = generateUpdateAdditive(order, schedule, availableStock);
            } // constructing value for the compound


            if (order !== null && order !== void 0 && order.isCompound) {
              if (schedule !== null && schedule !== void 0 && schedule.pH_OrderLineDispenseSchedule) {
                getCompOrder = getUpdatedCompOrder(order === null || order === void 0 ? void 0 : order.compounds, schedule, availableStock);
              }
            } //setting value in the brands


            order.brands = brands; //setting value in the Addictives

            order.additives = updatedAdditive; //setting value in the Compound

            order.compounds = getCompOrder; //schedule value in order

            order.pH_OrderLinePerdoseSchedule = schedule === null || schedule === void 0 ? void 0 : schedule.pH_OrderLinePerdoseSchedule;
            order.pH_OrderLineDispenseSchedule = schedule === null || schedule === void 0 ? void 0 : schedule.pH_OrderLineDispenseSchedule; //replacing the reconstructed order

            Orders[index] = order;

          case 26:
            index++;
            _context13.next = 5;
            break;

          case 29:
            return _context13.abrupt("return", Orders);

          case 30:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function getOrderSchedule(_x42, _x43, _x44) {
    return _ref13.apply(this, arguments);
  };
}();
var isMultiOrderVerify = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(multiOrder, selectedState, patientId, action, status, practitionerData, reIssueReason, isReisse) {
    var arr, index, singleOrder, data;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            arr = [];
            index = 0;

          case 2:
            if (!(index < multiOrder.length)) {
              _context14.next = 11;
              break;
            }

            singleOrder = multiOrder[index];
            _context14.next = 6;
            return generateVerifyData(singleOrder, selectedState, patientId, action, status, practitionerData, reIssueReason, isReisse);

          case 6:
            data = _context14.sent;
            arr.push(data);

          case 8:
            index++;
            _context14.next = 2;
            break;

          case 11:
            return _context14.abrupt("return", arr);

          case 12:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function isMultiOrderVerify(_x45, _x46, _x47, _x48, _x49, _x50, _x51, _x52) {
    return _ref14.apply(this, arguments);
  };
}();
var isMultiOrderVerifyMedication = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(multiOrder, selectedState, patientId, action, status, practitionerData, isApproval) {
    var arr, index, singleOrder, data;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            arr = [];
            index = 0;

          case 2:
            if (!(index < multiOrder.length)) {
              _context15.next = 11;
              break;
            }

            singleOrder = multiOrder[index];
            _context15.next = 6;
            return generateMedicationData(singleOrder, selectedState, patientId, action, status, practitionerData, true, isApproval);

          case 6:
            data = _context15.sent;
            arr.push(data);

          case 8:
            index++;
            _context15.next = 2;
            break;

          case 11:
            return _context15.abrupt("return", arr);

          case 12:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function isMultiOrderVerifyMedication(_x53, _x54, _x55, _x56, _x57, _x58, _x59) {
    return _ref15.apply(this, arguments);
  };
}();

var dbName = process.env.REACT_APP_DB;
var idm_metadata_dbname$1 = process.env.REACT_APP_METADATA_DB_NAME;
var metadataId = "04ecb73d-f048-44ce-8563-c9be015812dd";
process.env.REACT_APP_IDM_DB;
var __baseUrl__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_BASE_URL_HOST, ":").concat(process.env.REACT_APP_BASE_URL_PORT, "/api/read_qdmqueries");
var __uspsertUrl__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_BASE_URL_HOST, ":").concat(process.env.REACT_APP_BASE_URL_PORT, "/api/upsert_document");
var __update__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_BASE_URL_HOST, ":").concat(process.env.REACT_APP_BASE_URL_PORT, "/api/updatedocument");
var __readDocumentUrl__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_BASE_URL_HOST, ":").concat(process.env.REACT_APP_BASE_URL_PORT, "/api/read_documents");
var __deleteUrl__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_BASE_URL_HOST, ":").concat(process.env.REACT_APP_BASE_URL_PORT, "/api/delete_document");
var __softDelete__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_BASE_URL_HOST, ":").concat(process.env.REACT_APP_BASE_URL_PORT, "/api/soft_delete");
var __GetDispenseDuration__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_PHARMACY_URL_HOST, "/api/ScheduleGeneration/GetDispenseDuration");
var __DispenseDoseStrength__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_PHARMACY_URL_HOST, "/api/UomConversion/CalculateDispenseDoseStrength");
var __DoseScheduleGeneration__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_PHARMACY_URL_HOST, "/api/ScheduleGeneration/DoseScheduleGeneration");
var __AvailableStock__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_PHARMACY_URL_HOST, "/api/Exchequer/StockAvailabilityCheck");
var __AvailableApiKey__ = "".concat(process.env.REACT_APP_STOCK_AVAILABLE_API_KEY);
var __AvailableSecretKey__ = "".concat(process.env.REACT_APP_STOCK_AVAILABLE_SECRET_KEY);
"".concat(process.env.REACT_APP_NIFI_API, "/api/v1/verifyUserAction");
"".concat(process.env.REACT_APP_NIFI_API, "/api/v1/filling/Reverify");
"".concat(process.env.REACT_APP_NIFI_API, "/api/v1/filling/Filled");
var __DiscontinueActionUrl__ = "".concat(process.env.REACT_APP_NIFI_API, "/api/v1/verification/Discontinue");
"".concat(process.env.REACT_APP_NIFI_API, "/api/v1/checking/Reverify");
"".concat(process.env.REACT_APP_NIFI_API, "/api/v1/checking/Checked");
"".concat(process.env.REACT_APP_NIFI_API, "/api/v1/dispense/Reverify");
"".concat(process.env.REACT_APP_NIFI_API, "/api/v1/dispense/Issue");
var __PrintLabel__ = "".concat(process.env.REACT_APP_PDF_API, "/api/generateReport");
var __Getreportlist__ = "".concat(process.env.REACT_APP_QUERY_URL, "/GetReportList");
var __ReportQueryExecution__ = "".concat(process.env.REACT_APP_QUERY_URL, "/ReportQueryExecution");
var __OrderlinewithQueue__ = "".concat(process.env.REACT_APP_NIFI_API, "/api/v1/upsert/OrderlinewithQueue");
var __GetOrderDate__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_PHARMACY_URL_HOST, "/api/ScheduleGeneration/GetOrderStartDate");
var __ReturnDrug__ = "".concat(process.env.REACT_APP_NIFI_API, "/api/v1/insertQdmTransactionLog");
"".concat(process.env.REACT_APP_NIFI_API, "/api/v1/returnMedicationOrder");
"".concat(process.env.REACT_APP_NIFI_API, "/api/v1/returnMedicationOrderRequestApproved");
"".concat(process.env.REACT_APP_NIFI_API, "/api/v1/returnMedicationOrderRequestRejected");
var __OpenCart__ = "".concat(process.env.REACT_APP_NIFI_API, "/api/v1/multiSelectOpenCart");
var __CloseCart__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_PHARMACY_URL_HOST, "/api/ScheduleGeneration/CartClose");
var __GetDispenseDurationByCart__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_PHARMACY_URL_HOST, "/api/ScheduleGeneration/GetDispenseDurationbyCart");
var __TokenGeneration__ = "".concat(process.env.REACT_APP_TOKEN_URL, "/IDMJWTTokencreation");
var __RolePermission__ = "".concat(process.env.REACT_APP_TOKEN_URL, "/GetPermissionforRoles");
var __GetQueueList__ = "".concat(process.env.REACT_APP_NIFI_API, "/api/v1/getAllQueueList");
var __GetDrugDispLocMaster__ = "".concat(process.env.REACT_APP_NIFI_API, "/api/v1/LoadDispesnsepharmacy");
var __upsertPractitioner__ = "".concat(process.env.REACT_APP_NIFI_API, "/api/v1/upsertPractitioner");
var __orderDefault__ = "".concat(process.env.REACT_APP_NIFI_API, "/api/v1/orderDefault");
var __signin__ = "".concat(process.env.REACT_APP_NIFI_API, "/api/v1/orgUserSignIn"); //get allery interaction

var __allergyInteraction__ = "".concat(process.env.REACT_APP_COMMON_NIFI_API, "/api/v1/clinicalscreening");
var __drugDuplication__ = "".concat(process.env.REACT_APP_COMMON_NIFI_API, "/api/v1/drugDuplicationAlert"); // IDM Links

var __ListIDMRepositories__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_IDM_URL, "/list_idmRepository");
var __GetAllPermissions__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_IDM_URL, "/getAllPermissions");
var __GetPermissionByID__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_IDM_URL, "/get_permissionById");
var __UpsertPermission__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_IDM_URL, "/upsert_permission");
var __DeletePermission__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_IDM_URL, "/permissionSoftDelete");
var __GetRoleById__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_IDM_URL, "/get_roleById");
var __RoleSoftDelete__ = "".concat(process.env.REACT_APP_BASE_URL_PROTOCAL, "://").concat(process.env.REACT_APP_IDM_URL, "/roleSoftDelete");
var __reIssueMedication__ = "".concat(process.env.REACT_APP_NIFI_API, "/api/v1/reIssue/Insertqueue");
var __upsertQueueNo__ = "".concat(process.env.REACT_APP_NIFI_API, "/api/v1/upsertQueueNo");
"".concat(process.env.REACT_APP_NIFI_API, "/api/v1/orderLine/discontinue");

var fetchData = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(input) {
    var url,
        header,
        jwtToken,
        __options,
        res,
        data,
        _args = arguments;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = _args.length > 1 && _args[1] !== undefined ? _args[1] : __baseUrl__;
            header = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            jwtToken = localStorage.getItem("userInfo"); // get jwt token from local storage

            __options = {
              method: "POST",
              headers: _objectSpread2({
                "Content-Type": "application/json",
                jwttoken: jwtToken
              }, header),
              body: {}
            };
            _context.next = 6;
            return fetch(url, _objectSpread2(_objectSpread2({}, __options), input));

          case 6:
            res = _context.sent;
            _context.next = 9;
            return res.json();

          case 9:
            data = _context.sent;
            return _context.abrupt("return", data);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchData(_x) {
    return _ref3.apply(this, arguments);
  };
}();

var makeName = function makeName() {
  var _prefix$coding, _prefix$coding$, _suffix$coding, _suffix$coding$;

  var nameObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _nameObj$prefix = nameObj.prefix,
      prefix = _nameObj$prefix === void 0 ? "" : _nameObj$prefix,
      _nameObj$given = nameObj.given,
      given = _nameObj$given === void 0 ? "" : _nameObj$given,
      _nameObj$text = nameObj.text,
      text = _nameObj$text === void 0 ? "" : _nameObj$text,
      _nameObj$suffix = nameObj.suffix,
      suffix = _nameObj$suffix === void 0 ? "" : _nameObj$suffix,
      _nameObj$family = nameObj.family,
      family = _nameObj$family === void 0 ? "" : _nameObj$family;
  var prefixVal = (prefix === null || prefix === void 0 ? void 0 : (_prefix$coding = prefix.coding) === null || _prefix$coding === void 0 ? void 0 : (_prefix$coding$ = _prefix$coding[0]) === null || _prefix$coding$ === void 0 ? void 0 : _prefix$coding$.display) || (prefix === null || prefix === void 0 ? void 0 : prefix.display) || "";
  var suffixVal = (suffix === null || suffix === void 0 ? void 0 : (_suffix$coding = suffix.coding) === null || _suffix$coding === void 0 ? void 0 : (_suffix$coding$ = _suffix$coding[0]) === null || _suffix$coding$ === void 0 ? void 0 : _suffix$coding$.display) || (suffix === null || suffix === void 0 ? void 0 : suffix.display) || "";
  return "".concat(prefixVal && prefixVal + ".").concat(text && text + " ").concat(given && given + " ").concat(family && family + " ").concat(suffixVal && suffixVal);
};

var getUtcTime = function getUtcTime(date) {
  if (date) {
    return moment__default["default"].utc(date).unix();
  } else {
    return moment__default["default"].utc().unix();
  }
};

var utcTOLocal = function utcTOLocal(date, format) {
  var Ndate = new Date();

  if (typeof date === "number") {
    Ndate = moment__default["default"].unix(date);
  } else {
    Ndate = moment__default["default"](date);
  }

  var fmt = format ? format : "DD-MM-YYYY";

  if (format) {
    return moment__default["default"].utc(Ndate).local().format(fmt);
  } else {
    return moment__default["default"].utc(Ndate).local();
  }
};

var getAge = function getAge(date) {
  if (date) {
    var yearDiff = moment__default["default"]().diff(moment__default["default"](date, "DD/MM/YYYY"), "years", false);

    if (yearDiff > 0) {
      return yearDiff + " Y";
    }

    var monthDiff = moment__default["default"]().diff(moment__default["default"](date, "DD/MM/YYYY"), "months", false);

    if (monthDiff > 0) {
      return monthDiff + " M";
    }

    var dayDiff = moment__default["default"]().diff(moment__default["default"](date, "DD/MM/YYYY"), "days", false);
    return dayDiff + " D";
  }

  return "";
};

var fetchDataApi = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var url,
        input,
        jwtToken,
        __options,
        res,
        _args3 = arguments;

    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : __baseUrl__;
            input = _args3.length > 1 ? _args3[1] : undefined;
            jwtToken = localStorage.getItem("userInfo"); // get jwt token from local storage

            __options = input || {};

            if (__options.headers) {
              __options.headers.jwttoken = jwtToken;
            } else {
              __options.headers = {
                "Content-Type": "application/json",
                Accept: "application/json",
                jwttoken: jwtToken
              };
            }

            _context3.next = 7;
            return fetch(url, _objectSpread2({}, __options));

          case 7:
            res = _context3.sent;
            return _context3.abrupt("return", res);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchDataApi() {
    return _ref5.apply(this, arguments);
  };
}();

var fetchDataQueueList = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var url,
        header,
        jwtToken,
        __options,
        res,
        data,
        _args4 = arguments;

    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : __baseUrl__;
            header = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            jwtToken = localStorage.getItem("userInfo"); // get jwt token from local storage

            __options = {
              method: "POST",
              headers: _objectSpread2({
                "Content-Type": "application/json",
                jwttoken: jwtToken
              }, header)
            };
            _context4.next = 6;
            return fetch(url, _objectSpread2({}, __options));

          case 6:
            res = _context4.sent;
            _context4.next = 9;
            return res.json();

          case 9:
            data = _context4.sent;
            return _context4.abrupt("return", data);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchDataQueueList() {
    return _ref6.apply(this, arguments);
  };
}();

var _extraReducers$1s;
var Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJ = toolkit.createAsyncThunk("Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJReducer/pharmacy_orderrouting_orderingfacility_dropdown_zbjtj", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "Organization",
              filter: "FIRST(DOCUMENT(Organization.OrgType)[*].code) == 'OT003' && Organization.isExternal==false && Organization.activestatus==true && Organization.active==true ",
              return_fields: "KEEP(Organization,'_id','id','_key','name','entitycode','active','isExternal')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJReducer = toolkit.createSlice({
  name: "Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJReducer",
  initialState: {
    pharmacy_orderrouting_orderingfacility_dropdown_ZBjTJ: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1s = {}, _defineProperty(_extraReducers$1s, Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJ.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_orderrouting_orderingfacility_dropdown_ZBjTJ.loading = false, state.pharmacy_orderrouting_orderingfacility_dropdown_ZBjTJ.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_orderrouting_orderingfacility_dropdown_ZBjTJ.error = false, state.pharmacy_orderrouting_orderingfacility_dropdown_ZBjTJ.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1s, Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJ.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_orderrouting_orderingfacility_dropdown_ZBjTJ = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1s, Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJ.pending, function (state, action) {
    state.pharmacy_orderrouting_orderingfacility_dropdown_ZBjTJ.loading = true;
  }), _extraReducers$1s)
});
var Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJActions = {
  Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJ: Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJ
};
var Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJReducer$1 = Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJReducer.reducer;

var _extraReducers$1r;
var Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJ = toolkit.createAsyncThunk("Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJReducer/pharmacy_orderrouting_sourcelocationtype_dropdown_zbjtj", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: " CodingMaster.Type == 'LOCATIONTYPE' && CodingMaster.status == true && CodingMaster.activestatus==true ",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJReducer = toolkit.createSlice({
  name: "Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJReducer",
  initialState: {
    pharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJ: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1r = {}, _defineProperty(_extraReducers$1r, Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJ.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJ.loading = false, state.pharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJ.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJ.error = false, state.pharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJ.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1r, Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJ.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJ = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1r, Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJ.pending, function (state, action) {
    state.pharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJ.loading = true;
  }), _extraReducers$1r)
});
var Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJActions = {
  Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJ: Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJ
};
var Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJReducer$1 = Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJReducer.reducer;

var _extraReducers$1q;
var Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXX = toolkit.createAsyncThunk("Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXXReducer/pharmacy_orderrouting_sourcelocation_dropdown_a8jxx", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "LocationMaster",
              filter: " first(document(document(LocationMaster.locationType).coding)[*].code) == '" + (payload === null || payload === void 0 ? void 0 : payload.edit_orderingdetails_loccode) + "'  && document(first(document(LocationMaster.managingOrgID).OrgType)).code=='" + (payload === null || payload === void 0 ? void 0 : payload.edit_orderingdetails_orgcode) + "' && LocationMaster.activestatus == true && lower(LocationMaster.status) == 'active'  ",
              return_fields: "Keep(LocationMaster,'id','_id','_key','shortdesc','locationID','longdesc','status')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXXReducer = toolkit.createSlice({
  name: "Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXXReducer",
  initialState: {
    pharmacy_orderrouting_sourcelocation_dropdown_a8JXX: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1q = {}, _defineProperty(_extraReducers$1q, Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXX.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_orderrouting_sourcelocation_dropdown_a8JXX.loading = false, state.pharmacy_orderrouting_sourcelocation_dropdown_a8JXX.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_orderrouting_sourcelocation_dropdown_a8JXX.error = false, state.pharmacy_orderrouting_sourcelocation_dropdown_a8JXX.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1q, Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXX.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_orderrouting_sourcelocation_dropdown_a8JXX = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1q, Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXX.pending, function (state, action) {
    state.pharmacy_orderrouting_sourcelocation_dropdown_a8JXX.loading = true;
  }), _extraReducers$1q)
});
var Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXXActions = {
  Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXX: Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXX
};
var Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXXReducer$1 = Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXXReducer.reducer;

var _extraReducers$1p;
var editcontactpointpharmacy_contact_contactmode_dropdown_zorJV = toolkit.createAsyncThunk("editcontactpointpharmacy_contact_contactmode_dropdown_zorJVReducer/pharmacy_contact_contactmode_dropdown_zorjv", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='CONTACTSYSTEM' && CodingMaster.activestatus==true  && CodingMaster.status == true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var editcontactpointpharmacy_contact_contactmode_dropdown_zorJVReducer = toolkit.createSlice({
  name: "editcontactpointpharmacy_contact_contactmode_dropdown_zorJVReducer",
  initialState: {
    pharmacy_contact_contactmode_dropdown_zorJV: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1p = {}, _defineProperty(_extraReducers$1p, editcontactpointpharmacy_contact_contactmode_dropdown_zorJV.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_contact_contactmode_dropdown_zorJV.loading = false, state.pharmacy_contact_contactmode_dropdown_zorJV.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_contact_contactmode_dropdown_zorJV.error = false, state.pharmacy_contact_contactmode_dropdown_zorJV.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1p, editcontactpointpharmacy_contact_contactmode_dropdown_zorJV.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_contact_contactmode_dropdown_zorJV = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1p, editcontactpointpharmacy_contact_contactmode_dropdown_zorJV.pending, function (state, action) {
    state.pharmacy_contact_contactmode_dropdown_zorJV.loading = true;
  }), _extraReducers$1p)
});
var editcontactpointpharmacy_contact_contactmode_dropdown_zorJVActions = {
  editcontactpointpharmacy_contact_contactmode_dropdown_zorJV: editcontactpointpharmacy_contact_contactmode_dropdown_zorJV
};
var editcontactpointpharmacy_contact_contactmode_dropdown_zorJVReducer$1 = editcontactpointpharmacy_contact_contactmode_dropdown_zorJVReducer.reducer;

var _extraReducers$1o;
var editcontactpointpharmacy_contact_use_dropdown_zorJV = toolkit.createAsyncThunk("editcontactpointpharmacy_contact_use_dropdown_zorJVReducer/pharmacy_contact_use_dropdown_zorjv", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='ADDRESSUSE' && CodingMaster.activestatus==true && CodingMaster.status == true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var editcontactpointpharmacy_contact_use_dropdown_zorJVReducer = toolkit.createSlice({
  name: "editcontactpointpharmacy_contact_use_dropdown_zorJVReducer",
  initialState: {
    pharmacy_contact_use_dropdown_zorJV: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1o = {}, _defineProperty(_extraReducers$1o, editcontactpointpharmacy_contact_use_dropdown_zorJV.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_contact_use_dropdown_zorJV.loading = false, state.pharmacy_contact_use_dropdown_zorJV.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_contact_use_dropdown_zorJV.error = false, state.pharmacy_contact_use_dropdown_zorJV.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1o, editcontactpointpharmacy_contact_use_dropdown_zorJV.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_contact_use_dropdown_zorJV = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1o, editcontactpointpharmacy_contact_use_dropdown_zorJV.pending, function (state, action) {
    state.pharmacy_contact_use_dropdown_zorJV.loading = true;
  }), _extraReducers$1o)
});
var editcontactpointpharmacy_contact_use_dropdown_zorJVActions = {
  editcontactpointpharmacy_contact_use_dropdown_zorJV: editcontactpointpharmacy_contact_use_dropdown_zorJV
};
var editcontactpointpharmacy_contact_use_dropdown_zorJVReducer$1 = editcontactpointpharmacy_contact_use_dropdown_zorJVReducer.reducer;

var _extraReducers$1n;
var editcontactpointpharmacy_contact_priority_dropdown_zorJV = toolkit.createAsyncThunk("editcontactpointpharmacy_contact_priority_dropdown_zorJVReducer/pharmacy_contact_priority_dropdown_zorjv", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='RANK' && CodingMaster.activestatus==true  && CodingMaster.status == true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var editcontactpointpharmacy_contact_priority_dropdown_zorJVReducer = toolkit.createSlice({
  name: "editcontactpointpharmacy_contact_priority_dropdown_zorJVReducer",
  initialState: {
    pharmacy_contact_priority_dropdown_zorJV: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1n = {}, _defineProperty(_extraReducers$1n, editcontactpointpharmacy_contact_priority_dropdown_zorJV.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_contact_priority_dropdown_zorJV.loading = false, state.pharmacy_contact_priority_dropdown_zorJV.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_contact_priority_dropdown_zorJV.error = false, state.pharmacy_contact_priority_dropdown_zorJV.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1n, editcontactpointpharmacy_contact_priority_dropdown_zorJV.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_contact_priority_dropdown_zorJV = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1n, editcontactpointpharmacy_contact_priority_dropdown_zorJV.pending, function (state, action) {
    state.pharmacy_contact_priority_dropdown_zorJV.loading = true;
  }), _extraReducers$1n)
});
var editcontactpointpharmacy_contact_priority_dropdown_zorJVActions = {
  editcontactpointpharmacy_contact_priority_dropdown_zorJV: editcontactpointpharmacy_contact_priority_dropdown_zorJV
};
var editcontactpointpharmacy_contact_priority_dropdown_zorJVReducer$1 = editcontactpointpharmacy_contact_priority_dropdown_zorJVReducer.reducer;

var _extraReducers$1m;
var EditNewPharmacypharmacy_update_a0GKU = toolkit.createAsyncThunk("EditNewPharmacypharmacy_update_a0GKUReducer/pharmacy_update_a0gku", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify([{
              db_name: dbName,
              entity: "LocationMaster",
              is_metadata: true,
              metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
              filter: {
                _key: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy__key
              },
              doc: {
                identifier: payload === null || payload === void 0 ? void 0 : payload.identifier,
                status: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_status,
                operationalStatus: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_operationalstatus,
                shortdesc: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_shortdesc,
                alias: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_alias,
                longdesc: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_longdesc,
                mode: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_mode,
                telecom: payload === null || payload === void 0 ? void 0 : payload.telecom,
                address: payload === null || payload === void 0 ? void 0 : payload.address,
                locationType: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_locationtype,
                position: payload === null || payload === void 0 ? void 0 : payload.position,
                availableExceptions: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_availableexceptions,
                managingOrgID: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_managingorgid,
                id: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_id,
                locationRoletype: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_locationroletype,
                locationID: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_locationid,
                parentLocationID_desc: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_parentlocationid_desc,
                specialty: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_specialty,
                managingOrgEntityType: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_managingorgentitytype,
                clinicdetails: payload === null || payload === void 0 ? void 0 : payload.editnewpharmacy_clinicdetails,
                photo: payload === null || payload === void 0 ? void 0 : payload.photo,
                pharmacy: payload === null || payload === void 0 ? void 0 : payload.pharmacy,
                workingdayyear: payload === null || payload === void 0 ? void 0 : payload.workingdayyear,
                workingdayyearoverride: payload === null || payload === void 0 ? void 0 : payload.workingdayyearoverride,
                locconfig: payload === null || payload === void 0 ? void 0 : payload.locconfig,
                autocalculate: payload === null || payload === void 0 ? void 0 : payload.autocalculate
              }
            }]);
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__uspsertUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewPharmacypharmacy_update_a0GKUReducer = toolkit.createSlice({
  name: "EditNewPharmacypharmacy_update_a0GKUReducer",
  initialState: {
    pharmacy_update_a0GKU: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1m = {}, _defineProperty(_extraReducers$1m, EditNewPharmacypharmacy_update_a0GKU.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_update_a0GKU.loading = false, state.pharmacy_update_a0GKU.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_update_a0GKU.error = false, state.pharmacy_update_a0GKU.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1m, EditNewPharmacypharmacy_update_a0GKU.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_update_a0GKU = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1m, EditNewPharmacypharmacy_update_a0GKU.pending, function (state, action) {
    state.pharmacy_update_a0GKU.loading = true;
  }), _extraReducers$1m)
});
var EditNewPharmacypharmacy_update_a0GKUActions = {
  EditNewPharmacypharmacy_update_a0GKU: EditNewPharmacypharmacy_update_a0GKU
};
var EditNewPharmacypharmacy_update_a0GKUReducer$1 = EditNewPharmacypharmacy_update_a0GKUReducer.reducer;

var _extraReducers$1l;
var EditNewPharmacypharmacy_singleread_kbnjk = toolkit.createAsyncThunk("EditNewPharmacypharmacy_singleread_kbnjkReducer/pharmacy_singleread_kbnjk", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var editnewpharmacy__key, _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            editnewpharmacy__key = payload.editnewpharmacy__key;
            _context.prev = 1;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "LocationMaster",
              filter: "LocationMaster._key == '".concat(editnewpharmacy__key, "'"),
              return_fields: "merge(LocationMaster,{operationalStatus:(for operationalStatus in document(TO_ARRAY(LocationMaster.operationalStatus)) return merge(operationalStatus,{coding:document(operationalStatus.coding)}))},{managingOrgEntityType:document(LocationMaster.managingOrgEntityType)}, {parentLocationID_desc:LocationMaster.parentLocationID_desc},{address:document(LocationMaster.address)},{locationType:merge(document(LocationMaster.locationType),{coding:document(document(LocationMaster.locationType).coding)})},{managingOrgID:(for managingOrgID in document(TO_ARRAY(LocationMaster.managingOrgID)) return merge(managingOrgID,{OrgType:document(managingOrgID.OrgType)},{address:document(managingOrgID.address)} ) )},{locationRoletype:document(LocationMaster.locationRoletype)},{specialty:(for code in CodeableConceptMaster filter code._id == LocationMaster.specialty return merge(code,{coding:document(code.coding)}))},{photo:document(LocationMaster.photo)}, {pharmacy:(for ph in LocationMaster.pharmacy return merge(ph,{inventorySubStore:document(ph.inventorySubStore)}))},{telecom:(for tel in to_array(document(LocationMaster.telecom)) return merge(tel,{use:document(tel.use)},{rank:document(tel.rank)},{system:document(tel.system)}))})"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 8;
            return fetchDataApi(__readDocumentUrl__, options);

          case 8:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 11:
            _context.next = 13;
            return _res.json();

          case 13:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 17]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewPharmacypharmacy_singleread_kbnjkReducer = toolkit.createSlice({
  name: "EditNewPharmacypharmacy_singleread_kbnjkReducer",
  initialState: {
    pharmacy_singleread_kbnjk: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1l = {}, _defineProperty(_extraReducers$1l, EditNewPharmacypharmacy_singleread_kbnjk.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_singleread_kbnjk.loading = false, state.pharmacy_singleread_kbnjk.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_singleread_kbnjk.error = false, state.pharmacy_singleread_kbnjk.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1l, EditNewPharmacypharmacy_singleread_kbnjk.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_singleread_kbnjk = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1l, EditNewPharmacypharmacy_singleread_kbnjk.pending, function (state, action) {
    state.pharmacy_singleread_kbnjk.loading = true;
  }), _extraReducers$1l)
});
var EditNewPharmacypharmacy_singleread_kbnjkActions = {
  EditNewPharmacypharmacy_singleread_kbnjk: EditNewPharmacypharmacy_singleread_kbnjk
};
var EditNewPharmacypharmacy_singleread_kbnjkReducer$1 = EditNewPharmacypharmacy_singleread_kbnjkReducer.reducer;

var _extraReducers$1k;
var EditNewPharmacypharmacy_entitytype_dropdown_kbnjk = toolkit.createAsyncThunk("EditNewPharmacypharmacy_entitytype_dropdown_kbnjkReducer/pharmacy_entitytype_dropdown_kbnjk", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='ORGTYPE' && CodingMaster.activestatus==true && CodingMaster.status == true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status','shortdesc','activestatus')",
              sort: "CodingMaster.display"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewPharmacypharmacy_entitytype_dropdown_kbnjkReducer = toolkit.createSlice({
  name: "EditNewPharmacypharmacy_entitytype_dropdown_kbnjkReducer",
  initialState: {
    pharmacy_entitytype_dropdown_kbnjk: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1k = {}, _defineProperty(_extraReducers$1k, EditNewPharmacypharmacy_entitytype_dropdown_kbnjk.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_entitytype_dropdown_kbnjk.loading = false, state.pharmacy_entitytype_dropdown_kbnjk.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_entitytype_dropdown_kbnjk.error = false, state.pharmacy_entitytype_dropdown_kbnjk.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1k, EditNewPharmacypharmacy_entitytype_dropdown_kbnjk.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_entitytype_dropdown_kbnjk = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1k, EditNewPharmacypharmacy_entitytype_dropdown_kbnjk.pending, function (state, action) {
    state.pharmacy_entitytype_dropdown_kbnjk.loading = true;
  }), _extraReducers$1k)
});
var EditNewPharmacypharmacy_entitytype_dropdown_kbnjkActions = {
  EditNewPharmacypharmacy_entitytype_dropdown_kbnjk: EditNewPharmacypharmacy_entitytype_dropdown_kbnjk
};
var EditNewPharmacypharmacy_entitytype_dropdown_kbnjkReducer$1 = EditNewPharmacypharmacy_entitytype_dropdown_kbnjkReducer.reducer;

var _extraReducers$1j;
var EditNewPharmacypharmacy_entityname_dropdown_kbnjk = toolkit.createAsyncThunk("EditNewPharmacypharmacy_entityname_dropdown_kbnjkReducer/pharmacy_entityname_dropdown_kbnjk", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "Organization",
              filter: "FIRST(DOCUMENT(Organization.OrgType)[*].code) == 'OT003' && Organization.active==true && Organization.activestatus== true",
              return_fields: "KEEP(Organization,'_id','id','_key','name','entitycode','active','activestatus','isExternal')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewPharmacypharmacy_entityname_dropdown_kbnjkReducer = toolkit.createSlice({
  name: "EditNewPharmacypharmacy_entityname_dropdown_kbnjkReducer",
  initialState: {
    pharmacy_entityname_dropdown_kbnjk: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1j = {}, _defineProperty(_extraReducers$1j, EditNewPharmacypharmacy_entityname_dropdown_kbnjk.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_entityname_dropdown_kbnjk.loading = false, state.pharmacy_entityname_dropdown_kbnjk.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_entityname_dropdown_kbnjk.error = false, state.pharmacy_entityname_dropdown_kbnjk.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1j, EditNewPharmacypharmacy_entityname_dropdown_kbnjk.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_entityname_dropdown_kbnjk = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1j, EditNewPharmacypharmacy_entityname_dropdown_kbnjk.pending, function (state, action) {
    state.pharmacy_entityname_dropdown_kbnjk.loading = true;
  }), _extraReducers$1j)
});
var EditNewPharmacypharmacy_entityname_dropdown_kbnjkActions = {
  EditNewPharmacypharmacy_entityname_dropdown_kbnjk: EditNewPharmacypharmacy_entityname_dropdown_kbnjk
};
var EditNewPharmacypharmacy_entityname_dropdown_kbnjkReducer$1 = EditNewPharmacypharmacy_entityname_dropdown_kbnjkReducer.reducer;

var _extraReducers$1i;
var EditNewPharmacypharmacy_locationtype_dropdown_kbnjk = toolkit.createAsyncThunk("EditNewPharmacypharmacy_locationtype_dropdown_kbnjkReducer/pharmacy_locationtype_dropdown_kbnjk", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='LOCATIONTYPE' && CodingMaster.activestatus== true && CodingMaster.status == true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','shortdesc','Type','status','activestatus')",
              sort: "CodingMaster.display"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewPharmacypharmacy_locationtype_dropdown_kbnjkReducer = toolkit.createSlice({
  name: "EditNewPharmacypharmacy_locationtype_dropdown_kbnjkReducer",
  initialState: {
    pharmacy_locationtype_dropdown_kbnjk: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1i = {}, _defineProperty(_extraReducers$1i, EditNewPharmacypharmacy_locationtype_dropdown_kbnjk.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_locationtype_dropdown_kbnjk.loading = false, state.pharmacy_locationtype_dropdown_kbnjk.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_locationtype_dropdown_kbnjk.error = false, state.pharmacy_locationtype_dropdown_kbnjk.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1i, EditNewPharmacypharmacy_locationtype_dropdown_kbnjk.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_locationtype_dropdown_kbnjk = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1i, EditNewPharmacypharmacy_locationtype_dropdown_kbnjk.pending, function (state, action) {
    state.pharmacy_locationtype_dropdown_kbnjk.loading = true;
  }), _extraReducers$1i)
});
var EditNewPharmacypharmacy_locationtype_dropdown_kbnjkActions = {
  EditNewPharmacypharmacy_locationtype_dropdown_kbnjk: EditNewPharmacypharmacy_locationtype_dropdown_kbnjk
};
var EditNewPharmacypharmacy_locationtype_dropdown_kbnjkReducer$1 = EditNewPharmacypharmacy_locationtype_dropdown_kbnjkReducer.reducer;

var _extraReducers$1h;
var EditNewPharmacypharmacy_operationstatus_dropdown_kbnjk = toolkit.createAsyncThunk("EditNewPharmacypharmacy_operationstatus_dropdown_kbnjkReducer/pharmacy_operationstatus_dropdown_kbnjk", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='OPERATIONSTATUS' AND CodingMaster.activestatus==true  && CodingMaster.status == true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','shortdesc','Type','status','activestatus')",
              sort: "CodingMaster.display"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewPharmacypharmacy_operationstatus_dropdown_kbnjkReducer = toolkit.createSlice({
  name: "EditNewPharmacypharmacy_operationstatus_dropdown_kbnjkReducer",
  initialState: {
    pharmacy_operationstatus_dropdown_kbnjk: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1h = {}, _defineProperty(_extraReducers$1h, EditNewPharmacypharmacy_operationstatus_dropdown_kbnjk.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_operationstatus_dropdown_kbnjk.loading = false, state.pharmacy_operationstatus_dropdown_kbnjk.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_operationstatus_dropdown_kbnjk.error = false, state.pharmacy_operationstatus_dropdown_kbnjk.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1h, EditNewPharmacypharmacy_operationstatus_dropdown_kbnjk.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_operationstatus_dropdown_kbnjk = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1h, EditNewPharmacypharmacy_operationstatus_dropdown_kbnjk.pending, function (state, action) {
    state.pharmacy_operationstatus_dropdown_kbnjk.loading = true;
  }), _extraReducers$1h)
});
var EditNewPharmacypharmacy_operationstatus_dropdown_kbnjkActions = {
  EditNewPharmacypharmacy_operationstatus_dropdown_kbnjk: EditNewPharmacypharmacy_operationstatus_dropdown_kbnjk
};
var EditNewPharmacypharmacy_operationstatus_dropdown_kbnjkReducer$1 = EditNewPharmacypharmacy_operationstatus_dropdown_kbnjkReducer.reducer;

var _extraReducers$1g;
var EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjk = toolkit.createAsyncThunk("EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjkReducer/pharmacy_parentlocationid_description_dropdown_kbnjk", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "LocationMaster",
              filter: "LocationMaster.parentLocationID_desc == '' && LocationMaster.activestatus == true && lower(LocationMaster.status) == 'active'",
              return_fields: "keep(LocationMaster,'id','_id','_key','shortdesc','longdesc','locationID','status','activestatus')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjkReducer = toolkit.createSlice({
  name: "EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjkReducer",
  initialState: {
    pharmacy_parentlocationid_description_dropdown_kbnjk: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1g = {}, _defineProperty(_extraReducers$1g, EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjk.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_parentlocationid_description_dropdown_kbnjk.loading = false, state.pharmacy_parentlocationid_description_dropdown_kbnjk.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_parentlocationid_description_dropdown_kbnjk.error = false, state.pharmacy_parentlocationid_description_dropdown_kbnjk.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1g, EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjk.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_parentlocationid_description_dropdown_kbnjk = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1g, EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjk.pending, function (state, action) {
    state.pharmacy_parentlocationid_description_dropdown_kbnjk.loading = true;
  }), _extraReducers$1g)
});
var EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjkActions = {
  EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjk: EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjk
};
var EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjkReducer$1 = EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjkReducer.reducer;

var _extraReducers$1f;
var EditNewPharmacypharmacy_locationroletype_dropdown_kbnjk = toolkit.createAsyncThunk("EditNewPharmacypharmacy_locationroletype_dropdown_kbnjkReducer/pharmacy_locationroletype_dropdown_kbnjk", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='LOCATIONROLE' && CodingMaster.activestatus==true && CodingMaster.status==true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status','activestatus')",
              sort: "CodingMaster.display"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewPharmacypharmacy_locationroletype_dropdown_kbnjkReducer = toolkit.createSlice({
  name: "EditNewPharmacypharmacy_locationroletype_dropdown_kbnjkReducer",
  initialState: {
    pharmacy_locationroletype_dropdown_kbnjk: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1f = {}, _defineProperty(_extraReducers$1f, EditNewPharmacypharmacy_locationroletype_dropdown_kbnjk.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_locationroletype_dropdown_kbnjk.loading = false, state.pharmacy_locationroletype_dropdown_kbnjk.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_locationroletype_dropdown_kbnjk.error = false, state.pharmacy_locationroletype_dropdown_kbnjk.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1f, EditNewPharmacypharmacy_locationroletype_dropdown_kbnjk.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_locationroletype_dropdown_kbnjk = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1f, EditNewPharmacypharmacy_locationroletype_dropdown_kbnjk.pending, function (state, action) {
    state.pharmacy_locationroletype_dropdown_kbnjk.loading = true;
  }), _extraReducers$1f)
});
var EditNewPharmacypharmacy_locationroletype_dropdown_kbnjkActions = {
  EditNewPharmacypharmacy_locationroletype_dropdown_kbnjk: EditNewPharmacypharmacy_locationroletype_dropdown_kbnjk
};
var EditNewPharmacypharmacy_locationroletype_dropdown_kbnjkReducer$1 = EditNewPharmacypharmacy_locationroletype_dropdown_kbnjkReducer.reducer;

var _extraReducers$1e;
var EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjk = toolkit.createAsyncThunk("EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjkReducer/pharmacy_inventrysubtype_dropdown_kbnjk", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "LocationMaster",
              filter: "first(document(document(LocationMaster.locationType).coding)[*].code) == 'LT006' && LocationMaster.activestatus == true && lower(LocationMaster.status) == 'active'",
              return_fields: "KEEP(LocationMaster,'_id','id','_key','status','activestatus','longdesc','locationID')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjkReducer = toolkit.createSlice({
  name: "EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjkReducer",
  initialState: {
    pharmacy_inventrysubtype_dropdown_kbnjk: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1e = {}, _defineProperty(_extraReducers$1e, EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjk.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_inventrysubtype_dropdown_kbnjk.loading = false, state.pharmacy_inventrysubtype_dropdown_kbnjk.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_inventrysubtype_dropdown_kbnjk.error = false, state.pharmacy_inventrysubtype_dropdown_kbnjk.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1e, EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjk.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_inventrysubtype_dropdown_kbnjk = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1e, EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjk.pending, function (state, action) {
    state.pharmacy_inventrysubtype_dropdown_kbnjk.loading = true;
  }), _extraReducers$1e)
});
var EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjkActions = {
  EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjk: EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjk
};
var EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjkReducer$1 = EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjkReducer.reducer;

var _extraReducers$1d;
var contactpointpharmacy_contact_contactmode_dropdown_VqEMp = toolkit.createAsyncThunk("contactpointpharmacy_contact_contactmode_dropdown_VqEMpReducer/pharmacy_contact_contactmode_dropdown_vqemp", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='CONTACTSYSTEM' && CodingMaster.activestatus==true  && CodingMaster.status == true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var contactpointpharmacy_contact_contactmode_dropdown_VqEMpReducer = toolkit.createSlice({
  name: "contactpointpharmacy_contact_contactmode_dropdown_VqEMpReducer",
  initialState: {
    pharmacy_contact_contactmode_dropdown_VqEMp: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1d = {}, _defineProperty(_extraReducers$1d, contactpointpharmacy_contact_contactmode_dropdown_VqEMp.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_contact_contactmode_dropdown_VqEMp.loading = false, state.pharmacy_contact_contactmode_dropdown_VqEMp.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_contact_contactmode_dropdown_VqEMp.error = false, state.pharmacy_contact_contactmode_dropdown_VqEMp.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1d, contactpointpharmacy_contact_contactmode_dropdown_VqEMp.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_contact_contactmode_dropdown_VqEMp = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1d, contactpointpharmacy_contact_contactmode_dropdown_VqEMp.pending, function (state, action) {
    state.pharmacy_contact_contactmode_dropdown_VqEMp.loading = true;
  }), _extraReducers$1d)
});
var contactpointpharmacy_contact_contactmode_dropdown_VqEMpActions = {
  contactpointpharmacy_contact_contactmode_dropdown_VqEMp: contactpointpharmacy_contact_contactmode_dropdown_VqEMp
};
var contactpointpharmacy_contact_contactmode_dropdown_VqEMpReducer$1 = contactpointpharmacy_contact_contactmode_dropdown_VqEMpReducer.reducer;

var _extraReducers$1c;
var contactpointpharmacy_contact_use_dropdown_VqEMp = toolkit.createAsyncThunk("contactpointpharmacy_contact_use_dropdown_VqEMpReducer/pharmacy_contact_use_dropdown_vqemp", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='ADDRESSUSE' && CodingMaster.activestatus==true && CodingMaster.status == true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var contactpointpharmacy_contact_use_dropdown_VqEMpReducer = toolkit.createSlice({
  name: "contactpointpharmacy_contact_use_dropdown_VqEMpReducer",
  initialState: {
    pharmacy_contact_use_dropdown_VqEMp: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1c = {}, _defineProperty(_extraReducers$1c, contactpointpharmacy_contact_use_dropdown_VqEMp.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_contact_use_dropdown_VqEMp.loading = false, state.pharmacy_contact_use_dropdown_VqEMp.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_contact_use_dropdown_VqEMp.error = false, state.pharmacy_contact_use_dropdown_VqEMp.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1c, contactpointpharmacy_contact_use_dropdown_VqEMp.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_contact_use_dropdown_VqEMp = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1c, contactpointpharmacy_contact_use_dropdown_VqEMp.pending, function (state, action) {
    state.pharmacy_contact_use_dropdown_VqEMp.loading = true;
  }), _extraReducers$1c)
});
var contactpointpharmacy_contact_use_dropdown_VqEMpActions = {
  contactpointpharmacy_contact_use_dropdown_VqEMp: contactpointpharmacy_contact_use_dropdown_VqEMp
};
var contactpointpharmacy_contact_use_dropdown_VqEMpReducer$1 = contactpointpharmacy_contact_use_dropdown_VqEMpReducer.reducer;

var _extraReducers$1b;
var contactpointpharmacy_contact_priority_dropdown_VqEMp = toolkit.createAsyncThunk("contactpointpharmacy_contact_priority_dropdown_VqEMpReducer/pharmacy_contact_priority_dropdown_vqemp", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='RANK' && CodingMaster.activestatus==true  && CodingMaster.status == true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var contactpointpharmacy_contact_priority_dropdown_VqEMpReducer = toolkit.createSlice({
  name: "contactpointpharmacy_contact_priority_dropdown_VqEMpReducer",
  initialState: {
    pharmacy_contact_priority_dropdown_VqEMp: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1b = {}, _defineProperty(_extraReducers$1b, contactpointpharmacy_contact_priority_dropdown_VqEMp.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_contact_priority_dropdown_VqEMp.loading = false, state.pharmacy_contact_priority_dropdown_VqEMp.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_contact_priority_dropdown_VqEMp.error = false, state.pharmacy_contact_priority_dropdown_VqEMp.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1b, contactpointpharmacy_contact_priority_dropdown_VqEMp.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_contact_priority_dropdown_VqEMp = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1b, contactpointpharmacy_contact_priority_dropdown_VqEMp.pending, function (state, action) {
    state.pharmacy_contact_priority_dropdown_VqEMp.loading = true;
  }), _extraReducers$1b)
});
var contactpointpharmacy_contact_priority_dropdown_VqEMpActions = {
  contactpointpharmacy_contact_priority_dropdown_VqEMp: contactpointpharmacy_contact_priority_dropdown_VqEMp
};
var contactpointpharmacy_contact_priority_dropdown_VqEMpReducer$1 = contactpointpharmacy_contact_priority_dropdown_VqEMpReducer.reducer;

var _extraReducers$1a;
var addnewpharmacypharmacy_entitytype_dropdown_3YRAV = toolkit.createAsyncThunk("addnewpharmacypharmacy_entitytype_dropdown_3YRAVReducer/pharmacy_entitytype_dropdown_3yrav", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='ORGTYPE' && CodingMaster.activestatus==true && CodingMaster.status == true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status','shortdesc','activestatus')",
              sort: "CodingMaster.display"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var addnewpharmacypharmacy_entitytype_dropdown_3YRAVReducer = toolkit.createSlice({
  name: "addnewpharmacypharmacy_entitytype_dropdown_3YRAVReducer",
  initialState: {
    pharmacy_entitytype_dropdown_3YRAV: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$1a = {}, _defineProperty(_extraReducers$1a, addnewpharmacypharmacy_entitytype_dropdown_3YRAV.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_entitytype_dropdown_3YRAV.loading = false, state.pharmacy_entitytype_dropdown_3YRAV.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_entitytype_dropdown_3YRAV.error = false, state.pharmacy_entitytype_dropdown_3YRAV.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$1a, addnewpharmacypharmacy_entitytype_dropdown_3YRAV.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_entitytype_dropdown_3YRAV = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$1a, addnewpharmacypharmacy_entitytype_dropdown_3YRAV.pending, function (state, action) {
    state.pharmacy_entitytype_dropdown_3YRAV.loading = true;
  }), _extraReducers$1a)
});
var addnewpharmacypharmacy_entitytype_dropdown_3YRAVActions = {
  addnewpharmacypharmacy_entitytype_dropdown_3YRAV: addnewpharmacypharmacy_entitytype_dropdown_3YRAV
};
var addnewpharmacypharmacy_entitytype_dropdown_3YRAVReducer$1 = addnewpharmacypharmacy_entitytype_dropdown_3YRAVReducer.reducer;

var _extraReducers$19;
var addnewpharmacypharmacy_entityname_dropdown_3YRAV = toolkit.createAsyncThunk("addnewpharmacypharmacy_entityname_dropdown_3YRAVReducer/pharmacy_entityname_dropdown_3yrav", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "Organization",
              filter: "FIRST(DOCUMENT(Organization.OrgType)[*].code) == 'OT003' && Organization.active==true && Organization.activestatus== true",
              return_fields: "KEEP(Organization,'_id','id','_key','name','entitycode','active','activestatus','isExternal')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var addnewpharmacypharmacy_entityname_dropdown_3YRAVReducer = toolkit.createSlice({
  name: "addnewpharmacypharmacy_entityname_dropdown_3YRAVReducer",
  initialState: {
    pharmacy_entityname_dropdown_3YRAV: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$19 = {}, _defineProperty(_extraReducers$19, addnewpharmacypharmacy_entityname_dropdown_3YRAV.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_entityname_dropdown_3YRAV.loading = false, state.pharmacy_entityname_dropdown_3YRAV.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_entityname_dropdown_3YRAV.error = false, state.pharmacy_entityname_dropdown_3YRAV.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$19, addnewpharmacypharmacy_entityname_dropdown_3YRAV.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_entityname_dropdown_3YRAV = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$19, addnewpharmacypharmacy_entityname_dropdown_3YRAV.pending, function (state, action) {
    state.pharmacy_entityname_dropdown_3YRAV.loading = true;
  }), _extraReducers$19)
});
var addnewpharmacypharmacy_entityname_dropdown_3YRAVActions = {
  addnewpharmacypharmacy_entityname_dropdown_3YRAV: addnewpharmacypharmacy_entityname_dropdown_3YRAV
};
var addnewpharmacypharmacy_entityname_dropdown_3YRAVReducer$1 = addnewpharmacypharmacy_entityname_dropdown_3YRAVReducer.reducer;

var _extraReducers$18;
var addnewpharmacypharmacy_locationtype_dropdown_3YRAV = toolkit.createAsyncThunk("addnewpharmacypharmacy_locationtype_dropdown_3YRAVReducer/pharmacy_locationtype_dropdown_3yrav", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='LOCATIONTYPE' && CodingMaster.activestatus== true && CodingMaster.status == true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','shortdesc','Type','status','activestatus')",
              sort: "CodingMaster.display"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var addnewpharmacypharmacy_locationtype_dropdown_3YRAVReducer = toolkit.createSlice({
  name: "addnewpharmacypharmacy_locationtype_dropdown_3YRAVReducer",
  initialState: {
    pharmacy_locationtype_dropdown_3YRAV: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$18 = {}, _defineProperty(_extraReducers$18, addnewpharmacypharmacy_locationtype_dropdown_3YRAV.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_locationtype_dropdown_3YRAV.loading = false, state.pharmacy_locationtype_dropdown_3YRAV.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_locationtype_dropdown_3YRAV.error = false, state.pharmacy_locationtype_dropdown_3YRAV.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$18, addnewpharmacypharmacy_locationtype_dropdown_3YRAV.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_locationtype_dropdown_3YRAV = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$18, addnewpharmacypharmacy_locationtype_dropdown_3YRAV.pending, function (state, action) {
    state.pharmacy_locationtype_dropdown_3YRAV.loading = true;
  }), _extraReducers$18)
});
var addnewpharmacypharmacy_locationtype_dropdown_3YRAVActions = {
  addnewpharmacypharmacy_locationtype_dropdown_3YRAV: addnewpharmacypharmacy_locationtype_dropdown_3YRAV
};
var addnewpharmacypharmacy_locationtype_dropdown_3YRAVReducer$1 = addnewpharmacypharmacy_locationtype_dropdown_3YRAVReducer.reducer;

var _extraReducers$17;
var addnewpharmacypharmacy_operationstatus_dropdown_3YRAV = toolkit.createAsyncThunk("addnewpharmacypharmacy_operationstatus_dropdown_3YRAVReducer/pharmacy_operationstatus_dropdown_3yrav", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='OPERATIONSTATUS' AND CodingMaster.activestatus==true  && CodingMaster.status == true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','shortdesc','Type','status','activestatus')",
              sort: "CodingMaster.display"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var addnewpharmacypharmacy_operationstatus_dropdown_3YRAVReducer = toolkit.createSlice({
  name: "addnewpharmacypharmacy_operationstatus_dropdown_3YRAVReducer",
  initialState: {
    pharmacy_operationstatus_dropdown_3YRAV: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$17 = {}, _defineProperty(_extraReducers$17, addnewpharmacypharmacy_operationstatus_dropdown_3YRAV.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_operationstatus_dropdown_3YRAV.loading = false, state.pharmacy_operationstatus_dropdown_3YRAV.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_operationstatus_dropdown_3YRAV.error = false, state.pharmacy_operationstatus_dropdown_3YRAV.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$17, addnewpharmacypharmacy_operationstatus_dropdown_3YRAV.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_operationstatus_dropdown_3YRAV = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$17, addnewpharmacypharmacy_operationstatus_dropdown_3YRAV.pending, function (state, action) {
    state.pharmacy_operationstatus_dropdown_3YRAV.loading = true;
  }), _extraReducers$17)
});
var addnewpharmacypharmacy_operationstatus_dropdown_3YRAVActions = {
  addnewpharmacypharmacy_operationstatus_dropdown_3YRAV: addnewpharmacypharmacy_operationstatus_dropdown_3YRAV
};
var addnewpharmacypharmacy_operationstatus_dropdown_3YRAVReducer$1 = addnewpharmacypharmacy_operationstatus_dropdown_3YRAVReducer.reducer;

var _extraReducers$16;
var addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAV = toolkit.createAsyncThunk("addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAVReducer/pharmacy_parentlocationid_description_dropdown_3yrav", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "LocationMaster",
              filter: "LocationMaster.parentLocationID_desc == '' && LocationMaster.activestatus == true && lower(LocationMaster.status) == 'active'",
              return_fields: "keep(LocationMaster,'id','_id','_key','shortdesc','longdesc','locationID','status','activestatus')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAVReducer = toolkit.createSlice({
  name: "addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAVReducer",
  initialState: {
    pharmacy_parentlocationid_description_dropdown_3YRAV: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$16 = {}, _defineProperty(_extraReducers$16, addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAV.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_parentlocationid_description_dropdown_3YRAV.loading = false, state.pharmacy_parentlocationid_description_dropdown_3YRAV.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_parentlocationid_description_dropdown_3YRAV.error = false, state.pharmacy_parentlocationid_description_dropdown_3YRAV.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$16, addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAV.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_parentlocationid_description_dropdown_3YRAV = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$16, addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAV.pending, function (state, action) {
    state.pharmacy_parentlocationid_description_dropdown_3YRAV.loading = true;
  }), _extraReducers$16)
});
var addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAVActions = {
  addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAV: addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAV
};
var addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAVReducer$1 = addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAVReducer.reducer;

var _extraReducers$15;
var addnewpharmacypharmacy_locationroletype_dropdown_3YRAV = toolkit.createAsyncThunk("addnewpharmacypharmacy_locationroletype_dropdown_3YRAVReducer/pharmacy_locationroletype_dropdown_3yrav", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='LOCATIONROLE' && CodingMaster.activestatus==true && CodingMaster.status==true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status','activestatus')",
              sort: "CodingMaster.display"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var addnewpharmacypharmacy_locationroletype_dropdown_3YRAVReducer = toolkit.createSlice({
  name: "addnewpharmacypharmacy_locationroletype_dropdown_3YRAVReducer",
  initialState: {
    pharmacy_locationroletype_dropdown_3YRAV: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$15 = {}, _defineProperty(_extraReducers$15, addnewpharmacypharmacy_locationroletype_dropdown_3YRAV.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_locationroletype_dropdown_3YRAV.loading = false, state.pharmacy_locationroletype_dropdown_3YRAV.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_locationroletype_dropdown_3YRAV.error = false, state.pharmacy_locationroletype_dropdown_3YRAV.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$15, addnewpharmacypharmacy_locationroletype_dropdown_3YRAV.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_locationroletype_dropdown_3YRAV = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$15, addnewpharmacypharmacy_locationroletype_dropdown_3YRAV.pending, function (state, action) {
    state.pharmacy_locationroletype_dropdown_3YRAV.loading = true;
  }), _extraReducers$15)
});
var addnewpharmacypharmacy_locationroletype_dropdown_3YRAVActions = {
  addnewpharmacypharmacy_locationroletype_dropdown_3YRAV: addnewpharmacypharmacy_locationroletype_dropdown_3YRAV
};
var addnewpharmacypharmacy_locationroletype_dropdown_3YRAVReducer$1 = addnewpharmacypharmacy_locationroletype_dropdown_3YRAVReducer.reducer;

var _extraReducers$14;
var addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAV = toolkit.createAsyncThunk("addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAVReducer/pharmacy_inventrysubtype_dropdown_3yrav", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "LocationMaster",
              filter: "first(document(document(LocationMaster.locationType).coding)[*].code) == 'LT006' && LocationMaster.activestatus == true && lower(LocationMaster.status) == 'active'",
              return_fields: "KEEP(LocationMaster,'_id','id','_key','status','activestatus','longdesc','locationID')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAVReducer = toolkit.createSlice({
  name: "addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAVReducer",
  initialState: {
    pharmacy_inventrysubtype_dropdown_3YRAV: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$14 = {}, _defineProperty(_extraReducers$14, addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAV.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_inventrysubtype_dropdown_3YRAV.loading = false, state.pharmacy_inventrysubtype_dropdown_3YRAV.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_inventrysubtype_dropdown_3YRAV.error = false, state.pharmacy_inventrysubtype_dropdown_3YRAV.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$14, addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAV.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_inventrysubtype_dropdown_3YRAV = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$14, addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAV.pending, function (state, action) {
    state.pharmacy_inventrysubtype_dropdown_3YRAV.loading = true;
  }), _extraReducers$14)
});
var addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAVActions = {
  addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAV: addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAV
};
var addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAVReducer$1 = addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAVReducer.reducer;

var _extraReducers$13;
var addnewpharmacypharmacy_insert_nDuhJ = toolkit.createAsyncThunk("addnewpharmacypharmacy_insert_nDuhJReducer/pharmacy_insert_nduhj", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = [];
            body = [{
              db_name: dbName,
              entity: "LocationMaster",
              is_metadata: true,
              metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
              doc: {
                identifier: payload === null || payload === void 0 ? void 0 : payload.identifier,
                status: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_status,
                operationalStatus: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_operationalstatus,
                shortdesc: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_shortdesc,
                alias: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_alias,
                longdesc: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_longdesc,
                mode: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_mode,
                telecom: payload === null || payload === void 0 ? void 0 : payload.telecom,
                address: payload === null || payload === void 0 ? void 0 : payload.address,
                locationType: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_locationtype,
                position: payload === null || payload === void 0 ? void 0 : payload.position,
                availableExceptions: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_availableexceptions,
                managingOrgID: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_managingorgid,
                id: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_id,
                locationRoletype: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_locationroletype,
                locationID: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_locationid,
                parentLocationID_desc: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_parentlocationid_desc,
                specialty: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_specialty,
                managingOrgEntityType: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_managingorgentitytype,
                clinicdetails: payload === null || payload === void 0 ? void 0 : payload.addnewpharmacy_clinicdetails,
                photo: payload === null || payload === void 0 ? void 0 : payload.photo,
                pharmacy: payload === null || payload === void 0 ? void 0 : payload.pharmacy,
                workingdayyear: payload === null || payload === void 0 ? void 0 : payload.workingdayyear,
                workingdayyearoverride: payload === null || payload === void 0 ? void 0 : payload.workingdayyearoverride,
                locconfig: payload === null || payload === void 0 ? void 0 : payload.locconfig,
                autocalculate: payload === null || payload === void 0 ? void 0 : payload.autocalculate
              }
            }];

            if (payload.edit_id) {
              body[0].filter = {
                _key: payload === null || payload === void 0 ? void 0 : payload.edit_id
              };
            }

            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: JSON.stringify(body)
            };
            _context.next = 8;
            return fetchDataApi(__uspsertUrl__, options);

          case 8:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 11:
            _context.next = 13;
            return _res.json();

          case 13:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 17]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var addnewpharmacypharmacy_insert_nDuhJReducer = toolkit.createSlice({
  name: "addnewpharmacypharmacy_insert_nDuhJReducer",
  initialState: {
    pharmacy_insert_nDuhJ: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$13 = {}, _defineProperty(_extraReducers$13, addnewpharmacypharmacy_insert_nDuhJ.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_insert_nDuhJ.loading = false, state.pharmacy_insert_nDuhJ.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_insert_nDuhJ.error = false, state.pharmacy_insert_nDuhJ.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$13, addnewpharmacypharmacy_insert_nDuhJ.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_insert_nDuhJ = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$13, addnewpharmacypharmacy_insert_nDuhJ.pending, function (state, action) {
    state.pharmacy_insert_nDuhJ.loading = true;
  }), _extraReducers$13)
});
var addnewpharmacypharmacy_insert_nDuhJActions = {
  addnewpharmacypharmacy_insert_nDuhJ: addnewpharmacypharmacy_insert_nDuhJ
};
var addnewpharmacypharmacy_insert_nDuhJReducer$1 = addnewpharmacypharmacy_insert_nDuhJReducer.reducer;

var _extraReducers$12;
var orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1 = toolkit.createAsyncThunk("orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1Reducer/pharmacy_orderrouting_orderingfacility_dropdown_btpu1", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "Organization",
              filter: "FIRST(DOCUMENT(Organization.OrgType)[*].code) == 'OT003' && Organization.isExternal==false && Organization.activestatus==true && Organization.active==true ",
              return_fields: "KEEP(Organization,'_id','id','_key','name','entitycode','active','isExternal')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1Reducer = toolkit.createSlice({
  name: "orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1Reducer",
  initialState: {
    pharmacy_orderrouting_orderingfacility_dropdown_BtPu1: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$12 = {}, _defineProperty(_extraReducers$12, orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_orderrouting_orderingfacility_dropdown_BtPu1.loading = false, state.pharmacy_orderrouting_orderingfacility_dropdown_BtPu1.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_orderrouting_orderingfacility_dropdown_BtPu1.error = false, state.pharmacy_orderrouting_orderingfacility_dropdown_BtPu1.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$12, orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_orderrouting_orderingfacility_dropdown_BtPu1 = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$12, orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1.pending, function (state, action) {
    state.pharmacy_orderrouting_orderingfacility_dropdown_BtPu1.loading = true;
  }), _extraReducers$12)
});
var orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1Actions = {
  orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1: orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1
};
var orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1Reducer$1 = orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1Reducer.reducer;

var _extraReducers$11;
var orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1 = toolkit.createAsyncThunk("orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1Reducer/pharmacy_orderrouting_sourcelocationtype_dropdown_btpu1", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: " CodingMaster.Type == 'LOCATIONTYPE' && CodingMaster.status == true && CodingMaster.activestatus==true ",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1Reducer = toolkit.createSlice({
  name: "orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1Reducer",
  initialState: {
    pharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$11 = {}, _defineProperty(_extraReducers$11, orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1.loading = false, state.pharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1.error = false, state.pharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$11, orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1 = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$11, orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1.pending, function (state, action) {
    state.pharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1.loading = true;
  }), _extraReducers$11)
});
var orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1Actions = {
  orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1: orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1
};
var orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1Reducer$1 = orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1Reducer.reducer;

var _extraReducers$10;
var orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoM = toolkit.createAsyncThunk("orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoMReducer/pharmacy_orderrouting_sourcelocation_dropdown_pgqom", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "LocationMaster",
              filter: " first(document(document(LocationMaster.locationType).coding)[*].code) == '" + (payload === null || payload === void 0 ? void 0 : payload.orderingdetails_loccode) + "'  && document(first(document(LocationMaster.managingOrgID).OrgType)).code=='" + (payload === null || payload === void 0 ? void 0 : payload.orderingdetails_orgcode) + "' && LocationMaster.activestatus == true && lower(LocationMaster.status) == 'active'  ",
              return_fields: "Keep(LocationMaster,'id','_id','_key','shortdesc','locationID','longdesc','status')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoMReducer = toolkit.createSlice({
  name: "orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoMReducer",
  initialState: {
    pharmacy_orderrouting_sourcelocation_dropdown_pGqoM: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$10 = {}, _defineProperty(_extraReducers$10, orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoM.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_orderrouting_sourcelocation_dropdown_pGqoM.loading = false, state.pharmacy_orderrouting_sourcelocation_dropdown_pGqoM.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_orderrouting_sourcelocation_dropdown_pGqoM.error = false, state.pharmacy_orderrouting_sourcelocation_dropdown_pGqoM.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$10, orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoM.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_orderrouting_sourcelocation_dropdown_pGqoM = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$10, orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoM.pending, function (state, action) {
    state.pharmacy_orderrouting_sourcelocation_dropdown_pGqoM.loading = true;
  }), _extraReducers$10)
});
var orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoMActions = {
  orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoM: orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoM
};
var orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoMReducer$1 = orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoMReducer.reducer;

var _extraReducers$$;
var PHARMACY_MASTER_FULL_READ = toolkit.createAsyncThunk("pharmacytablepharmacy_fullread_pnrrOReducer/pharmacy_fullread_pnrro", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      isWithoutLimit,
      page,
      perPage,
      _payload$searchQuery,
      searchQuery,
      queryId,
      withoutLimitFilter,
      withLimitFilter,
      fullReadQDMQuery,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          isWithoutLimit = payload.isWithoutLimit, page = payload.page, perPage = payload.perPage, _payload$searchQuery = payload.searchQuery, searchQuery = _payload$searchQuery === void 0 ? "" : _payload$searchQuery;
          queryId = isWithoutLimit ? "99d58126-464f-44ae-963b-7af99cf83987" : "a6686a96-d5e3-46db-85fa-de36bb58ecc2";
          withoutLimitFilter = {
            filter: {
              search: "%".concat(searchQuery, "%")
            }
          };
          withLimitFilter = {
            filter: {
              search: "%".concat(searchQuery, "%"),
              page: page,
              perPage: perPage
            }
          };
          fullReadQDMQuery = _objectSpread2({
            db_name: dbName,
            queryid: queryId
          }, isWithoutLimit ? withoutLimitFilter : withLimitFilter);
          _context.next = 10;
          return fetchData({
            body: JSON.stringify(fullReadQDMQuery)
          }, __baseUrl__);

        case 10:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 14]]);
})));
var pharmacytablepharmacy_fullread_pnrrOReducer = toolkit.createSlice({
  name: "pharmacytablepharmacy_fullread_pnrrOReducer",
  initialState: {
    pharmacy_fullread_pnrrO: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$$ = {}, _defineProperty(_extraReducers$$, PHARMACY_MASTER_FULL_READ.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.pharmacy_fullread_pnrrO.loading = false, state.pharmacy_fullread_pnrrO.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.pharmacy_fullread_pnrrO.error = false, state.pharmacy_fullread_pnrrO.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$$, PHARMACY_MASTER_FULL_READ.rejected, function (state, action) {
    var _action$payload2;

    state.pharmacy_fullread_pnrrO = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$$, PHARMACY_MASTER_FULL_READ.pending, function (state, action) {
    state.pharmacy_fullread_pnrrO.loading = true;
  }), _extraReducers$$)
});
var pharmacytablepharmacy_fullread_pnrrOActions = {
  PHARMACY_MASTER_FULL_READ: PHARMACY_MASTER_FULL_READ
};
var pharmacytablepharmacy_fullread_pnrrOReducer$1 = pharmacytablepharmacy_fullread_pnrrOReducer.reducer;

var _extraReducers$_;
var schedulelinesfrequencymaster_days_dropdown_m1Wby = toolkit.createAsyncThunk("schedulelinesfrequencymaster_days_dropdown_m1WbyReducer/frequencymaster_days_dropdown_m1wby", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type == 'WEEKDAYS' && CodingMaster.status == true && CodingMaster.activestatus == true",
              return_fields: "keep(CodingMaster,'_key','_id','id','code','display','shortdesc','Type','status')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var schedulelinesfrequencymaster_days_dropdown_m1WbyReducer = toolkit.createSlice({
  name: "schedulelinesfrequencymaster_days_dropdown_m1WbyReducer",
  initialState: {
    frequencymaster_days_dropdown_m1Wby: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$_ = {}, _defineProperty(_extraReducers$_, schedulelinesfrequencymaster_days_dropdown_m1Wby.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.frequencymaster_days_dropdown_m1Wby.loading = false, state.frequencymaster_days_dropdown_m1Wby.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.frequencymaster_days_dropdown_m1Wby.error = false, state.frequencymaster_days_dropdown_m1Wby.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$_, schedulelinesfrequencymaster_days_dropdown_m1Wby.rejected, function (state, action) {
    var _action$payload2;

    state.frequencymaster_days_dropdown_m1Wby = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$_, schedulelinesfrequencymaster_days_dropdown_m1Wby.pending, function (state, action) {
    state.frequencymaster_days_dropdown_m1Wby.loading = true;
  }), _extraReducers$_)
});
var schedulelinesfrequencymaster_days_dropdown_m1WbyActions = {
  schedulelinesfrequencymaster_days_dropdown_m1Wby: schedulelinesfrequencymaster_days_dropdown_m1Wby
};
var schedulelinesfrequencymaster_days_dropdown_m1WbyReducer$1 = schedulelinesfrequencymaster_days_dropdown_m1WbyReducer.reducer;

var _extraReducers$Z;
var FREQUENCY_MASTER_FULL_READ = toolkit.createAsyncThunk("tablerowfrequencymaster_fullread_aFir7Reducer/frequencymaster_fullread_afir7", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      isWithoutLimit,
      page,
      perPage,
      _payload$searchQuery,
      searchQuery,
      queryId,
      withLimitFilter,
      withoutLimitFilter,
      fullReadQDMQuery,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          isWithoutLimit = payload.isWithoutLimit, page = payload.page, perPage = payload.perPage, _payload$searchQuery = payload.searchQuery, searchQuery = _payload$searchQuery === void 0 ? "" : _payload$searchQuery;
          queryId = isWithoutLimit ? "433d0178-9349-4a2f-bddb-932d83307f86" : "cf9f9eee-973a-42e3-a62f-af26e60d38b4";
          withLimitFilter = {
            filter: {
              code: "%".concat(searchQuery, "%"),
              page: page,
              perPage: perPage
            }
          };
          withoutLimitFilter = {
            filter: {
              code: "%".concat(searchQuery, "%")
            }
          };
          fullReadQDMQuery = _objectSpread2({
            db_name: dbName,
            queryid: queryId
          }, isWithoutLimit ? withoutLimitFilter : withLimitFilter);
          _context.next = 10;
          return fetchData({
            body: JSON.stringify(fullReadQDMQuery)
          }, __baseUrl__, {
            "Content-Type": "application/json",
            Accept: "application/json"
          });

        case 10:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 14]]);
})));
var tablerowfrequencymaster_fullread_aFir7Reducer = toolkit.createSlice({
  name: "tablerowfrequencymaster_fullread_aFir7Reducer",
  initialState: {
    frequencymaster_fullread_aFir7: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$Z = {}, _defineProperty(_extraReducers$Z, FREQUENCY_MASTER_FULL_READ.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.frequencymaster_fullread_aFir7.loading = false, state.frequencymaster_fullread_aFir7.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.frequencymaster_fullread_aFir7.error = false, state.frequencymaster_fullread_aFir7.message = httpMessage.OkMessage; // state.drugCatalogMasterFullread = action?.payload ?? {};
  }), _defineProperty(_extraReducers$Z, FREQUENCY_MASTER_FULL_READ.rejected, function (state, action) {
    var _action$payload2;

    state.frequencymaster_fullread_aFir7 = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$Z, FREQUENCY_MASTER_FULL_READ.pending, function (state, action) {
    state.frequencymaster_fullread_aFir7.loading = true;
  }), _extraReducers$Z)
});
var tablerowfrequencymaster_fullread_aFir7Actions = {
  FREQUENCY_MASTER_FULL_READ: FREQUENCY_MASTER_FULL_READ
};
var tablerowfrequencymaster_fullread_aFir7Reducer$1 = tablerowfrequencymaster_fullread_aFir7Reducer.reducer;

var _extraReducers$Y;
var edit_schedulelinesfrequencymaster_days_dropdown_ZifnB = toolkit.createAsyncThunk("edit_schedulelinesfrequencymaster_days_dropdown_ZifnBReducer/frequencymaster_days_dropdown_zifnb", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type == 'WEEKDAYS' && CodingMaster.status == true && CodingMaster.activestatus == true",
              return_fields: "keep(CodingMaster,'_key','_id','id','code','display','shortdesc','Type','status')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var edit_schedulelinesfrequencymaster_days_dropdown_ZifnBReducer = toolkit.createSlice({
  name: "edit_schedulelinesfrequencymaster_days_dropdown_ZifnBReducer",
  initialState: {
    frequencymaster_days_dropdown_ZifnB: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$Y = {}, _defineProperty(_extraReducers$Y, edit_schedulelinesfrequencymaster_days_dropdown_ZifnB.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.frequencymaster_days_dropdown_ZifnB.loading = false, state.frequencymaster_days_dropdown_ZifnB.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.frequencymaster_days_dropdown_ZifnB.error = false, state.frequencymaster_days_dropdown_ZifnB.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$Y, edit_schedulelinesfrequencymaster_days_dropdown_ZifnB.rejected, function (state, action) {
    var _action$payload2;

    state.frequencymaster_days_dropdown_ZifnB = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$Y, edit_schedulelinesfrequencymaster_days_dropdown_ZifnB.pending, function (state, action) {
    state.frequencymaster_days_dropdown_ZifnB.loading = true;
  }), _extraReducers$Y)
});
var edit_schedulelinesfrequencymaster_days_dropdown_ZifnBActions = {
  edit_schedulelinesfrequencymaster_days_dropdown_ZifnB: edit_schedulelinesfrequencymaster_days_dropdown_ZifnB
};
var edit_schedulelinesfrequencymaster_days_dropdown_ZifnBReducer$1 = edit_schedulelinesfrequencymaster_days_dropdown_ZifnBReducer.reducer;

var _extraReducers$X;
var addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55Y = toolkit.createAsyncThunk("addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55YReducer/frequencymaster_frequencytype_dropdown_oe55y", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='CLMMFREQTYPE' && CodingMaster.activestatus==true && CodingMaster.status==true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
              sort: "CodingMaster.display"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55YReducer = toolkit.createSlice({
  name: "addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55YReducer",
  initialState: {
    frequencymaster_frequencytype_dropdown_OE55Y: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$X = {}, _defineProperty(_extraReducers$X, addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55Y.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.frequencymaster_frequencytype_dropdown_OE55Y.loading = false, state.frequencymaster_frequencytype_dropdown_OE55Y.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.frequencymaster_frequencytype_dropdown_OE55Y.error = false, state.frequencymaster_frequencytype_dropdown_OE55Y.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$X, addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55Y.rejected, function (state, action) {
    var _action$payload2;

    state.frequencymaster_frequencytype_dropdown_OE55Y = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$X, addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55Y.pending, function (state, action) {
    state.frequencymaster_frequencytype_dropdown_OE55Y.loading = true;
  }), _extraReducers$X)
});
var addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55YActions = {
  addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55Y: addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55Y
};
var addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55YReducer$1 = addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55YReducer.reducer;

var _extraReducers$W;
var addnewfrequency_orgfrequencymaster_uom_dropdown_OE55Y = toolkit.createAsyncThunk("addnewfrequency_orgfrequencymaster_uom_dropdown_OE55YReducer/frequencymaster_uom_dropdown_oe55y", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='FREQUOM' && CodingMaster.activestatus==true && CodingMaster.status==true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
              sort: "CodingMaster.display"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var addnewfrequency_orgfrequencymaster_uom_dropdown_OE55YReducer = toolkit.createSlice({
  name: "addnewfrequency_orgfrequencymaster_uom_dropdown_OE55YReducer",
  initialState: {
    frequencymaster_uom_dropdown_OE55Y: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$W = {}, _defineProperty(_extraReducers$W, addnewfrequency_orgfrequencymaster_uom_dropdown_OE55Y.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.frequencymaster_uom_dropdown_OE55Y.loading = false, state.frequencymaster_uom_dropdown_OE55Y.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.frequencymaster_uom_dropdown_OE55Y.error = false, state.frequencymaster_uom_dropdown_OE55Y.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$W, addnewfrequency_orgfrequencymaster_uom_dropdown_OE55Y.rejected, function (state, action) {
    var _action$payload2;

    state.frequencymaster_uom_dropdown_OE55Y = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$W, addnewfrequency_orgfrequencymaster_uom_dropdown_OE55Y.pending, function (state, action) {
    state.frequencymaster_uom_dropdown_OE55Y.loading = true;
  }), _extraReducers$W)
});
var addnewfrequency_orgfrequencymaster_uom_dropdown_OE55YActions = {
  addnewfrequency_orgfrequencymaster_uom_dropdown_OE55Y: addnewfrequency_orgfrequencymaster_uom_dropdown_OE55Y
};
var addnewfrequency_orgfrequencymaster_uom_dropdown_OE55YReducer$1 = addnewfrequency_orgfrequencymaster_uom_dropdown_OE55YReducer.reducer;

var _extraReducers$V;
var addnewfrequency_orgfrequencymaster_insert_lHc7n = toolkit.createAsyncThunk("addnewfrequency_orgfrequencymaster_insert_lHc7nReducer/frequencymaster_insert_lhc7n", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _doc, _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify([{
              db_name: dbName,
              entity: "FrequencyMaster",
              is_metadata: true,
              metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
              doc: (_doc = {
                id: payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_id,
                freqcode: payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_freqcode,
                shortdesc: payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_shortdesc,
                longdesc: payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_longdesc,
                dosefreqval: payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_dosefreqval,
                dosefreqvalUOM: payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_dosefreqvaluom
              }, _defineProperty(_doc, "dosefreqval", payload !== null && payload !== void 0 && payload.addnewfrequency_org_dosefreqrateval ? payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_dosefreqrateval : payload === null || payload === void 0 ? void 0 : payload.once_every), _defineProperty(_doc, "dosefreqvalUOM", payload !== null && payload !== void 0 && payload.addnewfrequency_org_dosefreqrateuom ? payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_dosefreqrateuom : payload === null || payload === void 0 ? void 0 : payload.once_every_dropdown), _defineProperty(_doc, "graceperiod", payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_graceperiod), _defineProperty(_doc, "fixeddurationVal", payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_fixeddurationval), _defineProperty(_doc, "fixeddurUOM", payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_fixedduruom), _defineProperty(_doc, "frequencytype", payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_frequencytype), _defineProperty(_doc, "status", payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_status), _defineProperty(_doc, "scheduleline", payload === null || payload === void 0 ? void 0 : payload.scheduleline), _defineProperty(_doc, "IsBaseFreq", payload === null || payload === void 0 ? void 0 : payload.addnewfrequency_org_isbasefreq), _defineProperty(_doc, "directiontag", payload === null || payload === void 0 ? void 0 : payload.directiontag), _defineProperty(_doc, "directiontaglocal", payload === null || payload === void 0 ? void 0 : payload.directiontaglocal), _doc)
            }]);
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__uspsertUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var addnewfrequency_orgfrequencymaster_insert_lHc7nReducer = toolkit.createSlice({
  name: "addnewfrequency_orgfrequencymaster_insert_lHc7nReducer",
  initialState: {
    frequencymaster_insert_lHc7n: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$V = {}, _defineProperty(_extraReducers$V, addnewfrequency_orgfrequencymaster_insert_lHc7n.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.frequencymaster_insert_lHc7n.loading = false, state.frequencymaster_insert_lHc7n.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.frequencymaster_insert_lHc7n.error = false, state.frequencymaster_insert_lHc7n.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$V, addnewfrequency_orgfrequencymaster_insert_lHc7n.rejected, function (state, action) {
    var _action$payload2;

    state.frequencymaster_insert_lHc7n = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$V, addnewfrequency_orgfrequencymaster_insert_lHc7n.pending, function (state, action) {
    state.frequencymaster_insert_lHc7n.loading = true;
  }), _extraReducers$V)
});
var addnewfrequency_orgfrequencymaster_insert_lHc7nActions = {
  addnewfrequency_orgfrequencymaster_insert_lHc7n: addnewfrequency_orgfrequencymaster_insert_lHc7n
};
var addnewfrequency_orgfrequencymaster_insert_lHc7nReducer$1 = addnewfrequency_orgfrequencymaster_insert_lHc7nReducer.reducer;

var _extraReducers$U;
var addnewfrequency_orgfrequencymaster_days_dropdown_j5qvC = toolkit.createAsyncThunk("addnewfrequency_orgfrequencymaster_days_dropdown_j5qvCReducer/frequencymaster_days_dropdown_j5qvc", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type == 'WEEKDAYS' && CodingMaster.status == true && CodingMaster.activestatus == true",
              return_fields: "keep(CodingMaster,'_key','_id','id','code','display','shortdesc','Type','status')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var addnewfrequency_orgfrequencymaster_days_dropdown_j5qvCReducer = toolkit.createSlice({
  name: "addnewfrequency_orgfrequencymaster_days_dropdown_j5qvCReducer",
  initialState: {
    frequencymaster_days_dropdown_j5qvC: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$U = {}, _defineProperty(_extraReducers$U, addnewfrequency_orgfrequencymaster_days_dropdown_j5qvC.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.frequencymaster_days_dropdown_j5qvC.loading = false, state.frequencymaster_days_dropdown_j5qvC.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.frequencymaster_days_dropdown_j5qvC.error = false, state.frequencymaster_days_dropdown_j5qvC.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$U, addnewfrequency_orgfrequencymaster_days_dropdown_j5qvC.rejected, function (state, action) {
    var _action$payload2;

    state.frequencymaster_days_dropdown_j5qvC = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$U, addnewfrequency_orgfrequencymaster_days_dropdown_j5qvC.pending, function (state, action) {
    state.frequencymaster_days_dropdown_j5qvC.loading = true;
  }), _extraReducers$U)
});
var addnewfrequency_orgfrequencymaster_days_dropdown_j5qvCActions = {
  addnewfrequency_orgfrequencymaster_days_dropdown_j5qvC: addnewfrequency_orgfrequencymaster_days_dropdown_j5qvC
};
var addnewfrequency_orgfrequencymaster_days_dropdown_j5qvCReducer$1 = addnewfrequency_orgfrequencymaster_days_dropdown_j5qvCReducer.reducer;

var _extraReducers$T;
var EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrn = toolkit.createAsyncThunk("EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrnReducer/frequencymaster_frequencytype_dropdown_7zrrn", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='CLMMFREQTYPE' && CodingMaster.activestatus==true && CodingMaster.status==true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
              sort: "CodingMaster.display"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrnReducer = toolkit.createSlice({
  name: "EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrnReducer",
  initialState: {
    frequencymaster_frequencytype_dropdown_7zRrn: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$T = {}, _defineProperty(_extraReducers$T, EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrn.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.frequencymaster_frequencytype_dropdown_7zRrn.loading = false, state.frequencymaster_frequencytype_dropdown_7zRrn.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.frequencymaster_frequencytype_dropdown_7zRrn.error = false, state.frequencymaster_frequencytype_dropdown_7zRrn.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$T, EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrn.rejected, function (state, action) {
    var _action$payload2;

    state.frequencymaster_frequencytype_dropdown_7zRrn = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$T, EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrn.pending, function (state, action) {
    state.frequencymaster_frequencytype_dropdown_7zRrn.loading = true;
  }), _extraReducers$T)
});
var EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrnActions = {
  EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrn: EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrn
};
var EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrnReducer$1 = EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrnReducer.reducer;

var _extraReducers$S;
var EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrn = toolkit.createAsyncThunk("EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrnReducer/frequencymaster_uom_dropdown_7zrrn", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type=='FREQUOM' && CodingMaster.activestatus==true && CodingMaster.status==true",
              return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
              sort: "CodingMaster.display"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrnReducer = toolkit.createSlice({
  name: "EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrnReducer",
  initialState: {
    frequencymaster_uom_dropdown_7zRrn: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$S = {}, _defineProperty(_extraReducers$S, EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrn.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.frequencymaster_uom_dropdown_7zRrn.loading = false, state.frequencymaster_uom_dropdown_7zRrn.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.frequencymaster_uom_dropdown_7zRrn.error = false, state.frequencymaster_uom_dropdown_7zRrn.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$S, EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrn.rejected, function (state, action) {
    var _action$payload2;

    state.frequencymaster_uom_dropdown_7zRrn = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$S, EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrn.pending, function (state, action) {
    state.frequencymaster_uom_dropdown_7zRrn.loading = true;
  }), _extraReducers$S)
});
var EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrnActions = {
  EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrn: EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrn
};
var EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrnReducer$1 = EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrnReducer.reducer;

var _extraReducers$R;
var EditNewFrequency_orgfrequencymaster_singleread_7zRrn = toolkit.createAsyncThunk("EditNewFrequency_orgfrequencymaster_singleread_7zRrnReducer/frequencymaster_singleread_7zrrn", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "FrequencyMaster",
              filter: "FrequencyMaster._key=='" + (payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org__key) + "' && FrequencyMaster.activestatus==true",
              "return_fields": "merge(FrequencyMaster,{scheduleline:(for data in FrequencySchedule filter FrequencyMaster.scheduleline any == data._id return merge(data,{day:document(data.day)}))},{frequencytype:document(FrequencyMaster.frequencytype)},{dosefreqvalUOM:document(FrequencyMaster.dosefreqvalUOM)},{fixeddurUOM:document(FrequencyMaster.fixeddurUOM)})"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewFrequency_orgfrequencymaster_singleread_7zRrnReducer = toolkit.createSlice({
  name: "EditNewFrequency_orgfrequencymaster_singleread_7zRrnReducer",
  initialState: {
    frequencymaster_singleread_7zRrn: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$R = {}, _defineProperty(_extraReducers$R, EditNewFrequency_orgfrequencymaster_singleread_7zRrn.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.frequencymaster_singleread_7zRrn.loading = false, state.frequencymaster_singleread_7zRrn.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.frequencymaster_singleread_7zRrn.error = false, state.frequencymaster_singleread_7zRrn.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$R, EditNewFrequency_orgfrequencymaster_singleread_7zRrn.rejected, function (state, action) {
    var _action$payload2;

    state.frequencymaster_singleread_7zRrn = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$R, EditNewFrequency_orgfrequencymaster_singleread_7zRrn.pending, function (state, action) {
    state.frequencymaster_singleread_7zRrn.loading = true;
  }), _extraReducers$R)
});
var EditNewFrequency_orgfrequencymaster_singleread_7zRrnActions = {
  EditNewFrequency_orgfrequencymaster_singleread_7zRrn: EditNewFrequency_orgfrequencymaster_singleread_7zRrn
};
var EditNewFrequency_orgfrequencymaster_singleread_7zRrnReducer$1 = EditNewFrequency_orgfrequencymaster_singleread_7zRrnReducer.reducer;

var _extraReducers$Q;
var EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrn = toolkit.createAsyncThunk("EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrnReducer/frequencymaster_days_dropdown_7zrrn", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type == 'WEEKDAYS' && CodingMaster.status == true && CodingMaster.activestatus == true",
              return_fields: "keep(CodingMaster,'_key','_id','id','code','display','shortdesc','Type','status')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrnReducer = toolkit.createSlice({
  name: "EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrnReducer",
  initialState: {
    frequencymaster_days_dropdown_7zRrn: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$Q = {}, _defineProperty(_extraReducers$Q, EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrn.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.frequencymaster_days_dropdown_7zRrn.loading = false, state.frequencymaster_days_dropdown_7zRrn.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.frequencymaster_days_dropdown_7zRrn.error = false, state.frequencymaster_days_dropdown_7zRrn.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$Q, EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrn.rejected, function (state, action) {
    var _action$payload2;

    state.frequencymaster_days_dropdown_7zRrn = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$Q, EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrn.pending, function (state, action) {
    state.frequencymaster_days_dropdown_7zRrn.loading = true;
  }), _extraReducers$Q)
});
var EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrnActions = {
  EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrn: EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrn
};
var EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrnReducer$1 = EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrnReducer.reducer;

var _extraReducers$P;
var EditNewFrequency_orgfrequencymaster_update_wiw9R = toolkit.createAsyncThunk("EditNewFrequency_orgfrequencymaster_update_wiw9RReducer/frequencymaster_update_wiw9r", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _doc, _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify([{
              db_name: dbName,
              entity: "FrequencyMaster",
              is_metadata: true,
              filter: {
                _key: payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org__key
              },
              metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
              doc: (_doc = {
                id: payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_id,
                freqcode: payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_freqcode,
                shortdesc: payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_shortdesc,
                longdesc: payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_longdesc,
                dosefreqval: payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_dosefreqval,
                dosefreqvalUOM: payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_dosefreqvaluom
              }, _defineProperty(_doc, "dosefreqval", payload !== null && payload !== void 0 && payload.editnewfrequency_org_dosefreqrateval ? payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_dosefreqrateval : payload.once_every), _defineProperty(_doc, "dosefreqvalUOM", payload !== null && payload !== void 0 && payload.editnewfrequency_org_dosefreqrateuom ? payload.once_every_dropdown : payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_dosefreqrateuom), _defineProperty(_doc, "graceperiod", payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_graceperiod), _defineProperty(_doc, "fixeddurationVal", payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_fixeddurationval), _defineProperty(_doc, "fixeddurUOM", payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_fixedduruom), _defineProperty(_doc, "frequencytype", payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_frequencytype), _defineProperty(_doc, "status", payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_status), _defineProperty(_doc, "scheduleline", payload === null || payload === void 0 ? void 0 : payload.scheduleline), _defineProperty(_doc, "IsBaseFreq", payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_isbasefreq), _defineProperty(_doc, "directiontag", payload === null || payload === void 0 ? void 0 : payload.directiontag), _defineProperty(_doc, "directiontaglocal", payload === null || payload === void 0 ? void 0 : payload.directiontaglocal), _doc)
            }]);
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__uspsertUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewFrequency_orgfrequencymaster_update_wiw9RReducer = toolkit.createSlice({
  name: "EditNewFrequency_orgfrequencymaster_update_wiw9RReducer",
  initialState: {
    frequencymaster_update_wiw9R: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$P = {}, _defineProperty(_extraReducers$P, EditNewFrequency_orgfrequencymaster_update_wiw9R.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.frequencymaster_update_wiw9R.loading = false, state.frequencymaster_update_wiw9R.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.frequencymaster_update_wiw9R.error = false, state.frequencymaster_update_wiw9R.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$P, EditNewFrequency_orgfrequencymaster_update_wiw9R.rejected, function (state, action) {
    var _action$payload2;

    state.frequencymaster_update_wiw9R = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$P, EditNewFrequency_orgfrequencymaster_update_wiw9R.pending, function (state, action) {
    state.frequencymaster_update_wiw9R.loading = true;
  }), _extraReducers$P)
});
var EditNewFrequency_orgfrequencymaster_update_wiw9RActions = {
  EditNewFrequency_orgfrequencymaster_update_wiw9R: EditNewFrequency_orgfrequencymaster_update_wiw9R
};
var EditNewFrequency_orgfrequencymaster_update_wiw9RReducer$1 = EditNewFrequency_orgfrequencymaster_update_wiw9RReducer.reducer;

var _extraReducers$O;
var drugUpsert = toolkit.createAsyncThunk("drugReducer/upsert", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var rejectWithValue, data, LocationMasterId, editRule, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = action.rejectWithValue;
            data = payload.data, LocationMasterId = payload.LocationMasterId, editRule = payload.editRule;
            _context.prev = 2;
            body = data.map(function (v) {
              var _v$facility, _v$locationType;

              return {
                db_name: dbName,
                entity: "CA_PerformingLocationforOrdLocn",
                is_metadata: true,
                metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
                doc: {
                  id: 0,
                  ordering_org: (_v$facility = v === null || v === void 0 ? void 0 : v.facility) !== null && _v$facility !== void 0 ? _v$facility : "",
                  ordering_source_type: (_v$locationType = v === null || v === void 0 ? void 0 : v.locationType) !== null && _v$locationType !== void 0 ? _v$locationType : "",
                  ordering_source_code: "",
                  service_applicability: "medication",
                  order_criteria: _toConsumableArray(editRule),
                  status: true,
                  performing_org: "",
                  performing_location_role_type: "",
                  performing_location_code: LocationMasterId !== null && LocationMasterId !== void 0 ? LocationMasterId : ""
                }
              };
            });
            body = JSON.stringify(body);
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 8;
            return fetchDataApi(__uspsertUrl__, options);

          case 8:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 11:
            _context.next = 13;
            return _res.json();

          case 13:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 17]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var drugUpdate = toolkit.createAsyncThunk("drugReducer/update", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(payload, action) {
    var rejectWithValue, data, editRule, LocationMasterId, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            rejectWithValue = action.rejectWithValue;
            data = payload.data, payload.key, editRule = payload.editRule, LocationMasterId = payload.LocationMasterId;
            _context2.prev = 2;
            // return;
            // let body = {};
            body = data.map(function (v) {
              var _v$facility2, _v$locationType2;

              var Json = {
                db_name: dbName,
                entity: "CA_PerformingLocationforOrdLocn",
                is_metadata: true,
                metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
                doc: {
                  id: 0,
                  ordering_org: (_v$facility2 = v === null || v === void 0 ? void 0 : v.facility) !== null && _v$facility2 !== void 0 ? _v$facility2 : "",
                  ordering_source_type: (_v$locationType2 = v === null || v === void 0 ? void 0 : v.locationType) !== null && _v$locationType2 !== void 0 ? _v$locationType2 : "",
                  ordering_source_code: "",
                  service_applicability: "medication",
                  order_criteria: _toConsumableArray(editRule),
                  status: true,
                  performing_org: "",
                  performing_location_role_type: "",
                  performing_location_code: LocationMasterId !== null && LocationMasterId !== void 0 ? LocationMasterId : ""
                }
              };

              if (v !== null && v !== void 0 && v._key) {
                Json.filter = {
                  _key: v._key
                };
              }

              return Json;
            });
            body = JSON.stringify(body);
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context2.next = 8;
            return fetchDataApi(__uspsertUrl__, options);

          case 8:
            _res = _context2.sent;

            if (_res.ok) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 11:
            _context2.next = 13;
            return _res.json();

          case 13:
            response = _context2.sent;
            return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context2.t0.message
            })));

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 17]]);
  }));

  return function (_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}());
var sigleRead = toolkit.createAsyncThunk("drugReducer/singleread", /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(payload, action) {
    var rejectWithValue, LocationMasterId, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            rejectWithValue = action.rejectWithValue;
            LocationMasterId = payload.LocationMasterId;
            _context3.prev = 2;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CA_PerformingLocationforOrdLocn",
              filter: "CA_PerformingLocationforOrdLocn.performing_location_code == '".concat(LocationMasterId, "' && CA_PerformingLocationforOrdLocn.activestatus==true "),
              return_fields: "merge(CA_PerformingLocationforOrdLocn,{ordering_org:DOCUMENT(CA_PerformingLocationforOrdLocn.ordering_org)},{ordering_source_type:DOCUMENT(CA_PerformingLocationforOrdLocn.ordering_source_type)},{ordering_source_code:DOCUMENT(CA_PerformingLocationforOrdLocn.ordering_source_code)},{service_applicability:DOCUMENT(CA_PerformingLocationforOrdLocn.service_applicability)},{performing_org:DOCUMENT(CA_PerformingLocationforOrdLocn.performing_org)},{performing_location_role_type:DOCUMENT(CA_PerformingLocationforOrdLocn.performing_location_role_type)},{ performing_location_code:(for performing_location_code in document(TO_ARRAY(CA_PerformingLocationforOrdLocn.performing_location_code)) return merge(performing_location_code,{operationalStatus:(for operationalStatus in document(TO_ARRAY(performing_location_code.operationalStatus)) return merge(operationalStatus,{coding:document(operationalStatus.coding)}))},{specialty:(for specialty in document(TO_ARRAY(performing_location_code.specialty)) return merge(specialty,{coding:document(specialty.coding)}))}) ) })"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context3.next = 8;
            return fetchDataApi(__readDocumentUrl__, options);

          case 8:
            _res = _context3.sent;

            if (_res.ok) {
              _context3.next = 11;
              break;
            }

            return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 11:
            _context3.next = 13;
            return _res.json();

          case 13:
            response = _context3.sent;
            return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context3.t0.message
            })));

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 17]]);
  }));

  return function (_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}());
var drugReducer = toolkit.createSlice({
  name: "drugReducer",
  initialState: {
    upsert: _objectSpread2({}, defaultState.Info),
    read: _objectSpread2({}, defaultState.Info),
    update: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$O = {}, _defineProperty(_extraReducers$O, drugUpsert.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.upsert.loading = false, state.upsert.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.upsert.error = false, state.upsert.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$O, drugUpsert.rejected, function (state, action) {
    var _action$payload2;

    state.upsert = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$O, drugUpsert.pending, function (state, action) {
    state.upsert.loading = true;
  }), _defineProperty(_extraReducers$O, sigleRead.fulfilled, function (state, action) {
    var _action$payload$data2, _action$payload3;

    state.read.loading = false, state.read.data = (_action$payload$data2 = action === null || action === void 0 ? void 0 : (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.data) !== null && _action$payload$data2 !== void 0 ? _action$payload$data2 : action === null || action === void 0 ? void 0 : action.payload, state.read.error = false, state.read.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$O, sigleRead.rejected, function (state, action) {
    var _action$payload4;

    state.read = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$O, sigleRead.pending, function (state, action) {
    state.read.loading = true;
  }), _defineProperty(_extraReducers$O, drugUpdate.fulfilled, function (state, action) {
    var _action$payload$data3, _action$payload5;

    state.update.loading = false, state.update.data = (_action$payload$data3 = action === null || action === void 0 ? void 0 : (_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : _action$payload5.data) !== null && _action$payload$data3 !== void 0 ? _action$payload$data3 : action === null || action === void 0 ? void 0 : action.payload, state.update.error = false, state.update.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$O, drugUpdate.rejected, function (state, action) {
    var _action$payload6;

    state.update = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers$O, drugUpdate.pending, function (state, action) {
    state.update.loading = true;
  }), _extraReducers$O)
});
var drugActions = {
  drugUpsert: drugUpsert,
  sigleRead: sigleRead,
  drugUpdate: drugUpdate
};
var drugReducer$1 = drugReducer.reducer;

var _extraReducers$N;
var EditNewFrequency_orgbase_frequency_dropdown = toolkit.createAsyncThunk("EditNewFrequency_orgbase_frequency_dropdownReducer/base_frequency_dropdown", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "FrequencyMaster",
              filter: "FrequencyMaster.IsBaseFreq==true && FrequencyMaster.status==true && FrequencyMaster.activestatus==true ",
              return_fields: "KEEP(FrequencyMaster,'_id','id','_key','freqcode','shortdesc','IsBaseFreq','status')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var EditNewFrequency_orgbase_frequency_dropdownReducer = toolkit.createSlice({
  name: "EditNewFrequency_orgbase_frequency_dropdownReducer",
  initialState: {
    base_frequency_dropdown: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$N = {}, _defineProperty(_extraReducers$N, EditNewFrequency_orgbase_frequency_dropdown.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.base_frequency_dropdown.loading = false, state.base_frequency_dropdown.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.base_frequency_dropdown.error = false, state.base_frequency_dropdown.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$N, EditNewFrequency_orgbase_frequency_dropdown.rejected, function (state, action) {
    var _action$payload2;

    state.base_frequency_dropdown = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$N, EditNewFrequency_orgbase_frequency_dropdown.pending, function (state, action) {
    state.base_frequency_dropdown.loading = true;
  }), _extraReducers$N)
});
var EditNewFrequency_orgbase_frequency_dropdownActions = {
  EditNewFrequency_orgbase_frequency_dropdown: EditNewFrequency_orgbase_frequency_dropdown
};
var EditNewFrequency_orgbase_frequency_dropdownReducer$1 = EditNewFrequency_orgbase_frequency_dropdownReducer.reducer;

var _extraReducers$M;
var frequency_schedule_status_updata = toolkit.createAsyncThunk("frequency_schedule_status_updataReducer/frequencymaster_status_update", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify([{
              db_name: dbName,
              entity: "FrequencyMaster",
              is_metadata: true,
              filter: {
                _key: payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org__key
              },
              metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
              doc: {
                status: payload === null || payload === void 0 ? void 0 : payload.editnewfrequency_org_status
              }
            }]);
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__uspsertUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var frequency_schedule_status_updataReducer = toolkit.createSlice({
  name: "frequency_schedule_status_updataReducer",
  initialState: {
    frequencymaster_status_update: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$M = {}, _defineProperty(_extraReducers$M, frequency_schedule_status_updata.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.frequencymaster_status_update.loading = false, state.frequencymaster_status_update.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.frequencymaster_status_update.error = false, state.frequencymaster_status_update.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$M, frequency_schedule_status_updata.rejected, function (state, action) {
    var _action$payload2;

    state.frequencymaster_status_update = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$M, frequency_schedule_status_updata.pending, function (state, action) {
    state.frequencymaster_status_update.loading = true;
  }), _extraReducers$M)
});
var frequency_schedule_status_updataActions = {
  frequency_schedule_status_updata: frequency_schedule_status_updata
};
var frequency_schedule_status_updataReducer$1 = frequency_schedule_status_updataReducer.reducer;

var _extraReducers$L;
var schedule_line_day_dropdown = toolkit.createAsyncThunk("schedule_line_day_dropdownReducer/schedule_line_day_dropdown", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify({
              db_name: dbName,
              entity: "CodingMaster",
              filter: "CodingMaster.Type == 'WEEKDAYS' && CodingMaster.status == true && CodingMaster.activestatus == true",
              return_fields: "keep(CodingMaster,'_key','_id','id','code','display','shortdesc','Type','status')"
            });
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var schedule_line_day_dropdownReducer = toolkit.createSlice({
  name: "schedule_line_day_dropdownReducer",
  initialState: {
    schedule_line_day: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$L = {}, _defineProperty(_extraReducers$L, schedule_line_day_dropdown.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.schedule_line_day.loading = false, state.schedule_line_day.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.schedule_line_day.error = false, state.schedule_line_day.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$L, schedule_line_day_dropdown.rejected, function (state, action) {
    var _action$payload2;

    state.schedule_line_day = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$L, schedule_line_day_dropdown.pending, function (state, action) {
    state.schedule_line_day.loading = true;
  }), _extraReducers$L)
});
var schedule_line_day_dropdownActions = {
  schedule_line_day_dropdown: schedule_line_day_dropdown
};
var schedule_line_day_dropdownReducer$1 = schedule_line_day_dropdownReducer.reducer;

var pharmacyVerifierQuery = {
  addDrug: function addDrug() {
    return {
      db_name: dbName,
      entity: "DrugType",
      filter: "DrugType.drugtype in ['DISPOSABLE','DISPENSE','FLUID'] && DrugType.status==true && DrugType.activestatus == true",
      return_fields: "KEEP(DrugType,'_key','_id','id','drugtype','shortdesc','longdesc','status','activestatus')",
      sort: "DrugType.longdesc"
    };
  },
  drugType_against_drug: function drugType_against_drug(_id) {
    return {
      db_name: dbName,
      entity: "DrugMaster",
      filter: "DOCUMENT(DrugMaster.DrugType).drugtype=='".concat(_id, "' && DrugMaster.activestatus==true"),
      return_fields: "merge({alias:(for ali in to_array(DrugMaster.aliasDtls) return merge(ali,{aliasType:document(ali.aliasType)})),dispensedrugcode:DrugMaster._id,drugNameShort:DrugMaster.ShortDesc,drugNameLong:DrugMaster.LongDesc },{drugreleasetype:document(DrugMaster.DrugType).drugtype=='DISPOSABLE' ? first(for doc in CodingMaster filter doc.Type=='RELEASETYPE' && doc.code=='DISPOSABLE' return doc._id) : ' '},{packSizeApplicability:(for doc in TO_ARRAY(DrugMaster.packSizeApplicability)for uom in DrugMasterUOM filter uom._id ==doc return merge(uom,{applicableInd:keep(document(uom.applicableInd),'_id','code','display'),packSizeUoM:keep(document(uom.packSizeUoM),'UOM','_id'),roundtype:keep(document(uom.roundtype),'_id','code','display'),packUnitUoM:keep(document(uom.packUnitUoM),'_id','UOM')}))})"
    };
  },
  issueMedication: function issueMedication(_id) {
    return {
      db_name: dbName,
      entity: "PH_OrderLineDispenseSchedule,PH_OrderLinePerdoseSchedule",
      filter: {
        PH_OrderLineDispenseSchedule: "PH_OrderLineDispenseSchedule.ph_orderlineid=='".concat(_id, "' && DOCUMENT(PH_OrderLineDispenseSchedule.dispensethru).code !='RI' && PH_OrderLineDispenseSchedule.activestatus==true sort PH_OrderLineDispenseSchedule.dispdate desc limit 1"),
        PH_OrderLinePerdoseSchedule: "PH_OrderLinePerdoseSchedule.dispschedule_id==PH_OrderLineDispenseSchedule._id && PH_OrderLineDispenseSchedule.activestatus==true"
      },
      return_fields: "merge(PH_OrderLinePerdoseSchedule,{stkuom:document(PH_OrderLinePerdoseSchedule.stkuom)},{issueuom:document(PH_OrderLinePerdoseSchedule.issueuom)},{doseuom:document(PH_OrderLinePerdoseSchedule.doseuom)},{billuom:document(PH_OrderLinePerdoseSchedule.billuom)},{admuom:document(PH_OrderLinePerdoseSchedule.admuom)})"
    };
  },
  PharmacyFramework_Patientbanner: function PharmacyFramework_Patientbanner(id) {
    return {
      db_name: dbName,
      entity: "Patient",
      filter: "Patient._id=='".concat(id, "' && Patient.activestatus==true"),
      return_fields: "merge({_id:Patient._id},{birthDate:Patient.birthDate},{id:Patient.id},{_key:Patient._key},{photo:document(Patient.photo)},{name:(for doc in HumanNameMaster filter doc._id in Patient.name return merge(doc,{use:(document(doc.use)),prefix:(document(doc.prefix)),suffix:(document(doc.suffix))}))},{age:Patient.age},{bloodGroup:document(Patient.bloodGroup)},{telecom:(for doc in ContactPointMaster filter doc._id in Patient.telecom return merge(doc,{system:(document(doc.system)),use:(document(doc.use)),valueprefix:(document(doc.valueprefix)),rank:(document(doc.rank))}))},{alias:Patient.alias},{gender:document(Patient.gender)},{PatientType:document(Patient.patientTypecode).display},{EmergencyDetails:(FOR RelatedPerson IN RelatedPerson FILTER RelatedPerson.PatientID==[ to_string(Patient.id) ] && RelatedPerson.activestatus==true Return merge(keep(RelatedPerson,'_id','_key'),{name:first(document(RelatedPerson.name)[*].text)},{relationship:document(RelatedPerson.relationship).display},{telecom:document(RelatedPerson.telecom)[*].value}))})"
    };
  },
  PharmacyFramework_Financialbanner: function PharmacyFramework_Financialbanner(patientId) {
    return {
      db_name: dbName,
      entity: "Account",
      filter: "Account.guarantor[0].patient_id==".concat(patientId, " && Account.activestatus==true"),
      return_fields: "keep(Account,'payer_details','id','_id','_key','patient_id','organization_id','name')",
      sort: "Account.name"
    };
  },
  PharmacyFramework_Encounterbanner: function PharmacyFramework_Encounterbanner(patientId, loggedUserInfo) {
    // return {
    //   db_name: dbName,
    //   entity: "Encounter",
    //   filter: `Encounter.patient_id == ${id} && Encounter.activestatus == true`,
    //   return_fields:
    //     "merge({_id:Encounter._id},{id:Encounter.id},{_key:Encounter._key},{encounterdate:Encounter.encounterdate},{encounter_no:Encounter.encounter_no},{type_id:Encounter.type},{type:DOCUMENT(Encounter.type)[0].code},{visit_type:Encounter.visit_type},{location:first(document((Encounter.location)[*].location_id)[*].shortdesc)},{Practitioner_id:(for part in Encounter.participant for practId in Practitioner filter practId.id == part.Practitioner_id return merge(keep(practId,'_id'),{name:(for doc in HumanNameMaster filter doc._id in practId.name return merge(doc,{use:(document(document(doc.use).coding)),prefix:(document(document(doc.prefix).coding)),suffix:(document(document(doc.suffix).coding))}))}) )},{PractitionerRole_id:(for part in Encounter.participant for practRole in PractitionerRole filter practRole.id == part.PractitionerRole_id return document(document(practRole.role).coding))},{speciality:document(first(document(Encounter.practitioner_details[*].speciality)).coding)[*].display}, {Location:(for loc in LocationMaster filter first(Encounter.location[*].location_id) == loc._id return merge(loc,{locationType:merge(document(loc.locationType),{coding:document(document(loc.locationType).coding)})},{locationRoletype:document(loc.locationRoletype)}))})",
    //   sort: "Encounter.encounterdate desc",
    // };
    return {
      db_name: dbName,
      entity: "Organization,Encounter",
      filter: {
        Organization: "Organization._id == '".concat(loggedUserInfo === null || loggedUserInfo === void 0 ? void 0 : loggedUserInfo.facilityid, "'"),
        Encounter: "Encounter.patient_id == ".concat(patientId, " && Encounter.Organization_id == Organization.id && Encounter.activestatus == true")
      },
      return_fields: "merge({_id:Encounter._id},{id:Encounter.id},{_key:Encounter._key},{encounterdate:Encounter.encounterdate},{encounter_no:Encounter.encounter_no},{type_id:Encounter.type},{type:DOCUMENT(Encounter.type)[0].code},{visit_type:Encounter.visit_type},{location:first(document((Encounter.location)[*].location_id)[*].shortdesc)},{Practitioner_id:(for part in Encounter.participant for practId in Practitioner filter practId.id == part.Practitioner_id return merge(keep(practId,'_id'),{position:document(document(practId.position).coding)[*].display},{telecom:(for tel in ContactPointMaster filter tel._id in practId.telecom return merge(tel,{system:document(tel.system)}))},{name:(for doc in HumanNameMaster filter doc._id in practId.name return merge(doc,{use:(document(document(doc.use).coding)),prefix:(document(document(doc.prefix).coding)),suffix:(document(document(doc.suffix).coding))}))}) )},{PractitionerRole_id:(for part in Encounter.participant for practRole in PractitionerRole filter practRole.id == part.PractitionerRole_id return document(document(practRole.role).coding))},{speciality:document(first(document(Encounter.practitioner_details[*].speciality)).coding)[*].display}, {Location:(for loc in LocationMaster filter first(Encounter.location[*].location_id) == loc._id return merge(loc,{locationType:merge(document(loc.locationType),{coding:document(document(loc.locationType).coding)})},{locationRoletype:document(loc.locationRoletype)}))})",
      sort: "Encounter.encounterdate desc"
    };
  },
  PharmacyFramework_VitalsAgainstEncounter: function PharmacyFramework_VitalsAgainstEncounter(id) {
    return {
      db_name: dbName,
      entity: "CA_VitalSigns",
      filter: "CA_VitalSigns.encounterid == '".concat(id, "' && CA_VitalSigns.activestatus == true"),
      return_fields: "merge(keep(CA_VitalSigns,'_id','id','_key'),{component:CA_VitalSigns.component})"
    };
  },
  PharmacyFramework_AllergyAgainstPatient: function PharmacyFramework_AllergyAgainstPatient(id) {
    return {
      db_name: dbName,
      entity: "CA_AllergyIntolerance",
      filter: "CA_AllergyIntolerance.patient_id=='".concat(id, "' &&  CA_AllergyIntolerance.activestatus == true"),
      return_fields: "merge(keep(CA_AllergyIntolerance,'_key','id','_id','severity','criticality','clinicalstatus','type'),{shortdesc:document(CA_AllergyIntolerance.code).shortdesc})"
    };
  },
  PharmacyFramework_DiagnosisAgainstPatient: function PharmacyFramework_DiagnosisAgainstPatient(id) {
    return {
      db_name: dbName,
      entity: "CA_Diagnosis",
      filter: "CA_Diagnosis.patient_id == '".concat(id, "' && CA_Diagnosis.activestatus == true"),
      return_fields: "merge(keep(CA_Diagnosis,'_id','id','_key','clinicalstatus','VerificationSTatus','use'),{icdshortname:document(CA_Diagnosis.diagcode).icdshortname})"
    };
  },
  PharmacyFramework_ChiefComplaintsAgainstPatient: function PharmacyFramework_ChiefComplaintsAgainstPatient(id) {
    return {
      db_name: dbName,
      entity: "CA_ChiefComplaints",
      filter: "CA_ChiefComplaints.patient_id=='".concat(id, "' && CA_ChiefComplaints.activestatus == true"),
      return_fields: "merge(keep(CA_ChiefComplaints,'_id','id','_key','bodysite','clinicalStatus','verificationstatus','severity'),{shortdesc:document(CA_ChiefComplaints.code).shortdesc})"
    };
  },
  activeMedicatinAgainstPatientList: function activeMedicatinAgainstPatientList(patient_Id, encounter_Id, activestatus) {
    return {
      queryinputs: {
        activestatus: activestatus,
        patient_Id: patient_Id,
        encounter_Id: encounter_Id
      }
    };
  },
  activeMedicatinAgainstPatient: function activeMedicatinAgainstPatient(_ref) {
    var patient_Id = _ref.patient_Id,
        encounter_Id = _ref.encounter_Id,
        activestatus = _ref.activestatus,
        reportGrpCode = _ref.reportGrpCode,
        reportid = _ref.reportid,
        facility_id = _ref.facility_id,
        location_id = _ref.location_id;
    return {
      reportGrpCode: reportGrpCode,
      reportid: reportid,
      queryinputs: {
        activestatus: activestatus,
        patient_Id: patient_Id,
        encounter_Id: encounter_Id,
        facility_id: facility_id,
        location_id: location_id
      }
    };
  },
  patientQueue: function patientQueue(id, search, loggedUserInfo, grpid) {
    return {
      db_name: dbName,
      queryid: "502192b9-11bf-4bc3-84a3-08e5e37b44a8",
      filter: {
        queueid: "".concat(id),
        search: "%".concat(search, "%"),
        facility_id: loggedUserInfo === null || loggedUserInfo === void 0 ? void 0 : loggedUserInfo.facilityid,
        locationid: loggedUserInfo === null || loggedUserInfo === void 0 ? void 0 : loggedUserInfo.locationid,
        grpid: grpid !== null && grpid !== void 0 ? grpid : ""
      }
    };
  },
  patientQueueStatusList: function patientQueueStatusList() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='QUEUESTATUS' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  },
  searchPatientQueue: function searchPatientQueue(search, ExistingPatient, loggedUserInfo) {
    var patientInqueue = ExistingPatient.map(function (val) {
      return val._id;
    });
    return {
      db_name: dbName,
      entity: "Patient",
      filter: "(LIKE(Patient.alias,'%".concat(search, "%',true) || LIKE(first(document(Patient.telecom)).value,'%").concat(search, "%',true) || LIKE(first(document(Patient.name)).given,'%").concat(search, "%',true) || LIKE(first(document(Patient.name)).text,'%").concat(search, "%',true) ) && Patient._id NOT IN ['").concat(patientInqueue.join("','"), "'] && Patient.activestatus==true"),
      return_fields: "merge(keep(Patient,'_id','id','_key','age','bloodGroup','alias'),{name:(for doc in HumanNameMaster filter doc._id in Patient.name return merge(doc,{use:(document(doc.use).display),prefix:document(doc.prefix).display,suffix:document(doc.suffix).display}))},{telecom:(for doc in ContactPointMaster filter doc._id in Patient.telecom return doc.value)},{gender:document(Patient.gender).display},{photo:document(Patient.photo)})"
    };
  },
  dispense_and_details: function dispense_and_details(id) {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='".concat(id, "' && CodingMaster.activestatus==true && CodingMaster.status==true"),
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  alert_reason: function alert_reason() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='ALERTREASON' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "keep(CodingMaster,'_id','_key','code','display','id','Type','shortdesc')"
    };
  },
  alert_update: function alert_update(payload) {
    return [{
      db_name: dbName,
      entity: "PH_OrderLineAlertLogs",
      is_metadata: true,
      filter: {
        _key: payload._key
      },
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        interactionMessage: [{
          overrideReasonCode: payload === null || payload === void 0 ? void 0 : payload.overrideReasonCode,
          overrideNotes: payload === null || payload === void 0 ? void 0 : payload.notes,
          isAlert: payload === null || payload === void 0 ? void 0 : payload.isUpdate
        }]
      }
    }];
  },
  read_status_history: function read_status_history(key) {
    return {
      db_name: dbName,
      entity: "PH_OrderLineDispenseSchedule",
      filter: "PH_OrderLineDispenseSchedule._key=='".concat(key, "' && PH_OrderLineDispenseSchedule.activestatus==true"),
      return_fields: "merge(keep(PH_OrderLineDispenseSchedule,'status','statushistory'),{status:document(PH_OrderLineDispenseSchedule.status).display},{statushistory:(for sh in to_array(PH_OrderLineDispenseSchedule.statushistory) return merge(sh,{status:document(sh.status).display},{practitionerRole:first(document(document(document(sh.practitionerRole).role).coding)[*].display)},{practitioner:first(document(document(sh.practitioner).name)[*].text)}))})"
    };
  },
  instruction_master_read: function instruction_master_read() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='ORDERINSTRUCTION' && CodingMaster.activestatus==true",
      return_fields: "keep(CodingMaster,'_id','_key','id','Type','code','shortdesc','display','status')"
    };
  },
  reasonMaster: function reasonMaster(type) {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='".concat(type, "' && CodingMaster.activestatus==true && CodingMaster.status==true"),
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  returnMedicatioReason: function returnMedicatioReason(id) {
    return {
      db_name: dbName,
      entity: "DrugMaster",
      filter: "DrugMaster._id=='".concat(id, "' && DrugMaster.returnApplicable == true && DrugMaster.activestatus==true"),
      return_fields: "merge(keep(DrugMaster,'returnPeriodUOM','returnPeriodVal','returnApplicable'),{newReturnParams:(for nrp in DrugMaster.newReturnParams return merge(nrp,{returnReason:document(nrp.returnReason)}))},{returnPeriodUOM:document(DrugMaster.returnPeriodUOM)})"
    };
  },
  returnMedicatioReasonSingle: function returnMedicatioReasonSingle(id) {
    return {
      db_name: dbName,
      entity: "DrugMaster",
      filter: "DrugMaster._id=='".concat(id, "' && DrugMaster.returnApplicable == true && DrugMaster.activestatus==true"),
      return_fields: "merge(keep(DrugMaster,'returnPeriodUOM','returnPeriodVal','returnApplicable'),{newReturnParams:(for nrp in DrugMaster.newReturnParams return merge(nrp,{returnReason:document(nrp.returnReason)}))},{returnPeriodUOM:document(DrugMaster.returnPeriodUOM)})"
    };
  },
  returnMedicatioReasonMulti: function returnMedicatioReasonMulti(id) {
    return {
      db_name: dbName,
      queryid: "f1aed572-5074-4371-a99d-6e7398251702",
      filter: {
        drugID: _toConsumableArray(id)
      }
    };
  },
  reIssueMedicatioReason: function reIssueMedicatioReason() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='REISSUEREASON' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  dispense_history_read: function dispense_history_read(id) {
    return {
      db_name: dbName,
      entity: "PH_OrderLine",
      filter: "PH_OrderLine._id== '".concat(id, "' && PH_OrderLine.activestatus==true"),
      //${id} //PH_OrderLine/10583
      return_fields: "merge(PH_OrderLine,{diagnosis:document(PH_OrderLine.diagnosis)},{prescripionTypeName:document(PH_OrderLine.prescripionType).display},{drugType:document(PH_OrderLine.drugType)},{GenericDrug:(for dmtr in DrugMaster filter dmtr._id==PH_OrderLine.drugCode return document(dmtr.DrugGenericId))},{drug_category:document(PH_OrderLine.drug_category)},{formCode:document(PH_OrderLine.formCode)},{presNature:document(PH_OrderLine.presNature)},{presMode:document(PH_OrderLine.presMode)},{ordertype:document(PH_OrderLine.ordertype).display},{disptype:document(PH_OrderLine.disptype)},{encounter_Id:(for encounter_Id in document(to_array(PH_OrderLine.encounter_Id)) return merge(encounter_Id,{practitioner_details:(for practitioner_details in TO_ARRAY(encounter_Id.practitioner_details) return merge(practitioner_details,{speciality:(for code in document(to_array(practitioner_details.speciality)) return merge(code,{coding:document(code.coding)}) ) }) )},{patient_id:(for pat in Patient filter pat.id==encounter_Id.patient_id return merge(keep(pat,'_id','alias','name'),{name:(for nam in HumanNameMaster filter nam._id in pat.name return merge(keep(nam,'family','given','text','prefix','suffix','use'),{prefix:document(nam.prefix).display,suffix:document(nam.suffix).display,use:document(nam.use).display}))}) )}))}, {PH_OrderLineDispenseSchedule:(for sch in PH_OrderLineDispenseSchedule filter sch.ph_orderlineid==PH_OrderLine._id return merge(sch,{statushistory:(for shis in to_array(sch.statushistory) return merge(shis,{practitioner:(for prac in Practitioner filter prac._id==shis.practitioner return merge(prac,{telecom:document(prac.telecom),name:(for nam in HumanNameMaster filter nam._id==prac.name[0] return merge(nam,{suffix:document(document(nam.suffix).coding),prefix:document(document(nam.prefix).coding)}))}))},{practitionerRole:document(document(document(shis.practitionerRole).role).coding)},{status:document(shis.status)}) )}, {dispensedetails:(for dpd in PH_orderLinedispensedetails filter dpd._id in sch.dispensedetails return merge(dpd,{dispenseitemcode:document(dpd.dispenseitemcode)._id},{drugNameShort:document(dpd.dispenseitemcode).ShortDesc},{drugNameLong:document(dpd.dispenseitemcode).LongDesc},{drugName:document(dpd.dispenseitemcode).DrugCode},{dispuomtext:document(dpd.dispuom).UOM},{adminuomext:document(dpd.totadmuom).UOM},{billuomtext:document(dpd.totbilluom).UOM},{issueuomtext:document(dpd.totissueuom).UOM},{stockuomtext:document(dpd.totstkuom).UOM},{addrugcodename:document(dpd.addrugcode).DrugCode})) },{dispduruomText:document(sch.dispduruom).UOM}))}, {dosageDurationUOM:document(PH_OrderLine.dosageDurationUOM).UOM,drugName:(document(PH_OrderLine.drugCode).LongDesc),drugPhoto:document((document(PH_OrderLine.drugCode).photo)),drug_id:(PH_OrderLine.drugCode),dosageFreqCode:(document(PH_OrderLine.dosageFreqCode).freqcode),ivInfusionRatetext:DOCUMENT(PH_OrderLine.ivInfusionRateUOM).UOM,dosageFreqCode_id:PH_OrderLine.dosageFreqCode,dosageFreqCodetype:document(document(PH_OrderLine.dosageFreqCode).frequencytype).code,dosageUOM:document(PH_OrderLine.dosageUOM).UOM,dosageUOM_id:document(PH_OrderLine.dosageUOM)._id,routeCode:document(PH_OrderLine.routeCode).shortdesc,routeCode_id:(document(PH_OrderLine.routeCode)._id),status:(document(PH_OrderLine.status).display),status_id:PH_OrderLine.status },{requestor:(for req in PH_OrderLine.requestor return merge(req,{practId:(for prac in Practitioner filter prac._id==req.practId return merge(prac,{practitioner_role:(for pract in PractitionerRole filter pract._id in prac.practitioner_role return merge(keep(pract,'_id'),{OrgID:document(pract.OrgID).name},{SpecialtyID:document(document(pract.SpecialtyID).coding)[*].display}))},{telecom:(for tel in ContactPointMaster filter tel._id in prac.telecom return merge(tel,{system:document(tel.system)})),name:(for nam in HumanNameMaster filter nam._id==prac.name[0] return merge(nam,{suffix:document(document(nam.suffix).coding),prefix:document(document(nam.prefix).coding)}))}))})) },{dosageDurationUOM:(document(PH_OrderLine.dosageDurationUOM).UOM)},{dosageDurationUOM_id:(document(PH_OrderLine.dosageDurationUOM)._id)},{alloweddisptype:document(document(PH_OrderLine.drugCode).alloweddisptype)} )"
    };
  },
  cartNamePending: function cartNamePending() {
    return {
      db_name: dbName,
      entity: "PH_CartTransaction,PH_CartDefinition",
      filter: {
        PH_CartTransaction: "document(PH_CartTransaction.cartstatus).code=='PENDING' && PH_CartTransaction.activestatus==true",
        PH_CartDefinition: "PH_CartDefinition._id == PH_CartTransaction.cartid && PH_CartDefinition.activestatus==true"
      },
      return_fields: "merge(keep(PH_CartTransaction,'_id','_key','startdate','enddate','cartstatus','cartid'),{ward:document(PH_CartDefinition.ward)},{cartName:document(PH_CartTransaction.cartid).cartname},{cartstatusText:document(PH_CartTransaction.cartstatus).display})"
    };
  },
  cartName: function cartName() {
    return {
      db_name: dbName,
      entity: "PH_CartTransaction,PH_CartDefinition",
      filter: {
        PH_CartTransaction: "document(PH_CartTransaction.cartstatus).code=='OPEN' && PH_CartTransaction.activestatus==true",
        PH_CartDefinition: "PH_CartDefinition._id == PH_CartTransaction.cartid"
      },
      return_fields: "merge(keep(PH_CartTransaction,'_id','startdate','enddate','cartstatus','cartid'),{ward:document(PH_CartDefinition.ward)},{cartName:document(PH_CartTransaction.cartid).cartname},{cartstatusText:document(PH_CartTransaction.cartstatus).display})"
    };
  },
  cartUpdateStatus: function cartUpdateStatus(key, userId, data, status) {
    var _data$time, _data$remarks;

    return [{
      db_name: dbName,
      entity: "PH_CartTransaction",
      filter: {
        _key: key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        cartopentime: (_data$time = data === null || data === void 0 ? void 0 : data.time) !== null && _data$time !== void 0 ? _data$time : 0,
        cartopenuserid: userId !== null && userId !== void 0 ? userId : "",
        cartstatus: status !== null && status !== void 0 ? status : "",
        remarks: (_data$remarks = data === null || data === void 0 ? void 0 : data.remarks) !== null && _data$remarks !== void 0 ? _data$remarks : ""
      }
    }];
  },
  cartReadStatus: function cartReadStatus() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.code=='OPEN' && CodingMaster.Type=='CARTSTATUS' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  subStore: function subStore(id) {
    return {
      db_name: dbName,
      entity: "PH_CartDefinition",
      filter: "PH_CartDefinition._id=='".concat(id, "' && PH_CartDefinition.activestatus==true"),
      return_fields: "merge(keep(PH_CartDefinition,'_id','cartname','locationid'),{locationName:document(PH_CartDefinition.locationid).longdesc,locationDetails:document(PH_CartDefinition.locationid)})",
      sort: "document(PH_CartDefinition.locationid).longdesc"
    };
  },
  cartGenerate: function cartGenerate(cartid, carttrxid) {
    return {
      db_name: dbName,
      queryid: "bccf829f-f7b3-476c-893c-fd235c84da14",
      filter: {
        cartid: cartid,
        carttrxid: carttrxid
      }
    };
  },
  getTransaction: function getTransaction(cartid) {
    return {
      db_name: dbName,
      entity: "PH_CartTransaction",
      filter: "PH_CartTransaction.cartid=='".concat(cartid, "' && document(PH_CartTransaction.cartstatus).code=='OPEN' && PH_CartTransaction.activestatus==true"),
      return_fields: "merge(keep(PH_CartTransaction,'_id','startdate','enddate','cartstatus','cartid'),{cartName:document(PH_CartTransaction.cartid).cartname},{cartstatusText:document(PH_CartTransaction.cartstatus).display})",
      sort: "document(PH_CartTransaction.cartid).cartname"
    };
  },
  CartpatientQueue: function CartpatientQueue(cartID, locID, wardID, grpid) {
    return {
      db_name: dbName,
      queryid: "1fdc4cfd-4b2a-466e-85f6-6f0b24b65209",
      filter: {
        cartID: cartID,
        locID: locID,
        wardID: wardID // grpid: grpid,

      }
    };
  },
  cartReason: function cartReason() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.code=='OPEN' && CodingMaster.Type=='CARTSTATUS' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  orderCount: function orderCount(queueId, patientid, ScenarioId, StateId) {
    return {
      db_name: dbName,
      queryid: "901a95f2-8c1c-4eba-8171-ff29677d6bab",
      filter: {
        scenarioid: ScenarioId,
        queueId: queueId,
        patientid: patientid,
        stateid: StateId
      }
    };
  },
  queue: function queue(queueId) {
    return {
      db_name: dbName,
      entity: "queue",
      filter: "queue._id =='".concat(queueId, "' && queue.activestatus==true"),
      return_fields: "queue.groupdetails"
    };
  },
  queueCount: function queueCount(QueueID, practitionerData, priority_list) {
    return {
      db_name: dbName,
      queryid: "03a5eaed-e8e5-445f-b490-4c0bb4d0430b",
      filter: {
        queueid: QueueID,
        facility_id: practitionerData === null || practitionerData === void 0 ? void 0 : practitionerData.facilityid,
        locationid: practitionerData === null || practitionerData === void 0 ? void 0 : practitionerData.locationid,
        grpid: priority_list
      }
    };
  },
  queueLabel: function queueLabel(encounterid, patientid, dateformat, datetimeformat) {
    return {
      db_name: dbName,
      filter: {
        encounterid: encounterid,
        patientid: patientid,
        dateformat: dateformat,
        datetimeformat: datetimeformat
      },
      queryid: "40ee7de2-dccf-4399-ae1e-f2d40a74dcd9"
    };
  }
};

var query_ids$2 = "04ecb73d-f048-44ce-8563-c9be015812dd";
var generateJSONSingle = function generateJSONSingle(payload, logInfo) {
  var _payload$alertData, _payload$isfirststato, _ref, _logInfo$facilityid, _payload$addtictive$m, _payload$addtictive, _payload$patientid, _payload$encountertyp, _payload$encounterid, _ref2, _payload$prescripionT, _payload$prescription, _payload$Prescription, _payload$name$drugTyp, _payload$name, _payload$presNature$v, _payload$presNature, _payload$presMode$val, _payload$presMode, _payload$priority$val, _payload$priority, _payload$statusreason, _payload$intent, _payload$orderPrivile, _payload$privilegeAle, _payload$workFlowStat, _payload$drugCodeValu, _payload$formCode, _payload$routeCode$va, _payload$routeCode, _payload$dosageTypeIn, _payload$unitValue$va, _payload$unitValue, _payload$drug_categor, _payload$drug_categor2, _payload$dispensing_p, _payload$dispensing_p2, _payload$IVDosageDura, _payload$IVDosageDura2, _payload$unitsTypes$v, _payload$unitsTypes, _payload$ivInfusionRa, _payload$ivInfusionRa2, _payload$doseOption$v, _payload$doseOption, _payload$orderdescrip, _ref3, _payload$ivInfusionTi, _payload$ivInfusionTi2, _payload$occurStartDa, _payload$occurEndDate, _payload$totPresQtyUO, _payload$totPresQtyUO2, _payload$totDispQty, _payload$totDispQtyUO, _payload$totBilledQty, _payload$totBilledQty2, _payload$totReturnedQ, _payload$PRNYN, _payload$prnComment, _payload$direction, _payload$diagnosis, _payload$reasonCode, _payload$indication$v, _payload$indication, _payload$patientInstr, _payload$patientInstr2, _payload$patientInstr3, _payload$notes, _payload$parentPresId, _payload$presGroupRef, _payload$noofRefillsA, _payload$initialDispe, _payload$refillDispen, _payload$maxRefillDis, _payload$pendingRefil, _payload$prescription2, _payload$substitution, _payload$substitution2, _payload$substituteRe, _payload$broughtFromH, _payload$IVIngredient, _payload$statushistor, _payload$statusperiod, _payload$frequencyDet, _payload$frequencyDet2, _payload$unitsTypes$f, _ref4, _payload$frequencyDet3;

  var getAlertPayload = [];

  if ((payload === null || payload === void 0 ? void 0 : (_payload$alertData = payload.alertData) === null || _payload$alertData === void 0 ? void 0 : _payload$alertData.length) > 0) {
    getAlertPayload = generateAlertPayload(payload === null || payload === void 0 ? void 0 : payload.alertData, logInfo);
  }

  return [{
    db_name: dbName,
    entity: "PH_OrderLine",
    is_metadata: true,
    // ...filter,
    metadataId: query_ids$2,
    doc: {
      isfirststatorder: (_payload$isfirststato = payload === null || payload === void 0 ? void 0 : payload.isfirststatorder) !== null && _payload$isfirststato !== void 0 ? _payload$isfirststato : false,
      SlidingScaleDose: payload === null || payload === void 0 ? void 0 : payload.SlidingScaleDose,
      org_Id: (_ref = (_logInfo$facilityid = logInfo === null || logInfo === void 0 ? void 0 : logInfo.facilityid) !== null && _logInfo$facilityid !== void 0 ? _logInfo$facilityid : logInfo === null || logInfo === void 0 ? void 0 : logInfo.orgid) !== null && _ref !== void 0 ? _ref : "",
      addtictive: (_payload$addtictive$m = payload === null || payload === void 0 ? void 0 : (_payload$addtictive = payload.addtictive) === null || _payload$addtictive === void 0 ? void 0 : _payload$addtictive.map(function (item) {
        var _item$addoseuom, _item$addrugcode, _item$addrugcode$resu;

        return _objectSpread2(_objectSpread2({}, item), {}, {
          addoseuom: item === null || item === void 0 ? void 0 : (_item$addoseuom = item.addoseuom) === null || _item$addoseuom === void 0 ? void 0 : _item$addoseuom.value,
          addrugcode: item === null || item === void 0 ? void 0 : (_item$addrugcode = item.addrugcode) === null || _item$addrugcode === void 0 ? void 0 : (_item$addrugcode$resu = _item$addrugcode.result) === null || _item$addrugcode$resu === void 0 ? void 0 : _item$addrugcode$resu._id
        });
      })) !== null && _payload$addtictive$m !== void 0 ? _payload$addtictive$m : [],
      id: 0,
      orgEntityType: "",
      // org_Id: logInfo?.orgid ?? "Organization/10002",
      patient_Id: (_payload$patientid = payload.patientid) !== null && _payload$patientid !== void 0 ? _payload$patientid : "",
      encountertype: (_payload$encountertyp = payload.encountertype) !== null && _payload$encountertyp !== void 0 ? _payload$encountertyp : "",
      encounter_Id: (_payload$encounterid = payload.encounterid) !== null && _payload$encounterid !== void 0 ? _payload$encounterid : "",
      prescriptionType: (_ref2 = (_payload$prescripionT = payload.prescripionType) !== null && _payload$prescripionT !== void 0 ? _payload$prescripionT : payload.prescriptionType) !== null && _ref2 !== void 0 ? _ref2 : "",
      prescriptionId: (_payload$prescription = payload.prescriptionId) !== null && _payload$prescription !== void 0 ? _payload$prescription : "",
      PrescriptionDate: (_payload$Prescription = payload.PrescriptionDate) !== null && _payload$Prescription !== void 0 ? _payload$Prescription : 0,
      drugType: (_payload$name$drugTyp = payload === null || payload === void 0 ? void 0 : (_payload$name = payload.name) === null || _payload$name === void 0 ? void 0 : _payload$name.drugTypeId) !== null && _payload$name$drugTyp !== void 0 ? _payload$name$drugTyp : "",
      presNature: (_payload$presNature$v = (_payload$presNature = payload.presNature) === null || _payload$presNature === void 0 ? void 0 : _payload$presNature.value) !== null && _payload$presNature$v !== void 0 ? _payload$presNature$v : "",
      presMode: (_payload$presMode$val = (_payload$presMode = payload.presMode) === null || _payload$presMode === void 0 ? void 0 : _payload$presMode.value) !== null && _payload$presMode$val !== void 0 ? _payload$presMode$val : "",
      priority: (_payload$priority$val = (_payload$priority = payload.priority) === null || _payload$priority === void 0 ? void 0 : _payload$priority.value) !== null && _payload$priority$val !== void 0 ? _payload$priority$val : "",
      status: "CodingMaster/10703"    ,
      statusreason: (_payload$statusreason = payload.statusreason) !== null && _payload$statusreason !== void 0 ? _payload$statusreason : "",
      intent: (_payload$intent = payload.intent) !== null && _payload$intent !== void 0 ? _payload$intent : "",
      orderPrivilegeLevel: (_payload$orderPrivile = payload.orderPrivilegeLevel) !== null && _payload$orderPrivile !== void 0 ? _payload$orderPrivile : "",
      privilegeAlertMessageTxt: (_payload$privilegeAle = payload.privilegeAlertMessageTxt) !== null && _payload$privilegeAle !== void 0 ? _payload$privilegeAle : "",
      workFlowStatus: (_payload$workFlowStat = payload.workFlowStatus) !== null && _payload$workFlowStat !== void 0 ? _payload$workFlowStat : "",
      drugCode: (_payload$drugCodeValu = payload === null || payload === void 0 ? void 0 : payload.drugCodeValue) !== null && _payload$drugCodeValu !== void 0 ? _payload$drugCodeValu : "",
      formCode: (_payload$formCode = payload.formCode) !== null && _payload$formCode !== void 0 ? _payload$formCode : "",
      routeCode: (_payload$routeCode$va = (_payload$routeCode = payload.routeCode) === null || _payload$routeCode === void 0 ? void 0 : _payload$routeCode.value) !== null && _payload$routeCode$va !== void 0 ? _payload$routeCode$va : "",
      dosageTypeIndicator: (_payload$dosageTypeIn = payload.dosageTypeIndicator) !== null && _payload$dosageTypeIn !== void 0 ? _payload$dosageTypeIn : "",
      dosageValue: payload.doseMeasurementValue ? parseInt(payload.doseMeasurementValue) : 0,
      dosageUOM: (_payload$unitValue$va = (_payload$unitValue = payload.unitValue) === null || _payload$unitValue === void 0 ? void 0 : _payload$unitValue.value) !== null && _payload$unitValue$va !== void 0 ? _payload$unitValue$va : "",
      drug_category: (_payload$drug_categor = (_payload$drug_categor2 = payload.drug_category) === null || _payload$drug_categor2 === void 0 ? void 0 : _payload$drug_categor2.value) !== null && _payload$drug_categor !== void 0 ? _payload$drug_categor : "",
      dispensing_pharmacy: (_payload$dispensing_p = (_payload$dispensing_p2 = payload.dispensing_pharmacy) === null || _payload$dispensing_p2 === void 0 ? void 0 : _payload$dispensing_p2.value) !== null && _payload$dispensing_p !== void 0 ? _payload$dispensing_p : "",
      IVDosageDurationValue: payload.IVDosageDurationValue ? parseInt(payload.IVDosageDurationValue) : 0,
      IVDosageDurationUOM: (_payload$IVDosageDura = (_payload$IVDosageDura2 = payload.IVDosageDurationUOM) === null || _payload$IVDosageDura2 === void 0 ? void 0 : _payload$IVDosageDura2.value) !== null && _payload$IVDosageDura !== void 0 ? _payload$IVDosageDura : "",
      dosageFreqCode: (_payload$unitsTypes$v = (_payload$unitsTypes = payload.unitsTypes) === null || _payload$unitsTypes === void 0 ? void 0 : _payload$unitsTypes.value) !== null && _payload$unitsTypes$v !== void 0 ? _payload$unitsTypes$v : "",
      ivInfusionRateValue: payload.ivInfusionRateValue ? parseInt(payload.ivInfusionRateValue) : 0,
      ivInfusionRateUOM: (_payload$ivInfusionRa = (_payload$ivInfusionRa2 = payload.ivInfusionRateUOM) === null || _payload$ivInfusionRa2 === void 0 ? void 0 : _payload$ivInfusionRa2.value) !== null && _payload$ivInfusionRa !== void 0 ? _payload$ivInfusionRa : "",
      dosageDurationValue: payload.dosetime ? parseInt(payload.dosetime) : 0,
      dosageDurationUOM: (_payload$doseOption$v = (_payload$doseOption = payload.doseOption) === null || _payload$doseOption === void 0 ? void 0 : _payload$doseOption.value) !== null && _payload$doseOption$v !== void 0 ? _payload$doseOption$v : "",
      orderdescription: (_payload$orderdescrip = payload === null || payload === void 0 ? void 0 : payload.orderdescriptionName) !== null && _payload$orderdescrip !== void 0 ? _payload$orderdescrip : "",
      ivInfusionTime: payload !== null && payload !== void 0 && payload.ivInfusionTime ? JSON.parse(payload === null || payload === void 0 ? void 0 : payload.ivInfusionTime) : 0,
      ivInfusionTimeUom: (_ref3 = (_payload$ivInfusionTi = payload === null || payload === void 0 ? void 0 : (_payload$ivInfusionTi2 = payload.ivInfusionTimeUom) === null || _payload$ivInfusionTi2 === void 0 ? void 0 : _payload$ivInfusionTi2.value) !== null && _payload$ivInfusionTi !== void 0 ? _payload$ivInfusionTi : payload === null || payload === void 0 ? void 0 : payload.ivInfusionTimeUom) !== null && _ref3 !== void 0 ? _ref3 : "",
      // "UseAsFreqDose": payload.UseAsFreqDose ? getUseAsFreqDose(payload.UseAsFreqDose, payload.unitsTypes) : [],
      // "useAsTaperedDose": payload.useAsTaperedDose ? getuseAsTaperedDose(payload.useAsTaperedDose) : [],
      useAsSlidingScaleDose: payload.useAsSlidingScaleDose ? getuseAsSlidingScaleDose$1(payload.useAsSlidingScaleDose) : [],
      occurStartDateTime: (_payload$occurStartDa = payload.occurStartDateTime) !== null && _payload$occurStartDa !== void 0 ? _payload$occurStartDa : 0,
      occurEndDateTime: (_payload$occurEndDate = payload.occurEndDateTime) !== null && _payload$occurEndDate !== void 0 ? _payload$occurEndDate : 0,
      totPresQty: payload.totPresQty ? parseInt(payload.totPresQty) : 0,
      totPresQtyUOM: (_payload$totPresQtyUO = (_payload$totPresQtyUO2 = payload.totPresQtyUOM) === null || _payload$totPresQtyUO2 === void 0 ? void 0 : _payload$totPresQtyUO2.value) !== null && _payload$totPresQtyUO !== void 0 ? _payload$totPresQtyUO : "",
      totDispQty: (_payload$totDispQty = payload.totDispQty) !== null && _payload$totDispQty !== void 0 ? _payload$totDispQty : 0,
      totDispQtyUOM: (_payload$totDispQtyUO = payload.totDispQtyUOM) !== null && _payload$totDispQtyUO !== void 0 ? _payload$totDispQtyUO : "",
      totBilledQty: (_payload$totBilledQty = payload.totBilledQty) !== null && _payload$totBilledQty !== void 0 ? _payload$totBilledQty : 0,
      totBilledQtyUOM: (_payload$totBilledQty2 = payload.totBilledQtyUOM) !== null && _payload$totBilledQty2 !== void 0 ? _payload$totBilledQty2 : "",
      totReturnedQty: (_payload$totReturnedQ = payload.totReturnedQty) !== null && _payload$totReturnedQ !== void 0 ? _payload$totReturnedQ : 0,
      PRNYN: (_payload$PRNYN = payload.PRNYN) !== null && _payload$PRNYN !== void 0 ? _payload$PRNYN : false,
      prnComment: (_payload$prnComment = payload.prnComment) !== null && _payload$prnComment !== void 0 ? _payload$prnComment : "",
      direction: (_payload$direction = payload.direction) !== null && _payload$direction !== void 0 ? _payload$direction : "",
      diagnosis: (_payload$diagnosis = payload.diagnosis) !== null && _payload$diagnosis !== void 0 ? _payload$diagnosis : [],
      reasonCode: (_payload$reasonCode = payload.reasonCode) !== null && _payload$reasonCode !== void 0 ? _payload$reasonCode : "",
      indication: (_payload$indication$v = (_payload$indication = payload.indication) === null || _payload$indication === void 0 ? void 0 : _payload$indication.value) !== null && _payload$indication$v !== void 0 ? _payload$indication$v : "",
      patientInstruction: (_payload$patientInstr = (_payload$patientInstr2 = payload.patientInstruction) === null || _payload$patientInstr2 === void 0 ? void 0 : _payload$patientInstr2.value) !== null && _payload$patientInstr !== void 0 ? _payload$patientInstr : "",
      patientInstructiondesc: (_payload$patientInstr3 = payload.patientInstructiondesc) !== null && _payload$patientInstr3 !== void 0 ? _payload$patientInstr3 : "",
      notes: (_payload$notes = payload.notes) !== null && _payload$notes !== void 0 ? _payload$notes : "",
      parentPresId: (_payload$parentPresId = payload.parentPresId) !== null && _payload$parentPresId !== void 0 ? _payload$parentPresId : "",
      presGroupRefId: (_payload$presGroupRef = payload.presGroupRefId) !== null && _payload$presGroupRef !== void 0 ? _payload$presGroupRef : "",
      requestor: payload !== null && payload !== void 0 && payload.requestor ? getrequestor$1(payload === null || payload === void 0 ? void 0 : payload.requestor) : [],
      performer: payload !== null && payload !== void 0 && payload.performer ? getPerformer$1(payload === null || payload === void 0 ? void 0 : payload.performer) : [],
      noofRefillsAllowed: (_payload$noofRefillsA = payload.noofRefillsAllowed) !== null && _payload$noofRefillsA !== void 0 ? _payload$noofRefillsA : 0,
      initialDispenseDurn: (_payload$initialDispe = payload.initialDispenseDurn) !== null && _payload$initialDispe !== void 0 ? _payload$initialDispe : 0,
      refillDispenseIntervalDays: (_payload$refillDispen = payload.refillDispenseIntervalDays) !== null && _payload$refillDispen !== void 0 ? _payload$refillDispen : 0,
      maxRefillDispenseDurn: (_payload$maxRefillDis = payload.maxRefillDispenseDurn) !== null && _payload$maxRefillDis !== void 0 ? _payload$maxRefillDis : 0,
      pendingRefillCount: (_payload$pendingRefil = payload.pendingRefillCount) !== null && _payload$pendingRefil !== void 0 ? _payload$pendingRefil : "",
      prescriptionValidityPeriodDays: (_payload$prescription2 = payload.prescriptionValidityPeriodDays) !== null && _payload$prescription2 !== void 0 ? _payload$prescription2 : 0,
      substitutionAllowed: (_payload$substitution = payload.substitutionAllowed) !== null && _payload$substitution !== void 0 ? _payload$substitution : false,
      substitutionAllowedTypes: (_payload$substitution2 = payload.substitutionAllowedTypes) !== null && _payload$substitution2 !== void 0 ? _payload$substitution2 : "",
      substituteReasonCode: (_payload$substituteRe = payload.substituteReasonCode) !== null && _payload$substituteRe !== void 0 ? _payload$substituteRe : "",
      broughtFromHome: (_payload$broughtFromH = payload.broughtFromHome) !== null && _payload$broughtFromH !== void 0 ? _payload$broughtFromH : false,
      IVIngredientDescription: (_payload$IVIngredient = payload.IVIngredientDescription) !== null && _payload$IVIngredient !== void 0 ? _payload$IVIngredient : "",
      // "createdby": payload.createdby ?? "",
      // "updatedby": payload.updatedby ?? "",
      statushistory: (_payload$statushistor = payload.statushistory) !== null && _payload$statushistor !== void 0 ? _payload$statushistor : [],
      statusperiod: (_payload$statusperiod = payload.statusperiod) !== null && _payload$statusperiod !== void 0 ? _payload$statusperiod : 0,
      components: payload.additiveDetails ? getComponent$1(payload.additiveDetails) : [],
      FreqDetls: (payload === null || payload === void 0 ? void 0 : (_payload$frequencyDet = payload.frequencyDetails) === null || _payload$frequencyDet === void 0 ? void 0 : (_payload$frequencyDet2 = _payload$frequencyDet.frequency) === null || _payload$frequencyDet2 === void 0 ? void 0 : _payload$frequencyDet2.length) > 0 || ((_payload$unitsTypes$f = payload.unitsTypes.frequency) === null || _payload$unitsTypes$f === void 0 ? void 0 : _payload$unitsTypes$f.length) > 0 ? (_ref4 = (payload === null || payload === void 0 ? void 0 : (_payload$frequencyDet3 = payload.frequencyDetails) === null || _payload$frequencyDet3 === void 0 ? void 0 : _payload$frequencyDet3.frequency) || payload.unitsTypes.frequency) === null || _ref4 === void 0 ? void 0 : _ref4.map(function (v) {
        var _v$basefreq, _v$basefreq2, _v$day, _v$day2, _v$day3, _v$day4, _v$adminDosageInstruc;

        return {
          remarks: (v === null || v === void 0 ? void 0 : v.remarks) || "",
          dose: (v === null || v === void 0 ? void 0 : v.dose) || "",
          time: (v === null || v === void 0 ? void 0 : v.time) || "",
          baseFreq: v !== null && v !== void 0 && (_v$basefreq = v.basefreq) !== null && _v$basefreq !== void 0 && _v$basefreq.freqcode ? v === null || v === void 0 ? void 0 : (_v$basefreq2 = v.basefreq) === null || _v$basefreq2 === void 0 ? void 0 : _v$basefreq2.freqcode : "",
          // baseFreq: v?.baseFreq?._id || v?.basefreq?.code || "",
          weekDay: (v === null || v === void 0 ? void 0 : v.weekDay) || (v === null || v === void 0 ? void 0 : v.weekday) || "",
          day: v !== null && v !== void 0 && (_v$day = v.day) !== null && _v$day !== void 0 && _v$day.code ? typeof (v === null || v === void 0 ? void 0 : (_v$day2 = v.day) === null || _v$day2 === void 0 ? void 0 : _v$day2.code) === "string" ? JSON.parse(v === null || v === void 0 ? void 0 : (_v$day3 = v.day) === null || _v$day3 === void 0 ? void 0 : _v$day3.code) : v === null || v === void 0 ? void 0 : (_v$day4 = v.day) === null || _v$day4 === void 0 ? void 0 : _v$day4.code : 0,
          fromDay: v !== null && v !== void 0 && v.fromDay ? typeof (v === null || v === void 0 ? void 0 : v.fromDay) === "string" ? JSON.parse(v === null || v === void 0 ? void 0 : v.fromDay) : v === null || v === void 0 ? void 0 : v.fromDay : 0,
          toDay: v !== null && v !== void 0 && v.toDay ? typeof (v === null || v === void 0 ? void 0 : v.toDay) === "string" ? JSON.parse(v === null || v === void 0 ? void 0 : v.toDay) : v === null || v === void 0 ? void 0 : v.toDay : 0,
          fromDate: v !== null && v !== void 0 && v.fromDate ? typeof (v === null || v === void 0 ? void 0 : v.fromDate) === "string" ? JSON.parse(v === null || v === void 0 ? void 0 : v.fromDate) : v === null || v === void 0 ? void 0 : v.fromDate : 0,
          toDate: v !== null && v !== void 0 && v.toDate ? typeof (v === null || v === void 0 ? void 0 : v.toDate) === "string" ? JSON.parse(v === null || v === void 0 ? void 0 : v.toDate) : v === null || v === void 0 ? void 0 : v.toDate : 0,
          adminDosageInstruction: (_v$adminDosageInstruc = v === null || v === void 0 ? void 0 : v.adminDosageInstruction) !== null && _v$adminDosageInstruc !== void 0 ? _v$adminDosageInstruc : ""
        };
      }) : [],
      nextrefilldate: 0
    }
  }].concat(_toConsumableArray(getAlertPayload));
}; //to generate Alert payload

var generateAlertPayload = function generateAlertPayload(data, userInfo) {
  var _OverAllAlerts;

  var AlertTypes = [];
  data.forEach(function (val) {
    AlertTypes = [].concat(_toConsumableArray(AlertTypes), _toConsumableArray(Object.keys(val)));
  });
  var OverAllAlerts = [];
  data.forEach(function (val, i) {
    OverAllAlerts = [].concat(_toConsumableArray(OverAllAlerts), _toConsumableArray(val[AlertTypes[i]]));
  });
  return (_OverAllAlerts = OverAllAlerts) === null || _OverAllAlerts === void 0 ? void 0 : _OverAllAlerts.map(function (val, i) {
    var _val$orderLineId, _ref5, _val$Message, _ref6, _val$IAMTEXTN;

    var filter = {};

    if (val._key) {
      filter = {
        filter: {
          _key: val === null || val === void 0 ? void 0 : val._key
        }
      };
    }

    return _objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "PH_OrderLineAlertLogs",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, filter), {}, {
      doc: {
        orderlineid: (_val$orderLineId = val === null || val === void 0 ? void 0 : val.orderLineId) !== null && _val$orderLineId !== void 0 ? _val$orderLineId : "",
        seqno: i,
        reactiontypecode: val === null || val === void 0 ? void 0 : val.alertType,
        alerttitle: (_ref5 = (_val$Message = val === null || val === void 0 ? void 0 : val.Message) !== null && _val$Message !== void 0 ? _val$Message : val === null || val === void 0 ? void 0 : val.alerttitle) !== null && _ref5 !== void 0 ? _ref5 : "",
        alertmessage: (_ref6 = (_val$IAMTEXTN = val === null || val === void 0 ? void 0 : val.IAMTEXTN) !== null && _val$IAMTEXTN !== void 0 ? _val$IAMTEXTN : val === null || val === void 0 ? void 0 : val.alertmessage) !== null && _ref6 !== void 0 ? _ref6 : "",
        overridedetails: val._key ? [].concat(_toConsumableArray(val.overridedetails), [{
          overridereasoncode: "",
          overridenotes: "",
          overridebyid: userInfo === null || userInfo === void 0 ? void 0 : userInfo.practitionerid,
          overrideroleid: userInfo === null || userInfo === void 0 ? void 0 : userInfo.roleid
        }]) : [{
          overridereasoncode: "",
          overridenotes: "",
          overridebyid: userInfo === null || userInfo === void 0 ? void 0 : userInfo.practitionerid,
          overrideroleid: userInfo === null || userInfo === void 0 ? void 0 : userInfo.roleid
        }]
      }
    });
  });
};

var getuseAsSlidingScaleDose$1 = function getuseAsSlidingScaleDose(list) {
  var arr = [];
  list.map(function (val) {
    var _val$ssGrpId, _val$dispSeqNo, _val$adminFrDay2, _val$adminToDay2, _val$adminPrdUOM, _val$adminDosageQty, _val$adminDosageQtyUO, _val$adminDosageInstr;

    arr.push({
      ssGrpId: (_val$ssGrpId = val.ssGrpId) !== null && _val$ssGrpId !== void 0 ? _val$ssGrpId : 0,
      dispSeqNo: (_val$dispSeqNo = val.dispSeqNo) !== null && _val$dispSeqNo !== void 0 ? _val$dispSeqNo : 0,
      adminFrDay: (_val$adminFrDay2 = val.adminFrDay) !== null && _val$adminFrDay2 !== void 0 ? _val$adminFrDay2 : 0,
      adminToDay: (_val$adminToDay2 = val.adminToDay) !== null && _val$adminToDay2 !== void 0 ? _val$adminToDay2 : 0,
      adminPrdUOM: (_val$adminPrdUOM = val.adminPrdUOM) !== null && _val$adminPrdUOM !== void 0 ? _val$adminPrdUOM : "",
      adminDosageQty: (_val$adminDosageQty = val.adminDosageQty) !== null && _val$adminDosageQty !== void 0 ? _val$adminDosageQty : 0,
      adminDosageQtyUOM: (_val$adminDosageQtyUO = val.adminDosageQtyUOM) !== null && _val$adminDosageQtyUO !== void 0 ? _val$adminDosageQtyUO : "",
      adminDosageInstruction: (_val$adminDosageInstr = val.adminDosageInstruction) !== null && _val$adminDosageInstr !== void 0 ? _val$adminDosageInstr : ""
    });
  });
  return arr;
};

var getPerformer$1 = function getPerformer(list) {
  var arr = [];
  arr = list.map(function (val) {
    var _val$organization, _val$actionType, _val$practType, _val$practRole, _val$practId, _val$locationRoleType, _val$locationCode, _val$storeCode;

    arr.push({
      organization: (_val$organization = val.organization) !== null && _val$organization !== void 0 ? _val$organization : "",
      actionType: (_val$actionType = val.actionType) !== null && _val$actionType !== void 0 ? _val$actionType : "",
      practType: (_val$practType = val.practType) !== null && _val$practType !== void 0 ? _val$practType : "",
      practRole: (_val$practRole = val.practRole) !== null && _val$practRole !== void 0 ? _val$practRole : "",
      practId: (_val$practId = val.practId) !== null && _val$practId !== void 0 ? _val$practId : "",
      locationRoleType: (_val$locationRoleType = val.locationRoleType) !== null && _val$locationRoleType !== void 0 ? _val$locationRoleType : "",
      locationCode: (_val$locationCode = val.locationCode) !== null && _val$locationCode !== void 0 ? _val$locationCode : "",
      storeCode: (_val$storeCode = val.storeCode) !== null && _val$storeCode !== void 0 ? _val$storeCode : ""
    });
  });
  return arr;
};

var getrequestor$1 = function getrequestor(list) {
  var _list$organization$va, _list$organization, _list$practitionerRol, _list$practitionerRol2, _list$orderBy$value, _list$orderBy;

  var arr = []; // list.map(val => {

  arr.push({
    organization: (_list$organization$va = (_list$organization = list.organization) === null || _list$organization === void 0 ? void 0 : _list$organization.value) !== null && _list$organization$va !== void 0 ? _list$organization$va : "",
    practRole: (_list$practitionerRol = (_list$practitionerRol2 = list.practitionerRole) === null || _list$practitionerRol2 === void 0 ? void 0 : _list$practitionerRol2._id) !== null && _list$practitionerRol !== void 0 ? _list$practitionerRol : "",
    practId: (_list$orderBy$value = (_list$orderBy = list.orderBy) === null || _list$orderBy === void 0 ? void 0 : _list$orderBy.value) !== null && _list$orderBy$value !== void 0 ? _list$orderBy$value : ""
  }); // })

  return arr;
};

var getComponent$1 = function getComponent(list) {
  var arr = [];
  list.map(function (val, i) {
    var _val$description$valu, _val$description, _val$dosage$dosageFor, _val$dosage, _val$dosage$quantity, _val$dosage2, _val$dosage$unit$valu, _val$dosage3, _val$dosage3$unit;

    arr.push({
      seqno: i + 1,
      drugcode: (_val$description$valu = (_val$description = val.description) === null || _val$description === void 0 ? void 0 : _val$description.value) !== null && _val$description$valu !== void 0 ? _val$description$valu : "",
      formcode: (_val$dosage$dosageFor = (_val$dosage = val.dosage) === null || _val$dosage === void 0 ? void 0 : _val$dosage.dosageForm) !== null && _val$dosage$dosageFor !== void 0 ? _val$dosage$dosageFor : "",
      dosageQty: (_val$dosage$quantity = (_val$dosage2 = val.dosage) === null || _val$dosage2 === void 0 ? void 0 : _val$dosage2.quantity) !== null && _val$dosage$quantity !== void 0 ? _val$dosage$quantity : 0,
      dosageQtyUOM: (_val$dosage$unit$valu = (_val$dosage3 = val.dosage) === null || _val$dosage3 === void 0 ? void 0 : (_val$dosage3$unit = _val$dosage3.unit) === null || _val$dosage3$unit === void 0 ? void 0 : _val$dosage3$unit.value) !== null && _val$dosage$unit$valu !== void 0 ? _val$dosage$unit$valu : ""
    });
  });
  return arr;
};

var _extraReducers$K;
//reading PATIENT_BANNER

var PATIENT_BANNER = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/patient_banner", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      id,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          id = payload.id;
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.PharmacyFramework_Patientbanner(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 10]]);
}))); //reading ENCOUNTER_BANNER

var ENCOUNTER_BANNER = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/encounter_banner", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      getState,
      _state$signInReducerA,
      _state$signInReducerA2,
      id,
      state,
      loggedUserInfo,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue, getState = _ref4.getState;
          _context2.prev = 2;
          id = payload.id;
          state = getState();
          loggedUserInfo = state === null || state === void 0 ? void 0 : (_state$signInReducerA = state.signInReducerApiSlice) === null || _state$signInReducerA === void 0 ? void 0 : (_state$signInReducerA2 = _state$signInReducerA.loggedUserInfo) === null || _state$signInReducerA2 === void 0 ? void 0 : _state$signInReducerA2.data;
          _context2.next = 8;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.PharmacyFramework_Encounterbanner(id, loggedUserInfo))
          }, __readDocumentUrl__);

        case 8:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 12]]);
}))); //reading FINANCIAL_BANNER

var FINANCIAL_BANNER = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/financial_banner", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      id,
      data,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue, _ref6.getState;
          _context3.prev = 2;
          id = payload.id;
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.PharmacyFramework_Financialbanner(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 10]]);
}))); //reading PATIENT_BANNER

var VITALS_AGAINST_ENCOUNTER = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/vitals_against_encounter", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      id,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          id = payload.id;
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.PharmacyFramework_VitalsAgainstEncounter(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 10]]);
}))); //reading ALLERGY_AGAINST_PATIENT

var ALLERGY_AGAINST_PATIENT = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/allergy_against_patient", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      id,
      data,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          id = payload.id;
          _context5.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.PharmacyFramework_AllergyAgainstPatient(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context5.prev = 10;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 13:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 10]]);
}))); //reading DIAGNOSIS_AGAINST_PATIENT

var DIAGNOSIS_AGAINST_PATIENT = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/diagnosis_against_patient", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref12,
      rejectWithValue,
      id,
      data,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          id = payload.id;
          _context6.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.PharmacyFramework_DiagnosisAgainstPatient(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context6.sent;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context6.prev = 10;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 13:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 10]]);
}))); //reading CHIEF_COMPLAINT_AGAINST PATIENT

var CHIEFCOMPLAINT_AGAINST_PATIENT = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/chielfcomplaint_against_patient", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      id,
      data,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          id = payload.id;
          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.PharmacyFramework_ChiefComplaintsAgainstPatient(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context7.prev = 10;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 13:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 10]]);
})));
var MEDIACATION_LIST = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/medication_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref16,
      rejectWithValue,
      getState,
      _state$signInReducerA3,
      _state$signInReducerA4,
      id,
      encounter_Id,
      state,
      loggedUserInfo,
      data,
      color,
      filter,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref16 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref16.rejectWithValue, getState = _ref16.getState;
          _context8.prev = 2;
          id = payload.id, encounter_Id = payload.encounter_Id;
          state = getState();
          loggedUserInfo = state === null || state === void 0 ? void 0 : (_state$signInReducerA3 = state.signInReducerApiSlice) === null || _state$signInReducerA3 === void 0 ? void 0 : (_state$signInReducerA4 = _state$signInReducerA3.loggedUserInfo) === null || _state$signInReducerA4 === void 0 ? void 0 : _state$signInReducerA4.data;
          _context8.next = 8;
          return fetchData({
            body: JSON.stringify({
              queryinputs: {
                activestatus: true,
                patient_Id: id,
                encounter_Id: encounter_Id,
                facility_id: loggedUserInfo === null || loggedUserInfo === void 0 ? void 0 : loggedUserInfo.facilityid,
                location_id: loggedUserInfo === null || loggedUserInfo === void 0 ? void 0 : loggedUserInfo.locationid
              }
            })
          }, __Getreportlist__);

        case 8:
          data = _context8.sent;
          color = ["#7496F4", "#F47474", "#7496F4", "#7496F4", "#F47474", "#7496F4", "#F47474", "#7496F4", "#7496F4", "#F47474"];
          filter = data === null || data === void 0 ? void 0 : data.map(function (v) {
            return v.Reports.map(function (c, i) {
              return {
                reportid: c === null || c === void 0 ? void 0 : c.reportid,
                name: c === null || c === void 0 ? void 0 : c.reportname,
                number: c === null || c === void 0 ? void 0 : c.count,
                color: color[i],
                isfilter: c === null || c === void 0 ? void 0 : c.isfilter
              };
            });
          })[0];
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: {
              data: filter,
              fullData: data
            }
          }));

        case 14:
          _context8.prev = 14;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 17:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 14]]);
}))); //reading ACTIVE_MEDICATION_AGAINST PATIENT

var ACTIVEMEDIACATION_AGAINST_PATIENT = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/active_medication_against_patient", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref18,
      rejectWithValue,
      getState,
      _state$signInReducerA5,
      _state$signInReducerA6,
      _data$result,
      id,
      encounter_Id,
      _payload$reportid,
      reportid,
      facility_id,
      location_id,
      state,
      loggedUserInfo,
      data,
      arr,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref18 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref18.rejectWithValue, getState = _ref18.getState;
          _context9.prev = 2;
          id = payload.id, encounter_Id = payload.encounter_Id, payload.reportGrpCode, _payload$reportid = payload.reportid, reportid = _payload$reportid === void 0 ? "" : _payload$reportid, facility_id = payload.facility_id, location_id = payload.location_id;
          state = getState();
          loggedUserInfo = state === null || state === void 0 ? void 0 : (_state$signInReducerA5 = state.signInReducerApiSlice) === null || _state$signInReducerA5 === void 0 ? void 0 : (_state$signInReducerA6 = _state$signInReducerA5.loggedUserInfo) === null || _state$signInReducerA6 === void 0 ? void 0 : _state$signInReducerA6.data;
          _context9.next = 8;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.activeMedicatinAgainstPatient({
              patient_Id: id,
              encounter_Id: encounter_Id,
              activestatus: true,
              reportGrpCode: "",
              // reportGrpCode: reportGrpCode,
              reportid: reportid,
              facility_id: facility_id ? facility_id : loggedUserInfo === null || loggedUserInfo === void 0 ? void 0 : loggedUserInfo.facilityid,
              location_id: location_id ? location_id : loggedUserInfo === null || loggedUserInfo === void 0 ? void 0 : loggedUserInfo.locationid
            }))
          }, __ReportQueryExecution__);

        case 8:
          data = _context9.sent;
          arr = []; // const filter_ = data.Reports?.map((p) => {

          (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.map(function (v) {
            var _v$orderdescription, _v$dosageValue, _v$dosageUOM$UOM, _v$dosageUOM, _v$dosageFreqCode$fre, _v$dosageFreqCode, _v$routeCode$routecod, _v$routeCode, _v$FreqDetls$0$day, _v$FreqDetls, _v$FreqDetls$, _v$createddate, _v$dosageDurationUOM, _v$requestor, _v$requestor$, _v$requestor$$practId, _v$requestor$$practId2, _v$dosageFreqCode2, _v$dosageFreqCode2$fr;

            return arr.push({
              drugName: (_v$orderdescription = v === null || v === void 0 ? void 0 : v.orderdescription) !== null && _v$orderdescription !== void 0 ? _v$orderdescription : "",
              dosageValue: (_v$dosageValue = v === null || v === void 0 ? void 0 : v.dosageValue) !== null && _v$dosageValue !== void 0 ? _v$dosageValue : "",
              dosageUOM: (_v$dosageUOM$UOM = v === null || v === void 0 ? void 0 : (_v$dosageUOM = v.dosageUOM) === null || _v$dosageUOM === void 0 ? void 0 : _v$dosageUOM.UOM) !== null && _v$dosageUOM$UOM !== void 0 ? _v$dosageUOM$UOM : "",
              dosageFreqCode: (_v$dosageFreqCode$fre = v === null || v === void 0 ? void 0 : (_v$dosageFreqCode = v.dosageFreqCode) === null || _v$dosageFreqCode === void 0 ? void 0 : _v$dosageFreqCode.freqcode) !== null && _v$dosageFreqCode$fre !== void 0 ? _v$dosageFreqCode$fre : "",
              routeCode: (_v$routeCode$routecod = v === null || v === void 0 ? void 0 : (_v$routeCode = v.routeCode) === null || _v$routeCode === void 0 ? void 0 : _v$routeCode.routecode) !== null && _v$routeCode$routecod !== void 0 ? _v$routeCode$routecod : "",
              day: (_v$FreqDetls$0$day = v === null || v === void 0 ? void 0 : (_v$FreqDetls = v.FreqDetls) === null || _v$FreqDetls === void 0 ? void 0 : (_v$FreqDetls$ = _v$FreqDetls[0]) === null || _v$FreqDetls$ === void 0 ? void 0 : _v$FreqDetls$.day) !== null && _v$FreqDetls$0$day !== void 0 ? _v$FreqDetls$0$day : "",
              createddate: (_v$createddate = v === null || v === void 0 ? void 0 : v.createddate) !== null && _v$createddate !== void 0 ? _v$createddate : "",
              duration: "".concat(v === null || v === void 0 ? void 0 : v.dosageDurationValue, " ").concat(v === null || v === void 0 ? void 0 : (_v$dosageDurationUOM = v.dosageDurationUOM) === null || _v$dosageDurationUOM === void 0 ? void 0 : _v$dosageDurationUOM.UOM),
              doctorName: makeName(v === null || v === void 0 ? void 0 : (_v$requestor = v.requestor) === null || _v$requestor === void 0 ? void 0 : (_v$requestor$ = _v$requestor[0]) === null || _v$requestor$ === void 0 ? void 0 : (_v$requestor$$practId = _v$requestor$.practId) === null || _v$requestor$$practId === void 0 ? void 0 : (_v$requestor$$practId2 = _v$requestor$$practId.name) === null || _v$requestor$$practId2 === void 0 ? void 0 : _v$requestor$$practId2[0]),
              startdate: v === null || v === void 0 ? void 0 : v.occurStartDateTime,
              enddate: v === null || v === void 0 ? void 0 : v.occurEndDateTime,
              FreqDetls: v === null || v === void 0 ? void 0 : v.FreqDetls,
              _id: v === null || v === void 0 ? void 0 : v._id,
              dosageFreqTypeCode: v === null || v === void 0 ? void 0 : (_v$dosageFreqCode2 = v.dosageFreqCode) === null || _v$dosageFreqCode2 === void 0 ? void 0 : (_v$dosageFreqCode2$fr = _v$dosageFreqCode2.frequencytype) === null || _v$dosageFreqCode2$fr === void 0 ? void 0 : _v$dosageFreqCode2$fr.code
            });
          }); // });

          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            // data: data.Reports,
            data: arr,
            reportColumns: data === null || data === void 0 ? void 0 : data.reportfilter,
            reportRows: data === null || data === void 0 ? void 0 : data.result
          }));

        case 14:
          _context9.prev = 14;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 17:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 14]]);
}))); //reading PATIENT_SEARCH_NOT_IN_QUEUE

var PATIENT_SEARCH_NOT_IN_QUEUE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/patient_search_not_in_queue", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref20,
      rejectWithValue,
      getState,
      _state$signInReducerA7,
      _state$signInReducerA8,
      search,
      ExistingPatient,
      state,
      loggedUserInfo,
      data,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref20 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref20.rejectWithValue, getState = _ref20.getState;
          _context10.prev = 2;
          search = payload.search, ExistingPatient = payload.ExistingPatient;
          state = getState();
          loggedUserInfo = state === null || state === void 0 ? void 0 : (_state$signInReducerA7 = state.signInReducerApiSlice) === null || _state$signInReducerA7 === void 0 ? void 0 : (_state$signInReducerA8 = _state$signInReducerA7.loggedUserInfo) === null || _state$signInReducerA8 === void 0 ? void 0 : _state$signInReducerA8.data;

          if (search.length <= 0) {
            _readOnlyError("search");
          }

          _context10.next = 9;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.searchPatientQueue(search, ExistingPatient, loggedUserInfo))
          }, __readDocumentUrl__);

        case 9:
          data = _context10.sent;
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 16:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 13]]);
})));
var PATIENT_QUEUE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/patient_queue", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var payload,
      _ref22,
      rejectWithValue,
      getState,
      _state$signInReducerA9,
      _state$signInReducerA10,
      id,
      search,
      priorityID,
      state,
      loggedUserInfo,
      data,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
          _ref22 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref22.rejectWithValue, getState = _ref22.getState;
          _context11.prev = 2;
          id = payload.id, search = payload.search, priorityID = payload.priorityID;
          state = getState();
          loggedUserInfo = state === null || state === void 0 ? void 0 : (_state$signInReducerA9 = state.signInReducerApiSlice) === null || _state$signInReducerA9 === void 0 ? void 0 : (_state$signInReducerA10 = _state$signInReducerA9.loggedUserInfo) === null || _state$signInReducerA10 === void 0 ? void 0 : _state$signInReducerA10.data;
          _context11.next = 8;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.patientQueue(id, search, loggedUserInfo, priorityID))
          }, __baseUrl__);

        case 8:
          data = _context11.sent;
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 12:
          _context11.prev = 12;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 15:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 12]]);
})));
var PATIENT_QUEUE_STATUS_LIST = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/patient_queue_statusList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var payload,
      _ref24,
      rejectWithValue,
      data,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
          _ref24 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref24.rejectWithValue, _ref24.getState;
          _context12.prev = 2;

          _objectDestructuringEmpty(payload);

          _context12.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.patientQueueStatusList())
          }, __readDocumentUrl__);

        case 6:
          data = _context12.sent;
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context12.prev = 10;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 13:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 10]]);
})));
var CART_PATIENT_QUEUE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/cart_patient_queue", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
  var payload,
      _ref26,
      rejectWithValue,
      cartID,
      locID,
      wardID,
      _payload$grpid,
      grpid,
      data,
      _args13 = arguments;

  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          payload = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {};
          _ref26 = _args13.length > 1 ? _args13[1] : undefined, rejectWithValue = _ref26.rejectWithValue;
          _context13.prev = 2;
          cartID = payload.cartID, locID = payload.locID, wardID = payload.wardID, _payload$grpid = payload.grpid, grpid = _payload$grpid === void 0 ? "" : _payload$grpid;
          _context13.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.CartpatientQueue(cartID, locID, wardID, grpid))
          }, __baseUrl__);

        case 6:
          data = _context13.sent;
          return _context13.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context13.prev = 10;
          _context13.t0 = _context13["catch"](2);
          return _context13.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context13.t0.message
          })));

        case 13:
        case "end":
          return _context13.stop();
      }
    }
  }, _callee13, null, [[2, 10]]);
}))); //LabelPrinting

var LABEL_PRINT = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/label_print", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
  var payload,
      _ref28,
      rejectWithValue,
      Body,
      data,
      _args14 = arguments;

  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          payload = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : {};
          _ref28 = _args14.length > 1 ? _args14[1] : undefined, rejectWithValue = _ref28.rejectWithValue;
          _context14.prev = 2;
          Body = payload.Body;
          _context14.next = 6;
          return fetchData({
            body: JSON.stringify(Body)
          }, __PrintLabel__);

        case 6:
          data = _context14.sent;
          return _context14.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 10:
          _context14.prev = 10;
          _context14.t0 = _context14["catch"](2);
          return _context14.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context14.t0.message
          })));

        case 13:
        case "end":
          return _context14.stop();
      }
    }
  }, _callee14, null, [[2, 10]]);
})));
var STATUS_UPDATE_QUEUE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/statusUpdateQueue", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
  var payload,
      _ref30,
      rejectWithValue,
      _Body$queueid,
      _Body$transactionid,
      _Body$queueno,
      _Body$patientstatus,
      _Body$statushistory,
      Body,
      key,
      Json,
      data,
      _args15 = arguments;

  return _regeneratorRuntime().wrap(function _callee15$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          payload = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : {};
          _ref30 = _args15.length > 1 ? _args15[1] : undefined, rejectWithValue = _ref30.rejectWithValue;
          _context15.prev = 2;
          Body = payload.Body, key = payload.key;
          Json = {
            db_name: dbName,
            entity: "QueuenoCollection",
            is_metadata: true,
            metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
            doc: {
              queueid: (_Body$queueid = Body === null || Body === void 0 ? void 0 : Body.queueid) !== null && _Body$queueid !== void 0 ? _Body$queueid : "",
              transactionid: (_Body$transactionid = Body === null || Body === void 0 ? void 0 : Body.transactionid) !== null && _Body$transactionid !== void 0 ? _Body$transactionid : "",
              queueno: (_Body$queueno = Body === null || Body === void 0 ? void 0 : Body.queueno) !== null && _Body$queueno !== void 0 ? _Body$queueno : 0,
              patientstatus: (_Body$patientstatus = Body === null || Body === void 0 ? void 0 : Body.patientstatus) !== null && _Body$patientstatus !== void 0 ? _Body$patientstatus : "",
              statushistory: (_Body$statushistory = Body === null || Body === void 0 ? void 0 : Body.statushistory) !== null && _Body$statushistory !== void 0 ? _Body$statushistory : []
            }
          };

          if (key) {
            Json["filter"] = {
              _key: key
            };
          }

          _context15.next = 8;
          return fetchData({
            body: JSON.stringify([Json])
          }, __upsertQueueNo__);

        case 8:
          data = _context15.sent;
          return _context15.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 12:
          _context15.prev = 12;
          _context15.t0 = _context15["catch"](2);
          return _context15.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context15.t0.message
          })));

        case 15:
        case "end":
          return _context15.stop();
      }
    }
  }, _callee15, null, [[2, 12]]);
}))); // const LABEL_PRINT = createAsyncThunk(
//   `pharmacyFrameworkApiSlice/label_print`,
//   async (payload = {}, { rejectWithValue }) => {
//
//     try {
//       const {Body} = payload;
//       // const data = await fetchDataPdf(
//       //   {
//       //     body: JSON.stringify(Body)
//       //   },
//       //   __PrintLabel__
//       // );
//       let config = {
//         method: 'post',
//         url: __PrintLabel__,
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         data : Body
//       };
//     //  await axios(config)
//     //   .then(function (response) {
//     //     console.log(JSON.stringify(response.data));
//     //   })
//     } catch (error) {
//       console.clear()
//       console.log(error)
//       return rejectWithValue({
//         ...defaultReject,
//         message: error.message,
//       });
//     }
//   }
// );
//GETsTATE

var PHARMACY_GETTINGSTATE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/pharmacy_gettingstate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
  var payload,
      _ref32,
      rejectWithValue,
      _Task$,
      queueId,
      scenarioId,
      patientid,
      isCart,
      Task,
      States,
      obj,
      fillteredValue,
      _args16 = arguments;

  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          payload = _args16.length > 0 && _args16[0] !== undefined ? _args16[0] : {};
          _ref32 = _args16.length > 1 ? _args16[1] : undefined, rejectWithValue = _ref32.rejectWithValue;
          _context16.prev = 2;
          queueId = payload.queueId, scenarioId = payload.scenarioId, patientid = payload.patientid, isCart = payload.isCart;
          _context16.next = 6;
          return TaskFetch(scenarioId, queueId, patientid, isCart);

        case 6:
          Task = _context16.sent;
          States = [];
          (_Task$ = Task[0]) === null || _Task$ === void 0 ? void 0 : _Task$.forEach(function (val) {
            var _val$states;

            val === null || val === void 0 ? void 0 : (_val$states = val.states) === null || _val$states === void 0 ? void 0 : _val$states.forEach(function (state) {
              States.push({
                id: state === null || state === void 0 ? void 0 : state._id,
                label: state === null || state === void 0 ? void 0 : state.states,
                count: state === null || state === void 0 ? void 0 : state.reccount,
                scenarioid: val === null || val === void 0 ? void 0 : val.scenrioid,
                queueid: val === null || val === void 0 ? void 0 : val.queueid,
                scenrioname: val === null || val === void 0 ? void 0 : val.scenrioname,
                actions: state === null || state === void 0 ? void 0 : state.action
              });
            });
          });
          obj = {};
          States.forEach(function (val) {
            var ID = val.id;

            if (ID in obj) {
              obj[val.id].count = obj[val.id].count + val.count;
              obj[val.id] = _objectSpread2(_objectSpread2({}, obj[val.id]), {}, _defineProperty({}, val === null || val === void 0 ? void 0 : val.scenrioname, val === null || val === void 0 ? void 0 : val.actions));
            } else {
              obj[val.id] = _objectSpread2(_objectSpread2({}, val), {}, _defineProperty({}, val === null || val === void 0 ? void 0 : val.scenrioname, val === null || val === void 0 ? void 0 : val.actions));
            }
          });
          fillteredValue = Object.values(obj); // const data = Task[0]?.[0].states?.map((val) => {
          //   return {
          //     id: val?._id,
          //     label: val?.states,
          //     count: val?.reccount,
          //     scenarioid: Task[0]?.[0]?.scenrioid,
          //     queueid: Task[0]?.[0]?.queueid,
          //     scenrioname: Task[0]?.[0]?.scenrioname,
          //     actions: val?.action,
          //   };
          // });

          return _context16.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: fillteredValue
          }));

        case 15:
          _context16.prev = 15;
          _context16.t0 = _context16["catch"](2);
          return _context16.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context16.t0.message
          })));

        case 18:
        case "end":
          return _context16.stop();
      }
    }
  }, _callee16, null, [[2, 15]]);
}))); //PHARMACY_PHRAMEWORK

var PHARMACY_FRAMEWORK = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/pharmacy_framework", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
  var payload,
      _ref34,
      rejectWithValue,
      getState,
      _state$signInReducerA11,
      _state$signInReducerA12,
      _state$phramcyFramewo,
      _state$phramcyFramewo2,
      _state$phramcyFramewo3,
      _practitionerData$loc,
      _practitionerData$loc2,
      FirstState,
      stateid,
      patientid,
      isCart,
      queueid,
      state,
      practitionerData,
      ScenarioId,
      TaskAgainstState,
      dispenseDura,
      calculateDispenseStrength,
      data,
      ScheduledOrder,
      _args17 = arguments;

  return _regeneratorRuntime().wrap(function _callee17$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          payload = _args17.length > 0 && _args17[0] !== undefined ? _args17[0] : {};
          _ref34 = _args17.length > 1 ? _args17[1] : undefined, rejectWithValue = _ref34.rejectWithValue, getState = _ref34.getState;
          _context17.prev = 2;
          FirstState = payload.FirstState, stateid = payload.stateid, patientid = payload.patientid, payload.index, isCart = payload.isCart;
          FirstState === null || FirstState === void 0 ? void 0 : FirstState.scenarioid;
          queueid = FirstState === null || FirstState === void 0 ? void 0 : FirstState.queueid;
          state = getState();
          /* get practitioner */

          practitionerData = state === null || state === void 0 ? void 0 : (_state$signInReducerA11 = state.signInReducerApiSlice) === null || _state$signInReducerA11 === void 0 ? void 0 : (_state$signInReducerA12 = _state$signInReducerA11.loggedUserInfo) === null || _state$signInReducerA12 === void 0 ? void 0 : _state$signInReducerA12.data;
          ScenarioId = state === null || state === void 0 ? void 0 : (_state$phramcyFramewo = state.phramcyFrameworkApiSlice) === null || _state$phramcyFramewo === void 0 ? void 0 : (_state$phramcyFramewo2 = _state$phramcyFramewo.getScenarioList) === null || _state$phramcyFramewo2 === void 0 ? void 0 : (_state$phramcyFramewo3 = _state$phramcyFramewo2.data) === null || _state$phramcyFramewo3 === void 0 ? void 0 : _state$phramcyFramewo3.map(function (val) {
            return val === null || val === void 0 ? void 0 : val.scenarioid;
          });
          ScenarioId = _toConsumableArray(new Set(ScenarioId));
          _context17.next = 12;
          return TaskFetchByState(ScenarioId, queueid, stateid, patientid, isCart);

        case 12:
          TaskAgainstState = _context17.sent;

          if (!(TaskAgainstState.length === 0)) {
            _context17.next = 15;
            break;
          }

          return _context17.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: []
          }));

        case 15:
          _context17.next = 17;
          return GetDispenseDuration(TaskAgainstState, practitionerData);

        case 17:
          dispenseDura = _context17.sent;
          _context17.next = 20;
          return calculateDispenseDoseStrength(TaskAgainstState, patientid, dispenseDura, undefined);

        case 20:
          calculateDispenseStrength = _context17.sent;
          _context17.next = 23;
          return GenerateResponse(TaskAgainstState, dispenseDura, calculateDispenseStrength);

        case 23:
          data = _context17.sent;

          if (!(practitionerData !== null && practitionerData !== void 0 && (_practitionerData$loc = practitionerData.location) !== null && _practitionerData$loc !== void 0 && _practitionerData$loc.autocalculate)) {
            _context17.next = 28;
            break;
          }

          _context17.next = 27;
          return getOrderSchedule(data, practitionerData, isCart);

        case 27:
          ScheduledOrder = _context17.sent;

        case 28:
          return _context17.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: practitionerData !== null && practitionerData !== void 0 && (_practitionerData$loc2 = practitionerData.location) !== null && _practitionerData$loc2 !== void 0 && _practitionerData$loc2.autocalculate ? ScheduledOrder : data
          }));

        case 31:
          _context17.prev = 31;
          _context17.t0 = _context17["catch"](2);
          console.log(_context17.t0);
          return _context17.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context17.t0.message
          })));

        case 35:
        case "end":
          return _context17.stop();
      }
    }
  }, _callee17, null, [[2, 31]]);
})));
var PHARMACY_MULTIBATCH = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/pharmacy_multibatch", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
  var payload,
      _ref36,
      rejectWithValue,
      getState,
      _state$signInReducerA13,
      _state$signInReducerA14,
      _availableStock$Data,
      order,
      SelectedOrder,
      isShowMulti,
      alisName,
      orderbatches,
      state,
      practitionerData,
      scheduleGeneration,
      availableStock,
      getBatchDetails,
      _args18 = arguments;

  return _regeneratorRuntime().wrap(function _callee18$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          payload = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : {};
          _ref36 = _args18.length > 1 ? _args18[1] : undefined, rejectWithValue = _ref36.rejectWithValue, getState = _ref36.getState;
          _context18.prev = 2;
          order = payload.order, SelectedOrder = payload.SelectedOrder, isShowMulti = payload.isShowMulti, alisName = payload.alisName, orderbatches = payload.orderbatches;
          state = getState();
          practitionerData = state === null || state === void 0 ? void 0 : (_state$signInReducerA13 = state.signInReducerApiSlice) === null || _state$signInReducerA13 === void 0 ? void 0 : (_state$signInReducerA14 = _state$signInReducerA13.loggedUserInfo) === null || _state$signInReducerA14 === void 0 ? void 0 : _state$signInReducerA14.data;
          scheduleGeneration = JSON.parse(JSON.stringify(order));
          _context18.next = 9;
          return ptAvailStockMultiBatch(order, SelectedOrder, scheduleGeneration, practitionerData, isShowMulti, alisName, orderbatches);

        case 9:
          availableStock = _context18.sent;
          getBatchDetails = availableStock === null || availableStock === void 0 ? void 0 : (_availableStock$Data = availableStock.Data) === null || _availableStock$Data === void 0 ? void 0 : _availableStock$Data.map(function (val) {
            return _objectSpread2({
              id: val === null || val === void 0 ? void 0 : val.batchno,
              expiryDate: moment__default["default"](val === null || val === void 0 ? void 0 : val.expdate).format("MM/DD/YYYY"),
              bin: {
                number: val === null || val === void 0 ? void 0 : val.binlocty,
                aisle: val === null || val === void 0 ? void 0 : val.binname // shelf: val?.loccode,
                // level: val?.locrefno,

              },
              availableQuantity: val === null || val === void 0 ? void 0 : val.stockqty,
              availableQuantityUOM: val === null || val === void 0 ? void 0 : val.stockuom,
              heldQuantity: val === null || val === void 0 ? void 0 : val.blockqty,
              totalAmount: val === null || val === void 0 ? void 0 : val.chargeprice,
              Quantity: "".concat(val === null || val === void 0 ? void 0 : val.chargeqty, " ").concat(val === null || val === void 0 ? void 0 : val.chargeuom)
            }, val);
          });
          return _context18.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: getBatchDetails
          }));

        case 14:
          _context18.prev = 14;
          _context18.t0 = _context18["catch"](2);
          return _context18.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context18.t0.message
          })));

        case 17:
        case "end":
          return _context18.stop();
      }
    }
  }, _callee18, null, [[2, 14]]);
})));
var PHARMACY_CALCULATE_DOSESTRENGTH_STOCK = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/pharmacy_calculate_dosesstrength_stock", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
  var payload,
      _ref38,
      rejectWithValue,
      getState,
      _state$signInReducerA15,
      _state$signInReducerA16,
      _scheduleGeneration$p52,
      _scheduleGeneration$p53,
      order,
      SelectedOrder,
      isCart,
      isCartDetails,
      state,
      Value,
      practitionerData,
      OrderIndex,
      selectedOrderData,
      scheduleGenerationReponse,
      scheduleGeneration,
      _ref39,
      _scheduleGenerationRe,
      availableStock,
      UpdatedOrder,
      updatedAdditive,
      getCompOrder,
      data,
      _args19 = arguments;

  return _regeneratorRuntime().wrap(function _callee19$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          payload = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : {};
          _ref38 = _args19.length > 1 ? _args19[1] : undefined, rejectWithValue = _ref38.rejectWithValue, getState = _ref38.getState;
          _context19.prev = 2;
          order = payload.order, SelectedOrder = payload.SelectedOrder, isCart = payload.isCart, isCartDetails = payload.isCartDetails;
          state = getState();
          Value = JSON.parse(JSON.stringify(state === null || state === void 0 ? void 0 : state.phramcyFrameworkApiSlice.pharmacyFramework.data));
          /* get practitioner */

          practitionerData = state === null || state === void 0 ? void 0 : (_state$signInReducerA15 = state.signInReducerApiSlice) === null || _state$signInReducerA15 === void 0 ? void 0 : (_state$signInReducerA16 = _state$signInReducerA15.loggedUserInfo) === null || _state$signInReducerA16 === void 0 ? void 0 : _state$signInReducerA16.data;
          OrderIndex = Value.findIndex(function (val) {
            return val._id === order._id;
          });
          selectedOrderData = JSON.parse(JSON.stringify(order));
          _context19.next = 11;
          return DoseScheduleGeneration(order, SelectedOrder, isCart, isCartDetails);

        case 11:
          scheduleGenerationReponse = _context19.sent;
          scheduleGeneration = scheduleGenerationReponse === null || scheduleGenerationReponse === void 0 ? void 0 : scheduleGenerationReponse[0]; // if api throws error then return error

          if (!((scheduleGenerationReponse === null || scheduleGenerationReponse === void 0 ? void 0 : scheduleGenerationReponse.status) === 400 || (scheduleGenerationReponse === null || scheduleGenerationReponse === void 0 ? void 0 : scheduleGenerationReponse.status) === "400")) {
            _context19.next = 15;
            break;
          }

          return _context19.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: (_ref39 = (_scheduleGenerationRe = scheduleGenerationReponse.title) !== null && _scheduleGenerationRe !== void 0 ? _scheduleGenerationRe : scheduleGenerationReponse.message) !== null && _ref39 !== void 0 ? _ref39 : "Something went wrong! Unable to generate schedule.",
            data: Value
          })));

        case 15:
          _context19.next = 17;
          return ptAvailStock(order, SelectedOrder, scheduleGeneration, practitionerData);

        case 17:
          availableStock = _context19.sent;
          UpdatedOrder = selectedOrderData === null || selectedOrderData === void 0 ? void 0 : selectedOrderData.brands.map(function (brnd, i) {
            var _scheduleGeneration$p, _scheduleGeneration$p2, _scheduleGeneration$p3, _scheduleGeneration$p4, _scheduleGeneration$p5, _scheduleGeneration$p6;

            if (!(scheduleGeneration !== null && scheduleGeneration !== void 0 && (_scheduleGeneration$p = scheduleGeneration.pH_OrderLineDispenseSchedule) !== null && _scheduleGeneration$p !== void 0 && (_scheduleGeneration$p2 = _scheduleGeneration$p.dispensedetails) !== null && _scheduleGeneration$p2 !== void 0 && (_scheduleGeneration$p3 = _scheduleGeneration$p2[i]) !== null && _scheduleGeneration$p3 !== void 0 && _scheduleGeneration$p3.isAdditive) && (scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p4 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p4 === void 0 ? void 0 : (_scheduleGeneration$p5 = _scheduleGeneration$p4.dispensedetails) === null || _scheduleGeneration$p5 === void 0 ? void 0 : (_scheduleGeneration$p6 = _scheduleGeneration$p5[i]) === null || _scheduleGeneration$p6 === void 0 ? void 0 : _scheduleGeneration$p6.drugreleaseTypeText) !== "INGREDIENT") {
              var _brnd$alias, _brnd$alias$find, _scheduleGeneration$p7, _scheduleGeneration$p8, _scheduleGeneration$p9, _scheduleGeneration$p10, _scheduleGeneration$p11, _scheduleGeneration$p12, _scheduleGeneration$p13, _scheduleGeneration$p14, _scheduleGeneration$p15, _scheduleGeneration$p16, _scheduleGeneration$p17, _scheduleGeneration$p18, _scheduleGeneration$p19, _scheduleGeneration$p20, _scheduleGeneration$p21, _scheduleGeneration$p22, _scheduleGeneration$p23, _scheduleGeneration$p24, _selectedOrderData$dr, _selectedOrderData$dr2, _scheduleGeneration$p25, _scheduleGeneration$p26, _scheduleGeneration$p27, _scheduleGeneration$p28, _scheduleGeneration$p29, _scheduleGeneration$p30, _scheduleGeneration$p31, _scheduleGeneration$p32, _scheduleGeneration$p33, _scheduleGeneration$p34, _scheduleGeneration$p35, _scheduleGeneration$p36, _scheduleGeneration$p37, _scheduleGeneration$p38, _scheduleGeneration$p39, _scheduleGeneration$p40, _scheduleGeneration$p41, _scheduleGeneration$p42, _scheduleGeneration$p43, _scheduleGeneration$p44, _scheduleGeneration$p45, _scheduleGeneration$p46, _scheduleGeneration$p47, _scheduleGeneration$p48, _scheduleGeneration$p49, _scheduleGeneration$p50, _scheduleGeneration$p51;

              var alisName = brnd === null || brnd === void 0 ? void 0 : (_brnd$alias = brnd.alias) === null || _brnd$alias === void 0 ? void 0 : (_brnd$alias$find = _brnd$alias.find(function (v) {
                var _v$aliasType;

                return (v === null || v === void 0 ? void 0 : (_v$aliasType = v.aliasType) === null || _v$aliasType === void 0 ? void 0 : _v$aliasType.code) === "AM002";
              })) === null || _brnd$alias$find === void 0 ? void 0 : _brnd$alias$find.aliasCode;
              var drugReleaseType = scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p7 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p7 === void 0 ? void 0 : (_scheduleGeneration$p8 = _scheduleGeneration$p7.dispensedetails) === null || _scheduleGeneration$p8 === void 0 ? void 0 : (_scheduleGeneration$p9 = _scheduleGeneration$p8[i]) === null || _scheduleGeneration$p9 === void 0 ? void 0 : _scheduleGeneration$p9.drugreleaseTypeText;
              return {
                id: brnd === null || brnd === void 0 ? void 0 : brnd.id,
                uniqueId: brnd === null || brnd === void 0 ? void 0 : brnd.uniqueId,
                alias: brnd === null || brnd === void 0 ? void 0 : brnd.alias,
                drugPhotoId: brnd === null || brnd === void 0 ? void 0 : brnd.drugPhotoId,
                drugreleasetype: brnd === null || brnd === void 0 ? void 0 : brnd.drugreleasetype,
                name: brnd === null || brnd === void 0 ? void 0 : brnd.name,
                DrugType: brnd === null || brnd === void 0 ? void 0 : brnd.DrugType,
                drugNameLong: brnd === null || brnd === void 0 ? void 0 : brnd.drugNameLong,
                dispensedrugcode: brnd === null || brnd === void 0 ? void 0 : brnd.id,
                dosageUOM_id: (_scheduleGeneration$p10 = scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p11 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p11 === void 0 ? void 0 : (_scheduleGeneration$p12 = _scheduleGeneration$p11.dispensedetails) === null || _scheduleGeneration$p12 === void 0 ? void 0 : (_scheduleGeneration$p13 = _scheduleGeneration$p12[i]) === null || _scheduleGeneration$p13 === void 0 ? void 0 : _scheduleGeneration$p13.dispuom) !== null && _scheduleGeneration$p10 !== void 0 ? _scheduleGeneration$p10 : brnd === null || brnd === void 0 ? void 0 : brnd.dosageUOM_id,
                strength: brnd === null || brnd === void 0 ? void 0 : brnd.strength,
                route: "Oral",
                doseCount: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p14 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p14 === void 0 ? void 0 : (_scheduleGeneration$p15 = _scheduleGeneration$p14.dispensedetails) === null || _scheduleGeneration$p15 === void 0 ? void 0 : (_scheduleGeneration$p16 = _scheduleGeneration$p15[i]) === null || _scheduleGeneration$p16 === void 0 ? void 0 : _scheduleGeneration$p16.totnoofdose,
                tabPerDose: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p17 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p17 === void 0 ? void 0 : (_scheduleGeneration$p18 = _scheduleGeneration$p17.dispensedetails) === null || _scheduleGeneration$p18 === void 0 ? void 0 : (_scheduleGeneration$p19 = _scheduleGeneration$p18[i]) === null || _scheduleGeneration$p19 === void 0 ? void 0 : _scheduleGeneration$p19.totissueqty,
                actualdoseCount: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p20 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p20 === void 0 ? void 0 : (_scheduleGeneration$p21 = _scheduleGeneration$p20.dispensedetails) === null || _scheduleGeneration$p21 === void 0 ? void 0 : (_scheduleGeneration$p22 = _scheduleGeneration$p21[i]) === null || _scheduleGeneration$p22 === void 0 ? void 0 : _scheduleGeneration$p22.totbillqty,
                batches: drugReleaseType === "RCOMPOUND" ? getCompoundBatch(scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p23 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p23 === void 0 ? void 0 : (_scheduleGeneration$p24 = _scheduleGeneration$p23.dispensedetails) === null || _scheduleGeneration$p24 === void 0 ? void 0 : _scheduleGeneration$p24[i], selectedOrderData === null || selectedOrderData === void 0 ? void 0 : (_selectedOrderData$dr = selectedOrderData.drugDetails) === null || _selectedOrderData$dr === void 0 ? void 0 : (_selectedOrderData$dr2 = _selectedOrderData$dr[0]) === null || _selectedOrderData$dr2 === void 0 ? void 0 : _selectedOrderData$dr2.stability) : getBatches(availableStock === null || availableStock === void 0 ? void 0 : availableStock.Data, alisName),
                option: brnd.option,
                dosageValue: brnd === null || brnd === void 0 ? void 0 : brnd.dosageValue,
                allStrength: brnd === null || brnd === void 0 ? void 0 : brnd.allStrength,
                dosageUOM: brnd === null || brnd === void 0 ? void 0 : brnd.dosageUOM,
                packSizeApplicability: brnd === null || brnd === void 0 ? void 0 : brnd.packSizeApplicability,
                totadmqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p25 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p25 === void 0 ? void 0 : (_scheduleGeneration$p26 = _scheduleGeneration$p25.dispensedetails) === null || _scheduleGeneration$p26 === void 0 ? void 0 : (_scheduleGeneration$p27 = _scheduleGeneration$p26[i]) === null || _scheduleGeneration$p27 === void 0 ? void 0 : _scheduleGeneration$p27.totadmqty,
                totadmuom: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p28 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p28 === void 0 ? void 0 : (_scheduleGeneration$p29 = _scheduleGeneration$p28.dispensedetails) === null || _scheduleGeneration$p29 === void 0 ? void 0 : (_scheduleGeneration$p30 = _scheduleGeneration$p29[i]) === null || _scheduleGeneration$p30 === void 0 ? void 0 : _scheduleGeneration$p30.adminuomext,
                totstkqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p31 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p31 === void 0 ? void 0 : (_scheduleGeneration$p32 = _scheduleGeneration$p31.dispensedetails) === null || _scheduleGeneration$p32 === void 0 ? void 0 : (_scheduleGeneration$p33 = _scheduleGeneration$p32[i]) === null || _scheduleGeneration$p33 === void 0 ? void 0 : _scheduleGeneration$p33.totstkqty,
                totstkuom: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p34 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p34 === void 0 ? void 0 : (_scheduleGeneration$p35 = _scheduleGeneration$p34.dispensedetails) === null || _scheduleGeneration$p35 === void 0 ? void 0 : (_scheduleGeneration$p36 = _scheduleGeneration$p35[i]) === null || _scheduleGeneration$p36 === void 0 ? void 0 : _scheduleGeneration$p36.stockuomtext,
                totbillqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p37 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p37 === void 0 ? void 0 : (_scheduleGeneration$p38 = _scheduleGeneration$p37.dispensedetails) === null || _scheduleGeneration$p38 === void 0 ? void 0 : (_scheduleGeneration$p39 = _scheduleGeneration$p38[i]) === null || _scheduleGeneration$p39 === void 0 ? void 0 : _scheduleGeneration$p39.totbillqty,
                totbilluom: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p40 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p40 === void 0 ? void 0 : (_scheduleGeneration$p41 = _scheduleGeneration$p40.dispensedetails) === null || _scheduleGeneration$p41 === void 0 ? void 0 : (_scheduleGeneration$p42 = _scheduleGeneration$p41[i]) === null || _scheduleGeneration$p42 === void 0 ? void 0 : _scheduleGeneration$p42.billuomtext,
                totissueqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p43 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p43 === void 0 ? void 0 : (_scheduleGeneration$p44 = _scheduleGeneration$p43.dispensedetails) === null || _scheduleGeneration$p44 === void 0 ? void 0 : (_scheduleGeneration$p45 = _scheduleGeneration$p44[i]) === null || _scheduleGeneration$p45 === void 0 ? void 0 : _scheduleGeneration$p45.totissueqty,
                totissueuom: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p46 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p46 === void 0 ? void 0 : (_scheduleGeneration$p47 = _scheduleGeneration$p46.dispensedetails) === null || _scheduleGeneration$p47 === void 0 ? void 0 : (_scheduleGeneration$p48 = _scheduleGeneration$p47[i]) === null || _scheduleGeneration$p48 === void 0 ? void 0 : _scheduleGeneration$p48.issueuomtext,
                perdoseadminqty: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p49 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p49 === void 0 ? void 0 : (_scheduleGeneration$p50 = _scheduleGeneration$p49.dispensedetails) === null || _scheduleGeneration$p50 === void 0 ? void 0 : (_scheduleGeneration$p51 = _scheduleGeneration$p50[i]) === null || _scheduleGeneration$p51 === void 0 ? void 0 : _scheduleGeneration$p51.perdoseadminqty,
                pH_OrderLineDispenseSchedule: scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : scheduleGeneration.pH_OrderLineDispenseSchedule
              };
            }
          }).filter(function (notUndefined) {
            return notUndefined !== undefined;
          });
          updatedAdditive = generateUpdateAdditive(selectedOrderData, scheduleGeneration, availableStock);

          if (selectedOrderData !== null && selectedOrderData !== void 0 && selectedOrderData.isCompound) {
            getCompOrder = getUpdatedCompOrder(selectedOrderData === null || selectedOrderData === void 0 ? void 0 : selectedOrderData.compounds, scheduleGeneration, availableStock);
          }

          selectedOrderData.brands = UpdatedOrder;
          selectedOrderData.additives = updatedAdditive;
          selectedOrderData.compounds = getCompOrder;
          selectedOrderData.pH_OrderLinePerdoseSchedule = scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : scheduleGeneration.pH_OrderLinePerdoseSchedule;
          selectedOrderData.pH_OrderLineDispenseSchedule = scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : scheduleGeneration.pH_OrderLineDispenseSchedule;
          selectedOrderData.ivInfusionRateValue = scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p52 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p52 === void 0 ? void 0 : _scheduleGeneration$p52.ivInfusionRateValue;
          selectedOrderData.ivInfusionTime = scheduleGeneration === null || scheduleGeneration === void 0 ? void 0 : (_scheduleGeneration$p53 = scheduleGeneration.pH_OrderLineDispenseSchedule) === null || _scheduleGeneration$p53 === void 0 ? void 0 : _scheduleGeneration$p53.ivInfusionTime; //Recievednextrefilldate
          // selectedOrderData.nextrefilldate =
          //   scheduleGeneration?.pH_OrderLineDispenseSchedule?.nextrefilldate ?? 0;

          Value[OrderIndex] = selectedOrderData;
          data = JSON.parse(JSON.stringify(Value));
          return _context19.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 33:
          _context19.prev = 33;
          _context19.t0 = _context19["catch"](2);
          return _context19.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context19.t0.message
          })));

        case 36:
        case "end":
          return _context19.stop();
      }
    }
  }, _callee19, null, [[2, 33]]);
})));
var PHARMACY_MEDICATION_CHANGE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/pharmacy_medication_change", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
  var payload,
      _ref41,
      rejectWithValue,
      getState,
      order,
      state,
      Value,
      OrderIndex,
      selectedOrderData,
      calculateDispenseStrength,
      UpdatedOrder,
      data,
      _args20 = arguments;

  return _regeneratorRuntime().wrap(function _callee20$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          payload = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : {};
          _ref41 = _args20.length > 1 ? _args20[1] : undefined, rejectWithValue = _ref41.rejectWithValue, getState = _ref41.getState;
          _context20.prev = 2;
          order = payload.order, payload.SelectedOrder, payload.medication;
          state = getState();
          Value = JSON.parse(JSON.stringify(state === null || state === void 0 ? void 0 : state.phramcyFrameworkApiSlice.pharmacyFramework.data));
          OrderIndex = Value.findIndex(function (val) {
            return val._id === order._id;
          });
          selectedOrderData = JSON.parse(JSON.stringify(order));
          _context20.next = 10;
          return calculateDispenseDoseStrength([order], order === null || order === void 0 ? void 0 : order.patient_Id, undefined, true);

        case 10:
          calculateDispenseStrength = _context20.sent;
          // const scheduleGeneration = await DoseScheduleGeneration(
          //   order,
          //   calculateDispenseStrength
          // );
          // const availableStock = await ptAvailStock(order, SelectedOrder);
          UpdatedOrder = selectedOrderData === null || selectedOrderData === void 0 ? void 0 : selectedOrderData.brands.map(function (brnd, i) {
            var _calculateDispenseStr, _calculateDispenseStr2, _calculateDispenseStr3, _calculateDispenseStr4, _calculateDispenseStr5, _calculateDispenseStr6, _calculateDispenseStr7, _calculateDispenseStr8, _calculateDispenseStr9, _calculateDispenseStr10, _calculateDispenseStr11, _calculateDispenseStr12;

            return {
              id: brnd === null || brnd === void 0 ? void 0 : brnd.id,
              uniqueId: brnd === null || brnd === void 0 ? void 0 : brnd.uniqueId,
              drugPhotoId: brnd === null || brnd === void 0 ? void 0 : brnd.drugPhotoId,
              name: brnd === null || brnd === void 0 ? void 0 : brnd.name,
              dispensedrugcode: brnd === null || brnd === void 0 ? void 0 : brnd.id,
              drugNameLong: brnd === null || brnd === void 0 ? void 0 : brnd.drugNameLong,
              drugreleasetype: brnd === null || brnd === void 0 ? void 0 : brnd.drugreleasetype,
              DrugType: brnd === null || brnd === void 0 ? void 0 : brnd.DrugType,
              alias: brnd === null || brnd === void 0 ? void 0 : brnd.alias,
              //  brnd?.name,
              strength: "".concat(calculateDispenseStrength === null || calculateDispenseStrength === void 0 ? void 0 : (_calculateDispenseStr = calculateDispenseStrength[0]) === null || _calculateDispenseStr === void 0 ? void 0 : (_calculateDispenseStr2 = _calculateDispenseStr.dispenseDetails[i]) === null || _calculateDispenseStr2 === void 0 ? void 0 : _calculateDispenseStr2.dispenseStrength).concat(calculateDispenseStrength === null || calculateDispenseStrength === void 0 ? void 0 : (_calculateDispenseStr3 = calculateDispenseStrength[0]) === null || _calculateDispenseStr3 === void 0 ? void 0 : (_calculateDispenseStr4 = _calculateDispenseStr3.dispenseDetails[i]) === null || _calculateDispenseStr4 === void 0 ? void 0 : _calculateDispenseStr4.dispenseUOMText),
              //  brnd?.strength,
              route: "Oral",
              // doseCount: scheduleGeneration?.totalDose,
              // tabPerDose:
              //   scheduleGeneration.pH_OrderLineDispenseSchedule?.dispensedetails?.[
              //     i
              //   ]?.totissueqty,
              // actualdoseCount:
              //   scheduleGeneration.pH_OrderLineDispenseSchedule?.dispensedetails?.[
              //     i
              //   ]?.totbillqty,
              // batches: getBatches(availableStock?.Data, brnd?.name),
              batches: [],
              option: brnd.option,
              allStrength: calculateDispenseStrength === null || calculateDispenseStrength === void 0 ? void 0 : (_calculateDispenseStr5 = calculateDispenseStrength[0]) === null || _calculateDispenseStr5 === void 0 ? void 0 : (_calculateDispenseStr6 = _calculateDispenseStr5.dispenseDetails[i]) === null || _calculateDispenseStr6 === void 0 ? void 0 : _calculateDispenseStr6.dispdose,
              dosageValue: calculateDispenseStrength === null || calculateDispenseStrength === void 0 ? void 0 : (_calculateDispenseStr7 = calculateDispenseStrength[0]) === null || _calculateDispenseStr7 === void 0 ? void 0 : (_calculateDispenseStr8 = _calculateDispenseStr7.dispenseDetails[i]) === null || _calculateDispenseStr8 === void 0 ? void 0 : _calculateDispenseStr8.dispenseStrength,
              dosageUOM: calculateDispenseStrength === null || calculateDispenseStrength === void 0 ? void 0 : (_calculateDispenseStr9 = calculateDispenseStrength[0]) === null || _calculateDispenseStr9 === void 0 ? void 0 : (_calculateDispenseStr10 = _calculateDispenseStr9.dispenseDetails[i]) === null || _calculateDispenseStr10 === void 0 ? void 0 : _calculateDispenseStr10.dispenseUOMText,
              dosageUOM_id: calculateDispenseStrength === null || calculateDispenseStrength === void 0 ? void 0 : (_calculateDispenseStr11 = calculateDispenseStrength[0]) === null || _calculateDispenseStr11 === void 0 ? void 0 : (_calculateDispenseStr12 = _calculateDispenseStr11.dispenseDetails[i]) === null || _calculateDispenseStr12 === void 0 ? void 0 : _calculateDispenseStr12.dispenseUOM,
              // brnd?.dosageUOM,
              packSizeApplicability: brnd === null || brnd === void 0 ? void 0 : brnd.packSizeApplicability // totadmqty:
              //   scheduleGeneration.pH_OrderLineDispenseSchedule?.dispensedetails?.[
              //     i
              //   ]?.totadmqty,
              // totadmuom:
              //   scheduleGeneration.pH_OrderLineDispenseSchedule?.dispensedetails?.[
              //     i
              //   ]?.adminuomext,
              // totstkqty:
              //   scheduleGeneration.pH_OrderLineDispenseSchedule?.dispensedetails?.[
              //     i
              //   ]?.totstkqty,
              // totstkuom:
              //   scheduleGeneration.pH_OrderLineDispenseSchedule?.dispensedetails?.[
              //     i
              //   ].stockuomtext,
              // totbillqty:
              //   scheduleGeneration.pH_OrderLineDispenseSchedule?.dispensedetails?.[
              //     i
              //   ]?.totbillqty,
              // totbilluom:
              //   scheduleGeneration.pH_OrderLineDispenseSchedule?.dispensedetails?.[
              //     i
              //   ]?.billuomtext,
              // totissueqty:
              //   scheduleGeneration.pH_OrderLineDispenseSchedule?.dispensedetails?.[
              //     i
              //   ]?.totissueqty,
              // totissueuom:
              //   scheduleGeneration.pH_OrderLineDispenseSchedule?.dispensedetails?.[
              //     i
              //   ]?.issueuomtext,
              // pH_OrderLineDispenseSchedule:
              //   scheduleGeneration.pH_OrderLineDispenseSchedule,

            };
          }); // ;

          selectedOrderData.brands = UpdatedOrder;
          Value[OrderIndex] = selectedOrderData;
          data = JSON.parse(JSON.stringify(Value));
          return _context20.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 18:
          _context20.prev = 18;
          _context20.t0 = _context20["catch"](2);
          return _context20.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context20.t0.message
          })));

        case 21:
        case "end":
          return _context20.stop();
      }
    }
  }, _callee20, null, [[2, 18]]);
})));
var PHARMACY_VERIFY = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/pharmacy_verify", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
  var payload,
      _ref43,
      rejectWithValue,
      getState,
      _state$signInReducerA17,
      _state$signInReducerA18,
      orders,
      selectedState,
      patientId,
      action,
      status,
      reIssueReason,
      isReisse,
      state,
      practitionerData,
      data,
      res,
      _args21 = arguments;

  return _regeneratorRuntime().wrap(function _callee21$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          payload = _args21.length > 0 && _args21[0] !== undefined ? _args21[0] : {};
          _ref43 = _args21.length > 1 ? _args21[1] : undefined, rejectWithValue = _ref43.rejectWithValue, getState = _ref43.getState;
          _context21.prev = 2;
          orders = payload.orders, selectedState = payload.selectedState, patientId = payload.patientId, action = payload.action, status = payload.status, reIssueReason = payload.reIssueReason, isReisse = payload.isReisse;
          state = getState();
          practitionerData = state === null || state === void 0 ? void 0 : (_state$signInReducerA17 = state.signInReducerApiSlice) === null || _state$signInReducerA17 === void 0 ? void 0 : (_state$signInReducerA18 = _state$signInReducerA17.loggedUserInfo) === null || _state$signInReducerA18 === void 0 ? void 0 : _state$signInReducerA18.data;
          _context21.next = 8;
          return isMultiOrderVerify(orders, selectedState, patientId, action, status, practitionerData, reIssueReason, isReisse);

        case 8:
          data = _context21.sent;
          console.log("res", data); // return;

          _context21.next = 12;
          return fetchData({
            body: JSON.stringify(data)
          }, action.apiendpoint);

        case 12:
          res = _context21.sent;

          if (!(res.code === 1111)) {
            _context21.next = 15;
            break;
          }

          return _context21.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: "Something went wrong in nifi!",
            data: res
          })));

        case 15:
          return _context21.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 18:
          _context21.prev = 18;
          _context21.t0 = _context21["catch"](2);
          return _context21.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context21.t0.message
          })));

        case 21:
        case "end":
          return _context21.stop();
      }
    }
  }, _callee21, null, [[2, 18]]);
})));
var PHARMACY_VERIFY_DISCANTINUE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/pharmacy_verify_discontinue", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
  var payload,
      _ref45,
      rejectWithValue,
      action,
      orders,
      data,
      res,
      _args22 = arguments;

  return _regeneratorRuntime().wrap(function _callee22$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          payload = _args22.length > 0 && _args22[0] !== undefined ? _args22[0] : {};
          _ref45 = _args22.length > 1 ? _args22[1] : undefined, rejectWithValue = _ref45.rejectWithValue, _ref45.getState;
          _context22.prev = 2;
          action = payload.action, orders = payload.orders;
          data = orders;
          _context22.next = 7;
          return fetchData({
            body: JSON.stringify(data)
          }, action.apiendpoint);

        case 7:
          res = _context22.sent;

          if (!(res.code === 1111)) {
            _context22.next = 10;
            break;
          }

          return _context22.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: "Something went wrong in nifi!",
            data: res
          })));

        case 10:
          return _context22.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 13:
          _context22.prev = 13;
          _context22.t0 = _context22["catch"](2);
          return _context22.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context22.t0.message
          })));

        case 16:
        case "end":
          return _context22.stop();
      }
    }
  }, _callee22, null, [[2, 13]]);
})));
var PHARMACY_RETURN_MEDICATION = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/return_medication", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
  var payload,
      _ref47,
      rejectWithValue,
      getState,
      _state$signInReducerA19,
      _state$signInReducerA20,
      orders,
      selectedState,
      patientId,
      action,
      status,
      isApproval,
      state,
      practitionerData,
      data,
      res,
      _args23 = arguments;

  return _regeneratorRuntime().wrap(function _callee23$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          payload = _args23.length > 0 && _args23[0] !== undefined ? _args23[0] : {};
          _ref47 = _args23.length > 1 ? _args23[1] : undefined, rejectWithValue = _ref47.rejectWithValue, getState = _ref47.getState;
          _context23.prev = 2;
          orders = payload.orders, selectedState = payload.selectedState, patientId = payload.patientId, action = payload.action, status = payload.status, isApproval = payload.isApproval;
          state = getState();
          practitionerData = state === null || state === void 0 ? void 0 : (_state$signInReducerA19 = state.signInReducerApiSlice) === null || _state$signInReducerA19 === void 0 ? void 0 : (_state$signInReducerA20 = _state$signInReducerA19.loggedUserInfo) === null || _state$signInReducerA20 === void 0 ? void 0 : _state$signInReducerA20.data;
          _context23.next = 8;
          return isMultiOrderVerifyMedication(orders, selectedState, patientId, action, status, practitionerData, isApproval);

        case 8:
          data = _context23.sent;
          _context23.next = 11;
          return fetchData({
            body: JSON.stringify(data)
          }, action.apiendpoint);

        case 11:
          res = _context23.sent;
          return _context23.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 15:
          _context23.prev = 15;
          _context23.t0 = _context23["catch"](2);
          return _context23.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context23.t0.message
          })));

        case 18:
        case "end":
          return _context23.stop();
      }
    }
  }, _callee23, null, [[2, 15]]);
})));
var PHARMACY_DISCONTINUE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/pharmacy_discontinue", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
  var payload,
      _ref49,
      rejectWithValue,
      queueid,
      scenriodid,
      stateid,
      ticketid,
      actionid,
      _id,
      data,
      res,
      _args24 = arguments;

  return _regeneratorRuntime().wrap(function _callee24$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          payload = _args24.length > 0 && _args24[0] !== undefined ? _args24[0] : {};
          _ref49 = _args24.length > 1 ? _args24[1] : undefined, rejectWithValue = _ref49.rejectWithValue;
          _context24.prev = 2;
          queueid = payload.queueid, scenriodid = payload.scenriodid, stateid = payload.stateid, ticketid = payload.ticketid, actionid = payload.actionid, _id = payload._id;
          data = {
            queueid: queueid,
            scenriodid: scenriodid,
            stateid: stateid,
            ticketid: ticketid,
            actionid: actionid,
            _id: _id
          };
          _context24.next = 7;
          return fetchData({
            body: JSON.stringify(data)
          }, __DiscontinueActionUrl__);

        case 7:
          res = _context24.sent;
          return _context24.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 11:
          _context24.prev = 11;
          _context24.t0 = _context24["catch"](2);
          return _context24.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context24.t0.message
          })));

        case 14:
        case "end":
          return _context24.stop();
      }
    }
  }, _callee24, null, [[2, 11]]);
})));
var DISPENSE_AND_FILLING_REASON_DROPDOWN = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/dispense_filling", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
  var payload,
      _ref51,
      rejectWithValue,
      reason,
      data,
      _args25 = arguments;

  return _regeneratorRuntime().wrap(function _callee25$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          payload = _args25.length > 0 && _args25[0] !== undefined ? _args25[0] : {};
          _ref51 = _args25.length > 1 ? _args25[1] : undefined, rejectWithValue = _ref51.rejectWithValue;
          _context25.prev = 2;
          reason = payload.reason;
          _context25.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.dispense_and_details(reason))
          }, __readDocumentUrl__);

        case 6:
          data = _context25.sent;
          return _context25.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context25.prev = 10;
          _context25.t0 = _context25["catch"](2);
          return _context25.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context25.t0.message
          })));

        case 13:
        case "end":
          return _context25.stop();
      }
    }
  }, _callee25, null, [[2, 10]]);
}))); //filling listing

var PHARMACY_FILLING_LISTING = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/pharmacy_filling_listing", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
  var payload,
      _ref53,
      rejectWithValue,
      getState,
      _state$phramcyFramewo4,
      _state$phramcyFramewo5,
      _state$phramcyFramewo6,
      FirstState,
      stateid,
      patientid,
      isMedication,
      isCart,
      isReisse,
      queueid,
      state,
      ScenarioId,
      TaskAgainstState,
      data,
      res,
      _args26 = arguments;

  return _regeneratorRuntime().wrap(function _callee26$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          payload = _args26.length > 0 && _args26[0] !== undefined ? _args26[0] : {};
          _ref53 = _args26.length > 1 ? _args26[1] : undefined, rejectWithValue = _ref53.rejectWithValue, getState = _ref53.getState;
          _context26.prev = 2;
          FirstState = payload.FirstState, stateid = payload.stateid, patientid = payload.patientid, payload.index, isMedication = payload.isMedication, payload.pendingApprovel, isCart = payload.isCart, isReisse = payload.isReisse;
          FirstState === null || FirstState === void 0 ? void 0 : FirstState.scenarioid;
          queueid = FirstState === null || FirstState === void 0 ? void 0 : FirstState.queueid;
          state = getState();
          ScenarioId = state === null || state === void 0 ? void 0 : (_state$phramcyFramewo4 = state.phramcyFrameworkApiSlice) === null || _state$phramcyFramewo4 === void 0 ? void 0 : (_state$phramcyFramewo5 = _state$phramcyFramewo4.getScenarioList) === null || _state$phramcyFramewo5 === void 0 ? void 0 : (_state$phramcyFramewo6 = _state$phramcyFramewo5.data) === null || _state$phramcyFramewo6 === void 0 ? void 0 : _state$phramcyFramewo6.map(function (val) {
            return val === null || val === void 0 ? void 0 : val.scenarioid;
          });
          ScenarioId = _toConsumableArray(new Set(ScenarioId));
          _context26.next = 11;
          return TaskFetchByState(ScenarioId, queueid, stateid, patientid, isCart);

        case 11:
          TaskAgainstState = _context26.sent;

          if (!isMedication) {
            _context26.next = 18;
            break;
          }

          _context26.next = 15;
          return MedicationGenerateResponse(TaskAgainstState);

        case 15:
          data = _context26.sent;
          _context26.next = 30;
          break;

        case 18:
          if (!isReisse) {
            _context26.next = 27;
            break;
          }

          _context26.next = 21;
          return issueMedicationStockUpdate(TaskAgainstState, state);

        case 21:
          res = _context26.sent;
          _context26.next = 24;
          return GenerateFillingResponse(res, true);

        case 24:
          data = _context26.sent;
          _context26.next = 30;
          break;

        case 27:
          _context26.next = 29;
          return GenerateFillingResponse(TaskAgainstState);

        case 29:
          data = _context26.sent;

        case 30:
          return _context26.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 33:
          _context26.prev = 33;
          _context26.t0 = _context26["catch"](2);
          return _context26.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context26.t0.message
          })));

        case 36:
        case "end":
          return _context26.stop();
      }
    }
  }, _callee26, null, [[2, 33]]);
})));
var ALERT_UPDATE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/alert_update", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
  var payload,
      _ref55,
      rejectWithValue,
      getState,
      _state$signInReducerA21,
      _state$signInReducerA22,
      alertPayload,
      state,
      practitionerData,
      AlertData,
      data,
      _args27 = arguments;

  return _regeneratorRuntime().wrap(function _callee27$(_context27) {
    while (1) {
      switch (_context27.prev = _context27.next) {
        case 0:
          payload = _args27.length > 0 && _args27[0] !== undefined ? _args27[0] : {};
          _ref55 = _args27.length > 1 ? _args27[1] : undefined, rejectWithValue = _ref55.rejectWithValue, getState = _ref55.getState;
          _context27.prev = 2;
          alertPayload = payload.alertPayload;
          state = getState();
          practitionerData = state === null || state === void 0 ? void 0 : (_state$signInReducerA21 = state.signInReducerApiSlice) === null || _state$signInReducerA21 === void 0 ? void 0 : (_state$signInReducerA22 = _state$signInReducerA21.loggedUserInfo) === null || _state$signInReducerA22 === void 0 ? void 0 : _state$signInReducerA22.data;
          AlertData = generateAlertPayload(alertPayload, practitionerData);
          _context27.next = 9;
          return fetchData({
            body: JSON.stringify(AlertData)
          }, __uspsertUrl__);

        case 9:
          data = _context27.sent;
          return _context27.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 13:
          _context27.prev = 13;
          _context27.t0 = _context27["catch"](2);
          return _context27.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context27.t0.message
          })));

        case 16:
        case "end":
          return _context27.stop();
      }
    }
  }, _callee27, null, [[2, 13]]);
})));
var ALERT_REASON = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/alert_reason", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
  var _ref57,
      rejectWithValue,
      _data,
      data,
      _args28 = arguments;

  return _regeneratorRuntime().wrap(function _callee28$(_context28) {
    while (1) {
      switch (_context28.prev = _context28.next) {
        case 0:
          _ref57 = _args28.length > 1 ? _args28[1] : undefined, rejectWithValue = _ref57.rejectWithValue;
          _context28.prev = 2;
          _context28.next = 5;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery === null || pharmacyVerifierQuery === void 0 ? void 0 : pharmacyVerifierQuery.alert_reason())
          }, __readDocumentUrl__);

        case 5:
          data = _context28.sent;
          data = (_data = data) === null || _data === void 0 ? void 0 : _data.result.map(function (item) {
            return _objectSpread2(_objectSpread2({}, item), {}, {
              label: item === null || item === void 0 ? void 0 : item.display,
              value: item === null || item === void 0 ? void 0 : item.code
            });
          });
          return _context28.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context28.prev = 10;
          _context28.t0 = _context28["catch"](2);
          return _context28.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context28.t0.message
          })));

        case 13:
        case "end":
          return _context28.stop();
      }
    }
  }, _callee28, null, [[2, 10]]);
})));
var READ_STATUS_HISTORY = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/read_status_history", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
  var payload,
      _ref59,
      rejectWithValue,
      _data$result2,
      key,
      data,
      _args29 = arguments;

  return _regeneratorRuntime().wrap(function _callee29$(_context29) {
    while (1) {
      switch (_context29.prev = _context29.next) {
        case 0:
          payload = _args29.length > 0 && _args29[0] !== undefined ? _args29[0] : {};
          _ref59 = _args29.length > 1 ? _args29[1] : undefined, rejectWithValue = _ref59.rejectWithValue;
          _context29.prev = 2;
          key = payload.key;
          _context29.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery === null || pharmacyVerifierQuery === void 0 ? void 0 : pharmacyVerifierQuery.read_status_history(key))
          }, __readDocumentUrl__);

        case 6:
          data = _context29.sent;
          return _context29.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data === null || data === void 0 ? void 0 : (_data$result2 = data.result) === null || _data$result2 === void 0 ? void 0 : _data$result2[0]
          }));

        case 10:
          _context29.prev = 10;
          _context29.t0 = _context29["catch"](2);
          return _context29.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context29.t0.message
          })));

        case 13:
        case "end":
          return _context29.stop();
      }
    }
  }, _callee29, null, [[2, 10]]);
})));
var INSTRUCTION_MASTER_READ = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/instruction_master_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
  var _ref61,
      rejectWithValue,
      data,
      _args30 = arguments;

  return _regeneratorRuntime().wrap(function _callee30$(_context30) {
    while (1) {
      switch (_context30.prev = _context30.next) {
        case 0:
          _ref61 = _args30.length > 1 ? _args30[1] : undefined, rejectWithValue = _ref61.rejectWithValue;
          _context30.prev = 2;
          _context30.next = 5;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery === null || pharmacyVerifierQuery === void 0 ? void 0 : pharmacyVerifierQuery.instruction_master_read())
          }, __readDocumentUrl__);

        case 5:
          data = _context30.sent;
          return _context30.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data === null || data === void 0 ? void 0 : data.result
          }));

        case 9:
          _context30.prev = 9;
          _context30.t0 = _context30["catch"](2);
          return _context30.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context30.t0.message
          })));

        case 12:
        case "end":
          return _context30.stop();
      }
    }
  }, _callee30, null, [[2, 9]]);
})));
var DGET_DISPENSE_DURATION = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/get_dispense", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
  var payload,
      _ref63,
      rejectWithValue,
      list,
      dataCart,
      data,
      _args31 = arguments;

  return _regeneratorRuntime().wrap(function _callee31$(_context31) {
    while (1) {
      switch (_context31.prev = _context31.next) {
        case 0:
          payload = _args31.length > 0 && _args31[0] !== undefined ? _args31[0] : {};
          _ref63 = _args31.length > 1 ? _args31[1] : undefined, rejectWithValue = _ref63.rejectWithValue;
          _context31.prev = 2;
          list = payload.list;
          dataCart = list.isCart ? // [{ OrderId: "PH_OrderLine/10668" }]
          list === null || list === void 0 ? void 0 : list.map(function (v) {
            return {
              OrderId: v === null || v === void 0 ? void 0 : v.OrderId
            };
          }) : list;
          _context31.next = 7;
          return fetchData({
            body: JSON.stringify(dataCart)
          }, list.isCart ? __GetDispenseDurationByCart__ : __GetDispenseDuration__);

        case 7:
          data = _context31.sent;
          return _context31.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context31.prev = 11;
          _context31.t0 = _context31["catch"](2);
          return _context31.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context31.t0.message
          })));

        case 14:
        case "end":
          return _context31.stop();
      }
    }
  }, _callee31, null, [[2, 11]]);
})));
var GET_ORDER_DATE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/get_orderDate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
  var payload,
      _ref65,
      rejectWithValue,
      list,
      data,
      _args32 = arguments;

  return _regeneratorRuntime().wrap(function _callee32$(_context32) {
    while (1) {
      switch (_context32.prev = _context32.next) {
        case 0:
          payload = _args32.length > 0 && _args32[0] !== undefined ? _args32[0] : {};
          _ref65 = _args32.length > 1 ? _args32[1] : undefined, rejectWithValue = _ref65.rejectWithValue;
          _context32.prev = 2;
          list = payload;
          _context32.next = 6;
          return fetchData({
            body: JSON.stringify(list)
          }, __GetOrderDate__);

        case 6:
          data = _context32.sent;
          return _context32.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context32.prev = 10;
          _context32.t0 = _context32["catch"](2);
          return _context32.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context32.t0.message
          })));

        case 13:
        case "end":
          return _context32.stop();
      }
    }
  }, _callee32, null, [[2, 10]]);
})));
var RETURN_DRUG_TRANSACTION = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/return_drug_transaction", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
  var payload,
      _ref67,
      rejectWithValue,
      ids,
      body,
      data,
      _args33 = arguments;

  return _regeneratorRuntime().wrap(function _callee33$(_context33) {
    while (1) {
      switch (_context33.prev = _context33.next) {
        case 0:
          payload = _args33.length > 0 && _args33[0] !== undefined ? _args33[0] : {};
          _ref67 = _args33.length > 1 ? _args33[1] : undefined, rejectWithValue = _ref67.rejectWithValue;
          _context33.prev = 2;
          ids = payload.ids;
          body = {
            phOrderLineIds: (ids === null || ids === void 0 ? void 0 : ids.length) > 0 ? ids : []
          };
          _context33.next = 7;
          return fetchData({
            body: JSON.stringify(body)
          }, __ReturnDrug__);

        case 7:
          data = _context33.sent;
          return _context33.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context33.prev = 11;
          _context33.t0 = _context33["catch"](2);
          return _context33.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context33.t0.message
          })));

        case 14:
        case "end":
          return _context33.stop();
      }
    }
  }, _callee33, null, [[2, 11]]);
}))); // const GET_ACTIVE_MEDICATION_DATA_WITH_PH_ORDER_ID

var GET_ACTIVE_MEDICATION_DATA_WITH_PH_ORDER_ID = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/get_active_medication_data_with_ph_order_id", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
  var payload,
      _ref69,
      rejectWithValue,
      orderLineIds,
      queryId,
      fullReadQDMQuery,
      data,
      _args34 = arguments;

  return _regeneratorRuntime().wrap(function _callee34$(_context34) {
    while (1) {
      switch (_context34.prev = _context34.next) {
        case 0:
          payload = _args34.length > 0 && _args34[0] !== undefined ? _args34[0] : {};
          _ref69 = _args34.length > 1 ? _args34[1] : undefined, rejectWithValue = _ref69.rejectWithValue;
          _context34.prev = 2;
          orderLineIds = payload.orderLineIds;
          queryId = "9d00d18e-5c8c-45dd-b83f-a0e8b2a12647";
          fullReadQDMQuery = {
            db_name: dbName,
            queryid: queryId,
            filter: {
              orderlinid: (orderLineIds === null || orderLineIds === void 0 ? void 0 : orderLineIds.length) > 0 ? orderLineIds : []
            }
          };
          _context34.next = 8;
          return fetchData({
            body: JSON.stringify(fullReadQDMQuery)
          }, __baseUrl__);

        case 8:
          data = _context34.sent;
          return _context34.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 12:
          _context34.prev = 12;
          _context34.t0 = _context34["catch"](2);
          return _context34.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context34.t0.message
          })));

        case 15:
        case "end":
          return _context34.stop();
      }
    }
  }, _callee34, null, [[2, 12]]);
})));
var MEDICATION_REASON_DROPDOWN = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/return_medication_reason", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
  var payload,
      _ref71,
      rejectWithValue,
      _data$result3,
      _data$result3$,
      _data$result3$$newRet,
      drugId,
      data,
      arr,
      _args35 = arguments;

  return _regeneratorRuntime().wrap(function _callee35$(_context35) {
    while (1) {
      switch (_context35.prev = _context35.next) {
        case 0:
          payload = _args35.length > 0 && _args35[0] !== undefined ? _args35[0] : {};
          _ref71 = _args35.length > 1 ? _args35[1] : undefined, rejectWithValue = _ref71.rejectWithValue;
          _context35.prev = 2;
          drugId = payload.drugId;
          _context35.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.returnMedicatioReason(drugId))
          }, __readDocumentUrl__);

        case 6:
          data = _context35.sent;
          arr = [];
          data === null || data === void 0 ? void 0 : (_data$result3 = data.result) === null || _data$result3 === void 0 ? void 0 : (_data$result3$ = _data$result3[0]) === null || _data$result3$ === void 0 ? void 0 : (_data$result3$$newRet = _data$result3$.newReturnParams) === null || _data$result3$$newRet === void 0 ? void 0 : _data$result3$$newRet.map(function (v) {
            var _v$returnReason, _v$returnReason2;

            arr.push({
              label: v === null || v === void 0 ? void 0 : (_v$returnReason = v.returnReason) === null || _v$returnReason === void 0 ? void 0 : _v$returnReason.display,
              value: v === null || v === void 0 ? void 0 : (_v$returnReason2 = v.returnReason) === null || _v$returnReason2 === void 0 ? void 0 : _v$returnReason2._id,
              isapproval: v === null || v === void 0 ? void 0 : v.approvalReq
            });
          });
          return _context35.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context35.prev = 12;
          _context35.t0 = _context35["catch"](2);
          return _context35.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context35.t0.message
          })));

        case 15:
        case "end":
          return _context35.stop();
      }
    }
  }, _callee35, null, [[2, 12]]);
})));
var DISPENSE_HISTORY_READ = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/dispense_history_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
  var payload,
      _ref73,
      rejectWithValue,
      id,
      data,
      _args36 = arguments;

  return _regeneratorRuntime().wrap(function _callee36$(_context36) {
    while (1) {
      switch (_context36.prev = _context36.next) {
        case 0:
          payload = _args36.length > 0 && _args36[0] !== undefined ? _args36[0] : {};
          _ref73 = _args36.length > 1 ? _args36[1] : undefined, rejectWithValue = _ref73.rejectWithValue;
          _context36.prev = 2;
          id = payload.id;
          _context36.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery === null || pharmacyVerifierQuery === void 0 ? void 0 : pharmacyVerifierQuery.dispense_history_read(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context36.sent;
          return _context36.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data === null || data === void 0 ? void 0 : data.result
          }));

        case 10:
          _context36.prev = 10;
          _context36.t0 = _context36["catch"](2);
          return _context36.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context36.t0.message
          })));

        case 13:
        case "end":
          return _context36.stop();
      }
    }
  }, _callee36, null, [[2, 10]]);
}))); //reading CART_NAME

var CART_NAME = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/cart_name", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
  var payload,
      _ref75,
      rejectWithValue,
      open,
      data,
      _args37 = arguments;

  return _regeneratorRuntime().wrap(function _callee37$(_context37) {
    while (1) {
      switch (_context37.prev = _context37.next) {
        case 0:
          payload = _args37.length > 0 && _args37[0] !== undefined ? _args37[0] : {};
          _ref75 = _args37.length > 1 ? _args37[1] : undefined, rejectWithValue = _ref75.rejectWithValue;
          _context37.prev = 2;
          open = payload.open;
          _context37.next = 6;
          return fetchData({
            body: JSON.stringify(open ? pharmacyVerifierQuery.cartName() : pharmacyVerifierQuery.cartNamePending())
          }, __readDocumentUrl__);

        case 6:
          data = _context37.sent;
          return _context37.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context37.prev = 10;
          _context37.t0 = _context37["catch"](2);
          return _context37.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context37.t0.message
          })));

        case 13:
        case "end":
          return _context37.stop();
      }
    }
  }, _callee37, null, [[2, 10]]);
}))); //reading SUB_STORE

var SUB_STORE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/sub_store", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
  var payload,
      _ref77,
      rejectWithValue,
      id,
      data,
      _args38 = arguments;

  return _regeneratorRuntime().wrap(function _callee38$(_context38) {
    while (1) {
      switch (_context38.prev = _context38.next) {
        case 0:
          payload = _args38.length > 0 && _args38[0] !== undefined ? _args38[0] : {};
          _ref77 = _args38.length > 1 ? _args38[1] : undefined, rejectWithValue = _ref77.rejectWithValue;
          _context38.prev = 2;
          id = payload.id;
          _context38.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.subStore(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context38.sent;
          return _context38.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context38.prev = 10;
          _context38.t0 = _context38["catch"](2);
          return _context38.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context38.t0.message
          })));

        case 13:
        case "end":
          return _context38.stop();
      }
    }
  }, _callee38, null, [[2, 10]]);
}))); //reading CART_GENERATE

var CART_GENERATE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/cart_generate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
  var payload,
      _ref79,
      rejectWithValue,
      cartid,
      carttrxid,
      data,
      _args39 = arguments;

  return _regeneratorRuntime().wrap(function _callee39$(_context39) {
    while (1) {
      switch (_context39.prev = _context39.next) {
        case 0:
          payload = _args39.length > 0 && _args39[0] !== undefined ? _args39[0] : {};
          _ref79 = _args39.length > 1 ? _args39[1] : undefined, rejectWithValue = _ref79.rejectWithValue;
          _context39.prev = 2;
          cartid = payload.cartid, carttrxid = payload.carttrxid;
          _context39.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.cartGenerate(cartid, carttrxid))
          }, __baseUrl__);

        case 6:
          data = _context39.sent;
          return _context39.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context39.prev = 10;
          _context39.t0 = _context39["catch"](2);
          return _context39.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context39.t0.message
          })));

        case 13:
        case "end":
          return _context39.stop();
      }
    }
  }, _callee39, null, [[2, 10]]);
}))); //reading OPEN_CART

var OPEN_CART = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/open_cart", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
  var payload,
      _ref81,
      rejectWithValue,
      _list$carttransid,
      _list$cartid,
      _list$enterpriseid,
      _list$enterprisealias,
      _list$orgid,
      _list$orgaliasid,
      _list$facilityid,
      _list$facilityaliasid,
      _list$invlocationid,
      _list$invlocationcode,
      _list$orderLineId,
      list,
      data,
      _args40 = arguments;

  return _regeneratorRuntime().wrap(function _callee40$(_context40) {
    while (1) {
      switch (_context40.prev = _context40.next) {
        case 0:
          payload = _args40.length > 0 && _args40[0] !== undefined ? _args40[0] : {};
          _ref81 = _args40.length > 1 ? _args40[1] : undefined, rejectWithValue = _ref81.rejectWithValue;
          _context40.prev = 2;
          list = payload;
          _context40.next = 6;
          return fetchData({
            body: JSON.stringify([{
              carttransid: (_list$carttransid = list === null || list === void 0 ? void 0 : list.carttransid) !== null && _list$carttransid !== void 0 ? _list$carttransid : "",
              cartid: (_list$cartid = list === null || list === void 0 ? void 0 : list.cartid) !== null && _list$cartid !== void 0 ? _list$cartid : "",
              enterpriseid: (_list$enterpriseid = list === null || list === void 0 ? void 0 : list.enterpriseid) !== null && _list$enterpriseid !== void 0 ? _list$enterpriseid : "",
              enterprisealiasid: (_list$enterprisealias = list === null || list === void 0 ? void 0 : list.enterprisealiasid) !== null && _list$enterprisealias !== void 0 ? _list$enterprisealias : "",
              orgid: (_list$orgid = list === null || list === void 0 ? void 0 : list.orgid) !== null && _list$orgid !== void 0 ? _list$orgid : "",
              orgaliasid: (_list$orgaliasid = list === null || list === void 0 ? void 0 : list.orgaliasid) !== null && _list$orgaliasid !== void 0 ? _list$orgaliasid : "",
              facilityid: (_list$facilityid = list === null || list === void 0 ? void 0 : list.facilityid) !== null && _list$facilityid !== void 0 ? _list$facilityid : "",
              facilityaliasid: (_list$facilityaliasid = list === null || list === void 0 ? void 0 : list.facilityaliasid) !== null && _list$facilityaliasid !== void 0 ? _list$facilityaliasid : "",
              invlocationid: (_list$invlocationid = list === null || list === void 0 ? void 0 : list.invlocationid) !== null && _list$invlocationid !== void 0 ? _list$invlocationid : "",
              invlocationcode: (_list$invlocationcode = list === null || list === void 0 ? void 0 : list.invlocationcode) !== null && _list$invlocationcode !== void 0 ? _list$invlocationcode : "",
              orderLineId: (_list$orderLineId = list === null || list === void 0 ? void 0 : list.orderLineId) !== null && _list$orderLineId !== void 0 ? _list$orderLineId : ""
            }])
          }, __OpenCart__);

        case 6:
          data = _context40.sent;
          return _context40.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context40.prev = 10;
          _context40.t0 = _context40["catch"](2);
          return _context40.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context40.t0.message
          })));

        case 13:
        case "end":
          return _context40.stop();
      }
    }
  }, _callee40, null, [[2, 10]]);
}))); //reading GET_TRANSACTION

var GET_TRANSACTION = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/get_transaction", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
  var payload,
      _ref83,
      rejectWithValue,
      cartid,
      data,
      _args41 = arguments;

  return _regeneratorRuntime().wrap(function _callee41$(_context41) {
    while (1) {
      switch (_context41.prev = _context41.next) {
        case 0:
          payload = _args41.length > 0 && _args41[0] !== undefined ? _args41[0] : {};
          _ref83 = _args41.length > 1 ? _args41[1] : undefined, rejectWithValue = _ref83.rejectWithValue;
          _context41.prev = 2;
          cartid = payload.cartid;
          _context41.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.getTransaction(cartid))
          }, __readDocumentUrl__);

        case 6:
          data = _context41.sent;
          return _context41.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context41.prev = 10;
          _context41.t0 = _context41["catch"](2);
          return _context41.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context41.t0.message
          })));

        case 13:
        case "end":
          return _context41.stop();
      }
    }
  }, _callee41, null, [[2, 10]]);
}))); //reading CLOSE_CART

var CLOSE_CART = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/close_cart", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
  var payload,
      _ref85,
      rejectWithValue,
      _list$CartId,
      _list$LocationId,
      list,
      data,
      _args42 = arguments;

  return _regeneratorRuntime().wrap(function _callee42$(_context42) {
    while (1) {
      switch (_context42.prev = _context42.next) {
        case 0:
          payload = _args42.length > 0 && _args42[0] !== undefined ? _args42[0] : {};
          _ref85 = _args42.length > 1 ? _args42[1] : undefined, rejectWithValue = _ref85.rejectWithValue;
          _context42.prev = 2;
          list = payload;
          _context42.next = 6;
          return fetchData({
            body: JSON.stringify({
              CartId: (_list$CartId = list === null || list === void 0 ? void 0 : list.CartId) !== null && _list$CartId !== void 0 ? _list$CartId : "",
              LocationId: (_list$LocationId = list === null || list === void 0 ? void 0 : list.LocationId) !== null && _list$LocationId !== void 0 ? _list$LocationId : ""
            })
          }, __CloseCart__);

        case 6:
          data = _context42.sent;
          return _context42.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context42.prev = 10;
          _context42.t0 = _context42["catch"](2);
          return _context42.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context42.t0.message
          })));

        case 13:
        case "end":
          return _context42.stop();
      }
    }
  }, _callee42, null, [[2, 10]]);
}))); //reading CART_REASON

var CART_REASON = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/cart_reason", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
  var _ref87,
      rejectWithValue,
      data,
      _args43 = arguments;

  return _regeneratorRuntime().wrap(function _callee43$(_context43) {
    while (1) {
      switch (_context43.prev = _context43.next) {
        case 0:
          _ref87 = _args43.length > 1 ? _args43[1] : undefined, rejectWithValue = _ref87.rejectWithValue;
          _context43.prev = 2;
          _context43.next = 5;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.cartReason())
          }, __readDocumentUrl__);

        case 5:
          data = _context43.sent;
          return _context43.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 9:
          _context43.prev = 9;
          _context43.t0 = _context43["catch"](2);
          return _context43.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context43.t0.message
          })));

        case 12:
        case "end":
          return _context43.stop();
      }
    }
  }, _callee43, null, [[2, 9]]);
}))); //QUEUE LIST

var GETQUEUELIST = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/getQueueList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
  var _ref89,
      rejectWithValue,
      _data$result4,
      _data$result4$,
      _data$result4$$scenar,
      data,
      Scenarios,
      fillteredScenariosStates,
      obj,
      fillteredValue,
      _args44 = arguments;

  return _regeneratorRuntime().wrap(function _callee44$(_context44) {
    while (1) {
      switch (_context44.prev = _context44.next) {
        case 0:
          _ref89 = _args44.length > 1 ? _args44[1] : undefined, rejectWithValue = _ref89.rejectWithValue;
          _context44.prev = 2;
          _context44.next = 5;
          return fetchDataQueueList(__GetQueueList__);

        case 5:
          data = _context44.sent;
          Scenarios = []; //let ScenarioObj = {};

          (_data$result4 = data.result) === null || _data$result4 === void 0 ? void 0 : (_data$result4$ = _data$result4[0]) === null || _data$result4$ === void 0 ? void 0 : (_data$result4$$scenar = _data$result4$.scenarioChildren) === null || _data$result4$$scenar === void 0 ? void 0 : _data$result4$$scenar.forEach(function (scenario) {
            if (scenario.permsndelete || scenario !== null && scenario !== void 0 && scenario.permsnread || scenario !== null && scenario !== void 0 && scenario.permsnupdate || scenario !== null && scenario !== void 0 && scenario.permsnwrite) {
              var _scenario$repoid, _scenario$repoid2, _scenario$repodetails, _scenario$stateChildr;

              //Scenario Start
              var _obj = {};
              _obj.scenarioId = scenario === null || scenario === void 0 ? void 0 : (_scenario$repoid = scenario.repoid) === null || _scenario$repoid === void 0 ? void 0 : _scenario$repoid.unique_id;
              _obj.scenarioName = scenario === null || scenario === void 0 ? void 0 : (_scenario$repoid2 = scenario.repoid) === null || _scenario$repoid2 === void 0 ? void 0 : _scenario$repoid2.rep_name;
              _obj.queueId = (_scenario$repodetails = scenario.repodetails) === null || _scenario$repodetails === void 0 ? void 0 : _scenario$repodetails.queueid;
              var States = []; //State start

              scenario === null || scenario === void 0 ? void 0 : (_scenario$stateChildr = scenario.stateChildren) === null || _scenario$stateChildr === void 0 ? void 0 : _scenario$stateChildr.forEach(function (state) {
                if (state.permsndelete || state !== null && state !== void 0 && state.permsnread || state !== null && state !== void 0 && state.permsnupdate || state !== null && state !== void 0 && state.permsnwrite) {
                  var _state$repoid, _state$repoid2, _state$repodetails, _state$repodetails$se, _state$actionChildren;

                  var stateObj = {};
                  stateObj.stateId = state === null || state === void 0 ? void 0 : (_state$repoid = state.repoid) === null || _state$repoid === void 0 ? void 0 : _state$repoid.unique_id;
                  stateObj.stateName = state === null || state === void 0 ? void 0 : (_state$repoid2 = state.repoid) === null || _state$repoid2 === void 0 ? void 0 : _state$repoid2.rep_name;
                  stateObj.seqno = (_state$repodetails = state.repodetails) === null || _state$repodetails === void 0 ? void 0 : (_state$repodetails$se = _state$repodetails.seqno) === null || _state$repodetails$se === void 0 ? void 0 : _state$repodetails$se[0]; //Action start

                  var Actions = [];
                  state === null || state === void 0 ? void 0 : (_state$actionChildren = state.actionChildren) === null || _state$actionChildren === void 0 ? void 0 : _state$actionChildren.forEach(function (action) {
                    if (action.permsndelete || action !== null && action !== void 0 && action.permsnread || action !== null && action !== void 0 && action.permsnupdate || action !== null && action !== void 0 && action.permsnwrite) {
                      var _action$repodetails, _action$repoid, _action$repodetails2, _action$repodetails3, _action$repodetails4;

                      var actionObj = {};
                      actionObj.actionid = action === null || action === void 0 ? void 0 : (_action$repodetails = action.repodetails) === null || _action$repodetails === void 0 ? void 0 : _action$repodetails.actionid;
                      actionObj.action = action === null || action === void 0 ? void 0 : (_action$repoid = action.repoid) === null || _action$repoid === void 0 ? void 0 : _action$repoid.rep_name;
                      actionObj.apiendpoint = action === null || action === void 0 ? void 0 : (_action$repodetails2 = action.repodetails) === null || _action$repodetails2 === void 0 ? void 0 : _action$repodetails2.apiendpoint;
                      actionObj.chooseform = action === null || action === void 0 ? void 0 : (_action$repodetails3 = action.repodetails) === null || _action$repodetails3 === void 0 ? void 0 : _action$repodetails3.chooseform;
                      actionObj.choosetype = action === null || action === void 0 ? void 0 : (_action$repodetails4 = action.repodetails) === null || _action$repodetails4 === void 0 ? void 0 : _action$repodetails4.choosetype;
                      Actions.push(actionObj);
                    }
                  });
                  stateObj.actions = Actions;
                  States.push(stateObj);
                }
              });
              _obj.states = States; //ScenarioObj[scenario?.repoid?.rep_name] = obj;

              Scenarios.push(_obj);
            }
          });
          fillteredScenariosStates = [];
          Scenarios === null || Scenarios === void 0 ? void 0 : Scenarios.forEach(function (val) {
            val === null || val === void 0 ? void 0 : val.states.forEach(function (state) {
              fillteredScenariosStates.push({
                id: state === null || state === void 0 ? void 0 : state.stateId,
                label: state === null || state === void 0 ? void 0 : state.stateName,
                //count: state?.reccount,
                seqno: state === null || state === void 0 ? void 0 : state.seqno,
                scenarioid: val === null || val === void 0 ? void 0 : val.scenarioId,
                queueid: val === null || val === void 0 ? void 0 : val.queueId,
                scenrioname: val === null || val === void 0 ? void 0 : val.scenarioName,
                actions: state === null || state === void 0 ? void 0 : state.actions
              });
            });
          });
          obj = {};
          fillteredScenariosStates.forEach(function (val) {
            var ID = val.id;

            if (ID in obj) {
              //obj[val.id].count = obj[val.id].count + val.count;
              obj[val.id] = _objectSpread2(_objectSpread2({}, obj[val.id]), {}, _defineProperty({}, val === null || val === void 0 ? void 0 : val.scenrioname, val === null || val === void 0 ? void 0 : val.actions));
            } else {
              var Scenario = {
                id: val === null || val === void 0 ? void 0 : val.id,
                label: val === null || val === void 0 ? void 0 : val.label,
                seqno: val === null || val === void 0 ? void 0 : val.seqno,
                scenarioid: val === null || val === void 0 ? void 0 : val.scenarioid,
                queueid: val === null || val === void 0 ? void 0 : val.queueid,
                scenrioname: val === null || val === void 0 ? void 0 : val.scenrioname
              };
              obj[val.id] = _objectSpread2(_objectSpread2({}, Scenario), {}, _defineProperty({}, val === null || val === void 0 ? void 0 : val.scenrioname, val === null || val === void 0 ? void 0 : val.actions));
            }
          });
          fillteredValue = Object.values(obj); //let sortedValue = fillteredValue.sort((a, b) => a.seqno - b.seqno);

          return _context44.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: fillteredValue
          }));

        case 16:
          _context44.prev = 16;
          _context44.t0 = _context44["catch"](2);
          return _context44.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context44.t0.message
          })));

        case 19:
        case "end":
          return _context44.stop();
      }
    }
  }, _callee44, null, [[2, 16]]);
}))); //ACCESSQUEUE

var GETACCESSQUEUE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/getAccessQueue", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
  var _ref91,
      rejectWithValue,
      _data$result5,
      _data$result5$,
      _data$result5$$repode,
      data,
      _args45 = arguments;

  return _regeneratorRuntime().wrap(function _callee45$(_context45) {
    while (1) {
      switch (_context45.prev = _context45.next) {
        case 0:
          _ref91 = _args45.length > 1 ? _args45[1] : undefined, rejectWithValue = _ref91.rejectWithValue;
          _context45.prev = 2;
          _context45.next = 5;
          return fetchDataQueueList(__GetQueueList__);

        case 5:
          data = _context45.sent;
          return _context45.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: (_data$result5 = data.result) === null || _data$result5 === void 0 ? void 0 : (_data$result5$ = _data$result5[0]) === null || _data$result5$ === void 0 ? void 0 : (_data$result5$$repode = _data$result5$.repodetails) === null || _data$result5$$repode === void 0 ? void 0 : _data$result5$$repode._id
          }));

        case 9:
          _context45.prev = 9;
          _context45.t0 = _context45["catch"](2);
          return _context45.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context45.t0.message
          })));

        case 12:
        case "end":
          return _context45.stop();
      }
    }
  }, _callee45, null, [[2, 9]]);
}))); //QUEUE LIST

var ACCESSEDSCENARIOS = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/accessedScenarios", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
  var _ref93,
      rejectWithValue,
      _data$result6,
      _data$result6$,
      _data$result6$$scenar,
      data,
      Scenarios,
      _args46 = arguments;

  return _regeneratorRuntime().wrap(function _callee46$(_context46) {
    while (1) {
      switch (_context46.prev = _context46.next) {
        case 0:
          _ref93 = _args46.length > 1 ? _args46[1] : undefined, rejectWithValue = _ref93.rejectWithValue;
          _context46.prev = 2;
          _context46.next = 5;
          return fetchDataQueueList(__GetQueueList__);

        case 5:
          data = _context46.sent;
          Scenarios = []; //let ScenarioObj = {};

          (_data$result6 = data.result) === null || _data$result6 === void 0 ? void 0 : (_data$result6$ = _data$result6[0]) === null || _data$result6$ === void 0 ? void 0 : (_data$result6$$scenar = _data$result6$.scenarioChildren) === null || _data$result6$$scenar === void 0 ? void 0 : _data$result6$$scenar.forEach(function (scenario) {
            if (scenario.permsndelete || scenario !== null && scenario !== void 0 && scenario.permsnread || scenario !== null && scenario !== void 0 && scenario.permsnupdate || scenario !== null && scenario !== void 0 && scenario.permsnwrite) {
              var _scenario$repoid3, _scenario$repoid4;

              //Scenario Start
              var obj = {};
              obj.scenarioid = scenario === null || scenario === void 0 ? void 0 : (_scenario$repoid3 = scenario.repoid) === null || _scenario$repoid3 === void 0 ? void 0 : _scenario$repoid3.unique_id;
              obj.scenarioName = scenario === null || scenario === void 0 ? void 0 : (_scenario$repoid4 = scenario.repoid) === null || _scenario$repoid4 === void 0 ? void 0 : _scenario$repoid4.rep_name;
              Scenarios.push(obj);
            }
          });
          return _context46.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: Scenarios
          }));

        case 11:
          _context46.prev = 11;
          _context46.t0 = _context46["catch"](2);
          return _context46.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context46.t0.message
          })));

        case 14:
        case "end":
          return _context46.stop();
      }
    }
  }, _callee46, null, [[2, 11]]);
}))); //ORDERCOUNT

var ORDERCOUNT = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/orderCount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
  var payload,
      _ref95,
      rejectWithValue,
      getState,
      _state$phramcyFramewo7,
      _state$phramcyFramewo8,
      _state$phramcyFramewo9,
      _state$phramcyFramewo10,
      _state$phramcyFramewo11,
      _state$phramcyFramewo12,
      _data$,
      queueId,
      patientid,
      state,
      ScenarioId,
      StateId,
      data,
      States,
      obj,
      _args47 = arguments;

  return _regeneratorRuntime().wrap(function _callee47$(_context47) {
    while (1) {
      switch (_context47.prev = _context47.next) {
        case 0:
          payload = _args47.length > 0 && _args47[0] !== undefined ? _args47[0] : {};
          _ref95 = _args47.length > 1 ? _args47[1] : undefined, rejectWithValue = _ref95.rejectWithValue, getState = _ref95.getState;
          _context47.prev = 2;
          queueId = payload.queueId, patientid = payload.patientid;
          state = getState();
          ScenarioId = state === null || state === void 0 ? void 0 : (_state$phramcyFramewo7 = state.phramcyFrameworkApiSlice) === null || _state$phramcyFramewo7 === void 0 ? void 0 : (_state$phramcyFramewo8 = _state$phramcyFramewo7.getScenarioList) === null || _state$phramcyFramewo8 === void 0 ? void 0 : (_state$phramcyFramewo9 = _state$phramcyFramewo8.data) === null || _state$phramcyFramewo9 === void 0 ? void 0 : _state$phramcyFramewo9.map(function (val) {
            return val === null || val === void 0 ? void 0 : val.scenarioid;
          });
          ScenarioId = _toConsumableArray(new Set(ScenarioId));
          StateId = state === null || state === void 0 ? void 0 : (_state$phramcyFramewo10 = state.phramcyFrameworkApiSlice) === null || _state$phramcyFramewo10 === void 0 ? void 0 : (_state$phramcyFramewo11 = _state$phramcyFramewo10.pharmacyGettingState) === null || _state$phramcyFramewo11 === void 0 ? void 0 : (_state$phramcyFramewo12 = _state$phramcyFramewo11.data) === null || _state$phramcyFramewo12 === void 0 ? void 0 : _state$phramcyFramewo12.map(function (val) {
            return val === null || val === void 0 ? void 0 : val.id;
          });
          StateId = _toConsumableArray(new Set(StateId));
          _context47.next = 11;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.orderCount(queueId, patientid, ScenarioId, StateId))
          }, __baseUrl__);

        case 11:
          data = _context47.sent;
          States = [];
          data === null || data === void 0 ? void 0 : (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.forEach(function (scenario) {
            scenario === null || scenario === void 0 ? void 0 : scenario.states.forEach(function (state) {
              States.push(state);
            });
          });
          obj = {};
          States.forEach(function (val) {
            var ID = val.states;

            if (ID in obj) {
              obj[val === null || val === void 0 ? void 0 : val.states] += val.reccount;
            } else {
              obj[val.states] = val === null || val === void 0 ? void 0 : val.reccount;
            }
          });
          return _context47.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: obj
          }));

        case 19:
          _context47.prev = 19;
          _context47.t0 = _context47["catch"](2);
          return _context47.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context47.t0.message
          })));

        case 22:
        case "end":
          return _context47.stop();
      }
    }
  }, _callee47, null, [[2, 19]]);
}))); //Add drug

var ADDDRUG = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/addDrug", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
  var _ref97,
      rejectWithValue,
      data,
      _args48 = arguments;

  return _regeneratorRuntime().wrap(function _callee48$(_context48) {
    while (1) {
      switch (_context48.prev = _context48.next) {
        case 0:
          _ref97 = _args48.length > 1 ? _args48[1] : undefined, rejectWithValue = _ref97.rejectWithValue, _ref97.getState;
          _context48.prev = 2;
          _context48.next = 5;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.addDrug())
          }, __readDocumentUrl__);

        case 5:
          data = _context48.sent;
          return _context48.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 9:
          _context48.prev = 9;
          _context48.t0 = _context48["catch"](2);
          return _context48.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context48.t0.message
          })));

        case 12:
        case "end":
          return _context48.stop();
      }
    }
  }, _callee48, null, [[2, 9]]);
})));
var DRUG_AGAINST_DRUGTYPE = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/drugAgainstDrugType", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
  var payload,
      _ref99,
      rejectWithValue,
      id,
      data,
      _args49 = arguments;

  return _regeneratorRuntime().wrap(function _callee49$(_context49) {
    while (1) {
      switch (_context49.prev = _context49.next) {
        case 0:
          payload = _args49.length > 0 && _args49[0] !== undefined ? _args49[0] : {};
          _ref99 = _args49.length > 1 ? _args49[1] : undefined, rejectWithValue = _ref99.rejectWithValue, _ref99.getState;
          _context49.prev = 2;
          id = payload.id;
          _context49.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.drugType_against_drug(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context49.sent;
          return _context49.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context49.prev = 10;
          _context49.t0 = _context49["catch"](2);
          return _context49.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context49.t0.message
          })));

        case 13:
        case "end":
          return _context49.stop();
      }
    }
  }, _callee49, null, [[2, 10]]);
})));
var READ_ISSUE_MEDICATION = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/readIssueMedication", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
  var payload,
      _ref101,
      rejectWithValue,
      id,
      data,
      arr,
      _args50 = arguments;

  return _regeneratorRuntime().wrap(function _callee50$(_context50) {
    while (1) {
      switch (_context50.prev = _context50.next) {
        case 0:
          payload = _args50.length > 0 && _args50[0] !== undefined ? _args50[0] : {};
          _ref101 = _args50.length > 1 ? _args50[1] : undefined, rejectWithValue = _ref101.rejectWithValue, _ref101.getState;
          _context50.prev = 2;
          id = payload.id;
          _context50.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.issueMedication(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context50.sent;
          arr = [];
          data.result.map(function (v, i) {
            var _v$dosedatetime, _v$doseuom, _v$admuom, _v$issueuom;

            return arr.push(_objectSpread2(_objectSpread2({}, v), {}, {
              sNo: i + 1,
              doseDateTime: (_v$dosedatetime = v === null || v === void 0 ? void 0 : v.dosedatetime) !== null && _v$dosedatetime !== void 0 ? _v$dosedatetime : "",
              doeUOM: (v === null || v === void 0 ? void 0 : v.dose) + " " + (v === null || v === void 0 ? void 0 : (_v$doseuom = v.doseuom) === null || _v$doseuom === void 0 ? void 0 : _v$doseuom.UOM),
              AadminUOM: (v === null || v === void 0 ? void 0 : v.admqty) + " " + (v === null || v === void 0 ? void 0 : (_v$admuom = v.admuom) === null || _v$admuom === void 0 ? void 0 : _v$admuom.UOM),
              IssueQNY: (v === null || v === void 0 ? void 0 : v.issueqty) + " " + (v === null || v === void 0 ? void 0 : (_v$issueuom = v.issueuom) === null || _v$issueuom === void 0 ? void 0 : _v$issueuom.UOM),
              action: false
            }));
          });
          return _context50.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context50.prev = 12;
          _context50.t0 = _context50["catch"](2);
          return _context50.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context50.t0.message
          })));

        case 15:
        case "end":
          return _context50.stop();
      }
    }
  }, _callee50, null, [[2, 12]]);
})));
var ISSUE_MEDICATION = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/issueMedication", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee51() {
  var payload,
      _ref103,
      rejectWithValue,
      Json,
      data,
      _args51 = arguments;

  return _regeneratorRuntime().wrap(function _callee51$(_context51) {
    while (1) {
      switch (_context51.prev = _context51.next) {
        case 0:
          payload = _args51.length > 0 && _args51[0] !== undefined ? _args51[0] : {};
          _ref103 = _args51.length > 1 ? _args51[1] : undefined, rejectWithValue = _ref103.rejectWithValue, _ref103.getState;
          _context51.prev = 2;
          Json = payload.Json;
          _context51.next = 6;
          return fetchData({
            body: JSON.stringify(Json)
          }, __reIssueMedication__);

        case 6:
          data = _context51.sent;
          return _context51.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context51.prev = 10;
          _context51.t0 = _context51["catch"](2);
          return _context51.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context51.t0.message
          })));

        case 13:
        case "end":
          return _context51.stop();
      }
    }
  }, _callee51, null, [[2, 10]]);
})));
var REISSUE_REASON_DROPDOWN = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/reissue_medication_reason", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
  var _ref105,
      rejectWithValue,
      _data$result7,
      data,
      arr,
      _args52 = arguments;

  return _regeneratorRuntime().wrap(function _callee52$(_context52) {
    while (1) {
      switch (_context52.prev = _context52.next) {
        case 0:
          _ref105 = _args52.length > 1 ? _args52[1] : undefined, rejectWithValue = _ref105.rejectWithValue;
          _context52.prev = 2;
          _context52.next = 5;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.reIssueMedicatioReason())
          }, __readDocumentUrl__);

        case 5:
          data = _context52.sent;
          arr = [];
          data === null || data === void 0 ? void 0 : (_data$result7 = data.result) === null || _data$result7 === void 0 ? void 0 : _data$result7.map(function (v) {
            var _v$code, _v$status, _v$id;

            arr.push({
              label: v === null || v === void 0 ? void 0 : v.display,
              value: v === null || v === void 0 ? void 0 : v._id,
              code: (_v$code = v === null || v === void 0 ? void 0 : v.code) !== null && _v$code !== void 0 ? _v$code : "",
              status: (_v$status = v === null || v === void 0 ? void 0 : v.status) !== null && _v$status !== void 0 ? _v$status : false,
              id: (_v$id = v === null || v === void 0 ? void 0 : v.id) !== null && _v$id !== void 0 ? _v$id : ""
            });
          });
          return _context52.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context52.prev = 11;
          _context52.t0 = _context52["catch"](2);
          return _context52.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context52.t0.message
          })));

        case 14:
        case "end":
          return _context52.stop();
      }
    }
  }, _callee52, null, [[2, 11]]);
})));
var GET_PRIORITY_LIST = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/get_priority_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
  var payload,
      _ref107,
      rejectWithValue,
      _data$result8,
      _data$result8$,
      QueueID,
      data,
      arr,
      SortedValue,
      _args53 = arguments;

  return _regeneratorRuntime().wrap(function _callee53$(_context53) {
    while (1) {
      switch (_context53.prev = _context53.next) {
        case 0:
          payload = _args53.length > 0 && _args53[0] !== undefined ? _args53[0] : {};
          _ref107 = _args53.length > 1 ? _args53[1] : undefined, rejectWithValue = _ref107.rejectWithValue;
          _context53.prev = 2;
          QueueID = payload.QueueID;
          _context53.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.queue(QueueID))
          }, __readDocumentUrl__);

        case 6:
          data = _context53.sent;
          arr = [{
            label: "All",
            priority: 0,
            id: "",
            count: 0,
            icon: "All",
            activeIcon: "All",
            bgcolor: "#01205C",
            textcolor: "#fff"
          }];
          data === null || data === void 0 ? void 0 : (_data$result8 = data.result) === null || _data$result8 === void 0 ? void 0 : (_data$result8$ = _data$result8[0]) === null || _data$result8$ === void 0 ? void 0 : _data$result8$.map(function (v) {
            var _v$groupid;

            arr.push({
              label: v === null || v === void 0 ? void 0 : v.groupname,
              priority: parseInt(v === null || v === void 0 ? void 0 : v.priority),
              id: (_v$groupid = v === null || v === void 0 ? void 0 : v.groupid) !== null && _v$groupid !== void 0 ? _v$groupid : "",
              count: 0,
              icon: v === null || v === void 0 ? void 0 : v.groupicon,
              activeIcon: v === null || v === void 0 ? void 0 : v.hovericon,
              bgcolor: v === null || v === void 0 ? void 0 : v.bgcolor,
              textcolor: v === null || v === void 0 ? void 0 : v.textcolor
            });
          });
          SortedValue = arr.sort(function (a, b) {
            return a.priority - b.priority;
          });
          return _context53.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: SortedValue
          }));

        case 13:
          _context53.prev = 13;
          _context53.t0 = _context53["catch"](2);
          return _context53.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context53.t0.message
          })));

        case 16:
        case "end":
          return _context53.stop();
      }
    }
  }, _callee53, null, [[2, 13]]);
})));
var QUEUE_COUNT = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/get_queue_count", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee54() {
  var payload,
      _ref109,
      rejectWithValue,
      getState,
      _state$signInReducerA23,
      _state$signInReducerA24,
      QueueID,
      groupList,
      state,
      practitionerData,
      Prirority,
      data,
      _args54 = arguments;

  return _regeneratorRuntime().wrap(function _callee54$(_context54) {
    while (1) {
      switch (_context54.prev = _context54.next) {
        case 0:
          payload = _args54.length > 0 && _args54[0] !== undefined ? _args54[0] : {};
          _ref109 = _args54.length > 1 ? _args54[1] : undefined, rejectWithValue = _ref109.rejectWithValue, getState = _ref109.getState;
          _context54.prev = 2;
          QueueID = payload.QueueID, groupList = payload.groupList;
          state = getState();
          practitionerData = state === null || state === void 0 ? void 0 : (_state$signInReducerA23 = state.signInReducerApiSlice) === null || _state$signInReducerA23 === void 0 ? void 0 : (_state$signInReducerA24 = _state$signInReducerA23.loggedUserInfo) === null || _state$signInReducerA24 === void 0 ? void 0 : _state$signInReducerA24.data;
          Prirority = groupList === null || groupList === void 0 ? void 0 : groupList.map(function (v) {
            return v === null || v === void 0 ? void 0 : v.id;
          });
          _context54.next = 9;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.queueCount(QueueID, practitionerData, Prirority))
          }, __baseUrl__);

        case 9:
          data = _context54.sent;
          return _context54.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 13:
          _context54.prev = 13;
          _context54.t0 = _context54["catch"](2);
          return _context54.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context54.t0.message
          })));

        case 16:
        case "end":
          return _context54.stop();
      }
    }
  }, _callee54, null, [[2, 13]]);
})));
var UPDATE_STATUS_CART = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/update_cart", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
  var payload,
      _ref111,
      rejectWithValue,
      getState,
      _state$signInReducerA25,
      _state$signInReducerA26,
      _practitionerData$pra,
      _data$result$0$_id,
      _data$result9,
      _data$result9$,
      key,
      json,
      state,
      practitionerData,
      data,
      res,
      _args55 = arguments;

  return _regeneratorRuntime().wrap(function _callee55$(_context55) {
    while (1) {
      switch (_context55.prev = _context55.next) {
        case 0:
          payload = _args55.length > 0 && _args55[0] !== undefined ? _args55[0] : {};
          _ref111 = _args55.length > 1 ? _args55[1] : undefined, rejectWithValue = _ref111.rejectWithValue, getState = _ref111.getState;
          _context55.prev = 2;
          key = payload.key, json = payload.json;
          state = getState();
          practitionerData = state === null || state === void 0 ? void 0 : (_state$signInReducerA25 = state.signInReducerApiSlice) === null || _state$signInReducerA25 === void 0 ? void 0 : (_state$signInReducerA26 = _state$signInReducerA25.loggedUserInfo) === null || _state$signInReducerA26 === void 0 ? void 0 : _state$signInReducerA26.data;
          console.log("practitionerData", practitionerData);
          _context55.next = 9;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.cartReadStatus())
          }, __readDocumentUrl__);

        case 9:
          data = _context55.sent;
          _context55.next = 12;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.cartUpdateStatus(key, (_practitionerData$pra = practitionerData === null || practitionerData === void 0 ? void 0 : practitionerData.practitionerid) !== null && _practitionerData$pra !== void 0 ? _practitionerData$pra : "", json, (_data$result$0$_id = data === null || data === void 0 ? void 0 : (_data$result9 = data.result) === null || _data$result9 === void 0 ? void 0 : (_data$result9$ = _data$result9[0]) === null || _data$result9$ === void 0 ? void 0 : _data$result9$._id) !== null && _data$result$0$_id !== void 0 ? _data$result$0$_id : ""))
          }, __uspsertUrl__);

        case 12:
          res = _context55.sent;
          return _context55.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 16:
          _context55.prev = 16;
          _context55.t0 = _context55["catch"](2);
          return _context55.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context55.t0.message
          })));

        case 19:
        case "end":
          return _context55.stop();
      }
    }
  }, _callee55, null, [[2, 16]]);
})));
var REASON_DROPDOWN_MASTER = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/return_medication_reason", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
  var payload,
      _ref113,
      rejectWithValue,
      type,
      medication,
      reIssue,
      data,
      arr,
      _data$result10,
      finalArray,
      obj,
      _data$result11,
      _data$result11$,
      _data$result11$$newRe,
      _data$result12,
      _data$result13,
      _args56 = arguments;

  return _regeneratorRuntime().wrap(function _callee56$(_context56) {
    while (1) {
      switch (_context56.prev = _context56.next) {
        case 0:
          payload = _args56.length > 0 && _args56[0] !== undefined ? _args56[0] : {};
          _ref113 = _args56.length > 1 ? _args56[1] : undefined, rejectWithValue = _ref113.rejectWithValue;
          _context56.prev = 2;
          type = payload.type, medication = payload.medication, reIssue = payload.reIssue;
          _context56.next = 6;
          return fetchData({
            body: JSON.stringify(medication ? typeof type === "string" ? pharmacyVerifierQuery.returnMedicatioReasonSingle(type) : pharmacyVerifierQuery.returnMedicatioReasonMulti(type) : pharmacyVerifierQuery.reasonMaster(type))
          }, medication && typeof type !== "string" ? __baseUrl__ : __readDocumentUrl__);

        case 6:
          data = _context56.sent;
          arr = [];

          if (medication) {
            if (typeof type !== "string") {
              finalArray = [];
              data === null || data === void 0 ? void 0 : (_data$result10 = data.result) === null || _data$result10 === void 0 ? void 0 : _data$result10.forEach(function (val) {
                val.Reason.forEach(function (v) {
                  finalArray.push(v);
                });
                val.approvalReq.forEach(function (a) {
                  a.forEach(function (r) {
                    var object = {
                      _id: r.returnReason,
                      approvalReq: r.approvalReq
                    };
                    finalArray.push(object);
                  });
                });
              });
              obj = {};
              finalArray.forEach(function (val) {
                var ID = val._id;

                if (ID in obj) {
                  obj[ID].isapproval = val === null || val === void 0 ? void 0 : val.approvalReq;
                } else {
                  obj[ID] = {
                    label: val === null || val === void 0 ? void 0 : val.display,
                    value: val === null || val === void 0 ? void 0 : val._id,
                    isapproval: false
                  };
                }
              });
              arr = Object.values(obj);
            } else {
              data === null || data === void 0 ? void 0 : (_data$result11 = data.result) === null || _data$result11 === void 0 ? void 0 : (_data$result11$ = _data$result11[0]) === null || _data$result11$ === void 0 ? void 0 : (_data$result11$$newRe = _data$result11$.newReturnParams) === null || _data$result11$$newRe === void 0 ? void 0 : _data$result11$$newRe.map(function (v) {
                var _v$returnReason3, _v$returnReason4;

                arr.push({
                  label: v === null || v === void 0 ? void 0 : (_v$returnReason3 = v.returnReason) === null || _v$returnReason3 === void 0 ? void 0 : _v$returnReason3.display,
                  value: v === null || v === void 0 ? void 0 : (_v$returnReason4 = v.returnReason) === null || _v$returnReason4 === void 0 ? void 0 : _v$returnReason4._id,
                  isapproval: v === null || v === void 0 ? void 0 : v.approvalReq
                });
              });
            }
          } else if (reIssue) {
            data === null || data === void 0 ? void 0 : (_data$result12 = data.result) === null || _data$result12 === void 0 ? void 0 : _data$result12.map(function (v) {
              var _v$code2, _v$status2, _v$id2;

              arr.push({
                label: v === null || v === void 0 ? void 0 : v.display,
                value: v === null || v === void 0 ? void 0 : v._id,
                code: (_v$code2 = v === null || v === void 0 ? void 0 : v.code) !== null && _v$code2 !== void 0 ? _v$code2 : "",
                status: (_v$status2 = v === null || v === void 0 ? void 0 : v.status) !== null && _v$status2 !== void 0 ? _v$status2 : false,
                id: (_v$id2 = v === null || v === void 0 ? void 0 : v.id) !== null && _v$id2 !== void 0 ? _v$id2 : ""
              });
            });
          } else {
            data === null || data === void 0 ? void 0 : (_data$result13 = data.result) === null || _data$result13 === void 0 ? void 0 : _data$result13.map(function (v) {
              arr.push({
                title: v === null || v === void 0 ? void 0 : v.display,
                year: v === null || v === void 0 ? void 0 : v._id
              });
            });
          }

          return _context56.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context56.prev = 12;
          _context56.t0 = _context56["catch"](2);
          return _context56.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context56.t0.message
          })));

        case 15:
        case "end":
          return _context56.stop();
      }
    }
  }, _callee56, null, [[2, 12]]);
})));
var LABEL_PRESCRIPTION = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/get_label", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
  var payload,
      _ref115,
      rejectWithValue,
      encounterid,
      patientid,
      dateformat,
      datetimeformat,
      data,
      _args57 = arguments;

  return _regeneratorRuntime().wrap(function _callee57$(_context57) {
    while (1) {
      switch (_context57.prev = _context57.next) {
        case 0:
          payload = _args57.length > 0 && _args57[0] !== undefined ? _args57[0] : {};
          _ref115 = _args57.length > 1 ? _args57[1] : undefined, rejectWithValue = _ref115.rejectWithValue, _ref115.getState;
          _context57.prev = 2;
          encounterid = payload.encounterid, patientid = payload.patientid, dateformat = payload.dateformat, datetimeformat = payload.datetimeformat;
          _context57.next = 6;
          return fetchData({
            body: JSON.stringify(pharmacyVerifierQuery.queueLabel(encounterid, patientid, dateformat, datetimeformat))
          }, __baseUrl__);

        case 6:
          data = _context57.sent;
          return _context57.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context57.prev = 10;
          _context57.t0 = _context57["catch"](2);
          return _context57.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context57.t0.message
          })));

        case 13:
        case "end":
          return _context57.stop();
      }
    }
  }, _callee57, null, [[2, 10]]);
})));
var phramcyFrameworkApiSlice = toolkit.createSlice({
  name: "pharmacyFrameworkApiSlice",
  initialState: {
    get_queue_count: _objectSpread2({}, defaultState.List),
    get_priority_list: _objectSpread2({}, defaultState.List),
    add_drug: _objectSpread2({}, defaultState.List),
    drug_against_drugType: _objectSpread2({}, defaultState.List),
    patientBanner: _objectSpread2({}, defaultState.List),
    Encounterbanner: _objectSpread2({}, defaultState.List),
    vitalsAgainstEncounter: _objectSpread2({}, defaultState.List),
    allergyAgainstPatient: _objectSpread2({}, defaultState.List),
    diagnosisAgainstPatient: _objectSpread2({}, defaultState.List),
    chiefComplaintsAgainstPatient: _objectSpread2({}, defaultState.List),
    activeMedication: _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
      reportColumns: [],
      reportRows: []
    }),
    patientQueue: _objectSpread2({}, defaultState.List),
    patientSearchNotInQueue: _objectSpread2({}, defaultState.List),
    pharmacyGettingState: _objectSpread2({}, defaultState.List),
    pharmacyFramework: _objectSpread2({}, defaultState.List),
    calculateDispenseStrengthAndStock: _objectSpread2({}, defaultState.List),
    pharmacy_medication_change: _objectSpread2({}, defaultState.List),
    pharmacy_verify: _objectSpread2({}, defaultState.List),
    pharmacy_discontinue: _objectSpread2({}, defaultState.List),
    pharmacy_reason_drapdown: _objectSpread2({}, defaultState.List),
    pharmacy_filling_listing: _objectSpread2({}, defaultState.List),
    alertUpdate: _objectSpread2({}, defaultState.List),
    alertReasonDropdown: _objectSpread2({}, defaultState.List),
    instructionMasterRead: _objectSpread2({}, defaultState.List),
    readStatusHistory: _objectSpread2({}, defaultState.Info),
    label_print: _objectSpread2({}, defaultState.Info),
    medicationList: _objectSpread2({}, defaultState.Info),
    get_dispanse: _objectSpread2({}, defaultState.Info),
    getOrderDate: _objectSpread2({}, defaultState.Info),
    returnDrugTransaction: _objectSpread2({}, defaultState.Info),
    getActiveMedicationDataWithPhOrderId: _objectSpread2({}, defaultState.List),
    returnMedicationReason: _objectSpread2({}, defaultState.List),
    returnMedicationData: _objectSpread2({}, defaultState.List),
    dispenseHistoryRead: _objectSpread2({}, defaultState.List),
    cartName: _objectSpread2({}, defaultState.List),
    subStore: _objectSpread2({}, defaultState.List),
    generate: _objectSpread2({}, defaultState.List),
    openCart: _objectSpread2({}, defaultState.List),
    getTransaction: _objectSpread2({}, defaultState.List),
    closeCart: _objectSpread2({}, defaultState.List),
    closeCartReason: _objectSpread2({}, defaultState.List),
    orderCount: _objectSpread2({}, defaultState.Info),
    getScenarioList: _objectSpread2({}, defaultState.List),
    financialBanner: _objectSpread2({}, defaultState.List),
    pharmacyFrameworkMultiBatch: _objectSpread2({}, defaultState.List),
    issueMedicatioRead: _objectSpread2({}, defaultState.List),
    issueMedicatio: _objectSpread2({}, defaultState.List),
    issueMedicationReason: _objectSpread2({}, defaultState.List),
    accessedQueue: _objectSpread2({}, defaultState.Info),
    cartStatusUpdate: _objectSpread2({}, defaultState.List),
    patientQueueStatusData: _objectSpread2({}, defaultState.List),
    patientQueueStatusUpsert: _objectSpread2({}, defaultState.List),
    reasonMaster: _objectSpread2({}, defaultState.List),
    label_prescription: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$K = {}, _defineProperty(_extraReducers$K, LABEL_PRESCRIPTION.fulfilled, function (state, action) {
    var _action$payload;

    state.label_prescription = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$K, LABEL_PRESCRIPTION.pending, function (state, action) {
    state.label_prescription.loading = true;
  }), _defineProperty(_extraReducers$K, LABEL_PRESCRIPTION.rejected, function (state, action) {
    var _action$payload2;

    state.label_prescription = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$K, REASON_DROPDOWN_MASTER.fulfilled, function (state, action) {
    var _action$payload3;

    state.reasonMaster = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$K, REASON_DROPDOWN_MASTER.pending, function (state, action) {
    state.reasonMaster.loading = true;
  }), _defineProperty(_extraReducers$K, REASON_DROPDOWN_MASTER.rejected, function (state, action) {
    var _action$payload4;

    state.reasonMaster = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$K, UPDATE_STATUS_CART.fulfilled, function (state, action) {
    var _action$payload5;

    state.cartStatusUpdate = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$K, UPDATE_STATUS_CART.pending, function (state, action) {
    state.cartStatusUpdate.loading = true;
  }), _defineProperty(_extraReducers$K, UPDATE_STATUS_CART.rejected, function (state, action) {
    var _action$payload6;

    state.cartStatusUpdate = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers$K, QUEUE_COUNT.fulfilled, function (state, action) {
    var _action$payload7;

    state.get_queue_count = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : {};
  }), _defineProperty(_extraReducers$K, QUEUE_COUNT.pending, function (state, action) {
    state.get_queue_count.loading = true;
  }), _defineProperty(_extraReducers$K, QUEUE_COUNT.rejected, function (state, action) {
    var _action$payload8;

    state.get_queue_count = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : {};
  }), _defineProperty(_extraReducers$K, GET_PRIORITY_LIST.fulfilled, function (state, action) {
    var _action$payload9;

    state.get_priority_list = (_action$payload9 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload9 !== void 0 ? _action$payload9 : {};
  }), _defineProperty(_extraReducers$K, GET_PRIORITY_LIST.pending, function (state, action) {
    state.get_priority_list.loading = true;
  }), _defineProperty(_extraReducers$K, GET_PRIORITY_LIST.rejected, function (state, action) {
    var _action$payload10;

    state.get_priority_list = (_action$payload10 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload10 !== void 0 ? _action$payload10 : {};
  }), _defineProperty(_extraReducers$K, REISSUE_REASON_DROPDOWN.fulfilled, function (state, action) {
    var _action$payload11;

    state.issueMedicationReason = (_action$payload11 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload11 !== void 0 ? _action$payload11 : {};
  }), _defineProperty(_extraReducers$K, REISSUE_REASON_DROPDOWN.pending, function (state, action) {
    state.issueMedicationReason.loading = true;
  }), _defineProperty(_extraReducers$K, REISSUE_REASON_DROPDOWN.rejected, function (state, action) {
    var _action$payload12;

    state.issueMedicationReason = (_action$payload12 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload12 !== void 0 ? _action$payload12 : {};
  }), _defineProperty(_extraReducers$K, ISSUE_MEDICATION.fulfilled, function (state, action) {
    var _action$payload13;

    state.issueMedicatio = (_action$payload13 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload13 !== void 0 ? _action$payload13 : {};
  }), _defineProperty(_extraReducers$K, ISSUE_MEDICATION.pending, function (state, action) {
    state.issueMedicatio.loading = true;
  }), _defineProperty(_extraReducers$K, ISSUE_MEDICATION.rejected, function (state, action) {
    var _action$payload14;

    state.issueMedicatio = (_action$payload14 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload14 !== void 0 ? _action$payload14 : {};
  }), _defineProperty(_extraReducers$K, READ_ISSUE_MEDICATION.fulfilled, function (state, action) {
    var _action$payload15;

    state.issueMedicatioRead = (_action$payload15 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload15 !== void 0 ? _action$payload15 : {};
  }), _defineProperty(_extraReducers$K, READ_ISSUE_MEDICATION.pending, function (state, action) {
    state.issueMedicatioRead.loading = true;
  }), _defineProperty(_extraReducers$K, READ_ISSUE_MEDICATION.rejected, function (state, action) {
    var _action$payload16;

    state.issueMedicatioRead = (_action$payload16 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload16 !== void 0 ? _action$payload16 : {};
  }), _defineProperty(_extraReducers$K, DRUG_AGAINST_DRUGTYPE.fulfilled, function (state, action) {
    var _action$payload17;

    state.drug_against_drugType = (_action$payload17 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload17 !== void 0 ? _action$payload17 : {};
  }), _defineProperty(_extraReducers$K, DRUG_AGAINST_DRUGTYPE.pending, function (state, action) {
    state.drug_against_drugType.loading = true;
  }), _defineProperty(_extraReducers$K, DRUG_AGAINST_DRUGTYPE.rejected, function (state, action) {
    var _action$payload18;

    state.drug_against_drugType = (_action$payload18 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload18 !== void 0 ? _action$payload18 : {};
  }), _defineProperty(_extraReducers$K, ADDDRUG.fulfilled, function (state, action) {
    var _action$payload19;

    state.add_drug = (_action$payload19 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload19 !== void 0 ? _action$payload19 : {};
  }), _defineProperty(_extraReducers$K, ADDDRUG.pending, function (state, action) {
    state.add_drug.loading = true;
  }), _defineProperty(_extraReducers$K, ADDDRUG.rejected, function (state, action) {
    var _action$payload20;

    state.add_drug = (_action$payload20 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload20 !== void 0 ? _action$payload20 : {};
  }), _defineProperty(_extraReducers$K, ACCESSEDSCENARIOS.fulfilled, function (state, action) {
    var _action$payload21;

    state.getScenarioList = (_action$payload21 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload21 !== void 0 ? _action$payload21 : {};
  }), _defineProperty(_extraReducers$K, ACCESSEDSCENARIOS.pending, function (state, action) {
    state.getScenarioList.loading = true;
  }), _defineProperty(_extraReducers$K, ACCESSEDSCENARIOS.rejected, function (state, action) {
    var _action$payload22;

    state.getScenarioList = (_action$payload22 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload22 !== void 0 ? _action$payload22 : {};
  }), _defineProperty(_extraReducers$K, FINANCIAL_BANNER.fulfilled, function (state, action) {
    var _action$payload23;

    state.financialBanner = (_action$payload23 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload23 !== void 0 ? _action$payload23 : {};
  }), _defineProperty(_extraReducers$K, FINANCIAL_BANNER.pending, function (state, action) {
    state.financialBanner.loading = true;
  }), _defineProperty(_extraReducers$K, FINANCIAL_BANNER.rejected, function (state, action) {
    var _action$payload24;

    state.financialBanner = (_action$payload24 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload24 !== void 0 ? _action$payload24 : {};
  }), _defineProperty(_extraReducers$K, ORDERCOUNT.fulfilled, function (state, action) {
    var _action$payload25;

    state.orderCount = (_action$payload25 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload25 !== void 0 ? _action$payload25 : {};
  }), _defineProperty(_extraReducers$K, ORDERCOUNT.pending, function (state, action) {
    state.orderCount.loading = true;
  }), _defineProperty(_extraReducers$K, ORDERCOUNT.rejected, function (state, action) {
    var _action$payload26;

    state.orderCount = (_action$payload26 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload26 !== void 0 ? _action$payload26 : {};
  }), _defineProperty(_extraReducers$K, GETQUEUELIST.fulfilled, function (state, action) {
    var _action$payload27;

    state.pharmacyGettingState = (_action$payload27 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload27 !== void 0 ? _action$payload27 : {};
  }), _defineProperty(_extraReducers$K, GETQUEUELIST.pending, function (state, action) {
    state.pharmacyGettingState.loading = true;
  }), _defineProperty(_extraReducers$K, GETQUEUELIST.rejected, function (state, action) {
    var _action$payload28;

    state.pharmacyGettingState = (_action$payload28 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload28 !== void 0 ? _action$payload28 : {};
  }), _defineProperty(_extraReducers$K, GETACCESSQUEUE.fulfilled, function (state, action) {
    var _action$payload29;

    state.accessedQueue = (_action$payload29 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload29 !== void 0 ? _action$payload29 : {};
  }), _defineProperty(_extraReducers$K, GETACCESSQUEUE.pending, function (state, action) {
    state.accessedQueue.loading = true;
  }), _defineProperty(_extraReducers$K, GETACCESSQUEUE.rejected, function (state, action) {
    var _action$payload30;

    state.accessedQueue = (_action$payload30 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload30 !== void 0 ? _action$payload30 : {};
  }), _defineProperty(_extraReducers$K, CART_REASON.fulfilled, function (state, action) {
    var _action$payload31;

    state.closeCartReason = (_action$payload31 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload31 !== void 0 ? _action$payload31 : {};
  }), _defineProperty(_extraReducers$K, CART_REASON.pending, function (state, action) {
    state.closeCartReason.loading = true;
  }), _defineProperty(_extraReducers$K, CART_REASON.rejected, function (state, action) {
    var _action$payload32;

    state.closeCartReason = (_action$payload32 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload32 !== void 0 ? _action$payload32 : {};
  }), _defineProperty(_extraReducers$K, CLOSE_CART.fulfilled, function (state, action) {
    var _action$payload33;

    state.closeCart = (_action$payload33 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload33 !== void 0 ? _action$payload33 : {};
  }), _defineProperty(_extraReducers$K, CLOSE_CART.pending, function (state, action) {
    state.closeCart.loading = true;
  }), _defineProperty(_extraReducers$K, CLOSE_CART.rejected, function (state, action) {
    var _action$payload34;

    state.closeCart = (_action$payload34 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload34 !== void 0 ? _action$payload34 : {};
  }), _defineProperty(_extraReducers$K, CART_PATIENT_QUEUE.fulfilled, function (state, action) {
    var _action$payload35;

    state.patientQueue = (_action$payload35 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload35 !== void 0 ? _action$payload35 : {};
  }), _defineProperty(_extraReducers$K, CART_PATIENT_QUEUE.pending, function (state, action) {
    state.patientQueue.loading = true;
  }), _defineProperty(_extraReducers$K, CART_PATIENT_QUEUE.rejected, function (state, action) {
    var _action$payload36;

    state.patientQueue = (_action$payload36 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload36 !== void 0 ? _action$payload36 : {};
  }), _defineProperty(_extraReducers$K, GET_TRANSACTION.fulfilled, function (state, action) {
    var _action$payload37;

    state.getTransaction = (_action$payload37 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload37 !== void 0 ? _action$payload37 : {};
  }), _defineProperty(_extraReducers$K, GET_TRANSACTION.pending, function (state, action) {
    state.getTransaction.loading = true;
  }), _defineProperty(_extraReducers$K, GET_TRANSACTION.rejected, function (state, action) {
    var _action$payload38;

    state.getTransaction = (_action$payload38 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload38 !== void 0 ? _action$payload38 : {};
  }), _defineProperty(_extraReducers$K, OPEN_CART.fulfilled, function (state, action) {
    var _action$payload39;

    state.openCart = (_action$payload39 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload39 !== void 0 ? _action$payload39 : {};
  }), _defineProperty(_extraReducers$K, OPEN_CART.pending, function (state, action) {
    state.openCart.loading = true;
  }), _defineProperty(_extraReducers$K, OPEN_CART.rejected, function (state, action) {
    var _action$payload40;

    state.openCart = (_action$payload40 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload40 !== void 0 ? _action$payload40 : {};
  }), _defineProperty(_extraReducers$K, CART_GENERATE.fulfilled, function (state, action) {
    var _action$payload41;

    state.generate = (_action$payload41 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload41 !== void 0 ? _action$payload41 : {};
  }), _defineProperty(_extraReducers$K, CART_GENERATE.pending, function (state, action) {
    state.generate.loading = true;
  }), _defineProperty(_extraReducers$K, CART_GENERATE.rejected, function (state, action) {
    var _action$payload42;

    state.generate = (_action$payload42 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload42 !== void 0 ? _action$payload42 : {};
  }), _defineProperty(_extraReducers$K, SUB_STORE.fulfilled, function (state, action) {
    var _action$payload43;

    state.subStore = (_action$payload43 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload43 !== void 0 ? _action$payload43 : {};
  }), _defineProperty(_extraReducers$K, SUB_STORE.pending, function (state, action) {
    state.subStore.loading = true;
  }), _defineProperty(_extraReducers$K, SUB_STORE.rejected, function (state, action) {
    var _action$payload44;

    state.subStore = (_action$payload44 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload44 !== void 0 ? _action$payload44 : {};
  }), _defineProperty(_extraReducers$K, CART_NAME.fulfilled, function (state, action) {
    var _action$payload45;

    state.cartName = (_action$payload45 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload45 !== void 0 ? _action$payload45 : {};
  }), _defineProperty(_extraReducers$K, CART_NAME.pending, function (state, action) {
    state.cartName.loading = true;
  }), _defineProperty(_extraReducers$K, CART_NAME.rejected, function (state, action) {
    var _action$payload46;

    state.cartName = (_action$payload46 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload46 !== void 0 ? _action$payload46 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_RETURN_MEDICATION.fulfilled, function (state, action) {
    var _action$payload47;

    state.returnMedicationData = (_action$payload47 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload47 !== void 0 ? _action$payload47 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_RETURN_MEDICATION.pending, function (state, action) {
    state.returnMedicationData.loading = true;
  }), _defineProperty(_extraReducers$K, PHARMACY_RETURN_MEDICATION.rejected, function (state, action) {
    var _action$payload48;

    state.returnMedicationData = (_action$payload48 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload48 !== void 0 ? _action$payload48 : {};
  }), _defineProperty(_extraReducers$K, MEDICATION_REASON_DROPDOWN.fulfilled, function (state, action) {
    var _action$payload49;

    state.returnMedicationReason = (_action$payload49 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload49 !== void 0 ? _action$payload49 : {};
  }), _defineProperty(_extraReducers$K, MEDICATION_REASON_DROPDOWN.pending, function (state, action) {
    state.returnMedicationReason.loading = true;
  }), _defineProperty(_extraReducers$K, MEDICATION_REASON_DROPDOWN.rejected, function (state, action) {
    var _action$payload50;

    state.returnMedicationReason = (_action$payload50 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload50 !== void 0 ? _action$payload50 : {};
  }), _defineProperty(_extraReducers$K, GET_ORDER_DATE.fulfilled, function (state, action) {
    var _action$payload51;

    state.getOrderDate = (_action$payload51 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload51 !== void 0 ? _action$payload51 : {};
  }), _defineProperty(_extraReducers$K, GET_ORDER_DATE.pending, function (state, action) {
    state.getOrderDate.loading = true;
  }), _defineProperty(_extraReducers$K, GET_ORDER_DATE.rejected, function (state, action) {
    var _action$payload52;

    state.getOrderDate = (_action$payload52 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload52 !== void 0 ? _action$payload52 : {};
  }), _defineProperty(_extraReducers$K, PATIENT_BANNER.fulfilled, function (state, action) {
    var _action$payload53;

    state.patientBanner = (_action$payload53 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload53 !== void 0 ? _action$payload53 : {};
  }), _defineProperty(_extraReducers$K, PATIENT_BANNER.pending, function (state, action) {
    state.patientBanner.loading = true;
  }), _defineProperty(_extraReducers$K, PATIENT_BANNER.rejected, function (state, action) {
    var _action$payload54;

    state.patientBanner = (_action$payload54 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload54 !== void 0 ? _action$payload54 : {};
  }), _defineProperty(_extraReducers$K, ENCOUNTER_BANNER.fulfilled, function (state, action) {
    var _action$payload55;

    state.Encounterbanner = (_action$payload55 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload55 !== void 0 ? _action$payload55 : {};
  }), _defineProperty(_extraReducers$K, ENCOUNTER_BANNER.pending, function (state, action) {
    state.Encounterbanner.loading = true;
  }), _defineProperty(_extraReducers$K, ENCOUNTER_BANNER.rejected, function (state, action) {
    var _action$payload56;

    state.Encounterbanner = (_action$payload56 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload56 !== void 0 ? _action$payload56 : {};
  }), _defineProperty(_extraReducers$K, VITALS_AGAINST_ENCOUNTER.fulfilled, function (state, action) {
    var _action$payload57;

    state.vitalsAgainstEncounter = (_action$payload57 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload57 !== void 0 ? _action$payload57 : {};
  }), _defineProperty(_extraReducers$K, VITALS_AGAINST_ENCOUNTER.pending, function (state, action) {
    state.vitalsAgainstEncounter.loading = true;
  }), _defineProperty(_extraReducers$K, VITALS_AGAINST_ENCOUNTER.rejected, function (state, action) {
    var _action$payload58;

    state.vitalsAgainstEncounter = (_action$payload58 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload58 !== void 0 ? _action$payload58 : {};
  }), _defineProperty(_extraReducers$K, ALLERGY_AGAINST_PATIENT.fulfilled, function (state, action) {
    var _action$payload59;

    state.allergyAgainstPatient = (_action$payload59 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload59 !== void 0 ? _action$payload59 : {};
  }), _defineProperty(_extraReducers$K, ALLERGY_AGAINST_PATIENT.pending, function (state, action) {
    state.allergyAgainstPatient.loading = true;
  }), _defineProperty(_extraReducers$K, ALLERGY_AGAINST_PATIENT.rejected, function (state, action) {
    var _action$payload60;

    state.allergyAgainstPatient = (_action$payload60 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload60 !== void 0 ? _action$payload60 : {};
  }), _defineProperty(_extraReducers$K, DIAGNOSIS_AGAINST_PATIENT.fulfilled, function (state, action) {
    var _action$payload61;

    state.diagnosisAgainstPatient = (_action$payload61 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload61 !== void 0 ? _action$payload61 : {};
  }), _defineProperty(_extraReducers$K, DIAGNOSIS_AGAINST_PATIENT.pending, function (state, action) {
    state.diagnosisAgainstPatient.loading = true;
  }), _defineProperty(_extraReducers$K, DIAGNOSIS_AGAINST_PATIENT.rejected, function (state, action) {
    var _action$payload62;

    state.diagnosisAgainstPatient = (_action$payload62 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload62 !== void 0 ? _action$payload62 : {};
  }), _defineProperty(_extraReducers$K, CHIEFCOMPLAINT_AGAINST_PATIENT.fulfilled, function (state, action) {
    var _action$payload63;

    state.chiefComplaintsAgainstPatient = (_action$payload63 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload63 !== void 0 ? _action$payload63 : {};
  }), _defineProperty(_extraReducers$K, CHIEFCOMPLAINT_AGAINST_PATIENT.pending, function (state, action) {
    state.chiefComplaintsAgainstPatient.loading = true;
  }), _defineProperty(_extraReducers$K, CHIEFCOMPLAINT_AGAINST_PATIENT.rejected, function (state, action) {
    var _action$payload64;

    state.chiefComplaintsAgainstPatient = (_action$payload64 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload64 !== void 0 ? _action$payload64 : {};
  }), _defineProperty(_extraReducers$K, MEDIACATION_LIST.fulfilled, function (state, action) {
    var _action$payload65;

    state.medicationList = (_action$payload65 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload65 !== void 0 ? _action$payload65 : {};
  }), _defineProperty(_extraReducers$K, MEDIACATION_LIST.pending, function (state, action) {
    state.medicationList.loading = true;
  }), _defineProperty(_extraReducers$K, MEDIACATION_LIST.rejected, function (state, action) {
    var _action$payload66;

    state.medicationList = (_action$payload66 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload66 !== void 0 ? _action$payload66 : {};
  }), _defineProperty(_extraReducers$K, ACTIVEMEDIACATION_AGAINST_PATIENT.fulfilled, function (state, action) {
    var _action$payload67;

    state.activeMedication = (_action$payload67 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload67 !== void 0 ? _action$payload67 : {};
  }), _defineProperty(_extraReducers$K, ACTIVEMEDIACATION_AGAINST_PATIENT.pending, function (state, action) {
    state.activeMedication.loading = true;
  }), _defineProperty(_extraReducers$K, ACTIVEMEDIACATION_AGAINST_PATIENT.rejected, function (state, action) {
    var _action$payload68;

    state.activeMedication = (_action$payload68 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload68 !== void 0 ? _action$payload68 : {};
  }), _defineProperty(_extraReducers$K, PATIENT_QUEUE.fulfilled, function (state, action) {
    var _action$payload69;

    state.patientQueue = (_action$payload69 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload69 !== void 0 ? _action$payload69 : {};
  }), _defineProperty(_extraReducers$K, PATIENT_QUEUE.pending, function (state, action) {
    state.patientQueue.loading = true;
  }), _defineProperty(_extraReducers$K, PATIENT_QUEUE.rejected, function (state, action) {
    var _action$payload70;

    state.patientQueue = (_action$payload70 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload70 !== void 0 ? _action$payload70 : {};
  }), _defineProperty(_extraReducers$K, PATIENT_SEARCH_NOT_IN_QUEUE.fulfilled, function (state, action) {
    var _action$payload71;

    state.patientSearchNotInQueue = (_action$payload71 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload71 !== void 0 ? _action$payload71 : {};
  }), _defineProperty(_extraReducers$K, PATIENT_SEARCH_NOT_IN_QUEUE.pending, function (state, action) {
    state.patientSearchNotInQueue.loading = true;
  }), _defineProperty(_extraReducers$K, PATIENT_SEARCH_NOT_IN_QUEUE.rejected, function (state, action) {
    var _action$payload72;

    state.patientSearchNotInQueue = (_action$payload72 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload72 !== void 0 ? _action$payload72 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_GETTINGSTATE.fulfilled, function (state, action) {
    var _action$payload73;

    state.pharmacyGettingState = (_action$payload73 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload73 !== void 0 ? _action$payload73 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_GETTINGSTATE.pending, function (state, action) {
    state.pharmacyGettingState.loading = true;
  }), _defineProperty(_extraReducers$K, PHARMACY_GETTINGSTATE.rejected, function (state, action) {
    var _action$payload74;

    state.pharmacyGettingState = (_action$payload74 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload74 !== void 0 ? _action$payload74 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_FRAMEWORK.fulfilled, function (state, action) {
    var _action$payload75;

    state.pharmacyFramework = (_action$payload75 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload75 !== void 0 ? _action$payload75 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_FRAMEWORK.pending, function (state, action) {
    state.pharmacyFramework.loading = true;
  }), _defineProperty(_extraReducers$K, PHARMACY_FRAMEWORK.rejected, function (state, action) {
    var _action$payload76;

    state.pharmacyFramework = (_action$payload76 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload76 !== void 0 ? _action$payload76 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_MULTIBATCH.fulfilled, function (state, action) {
    var _action$payload77;

    state.pharmacyFrameworkMultiBatch = (_action$payload77 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload77 !== void 0 ? _action$payload77 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_MULTIBATCH.pending, function (state, action) {
    state.pharmacyFrameworkMultiBatch.loading = true;
  }), _defineProperty(_extraReducers$K, PHARMACY_MULTIBATCH.rejected, function (state, action) {
    var _action$payload78;

    state.pharmacyFrameworkMultiBatch = (_action$payload78 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload78 !== void 0 ? _action$payload78 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_CALCULATE_DOSESTRENGTH_STOCK.fulfilled, function (state, action) {
    var _action$payload79;

    state.pharmacyFramework = (_action$payload79 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload79 !== void 0 ? _action$payload79 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_CALCULATE_DOSESTRENGTH_STOCK.pending, function (state, action) {
    state.pharmacyFramework.loading = true;
  }), _defineProperty(_extraReducers$K, PHARMACY_CALCULATE_DOSESTRENGTH_STOCK.rejected, function (state, action) {
    var _action$payload80;

    state.pharmacyFramework = (_action$payload80 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload80 !== void 0 ? _action$payload80 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_MEDICATION_CHANGE.fulfilled, function (state, action) {
    var _action$payload81;

    state.pharmacyFramework = (_action$payload81 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload81 !== void 0 ? _action$payload81 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_MEDICATION_CHANGE.pending, function (state, action) {
    state.pharmacyFramework.loading = true;
  }), _defineProperty(_extraReducers$K, PHARMACY_MEDICATION_CHANGE.rejected, function (state, action) {
    var _action$payload82;

    state.pharmacyFramework = (_action$payload82 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload82 !== void 0 ? _action$payload82 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_VERIFY.fulfilled, function (state, action) {
    var _action$payload83;

    state.pharmacy_verify = (_action$payload83 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload83 !== void 0 ? _action$payload83 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_VERIFY.pending, function (state, action) {
    state.pharmacy_verify.loading = true;
  }), _defineProperty(_extraReducers$K, PHARMACY_VERIFY.rejected, function (state, action) {
    var _action$payload84;

    state.pharmacy_verify = (_action$payload84 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload84 !== void 0 ? _action$payload84 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_VERIFY_DISCANTINUE.fulfilled, function (state, action) {
    var _action$payload85;

    state.pharmacy_verify = (_action$payload85 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload85 !== void 0 ? _action$payload85 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_VERIFY_DISCANTINUE.pending, function (state, action) {
    state.pharmacy_verify.loading = true;
  }), _defineProperty(_extraReducers$K, PHARMACY_VERIFY_DISCANTINUE.rejected, function (state, action) {
    var _action$payload86;

    state.pharmacy_verify = (_action$payload86 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload86 !== void 0 ? _action$payload86 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_DISCONTINUE.fulfilled, function (state, action) {
    var _action$payload87;

    state.pharmacy_discontinue = (_action$payload87 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload87 !== void 0 ? _action$payload87 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_DISCONTINUE.pending, function (state, action) {
    state.pharmacy_discontinue.loading = true;
  }), _defineProperty(_extraReducers$K, PHARMACY_DISCONTINUE.rejected, function (state, action) {
    var _action$payload88;

    state.pharmacy_discontinue = (_action$payload88 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload88 !== void 0 ? _action$payload88 : {};
  }), _defineProperty(_extraReducers$K, DISPENSE_AND_FILLING_REASON_DROPDOWN.fulfilled, function (state, action) {
    var _action$payload89;

    state.pharmacy_reason_drapdown = (_action$payload89 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload89 !== void 0 ? _action$payload89 : {};
  }), _defineProperty(_extraReducers$K, DISPENSE_AND_FILLING_REASON_DROPDOWN.pending, function (state, action) {
    state.pharmacy_reason_drapdown.loading = true;
  }), _defineProperty(_extraReducers$K, DISPENSE_AND_FILLING_REASON_DROPDOWN.rejected, function (state, action) {
    var _action$payload90;

    state.pharmacy_reason_drapdown = (_action$payload90 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload90 !== void 0 ? _action$payload90 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_FILLING_LISTING.fulfilled, function (state, action) {
    var _action$payload91;

    state.pharmacyFramework = (_action$payload91 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload91 !== void 0 ? _action$payload91 : {};
  }), _defineProperty(_extraReducers$K, PHARMACY_FILLING_LISTING.pending, function (state, action) {
    state.pharmacyFramework.loading = true;
  }), _defineProperty(_extraReducers$K, PHARMACY_FILLING_LISTING.rejected, function (state, action) {
    var _action$payload92;

    state.pharmacyFramework = (_action$payload92 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload92 !== void 0 ? _action$payload92 : {};
  }), _defineProperty(_extraReducers$K, ALERT_UPDATE.fulfilled, function (state, action) {
    var _action$payload93;

    state.alertUpdate = (_action$payload93 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload93 !== void 0 ? _action$payload93 : {};
  }), _defineProperty(_extraReducers$K, ALERT_UPDATE.pending, function (state, action) {
    state.alertUpdate.loading = true;
  }), _defineProperty(_extraReducers$K, ALERT_UPDATE.rejected, function (state, action) {
    var _action$payload94;

    state.alertUpdate = (_action$payload94 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload94 !== void 0 ? _action$payload94 : {};
  }), _defineProperty(_extraReducers$K, ALERT_REASON.fulfilled, function (state, action) {
    var _action$payload95;

    state.alertReasonDropdown = (_action$payload95 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload95 !== void 0 ? _action$payload95 : {};
  }), _defineProperty(_extraReducers$K, ALERT_REASON.pending, function (state, action) {
    state.alertReasonDropdown.loading = true;
  }), _defineProperty(_extraReducers$K, ALERT_REASON.rejected, function (state, action) {
    var _action$payload96;

    state.alertReasonDropdown = (_action$payload96 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload96 !== void 0 ? _action$payload96 : {};
  }), _defineProperty(_extraReducers$K, INSTRUCTION_MASTER_READ.fulfilled, function (state, action) {
    var _action$payload97;

    state.instructionMasterRead = (_action$payload97 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload97 !== void 0 ? _action$payload97 : {};
  }), _defineProperty(_extraReducers$K, INSTRUCTION_MASTER_READ.pending, function (state, action) {
    state.instructionMasterRead.loading = true;
  }), _defineProperty(_extraReducers$K, INSTRUCTION_MASTER_READ.rejected, function (state, action) {
    var _action$payload98;

    state.instructionMasterRead = (_action$payload98 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload98 !== void 0 ? _action$payload98 : {};
  }), _defineProperty(_extraReducers$K, READ_STATUS_HISTORY.fulfilled, function (state, action) {
    var _action$payload99;

    state.readStatusHistory = (_action$payload99 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload99 !== void 0 ? _action$payload99 : {};
  }), _defineProperty(_extraReducers$K, READ_STATUS_HISTORY.pending, function (state, action) {
    state.readStatusHistory.loading = true;
  }), _defineProperty(_extraReducers$K, READ_STATUS_HISTORY.rejected, function (state, action) {
    var _action$payload100;

    state.readStatusHistory = (_action$payload100 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload100 !== void 0 ? _action$payload100 : {};
  }), _defineProperty(_extraReducers$K, LABEL_PRINT.fulfilled, function (state, action) {
    var _action$payload101;

    state.label_print = (_action$payload101 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload101 !== void 0 ? _action$payload101 : {};
  }), _defineProperty(_extraReducers$K, LABEL_PRINT.pending, function (state, action) {
    state.label_print.loading = true;
  }), _defineProperty(_extraReducers$K, LABEL_PRINT.rejected, function (state, action) {
    var _action$payload102;

    state.label_print = (_action$payload102 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload102 !== void 0 ? _action$payload102 : {};
  }), _defineProperty(_extraReducers$K, DGET_DISPENSE_DURATION.fulfilled, function (state, action) {
    var _action$payload103;

    state.get_dispanse = (_action$payload103 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload103 !== void 0 ? _action$payload103 : {};
  }), _defineProperty(_extraReducers$K, DGET_DISPENSE_DURATION.pending, function (state, action) {
    state.get_dispanse.loading = true;
  }), _defineProperty(_extraReducers$K, DGET_DISPENSE_DURATION.rejected, function (state, action) {
    var _action$payload104;

    state.get_dispanse = (_action$payload104 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload104 !== void 0 ? _action$payload104 : {};
  }), _defineProperty(_extraReducers$K, RETURN_DRUG_TRANSACTION.fulfilled, function (state, action) {
    var _action$payload105;

    state.returnDrugTransaction = (_action$payload105 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload105 !== void 0 ? _action$payload105 : {};
  }), _defineProperty(_extraReducers$K, RETURN_DRUG_TRANSACTION.pending, function (state, action) {
    state.returnDrugTransaction.loading = true;
  }), _defineProperty(_extraReducers$K, RETURN_DRUG_TRANSACTION.rejected, function (state, action) {
    var _action$payload106;

    state.returnDrugTransaction = (_action$payload106 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload106 !== void 0 ? _action$payload106 : {};
  }), _defineProperty(_extraReducers$K, GET_ACTIVE_MEDICATION_DATA_WITH_PH_ORDER_ID.fulfilled, function (state, action) {
    var _action$payload107;

    state.getActiveMedicationDataWithPhOrderId = (_action$payload107 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload107 !== void 0 ? _action$payload107 : {};
  }), _defineProperty(_extraReducers$K, GET_ACTIVE_MEDICATION_DATA_WITH_PH_ORDER_ID.pending, function (state, action) {
    state.getActiveMedicationDataWithPhOrderId.loading = true;
  }), _defineProperty(_extraReducers$K, GET_ACTIVE_MEDICATION_DATA_WITH_PH_ORDER_ID.rejected, function (state, action) {
    var _action$payload108;

    state.getActiveMedicationDataWithPhOrderId = (_action$payload108 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload108 !== void 0 ? _action$payload108 : {};
  }), _defineProperty(_extraReducers$K, DISPENSE_HISTORY_READ.fulfilled, function (state, action) {
    var _action$payload109;

    state.dispenseHistoryRead = (_action$payload109 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload109 !== void 0 ? _action$payload109 : {};
  }), _defineProperty(_extraReducers$K, DISPENSE_HISTORY_READ.pending, function (state, action) {
    state.dispenseHistoryRead.loading = true;
  }), _defineProperty(_extraReducers$K, DISPENSE_HISTORY_READ.rejected, function (state, action) {
    var _action$payload110;

    state.dispenseHistoryRead = (_action$payload110 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload110 !== void 0 ? _action$payload110 : {};
  }), _defineProperty(_extraReducers$K, PATIENT_QUEUE_STATUS_LIST.fulfilled, function (state, action) {
    var _action$payload111;

    state.patientQueueStatusData = (_action$payload111 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload111 !== void 0 ? _action$payload111 : {};
  }), _defineProperty(_extraReducers$K, PATIENT_QUEUE_STATUS_LIST.pending, function (state, action) {
    state.patientQueueStatusData.loading = true;
  }), _defineProperty(_extraReducers$K, PATIENT_QUEUE_STATUS_LIST.rejected, function (state, action) {
    var _action$payload112;

    state.patientQueueStatusData = (_action$payload112 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload112 !== void 0 ? _action$payload112 : {};
  }), _defineProperty(_extraReducers$K, STATUS_UPDATE_QUEUE.fulfilled, function (state, action) {
    var _action$payload113;

    state.patientQueueStatusUpsert = (_action$payload113 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload113 !== void 0 ? _action$payload113 : {};
  }), _defineProperty(_extraReducers$K, STATUS_UPDATE_QUEUE.pending, function (state, action) {
    state.patientQueueStatusUpsert.loading = true;
  }), _defineProperty(_extraReducers$K, STATUS_UPDATE_QUEUE.rejected, function (state, action) {
    var _action$payload114;

    state.patientQueueStatusUpsert = (_action$payload114 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload114 !== void 0 ? _action$payload114 : {};
  }), _extraReducers$K)
}); // FrequencySchedule ACTION LISTS

var phramcyFrameworkActions = {
  PATIENT_BANNER: PATIENT_BANNER,
  ENCOUNTER_BANNER: ENCOUNTER_BANNER,
  VITALS_AGAINST_ENCOUNTER: VITALS_AGAINST_ENCOUNTER,
  ALLERGY_AGAINST_PATIENT: ALLERGY_AGAINST_PATIENT,
  DIAGNOSIS_AGAINST_PATIENT: DIAGNOSIS_AGAINST_PATIENT,
  CHIEFCOMPLAINT_AGAINST_PATIENT: CHIEFCOMPLAINT_AGAINST_PATIENT,
  ACTIVEMEDIACATION_AGAINST_PATIENT: ACTIVEMEDIACATION_AGAINST_PATIENT,
  PATIENT_QUEUE: PATIENT_QUEUE,
  PATIENT_SEARCH_NOT_IN_QUEUE: PATIENT_SEARCH_NOT_IN_QUEUE,
  PHARMACY_FRAMEWORK: PHARMACY_FRAMEWORK,
  PHARMACY_GETTINGSTATE: PHARMACY_GETTINGSTATE,
  PHARMACY_CALCULATE_DOSESTRENGTH_STOCK: PHARMACY_CALCULATE_DOSESTRENGTH_STOCK,
  PHARMACY_MEDICATION_CHANGE: PHARMACY_MEDICATION_CHANGE,
  PHARMACY_VERIFY: PHARMACY_VERIFY,
  PHARMACY_DISCONTINUE: PHARMACY_DISCONTINUE,
  DISPENSE_AND_FILLING_REASON_DROPDOWN: DISPENSE_AND_FILLING_REASON_DROPDOWN,
  PHARMACY_FILLING_LISTING: PHARMACY_FILLING_LISTING,
  ALERT_UPDATE: ALERT_UPDATE,
  ALERT_REASON: ALERT_REASON,
  INSTRUCTION_MASTER_READ: INSTRUCTION_MASTER_READ,
  READ_STATUS_HISTORY: READ_STATUS_HISTORY,
  LABEL_PRINT: LABEL_PRINT,
  MEDIACATION_LIST: MEDIACATION_LIST,
  DGET_DISPENSE_DURATION: DGET_DISPENSE_DURATION,
  GET_ORDER_DATE: GET_ORDER_DATE,
  RETURN_DRUG_TRANSACTION: RETURN_DRUG_TRANSACTION,
  DISPENSE_HISTORY_READ: DISPENSE_HISTORY_READ,
  GET_ACTIVE_MEDICATION_DATA_WITH_PH_ORDER_ID: GET_ACTIVE_MEDICATION_DATA_WITH_PH_ORDER_ID,
  MEDICATION_REASON_DROPDOWN: MEDICATION_REASON_DROPDOWN,
  PHARMACY_RETURN_MEDICATION: PHARMACY_RETURN_MEDICATION,
  CART_NAME: CART_NAME,
  SUB_STORE: SUB_STORE,
  CART_GENERATE: CART_GENERATE,
  OPEN_CART: OPEN_CART,
  GET_TRANSACTION: GET_TRANSACTION,
  CART_PATIENT_QUEUE: CART_PATIENT_QUEUE,
  CLOSE_CART: CLOSE_CART,
  CART_REASON: CART_REASON,
  GETQUEUELIST: GETQUEUELIST,
  ORDERCOUNT: ORDERCOUNT,
  ACCESSEDSCENARIOS: ACCESSEDSCENARIOS,
  FINANCIAL_BANNER: FINANCIAL_BANNER,
  PHARMACY_MULTIBATCH: PHARMACY_MULTIBATCH,
  ADDDRUG: ADDDRUG,
  DRUG_AGAINST_DRUGTYPE: DRUG_AGAINST_DRUGTYPE,
  READ_ISSUE_MEDICATION: READ_ISSUE_MEDICATION,
  ISSUE_MEDICATION: ISSUE_MEDICATION,
  REISSUE_REASON_DROPDOWN: REISSUE_REASON_DROPDOWN,
  GETACCESSQUEUE: GETACCESSQUEUE,
  GET_PRIORITY_LIST: GET_PRIORITY_LIST,
  UPDATE_STATUS_CART: UPDATE_STATUS_CART,
  QUEUE_COUNT: QUEUE_COUNT,
  PATIENT_QUEUE_STATUS_LIST: PATIENT_QUEUE_STATUS_LIST,
  STATUS_UPDATE_QUEUE: STATUS_UPDATE_QUEUE,
  REASON_DROPDOWN_MASTER: REASON_DROPDOWN_MASTER,
  LABEL_PRESCRIPTION: LABEL_PRESCRIPTION,
  PHARMACY_VERIFY_DISCANTINUE: PHARMACY_VERIFY_DISCANTINUE
};
var signInReducer = phramcyFrameworkApiSlice.reducer;

var drugCatalogMasterQuery = {
  drugCatalogMasterRead: function drugCatalogMasterRead(page, perPage) {
    var searchQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var limit = {};

    if (perPage > 0) {
      limit = {
        limit: {
          count: perPage,
          offset: page
        }
      };
    }

    return _objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "DrugMaster",
      filter: "(LIKE(DrugMaster.DrugCode,'%".concat(searchQuery, "%',true) || LIKE(document(DrugMaster.DrugType).longdesc,'%").concat(searchQuery, "%',true) || LIKE(DrugMaster.ShortDesc,'%").concat(searchQuery, "%',true)) && DrugMaster.activestatus == true ")
    }, limit), {}, {
      return_fields: "merge(DrugMaster,{DrugCode:DrugMaster.DrugCode},{Count:count( for drgmst in DrugMaster filter (LIKE(drgmst.DrugCode,'%".concat(searchQuery, "%',true) || LIKE(document(drgmst.DrugType).longdesc,'%").concat(searchQuery, "%',true) || LIKE(drgmst.ShortDesc,'%").concat(searchQuery, "%',true)) && drgmst.activestatus == true return drgmst._id )},{ShortDesc:DrugMaster.ShortDesc},{DrugClass:DOCUMENT(DrugMaster.DrugClass)},{DrugType:DOCUMENT(DrugMaster.DrugType)},{DrugCategory:DOCUMENT(DrugMaster.DrugCategory)},{FormCode:DOCUMENT(DrugMaster.FormCode)},{StrengthValuesPossible:(for strValPoss in to_array(DrugMaster.StrengthValuesPossible) return merge(strValPoss,{StrengthUOM:document(strValPoss.StrengthUOM)},{StrengthVolumeUoM:document(strValPoss.StrengthVolumeUoM)},{OrderUOMAllowed:(for OrderUOMAllowed in to_array(strValPoss.OrderUOMAllowed) return merge(OrderUOMAllowed,{AllowedOrderDoseUOM:document(OrderUOMAllowed.AllowedOrderDoseUOM)},{AllowedOrderDoseVolUoM:document(OrderUOMAllowed.AllowedOrderDoseVolUoM)}))}))},{RoutesAllowed:document(DrugMaster.RoutesAllowed)})"),
      sort: "DrugMaster.createddate desc"
    });
  },
  drugCatalogMasterSingleRead: function drugCatalogMasterSingleRead(id) {
    return {
      db_name: dbName,
      entity: "DrugMaster",
      filter: "DrugMaster._id == '".concat(id, "' && DrugMaster.activestatus == true"),
      return_fields: "merge(DrugMaster,{stabilityUOM: document(DrugMaster.stabilityUOM)},{defaultdisptype:document(DrugMaster.defaultdisptype)},{alloweddisptype:document(DrugMaster.alloweddisptype)},{DrugClass:document(DrugMaster.DrugClass)},{DrugType:DOCUMENT(DrugMaster.DrugType)},{DrugGenericId:DOCUMENT(DrugMaster.DrugGenericId)},{DrugCategory:DOCUMENT(DrugMaster.DrugCategory)},{StrengthValuesPossible:(for strValPoss in to_array(DrugMaster.StrengthValuesPossible) return merge(strValPoss,{StrengthUOM:document(strValPoss.StrengthUOM)},{StrengthVolumeUoM:document(strValPoss.StrengthVolumeUoM)},{OrderUOMAllowed:(for OrderUOMAllowed in to_array(strValPoss.OrderUOMAllowed) return merge(OrderUOMAllowed,{AllowedOrderDoseUOM:document(OrderUOMAllowed.AllowedOrderDoseUOM)},{AllowedOrderDoseVolUoM:document(OrderUOMAllowed.AllowedOrderDoseVolUoM)}))}))},{TotalVolContentUoM:(for DrugUOM in to_array(document(DrugMaster.TotalVolContentUoM)) return merge(DrugUOM,{UOMType:document(DrugUOM.UOMType)}))},{FormCode:DOCUMENT(DrugMaster.FormCode)},{DefaultRouteCode:DOCUMENT(DrugMaster.DefaultRouteCode)},{RoutesAllowed:document(DrugMaster.RoutesAllowed)},{AlternateDrugs:DOCUMENT(DrugMaster.AlternateDrugs)},{GenericIngrListId:DOCUMENT(DrugMaster.GenericIngrListId)},{DrugDispRules:(for DrugDispRules in to_array(document(DrugMaster.DrugDispRules)) return merge(DrugDispRules,{Action:document(DrugDispRules.Action)},{maxDispDurationUOM:document(DrugDispRules.maxDispDurationUOM)},{dfltDispDurationUOM:document(DrugDispRules.dfltDispDurationUOM)}))},{FrequencyRules:(for FrequencyRules in to_array(document(DrugMaster.FrequencyRules)) return merge(FrequencyRules,{freqcode:document(FrequencyRules.freqcode) },{durnUOM:document(FrequencyRules.durnUOM)},{doseUOM:document(FrequencyRules.doseUOM)},{InfuseOverDurType:document(FrequencyRules.InfuseOverDurType)},{InfuseRateUom:document(FrequencyRules.InfuseRateUom)}))},{mappedItems:(for mappedItems in to_array(DrugMaster.mappedItems) return merge(mappedItems,{dispensedrugcode:document(mappedItems.dispensedrugcode)}))},{codeStandard:DOCUMENT(DrugMaster.codeStandard)},{entityLevelStatus:(for entityLevelStatus in to_array(document(DrugMaster.entityLevelStatus)) return merge(entityLevelStatus,{status:document(entityLevelStatus.status)},{entityCode:document(entityLevelStatus.entityCode)},{entityType:document(entityLevelStatus.entityType)}))},{packSizeApplicability:(for packSizeApplicability in to_array(document(DrugMaster.packSizeApplicability)) return merge(packSizeApplicability,{applicableInd:document(packSizeApplicability.applicableInd)},{roundtype:document(packSizeApplicability.roundtype)},{applicablityUOM:document(packSizeApplicability.applicablityUOM)},{packSizeUoM:document(packSizeApplicability.packSizeUoM)},{packUnitUoM:document(packSizeApplicability.packUnitUoM)}))},{aliasDtls:(for aliasDtls in to_array(DrugMaster.aliasDtls) return merge(aliasDtls,{aliasType:document(aliasDtls.aliasType)}) )},{instrDtls:(for instrDtls in to_array(DrugMaster.instrDtls) return merge(instrDtls,{instrType:document(instrDtls.instrType)}))},{drugSynonyms:(for drugSynonyms in to_array(DrugMaster.drugSynonyms) return merge(drugSynonyms,{synonymType:document(drugSynonyms.synonymType)}))},{photo:(for ph in document(to_array(DrugMaster.photo)) return ph)},{baseStkUoM:document(DrugMaster.baseStkUoM)},{compondCompDTls:(for compondCompDTls in to_array(DrugMaster.compondCompDTls) return merge(compondCompDTls,{compDrugCode:(for compDrugCode in to_array(compondCompDTls.compDrugCode) return document(compDrugCode))},{compQtyUom:document(compondCompDTls.compQtyUom)},{compStrengthUOM:document(compondCompDTls.compStrengthUOM)},{compStrengthVolumeUoM:document(compondCompDTls.compStrengthVolumeUoM)} ))},{directiontag:DrugMaster.directiontag},{directiontaglocal:DrugMaster.directiontaglocal},{returnPeriodUOM:document(DrugMaster.returnPeriodUOM)},{newReturnParams:(for nr in to_array(DrugMaster.newReturnParams) return merge(nr,{returnReason:document(nr.returnReason)}))})"
    };
  },
  status_update: function status_update(key, status) {
    return [{
      db_name: dbName,
      entity: "DrugMaster",
      filter: {
        _key: key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        status: status
      }
    }];
  },
  // Alerts & Restrictions Query
  drugRuleType: function drugRuleType() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type == 'RULETYPE' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  },
  drugPrivilegeType: function drugPrivilegeType() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type == 'PRIVILEGETYPE' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  },
  drugServiceApplicabilityType: function drugServiceApplicabilityType() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type == 'SERVICEAPPLICABILITY' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  },
  drugFacilityOptions: function drugFacilityOptions() {
    return {
      db_name: dbName,
      entity: "Organization",
      filter: "DOCUMENT(Organization.OrgType)[*].code ANY == 'OT003'",
      return_fields: "{_id:Organization._id,name:Organization.name}"
    };
  },
  drugApprovalWorkflowOptions: function drugApprovalWorkflowOptions() {
    return {
      db_name: dbName,
      entity: "queuescenarios",
      filter: "queuescenarios.activestatus==true && queuescenarios.status==true",
      return_fields: "Keep(queuescenarios,'_id','queueid','scenarioid','scenarioname')"
    };
  },
  drugalertRestrictionSingleRead: function drugalertRestrictionSingleRead(id) {
    return {
      db_name: dbName,
      entity: "CA_OrderCatalogPrivilegeLevel",
      filter: "CA_OrderCatalogPrivilegeLevel.activestatus == true && CA_OrderCatalogPrivilegeLevel.status==true && CA_OrderCatalogPrivilegeLevel.relationID=='".concat(id, "'"),
      return_fields: "{id:CA_OrderCatalogPrivilegeLevel.id,_key:CA_OrderCatalogPrivilegeLevel._key, orgn_code:CA_OrderCatalogPrivilegeLevel.orgn_code,service_applicablity:CA_OrderCatalogPrivilegeLevel.service_applicablity,patient_criteria:CA_OrderCatalogPrivilegeLevel.patient_criteria,pract_criteria:CA_OrderCatalogPrivilegeLevel.pract_criteria,rule_type:CA_OrderCatalogPrivilegeLevel.rule_type,privilege_type:CA_OrderCatalogPrivilegeLevel.privilege_type,alert_test_message:CA_OrderCatalogPrivilegeLevel.alert_test_message,workflow:CA_OrderCatalogPrivilegeLevel.workflow}"
    };
  },
  drugMappedDispensableRead: function drugMappedDispensableRead(_id) {
    return {
      db_name: dbName,
      entity: "DrugMaster",
      filter: "DrugMaster._id=='".concat(_id, "' && DrugMaster.activestatus==true"),
      return_fields: "keep(DrugMaster,'mappedItems','_id','_key','LongDesc','DrugCode')"
    };
  }
};
var masterQuery$8 = {
  code_standara: function code_standara() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='DBSOURCE' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  },
  drug_category: function drug_category() {
    return {
      db_name: dbName,
      entity: "DrugCategory",
      filter: "DrugCategory.activestatus == true && DrugCategory.status==true",
      return_fields: "KEEP(DrugCategory,'_key','_id','id','drugcategory','shortdesc','longdesc','status','activestatus')",
      sort: "DrugCategory.longdesc"
    };
  },
  drug_class: function drug_class() {
    return {
      db_name: dbName,
      entity: "DrugClass",
      filter: "DrugClass.activestatus == true && DrugClass.status == true",
      return_fields: "KEEP(DrugClass,'_key','_id','id','drugclass','shortdesc','longdesc','status','activestatus')",
      sort: "DrugClass.longdesc"
    };
  },
  drug_generic: function drug_generic() {
    return {
      db_name: dbName,
      entity: "GenericDrugMaster",
      filter: "GenericDrugMaster.activestatus == true ",
      limit: {
        count: 20,
        offset: 0
      },
      return_fields: "keep(GenericDrugMaster,'id','_id','longdesc','shortdesc','activestatus','mappedextsourcedb')",
      sort: "GenericDrugMaster.shortdesc"
    };
  },
  drug_type: function drug_type() {
    return {
      db_name: dbName,
      entity: "DrugType",
      filter: "DrugType.status==true && DrugType.activestatus == true ",
      return_fields: "KEEP(DrugType,'_key','_id','id','drugtype','shortdesc','longdesc','status','activestatus')",
      sort: "DrugType.longdesc"
    };
  },
  form: function form() {
    return {
      db_name: dbName,
      entity: "DosageForm",
      filter: "DosageForm.activestatus == true && DosageForm.status==true",
      return_fields: "KEEP(DosageForm,'_key','_id','id','dosageform','shortdesc','longdesc','status','activestatus')",
      sort: "DosageForm.longdesc"
    };
  },
  synonym_type: function synonym_type() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='SYNONYMTYPE' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  source: function source() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='ALIASSOURCE' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  drug_uom: function drug_uom() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='DRUGUOMCODE' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  },
  default_route: function default_route() {
    return {
      db_name: dbName,
      entity: "DrugRoutes",
      filter: "DrugRoutes.activestatus==true && DrugRoutes.status == true",
      return_fields: "kEEP(DrugRoutes,'id','_id','_key','routecode','shortdesc','longdesc','status','activestatus')",
      sort: "DrugRoutes.shortdesc"
    };
  },
  frequency: function frequency() {
    return {
      db_name: dbName,
      entity: "FrequencyMaster",
      filter: "FrequencyMaster.activestatus==true && FrequencyMaster.status == true",
      return_fields: "kEEP(FrequencyMaster,'id','_id','_key','freqcode','shortdesc','longdesc','status','activestatus')",
      sort: "CodingMaster.shortdesc"
    };
  },
  routes_allowed: function routes_allowed() {
    return {
      db_name: dbName,
      entity: "DrugRoutes",
      filter: "DrugRoutes.activestatus==true && DrugRoutes.status == true",
      return_fields: "kEEP(DrugRoutes,'id','_id','_key','routecode','shortdesc','longdesc','status','activestatus')",
      sort: "DrugRoutes.shortdesc"
    };
  },
  drug_followUom: function drug_followUom() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='FOLLOWUOM' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  },
  action: function action() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='DRUGACTION' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  },
  instruction_type: function instruction_type() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='INSTRUCTIONTYPE' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  drug_status: function drug_status() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='DRUGSTATUS' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  entity_type: function entity_type() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='ORGTYPE' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status','shortdesc','activestatus')",
      sort: "CodingMaster.display"
    };
  },
  applicability: function applicability() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='APPLICABLEUOM' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  privilege_type: function privilege_type() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type == 'PRIVILEGETYPE' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  },
  rule_type: function rule_type() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type == 'RULETYPE' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  },
  round_off_type: function round_off_type() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='ROUNDOFFTYPE' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  drug_code: function drug_code() {
    return {
      db_name: dbName,
      entity: "DrugMaster",
      // filter: "DrugMaster.activestatus == true ",
      filter: "DrugMaster.ApplicableForCompounding==true && DrugMaster.activestatus == true ",
      limit: {
        count: 20,
        offset: 0
      },
      return_fields: "keep(DrugMaster,'_id','id','_key','DrugCode','ShortDesc','StrengthValuesPossible','activestatus')",
      sort: "DrugMaster.shortdesc"
    };
  },
  item_code: function item_code(_ref) {
    var id = _ref.id;
    return {
      db_name: dbName,
      entity: "DrugMaster",
      filter: "DrugMaster._id !='".concat(id, "' && DrugMaster.activestatus == true && DrugMaster.IsDispensible == true"),
      limit: {
        count: 20,
        offset: 0
      },
      return_fields: "keep(DrugMaster,'_id','id','_key','DrugCode', 'ShortDesc','StrengthValuesPossible','activestatus')",
      sort: "DrugMaster.shortdesc"
    };
  },
  return_reason: function return_reason() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='MEDRETURNREASON' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  duration_uom: function duration_uom() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='DURATIONUOM' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  },
  pack_drug_uom: function pack_drug_uom() {
    return {
      db_name: dbName,
      entity: "DrugUOM",
      filter: "DrugUOM.status==true && DrugUOM.activestatus==true",
      return_fields: "keep(DrugUOM,'_id','UOM','UOMType','longdesc','shortdesc')"
    };
  },
  strength_uom: function strength_uom() {
    return {
      db_name: dbName,
      entity: "DrugUOM",
      filter: "document(DrugUOM.UOMType).code in ['DU013', 'DU012', 'DU010','DU008'] && DrugUOM.IsDosageQuantityUOM==true && DrugUOM.IsDosageStrengthUOM==true && DrugUOM.status==true && DrugUOM.activestatus==true",
      return_fields: "keep(DrugUOM,'_id','UOM','UOMType','longdesc','shortdesc')"
    };
  },
  order_default_duration_uom: function order_default_duration_uom() {
    return {
      db_name: dbName,
      entity: "DrugUOM",
      filter: "document(DrugUOM.UOMType).code =='DU010' && DrugUOM.status==true && DrugUOM.activestatus==true",
      return_fields: "keep(DrugUOM,'_id','UOM','UOMType','longdesc','shortdesc')"
    };
  },
  compound_quantity_uom: function compound_quantity_uom() {
    return {
      db_name: dbName,
      entity: "DrugUOM",
      filter: "document(DrugUOM.UOMType).code =='DU008' && DrugUOM.status==true && DrugUOM.activestatus==true",
      return_fields: "keep(DrugUOM,'_id','UOM','UOMType','longdesc','shortdesc')"
    };
  },
  dispense_type: function dispense_type() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='DISPENSETYPE' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  uom_time_type: function uom_time_type() {
    return {
      "db_name": dbName,
      "entity": "DrugUOM",
      "filter": "document(DrugUOM.UOMType).code in ['DU010'] && DrugUOM.status==true && DrugUOM.activestatus==true",
      "return_fields": "keep(DrugUOM,'_id','UOM','UOMType','longdesc','shortdesc')"
    };
  }
};
var entityNameOptionsQuery = function entityNameOptionsQuery() {
  var entityTypeCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "OT003";
  return {
    db_name: dbName,
    entity: "Organization",
    filter: "FIRST(DOCUMENT(Organization.OrgType)[*].code) == '".concat(entityTypeCode, "' && Organization.active==true && Organization.activestatus== true"),
    return_fields: "KEEP(Organization,'_id','id','_key','name','entitycode','active','activestatus','isExternal')"
  };
};

var initialSynonymState = {
  synonymType: "",
  langID: "",
  shortDesc: "",
  longDesc: ""
};
var initialAliasMappingState = {
  aliasType: "",
  aliasCode: "",
  aliasName: ""
};
var initialPackSizeApplicabilityState = {
  applicableInd: "",
  packSizeUoM: "",
  packSize: 0,
  packUnitUoM: "",
  roundtype: "",
  roundoff: 0,
  individualDoseRound: false
};
var initialFrequencyRulesState = {
  freqcode: "",
  durationcode: 0,
  durnUOM: "",
  doseval: 0,
  doseUOM: "",
  InfuseRateval: 0,
  InfuseRateUom: "",
  InfuseOverDurval: 0,
  InfuseOverDurType: "",
  Criteria: []
};
var initialDrugDispenseState = {
  dfltDispDurationVal: "",
  dfltDispDurationUOM: "",
  maxDispDurationVal: "",
  maxDispDurationUOM: "",
  Action: "",
  ActionMessage: "",
  Criteria: []
};
var initialInstructionsState = {
  instrType: "",
  instruction: "",
  otrLangInstr: ""
};
var initialMappedDispensablesState = {
  dispensedrugcode: "",
  seqno: null
};

var isArrayDataPresent = function isArrayDataPresent(data) {
  return Array.isArray(data) && (data === null || data === void 0 ? void 0 : data.length) > 0;
};

var removeEmptyRows = function removeEmptyRows(data) {
  var _ref = data || {},
      drugSynonyms = _ref.drugSynonyms,
      aliasDtls = _ref.aliasDtls,
      packSizeApplicability = _ref.packSizeApplicability,
      FrequencyRules = _ref.FrequencyRules,
      DrugDispRules = _ref.DrugDispRules,
      instrDtls = _ref.instrDtls,
      mappedItems = _ref.mappedItems;

  var newDrugSynonyms = isArrayDataPresent(drugSynonyms) ? drugSynonyms === null || drugSynonyms === void 0 ? void 0 : drugSynonyms.filter(function (item) {
    return Object.keys(initialSynonymState).some(function (key) {
      return Boolean(item === null || item === void 0 ? void 0 : item[key]) !== Boolean(initialSynonymState[key]);
    });
  }) : [];
  var newAliasDtls = isArrayDataPresent(aliasDtls) ? aliasDtls === null || aliasDtls === void 0 ? void 0 : aliasDtls.filter(function (item) {
    return Object.keys(initialAliasMappingState).some(function (key) {
      return Boolean(item === null || item === void 0 ? void 0 : item[key]) !== Boolean(initialAliasMappingState[key]);
    });
  }) : [];
  var newPackSizeApplicability = isArrayDataPresent(packSizeApplicability) ? packSizeApplicability === null || packSizeApplicability === void 0 ? void 0 : packSizeApplicability.filter(function (item) {
    return Object.keys(initialPackSizeApplicabilityState).some(function (key) {
      return Boolean(item === null || item === void 0 ? void 0 : item[key]) !== Boolean(initialPackSizeApplicabilityState[key]);
    });
  }) : [];
  var newFrequencyRules = isArrayDataPresent(FrequencyRules) ? FrequencyRules === null || FrequencyRules === void 0 ? void 0 : FrequencyRules.filter(function (item) {
    return Object.keys(initialFrequencyRulesState).some(function (key) {
      if (key === "Criteria" && Array.isArray(item === null || item === void 0 ? void 0 : item.Criteria)) {
        return (item === null || item === void 0 ? void 0 : item.Criteria.length) !== initialFrequencyRulesState.Criteria.length;
      }

      return Boolean(item === null || item === void 0 ? void 0 : item[key]) !== Boolean(initialFrequencyRulesState[key]);
    });
  }) : [];
  var newDrugDispRules = isArrayDataPresent(DrugDispRules) ? DrugDispRules === null || DrugDispRules === void 0 ? void 0 : DrugDispRules.filter(function (item) {
    return Object.keys(initialDrugDispenseState).some(function (key) {
      if (key === "Criteria" && Array.isArray(item === null || item === void 0 ? void 0 : item.Criteria)) {
        return (item === null || item === void 0 ? void 0 : item.Criteria.length) !== initialDrugDispenseState.Criteria.length;
      }

      return Boolean(item === null || item === void 0 ? void 0 : item[key]) !== Boolean(initialDrugDispenseState[key]);
    });
  }) : [];
  var newInstrDtls = isArrayDataPresent(instrDtls) ? instrDtls === null || instrDtls === void 0 ? void 0 : instrDtls.filter(function (item) {
    return Object.keys(initialInstructionsState).some(function (key) {
      return Boolean(item === null || item === void 0 ? void 0 : item[key]) !== Boolean(initialInstructionsState[key]);
    });
  }) : [];
  var newMappedItems = isArrayDataPresent(mappedItems) ? mappedItems === null || mappedItems === void 0 ? void 0 : mappedItems.filter(function (item) {
    return Object.keys(initialMappedDispensablesState).some(function (key) {
      return Boolean(item === null || item === void 0 ? void 0 : item[key]) !== Boolean(initialMappedDispensablesState[key]);
    });
  }) : [];
  return _objectSpread2(_objectSpread2({}, data), {}, {
    drugSynonyms: newDrugSynonyms,
    aliasDtls: newAliasDtls,
    packSizeApplicability: newPackSizeApplicability,
    FrequencyRules: newFrequencyRules,
    DrugDispRules: newDrugDispRules,
    instrDtls: newInstrDtls,
    mappedItems: newMappedItems
  });
};

var GenerateUpsert$1 = function GenerateUpsert(data) {
  // Remove Empty rows
  var payload = removeEmptyRows(data);
  var filter = {};

  if (payload !== null && payload !== void 0 && payload.isEdit) {
    filter = {
      filter: {
        _key: payload === null || payload === void 0 ? void 0 : payload._key
      }
    };
  }

  return [_objectSpread2(_objectSpread2({
    db_name: dbName,
    entity: "DrugMaster",
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
  }, filter), {}, {
    doc: {
      id: 0,
      DrugCode: payload === null || payload === void 0 ? void 0 : payload.DrugCode,
      ShortDesc: payload === null || payload === void 0 ? void 0 : payload.ShortDesc,
      LongDesc: payload === null || payload === void 0 ? void 0 : payload.LongDesc,
      // Charge: "boolean",
      DrugClass: payload === null || payload === void 0 ? void 0 : payload.DrugClass,
      DrugType: payload === null || payload === void 0 ? void 0 : payload.DrugType,
      DrugCategory: payload === null || payload === void 0 ? void 0 : payload.DrugCategory,
      StrengthValuesPossible: payload === null || payload === void 0 ? void 0 : payload.StrengthValuesPossible,
      // TotalVolContent: "string",
      // TotalVolContentUoM: "string",
      FormCode: payload === null || payload === void 0 ? void 0 : payload.FormCode,
      DefaultRouteCode: payload === null || payload === void 0 ? void 0 : payload.DefaultRouteCode,
      RoutesAllowed: payload === null || payload === void 0 ? void 0 : payload.RoutesAllowed,
      DispenseviaprescriptionOnly: payload === null || payload === void 0 ? void 0 : payload.DispenseviaprescriptionOnly,
      // IVFluid: "boolean",
      // DfltFluidCode: "string",
      // DispenseAlternateDrug: "boolean",
      // AlternateDrugs: "array",
      // SpecialInstructionText: "array",
      CounsellingRequired: payload === null || payload === void 0 ? void 0 : payload.CounsellingRequired,
      // DrugImageID: "number",
      ApplicableForCompounding: payload === null || payload === void 0 ? void 0 : payload.ApplicableForCompounding,
      Additive: payload === null || payload === void 0 ? void 0 : payload.Additive,
      // SourceOfDrugOrderCatalog: "string",
      DrugGenericId: payload === null || payload === void 0 ? void 0 : payload.DrugGenericId,
      // GenericIngrListId: "string",
      status: payload === null || payload === void 0 ? void 0 : payload.status,
      // statusactive: data?.status,
      alloweddisptype: payload === null || payload === void 0 ? void 0 : payload.alloweddisptype,
      defaultdisptype: payload === null || payload === void 0 ? void 0 : payload.defaultdisptype,
      DrugDispRules: payload === null || payload === void 0 ? void 0 : payload.DrugDispRules,
      FrequencyRules: payload === null || payload === void 0 ? void 0 : payload.FrequencyRules,
      mappedItems: payload === null || payload === void 0 ? void 0 : payload.mappedItems,
      // drugroutegenid: "string",
      codeStandard: payload === null || payload === void 0 ? void 0 : payload.codeStandard,
      IsDispensible: payload === null || payload === void 0 ? void 0 : payload.IsDispensible,
      orderable: payload === null || payload === void 0 ? void 0 : payload.orderable,
      entityLevelStatus: payload === null || payload === void 0 ? void 0 : payload.entityLevelStatus,
      packSizeApplicability: payload === null || payload === void 0 ? void 0 : payload.packSizeApplicability,
      aliasDtls: payload === null || payload === void 0 ? void 0 : payload.aliasDtls,
      instrDtls: payload === null || payload === void 0 ? void 0 : payload.instrDtls,
      directiontag: payload === null || payload === void 0 ? void 0 : payload.directiontag,
      directiontaglocal: payload === null || payload === void 0 ? void 0 : payload.directiontaglocal,
      drugSynonyms: payload === null || payload === void 0 ? void 0 : payload.drugSynonyms,
      photo: payload === null || payload === void 0 ? void 0 : payload.photo,
      // baseStkUoM: "string",
      // avgRate: "number",
      compondCompDTls: payload === null || payload === void 0 ? void 0 : payload.compondCompDTls,
      // privilegeID: "array",
      // extDrugGenericId: "string",
      returnApplicable: payload === null || payload === void 0 ? void 0 : payload.returnApplicable,
      returnPeriodVal: payload === null || payload === void 0 ? void 0 : payload.returnPeriodVal,
      returnPeriodUOM: payload === null || payload === void 0 ? void 0 : payload.returnPeriodUOM,
      partialQtyAllow: payload === null || payload === void 0 ? void 0 : payload.partialQtyAllow,
      returnPolicy: payload === null || payload === void 0 ? void 0 : payload.returnPolicy,
      newReturnParams: payload === null || payload === void 0 ? void 0 : payload.newReturnParams,
      stability: Number(payload === null || payload === void 0 ? void 0 : payload.stability),
      stabilityUOM: payload === null || payload === void 0 ? void 0 : payload.stabilityUOM
    }
  })];
};
var GenerateAlertRestrictionUpsert = function GenerateAlertRestrictionUpsert(data) {
  var filter = {};

  if (data !== null && data !== void 0 && data.isEdit) {
    filter = {
      filter: {
        _key: data === null || data === void 0 ? void 0 : data._key
      }
    };
  }

  return [_objectSpread2(_objectSpread2({
    db_name: dbName,
    entity: "CA_OrderCatalogPrivilegeLevel",
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
  }, filter), {}, {
    doc: {
      id: 0,
      orgn_code: data === null || data === void 0 ? void 0 : data.orgn_code,
      service_applicablity: data === null || data === void 0 ? void 0 : data.service_applicablity,
      order_catalog_criteria: data === null || data === void 0 ? void 0 : data.order_catalog_criteria,
      patient_criteria: data === null || data === void 0 ? void 0 : data.patient_criteria,
      pract_criteria: data === null || data === void 0 ? void 0 : data.pract_criteria,
      // appr_leveles: [
      //   {
      //     appr_level: "string",
      //     appr_level_description: "string",
      //     approval_authority_criteria: "array",
      //   },
      // ],
      rule_type: data === null || data === void 0 ? void 0 : data.rule_type,
      privilege_type: data === null || data === void 0 ? void 0 : data.privilege_type,
      status: data === null || data === void 0 ? void 0 : data.status,
      alert_test_message: data === null || data === void 0 ? void 0 : data.alert_test_message,
      workflow: data === null || data === void 0 ? void 0 : data.workflow,
      relationID: data === null || data === void 0 ? void 0 : data.relationID // This is mandatory for further reading of documents on Update mode. Do not remove this field.

    }
  })];
};
var GenerateMappedItemUpsert = function GenerateMappedItemUpsert(data) {
  var filter = {};

  if (data !== null && data !== void 0 && data._key) {
    filter = {
      filter: {
        _key: data === null || data === void 0 ? void 0 : data._key
      }
    };
  }

  return [_objectSpread2(_objectSpread2({
    db_name: dbName,
    entity: "DrugMaster"
  }, filter), {}, {
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
    doc: {
      mappedItems: data === null || data === void 0 ? void 0 : data.mappedItems // mappedItems: [
      //   {
      //     dispensedrugcode: "string",
      //     seqno: "number",
      //   },
      // ],

    }
  })];
};

var _extraReducers$J;
var DRUG_CATALOG_MASTER_FULL_READ = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_catalog_master_fullRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      isWithoutLimit,
      page,
      perPage,
      _payload$searchQuery,
      searchQuery,
      queryId,
      withoutLimitFilter,
      withLimitFilter,
      fullReadQDMQuery,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          isWithoutLimit = payload.isWithoutLimit, page = payload.page, perPage = payload.perPage, _payload$searchQuery = payload.searchQuery, searchQuery = _payload$searchQuery === void 0 ? "" : _payload$searchQuery;
          queryId = isWithoutLimit ? "b1656253-8d63-4954-98ea-3765c230a3d5" : "2d926ad5-19f5-4140-9158-f4cd17e7c307";
          withoutLimitFilter = {
            filter: {
              search: "%".concat(searchQuery, "%")
            }
          };
          withLimitFilter = {
            filter: {
              search: "%".concat(searchQuery, "%"),
              page: page,
              perPage: perPage
            }
          };
          fullReadQDMQuery = _objectSpread2({
            db_name: dbName,
            queryid: queryId
          }, isWithoutLimit ? withoutLimitFilter : withLimitFilter);
          _context.next = 10;
          return fetchData({
            body: JSON.stringify(fullReadQDMQuery)
          }, __baseUrl__);

        case 10:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 14]]);
})));
var DRUG_CATALOG_MASTER_SINGLE_READ = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_catalog_master_singleRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      id,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          id = payload.id;
          _context2.next = 6;
          return fetchData({
            body: JSON.stringify(drugCatalogMasterQuery.drugCatalogMasterSingleRead(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 13:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 10]]);
})));
var DRUG_CATALOG_STATUS_UPDATE = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_catalog_status_update", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      key,
      status,
      data,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          key = payload.key, status = payload.status;
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(drugCatalogMasterQuery.status_update(key, status))
          }, __uspsertUrl__);

        case 6:
          data = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 10]]);
})));

var loopMasters$9 = function loopMasters(params) {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(resolve, reject) {
      var calls;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              calls = Object.keys(masterQuery$8).map( /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(val) {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          if (!(val === "item_code")) {
                            _context4.next = 4;
                            break;
                          }

                          _context4.next = 3;
                          return fetchMaster$9(val, masterQuery$8[val], params === null || params === void 0 ? void 0 : params[val]);

                        case 3:
                          return _context4.abrupt("return", _context4.sent);

                        case 4:
                          _context4.next = 6;
                          return fetchMaster$9(val, masterQuery$8[val]);

                        case 6:
                          return _context4.abrupt("return", _context4.sent);

                        case 7:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x3) {
                  return _ref8.apply(this, arguments);
                };
              }());
              es6Promise.Promise.all(calls).then(function (data) {
                var json = {};
                data.map(function (val) {
                  var arr = [];
                  val.data.map(function (value) {
                    switch (val.name) {
                      case "synonym_type":
                      case "source":
                      case "drug_uom":
                      case "instruction_type":
                      case "drug_status":
                      case "applicability":
                      case "rule_type":
                      case "round_off_type":
                      case "return_reason":
                      case "duration_uom":
                      case "dispense_type":
                        arr.push({
                          label: value !== null && value !== void 0 && value.display ? value === null || value === void 0 ? void 0 : value.display : "",
                          value: value !== null && value !== void 0 && value._id ? value === null || value === void 0 ? void 0 : value._id : ""
                        });
                        break;

                      case "code_standara":
                      case "drug_class":
                      case "drug_generic":
                      case "drug_type":
                      case "form":
                      case "drug_category":
                      case "drug_type":
                      case "form":
                      case "default_route":
                      case "frequency":
                      case "routes_allowed":
                      case "drug_followUom":
                      case "action":
                      case "entity_type":
                      case "privilege_type":
                      case "pack_drug_uom":
                      case "strength_uom":
                      case "order_default_duration_uom":
                      case "compound_quantity_uom":
                      case "uom_time_type":
                        arr.push(_objectSpread2({
                          label: value.shortdesc ? value.shortdesc : "",
                          value: value._id
                        }, value));
                        break;

                      case "drug_code":
                      case "item_code":
                        arr.push(_objectSpread2({
                          label: value.ShortDesc ? value.ShortDesc : "",
                          value: value._id
                        }, value));
                        break;

                      default:
                        arr.push(_objectSpread2({
                          label: value,
                          value: value._id
                        }, value));
                        break;
                    }
                  });
                  json[val.name] = arr;
                  resolve(json);
                });
              })["catch"](function (err) {
                resolve([]);
              });

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x, _x2) {
      return _ref7.apply(this, arguments);
    };
  }());
};

var fetchMaster$9 = function fetchMaster(name, query, params) {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(resolve, reject) {
      var data;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return fetchData({
                body: JSON.stringify(query(params))
              }, __readDocumentUrl__);

            case 2:
              data = _context6.sent;
              resolve({
                data: data.result,
                name: name
              });

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x4, _x5) {
      return _ref9.apply(this, arguments);
    };
  }());
};

var DRUG_CATALOG_MASTER_DROPDOWN_QUERY = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_catalog_master_dropdown_query", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref11,
      rejectWithValue,
      itemCodeId,
      params,
      data,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref11 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref11.rejectWithValue;
          _context7.prev = 2;
          itemCodeId = payload.itemCodeId;
          params = {
            item_code: {
              id: itemCodeId
            }
          };
          _context7.next = 7;
          return loopMasters$9(params);

        case 7:
          data = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context7.prev = 11;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 14:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 11]]);
})));
var DRUG_CATALOG_MASTER_ENTITY_NAME_OPTIONS = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_catalog_master_entity_name_options", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref13,
      rejectWithValue,
      entityTypeCode,
      data,
      _data,
      _data$result,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref13 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref13.rejectWithValue;
          _context8.prev = 2;
          entityTypeCode = payload.entityTypeCode;
          _context8.next = 6;
          return fetchData({
            body: JSON.stringify(entityNameOptionsQuery(entityTypeCode))
          }, __readDocumentUrl__);

        case 6:
          data = _context8.sent;

          if (!(data.result.length > 0)) {
            _context8.next = 12;
            break;
          }

          data = (_data = data) === null || _data === void 0 ? void 0 : (_data$result = _data.result) === null || _data$result === void 0 ? void 0 : _data$result.map(function (option) {
            return _objectSpread2({
              label: option === null || option === void 0 ? void 0 : option.name,
              value: option === null || option === void 0 ? void 0 : option._id
            }, option);
          });
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 12:
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: []
          }));

        case 13:
          _context8.next = 18;
          break;

        case 15:
          _context8.prev = 15;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 18:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 15]]);
})));
var DRUG_CATALOG_MASTER_SAVE = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_catalog_master_save", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref15,
      rejectWithValue,
      body,
      Body,
      data,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref15 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref15.rejectWithValue;
          _context9.prev = 2;
          body = payload.body;
          Body = GenerateUpsert$1(body);
          _context9.next = 7;
          return fetchData({
            body: JSON.stringify(Body)
          }, __uspsertUrl__);

        case 7:
          data = _context9.sent;
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context9.prev = 11;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 14:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 11]]);
})));
var DRUG_CATALOG_MAPPED_ITEM_SAVE = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_catalog_mapped_item_save", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref17,
      rejectWithValue,
      body,
      Body,
      data,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref17 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref17.rejectWithValue;
          _context10.prev = 2;
          body = payload.body;
          Body = GenerateMappedItemUpsert(body);
          _context10.next = 7;
          return fetchData({
            body: JSON.stringify(Body)
          }, __uspsertUrl__);

        case 7:
          data = _context10.sent;
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context10.prev = 11;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 14:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 11]]);
})));
var DRUG_RULE__TYPE = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_rule_type", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var _ref19,
      rejectWithValue,
      _data$result2,
      data,
      _data$result3,
      res,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _ref19 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref19.rejectWithValue;
          _context11.prev = 2;
          _context11.next = 5;
          return fetchData({
            body: JSON.stringify(drugCatalogMasterQuery.drugRuleType())
          }, __readDocumentUrl__);

        case 5:
          data = _context11.sent;

          if (!((data === null || data === void 0 ? void 0 : (_data$result2 = data.result) === null || _data$result2 === void 0 ? void 0 : _data$result2.length) > 0)) {
            _context11.next = 11;
            break;
          }

          res = data === null || data === void 0 ? void 0 : (_data$result3 = data.result) === null || _data$result3 === void 0 ? void 0 : _data$result3.map(function (option) {
            return _objectSpread2(_objectSpread2({}, option), {}, {
              label: option === null || option === void 0 ? void 0 : option.display,
              value: option === null || option === void 0 ? void 0 : option._id
            });
          });
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res === null || res === void 0 ? void 0 : res.reverse()
          }));

        case 11:
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: []
          }));

        case 12:
          _context11.next = 17;
          break;

        case 14:
          _context11.prev = 14;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 17:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 14]]);
})));
var DRUG_PRIVILEGE__TYPE = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_privilege_type", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var _ref21,
      rejectWithValue,
      _data$result4,
      data,
      _data$result5,
      res,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _ref21 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref21.rejectWithValue;
          _context12.prev = 2;
          _context12.next = 5;
          return fetchData({
            body: JSON.stringify(drugCatalogMasterQuery.drugPrivilegeType())
          }, __readDocumentUrl__);

        case 5:
          data = _context12.sent;

          if (!((data === null || data === void 0 ? void 0 : (_data$result4 = data.result) === null || _data$result4 === void 0 ? void 0 : _data$result4.length) > 0)) {
            _context12.next = 11;
            break;
          }

          res = data === null || data === void 0 ? void 0 : (_data$result5 = data.result) === null || _data$result5 === void 0 ? void 0 : _data$result5.map(function (option) {
            return _objectSpread2(_objectSpread2({}, option), {}, {
              label: option === null || option === void 0 ? void 0 : option.display,
              value: option === null || option === void 0 ? void 0 : option._id
            });
          });
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 11:
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: []
          }));

        case 12:
          _context12.next = 17;
          break;

        case 14:
          _context12.prev = 14;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 17:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 14]]);
})));
var DRUG_SERVICE_APPLICABILITY_TYPE = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_service_applicability_type", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
  var _ref23,
      rejectWithValue,
      _data$result6,
      data,
      _data$result7,
      res,
      _args13 = arguments;

  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _ref23 = _args13.length > 1 ? _args13[1] : undefined, rejectWithValue = _ref23.rejectWithValue;
          _context13.prev = 2;
          _context13.next = 5;
          return fetchData({
            body: JSON.stringify(drugCatalogMasterQuery.drugServiceApplicabilityType())
          }, __readDocumentUrl__);

        case 5:
          data = _context13.sent;

          if (!((data === null || data === void 0 ? void 0 : (_data$result6 = data.result) === null || _data$result6 === void 0 ? void 0 : _data$result6.length) > 0)) {
            _context13.next = 11;
            break;
          }

          res = data === null || data === void 0 ? void 0 : (_data$result7 = data.result) === null || _data$result7 === void 0 ? void 0 : _data$result7.map(function (option) {
            return _objectSpread2(_objectSpread2({}, option), {}, {
              label: option === null || option === void 0 ? void 0 : option.display,
              value: option === null || option === void 0 ? void 0 : option._id
            });
          });
          return _context13.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res === null || res === void 0 ? void 0 : res.reverse()
          }));

        case 11:
          return _context13.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: []
          }));

        case 12:
          _context13.next = 17;
          break;

        case 14:
          _context13.prev = 14;
          _context13.t0 = _context13["catch"](2);
          return _context13.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context13.t0.message
          })));

        case 17:
        case "end":
          return _context13.stop();
      }
    }
  }, _callee13, null, [[2, 14]]);
})));
var DRUG_FACILITY_OPTIONS = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_facility_options", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
  var _ref25,
      rejectWithValue,
      _data$result8,
      data,
      _data$result9,
      res,
      _args14 = arguments;

  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _ref25 = _args14.length > 1 ? _args14[1] : undefined, rejectWithValue = _ref25.rejectWithValue;
          _context14.prev = 2;
          _context14.next = 5;
          return fetchData({
            body: JSON.stringify(drugCatalogMasterQuery.drugFacilityOptions())
          }, __readDocumentUrl__);

        case 5:
          data = _context14.sent;

          if (!((data === null || data === void 0 ? void 0 : (_data$result8 = data.result) === null || _data$result8 === void 0 ? void 0 : _data$result8.length) > 0)) {
            _context14.next = 11;
            break;
          }

          res = data === null || data === void 0 ? void 0 : (_data$result9 = data.result) === null || _data$result9 === void 0 ? void 0 : _data$result9.map(function (option) {
            return _objectSpread2(_objectSpread2({}, option), {}, {
              label: option === null || option === void 0 ? void 0 : option.name,
              value: option === null || option === void 0 ? void 0 : option._id
            });
          });
          return _context14.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 11:
          return _context14.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: []
          }));

        case 12:
          _context14.next = 17;
          break;

        case 14:
          _context14.prev = 14;
          _context14.t0 = _context14["catch"](2);
          return _context14.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context14.t0.message
          })));

        case 17:
        case "end":
          return _context14.stop();
      }
    }
  }, _callee14, null, [[2, 14]]);
})));
var DRUG_APPROVAL_WORKFLOW_OPTIONS = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_approval_workflow_options", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
  var _ref27,
      rejectWithValue,
      _data$result10,
      data,
      _data$result11,
      res,
      _args15 = arguments;

  return _regeneratorRuntime().wrap(function _callee15$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _ref27 = _args15.length > 1 ? _args15[1] : undefined, rejectWithValue = _ref27.rejectWithValue;
          _context15.prev = 2;
          _context15.next = 5;
          return fetchData({
            body: JSON.stringify(drugCatalogMasterQuery.drugApprovalWorkflowOptions())
          }, __readDocumentUrl__);

        case 5:
          data = _context15.sent;

          if (!((data === null || data === void 0 ? void 0 : (_data$result10 = data.result) === null || _data$result10 === void 0 ? void 0 : _data$result10.length) > 0)) {
            _context15.next = 11;
            break;
          }

          res = data === null || data === void 0 ? void 0 : (_data$result11 = data.result) === null || _data$result11 === void 0 ? void 0 : _data$result11.map(function (option) {
            return _objectSpread2(_objectSpread2({}, option), {}, {
              label: option === null || option === void 0 ? void 0 : option.scenarioname,
              value: option === null || option === void 0 ? void 0 : option._id
            });
          });
          return _context15.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 11:
          return _context15.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: []
          }));

        case 12:
          _context15.next = 17;
          break;

        case 14:
          _context15.prev = 14;
          _context15.t0 = _context15["catch"](2);
          return _context15.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context15.t0.message
          })));

        case 17:
        case "end":
          return _context15.stop();
      }
    }
  }, _callee15, null, [[2, 14]]);
})));
var DRUG_ALERTS_RESTRICTIONS_SAVE = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_alerts_restrictions_save", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
  var payload,
      _ref29,
      rejectWithValue,
      body,
      Body,
      data,
      _args16 = arguments;

  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          payload = _args16.length > 0 && _args16[0] !== undefined ? _args16[0] : {};
          _ref29 = _args16.length > 1 ? _args16[1] : undefined, rejectWithValue = _ref29.rejectWithValue;
          _context16.prev = 2;
          body = payload.body;
          Body = GenerateAlertRestrictionUpsert(body);
          _context16.next = 7;
          return fetchData({
            body: JSON.stringify(Body)
          }, __uspsertUrl__);

        case 7:
          data = _context16.sent;
          return _context16.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context16.prev = 11;
          _context16.t0 = _context16["catch"](2);
          return _context16.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context16.t0.message
          })));

        case 14:
        case "end":
          return _context16.stop();
      }
    }
  }, _callee16, null, [[2, 11]]);
})));
var DRUG_ALERTS_RESTRICTIONS_SINGLE_READ = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_alerts_restriction_singleRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
  var payload,
      _ref31,
      rejectWithValue,
      id,
      data,
      _args17 = arguments;

  return _regeneratorRuntime().wrap(function _callee17$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          payload = _args17.length > 0 && _args17[0] !== undefined ? _args17[0] : {};
          _ref31 = _args17.length > 1 ? _args17[1] : undefined, rejectWithValue = _ref31.rejectWithValue;
          _context17.prev = 2;
          id = payload.id;
          _context17.next = 6;
          return fetchData({
            body: JSON.stringify(drugCatalogMasterQuery.drugalertRestrictionSingleRead(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context17.sent;
          return _context17.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context17.prev = 10;
          _context17.t0 = _context17["catch"](2);
          return _context17.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context17.t0.message
          })));

        case 13:
        case "end":
          return _context17.stop();
      }
    }
  }, _callee17, null, [[2, 10]]);
})));
var DRUG_MAPPED_DISPENSABLE_READ = toolkit.createAsyncThunk("drugCatalogMasterApiSlice/drug_mapped_dispensable_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
  var payload,
      _ref33,
      rejectWithValue,
      _id,
      data,
      _args18 = arguments;

  return _regeneratorRuntime().wrap(function _callee18$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          payload = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : {};
          _ref33 = _args18.length > 1 ? _args18[1] : undefined, rejectWithValue = _ref33.rejectWithValue;
          _context18.prev = 2;
          _id = payload._id;
          _context18.next = 6;
          return fetchData({
            body: JSON.stringify(drugCatalogMasterQuery.drugMappedDispensableRead(_id))
          }, __readDocumentUrl__);

        case 6:
          data = _context18.sent;
          return _context18.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context18.prev = 10;
          _context18.t0 = _context18["catch"](2);
          return _context18.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context18.t0.message
          })));

        case 13:
        case "end":
          return _context18.stop();
      }
    }
  }, _callee18, null, [[2, 10]]);
})));
var drugCatalogMasterSlice = toolkit.createSlice({
  name: "drugCatalogMasterApiSlice",
  initialState: {
    drugCatalogMasterFullread: _objectSpread2({}, defaultState.List),
    drugCatalogMasterSingleread: _objectSpread2({}, defaultState.List),
    drugCatalogStatusUpdate: _objectSpread2({}, defaultState.List),
    drugCatalogMasterDropdownQuery: _objectSpread2({}, defaultState.Info),
    drugCatalogMasterEntityNameOptions: _objectSpread2({}, defaultState.List),
    drugCatalogMasterSave: _objectSpread2({}, defaultState.Info),
    drugMappedDispensableRead: _objectSpread2({}, defaultState.Info),
    drugCatalogMappedItemSave: _objectSpread2({}, defaultState.Info),
    drugRuleType: _objectSpread2({}, defaultState.List),
    drugPrivilegeType: _objectSpread2({}, defaultState.List),
    drugServiceApplicabilityType: _objectSpread2({}, defaultState.List),
    drugFacilityOptions: _objectSpread2({}, defaultState.List),
    drugApprovalWorkflowOptions: _objectSpread2({}, defaultState.List),
    drugAlertsRestrictionSave: _objectSpread2({}, defaultState.Info),
    drugAlertsRestrictionSingleRead: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$J = {}, _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_FULL_READ.fulfilled, function (state, action) {
    var _action$payload;

    state.drugCatalogMasterFullread = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_FULL_READ.pending, function (state, action) {
    state.drugCatalogMasterFullread.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_FULL_READ.rejected, function (state, action) {
    var _action$payload2;

    state.drugCatalogMasterFullread = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_SINGLE_READ.fulfilled, function (state, action) {
    var _action$payload3;

    state.drugCatalogMasterSingleread = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_SINGLE_READ.pending, function (state, action) {
    state.drugCatalogMasterSingleread.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_SINGLE_READ.rejected, function (state, action) {
    var _action$payload4;

    state.drugCatalogMasterSingleread = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_STATUS_UPDATE.fulfilled, function (state, action) {
    var _action$payload5;

    state.drugCatalogStatusUpdate = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_STATUS_UPDATE.pending, function (state, action) {
    state.drugCatalogStatusUpdate.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_STATUS_UPDATE.rejected, function (state, action) {
    var _action$payload6;

    state.drugCatalogStatusUpdate = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_DROPDOWN_QUERY.fulfilled, function (state, action) {
    var _action$payload7;

    state.drugCatalogMasterDropdownQuery = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : {};
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_DROPDOWN_QUERY.pending, function (state, action) {
    state.drugCatalogMasterDropdownQuery.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_DROPDOWN_QUERY.rejected, function (state, action) {
    var _action$payload8;

    state.drugCatalogMasterDropdownQuery = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : {};
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_ENTITY_NAME_OPTIONS.fulfilled, function (state, action) {
    var _action$payload9;

    state.drugCatalogMasterEntityNameOptions = (_action$payload9 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload9 !== void 0 ? _action$payload9 : {};
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_ENTITY_NAME_OPTIONS.pending, function (state, action) {
    state.drugCatalogMasterEntityNameOptions.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_ENTITY_NAME_OPTIONS.rejected, function (state, action) {
    var _action$payload10;

    state.drugCatalogMasterEntityNameOptions = (_action$payload10 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload10 !== void 0 ? _action$payload10 : {};
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_SAVE.fulfilled, function (state, action) {
    var _action$payload11;

    state.drugCatalogMasterSave = (_action$payload11 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload11 !== void 0 ? _action$payload11 : {};
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_SAVE.pending, function (state, action) {
    state.drugCatalogMasterSave.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MASTER_SAVE.rejected, function (state, action) {
    var _action$payload12;

    state.drugCatalogMasterSave = (_action$payload12 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload12 !== void 0 ? _action$payload12 : {};
  }), _defineProperty(_extraReducers$J, DRUG_MAPPED_DISPENSABLE_READ.fulfilled, function (state, action) {
    var _action$payload13;

    state.drugMappedDispensableRead = (_action$payload13 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload13 !== void 0 ? _action$payload13 : {};
  }), _defineProperty(_extraReducers$J, DRUG_MAPPED_DISPENSABLE_READ.pending, function (state, action) {
    state.drugMappedDispensableRead.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_MAPPED_DISPENSABLE_READ.rejected, function (state, action) {
    var _action$payload14;

    state.drugMappedDispensableRead = (_action$payload14 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload14 !== void 0 ? _action$payload14 : {};
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MAPPED_ITEM_SAVE.fulfilled, function (state, action) {
    var _action$payload15;

    state.drugCatalogMappedItemSave = (_action$payload15 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload15 !== void 0 ? _action$payload15 : {};
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MAPPED_ITEM_SAVE.pending, function (state, action) {
    state.drugCatalogMappedItemSave.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_CATALOG_MAPPED_ITEM_SAVE.rejected, function (state, action) {
    var _action$payload16;

    state.drugCatalogMappedItemSave = (_action$payload16 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload16 !== void 0 ? _action$payload16 : {};
  }), _defineProperty(_extraReducers$J, DRUG_RULE__TYPE.fulfilled, function (state, action) {
    var _action$payload17;

    state.drugRuleType = (_action$payload17 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload17 !== void 0 ? _action$payload17 : {};
  }), _defineProperty(_extraReducers$J, DRUG_RULE__TYPE.pending, function (state, action) {
    state.drugRuleType.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_RULE__TYPE.rejected, function (state, action) {
    var _action$payload18;

    state.drugRuleType = (_action$payload18 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload18 !== void 0 ? _action$payload18 : {};
  }), _defineProperty(_extraReducers$J, DRUG_PRIVILEGE__TYPE.fulfilled, function (state, action) {
    var _action$payload19;

    state.drugPrivilegeType = (_action$payload19 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload19 !== void 0 ? _action$payload19 : {};
  }), _defineProperty(_extraReducers$J, DRUG_PRIVILEGE__TYPE.pending, function (state, action) {
    state.drugPrivilegeType.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_PRIVILEGE__TYPE.rejected, function (state, action) {
    var _action$payload20;

    state.drugPrivilegeType = (_action$payload20 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload20 !== void 0 ? _action$payload20 : {};
  }), _defineProperty(_extraReducers$J, DRUG_SERVICE_APPLICABILITY_TYPE.fulfilled, function (state, action) {
    var _action$payload21;

    state.drugServiceApplicabilityType = (_action$payload21 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload21 !== void 0 ? _action$payload21 : {};
  }), _defineProperty(_extraReducers$J, DRUG_SERVICE_APPLICABILITY_TYPE.pending, function (state, action) {
    state.drugServiceApplicabilityType.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_SERVICE_APPLICABILITY_TYPE.rejected, function (state, action) {
    var _action$payload22;

    state.drugServiceApplicabilityType = (_action$payload22 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload22 !== void 0 ? _action$payload22 : {};
  }), _defineProperty(_extraReducers$J, DRUG_FACILITY_OPTIONS.fulfilled, function (state, action) {
    var _action$payload23;

    state.drugFacilityOptions = (_action$payload23 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload23 !== void 0 ? _action$payload23 : {};
  }), _defineProperty(_extraReducers$J, DRUG_FACILITY_OPTIONS.pending, function (state, action) {
    state.drugFacilityOptions.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_FACILITY_OPTIONS.rejected, function (state, action) {
    var _action$payload24;

    state.drugFacilityOptions = (_action$payload24 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload24 !== void 0 ? _action$payload24 : {};
  }), _defineProperty(_extraReducers$J, DRUG_APPROVAL_WORKFLOW_OPTIONS.fulfilled, function (state, action) {
    var _action$payload25;

    state.drugApprovalWorkflowOptions = (_action$payload25 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload25 !== void 0 ? _action$payload25 : {};
  }), _defineProperty(_extraReducers$J, DRUG_APPROVAL_WORKFLOW_OPTIONS.pending, function (state, action) {
    state.drugApprovalWorkflowOptions.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_APPROVAL_WORKFLOW_OPTIONS.rejected, function (state, action) {
    var _action$payload26;

    state.drugApprovalWorkflowOptions = (_action$payload26 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload26 !== void 0 ? _action$payload26 : {};
  }), _defineProperty(_extraReducers$J, DRUG_ALERTS_RESTRICTIONS_SAVE.fulfilled, function (state, action) {
    var _action$payload27;

    state.drugAlertsRestrictionSave = (_action$payload27 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload27 !== void 0 ? _action$payload27 : {};
  }), _defineProperty(_extraReducers$J, DRUG_ALERTS_RESTRICTIONS_SAVE.pending, function (state, action) {
    state.drugAlertsRestrictionSave.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_ALERTS_RESTRICTIONS_SAVE.rejected, function (state, action) {
    var _action$payload28;

    state.drugAlertsRestrictionSave = (_action$payload28 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload28 !== void 0 ? _action$payload28 : {};
  }), _defineProperty(_extraReducers$J, DRUG_ALERTS_RESTRICTIONS_SINGLE_READ.fulfilled, function (state, action) {
    var _action$payload29;

    state.drugAlertsRestrictionSingleRead = (_action$payload29 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload29 !== void 0 ? _action$payload29 : {};
  }), _defineProperty(_extraReducers$J, DRUG_ALERTS_RESTRICTIONS_SINGLE_READ.pending, function (state, action) {
    state.drugAlertsRestrictionSingleRead.loading = true;
  }), _defineProperty(_extraReducers$J, DRUG_ALERTS_RESTRICTIONS_SINGLE_READ.rejected, function (state, action) {
    var _action$payload30;

    state.drugAlertsRestrictionSingleRead = (_action$payload30 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload30 !== void 0 ? _action$payload30 : {};
  }), _extraReducers$J)
}); // FrequencySchedule ACTION LISTS

var drugCatalogMasterActions = {
  DRUG_CATALOG_MASTER_FULL_READ: DRUG_CATALOG_MASTER_FULL_READ,
  DRUG_CATALOG_MASTER_SINGLE_READ: DRUG_CATALOG_MASTER_SINGLE_READ,
  DRUG_CATALOG_STATUS_UPDATE: DRUG_CATALOG_STATUS_UPDATE,
  DRUG_CATALOG_MASTER_DROPDOWN_QUERY: DRUG_CATALOG_MASTER_DROPDOWN_QUERY,
  DRUG_CATALOG_MASTER_ENTITY_NAME_OPTIONS: DRUG_CATALOG_MASTER_ENTITY_NAME_OPTIONS,
  DRUG_CATALOG_MASTER_SAVE: DRUG_CATALOG_MASTER_SAVE,
  DRUG_MAPPED_DISPENSABLE_READ: DRUG_MAPPED_DISPENSABLE_READ,
  DRUG_CATALOG_MAPPED_ITEM_SAVE: DRUG_CATALOG_MAPPED_ITEM_SAVE,
  DRUG_RULE__TYPE: DRUG_RULE__TYPE,
  DRUG_PRIVILEGE__TYPE: DRUG_PRIVILEGE__TYPE,
  DRUG_SERVICE_APPLICABILITY_TYPE: DRUG_SERVICE_APPLICABILITY_TYPE,
  DRUG_FACILITY_OPTIONS: DRUG_FACILITY_OPTIONS,
  DRUG_APPROVAL_WORKFLOW_OPTIONS: DRUG_APPROVAL_WORKFLOW_OPTIONS,
  DRUG_ALERTS_RESTRICTIONS_SAVE: DRUG_ALERTS_RESTRICTIONS_SAVE,
  DRUG_ALERTS_RESTRICTIONS_SINGLE_READ: DRUG_ALERTS_RESTRICTIONS_SINGLE_READ
};
var drugCatalogMasterSlice$1 = drugCatalogMasterSlice.reducer;

var pharmacy = {
  Pharmacy_Rule_Group: function Pharmacy_Rule_Group() {
    return {
      db_name: "RuleBuilder",
      entity: "Groups",
      filter: "Groups.activestatus==true",
      return_fields: "{label : Groups.name, value:Groups.id}"
    };
  },
  Pharmacy_Rule: function Pharmacy_Rule(groupId) {
    return {
      db_name: "RuleBuilder",
      entity: "Rules",
      filter: "Rules.activestatus==true && Rules.groupId == ".concat(groupId),
      return_fields: "{ label: Rules.ruleName, value: Rules._id }"
    };
  }
};

var _extraReducers$I;
var group_dropdown = toolkit.createAsyncThunk("ruleExistReducer/getGroup", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload, action) {
    var _rejectWithValue, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _rejectWithValue = action.rejectWithValue;
            body = {};
            body = JSON.stringify(pharmacy.Pharmacy_Rule_Group());
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context.next = 7;
            return fetchDataApi(__readDocumentUrl__, options);

          case 7:
            _res = _context.sent;

            if (_res.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 10:
            _context.next = 12;
            return _res.json();

          case 12:
            response = _context.sent;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
var rule_dropdown = toolkit.createAsyncThunk("ruleExistReducer/getRule", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(payload, action) {
    var groupId, _rejectWithValue2, body, options, _res, response;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            groupId = payload.groupId;
            _rejectWithValue2 = action.rejectWithValue;
            body = {};
            body = JSON.stringify(pharmacy.Pharmacy_Rule(groupId));
            options = {
              method: "Post",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: body
            };
            _context2.next = 8;
            return fetchDataApi(__readDocumentUrl__, options);

          case 8:
            _res = _context2.sent;

            if (_res.ok) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", _rejectWithValue2(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _res === null || _res === void 0 ? void 0 : _res.statusText,
              Code: _res.status
            })));

          case 11:
            _context2.next = 13;
            return _res.json();

          case 13:
            response = _context2.sent;
            return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, response), {}, {
              Code: _res.status
            }));

          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context2.t0.message
            })));

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 17]]);
  }));

  return function (_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}());
var ruleExistReducer = toolkit.createSlice({
  name: "ruleExistReducer",
  initialState: {
    getGroup: _objectSpread2({}, defaultState.Info),
    getRule: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$I = {}, _defineProperty(_extraReducers$I, group_dropdown.fulfilled, function (state, action) {
    var _action$payload$data, _action$payload;

    state.getGroup.loading = false, state.getGroup.data = (_action$payload$data = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : action === null || action === void 0 ? void 0 : action.payload, state.getGroup.error = false, state.getGroup.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$I, group_dropdown.rejected, function (state, action) {
    var _action$payload2;

    state.getGroup = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$I, group_dropdown.pending, function (state, action) {
    state.getGroup.loading = true;
  }), _defineProperty(_extraReducers$I, rule_dropdown.fulfilled, function (state, action) {
    var _action$payload$data2, _action$payload3;

    state.getRule.loading = false, state.getRule.data = (_action$payload$data2 = action === null || action === void 0 ? void 0 : (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.data) !== null && _action$payload$data2 !== void 0 ? _action$payload$data2 : action === null || action === void 0 ? void 0 : action.payload, state.getRule.error = false, state.getRule.message = httpMessage.OkMessage;
  }), _defineProperty(_extraReducers$I, rule_dropdown.rejected, function (state, action) {
    var _action$payload4;

    state.getRule = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$I, rule_dropdown.pending, function (state, action) {
    state.getRule.loading = true;
  }), _extraReducers$I)
});
var group_dropdownActions = {
  group_dropdown: group_dropdown,
  rule_dropdown: rule_dropdown
};
var ruleExistReducer$1 = ruleExistReducer.reducer;

var queries$n = {
  laborder_PractitionerName: function laborder_PractitionerName(OrgId, id, _id) {
    return {
      db_name: dbName,
      entity: "Practitioner",
      filter: "DOCUMENT(DOCUMENT(Practitioner.practitioner_role)[0].EntityName).id==".concat(OrgId, " AND DOCUMENT( DOCUMENT(DOCUMENT(Practitioner.practitioner_role)[*].role)[0].coding[0])._id =='").concat(_id, "'"),
      return_fields: "MERGE(Practitioner,{name:(FOR hn IN TO_ARRAY(Practitioner.name) RETURN MERGE(DOCUMENT(hn),{use:(FOR cod IN TO_ARRAY(DOCUMENT(DOCUMENT(hn).use).coding) RETURN MERGE(DOCUMENT(DOCUMENT(hn).use),{coding:DOCUMENT(cod)})),prefix:(FOR cod IN TO_ARRAY(DOCUMENT(DOCUMENT(hn).prefix).coding) RETURN MERGE(DOCUMENT(DOCUMENT(hn).use),{coding:DOCUMENT(cod)})),suffix:(FOR cod IN TO_ARRAY(DOCUMENT(DOCUMENT(hn).suffix).coding) RETURN MERGE(DOCUMENT(DOCUMENT(hn).use),{coding:DOCUMENT(cod)}))}))})"
    };
  },
  drugType: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"DrugType\",\n        \"return_fields\": \"DrugType\"\n    }"),
  drugMaster: function drugMaster(input_text) {
    return "{\n      \"db_name\": \"".concat(dbName, "\",\n      \"entity\": \"DrugMaster\",\n      \"filter\": \"(LIKE(DrugMaster.DrugCode,'%").concat(input_text, "%',true) || LIKE(DrugMaster.ShortDesc,'%").concat(input_text, "%',true) ) && DrugMaster.activestatus == true \",\n       \"return_fields\": \"MERGE(DrugMaster,{DrugType:DOCUMENT(DrugMaster.DrugType),FormCode:DOCUMENT(DrugMaster.FormCode)},{StrengthValuesPossible:(for strValPoss in DrugMaster.StrengthValuesPossible return merge(strValPoss,{StrengthUOM:document(strValPoss.StrengthUOM)},{StrengthVolumeUoM:document(strValPoss.StrengthVolumeUoM)},{OrderUOMAllowed:(for OrderUOMAllowed in to_array(strValPoss.OrderUOMAllowed) return merge(OrderUOMAllowed,{AllowedOrderDoseUOM:document(OrderUOMAllowed.AllowedOrderDoseUOM)},{AllowedOrderDoseVolUoM:document(OrderUOMAllowed.AllowedOrderDoseVolUoM)}))}))},{aliasDtls:(for alias in to_array(DrugMaster.aliasDtls) return merge(alias,{aliasType:document(alias.aliasType)}))})\"\n      }");
  },
  getAlertCode: function getAlertCode(patientId) {
    return {
      db_name: dbName,
      queryid: "6385b198-8765-49b3-a5f4-0faac3e30fdd",
      filter: {
        patientID: patientId
      }
    };
  },
  getMedications: function getMedications(id) {
    return "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"filter\": \"PH_OrderLine.patient_Id=='").concat(id, "'\",\n        \"entity\": \"PH_OrderLine\",\n        \"return_fields\": \"MERGE(PH_OrderLine, { patient_Id:(FOR pname IN TO_ARRAY(DOCUMENT(PH_OrderLine.patient_Id).name) RETURN MERGE(DOCUMENT(PH_OrderLine.patient_Id), { name:DOCUMENT(pname), telecom:(FOR ptel IN TO_ARRAY(DOCUMENT(PH_OrderLine.patient_Id).telecom) RETURN DOCUMENT(ptel)), martialStatus:(FOR mstatus IN TO_ARRAY(DOCUMENT(PH_OrderLine.patient_Id).martialStatus) RETURN DOCUMENT(mstatus)) } ) ) ,org_Id:MERGE(DOCUMENT(PH_OrderLine.org_Id), { telecom:(FOR otel IN TO_ARRAY(DOCUMENT(PH_OrderLine.org_Id).telecom) RETURN DOCUMENT(otel) ), address:(FOR oadd IN TO_ARRAY(DOCUMENT(PH_OrderLine.org_Id).address) RETURN DOCUMENT(oadd) ) }) ,encounter_Id:DOCUMENT(PH_OrderLine.encounter_Id) ,dosageDurationUOM:DOCUMENT(PH_OrderLine.dosageDurationUOM) ,dosageFreqCode:DOCUMENT(PH_OrderLine.dosageFreqCode) ,dosageUOM:DOCUMENT(PH_OrderLine.dosageUOM) ,drugCode:DOCUMENT(PH_OrderLine.drugCode) ,drugType:DOCUMENT(PH_OrderLine.drugType) , createdby:(FOR hn IN TO_ARRAY(DOCUMENT(PH_OrderLine.createdby).name) RETURN MERGE(DOCUMENT(PH_OrderLine.createdby),{name:DOCUMENT(hn)})) , updatedby:(FOR hn IN TO_ARRAY(DOCUMENT(PH_OrderLine.updatedby).name) RETURN MERGE(DOCUMENT(PH_OrderLine.updatedby),{name:DOCUMENT(hn)})) , statushistory:(FOR sth IN TO_ARRAY(PH_OrderLine.statushistory) RETURN MERGE(sth,{PersonID:(FOR hn IN TO_ARRAY(DOCUMENT(sth.PersonID).name) RETURN MERGE(DOCUMENT(sth.PersonID),{name:DOCUMENT(hn)}))})) } )\"\n    }");
  },
  saveMedicationPendingOrders: function saveMedicationPendingOrders(ids) {
    return {
      "db_name": dbName,
      "queryid": "06077a49-47ce-478e-8890-5d8308581210",
      "filter": {
        "orderlineid": ids
      }
    };
  },
  readMedicationPendingOrders: function readMedicationPendingOrders(id) {
    return "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"PH_OrderLine\",\n    \"filter\": \"PH_OrderLine.patient_Id=='").concat(id, "' && document(PH_OrderLine.status).code=='MEDREC001' && PH_OrderLine.activestatus==true\",\n    \"return_fields\": \"merge(PH_OrderLine,{formCode:document(PH_OrderLine.formCode).longdesc},{patientInstruction:document(PH_OrderLine.patientInstruction)},{priority:document(document(PH_OrderLine.priority).coding)},{prescriptionType:document(PH_OrderLine.prescriptionType)},{diagnosis:(for doc in CA_Diagnosis filter doc._id in PH_OrderLine.diagnosis return merge(doc,{diagcode:document(doc.diagcode)}))},{dispensing_pharmacy:document(PH_OrderLine.dispensing_pharmacy)},{indication:document(PH_OrderLine.indication)},{org_Id:document(PH_OrderLine.org_Id)},{patient_Id:document(PH_OrderLine.patient_Id)},{encounter_Id:document(PH_OrderLine.encounter_Id)},{dosageDurationUOM:document(PH_OrderLine.dosageDurationUOM)},{dosageFreqCode:(for fm in FrequencyMaster filter fm._id == PH_OrderLine.dosageFreqCode return merge(fm,{frequencytype:document(fm.frequencytype)},{scheduleline:(for fshed in FrequencySchedule filter fshed._id in fm.scheduleline return merge(fshed,{basefreq:document(fshed.basefreq)}))}))},{dosageUOM:document(PH_OrderLine.dosageUOM)},{drugCode:merge(document(PH_OrderLine.drugCode),{StrengthValuesPossible:(for h in to_array(document(PH_OrderLine.drugCode).StrengthValuesPossible) return merge(h,{StrengthUOM:document(h.StrengthUOM)},{StrengthVolumeUoM:document(h.StrengthVolumeUoM)}))},{DrugCategory:document(document(PH_OrderLine.drugCode).DrugCategory)})},{drugType:document(PH_OrderLine.drugType)},{status:document(PH_OrderLine.status)},{requestor:(for r in to_array(PH_OrderLine.requestor) return merge(r,{practRole:document(r.practRole),practId:(for doc in Practitioner filter doc._id == r.practId return merge(doc,{name:(for HumanNameMaster in HumanNameMaster filter HumanNameMaster._id in doc.name return merge(HumanNameMaster,{use:(document(document(HumanNameMaster.use).coding))[*].display,prefix:(document(document(HumanNameMaster.prefix).coding))[*].display,suffix:(document(document(HumanNameMaster.suffix).coding))[*].display}))})),organization:document(r.organization)}))},{addtictive:(for addt in to_array(PH_OrderLine.addtictive) return merge(addt,{addrugcode:document(addt.addrugcode)},{addoseuom:document(addt.addoseuom)}))},{FreqDetls:(for freq in PH_OrderLine.FreqDetls return merge(freq,{baseFreq:document(freq.baseFreq)}))})\"\n}");
  },
  deleteMedicationPendingOrders: function deleteMedicationPendingOrders(id) {
    return "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"queryid\": \"fbb9e67a-9d7b-46c1-8b9a-2689fbbc7802\",\n    \"filter\": {\n    \"orderlineid\": \"").concat(id, "\"\n    }\n  }");
  },
  // "return_fields": "MERGE(PH_OrderLine, { patient_Id:(FOR pname IN DOCUMENT(PH_OrderLine.patient_Id).name  RETURN MERGE(DOCUMENT(PH_OrderLine.patient_Id), { name:DOCUMENT(pname), telecom:(FOR ptel IN DOCUMENT(PH_OrderLine.patient_Id).telecom RETURN DOCUMENT(ptel)), martialStatus:(FOR mstatus IN DOCUMENT(PH_OrderLine.patient_Id).martialStatus RETURN DOCUMENT(mstatus)) } ) ) ,org_Id:MERGE(DOCUMENT(PH_OrderLine.org_Id), { telecom:(FOR otel IN DOCUMENT(PH_OrderLine.org_Id).telecom RETURN DOCUMENT(otel) ), address:(FOR oadd IN DOCUMENT(PH_OrderLine.org_Id).address RETURN DOCUMENT(oadd) )  }) ,encounter_Id:DOCUMENT(PH_OrderLine.encounter_Id) ,dosageDurationUOM:DOCUMENT(PH_OrderLine.dosageDurationUOM) ,dosageFreqCode:DOCUMENT(PH_OrderLine.dosageFreqCode) ,dosageUOM:DOCUMENT(PH_OrderLine.dosageUOM) ,drugCode:DOCUMENT(PH_OrderLine.drugCode) ,drugType:DOCUMENT(PH_OrderLine.drugType) ,  createdby:(FOR hn IN TO_ARRAY(DOCUMENT(PH_OrderLine.createdby).name) RETURN MERGE(DOCUMENT(PH_OrderLine.createdby),{name:DOCUMENT(hn)})) ,  updatedby:(FOR hn IN TO_ARRAY(DOCUMENT(PH_OrderLine.updatedby).name) RETURN MERGE(DOCUMENT(PH_OrderLine.updatedby),{name:DOCUMENT(hn)})) ,  statushistory:(FOR sth IN TO_ARRAY(PH_OrderLine.statushistory)   RETURN MERGE(sth,{PersonID:(FOR hn IN  TO_ARRAY(DOCUMENT(sth.PersonID).name) RETURN MERGE(DOCUMENT(sth.PersonID),{name:DOCUMENT(hn)}))})) } ) "
  getOrganizationId: function getOrganizationId(id) {
    return "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"Organization\",\n        \"filter\": \"Organization.id == ").concat(id, "\",\n        \"return_fields\": \"Organization._id\"\n    }");
  },
  strength: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"RoutedDoseFormStrGen_Drug_Master\",\n        \"return_fields\": \"RoutedDoseFormStrGen_Drug_Master\"\n    }"),
  strengthUom: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"DrugUOM\",\n        \"filter\":\"DrugUOM.IsDosageStrengthUOM==true\",\n        \"return_fields\": \"DrugUOM\"\n    }"),
  strengthVolumn: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"RoutedDoseFormStrGen_Drug_Master\",\n        \"return_fields\": \"RoutedDoseFormStrGen_Drug_Master\"\n    }"),
  strengthVolumnUom: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"DrugUOM\",\n        \"filter\":\"DrugUOM.IsDosageStrengthUOM==true\",\n        \"return_fields\": \"DrugUOM\"\n    }"),
  DosageTypeIndicator: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n        \"filter\": \"CodeableConceptMaster.Type=='DOSAGETYPEINDICATOR'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  DosageUOM: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"DrugUOM\",\n        \"filter\":\"DrugUOM.IsDosageStrengthUOM==true\",\n        \"return_fields\": \"DrugUOM\"\n    }"),
  DosageVolumeUom: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"DrugUOM\",\n        \"filter\":\"DrugUOM.IsDosageStrengthUOM==true\",\n        \"return_fields\": \"DrugUOM\"\n    }"),
  DrugRoutes: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"DrugRoutes\",\n        \"filter\": \"DrugRoutes.status==true\",\n        \"return_fields\": \"DrugRoutes\"\n    }"),
  DosageForm: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"DosageForm\",\n        \"return_fields\": \"DosageForm\"\n    }"),
  FrequencyMaster: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"FrequencyMaster\",\n        \"filter\": \"FrequencyMaster.status==true\",\n        \"return_fields\": \"merge(FrequencyMaster, {fixeddurUOM: document(FrequencyMaster.fixeddurUOM)}, {scheduleline:(for freq in FrequencySchedule filter freq._id in FrequencyMaster.scheduleline return merge(freq,{basefreq:document(freq.basefreq)},{day:document(freq.day)}))},{frequencytype:document(FrequencyMaster.frequencytype)})\"\n    }"),
  DurationType: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"DrugUOM\",\n        \"filter\":\"LOWER(DOCUMENT(DrugUOM.UOMType).display) =='time' and DrugUOM.activestatus==true and DrugUOM.status==true\",\n        \"return_fields\": \"DrugUOM\"\n    }"),
  Priority: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n        \"filter\": \"CodeableConceptMaster.Type=='PRIORITY'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  DrugCategory: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"DrugCategory\",\n        \"return_fields\": \"DrugCategory\"\n    }"),
  OrderNature: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodingMaster\",\n        \"filter\": \"CodingMaster.Type=='ORDERNATURE' && CodingMaster.activestatus==true && CodingMaster.status == true\",\n        \"return_fields\": \"KEEP(CodingMaster,'_id','id','_key','code','display','Type','status','shortdesc','activestatus')\",\n        \"sort\": \"CodingMaster.display\"\n       }"),
  OrderMode: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodingMaster\",\n        \"filter\": \"CodingMaster.Type=='ORDERMODE' && CodingMaster.activestatus==true && CodingMaster.status == true\",\n        \"return_fields\": \"KEEP(CodingMaster,'_id','id','_key','code','display','Type','status','shortdesc','activestatus')\",\n        \"sort\": \"CodingMaster.display\"\n         }"),
  OrderPrescription: "{\n          \"db_name\": \"".concat(dbName, "\",\n          \"entity\": \"CodingMaster\",\n          \"filter\": \"CodingMaster.Type=='PRESCRIPTIONTYPE' && CodingMaster.activestatus==true && CodingMaster.status == true\",\n          \"return_fields\": \"KEEP(CodingMaster,'_id','id','_key','code','display','Type','status','shortdesc','activestatus')\",\n          \"sort\": \"CodingMaster.display\"\n           }"),
  DrugStoreDispLoc: function DrugStoreDispLoc(encounterTypeId) {
    return "{\n    \"Encounter\": {\n        \"type\": \"".concat(encounterTypeId, "\"\n    }\n  }");
  },
  DiagnosisAgainstEncounter: function DiagnosisAgainstEncounter(encounterId) {
    return "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CA_Diagnosis\",\n        \"filter\":\"CA_Diagnosis.encounter_id=='").concat(encounterId, "'\",\n        \"return_fields\": \"MERGE(CA_Diagnosis,{'encounter_id':DOCUMENT(CA_Diagnosis.encounter_id),diagcode:DOCUMENT(CA_Diagnosis.diagcode)})\"\n    }");
  },
  Reasoncode: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodingMaster\",\n        \"filter\": \"CodingMaster.Type=='INDICATIONREASON' && CodingMaster.activestatus==true && CodingMaster.status==true\",\n        \"return_fields\": \"KEEP(CodingMaster,'_id','id','_key','code','display','Type')\"\n    }"),
  Organization: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"Organization\",\n        \"return_fields\": \"Organization\"\n    }"),
  Patient_Instruction: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n        \"filter\": \"CodeableConceptMaster.Type=='PATINSTRUCTION' AND CodeableConceptMaster.activestatus==true\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  PractitionerRole: function PractitionerRole(orgId) {
    return "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"PractitionerRole,Organization,Practitioner\",\n        \"filter\": {\"PractitionerRole\":\"PractitionerRole.OrgID == '").concat(orgId, "'\",\n                    \"Practitioner\":\"PractitionerRole.id==Practitioner.PractitionerRoleID\"},\n        \"return_fields\": \"DISTINCT  MERGE({PractitionerRole:DOCUMENT(PractitionerRole.code)})\"\n    }");
  },
  Practitioner: function Practitioner(orgId) {
    return "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"PractitionerRole,Organization,Practitioner\",\n        \"filter\": {\n        \"PractitionerRole\": \"PractitionerRole.OrgID == '").concat(orgId, "'\",\n        \"Practitioner\": \"PractitionerRole.id==Practitioner.PractitionerRoleID\"\n    },\n    \"return_fields\": \" DISTINCT MERGE({_id:Practitioner._id},{id:Practitioner.id},{PractitionerName:DOCUMENT(Practitioner.name)})\"\n    }");
  },
  // InfusionRateUoM: `{
  //       "db_name": "${dbName}",
  //       "entity": "DrugUOM",
  //       "filter": "DOCUMENT(DrugUOM.UOMType).code=='DU010'",
  //       "return_fields": "DrugUOM"
  //   }`,
  InfusionRateUoM: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"DrugUOM\",\n        \"filter\": \"document(DrugUOM.UOMType).code in ['DU013', 'DU012', 'DU010','DU008'] && DrugUOM.IsDosageQuantityUOM==true && DrugUOM.IsDosageStrengthUOM==true && DrugUOM.status==true && DrugUOM.activestatus==true\",\n        \"return_fields\": \"keep(DrugUOM,'_id','UOM','UOMType','longdesc','shortdesc')\"\n    }"),
  TotalVolumeUoM: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"DrugUOM\",\n        \"filter\": \"DrugUOM.IsDosageStrengthUOM==true\",\n        \"return_fields\": \"DrugUOM\"\n    }"),
  Indication_Reason_Code: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"ReasonMaster\",\n        \"return_fields\": \"ReasonMaster\"\n    }"),
  BaseSchedule: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"FrequencyMaster\",\n        \"filter\":\"FrequencyMaster. freqcode=='TAP'\",\n        \"return_fields\": \"FrequencyMaster\"\n    }"),
  DeleteMedication: function DeleteMedication(id) {
    return "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"PH_OrderLine\",\n        \"filter\": \"PH_OrderLine._id=='").concat(id, "'\"\n    }");
  },
  statusMaster: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n        \"filter\": \"CodeableConceptMaster.Type=='MEDRECORDSTATUS'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  workFlowStatus: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n        \"filter\": \"CodeableConceptMaster.Type=='MEDWFSTATUS'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n        }"),
  singleReadEditInfo: function singleReadEditInfo(key) {
    return "{\n      \"db_name\": \"".concat(dbName, "\",\n      \"entity\": \"PH_OrderLine\",\n      \"filter\": \"PH_OrderLine._id=='").concat(key, "' && PH_OrderLine.activestatus==true\",\n    \"return_fields\": \"merge(PH_OrderLine,{formCode:document(PH_OrderLine.formCode).longdesc},{patientInstruction:document(PH_OrderLine.patientInstruction)},{priority:document(document(PH_OrderLine.priority).coding)},{prescriptionType:document(PH_OrderLine.prescriptionType)},{diagnosis:(for doc in CA_Diagnosis filter doc._id in PH_OrderLine.diagnosis return merge(doc,{diagcode:document(doc.diagcode)}))},{dispensing_pharmacy:document(PH_OrderLine.dispensing_pharmacy)},{indication:document(PH_OrderLine.indication)},{org_Id:document(PH_OrderLine.org_Id)},{patient_Id:document(PH_OrderLine.patient_Id)},{encounter_Id:document(PH_OrderLine.encounter_Id)},{dosageDurationUOM:document(PH_OrderLine.dosageDurationUOM)},{dosageFreqCode:(for fm in FrequencyMaster filter fm._id == PH_OrderLine.dosageFreqCode return merge(fm,{frequencytype:document(fm.frequencytype)},{scheduleline:(for fshed in FrequencySchedule filter fshed._id in fm.scheduleline return merge(fshed,{basefreq:document(fshed.basefreq)}))}))},{dosageUOM:document(PH_OrderLine.dosageUOM)},{drugCode:merge(document(PH_OrderLine.drugCode),{StrengthValuesPossible:(for h in to_array(document(PH_OrderLine.drugCode).StrengthValuesPossible) return merge(h,{StrengthUOM:document(h.StrengthUOM)},{StrengthVolumeUoM:document(h.StrengthVolumeUoM)}))},{DrugCategory:document(document(PH_OrderLine.drugCode).DrugCategory)})},{drugType:document(PH_OrderLine.drugType)},{status:document(PH_OrderLine.status)},{requestor:(for r in to_array(PH_OrderLine.requestor) return merge(r,{practRole:document(r.practRole),practId:(for doc in Practitioner filter doc._id == r.practId return merge(doc,{name:(for HumanNameMaster in HumanNameMaster filter HumanNameMaster._id in doc.name return merge(HumanNameMaster,{use:(document(document(HumanNameMaster.use).coding))[*].display,prefix:(document(document(HumanNameMaster.prefix).coding))[*].display,suffix:(document(document(HumanNameMaster.suffix).coding))[*].display}))})),organization:document(r.organization)}))},{addtictive:(for addt in to_array(PH_OrderLine.addtictive) return merge(addt,{addrugcode:document(addt.addrugcode)},{addoseuom:document(addt.addoseuom)}))},{FreqDetls:(for freq in PH_OrderLine.FreqDetls return merge(freq,{baseFreq:document(freq.baseFreq)}))})\"\n  }");
  },
  laborder_PractitionerRole: function laborder_PractitionerRole(OrgId) {
    return {
      db_name: dbName,
      entity: "PractitionerRole",
      filter: "DOCUMENT(PractitionerRole.EntityName).id==".concat(OrgId),
      return_fields: "DISTINCT DOCUMENT( DOCUMENT(PractitionerRole.role).coding)[0]"
    };
  },
  read_status_logs: function read_status_logs(key) {
    return {
      db_name: dbName,
      entity: "PH_OrderLineAlertLogs",
      filter: "PH_OrderLineAlertLogs.orderlineid=='".concat(key, "' && PH_OrderLineAlertLogs.activestatus==true"),
      return_fields: "PH_OrderLineAlertLogs"
    };
  }
};
var diagnosisMaster = {
  Diagnosis: function Diagnosis(input_text, enId) {
    return {
      db_name: dbName,
      entity: "Diagnosis",
      filter: "Diagnosis.activestatus==true && Diagnosis.icdname LIKE '%".concat(input_text, "%' && CA_Diagnosis.encounter_id=='").concat(enId, "'"),
      // filter: `Diagnosis.icdname LIKE '%${input_text}%' && (round(DATE_TIMESTAMP(DATE_ADD(DATE_NOW(), -1, 'day'))/1000)<=Diagnosis.effTo || Diagnosis.effTo==null)`,
      return_fields: "{_id:Diagnosis._id,icdcode:Diagnosis.icdcode,icdname:Diagnosis.icdname}",
      sort: "Diagnosis.icdname"
    };
  }
};

var query_ids$1 = "04ecb73d-f048-44ce-8563-c9be015812dd";
var generateJSON$3 = function generateJSON(payload, logInfo) {
  var _payload$isfirststato, _ref, _logInfo$facilityid, _payload$addtictive$m, _payload$addtictive, _payload$patientid, _payload$encountertyp, _payload$encounterid, _ref2, _payload$prescripionT, _payload$prescription, _payload$Prescription, _payload$name$drugTyp, _payload$name, _payload$presNature$v, _payload$presNature, _payload$presMode$val, _payload$presMode, _payload$priority$val, _payload$priority, _payload$statusreason, _payload$intent, _payload$orderPrivile, _payload$privilegeAle, _payload$workFlowStat, _payload$drugCodeValu, _payload$formCode, _payload$routeCode$va, _payload$routeCode, _payload$dosageTypeIn, _payload$unitValue$va, _payload$unitValue, _payload$drug_categor, _payload$drug_categor2, _payload$dispensing_p, _payload$dispensing_p2, _payload$IVDosageDura, _payload$IVDosageDura2, _payload$unitsTypes$v, _payload$unitsTypes, _payload$ivInfusionRa, _payload$ivInfusionRa2, _payload$doseOption$v, _payload$doseOption, _payload$orderdescrip, _ref3, _payload$ivInfusionTi, _payload$ivInfusionTi2, _payload$occurStartDa, _payload$occurEndDate, _payload$totPresQtyUO, _payload$totPresQtyUO2, _payload$totDispQty, _payload$totDispQtyUO, _payload$totBilledQty, _payload$totBilledQty2, _payload$totReturnedQ, _payload$PRNYN, _payload$prnComment, _payload$direction, _payload$diagnosis, _payload$reasonCode, _payload$indication$v, _payload$indication, _payload$patientInstr, _payload$patientInstr2, _payload$patientInstr3, _payload$notes, _payload$parentPresId, _payload$presGroupRef, _payload$noofRefillsA, _payload$initialDispe, _payload$refillDispen, _payload$maxRefillDis, _payload$pendingRefil, _payload$prescription2, _payload$substitution, _payload$substitution2, _payload$substituteRe, _payload$broughtFromH, _payload$IVIngredient, _payload$statushistor, _payload$statusperiod, _payload$frequencyDet, _payload$frequencyDet2, _payload$unitsTypes$f, _ref4, _payload$frequencyDet3;

  var filter = {};

  if (payload.editId) {
    filter = {
      filter: {
        _id: payload.editId
      }
    };
  }

  return [_objectSpread2(_objectSpread2({
    db_name: dbName,
    entity: "PH_OrderLine",
    is_metadata: true
  }, filter), {}, {
    metadataId: query_ids$1,
    doc: {
      id: 0,
      isfirststatorder: (_payload$isfirststato = payload === null || payload === void 0 ? void 0 : payload.isfirststatorder) !== null && _payload$isfirststato !== void 0 ? _payload$isfirststato : false,
      SlidingScaleDose: payload === null || payload === void 0 ? void 0 : payload.SlidingScaleDose,
      org_Id: (_ref = (_logInfo$facilityid = logInfo === null || logInfo === void 0 ? void 0 : logInfo.facilityid) !== null && _logInfo$facilityid !== void 0 ? _logInfo$facilityid : logInfo === null || logInfo === void 0 ? void 0 : logInfo.orgid) !== null && _ref !== void 0 ? _ref : "",
      addtictive: (_payload$addtictive$m = payload === null || payload === void 0 ? void 0 : (_payload$addtictive = payload.addtictive) === null || _payload$addtictive === void 0 ? void 0 : _payload$addtictive.map(function (item) {
        var _item$addoseuom, _item$addrugcode, _item$addrugcode$resu;

        return _objectSpread2(_objectSpread2({}, item), {}, {
          addoseuom: item === null || item === void 0 ? void 0 : (_item$addoseuom = item.addoseuom) === null || _item$addoseuom === void 0 ? void 0 : _item$addoseuom.value,
          addrugcode: item === null || item === void 0 ? void 0 : (_item$addrugcode = item.addrugcode) === null || _item$addrugcode === void 0 ? void 0 : (_item$addrugcode$resu = _item$addrugcode.result) === null || _item$addrugcode$resu === void 0 ? void 0 : _item$addrugcode$resu._id
        });
      })) !== null && _payload$addtictive$m !== void 0 ? _payload$addtictive$m : [],
      orgEntityType: "",
      // org_Id: logInfo?.orgid ?? "Organization/10002",
      patient_Id: (_payload$patientid = payload.patientid) !== null && _payload$patientid !== void 0 ? _payload$patientid : "",
      encountertype: (_payload$encountertyp = payload.encountertype) !== null && _payload$encountertyp !== void 0 ? _payload$encountertyp : "",
      encounter_Id: (_payload$encounterid = payload.encounterid) !== null && _payload$encounterid !== void 0 ? _payload$encounterid : "",
      prescriptionType: (_ref2 = (_payload$prescripionT = payload.prescripionType) !== null && _payload$prescripionT !== void 0 ? _payload$prescripionT : payload.prescriptionType) !== null && _ref2 !== void 0 ? _ref2 : "",
      prescriptionId: (_payload$prescription = payload.prescriptionId) !== null && _payload$prescription !== void 0 ? _payload$prescription : "",
      PrescriptionDate: (_payload$Prescription = payload.PrescriptionDate) !== null && _payload$Prescription !== void 0 ? _payload$Prescription : 0,
      drugType: (_payload$name$drugTyp = payload === null || payload === void 0 ? void 0 : (_payload$name = payload.name) === null || _payload$name === void 0 ? void 0 : _payload$name.drugTypeId) !== null && _payload$name$drugTyp !== void 0 ? _payload$name$drugTyp : "",
      presNature: (_payload$presNature$v = (_payload$presNature = payload.presNature) === null || _payload$presNature === void 0 ? void 0 : _payload$presNature.value) !== null && _payload$presNature$v !== void 0 ? _payload$presNature$v : "",
      presMode: (_payload$presMode$val = (_payload$presMode = payload.presMode) === null || _payload$presMode === void 0 ? void 0 : _payload$presMode.value) !== null && _payload$presMode$val !== void 0 ? _payload$presMode$val : "",
      priority: (_payload$priority$val = (_payload$priority = payload.priority) === null || _payload$priority === void 0 ? void 0 : _payload$priority.value) !== null && _payload$priority$val !== void 0 ? _payload$priority$val : "",
      status: payload.status || "CodingMaster/10703",
      statusreason: (_payload$statusreason = payload.statusreason) !== null && _payload$statusreason !== void 0 ? _payload$statusreason : "",
      intent: (_payload$intent = payload.intent) !== null && _payload$intent !== void 0 ? _payload$intent : "",
      orderPrivilegeLevel: (_payload$orderPrivile = payload.orderPrivilegeLevel) !== null && _payload$orderPrivile !== void 0 ? _payload$orderPrivile : "",
      privilegeAlertMessageTxt: (_payload$privilegeAle = payload.privilegeAlertMessageTxt) !== null && _payload$privilegeAle !== void 0 ? _payload$privilegeAle : "",
      workFlowStatus: (_payload$workFlowStat = payload.workFlowStatus) !== null && _payload$workFlowStat !== void 0 ? _payload$workFlowStat : "",
      drugCode: (_payload$drugCodeValu = payload === null || payload === void 0 ? void 0 : payload.drugCodeValue) !== null && _payload$drugCodeValu !== void 0 ? _payload$drugCodeValu : "",
      formCode: (_payload$formCode = payload.formCode) !== null && _payload$formCode !== void 0 ? _payload$formCode : "",
      routeCode: (_payload$routeCode$va = (_payload$routeCode = payload.routeCode) === null || _payload$routeCode === void 0 ? void 0 : _payload$routeCode.value) !== null && _payload$routeCode$va !== void 0 ? _payload$routeCode$va : "",
      dosageTypeIndicator: (_payload$dosageTypeIn = payload.dosageTypeIndicator) !== null && _payload$dosageTypeIn !== void 0 ? _payload$dosageTypeIn : "",
      dosageValue: payload.doseMeasurementValue ? parseInt(payload.doseMeasurementValue) : 0,
      dosageUOM: (_payload$unitValue$va = (_payload$unitValue = payload.unitValue) === null || _payload$unitValue === void 0 ? void 0 : _payload$unitValue.value) !== null && _payload$unitValue$va !== void 0 ? _payload$unitValue$va : "",
      drug_category: (_payload$drug_categor = (_payload$drug_categor2 = payload.drug_category) === null || _payload$drug_categor2 === void 0 ? void 0 : _payload$drug_categor2.value) !== null && _payload$drug_categor !== void 0 ? _payload$drug_categor : "",
      dispensing_pharmacy: (_payload$dispensing_p = (_payload$dispensing_p2 = payload.dispensing_pharmacy) === null || _payload$dispensing_p2 === void 0 ? void 0 : _payload$dispensing_p2.value) !== null && _payload$dispensing_p !== void 0 ? _payload$dispensing_p : "",
      IVDosageDurationValue: payload.IVDosageDurationValue ? parseInt(payload.IVDosageDurationValue) : 0,
      IVDosageDurationUOM: (_payload$IVDosageDura = (_payload$IVDosageDura2 = payload.IVDosageDurationUOM) === null || _payload$IVDosageDura2 === void 0 ? void 0 : _payload$IVDosageDura2.value) !== null && _payload$IVDosageDura !== void 0 ? _payload$IVDosageDura : "",
      dosageFreqCode: (_payload$unitsTypes$v = (_payload$unitsTypes = payload.unitsTypes) === null || _payload$unitsTypes === void 0 ? void 0 : _payload$unitsTypes.value) !== null && _payload$unitsTypes$v !== void 0 ? _payload$unitsTypes$v : "",
      ivInfusionRateValue: payload.ivInfusionRateValue ? parseInt(payload.ivInfusionRateValue) : 0,
      ivInfusionRateUOM: (_payload$ivInfusionRa = (_payload$ivInfusionRa2 = payload.ivInfusionRateUOM) === null || _payload$ivInfusionRa2 === void 0 ? void 0 : _payload$ivInfusionRa2.value) !== null && _payload$ivInfusionRa !== void 0 ? _payload$ivInfusionRa : "",
      dosageDurationValue: payload.dosetime ? parseInt(payload.dosetime) : 0,
      dosageDurationUOM: (_payload$doseOption$v = (_payload$doseOption = payload.doseOption) === null || _payload$doseOption === void 0 ? void 0 : _payload$doseOption.value) !== null && _payload$doseOption$v !== void 0 ? _payload$doseOption$v : "",
      orderdescription: (_payload$orderdescrip = payload === null || payload === void 0 ? void 0 : payload.orderdescriptionName) !== null && _payload$orderdescrip !== void 0 ? _payload$orderdescrip : "",
      ivInfusionTime: payload !== null && payload !== void 0 && payload.ivInfusionTime ? JSON.parse(payload === null || payload === void 0 ? void 0 : payload.ivInfusionTime) : 0,
      ivInfusionTimeUom: (_ref3 = (_payload$ivInfusionTi = payload === null || payload === void 0 ? void 0 : (_payload$ivInfusionTi2 = payload.ivInfusionTimeUom) === null || _payload$ivInfusionTi2 === void 0 ? void 0 : _payload$ivInfusionTi2.value) !== null && _payload$ivInfusionTi !== void 0 ? _payload$ivInfusionTi : payload === null || payload === void 0 ? void 0 : payload.ivInfusionTimeUom) !== null && _ref3 !== void 0 ? _ref3 : "",
      // "UseAsFreqDose": payload.UseAsFreqDose ? getUseAsFreqDose(payload.UseAsFreqDose, payload.unitsTypes) : [],
      // "useAsTaperedDose": payload.useAsTaperedDose ? getuseAsTaperedDose(payload.useAsTaperedDose) : [],
      useAsSlidingScaleDose: payload.useAsSlidingScaleDose ? getuseAsSlidingScaleDose(payload.useAsSlidingScaleDose) : [],
      occurStartDateTime: (_payload$occurStartDa = payload.occurStartDateTime) !== null && _payload$occurStartDa !== void 0 ? _payload$occurStartDa : 0,
      occurEndDateTime: (_payload$occurEndDate = payload.occurEndDateTime) !== null && _payload$occurEndDate !== void 0 ? _payload$occurEndDate : 0,
      totPresQty: payload.totPresQty ? parseInt(payload.totPresQty) : 0,
      totPresQtyUOM: (_payload$totPresQtyUO = (_payload$totPresQtyUO2 = payload.totPresQtyUOM) === null || _payload$totPresQtyUO2 === void 0 ? void 0 : _payload$totPresQtyUO2.value) !== null && _payload$totPresQtyUO !== void 0 ? _payload$totPresQtyUO : "",
      totDispQty: (_payload$totDispQty = payload.totDispQty) !== null && _payload$totDispQty !== void 0 ? _payload$totDispQty : 0,
      totDispQtyUOM: (_payload$totDispQtyUO = payload.totDispQtyUOM) !== null && _payload$totDispQtyUO !== void 0 ? _payload$totDispQtyUO : "",
      totBilledQty: (_payload$totBilledQty = payload.totBilledQty) !== null && _payload$totBilledQty !== void 0 ? _payload$totBilledQty : 0,
      totBilledQtyUOM: (_payload$totBilledQty2 = payload.totBilledQtyUOM) !== null && _payload$totBilledQty2 !== void 0 ? _payload$totBilledQty2 : "",
      totReturnedQty: (_payload$totReturnedQ = payload.totReturnedQty) !== null && _payload$totReturnedQ !== void 0 ? _payload$totReturnedQ : 0,
      PRNYN: (_payload$PRNYN = payload.PRNYN) !== null && _payload$PRNYN !== void 0 ? _payload$PRNYN : false,
      prnComment: (_payload$prnComment = payload.prnComment) !== null && _payload$prnComment !== void 0 ? _payload$prnComment : "",
      direction: (_payload$direction = payload.direction) !== null && _payload$direction !== void 0 ? _payload$direction : "",
      diagnosis: (_payload$diagnosis = payload.diagnosis) !== null && _payload$diagnosis !== void 0 ? _payload$diagnosis : [],
      reasonCode: (_payload$reasonCode = payload.reasonCode) !== null && _payload$reasonCode !== void 0 ? _payload$reasonCode : "",
      indication: (_payload$indication$v = (_payload$indication = payload.indication) === null || _payload$indication === void 0 ? void 0 : _payload$indication.value) !== null && _payload$indication$v !== void 0 ? _payload$indication$v : "",
      patientInstruction: (_payload$patientInstr = (_payload$patientInstr2 = payload.patientInstruction) === null || _payload$patientInstr2 === void 0 ? void 0 : _payload$patientInstr2.value) !== null && _payload$patientInstr !== void 0 ? _payload$patientInstr : "",
      patientInstructiondesc: (_payload$patientInstr3 = payload.patientInstructiondesc) !== null && _payload$patientInstr3 !== void 0 ? _payload$patientInstr3 : "",
      notes: (_payload$notes = payload.notes) !== null && _payload$notes !== void 0 ? _payload$notes : "",
      parentPresId: (_payload$parentPresId = payload.parentPresId) !== null && _payload$parentPresId !== void 0 ? _payload$parentPresId : "",
      presGroupRefId: (_payload$presGroupRef = payload.presGroupRefId) !== null && _payload$presGroupRef !== void 0 ? _payload$presGroupRef : "",
      requestor: payload !== null && payload !== void 0 && payload.requestor ? getrequestor(payload === null || payload === void 0 ? void 0 : payload.requestor) : [],
      performer: payload !== null && payload !== void 0 && payload.performer ? getPerformer(payload === null || payload === void 0 ? void 0 : payload.performer) : [],
      noofRefillsAllowed: (_payload$noofRefillsA = payload.noofRefillsAllowed) !== null && _payload$noofRefillsA !== void 0 ? _payload$noofRefillsA : 0,
      initialDispenseDurn: (_payload$initialDispe = payload.initialDispenseDurn) !== null && _payload$initialDispe !== void 0 ? _payload$initialDispe : 0,
      refillDispenseIntervalDays: (_payload$refillDispen = payload.refillDispenseIntervalDays) !== null && _payload$refillDispen !== void 0 ? _payload$refillDispen : 0,
      maxRefillDispenseDurn: (_payload$maxRefillDis = payload.maxRefillDispenseDurn) !== null && _payload$maxRefillDis !== void 0 ? _payload$maxRefillDis : 0,
      pendingRefillCount: (_payload$pendingRefil = payload.pendingRefillCount) !== null && _payload$pendingRefil !== void 0 ? _payload$pendingRefil : "",
      prescriptionValidityPeriodDays: (_payload$prescription2 = payload.prescriptionValidityPeriodDays) !== null && _payload$prescription2 !== void 0 ? _payload$prescription2 : 0,
      substitutionAllowed: (_payload$substitution = payload.substitutionAllowed) !== null && _payload$substitution !== void 0 ? _payload$substitution : false,
      substitutionAllowedTypes: (_payload$substitution2 = payload.substitutionAllowedTypes) !== null && _payload$substitution2 !== void 0 ? _payload$substitution2 : "",
      substituteReasonCode: (_payload$substituteRe = payload.substituteReasonCode) !== null && _payload$substituteRe !== void 0 ? _payload$substituteRe : "",
      broughtFromHome: (_payload$broughtFromH = payload.broughtFromHome) !== null && _payload$broughtFromH !== void 0 ? _payload$broughtFromH : false,
      IVIngredientDescription: (_payload$IVIngredient = payload.IVIngredientDescription) !== null && _payload$IVIngredient !== void 0 ? _payload$IVIngredient : "",
      // "createdby": payload.createdby ?? "",
      // "updatedby": payload.updatedby ?? "",
      statushistory: (_payload$statushistor = payload.statushistory) !== null && _payload$statushistor !== void 0 ? _payload$statushistor : [],
      statusperiod: (_payload$statusperiod = payload.statusperiod) !== null && _payload$statusperiod !== void 0 ? _payload$statusperiod : 0,
      components: payload.additiveDetails ? getComponent(payload.additiveDetails) : [],
      FreqDetls: (payload === null || payload === void 0 ? void 0 : (_payload$frequencyDet = payload.frequencyDetails) === null || _payload$frequencyDet === void 0 ? void 0 : (_payload$frequencyDet2 = _payload$frequencyDet.frequency) === null || _payload$frequencyDet2 === void 0 ? void 0 : _payload$frequencyDet2.length) > 0 || ((_payload$unitsTypes$f = payload.unitsTypes.frequency) === null || _payload$unitsTypes$f === void 0 ? void 0 : _payload$unitsTypes$f.length) > 0 ? (_ref4 = (payload === null || payload === void 0 ? void 0 : (_payload$frequencyDet3 = payload.frequencyDetails) === null || _payload$frequencyDet3 === void 0 ? void 0 : _payload$frequencyDet3.frequency) || payload.unitsTypes.frequency) === null || _ref4 === void 0 ? void 0 : _ref4.map(function (v) {
        var _v$basefreq, _v$basefreq2, _v$day, _v$day2, _v$day3, _v$day4, _v$adminDosageInstruc;

        debugger;
        return {
          remarks: (v === null || v === void 0 ? void 0 : v.remarks) || "",
          dose: (v === null || v === void 0 ? void 0 : v.dose) || "",
          time: (v === null || v === void 0 ? void 0 : v.time) || "",
          baseFreq: v !== null && v !== void 0 && (_v$basefreq = v.basefreq) !== null && _v$basefreq !== void 0 && _v$basefreq.freqcode ? v === null || v === void 0 ? void 0 : (_v$basefreq2 = v.basefreq) === null || _v$basefreq2 === void 0 ? void 0 : _v$basefreq2.freqcode : "",
          // baseFreq: v?.baseFreq || v?.basefreq || "",
          weekDay: (v === null || v === void 0 ? void 0 : v.weekDay) || (v === null || v === void 0 ? void 0 : v.weekday) || "",
          day: v !== null && v !== void 0 && (_v$day = v.day) !== null && _v$day !== void 0 && _v$day.code ? typeof (v === null || v === void 0 ? void 0 : (_v$day2 = v.day) === null || _v$day2 === void 0 ? void 0 : _v$day2.code) === "string" ? JSON.parse(v === null || v === void 0 ? void 0 : (_v$day3 = v.day) === null || _v$day3 === void 0 ? void 0 : _v$day3.code) : v === null || v === void 0 ? void 0 : (_v$day4 = v.day) === null || _v$day4 === void 0 ? void 0 : _v$day4.code : 0,
          fromDay: v !== null && v !== void 0 && v.fromDay ? typeof (v === null || v === void 0 ? void 0 : v.fromDay) === "string" ? JSON.parse(v === null || v === void 0 ? void 0 : v.fromDay) : v === null || v === void 0 ? void 0 : v.fromDay : 0,
          toDay: v !== null && v !== void 0 && v.toDay ? typeof (v === null || v === void 0 ? void 0 : v.toDay) === "string" ? JSON.parse(v === null || v === void 0 ? void 0 : v.toDay) : v === null || v === void 0 ? void 0 : v.toDay : 0,
          fromDate: v !== null && v !== void 0 && v.fromDate ? typeof (v === null || v === void 0 ? void 0 : v.fromDate) === "string" ? JSON.parse(v === null || v === void 0 ? void 0 : v.fromDate) : v === null || v === void 0 ? void 0 : v.fromDate : 0,
          toDate: v !== null && v !== void 0 && v.toDate ? typeof (v === null || v === void 0 ? void 0 : v.toDate) === "string" ? JSON.parse(v === null || v === void 0 ? void 0 : v.toDate) : v === null || v === void 0 ? void 0 : v.toDate : 0,
          adminDosageInstruction: (_v$adminDosageInstruc = v === null || v === void 0 ? void 0 : v.adminDosageInstruction) !== null && _v$adminDosageInstruc !== void 0 ? _v$adminDosageInstruc : ""
        };
      }) : [],
      nextrefilldate: 0
    }
  })];
};

var getuseAsSlidingScaleDose = function getuseAsSlidingScaleDose(list) {
  var arr = [];
  list.map(function (val) {
    var _val$ssGrpId, _val$dispSeqNo, _val$adminFrDay2, _val$adminToDay2, _val$adminPrdUOM, _val$adminDosageQty, _val$adminDosageQtyUO, _val$adminDosageInstr;

    arr.push({
      ssGrpId: (_val$ssGrpId = val.ssGrpId) !== null && _val$ssGrpId !== void 0 ? _val$ssGrpId : 0,
      dispSeqNo: (_val$dispSeqNo = val.dispSeqNo) !== null && _val$dispSeqNo !== void 0 ? _val$dispSeqNo : 0,
      adminFrDay: (_val$adminFrDay2 = val.adminFrDay) !== null && _val$adminFrDay2 !== void 0 ? _val$adminFrDay2 : 0,
      adminToDay: (_val$adminToDay2 = val.adminToDay) !== null && _val$adminToDay2 !== void 0 ? _val$adminToDay2 : 0,
      adminPrdUOM: (_val$adminPrdUOM = val.adminPrdUOM) !== null && _val$adminPrdUOM !== void 0 ? _val$adminPrdUOM : "",
      adminDosageQty: (_val$adminDosageQty = val.adminDosageQty) !== null && _val$adminDosageQty !== void 0 ? _val$adminDosageQty : 0,
      adminDosageQtyUOM: (_val$adminDosageQtyUO = val.adminDosageQtyUOM) !== null && _val$adminDosageQtyUO !== void 0 ? _val$adminDosageQtyUO : "",
      adminDosageInstruction: (_val$adminDosageInstr = val.adminDosageInstruction) !== null && _val$adminDosageInstr !== void 0 ? _val$adminDosageInstr : ""
    });
  });
  return arr;
};

var getPerformer = function getPerformer(list) {
  var arr = [];
  arr = list.map(function (val) {
    var _val$organization, _val$actionType, _val$practType, _val$practRole, _val$practId, _val$locationRoleType, _val$locationCode, _val$storeCode;

    arr.push({
      organization: (_val$organization = val.organization) !== null && _val$organization !== void 0 ? _val$organization : "",
      actionType: (_val$actionType = val.actionType) !== null && _val$actionType !== void 0 ? _val$actionType : "",
      practType: (_val$practType = val.practType) !== null && _val$practType !== void 0 ? _val$practType : "",
      practRole: (_val$practRole = val.practRole) !== null && _val$practRole !== void 0 ? _val$practRole : "",
      practId: (_val$practId = val.practId) !== null && _val$practId !== void 0 ? _val$practId : "",
      locationRoleType: (_val$locationRoleType = val.locationRoleType) !== null && _val$locationRoleType !== void 0 ? _val$locationRoleType : "",
      locationCode: (_val$locationCode = val.locationCode) !== null && _val$locationCode !== void 0 ? _val$locationCode : "",
      storeCode: (_val$storeCode = val.storeCode) !== null && _val$storeCode !== void 0 ? _val$storeCode : ""
    });
  });
  return arr;
};

var getrequestor = function getrequestor(list) {
  var _list$organization$va, _list$organization, _ref5, _list$practitionerRol, _list$practitionerRol2, _list$practitionerRol3, _list$orderBy$value, _list$orderBy;

  var arr = []; // list.map(val => {

  arr.push({
    organization: (_list$organization$va = (_list$organization = list.organization) === null || _list$organization === void 0 ? void 0 : _list$organization.value) !== null && _list$organization$va !== void 0 ? _list$organization$va : "",
    practRole: (_ref5 = (_list$practitionerRol = (_list$practitionerRol2 = list.practitionerRole) === null || _list$practitionerRol2 === void 0 ? void 0 : _list$practitionerRol2._id) !== null && _list$practitionerRol !== void 0 ? _list$practitionerRol : (_list$practitionerRol3 = list.practitionerRole) === null || _list$practitionerRol3 === void 0 ? void 0 : _list$practitionerRol3.value) !== null && _ref5 !== void 0 ? _ref5 : "",
    practId: (_list$orderBy$value = (_list$orderBy = list.orderBy) === null || _list$orderBy === void 0 ? void 0 : _list$orderBy.value) !== null && _list$orderBy$value !== void 0 ? _list$orderBy$value : ""
  }); // })

  return arr;
};

var getComponent = function getComponent(list) {
  var arr = [];
  list.map(function (val, i) {
    var _val$description$valu, _val$description, _val$dosage$dosageFor, _val$dosage, _val$dosage$quantity, _val$dosage2, _val$dosage$unit$valu, _val$dosage3, _val$dosage3$unit;

    arr.push({
      seqno: i + 1,
      drugcode: (_val$description$valu = (_val$description = val.description) === null || _val$description === void 0 ? void 0 : _val$description.value) !== null && _val$description$valu !== void 0 ? _val$description$valu : "",
      formcode: (_val$dosage$dosageFor = (_val$dosage = val.dosage) === null || _val$dosage === void 0 ? void 0 : _val$dosage.dosageForm) !== null && _val$dosage$dosageFor !== void 0 ? _val$dosage$dosageFor : "",
      dosageQty: (_val$dosage$quantity = (_val$dosage2 = val.dosage) === null || _val$dosage2 === void 0 ? void 0 : _val$dosage2.quantity) !== null && _val$dosage$quantity !== void 0 ? _val$dosage$quantity : 0,
      dosageQtyUOM: (_val$dosage$unit$valu = (_val$dosage3 = val.dosage) === null || _val$dosage3 === void 0 ? void 0 : (_val$dosage3$unit = _val$dosage3.unit) === null || _val$dosage3$unit === void 0 ? void 0 : _val$dosage3$unit.value) !== null && _val$dosage$unit$valu !== void 0 ? _val$dosage$unit$valu : ""
    });
  });
  return arr;
};

var _extraReducers$H;
var DRUGTYPE_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/drugType_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      data,
      arr,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return fetchData({
            body: queries$n.drugType
          }, __readDocumentUrl__);

        case 5:
          data = _context.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$shortdesc;

            arr.push({
              value: val._id,
              label: (_val$shortdesc = val.shortdesc) !== null && _val$shortdesc !== void 0 ? _val$shortdesc : "",
              id: val.id
            });
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var DRUGMASTER_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/drugMaster_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      searchText,
      data,
      arr,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          searchText = payload.searchText;
          _context2.next = 6;
          return fetchData({
            body: queries$n.drugMaster(searchText)
          }, __readDocumentUrl__);

        case 6:
          data = _context2.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$FormCode, _val$FormCode2, _val$StrengthValuesPo, _val$StrengthValuesPo2, _val$StrengthValuesPo3, _val$StrengthValuesPo4, _val$DrugType, _val$DrugType2, _val$DrugType3, _val$DrugType4, _val$drugroutegenid;

            var json = {
              value: val === null || val === void 0 ? void 0 : val._id,
              id: val === null || val === void 0 ? void 0 : val.id,
              FormCode: val === null || val === void 0 ? void 0 : (_val$FormCode = val.FormCode) === null || _val$FormCode === void 0 ? void 0 : _val$FormCode._id,
              FormData: val === null || val === void 0 ? void 0 : (_val$FormCode2 = val.FormCode) === null || _val$FormCode2 === void 0 ? void 0 : _val$FormCode2.longdesc,
              StrengthValues: val === null || val === void 0 ? void 0 : (_val$StrengthValuesPo = val.StrengthValuesPossible) === null || _val$StrengthValuesPo === void 0 ? void 0 : (_val$StrengthValuesPo2 = _val$StrengthValuesPo[0]) === null || _val$StrengthValuesPo2 === void 0 ? void 0 : _val$StrengthValuesPo2.StrengthValue,
              StrengthUOM: val === null || val === void 0 ? void 0 : (_val$StrengthValuesPo3 = val.StrengthValuesPossible) === null || _val$StrengthValuesPo3 === void 0 ? void 0 : (_val$StrengthValuesPo4 = _val$StrengthValuesPo3[0]) === null || _val$StrengthValuesPo4 === void 0 ? void 0 : _val$StrengthValuesPo4.StrengthUOM,
              drugType: val === null || val === void 0 ? void 0 : (_val$DrugType = val.DrugType) === null || _val$DrugType === void 0 ? void 0 : _val$DrugType.drugtype,
              drugTypeLong: val === null || val === void 0 ? void 0 : (_val$DrugType2 = val.DrugType) === null || _val$DrugType2 === void 0 ? void 0 : _val$DrugType2.longdesc,
              drugTypeShort: val === null || val === void 0 ? void 0 : (_val$DrugType3 = val.DrugType) === null || _val$DrugType3 === void 0 ? void 0 : _val$DrugType3.shortdesc,
              drugTypeId: val === null || val === void 0 ? void 0 : (_val$DrugType4 = val.DrugType) === null || _val$DrugType4 === void 0 ? void 0 : _val$DrugType4._id,
              drugroutegenid: (_val$drugroutegenid = val === null || val === void 0 ? void 0 : val.drugroutegenid) !== null && _val$drugroutegenid !== void 0 ? _val$drugroutegenid : "",
              result: val // formValue

            };
            arr.push(_objectSpread2(_objectSpread2({}, json), {}, {
              name: val.ShortDesc,
              label: val.ShortDesc // label: `${val.ShortDesc ?? ""} - ${json.StrengthValues} ${json.StrengthUOM}`,

            }));
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 12]]);
})));
var STRENGTH_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/strength_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var _ref6,
      rejectWithValue,
      data,
      arr,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          _context3.next = 5;
          return fetchData({
            body: queries$n.strength
          }, __readDocumentUrl__);

        case 5:
          data = _context3.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$shortdesc2;

            arr.push({
              value: val._id,
              label: (_val$shortdesc2 = val.shortdesc) !== null && _val$shortdesc2 !== void 0 ? _val$shortdesc2 : "",
              id: val.id,
              strengthvalue: val.strengthvalue,
              strengthvalueUoM: val.strengthvalueUoM
            });
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 11]]);
})));
var STRENGTHUOM_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/strengthUom_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var _ref8,
      rejectWithValue,
      data,
      arr,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          _context4.next = 5;
          return fetchData({
            body: queries$n.strengthUom
          }, __readDocumentUrl__);

        case 5:
          data = _context4.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$UOM;

            arr.push({
              value: val._id,
              label: (_val$UOM = val.UOM) !== null && _val$UOM !== void 0 ? _val$UOM : "",
              id: val.id
            });
          });
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 11]]);
})));
var STRENGTHVOLUMN_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/strengthVolumn_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var _ref10,
      rejectWithValue,
      data,
      arr,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          _context5.next = 5;
          return fetchData({
            body: queries$n.strengthVolumn
          }, __readDocumentUrl__);

        case 5:
          data = _context5.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$strengthvalue;

            arr.push({
              value: val._id,
              label: (_val$strengthvalue = val.strengthvalue) !== null && _val$strengthvalue !== void 0 ? _val$strengthvalue : "",
              uom: val.strengthvalueUoM,
              id: val.id
            });
          });
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 11]]);
})));
var STRENGTHVOLUMNUOM_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/strengthVolumnUom_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var _ref12,
      rejectWithValue,
      data,
      arr,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          _context6.next = 5;
          return fetchData({
            body: queries$n.strengthVolumnUom
          }, __readDocumentUrl__);

        case 5:
          data = _context6.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$UOM2;

            arr.push({
              value: val._id,
              label: (_val$UOM2 = val.UOM) !== null && _val$UOM2 !== void 0 ? _val$UOM2 : "",
              id: val.id
            });
          });
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 14:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 11]]);
})));
var DOSAGETYPEINDICATOR_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/DosageTypeIndicator_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var _ref14,
      rejectWithValue,
      data,
      arr,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          _context7.next = 5;
          return fetchData({
            body: queries$n.DosageTypeIndicator
          }, __readDocumentUrl__);

        case 5:
          data = _context7.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$coding$display, _val$coding;

            arr.push({
              value: val._id,
              label: (_val$coding$display = (_val$coding = val.coding) === null || _val$coding === void 0 ? void 0 : _val$coding.display) !== null && _val$coding$display !== void 0 ? _val$coding$display : "",
              id: val.id
            });
          });
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context7.prev = 11;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 14:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 11]]);
})));
var DOSAGEUOM_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/DosageUOM_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var _ref16,
      rejectWithValue,
      data,
      arr,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _ref16 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref16.rejectWithValue;
          _context8.prev = 2;
          _context8.next = 5;
          return fetchData({
            body: queries$n.DosageUOM
          }, __readDocumentUrl__);

        case 5:
          data = _context8.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$UOM3;

            arr.push({
              value: val._id,
              label: (_val$UOM3 = val === null || val === void 0 ? void 0 : val.UOM) !== null && _val$UOM3 !== void 0 ? _val$UOM3 : "",
              id: val.id
            });
          });
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 14:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 11]]);
})));
var DOSAGEVOLUMEUOM_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/DosageVolumeUom_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var _ref18,
      rejectWithValue,
      data,
      arr,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _ref18 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref18.rejectWithValue;
          _context9.prev = 2;
          _context9.next = 5;
          return fetchData({
            body: queries$n.DosageVolumeUom
          }, __readDocumentUrl__);

        case 5:
          data = _context9.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$UOM4;

            arr.push({
              value: val._id,
              label: (_val$UOM4 = val.UOM) !== null && _val$UOM4 !== void 0 ? _val$UOM4 : "",
              id: val.id
            });
          });
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context9.prev = 11;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 14:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 11]]);
})));
var DRUGROUTES_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/DrugRoutes_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var _ref20,
      rejectWithValue,
      data,
      arr,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _ref20 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref20.rejectWithValue;
          _context10.prev = 2;
          _context10.next = 5;
          return fetchData({
            body: queries$n.DrugRoutes
          }, __readDocumentUrl__);

        case 5:
          data = _context10.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$shortdesc3;

            arr.push({
              value: val._id,
              label: (_val$shortdesc3 = val.shortdesc) !== null && _val$shortdesc3 !== void 0 ? _val$shortdesc3 : "",
              id: val.id
            });
          });
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context10.prev = 11;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 14:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 11]]);
})));
var DOSAGEFORM_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/DosageForm_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var _ref22,
      rejectWithValue,
      data,
      arr,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _ref22 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref22.rejectWithValue;
          _context11.prev = 2;
          _context11.next = 5;
          return fetchData({
            body: queries$n.DosageForm
          }, __readDocumentUrl__);

        case 5:
          data = _context11.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$drugtype;

            arr.push({
              value: val._id,
              label: (_val$drugtype = val.drugtype) !== null && _val$drugtype !== void 0 ? _val$drugtype : "",
              id: val.id
            });
          });
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context11.prev = 11;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 14:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 11]]);
})));
var FREQUENCYMASTER_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/FrequencyMaster_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var _ref24,
      rejectWithValue,
      data,
      arr,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _ref24 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref24.rejectWithValue;
          _context12.prev = 2;
          _context12.next = 5;
          return fetchData({
            body: queries$n.FrequencyMaster
          }, __readDocumentUrl__);

        case 5:
          data = _context12.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$freqcode, _val$frequencytype$sh, _val$frequencytype, _val$fixeddurationVal, _val$fixeddurUOM$labe, _val$fixeddurUOM, _val$fixeddurUOM2;

            arr.push({
              value: val === null || val === void 0 ? void 0 : val._id,
              label: (_val$freqcode = val === null || val === void 0 ? void 0 : val.freqcode) !== null && _val$freqcode !== void 0 ? _val$freqcode : "",
              id: val === null || val === void 0 ? void 0 : val.id,
              frequency: val === null || val === void 0 ? void 0 : val.scheduleline,
              type: (_val$frequencytype$sh = val === null || val === void 0 ? void 0 : (_val$frequencytype = val.frequencytype) === null || _val$frequencytype === void 0 ? void 0 : _val$frequencytype.shortdesc) !== null && _val$frequencytype$sh !== void 0 ? _val$frequencytype$sh : "",
              fixeddurationVal: (_val$fixeddurationVal = val === null || val === void 0 ? void 0 : val.fixeddurationVal) !== null && _val$fixeddurationVal !== void 0 ? _val$fixeddurationVal : "",
              fixeddurUOM: (_val$fixeddurUOM$labe = _objectSpread2(_objectSpread2({}, val === null || val === void 0 ? void 0 : val.fixeddurUOM), {}, {
                label: val === null || val === void 0 ? void 0 : (_val$fixeddurUOM = val.fixeddurUOM) === null || _val$fixeddurUOM === void 0 ? void 0 : _val$fixeddurUOM.shortdesc,
                value: val === null || val === void 0 ? void 0 : (_val$fixeddurUOM2 = val.fixeddurUOM) === null || _val$fixeddurUOM2 === void 0 ? void 0 : _val$fixeddurUOM2._id
              })) !== null && _val$fixeddurUOM$labe !== void 0 ? _val$fixeddurUOM$labe : "",
              freqcode: val === null || val === void 0 ? void 0 : val.freqcode
            });
          });
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context12.prev = 11;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 14:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 11]]);
})));
var DURATIONTYPE_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/DurationType_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
  var _ref26,
      rejectWithValue,
      data,
      arr,
      _args13 = arguments;

  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _ref26 = _args13.length > 1 ? _args13[1] : undefined, rejectWithValue = _ref26.rejectWithValue;
          _context13.prev = 2;
          _context13.next = 5;
          return fetchData({
            body: queries$n.DurationType
          }, __readDocumentUrl__);

        case 5:
          data = _context13.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$shortdesc4, _val$shortdesc$, _val$shortdesc5;

            arr.push({
              value: val._id,
              label: (_val$shortdesc4 = val.shortdesc) !== null && _val$shortdesc4 !== void 0 ? _val$shortdesc4 : "",
              type: (_val$shortdesc$ = (_val$shortdesc5 = val.shortdesc) === null || _val$shortdesc5 === void 0 ? void 0 : _val$shortdesc5[0]) !== null && _val$shortdesc$ !== void 0 ? _val$shortdesc$ : "",
              id: val.id
            });
          });
          return _context13.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context13.prev = 11;
          _context13.t0 = _context13["catch"](2);
          return _context13.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context13.t0.message
          })));

        case 14:
        case "end":
          return _context13.stop();
      }
    }
  }, _callee13, null, [[2, 11]]);
})));
var PRIORITY_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/Priority_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
  var _ref28,
      rejectWithValue,
      data,
      arr,
      _args14 = arguments;

  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _ref28 = _args14.length > 1 ? _args14[1] : undefined, rejectWithValue = _ref28.rejectWithValue;
          _context14.prev = 2;
          _context14.next = 5;
          return fetchData({
            body: queries$n.Priority
          }, __readDocumentUrl__);

        case 5:
          data = _context14.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$coding$0$_id, _val$coding2, _val$coding2$, _val$coding$0$display, _val$coding3, _val$coding3$;

            arr.push({
              value: val._id,
              masterId: (_val$coding$0$_id = val === null || val === void 0 ? void 0 : (_val$coding2 = val.coding) === null || _val$coding2 === void 0 ? void 0 : (_val$coding2$ = _val$coding2[0]) === null || _val$coding2$ === void 0 ? void 0 : _val$coding2$._id) !== null && _val$coding$0$_id !== void 0 ? _val$coding$0$_id : "",
              label: (_val$coding$0$display = val === null || val === void 0 ? void 0 : (_val$coding3 = val.coding) === null || _val$coding3 === void 0 ? void 0 : (_val$coding3$ = _val$coding3[0]) === null || _val$coding3$ === void 0 ? void 0 : _val$coding3$.display) !== null && _val$coding$0$display !== void 0 ? _val$coding$0$display : "",
              id: val.id
            });
          });
          return _context14.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context14.prev = 11;
          _context14.t0 = _context14["catch"](2);
          return _context14.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context14.t0.message
          })));

        case 14:
        case "end":
          return _context14.stop();
      }
    }
  }, _callee14, null, [[2, 11]]);
})));
var DRUGCATEGORY_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/DrugCategory_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
  var _ref30,
      rejectWithValue,
      data,
      arr,
      _args15 = arguments;

  return _regeneratorRuntime().wrap(function _callee15$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _ref30 = _args15.length > 1 ? _args15[1] : undefined, rejectWithValue = _ref30.rejectWithValue;
          _context15.prev = 2;
          _context15.next = 5;
          return fetchData({
            body: queries$n.DrugCategory
          }, __readDocumentUrl__);

        case 5:
          data = _context15.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$shortdesc6;

            arr.push({
              value: val._id,
              label: (_val$shortdesc6 = val.shortdesc) !== null && _val$shortdesc6 !== void 0 ? _val$shortdesc6 : "",
              id: val.id
            });
          });
          return _context15.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context15.prev = 11;
          _context15.t0 = _context15["catch"](2);
          return _context15.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context15.t0.message
          })));

        case 14:
        case "end":
          return _context15.stop();
      }
    }
  }, _callee15, null, [[2, 11]]);
})));
var ORDER_PRESCRIPTION_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/OrderPrescription_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
  var _ref32,
      rejectWithValue,
      data,
      arr,
      _args16 = arguments;

  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _ref32 = _args16.length > 1 ? _args16[1] : undefined, rejectWithValue = _ref32.rejectWithValue;
          _context16.prev = 2;
          _context16.next = 5;
          return fetchData({
            body: queries$n.OrderPrescription
          }, __readDocumentUrl__);

        case 5:
          data = _context16.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$coding4;

            arr.push({
              value: val._id,
              label: (val === null || val === void 0 ? void 0 : val.display) || ((_val$coding4 = val.coding) === null || _val$coding4 === void 0 ? void 0 : _val$coding4[0].display) || "",
              id: val.id
            });
          });
          return _context16.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context16.prev = 11;
          _context16.t0 = _context16["catch"](2);
          return _context16.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context16.t0.message
          })));

        case 14:
        case "end":
          return _context16.stop();
      }
    }
  }, _callee16, null, [[2, 11]]);
})));
var ORDERNATURE_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/OrderNature_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
  var _ref34,
      rejectWithValue,
      data,
      arr,
      _args17 = arguments;

  return _regeneratorRuntime().wrap(function _callee17$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _ref34 = _args17.length > 1 ? _args17[1] : undefined, rejectWithValue = _ref34.rejectWithValue;
          _context17.prev = 2;
          _context17.next = 5;
          return fetchData({
            body: queries$n.OrderNature
          }, __readDocumentUrl__);

        case 5:
          data = _context17.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$coding5;

            arr.push({
              value: val._id,
              label: (val === null || val === void 0 ? void 0 : val.display) || ((_val$coding5 = val.coding) === null || _val$coding5 === void 0 ? void 0 : _val$coding5[0].display) || "",
              id: val.id
            });
          });
          return _context17.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context17.prev = 11;
          _context17.t0 = _context17["catch"](2);
          return _context17.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context17.t0.message
          })));

        case 14:
        case "end":
          return _context17.stop();
      }
    }
  }, _callee17, null, [[2, 11]]);
})));
var ORDERMODE_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/OrderMode_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
  var _ref36,
      rejectWithValue,
      data,
      arr,
      _args18 = arguments;

  return _regeneratorRuntime().wrap(function _callee18$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _ref36 = _args18.length > 1 ? _args18[1] : undefined, rejectWithValue = _ref36.rejectWithValue;
          _context18.prev = 2;
          _context18.next = 5;
          return fetchData({
            body: queries$n.OrderMode
          }, __readDocumentUrl__);

        case 5:
          data = _context18.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$coding6;

            arr.push({
              value: val._id,
              label: (val === null || val === void 0 ? void 0 : val.display) || ((_val$coding6 = val.coding) === null || _val$coding6 === void 0 ? void 0 : _val$coding6[0].display) || "",
              id: val.id
            });
          });
          return _context18.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context18.prev = 11;
          _context18.t0 = _context18["catch"](2);
          return _context18.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context18.t0.message
          })));

        case 14:
        case "end":
          return _context18.stop();
      }
    }
  }, _callee18, null, [[2, 11]]);
})));
var DRUGSTOREDISPLOC_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/DrugStoreDispLoc_masters", /*#__PURE__*/function () {
  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(_ref37, _ref38) {
    var encounterTypeId, rejectWithValue, data, arr;
    return _regeneratorRuntime().wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            encounterTypeId = _ref37.encounterTypeId;
            rejectWithValue = _ref38.rejectWithValue;
            _context19.prev = 2;
            _context19.next = 5;
            return fetchData({
              body: queries$n.DrugStoreDispLoc(encounterTypeId)
            }, __GetDrugDispLocMaster__);

          case 5:
            data = _context19.sent;
            arr = [];
            data.result.map(function (val) {
              var _val$locationName;

              arr.push({
                value: val === null || val === void 0 ? void 0 : val.locationId,
                label: (_val$locationName = val === null || val === void 0 ? void 0 : val.locationName) !== null && _val$locationName !== void 0 ? _val$locationName : ""
              });
            });
            return _context19.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: arr
            }));

          case 11:
            _context19.prev = 11;
            _context19.t0 = _context19["catch"](2);
            return _context19.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context19.t0.message
            })));

          case 14:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, null, [[2, 11]]);
  }));

  return function (_x, _x2) {
    return _ref39.apply(this, arguments);
  };
}());
var DIAGNOSISAGAINSTENCOUNTER_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/DiagnosisAgainstEncounter_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
  var payload,
      _ref41,
      rejectWithValue,
      id,
      data,
      arr,
      _args20 = arguments;

  return _regeneratorRuntime().wrap(function _callee20$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          payload = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : {};
          _ref41 = _args20.length > 1 ? _args20[1] : undefined, rejectWithValue = _ref41.rejectWithValue;
          id = payload.id;
          _context20.prev = 3;
          _context20.next = 6;
          return fetchData({
            body: queries$n.DiagnosisAgainstEncounter(id)
          }, __readDocumentUrl__);

        case 6:
          data = _context20.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$diagcode$icdshor, _val$diagcode;

            arr.push({
              value: val._id,
              label: (_val$diagcode$icdshor = (_val$diagcode = val.diagcode) === null || _val$diagcode === void 0 ? void 0 : _val$diagcode.icdshortname) !== null && _val$diagcode$icdshor !== void 0 ? _val$diagcode$icdshor : "",
              id: val.id
            });
          });
          return _context20.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context20.prev = 12;
          _context20.t0 = _context20["catch"](3);
          return _context20.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context20.t0.message
          })));

        case 15:
        case "end":
          return _context20.stop();
      }
    }
  }, _callee20, null, [[3, 12]]);
})));
var REASONCODE_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/Reasoncode_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
  var _ref43,
      rejectWithValue,
      data,
      arr,
      _args21 = arguments;

  return _regeneratorRuntime().wrap(function _callee21$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _ref43 = _args21.length > 1 ? _args21[1] : undefined, rejectWithValue = _ref43.rejectWithValue;
          _context21.prev = 2;
          _context21.next = 5;
          return fetchData({
            body: queries$n.Reasoncode
          }, __readDocumentUrl__);

        case 5:
          data = _context21.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$display;

            arr.push({
              value: val._id,
              label: (_val$display = val.display) !== null && _val$display !== void 0 ? _val$display : "",
              id: val.id
            });
          });
          return _context21.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context21.prev = 11;
          _context21.t0 = _context21["catch"](2);
          return _context21.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context21.t0.message
          })));

        case 14:
        case "end":
          return _context21.stop();
      }
    }
  }, _callee21, null, [[2, 11]]);
})));
var ORGANIZATION_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/Organization_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
  var _ref45,
      rejectWithValue,
      data,
      arr,
      _args22 = arguments;

  return _regeneratorRuntime().wrap(function _callee22$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          _ref45 = _args22.length > 1 ? _args22[1] : undefined, rejectWithValue = _ref45.rejectWithValue;
          _context22.prev = 2;
          _context22.next = 5;
          return fetchData({
            body: queries$n.Organization
          }, __readDocumentUrl__);

        case 5:
          data = _context22.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$name;

            arr.push({
              value: val._id,
              label: (_val$name = val.name) !== null && _val$name !== void 0 ? _val$name : "",
              id: val.id
            });
          });
          return _context22.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context22.prev = 11;
          _context22.t0 = _context22["catch"](2);
          return _context22.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context22.t0.message
          })));

        case 14:
        case "end":
          return _context22.stop();
      }
    }
  }, _callee22, null, [[2, 11]]);
})));
var PATIENT_INSTRUCTIONS_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/Patient_Instruction", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
  var _ref47,
      rejectWithValue,
      data,
      arr,
      _args23 = arguments;

  return _regeneratorRuntime().wrap(function _callee23$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          _ref47 = _args23.length > 1 ? _args23[1] : undefined, rejectWithValue = _ref47.rejectWithValue;
          _context23.prev = 2;
          _context23.next = 5;
          return fetchData({
            body: queries$n.Patient_Instruction
          }, __readDocumentUrl__);

        case 5:
          data = _context23.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$coding7, _val$coding7$, _val$coding$0$code, _val$coding8, _val$coding8$, _val$coding$0$display2, _val$coding9, _val$coding9$, _val$coding10, _val$coding10$;

            arr.push({
              value: (_val$coding7 = val.coding) === null || _val$coding7 === void 0 ? void 0 : (_val$coding7$ = _val$coding7[0]) === null || _val$coding7$ === void 0 ? void 0 : _val$coding7$._id,
              label: (_val$coding$0$code = (_val$coding8 = val.coding) === null || _val$coding8 === void 0 ? void 0 : (_val$coding8$ = _val$coding8[0]) === null || _val$coding8$ === void 0 ? void 0 : _val$coding8$.code) !== null && _val$coding$0$code !== void 0 ? _val$coding$0$code : "",
              display: (_val$coding$0$display2 = (_val$coding9 = val.coding) === null || _val$coding9 === void 0 ? void 0 : (_val$coding9$ = _val$coding9[0]) === null || _val$coding9$ === void 0 ? void 0 : _val$coding9$.display) !== null && _val$coding$0$display2 !== void 0 ? _val$coding$0$display2 : "",
              id: (_val$coding10 = val.coding) === null || _val$coding10 === void 0 ? void 0 : (_val$coding10$ = _val$coding10[0]) === null || _val$coding10$ === void 0 ? void 0 : _val$coding10$.id
            });
          });
          return _context23.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context23.prev = 11;
          _context23.t0 = _context23["catch"](2);
          return _context23.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context23.t0.message
          })));

        case 14:
        case "end":
          return _context23.stop();
      }
    }
  }, _callee23, null, [[2, 11]]);
})));
var STATUS_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/status_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
  var _ref49,
      rejectWithValue,
      data,
      arr,
      _args24 = arguments;

  return _regeneratorRuntime().wrap(function _callee24$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          _ref49 = _args24.length > 1 ? _args24[1] : undefined, rejectWithValue = _ref49.rejectWithValue;
          _context24.prev = 2;
          _context24.next = 5;
          return fetchData({
            body: queries$n.statusMaster
          }, __readDocumentUrl__);

        case 5:
          data = _context24.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$coding$0$display3, _val$coding11, _val$coding11$, _val$coding$0$code2, _val$coding12, _val$coding12$;

            arr.push({
              value: val._id,
              label: (_val$coding$0$display3 = (_val$coding11 = val.coding) === null || _val$coding11 === void 0 ? void 0 : (_val$coding11$ = _val$coding11[0]) === null || _val$coding11$ === void 0 ? void 0 : _val$coding11$.display) !== null && _val$coding$0$display3 !== void 0 ? _val$coding$0$display3 : "",
              id: val.id,
              code: (_val$coding$0$code2 = val === null || val === void 0 ? void 0 : (_val$coding12 = val.coding) === null || _val$coding12 === void 0 ? void 0 : (_val$coding12$ = _val$coding12[0]) === null || _val$coding12$ === void 0 ? void 0 : _val$coding12$.code) !== null && _val$coding$0$code2 !== void 0 ? _val$coding$0$code2 : ""
            });
          });
          return _context24.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context24.prev = 11;
          _context24.t0 = _context24["catch"](2);
          return _context24.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context24.t0.message
          })));

        case 14:
        case "end":
          return _context24.stop();
      }
    }
  }, _callee24, null, [[2, 11]]);
})));
var PRACTITIONERROLE_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/PractitionerRole_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
  var payload,
      _ref51,
      rejectWithValue,
      data,
      arr,
      _args25 = arguments;

  return _regeneratorRuntime().wrap(function _callee25$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          payload = _args25.length > 0 && _args25[0] !== undefined ? _args25[0] : {};
          _ref51 = _args25.length > 1 ? _args25[1] : undefined, rejectWithValue = _ref51.rejectWithValue;
          _context25.prev = 2;
          _context25.next = 5;
          return fetchData({
            body: queries$n.PractitionerRole(payload.orgId)
          }, __readDocumentUrl__);

        case 5:
          data = _context25.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$PractitionerRole, _val$PractitionerRole2, _val$PractitionerRole3;

            arr.push({
              value: (_val$PractitionerRole = val.PractitionerRole) === null || _val$PractitionerRole === void 0 ? void 0 : _val$PractitionerRole[0]._id,
              label: (_val$PractitionerRole2 = (_val$PractitionerRole3 = val.PractitionerRole) === null || _val$PractitionerRole3 === void 0 ? void 0 : _val$PractitionerRole3[0].text) !== null && _val$PractitionerRole2 !== void 0 ? _val$PractitionerRole2 : "",
              id: val.id
            });
          });
          return _context25.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context25.prev = 11;
          _context25.t0 = _context25["catch"](2);
          return _context25.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context25.t0.message
          })));

        case 14:
        case "end":
          return _context25.stop();
      }
    }
  }, _callee25, null, [[2, 11]]);
})));
var PRACTITIONER_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/Practitioner_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
  var payload,
      _ref53,
      rejectWithValue,
      data,
      arr,
      _args26 = arguments;

  return _regeneratorRuntime().wrap(function _callee26$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          payload = _args26.length > 0 && _args26[0] !== undefined ? _args26[0] : {};
          _ref53 = _args26.length > 1 ? _args26[1] : undefined, rejectWithValue = _ref53.rejectWithValue;
          _context26.prev = 2;
          _context26.next = 5;
          return fetchData({
            body: queries$n.Practitioner(payload.orgId)
          }, __readDocumentUrl__);

        case 5:
          data = _context26.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$PractitionerName, _val$PractitionerName2, _val$PractitionerName3;

            arr.push({
              value: val._id,
              label: (_val$PractitionerName = (_val$PractitionerName2 = val.PractitionerName) === null || _val$PractitionerName2 === void 0 ? void 0 : (_val$PractitionerName3 = _val$PractitionerName2[0]) === null || _val$PractitionerName3 === void 0 ? void 0 : _val$PractitionerName3.text) !== null && _val$PractitionerName !== void 0 ? _val$PractitionerName : ""
            });
          });
          return _context26.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context26.prev = 11;
          _context26.t0 = _context26["catch"](2);
          return _context26.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context26.t0.message
          })));

        case 14:
        case "end":
          return _context26.stop();
      }
    }
  }, _callee26, null, [[2, 11]]);
})));
var INFUSIONRATEUOM_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/InfusionRateUoM_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
  var _ref55,
      rejectWithValue,
      data,
      arr,
      _args27 = arguments;

  return _regeneratorRuntime().wrap(function _callee27$(_context27) {
    while (1) {
      switch (_context27.prev = _context27.next) {
        case 0:
          _ref55 = _args27.length > 1 ? _args27[1] : undefined, rejectWithValue = _ref55.rejectWithValue;
          _context27.prev = 2;
          _context27.next = 5;
          return fetchData({
            body: queries$n.InfusionRateUoM
          }, __readDocumentUrl__);

        case 5:
          data = _context27.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$UOM5;

            arr.push({
              value: val._id,
              label: (_val$UOM5 = val.UOM) !== null && _val$UOM5 !== void 0 ? _val$UOM5 : "",
              id: val.id
            });
          });
          return _context27.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context27.prev = 11;
          _context27.t0 = _context27["catch"](2);
          return _context27.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context27.t0.message
          })));

        case 14:
        case "end":
          return _context27.stop();
      }
    }
  }, _callee27, null, [[2, 11]]);
})));
var TOTALVOLUMEUOM_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/TotalVolumeUoM_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
  var _ref57,
      rejectWithValue,
      data,
      arr,
      _args28 = arguments;

  return _regeneratorRuntime().wrap(function _callee28$(_context28) {
    while (1) {
      switch (_context28.prev = _context28.next) {
        case 0:
          _ref57 = _args28.length > 1 ? _args28[1] : undefined, rejectWithValue = _ref57.rejectWithValue;
          _context28.prev = 2;
          _context28.next = 5;
          return fetchData({
            body: queries$n.TotalVolumeUoM
          }, __readDocumentUrl__);

        case 5:
          data = _context28.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$shortdesc7;

            arr.push({
              value: val._id,
              label: (_val$shortdesc7 = val.shortdesc) !== null && _val$shortdesc7 !== void 0 ? _val$shortdesc7 : "",
              id: val.id
            });
          });
          return _context28.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context28.prev = 11;
          _context28.t0 = _context28["catch"](2);
          return _context28.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context28.t0.message
          })));

        case 14:
        case "end":
          return _context28.stop();
      }
    }
  }, _callee28, null, [[2, 11]]);
})));
var INDICATION_REASON_CODE_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/Indication_Reason_Code_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
  var _ref59,
      rejectWithValue,
      data,
      arr,
      _args29 = arguments;

  return _regeneratorRuntime().wrap(function _callee29$(_context29) {
    while (1) {
      switch (_context29.prev = _context29.next) {
        case 0:
          _ref59 = _args29.length > 1 ? _args29[1] : undefined, rejectWithValue = _ref59.rejectWithValue;
          _context29.prev = 2;
          _context29.next = 5;
          return fetchData({
            body: queries$n.Indication_Reason_Code
          }, __readDocumentUrl__);

        case 5:
          data = _context29.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$ReasonDesc;

            arr.push({
              value: val._id,
              label: (_val$ReasonDesc = val.ReasonDesc) !== null && _val$ReasonDesc !== void 0 ? _val$ReasonDesc : "",
              id: val.id
            });
          });
          return _context29.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context29.prev = 11;
          _context29.t0 = _context29["catch"](2);
          return _context29.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context29.t0.message
          })));

        case 14:
        case "end":
          return _context29.stop();
      }
    }
  }, _callee29, null, [[2, 11]]);
})));
var BASESCHEDULE_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/BaseSchedule_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
  var _ref61,
      rejectWithValue,
      data,
      arr,
      _args30 = arguments;

  return _regeneratorRuntime().wrap(function _callee30$(_context30) {
    while (1) {
      switch (_context30.prev = _context30.next) {
        case 0:
          _ref61 = _args30.length > 1 ? _args30[1] : undefined, rejectWithValue = _ref61.rejectWithValue;
          _context30.prev = 2;
          _context30.next = 5;
          return fetchData({
            body: queries$n.BaseSchedule
          }, __readDocumentUrl__);

        case 5:
          data = _context30.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$shortdesc8;

            arr.push({
              value: val._id,
              label: (_val$shortdesc8 = val.shortdesc) !== null && _val$shortdesc8 !== void 0 ? _val$shortdesc8 : "",
              id: val.id
            });
          });
          return _context30.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context30.prev = 11;
          _context30.t0 = _context30["catch"](2);
          return _context30.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context30.t0.message
          })));

        case 14:
        case "end":
          return _context30.stop();
      }
    }
  }, _callee30, null, [[2, 11]]);
})));
var DELETEMEDICATION_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/DeleteMedication_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
  var payload,
      _ref63,
      rejectWithValue,
      data,
      _args31 = arguments;

  return _regeneratorRuntime().wrap(function _callee31$(_context31) {
    while (1) {
      switch (_context31.prev = _context31.next) {
        case 0:
          payload = _args31.length > 0 && _args31[0] !== undefined ? _args31[0] : {};
          _ref63 = _args31.length > 1 ? _args31[1] : undefined, rejectWithValue = _ref63.rejectWithValue;
          _context31.prev = 2;
          _context31.next = 5;
          return fetchData({
            body: queries$n.DeleteMedication(payload.id)
          }, __deleteUrl__);

        case 5:
          data = _context31.sent;
          return _context31.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 9:
          _context31.prev = 9;
          _context31.t0 = _context31["catch"](2);
          return _context31.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context31.t0.message
          })));

        case 12:
        case "end":
          return _context31.stop();
      }
    }
  }, _callee31, null, [[2, 9]]);
})));
var WORKFLOW_STATUS_MASTER = toolkit.createAsyncThunk("MedicationMastersSlice/workflow_status_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
  var _ref65,
      rejectWithValue,
      data,
      arr,
      _args32 = arguments;

  return _regeneratorRuntime().wrap(function _callee32$(_context32) {
    while (1) {
      switch (_context32.prev = _context32.next) {
        case 0:
          _ref65 = _args32.length > 1 ? _args32[1] : undefined, rejectWithValue = _ref65.rejectWithValue;
          _context32.prev = 2;
          _context32.next = 5;
          return fetchData({
            body: queries$n.workFlowStatus
          }, __readDocumentUrl__);

        case 5:
          data = _context32.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$coding$0$display4, _val$coding13, _val$coding13$, _val$coding$0$code3, _val$coding14, _val$coding14$;

            arr.push({
              value: val._id,
              label: (_val$coding$0$display4 = (_val$coding13 = val.coding) === null || _val$coding13 === void 0 ? void 0 : (_val$coding13$ = _val$coding13[0]) === null || _val$coding13$ === void 0 ? void 0 : _val$coding13$.display) !== null && _val$coding$0$display4 !== void 0 ? _val$coding$0$display4 : "",
              id: val.id,
              code: (_val$coding$0$code3 = val === null || val === void 0 ? void 0 : (_val$coding14 = val.coding) === null || _val$coding14 === void 0 ? void 0 : (_val$coding14$ = _val$coding14[0]) === null || _val$coding14$ === void 0 ? void 0 : _val$coding14$.code) !== null && _val$coding$0$code3 !== void 0 ? _val$coding$0$code3 : ""
            });
          });
          return _context32.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context32.prev = 11;
          _context32.t0 = _context32["catch"](2);
          return _context32.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context32.t0.message
          })));

        case 14:
        case "end":
          return _context32.stop();
      }
    }
  }, _callee32, null, [[2, 11]]);
})));
var SINGLE_READ_EDIT_INFO = toolkit.createAsyncThunk("MedicationMastersSlice/single_read_edit_info", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
  var payload,
      _ref67,
      rejectWithValue,
      key,
      data,
      _args33 = arguments;

  return _regeneratorRuntime().wrap(function _callee33$(_context33) {
    while (1) {
      switch (_context33.prev = _context33.next) {
        case 0:
          payload = _args33.length > 0 && _args33[0] !== undefined ? _args33[0] : {};
          _ref67 = _args33.length > 1 ? _args33[1] : undefined, rejectWithValue = _ref67.rejectWithValue;
          key = payload.key;
          _context33.prev = 3;
          _context33.next = 6;
          return fetchData({
            body: queries$n.singleReadEditInfo(key)
          }, __readDocumentUrl__);

        case 6:
          data = _context33.sent;
          return _context33.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data === null || data === void 0 ? void 0 : data.result
          }));

        case 10:
          _context33.prev = 10;
          _context33.t0 = _context33["catch"](3);
          return _context33.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context33.t0.message
          })));

        case 13:
        case "end":
          return _context33.stop();
      }
    }
  }, _callee33, null, [[3, 10]]);
})));
var ORDER_TYPE_REQ_DETAILS_ROLE = toolkit.createAsyncThunk("MedicationMastersSlice/laborder_pract_role", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
  var payload,
      _ref69,
      rejectWithValue,
      id,
      _data1$result,
      data1,
      data,
      _args34 = arguments;

  return _regeneratorRuntime().wrap(function _callee34$(_context34) {
    while (1) {
      switch (_context34.prev = _context34.next) {
        case 0:
          payload = _args34.length > 0 && _args34[0] !== undefined ? _args34[0] : {};
          _ref69 = _args34.length > 1 ? _args34[1] : undefined, rejectWithValue = _ref69.rejectWithValue;
          id = payload.id;
          _context34.prev = 3;
          _context34.next = 6;
          return fetchData({
            body: JSON.stringify(queries$n.laborder_PractitionerRole(id))
          }, __readDocumentUrl__);

        case 6:
          data1 = _context34.sent;
          data = [];
          data1 === null || data1 === void 0 ? void 0 : (_data1$result = data1.result) === null || _data1$result === void 0 ? void 0 : _data1$result.map(function (val) {
            var _val$display2, _val$display3;

            data.push({
              label: (_val$display2 = val === null || val === void 0 ? void 0 : val.display) !== null && _val$display2 !== void 0 ? _val$display2 : "",
              value: (_val$display3 = val === null || val === void 0 ? void 0 : val.display) !== null && _val$display3 !== void 0 ? _val$display3 : "",
              id: val === null || val === void 0 ? void 0 : val.id,
              _id: val === null || val === void 0 ? void 0 : val._id
            });
          });
          return _context34.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 12:
          _context34.prev = 12;
          _context34.t0 = _context34["catch"](3);
          return _context34.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context34.t0.message
          })));

        case 15:
        case "end":
          return _context34.stop();
      }
    }
  }, _callee34, null, [[3, 12]]);
})));
var ORDER_TYPE_REQ_DETAILS_LAB = toolkit.createAsyncThunk("MedicationMastersSlice/order_type_req_details", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
  var payload,
      _ref71,
      rejectWithValue,
      _data2$result,
      id,
      _id,
      orgId,
      data2,
      arr2,
      _args35 = arguments;

  return _regeneratorRuntime().wrap(function _callee35$(_context35) {
    while (1) {
      switch (_context35.prev = _context35.next) {
        case 0:
          payload = _args35.length > 0 && _args35[0] !== undefined ? _args35[0] : {};
          _ref71 = _args35.length > 1 ? _args35[1] : undefined, rejectWithValue = _ref71.rejectWithValue;
          _context35.prev = 2;
          id = payload.id, _id = payload._id, orgId = payload.orgId;
          _context35.next = 6;
          return fetchData({
            body: JSON.stringify(queries$n.laborder_PractitionerName(orgId, id, _id))
          }, __readDocumentUrl__);

        case 6:
          data2 = _context35.sent;
          arr2 = [];
          data2 === null || data2 === void 0 ? void 0 : (_data2$result = data2.result) === null || _data2$result === void 0 ? void 0 : _data2$result.map(function (val) {
            var _val$name2, _val$_id, _val$practitioner_id;

            arr2.push({
              label: makeName((val === null || val === void 0 ? void 0 : (_val$name2 = val.name) === null || _val$name2 === void 0 ? void 0 : _val$name2[0]) || {}),
              value: (_val$_id = val === null || val === void 0 ? void 0 : val._id) !== null && _val$_id !== void 0 ? _val$_id : "",
              practitioner_id: (_val$practitioner_id = val === null || val === void 0 ? void 0 : val.practitioner_id) !== null && _val$practitioner_id !== void 0 ? _val$practitioner_id : ""
            });
          });
          return _context35.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: arr2
          }));

        case 12:
          _context35.prev = 12;
          _context35.t0 = _context35["catch"](2);
          return _context35.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context35.t0.message
          })));

        case 15:
        case "end":
          return _context35.stop();
      }
    }
  }, _callee35, null, [[2, 12]]);
})));
var DIAGNOSIS_MASTERS$1 = toolkit.createAsyncThunk("MedicationMastersSlice/diagnosis", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
  var payload,
      _ref73,
      rejectWithValue,
      input_text,
      enId,
      data,
      arr,
      _args36 = arguments;

  return _regeneratorRuntime().wrap(function _callee36$(_context36) {
    while (1) {
      switch (_context36.prev = _context36.next) {
        case 0:
          payload = _args36.length > 0 && _args36[0] !== undefined ? _args36[0] : {};
          _ref73 = _args36.length > 1 ? _args36[1] : undefined, rejectWithValue = _ref73.rejectWithValue;
          _context36.prev = 2;
          input_text = payload.input_text, enId = payload.enId;
          _context36.next = 6;
          return fetchData({
            body: JSON.stringify(diagnosisMaster.Diagnosis(input_text, enId))
          }, __readDocumentUrl__);

        case 6:
          data = _context36.sent;
          arr = [];
          data.result.map(function (val) {
            var _val$icdname;

            arr.push({
              value: val === null || val === void 0 ? void 0 : val._id,
              label: (_val$icdname = val === null || val === void 0 ? void 0 : val.icdname) !== null && _val$icdname !== void 0 ? _val$icdname : ""
            });
          });
          return _context36.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context36.prev = 12;
          _context36.t0 = _context36["catch"](2);
          return _context36.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context36.t0.message
          })));

        case 15:
        case "end":
          return _context36.stop();
      }
    }
  }, _callee36, null, [[2, 12]]);
})));
var SAVE_MEDICATIONS = toolkit.createAsyncThunk("MedicationMastersSlice/save_medication", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
  var payload,
      _ref75,
      rejectWithValue,
      _data$Result,
      _data$Result$,
      _data$Result$$propert,
      _data$Result$$propert2,
      _list,
      loggedUserInfo,
      body,
      data,
      _args37 = arguments;

  return _regeneratorRuntime().wrap(function _callee37$(_context37) {
    while (1) {
      switch (_context37.prev = _context37.next) {
        case 0:
          payload = _args37.length > 0 && _args37[0] !== undefined ? _args37[0] : {};
          _ref75 = _args37.length > 1 ? _args37[1] : undefined, rejectWithValue = _ref75.rejectWithValue;
          _context37.prev = 2;
          _list = payload; // let state = getState();
          // let loggedUserInfo = state?.signInReducerApiSlice?.loggedUserInfo?.data;

          loggedUserInfo = jsonwebtoken__default["default"].decode(localStorage.getItem("userInfo"));
          body = _list.isAdd ? generateJSONSingle(_list, loggedUserInfo) : generateJSON$3(_list, loggedUserInfo);
          _context37.next = 8;
          return fetchData({
            body: JSON.stringify(body)
          }, _list.isAdd ? // __OrderlinewithQueue__
          __uspsertUrl__ : __uspsertUrl__);

        case 8:
          data = _context37.sent;
          return _context37.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: _list.isAdd ? !(data !== null && data !== void 0 && data.error) : data === null || data === void 0 ? void 0 : (_data$Result = data.Result) === null || _data$Result === void 0 ? void 0 : (_data$Result$ = _data$Result[0]) === null || _data$Result$ === void 0 ? void 0 : (_data$Result$$propert = _data$Result$.properties) === null || _data$Result$$propert === void 0 ? void 0 : (_data$Result$$propert2 = _data$Result$$propert.doc) === null || _data$Result$$propert2 === void 0 ? void 0 : _data$Result$$propert2._id
          }));

        case 12:
          _context37.prev = 12;
          _context37.t0 = _context37["catch"](2);
          console.log(_context37.t0);
          return _context37.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context37.t0.message
          })));

        case 16:
        case "end":
          return _context37.stop();
      }
    }
  }, _callee37, null, [[2, 12]]);
})));
var BULK_SAVE_MEDICATIONS = toolkit.createAsyncThunk("MedicationMastersSlice/bulk_save_medication", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
  var payload,
      _ref77,
      rejectWithValue,
      _data$Result2,
      _data$Result2$,
      _data$Result2$$proper,
      _data$Result2$$proper2,
      _key,
      drugCode,
      dataJson,
      data,
      _args38 = arguments;

  return _regeneratorRuntime().wrap(function _callee38$(_context38) {
    while (1) {
      switch (_context38.prev = _context38.next) {
        case 0:
          payload = _args38.length > 0 && _args38[0] !== undefined ? _args38[0] : {};
          _ref77 = _args38.length > 1 ? _args38[1] : undefined, rejectWithValue = _ref77.rejectWithValue, _ref77.getState;
          _context38.prev = 2;
          _key = payload._key, drugCode = payload.drugCode;
          dataJson = [{
            "db_name": dbName,
            "entity": "PH_OrderLine",
            "is_metadata": true,
            "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
            "filter": {
              "_key": _key !== null && _key !== void 0 ? _key : ''
            },
            "doc": {
              "status": "CodingMaster/10704",
              "drugCode": drugCode !== null && drugCode !== void 0 ? drugCode : ''
            }
          }];
          _context38.next = 7;
          return fetchData({
            body: JSON.stringify(dataJson)
          }, __OrderlinewithQueue__);

        case 7:
          data = _context38.sent;
          return _context38.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: list.isAdd ? !(data !== null && data !== void 0 && data.error) : data === null || data === void 0 ? void 0 : (_data$Result2 = data.Result) === null || _data$Result2 === void 0 ? void 0 : (_data$Result2$ = _data$Result2[0]) === null || _data$Result2$ === void 0 ? void 0 : (_data$Result2$$proper = _data$Result2$.properties) === null || _data$Result2$$proper === void 0 ? void 0 : (_data$Result2$$proper2 = _data$Result2$$proper.doc) === null || _data$Result2$$proper2 === void 0 ? void 0 : _data$Result2$$proper2._id
          }));

        case 11:
          _context38.prev = 11;
          _context38.t0 = _context38["catch"](2);
          console.log(_context38.t0);
          return _context38.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context38.t0.message
          })));

        case 15:
        case "end":
          return _context38.stop();
      }
    }
  }, _callee38, null, [[2, 11]]);
})));
var DELETE_NEW_ORDER_PENDING_STATUS = toolkit.createAsyncThunk("MedicationMastersSlice/medication_order_delete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
  var payload,
      _ref79,
      rejectWithValue,
      id,
      data,
      _args39 = arguments;

  return _regeneratorRuntime().wrap(function _callee39$(_context39) {
    while (1) {
      switch (_context39.prev = _context39.next) {
        case 0:
          payload = _args39.length > 0 && _args39[0] !== undefined ? _args39[0] : {};
          _ref79 = _args39.length > 1 ? _args39[1] : undefined, rejectWithValue = _ref79.rejectWithValue;
          _context39.prev = 2;
          id = payload.id;
          _context39.next = 6;
          return fetchData({
            body: queries$n.deleteMedicationPendingOrders(id)
          }, __baseUrl__);

        case 6:
          data = _context39.sent;
          return _context39.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data === null || data === void 0 ? void 0 : data.result
          }));

        case 10:
          _context39.prev = 10;
          _context39.t0 = _context39["catch"](2);
          return _context39.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context39.t0.message
          })));

        case 13:
        case "end":
          return _context39.stop();
      }
    }
  }, _callee39, null, [[2, 10]]);
})));
var SAVE_NEW_ORDER_PENDING_STATUS = toolkit.createAsyncThunk("MedicationMastersSlice/medication_order_delete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
  var payload,
      _ref81,
      rejectWithValue,
      ids,
      data,
      _args40 = arguments;

  return _regeneratorRuntime().wrap(function _callee40$(_context40) {
    while (1) {
      switch (_context40.prev = _context40.next) {
        case 0:
          payload = _args40.length > 0 && _args40[0] !== undefined ? _args40[0] : {};
          _ref81 = _args40.length > 1 ? _args40[1] : undefined, rejectWithValue = _ref81.rejectWithValue;
          _context40.prev = 2;
          ids = payload.ids;
          _context40.next = 6;
          return fetchData({
            body: JSON.stringify(queries$n.saveMedicationPendingOrders(ids))
          }, __baseUrl__);

        case 6:
          data = _context40.sent;
          return _context40.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data === null || data === void 0 ? void 0 : data.result
          }));

        case 10:
          _context40.prev = 10;
          _context40.t0 = _context40["catch"](2);
          return _context40.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context40.t0.message
          })));

        case 13:
        case "end":
          return _context40.stop();
      }
    }
  }, _callee40, null, [[2, 10]]);
})));
var READ_PENDING_MEDICATIONS = toolkit.createAsyncThunk("MedicationMastersSlice/read_pending_medication", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
  var payload,
      _ref83,
      rejectWithValue,
      pId,
      data,
      _args41 = arguments;

  return _regeneratorRuntime().wrap(function _callee41$(_context41) {
    while (1) {
      switch (_context41.prev = _context41.next) {
        case 0:
          payload = _args41.length > 0 && _args41[0] !== undefined ? _args41[0] : {};
          _ref83 = _args41.length > 1 ? _args41[1] : undefined, rejectWithValue = _ref83.rejectWithValue;
          _context41.prev = 2;
          pId = payload.pId;
          _context41.next = 6;
          return fetchData({
            body: queries$n.readMedicationPendingOrders(pId)
          }, __readDocumentUrl__);

        case 6:
          data = _context41.sent;
          return _context41.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data === null || data === void 0 ? void 0 : data.result
          }));

        case 10:
          _context41.prev = 10;
          _context41.t0 = _context41["catch"](2);
          return _context41.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context41.t0.message
          })));

        case 13:
        case "end":
          return _context41.stop();
      }
    }
  }, _callee41, null, [[2, 10]]);
})));
var GET_MEDICATIONS = toolkit.createAsyncThunk("MedicationMastersSlice/medication_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
  var payload,
      _ref85,
      rejectWithValue,
      id,
      data,
      _args42 = arguments;

  return _regeneratorRuntime().wrap(function _callee42$(_context42) {
    while (1) {
      switch (_context42.prev = _context42.next) {
        case 0:
          payload = _args42.length > 0 && _args42[0] !== undefined ? _args42[0] : {};
          _ref85 = _args42.length > 1 ? _args42[1] : undefined, rejectWithValue = _ref85.rejectWithValue;
          _context42.prev = 2;
          id = payload.id;
          _context42.next = 6;
          return fetchData({
            body: queries$n.getMedications(id)
          }, __readDocumentUrl__);

        case 6:
          data = _context42.sent;
          return _context42.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data === null || data === void 0 ? void 0 : data.result
          }));

        case 10:
          _context42.prev = 10;
          _context42.t0 = _context42["catch"](2);
          return _context42.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context42.t0.message
          })));

        case 13:
        case "end":
          return _context42.stop();
      }
    }
  }, _callee42, null, [[2, 10]]);
})));
var GET_ORDER_DEFAULT = toolkit.createAsyncThunk("MedicationMastersSlice/get_order_default", /*#__PURE__*/function () {
  var _ref88 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43(_ref86, _ref87) {
    var encounterId, drugMasterId, rejectWithValue, data;
    return _regeneratorRuntime().wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            encounterId = _ref86.encounterId, drugMasterId = _ref86.drugMasterId;
            rejectWithValue = _ref87.rejectWithValue;
            _context43.prev = 2;
            _context43.next = 5;
            return fetchData({
              body: JSON.stringify({
                Encounter_id: encounterId,
                //"Encounter/11143"
                DrugId: drugMasterId //"DrugMaster/143241935"

              })
            }, __orderDefault__);

          case 5:
            data = _context43.sent;
            return _context43.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: data
            }));

          case 9:
            _context43.prev = 9;
            _context43.t0 = _context43["catch"](2);
            return _context43.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context43.t0.message
            })));

          case 12:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43, null, [[2, 9]]);
  }));

  return function (_x3, _x4) {
    return _ref88.apply(this, arguments);
  };
}());
var GET_ALERT_CODES = toolkit.createAsyncThunk("MedicationMastersSlice/get_alert_codes", /*#__PURE__*/function () {
  var _ref91 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44(_ref89, _ref90) {
    var patientId, rejectWithValue, _data$, _data$$SavedDrugCodes, _data$$SavedDrugCodes2, _data$2, _data$2$SavedAllergyC, _data$2$SavedAllergyC2, _data$3, data, profileDrugCode, allergyCode, object;

    return _regeneratorRuntime().wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            patientId = _ref89.patientId;
            rejectWithValue = _ref90.rejectWithValue;
            _context44.prev = 2;
            _context44.next = 5;
            return fetchData({
              body: JSON.stringify(queries$n.getAlertCode(patientId))
            }, __baseUrl__);

          case 5:
            data = _context44.sent;
            //converting profile code to number then removing the NaN
            profileDrugCode = data === null || data === void 0 ? void 0 : (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : (_data$$SavedDrugCodes = _data$.SavedDrugCodes) === null || _data$$SavedDrugCodes === void 0 ? void 0 : (_data$$SavedDrugCodes2 = _data$$SavedDrugCodes.map(function (val) {
              return parseInt(val);
            })) === null || _data$$SavedDrugCodes2 === void 0 ? void 0 : _data$$SavedDrugCodes2.filter(function (val) {
              return !Number.isNaN(val);
            }); //converting allergy code to number then removing the NaN

            allergyCode = data === null || data === void 0 ? void 0 : (_data$2 = data[0]) === null || _data$2 === void 0 ? void 0 : (_data$2$SavedAllergyC = _data$2.SavedAllergyCodes) === null || _data$2$SavedAllergyC === void 0 ? void 0 : (_data$2$SavedAllergyC2 = _data$2$SavedAllergyC.map(function (val) {
              return parseInt(val);
            })) === null || _data$2$SavedAllergyC2 === void 0 ? void 0 : _data$2$SavedAllergyC2.filter(function (val) {
              return !Number.isNaN(val);
            });
            object = {
              ProfileDrugCodes: _toConsumableArray(new Set(profileDrugCode)),
              //removing duplicate values
              DiseaseCodes: _toConsumableArray(data === null || data === void 0 ? void 0 : (_data$3 = data[0]) === null || _data$3 === void 0 ? void 0 : _data$3.SavedDiseaseCodes),
              AllergyCodes: _toConsumableArray(new Set(allergyCode)) //removing duplicate values

            };
            return _context44.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: object
            }));

          case 12:
            _context44.prev = 12;
            _context44.t0 = _context44["catch"](2);
            return _context44.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context44.t0.message
            })));

          case 15:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44, null, [[2, 12]]);
  }));

  return function (_x5, _x6) {
    return _ref91.apply(this, arguments);
  };
}());
var GET_ALLERGY_INTERACTION = toolkit.createAsyncThunk("MedicationMastersSlice/get_allergy_interaction", /*#__PURE__*/function () {
  var _ref94 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45(_ref92, _ref93) {
    var payload, rejectWithValue, getState, _state$MedicationMast, _state$MedicationMast2, state, data, arr, _state$MedicationMast3;

    return _regeneratorRuntime().wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            payload = _ref92.payload;
            rejectWithValue = _ref93.rejectWithValue, getState = _ref93.getState;
            _context45.prev = 2;
            state = getState();
            _context45.next = 6;
            return fetchData({
              body: JSON.stringify(payload)
            }, __allergyInteraction__);

          case 6:
            data = _context45.sent;
            arr = [];
            arr = data === null || data === void 0 ? void 0 : data.result;

            if ((state === null || state === void 0 ? void 0 : (_state$MedicationMast = state.MedicationMastersSlice) === null || _state$MedicationMast === void 0 ? void 0 : (_state$MedicationMast2 = _state$MedicationMast.drug_duplication_read.data) === null || _state$MedicationMast2 === void 0 ? void 0 : _state$MedicationMast2.length) > 0) {
              arr.push({
                "Drug-Duplication-Alert": state === null || state === void 0 ? void 0 : (_state$MedicationMast3 = state.MedicationMastersSlice) === null || _state$MedicationMast3 === void 0 ? void 0 : _state$MedicationMast3.drug_duplication_read.data
              });
            }

            return _context45.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: arr
            }));

          case 13:
            _context45.prev = 13;
            _context45.t0 = _context45["catch"](2);
            return _context45.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context45.t0.message
            })));

          case 16:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45, null, [[2, 13]]);
  }));

  return function (_x7, _x8) {
    return _ref94.apply(this, arguments);
  };
}());
var ALERTLOGS_SINGLE_READ = toolkit.createAsyncThunk("pharmacyFrameworkApiSlice/alertlogs_single_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
  var payload,
      _ref96,
      rejectWithValue,
      _data$result,
      key,
      data,
      obj,
      Aerts,
      _args46 = arguments;

  return _regeneratorRuntime().wrap(function _callee46$(_context46) {
    while (1) {
      switch (_context46.prev = _context46.next) {
        case 0:
          payload = _args46.length > 0 && _args46[0] !== undefined ? _args46[0] : {};
          _ref96 = _args46.length > 1 ? _args46[1] : undefined, rejectWithValue = _ref96.rejectWithValue;
          _context46.prev = 2;
          key = payload.key;
          _context46.next = 6;
          return fetchData({
            body: JSON.stringify(queries$n === null || queries$n === void 0 ? void 0 : queries$n.read_status_logs(key))
          }, __readDocumentUrl__);

        case 6:
          data = _context46.sent;
          obj = {};
          data === null || data === void 0 ? void 0 : (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.forEach(function (val) {
            var _val$overridedetails;

            var ID = val === null || val === void 0 ? void 0 : val.reactiontypecode;
            var alert = {
              IAMTEXTN: val === null || val === void 0 ? void 0 : val.alertmessage,
              Message: val === null || val === void 0 ? void 0 : val.alerttitle,
              orderLineId: val === null || val === void 0 ? void 0 : val.orderlineid,
              overridedetails: val === null || val === void 0 ? void 0 : val.overridedetails,
              alertType: val === null || val === void 0 ? void 0 : val.reactiontypecode,
              messageRead: (val === null || val === void 0 ? void 0 : (_val$overridedetails = val.overridedetails) === null || _val$overridedetails === void 0 ? void 0 : _val$overridedetails.length) > 0 ? true : false,
              _id: val === null || val === void 0 ? void 0 : val._id,
              _key: val === null || val === void 0 ? void 0 : val._key
            };

            if (ID in obj) {
              obj[ID][ID].push(alert);
            } else {
              obj[val === null || val === void 0 ? void 0 : val.reactiontypecode] = _defineProperty({}, val === null || val === void 0 ? void 0 : val.reactiontypecode, [alert]);
            }
          });
          Aerts = Object.values(obj);
          return _context46.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: Aerts
          }));

        case 13:
          _context46.prev = 13;
          _context46.t0 = _context46["catch"](2);
          return _context46.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context46.t0.message
          })));

        case 16:
        case "end":
          return _context46.stop();
      }
    }
  }, _callee46, null, [[2, 13]]);
})));
var GET_DRUG_DUPLICATION = toolkit.createAsyncThunk("MedicationMastersSlice/get_drug_duplication", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
  var payload,
      _ref98,
      rejectWithValue,
      _list2,
      data,
      _args47 = arguments;

  return _regeneratorRuntime().wrap(function _callee47$(_context47) {
    while (1) {
      switch (_context47.prev = _context47.next) {
        case 0:
          payload = _args47.length > 0 && _args47[0] !== undefined ? _args47[0] : {};
          _ref98 = _args47.length > 1 ? _args47[1] : undefined, rejectWithValue = _ref98.rejectWithValue;
          _context47.prev = 2;
          _list2 = payload.list;
          _context47.next = 6;
          return fetchData({
            body: JSON.stringify(_list2)
          }, __drugDuplication__);

        case 6:
          data = _context47.sent;
          return _context47.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data === null || data === void 0 ? void 0 : data.result
          }));

        case 10:
          _context47.prev = 10;
          _context47.t0 = _context47["catch"](2);
          return _context47.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context47.t0.message
          })));

        case 13:
        case "end":
          return _context47.stop();
      }
    }
  }, _callee47, null, [[2, 10]]);
})));
var MedicationMastersSlice = toolkit.createSlice({
  name: "MedicationMastersSlice",
  initialState: {
    save_medication: _objectSpread2({}, defaultState.List),
    get_allergy_interaction: _objectSpread2({}, defaultState.List),
    get_alert_codes: _objectSpread2({}, defaultState.Info),
    allergy_upsert: _objectSpread2({}, defaultState.List),
    diagnosis: _objectSpread2({}, defaultState.List),
    laborder_pract_role: _objectSpread2({}, defaultState.List),
    single_read_edit_info: _objectSpread2({}, defaultState.List),
    drugType_masters: _objectSpread2({}, defaultState.List),
    drugMaster_masters: _objectSpread2({}, defaultState.List),
    strength_masters: _objectSpread2({}, defaultState.List),
    strengthUom_masters: _objectSpread2({}, defaultState.List),
    strengthVolumn_masters: _objectSpread2({}, defaultState.List),
    strengthVolumnUom_masters: _objectSpread2({}, defaultState.List),
    DosageTypeIndicator_masters: _objectSpread2({}, defaultState.List),
    DosageUOM_masters: _objectSpread2({}, defaultState.List),
    DosageVolumeUom_masters: _objectSpread2({}, defaultState.List),
    DrugRoutes_masters: _objectSpread2({}, defaultState.List),
    DosageForm_masters: _objectSpread2({}, defaultState.List),
    FrequencyMaster_masters: _objectSpread2({}, defaultState.List),
    DurationType_masters: _objectSpread2({}, defaultState.List),
    Priority_masters: _objectSpread2({}, defaultState.List),
    DrugCategory_masters: _objectSpread2({}, defaultState.List),
    OrderNature_masters: _objectSpread2({}, defaultState.List),
    OrderMode_masters: _objectSpread2({}, defaultState.List),
    DrugStoreDispLoc_masters: _objectSpread2({}, defaultState.List),
    DiagnosisAgainstEncounter_masters: _objectSpread2({}, defaultState.List),
    Reasoncode_masters: _objectSpread2({}, defaultState.List),
    Organization_masters: _objectSpread2({}, defaultState.List),
    Patient_Instruction: _objectSpread2({}, defaultState.List),
    PractitionerRole_masters: _objectSpread2({}, defaultState.List),
    Practitioner_masters: _objectSpread2({}, defaultState.List),
    InfusionRateUoM_masters: _objectSpread2({}, defaultState.List),
    TotalVolumeUoM_masters: _objectSpread2({}, defaultState.List),
    Indication_Reason_Code_masters: _objectSpread2({}, defaultState.List),
    BaseSchedule_masters: _objectSpread2({}, defaultState.List),
    DeleteMedication_masters: _objectSpread2({}, defaultState.List),
    status_masters: _objectSpread2({}, defaultState.List),
    workflow_status_masters: _objectSpread2({}, defaultState.List),
    medication_list: _objectSpread2({}, defaultState.List),
    order_prescription_list: _objectSpread2({}, defaultState.List),
    order_type_req_details: _objectSpread2({}, defaultState.List),
    getOrderDefault: _objectSpread2({}, defaultState.List),
    order_pending_delete: _objectSpread2({}, defaultState.List),
    order_pending_save: _objectSpread2({}, defaultState.List),
    order_pending_read: _objectSpread2({}, defaultState.List),
    drug_duplication_read: _objectSpread2({}, defaultState.List),
    bulk_drug_duplication_read: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$H = {}, _defineProperty(_extraReducers$H, BULK_SAVE_MEDICATIONS.fulfilled, function (state, action) {
    var _action$payload;

    state.bulk_drug_duplication_read = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : [];
  }), _defineProperty(_extraReducers$H, BULK_SAVE_MEDICATIONS.pending, function (state, action) {
    state.bulk_drug_duplication_read.loading = true;
  }), _defineProperty(_extraReducers$H, BULK_SAVE_MEDICATIONS.rejected, function (state, action) {
    var _action$payload2;

    state.bulk_drug_duplication_read = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : [];
  }), _defineProperty(_extraReducers$H, GET_DRUG_DUPLICATION.fulfilled, function (state, action) {
    var _action$payload3;

    state.drug_duplication_read = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : [];
  }), _defineProperty(_extraReducers$H, GET_DRUG_DUPLICATION.pending, function (state, action) {
    state.drug_duplication_read.loading = true;
  }), _defineProperty(_extraReducers$H, GET_DRUG_DUPLICATION.rejected, function (state, action) {
    var _action$payload4;

    state.drug_duplication_read = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : [];
  }), _defineProperty(_extraReducers$H, READ_PENDING_MEDICATIONS.fulfilled, function (state, action) {
    var _action$payload5;

    state.order_pending_read = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : [];
  }), _defineProperty(_extraReducers$H, READ_PENDING_MEDICATIONS.pending, function (state, action) {
    state.order_pending_read.loading = true;
  }), _defineProperty(_extraReducers$H, READ_PENDING_MEDICATIONS.rejected, function (state, action) {
    var _action$payload6;

    state.order_pending_read = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : [];
  }), _defineProperty(_extraReducers$H, SAVE_NEW_ORDER_PENDING_STATUS.fulfilled, function (state, action) {
    var _action$payload7;

    state.order_pending_save = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : [];
  }), _defineProperty(_extraReducers$H, SAVE_NEW_ORDER_PENDING_STATUS.pending, function (state, action) {
    state.order_pending_save.loading = true;
  }), _defineProperty(_extraReducers$H, SAVE_NEW_ORDER_PENDING_STATUS.rejected, function (state, action) {
    var _action$payload8;

    state.order_pending_save = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : [];
  }), _defineProperty(_extraReducers$H, DELETE_NEW_ORDER_PENDING_STATUS.fulfilled, function (state, action) {
    var _action$payload9;

    state.order_pending_delete = (_action$payload9 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload9 !== void 0 ? _action$payload9 : [];
  }), _defineProperty(_extraReducers$H, DELETE_NEW_ORDER_PENDING_STATUS.pending, function (state, action) {
    state.order_pending_delete.loading = true;
  }), _defineProperty(_extraReducers$H, DELETE_NEW_ORDER_PENDING_STATUS.rejected, function (state, action) {
    var _action$payload10;

    state.order_pending_delete = (_action$payload10 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload10 !== void 0 ? _action$payload10 : [];
  }), _defineProperty(_extraReducers$H, ORDER_TYPE_REQ_DETAILS_LAB.fulfilled, function (state, action) {
    var _action$payload11;

    state.order_type_req_details = (_action$payload11 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload11 !== void 0 ? _action$payload11 : [];
  }), _defineProperty(_extraReducers$H, ORDER_TYPE_REQ_DETAILS_LAB.pending, function (state, action) {
    state.order_type_req_details.loading = true;
  }), _defineProperty(_extraReducers$H, ORDER_TYPE_REQ_DETAILS_LAB.rejected, function (state, action) {
    var _action$payload12;

    state.order_type_req_details = (_action$payload12 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload12 !== void 0 ? _action$payload12 : [];
  }), _defineProperty(_extraReducers$H, GET_ALERT_CODES.fulfilled, function (state, action) {
    var _action$payload13;

    state.get_alert_codes = (_action$payload13 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload13 !== void 0 ? _action$payload13 : {};
  }), _defineProperty(_extraReducers$H, GET_ALERT_CODES.pending, function (state, action) {
    state.get_alert_codes.loading = true;
  }), _defineProperty(_extraReducers$H, GET_ALERT_CODES.rejected, function (state, action) {
    var _action$payload14;

    state.get_alert_codes = (_action$payload14 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload14 !== void 0 ? _action$payload14 : {};
  }), _defineProperty(_extraReducers$H, GET_ALLERGY_INTERACTION.fulfilled, function (state, action) {
    var _action$payload15;

    state.get_allergy_interaction = (_action$payload15 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload15 !== void 0 ? _action$payload15 : [];
  }), _defineProperty(_extraReducers$H, GET_ALLERGY_INTERACTION.pending, function (state, action) {
    state.get_allergy_interaction.loading = true;
  }), _defineProperty(_extraReducers$H, GET_ALLERGY_INTERACTION.rejected, function (state, action) {
    var _action$payload16;

    state.get_allergy_interaction = (_action$payload16 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload16 !== void 0 ? _action$payload16 : [];
  }), _defineProperty(_extraReducers$H, ALERTLOGS_SINGLE_READ.fulfilled, function (state, action) {
    var _action$payload17;

    state.get_allergy_interaction = (_action$payload17 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload17 !== void 0 ? _action$payload17 : [];
  }), _defineProperty(_extraReducers$H, ALERTLOGS_SINGLE_READ.pending, function (state, action) {
    state.get_allergy_interaction.loading = true;
  }), _defineProperty(_extraReducers$H, ALERTLOGS_SINGLE_READ.rejected, function (state, action) {
    var _action$payload18;

    state.get_allergy_interaction = (_action$payload18 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload18 !== void 0 ? _action$payload18 : [];
  }), _defineProperty(_extraReducers$H, ORDER_PRESCRIPTION_MASTER.fulfilled, function (state, action) {
    var _action$payload19;

    state.order_prescription_list.loading = false, state.order_prescription_list.error = false, state.order_prescription_list = (_action$payload19 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload19 !== void 0 ? _action$payload19 : {};
  }), _defineProperty(_extraReducers$H, ORDER_PRESCRIPTION_MASTER.pending, function (state, action) {
    state.order_prescription_list.error = false, state.order_prescription_list.loading = true;
  }), _defineProperty(_extraReducers$H, ORDER_PRESCRIPTION_MASTER.rejected, function (state, action) {
    var _action$payload20;

    state.order_prescription_list.loading = false, state.order_prescription_list.error = true, state.order_prescription_list = (_action$payload20 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload20 !== void 0 ? _action$payload20 : {};
  }), _defineProperty(_extraReducers$H, GET_MEDICATIONS.fulfilled, function (state, action) {
    var _action$payload21;

    state.medication_list.loading = false, state.medication_list.error = false, state.medication_list = (_action$payload21 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload21 !== void 0 ? _action$payload21 : {};
  }), _defineProperty(_extraReducers$H, GET_MEDICATIONS.pending, function (state, action) {
    state.medication_list.error = false, state.medication_list.loading = true;
  }), _defineProperty(_extraReducers$H, GET_MEDICATIONS.rejected, function (state, action) {
    var _action$payload22;

    state.medication_list.loading = false, state.medication_list.error = true, state.medication_list = (_action$payload22 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload22 !== void 0 ? _action$payload22 : {};
  }), _defineProperty(_extraReducers$H, SAVE_MEDICATIONS.fulfilled, function (state, action) {
    var _action$payload23;

    state.save_medication.loading = false, state.save_medication.error = false, state.save_medication = (_action$payload23 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload23 !== void 0 ? _action$payload23 : {};
  }), _defineProperty(_extraReducers$H, SAVE_MEDICATIONS.pending, function (state, action) {
    state.save_medication.error = false, state.save_medication.loading = true;
  }), _defineProperty(_extraReducers$H, SAVE_MEDICATIONS.rejected, function (state, action) {
    var _action$payload24;

    state.save_medication.loading = false, state.save_medication.error = true, state.save_medication = (_action$payload24 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload24 !== void 0 ? _action$payload24 : {};
  }), _defineProperty(_extraReducers$H, DIAGNOSIS_MASTERS$1.fulfilled, function (state, action) {
    var _action$payload25;

    state.diagnosis.loading = false, state.diagnosis.error = false, state.diagnosis = (_action$payload25 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload25 !== void 0 ? _action$payload25 : {};
  }), _defineProperty(_extraReducers$H, DIAGNOSIS_MASTERS$1.pending, function (state, action) {
    state.diagnosis.error = false, state.diagnosis.loading = true;
  }), _defineProperty(_extraReducers$H, DIAGNOSIS_MASTERS$1.rejected, function (state, action) {
    var _action$payload26;

    state.diagnosis.loading = false, state.diagnosis.error = true, state.diagnosis = (_action$payload26 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload26 !== void 0 ? _action$payload26 : {};
  }), _defineProperty(_extraReducers$H, ORDER_TYPE_REQ_DETAILS_ROLE.fulfilled, function (state, action) {
    var _action$payload27;

    state.laborder_pract_role.loading = false, state.laborder_pract_role.error = false, state.laborder_pract_role = (_action$payload27 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload27 !== void 0 ? _action$payload27 : {};
  }), _defineProperty(_extraReducers$H, ORDER_TYPE_REQ_DETAILS_ROLE.pending, function (state, action) {
    state.laborder_pract_role.error = false, state.laborder_pract_role.loading = true;
  }), _defineProperty(_extraReducers$H, ORDER_TYPE_REQ_DETAILS_ROLE.rejected, function (state, action) {
    var _action$payload28;

    state.laborder_pract_role.loading = false, state.laborder_pract_role.error = true, state.laborder_pract_role = (_action$payload28 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload28 !== void 0 ? _action$payload28 : {};
  }), _defineProperty(_extraReducers$H, SINGLE_READ_EDIT_INFO.fulfilled, function (state, action) {
    var _action$payload29;

    state.single_read_edit_info.loading = false, state.single_read_edit_info.error = false, state.single_read_edit_info = (_action$payload29 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload29 !== void 0 ? _action$payload29 : {};
  }), _defineProperty(_extraReducers$H, SINGLE_READ_EDIT_INFO.pending, function (state, action) {
    state.single_read_edit_info.error = false, state.single_read_edit_info.loading = true;
  }), _defineProperty(_extraReducers$H, SINGLE_READ_EDIT_INFO.rejected, function (state, action) {
    var _action$payload30;

    state.single_read_edit_info.loading = false, state.single_read_edit_info.error = true, state.single_read_edit_info = (_action$payload30 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload30 !== void 0 ? _action$payload30 : {};
  }), _defineProperty(_extraReducers$H, DRUGTYPE_MASTER.fulfilled, function (state, action) {
    var _action$payload31;

    state.drugType_masters.loading = false, state.drugType_masters.error = false, state.drugType_masters = (_action$payload31 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload31 !== void 0 ? _action$payload31 : {};
  }), _defineProperty(_extraReducers$H, DRUGTYPE_MASTER.pending, function (state, action) {
    state.drugType_masters.error = false, state.drugType_masters.loading = true;
  }), _defineProperty(_extraReducers$H, DRUGTYPE_MASTER.rejected, function (state, action) {
    var _action$payload32;

    state.drugType_masters.loading = false, state.drugType_masters.error = true, state.drugType_masters = (_action$payload32 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload32 !== void 0 ? _action$payload32 : {};
  }), _defineProperty(_extraReducers$H, DRUGMASTER_MASTER.fulfilled, function (state, action) {
    var _action$payload33;

    state.drugMaster_masters.loading = false, state.drugMaster_masters.error = false, state.drugMaster_masters = (_action$payload33 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload33 !== void 0 ? _action$payload33 : {};
  }), _defineProperty(_extraReducers$H, DRUGMASTER_MASTER.pending, function (state, action) {
    state.drugMaster_masters.loading = true, state.drugMaster_masters.error = false, state.drugMaster_masters.loading = true;
  }), _defineProperty(_extraReducers$H, DRUGMASTER_MASTER.rejected, function (state, action) {
    var _action$payload34;

    state.drugMaster_masters.loading = false, state.drugMaster_masters.error = true, state.drugMaster_masters = (_action$payload34 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload34 !== void 0 ? _action$payload34 : {};
  }), _defineProperty(_extraReducers$H, STRENGTH_MASTER.fulfilled, function (state, action) {
    var _action$payload35;

    state.strength_masters.loading = false, state.strength_masters.error = false, state.strength_masters = (_action$payload35 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload35 !== void 0 ? _action$payload35 : {};
  }), _defineProperty(_extraReducers$H, STRENGTH_MASTER.pending, function (state, action) {
    state.strength_masters.loading = true, state.strength_masters.error = false, state.strength_masters.loading = true;
  }), _defineProperty(_extraReducers$H, STRENGTH_MASTER.rejected, function (state, action) {
    var _action$payload36;

    state.strength_masters.loading = false, state.strength_masters.error = true, state.strength_masters = (_action$payload36 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload36 !== void 0 ? _action$payload36 : {};
  }), _defineProperty(_extraReducers$H, STRENGTHUOM_MASTER.fulfilled, function (state, action) {
    var _action$payload37;

    state.strengthUom_masters.loading = false, state.strengthUom_masters.error = false, state.strengthUom_masters = (_action$payload37 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload37 !== void 0 ? _action$payload37 : {};
  }), _defineProperty(_extraReducers$H, STRENGTHUOM_MASTER.pending, function (state, action) {
    state.strengthUom_masters.loading = true, state.strengthUom_masters.error = false, state.strengthUom_masters.loading = true;
  }), _defineProperty(_extraReducers$H, STRENGTHUOM_MASTER.rejected, function (state, action) {
    var _action$payload38;

    state.strengthUom_masters.loading = false, state.strengthUom_masters.error = true, state.strengthUom_masters = (_action$payload38 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload38 !== void 0 ? _action$payload38 : {};
  }), _defineProperty(_extraReducers$H, STRENGTHVOLUMN_MASTER.fulfilled, function (state, action) {
    var _action$payload39;

    state.strengthVolumn_masters.loading = false, state.strengthVolumn_masters.error = false, state.strengthVolumn_masters = (_action$payload39 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload39 !== void 0 ? _action$payload39 : {};
  }), _defineProperty(_extraReducers$H, STRENGTHVOLUMN_MASTER.pending, function (state, action) {
    state.strengthVolumn_masters.loading = true, state.strengthVolumn_masters.error = false, state.strengthVolumn_masters.loading = true;
  }), _defineProperty(_extraReducers$H, STRENGTHVOLUMN_MASTER.rejected, function (state, action) {
    var _action$payload40;

    state.strengthVolumn_masters.loading = false, state.strengthVolumn_masters.error = true, state.strengthVolumn_masters = (_action$payload40 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload40 !== void 0 ? _action$payload40 : {};
  }), _defineProperty(_extraReducers$H, STRENGTHVOLUMNUOM_MASTER.fulfilled, function (state, action) {
    var _action$payload41;

    state.strengthVolumnUom_masters.loading = false, state.strengthVolumnUom_masters.error = false, state.strengthVolumnUom_masters = (_action$payload41 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload41 !== void 0 ? _action$payload41 : {};
  }), _defineProperty(_extraReducers$H, STRENGTHVOLUMNUOM_MASTER.pending, function (state, action) {
    state.strengthVolumnUom_masters.loading = true, state.strengthVolumnUom_masters.error = false, state.strengthVolumnUom_masters.loading = true;
  }), _defineProperty(_extraReducers$H, STRENGTHVOLUMNUOM_MASTER.rejected, function (state, action) {
    var _action$payload42;

    state.strengthVolumnUom_masters.loading = false, state.strengthVolumnUom_masters.error = true, state.strengthVolumnUom_masters = (_action$payload42 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload42 !== void 0 ? _action$payload42 : {};
  }), _defineProperty(_extraReducers$H, DOSAGETYPEINDICATOR_MASTER.fulfilled, function (state, action) {
    var _action$payload43;

    state.DosageTypeIndicator_masters.loading = false, state.DosageTypeIndicator_masters.error = false, state.DosageTypeIndicator_masters = (_action$payload43 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload43 !== void 0 ? _action$payload43 : {};
  }), _defineProperty(_extraReducers$H, DOSAGETYPEINDICATOR_MASTER.pending, function (state, action) {
    state.DosageTypeIndicator_masters.loading = true, state.DosageTypeIndicator_masters.error = false, state.DosageTypeIndicator_masters.loading = true;
  }), _defineProperty(_extraReducers$H, DOSAGETYPEINDICATOR_MASTER.rejected, function (state, action) {
    var _action$payload44;

    state.DosageTypeIndicator_masters.loading = false, state.DosageTypeIndicator_masters.error = true, state.DosageTypeIndicator_masters = (_action$payload44 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload44 !== void 0 ? _action$payload44 : {};
  }), _defineProperty(_extraReducers$H, DOSAGEUOM_MASTER.fulfilled, function (state, action) {
    var _action$payload45;

    state.DosageUOM_masters.loading = false, state.DosageUOM_masters.error = false, state.DosageUOM_masters = (_action$payload45 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload45 !== void 0 ? _action$payload45 : {};
  }), _defineProperty(_extraReducers$H, DOSAGEUOM_MASTER.pending, function (state, action) {
    state.DosageUOM_masters.loading = true, state.DosageUOM_masters.error = false, state.DosageUOM_masters.loading = true;
  }), _defineProperty(_extraReducers$H, DOSAGEUOM_MASTER.rejected, function (state, action) {
    var _action$payload46;

    state.DosageUOM_masters.loading = false, state.DosageUOM_masters.error = true, state.DosageUOM_masters = (_action$payload46 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload46 !== void 0 ? _action$payload46 : {};
  }), _defineProperty(_extraReducers$H, DOSAGEVOLUMEUOM_MASTER.fulfilled, function (state, action) {
    var _action$payload47;

    state.DosageVolumeUom_masters.loading = false, state.DosageVolumeUom_masters.error = false, state.DosageVolumeUom_masters = (_action$payload47 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload47 !== void 0 ? _action$payload47 : {};
  }), _defineProperty(_extraReducers$H, DOSAGEVOLUMEUOM_MASTER.pending, function (state, action) {
    state.DosageVolumeUom_masters.loading = true, state.DosageVolumeUom_masters.error = false, state.DosageVolumeUom_masters.loading = true;
  }), _defineProperty(_extraReducers$H, DOSAGEVOLUMEUOM_MASTER.rejected, function (state, action) {
    var _action$payload48;

    state.DosageVolumeUom_masters.loading = false, state.DosageVolumeUom_masters.error = true, state.DosageVolumeUom_masters = (_action$payload48 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload48 !== void 0 ? _action$payload48 : {};
  }), _defineProperty(_extraReducers$H, DRUGROUTES_MASTER.fulfilled, function (state, action) {
    var _action$payload49;

    state.DrugRoutes_masters.loading = false, state.DrugRoutes_masters.error = false, state.DrugRoutes_masters = (_action$payload49 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload49 !== void 0 ? _action$payload49 : {};
  }), _defineProperty(_extraReducers$H, DRUGROUTES_MASTER.pending, function (state, action) {
    state.DrugRoutes_masters.loading = true, state.DrugRoutes_masters.error = false, state.DrugRoutes_masters.loading = true;
  }), _defineProperty(_extraReducers$H, DRUGROUTES_MASTER.rejected, function (state, action) {
    var _action$payload50;

    state.DrugRoutes_masters.loading = false, state.DrugRoutes_masters.error = true, state.DrugRoutes_masters = (_action$payload50 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload50 !== void 0 ? _action$payload50 : {};
  }), _defineProperty(_extraReducers$H, DOSAGEFORM_MASTER.fulfilled, function (state, action) {
    var _action$payload51;

    state.DosageForm_masters.loading = false, state.DosageForm_masters.error = false, state.DosageForm_masters = (_action$payload51 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload51 !== void 0 ? _action$payload51 : {};
  }), _defineProperty(_extraReducers$H, DOSAGEFORM_MASTER.pending, function (state, action) {
    state.DosageForm_masters.loading = true, state.DosageForm_masters.error = false, state.DosageForm_masters.loading = true;
  }), _defineProperty(_extraReducers$H, DOSAGEFORM_MASTER.rejected, function (state, action) {
    var _action$payload52;

    state.DosageForm_masters.loading = false, state.DosageForm_masters.error = true, state.DosageForm_masters = (_action$payload52 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload52 !== void 0 ? _action$payload52 : {};
  }), _defineProperty(_extraReducers$H, FREQUENCYMASTER_MASTER.fulfilled, function (state, action) {
    var _action$payload53;

    state.FrequencyMaster_masters.loading = false, state.FrequencyMaster_masters.error = false, state.FrequencyMaster_masters = (_action$payload53 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload53 !== void 0 ? _action$payload53 : {};
  }), _defineProperty(_extraReducers$H, FREQUENCYMASTER_MASTER.pending, function (state, action) {
    state.FrequencyMaster_masters.loading = true, state.FrequencyMaster_masters.error = false, state.FrequencyMaster_masters.loading = true;
  }), _defineProperty(_extraReducers$H, FREQUENCYMASTER_MASTER.rejected, function (state, action) {
    var _action$payload54;

    state.FrequencyMaster_masters.loading = false, state.FrequencyMaster_masters.error = true, state.FrequencyMaster_masters = (_action$payload54 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload54 !== void 0 ? _action$payload54 : {};
  }), _defineProperty(_extraReducers$H, DURATIONTYPE_MASTER.fulfilled, function (state, action) {
    var _action$payload55;

    state.DurationType_masters.loading = false, state.DurationType_masters.error = false, state.DurationType_masters = (_action$payload55 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload55 !== void 0 ? _action$payload55 : {};
  }), _defineProperty(_extraReducers$H, DURATIONTYPE_MASTER.pending, function (state, action) {
    state.DurationType_masters.loading = true, state.DurationType_masters.error = false, state.DurationType_masters.loading = true;
  }), _defineProperty(_extraReducers$H, DURATIONTYPE_MASTER.rejected, function (state, action) {
    var _action$payload56;

    state.DurationType_masters.loading = false, state.DurationType_masters.error = true, state.DurationType_masters = (_action$payload56 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload56 !== void 0 ? _action$payload56 : {};
  }), _defineProperty(_extraReducers$H, PRIORITY_MASTER.fulfilled, function (state, action) {
    var _action$payload57;

    state.Priority_masters.loading = false, state.Priority_masters.error = false, state.Priority_masters = (_action$payload57 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload57 !== void 0 ? _action$payload57 : {};
  }), _defineProperty(_extraReducers$H, PRIORITY_MASTER.pending, function (state, action) {
    state.Priority_masters.loading = true, state.Priority_masters.error = false, state.Priority_masters.loading = true;
  }), _defineProperty(_extraReducers$H, PRIORITY_MASTER.rejected, function (state, action) {
    var _action$payload58;

    state.Priority_masters.loading = false, state.Priority_masters.error = true, state.Priority_masters = (_action$payload58 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload58 !== void 0 ? _action$payload58 : {};
  }), _defineProperty(_extraReducers$H, DRUGCATEGORY_MASTER.fulfilled, function (state, action) {
    var _action$payload59;

    state.DrugCategory_masters.loading = false, state.DrugCategory_masters.error = false, state.DrugCategory_masters = (_action$payload59 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload59 !== void 0 ? _action$payload59 : {};
  }), _defineProperty(_extraReducers$H, DRUGCATEGORY_MASTER.pending, function (state, action) {
    state.DrugCategory_masters.loading = true, state.DrugCategory_masters.error = false, state.DrugCategory_masters.loading = true;
  }), _defineProperty(_extraReducers$H, DRUGCATEGORY_MASTER.rejected, function (state, action) {
    var _action$payload60;

    state.DrugCategory_masters.loading = false, state.DrugCategory_masters.error = true, state.DrugCategory_masters = (_action$payload60 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload60 !== void 0 ? _action$payload60 : {};
  }), _defineProperty(_extraReducers$H, ORDERNATURE_MASTER.fulfilled, function (state, action) {
    var _action$payload61;

    state.OrderNature_masters.loading = false, state.OrderNature_masters.error = false, state.OrderNature_masters = (_action$payload61 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload61 !== void 0 ? _action$payload61 : {};
  }), _defineProperty(_extraReducers$H, ORDERNATURE_MASTER.pending, function (state, action) {
    state.OrderNature_masters.loading = true, state.OrderNature_masters.error = false, state.OrderNature_masters.loading = true;
  }), _defineProperty(_extraReducers$H, ORDERNATURE_MASTER.rejected, function (state, action) {
    var _action$payload62;

    state.OrderNature_masters.loading = false, state.OrderNature_masters.error = true, state.OrderNature_masters = (_action$payload62 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload62 !== void 0 ? _action$payload62 : {};
  }), _defineProperty(_extraReducers$H, ORDERMODE_MASTER.fulfilled, function (state, action) {
    var _action$payload63;

    state.OrderMode_masters.loading = false, state.OrderMode_masters.error = false, state.OrderMode_masters = (_action$payload63 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload63 !== void 0 ? _action$payload63 : {};
  }), _defineProperty(_extraReducers$H, ORDERMODE_MASTER.pending, function (state, action) {
    state.OrderMode_masters.loading = true, state.OrderMode_masters.error = false, state.OrderMode_masters.loading = true;
  }), _defineProperty(_extraReducers$H, ORDERMODE_MASTER.rejected, function (state, action) {
    var _action$payload64;

    state.OrderMode_masters.loading = false, state.OrderMode_masters.error = true, state.OrderMode_masters = (_action$payload64 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload64 !== void 0 ? _action$payload64 : {};
  }), _defineProperty(_extraReducers$H, DRUGSTOREDISPLOC_MASTER.fulfilled, function (state, action) {
    var _action$payload65;

    state.DrugStoreDispLoc_masters.loading = false, state.DrugStoreDispLoc_masters.error = false, state.DrugStoreDispLoc_masters = (_action$payload65 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload65 !== void 0 ? _action$payload65 : {};
  }), _defineProperty(_extraReducers$H, DRUGSTOREDISPLOC_MASTER.pending, function (state, action) {
    state.DrugStoreDispLoc_masters.loading = true, state.DrugStoreDispLoc_masters.error = false, state.DrugStoreDispLoc_masters.loading = true;
  }), _defineProperty(_extraReducers$H, DRUGSTOREDISPLOC_MASTER.rejected, function (state, action) {
    var _action$payload66;

    state.DrugStoreDispLoc_masters.loading = false, state.DrugStoreDispLoc_masters.error = true, state.DrugStoreDispLoc_masters = (_action$payload66 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload66 !== void 0 ? _action$payload66 : {};
  }), _defineProperty(_extraReducers$H, DIAGNOSISAGAINSTENCOUNTER_MASTER.fulfilled, function (state, action) {
    var _action$payload67;

    state.DiagnosisAgainstEncounter_masters.loading = false, state.DiagnosisAgainstEncounter_masters.error = false, state.DiagnosisAgainstEncounter_masters = (_action$payload67 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload67 !== void 0 ? _action$payload67 : {};
  }), _defineProperty(_extraReducers$H, DIAGNOSISAGAINSTENCOUNTER_MASTER.pending, function (state, action) {
    state.DiagnosisAgainstEncounter_masters.loading = true, state.DiagnosisAgainstEncounter_masters.error = false, state.DiagnosisAgainstEncounter_masters.loading = true;
  }), _defineProperty(_extraReducers$H, DIAGNOSISAGAINSTENCOUNTER_MASTER.rejected, function (state, action) {
    var _action$payload68;

    state.DiagnosisAgainstEncounter_masters.loading = false, state.DiagnosisAgainstEncounter_masters.error = true, state.DiagnosisAgainstEncounter_masters = (_action$payload68 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload68 !== void 0 ? _action$payload68 : {};
  }), _defineProperty(_extraReducers$H, REASONCODE_MASTER.fulfilled, function (state, action) {
    var _action$payload69;

    state.Reasoncode_masters.loading = false, state.Reasoncode_masters.error = false, state.Reasoncode_masters = (_action$payload69 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload69 !== void 0 ? _action$payload69 : {};
  }), _defineProperty(_extraReducers$H, REASONCODE_MASTER.pending, function (state, action) {
    state.Reasoncode_masters.loading = true, state.Reasoncode_masters.error = false, state.Reasoncode_masters.loading = true;
  }), _defineProperty(_extraReducers$H, REASONCODE_MASTER.rejected, function (state, action) {
    var _action$payload70;

    state.Reasoncode_masters.loading = false, state.Reasoncode_masters.error = true, state.Reasoncode_masters = (_action$payload70 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload70 !== void 0 ? _action$payload70 : {};
  }), _defineProperty(_extraReducers$H, PATIENT_INSTRUCTIONS_MASTER.fulfilled, function (state, action) {
    var _action$payload71;

    state.Patient_Instruction.loading = false, state.Patient_Instruction.error = false, state.Patient_Instruction = (_action$payload71 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload71 !== void 0 ? _action$payload71 : {};
  }), _defineProperty(_extraReducers$H, PATIENT_INSTRUCTIONS_MASTER.pending, function (state, action) {
    state.Patient_Instruction.loading = true, state.Patient_Instruction.error = false, state.Patient_Instruction.loading = true;
  }), _defineProperty(_extraReducers$H, PATIENT_INSTRUCTIONS_MASTER.rejected, function (state, action) {
    var _action$payload72;

    state.Patient_Instruction.loading = false, state.Patient_Instruction.error = true, state.Patient_Instruction = (_action$payload72 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload72 !== void 0 ? _action$payload72 : {};
  }), _defineProperty(_extraReducers$H, ORGANIZATION_MASTER.fulfilled, function (state, action) {
    var _action$payload73;

    state.Organization_masters.loading = false, state.Organization_masters.error = false, state.Organization_masters = (_action$payload73 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload73 !== void 0 ? _action$payload73 : {};
  }), _defineProperty(_extraReducers$H, ORGANIZATION_MASTER.pending, function (state, action) {
    state.Organization_masters.loading = true, state.Organization_masters.error = false, state.Organization_masters.loading = true;
  }), _defineProperty(_extraReducers$H, ORGANIZATION_MASTER.rejected, function (state, action) {
    var _action$payload74;

    state.Organization_masters.loading = false, state.Organization_masters.error = true, state.Organization_masters = (_action$payload74 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload74 !== void 0 ? _action$payload74 : {};
  }), _defineProperty(_extraReducers$H, PRACTITIONERROLE_MASTER.fulfilled, function (state, action) {
    var _action$payload75;

    state.PractitionerRole_masters.loading = false, state.PractitionerRole_masters.error = false, state.PractitionerRole_masters = (_action$payload75 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload75 !== void 0 ? _action$payload75 : {};
  }), _defineProperty(_extraReducers$H, PRACTITIONERROLE_MASTER.pending, function (state, action) {
    state.PractitionerRole_masters.loading = true, state.PractitionerRole_masters.error = false, state.PractitionerRole_masters.loading = true;
  }), _defineProperty(_extraReducers$H, PRACTITIONERROLE_MASTER.rejected, function (state, action) {
    var _action$payload76;

    state.PractitionerRole_masters.loading = false, state.PractitionerRole_masters.error = true, state.PractitionerRole_masters = (_action$payload76 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload76 !== void 0 ? _action$payload76 : {};
  }), _defineProperty(_extraReducers$H, PRACTITIONER_MASTER.fulfilled, function (state, action) {
    var _action$payload77;

    state.Practitioner_masters.loading = false, state.Practitioner_masters.error = false, state.Practitioner_masters = (_action$payload77 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload77 !== void 0 ? _action$payload77 : {};
  }), _defineProperty(_extraReducers$H, PRACTITIONER_MASTER.pending, function (state, action) {
    state.Practitioner_masters.loading = true, state.Practitioner_masters.error = false, state.Practitioner_masters.loading = true;
  }), _defineProperty(_extraReducers$H, PRACTITIONER_MASTER.rejected, function (state, action) {
    var _action$payload78;

    state.Practitioner_masters.loading = false, state.Practitioner_masters.error = true, state.Practitioner_masters = (_action$payload78 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload78 !== void 0 ? _action$payload78 : {};
  }), _defineProperty(_extraReducers$H, INFUSIONRATEUOM_MASTER.fulfilled, function (state, action) {
    var _action$payload79;

    state.InfusionRateUoM_masters.loading = false, state.InfusionRateUoM_masters.error = false, state.InfusionRateUoM_masters = (_action$payload79 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload79 !== void 0 ? _action$payload79 : {};
  }), _defineProperty(_extraReducers$H, INFUSIONRATEUOM_MASTER.pending, function (state, action) {
    state.InfusionRateUoM_masters.loading = true, state.InfusionRateUoM_masters.error = false, state.InfusionRateUoM_masters.loading = true;
  }), _defineProperty(_extraReducers$H, INFUSIONRATEUOM_MASTER.rejected, function (state, action) {
    var _action$payload80;

    state.InfusionRateUoM_masters.loading = false, state.InfusionRateUoM_masters.error = true, state.InfusionRateUoM_masters = (_action$payload80 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload80 !== void 0 ? _action$payload80 : {};
  }), _defineProperty(_extraReducers$H, TOTALVOLUMEUOM_MASTER.fulfilled, function (state, action) {
    var _action$payload81;

    state.TotalVolumeUoM_masters.loading = false, state.TotalVolumeUoM_masters.error = false, state.TotalVolumeUoM_masters = (_action$payload81 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload81 !== void 0 ? _action$payload81 : {};
  }), _defineProperty(_extraReducers$H, TOTALVOLUMEUOM_MASTER.pending, function (state, action) {
    state.TotalVolumeUoM_masters.loading = true, state.TotalVolumeUoM_masters.error = false, state.TotalVolumeUoM_masters.loading = true;
  }), _defineProperty(_extraReducers$H, TOTALVOLUMEUOM_MASTER.rejected, function (state, action) {
    var _action$payload82;

    state.TotalVolumeUoM_masters.loading = false, state.TotalVolumeUoM_masters.error = true, state.TotalVolumeUoM_masters = (_action$payload82 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload82 !== void 0 ? _action$payload82 : {};
  }), _defineProperty(_extraReducers$H, INDICATION_REASON_CODE_MASTER.fulfilled, function (state, action) {
    var _action$payload83;

    state.Indication_Reason_Code_masters.loading = false, state.Indication_Reason_Code_masters.error = false, state.Indication_Reason_Code_masters = (_action$payload83 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload83 !== void 0 ? _action$payload83 : {};
  }), _defineProperty(_extraReducers$H, INDICATION_REASON_CODE_MASTER.pending, function (state, action) {
    state.Indication_Reason_Code_masters.loading = true, state.Indication_Reason_Code_masters.error = false, state.Indication_Reason_Code_masters.loading = true;
  }), _defineProperty(_extraReducers$H, INDICATION_REASON_CODE_MASTER.rejected, function (state, action) {
    var _action$payload84;

    state.Indication_Reason_Code_masters.loading = false, state.Indication_Reason_Code_masters.error = true, state.Indication_Reason_Code_masters = (_action$payload84 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload84 !== void 0 ? _action$payload84 : {};
  }), _defineProperty(_extraReducers$H, BASESCHEDULE_MASTER.fulfilled, function (state, action) {
    var _action$payload85;

    state.BaseSchedule_masters.loading = false, state.BaseSchedule_masters.error = false, state.BaseSchedule_masters = (_action$payload85 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload85 !== void 0 ? _action$payload85 : {};
  }), _defineProperty(_extraReducers$H, BASESCHEDULE_MASTER.pending, function (state, action) {
    state.BaseSchedule_masters.loading = true, state.BaseSchedule_masters.error = false, state.BaseSchedule_masters.loading = true;
  }), _defineProperty(_extraReducers$H, BASESCHEDULE_MASTER.rejected, function (state, action) {
    var _action$payload86;

    state.BaseSchedule_masters.loading = false, state.BaseSchedule_masters.error = true, state.BaseSchedule_masters = (_action$payload86 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload86 !== void 0 ? _action$payload86 : {};
  }), _defineProperty(_extraReducers$H, DELETEMEDICATION_MASTER.fulfilled, function (state, action) {
    var _action$payload87;

    state.DeleteMedication_masters.loading = false, state.DeleteMedication_masters.error = false, state.DeleteMedication_masters = (_action$payload87 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload87 !== void 0 ? _action$payload87 : {};
  }), _defineProperty(_extraReducers$H, DELETEMEDICATION_MASTER.pending, function (state, action) {
    state.DeleteMedication_masters.loading = true, state.DeleteMedication_masters.error = false, state.DeleteMedication_masters.loading = true;
  }), _defineProperty(_extraReducers$H, DELETEMEDICATION_MASTER.rejected, function (state, action) {
    var _action$payload88;

    state.DeleteMedication_masters.loading = false, state.DeleteMedication_masters.error = true, state.DeleteMedication_masters = (_action$payload88 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload88 !== void 0 ? _action$payload88 : {};
  }), _defineProperty(_extraReducers$H, STATUS_MASTER.fulfilled, function (state, action) {
    var _action$payload89;

    state.status_masters.loading = false, state.status_masters.error = false, state.status_masters = (_action$payload89 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload89 !== void 0 ? _action$payload89 : {};
  }), _defineProperty(_extraReducers$H, STATUS_MASTER.pending, function (state, action) {
    state.status_masters.loading = true, state.status_masters.error = false, state.status_masters.loading = true;
  }), _defineProperty(_extraReducers$H, STATUS_MASTER.rejected, function (state, action) {
    var _action$payload90;

    state.status_masters.loading = false, state.status_masters.error = true, state.status_masters = (_action$payload90 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload90 !== void 0 ? _action$payload90 : {};
  }), _defineProperty(_extraReducers$H, WORKFLOW_STATUS_MASTER.fulfilled, function (state, action) {
    var _action$payload91;

    state.workflow_status_masters.loading = false, state.workflow_status_masters.error = false, state.workflow_status_masters = (_action$payload91 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload91 !== void 0 ? _action$payload91 : {};
  }), _defineProperty(_extraReducers$H, WORKFLOW_STATUS_MASTER.pending, function (state, action) {
    state.workflow_status_masters.loading = true, state.workflow_status_masters.error = false, state.workflow_status_masters.loading = true;
  }), _defineProperty(_extraReducers$H, WORKFLOW_STATUS_MASTER.rejected, function (state, action) {
    var _action$payload92;

    state.workflow_status_masters.loading = false, state.workflow_status_masters.error = true, state.workflow_status_masters = (_action$payload92 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload92 !== void 0 ? _action$payload92 : {};
  }), _defineProperty(_extraReducers$H, GET_ORDER_DEFAULT.fulfilled, function (state, action) {
    var _action$payload93;

    state.getOrderDefault.loading = false, state.getOrderDefault.error = false, state.getOrderDefault = (_action$payload93 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload93 !== void 0 ? _action$payload93 : {};
  }), _defineProperty(_extraReducers$H, GET_ORDER_DEFAULT.pending, function (state, action) {
    state.getOrderDefault.loading = true, state.getOrderDefault.error = false, state.getOrderDefault.loading = true;
  }), _defineProperty(_extraReducers$H, GET_ORDER_DEFAULT.rejected, function (state, action) {
    var _action$payload94;

    state.getOrderDefault.loading = false, state.getOrderDefault.error = true, state.getOrderDefault = (_action$payload94 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload94 !== void 0 ? _action$payload94 : {};
  }), _extraReducers$H)
});
var MedicationMastersActions = {
  DRUGTYPE_MASTER: DRUGTYPE_MASTER,
  DRUGMASTER_MASTER: DRUGMASTER_MASTER,
  STRENGTH_MASTER: STRENGTH_MASTER,
  STRENGTHUOM_MASTER: STRENGTHUOM_MASTER,
  STRENGTHVOLUMN_MASTER: STRENGTHVOLUMN_MASTER,
  STRENGTHVOLUMNUOM_MASTER: STRENGTHVOLUMNUOM_MASTER,
  DOSAGETYPEINDICATOR_MASTER: DOSAGETYPEINDICATOR_MASTER,
  DOSAGEUOM_MASTER: DOSAGEUOM_MASTER,
  DOSAGEVOLUMEUOM_MASTER: DOSAGEVOLUMEUOM_MASTER,
  DRUGROUTES_MASTER: DRUGROUTES_MASTER,
  DOSAGEFORM_MASTER: DOSAGEFORM_MASTER,
  FREQUENCYMASTER_MASTER: FREQUENCYMASTER_MASTER,
  DURATIONTYPE_MASTER: DURATIONTYPE_MASTER,
  PRIORITY_MASTER: PRIORITY_MASTER,
  DRUGCATEGORY_MASTER: DRUGCATEGORY_MASTER,
  ORDERNATURE_MASTER: ORDERNATURE_MASTER,
  PATIENT_INSTRUCTIONS_MASTER: PATIENT_INSTRUCTIONS_MASTER,
  ORDERMODE_MASTER: ORDERMODE_MASTER,
  DRUGSTOREDISPLOC_MASTER: DRUGSTOREDISPLOC_MASTER,
  DIAGNOSISAGAINSTENCOUNTER_MASTER: DIAGNOSISAGAINSTENCOUNTER_MASTER,
  REASONCODE_MASTER: REASONCODE_MASTER,
  ORGANIZATION_MASTER: ORGANIZATION_MASTER,
  PRACTITIONERROLE_MASTER: PRACTITIONERROLE_MASTER,
  PRACTITIONER_MASTER: PRACTITIONER_MASTER,
  INFUSIONRATEUOM_MASTER: INFUSIONRATEUOM_MASTER,
  TOTALVOLUMEUOM_MASTER: TOTALVOLUMEUOM_MASTER,
  INDICATION_REASON_CODE_MASTER: INDICATION_REASON_CODE_MASTER,
  BASESCHEDULE_MASTER: BASESCHEDULE_MASTER,
  DELETEMEDICATION_MASTER: DELETEMEDICATION_MASTER,
  STATUS_MASTER: STATUS_MASTER,
  WORKFLOW_STATUS_MASTER: WORKFLOW_STATUS_MASTER,
  SINGLE_READ_EDIT_INFO: SINGLE_READ_EDIT_INFO,
  ORDER_TYPE_REQ_DETAILS_ROLE: ORDER_TYPE_REQ_DETAILS_ROLE,
  DIAGNOSIS_MASTERS: DIAGNOSIS_MASTERS$1,
  SAVE_MEDICATIONS: SAVE_MEDICATIONS,
  GET_MEDICATIONS: GET_MEDICATIONS,
  ORDER_PRESCRIPTION_MASTER: ORDER_PRESCRIPTION_MASTER,
  ORDER_TYPE_REQ_DETAILS_LAB: ORDER_TYPE_REQ_DETAILS_LAB,
  GET_ORDER_DEFAULT: GET_ORDER_DEFAULT,
  GET_ALLERGY_INTERACTION: GET_ALLERGY_INTERACTION,
  GET_ALERT_CODES: GET_ALERT_CODES,
  ALERTLOGS_SINGLE_READ: ALERTLOGS_SINGLE_READ,
  DELETE_NEW_ORDER_PENDING_STATUS: DELETE_NEW_ORDER_PENDING_STATUS,
  SAVE_NEW_ORDER_PENDING_STATUS: SAVE_NEW_ORDER_PENDING_STATUS,
  READ_PENDING_MEDICATIONS: READ_PENDING_MEDICATIONS,
  GET_DRUG_DUPLICATION: GET_DRUG_DUPLICATION,
  BULK_SAVE_MEDICATIONS: BULK_SAVE_MEDICATIONS
};
var MedicationMastersSlice$1 = MedicationMastersSlice.reducer;

var queries$m = {
  IdmGetPermission: function IdmGetPermission(id) {
    return {
      db_name: "".concat(dbName),
      entity: "PermissionRoleMapping",
      filter: "PermissionRoleMapping.role_id == ".concat(id),
      return_fields: "{PermissionRoleMapping}"
    };
  },
  GetPractitionerData: function GetPractitionerData(id) {
    return {
      db_name: dbName,
      filter: {
        _id: id
      },
      queryid: "8bb0d79e-1bb9-4320-92b1-bec2ea21ca26"
    };
  },
  GetPractitionerRole: function GetPractitionerRole(_id) {
    return {
      db_name: dbName,
      entity: "Practitioner,PractitionerRole",
      filter: {
        Practitioner: "Practitioner._id=='".concat(_id, "' && Practitioner.activestatus==true"),
        PractitionerRole: "Practitioner.practitioner_role any == PractitionerRole._id && Practitioner.activestatus==true"
      },
      return_fields: "merge(PractitionerRole,{role:document(document(PractitionerRole.role).coding)},{OrgID:document(PractitionerRole.OrgID)},{locationID:document(PractitionerRole.locationID)},{EntityType:document(document(PractitionerRole.EntityType).coding)},{EntityName:document(PractitionerRole.EntityName)})"
    };
  },
  GetEnterPriseList: function GetEnterPriseList(_id) {
    return {
      db_name: dbName,
      entity: "Organization",
      filter: "Organization._id=='".concat(_id, "'  && Organization.activestatus==true"),
      return_fields: "merge(Organization,{alias:(for ali in to_array(Organization.alias) return merge(ali,{aliasType:document(ali.aliasType)}))})"
    };
  },
  GetOrganisationListFirst: function GetOrganisationListFirst(_id) {
    return {
      db_name: dbName,
      filter: {
        _id: _id
      },
      queryid: "d8387fb2-ddf1-40e3-a5cb-d49ad81fd93b"
    };
  },
  GetOrganisationList: function GetOrganisationList(_id, queryType) {
    if (queryType === 1) return {
      db_name: dbName,
      filter: {
        _id: _id
      },
      queryid: "d8387fb2-ddf1-40e3-a5cb-d49ad81fd93b"
    };
    return {
      db_name: dbName,
      entity: "Organization",
      filter: "Organization.ParentOrgID any == ".concat(_id, " && Organization.activestatus==true"),
      return_fields: "merge(Organization,{alias:(for ali in to_array(Organization.alias) return merge(ali,{aliasType:document(ali.aliasType)}))})"
    };
  },
  GetFacilityList: function GetFacilityList(_id) {
    return {
      db_name: dbName,
      entity: "Organization",
      filter: "Organization.ParentOrgID any == ".concat(_id, " && Organization.activestatus==true"),
      return_fields: "merge(Organization,{alias:(for ali in to_array(Organization.alias) return merge(ali,{aliasType:document(ali.aliasType)}))})"
    };
  },
  GetLocationList: function GetLocationList(_id) {
    return {
      db_name: dbName,
      entity: "LocationMaster",
      filter: "LocationMaster.managingOrgID=='".concat(_id, "' && LocationMaster.activestatus==true"),
      return_fields: "merge(LocationMaster,{pharmacy:(for doc in TO_ARRAY(LocationMaster.pharmacy) return merge(doc,{inventorySubStore:document(doc.inventorySubStore)}))})"
    };
  },
  roleBasedPermission: function roleBasedPermission(roleId) {
    return {
      db_name: dbName,
      roleid: "".concat(roleId)
    };
  },
  saveUserPreference: function saveUserPreference(data) {
    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "Users",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, (data === null || data === void 0 ? void 0 : data._key) && {
      filter: {
        _key: data === null || data === void 0 ? void 0 : data._key
      }
    }), {}, {
      doc: {
        // _id: "string",
        username: data === null || data === void 0 ? void 0 : data.username,
        email: data === null || data === void 0 ? void 0 : data.email,
        realmRoles: data === null || data === void 0 ? void 0 : data.realmRoles,
        origin: data === null || data === void 0 ? void 0 : data.origin,
        id: data === null || data === void 0 ? void 0 : data.id,
        is_active: data === null || data === void 0 ? void 0 : data.is_active,
        role_mapping: data === null || data === void 0 ? void 0 : data.role_mapping,
        personid: data === null || data === void 0 ? void 0 : data.personid,
        userpreference: data === null || data === void 0 ? void 0 : data.userpreference
      }
    })];
  },
  readUserPreference: function readUserPreference(personId) {
    return {
      db_name: dbName,
      entity: "Users",
      filter: "Users.personid==".concat(personId, " && Users.activestatus==true"),
      return_fields: "merge(Users,{userpreference:merge(Users.userpreference,{ facility:first(for org in Organization filter org._id==Users.userpreference.facility return merge(org,{alias:(for ali in org.alias return merge(ali,{aliasType:document(ali.aliasType)}))})), enterprise:first(for org in Organization filter org._id==Users.userpreference.enterprise return merge(org,{alias:(for ali in org.alias return merge(ali,{aliasType:document(ali.aliasType)}))})), location:first(for lml in LocationMaster filter lml._id==Users.userpreference.location return merge(lml,{pharmacy:(for ivp in to_array(lml.pharmacy) return merge(ivp,{inventorySubStore:document(ivp.inventorySubStore)}))})), org:first(for org in Organization filter org._id== Users.userpreference.org return merge(org,{alias:(for ali in org.alias return merge(ali,{aliasType:document(ali.aliasType)}))}))})})"
    };
  },
  getDateFormatUsingFacilityId: function getDateFormatUsingFacilityId(facilityId) {
    return {
      db_name: dbName,
      entity: "Organization",
      filter: "Organization._key=='".concat(facilityId, "' AND Organization.activestatus==true"),
      return_fields: "merge(keep(Organization,'_id','name','entitycode','orgdatetimeformat','orgtimeformat','orgdateformat'),{orgdatetimeformat:document(Organization.orgdatetimeformat),orgdateformat:document(Organization.orgdateformat),orgtimeformat:document(Organization.orgtimeformat)})"
    };
  }
};

var _extraReducers$G;
var query_ids = {
  "signInSlice/SearchPractioner": "2fef3beb-6f38-48b0-955f-90f88dab2822"
};
var SEARCH_PRACTIONER = toolkit.createAsyncThunk("signInReducerApiSlice/SearchPractioner", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      _payload$email,
      email,
      body,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _payload$email = payload.email, email = _payload$email === void 0 ? "" : _payload$email;
          body = {
            db_name: dbName,
            queryid: query_ids["signInSlice/SearchPractioner"],
            filter: {
              emailId: email
            }
          };
          _context.next = 7;
          return fetchData({
            body: JSON.stringify(body)
          });

        case 7:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message,
            err: _context.t0
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var GET_PERMISSION_ROLE_DATA = toolkit.createAsyncThunk("OrganizationAuthApiSlice/getpermissiondata", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      id,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          id = payload.id;
          _context2.next = 6;
          return fetchData({
            body: JSON.stringify(queries$m.IdmGetPermission(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 13:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 10]]);
})));
var GETPRACTITIONER_DATA = toolkit.createAsyncThunk("signInReducerApiSlice/getpractitionerdata", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      id,
      data,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          id = payload.id;
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(queries$m.GetPractitionerData(id))
          }, __baseUrl__);

        case 6:
          data = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 10]]);
})));
var LOGGED_USER_INFO = toolkit.createAsyncThunk("signInReducerApiSlice/loggedUserInfo", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      params,
      keys,
      _args4 = arguments;
  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          params = payload.params, keys = payload.keys;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: _objectSpread2(_objectSpread2({}, params), keys),
            isSignedIn: true
          }));

        case 3:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4);
})));
var SIGNIN = toolkit.createAsyncThunk("signInReducerApiSlice/sign_in", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref9,
      rejectWithValue,
      data,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref9 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref9.rejectWithValue;
          _context5.prev = 2;
          _context5.next = 5;
          return fetchData({
            body: payload
          }, __signin__);

        case 5:
          data = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 9:
          _context5.prev = 9;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 12:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 9]]);
})));
var QDM_LOG = toolkit.createAsyncThunk("signInReducerApiSlice/qdm_log", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      params,
      _args6 = arguments;
  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          params = payload.params;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: params
          }));

        case 3:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6);
})));
var GetPractionerRole = toolkit.createAsyncThunk("signInReducerApiSlice/getPractionerRole", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref12,
      rejectWithValue,
      id,
      data,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref12 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context7.prev = 2;
          id = payload.id;
          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(queries$m.GetPractitionerRole(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context7.prev = 10;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 13:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 10]]);
})));
var GetEnterPriseList = toolkit.createAsyncThunk("signInReducerApiSlice/getEnterpriseList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref14,
      rejectWithValue,
      id,
      data,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref14 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context8.prev = 2;
          id = payload.id;
          _context8.next = 6;
          return fetchData({
            body: JSON.stringify(queries$m.GetEnterPriseList(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context8.sent;
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context8.prev = 10;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 13:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 10]]);
})));
var GetOrganisationList = toolkit.createAsyncThunk("signInReducerApiSlice/getOrganisationList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref16,
      rejectWithValue,
      id,
      queryType,
      data,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref16 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref16.rejectWithValue;
          _context9.prev = 2;
          id = payload.id, queryType = payload.queryType;
          _context9.next = 6;
          return fetchData({
            body: JSON.stringify(queries$m.GetOrganisationList(id, queryType))
          }, queryType === 1 ? __baseUrl__ : __readDocumentUrl__);

        case 6:
          data = _context9.sent;
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context9.prev = 10;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 13:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 10]]);
})));
var GetFacilityList = toolkit.createAsyncThunk("signInReducerApiSlice/getFacilityList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref18,
      rejectWithValue,
      id,
      data,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref18 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref18.rejectWithValue;
          _context10.prev = 2;
          id = payload.id;
          _context10.next = 6;
          return fetchData({
            body: JSON.stringify(queries$m.GetFacilityList(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context10.sent;
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context10.prev = 10;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 13:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 10]]);
})));
var GetLocationList = toolkit.createAsyncThunk("signInReducerApiSlice/getLocationList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var payload,
      _ref20,
      rejectWithValue,
      id,
      data,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
          _ref20 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref20.rejectWithValue;
          _context11.prev = 2;
          id = payload.id;
          _context11.next = 6;
          return fetchData({
            body: JSON.stringify(queries$m.GetLocationList(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context11.sent;
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context11.prev = 10;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 13:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 10]]);
})));
var GET_TOKEN = toolkit.createAsyncThunk("signInReducerApiSlice/getToken", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var payload,
      _ref22,
      rejectWithValue,
      params,
      data,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
          _ref22 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref22.rejectWithValue;
          _context12.prev = 2;
          params = payload.params;
          _context12.next = 6;
          return fetchData({
            body: JSON.stringify(params)
          }, __TokenGeneration__);

        case 6:
          data = _context12.sent;
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 10:
          _context12.prev = 10;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 13:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 10]]);
})));
var PERMISSION_ROLES = toolkit.createAsyncThunk("signInReducerApiSlice/permissionRoles", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
  var payload,
      _ref24,
      rejectWithValue,
      id,
      data,
      _args13 = arguments;

  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          payload = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {};
          _ref24 = _args13.length > 1 ? _args13[1] : undefined, rejectWithValue = _ref24.rejectWithValue;
          _context13.prev = 2;
          id = payload.id;
          _context13.next = 6;
          return fetchData({
            body: JSON.stringify(queries$m.roleBasedPermission(id))
          }, __RolePermission__);

        case 6:
          data = _context13.sent;
          return _context13.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context13.prev = 10;
          _context13.t0 = _context13["catch"](2);
          return _context13.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context13.t0.message
          })));

        case 13:
        case "end":
          return _context13.stop();
      }
    }
  }, _callee13, null, [[2, 10]]);
})));
var SAVE_USER_PREFERENCE = toolkit.createAsyncThunk("signInReducerApiSlice/save_user_preference", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
  var payload,
      _ref26,
      rejectWithValue,
      data,
      _args14 = arguments;

  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          payload = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : {};
          _ref26 = _args14.length > 1 ? _args14[1] : undefined, rejectWithValue = _ref26.rejectWithValue;
          _context14.prev = 2;
          _context14.next = 5;
          return fetchData({
            body: JSON.stringify(queries$m.saveUserPreference(payload))
          }, __uspsertUrl__);

        case 5:
          data = _context14.sent;
          return _context14.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 9:
          _context14.prev = 9;
          _context14.t0 = _context14["catch"](2);
          return _context14.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context14.t0.message
          })));

        case 12:
        case "end":
          return _context14.stop();
      }
    }
  }, _callee14, null, [[2, 9]]);
})));
var READ_USER_PREFERENCE = toolkit.createAsyncThunk("signInReducerApiSlice/read_user_preference", /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(_ref27, _ref28) {
    var personId, rejectWithValue, data;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            personId = _ref27.personId;
            rejectWithValue = _ref28.rejectWithValue;
            _context15.prev = 2;
            _context15.next = 5;
            return fetchData({
              body: JSON.stringify(queries$m.readUserPreference(personId))
            }, __readDocumentUrl__);

          case 5:
            data = _context15.sent;
            return _context15.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: data
            }));

          case 9:
            _context15.prev = 9;
            _context15.t0 = _context15["catch"](2);
            rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context15.t0
            }));

          case 12:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[2, 9]]);
  }));

  return function (_x, _x2) {
    return _ref29.apply(this, arguments);
  };
}());
var GET_DATE_FORMAT_USING_FACILITY_ID = toolkit.createAsyncThunk("signInReducerApiSlice/getDateFormatUsingFacilityId", /*#__PURE__*/function () {
  var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(_ref30, _ref31) {
    var facilityId, rejectWithValue, data;
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            facilityId = _ref30.facilityId;
            rejectWithValue = _ref31.rejectWithValue;
            _context16.prev = 2;
            _context16.next = 5;
            return fetchData({
              body: JSON.stringify(queries$m.getDateFormatUsingFacilityId(facilityId))
            }, __readDocumentUrl__);

          case 5:
            data = _context16.sent;
            return _context16.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
              data: data
            }));

          case 9:
            _context16.prev = 9;
            _context16.t0 = _context16["catch"](2);
            return _context16.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context16.t0.message
            })));

          case 12:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[2, 9]]);
  }));

  return function (_x3, _x4) {
    return _ref32.apply(this, arguments);
  };
}()); // const GETQUEUELIST = createAsyncThunk(
//   `signInReducerApiSlice/getQueueList`,
//   async (payload = {}, { rejectWithValue }) => {
//     try {
//       const data = await fetchDataQueueList(__GetQueueList__);
//       let Scenarios = [];
//       //let ScenarioObj = {};
//       data.result?.[0]?.scenarioChildren?.forEach((scenario) => {
//         if (
//           scenario.permsndelete ||
//           scenario?.permsnread ||
//           scenario?.permsnupdate ||
//           scenario?.permsnwrite
//         ) {
//           //Scenario Start
//           let obj = {};
//           obj.scenarioId = scenario?.repoid?.unique_id;
//           obj.scenarioName = scenario?.repoid?.rep_name;
//           obj.queueId = scenario.repodetails?.queueid;
//           let States = [];
//           //State start
//           scenario?.stateChildren?.forEach((state) => {
//             if (
//               state.permsndelete ||
//               state?.permsnread ||
//               state?.permsnupdate ||
//               state?.permsnwrite
//             ) {
//               let stateObj = {};
//               stateObj.stateId = state?.repoid?.unique_id;
//               stateObj.stateName = state?.repoid?.rep_name;
//               //Action start
//               let Actions = [];
//               state?.actionChildren?.forEach((action) => {
//                 if (
//                   action.permsndelete ||
//                   action?.permsnread ||
//                   action?.permsnupdate ||
//                   action?.permsnwrite
//                 ) {
//                   let actionObj = {};
//                   actionObj.actionid = action?.repodetails?.actionid;
//                   actionObj.action = action?.repoid?.rep_name;
//                   actionObj.apiendpoint = action?.repodetails?.apiendpoint;
//                   actionObj.chooseform = action?.repodetails?.chooseform;
//                   actionObj.choosetype = action?.repodetails?.choosetype;
//                   Actions.push(actionObj);
//                 }
//               });
//               stateObj.actions = Actions;
//               States.push(stateObj);
//             }
//           });
//           obj.states = States;
//           //ScenarioObj[scenario?.repoid?.rep_name] = obj;
//           Scenarios.push(obj);
//         }
//       });
//       let fillteredScenariosStates = [];
//       Scenarios?.forEach((val) => {
//         val?.states.forEach((state) => {
//           fillteredScenariosStates.push({
//             id: state?.stateId,
//             label: state?.stateName,
//             //count: state?.reccount,
//             scenarioid: val?.scenarioId,
//             queueid: val?.queueId,
//             scenrioname: val?.scenarioName,
//             actions: state?.actions,
//           });
//         });
//       });
//
//       let obj = {};
//       fillteredScenariosStates.forEach((val) => {
//         let ID = val.id;
//         if (ID in obj) {
//           //obj[val.id].count = obj[val.id].count + val.count;
//           obj[val.id] = {
//             ...obj[val.id],
//             [val?.scenrioname]: val?.actions,
//           };
//         } else {
//           obj[val.id] = {
//             ...val,
//             [val?.scenrioname]: val?.actions,
//           };
//         }
//       });
//       let fillteredValue = Object.values(obj);
//       return {
//         ...defaultState.List,
//         data: fillteredValue,
//       };
//     } catch (error) {
//
//       return rejectWithValue({
//         ...defaultReject,
//         message: error.message,
//       });
//     }
//   }
// );

var signInReducerApiSlice = toolkit.createSlice({
  name: "signInReducerApiSlice",
  initialState: {
    sign_in: _objectSpread2({}, defaultState === null || defaultState === void 0 ? void 0 : defaultState.List),
    searchPractioner: _objectSpread2({}, defaultState.Info),
    getPermission: _objectSpread2({}, defaultState.Info),
    getPractitonerData: _objectSpread2({}, defaultState.List),
    loggedUserInfo: _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
      isSignedIn: false
    }),
    getPractionerRole: _objectSpread2({}, defaultState.Info),
    getEnterpriseList: _objectSpread2({}, defaultState.Info),
    getOrganisationList: _objectSpread2({}, defaultState.Info),
    getFacilityList: _objectSpread2({}, defaultState.Info),
    getLocationList: _objectSpread2({}, defaultState.Info),
    token: _objectSpread2({}, defaultState.Info),
    permissionRoles: _objectSpread2({}, defaultState.Info),
    saveUserPreference: _objectSpread2({}, defaultState.Info),
    readUserPreference: _objectSpread2({}, defaultState.Info),
    getDateFormatUsingFacilityId: _objectSpread2({}, defaultState.Info),
    //getQueueList: { ...defaultState.Info },
    qdm_log: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$G = {}, _defineProperty(_extraReducers$G, SIGNIN.fulfilled, function (state, action) {
    var _action$payload;

    state.sign_in = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$G, SIGNIN.pending, function (state, action) {
    state.sign_in.loading = true;
  }), _defineProperty(_extraReducers$G, SIGNIN.rejected, function (state, action) {
    var _action$payload2;

    state.sign_in = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$G, QDM_LOG.fulfilled, function (state, action) {
    var _action$payload3;

    state.qdm_log = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$G, QDM_LOG.pending, function (state, action) {
    state.qdm_log.loading = true;
  }), _defineProperty(_extraReducers$G, QDM_LOG.rejected, function (state, action) {
    var _action$payload4;

    state.qdm_log = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$G, PERMISSION_ROLES.fulfilled, function (state, action) {
    var _action$payload5;

    state.permissionRoles = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$G, PERMISSION_ROLES.pending, function (state, action) {
    state.permissionRoles.loading = true;
  }), _defineProperty(_extraReducers$G, PERMISSION_ROLES.rejected, function (state, action) {
    var _action$payload6;

    state.permissionRoles = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers$G, GET_TOKEN.fulfilled, function (state, action) {
    var _action$payload7;

    state.token = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : {};
  }), _defineProperty(_extraReducers$G, GET_TOKEN.pending, function (state, action) {
    state.token.loading = true;
  }), _defineProperty(_extraReducers$G, GET_TOKEN.rejected, function (state, action) {
    var _action$payload8;

    state.token = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : {};
  }), _defineProperty(_extraReducers$G, LOGGED_USER_INFO.fulfilled, function (state, action) {
    var _action$payload9;

    state.loggedUserInfo = (_action$payload9 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload9 !== void 0 ? _action$payload9 : {};
  }), _defineProperty(_extraReducers$G, LOGGED_USER_INFO.pending, function (state, action) {
    state.loggedUserInfo.loading = true;
  }), _defineProperty(_extraReducers$G, LOGGED_USER_INFO.rejected, function (state, action) {
    var _action$payload10;

    state.loggedUserInfo = (_action$payload10 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload10 !== void 0 ? _action$payload10 : {};
  }), _defineProperty(_extraReducers$G, SEARCH_PRACTIONER.fulfilled, function (state, action) {
    var _action$payload11;

    state.searchPractioner = (_action$payload11 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload11 !== void 0 ? _action$payload11 : {};
  }), _defineProperty(_extraReducers$G, SEARCH_PRACTIONER.pending, function (state, action) {
    state.searchPractioner.loading = true;
  }), _defineProperty(_extraReducers$G, SEARCH_PRACTIONER.rejected, function (state, action) {
    var _action$payload12;

    state.searchPractioner = (_action$payload12 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload12 !== void 0 ? _action$payload12 : {};
  }), _defineProperty(_extraReducers$G, GETPRACTITIONER_DATA.fulfilled, function (state, action) {
    var _action$payload13;

    state.getPractitonerData = (_action$payload13 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload13 !== void 0 ? _action$payload13 : [];
  }), _defineProperty(_extraReducers$G, GETPRACTITIONER_DATA.pending, function (state, action) {
    state.getPractitonerData.loading = true;
  }), _defineProperty(_extraReducers$G, GETPRACTITIONER_DATA.rejected, function (state, action) {
    var _action$payload14;

    state.getPractitonerData = (_action$payload14 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload14 !== void 0 ? _action$payload14 : [];
  }), _defineProperty(_extraReducers$G, GET_PERMISSION_ROLE_DATA.fulfilled, function (state, action) {
    var _action$payload15;

    state.getPermission = (_action$payload15 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload15 !== void 0 ? _action$payload15 : {};
  }), _defineProperty(_extraReducers$G, GET_PERMISSION_ROLE_DATA.pending, function (state, action) {
    state.getPermission.loading = true;
  }), _defineProperty(_extraReducers$G, GET_PERMISSION_ROLE_DATA.rejected, function (state, action) {
    var _action$payload16;

    state.getPermission = (_action$payload16 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload16 !== void 0 ? _action$payload16 : {};
  }), _defineProperty(_extraReducers$G, GetPractionerRole.fulfilled, function (state, action) {
    var _action$payload17;

    state.getPractionerRole = (_action$payload17 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload17 !== void 0 ? _action$payload17 : {};
  }), _defineProperty(_extraReducers$G, GetPractionerRole.pending, function (state, action) {
    state.getPractionerRole.loading = true;
  }), _defineProperty(_extraReducers$G, GetPractionerRole.rejected, function (state, action) {
    var _action$payload18;

    state.getPractionerRole = (_action$payload18 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload18 !== void 0 ? _action$payload18 : {};
  }), _defineProperty(_extraReducers$G, GetEnterPriseList.fulfilled, function (state, action) {
    var _action$payload19;

    state.getEnterpriseList = (_action$payload19 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload19 !== void 0 ? _action$payload19 : {};
  }), _defineProperty(_extraReducers$G, GetEnterPriseList.pending, function (state, action) {
    state.getEnterpriseList.loading = true;
  }), _defineProperty(_extraReducers$G, GetEnterPriseList.rejected, function (state, action) {
    var _action$payload20;

    state.getEnterpriseList = (_action$payload20 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload20 !== void 0 ? _action$payload20 : {};
  }), _defineProperty(_extraReducers$G, GetOrganisationList.fulfilled, function (state, action) {
    var _action$payload21;

    state.getOrganisationList = (_action$payload21 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload21 !== void 0 ? _action$payload21 : {};
  }), _defineProperty(_extraReducers$G, GetOrganisationList.pending, function (state, action) {
    state.getOrganisationList.loading = true;
  }), _defineProperty(_extraReducers$G, GetOrganisationList.rejected, function (state, action) {
    var _action$payload22;

    state.getOrganisationList = (_action$payload22 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload22 !== void 0 ? _action$payload22 : {};
  }), _defineProperty(_extraReducers$G, GetFacilityList.fulfilled, function (state, action) {
    var _action$payload23;

    state.getFacilityList = (_action$payload23 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload23 !== void 0 ? _action$payload23 : {};
  }), _defineProperty(_extraReducers$G, GetFacilityList.pending, function (state, action) {
    state.getFacilityList.loading = true;
  }), _defineProperty(_extraReducers$G, GetFacilityList.rejected, function (state, action) {
    var _action$payload24;

    state.getFacilityList = (_action$payload24 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload24 !== void 0 ? _action$payload24 : {};
  }), _defineProperty(_extraReducers$G, GetLocationList.fulfilled, function (state, action) {
    var _action$payload25;

    state.getLocationList = (_action$payload25 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload25 !== void 0 ? _action$payload25 : {};
  }), _defineProperty(_extraReducers$G, GetLocationList.pending, function (state, action) {
    state.getLocationList.loading = true;
  }), _defineProperty(_extraReducers$G, GetLocationList.rejected, function (state, action) {
    var _action$payload26;

    state.getLocationList = (_action$payload26 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload26 !== void 0 ? _action$payload26 : {};
  }), _defineProperty(_extraReducers$G, SAVE_USER_PREFERENCE.fulfilled, function (state, action) {
    var _action$payload27;

    state.saveUserPreference = (_action$payload27 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload27 !== void 0 ? _action$payload27 : {};
  }), _defineProperty(_extraReducers$G, SAVE_USER_PREFERENCE.pending, function (state, action) {
    state.saveUserPreference.loading = true;
  }), _defineProperty(_extraReducers$G, SAVE_USER_PREFERENCE.rejected, function (state, action) {
    var _action$payload28;

    state.saveUserPreference = (_action$payload28 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload28 !== void 0 ? _action$payload28 : {};
  }), _defineProperty(_extraReducers$G, READ_USER_PREFERENCE.fulfilled, function (state, action) {
    var _action$payload29;

    state.readUserPreference = (_action$payload29 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload29 !== void 0 ? _action$payload29 : {};
  }), _defineProperty(_extraReducers$G, READ_USER_PREFERENCE.pending, function (state, action) {
    state.readUserPreference.loading = true;
  }), _defineProperty(_extraReducers$G, READ_USER_PREFERENCE.rejected, function (state, action) {
    var _action$payload30;

    state.readUserPreference = (_action$payload30 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload30 !== void 0 ? _action$payload30 : {};
  }), _defineProperty(_extraReducers$G, GET_DATE_FORMAT_USING_FACILITY_ID.fulfilled, function (state, action) {
    var _action$payload31;

    state.getDateFormatUsingFacilityId = (_action$payload31 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload31 !== void 0 ? _action$payload31 : {};
  }), _defineProperty(_extraReducers$G, GET_DATE_FORMAT_USING_FACILITY_ID.pending, function (state, action) {
    state.getDateFormatUsingFacilityId.loading = true;
  }), _defineProperty(_extraReducers$G, GET_DATE_FORMAT_USING_FACILITY_ID.rejected, function (state, action) {
    var _action$payload32;

    state.getDateFormatUsingFacilityId = (_action$payload32 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload32 !== void 0 ? _action$payload32 : {};
  }), _extraReducers$G)
});
var signInActions = {
  SEARCH_PRACTIONER: SEARCH_PRACTIONER,
  GET_PERMISSION_ROLE_DATA: GET_PERMISSION_ROLE_DATA,
  GETPRACTITIONER_DATA: GETPRACTITIONER_DATA,
  LOGGED_USER_INFO: LOGGED_USER_INFO,
  GetPractionerRole: GetPractionerRole,
  GetEnterPriseList: GetEnterPriseList,
  GetOrganisationList: GetOrganisationList,
  GetFacilityList: GetFacilityList,
  GetLocationList: GetLocationList,
  GET_TOKEN: GET_TOKEN,
  PERMISSION_ROLES: PERMISSION_ROLES,
  SAVE_USER_PREFERENCE: SAVE_USER_PREFERENCE,
  READ_USER_PREFERENCE: READ_USER_PREFERENCE,
  GET_DATE_FORMAT_USING_FACILITY_ID: GET_DATE_FORMAT_USING_FACILITY_ID,
  //GETQUEUELIST,
  QDM_LOG: QDM_LOG,
  SIGNIN: SIGNIN
};
var signInReducerApiSlice$1 = signInReducerApiSlice.reducer;

var cartDefinitionMasterQuery = {
  cartDefinitionFullRead: function cartDefinitionFullRead(page, perPage) {
    return {
      db_name: dbName,
      entity: "PH_CartDefinition",
      filter: "PH_CartDefinition.activestatus==true",
      return_fields: "merge(keep(PH_CartDefinition,'_id','id','_key'),{cartName:PH_CartDefinition.cartname,Ward:document(PH_CartDefinition.ward)[*].longdesc,Timings:(for tim in to_array(PH_CartDefinition.Timings) return merge(keep(tim,'weekdays'),{weekdays:document(tim.weekdays)[*].display})),subStore:document(PH_CartDefinition.locationid).longdesc, cartstatus:PH_CartDefinition.cartstatus})"
    };
  },
  cartDefinitionFilter: function cartDefinitionFilter(filter) {
    return {
      db_name: dbName,
      entity: "PH_CartDefinition",
      filter: "(like(document(PH_CartDefinition.locationid).longdesc,'%".concat(filter, "%',true) || like(PH_CartDefinition.cartname,'%").concat(filter, "%',true) || like(document(PH_CartDefinition.ward)[*].longdesc,'%").concat(filter, "%',true) ) && PH_CartDefinition.activestatus==true"),
      return_fields: "merge(keep(PH_CartDefinition,'_id','id','_key'),{cartName:PH_CartDefinition.cartname,Ward:document(PH_CartDefinition.ward)[*].longdesc,Timings:(for tim in to_array(PH_CartDefinition.Timings) return merge(keep(tim,'weekdays'),{weekdays:document(tim.weekdays)[*].display})),subStore:document(PH_CartDefinition.locationid).longdesc, cartstatus:PH_CartDefinition.cartstatus})"
    };
  },
  cartDefinitionSingleRead: function cartDefinitionSingleRead(id) {
    return {
      db_name: dbName,
      entity: "PH_CartDefinition",
      filter: "PH_CartDefinition._id=='".concat(id, "' && PH_CartDefinition.activestatus==true"),
      //${id} //PH_CartDefinition/10000
      return_fields: "merge(PH_CartDefinition,{ward:document(PH_CartDefinition.ward),locationid:document(PH_CartDefinition.locationid),disptype:document(PH_CartDefinition.disptype),Timings:(for tim in PH_CartDefinition.Timings return merge(tim,{weekdays:document(tim.weekdays)}))})"
    };
  }
};
var cartDefinitionOptionsQuery = {
  dispenseType: function dispenseType() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='DISPENSETYPE' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  pharmacy: function pharmacy() {
    return {
      db_name: dbName,
      entity: "LocationMaster",
      filter: "(document(LocationMaster.locationType).code== 'LT006' || FIRST(document(document(LocationMaster.locationType).coding)[*].code)== 'LT006') && LocationMaster.activestatus == true && lower(LocationMaster.status) == 'active'",
      return_fields: "KEEP(LocationMaster,'_id','id','_key','status','activestatus','longdesc','locationID')"
    };
  },
  ward: function ward() {
    return {
      db_name: dbName,
      entity: "LocationMaster",
      filter: "document(LocationMaster.locationType).code== 'LT008' ? true : first(document(document(LocationMaster.locationType).coding)[*].code)=='LT008'  && LocationMaster.activestatus == true && lower(LocationMaster.status) == 'active'",
      return_fields: "KEEP(LocationMaster,'_id','id','_key','status','activestatus','longdesc','locationID')"
    };
  },
  weekdays: function weekdays() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: " CodingMaster.Type=='WEEKDAYS' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: " KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: " CodingMaster.code"
    };
  }
};

var GenerateInsert = function GenerateInsert(data) {
  return [{
    db_name: dbName,
    entity: "PH_CartDefinition",
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
    doc: {
      id: 0,
      cartname: data === null || data === void 0 ? void 0 : data.cartname,
      disptype: data === null || data === void 0 ? void 0 : data.disptype,
      locationid: data === null || data === void 0 ? void 0 : data.locationid,
      ward: data === null || data === void 0 ? void 0 : data.ward,
      Timings: data === null || data === void 0 ? void 0 : data.Timings,
      cartstatus: data === null || data === void 0 ? void 0 : data.cartstatus // remarks: "string",

    }
  }];
};
var GenerateUpdate = function GenerateUpdate(data) {
  return [{
    db_name: dbName,
    entity: "PH_CartDefinition",
    is_metadata: true,
    filter: {
      _key: data === null || data === void 0 ? void 0 : data._key
    },
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
    doc: {
      cartname: data === null || data === void 0 ? void 0 : data.cartname,
      disptype: data === null || data === void 0 ? void 0 : data.disptype,
      locationid: data === null || data === void 0 ? void 0 : data.locationid,
      ward: data === null || data === void 0 ? void 0 : data.ward,
      Timings: data === null || data === void 0 ? void 0 : data.Timings,
      cartstatus: data === null || data === void 0 ? void 0 : data.cartstatus // remarks: "string",

    }
  }];
};
var GenerateStatusUpdate = function GenerateStatusUpdate(data) {
  return [{
    db_name: dbName,
    entity: "PH_CartDefinition",
    filter: {
      _key: data === null || data === void 0 ? void 0 : data._key
    },
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
    doc: {
      cartstatus: data === null || data === void 0 ? void 0 : data.cartstatus
    }
  }];
};
var GenerateTransactionUpdate = function GenerateTransactionUpdate(data) {
  var _data$cartopenuserid, _data$cartcloseuserid;

  var filter = {};

  if (data !== null && data !== void 0 && data.isEdit) {
    filter = {
      filter: {
        cartid: data === null || data === void 0 ? void 0 : data.cartid
      }
    };
  }

  return [_objectSpread2(_objectSpread2({
    db_name: dbName,
    entity: "PH_CartTransaction",
    is_metadata: true
  }, filter), {}, {
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
    doc: {
      cartid: data === null || data === void 0 ? void 0 : data.cartid,
      startdate: data === null || data === void 0 ? void 0 : data.startdate,
      enddate: data === null || data === void 0 ? void 0 : data.enddate,
      cartopentime: data === null || data === void 0 ? void 0 : data.cartopentime,
      cartopenuserid: (_data$cartopenuserid = data === null || data === void 0 ? void 0 : data.cartopenuserid) !== null && _data$cartopenuserid !== void 0 ? _data$cartopenuserid : "",
      cartcloseuserid: (_data$cartcloseuserid = data === null || data === void 0 ? void 0 : data.cartcloseuserid) !== null && _data$cartcloseuserid !== void 0 ? _data$cartcloseuserid : "",
      cartclosetime: data === null || data === void 0 ? void 0 : data.cartclosetime,
      cartstatus: data === null || data === void 0 ? void 0 : data.cartstatus
    }
  })];
}; // [
//   {
//     db_name: "primarycare",
//     entity: "PH_CartTransaction",
//     is_metadata: true,
//     metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
//     doc: {
//       cartid: "string",
//       startdate: "number",
//       enddate: "number",
//       cartopentime: "number",
//       cartopenuserid: "string",
//       cartcloseuserid: "string",
//       cartclosetime: "number",
//       cartstatus: "string",
//       remarks: "string",
//       SourceSystemID: "string",
//       SourceSystemRefId: "string",
//     },
//   },
// ];

var getFormattedFullReadData = function getFormattedFullReadData(data) {
  return data.map(function (item) {
    var _item$Timings, _item$Timings$, _item$Timings$$weekda, _item$Ward;

    return _objectSpread2(_objectSpread2({}, item), {}, {
      Timings: item === null || item === void 0 ? void 0 : (_item$Timings = item.Timings) === null || _item$Timings === void 0 ? void 0 : (_item$Timings$ = _item$Timings[0]) === null || _item$Timings$ === void 0 ? void 0 : (_item$Timings$$weekda = _item$Timings$.weekdays) === null || _item$Timings$$weekda === void 0 ? void 0 : _item$Timings$$weekda.join(", "),
      Ward: item === null || item === void 0 ? void 0 : (_item$Ward = item.Ward) === null || _item$Ward === void 0 ? void 0 : _item$Ward.join(", ")
    });
  });
};

var _extraReducers$F;

var loopMasters$8 = function loopMasters(params) {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject) {
      var calls;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              calls = Object.keys(cartDefinitionOptionsQuery).map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return fetchMaster$8(val, cartDefinitionOptionsQuery[val]);

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
              es6Promise.Promise.all(calls).then(function (data) {
                var json = {};
                data.map(function (val) {
                  var arr = [];
                  val.data.map(function (value) {
                    switch (val.name) {
                      case "pharmacy":
                      case "ward":
                        arr.push(_objectSpread2({
                          label: value === null || value === void 0 ? void 0 : value.longdesc,
                          value: value === null || value === void 0 ? void 0 : value._id
                        }, value));
                        break;

                      default:
                        arr.push(_objectSpread2({
                          label: value === null || value === void 0 ? void 0 : value.display,
                          value: value === null || value === void 0 ? void 0 : value._id
                        }, value));
                        break;
                    }
                  });
                  json[val.name] = arr;
                  resolve(json);
                });
              })["catch"](function (err) {
                resolve([]);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var fetchMaster$8 = function fetchMaster(name, query, params) {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetchData({
                body: JSON.stringify(query(params))
              }, __readDocumentUrl__);

            case 2:
              data = _context3.sent;
              resolve({
                data: data.result,
                name: name
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }());
};

var CART_DEFINITION_MASTER_FULL_READ = toolkit.createAsyncThunk("cartDefinitionMasterSlice/cartDefinitionFullRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref5,
      rejectWithValue,
      page,
      perPage,
      _payload$searchQuery,
      searchQuery,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref5 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref5.rejectWithValue;
          _context4.prev = 2;
          page = payload.page, perPage = payload.perPage, _payload$searchQuery = payload.searchQuery, searchQuery = _payload$searchQuery === void 0 ? "" : _payload$searchQuery;
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(cartDefinitionMasterQuery.cartDefinitionFullRead(page, perPage, searchQuery))
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: getFormattedFullReadData(data.result)
          }));

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 10]]);
})));
var CART_DEFINITION_MASTER_FILTER = toolkit.createAsyncThunk("cartDefinitionMasterSlice/cartDefinitionFilter", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref7,
      rejectWithValue,
      filter,
      data,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref7 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref7.rejectWithValue;
          _context5.prev = 2;
          filter = payload.filter;
          _context5.next = 6;
          return fetchData({
            body: JSON.stringify(cartDefinitionMasterQuery.cartDefinitionFilter(filter))
          }, __readDocumentUrl__);

        case 6:
          data = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: getFormattedFullReadData(data.result)
          }));

        case 10:
          _context5.prev = 10;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 13:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 10]]);
})));
var CART_DEFINITION_MASTER_SINGLE_READ = toolkit.createAsyncThunk("cartDefinitionMasterSlice/cartDefinitionSingleRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref9,
      rejectWithValue,
      id,
      data,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref9 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref9.rejectWithValue;
          _context6.prev = 2;
          id = payload.id;
          _context6.next = 6;
          return fetchData({
            body: JSON.stringify(cartDefinitionMasterQuery.cartDefinitionSingleRead(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context6.sent;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context6.prev = 10;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 13:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 10]]);
})));
var CART_DEFINITION_MASTER_DROPDOWN_OPTIONS = toolkit.createAsyncThunk("cartDefinitionMasterSlice/cartDefinitionDropdownOptions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var _ref11,
      rejectWithValue,
      data,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _ref11 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref11.rejectWithValue;
          _context7.prev = 2;
          _context7.next = 5;
          return loopMasters$8();

        case 5:
          data = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 12:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 9]]);
})));
var CART_DEFINITION_INSERT = toolkit.createAsyncThunk("cartDefinitionMasterSlice/cartDefinitionInsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref13,
      rejectWithValue,
      body,
      Body,
      data,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref13 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref13.rejectWithValue;
          _context8.prev = 2;
          body = payload.body;
          Body = GenerateInsert(body);
          _context8.next = 7;
          return fetchData({
            body: JSON.stringify(Body)
          }, __uspsertUrl__);

        case 7:
          data = _context8.sent;
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 14:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 11]]);
})));
var CART_DEFINITION_UPDATE = toolkit.createAsyncThunk("cartDefinitionMasterSlice/cartDefinitionUpdate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref15,
      rejectWithValue,
      body,
      Body,
      data,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref15 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref15.rejectWithValue;
          _context9.prev = 2;
          body = payload.body;
          Body = GenerateUpdate(body);
          _context9.next = 7;
          return fetchData({
            body: JSON.stringify(Body)
          }, __uspsertUrl__);

        case 7:
          data = _context9.sent;
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context9.prev = 11;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 14:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 11]]);
})));
var CART_DEFINITION_STATUS_UPDATE = toolkit.createAsyncThunk("cartDefinitionMasterSlice/cartDefinitionStatusUpdate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref17,
      rejectWithValue,
      body,
      Body,
      data,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref17 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref17.rejectWithValue;
          _context10.prev = 2;
          body = payload.body;
          Body = GenerateStatusUpdate(body);
          _context10.next = 7;
          return fetchData({
            body: JSON.stringify(Body)
          }, __uspsertUrl__);

        case 7:
          data = _context10.sent;
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context10.prev = 11;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 14:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 11]]);
})));
var CART_DEFINITION_TRANSACTION_UPDATE = toolkit.createAsyncThunk("cartDefinitionMasterSlice/cartDefinitionTransactionUpdate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var payload,
      _ref19,
      rejectWithValue,
      body,
      Body,
      data,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
          _ref19 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref19.rejectWithValue;
          _context11.prev = 2;
          body = payload.body;
          Body = GenerateTransactionUpdate(body);
          _context11.next = 7;
          return fetchData({
            body: JSON.stringify(Body)
          }, __uspsertUrl__);

        case 7:
          data = _context11.sent;
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context11.prev = 11;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 14:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 11]]);
})));
var cartDefinitionMasterSlice = toolkit.createSlice({
  name: "cartDefinitionMasterSlice",
  initialState: {
    cartDefinitionMasterFullread: _objectSpread2({}, defaultState.List),
    cartDefinitionMasterSingleread: _objectSpread2({}, defaultState.List),
    cartDefinitionDropdownOptions: _objectSpread2({}, defaultState.Info),
    cartDefinitionInsert: _objectSpread2({}, defaultState.Info),
    cartDefinitionUpdate: _objectSpread2({}, defaultState.Info),
    cartDefinitionStatusUpdate: _objectSpread2({}, defaultState.Info),
    cartDefinitionMasterFilter: _objectSpread2({}, defaultState.List),
    cartDefinitionTransactionUpdate: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$F = {}, _defineProperty(_extraReducers$F, CART_DEFINITION_MASTER_FILTER.fulfilled, function (state, action) {
    var _action$payload;

    state.cartDefinitionMasterFilter = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_MASTER_FILTER.pending, function (state, action) {
    state.cartDefinitionMasterFilter.loading = true;
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_MASTER_FILTER.rejected, function (state, action) {
    var _action$payload2;

    state.cartDefinitionMasterFilter = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_MASTER_FULL_READ.fulfilled, function (state, action) {
    var _action$payload3;

    state.cartDefinitionMasterFullread = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_MASTER_FULL_READ.pending, function (state, action) {
    state.cartDefinitionMasterFullread.loading = true;
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_MASTER_FULL_READ.rejected, function (state, action) {
    var _action$payload4;

    state.cartDefinitionMasterFullread = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_MASTER_SINGLE_READ.fulfilled, function (state, action) {
    var _action$payload5;

    state.cartDefinitionMasterSingleread = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_MASTER_SINGLE_READ.pending, function (state, action) {
    state.cartDefinitionMasterSingleread.loading = true;
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_MASTER_SINGLE_READ.rejected, function (state, action) {
    var _action$payload6;

    state.cartDefinitionMasterSingleread = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_MASTER_DROPDOWN_OPTIONS.fulfilled, function (state, action) {
    var _action$payload7;

    state.cartDefinitionDropdownOptions = (_action$payload7 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload7 !== void 0 ? _action$payload7 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_MASTER_DROPDOWN_OPTIONS.pending, function (state, action) {
    state.cartDefinitionDropdownOptions.loading = true;
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_MASTER_DROPDOWN_OPTIONS.rejected, function (state, action) {
    var _action$payload8;

    state.cartDefinitionDropdownOptions = (_action$payload8 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload8 !== void 0 ? _action$payload8 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_INSERT.fulfilled, function (state, action) {
    var _action$payload9;

    state.cartDefinitionInsert = (_action$payload9 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload9 !== void 0 ? _action$payload9 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_INSERT.pending, function (state, action) {
    state.cartDefinitionInsert.loading = true;
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_INSERT.rejected, function (state, action) {
    var _action$payload10;

    state.cartDefinitionInsert = (_action$payload10 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload10 !== void 0 ? _action$payload10 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_UPDATE.fulfilled, function (state, action) {
    var _action$payload11;

    state.cartDefinitionUpdate = (_action$payload11 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload11 !== void 0 ? _action$payload11 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_UPDATE.pending, function (state, action) {
    state.cartDefinitionUpdate.loading = true;
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_UPDATE.rejected, function (state, action) {
    var _action$payload12;

    state.cartDefinitionUpdate = (_action$payload12 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload12 !== void 0 ? _action$payload12 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_STATUS_UPDATE.fulfilled, function (state, action) {
    var _action$payload13;

    state.cartDefinitionStatusUpdate = (_action$payload13 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload13 !== void 0 ? _action$payload13 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_STATUS_UPDATE.pending, function (state, action) {
    state.cartDefinitionStatusUpdate.loading = true;
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_STATUS_UPDATE.rejected, function (state, action) {
    var _action$payload14;

    state.cartDefinitionStatusUpdate = (_action$payload14 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload14 !== void 0 ? _action$payload14 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_TRANSACTION_UPDATE.fulfilled, function (state, action) {
    var _action$payload15;

    state.cartDefinitionTransactionUpdate = (_action$payload15 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload15 !== void 0 ? _action$payload15 : {};
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_TRANSACTION_UPDATE.pending, function (state, action) {
    state.cartDefinitionTransactionUpdate.loading = true;
  }), _defineProperty(_extraReducers$F, CART_DEFINITION_TRANSACTION_UPDATE.rejected, function (state, action) {
    var _action$payload16;

    state.cartDefinitionTransactionUpdate = (_action$payload16 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload16 !== void 0 ? _action$payload16 : {};
  }), _extraReducers$F)
}); // FrequencySchedule ACTION LISTS

var cartDefinitionMasterActions = {
  CART_DEFINITION_MASTER_FULL_READ: CART_DEFINITION_MASTER_FULL_READ,
  CART_DEFINITION_MASTER_SINGLE_READ: CART_DEFINITION_MASTER_SINGLE_READ,
  CART_DEFINITION_MASTER_DROPDOWN_OPTIONS: CART_DEFINITION_MASTER_DROPDOWN_OPTIONS,
  CART_DEFINITION_INSERT: CART_DEFINITION_INSERT,
  CART_DEFINITION_UPDATE: CART_DEFINITION_UPDATE,
  CART_DEFINITION_STATUS_UPDATE: CART_DEFINITION_STATUS_UPDATE,
  CART_DEFINITION_MASTER_FILTER: CART_DEFINITION_MASTER_FILTER,
  CART_DEFINITION_TRANSACTION_UPDATE: CART_DEFINITION_TRANSACTION_UPDATE
};
var cartDefinitionMasterSlice$1 = cartDefinitionMasterSlice.reducer;

var frequencyTypes = {
  dayBased: "CodingMaster/10925",
  detail: "CodingMaster/10923",
  interval: "CodingMaster/10924",
  sequential: "CodingMaster/10927",
  userDefined: "CodingMaster/10926"
};
var getDoseFrequencyValueBasedOnFrequencyType = function getDoseFrequencyValueBasedOnFrequencyType(_id, data) {
  var _frequencyValues;

  var _ref = data || {},
      totalNoOfDays = _ref.totalNoOfDays,
      dosePerDay = _ref.dosePerDay,
      onceEveryValue = _ref.onceEveryValue,
      intervalDays = _ref.intervalDays;

  var frequencyValues = (_frequencyValues = {}, _defineProperty(_frequencyValues, frequencyTypes.dayBased, Number(totalNoOfDays)), _defineProperty(_frequencyValues, frequencyTypes.detail, Number(dosePerDay)), _defineProperty(_frequencyValues, frequencyTypes.userDefined, Number(dosePerDay)), _defineProperty(_frequencyValues, frequencyTypes.interval, Number(onceEveryValue)), _defineProperty(_frequencyValues, frequencyTypes.sequential, Number(intervalDays)), _frequencyValues);
  return frequencyValues[_id];
};
var getScheduleLineBasedOnFrequencyType = function getScheduleLineBasedOnFrequencyType(_id, data) {
  var _frequencyValues2;

  var _ref2 = data || {},
      _ref2$dayBasedSchedul = _ref2.dayBasedSchedule,
      dayBasedSchedule = _ref2$dayBasedSchedul === void 0 ? [] : _ref2$dayBasedSchedul,
      _ref2$detailSchedule = _ref2.detailSchedule,
      detailSchedule = _ref2$detailSchedule === void 0 ? [] : _ref2$detailSchedule,
      _ref2$intervalSchedul = _ref2.intervalSchedule,
      intervalSchedule = _ref2$intervalSchedul === void 0 ? [] : _ref2$intervalSchedul,
      _ref2$sequentialSched = _ref2.sequentialSchedule,
      sequentialSchedule = _ref2$sequentialSched === void 0 ? [] : _ref2$sequentialSched,
      _ref2$userDefinedSche = _ref2.userDefinedSchedule,
      userDefinedSchedule = _ref2$userDefinedSche === void 0 ? [] : _ref2$userDefinedSche;

  var formattedDayBasedSchedule = [];
  var formattedDetailSchedule = [];
  var formattedIntervalSchedule = [];
  var formattedSequentialSchedule = [];
  var formattedUserDefinedSchedule = [];

  if (_id === frequencyTypes.dayBased) {
    dayBasedSchedule.forEach(function (item) {
      var _item$day, _item$basefreq;

      formattedDayBasedSchedule.push(_objectSpread2(_objectSpread2({}, item), {}, {
        day: item === null || item === void 0 ? void 0 : (_item$day = item.day) === null || _item$day === void 0 ? void 0 : _item$day._id,
        basefreq: item === null || item === void 0 ? void 0 : (_item$basefreq = item.basefreq) === null || _item$basefreq === void 0 ? void 0 : _item$basefreq._id
      }));
    });
  }

  if (_id === frequencyTypes.detail) {
    detailSchedule.forEach(function (item) {
      var _moment;

      formattedDetailSchedule.push(_objectSpread2(_objectSpread2({}, item), {}, {
        time: (_moment = moment__default["default"](item === null || item === void 0 ? void 0 : item.time)) !== null && _moment !== void 0 && _moment.isValid() ? moment__default["default"](item === null || item === void 0 ? void 0 : item.time).format("HH:mm") : "00:00"
      }));
    });
  }

  if (_id === frequencyTypes.interval) {
    intervalSchedule.forEach(function (item) {
      var _item$basefreq2;

      formattedIntervalSchedule.push(_objectSpread2(_objectSpread2({}, item), {}, {
        basefreq: item === null || item === void 0 ? void 0 : (_item$basefreq2 = item.basefreq) === null || _item$basefreq2 === void 0 ? void 0 : _item$basefreq2._id
      }));
    });
  }

  if (_id === frequencyTypes.sequential) {
    sequentialSchedule.forEach(function (item) {
      var _item$basefreq3;

      formattedSequentialSchedule.push(_objectSpread2(_objectSpread2({}, item), {}, {
        basefreq: item === null || item === void 0 ? void 0 : (_item$basefreq3 = item.basefreq) === null || _item$basefreq3 === void 0 ? void 0 : _item$basefreq3._id
      }));
    });
  }

  if (_id === frequencyTypes.userDefined) {
    userDefinedSchedule.forEach(function (item) {
      var _item$basefreq4;

      formattedUserDefinedSchedule.push(_objectSpread2(_objectSpread2({}, item), {}, {
        fromDay: Number(item === null || item === void 0 ? void 0 : item.fromDay),
        toDay: Number(item === null || item === void 0 ? void 0 : item.toDay),
        basefreq: item === null || item === void 0 ? void 0 : (_item$basefreq4 = item.basefreq) === null || _item$basefreq4 === void 0 ? void 0 : _item$basefreq4._id
      }));
    });
  }

  var frequencyValues = (_frequencyValues2 = {}, _defineProperty(_frequencyValues2, frequencyTypes.dayBased, formattedDayBasedSchedule), _defineProperty(_frequencyValues2, frequencyTypes.detail, formattedDetailSchedule), _defineProperty(_frequencyValues2, frequencyTypes.userDefined, formattedUserDefinedSchedule), _defineProperty(_frequencyValues2, frequencyTypes.interval, formattedIntervalSchedule), _defineProperty(_frequencyValues2, frequencyTypes.sequential, formattedSequentialSchedule), _frequencyValues2);
  return frequencyValues[_id];
};

var GenerateUpsert = function GenerateUpsert(data) {
  var _data$frequencyType$_, _data$frequencyType, _data$frequencyType2, _data$onceEveryUOM$_i, _data$onceEveryUOM, _data$fixedDurationUO, _data$fixedDurationUO2, _data$frequencyType3, _data$directionDtls, _data$directionDtls2;

  var filter = {};

  if (data !== null && data !== void 0 && data._key) {
    filter = {
      filter: {
        _key: data === null || data === void 0 ? void 0 : data._key
      }
    };
  }

  return [_objectSpread2(_objectSpread2({
    db_name: dbName,
    entity: "FrequencyMaster",
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
  }, filter), {}, {
    doc: {
      id: 0,
      freqcode: data === null || data === void 0 ? void 0 : data.frequencyCode,
      shortdesc: data === null || data === void 0 ? void 0 : data.frequencyName,
      frequencytype: (_data$frequencyType$_ = data === null || data === void 0 ? void 0 : (_data$frequencyType = data.frequencyType) === null || _data$frequencyType === void 0 ? void 0 : _data$frequencyType._id) !== null && _data$frequencyType$_ !== void 0 ? _data$frequencyType$_ : "",
      // longdesc: data?.addnewfrequency_org_longdesc,
      dosefreqval: getDoseFrequencyValueBasedOnFrequencyType(data === null || data === void 0 ? void 0 : (_data$frequencyType2 = data.frequencyType) === null || _data$frequencyType2 === void 0 ? void 0 : _data$frequencyType2._id, data),
      dosefreqvalUOM: (_data$onceEveryUOM$_i = data === null || data === void 0 ? void 0 : (_data$onceEveryUOM = data.onceEveryUOM) === null || _data$onceEveryUOM === void 0 ? void 0 : _data$onceEveryUOM._id) !== null && _data$onceEveryUOM$_i !== void 0 ? _data$onceEveryUOM$_i : "",
      graceperiod: Number(data === null || data === void 0 ? void 0 : data.dispenseGracePeriod),
      fixeddurationVal: Number(data === null || data === void 0 ? void 0 : data.fixedDurationValue),
      fixeddurUOM: (_data$fixedDurationUO = data === null || data === void 0 ? void 0 : (_data$fixedDurationUO2 = data.fixedDurationUOM) === null || _data$fixedDurationUO2 === void 0 ? void 0 : _data$fixedDurationUO2._id) !== null && _data$fixedDurationUO !== void 0 ? _data$fixedDurationUO : "",
      IsBaseFreq: data === null || data === void 0 ? void 0 : data.isBaseFrequency,
      status: data === null || data === void 0 ? void 0 : data.status,
      scheduleline: getScheduleLineBasedOnFrequencyType(data === null || data === void 0 ? void 0 : (_data$frequencyType3 = data.frequencyType) === null || _data$frequencyType3 === void 0 ? void 0 : _data$frequencyType3._id, data),
      directiontag: (data === null || data === void 0 ? void 0 : (_data$directionDtls = data.directionDtls) === null || _data$directionDtls === void 0 ? void 0 : _data$directionDtls.length) > 0 ? data === null || data === void 0 ? void 0 : data.directionDtls[0].directiontag : "",
      directiontaglocal: (data === null || data === void 0 ? void 0 : (_data$directionDtls2 = data.directionDtls) === null || _data$directionDtls2 === void 0 ? void 0 : _data$directionDtls2.length) > 0 ? data === null || data === void 0 ? void 0 : data.directionDtls[0].directiontaglocal : ""
    }
  })];
};

var frequencyMasterQuery = {
  singleRead: function singleRead(_key) {
    return {
      db_name: dbName,
      entity: "FrequencyMaster",
      filter: "FrequencyMaster._key=='".concat(_key, "' && FrequencyMaster.activestatus==true"),
      //${id} //PH_CartDefinition/10000
      return_fields: "merge(FrequencyMaster,{scheduleline:(for data in FrequencySchedule filter FrequencyMaster.scheduleline any == data._id return merge(data,{day:document(data.day)}))},{frequencytype:document(FrequencyMaster.frequencytype)},{dosefreqvalUOM:document(FrequencyMaster.dosefreqvalUOM)},{fixeddurUOM:document(FrequencyMaster.fixeddurUOM)})"
    }; // return {
    //   db_name: dbName,
    //   entity: "FrequencyMaster",
    //   filter:
    //     "FrequencyMaster._key=='" +
    //     payload?.editnewfrequency_org__key +
    //     "' && FrequencyMaster.activestatus==true",
    //   return_fields:
    //     "merge(FrequencyMaster,{scheduleline:(for data in FrequencySchedule filter FrequencyMaster.scheduleline any == data._id return merge(data,{day:document(data.day)}))},{frequencytype:document(FrequencyMaster.frequencytype)},{dosefreqvalUOM:document(FrequencyMaster.dosefreqvalUOM)},{fixeddurUOM:document(FrequencyMaster.fixeddurUOM)})",
    // };
  }
};
var uom_time_type = {
  "db_name": dbName,
  "entity": "DrugUOM",
  "filter": "document(DrugUOM.UOMType).code in ['DU010'] && DrugUOM.status==true && DrugUOM.activestatus==true",
  "return_fields": "keep(DrugUOM,'_id','UOM','UOMType','longdesc','shortdesc')"
};

var _extraReducers$E;
var FREQUENCY_UPSERT = toolkit.createAsyncThunk("frequencyMasterSlice/frequencyUpsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      Body,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          Body = GenerateUpsert(payload);
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(Body)
          }, __uspsertUrl__);

        case 6:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 10]]);
})));
var FREQUENCY_SINGLE_READ = toolkit.createAsyncThunk("frequencyMasterSlice/frequencySingleRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      _key,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          _key = payload._key;
          _context2.next = 6;
          return fetchData({
            body: JSON.stringify(frequencyMasterQuery.singleRead(_key))
          }, __readDocumentUrl__);

        case 6:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 13:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 10]]);
}))); // const UOM_TIME_TYPE_OPTIONS = createAsyncThunk(
//   "frequencyMasterSlice/frequencyUomTimeTypeOptions",
//   async (payload = {}, { rejectWithValue }) => {
//     try {
//       const data = await fetchData(
//         {
//           body: JSON.stringify(frequencyMasterQuery.singleRead(_key)),
//         },
//         __readDocumentUrl__
//       );
//       return {
//         ...defaultState.List,
//         data: data.result,
//       };
//     } catch (error) {
//       return rejectWithValue({
//         ...defaultReject,
//         message: error.message,
//       });
//     }
//   }
// );

var UOM_TIME_TYPE_OPTIONS = toolkit.createAsyncThunk("frequencyMasterSlice/frequencyUomTimeTypeOptions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var _ref6,
      rejectWithValue,
      data,
      _data,
      _data$result,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          _context3.next = 5;
          return fetchData({
            body: JSON.stringify(uom_time_type)
          }, __readDocumentUrl__);

        case 5:
          data = _context3.sent;

          if (!(data.result.length > 0)) {
            _context3.next = 11;
            break;
          }

          data = (_data = data) === null || _data === void 0 ? void 0 : (_data$result = _data.result) === null || _data$result === void 0 ? void 0 : _data$result.map(function (option) {
            return _objectSpread2({
              label: option === null || option === void 0 ? void 0 : option.shortdesc,
              value: option === null || option === void 0 ? void 0 : option._id
            }, option);
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: []
          }));

        case 12:
          _context3.next = 17;
          break;

        case 14:
          _context3.prev = 14;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 17:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 14]]);
})));
var frequencyMasterSlice = toolkit.createSlice({
  name: "frequencyMasterSlice",
  initialState: {
    frequencyUpsert: _objectSpread2({}, defaultState.Info),
    frequencySingleRead: _objectSpread2({}, defaultState.Info),
    frequencyUomTimeTypeOptions: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$E = {}, _defineProperty(_extraReducers$E, FREQUENCY_UPSERT.fulfilled, function (state, action) {
    var _action$payload;

    state.frequencyUpsert = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {};
  }), _defineProperty(_extraReducers$E, FREQUENCY_UPSERT.pending, function (state, action) {
    state.frequencyUpsert.loading = true;
  }), _defineProperty(_extraReducers$E, FREQUENCY_UPSERT.rejected, function (state, action) {
    var _action$payload2;

    state.frequencyUpsert = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {};
  }), _defineProperty(_extraReducers$E, FREQUENCY_SINGLE_READ.fulfilled, function (state, action) {
    var _action$payload3;

    state.frequencySingleRead = (_action$payload3 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload3 !== void 0 ? _action$payload3 : {};
  }), _defineProperty(_extraReducers$E, FREQUENCY_SINGLE_READ.pending, function (state, action) {
    state.frequencySingleRead.loading = true;
  }), _defineProperty(_extraReducers$E, FREQUENCY_SINGLE_READ.rejected, function (state, action) {
    var _action$payload4;

    state.frequencySingleRead = (_action$payload4 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload4 !== void 0 ? _action$payload4 : {};
  }), _defineProperty(_extraReducers$E, UOM_TIME_TYPE_OPTIONS.fulfilled, function (state, action) {
    var _action$payload5;

    state.frequencyUomTimeTypeOptions = (_action$payload5 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload5 !== void 0 ? _action$payload5 : {};
  }), _defineProperty(_extraReducers$E, UOM_TIME_TYPE_OPTIONS.pending, function (state, action) {
    state.frequencyUomTimeTypeOptions.loading = true;
  }), _defineProperty(_extraReducers$E, UOM_TIME_TYPE_OPTIONS.rejected, function (state, action) {
    var _action$payload6;

    state.frequencyUomTimeTypeOptions = (_action$payload6 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload6 !== void 0 ? _action$payload6 : {};
  }), _extraReducers$E)
}); // FrequencySchedule ACTION LISTS

var frequencyMasterActions = {
  FREQUENCY_UPSERT: FREQUENCY_UPSERT,
  FREQUENCY_SINGLE_READ: FREQUENCY_SINGLE_READ,
  UOM_TIME_TYPE_OPTIONS: UOM_TIME_TYPE_OPTIONS
};
var frequencyMasterSlice$1 = frequencyMasterSlice.reducer;

var queries$l = {
  careTypeRead: function careTypeRead() {
    return {
      db_name: dbName,
      entity: "CareType",
      filter: "CareType.activestatus==true",
      return_fields: "{id:CareType.id,_id:CareType._id,careType:CareType.careType,description:CareType.description,carelevelRank:CareType.carelevelRank}"
    };
  },
  levelOfCareRead: function levelOfCareRead() {
    return {
      db_name: dbName,
      entity: "LevelOfCare",
      filter: "LevelOfCare.activestatus==true",
      return_fields: "{id:LevelOfCare.id,_id:LevelOfCare._id,levelofcareCode:LevelOfCare.levelofcareCode,description:LevelOfCare.description,careType:document(LevelOfCare.careType),active:LevelOfCare.active,key:LevelOfCare._key}",
      sort: "LevelOfCare.createddate"
    };
  },
  levelOfCareSinleRead: function levelOfCareSinleRead(key) {
    return {
      db_name: dbName,
      entity: "LevelOfCare",
      filter: "LevelOfCare.activestatus==true && LevelOfCare._key=='".concat(key, "'"),
      return_fields: "{id:LevelOfCare.id,_id:LevelOfCare._id,levelofcareCode:LevelOfCare.levelofcareCode,description:LevelOfCare.description,careType:document(LevelOfCare.careType),active:LevelOfCare.active}"
    };
  },
  status_update_level_of_care: function status_update_level_of_care(data) {
    return [{
      db_name: dbName,
      entity: "LevelOfCare",
      filter: {
        _key: data._key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        active: data.status
      }
    }];
  },
  insert_level_Of_care: function insert_level_Of_care(data) {
    var filter = {};

    if (data._key) {
      filter = {
        filter: {
          _key: data._key
        }
      };
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "LevelOfCare"
    }, filter), {}, {
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        levelofcareCode: data.levelofcareCode,
        description: data.description,
        careType: data.careType,
        active: data.status,
        id: data.id
      }
    })];
  },
  //HEALTH CARE SERVICE READ
  healthCareServiceRead: function healthCareServiceRead() {
    return {
      db_name: dbName,
      entity: "HealthcareService",
      filter: "HealthcareService.activestatus==true",
      return_fields: "  {id:HealthcareService.id,_id:HealthcareService._id,_key:HealthcareService._key,active:HealthcareService.active,comment:HealthcareService.comment,SpecialtyID:document(HealthcareService.SpecialtyID),healthcareservicecode:HealthcareService.healthcareservicecode,name:HealthcareService.name,notes:HealthcareService.notes,category:document(HealthcareService.category),Type:document(HealthcareService.Type),applicablefacilities:HealthcareService.applicablefacilities ==null?null :(for hs in TO_ARRAY( HealthcareService.applicablefacilities) return {facility:document(hs.facility),locationtype:document(hs.locationtype),locationid:document(hs.locationid)})}",
      sort: "HealthcareService.createddate"
    };
  },
  //HEALTH CARE SERVICE STATUS CHANGE
  healthCareServiceStatusChange: function healthCareServiceStatusChange(data) {
    return [{
      db_name: dbName,
      entity: "HealthcareService",
      filter: {
        _key: data._key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        active: data.status
      }
    }];
  },
  //HEALTH CARE SERVICE EDIT
  // editHealthCareService: (_key) => {
  //   return {
  //     db_name: dbName,
  //     entity: "HealthcareService",
  //     filter: `HealthcareService.activestatus==true && HealthcareService._key=='${_key}'`,
  //     return_fields: "  {id:HealthcareService.id,_id:HealthcareService._id,_key:HealthcareService._key,active:HealthcareService.active,comment:HealthcareService.comment,SpecialtyID:document(HealthcareService.SpecialtyID),healthcareservicecode:HealthcareService.healthcareservicecode,name:HealthcareService.name,notes:HealthcareService.notes,category:document(HealthcareService.category),Type:document(HealthcareService.Type),applicablefacilities:HealthcareService.applicablefacilities ==null?null :(for hs in TO_ARRAY( HealthcareService.applicablefacilities) return {facility:document(hs.facility),locationtype:document(hs.locationtype),locationid:document(hs.locationid)})}"
  //   }
  // },
  editHealthCareService: function editHealthCareService(_key) {
    return {
      db_name: dbName,
      entity: "HealthcareService",
      filter: "HealthcareService.activestatus==true && HealthcareService._key=='".concat(_key, "'"),
      return_fields: " {id:HealthcareService.id,_id:HealthcareService._id,_key:HealthcareService._key,active:HealthcareService.active,comment:HealthcareService.comment,SpecialtyID:document(HealthcareService.SpecialtyID),healthcareservicecode:HealthcareService.healthcareservicecode,name:HealthcareService.name,notes:HealthcareService.notes,category:document(HealthcareService.category),Type:document(HealthcareService.Type),applicablefacilities:HealthcareService.applicablefacilities ==null?null :(for hs in TO_ARRAY( HealthcareService.applicablefacilities) return {facility:document(hs.facility),locationtype:(for loc in CodeableConceptMaster filter loc._id == hs.locationtype return merge(loc,{coding:(document(loc.coding))})),locationid:document(hs.locationid)})}"
    };
  },
  //SPECIALITY READ
  specialityRead: function specialityRead() {
    return {
      db_name: dbName,
      entity: "Specialty",
      filter: "Specialty.activestatus==true && Specialty.parentspecialtyCode==''",
      return_fields: "merge(Specialty,{facilities:document(Specialty.facilities)},{parentspecialtyCode:document(Specialty.parentspecialtyCode)})"
    };
  },
  //SPECIALITY CHILD READ
  specialityChildRead: function specialityChildRead(id) {
    return {
      db_name: dbName,
      entity: "Specialty",
      filter: "Specialty.activestatus==true && Specialty.parentspecialtyCode=='".concat(id, "'"),
      return_fields: "merge(Specialty,{facilities:document(Specialty.facilities)},{parentspecialtyCode:document(Specialty.parentspecialtyCode)})"
    };
  },
  //SPECIALITY EDIT
  editSpeciality: function editSpeciality(_key) {
    return {
      db_name: dbName,
      entity: "Specialty",
      filter: "Specialty.activestatus==true && Specialty._key=='".concat(_key, "'"),
      return_fields: "merge(Specialty,{facilities:(for fac in document(Specialty.facilities) return merge(fac,{orgId:document(fac.orgId)}))},{parentspecialtyCode:document(Specialty.parentspecialtyCode)})"
    };
  }
};

var generateJson$b = function generateJson(data) {
  var _data$status, _data$serviceDescript, _data$comment, _data$id, _data$speciality$valu, _data$speciality, _data$serviceCategory, _data$serviceCategory2, _data$serviceType$val, _data$serviceType, _data$serviceCode;

  var filter = {};

  if (data._key_id) {
    filter = {
      filter: {
        _key: data._key_id
      }
    };
  }

  var arr = [_objectSpread2(_objectSpread2({
    "db_name": dbName,
    "entity": "HealthcareService"
  }, filter), {}, {
    "is_metadata": true,
    "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
    "doc": {
      "active": (_data$status = data.status) !== null && _data$status !== void 0 ? _data$status : "",
      "name": (_data$serviceDescript = data.serviceDescription) !== null && _data$serviceDescript !== void 0 ? _data$serviceDescript : "",
      "comment": (_data$comment = data.comment) !== null && _data$comment !== void 0 ? _data$comment : "",
      "id": (_data$id = data.id) !== null && _data$id !== void 0 ? _data$id : "",
      "SpecialtyID": (_data$speciality$valu = (_data$speciality = data.speciality) === null || _data$speciality === void 0 ? void 0 : _data$speciality.value) !== null && _data$speciality$valu !== void 0 ? _data$speciality$valu : "",
      "category": (_data$serviceCategory = (_data$serviceCategory2 = data.serviceCategory) === null || _data$serviceCategory2 === void 0 ? void 0 : _data$serviceCategory2.value) !== null && _data$serviceCategory !== void 0 ? _data$serviceCategory : "",
      "Type": (_data$serviceType$val = (_data$serviceType = data.serviceType) === null || _data$serviceType === void 0 ? void 0 : _data$serviceType.value) !== null && _data$serviceType$val !== void 0 ? _data$serviceType$val : "",
      "healthcareservicecode": (_data$serviceCode = data.serviceCode) !== null && _data$serviceCode !== void 0 ? _data$serviceCode : "",
      "notes": data.notes,
      "applicablefacilities": generateApplicableFacility(data.applicableFacilities)
    }
  })];
  return arr;
};

var generateApplicableFacility = function generateApplicableFacility(data) {
  var arr = [];
  data.map(function (val) {
    var _val$facilityName, _val$locationType_, _val$locationIdDescri;

    arr.push({
      "facility": (_val$facilityName = val.facilityName) === null || _val$facilityName === void 0 ? void 0 : _val$facilityName.value,
      "locationtype": (_val$locationType_ = val.locationType_) === null || _val$locationType_ === void 0 ? void 0 : _val$locationType_.value,
      "locationid": (_val$locationIdDescri = val.locationIdDescription) === null || _val$locationIdDescri === void 0 ? void 0 : _val$locationIdDescri.value
    });
  });
  return arr;
};

var generateJsonSpeciality = function generateJsonSpeciality(data) {
  var _data$specialityCode, _data$specialityDescr, _data$parentSpecialit, _data$status2, _data$lastLevel, _data$id2;

  var filter = {};

  if (data._key_id) {
    filter = {
      filter: {
        _key: data._key_id
      }
    };
  }

  var arr = [_objectSpread2(_objectSpread2({
    "db_name": dbName,
    "entity": "Specialty"
  }, filter), {}, {
    "is_metadata": true,
    "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
    "doc": {
      "specialtyCode": (_data$specialityCode = data.specialityCode) !== null && _data$specialityCode !== void 0 ? _data$specialityCode : "",
      "description": (_data$specialityDescr = data.specialityDescription) !== null && _data$specialityDescr !== void 0 ? _data$specialityDescr : "",
      "parentspecialtyCode": (_data$parentSpecialit = data.parentSpeciality.value) !== null && _data$parentSpecialit !== void 0 ? _data$parentSpecialit : "",
      "active": (_data$status2 = data.status) !== null && _data$status2 !== void 0 ? _data$status2 : true,
      "islastLevel": (_data$lastLevel = data.lastLevel) !== null && _data$lastLevel !== void 0 ? _data$lastLevel : true,
      "id": (_data$id2 = data.id) !== null && _data$id2 !== void 0 ? _data$id2 : "",
      "facilities": generateApplicableFacility_(data.applicableFacilities)
    }
  })];
  return arr;
};

var generateApplicableFacility_ = function generateApplicableFacility_(data) {
  var arr = [];
  data.map(function (val) {
    var _val$facilityName$val;

    arr.push({
      orgId: (_val$facilityName$val = val.facilityName.value) !== null && _val$facilityName$val !== void 0 ? _val$facilityName$val : "",
      effFrom: moment__default["default"](val === null || val === void 0 ? void 0 : val.effectiveFrom).unix(),
      effTo: moment__default["default"](val === null || val === void 0 ? void 0 : val.effectiveTo).unix(),
      id: 0
    });
  });
  return arr;
};

var generateHealthCareServiceReadJSON = function generateHealthCareServiceReadJSON(val, state) {
  var json = {
    id: val.id,
    _key: val._key,
    _id: val.id,
    serviceCode: val.healthcareservicecode,
    serviceDescription: val.name,
    comment: val.comment,
    notes: val.notes,
    status: val.active,
    speciality: {
      value: val.SpecialtyID._id,
      label: val.SpecialtyID.display
    },
    serviceType: {
      value: val.Type._id,
      label: val.Type.display
    },
    serviceCategory: {
      value: val.category._id,
      label: val.category.display
    },
    // speciality: val.SpecialtyID
    //     ? state.health_care_service_master.speciality.find(
    //         (sys) => val.SpecialtyID._id.indexOf(sys.value) > -1
    //       ) 
    //     : null,
    applicableFacilities: generateapplicableFacilities(val.applicablefacilities)
  };
  return json;
};

var generateapplicableFacilities = function generateapplicableFacilities(data) {
  var applicableFacilitiesArr_ = data.map(function (v_) {
    var _v_$facility$_id, _v_$facility, _v_$facility$name, _v_$facility2, _v_$locationtype$0$_i, _v_$locationtype, _v_$locationtype$, _v_$locationtype$0$co, _v_$locationtype2, _v_$locationtype2$, _v_$locationtype2$$co, _v_$locationtype2$$co2, _v_$locationid$_id, _v_$locationid, _v_$locationid$shortd, _v_$locationid2;

    return {
      facilityName: v_.facility ? {
        value: (_v_$facility$_id = (_v_$facility = v_.facility) === null || _v_$facility === void 0 ? void 0 : _v_$facility._id) !== null && _v_$facility$_id !== void 0 ? _v_$facility$_id : "",
        label: (_v_$facility$name = (_v_$facility2 = v_.facility) === null || _v_$facility2 === void 0 ? void 0 : _v_$facility2.name) !== null && _v_$facility$name !== void 0 ? _v_$facility$name : ""
      } : {},
      locationType_: v_.locationtype ? {
        value: (_v_$locationtype$0$_i = (_v_$locationtype = v_.locationtype) === null || _v_$locationtype === void 0 ? void 0 : (_v_$locationtype$ = _v_$locationtype[0]) === null || _v_$locationtype$ === void 0 ? void 0 : _v_$locationtype$._id) !== null && _v_$locationtype$0$_i !== void 0 ? _v_$locationtype$0$_i : "",
        label: (_v_$locationtype$0$co = (_v_$locationtype2 = v_.locationtype) === null || _v_$locationtype2 === void 0 ? void 0 : (_v_$locationtype2$ = _v_$locationtype2[0]) === null || _v_$locationtype2$ === void 0 ? void 0 : (_v_$locationtype2$$co = _v_$locationtype2$.coding) === null || _v_$locationtype2$$co === void 0 ? void 0 : (_v_$locationtype2$$co2 = _v_$locationtype2$$co[0]) === null || _v_$locationtype2$$co2 === void 0 ? void 0 : _v_$locationtype2$$co2.display) !== null && _v_$locationtype$0$co !== void 0 ? _v_$locationtype$0$co : ""
      } : {},
      locationIdDescription: v_.locationid ? {
        value: (_v_$locationid$_id = (_v_$locationid = v_.locationid) === null || _v_$locationid === void 0 ? void 0 : _v_$locationid._id) !== null && _v_$locationid$_id !== void 0 ? _v_$locationid$_id : "",
        label: (_v_$locationid$shortd = (_v_$locationid2 = v_.locationid) === null || _v_$locationid2 === void 0 ? void 0 : _v_$locationid2.shortdesc) !== null && _v_$locationid$shortd !== void 0 ? _v_$locationid$shortd : ""
      } : {}
    };
  });
  return applicableFacilitiesArr_;
}; //EDIT SPECIALITY READ JSON


var generateSpecialityReadJSON = function generateSpecialityReadJSON(val, state_) {
  var json = {
    id: val.id,
    _key: val._key,
    _id: val.id,
    specialityCode: val.specialtyCode,
    specialityDescription: val.description,
    lastLevel: val.islastLevel,
    status: val.active,
    // parentSpeciality: val.parentspecialtyCode 
    //     ? state_.speciality_master_parent_speciality?.data.find(
    //         (sys) => val.parentspecialtyCode.indexOf(sys.value) > -1
    //       ) 
    //     : null,
    parentSpeciality: val.parentspecialtyCode ? {
      value: val.parentspecialtyCode._id,
      label: val.parentspecialtyCode.description
    } : {},
    applicableFacilities: generateapplicableFacility(val.facilities)
  };
  return json;
};

var generateapplicableFacility = function generateapplicableFacility(data, state) {
  var applicableFacilitiesArr = data.map(function (v) {
    return {
      // facilityName:  (v.orgId && Array.isArray(v.orgId) && v.orgId.length >0)
      // ? state.speciality_master_facility?.data.find(
      //     (sys) => v.facilities?._id.indexOf(sys.value) > -1
      //   ) 
      // : null,
      facilityName: v.orgId ? {
        value: v.orgId._id,
        label: v.orgId.name
      } : {},
      effectiveFrom: v.effFrom ? moment__default["default"](v.openingtime).format("DD MMM,YYYY") : "",
      effectiveTo: v.effTo ? moment__default["default"](v.effTo).format("DD MMM,YYYY") : "",
      id: v.id,
      _id: v._id,
      _key: v._key,
      status: v.active
    };
  });
  return applicableFacilitiesArr;
};

var masterQuery$7 = {
  careTypeMasterQuery: function careTypeMasterQuery() {
    return {
      db_name: dbName,
      entity: "CareType",
      sort: "CareType.description",
      filter: "CareType.activestatus==true",
      return_fields: "{id:CareType.id,_id:CareType._id,careType:CareType.careType,description:CareType.description,carelevelRank:CareType.carelevelRank}"
    };
  },
  healthcareservice_LocationDescription_MasterQuery: function healthcareservice_LocationDescription_MasterQuery(id) {
    return {
      db_name: dbName,
      entity: "LocationMaster",
      sort: "LocationMaster.locationID",
      filter: "LocationMaster.activestatus==true && LocationMaster.locationType=='".concat(id, "'"),
      return_fields: "{_id:LocationMaster._id,_key:LocationMaster._key,id:LocationMaster.id,shortdesc:LocationMaster.shortdesc,longdesc:LocationMaster.longdesc,locationID:LocationMaster.locationID,locationType:(for cod in CodeableConceptMaster filter cod._id==LocationMaster.locationType return {Coding:document(cod.coding)})}"
    };
  },
  specialityMasterParentSpeciality: function specialityMasterParentSpeciality() {
    return {
      db_name: dbName,
      entity: "Specialty",
      filter: "Specialty.activestatus==true",
      return_fields: "{_id:Specialty._id,_key:Specialty._key,id:Specialty.id,specialtyCode:Specialty.specialtyCode,description:Specialty.description,parentspecialtyCode:document(Specialty.parentspecialtyCode).specialtyCode}"
    };
  },
  specialityMasterFacility: function specialityMasterFacility() {
    return {
      db_name: dbName,
      entity: "Organization",
      filter: "Organization.activestatus==true && lower(first(document(Organization.OrgType)[*].display)) == 'facility'",
      return_fields: "{_id:Organization._id,_key:Organization._key,id:Organization.id,name:Organization.name,alias:Organization.alias}"
    };
  }
};
var masterQueryHealthCareService = {
  serviceCategory: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodingMaster\",\n    \"sort\":\"CodingMaster.display\",\n    \"filter\": \"CodingMaster.activestatus==true && CodingMaster.Type=='SERVICECATEGORY'\",\n    \"return_fields\": \"CodingMaster\"\n  }"),
  serviceType: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodingMaster\",\n     \"sort\":\"CodingMaster.display\",\n    \"filter\": \"CodingMaster.activestatus==true && CodingMaster.Type=='SERVICETYPE'\",\n    \"return_fields\": \"CodingMaster\"\n  }"),
  speciality: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodeableConceptMaster\",\n    \"filter\": \"CodeableConceptMaster.Type=='SPECIALTY' && CodeableConceptMaster.activestatus==true\",\n    \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\",\n    \"sort\": \"document(CodeableConceptMaster.coding[0]).display\"\n  }"),
  facilityName: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"Organization\",\n    \"sort\":\"Organization.name\",\n    \"filter\": \"Organization.activestatus==true && lower(first(document(Organization.OrgType)[*].display)) == 'facility'\",\n    \"return_fields\": \"{_id:Organization._id,_key:Organization._key,id:Organization.id,name:Organization.name,alias:Organization.alias}\"\n  }"),
  // locationType : `{
  //   "db_name": dbName,
  //   "entity": "CodingMaster",
  //   "filter": "CodingMaster.activestatus==true && CodingMaster.Type=='LOCATIONTYPE'",
  //   "return_fields": "CodingMaster"
  // }`,
  locationType: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodeableConceptMaster\",\n    \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n    \"filter\": \"CodeableConceptMaster.Type=='LOCATIONTYPE' && CodeableConceptMaster.activestatus==true\",\n    \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }")
};

var _extraReducers$D;
//CARE TYPE READ

var CARE_TYPE_READ = toolkit.createAsyncThunk("organizationConfigApiSlice/careTypeRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return fetchData({
            body: JSON.stringify(queries$l.careTypeRead())
          }, __readDocumentUrl__);

        case 5:
          data = _context.sent;
          arry = [];

          if (data.result) {
            data.result.map(function (val) {
              arry.push({
                id: val.id,
                _id: val._id,
                careType: val.careType,
                description: val.description,
                carelevelRank: val.carelevelRank
              });
            });
          }

          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
}))); //LEVEL OF CARE READ

var LEVEL_OF_CARE_READ = toolkit.createAsyncThunk("organizationConfigApiSlice/levelOfCareRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var _ref4,
      rejectWithValue,
      data,
      arry,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          _context2.next = 5;
          return fetchData({
            body: JSON.stringify(queries$l.levelOfCareRead())
          }, __readDocumentUrl__);

        case 5:
          data = _context2.sent;
          arry = [];

          if (data.result) {
            data.result.map(function (val) {
              var _val$id, _val$_id, _val$key, _val$levelofcareCode, _val$description, _val$careType$descrip, _val$careType$_id, _val$active;

              arry.push({
                id: (_val$id = val.id) !== null && _val$id !== void 0 ? _val$id : "",
                _id: (_val$_id = val._id) !== null && _val$_id !== void 0 ? _val$_id : "",
                key: (_val$key = val.key) !== null && _val$key !== void 0 ? _val$key : "",
                levelofcareCode: (_val$levelofcareCode = val.levelofcareCode) !== null && _val$levelofcareCode !== void 0 ? _val$levelofcareCode : "",
                description: (_val$description = val.description) !== null && _val$description !== void 0 ? _val$description : "",
                careType: (_val$careType$descrip = val.careType.description) !== null && _val$careType$descrip !== void 0 ? _val$careType$descrip : "",
                careTypeId: (_val$careType$_id = val.careType._id) !== null && _val$careType$_id !== void 0 ? _val$careType$_id : "",
                status: (_val$active = val.active) !== null && _val$active !== void 0 ? _val$active : ""
              });
            });
          }

          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
}))); //LEVEL OF CARE SINGLE READ

var LEVEL_OF_CARE_SINGLE_READ = toolkit.createAsyncThunk("organizationConfigApiSlice/levelOfCareSingleRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      _key,
      data,
      data_,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          _key = payload._key;
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(queries$l.levelOfCareSinleRead(_key))
          }, __readDocumentUrl__);

        case 6:
          data = _context3.sent;
          data_ = data.result[0];
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data_
          }));

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 11]]);
}))); //LEVEL OF CARE STATUS CHANGE

var LEVEL_OF_CARE_STATUS_CHANGE = toolkit.createAsyncThunk("organizationConfigApiSlice/levelOfCareStatus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      statuschange,
      queriesjson,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          statuschange = {
            _key: payload.key,
            status: payload.status
          };
          queriesjson = queries$l.status_update_level_of_care(statuschange);
          _context4.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 11]]);
}))); //LEVEL OF CARE INSERT

var LEVEL_OF_CARE_INSERT = toolkit.createAsyncThunk("organizationConfigApiSlice/levelOfCareInsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      queriesjson,
      res,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          //let { data } = payload;
          queriesjson = queries$l.insert_level_Of_care(payload);
          _context5.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 6:
          res = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 10:
          _context5.prev = 10;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 13:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 10]]);
}))); //HEALTH CARE SERVICE READ

var HEALTH_CARE_SERVICE_READ = toolkit.createAsyncThunk("organizationConfigApiSlice/healthCareServiceRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var _ref12,
      rejectWithValue,
      data,
      arry,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          _context6.next = 5;
          return fetchData({
            body: JSON.stringify(queries$l.healthCareServiceRead())
          }, __readDocumentUrl__);

        case 5:
          data = _context6.sent;
          arry = [];

          if (data.result) {
            data.result.map(function (val) {
              var _val$id2, _val$_id2, _val$_key, _val$healthcareservic, _val$name, _val$category$display, _val$category, _val$Type$display, _val$Type, _val$active2;

              arry.push({
                id: (_val$id2 = val.id) !== null && _val$id2 !== void 0 ? _val$id2 : "",
                _id: (_val$_id2 = val._id) !== null && _val$_id2 !== void 0 ? _val$_id2 : "",
                _key: (_val$_key = val._key) !== null && _val$_key !== void 0 ? _val$_key : "",
                healthcareservicecode: (_val$healthcareservic = val.healthcareservicecode) !== null && _val$healthcareservic !== void 0 ? _val$healthcareservic : "",
                name: (_val$name = val.name) !== null && _val$name !== void 0 ? _val$name : "",
                category: (_val$category$display = (_val$category = val.category) === null || _val$category === void 0 ? void 0 : _val$category.display) !== null && _val$category$display !== void 0 ? _val$category$display : "",
                Type: (_val$Type$display = (_val$Type = val.Type) === null || _val$Type === void 0 ? void 0 : _val$Type.display) !== null && _val$Type$display !== void 0 ? _val$Type$display : "",
                status: (_val$active2 = val.active) !== null && _val$active2 !== void 0 ? _val$active2 : ""
              });
            });
          }

          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 14:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 11]]);
}))); //HEALTH_CARE_SERVICE_STATUS_CHANGE

var HEALTH_CARE_SERVICE_STATUS_CHANGE = toolkit.createAsyncThunk("organizationConfigApiSlice/healthCareServiceStatus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      statuschange,
      queriesjson,
      data,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          statuschange = {
            _key: payload._key,
            status: payload.status
          };
          queriesjson = queries$l.healthCareServiceStatusChange(statuschange);
          _context7.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context7.prev = 11;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 14:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 11]]);
}))); //HEALTH_CARE_SERVICE_INSERT

var HEALTH_CARE_SERVICE_INSERT = toolkit.createAsyncThunk("organizationConfigApiSlice/save_health_care_service", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref16,
      rejectWithValue,
      dataList,
      queriesjson,
      data,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref16 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref16.rejectWithValue;
          _context8.prev = 2;
          dataList = payload.dataList;
          queriesjson = generateJson$b(dataList);
          _context8.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context8.sent;
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 14:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 11]]);
}))); //let fileds = ["serviceCategory", "serviceType", "locationType"];

var fileds$4 = ["serviceCategory", "serviceType"];

var loopMasters$7 = function loopMasters() {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(resolve, reject) {
      var calls;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              calls = Object.keys(masterQueryHealthCareService).map( /*#__PURE__*/function () {
                var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(val) {
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return fetchMaster$7(val, masterQueryHealthCareService[val]);

                        case 2:
                          return _context9.abrupt("return", _context9.sent);

                        case 3:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }));

                return function (_x3) {
                  return _ref18.apply(this, arguments);
                };
              }());
              es6Promise.Promise.all(calls).then(function (data) {
                var json = {};
                data.map(function (val) {
                  var arr = [];
                  val.data.map(function (value) {
                    if (fileds$4.includes(val.name)) {
                      arr.push({
                        label: value.display,
                        value: value._id
                      });
                    } else if ("speciality" === val.name) {
                      var _value$coding, _value$coding$, _value$coding2, _value$coding2$;

                      arr.push({
                        label: value === null || value === void 0 ? void 0 : (_value$coding = value.coding) === null || _value$coding === void 0 ? void 0 : (_value$coding$ = _value$coding[0]) === null || _value$coding$ === void 0 ? void 0 : _value$coding$.display,
                        value: value === null || value === void 0 ? void 0 : (_value$coding2 = value.coding) === null || _value$coding2 === void 0 ? void 0 : (_value$coding2$ = _value$coding2[0]) === null || _value$coding2$ === void 0 ? void 0 : _value$coding2$._id
                      });
                    } else if ("facilityName" === val.name) {
                      arr.push({
                        label: value.name,
                        value: value._id
                      });
                    } else if ("locationType" === val.name) {
                      arr.push({
                        label: value.coding[0].display,
                        value: value._id
                      });
                    }
                  });
                  json[val.name] = arr;
                  resolve(json);
                });
              })["catch"](function (err) {
                resolve([]);
              });

            case 2:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x, _x2) {
      return _ref17.apply(this, arguments);
    };
  }());
};

var fetchMaster$7 = function fetchMaster(name, query) {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(resolve, reject) {
      var data;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return fetchData({
                body: query
              }, __readDocumentUrl__);

            case 2:
              data = _context11.sent;
              resolve({
                data: data.result,
                name: name
              });

            case 4:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function (_x4, _x5) {
      return _ref19.apply(this, arguments);
    };
  }());
};

var HEALTH_CARE_SERVICE_MASTER_LOCATION_DESCRIPTION = toolkit.createAsyncThunk("organizationConfigApiSlice/healthcareServiceLocationDescription", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var payload,
      _ref21,
      rejectWithValue,
      id,
      data,
      arry,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
          _ref21 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref21.rejectWithValue;
          _context12.prev = 2;
          id = payload.id;
          _context12.next = 6;
          return fetchData({
            body: JSON.stringify(masterQuery$7.healthcareservice_LocationDescription_MasterQuery(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context12.sent;
          arry = [];
          data.result.map(function (val) {
            var _val$locationID, _val$_id3;

            arry.push({
              label: (_val$locationID = val.locationID) !== null && _val$locationID !== void 0 ? _val$locationID : "",
              value: (_val$_id3 = val._id) !== null && _val$_id3 !== void 0 ? _val$_id3 : ""
            });
          });
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context12.prev = 12;
          _context12.t0 = _context12["catch"](2);
          alert("error");
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 16:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 12]]);
})));
var HEALTH_CARE_SERVICE_MASTER = toolkit.createAsyncThunk("organizationConfigApiSlice/health_care_service_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
  var payload,
      _ref23,
      rejectWithValue,
      data,
      _args13 = arguments;

  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          payload = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {};
          _ref23 = _args13.length > 1 ? _args13[1] : undefined, rejectWithValue = _ref23.rejectWithValue;
          _context13.prev = 2;
          payload.type;
          _context13.next = 6;
          return loopMasters$7();

        case 6:
          data = _context13.sent;
          return _context13.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 10:
          _context13.prev = 10;
          _context13.t0 = _context13["catch"](2);
          return _context13.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context13.t0.message
          })));

        case 13:
        case "end":
          return _context13.stop();
      }
    }
  }, _callee13, null, [[2, 10]]);
})));
var EDIT_HEALTH_CARE_SERVICE = toolkit.createAsyncThunk("organizationConfigApiSlice/editHealthCareService", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
  var payload,
      _ref25,
      rejectWithValue,
      getState,
      id,
      state,
      data,
      res,
      _args14 = arguments;

  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          payload = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : {};
          _ref25 = _args14.length > 1 ? _args14[1] : undefined, rejectWithValue = _ref25.rejectWithValue, getState = _ref25.getState;
          _context14.prev = 2;
          id = payload.id;
          state = getState();
          state.organizationConfigSlice;
          _context14.next = 8;
          return fetchData({
            body: JSON.stringify(queries$l.editHealthCareService(id))
          }, __readDocumentUrl__);

        case 8:
          data = _context14.sent;
          res = generateHealthCareServiceReadJSON(data.result[0]);
          return _context14.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 13:
          _context14.prev = 13;
          _context14.t0 = _context14["catch"](2);
          return _context14.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context14.t0.message
          })));

        case 16:
        case "end":
          return _context14.stop();
      }
    }
  }, _callee14, null, [[2, 13]]);
}))); //SPECIALITY_READ

var SPECIALITY_READ = toolkit.createAsyncThunk("organizationConfigApiSlice/specialityRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
  var _ref27,
      rejectWithValue,
      data,
      arry,
      _args15 = arguments;

  return _regeneratorRuntime().wrap(function _callee15$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _ref27 = _args15.length > 1 ? _args15[1] : undefined, rejectWithValue = _ref27.rejectWithValue;
          _context15.prev = 2;
          _context15.next = 5;
          return fetchData({
            body: JSON.stringify(queries$l.specialityRead())
          }, __readDocumentUrl__);

        case 5:
          data = _context15.sent;
          arry = [];

          if (data.result) {
            data.result.map(function (val) {
              var _val$id3, _val$_id4, _val$_key2, _val$specialtyCode, _val$description2, _val$active3;

              arry.push({
                id: (_val$id3 = val.id) !== null && _val$id3 !== void 0 ? _val$id3 : "",
                _id: (_val$_id4 = val._id) !== null && _val$_id4 !== void 0 ? _val$_id4 : "",
                _key: (_val$_key2 = val._key) !== null && _val$_key2 !== void 0 ? _val$_key2 : "",
                specialtyCode: (_val$specialtyCode = val.specialtyCode) !== null && _val$specialtyCode !== void 0 ? _val$specialtyCode : "",
                description: (_val$description2 = val.description) !== null && _val$description2 !== void 0 ? _val$description2 : "",
                status: (_val$active3 = val.active) !== null && _val$active3 !== void 0 ? _val$active3 : true,
                children: []
              });
            });
          }

          return _context15.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context15.prev = 11;
          _context15.t0 = _context15["catch"](2);
          return _context15.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context15.t0.message
          })));

        case 14:
        case "end":
          return _context15.stop();
      }
    }
  }, _callee15, null, [[2, 11]]);
}))); //SPECIALITY_CHILD_READ

var SPECIALITY_CHILD_READ = toolkit.createAsyncThunk("organizationConfigApiSlice/specialityChildRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
  var payload,
      _ref29,
      rejectWithValue,
      id,
      data,
      arry,
      _args16 = arguments;

  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          payload = _args16.length > 0 && _args16[0] !== undefined ? _args16[0] : {};
          _ref29 = _args16.length > 1 ? _args16[1] : undefined, rejectWithValue = _ref29.rejectWithValue;
          _context16.prev = 2;
          id = payload.id;
          _context16.next = 6;
          return fetchData({
            body: JSON.stringify(queries$l.specialityChildRead(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context16.sent;
          arry = [];

          if (data.result) {
            data.result.map(function (val) {
              var _val$id4, _val$_id5, _val$_key3, _val$specialtyCode2, _val$description3, _val$active4;

              arry.push({
                id: (_val$id4 = val.id) !== null && _val$id4 !== void 0 ? _val$id4 : "",
                _id: (_val$_id5 = val._id) !== null && _val$_id5 !== void 0 ? _val$_id5 : "",
                _key: (_val$_key3 = val._key) !== null && _val$_key3 !== void 0 ? _val$_key3 : "",
                specialtyCode: (_val$specialtyCode2 = val.specialtyCode) !== null && _val$specialtyCode2 !== void 0 ? _val$specialtyCode2 : "",
                description: (_val$description3 = val.description) !== null && _val$description3 !== void 0 ? _val$description3 : "",
                status: (_val$active4 = val.active) !== null && _val$active4 !== void 0 ? _val$active4 : true
              });
            });
          }

          return _context16.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context16.prev = 12;
          _context16.t0 = _context16["catch"](2);
          return _context16.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context16.t0.message
          })));

        case 15:
        case "end":
          return _context16.stop();
      }
    }
  }, _callee16, null, [[2, 12]]);
}))); //SPECIALTY_INSERT

var SPECIALTY_INSERT = toolkit.createAsyncThunk("organizationConfigApiSlice/specialityInsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
  var payload,
      _ref31,
      rejectWithValue,
      dataList,
      queriesjson,
      data,
      _args17 = arguments;

  return _regeneratorRuntime().wrap(function _callee17$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          payload = _args17.length > 0 && _args17[0] !== undefined ? _args17[0] : {};
          _ref31 = _args17.length > 1 ? _args17[1] : undefined, rejectWithValue = _ref31.rejectWithValue;
          _context17.prev = 2;
          dataList = payload.dataList;
          queriesjson = generateJsonSpeciality(dataList);
          _context17.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context17.sent;
          return _context17.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context17.prev = 11;
          _context17.t0 = _context17["catch"](2);
          return _context17.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context17.t0.message
          })));

        case 14:
        case "end":
          return _context17.stop();
      }
    }
  }, _callee17, null, [[2, 11]]);
})));
var SPECIALITY_MASTER_PARENT_SPECIALITY = toolkit.createAsyncThunk("organizationConfigApiSlice/specialityMasterParentSpeciality", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
  var payload,
      _ref33,
      rejectWithValue,
      id,
      data,
      arry,
      _args18 = arguments;

  return _regeneratorRuntime().wrap(function _callee18$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          payload = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : {};
          _ref33 = _args18.length > 1 ? _args18[1] : undefined, rejectWithValue = _ref33.rejectWithValue;
          _context18.prev = 2;
          id = payload.id;
          _context18.next = 6;
          return fetchData({
            body: JSON.stringify(masterQuery$7.specialityMasterParentSpeciality(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context18.sent;
          arry = [];
          data.result.map(function (val) {
            var _val$description4, _val$_id6;

            arry.push({
              label: (_val$description4 = val.description) !== null && _val$description4 !== void 0 ? _val$description4 : "",
              value: (_val$_id6 = val._id) !== null && _val$_id6 !== void 0 ? _val$_id6 : ""
            });
          });
          return _context18.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context18.prev = 12;
          _context18.t0 = _context18["catch"](2);
          alert("error");
          return _context18.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context18.t0.message
          })));

        case 16:
        case "end":
          return _context18.stop();
      }
    }
  }, _callee18, null, [[2, 12]]);
})));
var SPECIALITY_MASTER_FACILITY = toolkit.createAsyncThunk("organizationConfigApiSlice/specialityMasterFacility", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
  var _ref35,
      rejectWithValue,
      data,
      arry,
      _args19 = arguments;

  return _regeneratorRuntime().wrap(function _callee19$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _ref35 = _args19.length > 1 ? _args19[1] : undefined, rejectWithValue = _ref35.rejectWithValue;
          _context19.prev = 2;
          _context19.next = 5;
          return fetchData({
            body: JSON.stringify(masterQuery$7.specialityMasterFacility())
          }, __readDocumentUrl__);

        case 5:
          data = _context19.sent;
          arry = [];
          data.result.map(function (val) {
            var _val$name2, _val$_id7;

            arry.push({
              label: (_val$name2 = val.name) !== null && _val$name2 !== void 0 ? _val$name2 : "",
              value: (_val$_id7 = val._id) !== null && _val$_id7 !== void 0 ? _val$_id7 : ""
            });
          });
          return _context19.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context19.prev = 11;
          _context19.t0 = _context19["catch"](2);
          alert("error");
          return _context19.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context19.t0.message
          })));

        case 15:
        case "end":
          return _context19.stop();
      }
    }
  }, _callee19, null, [[2, 11]]);
}))); //EDIT_SPECIALITY

var EDIT_SPECIALITY = toolkit.createAsyncThunk("organizationConfigApiSlice/editSpeciality", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
  var payload,
      _ref37,
      rejectWithValue,
      getState,
      id,
      state,
      data,
      res,
      _args20 = arguments;

  return _regeneratorRuntime().wrap(function _callee20$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          payload = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : {};
          _ref37 = _args20.length > 1 ? _args20[1] : undefined, rejectWithValue = _ref37.rejectWithValue, getState = _ref37.getState;
          _context20.prev = 2;
          id = payload.id;
          state = getState();
          state.organizationConfigSlice;
          _context20.next = 8;
          return fetchData({
            body: JSON.stringify(queries$l.editSpeciality(id))
          }, __readDocumentUrl__);

        case 8:
          data = _context20.sent;
          res = generateSpecialityReadJSON(data.result[0]);
          return _context20.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 13:
          _context20.prev = 13;
          _context20.t0 = _context20["catch"](2);
          return _context20.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context20.t0.message
          })));

        case 16:
        case "end":
          return _context20.stop();
      }
    }
  }, _callee20, null, [[2, 13]]);
})));
var organizationConfigSlice = toolkit.createSlice({
  name: "organizationConfigApiSlice",
  initialState: {
    care_type_list: _objectSpread2({}, defaultState.List),
    level_of_care_list: _objectSpread2({}, defaultState.List),
    level_of_care_status_change: _objectSpread2({}, defaultState.List),
    level_of_care_insert: _objectSpread2({}, defaultState.List),
    level_of_care_single_read: _objectSpread2({}, defaultState.List),
    health_care_service_read: _objectSpread2({}, defaultState.List),
    health_care_service_status_change: _objectSpread2({}, defaultState.List),
    health_care_service_insert: _objectSpread2({}, defaultState.List),
    health_care_service_master: _objectSpread2({}, defaultState.Info),
    health_care_service_master_location_description: _objectSpread2({}, defaultState.Info),
    health_care_service_single_read: _objectSpread2({}, defaultState.List),
    speciality_read: _objectSpread2({}, defaultState.List),
    speciality_child_read: _objectSpread2({}, defaultState.List),
    speciality_insert: _objectSpread2({}, defaultState.List),
    speciality_master_facility: _objectSpread2({}, defaultState.Info),
    speciality_master_parent_speciality: _objectSpread2({}, defaultState.Info),
    speciality_edit: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$D = {}, _defineProperty(_extraReducers$D, SPECIALITY_MASTER_PARENT_SPECIALITY.fulfilled, function (state, action) {
    state.speciality_master_parent_speciality.loading = false, state.speciality_master_parent_speciality.error = false, state.speciality_master_parent_speciality = action.payload;
  }), _defineProperty(_extraReducers$D, SPECIALITY_MASTER_PARENT_SPECIALITY.pending, function (state, action) {
    state.speciality_master_parent_speciality.loading = true, state.speciality_master_parent_speciality.error = false, state.speciality_master_parent_speciality.loading = true;
  }), _defineProperty(_extraReducers$D, SPECIALITY_MASTER_PARENT_SPECIALITY.rejected, function (state, action) {
    state.speciality_master_parent_speciality.loading = false, state.speciality_master_parent_speciality.error = true, state.speciality_master_parent_speciality = action.payload;
  }), _defineProperty(_extraReducers$D, SPECIALITY_MASTER_FACILITY.fulfilled, function (state, action) {
    state.speciality_master_facility.loading = false, state.speciality_master_facility.error = false, state.speciality_master_facility = action.payload;
  }), _defineProperty(_extraReducers$D, SPECIALITY_MASTER_FACILITY.pending, function (state, action) {
    state.speciality_master_facility.loading = true, state.speciality_master_facility.error = false, state.speciality_master_facility.loading = true;
  }), _defineProperty(_extraReducers$D, SPECIALITY_MASTER_FACILITY.rejected, function (state, action) {
    state.speciality_master_facility.loading = false, state.speciality_master_facility.error = true, state.speciality_master_facility = action.payload;
  }), _defineProperty(_extraReducers$D, CARE_TYPE_READ.fulfilled, function (state, action) {
    state.care_type_list.loading = false, state.care_type_list.error = false, state.care_type_list = action.payload;
  }), _defineProperty(_extraReducers$D, CARE_TYPE_READ.pending, function (state, action) {
    state.care_type_list.loading = true, state.care_type_list.error = false, state.care_type_list.loading = true;
  }), _defineProperty(_extraReducers$D, CARE_TYPE_READ.rejected, function (state, action) {
    state.care_type_list.loading = false, state.care_type_list.error = true, state.care_type_list = action.payload;
  }), _defineProperty(_extraReducers$D, LEVEL_OF_CARE_READ.fulfilled, function (state, action) {
    state.level_of_care_list.loading = false, state.level_of_care_list.error = false, state.level_of_care_list = action.payload;
  }), _defineProperty(_extraReducers$D, LEVEL_OF_CARE_READ.pending, function (state, action) {
    state.level_of_care_list.loading = true, state.level_of_care_list.error = false, state.level_of_care_list.loading = true;
  }), _defineProperty(_extraReducers$D, LEVEL_OF_CARE_READ.rejected, function (state, action) {
    state.level_of_care_list.loading = false, state.level_of_care_list.error = true, state.level_of_care_list = action.payload;
  }), _defineProperty(_extraReducers$D, LEVEL_OF_CARE_STATUS_CHANGE.fulfilled, function (state, action) {
    state.level_of_care_status_change.loading = false, state.level_of_care_status_change.error = false, state.level_of_care_status_change = action.payload;
  }), _defineProperty(_extraReducers$D, LEVEL_OF_CARE_STATUS_CHANGE.pending, function (state, action) {
    state.level_of_care_status_change.loading = true, state.level_of_care_status_change.error = false, state.level_of_care_status_change.loading = true;
  }), _defineProperty(_extraReducers$D, LEVEL_OF_CARE_STATUS_CHANGE.rejected, function (state, action) {
    state.level_of_care_status_change.loading = false, state.level_of_care_status_change.error = true, state.level_of_care_status_change = action.payload;
  }), _defineProperty(_extraReducers$D, LEVEL_OF_CARE_INSERT.fulfilled, function (state, action) {
    state.level_of_care_insert.loading = false, state.level_of_care_insert.error = false, state.level_of_care_insert = action.payload;
  }), _defineProperty(_extraReducers$D, LEVEL_OF_CARE_INSERT.pending, function (state, action) {
    state.level_of_care_insert.loading = true, state.level_of_care_insert.error = false, state.level_of_care_insert.loading = true;
  }), _defineProperty(_extraReducers$D, LEVEL_OF_CARE_INSERT.rejected, function (state, action) {
    state.level_of_care_insert.loading = false, state.level_of_care_insert.error = true, state.level_of_care_insert = action.payload;
  }), _defineProperty(_extraReducers$D, LEVEL_OF_CARE_SINGLE_READ.fulfilled, function (state, action) {
    state.level_of_care_single_read.loading = false, state.level_of_care_single_read.error = false, state.level_of_care_single_read = action.payload;
  }), _defineProperty(_extraReducers$D, LEVEL_OF_CARE_SINGLE_READ.pending, function (state, action) {
    state.level_of_care_single_read.loading = true, state.level_of_care_single_read.error = false, state.level_of_care_single_read.loading = true;
  }), _defineProperty(_extraReducers$D, LEVEL_OF_CARE_SINGLE_READ.rejected, function (state, action) {
    state.level_of_care_single_read.loading = false, state.level_of_care_single_read.error = true, state.level_of_care_single_read = action.payload;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_READ.fulfilled, function (state, action) {
    state.health_care_service_read.loading = false, state.health_care_service_read.error = false, state.health_care_service_read = action.payload;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_READ.pending, function (state, action) {
    state.health_care_service_read.loading = true, state.health_care_service_read.error = false, state.health_care_service_read.loading = true;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_READ.rejected, function (state, action) {
    state.health_care_service_read.loading = false, state.health_care_service_read.error = true, state.health_care_service_read = action.payload;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_STATUS_CHANGE.fulfilled, function (state, action) {
    state.health_care_service_status_change.loading = false, state.health_care_service_status_change.error = false, state.health_care_service_status_change = action.payload;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_STATUS_CHANGE.pending, function (state, action) {
    state.health_care_service_status_change.loading = true, state.health_care_service_status_change.error = false, state.health_care_service_status_change.loading = true;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_STATUS_CHANGE.rejected, function (state, action) {
    state.health_care_service_status_change.loading = false, state.health_care_service_status_change.error = true, state.health_care_service_status_change = action.payload;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_INSERT.fulfilled, function (state, action) {
    state.health_care_service_insert.loading = false, state.health_care_service_insert.error = false, state.health_care_service_insert = action.payload;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_INSERT.pending, function (state, action) {
    state.health_care_service_insert.loading = true, state.health_care_service_insert.error = false, state.health_care_service_insert.loading = true;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_INSERT.rejected, function (state, action) {
    state.health_care_service_insert.loading = false, state.health_care_service_insert.error = true, state.health_care_service_insert = action.payload;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_MASTER.fulfilled, function (state, action) {
    state.health_care_service_master.loading = false, state.health_care_service_master.error = false, state.health_care_service_master = action.payload;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_MASTER.pending, function (state, action) {
    state.health_care_service_master.loading = true, state.health_care_service_master.error = false, state.health_care_service_master.loading = true;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_MASTER.rejected, function (state, action) {
    state.health_care_service_master.loading = false, state.health_care_service_master.error = true, state.health_care_service_master = action.payload;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_MASTER_LOCATION_DESCRIPTION.fulfilled, function (state, action) {
    state.health_care_service_master_location_description.loading = false, state.health_care_service_master_location_description.error = false, state.health_care_service_master_location_description = action.payload;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_MASTER_LOCATION_DESCRIPTION.pending, function (state, action) {
    state.health_care_service_master_location_description.loading = true, state.health_care_service_master_location_description.error = false, state.health_care_service_master_location_description.loading = true;
  }), _defineProperty(_extraReducers$D, HEALTH_CARE_SERVICE_MASTER_LOCATION_DESCRIPTION.rejected, function (state, action) {
    state.health_care_service_master_location_description.loading = false, state.health_care_service_master_location_description.error = true, state.health_care_service_master_location_description = action.payload;
  }), _defineProperty(_extraReducers$D, EDIT_HEALTH_CARE_SERVICE.fulfilled, function (state, action) {
    state.health_care_service_single_read.loading = false, state.health_care_service_single_read.error = false, state.health_care_service_single_read = action.payload;
  }), _defineProperty(_extraReducers$D, EDIT_HEALTH_CARE_SERVICE.pending, function (state, action) {
    state.health_care_service_single_read.loading = true, state.health_care_service_single_read.error = false, state.health_care_service_single_read.loading = true;
  }), _defineProperty(_extraReducers$D, EDIT_HEALTH_CARE_SERVICE.rejected, function (state, action) {
    state.health_care_service_single_read.loading = false, state.health_care_service_single_read.error = true, state.health_care_service_single_read = action.payload;
  }), _defineProperty(_extraReducers$D, SPECIALITY_READ.fulfilled, function (state, action) {
    state.speciality_read.loading = false, state.speciality_read.error = false, state.speciality_read = action.payload;
  }), _defineProperty(_extraReducers$D, SPECIALITY_READ.pending, function (state, action) {
    state.speciality_read.loading = true, state.speciality_read.error = false, state.speciality_read.loading = true;
  }), _defineProperty(_extraReducers$D, SPECIALITY_READ.rejected, function (state, action) {
    state.speciality_read.loading = false, state.speciality_read.error = true, state.speciality_read = action.payload;
  }), _defineProperty(_extraReducers$D, SPECIALITY_CHILD_READ.fulfilled, function (state, action) {
    state.speciality_child_read.loading = false, state.speciality_child_read.error = false, state.speciality_child_read = action.payload;
  }), _defineProperty(_extraReducers$D, SPECIALITY_CHILD_READ.pending, function (state, action) {
    state.speciality_child_read.loading = true, state.speciality_child_read.error = false, state.speciality_child_read.loading = true;
  }), _defineProperty(_extraReducers$D, SPECIALITY_CHILD_READ.rejected, function (state, action) {
    state.speciality_child_read.loading = false, state.speciality_child_read.error = true, state.speciality_child_read = action.payload;
  }), _defineProperty(_extraReducers$D, SPECIALTY_INSERT.fulfilled, function (state, action) {
    state.speciality_insert.loading = false, state.speciality_insert.error = false, state.speciality_insert = action.payload;
  }), _defineProperty(_extraReducers$D, SPECIALTY_INSERT.pending, function (state, action) {
    state.speciality_insert.loading = true, state.speciality_insert.error = false, state.speciality_insert.loading = true;
  }), _defineProperty(_extraReducers$D, SPECIALTY_INSERT.rejected, function (state, action) {
    state.speciality_insert.loading = false, state.speciality_insert.error = true, state.speciality_insert = action.payload;
  }), _defineProperty(_extraReducers$D, EDIT_SPECIALITY.fulfilled, function (state, action) {
    state.speciality_edit.loading = false, state.speciality_edit.error = false, state.speciality_edit = action.payload;
  }), _defineProperty(_extraReducers$D, EDIT_SPECIALITY.pending, function (state, action) {
    state.speciality_edit.loading = true, state.speciality_edit.error = false, state.speciality_edit.loading = true;
  }), _defineProperty(_extraReducers$D, EDIT_SPECIALITY.rejected, function (state, action) {
    state.speciality_edit.loading = false, state.speciality_edit.error = true, state.speciality_edit = action.payload;
  }), _extraReducers$D)
});
var organizationConfigActions = {
  CARE_TYPE_READ: CARE_TYPE_READ,
  LEVEL_OF_CARE_READ: LEVEL_OF_CARE_READ,
  LEVEL_OF_CARE_STATUS_CHANGE: LEVEL_OF_CARE_STATUS_CHANGE,
  LEVEL_OF_CARE_INSERT: LEVEL_OF_CARE_INSERT,
  LEVEL_OF_CARE_SINGLE_READ: LEVEL_OF_CARE_SINGLE_READ,
  HEALTH_CARE_SERVICE_READ: HEALTH_CARE_SERVICE_READ,
  HEALTH_CARE_SERVICE_STATUS_CHANGE: HEALTH_CARE_SERVICE_STATUS_CHANGE,
  HEALTH_CARE_SERVICE_INSERT: HEALTH_CARE_SERVICE_INSERT,
  HEALTH_CARE_SERVICE_MASTER: HEALTH_CARE_SERVICE_MASTER,
  HEALTH_CARE_SERVICE_MASTER_LOCATION_DESCRIPTION: HEALTH_CARE_SERVICE_MASTER_LOCATION_DESCRIPTION,
  EDIT_HEALTH_CARE_SERVICE: EDIT_HEALTH_CARE_SERVICE,
  SPECIALITY_READ: SPECIALITY_READ,
  SPECIALITY_CHILD_READ: SPECIALITY_CHILD_READ,
  SPECIALTY_INSERT: SPECIALTY_INSERT,
  SPECIALITY_MASTER_PARENT_SPECIALITY: SPECIALITY_MASTER_PARENT_SPECIALITY,
  SPECIALITY_MASTER_FACILITY: SPECIALITY_MASTER_FACILITY,
  EDIT_SPECIALITY: EDIT_SPECIALITY
};
var organizationConfigSlice$1 = organizationConfigSlice.reducer;

var _extraReducers$C;
var CARE_TYPE_MASTERS = toolkit.createAsyncThunk("organizationConfigMasterAPISlice/care_type_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return fetchData({
            body: JSON.stringify(masterQuery$7.careTypeMasterQuery())
          }, __readDocumentUrl__);

        case 5:
          data = _context.sent;
          arry = [];
          data.result.map(function (val) {
            var _val$_id, _val$description;

            arry.push({
              value: (_val$_id = val._id) !== null && _val$_id !== void 0 ? _val$_id : "",
              label: (_val$description = val.description) !== null && _val$description !== void 0 ? _val$description : ""
            });
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          alert("error");
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var organizationConfigMasterSlice = toolkit.createSlice({
  name: "organizationConfigMasterAPISlice",
  initialState: {
    care_type_master: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$C = {}, _defineProperty(_extraReducers$C, CARE_TYPE_MASTERS.fulfilled, function (state, action) {
    state.care_type_master.loading = false, state.care_type_master.error = false, state.care_type_master = action.payload;
  }), _defineProperty(_extraReducers$C, CARE_TYPE_MASTERS.pending, function (state, action) {
    state.care_type_master.loading = true, state.care_type_master.error = false;
  }), _defineProperty(_extraReducers$C, CARE_TYPE_MASTERS.rejected, function (state, action) {
    state.care_type_master.loading = false, state.care_type_master.error = true, state.care_type_master = action.payload;
  }), _extraReducers$C)
});
var organizationConfigMasterActions = {
  CARE_TYPE_MASTERS: CARE_TYPE_MASTERS
};
var organizationConfigMasterSlice$1 = organizationConfigMasterSlice.reducer;

// import { dbName } from "../../qdm_query_ids";
var queries$k = {
  getTreeStuct: function getTreeStuct(type) {
    return {
      db_name: dbName,
      entity: "Organization",
      // filter: "'CodingMaster/11898' IN Organization.OrgType",
      filter: "Organization.ParentOrgID ==[] && Organization.activestatus==true &&  Organization.isExternal==".concat(type.isexternal),
      // return_fields: "MERGE(Organization,{Organization:(FOR org IN Organization  FILTER Organization.id IN org.ParentOrgID AND 'CodingMaster/11899' IN org.OrgType   RETURN MERGE(org,{facility:(FOR fac IN Organization FILTER 'CodingMaster/11058' IN fac.OrgType AND org.id IN fac.ParentOrgID RETURN fac)}) )})",
      return_fields: "MERGE(Organization,{Organization:(FOR org IN Organization  FILTER Organization.id IN org.ParentOrgID  RETURN MERGE(org,{facility:(FOR fac IN Organization FILTER org.id IN fac.ParentOrgID RETURN fac)}) )})",
      sort: "Organization.createddate desc"
    };
  },
  entityType: function entityType() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='ORGTYPE' AND CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN TO_ARRAY(CodeableConceptMaster.coding) RETURN DOCUMENT(cod))})"
    };
  },
  getParentEntityFull: function getParentEntityFull() {
    return {
      db_name: dbName,
      entity: "Organization",
      sort: "Organization.name",
      filter: "Organization.activestatus==true AND Organization.active==true",
      return_fields: "{_id:Organization._id,_key:Organization._key,id:Organization.id,name:Organization.name,alias:Organization.alias}"
    };
  },
  getParentEntity: function getParentEntity(type) {
    // return {
    // 	db_name: dbName,
    // 	entity: "Organization",
    // 	sort: "Organization.name",
    // 	filter: `Organization.activestatus==true AND Organization.active==true && Organization.isExternal==${type.isexternal} && Organization.OrgType === '${type.entityType}'`,
    // 	return_fields:
    // 		"{_id:Organization._id,_key:Organization._key,id:Organization.id,name:Organization.name,alias:Organization.alias}",
    // };
    return {
      "db_name": dbName,
      "entity": "Organization",
      "sort": "Organization.name",
      "filter": "Organization.activestatus==true AND Organization.active==true && Organization.isExternal==".concat(type.isexternal, " && DOCUMENT(Organization.OrgType)[*].code ANY == '").concat(type.entityType, "'"),
      "return_fields": "{OrgType: Organization.OrgType, _id:Organization._id,_key:Organization._key,id:Organization.id,name:Organization.name,alias:Organization.alias}"
    };
  },
  getLevelOfCare: function getLevelOfCare() {
    return {
      db_name: dbName,
      entity: "LevelOfCare",
      sort: "LevelOfCare.description",
      filter: "LevelOfCare.active==true && LevelOfCare.activestatus==true",
      return_fields: "{id:LevelOfCare.id,_id:LevelOfCare._id,levelofcareCode:LevelOfCare.levelofcareCode,description:LevelOfCare.description,careType:document(LevelOfCare.careType),active:LevelOfCare.active}"
    };
  },
  orgUseIdenifi: function orgUseIdenifi() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='USE' AND CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN TO_ARRAY(CodeableConceptMaster.coding) RETURN DOCUMENT(cod))})"
    };
  },
  orgIdTypeIdenifi: function orgIdTypeIdenifi() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='ORGIDENTIFICATIONTYPE' AND CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN TO_ARRAY(CodeableConceptMaster.coding) RETURN DOCUMENT(cod))})"
    };
  },
  aliastype: function aliastype() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='ACCOUNTENTITYTYPE' AND CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN TO_ARRAY(CodeableConceptMaster.coding) RETURN DOCUMENT(cod))})"
    };
  },
  //ORGANIZATION TREE DETAILS
  getTreeDetails: function getTreeDetails(_key) {
    return {
      "db_name": dbName,
      "entity": "Organization",
      "filter": "Organization._key=='".concat(_key, "' AND Organization.activestatus==true"),
      "return_fields": "MERGE(Organization, {identifier:(FOR iden IN TO_ARRAY(Organization.identifier) RETURN MERGE(DOCUMENT(iden), {user:DOCUMENT(DOCUMENT(iden).user),period:(FOR per IN TO_ARRAY(DOCUMENT(iden).period) RETURN DOCUMENT(per) ),Type:DOCUMENT(DOCUMENT(iden).Type)})) , address:(FOR add IN TO_ARRAY(Organization.address) RETURN MERGE(DOCUMENT(add),{Type:DOCUMENT(DOCUMENT(add).Type),use:DOCUMENT(DOCUMENT(add).use),city:DOCUMENT(DOCUMENT(add).city),country:DOCUMENT(DOCUMENT(add).country),district:DOCUMENT(DOCUMENT(add).district),state:DOCUMENT(DOCUMENT(add).state),postalCode:DOCUMENT(DOCUMENT(add).postalCode)})) ,alias:(FOR alias IN TO_ARRAY(Organization.alias) RETURN MERGE(alias,{aliasType:DOCUMENT(alias.aliasType) ,aliasCode:DOCUMENT(alias.aliasCode) })) ,levelofcareid:DOCUMENT(Organization.levelofcareid) ,logo:(FOR attc IN TO_ARRAY(Organization.logo) RETURN DOCUMENT(attc)) ,telecom:(FOR tel IN TO_ARRAY(Organization.telecom) RETURN MERGE(DOCUMENT(tel),{system:DOCUMENT(DOCUMENT(tel).system),use:DOCUMENT(DOCUMENT(tel).use),rank:DOCUMENT(DOCUMENT(tel).rank) ,valueprefix:DOCUMENT(DOCUMENT(tel).valueprefix)})) , contact:(FOR cnt IN TO_ARRAY(Organization.contact) RETURN MERGE(cnt,{telecom:(FOR tel IN TO_ARRAY(cnt.telecom) RETURN MERGE(DOCUMENT(tel),{use:DOCUMENT(DOCUMENT(tel).use),system:DOCUMENT(DOCUMENT(tel).system),rank:DOCUMENT(DOCUMENT(tel).rank),valueprefix:DOCUMENT(DOCUMENT(tel).valueprefix) })),name:(FOR nm IN TO_ARRAY(cnt.name) RETURN MERGE(DOCUMENT(nm),{use:DOCUMENT(DOCUMENT(nm).use),prefix:DOCUMENT(DOCUMENT(nm).prefix),suffix:DOCUMENT(DOCUMENT(nm).suffix)})),designation:DOCUMENT(cnt.designation)}) ),OrgType:(FOR org IN TO_ARRAY(Organization.OrgType) RETURN DOCUMENT(org)),specialtyDetails:(FOR spec IN TO_ARRAY(Organization.specialtyDetails) RETURN MERGE(spec,{specialty:document(spec.specialty)})),orgdateformat:document(Organization.orgdateformat),orgtimeformat:document(Organization.orgtimeformat),orgdatetimeformat:document(Organization.orgdatetimeformat) })"
    };
  },
  //GET PARENT ORG NAME BY ID
  getParentOrgNameById: function getParentOrgNameById(_key) {
    return {
      db_name: dbName,
      entity: "Organization",
      filter: "Organization.id == ".concat(_key),
      return_fields: "{_id:Organization._id,_key:Organization._key,id:Organization.id,name:Organization.name,parentorgid:Organization.ParentOrgID}"
    };
  },
  //UPSERT STATUS
  upsertSatus: function upsertSatus(key, status) {
    return [{
      db_name: dbName,
      entity: "Organization",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      filter: {
        _key: "".concat(key)
      },
      doc: {
        active: status
      }
    }];
  },
  orgAddType: function orgAddType() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='ADDRESSTYPE'",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  orgAddUSE: function orgAddUSE() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='ADDRESSUSE'",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  orgAddCity: function orgAddCity() {
    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      sort: "SMGeographicMaster.geogLevelName",
      filter: "Lower(DOCUMENT(SMGeographicMaster.geogLevelType).display)=='city' && SMGeographicMaster.activestatus == true && SMGeographicMaster.active == true",
      return_fields: "{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode,geogLevelCode:SMGeographicMaster.geogLevelCode}"
    };
  },
  orgAddDISTRICT: function orgAddDISTRICT(val) {
    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      sort: "SMGeographicMaster.geogLevelName",
      filter: "Lower(DOCUMENT(SMGeographicMaster.geogLevelType).display)=='district' && SMGeographicMaster._id=='".concat(val, "' && SMGeographicMaster.activestatus == true && SMGeographicMaster.active == true"),
      return_fields: "{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode}"
    };
  },
  orgAddSTATE: function orgAddSTATE(val) {
    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      sort: "SMGeographicMaster.geogLevelName",
      filter: "Lower(DOCUMENT(SMGeographicMaster.geogLevelType).display)=='state' && SMGeographicMaster._id=='".concat(val, "' && SMGeographicMaster.activestatus == true && SMGeographicMaster.active == true"),
      return_fields: "{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode}"
    };
  },
  orgAddCOUNTRY: function orgAddCOUNTRY(val) {
    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      sort: "SMGeographicMaster.geogLevelName",
      filter: "Lower(DOCUMENT(SMGeographicMaster.geogLevelType).display)=='country' && SMGeographicMaster._id=='".concat(val, "' && SMGeographicMaster.activestatus == true && SMGeographicMaster.active == true"),
      return_fields: "{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode}"
    };
  },
  orgAddPINCODE: function orgAddPINCODE(val) {
    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      sort: "SMGeographicMaster.geogLevelName",
      filter: "Lower(DOCUMENT(SMGeographicMaster.geogLevelType).display)=='pincode' && SMGeographicMaster.parentGeogLevelCode=='".concat(val, "' && SMGeographicMaster.activestatus == true && SMGeographicMaster.active == true"),
      return_fields: "{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode}"
    };
  },
  orgContactDetailMode: function orgContactDetailMode() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='CONTACTSYSTEM'",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  orgContactDetailCode: function orgContactDetailCode() {
    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      sort: "SMGeographicMaster.geogLevelName",
      filter: "Lower(DOCUMENT(SMGeographicMaster.geogLevelType).display)=='country' && SMGeographicMaster.activestatus == true && SMGeographicMaster.active == true",
      return_fields: "{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode,GeoLocationISDCode:SMGeographicMaster.GeoLocationISDCode}"
    };
  },
  orgContactDetailUse: function orgContactDetailUse() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='USE'",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  orgContactDetailPriority: function orgContactDetailPriority() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='PRIORITY'",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  orgNamePrefix: function orgNamePrefix() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='NAMEPREFIX' AND CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN TO_ARRAY(CodeableConceptMaster.coding) RETURN DOCUMENT(cod))})"
    };
  },
  orgNameSuffix: function orgNameSuffix() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='NAMESUFFIX' AND CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN TO_ARRAY(CodeableConceptMaster.coding) RETURN DOCUMENT(cod))})"
    };
  },
  positionDesi: function positionDesi() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='DESIGNATION' && CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  SpecialtyDrop: function SpecialtyDrop() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='SPECIALTY' && CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  orgdateformat: function orgdateformat() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='ORGDATEFORMAT' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  },
  orgtimeformat: function orgtimeformat() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='ORGTIMEFORMAT' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  },
  orgdatetimeformat: function orgdatetimeformat() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='ORGDATETIMEFORMAT' && CodingMaster.activestatus==true && CodingMaster.status == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','Type','status','activestatus','shortdesc','display','code')",
      sort: "CodingMaster.shortdesc"
    };
  }
};

var ReadTreeJson = function ReadTreeJson(data) {
  var arry = [];

  var getJSONObj = function getJSONObj(data) {
    data.map(function (treeItemData) {
      if (treeItemData.name) {
        arry.push({
          name: treeItemData !== null && treeItemData !== void 0 && treeItemData.name ? treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData.name : "",
          id: treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData.id,
          _id: treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData._id,
          _key: treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData._key,
          children: OrganizationObj(treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData.Organization),
          icon: "enterprice"
        });
      }
    });
  };

  getJSONObj(data);
  return arry;
};
var OrganizationObj = function OrganizationObj(data) {
  var arry = [];

  var getJSONObj = function getJSONObj(data) {
    data.map(function (treeItemData) {
      if (treeItemData.name) {
        arry.push({
          name: treeItemData !== null && treeItemData !== void 0 && treeItemData.name ? treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData.name : "",
          id: treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData.id,
          _id: treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData._id,
          children: facilityObj(treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData.facility),
          _key: treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData._key,
          icon: "organization"
        });
      }
    });
  };

  getJSONObj(data);
  return arry;
};
var facilityObj = function facilityObj(data) {
  var arry = [];

  var getJSONObj = function getJSONObj(data) {
    data.map(function (treeItemData) {
      if (treeItemData.name) {
        arry.push({
          name: treeItemData !== null && treeItemData !== void 0 && treeItemData.name ? treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData.name : "",
          id: treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData.id,
          _id: treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData._id,
          _key: treeItemData === null || treeItemData === void 0 ? void 0 : treeItemData._key,
          icon: "facility",
          children: []
        });
      }
    });
  };

  getJSONObj(data);
  return arry;
};

var contactConstruct = function contactConstruct(data) {
  var contact_arr = [];

  if (data.length > 0) {
    data.map(function (val_) {
      return contact_arr.push(_defineProperty({}, val_.system, val_.value)); // if(val_.system === "Phone"){
      // 	contact_arr.push({
      // 		phone : val_.value
      // 	})
      // } else if(val_.system === "Fax"){
      // 	contact_arr.push({
      // 		fax : val_.value
      // 	})
      // } else if(val_.system === "Email"){
      // 	contact_arr.push({
      // 		email : val_.value
      // 	})
      // } else if(val_.system === "Mobile"){
      // 	contact_arr.push({
      // 		mobile : val_.value
      // 	})
      // }
    });
  }

  return contact_arr;
}; //ADDRESS CONSTRUCTION FOR TREE DETAILS


var getpersondetails = function getpersondetails(contactlist) {
  var dataList = [];

  if ((contactlist === null || contactlist === void 0 ? void 0 : contactlist.length) > 0) {
    contactlist === null || contactlist === void 0 ? void 0 : contactlist.map(function (val) {
      var _val$name, _val$name$, _val$name2, _val$name2$, _val$name3, _val$name3$, _val$name4, _val$name4$, _val$designation$disp, _val$designation, _val$telecom$0$system, _val$telecom, _val$telecom$, _val$telecom$$system, _val$telecom2, _val$telecom2$, _val$telecom$0$valuep, _val$telecom3, _val$telecom3$, _val$telecom3$$valuep, _val$telecom4, _val$telecom4$;

      var lists = {
        name: val !== null && val !== void 0 && (_val$name = val.name) !== null && _val$name !== void 0 && (_val$name$ = _val$name[0]) !== null && _val$name$ !== void 0 && _val$name$.text ? (val === null || val === void 0 ? void 0 : (_val$name2 = val.name) === null || _val$name2 === void 0 ? void 0 : (_val$name2$ = _val$name2[0]) === null || _val$name2$ === void 0 ? void 0 : _val$name2$.text) + " " + (val === null || val === void 0 ? void 0 : (_val$name3 = val.name) === null || _val$name3 === void 0 ? void 0 : (_val$name3$ = _val$name3[0]) === null || _val$name3$ === void 0 ? void 0 : _val$name3$.family) + " " + (val === null || val === void 0 ? void 0 : (_val$name4 = val.name) === null || _val$name4 === void 0 ? void 0 : (_val$name4$ = _val$name4[0]) === null || _val$name4$ === void 0 ? void 0 : _val$name4$.given) : "",
        designation: (_val$designation$disp = val === null || val === void 0 ? void 0 : (_val$designation = val.designation) === null || _val$designation === void 0 ? void 0 : _val$designation.display) !== null && _val$designation$disp !== void 0 ? _val$designation$disp : "",
        contact_type: (_val$telecom$0$system = val === null || val === void 0 ? void 0 : (_val$telecom = val.telecom) === null || _val$telecom === void 0 ? void 0 : (_val$telecom$ = _val$telecom[0]) === null || _val$telecom$ === void 0 ? void 0 : (_val$telecom$$system = _val$telecom$.system) === null || _val$telecom$$system === void 0 ? void 0 : _val$telecom$$system.display) !== null && _val$telecom$0$system !== void 0 ? _val$telecom$0$system : "",
        contact: val !== null && val !== void 0 && (_val$telecom2 = val.telecom) !== null && _val$telecom2 !== void 0 && (_val$telecom2$ = _val$telecom2[0]) !== null && _val$telecom2$ !== void 0 && _val$telecom2$.value ? ((_val$telecom$0$valuep = val === null || val === void 0 ? void 0 : (_val$telecom3 = val.telecom) === null || _val$telecom3 === void 0 ? void 0 : (_val$telecom3$ = _val$telecom3[0]) === null || _val$telecom3$ === void 0 ? void 0 : (_val$telecom3$$valuep = _val$telecom3$.valueprefix) === null || _val$telecom3$$valuep === void 0 ? void 0 : _val$telecom3$$valuep.GeoLocationISDCode) !== null && _val$telecom$0$valuep !== void 0 ? _val$telecom$0$valuep : "") + " " + (val === null || val === void 0 ? void 0 : (_val$telecom4 = val.telecom) === null || _val$telecom4 === void 0 ? void 0 : (_val$telecom4$ = _val$telecom4[0]) === null || _val$telecom4$ === void 0 ? void 0 : _val$telecom4$.value) : ""
      };
      dataList.push(lists);
    });
  }

  return dataList;
};

var ReadTreeDetailJson = function ReadTreeDetailJson(data, parentOrgName) {
  var specialtyDetailsarr = data === null || data === void 0 ? void 0 : data.specialtyDetails.map(function (val, i) {
    var _val$specialty;

    // specialtyDetailsarr
    return {
      effFrom: moment__default["default"](moment__default["default"].unix(val.effFrom)._d).format("DD-MM-YYYY"),
      effTo: moment__default["default"](moment__default["default"].unix(val.effTo)._d).format("DD-MM-YYYY"),
      specialty: val === null || val === void 0 ? void 0 : (_val$specialty = val.specialty) === null || _val$specialty === void 0 ? void 0 : _val$specialty.display
    };
  });
  var obj = {};

  if (data) {
    var _data$name, _data$entitycode, _data$ParentOrgID, _data$levelofcareid$d, _data$levelofcareid, _data$levelofcareid$l, _data$levelofcareid2, _ref2, _data$address, _data$address$, _data$address2, _data$address2$, _data$address2$$city, _data$address3, _data$address3$, _data$address3$$distr, _data$address4, _data$address4$, _data$address4$$state, _data$address5, _data$address5$, _data$address5$$posta, _data$address6, _data$address6$, _data$address6$$count, _data$contact$, _data$contact$$name$, _data$contact$$name$$, _data$contact$2, _data$contact$2$name$, _data$contact$3, _data$contact$3$name$, _data$contact$4, _data$contact$4$name$, _data$contact$5, _data$contact$5$name$, _data$contact$5$name$2, _data$contact$0$desig, _data$contact, _data$contact$6, _data$contact$6$desig, _data$logo$, _getpersondetails, _data$contact2, _data$isExternal, _data$OrgType$0$code, _data$OrgType, _data$OrgType$;

    obj = {
      entityName: (_data$name = data === null || data === void 0 ? void 0 : data.name) !== null && _data$name !== void 0 ? _data$name : "",
      entityCode: (_data$entitycode = data === null || data === void 0 ? void 0 : data.entitycode) !== null && _data$entitycode !== void 0 ? _data$entitycode : "",
      _key: data === null || data === void 0 ? void 0 : data._key,
      parentEntityId: data === null || data === void 0 ? void 0 : (_data$ParentOrgID = data.ParentOrgID) === null || _data$ParentOrgID === void 0 ? void 0 : _data$ParentOrgID[0],
      parentEntity: parentOrgName !== null && parentOrgName !== void 0 ? parentOrgName : "",
      levelOfCare: (_data$levelofcareid$d = data === null || data === void 0 ? void 0 : (_data$levelofcareid = data.levelofcareid) === null || _data$levelofcareid === void 0 ? void 0 : _data$levelofcareid.description) !== null && _data$levelofcareid$d !== void 0 ? _data$levelofcareid$d : "",
      level: (_data$levelofcareid$l = data === null || data === void 0 ? void 0 : (_data$levelofcareid2 = data.levelofcareid) === null || _data$levelofcareid2 === void 0 ? void 0 : _data$levelofcareid2.levelofcareCode) !== null && _data$levelofcareid$l !== void 0 ? _data$levelofcareid$l : "",
      address: (_ref2 = (data === null || data === void 0 ? void 0 : (_data$address = data.address) === null || _data$address === void 0 ? void 0 : (_data$address$ = _data$address[0]) === null || _data$address$ === void 0 ? void 0 : _data$address$.line) + ", " + (data === null || data === void 0 ? void 0 : (_data$address2 = data.address) === null || _data$address2 === void 0 ? void 0 : (_data$address2$ = _data$address2[0]) === null || _data$address2$ === void 0 ? void 0 : (_data$address2$$city = _data$address2$.city) === null || _data$address2$$city === void 0 ? void 0 : _data$address2$$city.geogLevelName) + ", " + (data === null || data === void 0 ? void 0 : (_data$address3 = data.address) === null || _data$address3 === void 0 ? void 0 : (_data$address3$ = _data$address3[0]) === null || _data$address3$ === void 0 ? void 0 : (_data$address3$$distr = _data$address3$.district) === null || _data$address3$$distr === void 0 ? void 0 : _data$address3$$distr.geogLevelName) + ", " + (data === null || data === void 0 ? void 0 : (_data$address4 = data.address) === null || _data$address4 === void 0 ? void 0 : (_data$address4$ = _data$address4[0]) === null || _data$address4$ === void 0 ? void 0 : (_data$address4$$state = _data$address4$.state) === null || _data$address4$$state === void 0 ? void 0 : _data$address4$$state.geogLevelName) + ", " + (data === null || data === void 0 ? void 0 : (_data$address5 = data.address) === null || _data$address5 === void 0 ? void 0 : (_data$address5$ = _data$address5[0]) === null || _data$address5$ === void 0 ? void 0 : (_data$address5$$posta = _data$address5$.postalCode) === null || _data$address5$$posta === void 0 ? void 0 : _data$address5$$posta.geogLevelName) + ", " + (data === null || data === void 0 ? void 0 : (_data$address6 = data.address) === null || _data$address6 === void 0 ? void 0 : (_data$address6$ = _data$address6[0]) === null || _data$address6$ === void 0 ? void 0 : (_data$address6$$count = _data$address6$.country) === null || _data$address6$$count === void 0 ? void 0 : _data$address6$$count.geogLevelName)) !== null && _ref2 !== void 0 ? _ref2 : "",
      contactPersonName: (data === null || data === void 0 ? void 0 : (_data$contact$ = data.contact[0]) === null || _data$contact$ === void 0 ? void 0 : (_data$contact$$name$ = _data$contact$.name[0]) === null || _data$contact$$name$ === void 0 ? void 0 : (_data$contact$$name$$ = _data$contact$$name$.prefix) === null || _data$contact$$name$$ === void 0 ? void 0 : _data$contact$$name$$.display) + " " + (data === null || data === void 0 ? void 0 : (_data$contact$2 = data.contact[0]) === null || _data$contact$2 === void 0 ? void 0 : (_data$contact$2$name$ = _data$contact$2.name[0]) === null || _data$contact$2$name$ === void 0 ? void 0 : _data$contact$2$name$.text) + " " + (data === null || data === void 0 ? void 0 : (_data$contact$3 = data.contact[0]) === null || _data$contact$3 === void 0 ? void 0 : (_data$contact$3$name$ = _data$contact$3.name[0]) === null || _data$contact$3$name$ === void 0 ? void 0 : _data$contact$3$name$.family) + " " + (data === null || data === void 0 ? void 0 : (_data$contact$4 = data.contact[0]) === null || _data$contact$4 === void 0 ? void 0 : (_data$contact$4$name$ = _data$contact$4.name[0]) === null || _data$contact$4$name$ === void 0 ? void 0 : _data$contact$4$name$.given) + " " + (data === null || data === void 0 ? void 0 : (_data$contact$5 = data.contact[0]) === null || _data$contact$5 === void 0 ? void 0 : (_data$contact$5$name$ = _data$contact$5.name[0]) === null || _data$contact$5$name$ === void 0 ? void 0 : (_data$contact$5$name$2 = _data$contact$5$name$.suffix) === null || _data$contact$5$name$2 === void 0 ? void 0 : _data$contact$5$name$2.display) + "",
      designation: (_data$contact$0$desig = data === null || data === void 0 ? void 0 : (_data$contact = data.contact) === null || _data$contact === void 0 ? void 0 : (_data$contact$6 = _data$contact[0]) === null || _data$contact$6 === void 0 ? void 0 : (_data$contact$6$desig = _data$contact$6.designation) === null || _data$contact$6$desig === void 0 ? void 0 : _data$contact$6$desig.description) !== null && _data$contact$0$desig !== void 0 ? _data$contact$0$desig : "",
      contactData: contactConstruct(data === null || data === void 0 ? void 0 : data.telecom),
      status: data === null || data === void 0 ? void 0 : data.active,
      log: data === null || data === void 0 ? void 0 : (_data$logo$ = data.logo[0]) === null || _data$logo$ === void 0 ? void 0 : _data$logo$.fileid,
      specialtyDetails: specialtyDetailsarr,
      contact_person_name: (_getpersondetails = getpersondetails((data === null || data === void 0 ? void 0 : (_data$contact2 = data.contact) === null || _data$contact2 === void 0 ? void 0 : _data$contact2.length) > 0 ? data === null || data === void 0 ? void 0 : data.contact : null)) !== null && _getpersondetails !== void 0 ? _getpersondetails : null,
      external: (_data$isExternal = data === null || data === void 0 ? void 0 : data.isExternal) !== null && _data$isExternal !== void 0 ? _data$isExternal : false,
      orgEntityCode: (_data$OrgType$0$code = data === null || data === void 0 ? void 0 : (_data$OrgType = data.OrgType) === null || _data$OrgType === void 0 ? void 0 : (_data$OrgType$ = _data$OrgType[0]) === null || _data$OrgType$ === void 0 ? void 0 : _data$OrgType$.code) !== null && _data$OrgType$0$code !== void 0 ? _data$OrgType$0$code : "",
      orgdateformat: data !== null && data !== void 0 && data.orgdateformat ? data === null || data === void 0 ? void 0 : data.orgdateformat : {},
      orgdatetimeformat: data !== null && data !== void 0 && data.orgdatetimeformat ? data === null || data === void 0 ? void 0 : data.orgdatetimeformat : {},
      orgtimeformat: data !== null && data !== void 0 && data.orgtimeformat ? data === null || data === void 0 ? void 0 : data.orgtimeformat : {}
    };
  }

  return obj;
};

var generateJson$a = {
  insert_json: function insert_json(data, key) {
    var _data$Identification, _data$Alias, _data$Address, _data$Contact, _data$ContactPersonDe, _data$specialtyDetail, _data$external, _data$ParentEntity, _data$ParentEntity2, _data$LevelOfCare, _data$imageDetails$, _data$imageDetails$2, _data$imageDetails$3, _data$imageDetails$4, _data$orgdateformat, _data$orgtimeformat, _data$orgdatetimeform;

    var identifierArr = data === null || data === void 0 ? void 0 : (_data$Identification = data.Identification) === null || _data$Identification === void 0 ? void 0 : _data$Identification.map(function (v, i) {
      var _v$use;

      if (v !== null && v !== void 0 && (_v$use = v.use) !== null && _v$use !== void 0 && _v$use.value) {
        var _v$use2, _v$idtype;

        return {
          user: v === null || v === void 0 ? void 0 : (_v$use2 = v.use) === null || _v$use2 === void 0 ? void 0 : _v$use2.value,
          value: v === null || v === void 0 ? void 0 : v.idnumber,
          period: [{
            start: getUtcTime(moment__default["default"](v === null || v === void 0 ? void 0 : v.startdate)),
            end: getUtcTime(moment__default["default"](v === null || v === void 0 ? void 0 : v.enddate)),
            id: 0
          }],
          Type: v === null || v === void 0 ? void 0 : (_v$idtype = v.idtype) === null || _v$idtype === void 0 ? void 0 : _v$idtype.value
        };
      }
    });
    var aliasArr = data === null || data === void 0 ? void 0 : (_data$Alias = data.Alias) === null || _data$Alias === void 0 ? void 0 : _data$Alias.map(function (v, i) {
      var _v$aliastype;

      return {
        aliasType: v === null || v === void 0 ? void 0 : (_v$aliastype = v.aliastype) === null || _v$aliastype === void 0 ? void 0 : _v$aliastype.value,
        aliasDesc: v === null || v === void 0 ? void 0 : v.aliasname,
        aliasStart: getUtcTime(moment__default["default"](v === null || v === void 0 ? void 0 : v.startdate)),
        aliasEnd: getUtcTime(moment__default["default"](v === null || v === void 0 ? void 0 : v.enddate))
      };
    });
    var addressArr = data === null || data === void 0 ? void 0 : (_data$Address = data.Address) === null || _data$Address === void 0 ? void 0 : _data$Address.map(function (val, i) {
      var _val$use, _val$city, _val$district, _val$state, _val$pincode, _val$country, _val$type;

      var address1 = val !== null && val !== void 0 && val.address1 ? val === null || val === void 0 ? void 0 : val.address1 : "";
      var address2 = val !== null && val !== void 0 && val.address2 ? val === null || val === void 0 ? void 0 : val.address2 : "";
      var address3 = val !== null && val !== void 0 && val.address3 ? val === null || val === void 0 ? void 0 : val.address3 : "";
      return {
        use: val === null || val === void 0 ? void 0 : (_val$use = val.use) === null || _val$use === void 0 ? void 0 : _val$use.value,
        text: "",
        line: address1 + "," + address2 + "," + address3,
        city: val === null || val === void 0 ? void 0 : (_val$city = val.city) === null || _val$city === void 0 ? void 0 : _val$city.value,
        district: val === null || val === void 0 ? void 0 : (_val$district = val.district) === null || _val$district === void 0 ? void 0 : _val$district.value,
        state: val === null || val === void 0 ? void 0 : (_val$state = val.state) === null || _val$state === void 0 ? void 0 : _val$state.value,
        postalCode: val === null || val === void 0 ? void 0 : (_val$pincode = val.pincode) === null || _val$pincode === void 0 ? void 0 : _val$pincode.value,
        country: val === null || val === void 0 ? void 0 : (_val$country = val.country) === null || _val$country === void 0 ? void 0 : _val$country.value,
        Type: val === null || val === void 0 ? void 0 : (_val$type = val.type) === null || _val$type === void 0 ? void 0 : _val$type.value,
        id: 0
      };
    });
    var teltcomArr = data === null || data === void 0 ? void 0 : (_data$Contact = data.Contact) === null || _data$Contact === void 0 ? void 0 : _data$Contact.map(function (val, i) {
      if (val.mode.value) {
        var _val$mode, _val$use2, _val$priority, _val$code;

        return {
          system: val === null || val === void 0 ? void 0 : (_val$mode = val.mode) === null || _val$mode === void 0 ? void 0 : _val$mode.value,
          value: val === null || val === void 0 ? void 0 : val.number,
          use: val === null || val === void 0 ? void 0 : (_val$use2 = val.use) === null || _val$use2 === void 0 ? void 0 : _val$use2.value,
          rank: val === null || val === void 0 ? void 0 : (_val$priority = val.priority) === null || _val$priority === void 0 ? void 0 : _val$priority.value,
          id: 0,
          valueprefix: val === null || val === void 0 ? void 0 : (_val$code = val.code) === null || _val$code === void 0 ? void 0 : _val$code.value
        };
      }
    });
    var contactpersondetailsArr = data === null || data === void 0 ? void 0 : (_data$ContactPersonDe = data.ContactPersonDetails) === null || _data$ContactPersonDe === void 0 ? void 0 : _data$ContactPersonDe.map(function (val, i) {
      var _val$point, _val$use3, _val$prefix, _val$suffix, _val$designation;

      var telecomArr = [];
      val === null || val === void 0 ? void 0 : (_val$point = val.point) === null || _val$point === void 0 ? void 0 : _val$point.map(function (v, i) {
        var _v$use3, _v$mode;

        if (v !== null && v !== void 0 && (_v$use3 = v.use) !== null && _v$use3 !== void 0 && _v$use3.value && v !== null && v !== void 0 && (_v$mode = v.mode) !== null && _v$mode !== void 0 && _v$mode.value && v !== null && v !== void 0 && v.number) {
          var _v$mode2, _v$use4, _v$priority, _v$code;

          telecomArr.push({
            system: v === null || v === void 0 ? void 0 : (_v$mode2 = v.mode) === null || _v$mode2 === void 0 ? void 0 : _v$mode2.value,
            value: v === null || v === void 0 ? void 0 : v.number,
            use: v === null || v === void 0 ? void 0 : (_v$use4 = v.use) === null || _v$use4 === void 0 ? void 0 : _v$use4.value,
            rank: v === null || v === void 0 ? void 0 : (_v$priority = v.priority) === null || _v$priority === void 0 ? void 0 : _v$priority.value,
            id: 0,
            valueprefix: v === null || v === void 0 ? void 0 : (_v$code = v.code) === null || _v$code === void 0 ? void 0 : _v$code.value
          });
        }
      });
      return {
        telecom: telecomArr,
        name: [{
          use: val === null || val === void 0 ? void 0 : (_val$use3 = val.use) === null || _val$use3 === void 0 ? void 0 : _val$use3.value,
          text: val === null || val === void 0 ? void 0 : val.firstName,
          family: val === null || val === void 0 ? void 0 : val.middleName,
          given: val === null || val === void 0 ? void 0 : val.lastName,
          prefix: val === null || val === void 0 ? void 0 : (_val$prefix = val.prefix) === null || _val$prefix === void 0 ? void 0 : _val$prefix.value,
          suffix: val === null || val === void 0 ? void 0 : (_val$suffix = val.suffix) === null || _val$suffix === void 0 ? void 0 : _val$suffix.value,
          period: [],
          id: 0
        }],
        designation: val === null || val === void 0 ? void 0 : (_val$designation = val.designation) === null || _val$designation === void 0 ? void 0 : _val$designation.value
      };
    });
    var specialtyDetailsArr = data === null || data === void 0 ? void 0 : (_data$specialtyDetail = data.specialtyDetails) === null || _data$specialtyDetail === void 0 ? void 0 : _data$specialtyDetail.map(function (val, i) {
      return {
        specialty: val === null || val === void 0 ? void 0 : val.dropdown.id,
        effFrom: getUtcTime(moment__default["default"](val === null || val === void 0 ? void 0 : val.fromDate)),
        effTo: getUtcTime(moment__default["default"](val === null || val === void 0 ? void 0 : val.toDate)),
        external: false
      };
    });
    var filter = {};
    var id = {
      id: 0
    };

    if (key) {
      filter = {
        filter: {
          _key: "".concat(key)
        }
      };
      id = {};
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "Organization",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, filter), {}, {
      doc: _objectSpread2(_objectSpread2({
        active: true,
        identifier: identifierArr === null || identifierArr === void 0 ? void 0 : identifierArr.filter(function (val) {
          return val != undefined;
        }),
        name: data === null || data === void 0 ? void 0 : data.EntityName,
        alias: aliasArr,
        telecom: teltcomArr === null || teltcomArr === void 0 ? void 0 : teltcomArr.filter(function (val) {
          return val != undefined;
        }),
        address: addressArr,
        contact: contactpersondetailsArr,
        specialtyDetails: specialtyDetailsArr
      }, id), {}, {
        isExternal: (_data$external = data === null || data === void 0 ? void 0 : data.external) !== null && _data$external !== void 0 ? _data$external : false,
        ParentOrgID: data !== null && data !== void 0 && (_data$ParentEntity = data.ParentEntity) !== null && _data$ParentEntity !== void 0 && _data$ParentEntity.value ? [data === null || data === void 0 ? void 0 : (_data$ParentEntity2 = data.ParentEntity) === null || _data$ParentEntity2 === void 0 ? void 0 : _data$ParentEntity2.value] : [],
        OrgType: [data.EntityType.value],
        levelofcareid: data === null || data === void 0 ? void 0 : (_data$LevelOfCare = data.LevelOfCare) === null || _data$LevelOfCare === void 0 ? void 0 : _data$LevelOfCare.value,
        logo: data !== null && data !== void 0 && data.imageDetails && (data === null || data === void 0 ? void 0 : data.imageDetails.length) > 0 ? [{
          date: "",
          url: "",
          id: 0,
          fileName: data === null || data === void 0 ? void 0 : (_data$imageDetails$ = data.imageDetails[0]) === null || _data$imageDetails$ === void 0 ? void 0 : _data$imageDetails$.filename,
          fileid: data === null || data === void 0 ? void 0 : (_data$imageDetails$2 = data.imageDetails[0]) === null || _data$imageDetails$2 === void 0 ? void 0 : _data$imageDetails$2.fileid,
          filetype: data === null || data === void 0 ? void 0 : (_data$imageDetails$3 = data.imageDetails[0]) === null || _data$imageDetails$3 === void 0 ? void 0 : _data$imageDetails$3.filetype,
          objectid: data === null || data === void 0 ? void 0 : (_data$imageDetails$4 = data.imageDetails[0]) === null || _data$imageDetails$4 === void 0 ? void 0 : _data$imageDetails$4.objectid
        }] : [],
        entitycode: data === null || data === void 0 ? void 0 : data.EntityCode,
        orgdateformat: data === null || data === void 0 ? void 0 : (_data$orgdateformat = data.orgdateformat) === null || _data$orgdateformat === void 0 ? void 0 : _data$orgdateformat.value,
        orgtimeformat: data === null || data === void 0 ? void 0 : (_data$orgtimeformat = data.orgtimeformat) === null || _data$orgtimeformat === void 0 ? void 0 : _data$orgtimeformat.value,
        orgdatetimeformat: data === null || data === void 0 ? void 0 : (_data$orgdatetimeform = data.orgdatetimeformat) === null || _data$orgdatetimeform === void 0 ? void 0 : _data$orgdatetimeform.value
      })
    })];
  }
};
var generateReadJson$2 = {
  read_json: function read_json(data, Parentget) {
    var _data$identifier, _data$alias, _data$address, _data$telecom, _data$contact, _data$OrgType$, _data$OrgType$2, _data$OrgType$3, _data$ParentOrgID, _data$levelofcareid, _data$levelofcareid2, _data$isExternal, _data$logo$, _data$logo$2, _data$logo$3, _data$logo$4, _data$logo$5, _data$orgdateformat2, _data$orgdateformat3, _data$orgdatetimeform2, _data$orgdatetimeform3, _data$orgtimeformat2, _data$orgtimeformat3;

    var IdentificationArr = data === null || data === void 0 ? void 0 : (_data$identifier = data.identifier) === null || _data$identifier === void 0 ? void 0 : _data$identifier.map(function (v, i) {
      var _v$period$, _v$period$2, _v$user, _v$user2, _v$Type, _v$Type2;

      // IdentificationArr readdd
      return {
        startdate: moment__default["default"].utc(moment__default["default"].unix(v === null || v === void 0 ? void 0 : (_v$period$ = v.period[0]) === null || _v$period$ === void 0 ? void 0 : _v$period$.start)).local()._d,
        // startdate: moment().utc(v?.period[0]?.start, "DD-MM-YYYY")._d,
        enddate: moment__default["default"].utc(moment__default["default"].unix(v === null || v === void 0 ? void 0 : (_v$period$2 = v.period[0]) === null || _v$period$2 === void 0 ? void 0 : _v$period$2.end)).local()._d,
        // enddate: moment().utc(v?.period[0]?.end, "DD-MM-YYYY")._d,
        use: {
          title: v === null || v === void 0 ? void 0 : (_v$user = v.user) === null || _v$user === void 0 ? void 0 : _v$user.display,
          value: v === null || v === void 0 ? void 0 : (_v$user2 = v.user) === null || _v$user2 === void 0 ? void 0 : _v$user2._id
        },
        idtype: {
          title: v === null || v === void 0 ? void 0 : (_v$Type = v.Type) === null || _v$Type === void 0 ? void 0 : _v$Type.display,
          value: v === null || v === void 0 ? void 0 : (_v$Type2 = v.Type) === null || _v$Type2 === void 0 ? void 0 : _v$Type2._id
        },
        idnumber: v === null || v === void 0 ? void 0 : v.value
      };
    });
    var AliasArr = data === null || data === void 0 ? void 0 : (_data$alias = data.alias) === null || _data$alias === void 0 ? void 0 : _data$alias.map(function (v, i) {
      var _v$aliasType, _v$aliasType2;

      // AliasArr read
      return {
        startdate: moment__default["default"]().utc(v === null || v === void 0 ? void 0 : v.aliasEnd, "DD-MM-YYYY")._d,
        enddate: moment__default["default"]().utc(v === null || v === void 0 ? void 0 : v.aliasStart, "DD-MM-YYYY")._d,
        aliastype: {
          title: v === null || v === void 0 ? void 0 : (_v$aliasType = v.aliasType) === null || _v$aliasType === void 0 ? void 0 : _v$aliasType.display,
          value: v === null || v === void 0 ? void 0 : (_v$aliasType2 = v.aliasType) === null || _v$aliasType2 === void 0 ? void 0 : _v$aliasType2._id
        },
        aliasname: v === null || v === void 0 ? void 0 : v.aliasDesc
      };
    });
    var AddressArr = data === null || data === void 0 ? void 0 : (_data$address = data.address) === null || _data$address === void 0 ? void 0 : _data$address.map(function (v, i) {
      var _v$use5, _v$use6, _v$Type3, _v$Type4, _v$city, _v$city2, _v$district, _v$district2, _v$state, _v$state2, _v$country, _v$country2, _v$postalCode, _v$postalCode2;

      // AddressArr read
      var addressAll = v.line.split(",");
      return {
        use: {
          title: v === null || v === void 0 ? void 0 : (_v$use5 = v.use) === null || _v$use5 === void 0 ? void 0 : _v$use5.display,
          value: v === null || v === void 0 ? void 0 : (_v$use6 = v.use) === null || _v$use6 === void 0 ? void 0 : _v$use6._id
        },
        type: {
          title: v === null || v === void 0 ? void 0 : (_v$Type3 = v.Type) === null || _v$Type3 === void 0 ? void 0 : _v$Type3.display,
          value: v === null || v === void 0 ? void 0 : (_v$Type4 = v.Type) === null || _v$Type4 === void 0 ? void 0 : _v$Type4._id
        },
        address1: addressAll[0],
        address2: addressAll[1],
        address3: addressAll[2],
        city: {
          title: v === null || v === void 0 ? void 0 : (_v$city = v.city) === null || _v$city === void 0 ? void 0 : _v$city.geogLevelName,
          value: v === null || v === void 0 ? void 0 : (_v$city2 = v.city) === null || _v$city2 === void 0 ? void 0 : _v$city2._id
        },
        district: {
          title: v === null || v === void 0 ? void 0 : (_v$district = v.district) === null || _v$district === void 0 ? void 0 : _v$district.geogLevelName,
          value: v === null || v === void 0 ? void 0 : (_v$district2 = v.district) === null || _v$district2 === void 0 ? void 0 : _v$district2._id
        },
        state: {
          title: v === null || v === void 0 ? void 0 : (_v$state = v.state) === null || _v$state === void 0 ? void 0 : _v$state.geogLevelName,
          value: v === null || v === void 0 ? void 0 : (_v$state2 = v.state) === null || _v$state2 === void 0 ? void 0 : _v$state2._id
        },
        country: {
          title: v === null || v === void 0 ? void 0 : (_v$country = v.country) === null || _v$country === void 0 ? void 0 : _v$country.geogLevelName,
          value: v === null || v === void 0 ? void 0 : (_v$country2 = v.country) === null || _v$country2 === void 0 ? void 0 : _v$country2._id
        },
        pincode: {
          title: v === null || v === void 0 ? void 0 : (_v$postalCode = v.postalCode) === null || _v$postalCode === void 0 ? void 0 : _v$postalCode.geogLevelName,
          value: v === null || v === void 0 ? void 0 : (_v$postalCode2 = v.postalCode) === null || _v$postalCode2 === void 0 ? void 0 : _v$postalCode2._id
        }
      };
    });
    var ContactArr = data === null || data === void 0 ? void 0 : (_data$telecom = data.telecom) === null || _data$telecom === void 0 ? void 0 : _data$telecom.map(function (v, i) {
      var _v$valueprefix, _v$valueprefix2, _v$system, _v$system2, _v$use7, _v$use8, _v$rank, _v$rank2;

      // AliasArr read
      return {
        code: {
          title: v === null || v === void 0 ? void 0 : (_v$valueprefix = v.valueprefix) === null || _v$valueprefix === void 0 ? void 0 : _v$valueprefix.GeoLocationISDCode,
          value: v === null || v === void 0 ? void 0 : (_v$valueprefix2 = v.valueprefix) === null || _v$valueprefix2 === void 0 ? void 0 : _v$valueprefix2._id
        },
        mode: {
          title: v === null || v === void 0 ? void 0 : (_v$system = v.system) === null || _v$system === void 0 ? void 0 : _v$system.display,
          value: v === null || v === void 0 ? void 0 : (_v$system2 = v.system) === null || _v$system2 === void 0 ? void 0 : _v$system2._id
        },
        number: v === null || v === void 0 ? void 0 : v.value,
        use: {
          title: v === null || v === void 0 ? void 0 : (_v$use7 = v.use) === null || _v$use7 === void 0 ? void 0 : _v$use7.display,
          value: v === null || v === void 0 ? void 0 : (_v$use8 = v.use) === null || _v$use8 === void 0 ? void 0 : _v$use8._id
        },
        priority: {
          title: v === null || v === void 0 ? void 0 : (_v$rank = v.rank) === null || _v$rank === void 0 ? void 0 : _v$rank.display,
          value: v === null || v === void 0 ? void 0 : (_v$rank2 = v.rank) === null || _v$rank2 === void 0 ? void 0 : _v$rank2._id
        }
      };
    });
    var ContactPersonDetailsArr = data === null || data === void 0 ? void 0 : (_data$contact = data.contact) === null || _data$contact === void 0 ? void 0 : _data$contact.map(function (v, i) {
      var _v$name$, _v$name$$prefix, _v$name$2, _v$name$2$prefix, _v$name$3, _v$name$4, _v$name$5, _v$name$6, _v$name$6$suffix, _v$name$7, _v$name$7$suffix, _v$designation, _v$designation2, _v$telecom;

      // ContactPersonDetailsArr read
      return {
        use: {
          title: v.name[0].use.display,
          value: v.name[0].use._id
        },
        prefix: {
          title: v === null || v === void 0 ? void 0 : (_v$name$ = v.name[0]) === null || _v$name$ === void 0 ? void 0 : (_v$name$$prefix = _v$name$.prefix) === null || _v$name$$prefix === void 0 ? void 0 : _v$name$$prefix.display,
          value: v === null || v === void 0 ? void 0 : (_v$name$2 = v.name[0]) === null || _v$name$2 === void 0 ? void 0 : (_v$name$2$prefix = _v$name$2.prefix) === null || _v$name$2$prefix === void 0 ? void 0 : _v$name$2$prefix._id
        },
        firstName: v === null || v === void 0 ? void 0 : (_v$name$3 = v.name[0]) === null || _v$name$3 === void 0 ? void 0 : _v$name$3.text,
        middleName: v === null || v === void 0 ? void 0 : (_v$name$4 = v.name[0]) === null || _v$name$4 === void 0 ? void 0 : _v$name$4.family,
        lastName: v === null || v === void 0 ? void 0 : (_v$name$5 = v.name[0]) === null || _v$name$5 === void 0 ? void 0 : _v$name$5.given,
        suffix: {
          title: v === null || v === void 0 ? void 0 : (_v$name$6 = v.name[0]) === null || _v$name$6 === void 0 ? void 0 : (_v$name$6$suffix = _v$name$6.suffix) === null || _v$name$6$suffix === void 0 ? void 0 : _v$name$6$suffix.display,
          value: v === null || v === void 0 ? void 0 : (_v$name$7 = v.name[0]) === null || _v$name$7 === void 0 ? void 0 : (_v$name$7$suffix = _v$name$7.suffix) === null || _v$name$7$suffix === void 0 ? void 0 : _v$name$7$suffix._id
        },
        designation: {
          title: v === null || v === void 0 ? void 0 : (_v$designation = v.designation) === null || _v$designation === void 0 ? void 0 : _v$designation.display,
          value: v === null || v === void 0 ? void 0 : (_v$designation2 = v.designation) === null || _v$designation2 === void 0 ? void 0 : _v$designation2._id
        },
        point: v === null || v === void 0 ? void 0 : (_v$telecom = v.telecom) === null || _v$telecom === void 0 ? void 0 : _v$telecom.map(function (val, i) {
          var _val$system, _val$system2, _val$valueprefix, _val$valueprefix2, _val$use4, _val$use5, _val$rank, _val$rank2;

          return {
            mode: {
              title: val === null || val === void 0 ? void 0 : (_val$system = val.system) === null || _val$system === void 0 ? void 0 : _val$system.display,
              value: val === null || val === void 0 ? void 0 : (_val$system2 = val.system) === null || _val$system2 === void 0 ? void 0 : _val$system2._id
            },
            code: {
              title: val === null || val === void 0 ? void 0 : (_val$valueprefix = val.valueprefix) === null || _val$valueprefix === void 0 ? void 0 : _val$valueprefix.GeoLocationISDCode,
              value: val === null || val === void 0 ? void 0 : (_val$valueprefix2 = val.valueprefix) === null || _val$valueprefix2 === void 0 ? void 0 : _val$valueprefix2._id
            },
            number: val === null || val === void 0 ? void 0 : val.value,
            use: {
              title: val === null || val === void 0 ? void 0 : (_val$use4 = val.use) === null || _val$use4 === void 0 ? void 0 : _val$use4.display,
              value: val === null || val === void 0 ? void 0 : (_val$use5 = val.use) === null || _val$use5 === void 0 ? void 0 : _val$use5._id
            },
            priority: {
              title: val === null || val === void 0 ? void 0 : (_val$rank = val.rank) === null || _val$rank === void 0 ? void 0 : _val$rank.display,
              value: val === null || val === void 0 ? void 0 : (_val$rank2 = val.rank) === null || _val$rank2 === void 0 ? void 0 : _val$rank2._id
            }
          };
        })
      };
    });
    var specialtyDetailsarr = data === null || data === void 0 ? void 0 : data.specialtyDetails.map(function (val, i) {
      var _val$specialty, _val$specialty2, _val$specialty3, _val$specialty4, _val$specialty5, _val$specialty6, _val$specialty7, _val$specialty8;

      // specialtyDetailsarr
      return {
        effFrom: utcTOLocal(val === null || val === void 0 ? void 0 : val.effFrom, "DD-MM-YYYY"),
        effTo: utcTOLocal(val === null || val === void 0 ? void 0 : val.effTo, "DD-MM-YYYY"),
        specialty: val === null || val === void 0 ? void 0 : (_val$specialty = val.specialty) === null || _val$specialty === void 0 ? void 0 : _val$specialty.display,
        code: val === null || val === void 0 ? void 0 : (_val$specialty2 = val.specialty) === null || _val$specialty2 === void 0 ? void 0 : _val$specialty2.code,
        specialty_id: val === null || val === void 0 ? void 0 : (_val$specialty3 = val.specialty) === null || _val$specialty3 === void 0 ? void 0 : _val$specialty3._id,
        fromDate: moment__default["default"](utcTOLocal(val === null || val === void 0 ? void 0 : val.effFrom, "DD-MM-YYYY"))._d,
        // moment(val?.effFrom)._d,
        toDate: moment__default["default"](utcTOLocal(val === null || val === void 0 ? void 0 : val.effTo, "DD-MM-YYYY"))._d,
        //moment(val.effTo)._d,
        dropdown: {
          label: (val === null || val === void 0 ? void 0 : (_val$specialty4 = val.specialty) === null || _val$specialty4 === void 0 ? void 0 : _val$specialty4.display) + " (" + (val === null || val === void 0 ? void 0 : (_val$specialty5 = val.specialty) === null || _val$specialty5 === void 0 ? void 0 : _val$specialty5.code) + ")",
          value: val === null || val === void 0 ? void 0 : (_val$specialty6 = val.specialty) === null || _val$specialty6 === void 0 ? void 0 : _val$specialty6.code,
          name: val === null || val === void 0 ? void 0 : (_val$specialty7 = val.specialty) === null || _val$specialty7 === void 0 ? void 0 : _val$specialty7.display,
          id: val === null || val === void 0 ? void 0 : (_val$specialty8 = val.specialty) === null || _val$specialty8 === void 0 ? void 0 : _val$specialty8._id
        }
      };
    });
    return {
      _key: data === null || data === void 0 ? void 0 : data._key,
      status: data === null || data === void 0 ? void 0 : data.active,
      EntityType_: {
        title: data === null || data === void 0 ? void 0 : (_data$OrgType$ = data.OrgType[0]) === null || _data$OrgType$ === void 0 ? void 0 : _data$OrgType$.display,
        value: data === null || data === void 0 ? void 0 : (_data$OrgType$2 = data.OrgType[0]) === null || _data$OrgType$2 === void 0 ? void 0 : _data$OrgType$2._id,
        code: data === null || data === void 0 ? void 0 : (_data$OrgType$3 = data.OrgType[0]) === null || _data$OrgType$3 === void 0 ? void 0 : _data$OrgType$3.code
      },
      ParentEntity_: (data === null || data === void 0 ? void 0 : (_data$ParentOrgID = data.ParentOrgID) === null || _data$ParentOrgID === void 0 ? void 0 : _data$ParentOrgID.length) > 0 ? Parentget === null || Parentget === void 0 ? void 0 : Parentget.filter(function (val) {
        return (val === null || val === void 0 ? void 0 : val.value) === (data === null || data === void 0 ? void 0 : data.ParentOrgID[0]);
      }) : [],
      LevelOfCare_: {
        title: data === null || data === void 0 ? void 0 : (_data$levelofcareid = data.levelofcareid) === null || _data$levelofcareid === void 0 ? void 0 : _data$levelofcareid.description,
        value: data === null || data === void 0 ? void 0 : (_data$levelofcareid2 = data.levelofcareid) === null || _data$levelofcareid2 === void 0 ? void 0 : _data$levelofcareid2._id
      },
      EntityCode_: data === null || data === void 0 ? void 0 : data.entitycode,
      EntityName_: data === null || data === void 0 ? void 0 : data.name,
      //
      Identification_: IdentificationArr,
      Alias_: AliasArr,
      Address_: AddressArr,
      Contact_: ContactArr,
      ContactPersonDetails_: ContactPersonDetailsArr,
      specialtyDetails: specialtyDetailsarr,
      external: (_data$isExternal = data === null || data === void 0 ? void 0 : data.isExternal) !== null && _data$isExternal !== void 0 ? _data$isExternal : false,
      imageDetails_: data !== null && data !== void 0 && (_data$logo$ = data.logo[0]) !== null && _data$logo$ !== void 0 && _data$logo$.fileid ? [{
        fileid: data === null || data === void 0 ? void 0 : (_data$logo$2 = data.logo[0]) === null || _data$logo$2 === void 0 ? void 0 : _data$logo$2.fileid,
        filetype: data === null || data === void 0 ? void 0 : (_data$logo$3 = data.logo[0]) === null || _data$logo$3 === void 0 ? void 0 : _data$logo$3.filetype,
        objectid: data === null || data === void 0 ? void 0 : (_data$logo$4 = data.logo[0]) === null || _data$logo$4 === void 0 ? void 0 : _data$logo$4.objectid,
        filename: data === null || data === void 0 ? void 0 : (_data$logo$5 = data.logo[0]) === null || _data$logo$5 === void 0 ? void 0 : _data$logo$5.fileName
      }] : null,
      orgdateformat: data !== null && data !== void 0 && data.orgdateformat ? _objectSpread2(_objectSpread2({}, data === null || data === void 0 ? void 0 : data.orgdateformat), {}, {
        title: data === null || data === void 0 ? void 0 : (_data$orgdateformat2 = data.orgdateformat) === null || _data$orgdateformat2 === void 0 ? void 0 : _data$orgdateformat2.display,
        value: data === null || data === void 0 ? void 0 : (_data$orgdateformat3 = data.orgdateformat) === null || _data$orgdateformat3 === void 0 ? void 0 : _data$orgdateformat3._id
      }) : {},
      orgdatetimeformat: data !== null && data !== void 0 && data.orgdatetimeformat ? _objectSpread2(_objectSpread2({}, data === null || data === void 0 ? void 0 : data.orgdatetimeformat), {}, {
        title: data === null || data === void 0 ? void 0 : (_data$orgdatetimeform2 = data.orgdatetimeformat) === null || _data$orgdatetimeform2 === void 0 ? void 0 : _data$orgdatetimeform2.display,
        value: data === null || data === void 0 ? void 0 : (_data$orgdatetimeform3 = data.orgdatetimeformat) === null || _data$orgdatetimeform3 === void 0 ? void 0 : _data$orgdatetimeform3._id
      }) : {},
      orgtimeformat: data !== null && data !== void 0 && data.orgtimeformat ? _objectSpread2(_objectSpread2({}, data === null || data === void 0 ? void 0 : data.orgtimeformat), {}, {
        title: data === null || data === void 0 ? void 0 : (_data$orgtimeformat2 = data.orgtimeformat) === null || _data$orgtimeformat2 === void 0 ? void 0 : _data$orgtimeformat2.display,
        value: data === null || data === void 0 ? void 0 : (_data$orgtimeformat3 = data.orgtimeformat) === null || _data$orgtimeformat3 === void 0 ? void 0 : _data$orgtimeformat3._id
      }) : {}
    };
  }
};

var _extraReducers$B;
var ORGANIZATION_TREE_READ = toolkit.createAsyncThunk("organizationSlice/organizationTreeList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      type,
      data,
      getJson,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          type = payload;
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.getTreeStuct(type))
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          getJson = ReadTreeJson(data.result);
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: getJson
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var ORGANIZATION_ENTITY_TYPE = toolkit.createAsyncThunk("organizationSlice/organizationEntityType", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      data,
      result,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          payload.type;
          _context2.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.entityType())
          }, __readDocumentUrl__);

        case 6:
          data = _context2.sent;
          result = [];
          data.result.map(function (val, i) {
            var _val$coding$, _val$coding$2;

            if (val !== null && val !== void 0 && (_val$coding$ = val.coding[0]) !== null && _val$coding$ !== void 0 && _val$coding$.display && val !== null && val !== void 0 && (_val$coding$2 = val.coding[0]) !== null && _val$coding$2 !== void 0 && _val$coding$2._id) {
              var _val$coding$3, _val$coding, _val$coding$4;

              result.push(_objectSpread2({
                title: val === null || val === void 0 ? void 0 : (_val$coding$3 = val.coding[0]) === null || _val$coding$3 === void 0 ? void 0 : _val$coding$3.display,
                value: val === null || val === void 0 ? void 0 : val.coding[0]._id,
                code: val === null || val === void 0 ? void 0 : (_val$coding = val.coding) === null || _val$coding === void 0 ? void 0 : (_val$coding$4 = _val$coding[0]) === null || _val$coding$4 === void 0 ? void 0 : _val$coding$4.code
              }, val));
            }
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 12]]);
})));
var ORGANIZATION_GET_PARENT_ENTITY = toolkit.createAsyncThunk("organizationSlice/orgParEntity", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      type,
      data,
      result,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          type = payload;
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.getParentEntity(type))
          }, __readDocumentUrl__);

        case 6:
          data = _context3.sent;
          result = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.name && val !== null && val !== void 0 && val._id) {
              result.push({
                title: val === null || val === void 0 ? void 0 : val.name,
                value: val === null || val === void 0 ? void 0 : val.id
              });
            }
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 15:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 12]]);
})));
var ORGANIZATION_GET_LEVEL_CARE = toolkit.createAsyncThunk("organizationSlice/orgLevelCare", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      data,
      result,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          payload.type;
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.getLevelOfCare())
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          result = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val._id) {
              result.push({
                title: val === null || val === void 0 ? void 0 : val.description,
                value: val === null || val === void 0 ? void 0 : val._id
              });
            }
          });
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 12]]);
})));
var ORGANIZATION_GET_USE_IDENTIFICATION = toolkit.createAsyncThunk("organizationSlice/orgUseIdenifi", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      data,
      result,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          payload.type;
          _context5.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgUseIdenifi())
          }, __readDocumentUrl__);

        case 6:
          data = _context5.sent;
          result = [];
          data.result.map(function (val, i) {
            var _val$coding$5, _val$coding$6;

            if (val !== null && val !== void 0 && (_val$coding$5 = val.coding[0]) !== null && _val$coding$5 !== void 0 && _val$coding$5.display && val !== null && val !== void 0 && (_val$coding$6 = val.coding[0]) !== null && _val$coding$6 !== void 0 && _val$coding$6._id) {
              var _val$coding$7;

              result.push({
                title: val === null || val === void 0 ? void 0 : (_val$coding$7 = val.coding[0]) === null || _val$coding$7 === void 0 ? void 0 : _val$coding$7.display,
                value: val === null || val === void 0 ? void 0 : val.coding[0]._id
              });
            }
          });
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 12]]);
})));
var ORGANIZATION_GET_IDTYPE_IDENTIF = toolkit.createAsyncThunk("organizationSlice/orgIdTypeIdenifi", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref12,
      rejectWithValue,
      data,
      result,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          payload.type;
          _context6.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgIdTypeIdenifi())
          }, __readDocumentUrl__);

        case 6:
          data = _context6.sent;
          result = [];
          data.result.map(function (val, i) {
            var _val$coding$8, _val$coding$9;

            if (val !== null && val !== void 0 && (_val$coding$8 = val.coding[0]) !== null && _val$coding$8 !== void 0 && _val$coding$8.display && val !== null && val !== void 0 && (_val$coding$9 = val.coding[0]) !== null && _val$coding$9 !== void 0 && _val$coding$9._id) {
              var _val$coding$10;

              result.push({
                title: val === null || val === void 0 ? void 0 : (_val$coding$10 = val.coding[0]) === null || _val$coding$10 === void 0 ? void 0 : _val$coding$10.display,
                value: val === null || val === void 0 ? void 0 : val.coding[0]._id
              });
            }
          });
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 15:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 12]]);
})));
var ORGANIZATION_GET_ALIAS_TYPE = toolkit.createAsyncThunk("organizationSlice/aliastype", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      data,
      result,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          payload.type;
          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.aliastype())
          }, __readDocumentUrl__);

        case 6:
          data = _context7.sent;
          result = [];
          data.result.map(function (val, i) {
            var _val$coding$11, _val$coding$12;

            if (val !== null && val !== void 0 && (_val$coding$11 = val.coding[0]) !== null && _val$coding$11 !== void 0 && _val$coding$11.display && val !== null && val !== void 0 && (_val$coding$12 = val.coding[0]) !== null && _val$coding$12 !== void 0 && _val$coding$12._id) {
              var _val$coding$13;

              result.push({
                title: val === null || val === void 0 ? void 0 : (_val$coding$13 = val.coding[0]) === null || _val$coding$13 === void 0 ? void 0 : _val$coding$13.display,
                value: val === null || val === void 0 ? void 0 : val.coding[0]._id
              });
            }
          });
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 15:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 12]]);
})));
var ORGANIZATION_READ_STATUS_UPSERT = toolkit.createAsyncThunk("organizationSlice/organizationReadStatusUpsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref16,
      rejectWithValue,
      _key,
      status,
      data,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref16 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref16.rejectWithValue;
          _context8.prev = 2;
          _key = payload._key, status = payload.status;
          _context8.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.upsertSatus(_key, status))
          }, __uspsertUrl__);

        case 6:
          data = _context8.sent;
          data === null || data === void 0 ? void 0 : data.code;
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 14:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 11]]);
})));
var ORGANIZATION_READ_DETAILS = toolkit.createAsyncThunk("organizationSlice/organizationReadDetails", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref18,
      rejectWithValue,
      _data$result,
      _data$result$,
      _data$result$$ParentO,
      _data$result2,
      _parentOrgName$result,
      _parentOrgName$result2,
      _key,
      data,
      parentOrgId,
      parentOrgName,
      getJson,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref18 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref18.rejectWithValue;
          _context9.prev = 2;
          _key = payload._key;
          _context9.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.getTreeDetails(_key))
          }, __readDocumentUrl__);

        case 6:
          data = _context9.sent;
          parentOrgId = data === null || data === void 0 ? void 0 : (_data$result = data.result) === null || _data$result === void 0 ? void 0 : (_data$result$ = _data$result[0]) === null || _data$result$ === void 0 ? void 0 : (_data$result$$ParentO = _data$result$.ParentOrgID) === null || _data$result$$ParentO === void 0 ? void 0 : _data$result$$ParentO[0];
          parentOrgName = 0;

          if (!parentOrgId) {
            _context9.next = 13;
            break;
          }

          _context9.next = 12;
          return fetchData({
            body: JSON.stringify(queries$k.getParentOrgNameById(parentOrgId))
          }, __readDocumentUrl__);

        case 12:
          parentOrgName = _context9.sent;

        case 13:
          getJson = ReadTreeDetailJson((_data$result2 = data.result) === null || _data$result2 === void 0 ? void 0 : _data$result2[0], (_parentOrgName$result = parentOrgName.result) === null || _parentOrgName$result === void 0 ? void 0 : (_parentOrgName$result2 = _parentOrgName$result[0]) === null || _parentOrgName$result2 === void 0 ? void 0 : _parentOrgName$result2.name);
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: getJson
          }));

        case 17:
          _context9.prev = 17;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 20:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 17]]);
})));
var ORGANIZATION_GET_ADD_TYPE = toolkit.createAsyncThunk("organizationSlice/orgAddType", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref20,
      rejectWithValue,
      data,
      result,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref20 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref20.rejectWithValue;
          _context10.prev = 2;
          payload.type;
          _context10.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgAddType())
          }, __readDocumentUrl__);

        case 6:
          data = _context10.sent;
          result = [];
          data.result.map(function (val, i) {
            var _val$coding$14, _val$coding$15;

            if (val !== null && val !== void 0 && (_val$coding$14 = val.coding[0]) !== null && _val$coding$14 !== void 0 && _val$coding$14.display && val !== null && val !== void 0 && (_val$coding$15 = val.coding[0]) !== null && _val$coding$15 !== void 0 && _val$coding$15._id) {
              var _val$coding$16;

              result.push({
                title: val === null || val === void 0 ? void 0 : (_val$coding$16 = val.coding[0]) === null || _val$coding$16 === void 0 ? void 0 : _val$coding$16.display,
                value: val === null || val === void 0 ? void 0 : val.coding[0]._id
              });
            }
          });
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context10.prev = 12;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 15:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 12]]);
})));
var ORGANIZATION_GET_ADD_USE = toolkit.createAsyncThunk("organizationSlice/orgAddUSE", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var payload,
      _ref22,
      rejectWithValue,
      data,
      result,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
          _ref22 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref22.rejectWithValue;
          _context11.prev = 2;
          payload.type;
          _context11.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgAddUSE())
          }, __readDocumentUrl__);

        case 6:
          data = _context11.sent;
          result = [];
          data.result.map(function (val, i) {
            var _val$coding$17, _val$coding$18;

            if (val !== null && val !== void 0 && (_val$coding$17 = val.coding[0]) !== null && _val$coding$17 !== void 0 && _val$coding$17.display && val !== null && val !== void 0 && (_val$coding$18 = val.coding[0]) !== null && _val$coding$18 !== void 0 && _val$coding$18._id) {
              var _val$coding$19;

              result.push({
                title: val === null || val === void 0 ? void 0 : (_val$coding$19 = val.coding[0]) === null || _val$coding$19 === void 0 ? void 0 : _val$coding$19.display,
                value: val === null || val === void 0 ? void 0 : val.coding[0]._id
              });
            }
          });
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context11.prev = 12;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 15:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 12]]);
})));
var ORGANIZATION_GET_ADD_City = toolkit.createAsyncThunk("organizationSlice/orgAddCity", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var payload,
      _ref24,
      rejectWithValue,
      data,
      result,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
          _ref24 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref24.rejectWithValue;
          _context12.prev = 2;
          payload.type;
          _context12.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgAddCity())
          }, __readDocumentUrl__);

        case 6:
          data = _context12.sent;
          result = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.parentGeogLevelCode && val !== null && val !== void 0 && val.geogLevelName) {
              result.push({
                id: val === null || val === void 0 ? void 0 : val.parentGeogLevelCode,
                title: val === null || val === void 0 ? void 0 : val.geogLevelName,
                value: val._id,
                code: val === null || val === void 0 ? void 0 : val.geogLevelCode
              });
            }
          });
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context12.prev = 12;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 15:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 12]]);
})));
var ORGANIZATION_GET_ADD_DISTRICT = toolkit.createAsyncThunk("organizationSlice/orgAddDISTRICT", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
  var payload,
      _ref26,
      rejectWithValue,
      val,
      data,
      result,
      _args13 = arguments;

  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          payload = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {};
          _ref26 = _args13.length > 1 ? _args13[1] : undefined, rejectWithValue = _ref26.rejectWithValue;
          _context13.prev = 2;
          val = payload.val;
          _context13.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgAddDISTRICT(val))
          }, __readDocumentUrl__);

        case 6:
          data = _context13.sent;
          result = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.parentGeogLevelCode && val !== null && val !== void 0 && val.geogLevelName) {
              result.push({
                id: val === null || val === void 0 ? void 0 : val.parentGeogLevelCode,
                title: val === null || val === void 0 ? void 0 : val.geogLevelName,
                value: val._id
              });
            }
          });
          return _context13.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context13.prev = 12;
          _context13.t0 = _context13["catch"](2);
          return _context13.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context13.t0.message
          })));

        case 15:
        case "end":
          return _context13.stop();
      }
    }
  }, _callee13, null, [[2, 12]]);
})));
var ORGANIZATION_GET_AddSTATE = toolkit.createAsyncThunk("organizationSlice/orgAddSTATE", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
  var payload,
      _ref28,
      rejectWithValue,
      val,
      data,
      result,
      _args14 = arguments;

  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          payload = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : {};
          _ref28 = _args14.length > 1 ? _args14[1] : undefined, rejectWithValue = _ref28.rejectWithValue;
          _context14.prev = 2;
          val = payload.val;
          _context14.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgAddSTATE(val))
          }, __readDocumentUrl__);

        case 6:
          data = _context14.sent;
          result = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.parentGeogLevelCode && val !== null && val !== void 0 && val.geogLevelName) {
              result.push({
                id: val === null || val === void 0 ? void 0 : val.parentGeogLevelCode,
                title: val === null || val === void 0 ? void 0 : val.geogLevelName,
                value: val._id
              });
            }
          });
          return _context14.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context14.prev = 12;
          _context14.t0 = _context14["catch"](2);
          return _context14.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context14.t0.message
          })));

        case 15:
        case "end":
          return _context14.stop();
      }
    }
  }, _callee14, null, [[2, 12]]);
})));
var ORGANIZATION_GET_COUNTRY = toolkit.createAsyncThunk("organizationSlice/orgAddCOUNTRY", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
  var payload,
      _ref30,
      rejectWithValue,
      val,
      data,
      result,
      _args15 = arguments;

  return _regeneratorRuntime().wrap(function _callee15$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          payload = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : {};
          _ref30 = _args15.length > 1 ? _args15[1] : undefined, rejectWithValue = _ref30.rejectWithValue;
          _context15.prev = 2;
          val = payload.val;
          _context15.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgAddCOUNTRY(val))
          }, __readDocumentUrl__);

        case 6:
          data = _context15.sent;
          result = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.geogLevelName) {
              result.push({
                id: val === null || val === void 0 ? void 0 : val.parentGeogLevelCode,
                title: val === null || val === void 0 ? void 0 : val.geogLevelName,
                value: val._id
              });
            }
          });
          return _context15.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context15.prev = 12;
          _context15.t0 = _context15["catch"](2);
          return _context15.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context15.t0.message
          })));

        case 15:
        case "end":
          return _context15.stop();
      }
    }
  }, _callee15, null, [[2, 12]]);
})));
var ORGANIZATION_GET_PINCODE = toolkit.createAsyncThunk("organizationSlice/orgAddPINCODE", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
  var payload,
      _ref32,
      rejectWithValue,
      val,
      data,
      result,
      _args16 = arguments;

  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          payload = _args16.length > 0 && _args16[0] !== undefined ? _args16[0] : {};
          _ref32 = _args16.length > 1 ? _args16[1] : undefined, rejectWithValue = _ref32.rejectWithValue;
          _context16.prev = 2;
          val = payload.val;
          _context16.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgAddPINCODE(val))
          }, __readDocumentUrl__);

        case 6:
          data = _context16.sent;
          result = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.parentGeogLevelCode && val !== null && val !== void 0 && val.geogLevelName) {
              result.push({
                id: val === null || val === void 0 ? void 0 : val.parentGeogLevelCode,
                title: val === null || val === void 0 ? void 0 : val.geogLevelName,
                value: val._id
              });
            }
          });
          return _context16.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context16.prev = 12;
          _context16.t0 = _context16["catch"](2);
          return _context16.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context16.t0.message
          })));

        case 15:
        case "end":
          return _context16.stop();
      }
    }
  }, _callee16, null, [[2, 12]]);
})));
var ORGANIZATION_GET_CONTACTDETAILMODE = toolkit.createAsyncThunk("organizationSlice/orgContactDetailMode", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
  var payload,
      _ref34,
      rejectWithValue,
      data,
      result,
      _args17 = arguments;

  return _regeneratorRuntime().wrap(function _callee17$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          payload = _args17.length > 0 && _args17[0] !== undefined ? _args17[0] : {};
          _ref34 = _args17.length > 1 ? _args17[1] : undefined, rejectWithValue = _ref34.rejectWithValue;
          _context17.prev = 2;
          payload.type;
          _context17.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgContactDetailMode())
          }, __readDocumentUrl__);

        case 6:
          data = _context17.sent;
          result = [];
          data.result.map(function (val, i) {
            var _val$coding$20, _val$coding$21;

            if (val !== null && val !== void 0 && (_val$coding$20 = val.coding[0]) !== null && _val$coding$20 !== void 0 && _val$coding$20.display && val !== null && val !== void 0 && (_val$coding$21 = val.coding[0]) !== null && _val$coding$21 !== void 0 && _val$coding$21._id) {
              var _val$coding$22;

              result.push({
                title: val === null || val === void 0 ? void 0 : (_val$coding$22 = val.coding[0]) === null || _val$coding$22 === void 0 ? void 0 : _val$coding$22.display,
                value: val === null || val === void 0 ? void 0 : val.coding[0]._id
              });
            }
          });
          return _context17.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context17.prev = 12;
          _context17.t0 = _context17["catch"](2);
          return _context17.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context17.t0.message
          })));

        case 15:
        case "end":
          return _context17.stop();
      }
    }
  }, _callee17, null, [[2, 12]]);
})));
var ORGANIZATION_GET_CONNTACTDETAILCODE = toolkit.createAsyncThunk("organizationSlice/orgContactDetailCode", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
  var payload,
      _ref36,
      rejectWithValue,
      val,
      data,
      result,
      _args18 = arguments;

  return _regeneratorRuntime().wrap(function _callee18$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          payload = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : {};
          _ref36 = _args18.length > 1 ? _args18[1] : undefined, rejectWithValue = _ref36.rejectWithValue;
          _context18.prev = 2;
          val = payload.val;
          _context18.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgContactDetailCode(val))
          }, __readDocumentUrl__);

        case 6:
          data = _context18.sent;
          result = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.GeoLocationISDCode && val !== null && val !== void 0 && val._id) {
              result.push({
                title: val === null || val === void 0 ? void 0 : val.GeoLocationISDCode,
                value: val === null || val === void 0 ? void 0 : val._id
              });
            }
          });
          return _context18.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context18.prev = 12;
          _context18.t0 = _context18["catch"](2);
          return _context18.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context18.t0.message
          })));

        case 15:
        case "end":
          return _context18.stop();
      }
    }
  }, _callee18, null, [[2, 12]]);
})));
var ORGANIZATION_GET_CONTACTDETAILUSE = toolkit.createAsyncThunk("organizationSlice/orgContactDetailUse", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
  var payload,
      _ref38,
      rejectWithValue,
      data,
      result,
      _args19 = arguments;

  return _regeneratorRuntime().wrap(function _callee19$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          payload = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : {};
          _ref38 = _args19.length > 1 ? _args19[1] : undefined, rejectWithValue = _ref38.rejectWithValue;
          _context19.prev = 2;
          payload.type;
          _context19.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgContactDetailUse())
          }, __readDocumentUrl__);

        case 6:
          data = _context19.sent;
          result = [];
          data.result.map(function (val, i) {
            var _val$coding$23, _val$coding$24;

            if (val !== null && val !== void 0 && (_val$coding$23 = val.coding[0]) !== null && _val$coding$23 !== void 0 && _val$coding$23.display && val !== null && val !== void 0 && (_val$coding$24 = val.coding[0]) !== null && _val$coding$24 !== void 0 && _val$coding$24._id) {
              var _val$coding$25;

              result.push({
                title: val === null || val === void 0 ? void 0 : (_val$coding$25 = val.coding[0]) === null || _val$coding$25 === void 0 ? void 0 : _val$coding$25.display,
                value: val === null || val === void 0 ? void 0 : val.coding[0]._id
              });
            }
          });
          return _context19.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context19.prev = 12;
          _context19.t0 = _context19["catch"](2);
          return _context19.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context19.t0.message
          })));

        case 15:
        case "end":
          return _context19.stop();
      }
    }
  }, _callee19, null, [[2, 12]]);
})));
var ORGANIZATION_GET_CONTACTDETAILPRIORITY = toolkit.createAsyncThunk("organizationSlice/0", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
  var payload,
      _ref40,
      rejectWithValue,
      data,
      result,
      _args20 = arguments;

  return _regeneratorRuntime().wrap(function _callee20$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          payload = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : {};
          _ref40 = _args20.length > 1 ? _args20[1] : undefined, rejectWithValue = _ref40.rejectWithValue;
          _context20.prev = 2;
          payload.type;
          _context20.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgContactDetailPriority())
          }, __readDocumentUrl__);

        case 6:
          data = _context20.sent;
          result = [];
          data.result.map(function (val, i) {
            var _val$coding$26, _val$coding$27;

            if (val !== null && val !== void 0 && (_val$coding$26 = val.coding[0]) !== null && _val$coding$26 !== void 0 && _val$coding$26.display && val !== null && val !== void 0 && (_val$coding$27 = val.coding[0]) !== null && _val$coding$27 !== void 0 && _val$coding$27._id) {
              var _val$coding$28;

              result.push({
                title: val === null || val === void 0 ? void 0 : (_val$coding$28 = val.coding[0]) === null || _val$coding$28 === void 0 ? void 0 : _val$coding$28.display,
                value: val === null || val === void 0 ? void 0 : val.coding[0]._id
              });
            }
          });
          return _context20.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context20.prev = 12;
          _context20.t0 = _context20["catch"](2);
          return _context20.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context20.t0.message
          })));

        case 15:
        case "end":
          return _context20.stop();
      }
    }
  }, _callee20, null, [[2, 12]]);
})));
var ORGANIZATION_GET_CONTACT_PREFIX = toolkit.createAsyncThunk("organizationSlice/orgNamePrefix", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
  var payload,
      _ref42,
      rejectWithValue,
      data,
      result,
      _args21 = arguments;

  return _regeneratorRuntime().wrap(function _callee21$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          payload = _args21.length > 0 && _args21[0] !== undefined ? _args21[0] : {};
          _ref42 = _args21.length > 1 ? _args21[1] : undefined, rejectWithValue = _ref42.rejectWithValue;
          _context21.prev = 2;
          payload.type;
          _context21.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgNamePrefix())
          }, __readDocumentUrl__);

        case 6:
          data = _context21.sent;
          result = [];
          data.result.map(function (val, i) {
            var _val$coding$29, _val$coding$30;

            if (val !== null && val !== void 0 && (_val$coding$29 = val.coding[0]) !== null && _val$coding$29 !== void 0 && _val$coding$29.display && val !== null && val !== void 0 && (_val$coding$30 = val.coding[0]) !== null && _val$coding$30 !== void 0 && _val$coding$30._id) {
              var _val$coding$31;

              result.push({
                title: val === null || val === void 0 ? void 0 : (_val$coding$31 = val.coding[0]) === null || _val$coding$31 === void 0 ? void 0 : _val$coding$31.display,
                value: val === null || val === void 0 ? void 0 : val.coding[0]._id
              });
            }
          });
          return _context21.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context21.prev = 12;
          _context21.t0 = _context21["catch"](2);
          return _context21.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context21.t0.message
          })));

        case 15:
        case "end":
          return _context21.stop();
      }
    }
  }, _callee21, null, [[2, 12]]);
})));
var ORGANIZATION_GET_CONTACT_SUFFIX = toolkit.createAsyncThunk("organizationSlice/orgNameSuffix", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
  var payload,
      _ref44,
      rejectWithValue,
      data,
      result,
      _args22 = arguments;

  return _regeneratorRuntime().wrap(function _callee22$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          payload = _args22.length > 0 && _args22[0] !== undefined ? _args22[0] : {};
          _ref44 = _args22.length > 1 ? _args22[1] : undefined, rejectWithValue = _ref44.rejectWithValue;
          _context22.prev = 2;
          payload.type;
          _context22.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.orgNameSuffix())
          }, __readDocumentUrl__);

        case 6:
          data = _context22.sent;
          result = [];
          data.result.map(function (val, i) {
            var _val$coding$32, _val$coding$33;

            if (val !== null && val !== void 0 && (_val$coding$32 = val.coding[0]) !== null && _val$coding$32 !== void 0 && _val$coding$32.display && val !== null && val !== void 0 && (_val$coding$33 = val.coding[0]) !== null && _val$coding$33 !== void 0 && _val$coding$33._id) {
              var _val$coding$34;

              result.push({
                title: val === null || val === void 0 ? void 0 : (_val$coding$34 = val.coding[0]) === null || _val$coding$34 === void 0 ? void 0 : _val$coding$34.display,
                value: val === null || val === void 0 ? void 0 : val.coding[0]._id
              });
            }
          });
          return _context22.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context22.prev = 12;
          _context22.t0 = _context22["catch"](2);
          return _context22.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context22.t0.message
          })));

        case 15:
        case "end":
          return _context22.stop();
      }
    }
  }, _callee22, null, [[2, 12]]);
})));
var ORGANIZATION_GET_CONTACT_DESI = toolkit.createAsyncThunk("organizationSlice/positionDesi", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
  var payload,
      _ref46,
      rejectWithValue,
      data,
      result,
      _args23 = arguments;

  return _regeneratorRuntime().wrap(function _callee23$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          payload = _args23.length > 0 && _args23[0] !== undefined ? _args23[0] : {};
          _ref46 = _args23.length > 1 ? _args23[1] : undefined, rejectWithValue = _ref46.rejectWithValue;
          _context23.prev = 2;
          payload.type;
          _context23.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.positionDesi())
          }, __readDocumentUrl__);

        case 6:
          data = _context23.sent;
          result = [];
          data.result.map(function (val, i) {
            var _val$coding2, _val$coding2$;

            if (val !== null && val !== void 0 && (_val$coding2 = val.coding) !== null && _val$coding2 !== void 0 && (_val$coding2$ = _val$coding2[0]) !== null && _val$coding2$ !== void 0 && _val$coding2$.display) {
              var _val$coding3, _val$coding3$, _val$coding4, _val$coding4$;

              result.push({
                title: val === null || val === void 0 ? void 0 : (_val$coding3 = val.coding) === null || _val$coding3 === void 0 ? void 0 : (_val$coding3$ = _val$coding3[0]) === null || _val$coding3$ === void 0 ? void 0 : _val$coding3$.display,
                value: val === null || val === void 0 ? void 0 : (_val$coding4 = val.coding) === null || _val$coding4 === void 0 ? void 0 : (_val$coding4$ = _val$coding4[0]) === null || _val$coding4$ === void 0 ? void 0 : _val$coding4$._id
              });
            }
          });
          return _context23.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context23.prev = 12;
          _context23.t0 = _context23["catch"](2);
          return _context23.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context23.t0.message
          })));

        case 15:
        case "end":
          return _context23.stop();
      }
    }
  }, _callee23, null, [[2, 12]]);
})));
var SET_ORGANIZATION = toolkit.createAsyncThunk("organizationSlice/setOrganization", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
  var payload,
      _ref48,
      rejectWithValue,
      state,
      key,
      queriesjson,
      data,
      _args24 = arguments;

  return _regeneratorRuntime().wrap(function _callee24$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          payload = _args24.length > 0 && _args24[0] !== undefined ? _args24[0] : {};
          _ref48 = _args24.length > 1 ? _args24[1] : undefined, rejectWithValue = _ref48.rejectWithValue;
          _context24.prev = 2;
          state = payload.state, key = payload.key;
          queriesjson = generateJson$a.insert_json(state, key);
          _context24.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context24.sent;
          return _context24.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 12:
          _context24.prev = 12;
          _context24.t0 = _context24["catch"](2);
          return _context24.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context24.t0.message
          })));

        case 15:
        case "end":
          return _context24.stop();
      }
    }
  }, _callee24, null, [[2, 12]]);
})));
var ORG_FROM_GET = toolkit.createAsyncThunk("organizationSlice/getOrganization", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
  var payload,
      _ref50,
      rejectWithValue,
      key,
      getParentEntityData,
      result,
      data,
      queriesjson,
      _args25 = arguments;

  return _regeneratorRuntime().wrap(function _callee25$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          payload = _args25.length > 0 && _args25[0] !== undefined ? _args25[0] : {};
          _ref50 = _args25.length > 1 ? _args25[1] : undefined, rejectWithValue = _ref50.rejectWithValue;
          _context25.prev = 2;
          key = payload.key;
          _context25.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.getParentEntityFull())
          }, __readDocumentUrl__);

        case 6:
          getParentEntityData = _context25.sent;
          result = [];
          getParentEntityData.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.name && val !== null && val !== void 0 && val._id) {
              result.push({
                title: val === null || val === void 0 ? void 0 : val.name,
                value: val === null || val === void 0 ? void 0 : val.id
              });
            }
          });
          _context25.next = 11;
          return fetchData({
            body: JSON.stringify(queries$k.getTreeDetails(key))
          }, __readDocumentUrl__);

        case 11:
          data = _context25.sent;
          queriesjson = generateReadJson$2.read_json(data.result[0], result);
          return _context25.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: queriesjson
          }));

        case 16:
          _context25.prev = 16;
          _context25.t0 = _context25["catch"](2);
          return _context25.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context25.t0.message
          })));

        case 19:
        case "end":
          return _context25.stop();
      }
    }
  }, _callee25, null, [[2, 16]]);
})));
var ORGANIZATION_GET_SPECIALTY_DROP = toolkit.createAsyncThunk("organizationSlice/specialtyDrop", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
  var payload,
      _ref52,
      rejectWithValue,
      data,
      result,
      _args26 = arguments;

  return _regeneratorRuntime().wrap(function _callee26$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          payload = _args26.length > 0 && _args26[0] !== undefined ? _args26[0] : {};
          _ref52 = _args26.length > 1 ? _args26[1] : undefined, rejectWithValue = _ref52.rejectWithValue;
          _context26.prev = 2;
          payload.type;
          _context26.next = 6;
          return fetchData({
            body: JSON.stringify(queries$k.SpecialtyDrop())
          }, __readDocumentUrl__);

        case 6:
          data = _context26.sent;
          result = [];
          data.result.map(function (val, i) {
            var _val$coding5, _val$coding6, _val$coding6$;

            if (val !== null && val !== void 0 && (_val$coding5 = val.coding) !== null && _val$coding5 !== void 0 && _val$coding5[0] && val !== null && val !== void 0 && (_val$coding6 = val.coding) !== null && _val$coding6 !== void 0 && (_val$coding6$ = _val$coding6[0]) !== null && _val$coding6$ !== void 0 && _val$coding6$._id) {
              var _val$coding7, _val$coding7$, _val$coding8, _val$coding8$, _val$coding9, _val$coding9$, _val$coding10, _val$coding10$, _val$coding11, _val$coding11$;

              result.push({
                label: (val === null || val === void 0 ? void 0 : (_val$coding7 = val.coding) === null || _val$coding7 === void 0 ? void 0 : (_val$coding7$ = _val$coding7[0]) === null || _val$coding7$ === void 0 ? void 0 : _val$coding7$.display) + " (" + (val === null || val === void 0 ? void 0 : (_val$coding8 = val.coding) === null || _val$coding8 === void 0 ? void 0 : (_val$coding8$ = _val$coding8[0]) === null || _val$coding8$ === void 0 ? void 0 : _val$coding8$.code) + ")",
                value: val === null || val === void 0 ? void 0 : (_val$coding9 = val.coding) === null || _val$coding9 === void 0 ? void 0 : (_val$coding9$ = _val$coding9[0]) === null || _val$coding9$ === void 0 ? void 0 : _val$coding9$.code,
                name: val === null || val === void 0 ? void 0 : (_val$coding10 = val.coding) === null || _val$coding10 === void 0 ? void 0 : (_val$coding10$ = _val$coding10[0]) === null || _val$coding10$ === void 0 ? void 0 : _val$coding10$.display,
                id: val === null || val === void 0 ? void 0 : (_val$coding11 = val.coding) === null || _val$coding11 === void 0 ? void 0 : (_val$coding11$ = _val$coding11[0]) === null || _val$coding11$ === void 0 ? void 0 : _val$coding11$._id
              });
            }
          });
          return _context26.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 12:
          _context26.prev = 12;
          _context26.t0 = _context26["catch"](2);
          return _context26.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context26.t0.message
          })));

        case 15:
        case "end":
          return _context26.stop();
      }
    }
  }, _callee26, null, [[2, 12]]);
})));
var ORGANIZATION_GET_DATE_FORMAT = toolkit.createAsyncThunk("organizationSlice/orgDateFormat", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
  var _ref54,
      rejectWithValue,
      data,
      result,
      _args27 = arguments;

  return _regeneratorRuntime().wrap(function _callee27$(_context27) {
    while (1) {
      switch (_context27.prev = _context27.next) {
        case 0:
          _ref54 = _args27.length > 1 ? _args27[1] : undefined, rejectWithValue = _ref54.rejectWithValue;
          _context27.prev = 2;
          _context27.next = 5;
          return fetchData({
            body: JSON.stringify(queries$k.orgdateformat())
          }, __readDocumentUrl__);

        case 5:
          data = _context27.sent;
          result = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.display && val !== null && val !== void 0 && val._id) {
              result.push({
                title: val === null || val === void 0 ? void 0 : val.display,
                value: val._id
              });
            }
          });
          return _context27.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 11:
          _context27.prev = 11;
          _context27.t0 = _context27["catch"](2);
          return _context27.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context27.t0.message
          })));

        case 14:
        case "end":
          return _context27.stop();
      }
    }
  }, _callee27, null, [[2, 11]]);
})));
var ORGANIZATION_GET_TIME_FORMAT = toolkit.createAsyncThunk("organizationSlice/orgTimeFormat", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
  var _ref56,
      rejectWithValue,
      data,
      result,
      _args28 = arguments;

  return _regeneratorRuntime().wrap(function _callee28$(_context28) {
    while (1) {
      switch (_context28.prev = _context28.next) {
        case 0:
          _ref56 = _args28.length > 1 ? _args28[1] : undefined, rejectWithValue = _ref56.rejectWithValue;
          _context28.prev = 2;
          _context28.next = 5;
          return fetchData({
            body: JSON.stringify(queries$k.orgtimeformat())
          }, __readDocumentUrl__);

        case 5:
          data = _context28.sent;
          result = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.display && val !== null && val !== void 0 && val._id) {
              result.push({
                title: val === null || val === void 0 ? void 0 : val.display,
                value: val._id
              });
            }
          });
          return _context28.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 11:
          _context28.prev = 11;
          _context28.t0 = _context28["catch"](2);
          return _context28.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context28.t0.message
          })));

        case 14:
        case "end":
          return _context28.stop();
      }
    }
  }, _callee28, null, [[2, 11]]);
})));
var ORGANIZATION_GET_DATE_TIME_FORMAT = toolkit.createAsyncThunk("organizationSlice/orgDateTimeFormat", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
  var _ref58,
      rejectWithValue,
      data,
      result,
      _args29 = arguments;

  return _regeneratorRuntime().wrap(function _callee29$(_context29) {
    while (1) {
      switch (_context29.prev = _context29.next) {
        case 0:
          _ref58 = _args29.length > 1 ? _args29[1] : undefined, rejectWithValue = _ref58.rejectWithValue;
          _context29.prev = 2;
          _context29.next = 5;
          return fetchData({
            body: JSON.stringify(queries$k.orgdatetimeformat())
          }, __readDocumentUrl__);

        case 5:
          data = _context29.sent;
          result = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.display && val !== null && val !== void 0 && val._id) {
              result.push({
                title: val === null || val === void 0 ? void 0 : val.display,
                value: val._id
              });
            }
          });
          return _context29.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: result
          }));

        case 11:
          _context29.prev = 11;
          _context29.t0 = _context29["catch"](2);
          return _context29.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context29.t0.message
          })));

        case 14:
        case "end":
          return _context29.stop();
      }
    }
  }, _callee29, null, [[2, 11]]);
})));
var organizationSlice = toolkit.createSlice({
  name: "practitionerApiSlice",
  initialState: {
    organizationTreeList: _objectSpread2({}, defaultState.List),
    organizationEntityType: _objectSpread2({}, defaultState.List),
    orgParEntity: _objectSpread2({}, defaultState.List),
    orgLevelCare: _objectSpread2({}, defaultState.List),
    orgUseIdenifi: _objectSpread2({}, defaultState.List),
    orgIdTypeIdenifi: _objectSpread2({}, defaultState.List),
    aliastype: _objectSpread2({}, defaultState.List),
    organizationReadDetails: _objectSpread2({}, defaultState.Info),
    organizationReadStatusUpsert: _objectSpread2({}, defaultState.List),
    orgAddType: _objectSpread2({}, defaultState.List),
    orgAddUSE: _objectSpread2({}, defaultState.List),
    orgAddCity: _objectSpread2({}, defaultState.List),
    orgAddDISTRICT: _objectSpread2({}, defaultState.List),
    orgAddSTATE: _objectSpread2({}, defaultState.List),
    orgAddCOUNTRY: _objectSpread2({}, defaultState.List),
    orgAddPINCODE: _objectSpread2({}, defaultState.List),
    orgContactDetailMode: _objectSpread2({}, defaultState.List),
    orgContactDetailCode: _objectSpread2({}, defaultState.List),
    orgContactDetailUse: _objectSpread2({}, defaultState.List),
    orgContactDetailPriority: _objectSpread2({}, defaultState.List),
    orgNamePrefix: _objectSpread2({}, defaultState.List),
    orgNameSuffix: _objectSpread2({}, defaultState.List),
    positionDesi: _objectSpread2({}, defaultState.List),
    setOrganization: _objectSpread2({}, defaultState.List),
    getOrganization: _objectSpread2({}, defaultState.List),
    specialtyDrop: _objectSpread2({}, defaultState.List),
    orgDateFormat: _objectSpread2({}, defaultState.List),
    orgTimeFormat: _objectSpread2({}, defaultState.List),
    orgDateTimeFormat: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$B = {}, _defineProperty(_extraReducers$B, ORGANIZATION_TREE_READ.fulfilled, function (state, action) {
    state.organizationTreeList.loading = false, state.organizationTreeList.error = false, state.organizationTreeList = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_TREE_READ.pending, function (state, action) {
    state.organizationTreeList.loading = true, state.organizationTreeList.error = false, state.organizationTreeList.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_TREE_READ.rejected, function (state, action) {
    state.organizationTreeList.loading = false, state.organizationTreeList.error = true, state.organizationTreeList = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_READ_DETAILS.fulfilled, function (state, action) {
    state.organizationReadDetails.loading = false, state.organizationReadDetails.error = false, state.organizationReadDetails = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_READ_DETAILS.pending, function (state, action) {
    state.organizationReadDetails.loading = true, state.organizationReadDetails.error = false, state.organizationReadDetails.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_READ_DETAILS.rejected, function (state, action) {
    state.organizationReadDetails.loading = false, state.organizationReadDetails.error = true, state.organizationReadDetails = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_READ_STATUS_UPSERT.fulfilled, function (state, action) {
    state.organizationReadStatusUpsert.loading = false, state.organizationReadStatusUpsert.error = false, state.organizationReadStatusUpsert = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_READ_STATUS_UPSERT.pending, function (state, action) {
    state.organizationReadStatusUpsert.loading = true, state.organizationReadStatusUpsert.error = false, state.organizationReadStatusUpsert.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_READ_STATUS_UPSERT.rejected, function (state, action) {
    state.organizationReadStatusUpsert.loading = false, state.organizationReadStatusUpsert.error = true, state.organizationReadStatusUpsert = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_ENTITY_TYPE.fulfilled, function (state, action) {
    state.organizationEntityType.loading = false, state.organizationEntityType.error = false, state.organizationEntityType = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_ENTITY_TYPE.pending, function (state, action) {
    state.organizationEntityType.loading = true, state.organizationEntityType.error = false, state.organizationEntityType.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_ENTITY_TYPE.rejected, function (state, action) {
    state.organizationEntityType.loading = false, state.organizationEntityType.error = true, state.organizationEntityType = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_PARENT_ENTITY.fulfilled, function (state, action) {
    state.orgParEntity.loading = false, state.orgParEntity.error = false, state.orgParEntity = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_PARENT_ENTITY.pending, function (state, action) {
    state.orgParEntity.loading = true, state.orgParEntity.error = false, state.orgParEntity.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_PARENT_ENTITY.rejected, function (state, action) {
    state.orgParEntity.loading = false, state.orgParEntity.error = true, state.orgParEntity = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_LEVEL_CARE.fulfilled, function (state, action) {
    state.orgLevelCare.loading = false, state.orgLevelCare.error = false, state.orgLevelCare = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_LEVEL_CARE.pending, function (state, action) {
    state.orgLevelCare.loading = true, state.orgLevelCare.error = false, state.orgLevelCare.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_LEVEL_CARE.rejected, function (state, action) {
    state.orgLevelCare.loading = false, state.orgLevelCare.error = true, state.orgLevelCare = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_USE_IDENTIFICATION.fulfilled, function (state, action) {
    state.orgUseIdenifi.loading = false, state.orgUseIdenifi.error = false, state.orgUseIdenifi = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_USE_IDENTIFICATION.pending, function (state, action) {
    state.orgUseIdenifi.loading = true, state.orgUseIdenifi.error = false, state.orgUseIdenifi.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_USE_IDENTIFICATION.rejected, function (state, action) {
    state.orgUseIdenifi.loading = false, state.orgUseIdenifi.error = true, state.orgUseIdenifi = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_IDTYPE_IDENTIF.fulfilled, function (state, action) {
    state.orgIdTypeIdenifi.loading = false, state.orgIdTypeIdenifi.error = false, state.orgIdTypeIdenifi = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_IDTYPE_IDENTIF.pending, function (state, action) {
    state.orgIdTypeIdenifi.loading = true, state.orgIdTypeIdenifi.error = false, state.orgIdTypeIdenifi.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_IDTYPE_IDENTIF.rejected, function (state, action) {
    state.orgIdTypeIdenifi.loading = false, state.orgIdTypeIdenifi.error = true, state.orgIdTypeIdenifi = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ALIAS_TYPE.fulfilled, function (state, action) {
    state.aliastype.loading = false, state.aliastype.error = false, state.aliastype = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ALIAS_TYPE.pending, function (state, action) {
    state.aliastype.loading = true, state.aliastype.error = false, state.aliastype.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ALIAS_TYPE.rejected, function (state, action) {
    state.aliastype.loading = false, state.aliastype.error = true, state.aliastype = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ADD_TYPE.fulfilled, function (state, action) {
    state.orgAddType.loading = false, state.orgAddType.error = false, state.orgAddType = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ADD_TYPE.pending, function (state, action) {
    state.orgAddType.loading = true, state.orgAddType.error = false, state.orgAddType.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ADD_TYPE.rejected, function (state, action) {
    state.orgAddType.loading = false, state.orgAddType.error = true, state.orgAddType = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ADD_USE.fulfilled, function (state, action) {
    state.orgAddUSE.loading = false, state.orgAddUSE.error = false, state.orgAddUSE = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ADD_USE.pending, function (state, action) {
    state.orgAddUSE.loading = true, state.orgAddUSE.error = false, state.orgAddUSE.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ADD_USE.rejected, function (state, action) {
    state.orgAddUSE.loading = false, state.orgAddUSE.error = true, state.orgAddUSE = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ADD_City.fulfilled, function (state, action) {
    state.orgAddCity.loading = false, state.orgAddCity.error = false, state.orgAddCity = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ADD_City.pending, function (state, action) {
    state.orgAddCity.loading = true, state.orgAddCity.error = false, state.orgAddCity.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ADD_City.rejected, function (state, action) {
    state.orgAddCity.loading = false, state.orgAddCity.error = true, state.orgAddCity = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ADD_DISTRICT.fulfilled, function (state, action) {
    state.orgAddDISTRICT.loading = false, state.orgAddDISTRICT.error = false, state.orgAddDISTRICT = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ADD_DISTRICT.pending, function (state, action) {
    state.orgAddDISTRICT.loading = true, state.orgAddDISTRICT.error = false, state.orgAddDISTRICT.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_ADD_DISTRICT.rejected, function (state, action) {
    state.orgAddDISTRICT.loading = false, state.orgAddDISTRICT.error = true, state.orgAddDISTRICT = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_AddSTATE.fulfilled, function (state, action) {
    state.orgAddSTATE.loading = false, state.orgAddSTATE.error = false, state.orgAddSTATE = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_AddSTATE.pending, function (state, action) {
    state.orgAddSTATE.loading = true, state.orgAddSTATE.error = false, state.orgAddSTATE.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_AddSTATE.rejected, function (state, action) {
    state.orgAddSTATE.loading = false, state.orgAddSTATE.error = true, state.orgAddSTATE = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_COUNTRY.fulfilled, function (state, action) {
    state.orgAddCOUNTRY.loading = false, state.orgAddCOUNTRY.error = false, state.orgAddCOUNTRY = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_COUNTRY.pending, function (state, action) {
    state.orgAddCOUNTRY.loading = true, state.orgAddCOUNTRY.error = false, state.orgAddCOUNTRY.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_COUNTRY.rejected, function (state, action) {
    state.orgAddCOUNTRY.loading = false, state.orgAddCOUNTRY.error = true, state.orgAddCOUNTRY = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_PINCODE.fulfilled, function (state, action) {
    state.orgAddPINCODE.loading = false, state.orgAddPINCODE.error = false, state.orgAddPINCODE = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_PINCODE.pending, function (state, action) {
    state.orgAddPINCODE.loading = true, state.orgAddPINCODE.error = false, state.orgAddPINCODE.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_PINCODE.rejected, function (state, action) {
    state.orgAddPINCODE.loading = false, state.orgAddPINCODE.error = true, state.orgAddPINCODE = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACTDETAILMODE.fulfilled, function (state, action) {
    state.orgContactDetailMode.loading = false, state.orgContactDetailMode.error = false, state.orgContactDetailMode = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACTDETAILMODE.pending, function (state, action) {
    state.orgContactDetailMode.loading = true, state.orgContactDetailMode.error = false, state.orgContactDetailMode.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACTDETAILMODE.rejected, function (state, action) {
    state.orgContactDetailMode.loading = false, state.orgContactDetailMode.error = true, state.orgContactDetailMode = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONNTACTDETAILCODE.fulfilled, function (state, action) {
    state.orgContactDetailCode.loading = false, state.orgContactDetailCode.error = false, state.orgContactDetailCode = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONNTACTDETAILCODE.pending, function (state, action) {
    state.orgContactDetailCode.loading = true, state.orgContactDetailCode.error = false, state.orgContactDetailCode.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONNTACTDETAILCODE.rejected, function (state, action) {
    state.orgContactDetailCode.loading = false, state.orgContactDetailCode.error = true, state.orgContactDetailCode = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACTDETAILUSE.fulfilled, function (state, action) {
    state.orgContactDetailUse.loading = false, state.orgContactDetailUse.error = false, state.orgContactDetailUse = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACTDETAILUSE.pending, function (state, action) {
    state.orgContactDetailUse.loading = true, state.orgContactDetailUse.error = false, state.orgContactDetailUse.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACTDETAILUSE.rejected, function (state, action) {
    state.orgContactDetailUse.loading = false, state.orgContactDetailUse.error = true, state.orgContactDetailUse = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACTDETAILPRIORITY.fulfilled, function (state, action) {
    state.orgContactDetailPriority.loading = false, state.orgContactDetailPriority.error = false, state.orgContactDetailPriority = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACTDETAILPRIORITY.pending, function (state, action) {
    state.orgContactDetailPriority.loading = true, state.orgContactDetailPriority.error = false, state.orgContactDetailPriority.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACTDETAILPRIORITY.rejected, function (state, action) {
    state.orgContactDetailPriority.loading = false, state.orgContactDetailPriority.error = true, state.orgContactDetailPriority = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACT_PREFIX.fulfilled, function (state, action) {
    state.orgNamePrefix.loading = false, state.orgNamePrefix.error = false, state.orgNamePrefix = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACT_PREFIX.pending, function (state, action) {
    state.orgNamePrefix.loading = true, state.orgNamePrefix.error = false, state.orgNamePrefix.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACT_PREFIX.rejected, function (state, action) {
    state.orgNamePrefix.loading = false, state.orgNamePrefix.error = true, state.orgNamePrefix = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACT_SUFFIX.fulfilled, function (state, action) {
    state.orgNameSuffix.loading = false, state.orgNameSuffix.error = false, state.orgNameSuffix = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACT_SUFFIX.pending, function (state, action) {
    state.orgNameSuffix.loading = true, state.orgNameSuffix.error = false, state.orgNameSuffix.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACT_SUFFIX.rejected, function (state, action) {
    state.orgNameSuffix.loading = false, state.orgNameSuffix.error = true, state.orgNameSuffix = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACT_DESI.fulfilled, function (state, action) {
    state.positionDesi.loading = false, state.positionDesi.error = false, state.positionDesi = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACT_DESI.pending, function (state, action) {
    state.positionDesi.loading = true, state.positionDesi.error = false, state.positionDesi.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_CONTACT_DESI.rejected, function (state, action) {
    state.positionDesi.loading = false, state.positionDesi.error = true, state.positionDesi = action.payload;
  }), _defineProperty(_extraReducers$B, SET_ORGANIZATION.fulfilled, function (state, action) {
    state.setOrganization.loading = false, state.setOrganization.error = false, state.setOrganization = action.payload;
  }), _defineProperty(_extraReducers$B, SET_ORGANIZATION.pending, function (state, action) {
    state.setOrganization.loading = true, state.setOrganization.error = false, state.setOrganization.loading = true;
  }), _defineProperty(_extraReducers$B, SET_ORGANIZATION.rejected, function (state, action) {
    state.setOrganization.loading = false, state.setOrganization.error = true, state.setOrganization = action.payload;
  }), _defineProperty(_extraReducers$B, ORG_FROM_GET.fulfilled, function (state, action) {
    state.getOrganization.loading = false, state.getOrganization.error = false, state.getOrganization = action.payload;
  }), _defineProperty(_extraReducers$B, ORG_FROM_GET.pending, function (state, action) {
    state.getOrganization.loading = true, state.getOrganization.error = false, state.getOrganization.loading = true;
  }), _defineProperty(_extraReducers$B, ORG_FROM_GET.rejected, function (state, action) {
    state.getOrganization.loading = false, state.getOrganization.error = true, state.getOrganization = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_SPECIALTY_DROP.fulfilled, function (state, action) {
    state.specialtyDrop.loading = false, state.specialtyDrop.error = false, state.specialtyDrop = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_SPECIALTY_DROP.pending, function (state, action) {
    state.specialtyDrop.loading = true, state.specialtyDrop.error = false, state.specialtyDrop.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_SPECIALTY_DROP.rejected, function (state, action) {
    state.specialtyDrop.loading = false, state.specialtyDrop.error = true, state.specialtyDrop = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_DATE_FORMAT.fulfilled, function (state, action) {
    state.orgDateFormat.loading = false, state.orgDateFormat.error = false, state.orgDateFormat = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_DATE_FORMAT.pending, function (state, action) {
    state.orgDateFormat.loading = true, state.orgDateFormat.error = false, state.orgDateFormat.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_DATE_FORMAT.rejected, function (state, action) {
    state.orgDateFormat.loading = false, state.orgDateFormat.error = true, state.orgDateFormat = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_TIME_FORMAT.fulfilled, function (state, action) {
    state.orgTimeFormat.loading = false, state.orgTimeFormat.error = false, state.orgTimeFormat = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_TIME_FORMAT.pending, function (state, action) {
    state.orgTimeFormat.loading = true, state.orgTimeFormat.error = false, state.orgTimeFormat.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_TIME_FORMAT.rejected, function (state, action) {
    state.orgTimeFormat.loading = false, state.orgTimeFormat.error = true, state.orgTimeFormat = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_DATE_TIME_FORMAT.fulfilled, function (state, action) {
    state.orgDateTimeFormat.loading = false, state.orgDateTimeFormat.error = false, state.orgDateTimeFormat = action.payload;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_DATE_TIME_FORMAT.pending, function (state, action) {
    state.orgDateTimeFormat.loading = true, state.orgDateTimeFormat.error = false, state.orgDateTimeFormat.loading = true;
  }), _defineProperty(_extraReducers$B, ORGANIZATION_GET_DATE_TIME_FORMAT.rejected, function (state, action) {
    state.orgDateTimeFormat.loading = false, state.orgDateTimeFormat.error = true, state.orgDateTimeFormat = action.payload;
  }), _extraReducers$B)
});
var organizationActions = {
  ORGANIZATION_TREE_READ: ORGANIZATION_TREE_READ,
  ORGANIZATION_ENTITY_TYPE: ORGANIZATION_ENTITY_TYPE,
  ORGANIZATION_GET_PARENT_ENTITY: ORGANIZATION_GET_PARENT_ENTITY,
  ORGANIZATION_GET_LEVEL_CARE: ORGANIZATION_GET_LEVEL_CARE,
  ORGANIZATION_GET_USE_IDENTIFICATION: ORGANIZATION_GET_USE_IDENTIFICATION,
  ORGANIZATION_GET_IDTYPE_IDENTIF: ORGANIZATION_GET_IDTYPE_IDENTIF,
  ORGANIZATION_GET_ALIAS_TYPE: ORGANIZATION_GET_ALIAS_TYPE,
  ORGANIZATION_READ_DETAILS: ORGANIZATION_READ_DETAILS,
  ORGANIZATION_READ_STATUS_UPSERT: ORGANIZATION_READ_STATUS_UPSERT,
  ORGANIZATION_GET_ADD_TYPE: ORGANIZATION_GET_ADD_TYPE,
  ORGANIZATION_GET_ADD_USE: ORGANIZATION_GET_ADD_USE,
  ORGANIZATION_GET_ADD_City: ORGANIZATION_GET_ADD_City,
  ORGANIZATION_GET_ADD_DISTRICT: ORGANIZATION_GET_ADD_DISTRICT,
  ORGANIZATION_GET_AddSTATE: ORGANIZATION_GET_AddSTATE,
  ORGANIZATION_GET_COUNTRY: ORGANIZATION_GET_COUNTRY,
  ORGANIZATION_GET_PINCODE: ORGANIZATION_GET_PINCODE,
  ORGANIZATION_GET_CONTACTDETAILMODE: ORGANIZATION_GET_CONTACTDETAILMODE,
  ORGANIZATION_GET_CONNTACTDETAILCODE: ORGANIZATION_GET_CONNTACTDETAILCODE,
  ORGANIZATION_GET_CONTACTDETAILUSE: ORGANIZATION_GET_CONTACTDETAILUSE,
  ORGANIZATION_GET_CONTACTDETAILPRIORITY: ORGANIZATION_GET_CONTACTDETAILPRIORITY,
  ORGANIZATION_GET_CONTACT_SUFFIX: ORGANIZATION_GET_CONTACT_SUFFIX,
  ORGANIZATION_GET_CONTACT_PREFIX: ORGANIZATION_GET_CONTACT_PREFIX,
  ORGANIZATION_GET_CONTACT_DESI: ORGANIZATION_GET_CONTACT_DESI,
  SET_ORGANIZATION: SET_ORGANIZATION,
  ORG_FROM_GET: ORG_FROM_GET,
  ORGANIZATION_GET_SPECIALTY_DROP: ORGANIZATION_GET_SPECIALTY_DROP,
  ORGANIZATION_GET_DATE_FORMAT: ORGANIZATION_GET_DATE_FORMAT,
  ORGANIZATION_GET_TIME_FORMAT: ORGANIZATION_GET_TIME_FORMAT,
  ORGANIZATION_GET_DATE_TIME_FORMAT: ORGANIZATION_GET_DATE_TIME_FORMAT
};
var organizationSlice$1 = organizationSlice.reducer;

var query$8 = {
  // pending list
  getList: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"queryid\": \"2b8b8013-75da-43c0-b2f8-c6f411e7e630\"\n      }"),
  // view pending detials
  getPendingPatientList: function getPendingPatientList(data) {
    // return`{
    //     "db_name": "${dbName}",
    //     "entity": "Appointment,Patient",
    //     "filter": {
    //     "Appointment":"${data?.id} IN Appointment.practitionerID AND Appointment.start>=DATE_TIMESTAMP(DATE_NOW()/1000) AND Appointment.appstatus == 'pending'",
    //     "Patient":"Patient.personID IN Appointment.PersonID"
    // },
    //     "return_fields": "MERGE(Appointment,{reasonCode: (FOR res in ReasonMaster filter Appointment.reasonCode any == res.ReasonCode return res),Patient:MERGE(Patient,{gender: (FOR cd in CodingMaster filter cd._id == Patient.gender RETURN cd.display),name:(FOR hn IN TO_ARRAY(Patient.name) RETURN DOCUMENT(hn)),telecom:(FOR tel IN TO_ARRAY(Patient.telecom) RETURN DOCUMENT(tel))})})"
    // }`
    return "{\n          \"db_name\": \"".concat(dbName, "\",\n          \"entity\": \"Appointment,Patient\",\n          \"filter\": {\n          \"Appointment\": \"").concat(data === null || data === void 0 ? void 0 : data.id, " == Document(Appointment.resourcecode).id AND Appointment.start>=DATE_TIMESTAMP(DATE_NOW()/1000) AND Appointment.appstatus == 'pending'\",\n          \"Patient\": \"Patient.personID IN Appointment.PersonID\"\n          },\n          \"return_fields\": \"MERGE(Appointment,{reasonCode: (FOR res in ReasonMaster filter Appointment.reasonCode any == res.ReasonCode return res),Patient:MERGE(Patient,{gender: (FOR cd in CodingMaster filter cd._id == Patient.gender RETURN cd.display),name:(FOR hn IN TO_ARRAY(Patient.name) RETURN DOCUMENT(hn)),telecom:(FOR tel IN TO_ARRAY(Patient.telecom) RETURN DOCUMENT(tel)),slotID:(for doc in Slot filter doc.id in Appointment.slotID return merge(doc,{blockreason:document(doc.blockreason)}))})})\"\n        }");
  },
  getPractitionerAgainstSpeciality: function getPractitionerAgainstSpeciality(data) {
    // return`
    // {
    //   "db_name": "${dbName}",
    //   "entity": "Appointment,Practitioner",
    //   "filter": {"Appointment":"Appointment.id==${data?.appId}"
    //   ,"Practitioner":"Practitioner.id IN Appointment.practitionerID "
    //   },
    //   "return_fields": "{ 'Practitioner':(FOR pract IN Practitioner FILTER Practitioner.id !=pract.id AND DOCUMENT(Practitioner.practitioner_role)[*].role ANY IN DOCUMENT(pract.practitioner_role)[*].role RETURN MERGE(pract,{name:(FOR hn IN TO_ARRAY(pract.name) RETURN DOCUMENT(hn)) ,practitioner_role:(FOR practrole IN TO_ARRAY(pract.practitioner_role) RETURN MERGE(DOCUMENT(practrole),{role:MERGE(DOCUMENT(DOCUMENT(practrole).role),{coding:DOCUMENT(DOCUMENT(DOCUMENT(practrole).role).coding)}) ,SpecialtyID:MERGE(DOCUMENT(DOCUMENT(practrole).SpecialtyID),{coding:DOCUMENT(DOCUMENT(DOCUMENT(practrole).SpecialtyID).coding)}) })) }))}"
    //   }`
    return "{\n          \"db_name\": \"".concat(dbName, "\",\n          \"entity\": \"Appointment,Practitioner\",\n          \"filter\": {\n            \"Appointment\": \"Appointment.id==").concat(data === null || data === void 0 ? void 0 : data.appId, "\",\n            \"Practitioner\": \"Practitioner.id  == Document(Appointment.resourcecode).id \"\n          },\n          \"return_fields\": \"{ 'Practitioner':(FOR pract IN Practitioner FILTER Practitioner.id !=pract.id AND DOCUMENT(Practitioner.practitioner_role)[*].role ANY IN DOCUMENT(pract.practitioner_role)[*].role RETURN MERGE(pract,{name:(FOR hn IN TO_ARRAY(pract.name) RETURN DOCUMENT(hn)) ,practitioner_role:(FOR practrole IN TO_ARRAY(pract.practitioner_role) RETURN MERGE(DOCUMENT(practrole),{role:MERGE(DOCUMENT(DOCUMENT(practrole).role),{coding:DOCUMENT(DOCUMENT(DOCUMENT(practrole).role).coding)}) ,SpecialtyID:MERGE(DOCUMENT(DOCUMENT(practrole).SpecialtyID),{coding:DOCUMENT(DOCUMENT(DOCUMENT(practrole).SpecialtyID).coding)}) })) }))}\"\n        }");
  },
  getCancellationReason: function getCancellationReason(data) {
    return "{\n          \"db_name\": \"".concat(dbName, "\",\n          \"entity\": \"ReasonMaster\",\n          \"filter\": \"ReasonMaster.ReasonCode == '").concat(data === null || data === void 0 ? void 0 : data.code, "'\",\n          \"return_fields\": \"ReasonMaster\"\n          }");
  }
};

var _extraReducers$A;
var GET_PENDING_RESCHEDULE_LIST = toolkit.createAsyncThunk("getPendingRescheduleListApiSlice/list_pending_reschedule", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      data,
      returnedData,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return fetchData({
            body: query$8.getList
          }, __baseUrl__);

        case 5:
          data = _context.sent;
          returnedData = data ? data === null || data === void 0 ? void 0 : data.map(function (_) {
            var _makeName, _$name, _$Date, _$role$0$role$coding$, _$role, _$role$, _$role$$role, _$role$$role$coding, _$role$$role$coding$, _ref3, _$role$0$SpecialtyID$, _$role2, _$role2$, _$role2$$SpecialtyID, _$role2$$SpecialtyID$, _$role2$$SpecialtyID$2, _$role3, _$role3$, _$role3$$SpecialtyID, _$affectedappointment, _$id;

            return {
              "resource name": (_makeName = makeName(_ === null || _ === void 0 ? void 0 : (_$name = _.name) === null || _$name === void 0 ? void 0 : _$name[0])) !== null && _makeName !== void 0 ? _makeName : '',
              "date": (_$Date = _ === null || _ === void 0 ? void 0 : _.Date) !== null && _$Date !== void 0 ? _$Date : '',
              "role": (_$role$0$role$coding$ = _ === null || _ === void 0 ? void 0 : (_$role = _.role) === null || _$role === void 0 ? void 0 : (_$role$ = _$role[0]) === null || _$role$ === void 0 ? void 0 : (_$role$$role = _$role$.role) === null || _$role$$role === void 0 ? void 0 : (_$role$$role$coding = _$role$$role.coding) === null || _$role$$role$coding === void 0 ? void 0 : (_$role$$role$coding$ = _$role$$role$coding[0]) === null || _$role$$role$coding$ === void 0 ? void 0 : _$role$$role$coding$.display) !== null && _$role$0$role$coding$ !== void 0 ? _$role$0$role$coding$ : '',
              "speciality": (_ref3 = (_$role$0$SpecialtyID$ = _ === null || _ === void 0 ? void 0 : (_$role2 = _.role) === null || _$role2 === void 0 ? void 0 : (_$role2$ = _$role2[0]) === null || _$role2$ === void 0 ? void 0 : (_$role2$$SpecialtyID = _$role2$.SpecialtyID) === null || _$role2$$SpecialtyID === void 0 ? void 0 : (_$role2$$SpecialtyID$ = _$role2$$SpecialtyID.coding) === null || _$role2$$SpecialtyID$ === void 0 ? void 0 : (_$role2$$SpecialtyID$2 = _$role2$$SpecialtyID$[0]) === null || _$role2$$SpecialtyID$2 === void 0 ? void 0 : _$role2$$SpecialtyID$2.display) !== null && _$role$0$SpecialtyID$ !== void 0 ? _$role$0$SpecialtyID$ : _ === null || _ === void 0 ? void 0 : (_$role3 = _.role) === null || _$role3 === void 0 ? void 0 : (_$role3$ = _$role3[0]) === null || _$role3$ === void 0 ? void 0 : (_$role3$$SpecialtyID = _$role3$.SpecialtyID) === null || _$role3$$SpecialtyID === void 0 ? void 0 : _$role3$$SpecialtyID.display) !== null && _ref3 !== void 0 ? _ref3 : '',
              "number Of Appointments Affected": (_$affectedappointment = _ === null || _ === void 0 ? void 0 : _.affectedappointmentscount) !== null && _$affectedappointment !== void 0 ? _$affectedappointment : '',
              "id": (_$id = _ === null || _ === void 0 ? void 0 : _.id) !== null && _$id !== void 0 ? _$id : '',
              "action": true
            };
          }) : [];
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: returnedData
          }));

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 10]]);
})));
var VIEW_PENDING_PATIENT_LIST = toolkit.createAsyncThunk("getPendingRescheduleListApiSlice/view_pending_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref5,
      rejectWithValue,
      _data$result,
      data,
      returnedData,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref5 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref5.rejectWithValue;
          _context2.prev = 2;
          _context2.next = 5;
          return fetchData({
            body: query$8.getPendingPatientList(payload)
          }, __readDocumentUrl__);

        case 5:
          data = _context2.sent;
          returnedData = data !== null && data !== void 0 && data.result ? data === null || data === void 0 ? void 0 : (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.map(function (_) {
            var _$Patient, _makeName2, _$Patient2, _$Patient2$name, _$Patient$alias, _$Patient3, _ref6, _$Patient4, _$Patient4$telecom, _$Patient4$telecom$, _$appno, _$Patient$slotID$0$bl, _$Patient5, _$Patient5$slotID, _$Patient5$slotID$, _$Patient5$slotID$$bl, _$Patient$gender$, _$Patient6, _$Patient6$gender, _$id2;

            var age = getAge(_ === null || _ === void 0 ? void 0 : (_$Patient = _.Patient) === null || _$Patient === void 0 ? void 0 : _$Patient.birthDate);
            return {
              "select": false,
              "name": (_makeName2 = makeName(_ === null || _ === void 0 ? void 0 : (_$Patient2 = _.Patient) === null || _$Patient2 === void 0 ? void 0 : (_$Patient2$name = _$Patient2.name) === null || _$Patient2$name === void 0 ? void 0 : _$Patient2$name[0])) !== null && _makeName2 !== void 0 ? _makeName2 : '',
              "mrn": (_$Patient$alias = _ === null || _ === void 0 ? void 0 : (_$Patient3 = _.Patient) === null || _$Patient3 === void 0 ? void 0 : _$Patient3.alias) !== null && _$Patient$alias !== void 0 ? _$Patient$alias : '---',
              "age": age !== null && age !== void 0 ? age : '',
              "mobile no": (_ref6 = "".concat(_ === null || _ === void 0 ? void 0 : (_$Patient4 = _.Patient) === null || _$Patient4 === void 0 ? void 0 : (_$Patient4$telecom = _$Patient4.telecom) === null || _$Patient4$telecom === void 0 ? void 0 : (_$Patient4$telecom$ = _$Patient4$telecom[0]) === null || _$Patient4$telecom$ === void 0 ? void 0 : _$Patient4$telecom$.value)) !== null && _ref6 !== void 0 ? _ref6 : '',
              "appt ref no.": (_$appno = _ === null || _ === void 0 ? void 0 : _.appno) !== null && _$appno !== void 0 ? _$appno : '',
              "appt date & time": _ !== null && _ !== void 0 && _.start ? utcTOLocal(_ === null || _ === void 0 ? void 0 : _.start, 'DD MMM,YYYY hh:mm A') : '',
              "reason": (_$Patient$slotID$0$bl = _ === null || _ === void 0 ? void 0 : (_$Patient5 = _.Patient) === null || _$Patient5 === void 0 ? void 0 : (_$Patient5$slotID = _$Patient5.slotID) === null || _$Patient5$slotID === void 0 ? void 0 : (_$Patient5$slotID$ = _$Patient5$slotID[0]) === null || _$Patient5$slotID$ === void 0 ? void 0 : (_$Patient5$slotID$$bl = _$Patient5$slotID$.blockreason) === null || _$Patient5$slotID$$bl === void 0 ? void 0 : _$Patient5$slotID$$bl.display) !== null && _$Patient$slotID$0$bl !== void 0 ? _$Patient$slotID$0$bl : '',
              "gender": (_$Patient$gender$ = _ === null || _ === void 0 ? void 0 : (_$Patient6 = _.Patient) === null || _$Patient6 === void 0 ? void 0 : (_$Patient6$gender = _$Patient6.gender) === null || _$Patient6$gender === void 0 ? void 0 : _$Patient6$gender[0]) !== null && _$Patient$gender$ !== void 0 ? _$Patient$gender$ : '',
              "appointmentId": (_$id2 = _ === null || _ === void 0 ? void 0 : _.id) !== null && _$id2 !== void 0 ? _$id2 : ''
            };
          }) : [];
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: returnedData
          }));

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 13:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 10]]);
})));
var GET_PRACTITIONER_AGAINST_SPECIALITY = toolkit.createAsyncThunk("getPendingRescheduleListApiSlice/getPractitionerAgainstSpeciality", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref8,
      rejectWithValue,
      _data$result2,
      _data$result2$,
      _data$result3,
      _data$result3$,
      _data$result3$$Practi,
      data,
      returnedData,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref8 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context3.prev = 2;
          _context3.next = 5;
          return fetchData({
            body: query$8.getPractitionerAgainstSpeciality(payload)
          }, __readDocumentUrl__);

        case 5:
          data = _context3.sent;
          returnedData = data !== null && data !== void 0 && (_data$result2 = data.result) !== null && _data$result2 !== void 0 && (_data$result2$ = _data$result2[0]) !== null && _data$result2$ !== void 0 && _data$result2$.Practitioner ? data === null || data === void 0 ? void 0 : (_data$result3 = data.result) === null || _data$result3 === void 0 ? void 0 : (_data$result3$ = _data$result3[0]) === null || _data$result3$ === void 0 ? void 0 : (_data$result3$$Practi = _data$result3$.Practitioner) === null || _data$result3$$Practi === void 0 ? void 0 : _data$result3$$Practi.map(function (_) {
            var _$name2, _$practitioner_role$c, _$practitioner_role, _$practitioner_role$c2, _$practitioner_role$c3, _$id3, _$practitioner_role$S, _$practitioner_role2, _$practitioner_role2$;

            return {
              label: makeName(_ === null || _ === void 0 ? void 0 : (_$name2 = _.name) === null || _$name2 === void 0 ? void 0 : _$name2[0]),
              //name
              value: (_$practitioner_role$c = _ === null || _ === void 0 ? void 0 : (_$practitioner_role = _.practitioner_role) === null || _$practitioner_role === void 0 ? void 0 : (_$practitioner_role$c2 = _$practitioner_role.coding) === null || _$practitioner_role$c2 === void 0 ? void 0 : (_$practitioner_role$c3 = _$practitioner_role$c2[0]) === null || _$practitioner_role$c3 === void 0 ? void 0 : _$practitioner_role$c3.display) !== null && _$practitioner_role$c !== void 0 ? _$practitioner_role$c : '',
              //role
              id: (_$id3 = _ === null || _ === void 0 ? void 0 : _.id) !== null && _$id3 !== void 0 ? _$id3 : '',
              speciality: (_$practitioner_role$S = _ === null || _ === void 0 ? void 0 : (_$practitioner_role2 = _.practitioner_role) === null || _$practitioner_role2 === void 0 ? void 0 : (_$practitioner_role2$ = _$practitioner_role2.SpecialtyID) === null || _$practitioner_role2$ === void 0 ? void 0 : _$practitioner_role2$.text) !== null && _$practitioner_role$S !== void 0 ? _$practitioner_role$S : '',
              practitionerDetails: _
            };
          }) : [];
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: returnedData
          }));

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 10]]);
})));
var CANCELLATION_REASON = toolkit.createAsyncThunk("getPendingRescheduleListApiSlice/getCancellationReason", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref10,
      rejectWithValue,
      _data$result4,
      data,
      returnedData,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref10 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context4.prev = 2;
          _context4.next = 5;
          return fetchData({
            body: query$8.getCancellationReason(payload)
          }, __readDocumentUrl__);

        case 5:
          data = _context4.sent;
          returnedData = data !== null && data !== void 0 && data.result ? data === null || data === void 0 ? void 0 : (_data$result4 = data.result) === null || _data$result4 === void 0 ? void 0 : _data$result4.map(function (_) {
            return {
              value: _ === null || _ === void 0 ? void 0 : _.ReasonCode,
              label: _ === null || _ === void 0 ? void 0 : _.ReasonDesc
            };
          }) : [];
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: returnedData
          }));

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 10]]);
})));
var getPendingRescheduleListApiSlice = toolkit.createSlice({
  name: "getPendingRescheduleListApiSlice",
  initialState: {
    pending_reschedule_list: _objectSpread2({}, defaultState.List),
    pending_patient_list: _objectSpread2({}, defaultState.List),
    practitionerDataAgainstSpeciality: _objectSpread2({}, defaultState.List),
    cancellationReason: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$A = {}, _defineProperty(_extraReducers$A, GET_PENDING_RESCHEDULE_LIST.fulfilled, function (state, action) {
    state.pending_reschedule_list.loading = false, state.pending_reschedule_list.error = false, state.pending_reschedule_list = action.payload;
  }), _defineProperty(_extraReducers$A, GET_PENDING_RESCHEDULE_LIST.pending, function (state, action) {
    state.pending_reschedule_list.loading = true, state.pending_reschedule_list.error = false, state.pending_reschedule_list.loading = true;
  }), _defineProperty(_extraReducers$A, GET_PENDING_RESCHEDULE_LIST.rejected, function (state, action) {
    state.pending_reschedule_list.loading = false, state.pending_reschedule_list.error = true, state.pending_reschedule_list = action.payload;
  }), _defineProperty(_extraReducers$A, VIEW_PENDING_PATIENT_LIST.fulfilled, function (state, action) {
    state.pending_patient_list.loading = false, state.pending_patient_list.error = false, state.pending_patient_list = action.payload;
  }), _defineProperty(_extraReducers$A, VIEW_PENDING_PATIENT_LIST.pending, function (state, action) {
    state.pending_patient_list.loading = true, state.pending_patient_list.error = false, state.pending_patient_list.loading = true;
  }), _defineProperty(_extraReducers$A, VIEW_PENDING_PATIENT_LIST.rejected, function (state, action) {
    state.pending_patient_list.loading = false, state.pending_patient_list.error = true, state.pending_patient_list = action.payload;
  }), _defineProperty(_extraReducers$A, GET_PRACTITIONER_AGAINST_SPECIALITY.fulfilled, function (state, action) {
    state.practitionerDataAgainstSpeciality.loading = false, state.practitionerDataAgainstSpeciality.error = false, state.practitionerDataAgainstSpeciality = action.payload;
  }), _defineProperty(_extraReducers$A, GET_PRACTITIONER_AGAINST_SPECIALITY.pending, function (state, action) {
    state.practitionerDataAgainstSpeciality.loading = true, state.practitionerDataAgainstSpeciality.error = false, state.practitionerDataAgainstSpeciality.loading = true;
  }), _defineProperty(_extraReducers$A, GET_PRACTITIONER_AGAINST_SPECIALITY.rejected, function (state, action) {
    state.practitionerDataAgainstSpeciality.loading = false, state.practitionerDataAgainstSpeciality.error = true, state.practitionerDataAgainstSpeciality = action.payload;
  }), _defineProperty(_extraReducers$A, CANCELLATION_REASON.fulfilled, function (state, action) {
    state.cancellationReason.loading = false, state.cancellationReason.error = false, state.cancellationReason = action.payload;
  }), _defineProperty(_extraReducers$A, CANCELLATION_REASON.pending, function (state, action) {
    state.cancellationReason.loading = true, state.cancellationReason.error = false, state.cancellationReason.loading = true;
  }), _defineProperty(_extraReducers$A, CANCELLATION_REASON.rejected, function (state, action) {
    state.cancellationReason.loading = false, state.cancellationReason.error = true, state.cancellationReason = action.payload;
  }), _extraReducers$A)
});
var pendingRescheduleListActions = {
  GET_PENDING_RESCHEDULE_LIST: GET_PENDING_RESCHEDULE_LIST,
  VIEW_PENDING_PATIENT_LIST: VIEW_PENDING_PATIENT_LIST,
  GET_PRACTITIONER_AGAINST_SPECIALITY: GET_PRACTITIONER_AGAINST_SPECIALITY,
  CANCELLATION_REASON: CANCELLATION_REASON
};
var pendingRescheduleListSlice = getPendingRescheduleListApiSlice.reducer;

var queries$j = {
  geoCodeType: function geoCodeType(type) {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      sort: "CodingMaster.display",
      filter: "CodingMaster.activestatus==true && CodingMaster.Type=='GEOCODE'",
      return_fields: "CodingMaster"
    };
  },
  geoParentType: function geoParentType(type) {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      sort: "CodingMaster.display",
      filter: "CodingMaster.activestatus==true && CodingMaster.Type=='GEOCODE'",
      return_fields: "CodingMaster"
    };
  },
  //COUNTRY READ
  geoCountryRead: function geoCountryRead() {
    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      filter: "SMGeographicMaster.activestatus==true && lower(document(SMGeographicMaster.geogLevelType).display)=='country'",
      sort: "SMGeographicMaster.createddate desc",
      return_fields: "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, GeoLocationISDCode :SMGeographicMaster.GeoLocationISDCode, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.active,_key:SMGeographicMaster._key}"
    };
  },
  //STATE READ
  geoStateRead: function geoStateRead(id) {
    var _ref, _ref$toUpperCase;

    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      filter: "SMGeographicMaster.activestatus==true && upper(document(SMGeographicMaster.geogLevelType).display)=='STATE'  && upper(document(SMGeographicMaster.parentGeogLevelCode).geogLevelCode)=='".concat((_ref = id || "") === null || _ref === void 0 ? void 0 : (_ref$toUpperCase = _ref.toUpperCase) === null || _ref$toUpperCase === void 0 ? void 0 : _ref$toUpperCase.call(_ref), "'"),
      sort: "SMGeographicMaster.createddate desc",
      return_fields: "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.active,_key:SMGeographicMaster._key}"
    };
  },
  //DISTRICT READ
  geoDistrictRead: function geoDistrictRead(id) {
    var _ref2, _ref2$toUpperCase;

    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      filter: "SMGeographicMaster.activestatus==true && upper(document(SMGeographicMaster.geogLevelType).display)=='DISTRICT'  && upper(document(SMGeographicMaster.parentGeogLevelCode).geogLevelCode)=='".concat((_ref2 = id || "") === null || _ref2 === void 0 ? void 0 : (_ref2$toUpperCase = _ref2.toUpperCase) === null || _ref2$toUpperCase === void 0 ? void 0 : _ref2$toUpperCase.call(_ref2), "'"),
      sort: "SMGeographicMaster.createddate desc",
      return_fields: "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.active,_key:SMGeographicMaster._key}"
    };
  },
  //CITY READ
  geoCityRead: function geoCityRead(id) {
    var _ref3, _ref3$toUpperCase;

    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      filter: "SMGeographicMaster.activestatus==true && upper(document(SMGeographicMaster.geogLevelType).display)=='CITY'  && upper(document(SMGeographicMaster.parentGeogLevelCode).geogLevelCode)=='".concat((_ref3 = id || "") === null || _ref3 === void 0 ? void 0 : (_ref3$toUpperCase = _ref3.toUpperCase) === null || _ref3$toUpperCase === void 0 ? void 0 : _ref3$toUpperCase.call(_ref3), "'"),
      sort: "SMGeographicMaster.createddate desc",
      return_fields: "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.active,_key:SMGeographicMaster._key}"
    };
  },
  //PINCODE READ
  geoPincodeRead: function geoPincodeRead(id) {
    var _ref4, _ref4$toUpperCase;

    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      filter: "SMGeographicMaster.activestatus==true && upper(document(SMGeographicMaster.geogLevelType).display)=='PINCODE'  && upper(document(SMGeographicMaster.parentGeogLevelCode).geogLevelCode)=='".concat((_ref4 = id || "") === null || _ref4 === void 0 ? void 0 : (_ref4$toUpperCase = _ref4.toUpperCase) === null || _ref4$toUpperCase === void 0 ? void 0 : _ref4$toUpperCase.call(_ref4), "'"),
      sort: "SMGeographicMaster.createddate desc",
      return_fields: "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.active,_key:SMGeographicMaster._key}"
    };
  },
  //STATUS CHANGE
  geoStatusChange: function geoStatusChange(data) {
    return [{
      db_name: dbName,
      entity: "SMGeographicMaster",
      filter: {
        _key: data._key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        active: data.status
      }
    }];
  },
  //GEOGRAPHIC_MASTER_MASTER
  geoMasterMaster: function geoMasterMaster() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      sort: "CodingMaster.display",
      filter: "CodingMaster.activestatus==true && CodingMaster.Type=='GEOCODE'",
      return_fields: "CodingMaster"
    };
  },
  //GEOGRAPHIC_PARENT_CODE
  geoMasterParentCode: function geoMasterParentCode(id) {
    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      sort: "SMGeographicMaster.geogLevelName",
      filter: "SMGeographicMaster.geogLevelType=='".concat(id, "' && SMGeographicMaster.activestatus==true"),
      return_fields: "{id:SMGeographicMaster.id,_id:SMGeographicMaster._id,geogLevelCode:SMGeographicMaster.geogLevelCode,geogLevelName:SMGeographicMaster.geogLevelName,geogLevelType:document(SMGeographicMaster.geogLevelType).display,parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType),parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode),GeoLocationISDCode:SMGeographicMaster.GeoLocationISDCode,_key:SMGeographicMaster._key}"
    };
  },
  //GEOGRAPHIC_SINGLE_READ
  editGeoGraphicSingleRead: function editGeoGraphicSingleRead(id) {
    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      filter: "SMGeographicMaster.activestatus==true && SMGeographicMaster._key=='".concat(id, "'"),
      return_fields: "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), GeoLocationISDCode :SMGeographicMaster.GeoLocationISDCode, parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.activestatus,_key:SMGeographicMaster._key}"
    };
  },
  //geo code exits checking
  geoCodeExits: function geoCodeExits(_ref5) {
    var levelType = _ref5.levelType,
        geoLevelCode = _ref5.geoLevelCode;
    return "{\n\t\t\t\"db_name\": \"".concat(dbName, "\",\n\t\t\t\"entity\": \"SMGeographicMaster\",\n\t\t\t\"filter\": \"SMGeographicMaster.geogLevelType=='").concat(levelType, "' && SMGeographicMaster.geogLevelCode=='").concat(geoLevelCode, "'\",\n\t\t\t\"return_fields\": \"SMGeographicMaster\"\n\t\t  }");
  }
};

var generateJson$9 = function generateJson(data) {
  var _data$id, _data$type$value, _data$code, _data$name, _data$parentType$valu, _data$parentCode$valu, _data$status, _data$geolocationISD;

  var filter = {};

  if (data._key) {
    filter = {
      filter: {
        _key: data._key
      }
    };
  }

  var arr = [_objectSpread2(_objectSpread2({
    "db_name": dbName,
    "entity": "SMGeographicMaster",
    "is_metadata": true
  }, filter), {}, {
    "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
    "doc": {
      "_id": "",
      "id": (_data$id = data.id) !== null && _data$id !== void 0 ? _data$id : "",
      "geogLevelType": (_data$type$value = data.type.value) !== null && _data$type$value !== void 0 ? _data$type$value : "",
      "geogLevelCode": (_data$code = data.code) !== null && _data$code !== void 0 ? _data$code : "",
      "geogLevelName": (_data$name = data.name) !== null && _data$name !== void 0 ? _data$name : "",
      "parentGeogLevelType": (_data$parentType$valu = data.parentType.value) !== null && _data$parentType$valu !== void 0 ? _data$parentType$valu : "",
      "parentGeogLevelCode": (_data$parentCode$valu = data.parentCode.value) !== null && _data$parentCode$valu !== void 0 ? _data$parentCode$valu : "",
      "active": (_data$status = data.status) !== null && _data$status !== void 0 ? _data$status : "",
      "GeoLocationISDCode": (_data$geolocationISD = data.geolocationISD) !== null && _data$geolocationISD !== void 0 ? _data$geolocationISD : ""
    }
  })];
  return arr;
};

var generateReadJSON$5 = function generateReadJSON(val, state) {
  var _val$geogLevelType, _val$geogLevelType$_i, _val$geogLevelType2, _val$geogLevelType$di, _val$geogLevelType3, _val$GeoLocationISDCo, _val$geogLevelCode, _val$geogLevelName, _val$parentGeogLevelT, _val$parentGeogLevelT2, _val$parentGeogLevelT3, _val$parentGeogLevelT4, _val$parentGeogLevelT5, _val$parentGeogLevelC, _val$parentGeogLevelC2, _val$parentGeogLevelC3, _val$parentGeogLevelC4, _val$parentGeogLevelC5, _val$_id, _val$id, _val$_key, _val$active;

  var json = {
    type: val.geogLevelType && (_val$geogLevelType = val.geogLevelType) !== null && _val$geogLevelType !== void 0 && _val$geogLevelType._id ? {
      value: (_val$geogLevelType$_i = (_val$geogLevelType2 = val.geogLevelType) === null || _val$geogLevelType2 === void 0 ? void 0 : _val$geogLevelType2._id) !== null && _val$geogLevelType$_i !== void 0 ? _val$geogLevelType$_i : "",
      label: (_val$geogLevelType$di = (_val$geogLevelType3 = val.geogLevelType) === null || _val$geogLevelType3 === void 0 ? void 0 : _val$geogLevelType3.display) !== null && _val$geogLevelType$di !== void 0 ? _val$geogLevelType$di : ""
    } : "",
    geolocationISD: (_val$GeoLocationISDCo = val.GeoLocationISDCode) !== null && _val$GeoLocationISDCo !== void 0 ? _val$GeoLocationISDCo : "",
    code: (_val$geogLevelCode = val.geogLevelCode) !== null && _val$geogLevelCode !== void 0 ? _val$geogLevelCode : "",
    name: (_val$geogLevelName = val.geogLevelName) !== null && _val$geogLevelName !== void 0 ? _val$geogLevelName : "",
    parentType: val.parentGeogLevelType && (_val$parentGeogLevelT = val.parentGeogLevelType) !== null && _val$parentGeogLevelT !== void 0 && _val$parentGeogLevelT._id ? {
      value: (_val$parentGeogLevelT2 = (_val$parentGeogLevelT3 = val.parentGeogLevelType) === null || _val$parentGeogLevelT3 === void 0 ? void 0 : _val$parentGeogLevelT3._id) !== null && _val$parentGeogLevelT2 !== void 0 ? _val$parentGeogLevelT2 : "",
      label: (_val$parentGeogLevelT4 = (_val$parentGeogLevelT5 = val.parentGeogLevelType) === null || _val$parentGeogLevelT5 === void 0 ? void 0 : _val$parentGeogLevelT5.display) !== null && _val$parentGeogLevelT4 !== void 0 ? _val$parentGeogLevelT4 : ""
    } : "",
    parentCode: val.parentGeogLevelCode && (_val$parentGeogLevelC = val.parentGeogLevelCode) !== null && _val$parentGeogLevelC !== void 0 && _val$parentGeogLevelC._id ? {
      value: (_val$parentGeogLevelC2 = (_val$parentGeogLevelC3 = val.parentGeogLevelCode) === null || _val$parentGeogLevelC3 === void 0 ? void 0 : _val$parentGeogLevelC3._id) !== null && _val$parentGeogLevelC2 !== void 0 ? _val$parentGeogLevelC2 : "",
      label: (_val$parentGeogLevelC4 = (_val$parentGeogLevelC5 = val.parentGeogLevelCode) === null || _val$parentGeogLevelC5 === void 0 ? void 0 : _val$parentGeogLevelC5.geogLevelName) !== null && _val$parentGeogLevelC4 !== void 0 ? _val$parentGeogLevelC4 : ""
    } : "",
    _id: (_val$_id = val._id) !== null && _val$_id !== void 0 ? _val$_id : "",
    id: (_val$id = val.id) !== null && _val$id !== void 0 ? _val$id : "",
    _key: (_val$_key = val._key) !== null && _val$_key !== void 0 ? _val$_key : "",
    status: (_val$active = val.active) !== null && _val$active !== void 0 ? _val$active : ""
  };
  return json;
};

var _extraReducers$z;
var GEOGRAPHIC_TYPE_READ = toolkit.createAsyncThunk("geographicSlice/geoGraphicTypeRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          queriesjson = queries$j.geoCodeType();
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          arry = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val._id && val !== null && val !== void 0 && val.display) {
              arry.push({
                id: val === null || val === void 0 ? void 0 : val.id,
                label: val === null || val === void 0 ? void 0 : val.display,
                value: val._id,
                code: val === null || val === void 0 ? void 0 : val.code
              });
            }
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 12]]);
})));
var GEOGRAPHIC_PARENT_READ = toolkit.createAsyncThunk("geographicSlice/geoParentRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var _ref4,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          queriesjson = queries$j.geoParentType();
          _context2.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context2.sent;
          arry = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val._id && val !== null && val !== void 0 && val.display) {
              arry.push({
                id: val === null || val === void 0 ? void 0 : val.id,
                label: val === null || val === void 0 ? void 0 : val.display,
                value: val._id,
                code: val === null || val === void 0 ? void 0 : val.code
              });
            }
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 12]]);
}))); //GEOGRAPHIC_COUNTRY_READ

var GEOGRAPHIC_COUNTRY_READ = toolkit.createAsyncThunk("geographicSlice/geoCountryRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var _ref6,
      rejectWithValue,
      _data$result,
      queriesjson,
      data,
      arry,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          queriesjson = queries$j.geoCountryRead();
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context3.sent;
          arry = [];
          data === null || data === void 0 ? void 0 : (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.map(function (val, i) {
            var _val$id, _val$_id, _val$_key, _val$geogLevelCode, _val$geogLevelName, _val$GeoLocationISDCo;

            arry.push({
              id: (_val$id = val === null || val === void 0 ? void 0 : val.id) !== null && _val$id !== void 0 ? _val$id : "",
              _id: (_val$_id = val === null || val === void 0 ? void 0 : val._id) !== null && _val$_id !== void 0 ? _val$_id : "",
              _key: (_val$_key = val._key) !== null && _val$_key !== void 0 ? _val$_key : "",
              code: (_val$geogLevelCode = val === null || val === void 0 ? void 0 : val.geogLevelCode) !== null && _val$geogLevelCode !== void 0 ? _val$geogLevelCode : "",
              name: (_val$geogLevelName = val === null || val === void 0 ? void 0 : val.geogLevelName) !== null && _val$geogLevelName !== void 0 ? _val$geogLevelName : "",
              geoLocationISDCode: (_val$GeoLocationISDCo = val === null || val === void 0 ? void 0 : val.GeoLocationISDCode) !== null && _val$GeoLocationISDCo !== void 0 ? _val$GeoLocationISDCo : "",
              status: val === null || val === void 0 ? void 0 : val.active
            });
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 15:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 12]]);
}))); //GEOGRAPHIC_STATE_READ

var GEOGRAPHIC_STATE_READ = toolkit.createAsyncThunk("geographicSlice/geoStateRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      _data$result2,
      queriesjson,
      data,
      arry,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          queriesjson = queries$j.geoStateRead(payload === null || payload === void 0 ? void 0 : payload.id);
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          arry = [];
          data === null || data === void 0 ? void 0 : (_data$result2 = data.result) === null || _data$result2 === void 0 ? void 0 : _data$result2.map(function (val, i) {
            var _val$id2, _val$_id2, _val$_key2, _val$geogLevelCode2, _val$geogLevelName2;

            arry.push({
              id: (_val$id2 = val === null || val === void 0 ? void 0 : val.id) !== null && _val$id2 !== void 0 ? _val$id2 : "",
              _id: (_val$_id2 = val === null || val === void 0 ? void 0 : val._id) !== null && _val$_id2 !== void 0 ? _val$_id2 : "",
              _key: (_val$_key2 = val._key) !== null && _val$_key2 !== void 0 ? _val$_key2 : "",
              code: (_val$geogLevelCode2 = val === null || val === void 0 ? void 0 : val.geogLevelCode) !== null && _val$geogLevelCode2 !== void 0 ? _val$geogLevelCode2 : "",
              name: (_val$geogLevelName2 = val === null || val === void 0 ? void 0 : val.geogLevelName) !== null && _val$geogLevelName2 !== void 0 ? _val$geogLevelName2 : "",
              status: val === null || val === void 0 ? void 0 : val.active
            });
          });
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 12]]);
}))); //GEOGRAPHIC_DISTRICT_READ

var GEOGRAPHIC_DISTRICT_READ = toolkit.createAsyncThunk("geographicSlice/geoDistrictRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      _data$result3,
      queriesjson,
      data,
      arry,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          queriesjson = queries$j.geoDistrictRead(payload === null || payload === void 0 ? void 0 : payload.id);
          _context5.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context5.sent;
          arry = [];
          data === null || data === void 0 ? void 0 : (_data$result3 = data.result) === null || _data$result3 === void 0 ? void 0 : _data$result3.map(function (val, i) {
            var _val$id3, _val$_id3, _val$_key3, _val$geogLevelCode3, _val$geogLevelName3;

            arry.push({
              id: (_val$id3 = val === null || val === void 0 ? void 0 : val.id) !== null && _val$id3 !== void 0 ? _val$id3 : "",
              _id: (_val$_id3 = val === null || val === void 0 ? void 0 : val._id) !== null && _val$_id3 !== void 0 ? _val$_id3 : "",
              _key: (_val$_key3 = val._key) !== null && _val$_key3 !== void 0 ? _val$_key3 : "",
              code: (_val$geogLevelCode3 = val === null || val === void 0 ? void 0 : val.geogLevelCode) !== null && _val$geogLevelCode3 !== void 0 ? _val$geogLevelCode3 : "",
              name: (_val$geogLevelName3 = val === null || val === void 0 ? void 0 : val.geogLevelName) !== null && _val$geogLevelName3 !== void 0 ? _val$geogLevelName3 : "",
              status: val === null || val === void 0 ? void 0 : val.active
            });
          });
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 12]]);
}))); //GEOGRAPHIC_CITY_READ

var GEOGRAPHIC_CITY_READ = toolkit.createAsyncThunk("geographicSlice/geoCityRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref12,
      rejectWithValue,
      _data$result4,
      queriesjson,
      data,
      arry,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          queriesjson = queries$j.geoCityRead(payload === null || payload === void 0 ? void 0 : payload.id);
          _context6.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context6.sent;
          arry = [];
          data === null || data === void 0 ? void 0 : (_data$result4 = data.result) === null || _data$result4 === void 0 ? void 0 : _data$result4.map(function (val, i) {
            var _val$id4, _val$_id4, _val$_key4, _val$geogLevelCode4, _val$geogLevelName4;

            arry.push({
              id: (_val$id4 = val === null || val === void 0 ? void 0 : val.id) !== null && _val$id4 !== void 0 ? _val$id4 : "",
              _id: (_val$_id4 = val === null || val === void 0 ? void 0 : val._id) !== null && _val$_id4 !== void 0 ? _val$_id4 : "",
              _key: (_val$_key4 = val._key) !== null && _val$_key4 !== void 0 ? _val$_key4 : "",
              code: (_val$geogLevelCode4 = val === null || val === void 0 ? void 0 : val.geogLevelCode) !== null && _val$geogLevelCode4 !== void 0 ? _val$geogLevelCode4 : "",
              name: (_val$geogLevelName4 = val === null || val === void 0 ? void 0 : val.geogLevelName) !== null && _val$geogLevelName4 !== void 0 ? _val$geogLevelName4 : "",
              status: val === null || val === void 0 ? void 0 : val.active
            });
          });
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 15:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 12]]);
}))); //GEOGRAPHIC_PINCODE_READ

var GEOGRAPHIC_PINCODE_READ = toolkit.createAsyncThunk("geographicSlice/geoPincodeRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      _data$result5,
      queriesjson,
      data,
      arry,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          queriesjson = queries$j.geoPincodeRead(payload === null || payload === void 0 ? void 0 : payload.id);
          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context7.sent;
          arry = [];
          data === null || data === void 0 ? void 0 : (_data$result5 = data.result) === null || _data$result5 === void 0 ? void 0 : _data$result5.map(function (val, i) {
            var _val$id5, _val$_id5, _val$_key5, _val$geogLevelCode5, _val$geogLevelName5;

            arry.push({
              id: (_val$id5 = val === null || val === void 0 ? void 0 : val.id) !== null && _val$id5 !== void 0 ? _val$id5 : "",
              _id: (_val$_id5 = val === null || val === void 0 ? void 0 : val._id) !== null && _val$_id5 !== void 0 ? _val$_id5 : "",
              _key: (_val$_key5 = val._key) !== null && _val$_key5 !== void 0 ? _val$_key5 : "",
              code: (_val$geogLevelCode5 = val === null || val === void 0 ? void 0 : val.geogLevelCode) !== null && _val$geogLevelCode5 !== void 0 ? _val$geogLevelCode5 : "",
              name: (_val$geogLevelName5 = val === null || val === void 0 ? void 0 : val.geogLevelName) !== null && _val$geogLevelName5 !== void 0 ? _val$geogLevelName5 : "",
              status: val === null || val === void 0 ? void 0 : val.active
            });
          });
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 15:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 12]]);
}))); //GEOGRAPHIC_STATUS_CHANGE

var GEOGRAPHIC_STATUS_CHANGE = toolkit.createAsyncThunk("geographicSlice/geoStatusChange", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref16,
      rejectWithValue,
      statuschange,
      queriesjson,
      data,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref16 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref16.rejectWithValue;
          _context8.prev = 2;
          statuschange = {
            _key: payload._key,
            status: payload.status
          };
          queriesjson = queries$j.geoStatusChange(statuschange);
          _context8.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context8.sent;
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 14:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 11]]);
}))); //GEOGRAPHIC_MASTER_MASTER

var GEOGRAPHIC_MASTER_MASTER = toolkit.createAsyncThunk("geographicSlice/geoMasterMaster", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var _ref18,
      rejectWithValue,
      data,
      arry,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _ref18 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref18.rejectWithValue;
          _context9.prev = 2;
          _context9.next = 5;
          return fetchData({
            body: JSON.stringify(queries$j.geoMasterMaster())
          }, __readDocumentUrl__);

        case 5:
          data = _context9.sent;
          arry = [];
          data.result.map(function (val) {
            var _val$_id6, _val$display;

            arry.push({
              value: (_val$_id6 = val._id) !== null && _val$_id6 !== void 0 ? _val$_id6 : "",
              label: (_val$display = val.display) !== null && _val$display !== void 0 ? _val$display : ""
            });
          });
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context9.prev = 11;
          _context9.t0 = _context9["catch"](2);
          alert("error");
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 15:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 11]]);
}))); //GEOGRAPHIC_PARENT_CODE

var GEOGRAPHIC_PARENT_CODE = toolkit.createAsyncThunk("geographicSlice/geoMasterParentCode", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref20,
      rejectWithValue,
      id,
      data,
      arry,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref20 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref20.rejectWithValue;
          _context10.prev = 2;
          id = payload.id;
          _context10.next = 6;
          return fetchData({
            body: JSON.stringify(queries$j.geoMasterParentCode(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context10.sent;
          arry = [];
          data.result.map(function (val) {
            var _val$_id7, _val$geogLevelName6;

            arry.push({
              value: (_val$_id7 = val._id) !== null && _val$_id7 !== void 0 ? _val$_id7 : "",
              label: (_val$geogLevelName6 = val.geogLevelName) !== null && _val$geogLevelName6 !== void 0 ? _val$geogLevelName6 : ""
            });
          });
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context10.prev = 12;
          _context10.t0 = _context10["catch"](2);
          alert("error");
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 16:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 12]]);
}))); //GEOGRAPIC_INSERT

var GEOGRAPIC_INSERT = toolkit.createAsyncThunk("geographicSlice/geoGraphicInsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var payload,
      _ref22,
      rejectWithValue,
      dataList,
      queriesjson,
      data,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
          _ref22 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref22.rejectWithValue;
          _context11.prev = 2;
          dataList = payload.dataList;
          queriesjson = generateJson$9(dataList);
          _context11.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context11.sent;
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context11.prev = 11;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 14:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 11]]);
}))); //GEOGRAPIC EXITS CHECK

var GEOGRAPIC_EXITS_DATA = toolkit.createAsyncThunk("geographicSlice/geogrpicExitsData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var payload,
      _ref24,
      rejectWithValue,
      levelType,
      geoLevelCode,
      data,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
          _ref24 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref24.rejectWithValue;
          _context12.prev = 2;
          levelType = payload.levelType, geoLevelCode = payload.geoLevelCode;
          _context12.next = 6;
          return fetchData({
            body: queries$j.geoCodeExits({
              levelType: levelType,
              geoLevelCode: geoLevelCode
            })
          }, __readDocumentUrl__);

        case 6:
          data = _context12.sent;
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 10:
          _context12.prev = 10;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 13:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 10]]);
})));
var GEOGRAPHIC_SINGLE_READ = toolkit.createAsyncThunk("geographicSlice/geoGraphicSingleRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
  var payload,
      _ref26,
      rejectWithValue,
      getState,
      _key,
      state,
      data,
      res,
      _args13 = arguments;

  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          payload = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {};
          _ref26 = _args13.length > 1 ? _args13[1] : undefined, rejectWithValue = _ref26.rejectWithValue, getState = _ref26.getState;
          _context13.prev = 2;
          _key = payload._key;
          state = getState();
          state.geoGraphicSlice;
          _context13.next = 8;
          return fetchData({
            body: JSON.stringify(queries$j.editGeoGraphicSingleRead(_key))
          }, __readDocumentUrl__);

        case 8:
          data = _context13.sent;
          res = generateReadJSON$5(data.result[0]);
          return _context13.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 13:
          _context13.prev = 13;
          _context13.t0 = _context13["catch"](2);
          return _context13.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context13.t0.message
          })));

        case 16:
        case "end":
          return _context13.stop();
      }
    }
  }, _callee13, null, [[2, 13]]);
})));
var geoGraphicSlice = toolkit.createSlice({
  name: "geographicApiSlice",
  initialState: {
    geoGraphicTypeRead: _objectSpread2({}, defaultState.List),
    geoParentRead: _objectSpread2({}, defaultState.List),
    geoCountryRead: _objectSpread2({}, defaultState.List),
    geoStateRead: _objectSpread2({}, defaultState.List),
    geoDistrictRead: _objectSpread2({}, defaultState.List),
    geoCityRead: _objectSpread2({}, defaultState.List),
    geoPincodeRead: _objectSpread2({}, defaultState.List),
    geoStatusChange: _objectSpread2({}, defaultState.List),
    geoMasterMaster: _objectSpread2({}, defaultState.List),
    geoMasterParentCode: _objectSpread2({}, defaultState.List),
    geoGraphicInsert: _objectSpread2({}, defaultState.List),
    geogrpicExitsData: _objectSpread2({}, defaultState.Info),
    geoGraphicSingleRead: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$z = {}, _defineProperty(_extraReducers$z, GEOGRAPHIC_TYPE_READ.fulfilled, function (state, action) {
    state.geoGraphicTypeRead.loading = false, state.geoGraphicTypeRead.error = false, state.geoGraphicTypeRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_TYPE_READ.pending, function (state, action) {
    state.geoGraphicTypeRead.loading = true, state.geoGraphicTypeRead.error = false, state.geoGraphicTypeRead.loading = true;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_TYPE_READ.rejected, function (state, action) {
    state.geoGraphicTypeRead.loading = false, state.geoGraphicTypeRead.error = true, state.geoGraphicTypeRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_PARENT_READ.fulfilled, function (state, action) {
    state.geoParentRead.loading = false, state.geoParentRead.error = false, state.geoParentRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_PARENT_READ.pending, function (state, action) {
    state.geoParentRead.loading = true, state.geoParentRead.error = false, state.geoParentRead.loading = true;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_PARENT_READ.rejected, function (state, action) {
    state.geoParentRead.loading = false, state.geoParentRead.error = true, state.geoParentRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_COUNTRY_READ.fulfilled, function (state, action) {
    state.geoCountryRead.loading = false, state.geoCountryRead.error = false, state.geoCountryRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_COUNTRY_READ.pending, function (state, action) {
    state.geoCountryRead.loading = true, state.geoCountryRead.error = false, state.geoCountryRead.loading = true;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_COUNTRY_READ.rejected, function (state, action) {
    state.geoCountryRead.loading = false, state.geoCountryRead.error = true, state.geoCountryRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_STATE_READ.fulfilled, function (state, action) {
    state.geoStateRead.loading = false, state.geoStateRead.error = false, state.geoStateRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_STATE_READ.pending, function (state, action) {
    state.geoStateRead.loading = true, state.geoStateRead.error = false, state.geoStateRead.loading = true;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_STATE_READ.rejected, function (state, action) {
    state.geoStateRead.loading = false, state.geoStateRead.error = true, state.geoStateRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_DISTRICT_READ.fulfilled, function (state, action) {
    state.geoDistrictRead.loading = false, state.geoDistrictRead.error = false, state.geoDistrictRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_DISTRICT_READ.pending, function (state, action) {
    state.geoDistrictRead.loading = true, state.geoDistrictRead.error = false, state.geoDistrictRead.loading = true;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_DISTRICT_READ.rejected, function (state, action) {
    state.geoDistrictRead.loading = false, state.geoDistrictRead.error = true, state.geoDistrictRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_CITY_READ.fulfilled, function (state, action) {
    state.geoCityRead.loading = false, state.geoCityRead.error = false, state.geoCityRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_CITY_READ.pending, function (state, action) {
    state.geoCityRead.loading = true, state.geoCityRead.error = false, state.geoCityRead.loading = true;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_CITY_READ.rejected, function (state, action) {
    state.geoCityRead.loading = false, state.geoCityRead.error = true, state.geoCityRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_PINCODE_READ.fulfilled, function (state, action) {
    state.geoPincodeRead.loading = false, state.geoPincodeRead.error = false, state.geoPincodeRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_PINCODE_READ.pending, function (state, action) {
    state.geoPincodeRead.loading = true, state.geoPincodeRead.error = false, state.geoPincodeRead.loading = true;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_PINCODE_READ.rejected, function (state, action) {
    state.geoPincodeRead.loading = false, state.geoPincodeRead.error = true, state.geoPincodeRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_STATUS_CHANGE.fulfilled, function (state, action) {
    state.geoStatusChange.loading = false, state.geoStatusChange.error = false, state.geoStatusChange = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_STATUS_CHANGE.pending, function (state, action) {
    state.geoStatusChange.loading = true, state.geoStatusChange.error = false, state.geoStatusChange.loading = true;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_STATUS_CHANGE.rejected, function (state, action) {
    state.geoStatusChange.loading = false, state.geoStatusChange.error = true, state.geoStatusChange = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_MASTER_MASTER.fulfilled, function (state, action) {
    state.geoMasterMaster.loading = false, state.geoMasterMaster.error = false, state.geoMasterMaster = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_MASTER_MASTER.pending, function (state, action) {
    state.geoMasterMaster.loading = true, state.geoMasterMaster.error = false, state.geoMasterMaster.loading = true;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_MASTER_MASTER.rejected, function (state, action) {
    state.geoMasterMaster.loading = false, state.geoMasterMaster.error = true, state.geoMasterMaster = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_PARENT_CODE.fulfilled, function (state, action) {
    state.geoMasterParentCode.loading = false, state.geoMasterParentCode.error = false, state.geoMasterParentCode = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_PARENT_CODE.pending, function (state, action) {
    state.geoMasterParentCode.loading = true, state.geoMasterParentCode.error = false, state.geoMasterParentCode.loading = true;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_PARENT_CODE.rejected, function (state, action) {
    state.geoMasterParentCode.loading = false, state.geoMasterParentCode.error = true, state.geoMasterParentCode = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPIC_INSERT.fulfilled, function (state, action) {
    state.geoGraphicInsert.loading = false, state.geoGraphicInsert.error = false, state.geoGraphicInsert = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPIC_INSERT.pending, function (state, action) {
    state.geoGraphicInsert.loading = true, state.geoGraphicInsert.error = false, state.geoGraphicInsert.loading = true;
  }), _defineProperty(_extraReducers$z, GEOGRAPIC_INSERT.rejected, function (state, action) {
    state.geoGraphicInsert.loading = false, state.geoGraphicInsert.error = true, state.geoGraphicInsert = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_SINGLE_READ.fulfilled, function (state, action) {
    state.geoGraphicSingleRead.loading = false, state.geoGraphicSingleRead.error = false, state.geoGraphicSingleRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_SINGLE_READ.pending, function (state, action) {
    state.geoGraphicSingleRead.loading = true, state.geoGraphicSingleRead.error = false, state.geoGraphicSingleRead.loading = true;
  }), _defineProperty(_extraReducers$z, GEOGRAPHIC_SINGLE_READ.rejected, function (state, action) {
    state.geoGraphicSingleRead.loading = false, state.geoGraphicSingleRead.error = true, state.geoGraphicSingleRead = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPIC_EXITS_DATA.fulfilled, function (state, action) {
    state.geogrpicExitsData.loading = false, state.geogrpicExitsData.error = false, state.geogrpicExitsData = action.payload;
  }), _defineProperty(_extraReducers$z, GEOGRAPIC_EXITS_DATA.pending, function (state, action) {
    state.geogrpicExitsData.loading = true, state.geogrpicExitsData.error = false, state.geogrpicExitsData.loading = true;
  }), _defineProperty(_extraReducers$z, GEOGRAPIC_EXITS_DATA.rejected, function (state, action) {
    state.geogrpicExitsData.loading = false, state.geogrpicExitsData.error = true, state.geogrpicExitsData = action.payload;
  }), _extraReducers$z)
});
var geoGraphicActions = {
  GEOGRAPHIC_TYPE_READ: GEOGRAPHIC_TYPE_READ,
  GEOGRAPHIC_PARENT_READ: GEOGRAPHIC_PARENT_READ,
  GEOGRAPHIC_COUNTRY_READ: GEOGRAPHIC_COUNTRY_READ,
  GEOGRAPHIC_STATE_READ: GEOGRAPHIC_STATE_READ,
  GEOGRAPHIC_DISTRICT_READ: GEOGRAPHIC_DISTRICT_READ,
  GEOGRAPHIC_CITY_READ: GEOGRAPHIC_CITY_READ,
  GEOGRAPHIC_PINCODE_READ: GEOGRAPHIC_PINCODE_READ,
  GEOGRAPHIC_STATUS_CHANGE: GEOGRAPHIC_STATUS_CHANGE,
  GEOGRAPHIC_MASTER_MASTER: GEOGRAPHIC_MASTER_MASTER,
  GEOGRAPHIC_PARENT_CODE: GEOGRAPHIC_PARENT_CODE,
  GEOGRAPIC_INSERT: GEOGRAPIC_INSERT,
  GEOGRAPIC_EXITS_DATA: GEOGRAPIC_EXITS_DATA,
  GEOGRAPHIC_SINGLE_READ: GEOGRAPHIC_SINGLE_READ
};
var geoGraphicSlice$1 = geoGraphicSlice.reducer;

var additionalcolumns = function additionalcolumns(list) {
  var datas = [];

  if ((list === null || list === void 0 ? void 0 : list.length) > 0) {
    list === null || list === void 0 ? void 0 : list.map(function (val) {
      var _val$columnName, _val$columnType$value, _val$columnType, _val$columnMaster, _val$mandatory;

      var json = {
        columnname: (_val$columnName = val === null || val === void 0 ? void 0 : val.columnName) !== null && _val$columnName !== void 0 ? _val$columnName : "",
        columntype: (_val$columnType$value = val === null || val === void 0 ? void 0 : (_val$columnType = val.columnType) === null || _val$columnType === void 0 ? void 0 : _val$columnType.value) !== null && _val$columnType$value !== void 0 ? _val$columnType$value : "",
        columnsize: val !== null && val !== void 0 && val.columnSize ? parseInt(val === null || val === void 0 ? void 0 : val.columnSize) : 0,
        columnmaster: (_val$columnMaster = val === null || val === void 0 ? void 0 : val.columnMaster) !== null && _val$columnMaster !== void 0 ? _val$columnMaster : null,
        ismandatory: (_val$mandatory = val === null || val === void 0 ? void 0 : val.mandatory) !== null && _val$mandatory !== void 0 ? _val$mandatory : false
      };
      datas.push(json);
    });
  }

  return datas;
};

var queries$i = {
  generalMasterlist_val: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"GMvalues\",\n        \"filter\": \"GMvalues.activestatus==true\",\n        \"return_fields\": \"merge(GMvalues,{gentype:document(GMvalues.gentype)})\"\n      }"),
  generalMasterlist: function generalMasterlist() {
    var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return {
      db_name: "".concat(dbName),
      entity: "GMdefinition",
      sort: "GMdefinition.gentype",
      filter: "".concat(search != "" ? "LIKE(GMdefinition.genname, \"%".concat(search, "%\", true) && GMdefinition.activestatus==true") : "GMdefinition.activestatus==true"),
      return_fields: "merge(GMdefinition,{additionalcolumns:(for ad in to_array(GMdefinition.additionalcolumns) return merge(ad,{columntype:document(ad.columntype)}))})"
    };
  },
  // column_type: `{
  //   "db_name": "${dbName}",
  //   "entity": "CodingMaster",
  //   "sort":"CodingMaster.display",
  //   "filter": "CodingMaster.Type=='QDMDATATYPE' && CodingMaster.activestatus==true",
  //   "return_fields": "{ID:CodingMaster.id,_id:CodingMaster._id,Key:CodingMaster._key,ColumnType:CodingMaster.display,code:CodingMaster.code}"
  // }`,
  column_type: "{\n      \"db_name\": \"".concat(dbName, "\",\n      \"entity\": \"CodingMaster\",\n      \"filter\": \"CodingMaster.Type=='QDMDATATYPE' && CodingMaster.activestatus==true && CodingMaster.status==true\",\n      \"return_fields\": \"KEEP(CodingMaster,'_id','id','_key','code','display','Type')\"\n    }"),
  visit_type_indicator: "{\n      \"db_name\": \"".concat(dbName, "\",\n      \"entity\": \"CodingMaster\",\n      \"filter\": \"CodingMaster.Type=='VISITTYPEINDICATOR' && CodingMaster.activestatus==true && CodingMaster.status==true\",\n      \"return_fields\": \"KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')\"\n    }"),
  upsert_general_master: function upsert_general_master(datas) {
    var filter = {};

    if (datas !== null && datas !== void 0 && datas._key) {
      var _datas$additional_col;

      filter = {
        filter: {
          _key: datas === null || datas === void 0 ? void 0 : datas._key
        }
      };
      return [_objectSpread2(_objectSpread2({
        db_name: dbName,
        entity: "GMdefinition",
        is_metadata: true
      }, filter), {}, {
        metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
        doc: {
          additionalcolumns: additionalcolumns((_datas$additional_col = datas === null || datas === void 0 ? void 0 : datas.additional_colum) !== null && _datas$additional_col !== void 0 ? _datas$additional_col : [])
        }
      })];
    } else {
      var _datas$general_type, _datas$general_name, _datas$additional_col2;

      return [_objectSpread2(_objectSpread2({
        db_name: dbName,
        entity: "GMdefinition",
        is_metadata: true
      }, filter), {}, {
        metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
        doc: {
          id: 0,
          gentype: (_datas$general_type = datas === null || datas === void 0 ? void 0 : datas.general_type) !== null && _datas$general_type !== void 0 ? _datas$general_type : "",
          genname: (_datas$general_name = datas === null || datas === void 0 ? void 0 : datas.general_name) !== null && _datas$general_name !== void 0 ? _datas$general_name : "",
          additionalcolumns: additionalcolumns((_datas$additional_col2 = datas === null || datas === void 0 ? void 0 : datas.additional_colum) !== null && _datas$additional_col2 !== void 0 ? _datas$additional_col2 : []),
          issystemdefined: false
        }
      })];
    }
  },
  get_general_master_type: function get_general_master_type(type) {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='".concat(type, "' && CodeableConceptMaster.activestatus==true"),
      return_fields: "MERGE(CodeableConceptMaster,{coding:document(CodeableConceptMaster.coding)})"
    };
  },
  add_new_general_type: function add_new_general_type(data) {
    var _data$code, _data$code$trim, _data$code2, _data$long_descriptio, _data$type, _data$short_descripti, _data$addition, _data$type2;

    // return [
    //   {
    //     "db_name": dbName,
    //     "entity": "CodingMaster",
    //     "is_metadata": true,
    //     "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
    //     "doc": {
    //       // "_id": "string",
    //       // "system": "string",
    //       // "version": "string",
    //       "code": data?.code??"",
    //       "display": data?.long_description??"",
    //       // "userSelected": "boolean",
    //       "id": 0,
    //       "Type": data?.type??"",
    //       "shortdesc": data?.short_description??"",
    //       "status": true,
    //       "gmconfigvalues": data?.addition??{}
    //     }
    //   }
    // ]
    return [{
      db_name: dbName,
      entity: "CodeableConceptMaster",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        text: (_data$code = data === null || data === void 0 ? void 0 : data.code) !== null && _data$code !== void 0 ? _data$code : "",
        coding: [{
          // "system": "string",
          // "version": "string",
          code: (_data$code$trim = data === null || data === void 0 ? void 0 : (_data$code2 = data.code) === null || _data$code2 === void 0 ? void 0 : _data$code2.trim()) !== null && _data$code$trim !== void 0 ? _data$code$trim : "",
          display: (_data$long_descriptio = data === null || data === void 0 ? void 0 : data.long_description) !== null && _data$long_descriptio !== void 0 ? _data$long_descriptio : "",
          // "userSelected": "boolean",
          id: 0,
          Type: (_data$type = data === null || data === void 0 ? void 0 : data.type) !== null && _data$type !== void 0 ? _data$type : "",
          shortdesc: (_data$short_descripti = data === null || data === void 0 ? void 0 : data.short_description) !== null && _data$short_descripti !== void 0 ? _data$short_descripti : "",
          gmconfigvalues: (_data$addition = data === null || data === void 0 ? void 0 : data.addition) !== null && _data$addition !== void 0 ? _data$addition : {},
          status: true
        }],
        id: 0,
        Type: (_data$type2 = data === null || data === void 0 ? void 0 : data.type) !== null && _data$type2 !== void 0 ? _data$type2 : "",
        status: true
      }
    }];
  },
  update_general_type: function update_general_type(edit_data) {
    var _edit_data$_key, _edit_data$code$trim, _edit_data$code, _edit_data$long_descr, _edit_data$short_desc, _edit_data$addition;

    return [{
      db_name: dbName,
      entity: "CodingMaster",
      is_metadata: true,
      filter: {
        _key: (_edit_data$_key = edit_data === null || edit_data === void 0 ? void 0 : edit_data._key) !== null && _edit_data$_key !== void 0 ? _edit_data$_key : ""
      },
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        // "system": "string",
        // "version": "string",
        code: (_edit_data$code$trim = edit_data === null || edit_data === void 0 ? void 0 : (_edit_data$code = edit_data.code) === null || _edit_data$code === void 0 ? void 0 : _edit_data$code.trim()) !== null && _edit_data$code$trim !== void 0 ? _edit_data$code$trim : "",
        display: (_edit_data$long_descr = edit_data === null || edit_data === void 0 ? void 0 : edit_data.long_description) !== null && _edit_data$long_descr !== void 0 ? _edit_data$long_descr : "",
        // "userSelected": "boolean",
        // "id": "number",
        Type: edit_data === null || edit_data === void 0 ? void 0 : edit_data.type,
        shortdesc: (_edit_data$short_desc = edit_data === null || edit_data === void 0 ? void 0 : edit_data.short_description) !== null && _edit_data$short_desc !== void 0 ? _edit_data$short_desc : "",
        gmconfigvalues: (_edit_data$addition = edit_data === null || edit_data === void 0 ? void 0 : edit_data.addition) !== null && _edit_data$addition !== void 0 ? _edit_data$addition : {} // "status": edit_data?.status_active??false,

      }
    }];
  },
  update_general_master_status: function update_general_master_status(data) {
    var _data$status, _data$status2;

    // return [
    //   {
    //     "db_name": dbName,
    //     "entity": "CodingMaster",
    //     "filter": {
    //       "_key": data?._key
    //     },
    //     "is_metadata": true,
    //     "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
    //     "doc": {
    //       "status": data?.status??false
    //     }
    //   }
    // ]
    return [{
      db_name: dbName,
      entity: "CodeableConceptMaster",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      filter: {
        _key: data === null || data === void 0 ? void 0 : data.codeable_concept_key
      },
      doc: {
        coding: [{
          _key: data === null || data === void 0 ? void 0 : data.coding_key,
          status: (_data$status = data === null || data === void 0 ? void 0 : data.status) !== null && _data$status !== void 0 ? _data$status : false
        }],
        status: (_data$status2 = data === null || data === void 0 ? void 0 : data.status) !== null && _data$status2 !== void 0 ? _data$status2 : false
      }
    }];
  },
  codingMasterQuery: function codingMasterQuery(name) {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type== '".concat(name, "' && CodingMaster.activestatus==true && CodingMaster.status==true"),
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')"
    };
  }
};

var getTableData = function getTableData(data, masters, type) {
  var setType = function setType(string_type, object_type, name) {
    var _object_type$generalM, _object_type$generalM2, _object_type$generalM3, _object_type$generalM4, _object_type$generalM5, _object_type$generalM6, _object_type$generalM7, _object_type$generalM8, _object_type$generalM9, _object_type$generalM10;

    var get_type = (_object_type$generalM = object_type === null || object_type === void 0 ? void 0 : (_object_type$generalM2 = object_type.generalMastersRead) === null || _object_type$generalM2 === void 0 ? void 0 : (_object_type$generalM3 = _object_type$generalM2.data) === null || _object_type$generalM3 === void 0 ? void 0 : (_object_type$generalM4 = _object_type$generalM3.filter(function (v) {
      return (v === null || v === void 0 ? void 0 : v.name) === type;
    })) === null || _object_type$generalM4 === void 0 ? void 0 : (_object_type$generalM5 = _object_type$generalM4[0]) === null || _object_type$generalM5 === void 0 ? void 0 : (_object_type$generalM6 = _object_type$generalM5.additionalcolumns) === null || _object_type$generalM6 === void 0 ? void 0 : (_object_type$generalM7 = _object_type$generalM6.filter(function (t) {
      return (t === null || t === void 0 ? void 0 : t.columnname) === name;
    })) === null || _object_type$generalM7 === void 0 ? void 0 : (_object_type$generalM8 = _object_type$generalM7[0]) === null || _object_type$generalM8 === void 0 ? void 0 : (_object_type$generalM9 = _object_type$generalM8.columntype) === null || _object_type$generalM9 === void 0 ? void 0 : (_object_type$generalM10 = _object_type$generalM9.display) === null || _object_type$generalM10 === void 0 ? void 0 : _object_type$generalM10.toLocaleLowerCase()) !== null && _object_type$generalM !== void 0 ? _object_type$generalM : null;

    switch (get_type) {
      case "date":
        return string_type ? moment__default["default"](string_type).format("Do MMM YYYY") : null;

      case "text":
      case "string":
      case "text box":
      case "numeric":
        return string_type;

      case "switch":
      case "checkbox":
      case "boolean":
        return string_type ? "Yes" : "No";

      case "select":
        return string_type ? string_type === null || string_type === void 0 ? void 0 : string_type.label : null;

      default:
        return string_type;
    }
  };

  var arry = [];
  data === null || data === void 0 ? void 0 : data.map(function (val, i) {
    if (val !== null && val !== void 0 && val._id) {
      var _val$coding, _val$coding$, _val$coding2, _val$coding2$, _Object$keys, _val$coding$0$code, _val$coding3, _val$coding3$, _val$coding$0$display, _val$coding4, _val$coding4$, _val$coding$0$shortde, _val$coding5, _val$coding5$, _val$coding$0$status, _val$coding6, _val$coding6$;

      var gmconfigvalues_change = val !== null && val !== void 0 && (_val$coding = val.coding) !== null && _val$coding !== void 0 && (_val$coding$ = _val$coding[0]) !== null && _val$coding$ !== void 0 && _val$coding$.gmconfigvalues ? JSON.parse(JSON.stringify(val === null || val === void 0 ? void 0 : (_val$coding2 = val.coding) === null || _val$coding2 === void 0 ? void 0 : (_val$coding2$ = _val$coding2[0]) === null || _val$coding2$ === void 0 ? void 0 : _val$coding2$.gmconfigvalues)) : {};

      if (gmconfigvalues_change && ((_Object$keys = Object.keys(gmconfigvalues_change)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0) {
        Object.keys(gmconfigvalues_change).map(function (valu) {
          return gmconfigvalues_change[valu] = setType(gmconfigvalues_change[valu], masters, valu);
        });
      }

      arry.push(_objectSpread2(_objectSpread2({
        code: (_val$coding$0$code = val === null || val === void 0 ? void 0 : (_val$coding3 = val.coding) === null || _val$coding3 === void 0 ? void 0 : (_val$coding3$ = _val$coding3[0]) === null || _val$coding3$ === void 0 ? void 0 : _val$coding3$.code) !== null && _val$coding$0$code !== void 0 ? _val$coding$0$code : "",
        long_description: (_val$coding$0$display = val === null || val === void 0 ? void 0 : (_val$coding4 = val.coding) === null || _val$coding4 === void 0 ? void 0 : (_val$coding4$ = _val$coding4[0]) === null || _val$coding4$ === void 0 ? void 0 : _val$coding4$.display) !== null && _val$coding$0$display !== void 0 ? _val$coding$0$display : "",
        short_description: (_val$coding$0$shortde = val === null || val === void 0 ? void 0 : (_val$coding5 = val.coding) === null || _val$coding5 === void 0 ? void 0 : (_val$coding5$ = _val$coding5[0]) === null || _val$coding5$ === void 0 ? void 0 : _val$coding5$.shortdesc) !== null && _val$coding$0$shortde !== void 0 ? _val$coding$0$shortde : "",
        status_active: (_val$coding$0$status = val === null || val === void 0 ? void 0 : (_val$coding6 = val.coding) === null || _val$coding6 === void 0 ? void 0 : (_val$coding6$ = _val$coding6[0]) === null || _val$coding6$ === void 0 ? void 0 : _val$coding6$.status) !== null && _val$coding$0$status !== void 0 ? _val$coding$0$status : false
      }, gmconfigvalues_change), val));
    }
  });
  return arry;
};

var _extraReducers$y;

var loopMasters$6 = function loopMasters(masterQuery) {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject) {
      var calls;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              calls = masterQuery.map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return fetchMaster$6(val, JSON.stringify(queries$i.codingMasterQuery(val)));

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
              es6Promise.Promise.all(calls).then(function (data) {
                var json = {};
                data.map(function (val) {
                  var arr = [];
                  val.data.map(function (value) {
                    var _value$display;

                    // arr.push({
                    // 	label: value.coding ? value.coding[0] ? value.coding[0].display : "" : val,
                    // 	value: value.coding?.[0]?._id,
                    // 	...value
                    // })
                    arr.push(_objectSpread2({
                      label: (_value$display = value === null || value === void 0 ? void 0 : value.display) !== null && _value$display !== void 0 ? _value$display : "",
                      value: value._id
                    }, value));
                  });
                  json[val.name] = arr;
                  resolve(json);
                });
              })["catch"](function (err) {
                resolve([]);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var fetchMaster$6 = function fetchMaster(name, query) {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetchData({
                body: query
              }, __readDocumentUrl__);

            case 2:
              data = _context3.sent;
              resolve({
                data: data.result,
                name: name
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }());
};

var GENERAL_MASTERS_READ = toolkit.createAsyncThunk("generalMasterSlice/generalMastersRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref5,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref5 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref5.rejectWithValue;
          _context4.prev = 2;
          queriesjson = queries$i.generalMasterlist(payload.search);
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          arry = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.gentype) {
              var _val$gentype;

              arry.push(_objectSpread2({
                name: (_val$gentype = val === null || val === void 0 ? void 0 : val.gentype) !== null && _val$gentype !== void 0 ? _val$gentype : ""
              }, val));
            }
          });
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 12]]);
})));
var COLUMN_TYPE_MASTERS = toolkit.createAsyncThunk("generalMasterSlice/column_type", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var _ref7,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _ref7 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref7.rejectWithValue;
          _context5.prev = 2;
          queriesjson = queries$i.column_type;
          _context5.next = 6;
          return fetchData({
            body: queriesjson
          }, __readDocumentUrl__);

        case 6:
          data = _context5.sent;
          arry = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.display) {
              var _val$display;

              arry.push(_objectSpread2({
                label: (_val$display = val === null || val === void 0 ? void 0 : val.display) !== null && _val$display !== void 0 ? _val$display : "",
                value: val._id
              }, val));
            }
          });
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 12]]);
})));
var UPSERT_GENERAL_MASTER_LIST = toolkit.createAsyncThunk("generalMasterSlice/list_mmaster_upsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref9,
      rejectWithValue,
      _data$result,
      data_payload,
      queriesjson,
      data,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref9 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref9.rejectWithValue;
          _context6.prev = 2;
          data_payload = payload;
          queriesjson = queries$i.upsert_general_master(data_payload);
          _context6.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context6.sent;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: (_data$result = data.result) !== null && _data$result !== void 0 ? _data$result : data
          }));

        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 14:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 11]]);
})));
var GET_GENERAL_MASTER_TYPE = toolkit.createAsyncThunk("generalMasterSlice/get_general_master_type", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      actions,
      type,
      data,
      readData,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          actions = _args7.length > 1 ? _args7[1] : undefined;
          _context7.prev = 2;
          actions.rejectWithValue, actions.getState;
          type = payload.type;
          _context7.next = 7;
          return fetchData({
            body: JSON.stringify(queries$i.get_general_master_type(type))
          }, __readDocumentUrl__);

        case 7:
          data = _context7.sent;
          readData = getTableData(data.result, actions.getState().generalMasterSlice, type);
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: readData
          }));

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context7.t0.message
          })));

        case 15:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 12]]);
})));
var ADD_NEW_GENERAL_MASTER_TYPE = toolkit.createAsyncThunk("generalMasterSlice/add_new_general_type", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref12,
      rejectWithValue,
      data_payload,
      queriesjson,
      data,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref12 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context8.prev = 2;
          data_payload = payload;
          queriesjson = queries$i.add_new_general_type(data_payload);
          _context8.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context8.sent;
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 14:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 11]]);
})));
var UPDATE_GENERAL_MASTER_TYPE = toolkit.createAsyncThunk("generalMasterSlice/update_general_type", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref14,
      rejectWithValue,
      _data$result2,
      data_payload,
      queriesjson,
      data,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref14 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context9.prev = 2;
          data_payload = payload;
          queriesjson = queries$i.update_general_type(data_payload);
          _context9.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context9.sent;
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: (_data$result2 = data.result) !== null && _data$result2 !== void 0 ? _data$result2 : data
          }));

        case 11:
          _context9.prev = 11;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 14:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 11]]);
})));
var UPDATE_GENERAL_MASTER_STATUS = toolkit.createAsyncThunk("generalMasterSlice/update_general_status", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref16,
      rejectWithValue,
      data_payload,
      queriesjson,
      data,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref16 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref16.rejectWithValue;
          _context10.prev = 2;
          data_payload = payload;
          queriesjson = queries$i.update_general_master_status(data_payload);
          _context10.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context10.sent;
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context10.prev = 11;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 14:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 11]]);
})));
var VISIT_TYPE_INDICATOR = toolkit.createAsyncThunk("generalMasterSlice/visit_type_indicator", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var _ref18,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _ref18 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref18.rejectWithValue;
          _context11.prev = 2;
          queriesjson = queries$i.visit_type_indicator;
          _context11.next = 6;
          return fetchData({
            body: queriesjson
          }, __readDocumentUrl__);

        case 6:
          data = _context11.sent;
          arry = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val.display) {
              var _val$display2;

              arry.push({
                label: (_val$display2 = val === null || val === void 0 ? void 0 : val.display) !== null && _val$display2 !== void 0 ? _val$display2 : "",
                value: val._id
              });
            }
          });
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context11.prev = 12;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 15:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 12]]);
})));
var COLUMN_MASTERS = toolkit.createAsyncThunk("generalMasterSlice/column_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var payload,
      _ref20,
      rejectWithValue,
      list,
      data,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
          _ref20 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref20.rejectWithValue;
          _context12.prev = 2;
          list = payload;
          _context12.next = 6;
          return loopMasters$6(list);

        case 6:
          data = _context12.sent;
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 10:
          _context12.prev = 10;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 13:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 10]]);
})));
var generalMasterSlice = toolkit.createSlice({
  name: "geographicApiSlice",
  initialState: {
    generalMastersRead: _objectSpread2({}, defaultState.List),
    column_type_master: _objectSpread2({}, defaultState.List),
    upsert_general_master_type: _objectSpread2({}, defaultState.List),
    get_general_master_type: _objectSpread2({}, defaultState.List),
    add_new_general_type: _objectSpread2({}, defaultState.List),
    update_general_type: _objectSpread2({}, defaultState.List),
    update_general_status: _objectSpread2({}, defaultState.List),
    visit_type_indicator: _objectSpread2({}, defaultState.List),
    column_masters: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$y = {}, _defineProperty(_extraReducers$y, GENERAL_MASTERS_READ.fulfilled, function (state, action) {
    state.generalMastersRead.loading = false, state.generalMastersRead.error = false, state.generalMastersRead = action.payload;
  }), _defineProperty(_extraReducers$y, GENERAL_MASTERS_READ.pending, function (state, action) {
    state.generalMastersRead.loading = true, state.generalMastersRead.error = false, state.generalMastersRead.loading = true;
  }), _defineProperty(_extraReducers$y, GENERAL_MASTERS_READ.rejected, function (state, action) {
    state.generalMastersRead.loading = false, state.generalMastersRead.error = true, state.generalMastersRead = action.payload;
  }), _defineProperty(_extraReducers$y, COLUMN_TYPE_MASTERS.fulfilled, function (state, action) {
    state.column_type_master.loading = false, state.column_type_master.error = false, state.column_type_master = action.payload;
  }), _defineProperty(_extraReducers$y, COLUMN_TYPE_MASTERS.pending, function (state, action) {
    state.column_type_master.loading = true, state.column_type_master.error = false, state.column_type_master.loading = true;
  }), _defineProperty(_extraReducers$y, COLUMN_TYPE_MASTERS.rejected, function (state, action) {
    state.column_type_master.loading = false, state.column_type_master.error = true, state.column_type_master = action.payload;
  }), _defineProperty(_extraReducers$y, UPSERT_GENERAL_MASTER_LIST.fulfilled, function (state, action) {
    state.upsert_general_master_type.loading = false, state.upsert_general_master_type.error = false, state.upsert_general_master_type = action.payload;
  }), _defineProperty(_extraReducers$y, UPSERT_GENERAL_MASTER_LIST.pending, function (state, action) {
    state.upsert_general_master_type.loading = true, state.upsert_general_master_type.error = false, state.upsert_general_master_type.loading = true;
  }), _defineProperty(_extraReducers$y, UPSERT_GENERAL_MASTER_LIST.rejected, function (state, action) {
    state.upsert_general_master_type.loading = false, state.upsert_general_master_type.error = true, state.upsert_general_master_type = action.payload;
  }), _defineProperty(_extraReducers$y, GET_GENERAL_MASTER_TYPE.fulfilled, function (state, action) {
    state.get_general_master_type.loading = false, state.get_general_master_type.error = false, state.get_general_master_type = action.payload;
  }), _defineProperty(_extraReducers$y, GET_GENERAL_MASTER_TYPE.pending, function (state, action) {
    state.get_general_master_type.loading = true, state.get_general_master_type.error = false, state.get_general_master_type.loading = true;
  }), _defineProperty(_extraReducers$y, GET_GENERAL_MASTER_TYPE.rejected, function (state, action) {
    state.get_general_master_type.loading = false, state.get_general_master_type.error = true, state.get_general_master_type = action.payload;
  }), _defineProperty(_extraReducers$y, ADD_NEW_GENERAL_MASTER_TYPE.fulfilled, function (state, action) {
    state.add_new_general_type.loading = false, state.add_new_general_type.error = false, state.add_new_general_type = action.payload;
  }), _defineProperty(_extraReducers$y, ADD_NEW_GENERAL_MASTER_TYPE.pending, function (state, action) {
    state.add_new_general_type.loading = true, state.add_new_general_type.error = false, state.add_new_general_type.loading = true;
  }), _defineProperty(_extraReducers$y, ADD_NEW_GENERAL_MASTER_TYPE.rejected, function (state, action) {
    state.add_new_general_type.loading = false, state.add_new_general_type.error = true, state.add_new_general_type = action.payload;
  }), _defineProperty(_extraReducers$y, UPDATE_GENERAL_MASTER_TYPE.fulfilled, function (state, action) {
    state.update_general_type.loading = false, state.update_general_type.error = false, state.update_general_type = action.payload;
  }), _defineProperty(_extraReducers$y, UPDATE_GENERAL_MASTER_TYPE.pending, function (state, action) {
    state.update_general_type.loading = true, state.update_general_type.error = false, state.update_general_type.loading = true;
  }), _defineProperty(_extraReducers$y, UPDATE_GENERAL_MASTER_TYPE.rejected, function (state, action) {
    state.update_general_type.loading = false, state.update_general_type.error = true, state.update_general_type = action.payload;
  }), _defineProperty(_extraReducers$y, UPDATE_GENERAL_MASTER_STATUS.fulfilled, function (state, action) {
    state.update_general_status.loading = false, state.update_general_status.error = false, state.update_general_status = action.payload;
  }), _defineProperty(_extraReducers$y, UPDATE_GENERAL_MASTER_STATUS.pending, function (state, action) {
    state.update_general_status.loading = true, state.update_general_status.error = false, state.update_general_status.loading = true;
  }), _defineProperty(_extraReducers$y, UPDATE_GENERAL_MASTER_STATUS.rejected, function (state, action) {
    state.update_general_status.loading = false, state.update_general_status.error = true, state.update_general_status = action.payload;
  }), _defineProperty(_extraReducers$y, VISIT_TYPE_INDICATOR.fulfilled, function (state, action) {
    state.visit_type_indicator.loading = false, state.visit_type_indicator.error = false, state.visit_type_indicator = action.payload;
  }), _defineProperty(_extraReducers$y, VISIT_TYPE_INDICATOR.pending, function (state, action) {
    state.visit_type_indicator.loading = true, state.visit_type_indicator.error = false, state.visit_type_indicator.loading = true;
  }), _defineProperty(_extraReducers$y, VISIT_TYPE_INDICATOR.rejected, function (state, action) {
    state.visit_type_indicator.loading = false, state.visit_type_indicator.error = true, state.visit_type_indicator = action.payload;
  }), _defineProperty(_extraReducers$y, COLUMN_MASTERS.fulfilled, function (state, action) {
    state.column_masters.loading = false, state.column_masters.error = false, state.column_masters = action.payload;
  }), _defineProperty(_extraReducers$y, COLUMN_MASTERS.pending, function (state, action) {
    state.column_masters.loading = true, state.column_masters.error = false, state.column_masters.loading = true;
  }), _defineProperty(_extraReducers$y, COLUMN_MASTERS.rejected, function (state, action) {
    state.column_masters.loading = false, state.column_masters.error = true, state.column_masters = action.payload;
  }), _extraReducers$y)
});
var generalMasterActions = {
  GENERAL_MASTERS_READ: GENERAL_MASTERS_READ,
  COLUMN_TYPE_MASTERS: COLUMN_TYPE_MASTERS,
  UPSERT_GENERAL_MASTER_LIST: UPSERT_GENERAL_MASTER_LIST,
  GET_GENERAL_MASTER_TYPE: GET_GENERAL_MASTER_TYPE,
  ADD_NEW_GENERAL_MASTER_TYPE: ADD_NEW_GENERAL_MASTER_TYPE,
  UPDATE_GENERAL_MASTER_TYPE: UPDATE_GENERAL_MASTER_TYPE,
  UPDATE_GENERAL_MASTER_STATUS: UPDATE_GENERAL_MASTER_STATUS,
  VISIT_TYPE_INDICATOR: VISIT_TYPE_INDICATOR,
  COLUMN_MASTERS: COLUMN_MASTERS
};
var generalMasterSlice$1 = generalMasterSlice.reducer;

var queries$h = {
  status_update_practitioner: function status_update_practitioner(data) {
    return [{
      db_name: dbName,
      entity: "CodeableConceptMaster",
      filter: {
        _key: data._key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        status: data.status
      }
    }];
  },
  status_update_symptom_and_specialty: function status_update_symptom_and_specialty(data) {
    return [{
      db_name: dbName,
      entity: "SymptomsMapping",
      filter: {
        _key: data._key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        status: data.status
      }
    }];
  },
  symptom_and_specialty_upsert: function symptom_and_specialty_upsert(data) {
    var _data$symtom_descript, _data$id, _data$status, _data$symptom_code$tr, _data$symptom_code, _data$specialities;

    var filter = {};

    if (data._key) {
      filter = {
        filter: {
          _key: data._key
        }
      };
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "SymptomsMapping"
    }, filter), {}, {
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        SymptomsName: (_data$symtom_descript = data === null || data === void 0 ? void 0 : data.symtom_description) !== null && _data$symtom_descript !== void 0 ? _data$symtom_descript : "",
        id: (_data$id = data === null || data === void 0 ? void 0 : data.id) !== null && _data$id !== void 0 ? _data$id : 0,
        status: (_data$status = data === null || data === void 0 ? void 0 : data.status) !== null && _data$status !== void 0 ? _data$status : true,
        symptomsCode: (_data$symptom_code$tr = data === null || data === void 0 ? void 0 : (_data$symptom_code = data.symptom_code) === null || _data$symptom_code === void 0 ? void 0 : _data$symptom_code.trim()) !== null && _data$symptom_code$tr !== void 0 ? _data$symptom_code$tr : "",
        specialty: (_data$specialities = data === null || data === void 0 ? void 0 : data.specialities) !== null && _data$specialities !== void 0 ? _data$specialities : []
      }
    })];
  },
  symptom_and_specialty_read: function symptom_and_specialty_read() {
    return {
      db_name: dbName,
      entity: "SymptomsMapping",
      filter: "SymptomsMapping.activestatus==true",
      return_fields: "merge(SymptomsMapping,{specialty:(FOR cod IN CodeableConceptMaster filter cod._id in SymptomsMapping.specialty  RETURN merge(cod,{coding:document(cod.coding)}))})",
      sort: "SymptomsMapping.createddate"
    };
  },
  symptom_and_specialty_single_read: function symptom_and_specialty_single_read(_key) {
    return {
      db_name: dbName,
      entity: "SymptomsMapping",
      filter: "SymptomsMapping._key=='".concat(_key, "' && SymptomsMapping.activestatus==true"),
      return_fields: "merge(SymptomsMapping,{specialty:(FOR cod IN CodeableConceptMaster filter cod._id in SymptomsMapping.specialty  RETURN merge(cod,{coding:document(cod.coding)}))})"
    };
  },
  specialtyMaster: function specialtyMaster() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      filter: "CodeableConceptMaster.Type=='SPECIALTY' && CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})",
      sort: "document(CodeableConceptMaster.coding)[*].display"
    };
  },
  upsert: function upsert(data) {
    var filter = {};
    var metadata = {};

    if (data._key) {
      filter = {
        filter: {
          _key: data._key
        }
      };
    }

    if (data.id) {
      metadata = {
        id: data.id
      };
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "CodeableConceptMaster",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, filter), {}, {
      doc: {
        text: "",
        coding: [_objectSpread2({
          system: "",
          version: "1",
          code: data.code,
          display: data.description,
          userSelected: true,
          id: 0,
          Type: data.type
        }, metadata)],
        Type: data.type,
        id: 0,
        status: true
      }
    })];
  }
};

var _extraReducers$x;
var SYMPTOM_AND_SPECIALTY_STATUS_CHANGE = toolkit.createAsyncThunk("symptomAndSpecialtySlice/symptom_and_specialty_status_update", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      statuschange,
      queriesjson,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          statuschange = {
            _key: payload._key,
            status: payload.status
          };
          queriesjson = queries$h.status_update_symptom_and_specialty(statuschange);
          _context.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));

var constructReadJSON = function constructReadJSON(data) {
  var arry = [];
  data.map(function (val) {
    var _val$coding$0$display, _val$coding, _val$coding$;

    arry.push((_val$coding$0$display = (_val$coding = val.coding) === null || _val$coding === void 0 ? void 0 : (_val$coding$ = _val$coding[0]) === null || _val$coding$ === void 0 ? void 0 : _val$coding$.display) !== null && _val$coding$0$display !== void 0 ? _val$coding$0$display : "");
  });
  return arry.join();
};

var constructSingleReadJSON = function constructSingleReadJSON(data) {
  var arry = [];
  data.map(function (val) {
    var _val$_id, _val$coding$0$display2, _val$coding2, _val$coding2$;

    arry.push({
      "value": (_val$_id = val._id) !== null && _val$_id !== void 0 ? _val$_id : 0,
      "label": (_val$coding$0$display2 = (_val$coding2 = val.coding) === null || _val$coding2 === void 0 ? void 0 : (_val$coding2$ = _val$coding2[0]) === null || _val$coding2$ === void 0 ? void 0 : _val$coding2$.display) !== null && _val$coding$0$display2 !== void 0 ? _val$coding$0$display2 : ""
    });
  });
  return arry;
};

var SYMPTOM_AND_SPECIALTY_READ = toolkit.createAsyncThunk("symptomAndSpecialtySlice/symptom_and_specialty_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var _ref4,
      rejectWithValue,
      readqueries,
      data,
      arry,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          readqueries = queries$h.symptom_and_specialty_read();
          _context2.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context2.sent;
          arry = [];
          data.result.map(function (val) {
            if (val._key) {
              arry.push({
                id: val.id ? val.id : 0,
                _key: val._key ? val._key : "",
                status: val.status ? val.status : false,
                symtom_description: val.SymptomsName ? val.SymptomsName : "",
                symptom_code: val.symptomsCode ? val.symptomsCode : "",
                specialities: constructReadJSON(val.specialty)
              });
            }
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context2.t0.message
          })));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 12]]);
})));
var SYMPTOM_AND_SPECIALTY_SINGLE_READ = toolkit.createAsyncThunk("symptomAndSpecialtySlice/symptom_and_specialty_single_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      readqueries,
      data,
      arry,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          readqueries = queries$h.symptom_and_specialty_single_read(payload.kay);
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context3.sent;
          arry = [];
          data.result.map(function (val) {
            if (val._key) {
              arry.push({
                id: val.id ? val.id : 0,
                _key: val._key ? val._key : "",
                status: val.status ? val.status : false,
                symtom_description: val.SymptomsName ? val.SymptomsName : "",
                symptom_code: val.symptomsCode ? val.symptomsCode : "",
                specialities: constructSingleReadJSON(val.specialty)
              });
            }
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context3.t0.message
          })));

        case 15:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 12]]);
})));
var SYMPTOM_AND_SPECIALTY_UPSERT = toolkit.createAsyncThunk("symptomAndSpecialtySlice/symptom_and_specialty_upsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      queriesjson,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          queriesjson = queries$h.symptom_and_specialty_upsert(payload);
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 6:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 10]]);
})));
var SYMPTOM_AND_SPECIALTY_MASTERS = toolkit.createAsyncThunk("symptomAndSpecialtySlice/symptom_and_specialty_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var _ref10,
      rejectWithValue,
      data_arr,
      arry,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          _context5.next = 5;
          return fetchData({
            body: JSON.stringify(queries$h.specialtyMaster())
          }, __readDocumentUrl__);

        case 5:
          data_arr = _context5.sent;
          arry = [];
          _context5.next = 9;
          return data_arr.result.map(function (val) {
            arry.push({
              label: val.coding[0].display,
              value: val._id
            });
          });

        case 9:
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 12]]);
})));
var symptomAndSpecialtySlice = toolkit.createSlice({
  name: "symptomAndSpecialtySlice",
  initialState: {
    symptom_and_specialty_status_update: _objectSpread2({}, defaultState.List),
    symptom_and_specialty_list: _objectSpread2({}, defaultState.List),
    symptom_and_specialty_single_read: _objectSpread2({}, defaultState.List),
    symptom_and_specialty_upsert: _objectSpread2({}, defaultState.List),
    symptom_and_specialty_master: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$x = {}, _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_STATUS_CHANGE.fulfilled, function (state, action) {
    state.symptom_and_specialty_status_update.loading = false, state.symptom_and_specialty_status_update.error = false, state.symptom_and_specialty_status_update = action.payload;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_STATUS_CHANGE.pending, function (state, action) {
    state.symptom_and_specialty_status_update.loading = true, state.symptom_and_specialty_status_update.error = false, state.symptom_and_specialty_status_update.loading = true;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_STATUS_CHANGE.rejected, function (state, action) {
    state.symptom_and_specialty_status_update.loading = false, state.symptom_and_specialty_status_update.error = true, state.symptom_and_specialty_status_update = action.payload;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_READ.fulfilled, function (state, action) {
    state.symptom_and_specialty_list.loading = false, state.symptom_and_specialty_list.error = false, state.symptom_and_specialty_list = action.payload;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_READ.pending, function (state, action) {
    state.symptom_and_specialty_list.loading = true, state.symptom_and_specialty_list.error = false, state.symptom_and_specialty_list.loading = true;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_READ.rejected, function (state, action) {
    state.symptom_and_specialty_list.loading = false, state.symptom_and_specialty_list.error = true, state.symptom_and_specialty_list = action.payload;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_SINGLE_READ.fulfilled, function (state, action) {
    state.symptom_and_specialty_single_read.loading = false, state.symptom_and_specialty_single_read.error = false, state.symptom_and_specialty_single_read = action.payload;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_SINGLE_READ.pending, function (state, action) {
    state.symptom_and_specialty_single_read.loading = true, state.symptom_and_specialty_single_read.error = false, state.symptom_and_specialty_single_read.loading = true;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_SINGLE_READ.rejected, function (state, action) {
    state.symptom_and_specialty_single_read.loading = false, state.symptom_and_specialty_single_read.error = true, state.symptom_and_specialty_single_read = action.payload;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_MASTERS.fulfilled, function (state, action) {
    state.symptom_and_specialty_master.loading = false, state.symptom_and_specialty_master.error = false, state.symptom_and_specialty_master = action.payload;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_MASTERS.pending, function (state, action) {
    state.symptom_and_specialty_master.loading = true, state.symptom_and_specialty_master.error = false, state.symptom_and_specialty_master.loading = true;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_MASTERS.rejected, function (state, action) {
    state.symptom_and_specialty_master.loading = false, state.symptom_and_specialty_master.error = true, state.symptom_and_specialty_master = action.payload;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_UPSERT.fulfilled, function (state, action) {
    state.symptom_and_specialty_upsert.loading = false, state.symptom_and_specialty_upsert.error = false, state.symptom_and_specialty_upsert = action.payload;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_UPSERT.pending, function (state, action) {
    state.symptom_and_specialty_upsert.loading = true, state.symptom_and_specialty_upsert.error = false, state.symptom_and_specialty_upsert.loading = true;
  }), _defineProperty(_extraReducers$x, SYMPTOM_AND_SPECIALTY_UPSERT.rejected, function (state, action) {
    state.symptom_and_specialty_upsert.loading = false, state.symptom_and_specialty_upsert.error = true, state.symptom_and_specialty_upsert = action.payload;
  }), _extraReducers$x)
});
var symptomAndSpecialtyActions = {
  SYMPTOM_AND_SPECIALTY_STATUS_CHANGE: SYMPTOM_AND_SPECIALTY_STATUS_CHANGE,
  SYMPTOM_AND_SPECIALTY_READ: SYMPTOM_AND_SPECIALTY_READ,
  SYMPTOM_AND_SPECIALTY_MASTERS: SYMPTOM_AND_SPECIALTY_MASTERS,
  SYMPTOM_AND_SPECIALTY_UPSERT: SYMPTOM_AND_SPECIALTY_UPSERT,
  SYMPTOM_AND_SPECIALTY_SINGLE_READ: SYMPTOM_AND_SPECIALTY_SINGLE_READ
};
var symptomAndSpecialtySlice$1 = symptomAndSpecialtySlice.reducer;

var queries$g = {
  encounterType: function encounterType(type) {
    // return {
    //         "db_name": dbName,
    //         "entity": "AMPatientClass",
    //         "filter": "AMPatientClass.activestatus==true",
    //         "return_fields": "merge(AMPatientClass,{encType:document(AMPatientClass.encType).code},{encTypeDesc:document(AMPatientClass.encTypeDesc).display},{encClsType:document(AMPatientClass.encClsType).code},{encClsDesc:document(AMPatientClass.encClsDesc).display})",
    //         "sort": "document(AMPatientClass.encTypeDesc).display"
    //     }
    return {
      "db_name": dbName,
      "entity": "AMPatientClass",
      "filter": "AMPatientClass.activestatus==true",
      "return_fields": "merge(AMPatientClass,{encClsByTypes:(for encClsByTypes in (AMPatientClass.encClsByTypes) return merge(encClsByTypes,{encClsType:document(encClsByTypes.encClsType)}))},{encType:document(AMPatientClass.encType)})",
      "sort": "document(AMPatientClass.encType).display "
    };
  },
  //STATUS CHANGE
  encouterStatusChange: function encouterStatusChange(data) {
    return [{
      "db_name": dbName,
      "entity": "AMPatientClass",
      "filter": {
        _key: data._key
      },
      "is_metadata": true,
      "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
      "doc": {
        "status": data.status
      }
    }];
  }
};

var _extraReducers$w;
var ENCOUNTER_TYPE_READ = toolkit.createAsyncThunk("encouterTypeSlice/encouterTypeRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          queriesjson = queries$g.encounterType();
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          arry = [];
          data.result.map(function (val, i) {
            if (val !== null && val !== void 0 && val._id) {
              var _val$id, _val$_id, _val$encType$display, _val$encType, _val$encType$code, _val$encType2;

              arry.push(_objectSpread2({
                id: (_val$id = val === null || val === void 0 ? void 0 : val.id) !== null && _val$id !== void 0 ? _val$id : "",
                _id: (_val$_id = val === null || val === void 0 ? void 0 : val._id) !== null && _val$_id !== void 0 ? _val$_id : "",
                description: (_val$encType$display = val === null || val === void 0 ? void 0 : (_val$encType = val.encType) === null || _val$encType === void 0 ? void 0 : _val$encType.display) !== null && _val$encType$display !== void 0 ? _val$encType$display : "",
                code: (_val$encType$code = val === null || val === void 0 ? void 0 : (_val$encType2 = val.encType) === null || _val$encType2 === void 0 ? void 0 : _val$encType2.code) !== null && _val$encType$code !== void 0 ? _val$encType$code : "",
                encounter_class: constructEncounterClassData(val === null || val === void 0 ? void 0 : val.encClsByTypes).toString()
              }, val));
            }
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 12]]);
})));

var constructEncounterClassData = function constructEncounterClassData(data) {
  var arr = [];

  if (data.length > 0 && Array.isArray(data)) {
    data.map(function (val) {
      var _val$encClsType, _val$encClsType2;

      if (val !== null && val !== void 0 && (_val$encClsType = val.encClsType) !== null && _val$encClsType !== void 0 && _val$encClsType.display && val !== null && val !== void 0 && (_val$encClsType2 = val.encClsType) !== null && _val$encClsType2 !== void 0 && _val$encClsType2.code) {
        var _val$encClsType3, _val$encClsType4, _val$encClsType5, _val$encClsType6;

        var dis = val !== null && val !== void 0 && (_val$encClsType3 = val.encClsType) !== null && _val$encClsType3 !== void 0 && _val$encClsType3.display ? val === null || val === void 0 ? void 0 : (_val$encClsType4 = val.encClsType) === null || _val$encClsType4 === void 0 ? void 0 : _val$encClsType4.display : "";
        var co = val !== null && val !== void 0 && (_val$encClsType5 = val.encClsType) !== null && _val$encClsType5 !== void 0 && _val$encClsType5.code ? val === null || val === void 0 ? void 0 : (_val$encClsType6 = val.encClsType) === null || _val$encClsType6 === void 0 ? void 0 : _val$encClsType6.code : "" + " )";
        arr.push(dis + " (" + co + ")");
      }
    });
  }

  return arr;
}; //ENCOUNTER_TYPE_STATUS_CHANGE


var ENCOUNTER_TYPE_STATUS_CHANGE = toolkit.createAsyncThunk("encouterTypeSlice/encouterStatusChange", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      statuschange,
      queriesjson,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          statuschange = {
            _key: payload._key,
            status: payload.status
          };
          queriesjson = queries$g.encouterStatusChange(statuschange);
          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var encouterTypeSlice = toolkit.createSlice({
  name: "encouterTypeSlice",
  initialState: {
    encouterTypeRead: _objectSpread2({}, defaultState.List),
    encouterStatusChange: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$w = {}, _defineProperty(_extraReducers$w, ENCOUNTER_TYPE_READ.fulfilled, function (state, action) {
    state.encouterTypeRead.loading = false, state.encouterTypeRead.error = false, state.encouterTypeRead = action.payload;
  }), _defineProperty(_extraReducers$w, ENCOUNTER_TYPE_READ.pending, function (state, action) {
    state.encouterTypeRead.loading = true, state.encouterTypeRead.error = false, state.encouterTypeRead.loading = true;
  }), _defineProperty(_extraReducers$w, ENCOUNTER_TYPE_READ.rejected, function (state, action) {
    state.encouterTypeRead.loading = false, state.encouterTypeRead.error = true, state.encouterTypeRead = action.payload;
  }), _defineProperty(_extraReducers$w, ENCOUNTER_TYPE_STATUS_CHANGE.fulfilled, function (state, action) {
    state.encouterStatusChange.loading = false, state.encouterStatusChange.error = false, state.encouterStatusChange = action.payload;
  }), _defineProperty(_extraReducers$w, ENCOUNTER_TYPE_STATUS_CHANGE.pending, function (state, action) {
    state.encouterStatusChange.loading = true, state.encouterStatusChange.error = false, state.encouterStatusChange.loading = true;
  }), _defineProperty(_extraReducers$w, ENCOUNTER_TYPE_STATUS_CHANGE.rejected, function (state, action) {
    state.encouterStatusChange.loading = false, state.encouterStatusChange.error = true, state.encouterStatusChange = action.payload;
  }), _extraReducers$w)
});
var encouterTypeActions = {
  ENCOUNTER_TYPE_READ: ENCOUNTER_TYPE_READ,
  ENCOUNTER_TYPE_STATUS_CHANGE: ENCOUNTER_TYPE_STATUS_CHANGE
};
var encounterTypeSlice = encouterTypeSlice.reducer;

var queries$f = {
  locationlist: function locationlist(type) {
    // return {
    //   db_name: dbName,
    //   entity:
    //     "LocationMaster,LocationMaster_CodeableConceptMaster_E,CodeableConceptMaster_CodingMaster_E,LocationMaster_LocationRoleType_E,LocationMaster_Organization_E,Organization_CodeableConceptMaster_E,LocationMaster_ContactPointMaster_E,LocationMaster_AddressMaster_E,LocationMaster_AttachmentMaster_E",
    //   filter: "LocationMaster.activestatus==true",
    //   isTraversal: "true",
    //   sort: "LocationMaster.createddate",
    //   return_fields: "{vertices:v,orginatedata:LocationMaster}",
    // };
    return {
      db_name: dbName,
      entity: "LocationMaster",
      return_fields: "merge(LocationMaster,{operationalStatus:(for ops in CodeableConceptMaster filter ops._id==LocationMaster.operationalStatus return merge(ops,{coding:document(ops.coding)}))},{managingOrgEntityType:(for moe in CodeableConceptMaster filter moe._id==LocationMaster.managingOrgEntityType return merge(moe,{coding:document(moe.coding)}))}, {parentLocationID_desc:document(to_array(LocationMaster.parentLocationID_desc))},{address:document(LocationMaster.address)},{locationType:(for lt in CodeableConceptMaster filter lt._id==LocationMaster.locationType return (merge(lt,{coding:document(lt.coding)})))},{managingOrgID:document(to_array(LocationMaster.managingOrgID))},{locationRoletype:document(to_array(LocationMaster.locationRoletype))},{specialty:document(to_array(LocationMaster.specialty))},{photo:document(LocationMaster.photo)}, {pharmacy:(for ph in LocationMaster.pharmacy return merge(ph,{inventorySubStore:document(ph.inventorySubStore)}))}, {telecom:(for tel in document(LocationMaster.telecom) return merge(tel,{use:document(tel.use)},{rank:document(tel.rank)},{system:document(tel.system)}))})"
    };
  },
  locationlistupsert: function locationlistupsert(data) {
    var filter = {};

    if (data.isStatusChange) {
      // extraJson = {
      //   _id: data._id,
      // };
      filter = {
        filter: {
          _key: data._key
        }
      };
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "LocationMaster",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, filter), {}, {
      doc: {
        status: "".concat(data.status) // ...extraJson,

      }
    })];
  },
  location_by_id: function location_by_id(id) {
    // return {
    //   db_name: dbName,
    //   entity: "LocationMaster,LocationMaster_CodeableConceptMaster_E,CodeableConceptMaster_CodingMaster_E,LocationMaster_LocationRoleType_E,LocationMaster_Organization_E,Organization_CodeableConceptMaster_E,LocationMaster_ContactPointMaster_E,LocationMaster_AddressMaster_E,LocationMaster_AttachmentMaster_E",
    //   filter: `LocationMaster.activestatus==true && LocationMaster._key=='${id}'`,
    //   isTraversal: "true",
    //   return_fields: "{vertices:v,orginatedata:LocationMaster}",
    // };
    // return {
    //     "db_name": dbName,
    //     "entity": "LocationMaster,LocationMaster_CodeableConceptMaster_E,LocationMaster_CodingMaster_E,CodeableConceptMaster_CodingMaster_E,LocationMaster_LocationRoleType_E,LocationMaster_Organization_E,Organization_CodeableConceptMaster_E,LocationMaster_ContactPointMaster_E,LocationMaster_AddressMaster_E,LocationMaster_AttachmentMaster_E",
    //     "filter": `LocationMaster.activestatus==true && LocationMaster._key=='${id}'`,
    //     "isTraversal": "true",
    //     "return_fields": "{vertices:v,orginatedata:LocationMaster}"
    // }
    return {
      db_name: dbName,
      entity: "LocationMaster",
      filter: "LocationMaster._key == '".concat(id, "'"),
      return_fields: "merge(LocationMaster,{operationalStatus:(for ops in CodeableConceptMaster filter ops._id==LocationMaster.operationalStatus return merge(ops,{coding:document(ops.coding)}))},{managingOrgEntityType:(for moe in CodeableConceptMaster filter moe._id==LocationMaster.managingOrgEntityType return merge(moe,{coding:document(moe.coding)}))}, {parentLocationID_desc:document(to_array(LocationMaster.parentLocationID_desc))},{address:document(LocationMaster.address)},{locationType:(for lt in CodeableConceptMaster filter lt._id==LocationMaster.locationType return (merge(lt,{coding:document(lt.coding)})))},{managingOrgID:document(to_array(LocationMaster.managingOrgID))},{locationRoletype:document(to_array(LocationMaster.locationRoletype))},{specialty:document(to_array(LocationMaster.specialty))},{photo:document(LocationMaster.photo)}, {pharmacy:(for ph in LocationMaster.pharmacy return merge(ph,{inventorySubStore:document(ph.inventorySubStore)}))}, {telecom:(for tel in document(LocationMaster.telecom) return merge(tel,{use:document(tel.use)},{rank:document(tel.rank)},{system:document(tel.system)}))})"
    };
  },
  locationmasterinsert: function locationmasterinsert(data) {
    if (data) {
      doc = {
        doc: {
          doc: data
        }
      };
    }

    return [_objectSpread2({
      db_name: dbName,
      entity: "LocationMaster",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, doc)];
  }
};

var dayslotlist = function dayslotlist(data) {
  var dayslotLists = [];

  if (data && data.length > 0) {
    data.map(function (val) {
      var dayslot_obj = {
        ovrday: val.day,
        ovrdays_of_week: timeslotList(val.timeSlots)
      };
      dayslotLists.push(dayslot_obj);
    });
  }

  return dayslotLists;
};

var timeslotList = function timeslotList(data) {
  var timeslot_Lists = [];

  if (data && data.length > 0) {
    data.map(function (val) {
      var timelot_obj = {
        ovrfromtime: val.fromTime ? getUtcTime(moment__default["default"](val.fromTime)) : null,
        ovrtotime: val.toTime ? getUtcTime(moment__default["default"](val.toTime)) : null // ovrfromtime: val.fromTime
        //   ? parseFloat(val.fromTime.replace(":", "."))
        //   : null,
        // ovrtotime: val.toTime ? parseFloat(val.toTime.replace(":", ".")) : null,

      };
      timeslot_Lists.push(timelot_obj);
    });
  }

  return timeslot_Lists;
};

var workday_timeslot = function workday_timeslot(data) {
  var workday_timeslotLists = [];

  if (data && data.length > 0) {
    data.map(function (val) {
      var workday_timeslot_obj = {
        openingtime: val.fromTime ? getUtcTime(moment__default["default"](val.fromTime)) : null,
        closingtime: val.toTime ? getUtcTime(moment__default["default"](val.toTime)) : null // openingtime: val.fromTime
        //   ? parseFloat(val.fromTime.replace(":", "."))
        //   : null,
        // closingtime: val.toTime
        //   ? parseFloat(val.toTime.replace(":", "."))
        //   : null,

      };
      workday_timeslotLists.push(workday_timeslot_obj);
    });
  }

  return workday_timeslotLists;
};

var generateJSON$2 = function generateJSON(data, _key) {
  var _data$overRideCard, _data$operationalStat, _data$operationalStat2, _data$locationType$la, _data$locationType, _data$locationRoleTyp, _data$locationRoleTyp2, _data$parentLocationI, _data$parentLocationI2, _data$speciality$labe, _data$speciality, _data$entityType$labe, _data$entityType;

  //  filter to update the location master
  var filter = {};

  if (_key) {
    filter = {
      filter: {
        _key: _key
      }
    };
  }

  var identifierList = [{
    // _id: "",
    user: "",
    system: "",
    value: "",
    period: [{
      //_id: "",
      start: getUtcTime(),
      end: getUtcTime(moment__default["default"]().endOf("day")) //id: "",

    }] // assigner: "",
    // Type: "",
    // id: "",
    // files: [
    //   {
    //     fileid: "",
    //     filename: "",
    //     objectid: "",
    //     filetype: "",
    //   },
    // ],

  }]; // CONTACT DETAILS

  var contactArr = [];

  if (data.contactDetails && data.contactDetails.length > 0) {
    data.contactDetails.map(function (val) {
      var contactData_obj = {
        //_id: "",
        system: val.contactMode.value.value ? val.contactMode.value.value : "",
        value: val.contactModeType.value ? val.contactModeType.value : "",
        use: val.use.value.value ? val.use.value.value : "",
        rank: val.priority.value.value ? val.priority.value.value : "",
        period: [{
          //_id: "",
          start: getUtcTime(),
          end: getUtcTime(moment__default["default"]().endOf("day")) //id: "",

        }],
        //id: "",
        valueprefix: val.countryCode.value.value ? val.countryCode.value.value : ""
      };
      contactArr.push(contactData_obj);
    });
  } //WORKING DAY DETAILS


  var workingDayArr = [];

  if (data.working_days_yes_no === "Yes") {
    workingDayArr = [{
      allday: true,
      year: 0,
      day: "",
      daysOfWeek: []
    }];
  } else if (data.working_days_yes_no === "No") {
    data.workingday_daySlots.map(function (val, i) {
      var day_obj = {
        allday: false,
        //year: data.workingday_year,
        year: parseInt(data.workingday_year),
        day: val.day,
        daysOfWeek: workday_timeslot(val.timeSlots)
      };
      workingDayArr.push(day_obj);
    });
  } //OVERRIDE DETAILS


  var overRideArr = [];
  var final_obj = {};
  (_data$overRideCard = data.overRideCard) === null || _data$overRideCard === void 0 ? void 0 : _data$overRideCard.map(function (val, i) {
    if (val.type === "singleDate") {
      final_obj = {
        overridetype: "Single",
        ovrfromdate: val.selectDate ? getUtcTime(moment__default["default"](val.selectDate)) : null,
        ovrtodate: 0,
        operationTime: [{
          ovrday: "Monday",
          ovrdays_of_week: timeslotList(val.timeSlots)
        }]
      };
      overRideArr.push(final_obj);
    } else if (val.type === "dateRange") {
      final_obj = {
        overridetype: "Multiple",
        ovrfromdate: val.fromDate ? getUtcTime(moment__default["default"](val.fromDate)) : null,
        ovrtodate: val.toDate ? getUtcTime(moment__default["default"](val.toDate)) : null,
        operationTime: dayslotlist(val.daySlots)
      };
      overRideArr.push(final_obj);
    }
  });
  var json = [_objectSpread2(_objectSpread2({
    db_name: dbName,
    entity: "LocationMaster",
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
  }, filter), {}, {
    doc: {
      //_id: "",
      identifier: identifierList,
      status: "Active",
      operationalStatus: (_data$operationalStat = (_data$operationalStat2 = data.operationalStatus) === null || _data$operationalStat2 === void 0 ? void 0 : _data$operationalStat2.label) !== null && _data$operationalStat !== void 0 ? _data$operationalStat : null,
      shortdesc: data.shortDescription,
      //alias: "",
      longdesc: data.longDescription,
      //mode: "",
      telecom: contactArr,
      address: [{
        //_id: "",
        use: "",
        text: data.locationAddress,
        line: "",
        city: "",
        district: "",
        state: "",
        postalCode: "",
        country: "" // period: [
        //   {
        //     _id: "",
        //     start: "",
        //     end: "",
        //     id: "",
        //   },
        // ],
        // latitude: "",
        // longitude: "",
        // Type: "",
        // id: "",

      }],
      locationType: (_data$locationType$la = data === null || data === void 0 ? void 0 : (_data$locationType = data.locationType) === null || _data$locationType === void 0 ? void 0 : _data$locationType.label) !== null && _data$locationType$la !== void 0 ? _data$locationType$la : null,
      position: [{
        longitude: data.longitude,
        latitude: data.latitude,
        altitude: data.altitude
      }],
      //availableExceptions: "",
      managingOrgID: data.entityName.value,
      id: 0,
      locationRoletype: (_data$locationRoleTyp = data === null || data === void 0 ? void 0 : (_data$locationRoleTyp2 = data.locationRoleType) === null || _data$locationRoleTyp2 === void 0 ? void 0 : _data$locationRoleTyp2.label) !== null && _data$locationRoleTyp !== void 0 ? _data$locationRoleTyp : null,
      locationID: data.locationId,
      parentLocationID_desc: (_data$parentLocationI = data === null || data === void 0 ? void 0 : (_data$parentLocationI2 = data.parentLocationIdandDescription) === null || _data$parentLocationI2 === void 0 ? void 0 : _data$parentLocationI2.label) !== null && _data$parentLocationI !== void 0 ? _data$parentLocationI : null,
      specialty: (_data$speciality$labe = data === null || data === void 0 ? void 0 : (_data$speciality = data.speciality) === null || _data$speciality === void 0 ? void 0 : _data$speciality.label) !== null && _data$speciality$labe !== void 0 ? _data$speciality$labe : null,
      managingOrgEntityType: (_data$entityType$labe = data === null || data === void 0 ? void 0 : (_data$entityType = data.entityType) === null || _data$entityType === void 0 ? void 0 : _data$entityType.label) !== null && _data$entityType$labe !== void 0 ? _data$entityType$labe : null,
      workingdayyear: workingDayArr,
      workingdayyearoverride: overRideArr,
      clinicdetails: data.clinicDetails,
      photo: [{
        //_id: "",
        date: "",
        url: "",
        //id: "",
        fileName: data.photo[0].fileName,
        fileid: data.photo[0].fileid,
        filetype: data.photo[0].filetype,
        objectid: data.photo[0].objectid
      }],
      pharmacy: [{
        storecode: data.storeCode,
        returnAllowed: data.returnAllowed,
        maxdaysforRtn: parseInt(data.maxDaysForReturn),
        exRxAllowed: data.externalRxAllowed,
        otcAllowed: data.otcAllowed
      }]
    }
  })];
  return json;
};

var _extraReducers$v;
var LOCATION_READ = toolkit.createAsyncThunk("locationSlice/locationlist", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      type,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          type = payload.type;
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(queries$f.locationlist(type))
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          arry = [];
          _context.next = 10;
          return data.result.map(function (val) {
            if (val.locationID) {
              var _val$locationType, _val$locationType$, _val$locationType$$co, _val$locationType$$co2, _val$locationType2, _val$locationType2$, _val$locationType2$$c, _val$locationType2$$c2, _val$locationType3, _val$locationType3$, _val$locationType3$$c, _val$locationType3$$c2, _val$locationType4, _val$locationType4$, _val$locationType4$$c, _val$locationType4$$c2, _val$locationType5, _val$locationType5$, _val$locationType5$$c, _val$locationType5$$c2, _val$locationType6, _val$locationType6$, _val$locationType6$$c, _val$locationType6$$c2;

              arry.push({
                location_id: val.locationID,
                location_type: ((_val$locationType = val.locationType) === null || _val$locationType === void 0 ? void 0 : (_val$locationType$ = _val$locationType[0]) === null || _val$locationType$ === void 0 ? void 0 : (_val$locationType$$co = _val$locationType$.coding) === null || _val$locationType$$co === void 0 ? void 0 : (_val$locationType$$co2 = _val$locationType$$co[0]) === null || _val$locationType$$co2 === void 0 ? void 0 : _val$locationType$$co2.code) + " - " + ((_val$locationType2 = val.locationType) === null || _val$locationType2 === void 0 ? void 0 : (_val$locationType2$ = _val$locationType2[0]) === null || _val$locationType2$ === void 0 ? void 0 : (_val$locationType2$$c = _val$locationType2$.coding) === null || _val$locationType2$$c === void 0 ? void 0 : (_val$locationType2$$c2 = _val$locationType2$$c[0]) === null || _val$locationType2$$c2 === void 0 ? void 0 : _val$locationType2$$c2.Type),
                location_type_code: (_val$locationType3 = val.locationType) === null || _val$locationType3 === void 0 ? void 0 : (_val$locationType3$ = _val$locationType3[0]) === null || _val$locationType3$ === void 0 ? void 0 : (_val$locationType3$$c = _val$locationType3$.coding) === null || _val$locationType3$$c === void 0 ? void 0 : (_val$locationType3$$c2 = _val$locationType3$$c[0]) === null || _val$locationType3$$c2 === void 0 ? void 0 : _val$locationType3$$c2.code,
                location_type_name: (_val$locationType4 = val.locationType) === null || _val$locationType4 === void 0 ? void 0 : (_val$locationType4$ = _val$locationType4[0]) === null || _val$locationType4$ === void 0 ? void 0 : (_val$locationType4$$c = _val$locationType4$.coding) === null || _val$locationType4$$c === void 0 ? void 0 : (_val$locationType4$$c2 = _val$locationType4$$c[0]) === null || _val$locationType4$$c2 === void 0 ? void 0 : _val$locationType4$$c2.Type,
                location_type_id: (_val$locationType5 = val.locationType) === null || _val$locationType5 === void 0 ? void 0 : (_val$locationType5$ = _val$locationType5[0]) === null || _val$locationType5$ === void 0 ? void 0 : (_val$locationType5$$c = _val$locationType5$.coding) === null || _val$locationType5$$c === void 0 ? void 0 : (_val$locationType5$$c2 = _val$locationType5$$c[0]) === null || _val$locationType5$$c2 === void 0 ? void 0 : _val$locationType5$$c2._id,
                location_type_key: (_val$locationType6 = val.locationType) === null || _val$locationType6 === void 0 ? void 0 : (_val$locationType6$ = _val$locationType6[0]) === null || _val$locationType6$ === void 0 ? void 0 : (_val$locationType6$$c = _val$locationType6$.coding) === null || _val$locationType6$$c === void 0 ? void 0 : (_val$locationType6$$c2 = _val$locationType6$$c[0]) === null || _val$locationType6$$c2 === void 0 ? void 0 : _val$locationType6$$c2._key,
                long_description: val.longdesc,
                short_description: val.shortdesc,
                _key: val._key,
                id: val.id,
                _id: val._id,
                status: val.status === "Active" ? true : false,
                active_status: val.activestatus
              });
            }
          });

        case 10:
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 13]]);
})));
var LOCATION_LIST_UPSERT = toolkit.createAsyncThunk("locationSlice/locationlistupsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      upsertkey,
      queriesjson,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          upsertkey = {
            isStatusChange: payload.isStatusChange,
            _key: payload._key,
            status: payload.status //status: payload.status,

          };
          queriesjson = queries$f.locationlistupsert(upsertkey);
          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var LOCATION_MASTER_INSERT = toolkit.createAsyncThunk("locationApiSlice/locationinsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      data,
      _key,
      queriesjson,
      dataRes,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          data = payload.data, _key = payload._key;
          queriesjson = generateJSON$2(data, _key);
          _context3.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          dataRes = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: dataRes
          }));

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 11]]);
})));
var locationSlice = toolkit.createSlice({
  name: "locationApiSlice",
  initialState: {
    location_list: _objectSpread2({}, defaultState.List),
    location_list_upsert: _objectSpread2({}, defaultState.List),
    location_insert: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$v = {}, _defineProperty(_extraReducers$v, LOCATION_READ.fulfilled, function (state, action) {
    state.location_list.loading = false, state.location_list.error = false, state.location_list = action.payload;
  }), _defineProperty(_extraReducers$v, LOCATION_READ.pending, function (state, action) {
    state.location_list.loading = true, state.location_list.error = false, state.location_list.loading = true;
  }), _defineProperty(_extraReducers$v, LOCATION_READ.rejected, function (state, action) {
    state.location_list.loading = false, state.location_list.error = true, state.location_list = action.payload;
  }), _defineProperty(_extraReducers$v, LOCATION_LIST_UPSERT.fulfilled, function (state, action) {
    state.location_list_upsert.loading = false, state.location_list_upsert.error = false, state.location_list_upsert = action.payload;
  }), _defineProperty(_extraReducers$v, LOCATION_LIST_UPSERT.pending, function (state, action) {
    state.location_list_upsert.loading = true, state.location_list_upsert.error = false, state.location_list_upsert.loading = true;
  }), _defineProperty(_extraReducers$v, LOCATION_LIST_UPSERT.rejected, function (state, action) {
    state.location_list_upsert.loading = false, state.location_list_upsert.error = true, state.location_list_upsert = action.payload;
  }), _defineProperty(_extraReducers$v, LOCATION_MASTER_INSERT.fulfilled, function (state, action) {
    state.location_insert.loading = false, state.location_insert.error = false, state.location_insert = action.payload;
  }), _defineProperty(_extraReducers$v, LOCATION_MASTER_INSERT.pending, function (state, action) {
    state.location_insert.loading = true, state.location_insert.error = false, state.location_insert.loading = true;
  }), _defineProperty(_extraReducers$v, LOCATION_MASTER_INSERT.rejected, function (state, action) {
    state.location_insert.loading = false, state.location_insert.error = true, state.location_insert = action.payload;
  }), _extraReducers$v)
});
var locationActions$1 = {
  LOCATION_READ: LOCATION_READ,
  LOCATION_LIST_UPSERT: LOCATION_LIST_UPSERT,
  LOCATION_MASTER_INSERT: LOCATION_MASTER_INSERT
};
var locationSlice$1 = locationSlice.reducer;

var masterQuery$6 = {
  locationMasterEntityType: function locationMasterEntityType() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='ORGTYPE' AND CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  locationMasterEntityName: function locationMasterEntityName(type) {
    // return {
    //   db_name: dbName,
    //   entity: "Organization",
    //   filter:
    //     `'${type}' IN Organization.OrgType AND Organization.activestatus==true`,
    //   return_fields:
    //     "{id:Organization.id,name:Organization.name,_id:Organization._id,_key:Organization._key}",
    // }
    return {
      "db_name": dbName,
      "entity": "Organization",
      "sort": "Organization.name",
      "filter": "Organization.OrgType==['".concat(type, "'] && Organization.activestatus==true"),
      "return_fields": "{id:Organization.id,name:Organization.name,_id:Organization._id,_key:Organization._key}"
    };
  },
  locationMasterLocationType: function locationMasterLocationType() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='LOCATIONTYPE' AND CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  locationMasterOperationalStatus: function locationMasterOperationalStatus() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='OPERATIONSTATUS' AND CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  locationMasterParentLocationIdDescription: function locationMasterParentLocationIdDescription() {
    return {
      db_name: dbName,
      entity: "LocationMaster",
      sort: "LocationMaster.locationID",
      filter: "LocationMaster.activestatus==true",
      return_fields: "{_id:LocationMaster._id,_key:LocationMaster._key,id:LocationMaster.id,shortdesc:LocationMaster.shortdesc,longdesc:LocationMaster.longdesc,locationID:LocationMaster.locationID}"
    };
  },
  // locationMasterLocationRoleType: () => {
  //   return {
  //     db_name: dbName,
  //     entity: "LocationRoleType",
  //     filter: "LocationRoleType.activestatus==true",
  //     return_fields:
  //       "{_id:LocationRoleType._id,_key:LocationRoleType._key,id:LocationRoleType.id,shortdesc:LocationRoleType.ShortDesc,longdesc:LocationRoleType.LongDesc}",
  //   };
  // },
  locationMasterLocationRoleType: function locationMasterLocationRoleType() {
    return {
      "db_name": dbName,
      "entity": "CodingMaster",
      "sort": "CodingMaster.display",
      "filter": "CodingMaster.status==true && CodingMaster.activestatus==true && CodingMaster.Type=='LOCATIONROLE'",
      "return_fields": "KEEP(CodingMaster,'id','_id','_key','shortdesc','display','Type')"
    };
  },
  locationMasterSpeciality: function locationMasterSpeciality(id) {
    // return {
    //   db_name: dbName,
    //   entity: "HealthcareService,CodeableConceptMaster",
    //   filter: {
    //     HealthcareService: `HealthcareService.OrgID==${id}`,
    //     CodeableConceptMaster:
    //       "CodeableConceptMaster.id IN HealthcareService.SpecialtyID AND CodeableConceptMaster.Type=='SPECIALTY'",
    //   },
    //   return_fields:
    //     "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})",
    // };
    return {
      "db_name": dbName,
      "entity": "Organization",
      "filter": "Organization.id==".concat(id, " && Organization.activestatus==true"),
      "return_fields": " DOCUMENT(Organization.specialtyDetails[*].specialty)"
    };
  },
  locationMasterContactMode: function locationMasterContactMode() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='CONTACTSYSTEM' AND CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  locationMasterISD: function locationMasterISD() {
    return {
      db_name: dbName,
      entity: "SMGeographicMaster",
      sort: "SMGeographicMaster.geogLevelName",
      filter: "Lower(DOCUMENT(SMGeographicMaster.geogLevelType).display)=='country' && SMGeographicMaster.activestatus == true",
      return_fields: "{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode,GeoLocationISDCode:SMGeographicMaster.GeoLocationISDCode}"
    };
  },
  locationMasterUse: function locationMasterUse() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='ADDRESSUSE' AND CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  locationMasterPriority: function locationMasterPriority() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.Type=='RANK' AND CodeableConceptMaster.activestatus==true",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  }
};

var contactDetailList = function contactDetailList(data, state) {
  var contact_Lists = [];

  if (data && data.length > 0) {
    data.map(function (val) {
      var contact_obj = {
        contactMode: {
          name: "Contact Mode",
          value: contactModeList(val.system, state)
        },
        countryCode: {
          name: "",
          value: countryCodeList(val.valueprefix, state)
        },
        contactModeType: {
          name: "Contact Mode Type",
          value: val.value
        },
        use: {
          name: "Use",
          value: useList(val.use, state)
        },
        priority: {
          name: "Priority",
          value: priorityList(val.rank, state)
        }
      };
      contact_Lists.push(contact_obj);
    });
  }

  return contact_Lists;
}; //CONTACT MODE OBJ


var contactModeList = function contactModeList(data, state) {
  var contact_mode_obj = {};

  if (data) {
    contact_mode_obj = data && data.length > 0 // state.location_masters_contactmode.data.find(
    //   (sys) => data.indexOf(sys.value) > -1
    // )
    ? state.location_masters_contactmode.data.find(function (sys) {
      return data.indexOf(sys.value) > -1;
    }) : {
      label: "",
      value: ""
    };
  }

  return contact_mode_obj;
}; //COUNTRY CODE OBJ


var countryCodeList = function countryCodeList(data, state) {
  var country_code_obj = {};

  if (data) {
    country_code_obj = data && data.length > 0 // state.location_masters_isd.data.find(
    //   (sys) => data.indexOf(sys.value) > -1
    // )
    ? country_code_obj = state.location_masters_isd.data.find(function (sys) {
      return data.indexOf(sys.value) > -1;
    }) : {
      label: "",
      value: ""
    };
  }

  return country_code_obj;
}; //USE OBJ


var useList = function useList(data, state) {
  var use_obj = {};

  if (data) {
    use_obj = data && data.length > 0 // state.location_masters_use.data.find(
    //   (sys) => data.indexOf(sys.value) > -1
    // )
    ? use_obj = state.location_masters_use.data.find(function (sys) {
      return data.indexOf(sys.value) > -1;
    }) : {
      label: "",
      value: ""
    };
  }

  return use_obj;
}; //RANK OBJ


var priorityList = function priorityList(data, state) {
  var priority_obj = {};

  if (data) {
    priority_obj = data && data.length > 0 // state.location_masters_priority.data.find(
    //   (sys) => data.indexOf(sys.value) > -1
    // )
    ? priority_obj = state.location_masters_priority.data.find(function (sys) {
      return data.indexOf(sys.value) > -1;
    }) : {
      label: "",
      value: ""
    };
  }

  return priority_obj;
};

var workingDayList = function workingDayList(data) {
  var WorkingDayArr = [];

  if (data && data.length > 0) {
    data.map(function (val) {
      var WorkingDay_obj = {
        day: val.day ? val.day : "",
        checked: true,
        timeSlots: workDayofWeekList(val.daysOfWeek)
      };
      WorkingDayArr.push(WorkingDay_obj);
    });
  }

  return WorkingDayArr;
};

var workDayofWeekList = function workDayofWeekList(data) {
  var WorkingDayofWeeksArr = [];

  if (data && data.length > 0) {
    data.map(function (val) {
      var WorkingDay_of_week_obj = {
        // fromTime: val.openingtime
        //   ? moment.unix(val.openingtime).format("HH:MM")
        //   : "",
        // toTime: val.closingtime
        //   ? moment.unix(val.closingtime).format("HH:MM")
        //   : "",
        // fromTime: val.openingtime
        //   ? val.openingtime.toString().replace(".", ":")
        //   : "",
        // toTime: val.closingtime
        //   ? val.closingtime.toString().replace(".", ":")
        //   : "",
        fromTime: val.openingtime ? moment__default["default"].unix(val.openingtime) : "",
        toTime: val.closingtime ? moment__default["default"].unix(val.closingtime) : ""
      };
      WorkingDayofWeeksArr.push(WorkingDay_of_week_obj);
    });
  }

  return WorkingDayofWeeksArr;
};

var overRideList = function overRideList(data) {
  var overRideArr = [];

  if (data && data.length > 0) {
    data.map(function (val) {
      var over_ride_obj = {};

      if (val.overridetype === "Single") {
        over_ride_obj = {
          type: "singleDate",
          // selectDate: val.ovrfromdate
          //   ? moment.unix(val.ovrfromdate).format("DD-MM-YYYY")
          //   : "",
          selectDate: val.ovrfromdate ? moment__default["default"].unix(val.ovrfromdate) : "",
          timeSlots: overRideTimeslot(val.operationTime[0].ovrdays_of_week)
        };
        overRideArr.push(over_ride_obj);
      } else if (val.overridetype === "Multiple") {
        over_ride_obj = {
          type: "dateRange",
          // fromDate: val.ovrfromdate
          //   ? moment.unix(val.ovrfromdate).format("DD-MM-YYYY")
          //   : "",
          // toDate: val.ovrtodate
          //   ? moment.unix(val.ovrtodate).format("DD-MM-YYYY")
          //   : "",
          fromDate: val.ovrfromdate ? moment__default["default"].unix(val.ovrfromdate) : "",
          toDate: val.ovrtodate ? moment__default["default"].unix(val.ovrtodate) : "",
          daySlots: overRideDayslot(val.operationTime)
        }, overRideArr.push(over_ride_obj);
      }
    });
  }

  return overRideArr;
};

var overRideDayslot = function overRideDayslot(data) {
  var overRideDaySlot = [];

  if (data && data.length > 0) {
    data.map(function (val) {
      var over_ride_dayslot_obj = {
        day: val.ovrday,
        checked: true,
        timeSlots: overRideTimeslot(val.ovrdays_of_week)
      };
      overRideDaySlot.push(over_ride_dayslot_obj);
    });
  }

  return overRideDaySlot;
};

var overRideTimeslot = function overRideTimeslot(data) {
  var overRideTimeSlot = [];

  if (data && data.length > 0) {
    data.map(function (val) {
      var over_ride_timeslot_obj = {
        // fromTime: val.ovrfromtime
        //   ? moment.unix(val.ovrfromtime).format("HH:MM")
        //   : "",
        // toTime: val.ovrtotime ? moment.unix(val.ovrtotime).format("HH:MM") : "",
        // fromTime: val.ovrfromtime
        //   ? val.ovrfromtime.toString().replace(".", ":")
        //   : "",
        // toTime: val.ovrtotime ? val.ovrtotime.toString().replace(".", ":") : "",
        fromTime: val.ovrfromtime ? moment__default["default"].unix(val.ovrfromtime) : "",
        toTime: val.ovrtotime ? moment__default["default"].unix(val.ovrtotime) : ""
      };
      overRideTimeSlot.push(over_ride_timeslot_obj);
    });
  }

  return overRideTimeSlot;
};

var photoData = function photoData(data) {
  var photo_Data = [];

  if (data && data.length > 0) {
    data.map(function (val) {
      var photo_data_obj = {
        _id: val._id,
        date: val.date,
        url: val.url,
        id: val.id,
        fileName: val.fileName,
        fileid: val.fileid,
        filetype: val.filetype,
        objectid: val.objectid
      };
      photo_Data.push(photo_data_obj);
    });
  }

  return photo_Data;
};

var generateReadJSON$4 = function generateReadJSON(data, state) {
  var _state$location_maste, _state$location_maste2, _data$managingOrgID, _data$managingOrgID$, _data$address, _data$address$, _data$address2, _data$address2$, _data$position, _data$position$, _data$position2, _data$position2$, _data$position3, _data$position3$, _data$workingdayyear, _data$workingdayyear$;

  var inital_workingday_slot_arr = [{
    day: "Mon",
    checked: true,
    timeSlots: [{
      fromTime: "",
      toTime: ""
    }]
  }, {
    day: "Tue",
    checked: true,
    timeSlots: [{
      fromTime: "",
      toTime: ""
    }]
  }, {
    day: "Wed",
    checked: true,
    timeSlots: [{
      fromTime: "",
      toTime: ""
    }]
  }, {
    day: "Tue",
    checked: true,
    timeSlots: [{
      fromTime: "",
      toTime: ""
    }]
  }, {
    day: "Fri",
    checked: true,
    timeSlots: [{
      fromTime: "",
      toTime: ""
    }]
  }, {
    day: "Sat",
    checked: true,
    timeSlots: [{
      fromTime: "",
      toTime: ""
    }]
  }, {
    day: "Sun",
    checked: true,
    timeSlots: [{
      fromTime: "",
      toTime: ""
    }]
  }];
  var json = {
    entityType: data.managingOrgEntityType && data.managingOrgEntityType.length > 0 // state.location_masters_entitytype.data.find(
    //   (sys) => data.managingOrgEntityType.indexOf(sys.label) > -1
    // )
    ? state === null || state === void 0 ? void 0 : (_state$location_maste = state.location_masters_entitytype) === null || _state$location_maste === void 0 ? void 0 : (_state$location_maste2 = _state$location_maste.data) === null || _state$location_maste2 === void 0 ? void 0 : _state$location_maste2.find(function (sys) {
      var _data$managingOrgEnti, _data$managingOrgEnti2;

      return ((_data$managingOrgEnti = data.managingOrgEntityType[0]) === null || _data$managingOrgEnti === void 0 ? void 0 : (_data$managingOrgEnti2 = _data$managingOrgEnti._id) === null || _data$managingOrgEnti2 === void 0 ? void 0 : _data$managingOrgEnti2.indexOf(sys.label)) > -1;
    }) : {
      label: "",
      value: ""
    },
    entityNameId: data === null || data === void 0 ? void 0 : (_data$managingOrgID = data.managingOrgID) === null || _data$managingOrgID === void 0 ? void 0 : (_data$managingOrgID$ = _data$managingOrgID[0]) === null || _data$managingOrgID$ === void 0 ? void 0 : _data$managingOrgID$._id,
    // entityName: (data.managingOrgID && Array.isArray(data.managingOrgID) && data.managingOrgID.length >0)
    //   ? state.location_masters_entityname.data.find(
    //       (sys) => data.managingOrgID?.[0]?._id.indexOf(sys.label) > -1
    //     )
    //   : { label: "", value: "" },
    locationType: data.locationType && Array.isArray(data.locationType) && data.locationType.length > 0 // state.location_masters_locationtype.data.find(
    //   (sys) => data.locationType[0]._id.indexOf(sys.label) > -1
    // )
    ? state.location_masters_locationtype.data.find(function (sys) {
      var _data$locationType$, _data$locationType$$_;

      return ((_data$locationType$ = data.locationType[0]) === null || _data$locationType$ === void 0 ? void 0 : (_data$locationType$$_ = _data$locationType$._id) === null || _data$locationType$$_ === void 0 ? void 0 : _data$locationType$$_.indexOf(sys.label)) > -1;
    }) : {
      label: "",
      value: ""
    },
    locationId: data.locationID ? data.locationID : "",
    shortDescription: data.shortdesc ? data.shortdesc : "",
    longDescription: data.longdesc ? data.longdesc : "",
    operationalStatus: data.operationalStatus && Array.isArray(data.operationalStatus) && data.operationalStatus.length > 0 // state.location_masters_operationalstatus.data.find(
    //   (sys) => data.operationalStatus[0]._id.indexOf(sys.label) > -1
    // )
    ? state.location_masters_operationalstatus.data.find(function (sys) {
      return data.operationalStatus[0]._id.indexOf(sys.label) > -1;
    }) : {
      label: "",
      value: ""
    },
    parentLocationIdandDescription: data.parentLocationID_desc && data.parentLocationID_desc.length > 0 // state.location_masters_parent_location_id.data.find(
    //   (sys) => data.parentLocationID_desc[0]._id.indexOf(sys.label) > -1
    // )
    ? state.location_masters_parent_location_id.data.find(function (sys) {
      return data.parentLocationID_desc.indexOf(sys.label) > -1;
    }) : {
      label: "",
      value: ""
    },
    // locationRoleType:(data.locationRoletype && Array.isArray(data.locationRoletype) && data.locationRoletype.length >0)
    // //  state.location_masters_locationroletype.data.find(
    // //   (sys) => data.locationRoletype[0]._id.indexOf(sys.label) > -1
    // // )
    //   ? state.location_masters_locationroletype.data.find(
    //       (sys) => data.locationRoletype[0]._id.indexOf(sys.label) > -1
    //     )
    //   : { label: "", value: "" },
    locationRoleType: data.locationRoletype && data.locationRoletype.length > 0 ? state.location_masters_locationroletype.data.find(function (sys) {
      return data.locationRoletype.indexOf(sys.label) > -1;
    }) : {
      label: "",
      value: ""
    },
    speciality: data.specialty,
    // (data.specialty && data.specialty.length > 0)
    //   ? state.location_masters_speciality.data.find(
    //       (sys) => data.specialty.indexOf(sys.label) > -1
    //     )
    //   : { label: "", value: "" },
    clinicDetails: data.clinicdetails ? data.clinicdetails : "",
    locationAddress: (_data$address = data.address) !== null && _data$address !== void 0 && (_data$address$ = _data$address[0]) !== null && _data$address$ !== void 0 && _data$address$.text ? (_data$address2 = data.address) === null || _data$address2 === void 0 ? void 0 : (_data$address2$ = _data$address2[0]) === null || _data$address2$ === void 0 ? void 0 : _data$address2$.text : "",
    longitude: (_data$position = data.position) !== null && _data$position !== void 0 && (_data$position$ = _data$position[0]) !== null && _data$position$ !== void 0 && _data$position$.longitude ? data.position[0].longitude : "",
    latitude: (_data$position2 = data.position) !== null && _data$position2 !== void 0 && (_data$position2$ = _data$position2[0]) !== null && _data$position2$ !== void 0 && _data$position2$.latitude ? data.position[0].latitude : "",
    altitude: (_data$position3 = data.position) !== null && _data$position3 !== void 0 && (_data$position3$ = _data$position3[0]) !== null && _data$position3$ !== void 0 && _data$position3$.altitude ? data.position[0].altitude : "",
    workingday_year: (_data$workingdayyear = data.workingdayyear) !== null && _data$workingdayyear !== void 0 && (_data$workingdayyear$ = _data$workingdayyear[0]) !== null && _data$workingdayyear$ !== void 0 && _data$workingdayyear$.year ? data.workingdayyear[0].year : "",
    contactDetails: contactDetailList(data.telecom, state),
    workingday_daySlots: data.workingdayyear[0].allday === false ? workingDayList(data.workingdayyear) : inital_workingday_slot_arr,
    overRideCard: overRideList(data.workingdayyearoverride),
    working_days_yes_no: data.workingdayyear[0].allday === true ? "Yes" : "No",
    is_visible: data.workingdayyear[0].allday === true ? false : true,
    photo: photoData(data.photo),
    returnAllowed: data.pharmacy && data.pharmacy.length > 0 && Array.isArray(data.pharmacy) ? data.pharmacy[0].returnAllowed : false,
    otcAllowed: data.pharmacy && data.pharmacy.length > 0 && Array.isArray(data.pharmacy) ? data.pharmacy[0].otcAllowed : false,
    externalRxAllowed: data.pharmacy && data.pharmacy.length > 0 && Array.isArray(data.pharmacy) ? data.pharmacy[0].exRxAllowed : false,
    storeCode: data.pharmacy && data.pharmacy.length > 0 && Array.isArray(data.pharmacy) ? data.pharmacy[0].storecode : "",
    maxDaysForReturn: data.pharmacy && data.pharmacy.length > 0 && Array.isArray(data.pharmacy) ? data.pharmacy[0].maxdaysforRtn : null
  };
  return json;
};

var _extraReducers$u;
var LOCATION_MASTERS_ENTITYTYPE = toolkit.createAsyncThunk("locationMasterSlice/location_masters_entitytype", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      data_arr,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return fetchData({
            body: JSON.stringify(masterQuery$6.locationMasterEntityType())
          }, __readDocumentUrl__);

        case 5:
          data_arr = _context.sent;
          arry = [];
          _context.next = 9;
          return data_arr.result.map(function (val) {
            arry.push(_objectSpread2({
              value: val.coding[0].display,
              label: val._id,
              id: val.id
            }, val));
          });

        case 9:
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 12]]);
})));
var LOCATION_MASTERS_ENTITYNAME = toolkit.createAsyncThunk("locationMasterSlice/location_masters_entityname", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      type,
      data_arr,
      arry,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          type = payload.type;
          _context2.next = 6;
          return fetchData({
            body: JSON.stringify(masterQuery$6.locationMasterEntityName(type))
          }, __readDocumentUrl__);

        case 6:
          data_arr = _context2.sent;
          arry = [];
          _context2.next = 10;
          return data_arr.result.map(function (val) {
            arry.push(_objectSpread2({
              value: val._id,
              label: val.name,
              id: val.id
            }, val));
          });

        case 10:
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 16:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 13]]);
})));
var LOCATION_MASTERS_LOCATIONTYPE = toolkit.createAsyncThunk("locationMasterSlice/location_masters_locationtype", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var _ref6,
      rejectWithValue,
      data_arr,
      arry,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          _context3.next = 5;
          return fetchData({
            body: JSON.stringify(masterQuery$6.locationMasterLocationType())
          }, __readDocumentUrl__);

        case 5:
          data_arr = _context3.sent;
          arry = [];
          _context3.next = 9;
          return data_arr.result.map(function (val) {
            arry.push({
              value: val.coding[0].display,
              label: val._id
            });
          });

        case 9:
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 15:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 12]]);
})));
var LOCATION_MASTERS_OPERATIONALSTATUS = toolkit.createAsyncThunk("locationMasterSlice/location_masters_operationalstatus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var _ref8,
      rejectWithValue,
      data_arr,
      arry,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          _context4.next = 5;
          return fetchData({
            body: JSON.stringify(masterQuery$6.locationMasterOperationalStatus())
          }, __readDocumentUrl__);

        case 5:
          data_arr = _context4.sent;
          arry = [];
          _context4.next = 9;
          return data_arr.result.map(function (val) {
            arry.push({
              value: val.coding[0].display,
              label: val._id
            });
          });

        case 9:
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 12]]);
})));
var LOCATION_MASTERS_PARENT_LOCATION_ID_DESCRIPTION = toolkit.createAsyncThunk("locationMasterSlice/location_masters_parent_location_id", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var _ref10,
      rejectWithValue,
      data_arr,
      arry,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          _context5.next = 5;
          return fetchData({
            body: JSON.stringify(masterQuery$6.locationMasterParentLocationIdDescription())
          }, __readDocumentUrl__);

        case 5:
          data_arr = _context5.sent;
          arry = [];
          _context5.next = 9;
          return data_arr.result.map(function (val) {
            arry.push({
              label: val._id,
              value: val.locationID
            });
          });

        case 9:
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 12]]);
})));
var LOCATION_MASTERS_LOCATIONROLETYPE = toolkit.createAsyncThunk("locationMasterSlice/location_masters_locationroletype", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var _ref12,
      rejectWithValue,
      data_arr,
      arry,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          _context6.next = 5;
          return fetchData({
            body: JSON.stringify(masterQuery$6.locationMasterLocationRoleType())
          }, __readDocumentUrl__);

        case 5:
          data_arr = _context6.sent;
          arry = [];
          _context6.next = 9;
          return data_arr.result.map(function (val) {
            arry.push(_objectSpread2({
              value: val.shortdesc,
              label: val._id
            }, val));
          });

        case 9:
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 15:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 12]]);
})));
var LOCATION_MASTER_SPECIALITY = toolkit.createAsyncThunk("locationMasterSlice/location_masters_speciality", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      _data_arr$result,
      _data_arr$result$,
      id,
      data_arr,
      arry,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          id = payload.id;
          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(masterQuery$6.locationMasterSpeciality(id))
          }, __readDocumentUrl__);

        case 6:
          data_arr = _context7.sent;
          arry = [];
          _context7.next = 10;
          return (_data_arr$result = data_arr.result) === null || _data_arr$result === void 0 ? void 0 : (_data_arr$result$ = _data_arr$result[0]) === null || _data_arr$result$ === void 0 ? void 0 : _data_arr$result$.map(function (val) {
            var _val$display;

            arry.push(_objectSpread2({
              value: (_val$display = val === null || val === void 0 ? void 0 : val.display) !== null && _val$display !== void 0 ? _val$display : "",
              label: val._id
            }, val));
          });

        case 10:
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context7.prev = 13;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 16:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 13]]);
})));
var LOCATION_MASTER_CONTACTMODE = toolkit.createAsyncThunk("locationMasterSlice/location_masters_contactmode", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var _ref16,
      rejectWithValue,
      data_arr,
      arry,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _ref16 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref16.rejectWithValue;
          _context8.prev = 2;
          _context8.next = 5;
          return fetchData({
            body: JSON.stringify(masterQuery$6.locationMasterContactMode())
          }, __readDocumentUrl__);

        case 5:
          data_arr = _context8.sent;
          arry = [];
          _context8.next = 9;
          return data_arr.result.map(function (val) {
            arry.push({
              value: val.coding[0].display,
              label: val._id
            });
          });

        case 9:
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context8.prev = 12;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 15:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 12]]);
})));
var LOCATION_MASTER_ISD = toolkit.createAsyncThunk("locationMasterSlice/location_masters_isd", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var _ref18,
      rejectWithValue,
      data_arr,
      arry,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _ref18 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref18.rejectWithValue;
          _context9.prev = 2;
          _context9.next = 5;
          return fetchData({
            body: JSON.stringify(masterQuery$6.locationMasterISD())
          }, __readDocumentUrl__);

        case 5:
          data_arr = _context9.sent;
          arry = [];
          _context9.next = 9;
          return data_arr.result.map(function (val) {
            arry.push({
              value: val.GeoLocationISDCode,
              label: val._id
            });
          });

        case 9:
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context9.prev = 12;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 15:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 12]]);
})));
var LOCATION_MASTER_USE = toolkit.createAsyncThunk("locationMasterSlice/location_masters_use", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var _ref20,
      rejectWithValue,
      data_arr,
      arry,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _ref20 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref20.rejectWithValue;
          _context10.prev = 2;
          _context10.next = 5;
          return fetchData({
            body: JSON.stringify(masterQuery$6.locationMasterUse())
          }, __readDocumentUrl__);

        case 5:
          data_arr = _context10.sent;
          arry = [];
          _context10.next = 9;
          return data_arr.result.map(function (val) {
            arry.push({
              value: val.coding[0].display,
              label: val._id
            });
          });

        case 9:
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context10.prev = 12;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 15:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 12]]);
})));
var LOCATION_MASTER_PRIORITY = toolkit.createAsyncThunk("locationMasterSlice/location_masters_priority", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var _ref22,
      rejectWithValue,
      data_arr,
      arry,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _ref22 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref22.rejectWithValue;
          _context11.prev = 2;
          _context11.next = 5;
          return fetchData({
            body: JSON.stringify(masterQuery$6.locationMasterPriority())
          }, __readDocumentUrl__);

        case 5:
          data_arr = _context11.sent;
          arry = [];
          _context11.next = 9;
          return data_arr.result.map(function (val) {
            arry.push({
              value: val.coding[0].display,
              label: val._id
            });
          });

        case 9:
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context11.prev = 12;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 15:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 12]]);
})));
var LOCATION_MASTER_GET_BY_ID = toolkit.createAsyncThunk("locationMasterSlice/location_masters_by_id", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var payload,
      _ref24,
      rejectWithValue,
      getState,
      id,
      state,
      ccState,
      data,
      readJSON,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
          _ref24 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref24.rejectWithValue, getState = _ref24.getState;
          _context12.prev = 2;
          id = payload.id;
          state = getState();
          ccState = state.locationMasterSlice; //let masterlist = await loopMasters();
          //

          _context12.next = 8;
          return fetchData({
            body: JSON.stringify(queries$f.location_by_id(id))
          }, __readDocumentUrl__);

        case 8:
          data = _context12.sent;
          //
          readJSON = generateReadJSON$4(data.result[0] ? data.result[0] : null, //masterlist
          ccState);
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: readJSON
          }));

        case 13:
          _context12.prev = 13;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 16:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 13]]);
})));
var locationMasterSlice = toolkit.createSlice({
  name: "locationMasterAPISlice",
  initialState: {
    location_masters_entitytype: _objectSpread2({}, defaultState.List),
    location_masters_entityname: _objectSpread2({}, defaultState.List),
    location_masters_locationtype: _objectSpread2({}, defaultState.List),
    location_masters_operationalstatus: _objectSpread2({}, defaultState.List),
    location_masters_parent_location_id: _objectSpread2({}, defaultState.List),
    location_masters_locationroletype: _objectSpread2({}, defaultState.List),
    location_masters_speciality: _objectSpread2({}, defaultState.List),
    location_masters_contactmode: _objectSpread2({}, defaultState.List),
    location_masters_isd: _objectSpread2({}, defaultState.List),
    location_masters_use: _objectSpread2({}, defaultState.List),
    location_masters_priority: _objectSpread2({}, defaultState.List),
    locationmasterbyid: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$u = {}, _defineProperty(_extraReducers$u, LOCATION_MASTERS_ENTITYTYPE.fulfilled, function (state, action) {
    state.location_masters_entitytype.loading = false, state.location_masters_entitytype.error = false, state.location_masters_entitytype = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_ENTITYTYPE.pending, function (state, action) {
    state.location_masters_entitytype.loading = true, state.location_masters_entitytype.error = false, state.location_masters_entitytype.loading = true;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_ENTITYTYPE.rejected, function (state, action) {
    state.location_masters_entitytype.loading = false, state.location_masters_entitytype.error = true, state.location_masters_entitytype = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_ENTITYNAME.fulfilled, function (state, action) {
    state.location_masters_entityname.loading = false, state.location_masters_entityname.error = false, state.location_masters_entityname = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_ENTITYNAME.pending, function (state, action) {
    state.location_masters_entityname.loading = true, state.location_masters_entityname.error = false, state.location_masters_entityname.loading = true;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_ENTITYNAME.rejected, function (state, action) {
    state.location_masters_entityname.loading = false, state.location_masters_entityname.error = true, state.location_masters_entityname = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_LOCATIONTYPE.fulfilled, function (state, action) {
    state.location_masters_locationtype.loading = false, state.location_masters_locationtype.error = false, state.location_masters_locationtype = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_LOCATIONTYPE.pending, function (state, action) {
    state.location_masters_locationtype.loading = true, state.location_masters_locationtype.error = false, state.location_masters_locationtype.loading = true;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_LOCATIONTYPE.rejected, function (state, action) {
    state.location_masters_locationtype.loading = false, state.location_masters_locationtype.error = true, state.location_masters_locationtype = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_OPERATIONALSTATUS.fulfilled, function (state, action) {
    state.location_masters_operationalstatus.loading = false, state.location_masters_operationalstatus.error = false, state.location_masters_operationalstatus = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_OPERATIONALSTATUS.pending, function (state, action) {
    state.location_masters_operationalstatus.loading = true, state.location_masters_operationalstatus.error = false, state.location_masters_operationalstatus.loading = true;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_OPERATIONALSTATUS.rejected, function (state, action) {
    state.location_masters_operationalstatus.loading = false, state.location_masters_operationalstatus.error = true, state.location_masters_operationalstatus = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_PARENT_LOCATION_ID_DESCRIPTION.fulfilled, function (state, action) {
    state.location_masters_parent_location_id.loading = false, state.location_masters_parent_location_id.error = false, state.location_masters_parent_location_id = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_PARENT_LOCATION_ID_DESCRIPTION.pending, function (state, action) {
    state.location_masters_parent_location_id.loading = true, state.location_masters_parent_location_id.error = false, state.location_masters_parent_location_id.loading = true;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_PARENT_LOCATION_ID_DESCRIPTION.rejected, function (state, action) {
    state.location_masters_parent_location_id.loading = false, state.location_masters_parent_location_id.error = true, state.location_masters_parent_location_id = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_LOCATIONROLETYPE.fulfilled, function (state, action) {
    state.location_masters_locationroletype.loading = false, state.location_masters_locationroletype.error = false, state.location_masters_locationroletype = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_LOCATIONROLETYPE.pending, function (state, action) {
    state.location_masters_locationroletype.loading = true, state.location_masters_locationroletype.error = false, state.location_masters_locationroletype.loading = true;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTERS_LOCATIONROLETYPE.rejected, function (state, action) {
    state.location_masters_locationroletype.loading = false, state.location_masters_locationroletype.error = true, state.location_masters_locationroletype = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_SPECIALITY.fulfilled, function (state, action) {
    state.location_masters_speciality.loading = false, state.location_masters_speciality.error = false, state.location_masters_speciality = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_SPECIALITY.pending, function (state, action) {
    state.location_masters_speciality.loading = true, state.location_masters_speciality.error = false, state.location_masters_speciality.loading = true;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_SPECIALITY.rejected, function (state, action) {
    state.location_masters_speciality.loading = false, state.location_masters_speciality.error = true, state.location_masters_speciality = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_CONTACTMODE.fulfilled, function (state, action) {
    state.location_masters_contactmode.loading = false, state.location_masters_contactmode.error = false, state.location_masters_contactmode = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_CONTACTMODE.pending, function (state, action) {
    state.location_masters_contactmode.loading = true, state.location_masters_contactmode.error = false, state.location_masters_contactmode.loading = true;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_CONTACTMODE.rejected, function (state, action) {
    state.location_masters_contactmode.loading = false, state.location_masters_contactmode.error = true, state.location_masters_contactmode = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_ISD.fulfilled, function (state, action) {
    state.location_masters_isd.loading = false, state.location_masters_isd.error = false, state.location_masters_isd = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_ISD.pending, function (state, action) {
    state.location_masters_isd.loading = true, state.location_masters_isd.error = false, state.location_masters_isd.loading = true;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_ISD.rejected, function (state, action) {
    state.location_masters_isd.loading = false, state.location_masters_isd.error = true, state.location_masters_isd = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_USE.fulfilled, function (state, action) {
    state.location_masters_use.loading = false, state.location_masters_use.error = false, state.location_masters_use = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_USE.pending, function (state, action) {
    state.location_masters_use.loading = true, state.location_masters_use.error = false, state.location_masters_use.loading = true;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_USE.rejected, function (state, action) {
    state.location_masters_use.loading = false, state.location_masters_use.error = true, state.location_masters_use = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_PRIORITY.fulfilled, function (state, action) {
    state.location_masters_priority.loading = false, state.location_masters_priority.error = false, state.location_masters_priority = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_PRIORITY.pending, function (state, action) {
    state.location_masters_priority.loading = true, state.location_masters_priority.error = false, state.location_masters_priority.loading = true;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_PRIORITY.rejected, function (state, action) {
    state.location_masters_priority.loading = false, state.location_masters_priority.error = true, state.location_masters_priority = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_GET_BY_ID.fulfilled, function (state, action) {
    state.locationmasterbyid.loading = false, state.locationmasterbyid.error = false, state.locationmasterbyid = action.payload;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_GET_BY_ID.pending, function (state, action) {
    state.locationmasterbyid.loading = true, state.locationmasterbyid.error = false, state.locationmasterbyid.loading = true;
  }), _defineProperty(_extraReducers$u, LOCATION_MASTER_GET_BY_ID.rejected, function (state, action) {
    state.locationmasterbyid.loading = false, state.locationmasterbyid.error = true, state.locationmasterbyid = action.payload;
  }), _extraReducers$u)
});
var locationMasterActions = {
  LOCATION_MASTERS_ENTITYTYPE: LOCATION_MASTERS_ENTITYTYPE,
  LOCATION_MASTERS_ENTITYNAME: LOCATION_MASTERS_ENTITYNAME,
  LOCATION_MASTERS_LOCATIONTYPE: LOCATION_MASTERS_LOCATIONTYPE,
  LOCATION_MASTERS_OPERATIONALSTATUS: LOCATION_MASTERS_OPERATIONALSTATUS,
  LOCATION_MASTERS_PARENT_LOCATION_ID_DESCRIPTION: LOCATION_MASTERS_PARENT_LOCATION_ID_DESCRIPTION,
  LOCATION_MASTERS_LOCATIONROLETYPE: LOCATION_MASTERS_LOCATIONROLETYPE,
  LOCATION_MASTER_SPECIALITY: LOCATION_MASTER_SPECIALITY,
  LOCATION_MASTER_CONTACTMODE: LOCATION_MASTER_CONTACTMODE,
  LOCATION_MASTER_ISD: LOCATION_MASTER_ISD,
  LOCATION_MASTER_USE: LOCATION_MASTER_USE,
  LOCATION_MASTER_PRIORITY: LOCATION_MASTER_PRIORITY,
  LOCATION_MASTER_GET_BY_ID: LOCATION_MASTER_GET_BY_ID
};
var locationMasterSlice$1 = locationMasterSlice.reducer;

var queries$e = {
  role_read: function role_read(data) {
    var filter = {
      filter: "CodeableConceptMaster.Type == 'PRACTROLE' && CodeableConceptMaster.status == true"
    };
    return _objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "CodeableConceptMaster"
    }, filter), {}, {
      sort: "CodeableConceptMaster.createddate",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(for cod IN TO_ARRAY(CodeableConceptMaster.coding) RETURN DOCUMENT(cod))})"
    });
  },
  permission_role_read: function permission_role_read(data) {
    var filter = {};

    if ((data === null || data === void 0 ? void 0 : data.role_id) >= 0) {
      filter = {
        filter: "PermissionRoleMapping.role_id == ".concat(data.role_id)
      };
    }

    return _objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "PermissionRoleMapping"
    }, filter), {}, {
      return_fields: "{PermissionRoleMapping}"
    });
  },
  get_role_by_id: function get_role_by_id(roleid) {
    return {
      db_name: dbName,
      entity: "IDM_PermissionRoleMapping",
      roleid: roleid //"CodingMaster/11117",

    };
  },
  permission_management_read: function permission_management_read(data) {
    var filter = {}; // if(data.role_id){
    //   filter = { "filter": `PermissionManagement.role_id == '${data.role_id}'` }
    // }

    return _objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "PermissionManagement"
    }, filter), {}, {
      return_fields: "{PermissionManagement}"
    });
  },
  permission_role_upsert: function permission_role_upsert(data) {
    var filter = {};

    if (data._key) {
      filter = {
        filter: {
          _key: data._key
        }
      };
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "PermissionRoleMapping",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, filter), {}, {
      doc: _objectSpread2({}, data)
    })];
  },
  role_upsert: function role_upsert(data) {
    var filter = {};

    if (data._key) {
      filter = {
        filter: {
          _key: data._key
        }
      };
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "CodeableConceptMaster",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, filter), {}, {
      doc: _objectSpread2({}, data)
    })];
  },
  role_soft_delete: function role_soft_delete(key) {
    return {
      db_name: dbName,
      metadata_dbname: idm_metadata_dbname,
      entity: "IDM_PermissionRoleMapping",
      filter: "IDM_PermissionRoleMapping._key=='".concat(key, "'")
    };
  },
  role_delete: function role_delete(data) {
    var filter = {};

    if (data._id) {
      filter = {
        filter: {
          _id: data._id
        }
      };
    }

    return [_objectSpread2({
      db_name: dbName,
      entity: "CodeableConceptMaster",
      // "is_metadata": true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, filter)];
  },
  coding_update: function coding_update(data) {
    // return [{
    //   "db_name": dbName,
    //   "entity": "CodingMaster",
    //   "is_metadata": true,
    //   "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
    //   "filter": {
    //   "_key":`${data._key}` ,
    //   },
    //   "doc": {
    //     ...data
    //   }
    // }]
    var filter = {
      filter: {
        _key: "".concat(data === null || data === void 0 ? void 0 : data._key)
      }
    };
    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "IDM_PermissionRoleMapping",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, (data === null || data === void 0 ? void 0 : data._key) && filter), {}, {
      doc: {
        id: data === null || data === void 0 ? void 0 : data.id,
        roleid: data === null || data === void 0 ? void 0 : data.roleid,
        rolename: data === null || data === void 0 ? void 0 : data.rolename,
        perrolepermsnid: data === null || data === void 0 ? void 0 : data.perrolepermsnid,
        activestatus: data === null || data === void 0 ? void 0 : data.activestatus,
        metadataid: "68ca97fa-a05a-414b-8506-fddc86c94c72",
        clientid: "clients/301506036",
        projectid: "projects/301511283"
      }
    })];
  }
};

var _extraReducers$t;
var PERMISSION_ROLE_UPSERT = toolkit.createAsyncThunk("rolesSlice/permission_role_upsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      params,
      queriesjson,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          params = _objectSpread2({
            _key: payload._key
          }, payload);
          queriesjson = queries$e.permission_role_upsert(params);
          _context.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var CODABALE_CONCEPT_UPSERT = toolkit.createAsyncThunk("rolesSlice/codable_concept_upsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      params,
      queriesjson,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          params = _objectSpread2({
            _key: payload._key
          }, payload);
          queriesjson = queries$e.role_upsert(params);
          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
}))); //coding_update

var ROLE_SOFT_DELETE = toolkit.createAsyncThunk("rolesSlice/role_soft_delete", /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref5, _ref6) {
    var _key, rejectWithValue, queriesjson, data;

    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _key = _ref5._key;
            rejectWithValue = _ref6.rejectWithValue;
            _context3.prev = 2;
            queriesjson = queries$e.role_soft_delete(_key);
            _context3.next = 6;
            return fetchData({
              body: JSON.stringify(queriesjson)
            }, __RoleSoftDelete__);

          case 6:
            data = _context3.sent;
            return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: data
            }));

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context3.t0.message
            })));

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 10]]);
  }));

  return function (_x, _x2) {
    return _ref7.apply(this, arguments);
  };
}());
var CODING_UPSERT = toolkit.createAsyncThunk("rolesSlice/coding_upsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref9,
      rejectWithValue,
      params,
      queriesjson,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref9 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref9.rejectWithValue;
          _context4.prev = 2;
          params = _objectSpread2({
            _key: payload._key
          }, payload);
          queriesjson = queries$e.coding_update(params);
          _context4.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 11]]);
})));
var CODABALE_CONCEPT_DELETE = toolkit.createAsyncThunk("rolesSlice/codable_concept_delete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref11,
      rejectWithValue,
      params,
      queriesjson,
      data,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref11 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref11.rejectWithValue;
          _context5.prev = 2;
          params = _objectSpread2({
            _id: payload._id
          }, payload);
          queriesjson = queries$e.role_delete(params);
          _context5.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __softDelete__);

        case 7:
          data = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 11]]);
})));
var GET_ROLE_BY_ID = toolkit.createAsyncThunk("rolesSlice/get_role_by_id", /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(_ref12, _ref13) {
    var roleid, rejectWithValue, readqueries, data;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            roleid = _ref12.roleid;
            rejectWithValue = _ref13.rejectWithValue;
            _context6.prev = 2;
            readqueries = queries$e.get_role_by_id(roleid);
            _context6.next = 6;
            return fetchData({
              body: JSON.stringify(readqueries)
            }, __GetRoleById__);

          case 6:
            data = _context6.sent;
            return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: data
            }));

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](2);
            return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
              message: _context6.t0.message
            })));

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[2, 10]]);
  }));

  return function (_x3, _x4) {
    return _ref14.apply(this, arguments);
  };
}());
var PERMISSION_MANAGEMENT_READ = toolkit.createAsyncThunk("rolesSlice/permission_management_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref16,
      rejectWithValue,
      readqueries,
      data,
      arry,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref16 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref16.rejectWithValue;
          _context7.prev = 2;
          readqueries = queries$e.permission_management_read(payload);
          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context7.sent;
          arry = [];
          data.result.map(function (val) {
            if (val.PermissionManagement) {
              arry.push(_objectSpread2({}, val.PermissionManagement));
            }
          });
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context7.t0.message
          })));

        case 15:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 12]]);
})));
var PERMISSION_MANAGEMENT_ROLE_READ = toolkit.createAsyncThunk("rolesSlice/permission_management_role_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref18,
      rejectWithValue,
      readqueries,
      data,
      arry,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref18 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref18.rejectWithValue;
          _context8.prev = 2;
          readqueries = queries$e.permission_role_read(payload);
          _context8.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context8.sent;
          arry = [];
          data.result.map(function (val) {
            if (val.PermissionRoleMapping) {
              arry.push(_objectSpread2({}, val.PermissionRoleMapping));
            }
          });
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context8.prev = 12;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context8.t0.message
          })));

        case 15:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 12]]);
})));
var ROLE_READ = toolkit.createAsyncThunk("rolesSlice/role_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref20,
      rejectWithValue,
      readqueries,
      data,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref20 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref20.rejectWithValue;
          _context9.prev = 2;
          readqueries = queries$e.role_read(payload);
          _context9.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context9.sent;
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context9.prev = 10;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context9.t0.message
          })));

        case 13:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 10]]);
})));
var rolesSlice = toolkit.createSlice({
  name: "rolesSlice",
  initialState: {
    permission_role_upsert: _objectSpread2({}, defaultState.List),
    codable_concept_upsert: _objectSpread2({}, defaultState.List),
    permission_management_read: _objectSpread2({}, defaultState.List),
    permission_management_role_read: _objectSpread2({}, defaultState.List),
    role_read: _objectSpread2({}, defaultState.List),
    codable_concept_delete: _objectSpread2({}, defaultState.List),
    coding_upsert: _objectSpread2({}, defaultState.List),
    get_role_by_id: _objectSpread2({}, defaultState.List),
    role_soft_delete: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$t = {}, _defineProperty(_extraReducers$t, PERMISSION_ROLE_UPSERT.fulfilled, function (state, action) {
    state.permission_role_upsert.loading = false, state.permission_role_upsert.error = false, state.permission_role_upsert = action.payload;
  }), _defineProperty(_extraReducers$t, PERMISSION_ROLE_UPSERT.pending, function (state, action) {
    state.permission_role_upsert.loading = true, state.permission_role_upsert.error = false, state.permission_role_upsert.loading = true;
  }), _defineProperty(_extraReducers$t, PERMISSION_ROLE_UPSERT.rejected, function (state, action) {
    state.permission_role_upsert.loading = false, state.permission_role_upsert.error = true, state.permission_role_upsert = action.payload;
  }), _defineProperty(_extraReducers$t, CODABALE_CONCEPT_UPSERT.fulfilled, function (state, action) {
    state.codable_concept_upsert.loading = false, state.codable_concept_upsert.error = false, state.codable_concept_upsert = action.payload;
  }), _defineProperty(_extraReducers$t, CODABALE_CONCEPT_UPSERT.pending, function (state, action) {
    state.codable_concept_upsert.loading = true, state.codable_concept_upsert.error = false, state.codable_concept_upsert.loading = true;
  }), _defineProperty(_extraReducers$t, CODABALE_CONCEPT_UPSERT.rejected, function (state, action) {
    state.codable_concept_upsert.loading = false, state.codable_concept_upsert.error = true, state.codable_concept_upsert = action.payload;
  }), _defineProperty(_extraReducers$t, PERMISSION_MANAGEMENT_READ.fulfilled, function (state, action) {
    state.permission_management_read.loading = false, state.permission_management_read.error = false, state.permission_management_read = action.payload;
  }), _defineProperty(_extraReducers$t, PERMISSION_MANAGEMENT_READ.pending, function (state, action) {
    state.permission_management_read.loading = true, state.permission_management_read.error = false, state.permission_management_read.loading = true;
  }), _defineProperty(_extraReducers$t, PERMISSION_MANAGEMENT_READ.rejected, function (state, action) {
    state.permission_management_read.loading = false, state.permission_management_read.error = true, state.permission_management_read = action.payload;
  }), _defineProperty(_extraReducers$t, PERMISSION_MANAGEMENT_ROLE_READ.fulfilled, function (state, action) {
    state.permission_management_role_read.loading = false, state.permission_management_role_read.error = false, state.permission_management_role_read = action.payload;
  }), _defineProperty(_extraReducers$t, PERMISSION_MANAGEMENT_ROLE_READ.pending, function (state, action) {
    state.permission_management_role_read.loading = true, state.permission_management_role_read.error = false, state.permission_management_role_read.loading = true;
  }), _defineProperty(_extraReducers$t, PERMISSION_MANAGEMENT_ROLE_READ.rejected, function (state, action) {
    state.permission_management_role_read.loading = false, state.permission_management_role_read.error = true, state.permission_management_role_read = action.payload;
  }), _defineProperty(_extraReducers$t, ROLE_READ.fulfilled, function (state, action) {
    state.role_read.loading = false, state.role_read.error = false, state.role_read = action.payload;
  }), _defineProperty(_extraReducers$t, ROLE_READ.pending, function (state, action) {
    state.role_read.loading = true, state.role_read.error = false, state.role_read.loading = true;
  }), _defineProperty(_extraReducers$t, ROLE_READ.rejected, function (state, action) {
    state.role_read.loading = false, state.role_read.error = true, state.role_read = action.payload;
  }), _defineProperty(_extraReducers$t, CODABALE_CONCEPT_DELETE.fulfilled, function (state, action) {
    state.role_read.loading = false, state.role_read.error = false, state.role_read = action.payload;
  }), _defineProperty(_extraReducers$t, CODABALE_CONCEPT_DELETE.pending, function (state, action) {
    state.role_read.loading = true, state.role_read.error = false, state.role_read.loading = true;
  }), _defineProperty(_extraReducers$t, CODABALE_CONCEPT_DELETE.rejected, function (state, action) {
    state.role_read.loading = false, state.role_read.error = true, state.role_read = action.payload;
  }), _defineProperty(_extraReducers$t, CODING_UPSERT.fulfilled, function (state, action) {
    state.coding_upsert.loading = false, state.coding_upsert.error = false, state.coding_upsert = action.payload;
  }), _defineProperty(_extraReducers$t, CODING_UPSERT.pending, function (state, action) {
    state.coding_upsert.loading = true, state.coding_upsert.error = false, state.coding_upsert.loading = true;
  }), _defineProperty(_extraReducers$t, CODING_UPSERT.rejected, function (state, action) {
    state.coding_upsert.loading = false, state.coding_upsert.error = true, state.coding_upsert = action.payload;
  }), _defineProperty(_extraReducers$t, GET_ROLE_BY_ID.fulfilled, function (state, action) {
    state.get_role_by_id.loading = false, state.get_role_by_id.error = false, state.get_role_by_id = action.payload;
  }), _defineProperty(_extraReducers$t, GET_ROLE_BY_ID.pending, function (state, action) {
    state.get_role_by_id.loading = true, state.get_role_by_id.error = false, state.get_role_by_id.loading = true;
  }), _defineProperty(_extraReducers$t, GET_ROLE_BY_ID.rejected, function (state, action) {
    state.get_role_by_id.loading = false, state.get_role_by_id.error = true, state.get_role_by_id = action.payload;
  }), _defineProperty(_extraReducers$t, ROLE_SOFT_DELETE.fulfilled, function (state, action) {
    state.role_soft_delete.loading = false, state.role_soft_delete.error = false, state.role_soft_delete = action.payload;
  }), _defineProperty(_extraReducers$t, ROLE_SOFT_DELETE.pending, function (state, action) {
    state.role_soft_delete.loading = true, state.role_soft_delete.error = false, state.role_soft_delete.loading = true;
  }), _defineProperty(_extraReducers$t, ROLE_SOFT_DELETE.rejected, function (state, action) {
    state.role_soft_delete.loading = false, state.role_soft_delete.error = true, state.role_soft_delete = action.payload;
  }), _extraReducers$t)
});
var roleActions = {
  CODING_UPSERT: CODING_UPSERT,
  PERMISSION_ROLE_UPSERT: PERMISSION_ROLE_UPSERT,
  CODABALE_CONCEPT_UPSERT: CODABALE_CONCEPT_UPSERT,
  PERMISSION_MANAGEMENT_READ: PERMISSION_MANAGEMENT_READ,
  PERMISSION_MANAGEMENT_ROLE_READ: PERMISSION_MANAGEMENT_ROLE_READ,
  ROLE_READ: ROLE_READ,
  CODABALE_CONCEPT_DELETE: CODABALE_CONCEPT_DELETE,
  GET_ROLE_BY_ID: GET_ROLE_BY_ID
};
var rolesSlice$1 = rolesSlice.reducer;

var queries$d = {
  role_read: function role_read(data) {
    var filter = {
      filter: "CodeableConceptMaster.Type == 'PRACTROLE' && CodeableConceptMaster.status == true"
    };
    return _objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "CodeableConceptMaster"
    }, filter), {}, {
      return_fields: "MERGE(CodeableConceptMaster,{coding:(for cod IN TO_ARRAY(CodeableConceptMaster.coding) RETURN DOCUMENT(cod))})"
    });
  },
  permission_role_read: function permission_role_read(data) {
    var filter = {};

    if (data.role_id >= 0) {
      filter = {
        filter: "PermissionRoleMapping.role_id == ".concat(data.role_id)
      };
    }

    return _objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "PermissionRoleMapping"
    }, filter), {}, {
      return_fields: "{PermissionRoleMapping}"
    });
  },
  repository_read: function repository_read(data) {
    //first json format from barani
    // let filter = {filter:`Repository.rep_id=='cee89c6e-07db-4ae0-8b3f-e6eaefa70d35'`};
    //kumaravel format
    // let filter = {filter:`Repository.rep_id=='cb98c91e-6643-4309-b15c-fd65990f57d6'`};
    // if(data.role_id){
    //   filter = { "filter": `PermissionManagement.role_id == '${data.role_id}'` }
    // }
    // return {
    //   "db_name": dbName,
    //   "entity": "Repository",
    //   // "filter": "Holiday.activestatus ==true",
    //   ...filter,
    //   "return_fields": "{Repository}"
    // }
    return {
      db_name: dbName,
      metadataid: "68ca97fa-a05a-414b-8506-fddc86c94c72"
    };
  }
};

var _extraReducers$s;
var REPOSITORY_READ_DOCUMENT = toolkit.createAsyncThunk("repositorySlice/repository_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      readqueries,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          readqueries = queries$d.repository_read(payload);
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __ListIDMRepositories__);

        case 6:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context.t0.message
          })));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 10]]);
})));
var repositorySlice = toolkit.createSlice({
  name: "repositorySlice",
  initialState: {
    repository_read: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$s = {}, _defineProperty(_extraReducers$s, REPOSITORY_READ_DOCUMENT.fulfilled, function (state, action) {
    state.repository_read.loading = false, state.repository_read.error = false, state.repository_read = action.payload;
  }), _defineProperty(_extraReducers$s, REPOSITORY_READ_DOCUMENT.pending, function (state, action) {
    state.repository_read.loading = true, state.repository_read.error = false, state.repository_read.loading = true;
  }), _defineProperty(_extraReducers$s, REPOSITORY_READ_DOCUMENT.rejected, function (state, action) {
    state.repository_read.loading = false, state.repository_read.error = true, state.repository_read = action.payload;
  }), _extraReducers$s)
});
var repositoryActions = {
  REPOSITORY_READ_DOCUMENT: REPOSITORY_READ_DOCUMENT
};
var repositorySlice$1 = repositorySlice.reducer;

var queries$c = {
  permission_read: function permission_read(data) {
    // let filter = { filter: "PermissionManagement.activestatus==true" };
    // return {
    //   db_name: dbName,
    //   entity: "PermissionManagement",
    //   // "filter": "Holiday.activestatus ==true",
    //   ...filter,
    //   return_fields: "{PermissionManagement}",
    // };
    return {
      db_name: dbName,
      entity: "IDM_PermissionManagement"
    };
  },
  permission_read_by_id: function permission_read_by_id(_id) {
    return {
      db_name: dbName,
      entity: "IDM_PermissionManagement",
      _id: _id !== null && _id !== void 0 ? _id : ""
    };
  },
  permission_delete: function permission_delete(_key) {
    return {
      db_name: dbName,
      metadata_dbname: idm_metadata_dbname$1,
      entity: "IDM_PermissionManagement",
      filter: "IDM_PermissionManagement._key=='".concat(_key, "'")
    };
  },
  // permission_upsert: (data) => {
  //   let filter = {};
  //   if (data._key) {
  //     filter = { filter: { _key: data._key } };
  //   }
  //   return [
  //     {
  //       db_name: dbName,
  //       entity: "PermissionManagement",
  //       is_metadata: true,
  //       metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
  //       ...filter,
  //       doc: {
  //         ...data,
  //       },
  //     },
  //   ];
  // },
  permission_upsert: function permission_upsert(data) {
    var filter = {};

    if (data._key) {
      filter = {
        filter: {
          _key: data._key
        }
      };
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "IDM_PermissionManagement",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      metadata_dbname: idm_metadata_dbname$1
    }, filter), {}, {
      doc: {
        permsnid: data === null || data === void 0 ? void 0 : data.permsnid,
        permsnname: data === null || data === void 0 ? void 0 : data.permsnname,
        status: data === null || data === void 0 ? void 0 : data.status,
        metadataid: "68ca97fa-a05a-414b-8506-fddc86c94c72",
        clientid: "clients/301506036",
        projectid: "projects/301511283",
        permsn_repo: data === null || data === void 0 ? void 0 : data.permsn_repo //   [
        //     {
        //         "_key": "@_key"
        //         "repoid": "string",
        //         "permsnread": "boolean",
        //         "permsnwrite": "boolean",
        //         "permsnupdate": "boolean",
        //         "permsndelete": "boolean"
        //     }
        //  ]

      }
    })];
  }
};

var _extraReducers$r;

var _excluded = ["permsn_repo"];
var PERMISSION_UPSERT = toolkit.createAsyncThunk("permissionSlice/permission_upsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      params,
      queriesjson,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          params = _objectSpread2({
            _key: payload._key
          }, payload);
          queriesjson = queries$c.permission_upsert(params);
          _context.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __UpsertPermission__);

        case 7:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var PERMISSION_DELETE = toolkit.createAsyncThunk("permissionSlice/permission_delete", /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref3, _ref4) {
    var _key, rejectWithValue, queriesjson, data;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _key = _ref3._key;
            rejectWithValue = _ref4.rejectWithValue;
            _context2.prev = 2;
            queriesjson = queries$c.permission_delete(_key);
            _context2.next = 6;
            return fetchData({
              body: JSON.stringify(queriesjson)
            }, __DeletePermission__);

          case 6:
            data = _context2.sent;
            return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: data
            }));

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context2.t0.message
            })));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 10]]);
  }));

  return function (_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}());
var PERMISSION_READ = toolkit.createAsyncThunk("permissionSlice/permission_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref7,
      rejectWithValue,
      readqueries,
      data,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref7 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref7.rejectWithValue;
          _context3.prev = 2;
          readqueries = queries$c.permission_read(payload);
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __GetAllPermissions__);

        case 6:
          data = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context3.t0.message
          })));

        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 10]]);
})));
var PERMISSION_READ_AS_OPTIONS = toolkit.createAsyncThunk("permissionSlice/permission_read_as_options", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref9,
      rejectWithValue,
      _data$result,
      readqueries,
      data,
      res,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref9 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref9.rejectWithValue;
          _context4.prev = 2;
          readqueries = queries$c.permission_read(payload);
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __GetAllPermissions__);

        case 6:
          data = _context4.sent;
          // let arry = [];
          // data.result.map(val => {
          //   if(val.PermissionManagement){
          //     arry.push({
          //       ...val.PermissionManagement
          //     })
          //   }
          // });
          res = data === null || data === void 0 ? void 0 : (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.map(function (item) {
            item.permsn_repo;
                var rest = _objectWithoutProperties(item, _excluded);

            return _objectSpread2(_objectSpread2({}, rest), {}, {
              label: rest === null || rest === void 0 ? void 0 : rest.permsnname,
              value: rest === null || rest === void 0 ? void 0 : rest._id
            });
          });
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context4.t0.message
          })));

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 11]]);
})));
var PERMISSION_READ_BY_ID = toolkit.createAsyncThunk("permissionSlice/permission_read_by_id", /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref10, _ref11) {
    var _id, rejectWithValue, readqueries, data;

    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _id = _ref10._id;
            rejectWithValue = _ref11.rejectWithValue;
            _context5.prev = 2;
            readqueries = queries$c.permission_read_by_id(_id);
            _context5.next = 6;
            return fetchData({
              body: JSON.stringify(readqueries)
            }, __GetPermissionByID__);

          case 6:
            data = _context5.sent;
            return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
              data: data
            }));

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](2);
            return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
              message: _context5.t0.message
            })));

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 10]]);
  }));

  return function (_x3, _x4) {
    return _ref12.apply(this, arguments);
  };
}());
var permissionSlice = toolkit.createSlice({
  name: "permissionSlice",
  initialState: {
    permission_upsert: _objectSpread2({}, defaultState.List),
    permission_delete: _objectSpread2({}, defaultState.List),
    permission_read: _objectSpread2({}, defaultState.List),
    permission_read_by_id: _objectSpread2({}, defaultState.List),
    permission_read_as_options: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$r = {}, _defineProperty(_extraReducers$r, PERMISSION_UPSERT.fulfilled, function (state, action) {
    state.permission_upsert.loading = false, state.permission_upsert.error = false, state.permission_upsert = action.payload;
  }), _defineProperty(_extraReducers$r, PERMISSION_UPSERT.pending, function (state, action) {
    state.permission_upsert.loading = true, state.permission_upsert.error = false, state.permission_upsert.loading = true;
  }), _defineProperty(_extraReducers$r, PERMISSION_UPSERT.rejected, function (state, action) {
    state.permission_upsert.loading = false, state.permission_upsert.error = true, state.permission_upsert = action.payload;
  }), _defineProperty(_extraReducers$r, PERMISSION_DELETE.fulfilled, function (state, action) {
    state.permission_delete.loading = false, state.permission_delete.error = false, state.permission_delete = action.payload;
  }), _defineProperty(_extraReducers$r, PERMISSION_DELETE.pending, function (state, action) {
    state.permission_delete.loading = true, state.permission_delete.error = false, state.permission_delete.loading = true;
  }), _defineProperty(_extraReducers$r, PERMISSION_DELETE.rejected, function (state, action) {
    state.permission_delete.loading = false, state.permission_delete.error = true, state.permission_delete = action.payload;
  }), _defineProperty(_extraReducers$r, PERMISSION_READ.fulfilled, function (state, action) {
    state.permission_read.loading = false, state.permission_read.error = false, state.permission_read = action.payload;
  }), _defineProperty(_extraReducers$r, PERMISSION_READ.pending, function (state, action) {
    state.permission_read.loading = true, state.permission_read.error = false, state.permission_read.loading = true;
  }), _defineProperty(_extraReducers$r, PERMISSION_READ.rejected, function (state, action) {
    state.permission_read.loading = false, state.permission_read.error = true, state.permission_read = action.payload;
  }), _defineProperty(_extraReducers$r, PERMISSION_READ_BY_ID.fulfilled, function (state, action) {
    state.permission_read_by_id.loading = false, state.permission_read_by_id.error = false, state.permission_read_by_id = action.payload;
  }), _defineProperty(_extraReducers$r, PERMISSION_READ_BY_ID.pending, function (state, action) {
    state.permission_read_by_id.loading = true, state.permission_read_by_id.error = false, state.permission_read_by_id.loading = true;
  }), _defineProperty(_extraReducers$r, PERMISSION_READ_BY_ID.rejected, function (state, action) {
    state.permission_read_by_id.loading = false, state.permission_read_by_id.error = true, state.permission_read_by_id = action.payload;
  }), _defineProperty(_extraReducers$r, PERMISSION_READ_AS_OPTIONS.fulfilled, function (state, action) {
    state.permission_read_as_options.loading = false, state.permission_read_as_options.error = false, state.permission_read_as_options = action.payload;
  }), _defineProperty(_extraReducers$r, PERMISSION_READ_AS_OPTIONS.pending, function (state, action) {
    state.permission_read_as_options.loading = true, state.permission_read_as_options.error = false, state.permission_read_as_options.loading = true;
  }), _defineProperty(_extraReducers$r, PERMISSION_READ_AS_OPTIONS.rejected, function (state, action) {
    state.permission_read_as_options.loading = false, state.permission_read_as_options.error = true, state.permission_read_as_options = action.payload;
  }), _extraReducers$r)
});
var permissionActions = {
  PERMISSION_READ: PERMISSION_READ,
  PERMISSION_READ_BY_ID: PERMISSION_READ_BY_ID,
  PERMISSION_DELETE: PERMISSION_DELETE,
  PERMISSION_UPSERT: PERMISSION_UPSERT,
  PERMISSION_READ_AS_OPTIONS: PERMISSION_READ_AS_OPTIONS
};
var permissionSlice$1 = permissionSlice.reducer;

var queries$b = {
  person_read: function person_read(data) {
    return {
      "db_name": dbName,
      "entity": "Person",
      "filter": "Person.activestatus==true",
      "sort": "Person.createddate",
      "return_fields": "merge(Person,{name:(for nam in HumanNameMaster filter nam._id in Person.name return merge(nam,{use:document(nam.use),suffix:document(nam.suffix),prefix:document(nam.prefix)}))},{gender:document(Person.gender)},{telecom:(for con in ContactPointMaster filter con._id in Person.telecom return merge(con,{use:document(con.use),rank:document(con.rank)}))},{photo:document(Person.photo)},{address:document(Person.address)},{identifier:(for iden in IdentifierMaster filter iden._id in Person.identifier return merge(iden,{user:document(iden.user),Type:document(iden.Type)}))},{OrgID:document(Person.OrgID)},{orgType:document(Person.orgType)})"
    };
  },
  person_delete: function person_delete(data) {
    var filter = {};

    if (data._id) {
      filter = {
        filter: {
          _id: data._id
        }
      };
    }

    return [_objectSpread2({
      "db_name": dbName,
      "entity": "Person",
      // "is_metadata": true,
      "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, filter)];
  },
  person_upsert: function person_upsert(data) {
    var filter = {};

    if (data._key) {
      filter = {
        filter: {
          _key: data._key
        }
      };
    }

    delete data._key;
    return [_objectSpread2(_objectSpread2({
      "db_name": dbName,
      "entity": "Person",
      "is_metadata": true,
      "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, filter), {}, {
      "doc": _objectSpread2({}, data)
    })];
  },
  contact_system_master: function contact_system_master(data) {
    return {
      "db_name": dbName,
      "entity": "CodingMaster",
      "filter": "CodingMaster.Type=='CONTACTSYSTEM' && CodingMaster.activestatus==true",
      "return_fields": "KEEP(CodingMaster,'_id','id','_key','code','display','Type')"
    };
  },
  entity_name_master: function entity_name_master(data) {
    return {
      "db_name": dbName,
      "entity": "Organization",
      "filter": "Organization.activestatus==true && lower(first(document(Organization.OrgType)[*].display)) == '".concat(data, "'"),
      "return_fields": "{_id:Organization._id,_key:Organization._key,id:Organization.id,name:Organization.name,alias:Organization.alias}"
    };
  },
  entity_type_master: function entity_type_master(data) {
    return {
      "db_name": dbName,
      "entity": "CodingMaster",
      "filter": "CodingMaster.Type=='ORGTYPE' && CodingMaster.activestatus==true",
      "return_fields": "KEEP(CodingMaster,'_id','id','_key','code','display','Type')"
    };
  },
  gender_master: function gender_master(data) {
    return {
      "db_name": dbName,
      "entity": "CodingMaster",
      "filter": "CodingMaster.Type=='GENDER' && CodingMaster.activestatus==true",
      "return_fields": "KEEP(CodingMaster,'_id','id','_key','code','display','Type')"
    };
  },
  id_type_master: function id_type_master(data) {
    return {
      "db_name": dbName,
      "entity": "CodingMaster",
      "filter": "CodingMaster.Type=='ALTERNATEIDTYPE' && CodingMaster.activestatus==true",
      "return_fields": "KEEP(CodingMaster,'_id','id','_key','code','display','Type')"
    };
  },
  prefix_master: function prefix_master(data) {
    return {
      "db_name": dbName,
      "entity": "CodingMaster",
      "filter": "CodingMaster.Type=='NAMEPREFIX' && CodingMaster.activestatus==true",
      "return_fields": "KEEP(CodingMaster,'_id','id','_key','code','display','Type')"
    };
  },
  priority_master: function priority_master(data) {
    return {
      "db_name": dbName,
      "entity": "CodingMaster",
      "filter": "CodingMaster.Type=='PRIORITY' && CodingMaster.activestatus==true",
      "return_fields": "KEEP(CodingMaster,'_id','id','_key','code','display','Type')"
    };
  },
  surffix_master: function surffix_master(data) {
    return {
      "db_name": dbName,
      "entity": "CodingMaster",
      "filter": "CodingMaster.Type=='NAMESUFFIX' && CodingMaster.activestatus==true",
      "return_fields": "KEEP(CodingMaster,'_id','id','_key','code','display','Type')"
    };
  },
  use_master: function use_master(data) {
    return {
      "db_name": dbName,
      "entity": "CodingMaster",
      "filter": "CodingMaster.Type=='USE' && CodingMaster.activestatus==true",
      "return_fields": "KEEP(CodingMaster,'_id','id','_key','code','display','Type')"
    };
  },
  single_read_person: function single_read_person(data) {
    return {
      "db_name": dbName,
      "entity": "Person",
      "filter": " Person._key=='".concat(data._key, "' && Person.activestatus==true"),
      "return_fields": "merge(Person,{name:(for nam in HumanNameMaster filter nam._id in Person.name return merge(nam,{use:document(nam.use),suffix:document(nam.suffix),prefix:document(nam.prefix)}))},{gender:document(Person.gender)},{telecom:(for con in ContactPointMaster filter con._id in Person.telecom return merge(con,{use:document(con.use),rank:document(con.rank)}))},{photo:document(Person.photo)},{address:(for add in AddressMaster filter add._id in Person.address return merge(add,{use:document(add.use),Type:document(add.Type),city:document(add.city),district:document(add.district),state:document(add.state),country:document(add.country),postalCode:document(add.postalCode)}))},{identifier:(for iden in IdentifierMaster filter iden._id in Person.identifier return merge(iden,{user:document(iden.user),Type:document(iden.Type),period:document(iden.period)}))},{OrgID:document(Person.OrgID)},{orgType:document(Person.orgType)})"
    }; // return {
    //   "db_name": dbName,
    //   "entity": "Person",
    //   "filter": `Person.activestatus==true && Person._key=='${data._key}'`,
    //   "return_fields": "merge(Person,{name:(for nam in HumanNameMaster filter nam._id in Person.name return merge(nam,{use:document(nam.use),suffix:document(nam.suffix),prefix:document(nam.prefix)}))},{gender:document(Person.gender)},{telecom:(for con in ContactPointMaster filter con._id in Person.telecom return merge(con,{use:document(con.use),rank:document(con.rank),system:document(con.system)}))},{photo:document(Person.photo)},{address:document(Person.address)},{identifier:(for iden in IdentifierMaster filter iden._id in Person.identifier return merge(iden,{user:document(iden.user),Type:document(iden.Type)}))},{OrgID:document(Person.OrgID)},{orgType:document(Person.orgType)})"
    // }
  }
}; // person_read: (data) => {
//   let filter = {};
//   return {
//     "db_name": dbName,
//     "entity": "Person",
//     "filter": "Person.activestatus==true",
//     "limit": {
//     "count": 10,
//     "offset": 0
//     },
//     "return_fields": "merge(Person,{name:(for nam in HumanNameMaster filter nam._id in Person.name return merge(nam,{use:document(nam.use),suffix:document(nam.suffix),prefix:document(nam.prefix)}))},{gender:document(Person.gender)},{telecom:(for con in ContactPointMaster filter con._id in Person.telecom return merge(con,{use:document(con.use),rank:document(con.rank)}))},{photo:document(Person.photo)},{address:document(Person.address)},{identifier:(for iden in IdentifierMaster filter iden._id in Person.identifier return merge(iden,{user:document(iden.user),Type:document(iden.Type)}))},{OrgID:document(Person.OrgID)},{orgType:document(Person.orgType)})",
//     "sort": "Person.createddate"
//     }
// },

var _extraReducers$q;
var PERSON_UPSERT = toolkit.createAsyncThunk("personSlice/person_upsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      params,
      queriesjson,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          params = _objectSpread2({
            _key: payload._key
          }, payload);
          queriesjson = queries$b.person_upsert(params);
          _context.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var PERSON_DELETE = toolkit.createAsyncThunk("personSlice/person_delete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      params,
      queriesjson,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          params = _objectSpread2({
            _id: payload._id
          }, payload);
          queriesjson = queries$b.person_delete(params);
          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __deleteUrl__);

        case 7:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var PERSON_READ = toolkit.createAsyncThunk("personSlice/person_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      readqueries,
      data,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          readqueries = queries$b.person_read(payload);
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context3.t0.message
          })));

        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 10]]);
}))); //single read person

var SINGLE_PERSON_READ = toolkit.createAsyncThunk("personSlice/single_read_person", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      readqueries,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          readqueries = queries$b.single_read_person(payload);
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context4.t0.message
          })));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 10]]);
}))); //contact_system_master

var CONTACTSYSTEMMASTER = toolkit.createAsyncThunk("personSlice/contact_system_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      readqueries,
      data,
      arry,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          readqueries = queries$b.contact_system_master(payload);
          _context5.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context5.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
              label: val.display,
              value: val._id
            }));
          });
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context5.t0.message
          })));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 12]]);
}))); //entity_name_master

var ENTITYNAMEMASTER = toolkit.createAsyncThunk("personSlice/entity_name_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref12,
      rejectWithValue,
      readqueries,
      data,
      arry,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          readqueries = queries$b.entity_name_master(payload);
          _context6.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context6.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
              label: val.name,
              value: val._id
            }));
          });
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context6.t0.message
          })));

        case 15:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 12]]);
}))); //entity_type_master

var ENTITYTYPEMASTER = toolkit.createAsyncThunk("personSlice/entity_type_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      readqueries,
      data,
      arry,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          readqueries = queries$b.entity_type_master(payload);
          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context7.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
              label: val.display,
              value: val._id
            }));
          });
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context7.t0.message
          })));

        case 15:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 12]]);
}))); //gender_master

var GENDERMASTER = toolkit.createAsyncThunk("personSlice/gender_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref16,
      rejectWithValue,
      readqueries,
      data,
      arry,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref16 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref16.rejectWithValue;
          _context8.prev = 2;
          readqueries = queries$b.gender_master(payload);
          _context8.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context8.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
              label: val.display,
              value: val._id
            }));
          });
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context8.prev = 12;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context8.t0.message
          })));

        case 15:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 12]]);
}))); //id_type_master

var IDTYPEMASTER = toolkit.createAsyncThunk("personSlice/id_type_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref18,
      rejectWithValue,
      readqueries,
      data,
      arry,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref18 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref18.rejectWithValue;
          _context9.prev = 2;
          readqueries = queries$b.id_type_master(payload);
          _context9.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context9.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
              label: val.display,
              value: val._id
            }));
          });
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context9.prev = 12;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context9.t0.message
          })));

        case 15:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 12]]);
}))); //prefix_master

var PREFIXMASTER = toolkit.createAsyncThunk("personSlice/prefix_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref20,
      rejectWithValue,
      readqueries,
      data,
      arry,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref20 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref20.rejectWithValue;
          _context10.prev = 2;
          readqueries = queries$b.prefix_master(payload);
          _context10.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context10.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
              label: val.display,
              value: val._id
            }));
          });
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context10.prev = 12;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context10.t0.message
          })));

        case 15:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 12]]);
}))); //priority_master

var PRIORITYMASTER = toolkit.createAsyncThunk("personSlice/priority_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var payload,
      _ref22,
      rejectWithValue,
      readqueries,
      data,
      arry,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
          _ref22 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref22.rejectWithValue;
          _context11.prev = 2;
          readqueries = queries$b.priority_master(payload);
          _context11.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context11.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
              label: val.display,
              value: val._id
            }));
          });
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context11.prev = 12;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context11.t0.message
          })));

        case 15:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 12]]);
}))); //surffix_master

var SURFFIXMASTER = toolkit.createAsyncThunk("personSlice/surffix_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var payload,
      _ref24,
      rejectWithValue,
      readqueries,
      data,
      arry,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
          _ref24 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref24.rejectWithValue;
          _context12.prev = 2;
          readqueries = queries$b.surffix_master(payload);
          _context12.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context12.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
              label: val.display,
              value: val._id
            }));
          });
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context12.prev = 12;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context12.t0.message
          })));

        case 15:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 12]]);
}))); //use_master

var USEMASTER = toolkit.createAsyncThunk("personSlice/use_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
  var payload,
      _ref26,
      rejectWithValue,
      readqueries,
      data,
      arry,
      _args13 = arguments;

  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          payload = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {};
          _ref26 = _args13.length > 1 ? _args13[1] : undefined, rejectWithValue = _ref26.rejectWithValue;
          _context13.prev = 2;
          readqueries = queries$b.use_master(payload);
          _context13.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context13.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
              label: val.display,
              value: val._id
            }));
          });
          return _context13.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context13.prev = 12;
          _context13.t0 = _context13["catch"](2);
          return _context13.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context13.t0.message
          })));

        case 15:
        case "end":
          return _context13.stop();
      }
    }
  }, _callee13, null, [[2, 12]]);
})));
var personSlice = toolkit.createSlice({
  name: "personSlice",
  initialState: {
    person_upsert: _objectSpread2({}, defaultState.List),
    person_delete: _objectSpread2({}, defaultState.List),
    person_read: _objectSpread2({}, defaultState.List),
    contact_system_master: _objectSpread2({}, defaultState.List),
    entity_name_master: _objectSpread2({}, defaultState.List),
    entity_type_master: _objectSpread2({}, defaultState.List),
    gender_master: _objectSpread2({}, defaultState.List),
    id_type_master: _objectSpread2({}, defaultState.List),
    prefix_master: _objectSpread2({}, defaultState.List),
    priority_master: _objectSpread2({}, defaultState.List),
    surffix_master: _objectSpread2({}, defaultState.List),
    use_master: _objectSpread2({}, defaultState.List),
    single_read_person: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$q = {}, _defineProperty(_extraReducers$q, PERSON_UPSERT.fulfilled, function (state, action) {
    state.person_upsert.loading = false, state.person_upsert.error = false, state.person_upsert = action.payload;
  }), _defineProperty(_extraReducers$q, PERSON_UPSERT.pending, function (state, action) {
    state.person_upsert.loading = true, state.person_upsert.error = false, state.person_upsert.loading = true;
  }), _defineProperty(_extraReducers$q, PERSON_UPSERT.rejected, function (state, action) {
    state.person_upsert.loading = false, state.person_upsert.error = true, state.person_upsert = action.payload;
  }), _defineProperty(_extraReducers$q, PERSON_DELETE.fulfilled, function (state, action) {
    state.person_delete.loading = false, state.person_delete.error = false, state.person_delete = action.payload;
  }), _defineProperty(_extraReducers$q, PERSON_DELETE.pending, function (state, action) {
    state.person_delete.loading = true, state.person_delete.error = false, state.person_delete.loading = true;
  }), _defineProperty(_extraReducers$q, PERSON_DELETE.rejected, function (state, action) {
    state.person_delete.loading = false, state.person_delete.error = true, state.person_delete = action.payload;
  }), _defineProperty(_extraReducers$q, PERSON_READ.fulfilled, function (state, action) {
    state.person_read.loading = false, state.person_read.error = false, state.person_read = action.payload;
  }), _defineProperty(_extraReducers$q, PERSON_READ.pending, function (state, action) {
    state.person_read.loading = true, state.person_read.error = false, state.person_read.loading = true;
  }), _defineProperty(_extraReducers$q, PERSON_READ.rejected, function (state, action) {
    state.person_read.loading = false, state.person_read.error = true, state.person_read = action.payload;
  }), _defineProperty(_extraReducers$q, CONTACTSYSTEMMASTER.fulfilled, function (state, action) {
    state.contact_system_master.loading = false, state.contact_system_master.error = false, state.contact_system_master = action.payload;
  }), _defineProperty(_extraReducers$q, CONTACTSYSTEMMASTER.pending, function (state, action) {
    state.contact_system_master.loading = true, state.contact_system_master.error = false, state.contact_system_master.loading = true;
  }), _defineProperty(_extraReducers$q, CONTACTSYSTEMMASTER.rejected, function (state, action) {
    state.contact_system_master.loading = false, state.contact_system_master.error = true, state.contact_system_master = action.payload;
  }), _defineProperty(_extraReducers$q, ENTITYNAMEMASTER.fulfilled, function (state, action) {
    state.entity_name_master.loading = false, state.entity_name_master.error = false, state.entity_name_master = action.payload;
  }), _defineProperty(_extraReducers$q, ENTITYNAMEMASTER.pending, function (state, action) {
    state.entity_name_master.loading = true, state.entity_name_master.error = false, state.entity_name_master.loading = true;
  }), _defineProperty(_extraReducers$q, ENTITYNAMEMASTER.rejected, function (state, action) {
    state.entity_name_master.loading = false, state.entity_name_master.error = true, state.entity_name_master = action.payload;
  }), _defineProperty(_extraReducers$q, ENTITYTYPEMASTER.fulfilled, function (state, action) {
    state.entity_type_master.loading = false, state.entity_type_master.error = false, state.entity_type_master = action.payload;
  }), _defineProperty(_extraReducers$q, ENTITYTYPEMASTER.pending, function (state, action) {
    state.entity_type_master.loading = true, state.entity_type_master.error = false, state.entity_type_master.loading = true;
  }), _defineProperty(_extraReducers$q, ENTITYTYPEMASTER.rejected, function (state, action) {
    state.entity_type_master.loading = false, state.entity_type_master.error = true, state.entity_type_master = action.payload;
  }), _defineProperty(_extraReducers$q, GENDERMASTER.fulfilled, function (state, action) {
    state.gender_master.loading = false, state.gender_master.error = false, state.gender_master = action.payload;
  }), _defineProperty(_extraReducers$q, GENDERMASTER.pending, function (state, action) {
    state.gender_master.loading = true, state.gender_master.error = false, state.gender_master.loading = true;
  }), _defineProperty(_extraReducers$q, GENDERMASTER.rejected, function (state, action) {
    state.gender_master.loading = false, state.gender_master.error = true, state.gender_master = action.payload;
  }), _defineProperty(_extraReducers$q, IDTYPEMASTER.fulfilled, function (state, action) {
    state.id_type_master.loading = false, state.id_type_master.error = false, state.id_type_master = action.payload;
  }), _defineProperty(_extraReducers$q, IDTYPEMASTER.pending, function (state, action) {
    state.id_type_master.loading = true, state.id_type_master.error = false, state.id_type_master.loading = true;
  }), _defineProperty(_extraReducers$q, IDTYPEMASTER.rejected, function (state, action) {
    state.id_type_master.loading = false, state.id_type_master.error = true, state.id_type_master = action.payload;
  }), _defineProperty(_extraReducers$q, PREFIXMASTER.fulfilled, function (state, action) {
    state.prefix_master.loading = false, state.prefix_master.error = false, state.prefix_master = action.payload;
  }), _defineProperty(_extraReducers$q, PREFIXMASTER.pending, function (state, action) {
    state.prefix_master.loading = true, state.prefix_master.error = false, state.prefix_master.loading = true;
  }), _defineProperty(_extraReducers$q, PREFIXMASTER.rejected, function (state, action) {
    state.prefix_master.loading = false, state.prefix_master.error = true, state.prefix_master = action.payload;
  }), _defineProperty(_extraReducers$q, PRIORITYMASTER.fulfilled, function (state, action) {
    state.priority_master.loading = false, state.priority_master.error = false, state.priority_master = action.payload;
  }), _defineProperty(_extraReducers$q, PRIORITYMASTER.pending, function (state, action) {
    state.priority_master.loading = true, state.priority_master.error = false, state.priority_master.loading = true;
  }), _defineProperty(_extraReducers$q, PRIORITYMASTER.rejected, function (state, action) {
    state.priority_master.loading = false, state.priority_master.error = true, state.priority_master = action.payload;
  }), _defineProperty(_extraReducers$q, SURFFIXMASTER.fulfilled, function (state, action) {
    state.surffix_master.loading = false, state.surffix_master.error = false, state.surffix_master = action.payload;
  }), _defineProperty(_extraReducers$q, SURFFIXMASTER.pending, function (state, action) {
    state.surffix_master.loading = true, state.surffix_master.error = false, state.surffix_master.loading = true;
  }), _defineProperty(_extraReducers$q, SURFFIXMASTER.rejected, function (state, action) {
    state.surffix_master.loading = false, state.surffix_master.error = true, state.surffix_master = action.payload;
  }), _defineProperty(_extraReducers$q, USEMASTER.fulfilled, function (state, action) {
    state.use_master.loading = false, state.use_master.error = false, state.use_master = action.payload;
  }), _defineProperty(_extraReducers$q, USEMASTER.pending, function (state, action) {
    state.use_master.loading = true, state.use_master.error = false, state.use_master.loading = true;
  }), _defineProperty(_extraReducers$q, USEMASTER.rejected, function (state, action) {
    state.use_master.loading = false, state.use_master.error = true, state.use_master = action.payload;
  }), _defineProperty(_extraReducers$q, SINGLE_PERSON_READ.fulfilled, function (state, action) {
    state.single_read_person.loading = false, state.single_read_person.error = false, state.single_read_person = action.payload;
  }), _defineProperty(_extraReducers$q, SINGLE_PERSON_READ.pending, function (state, action) {
    state.single_read_person.loading = true, state.single_read_person.error = false, state.single_read_person.loading = true;
  }), _defineProperty(_extraReducers$q, SINGLE_PERSON_READ.rejected, function (state, action) {
    state.single_read_person.loading = false, state.single_read_person.error = true, state.single_read_person = action.payload;
  }), _extraReducers$q)
});
var personActions = {
  PERSON_READ: PERSON_READ,
  PERSON_DELETE: PERSON_DELETE,
  PERSON_UPSERT: PERSON_UPSERT,
  CONTACTSYSTEMMASTER: CONTACTSYSTEMMASTER,
  ENTITYNAMEMASTER: ENTITYNAMEMASTER,
  ENTITYTYPEMASTER: ENTITYTYPEMASTER,
  GENDERMASTER: GENDERMASTER,
  IDTYPEMASTER: IDTYPEMASTER,
  PREFIXMASTER: PREFIXMASTER,
  PRIORITYMASTER: PRIORITYMASTER,
  SURFFIXMASTER: SURFFIXMASTER,
  USEMASTER: USEMASTER,
  SINGLE_PERSON_READ: SINGLE_PERSON_READ
};
var personSlice$1 = personSlice.reducer;

var queries$a = {
  user_read: function user_read(data) {
    var filter = {};
    return _objectSpread2(_objectSpread2({
      "db_name": dbName,
      "entity": "Practitioner"
    }, filter), {}, {
      "return_fields": "{Practitioner}"
    });
  },
  user_delete: function user_delete(data) {
    var filter = {};

    if (data._id) {
      filter = {
        filter: {
          _id: data._id
        }
      };
    }

    return [_objectSpread2({
      "db_name": dbName,
      "entity": "Practitioner",
      // "is_metadata": true,
      "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, filter)];
  },
  user_upsert: function user_upsert(data) {
    var filter = {};

    if (data._key) {
      filter = {
        filter: {
          _key: data._key
        }
      };
    }

    return [_objectSpread2(_objectSpread2({
      "db_name": dbName,
      "entity": "Practitioner",
      "is_metadata": true,
      "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, filter), {}, {
      "doc": _objectSpread2({}, data)
    })];
  },
  practitioner_by_id: function practitioner_by_id(data) {
    return {
      "db_name": dbName,
      "entity": "Practitioner",
      "filter": "Practitioner.PersonID==".concat(data.id, " && Practitioner.activestatus==true"),
      "return_fields": "merge(Practitioner,{identifier:(for doc in IdentifierMaster filter doc._id in Practitioner.identifier return merge(doc,{period:(for cod in doc.period return document(cod))})),address:(for a in Practitioner.address return document(a)),communication:( FOR cod IN CodeableConceptMaster filter cod._id in Practitioner.communication RETURN MERGE(cod,{coding:(FOR d IN cod.coding RETURN DOCUMENT(d))})),marital_status:(FOR cod IN CodeableConceptMaster filter cod._id==Practitioner.marital_status RETURN MERGE(cod,{coding:(FOR d IN cod.coding RETURN DOCUMENT(d))})),name:(for a in Practitioner.name return MERGE(document(a),{period:DOCUMENT(document(a).period)})),nationality:(FOR cod IN SMGeographicMaster filter cod._id==Practitioner.nationality RETURN cod),photo:(for a in Practitioner.photo return document(a)),position:(for pt in CodeableConceptMaster filter pt._id==Practitioner.position return merge(pt,{coding:(FOR d IN pt.coding RETURN DOCUMENT(d))})),practitioner_type:(for pt in CodeableConceptMaster filter pt._id==Practitioner.practitioner_type return merge(pt,{coding:(FOR d IN pt.coding RETURN DOCUMENT(d))})),telecom:(for a in Practitioner.telecom return document(a)),job_experience:(for c in Practitioner.job_experience RETURN merge(c,{jobexperience_contact_details:(for con in c.jobexperience_contact_details return document(con)), jobexperience_address:(for add in c.jobexperience_address return document(add))})),training_details:(for c in Practitioner.training_details RETURN merge(c,{training_contact_details:(for con in c.training_contact_details return document(con)), training_address:(for add in c.training_address return document(add))})),practitioner_role:(for doc in PractitionerRole filter doc._id IN Practitioner.practitioner_role return MERGE(doc,{telecom:(for rol in ContactPointMaster filter rol._id in doc.telecom return rol),role:(for cod in CodeableConceptMaster filter cod._id==doc.role return merge(cod,{coding:(for code in CodingMaster filter code._id in cod.coding return code)})),period:(for per in periodMaster filter per._id in doc.period return per)})),gender:(FOR cod IN CodeableConceptMaster filter cod._id==Practitioner.gender RETURN MERGE(cod,{coding:(FOR d IN cod.coding RETURN DOCUMENT(d))})),employee_status:(for pt in CodeableConceptMaster filter pt._id==Practitioner.employee_status return merge(pt,{coding:(FOR d IN pt.coding RETURN DOCUMENT(d))}))})"
    };
  }
};

var _extraReducers$p;
var USER_UPSERT = toolkit.createAsyncThunk("userSlice/user_upsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      params,
      queriesjson,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          params = _objectSpread2({
            _key: payload._key
          }, payload);
          queriesjson = queries$a.user_upsert(params);
          _context.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            _key: data._key,
            data: data
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var USER_DELETE = toolkit.createAsyncThunk("userSlice/user_delete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      params,
      queriesjson,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          params = _objectSpread2({
            _id: payload._id
          }, payload);
          queriesjson = queries$a.user_delete(params);
          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __deleteUrl__);

        case 7:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var USER_READ = toolkit.createAsyncThunk("userSlice/user_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      readqueries,
      data,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          readqueries = queries$a.practitioner_by_id(payload);
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(readqueries)
          }, __readDocumentUrl__);

        case 6:
          data = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context3.t0.message
          })));

        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 10]]);
})));
var userSlice = toolkit.createSlice({
  name: "userSlice",
  initialState: {
    user_upsert: _objectSpread2({}, defaultState.List),
    user_delete: _objectSpread2({}, defaultState.List),
    user_read: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$p = {}, _defineProperty(_extraReducers$p, USER_UPSERT.fulfilled, function (state, action) {
    state.user_upsert.loading = false, state.user_upsert.error = false, state.user_upsert = action.payload;
  }), _defineProperty(_extraReducers$p, USER_UPSERT.pending, function (state, action) {
    state.user_upsert.loading = true, state.user_upsert.error = false, state.user_upsert.loading = true;
  }), _defineProperty(_extraReducers$p, USER_UPSERT.rejected, function (state, action) {
    state.user_upsert.loading = false, state.user_upsert.error = true, state.user_upsert = action.payload;
  }), _defineProperty(_extraReducers$p, USER_DELETE.fulfilled, function (state, action) {
    state.user_delete.loading = false, state.user_delete.error = false, state.user_delete = action.payload;
  }), _defineProperty(_extraReducers$p, USER_DELETE.pending, function (state, action) {
    state.user_delete.loading = true, state.user_delete.error = false, state.user_delete.loading = true;
  }), _defineProperty(_extraReducers$p, USER_DELETE.rejected, function (state, action) {
    state.user_delete.loading = false, state.user_delete.error = true, state.user_delete = action.payload;
  }), _defineProperty(_extraReducers$p, USER_READ.fulfilled, function (state, action) {
    state.user_read.loading = false, state.user_read.error = false, state.user_read = action.payload;
  }), _defineProperty(_extraReducers$p, USER_READ.pending, function (state, action) {
    state.user_read.loading = true, state.user_read.error = false, state.user_read.loading = true;
  }), _defineProperty(_extraReducers$p, USER_READ.rejected, function (state, action) {
    state.user_read.loading = false, state.user_read.error = true, state.user_read = action.payload;
  }), _extraReducers$p)
});
var userActions = {
  USER_READ: USER_READ,
  USER_DELETE: USER_DELETE,
  USER_UPSERT: USER_UPSERT
};
var userSlice$1 = userSlice.reducer;

var queries$9 = {
  rolelist: function rolelist(type) {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      filter: "CodeableConceptMaster.Type=='".concat(type, "'"),
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})",
      sort: "CodeableConceptMaster.createddate"
    };
  },
  upsert: function upsert(data) {
    var filter = {};
    var _key = {};

    if (data._key) {
      filter = {
        filter: {
          _key: data._key
        }
      };
    }

    if (data !== null && data !== void 0 && data.coding_key) {
      _key = {
        _key: data === null || data === void 0 ? void 0 : data.coding_key
      };
    }

    if (data.id) {
      ({
        id: data.id
      });
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "CodeableConceptMaster",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, filter), {}, {
      doc: {
        text: "",
        _id: "",
        id: 0,
        coding: [_objectSpread2({
          system: "",
          version: "1",
          code: data.code,
          display: data.description,
          userSelected: true,
          Type: data.type,
          id: data.id,
          status: data.status
        }, _key)],
        Type: data.type,
        status: data.status
      }
    })];
  },
  practitioner_by_id: function practitioner_by_id(id) {
    return {
      db_name: dbName,
      entity: "Practitioner",
      filter: "Practitioner._key=='".concat(id, "' && Practitioner.activestatus==true"),
      return_fields: "merge(Practitioner,{identifier:(for doc in IdentifierMaster filter doc._id in Practitioner.identifier return merge(doc,{period:(for cod in doc.period return document(cod))})),address:(for a in Practitioner.address return document(a)),communication:( FOR cod IN CodeableConceptMaster filter cod._id in Practitioner.communication RETURN MERGE(cod,{coding:(FOR d IN cod.coding RETURN DOCUMENT(d))})),marital_status:(FOR cod IN CodeableConceptMaster filter cod._id==Practitioner.marital_status RETURN MERGE(cod,{coding:(FOR d IN cod.coding RETURN DOCUMENT(d))})),name:(for a in Practitioner.name return document(a)),nationality:(FOR cod IN SMGeographicMaster filter cod._id==Practitioner.nationality RETURN cod),photo:(for a in Practitioner.photo return document(a)),position:(for pt in CodeableConceptMaster filter pt._id==Practitioner.position return merge(pt,{coding:(FOR d IN pt.coding RETURN DOCUMENT(d))})),practitioner_type:(for pt in CodeableConceptMaster filter pt._id==Practitioner.practitioner_type return merge(pt,{coding:(FOR d IN pt.coding RETURN DOCUMENT(d))})),telecom:(for a in Practitioner.telecom return document(a)),job_experience:(for c in Practitioner.job_experience RETURN merge(c,{jobexperience_contact_details:(for con in c.jobexperience_contact_details return document(con)), jobexperience_address:(for add in c.jobexperience_address return document(add))})),training_details:(for c in Practitioner.training_details RETURN merge(c,{training_contact_details:(for con in c.training_contact_details return document(con)), training_address:(for add in c.training_address return document(add))})),practitioner_role:(for doc in PractitionerRole filter doc._id IN Practitioner.practitioner_role return MERGE(doc,{telecom:(for rol in ContactPointMaster filter rol._id in doc.telecom return rol),role:(for cod in CodeableConceptMaster filter cod._id==doc.role return merge(cod,{coding:(for code in CodingMaster filter code._id in cod.coding return code)})),period:(for per in periodMaster filter per._id in doc.period return per)})),gender:(FOR cod IN CodeableConceptMaster filter cod._id==Practitioner.gender RETURN MERGE(cod,{coding:(FOR d IN cod.coding RETURN DOCUMENT(d))})),employee_status:(for pt in CodeableConceptMaster filter pt._id==Practitioner.employee_status return merge(pt,{coding:(FOR d IN pt.coding RETURN DOCUMENT(d))}))})"
    };
  },
  practitioner_list: function practitioner_list() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var search = arguments.length > 2 ? arguments[2] : undefined;
    return {
      db_name: dbName,
      entity: "Practitioner",
      // sort : "Practitioner.createddate",
      "sort": "Practitioner.updatedate desc",
      filter: "(like(document(first(Practitioner.name)).text,'%".concat(search, "%',true) || like(document(first(document(Practitioner.practitioner_type).coding)).display,'%").concat(search, "%',true) || like(document(document(document(Practitioner.practitioner_role[0]).SpecialtyID).coding[0]).display,'%").concat(search, "%',true)) && Practitioner.activestatus==true"),
      limit: {
        "offset": page,
        "count": perPage
      },
      return_fields: "{TotalCount:COUNT(FOR cnt IN Practitioner RETURN cnt._key),PersonID:Practitioner.PersonID,_id:Practitioner._id, id:Practitioner.id,name:(FOR nam IN TO_ARRAY(Practitioner.name) RETURN DOCUMENT(nam).text)[0],type: (for t in CodeableConceptMaster filter t._id == Practitioner.practitioner_type return merge(t,{coding:(for cod in CodingMaster filter cod._id in t.coding return cod.display)})),_key:Practitioner._key,status:Practitioner.status,Practitionerrole:(for pr in PractitionerRole filter pr._id in Practitioner.practitioner_role && pr.primary_specialty==true return merge(pr,{SpecialtyID:(for spe in CodeableConceptMaster filter spe._id ==pr.SpecialtyID return merge(spe,{coding:(for cod in CodingMaster filter cod._id in spe.coding return cod.display)}))}))}"
    };
  },
  status_update_practitioner: function status_update_practitioner(data) {
    return [{
      db_name: dbName,
      entity: "Practitioner",
      filter: {
        _key: data._key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        status: data.status
      }
    }];
  },
  get_entity_by_id: function get_entity_by_id(id) {
    return {
      "db_name": dbName,
      "entity": "Organization",
      "sort": "Organization.name",
      "filter": "Organization.activestatus==true && Organization.OrgType any =='".concat(id, "'"),
      "return_fields": "{_id:Organization._id,_key:Organization._key,id:Organization.id,name:Organization.name,alias:Organization.alias}"
    };
  }
};

var contactList = function contactList(data) {
  var contactLists = [];

  if (data && data.length > 0) {
    data.map(function (val) {
      var contactData = {
        // "_id": "string",
        "system": val.mode ? val.mode.value : "",
        "value": val.mobile ? val.mobile : "",
        "use": val.use ? val.use.value : "",
        "rank": val.priority ? val.priority.value : "",
        "valueprefix": val.country_code ? val.country_code.value : "",
        "period": [{
          // "_id": "string",
          "start": getUtcTime(),
          "end": getUtcTime(moment__default["default"]().endOf('day')) // "id": "number"

        }] // "id": "number"

      };
      contactLists.push(contactData);
    });
  }

  return contactLists;
}; // Address list


var addresslist = function addresslist(data) {
  var addLists = [];

  if (data && data.length > 0) {
    data.map(function (val) {
      var _val$pincode, _val$pincode2;

      var addressData = {
        // "_id": "string",
        "use": val.use ? val.use.value : '',
        "text": val.addressLine1 ? val.addressLine1 : "",
        "line": val.addressLine2 ? val.addressLine2 : "",
        "city": val.city ? val.city.value : '',
        "district": val.district ? val.district.value : "",
        "state": val.state ? val.state.value : "",
        "postalCode": (_val$pincode = val.pincode) !== null && _val$pincode !== void 0 && _val$pincode._id ? (_val$pincode2 = val.pincode) === null || _val$pincode2 === void 0 ? void 0 : _val$pincode2._id : "",
        "country": val.country ? val.country.value : "",
        "latitude": "",
        "longitude": "",
        'Type': val.type ? val.type.value : ""
      };
      addLists.push(addressData);
    });
  }

  return addLists;
};

var generateJSON$1 = function generateJSON(data, _key, person_id, ID) {
  //person id
  var personId = {};

  if (person_id >= 0) {
    personId = {
      "PersonID": person_id
    };
  } //  filter to update the practitioner


  var filter = {};

  if (_key) {
    filter = {
      "filter": {
        "_id": _key
      }
    };
  }

  var id = {};

  if (ID >= 0) {
    id = {
      id: ID
    };
  } // PRACTITIONER IDENTIFICATION

  if (data.identification && data.identification.length > 0) {
    data.identification.map(function (val) {
      // var given = moment(val.expiry_date, "YYYY-MM-DD");
      // var current = moment().startOf('day');
      // var expiry_day = moment.duration(given.diff(current)).asDays();
      ({
        "IDType": val.id_type.value ? val.id_type.value : "",
        "IDNumber": val.id_number ? val.id_number : "",
        "ExpiryDate": val.expiry_date ? getUtcTime(moment__default["default"](val.expiry_date)) : null // doc
        // "files": val.doc ? val.doc : []

      });
    });
  }

  var identifierList = [];

  if (data.identification && data.identification.length > 0) {
    data.identification.map(function (val) {
      var data = {
        // "_id": "string",
        "user": val.id_type.value ? val.id_type.value : "",
        "system": "",
        "value": val.id_number ? val.id_number : "",
        "files": val.doc ? val.doc : [],
        "period": [{
          // "_id": "string",
          "start": getUtcTime(),
          "end": val.expiry_date ? getUtcTime(moment__default["default"](val.expiry_date)) : null // "id": "number"

        }] // "assigner": "string",
        // "Type": "string",
        // "id": "number",

      };
      identifierList.push(data);
    });
  } // PRACTITIONER DETAILS


  var names = [];

  if (data.names && data.names.length > 0) {
    data.names.map(function (val) {
      var nameData = {
        // "_id": "string",
        "use": val.use ? val.use.value : "",
        "text": val.first_name ? val.first_name : "",
        "family": val.last_name ? val.last_name : "",
        "given": val.middle_name ? val.middle_name : "",
        "prefix": val.prefix ? val.prefix.value : "",
        "suffix": val.suffix ? val.suffix.value : "",
        "period": [{
          // "_id": "",
          "start": getUtcTime(),
          "end": getUtcTime(moment__default["default"]().endOf('day')) // "id": "number"

        }]
      };
      names.push(nameData);
    });
  } // Practitioner Description


  var languagesList = [];

  if (data.practitioner_description && data.practitioner_description.communication_languages && data.practitioner_description.communication_languages.length > 0) {
    languagesList = data.practitioner_description.communication_languages.map(function (val) {
      return val.value;
    });
  } // CONTACT DETAILS
  // contact list


  var contact = [];

  if (data.contact && data.contact.length > 0) {
    data.contact.map(function (val) {
      var contactData = {
        // "_id": "string",
        "system": val.mode ? val.mode.value : "",
        "value": val.mobile ? val.mobile : "",
        "use": val.use ? val.use.value : "",
        "rank": val.priority ? val.priority.value : "",
        "valueprefix": val.country_code ? val.country_code.value : "",
        "period": [{
          // "_id": "string",
          "start": getUtcTime(),
          "end": getUtcTime(moment__default["default"]().endOf('day')) // "id": "number"

        }] // "id": "number"

      };
      contact.push(contactData);
    });
  }

  var practitioner_list = [];

  if (data.practitionerbyrole && data.practitionerbyrole.length > 0) {
    data.practitionerbyrole.map(function (val) {
      var key = {};
      var roleId = {};

      if (val !== null && val !== void 0 && val._key) {
        key = {
          _key: val === null || val === void 0 ? void 0 : val._key
        };
      } else {
        roleId = {
          id: 0
        };
      }

      var practitionerData = _objectSpread2(_objectSpread2({
        role: val.select_role ? val.select_role.value : "",
        active: val.status ? val.status : false,
        // "EntityName": val.entity_name ? val.entity_name.value : "",
        period: [{
          // "_id": "string",
          start: val.start_date ? getUtcTime(moment__default["default"](val.start_date)) : null,
          end: val.end_date ? getUtcTime(moment__default["default"](val.end_date)) : null // "id": "number"

        }],
        SpecialtyID: val.speciality ? val.speciality.value : "",
        EntityType: val.select_entity ? val.select_entity._id : "",
        OrgID: val.entity_name ? "".concat(val.entity_name.value) : "",
        EntityName: val.entity_name ? "".concat(val.entity_name.value) : "",
        locationID: val.select_location ? val.select_location.value : "",
        primary_specialty: val.primary_specialty ? val.primary_specialty : false,
        telecom: contactList(val.contact),
        files: val.doc ? val.doc : []
      }, roleId), key);

      practitioner_list.push(practitionerData);
    });
  } // Address


  var addressList = [];

  if (data.address && data.address.length > 0) {
    data.address.map(function (val) {
      var _val$pincode3, _val$pincode4;

      var addressData = {
        // "_id": "string",
        "use": val.use ? val.use.value : '',
        "text": val.addressLine1 ? val.addressLine1 : "",
        "line": val.addressLine2 ? val.addressLine2 : "",
        "city": val.city ? val.city.value : '',
        "district": val.district ? val.district.value : "",
        "state": val.state ? val.state.value : "",
        "postalCode": (_val$pincode3 = val.pincode) !== null && _val$pincode3 !== void 0 && _val$pincode3._id ? (_val$pincode4 = val.pincode) === null || _val$pincode4 === void 0 ? void 0 : _val$pincode4._id : "",
        "country": val.country ? val.country.value : "",
        "latitude": "",
        "longitude": "",
        'Type': val.type ? val.type.value : ""
      };
      addressList.push(addressData);
    }); // return addressList;
  } // Qualification


  var qualification_list = [];

  if (data.qualification && data.qualification.length > 0) {
    data.qualification.map(function (val) {
      var qualificationData = {
        "name": val.name ? val.name : "",
        "university_board": val.qualification_name ? val.qualification_name : "",
        "issue_date": val.issued_by ? getUtcTime(moment__default["default"](val.issued_by)) : null,
        "valid_from": val.start_date ? getUtcTime(moment__default["default"](val.start_date)) : null,
        "valid_to": val.end_date ? getUtcTime(moment__default["default"](val.end_date)) : null,
        "files": val.doc ? val.doc : []
      };
      qualification_list.push(qualificationData);
    }); // return qualification_list;
  } // Publication


  var publication_list = [];

  if (data.publication && data.publication.length > 0) {
    data.publication.map(function (val) {
      var publicationData = {
        "description": val.description ? val.description : "",
        "link": val.link ? val.link : ""
      };
      publication_list.push(publicationData);
    }); // return publication_list;
  } // Training


  var training_list = [];

  if (data.training && data.training.length > 0) {
    data.training.map(function (val) {
      var trainingData = {
        "organization": val.organization ? val.organization : "",
        "course_name": val.course_name ? val.course_name : "",
        "responsible_person": val.responsible_person ? val.responsible_person : "",
        "course_start_date": val.course_start_date ? getUtcTime(moment__default["default"](val.course_start_date)) : null,
        "course_end_date": val.course_end_date ? getUtcTime(moment__default["default"](val.course_end_date)) : null,
        "certificate_issued_date": val.certificate_issue_date ? getUtcTime(moment__default["default"](val.certificate_issue_date)) : null,
        "certificate_expiry_date": val.certificate_expiry_date ? getUtcTime(moment__default["default"](val.certificate_expiry_date)) : null,
        "files": val.doc ? val.doc : [],
        "training_contact_details": contactList(val.contact),
        "training_address": addresslist(val.address)
      };
      training_list.push(trainingData);
    }); // return training_list;
  } // Job Experience


  var job_experience_list = [];

  if (data.job && data.job.length > 0) {
    data.job.map(function (val) {
      var jsobData = {
        "organization": val.organization ? val.organization : "",
        "department": val.department ? val.department : "",
        "designation": val.designation ? val.designation : "",
        "role": val.role ? val.role : "",
        "start_date": val.start_date ? getUtcTime(moment__default["default"](val.start_date)) : null,
        "end_date": val.end_date ? getUtcTime(moment__default["default"](val.end_date)) : null,
        "report_to": val.reporting_to ? val.reporting_to : "",
        "grade": val.grade ? val.grade : "",
        "pay_scale": val.pay_scale ? val.pay_scale : "",
        "job_description": val.job_description ? val.job_description : "",
        "files": val.doc ? val.doc : [],
        "sequence_no": val.sequence_no ? val.sequence_no : "",
        "jobexperience_contact_details": contactList(val.contact),
        "jobexperience_address": addresslist(val.address)
      };
      job_experience_list.push(jsobData);
    }); // return job_experience_list;
  } // Acheivement/Awards


  var awardsList = [];

  if (data.awards && data.awards.length > 0) {
    data.awards.map(function (val) {
      var awardsData = {
        "organization": val.organization ? val.organization : "",
        "type": val.type ? val.type : "",
        "title": val.title ? val.title : "",
        "note": val.notes ? val.notes : "",
        "date": val.date ? getUtcTime(moment__default["default"](val.date)) : null,
        "files": val.doc ? val.doc : []
      };
      awardsList.push(awardsData);
    }); // return awardsList;
  }

  var json = [_objectSpread2(_objectSpread2({
    "db_name": dbName,
    "entity": "Practitioner",
    "is_metadata": true,
    "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd"
  }, filter), {}, {
    "doc": _objectSpread2(_objectSpread2({}, id), {}, {
      "identifier": identifierList,
      "name": names,
      "gender": data.details.gender ? data.details.gender._id : "",
      "birthDate": data.details.dob ? moment__default["default"](data.details.dob).unix() : null,
      "marital_status": data.details.marital_status ? data.details.marital_status.value : "",
      "status": data.details.status ? data.details.status : false,
      "nationality": data.details.nationality ? data.details.nationality.value : "",
      "active": true,
      // practitioner_description
      "practitioner_type": data.practitioner_description.practitioner_type ? data.practitioner_description.practitioner_type.value : "",
      "position": data.practitioner_description.position ? data.practitioner_description.position.value : "",
      "employee_status": data.practitioner_description.employee_type ? data.practitioner_description.employee_type.value : "",
      "communication": languagesList,
      // "practitioner_description": [
      //   {
      //     "communication_languages": languagesList,
      //   }
      // ],
      "telecom": contact,
      "practitioner_role": practitioner_list,
      "address": addressList,
      "qualification": qualification_list,
      "job_experience": job_experience_list,
      "achievements_awards_details": awardsList,
      "training_details": training_list,
      "publication_details": publication_list,
      "biography": [{
        "biography_description": data.details.biography_description ? data.details.biography_description : ""
      }],
      "photo": [{
        // "_id": "string",
        "date": "",
        "url": "",
        // "id": "number",
        "fileName": data.details.photo && data.details.photo.fileName ? data.details.photo.fileName : "",
        "fileid": data.details.photo && data.details.photo.fileid ? data.details.photo.fileid : "",
        "filetype": data.details.photo && data.details.photo.filetype ? data.details.photo.filetype : "",
        "objectid": data.details.photo && data.details.photo.objectid ? data.details.photo.objectid : ""
      }],
      "practitioner_id": data.details.practitoner_id ? data.details.practitoner_id : ""
    }, personId)
  })];
  return json;
};

var _extraReducers$o;
var PRACTITIONER_ROLE_READ = toolkit.createAsyncThunk("practitionerSlice/practitionerlist", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      type,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          type = payload.type;
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(queries$9.rolelist(type))
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          arry = [];
          data.result.map(function (val) {
            if (val.coding[0] && val.coding[0].code && val.coding[0].display) {
              var _val$coding$0$_key;

              arry.push({
                "code_type": val.coding[0].code,
                "description": val.coding[0].display,
                "coding_key": (_val$coding$0$_key = val.coding[0]._key) !== null && _val$coding$0$_key !== void 0 ? _val$coding$0$_key : null,
                "id": val.coding[0].id,
                "_key": val._key,
                'status': val.status,
                "activestatus": val.coding[0].activestatus
              });
            }
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 12]]);
})));
var PRACTITIONER_ROLE_UPSERT = toolkit.createAsyncThunk("practitionerSlice/practitionerRoleAdd", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      upsertkey,
      queriesjson,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          upsertkey = {
            code: payload.code,
            description: payload.description,
            type: payload.type,
            status: payload.status,
            _key: payload._key,
            id: payload.id,
            coding_key: payload.coding_key
          };
          queriesjson = queries$9.upsert(upsertkey);
          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var PRACTITIONER_LIST_READ = toolkit.createAsyncThunk("practitionerSlice/practitioner", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      data,
      arry,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          _context3.next = 5;
          return fetchData({
            body: JSON.stringify(queries$9.practitioner_list(payload === null || payload === void 0 ? void 0 : payload.page, payload === null || payload === void 0 ? void 0 : payload.perPage, payload !== null && payload !== void 0 && payload.search ? payload === null || payload === void 0 ? void 0 : payload.search : ''))
          }, __readDocumentUrl__);

        case 5:
          data = _context3.sent;
          arry = [];
          data.result.map(function (val) {
            // if(val.name){
            arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
              "total_count": val === null || val === void 0 ? void 0 : val.TotalCount,
              "name": val.name ? val.name : "-",
              "primaryspeciality": val.Practitionerrole[0] && val.Practitionerrole[0].SpecialtyID[0] ? val.Practitionerrole[0].SpecialtyID[0].coding.join() : "-",
              "type": val.type[0] ? val.type[0].coding.join() : "-",
              "_key": val._key,
              'status': val.status
            })); // }
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 11]]);
})));
var PRACTITIONER_UPSERT = toolkit.createAsyncThunk("practitionerSlice/practitionerAdd", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      data,
      _key,
      personId,
      ID,
      queriesjson,
      dataRes,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          data = payload.data, _key = payload._key, personId = payload.personId, ID = payload.ID;
          queriesjson = generateJSON$1(data, _key, personId, ID);
          _context4.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __upsertPractitioner__);

        case 7:
          dataRes = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: dataRes
          }));

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 11]]);
})));
var PRACTITIONER_STATUS_CHANGE = toolkit.createAsyncThunk("practitionerSlice/practitionerStatus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      statuschange,
      queriesjson,
      data,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          statuschange = {
            _key: payload._key,
            status: payload.status
          };
          queriesjson = queries$9.status_update_practitioner(statuschange);
          _context5.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 11]]);
})));
var GET_ENTITY_BY_ID = toolkit.createAsyncThunk("practitionerSlice/get_entity_id", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref12,
      rejectWithValue,
      id,
      data,
      arry,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          id = payload.id;
          _context6.next = 6;
          return fetchData({
            body: JSON.stringify(queries$9.get_entity_by_id(id))
          }, __readDocumentUrl__);

        case 6:
          data = _context6.sent;
          arry = [];
          data.result.map(function (value) {
            var _value$name, _value$_id;

            arry.push(_objectSpread2({
              label: (_value$name = value === null || value === void 0 ? void 0 : value.name) !== null && _value$name !== void 0 ? _value$name : "",
              value: (_value$_id = value === null || value === void 0 ? void 0 : value._id) !== null && _value$_id !== void 0 ? _value$_id : ""
            }, value));
          });
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 15:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 12]]);
})));
var practitionerSlice = toolkit.createSlice({
  name: "practitionerApiSlice",
  initialState: {
    practitioner_role_list: _objectSpread2({}, defaultState.List),
    practitioner_role_upsert: _objectSpread2({}, defaultState.List),
    practitioner_list: _objectSpread2({}, defaultState.List),
    practitioner_upsert: _objectSpread2({}, defaultState.List),
    practitioner_status_update: _objectSpread2({}, defaultState.List),
    get_entity_by_id: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$o = {}, _defineProperty(_extraReducers$o, PRACTITIONER_ROLE_READ.fulfilled, function (state, action) {
    state.practitioner_role_list.loading = false, state.practitioner_role_list.error = false, state.practitioner_role_list = action.payload;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_ROLE_READ.pending, function (state, action) {
    state.practitioner_role_list.loading = true, state.practitioner_role_list.error = false, state.practitioner_role_list.loading = true;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_ROLE_READ.rejected, function (state, action) {
    state.practitioner_role_list.loading = false, state.practitioner_role_list.error = true, state.practitioner_role_list = action.payload;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_ROLE_UPSERT.fulfilled, function (state, action) {
    state.practitioner_role_upsert.loading = false, state.practitioner_role_upsert.error = false, state.practitioner_role_upsert = action.payload;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_ROLE_UPSERT.pending, function (state, action) {
    state.practitioner_role_upsert.loading = true, state.practitioner_role_upsert.error = false, state.practitioner_role_upsert.loading = true;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_ROLE_UPSERT.rejected, function (state, action) {
    state.practitioner_role_upsert.loading = false, state.practitioner_role_upsert.error = true, state.practitioner_role_upsert = action.payload;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_LIST_READ.fulfilled, function (state, action) {
    state.practitioner_list.loading = false, state.practitioner_list.error = false, state.practitioner_list = action.payload;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_LIST_READ.pending, function (state, action) {
    state.practitioner_list.loading = true, state.practitioner_list.error = false, state.practitioner_list.loading = true;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_LIST_READ.rejected, function (state, action) {
    state.practitioner_list.loading = false, state.practitioner_list.error = true, state.practitioner_list = action.payload;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_UPSERT.fulfilled, function (state, action) {
    state.practitioner_upsert.loading = false, state.practitioner_upsert.error = false, state.practitioner_upsert = action.payload;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_UPSERT.pending, function (state, action) {
    state.practitioner_upsert.loading = true, state.practitioner_upsert.error = false, state.practitioner_upsert.loading = true;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_UPSERT.rejected, function (state, action) {
    state.practitioner_upsert.loading = false, state.practitioner_upsert.error = true, state.practitioner_upsert = action.payload;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_STATUS_CHANGE.fulfilled, function (state, action) {
    state.practitioner_status_update.loading = false, state.practitioner_status_update.error = false, state.practitioner_status_update = action.payload;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_STATUS_CHANGE.pending, function (state, action) {
    state.practitioner_status_update.loading = true, state.practitioner_status_update.error = false, state.practitioner_status_update.loading = true;
  }), _defineProperty(_extraReducers$o, PRACTITIONER_STATUS_CHANGE.rejected, function (state, action) {
    state.practitioner_status_update.loading = false, state.practitioner_status_update.error = true, state.practitioner_status_update = action.payload;
  }), _defineProperty(_extraReducers$o, GET_ENTITY_BY_ID.fulfilled, function (state, action) {
    state.get_entity_by_id.loading = false, state.get_entity_by_id.error = false, state.get_entity_by_id = action.payload;
  }), _defineProperty(_extraReducers$o, GET_ENTITY_BY_ID.pending, function (state, action) {
    state.get_entity_by_id.loading = true, state.get_entity_by_id.error = false, state.get_entity_by_id.loading = true;
  }), _defineProperty(_extraReducers$o, GET_ENTITY_BY_ID.rejected, function (state, action) {
    state.get_entity_by_id.loading = false, state.get_entity_by_id.error = true, state.get_entity_by_id = action.payload;
  }), _extraReducers$o)
});
var practitionerActions$1 = {
  PRACTITIONER_ROLE_READ: PRACTITIONER_ROLE_READ,
  PRACTITIONER_ROLE_UPSERT: PRACTITIONER_ROLE_UPSERT,
  PRACTITIONER_LIST_READ: PRACTITIONER_LIST_READ,
  PRACTITIONER_UPSERT: PRACTITIONER_UPSERT,
  PRACTITIONER_STATUS_CHANGE: PRACTITIONER_STATUS_CHANGE,
  GET_ENTITY_BY_ID: GET_ENTITY_BY_ID
};
var practitionerSlice$1 = practitionerSlice.reducer;

var _masterQuery;
var masterQuery$5 = (_masterQuery = {
  "id_type": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='ALTERNATEIDTYPE' && CodeableConceptMaster.status == true\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  "id_number": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='RELATIONSHIP'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  "prefix": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='NAMEPREFIX'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  "suffix": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n        \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='NAMESUFFIX'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  "gender": "{\n            \"db_name\": \"".concat(dbName, "\",\n            \"entity\": \"CodeableConceptMaster\",\n            \"filter\": \"CodeableConceptMaster.Type=='GENDER' AND DOCUMENT(CodeableConceptMaster.coding)[*].code ANY != 'ANY' AND DOCUMENT(CodeableConceptMaster.coding)[*].status ANY ==true\",\n            \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\",\n            \"sort\": \"document(CodeableConceptMaster.coding[0]).display\"\n    }"),
  "use": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n        \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='USE'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  "practitioner_type": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='PRACTTYPE' && CodeableConceptMaster.status == true\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  "Communication_languages": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='LANGUAGE'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  "speciality": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='SPECIALTY' && CodeableConceptMaster.status==true\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  // "entity": `{
  //     "db_name": "${dbName}",
  //     "entity": "Organization",
  //     "filter": "Organization.OrgType!=[]",
  //     "return_fields": "DISTINCT Organization.OrgType[0]"
  // }`,
  "entity": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='ORGTYPE' AND CodeableConceptMaster.activestatus==true\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN TO_ARRAY(CodeableConceptMaster.coding) RETURN DOCUMENT(cod))})\"\n    }"),
  // "entity_name": `{
  //     "db_name": "${dbName}",
  //     "entity": "Organization",
  //     "filter": "'Hospital' IN Organization.OrgType",
  //     "return_fields": "{OrgID:Organization.id,name:Organization.name}"
  // }`,
  "entity_name": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"Organization\",\n        \"filter\": \"Organization.activestatus==true\",\n        \"return_fields\": \"{_id:Organization._id,_key:Organization._key,id:Organization.id,name:Organization.name,alias:Organization.alias}\"\n    }"),
  "Address_use": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='USE'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  "contact_mode": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='CONTACTSYSTEM'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  "priority": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='PRIORITY'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  "address_type": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='ADDRESSTYPE'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  "role": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='PRACTROLE' && CodeableConceptMaster.status == true\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }"),
  "location": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"LocationMaster\",\n        \"sort\":\"LocationMaster.shortdesc\",\n        \"filter\": \"LocationMaster.activestatus==true && lower(LocationMaster.status)=='active'\", \n        \"return_fields\": \"LocationMaster\"\n    }"),
  "city": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"SMGeographicMaster\",\n        \"sort\":\"SMGeographicMaster.geogLevelName\",\n        \"filter\": \"SMGeographicMaster.geogLevelType=='CITY' && SMGeographicMaster.activestatus == true\",\n        \"return_fields\": \"{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode}\"\n    }"),
  "district": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"SMGeographicMaster\",\n         \"sort\":\"SMGeographicMaster.geogLevelName\",\n        \"filter\": \"SMGeographicMaster.geogLevelType=='DISTRICT' && SMGeographicMaster.geogLevelCode=='BLR' && SMGeographicMaster.activestatus == true\",\n        \"return_fields\": \"{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode}\"\n    }"),
  "state": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"SMGeographicMaster\",\n         \"sort\":\"SMGeographicMaster.geogLevelName\",\n        \"filter\": \"SMGeographicMaster.geogLevelType=='STATE' && SMGeographicMaster.geogLevelCode=='KAR' && SMGeographicMaster.activestatus == true\",\n        \"return_fields\": \"{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode}\"\n    }"),
  "country": "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"SMGeographicMaster\",\n         \"sort\":\"SMGeographicMaster.geogLevelName\",\n        \"filter\": \"SMGeographicMaster.geogLevelType=='COUNTRY' && SMGeographicMaster.activestatus == true\",\n        \"return_fields\": \"{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode}\"\n    }")
}, _defineProperty(_masterQuery, "country", "{\n        \"db_name\": \"primarycare\",\n        \"entity\": \"SMGeographicMaster\",\n        \"sort\": \"SMGeographicMaster.geogLevelName\",\n        \"filter\": \"document(SMGeographicMaster.geogLevelType).code=='GE002' && SMGeographicMaster.activestatus == true\",\n        \"return_fields\": \"{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,geogLevelCode:SMGeographicMaster.geogLevelCode,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode}\"\n    }"), _defineProperty(_masterQuery, "position", "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='POSITION' && CodeableConceptMaster.status==true\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }")), _defineProperty(_masterQuery, "employee_type", "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n         \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='EMPSTATUS' && CodeableConceptMaster.status==true\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }")), _defineProperty(_masterQuery, "marital_status", "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n        \"sort\":\"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='MARITALSTATUS' && CodeableConceptMaster.activestatus==true && CodeableConceptMaster.status == true\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n    }")), _defineProperty(_masterQuery, "nationality", "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"SMGeographicMaster\",\n        \"sort\": \"SMGeographicMaster.geogLevelName\",\n        \"filter\": \"lower(document(SMGeographicMaster.geogLevelType).display)=='country' && SMGeographicMaster.activestatus == true && SMGeographicMaster.active== true\",\n        \"return_fields\": \"{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode}\"\n    }")), _defineProperty(_masterQuery, "country_code", "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"SMGeographicMaster\",\n        \"sort\": \"SMGeographicMaster.GeoLocationISDCode\",\n        \"filter\": \"lower(document(SMGeographicMaster.geogLevelType).display)=='country' && SMGeographicMaster.activestatus == true && SMGeographicMaster.active == true\",\n        \"return_fields\": \"{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode,GeoLocationISDCode:SMGeographicMaster.GeoLocationISDCode}\"\n    }")), _masterQuery);
var masterqueries = {
  practitioner_location_rule: function practitioner_location_rule(type) {
    return {
      db_name: dbName,
      entity: "LocationMaster",
      sort: "LocationMaster.shortdesc",
      filter: "LocationMaster.managingOrgID=='".concat(type, "' && LocationMaster.activestatus==true && lower(LocationMaster.status)=='active'"),
      "return_fields": "LocationMaster"
    };
  },
  country: function country() {
    return {
      "db_name": dbName,
      "entity": "SMGeographicMaster",
      "sort": "SMGeographicMaster.geogLevelName",
      "filter": "document(SMGeographicMaster.geogLevelType).code=='GE002' && SMGeographicMaster.activestatus == true",
      "return_fields": "{_id:SMGeographicMaster._id,id:SMGeographicMaster.id,geogLevelName:SMGeographicMaster.geogLevelName,geogLevelCode:SMGeographicMaster.geogLevelCode,parentGeogLevelType:SMGeographicMaster.parentGeogLevelType,parentGeogLevelCode:SMGeographicMaster.parentGeogLevelCode}"
    };
  },
  state_by_country: function state_by_country(geogLevelCode) {
    return {
      "db_name": dbName,
      "entity": "SMGeographicMaster",
      "filter": "SMGeographicMaster.activestatus==true && lower(document(SMGeographicMaster.geogLevelType).display)=='state' && lower(document(SMGeographicMaster.parentGeogLevelCode).geogLevelCode)==lower('".concat(geogLevelCode, "')"),
      "return_fields": "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.activestatus,_key:SMGeographicMaster._key}"
    };
  },
  district_by_state: function district_by_state(geogLevelCode) {
    return {
      "db_name": dbName,
      "entity": "SMGeographicMaster",
      "filter": "SMGeographicMaster.activestatus==true && lower(document(SMGeographicMaster.geogLevelType).display)=='district' && lower(document(SMGeographicMaster.parentGeogLevelCode).geogLevelCode)==lower('".concat(geogLevelCode, "')"),
      "return_fields": "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.activestatus,_key:SMGeographicMaster._key}"
    };
  },
  city_by_district: function city_by_district(geogLevelCode) {
    return {
      "db_name": dbName,
      "entity": "SMGeographicMaster",
      "filter": "SMGeographicMaster.activestatus==true && lower(document(SMGeographicMaster.geogLevelType).display)=='city' && lower(document(SMGeographicMaster.parentGeogLevelCode).geogLevelCode)==lower('".concat(geogLevelCode, "')"),
      "return_fields": "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.activestatus,_key:SMGeographicMaster._key}"
    };
  },
  pincode_by_city: function pincode_by_city(geogLevelCode) {
    return {
      "db_name": dbName,
      "entity": "SMGeographicMaster",
      "filter": "SMGeographicMaster.activestatus==true && lower(document(SMGeographicMaster.geogLevelType).display)=='pincode' && lower(document(SMGeographicMaster.parentGeogLevelCode).geogLevelCode)==lower('".concat(geogLevelCode, "')"),
      "return_fields": "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.activestatus,_key:SMGeographicMaster._key}"
    };
  },
  state_by_country_: function state_by_country_() {
    return {
      "db_name": dbName,
      "entity": "SMGeographicMaster",
      "filter": "SMGeographicMaster.activestatus==true && lower(document(SMGeographicMaster.geogLevelType).display)=='state'",
      "return_fields": "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.activestatus,_key:SMGeographicMaster._key}"
    };
  },
  district_by_state_: function district_by_state_() {
    return {
      "db_name": dbName,
      "entity": "SMGeographicMaster",
      "filter": "SMGeographicMaster.activestatus==true && lower(document(SMGeographicMaster.geogLevelType).display)=='district'",
      "return_fields": "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.activestatus,_key:SMGeographicMaster._key}"
    };
  },
  city_by_district_: function city_by_district_() {
    return {
      "db_name": dbName,
      "entity": "SMGeographicMaster",
      "filter": "SMGeographicMaster.activestatus==true && lower(document(SMGeographicMaster.geogLevelType).display)=='city'",
      "return_fields": "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.activestatus,_key:SMGeographicMaster._key}"
    };
  },
  pincode_by_city_: function pincode_by_city_() {
    return {
      "db_name": dbName,
      "entity": "SMGeographicMaster",
      "filter": "SMGeographicMaster.activestatus==true && lower(document(SMGeographicMaster.geogLevelType).display)=='pincode'",
      "return_fields": "{_id:SMGeographicMaster._id, id:SMGeographicMaster.id, geogLevelType:document(SMGeographicMaster.geogLevelType), geogLevelCode:SMGeographicMaster.geogLevelCode, geogLevelName:SMGeographicMaster.geogLevelName, parentGeogLevelType:document(SMGeographicMaster.parentGeogLevelType), parentGeogLevelCode:document(SMGeographicMaster.parentGeogLevelCode), active: SMGeographicMaster.activestatus,_key:SMGeographicMaster._key}"
    };
  }
};

var getOptionWithMaster = function getOptionWithMaster(data) {
  var getoptions = [];

  if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
    data.map(function (val) {
      getoptions.push(_objectSpread2({
        label: val.coding ? val.coding[0] ? val.coding[0].display : "" : val,
        value: val._id
      }, val));
    });
  }

  return getoptions;
};

var getmasterOprions = function getmasterOprions(key, value, master, valueKey) {
  var list = [];

  if (value && (value === null || value === void 0 ? void 0 : value.length) > 0) {
    list = master[key].filter(function (val) {
      return val[valueKey ? valueKey : "value"] === value;
    }) ? master[key].filter(function (val) {
      return val[valueKey ? valueKey : "value"] === value;
    }) : [];
  }

  return list;
};

var contactListData = function contactListData(data, masters) {
  var list = [];

  if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
    data.map(function (val) {
      var contactData = {
        "mode": getmasterOprions("contact_mode", val.system, masters)[0],
        "mobile": val.value ? val.value : "",
        "use": getmasterOprions("Address_use", val.use, masters)[0],
        "priority": getmasterOprions("priority", "".concat(val.rank), masters)[0],
        "country_code": getmasterOprions("country_code", val.valueprefix, masters)[0]
      };
      list.push(contactData);
    });
  }

  return list;
};

var addressListData = function addressListData(data, masters) {
  var list = [];

  if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
    data.map(function (val) {
      var _val$text, _val$line, _val$postalCode;

      var addresslistData = {
        "use": getmasterOprions("Address_use", val.use, masters)[0],
        "addressLine1": val.text && ((_val$text = val.text) === null || _val$text === void 0 ? void 0 : _val$text.length) > 0 ? val.text : "",
        "addressLine2": val.line && ((_val$line = val.line) === null || _val$line === void 0 ? void 0 : _val$line.length) > 0 ? val.line : "",
        "city": getmasterOprions("city", val.city, masters)[0],
        "district": getmasterOprions("district", val === null || val === void 0 ? void 0 : val.district, masters)[0],
        "state": getmasterOprions("state", val === null || val === void 0 ? void 0 : val.state, masters)[0],
        "pincode": val.postalCode && ((_val$postalCode = val.postalCode) === null || _val$postalCode === void 0 ? void 0 : _val$postalCode.length) > 0 ? val.postalCode : "",
        "country": getmasterOprions("country", val.country, masters)[0],
        "type": getmasterOprions("address_type", val.Type, masters)[0]
      };
      list.push(addresslistData);
    });
  }

  return list;
};

var getGeoData = function getGeoData(id, dropDownData) {
  var obj = {};

  if (id) {
    if (Array.isArray(dropDownData)) {
      //return dropDownData?.filter(val => val?._id === id)
      dropDownData === null || dropDownData === void 0 ? void 0 : dropDownData.map(function (val) {
        if ((val === null || val === void 0 ? void 0 : val._id) === id) {
          obj = _objectSpread2({
            label: val.geogLevelName,
            value: val._id
          }, val);
        }
      });
    }
  }

  return obj;
};

var generateReadJSON$3 = function generateReadJSON(data, masters, countryData, stateData, districtData, cityData, pincodeData) {
  var _data$identifier, _data$name, _data$communication, _data$telecom, _data$practitioner_ro, _data$address, _data$qualification, _data$publication_det, _data$training_detail, _data$job_experience, _data$achievements_aw, _data$gender, _data$marital_status, _data$nationality, _data$practitioner_ty, _data$position, _data$employee_status;

  var identifier = [];

  if (data.identifier && ((_data$identifier = data.identifier) === null || _data$identifier === void 0 ? void 0 : _data$identifier.length) > 0) {
    data.identifier.map(function (val) {
      var _val$user;

      var identifierData = {
        "id_type": ((_val$user = val.user) === null || _val$user === void 0 ? void 0 : _val$user.length) > 0 && masters.id_type.filter(function (idlabel) {
          return idlabel.value === val.user;
        })[0] ? masters.id_type.filter(function (idlabel) {
          return idlabel.value === val.user;
        })[0] : {},
        "id_number": val.value,
        "expiry_date": val.period[0].end ? moment__default["default"].unix(val.period[0].end).format("YYYY-MM-DD") : null,
        "doc": val.files
      };
      identifier.push(identifierData);
    });
  }

  var nameslist = [];

  if (data.name && ((_data$name = data.name) === null || _data$name === void 0 ? void 0 : _data$name.length) > 0) {
    data.name.map(function (val) {
      var namedatas = {
        use: val.use ? masters.use.filter(function (idlabel) {
          return idlabel.value === val.use;
        })[0] : {},
        prefix: val.prefix ? masters.prefix.filter(function (idlabel) {
          return idlabel.value === val.prefix;
        })[0] : {},
        first_name: val.text,
        middle_name: val.given,
        last_name: val.family,
        suffix: val.suffix ? masters.suffix.filter(function (idlabel) {
          return idlabel.value === val.suffix;
        })[0] : {}
      };
      nameslist.push(namedatas);
    });
  }

  var getlanguageoptions = [];

  if (data.communication && ((_data$communication = data.communication) === null || _data$communication === void 0 ? void 0 : _data$communication.length) > 0) {
    data.communication.map(function (val) {
      var languageoptionsData = _objectSpread2({
        label: val.coding ? val.coding[0] ? val.coding[0].display : "" : val,
        value: val._id
      }, val);

      getlanguageoptions.push(languageoptionsData);
    });
  }

  var contactlist = [];

  if (data.telecom && ((_data$telecom = data.telecom) === null || _data$telecom === void 0 ? void 0 : _data$telecom.length) > 0) {
    data.telecom.map(function (val) {
      var contactData = {
        "mode": getmasterOprions("contact_mode", val.system, masters)[0],
        "mobile": val.value ? val.value : "",
        "use": getmasterOprions("Address_use", val.use, masters)[0],
        "priority": getmasterOprions("priority", "".concat(val.rank), masters)[0],
        "country_code": getmasterOprions("country_code", val.valueprefix, masters)[0]
      };
      contactlist.push(contactData);
    });
  }

  var practitionerbyrolelist = [];

  if (data.practitioner_role && ((_data$practitioner_ro = data.practitioner_role) === null || _data$practitioner_ro === void 0 ? void 0 : _data$practitioner_ro.length) > 0) {
    data.practitioner_role.map(function (val) {
      var _val$OrgID, _val$role, _val$period, _val$period2;

      var practitionerData = {
        speciality: getmasterOprions("speciality", val.SpecialtyID, masters)[0],
        select_entity: getmasterOprions("entity", val.EntityType, masters, "_id")[0],
        entity_name: val.OrgID && ((_val$OrgID = val.OrgID) === null || _val$OrgID === void 0 ? void 0 : _val$OrgID.length) > 0 ? masters["entity_name"].filter(function (valss) {
          return valss.value.toString() === val.OrgID;
        })[0] : {},
        select_location: getmasterOprions("location", val.locationID, masters)[0],
        primary_specialty: val.primary_specialty ? val.primary_specialty : false,
        select_role: getmasterOprions("role", val.role && ((_val$role = val.role) === null || _val$role === void 0 ? void 0 : _val$role.length) > 0 ? val.role[0]._id : null, masters)[0],
        status: val.active ? val.active : false,
        start_date: val.period && ((_val$period = val.period) === null || _val$period === void 0 ? void 0 : _val$period.length) > 0 && val.period[0].start ? utcTOLocal(val.period[0].start, "YYYY-MM-DD") : null,
        end_date: val.period && ((_val$period2 = val.period) === null || _val$period2 === void 0 ? void 0 : _val$period2.length) > 0 && val.period[0].end ? utcTOLocal(val.period[0].end, "YYYY-MM-DD") : null,
        contact: contactListData(val.telecom, masters),
        doc: val.files ? val.files : [],
        // "telecom": contactList(val.contact),
        _key: val === null || val === void 0 ? void 0 : val._key
      };
      practitionerbyrolelist.push(practitionerData);
    });
  }

  var addresslist = [];

  if (data.address && ((_data$address = data.address) === null || _data$address === void 0 ? void 0 : _data$address.length) > 0) {
    data.address.map(function (val) {
      var _val$text2, _val$line2;

      var addresslistData = {
        "use": getmasterOprions("Address_use", val.use, masters)[0],
        "addressLine1": val.text && ((_val$text2 = val.text) === null || _val$text2 === void 0 ? void 0 : _val$text2.length) > 0 ? val.text : "",
        "addressLine2": val.line && ((_val$line2 = val.line) === null || _val$line2 === void 0 ? void 0 : _val$line2.length) > 0 ? val.line : "",
        // "city": getmasterOprions("city", val.city, masters)[0],
        // "district": getmasterOprions("district", val.district, masters)[0],
        // "state": getmasterOprions("state", val.state, masters)[0],
        // "pincode": (val.postalCode && val.postalCode?.length > 0) ? val.postalCode : "",
        // "country": getmasterOprions("country", val.country, masters)[0],
        "city": getGeoData(val === null || val === void 0 ? void 0 : val.city, cityData),
        "district": getGeoData(val === null || val === void 0 ? void 0 : val.district, districtData),
        "state": getGeoData(val === null || val === void 0 ? void 0 : val.state, stateData),
        "pincode": getGeoData(val.postalCode, pincodeData),
        "country": getGeoData(val.country, countryData),
        "type": getmasterOprions("address_type", val.Type, masters)[0]
      };
      addresslist.push(addresslistData);
    });
  }

  var qualificationList = [];

  if (data.qualification && ((_data$qualification = data.qualification) === null || _data$qualification === void 0 ? void 0 : _data$qualification.length) > 0) {
    data.qualification.map(function (val) {
      var qualificationData = {
        "name": val.name ? val.name : "",
        "qualification_name": val.university_board ? val.university_board : "",
        "issued_by": val.issue_date ? utcTOLocal(val.issue_date, "YYYY-MM-DD") : null,
        "start_date": val.valid_from ? utcTOLocal(val.valid_from, "YYYY-MM-DD") : null,
        "end_date": val.valid_to ? utcTOLocal(val.valid_to, "YYYY-MM-DD") : null,
        "doc": val.files ? val.files : []
      };
      qualificationList.push(qualificationData);
    });
  }

  var PublicationList = [];

  if (data.publication_details && ((_data$publication_det = data.publication_details) === null || _data$publication_det === void 0 ? void 0 : _data$publication_det.length) > 0) {
    data.publication_details.map(function (val) {
      var PublicationListdata = {
        "description": val.description ? val.description : "",
        "link": val.link ? val.link : ""
      };
      PublicationList.push(PublicationListdata);
    });
  }

  var trainingList = [];

  if (data.training_details && ((_data$training_detail = data.training_details) === null || _data$training_detail === void 0 ? void 0 : _data$training_detail.length) > 0) {
    data.training_details.map(function (val) {
      var _val$training_contact, _val$training_address;

      var trainingListData = {
        "organization": val.organization ? val.organization : "",
        "course_name": val.course_name ? val.course_name : "",
        "responsible_person": val.responsible_person ? val.responsible_person : "",
        "course_start_date": val.course_start_date ? utcTOLocal(val.course_start_date, "YYYY-MM-DD") : null,
        "course_end_date": val.course_end_date ? utcTOLocal(val.course_end_date, "YYYY-MM-DD") : null,
        "certificate_issue_date": val.certificate_issued_date ? utcTOLocal(val.certificate_issued_date, "YYYY-MM-DD") : null,
        "certificate_expiry_date": val.certificate_expiry_date ? utcTOLocal(val.certificate_expiry_date, "YYYY-MM-DD") : null,
        "doc": val.files ? val.files : [],
        "contact": contactListData((_val$training_contact = val === null || val === void 0 ? void 0 : val.training_contact_details) !== null && _val$training_contact !== void 0 ? _val$training_contact : [], masters),
        "address": addressListData((_val$training_address = val === null || val === void 0 ? void 0 : val.training_address) !== null && _val$training_address !== void 0 ? _val$training_address : [], masters)
      };
      trainingList.push(trainingListData);
    });
  }

  var jobList = [];

  if (data.job_experience && ((_data$job_experience = data.job_experience) === null || _data$job_experience === void 0 ? void 0 : _data$job_experience.length) > 0) {
    data.job_experience.map(function (val) {
      var jobListData = {
        "organization": val.organization ? val.organization : "",
        "department": val.department ? val.department : "",
        "designation": val.designation ? val.designation : "",
        "role": val.role ? val.role : "",
        "start_date": val.start_date ? utcTOLocal(val.start_date, "YYYY-MM-DD") : null,
        "end_date": val.end_date ? utcTOLocal(val.end_date, "YYYY-MM-DD") : null,
        "reporting_to": val.report_to ? val.report_to : "",
        "grade": val.grade ? val.grade : "",
        "pay_scale": val.pay_scale ? val.pay_scale : "",
        "job_description": val.job_description ? val.job_description : "",
        "doc": val.files ? val.files : [],
        "sequence_no": val.sequence_no ? val.sequence_no : "",
        "contact": contactListData(val.jobexperience_contact_details, masters),
        "address": addressListData(val.jobexperience_address, masters)
      };
      jobList.push(jobListData);
    });
  }

  var awardsList = [];

  if (data.achievements_awards_details && ((_data$achievements_aw = data.achievements_awards_details) === null || _data$achievements_aw === void 0 ? void 0 : _data$achievements_aw.length) > 0) {
    data.achievements_awards_details.map(function (val) {
      var awardsListData = {
        "organization": val.organization ? val.organization : "",
        "type": val.type ? val.type : "",
        "title": val.title ? val.title : "",
        "notes": val.note ? val.note : "",
        "date": val.date ? utcTOLocal(val.date, "YYYY-MM-DD") : null,
        "doc": val.files ? val.files : []
      };
      awardsList.push(awardsListData);
    });
  }

  var json = {
    identification: identifier,
    names: nameslist ? nameslist : [{}],
    details: {
      "practitoner_id": data.practitioner_id,
      "gender": ((_data$gender = data.gender) === null || _data$gender === void 0 ? void 0 : _data$gender.length) > 0 && masters.gender.filter(function (idlabel) {
        return idlabel.value === data.gender[0]._id;
      })[0] ? masters.gender.filter(function (idlabel) {
        return idlabel.value === data.gender[0]._id;
      })[0] : {},
      "dob": data.birthDate ? moment__default["default"].unix(data.birthDate).format("YYYY-MM-DD") : null,
      "marital_status": ((_data$marital_status = data.marital_status) === null || _data$marital_status === void 0 ? void 0 : _data$marital_status.length) > 0 && masters.marital_status.filter(function (idlabel) {
        return idlabel.value === data.marital_status[0]._id;
      })[0] ? masters.marital_status.filter(function (idlabel) {
        return idlabel.value === data.marital_status[0]._id;
      })[0] : {},
      "nationality": ((_data$nationality = data.nationality) === null || _data$nationality === void 0 ? void 0 : _data$nationality.length) > 0 && masters.nationality.filter(function (idlabel) {
        return idlabel.value === data.nationality[0]._id;
      })[0] ? masters.nationality.filter(function (idlabel) {
        return idlabel.value === data.nationality[0]._id;
      })[0] : {},
      "status": data.status,
      "biography_description": data.biography && data.biography[0] && data.biography[0].biography_description ? data.biography[0].biography_description : "",
      "photo": {
        "fileName": data.photo && data.photo[0] && data.photo[0].fileName ? data.photo[0].fileName : "",
        "fileid": data.photo && data.photo[0] && data.photo[0].fileid ? data.photo[0].fileid : "",
        "filetype": data.photo && data.photo[0] && data.photo[0].filetype ? data.photo[0].filetype : "",
        "objectid": data.photo && data.photo[0] && data.photo[0].objectid ? data.photo[0].objectid : ""
      }
    },
    practitioner_description: {
      "practitioner_type": data.practitioner_type && ((_data$practitioner_ty = data.practitioner_type) === null || _data$practitioner_ty === void 0 ? void 0 : _data$practitioner_ty.length) > 0 ? getOptionWithMaster(data.practitioner_type)[0] ? getOptionWithMaster(data.practitioner_type)[0] : {} : {},
      "position": data.position && ((_data$position = data.position) === null || _data$position === void 0 ? void 0 : _data$position.length) > 0 ? getOptionWithMaster(data.position)[0] ? getOptionWithMaster(data.position)[0] : {} : {},
      "employee_type": data.employee_status && ((_data$employee_status = data.employee_status) === null || _data$employee_status === void 0 ? void 0 : _data$employee_status.length) > 0 ? getOptionWithMaster(data.employee_status)[0] ? getOptionWithMaster(data.employee_status)[0] : {} : {},
      "communication_languages": getlanguageoptions
    },
    practitionerbyrole: practitionerbyrolelist,
    // communication: {},
    contact: contactlist,
    // Submitrole: {},
    address: addresslist,
    publication: PublicationList,
    // reporting: {},
    qualification: qualificationList,
    training: trainingList,
    job: jobList,
    awards: awardsList
  };
  return json;
};

var _extraReducers$n;
var location = ["nationality", "city", "district", "state", "country"];

var loopMasters$5 = function loopMasters() {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject) {
      var calls;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              calls = Object.keys(masterQuery$5).map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return fetchMaster$5(val, masterQuery$5[val]);

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
              es6Promise.Promise.all(calls).then(function (data) {
                var json = {};
                data.map(function (val) {
                  var arr = [];
                  val.data.map(function (value) {
                    if ("country_code" === val.name) {
                      arr.push(_objectSpread2({
                        label: value.GeoLocationISDCode,
                        value: value._id
                      }, value));
                    } else if ("location" === val.name) {
                      if (value.shortdesc) {
                        arr.push(_objectSpread2({
                          label: value.shortdesc,
                          value: value._id
                        }, value));
                      }
                    } else if ("entity" === val.name) {
                      arr.push(_objectSpread2({
                        label: value.coding ? value.coding[0] ? value.coding[0].display : "" : val,
                        value: value.coding ? value.coding[0] ? value.coding[0]._id : "" : val
                      }, value));
                    } else if (["entity_name"].indexOf(val.name) === 0) {
                      arr.push(_objectSpread2({
                        label: value.name ? value.name : "",
                        value: value._id ? value._id : ""
                      }, value));
                    } else if (location.indexOf(val.name) === -1) {
                      if (val.name === "Address_use" || val.name === "address_type" || val.name === "contact_mode") {
                        var _value$coding, _value$coding$;

                        arr.push(_objectSpread2({
                          label: value.coding ? value.coding[0] ? value.coding[0].display : "" : val,
                          value: (_value$coding = value.coding) === null || _value$coding === void 0 ? void 0 : (_value$coding$ = _value$coding[0]) === null || _value$coding$ === void 0 ? void 0 : _value$coding$._id
                        }, value));
                      } else {
                        arr.push(_objectSpread2({
                          label: value.coding ? value.coding[0] ? value.coding[0].display : "" : val,
                          value: value._id
                        }, value));
                      }
                    } else {
                      arr.push(_objectSpread2({
                        label: value.geogLevelName,
                        value: value._id
                      }, value));
                    }
                  });
                  json[val.name] = arr;
                  resolve(json);
                });
              })["catch"](function (err) {
                resolve([]);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var fetchMaster$5 = function fetchMaster(name, query) {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetchData({
                body: query
              }, __readDocumentUrl__);

            case 2:
              data = _context3.sent;
              resolve({
                data: data.result,
                name: name
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }());
};

var PRACTITIONER_MASTERS = toolkit.createAsyncThunk("practitionerMasterSlice/practitionerlist", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref5,
      rejectWithValue,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref5 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref5.rejectWithValue;
          _context4.prev = 2;
          payload.type;
          _context4.next = 6;
          return loopMasters$5();

        case 6:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 10]]);
})));
var PRACTITIONER_LOCATION_MASTERS = toolkit.createAsyncThunk("practitionerMasterSlice/practitionerLocationMaster", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref7,
      rejectWithValue,
      _data$result,
      type,
      data,
      arr,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref7 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref7.rejectWithValue;
          _context5.prev = 2;
          type = payload.type;
          _context5.next = 6;
          return fetchData({
            body: JSON.stringify(masterqueries.practitioner_location_rule(type))
          }, __readDocumentUrl__);

        case 6:
          data = _context5.sent;
          arr = [];

          if ((data === null || data === void 0 ? void 0 : (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.length) > 0) {
            data.result.map(function (v) {
              var _v$longdesc, _v$_id;

              arr.push({
                label: (_v$longdesc = v === null || v === void 0 ? void 0 : v.longdesc) !== null && _v$longdesc !== void 0 ? _v$longdesc : '',
                value: (_v$_id = v === null || v === void 0 ? void 0 : v._id) !== null && _v$_id !== void 0 ? _v$_id : ''
              });
            });
          }

          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 12]]);
})));
var PRACTITIONER_GET_BY_ID = toolkit.createAsyncThunk("practitionerMasterSlice/practitionerbyid", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref9,
      rejectWithValue,
      id,
      masterlist,
      data,
      country_data,
      state_data,
      district_data,
      city_data,
      pincode_data,
      readJSON,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref9 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref9.rejectWithValue;
          _context6.prev = 2;
          id = payload.id;
          _context6.next = 6;
          return loopMasters$5();

        case 6:
          masterlist = _context6.sent;
          _context6.next = 9;
          return fetchData({
            body: JSON.stringify(queries$9.practitioner_by_id(id))
          }, __readDocumentUrl__);

        case 9:
          data = _context6.sent;
          _context6.next = 12;
          return fetchData({
            body: JSON.stringify(masterqueries.country())
          }, __readDocumentUrl__);

        case 12:
          country_data = _context6.sent;
          _context6.next = 15;
          return fetchData({
            body: JSON.stringify(masterqueries.state_by_country_())
          }, __readDocumentUrl__);

        case 15:
          state_data = _context6.sent;
          _context6.next = 18;
          return fetchData({
            body: JSON.stringify(masterqueries.district_by_state_())
          }, __readDocumentUrl__);

        case 18:
          district_data = _context6.sent;
          _context6.next = 21;
          return fetchData({
            body: JSON.stringify(masterqueries.city_by_district_())
          }, __readDocumentUrl__);

        case 21:
          city_data = _context6.sent;
          _context6.next = 24;
          return fetchData({
            body: JSON.stringify(masterqueries.pincode_by_city_())
          }, __readDocumentUrl__);

        case 24:
          pincode_data = _context6.sent;
          readJSON = generateReadJSON$3(data.result[0] ? data.result[0] : null, masterlist, country_data === null || country_data === void 0 ? void 0 : country_data.result, state_data === null || state_data === void 0 ? void 0 : state_data.result, district_data === null || district_data === void 0 ? void 0 : district_data.result, city_data === null || city_data === void 0 ? void 0 : city_data.result, pincode_data === null || pincode_data === void 0 ? void 0 : pincode_data.result);
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: readJSON
          }));

        case 29:
          _context6.prev = 29;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 32:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 29]]);
})));
var PRACTITIONER_COUNTRY_MASTER = toolkit.createAsyncThunk("practitionerMasterSlice/practitioner_country_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref11,
      rejectWithValue,
      _data$result2,
      data,
      arr,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref11 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref11.rejectWithValue;
          _context7.prev = 2;

          _objectDestructuringEmpty(payload);

          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(masterqueries.country())
          }, __readDocumentUrl__);

        case 6:
          data = _context7.sent;
          arr = [];

          if (Array.isArray(data.result) && (data === null || data === void 0 ? void 0 : (_data$result2 = data.result) === null || _data$result2 === void 0 ? void 0 : _data$result2.length) > 0) {
            data === null || data === void 0 ? void 0 : data.result.map(function (val) {
              arr.push(_objectSpread2({
                label: val.geogLevelName,
                value: val._id
              }, val));
            });
          }

          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 15:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 12]]);
})));
var PRACTITIONER_STATE_MASTER = toolkit.createAsyncThunk("practitionerMasterSlice/practitioner_state_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref13,
      rejectWithValue,
      _data$result3,
      geogLevelCode,
      data,
      arr,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref13 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref13.rejectWithValue;
          _context8.prev = 2;
          geogLevelCode = payload.geogLevelCode;
          _context8.next = 6;
          return fetchData({
            body: JSON.stringify(masterqueries.state_by_country(geogLevelCode))
          }, __readDocumentUrl__);

        case 6:
          data = _context8.sent;
          arr = [];

          if (Array.isArray(data.result) && (data === null || data === void 0 ? void 0 : (_data$result3 = data.result) === null || _data$result3 === void 0 ? void 0 : _data$result3.length) > 0) {
            data === null || data === void 0 ? void 0 : data.result.map(function (val) {
              arr.push(_objectSpread2({
                label: val.geogLevelName,
                value: val._id
              }, val));
            });
          }

          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context8.prev = 12;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 15:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 12]]);
})));
var PRACTITIONER_DISTRICT_MASTER = toolkit.createAsyncThunk("practitionerMasterSlice/practitioner_district_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref15,
      rejectWithValue,
      _data$result4,
      geogLevelCode,
      data,
      arr,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref15 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref15.rejectWithValue;
          _context9.prev = 2;
          geogLevelCode = payload.geogLevelCode;
          _context9.next = 6;
          return fetchData({
            body: JSON.stringify(masterqueries.district_by_state(geogLevelCode))
          }, __readDocumentUrl__);

        case 6:
          data = _context9.sent;
          arr = [];

          if (Array.isArray(data.result) && (data === null || data === void 0 ? void 0 : (_data$result4 = data.result) === null || _data$result4 === void 0 ? void 0 : _data$result4.length) > 0) {
            data === null || data === void 0 ? void 0 : data.result.map(function (val) {
              arr.push(_objectSpread2({
                label: val.geogLevelName,
                value: val._id
              }, val));
            });
          }

          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context9.prev = 12;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 15:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 12]]);
})));
var PRACTITIONER_CITY_MASTER = toolkit.createAsyncThunk("practitionerMasterSlice/practitioner_city_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref17,
      rejectWithValue,
      _data$result5,
      geogLevelCode,
      data,
      arr,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref17 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref17.rejectWithValue;
          _context10.prev = 2;
          geogLevelCode = payload.geogLevelCode;
          _context10.next = 6;
          return fetchData({
            body: JSON.stringify(masterqueries.city_by_district(geogLevelCode))
          }, __readDocumentUrl__);

        case 6:
          data = _context10.sent;
          arr = [];

          if (Array.isArray(data.result) && (data === null || data === void 0 ? void 0 : (_data$result5 = data.result) === null || _data$result5 === void 0 ? void 0 : _data$result5.length) > 0) {
            data === null || data === void 0 ? void 0 : data.result.map(function (val) {
              arr.push(_objectSpread2({
                label: val.geogLevelName,
                value: val._id
              }, val));
            });
          }

          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context10.prev = 12;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 15:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 12]]);
})));
var PRACTITIONER_PINCODE_MASTER = toolkit.createAsyncThunk("practitionerMasterSlice/practitioner_pincode_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var payload,
      _ref19,
      rejectWithValue,
      _data$result6,
      geogLevelCode,
      data,
      arr,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
          _ref19 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref19.rejectWithValue;
          _context11.prev = 2;
          geogLevelCode = payload.geogLevelCode;
          _context11.next = 6;
          return fetchData({
            body: JSON.stringify(masterqueries.pincode_by_city(geogLevelCode))
          }, __readDocumentUrl__);

        case 6:
          data = _context11.sent;
          arr = [];

          if (Array.isArray(data.result) && (data === null || data === void 0 ? void 0 : (_data$result6 = data.result) === null || _data$result6 === void 0 ? void 0 : _data$result6.length) > 0) {
            data === null || data === void 0 ? void 0 : data.result.map(function (val) {
              arr.push(_objectSpread2({
                label: val.geogLevelName,
                value: val._id
              }, val));
            });
          }

          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context11.prev = 12;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 15:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 12]]);
})));
var practitionerMasterSlice = toolkit.createSlice({
  name: "practitionerMasterSlice",
  initialState: {
    practitioner_masters: _objectSpread2({}, defaultState.Info),
    practitionerbyid: _objectSpread2({}, defaultState.Info),
    practitioner_country_master: _objectSpread2({}, defaultState.Info),
    practitioner_state_master: _objectSpread2({}, defaultState.Info),
    practitioner_district_master: _objectSpread2({}, defaultState.Info),
    practitioner_city_master: _objectSpread2({}, defaultState.Info),
    practitioner_pincode_master: _objectSpread2({}, defaultState.Info),
    practitioner_location: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$n = {}, _defineProperty(_extraReducers$n, PRACTITIONER_LOCATION_MASTERS.fulfilled, function (state, action) {
    state.practitioner_location.loading = false, state.practitioner_location.error = false, state.practitioner_location = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_LOCATION_MASTERS.pending, function (state, action) {
    state.practitioner_location.loading = true, state.practitioner_location.error = false, state.practitioner_location.loading = true;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_LOCATION_MASTERS.rejected, function (state, action) {
    state.practitioner_location.loading = false, state.practitioner_location.error = true, state.practitioner_location = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_MASTERS.fulfilled, function (state, action) {
    state.practitioner_masters.loading = false, state.practitioner_masters.error = false, state.practitioner_masters = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_MASTERS.pending, function (state, action) {
    state.practitioner_masters.loading = true, state.practitioner_masters.error = false, state.practitioner_masters.loading = true;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_MASTERS.rejected, function (state, action) {
    state.practitioner_masters.loading = false, state.practitioner_masters.error = true, state.practitioner_masters = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_GET_BY_ID.fulfilled, function (state, action) {
    state.practitionerbyid.loading = false, state.practitionerbyid.error = false, state.practitionerbyid = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_GET_BY_ID.pending, function (state, action) {
    state.practitionerbyid.loading = true, state.practitionerbyid.error = false, state.practitionerbyid.loading = true;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_GET_BY_ID.rejected, function (state, action) {
    state.practitionerbyid.loading = false, state.practitionerbyid.error = true, state.practitionerbyid = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_COUNTRY_MASTER.fulfilled, function (state, action) {
    state.practitioner_country_master.loading = false, state.practitioner_country_master.error = false, state.practitioner_country_master = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_COUNTRY_MASTER.pending, function (state, action) {
    state.practitioner_country_master.loading = true, state.practitioner_country_master.error = false, state.practitioner_country_master.loading = true;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_COUNTRY_MASTER.rejected, function (state, action) {
    state.practitioner_country_master.loading = false, state.practitioner_country_master.error = true, state.practitioner_country_master = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_STATE_MASTER.fulfilled, function (state, action) {
    state.practitioner_state_master.loading = false, state.practitioner_state_master.error = false, state.practitioner_state_master = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_STATE_MASTER.pending, function (state, action) {
    state.practitioner_state_master.loading = true, state.practitioner_state_master.error = false, state.practitioner_state_master.loading = true;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_STATE_MASTER.rejected, function (state, action) {
    state.practitioner_state_master.loading = false, state.practitioner_state_master.error = true, state.practitioner_state_master = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_DISTRICT_MASTER.fulfilled, function (state, action) {
    state.practitioner_district_master.loading = false, state.practitioner_district_master.error = false, state.practitioner_district_master = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_DISTRICT_MASTER.pending, function (state, action) {
    state.practitioner_district_master.loading = true, state.practitioner_district_master.error = false, state.practitioner_district_master.loading = true;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_DISTRICT_MASTER.rejected, function (state, action) {
    state.practitioner_district_master.loading = false, state.practitioner_district_master.error = true, state.practitioner_district_master = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_CITY_MASTER.fulfilled, function (state, action) {
    state.practitioner_city_master.loading = false, state.practitioner_city_master.error = false, state.practitioner_city_master = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_CITY_MASTER.pending, function (state, action) {
    state.practitioner_city_master.loading = true, state.practitioner_city_master.error = false, state.practitioner_city_master.loading = true;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_CITY_MASTER.rejected, function (state, action) {
    state.practitioner_city_master.loading = false, state.practitioner_city_master.error = true, state.practitioner_city_master = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_PINCODE_MASTER.fulfilled, function (state, action) {
    state.practitioner_pincode_master.loading = false, state.practitioner_pincode_master.error = false, state.practitioner_pincode_master = action.payload;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_PINCODE_MASTER.pending, function (state, action) {
    state.practitioner_pincode_master.loading = true, state.practitioner_pincode_master.error = false, state.practitioner_pincode_master.loading = true;
  }), _defineProperty(_extraReducers$n, PRACTITIONER_PINCODE_MASTER.rejected, function (state, action) {
    state.practitioner_pincode_master.loading = false, state.practitioner_pincode_master.error = true, state.practitioner_pincode_master = action.payload;
  }), _extraReducers$n)
});
var practitionerMasterActions = {
  PRACTITIONER_MASTERS: PRACTITIONER_MASTERS,
  PRACTITIONER_GET_BY_ID: PRACTITIONER_GET_BY_ID,
  PRACTITIONER_COUNTRY_MASTER: PRACTITIONER_COUNTRY_MASTER,
  PRACTITIONER_STATE_MASTER: PRACTITIONER_STATE_MASTER,
  PRACTITIONER_DISTRICT_MASTER: PRACTITIONER_DISTRICT_MASTER,
  PRACTITIONER_CITY_MASTER: PRACTITIONER_CITY_MASTER,
  PRACTITIONER_PINCODE_MASTER: PRACTITIONER_PINCODE_MASTER,
  PRACTITIONER_LOCATION_MASTERS: PRACTITIONER_LOCATION_MASTERS
};
var practitionerMasterSlice$1 = practitionerMasterSlice.reducer;

var query$7 = {
  unitUom: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodeableConceptMaster\",\n        \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n        \"filter\": \"CodeableConceptMaster.Type=='VITALSUOM'\",\n        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n        }"),
  // getAgeRange: `{
  //     "db_name": "${dbName}",
  //     "entity": "AgeRanges",
  //     "return_fields": "MERGE(AgeRanges, {AgeCategory: (FOR cat IN TO_ARRAY(AgeRanges.AgeCategory) RETURN MERGE(DOCUMENT(cat), {UOM:(FOR cod IN TO_ARRAY(DOCUMENT(DOCUMENT(cat).UOM).coding) RETURN MERGE(DOCUMENT(DOCUMENT(cat).UOM),{coding:DOCUMENT(cod)} ) ) } ) ) } )"
  //   }`,
  getAgeRange: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"AgeRanges\",\n        \"return_fields\": \"MERGE(AgeRanges, {AgeCategory: (FOR cat IN TO_ARRAY(AgeRanges.AgeCategory) RETURN MERGE(DOCUMENT(cat), {UOM:(FOR cod IN TO_ARRAY(DOCUMENT(DOCUMENT(cat).UOM).coding) RETURN MERGE(DOCUMENT(DOCUMENT(cat).UOM),{coding:DOCUMENT(cod)} ) ) } ) ) } )\",\n        \"sort\":\"AgeRanges.createddate\"\n    }")
};

var generateJson$8 = function generateJson(data) {
  var filter = {};

  if (data.editData) {
    filter = {
      filter: {
        _id: data.editData._id
      }
    };
  }

  return [_objectSpread2(_objectSpread2({
    "db_name": dbName
  }, filter), {}, {
    "entity": "AgeRanges",
    "is_metadata": true,
    "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
    "doc": {
      "agerangecode": data.code,
      "shortdesc": data.shortdes,
      "longdesc": data.longdes,
      "AgeCategory": generateCategory(data.categoryDetail),
      "status": data.status
    }
  })];
};

var generateCategory = function generateCategory(data) {
  var arr = [];
  data.map(function (val) {
    var ids = {};

    if (val._id) {
      ids._id = val._id;
    }

    arr.push(_objectSpread2(_objectSpread2({}, ids), {}, {
      "code": val.code,
      "age_minimum": val.age_minimum ? parseInt(val.age_minimum) : 0,
      "age_maximum": val.age_maximum ? parseInt(val.age_maximum) : 0,
      "UOM": val.UOM ? val.UOM.value : "",
      "description": val.description
    }));
  });
  return arr;
};

var _extraReducers$m;
var UPSERT_AGE_RANGE = toolkit.createAsyncThunk("ageRangeMasterApiSlice/save_age_range", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      dataList,
      queriesjson,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          dataList = payload.dataList;
          queriesjson = generateJson$8(dataList);
          _context.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var UPDATE_AGE_RANGE = toolkit.createAsyncThunk("ageRangeMasterApiSlice/update_age_range", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      editId,
      status,
      queriesjson,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          editId = payload.editId, status = payload.status;
          queriesjson = [{
            "db_name": dbName,
            "entity": "AgeRanges",
            "filter": "AgeRanges._id==\"".concat(editId, "\""),
            "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
            "doc": {
              "status": status
            }
          }];
          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __update__);

        case 7:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          alert(_context2.t0.message);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var UNIT_UOM = toolkit.createAsyncThunk("ageRangeMasterApiSlice/unit_uom_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var _ref6,
      rejectWithValue,
      data,
      arry,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          _context3.next = 5;
          return fetchData({
            body: query$7.unitUom
          }, __readDocumentUrl__);

        case 5:
          data = _context3.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push({
              label: val.coding[0].display,
              value: val._id,
              code: val.coding[0].code
            });
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 11]]);
})));
var GET_AGE_RANGE_MASTER = toolkit.createAsyncThunk("ageRangeMasterApiSlice/age_range_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var _ref8,
      rejectWithValue,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          _context4.next = 5;
          return fetchData({
            body: query$7.getAgeRange
          }, __readDocumentUrl__);

        case 5:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 9:
          _context4.prev = 9;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 12:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 9]]);
})));
var ageRangeMasterSlice = toolkit.createSlice({
  name: "ageRangeMasterApiSlice",
  initialState: {
    unit_uom_list: _objectSpread2({}, defaultState.List),
    age_range_list: _objectSpread2({}, defaultState.List),
    save_age_range: _objectSpread2({}, defaultState.Info),
    update_age_range: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$m = {}, _defineProperty(_extraReducers$m, UNIT_UOM.fulfilled, function (state, action) {
    state.unit_uom_list.loading = false, state.unit_uom_list.error = false, state.unit_uom_list = action.payload;
  }), _defineProperty(_extraReducers$m, UNIT_UOM.pending, function (state, action) {
    state.unit_uom_list.loading = true, state.unit_uom_list.error = false, state.unit_uom_list.loading = true;
  }), _defineProperty(_extraReducers$m, UNIT_UOM.rejected, function (state, action) {
    state.unit_uom_list.loading = false, state.unit_uom_list.error = true, state.unit_uom_list = action.payload;
  }), _defineProperty(_extraReducers$m, GET_AGE_RANGE_MASTER.fulfilled, function (state, action) {
    state.age_range_list.loading = false, state.age_range_list.error = false, state.age_range_list = action.payload;
  }), _defineProperty(_extraReducers$m, GET_AGE_RANGE_MASTER.pending, function (state, action) {
    state.age_range_list.loading = true, state.age_range_list.error = false, state.age_range_list.loading = true;
  }), _defineProperty(_extraReducers$m, GET_AGE_RANGE_MASTER.rejected, function (state, action) {
    state.age_range_list.loading = false, state.age_range_list.error = true, state.age_range_list = action.payload;
  }), _defineProperty(_extraReducers$m, UPSERT_AGE_RANGE.fulfilled, function (state, action) {
    state.save_age_range.loading = false, state.save_age_range.error = false, state.save_age_range = action.payload;
  }), _defineProperty(_extraReducers$m, UPSERT_AGE_RANGE.pending, function (state, action) {
    state.save_age_range.loading = true, state.save_age_range.error = false, state.save_age_range.loading = true;
  }), _defineProperty(_extraReducers$m, UPSERT_AGE_RANGE.rejected, function (state, action) {
    state.save_age_range.loading = false, state.save_age_range.error = true, state.save_age_range = action.payload;
  }), _defineProperty(_extraReducers$m, UPDATE_AGE_RANGE.fulfilled, function (state, action) {
    state.update_age_range.loading = false, state.update_age_range.error = false, state.update_age_range = action.payload;
  }), _defineProperty(_extraReducers$m, UPDATE_AGE_RANGE.pending, function (state, action) {
    state.update_age_range.loading = true, state.update_age_range.error = false, state.update_age_range.loading = true;
  }), _defineProperty(_extraReducers$m, UPDATE_AGE_RANGE.rejected, function (state, action) {
    state.update_age_range.loading = false, state.update_age_range.error = true, state.update_age_range = action.payload;
  }), _extraReducers$m)
});
var ageRangeMasterActions = {
  UNIT_UOM: UNIT_UOM,
  GET_AGE_RANGE_MASTER: GET_AGE_RANGE_MASTER,
  UPSERT_AGE_RANGE: UPSERT_AGE_RANGE,
  UPDATE_AGE_RANGE: UPDATE_AGE_RANGE
};
var ageRangeMasterSlice$1 = ageRangeMasterSlice.reducer;

var query$6 = {
  getList: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"VitalsMeasureCodes\",\n        \"sort\": \"VitalsMeasureCodes.createddate\",\n        \"filter\": {\n        \"VitalsMeasureCodes\":\"VitalsMeasureCodes.activestatus==true\"\n      },\n        \"return_fields\": \"VitalsMeasureCodes\"\n      }")
};

var generateJson$7 = function generateJson(data) {
  var filter = {};

  if (data.edit_data) {
    filter = {
      filter: {
        _id: data.edit_data._id
      }
    };
  }

  return [_objectSpread2(_objectSpread2({
    "db_name": dbName
  }, filter), {}, {
    "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
    "entity": "VitalsMeasureCodes",
    "is_metadata": true,
    "doc": {
      "ObsValMeasCode": data.ObsValMeasCode,
      "shortdesc": data.shortdesc,
      "longdesc": data.longdesc,
      "status": data.status
    }
  })];
};

var _extraReducers$l;
var GET_VITALS_MEASURE_CODE = toolkit.createAsyncThunk("measureCodeApiSlice/age_range_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      data,
      TableData,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return fetchData({
            body: query$6.getList
          }, __readDocumentUrl__);

        case 5:
          data = _context.sent;
          TableData = data.result.sort(function (a, b) {
            return (a === null || a === void 0 ? void 0 : a.createddate) - (b === null || b === void 0 ? void 0 : b.createddate);
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: TableData
          }));

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 10]]);
})));
var UPSERT_MEASURE_CODE = toolkit.createAsyncThunk("measureCodeApiSlice/save_measure_code", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      dataList,
      queriesjson,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          dataList = payload.dataList;
          queriesjson = generateJson$7(dataList);
          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          alert(_context2.t0.message);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var UPDATE_MEASURE_CODE_STATUS = toolkit.createAsyncThunk("ageRangeMasterApiSlice/update_measure_status", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      editId,
      status,
      queriesjson,
      data,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          editId = payload.editId, status = payload.status;
          queriesjson = [{
            "db_name": dbName,
            "entity": "VitalsMeasureCodes",
            "filter": "VitalsMeasureCodes._id==\"".concat(editId, "\""),
            "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
            "doc": {
              "status": status
            }
          }];
          _context3.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __update__);

        case 7:
          data = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          alert(_context3.t0.message);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 15:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 11]]);
})));
var vitalsMeasureCodeSlice = toolkit.createSlice({
  name: "measureCodeApiSlice",
  initialState: {
    meadure_code_list: _objectSpread2({}, defaultState.List),
    save_measure_code: _objectSpread2({}, defaultState.Info),
    update_measure_status: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$l = {}, _defineProperty(_extraReducers$l, GET_VITALS_MEASURE_CODE.fulfilled, function (state, action) {
    state.meadure_code_list.loading = false, state.meadure_code_list.error = false, state.meadure_code_list = action.payload;
  }), _defineProperty(_extraReducers$l, GET_VITALS_MEASURE_CODE.pending, function (state, action) {
    state.meadure_code_list.loading = true, state.meadure_code_list.error = false, state.meadure_code_list.loading = true;
  }), _defineProperty(_extraReducers$l, GET_VITALS_MEASURE_CODE.rejected, function (state, action) {
    state.meadure_code_list.loading = false, state.meadure_code_list.error = true, state.meadure_code_list = action.payload;
  }), _defineProperty(_extraReducers$l, UPSERT_MEASURE_CODE.fulfilled, function (state, action) {
    state.save_measure_code.loading = false, state.save_measure_code.error = false, state.save_measure_code = action.payload;
  }), _defineProperty(_extraReducers$l, UPSERT_MEASURE_CODE.pending, function (state, action) {
    state.save_measure_code.loading = true, state.save_measure_code.error = false, state.save_measure_code.loading = true;
  }), _defineProperty(_extraReducers$l, UPSERT_MEASURE_CODE.rejected, function (state, action) {
    state.save_measure_code.loading = false, state.save_measure_code.error = true, state.save_measure_code = action.payload;
  }), _defineProperty(_extraReducers$l, UPDATE_MEASURE_CODE_STATUS.fulfilled, function (state, action) {
    state.update_measure_status.loading = false, state.update_measure_status.error = false, state.update_measure_status = action.payload;
  }), _defineProperty(_extraReducers$l, UPDATE_MEASURE_CODE_STATUS.pending, function (state, action) {
    state.update_measure_status.loading = true, state.update_measure_status.error = false, state.update_measure_status.loading = true;
  }), _defineProperty(_extraReducers$l, UPDATE_MEASURE_CODE_STATUS.rejected, function (state, action) {
    state.update_measure_status.loading = false, state.update_measure_status.error = true, state.update_measure_status = action.payload;
  }), _extraReducers$l)
});
var vitalsMeasureCodeActions = {
  GET_VITALS_MEASURE_CODE: GET_VITALS_MEASURE_CODE,
  UPSERT_MEASURE_CODE: UPSERT_MEASURE_CODE,
  UPDATE_MEASURE_CODE_STATUS: UPDATE_MEASURE_CODE_STATUS
};
var vitalsMeasureCodeSlice$1 = vitalsMeasureCodeSlice.reducer;

var query$5 = {
  entityName: function entityName(data) {
    return {
      db_name: dbName,
      entity: "Organization",
      sort: "Organization.name",
      filter: "Organization.OrgType==['".concat(data, "'] && Organization.activestatus==true"),
      return_fields: "Organization"
    };
  },
  entityType: "{ \n                \"db_name\": \"".concat(dbName, "\",\n                \"entity\": \"CodeableConceptMaster\",\n                 \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n                \"filter\": \"CodeableConceptMaster.Type=='ORGTYPE' AND CodeableConceptMaster.activestatus==true\",\n                \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n              }"),
  gender: "{\n            \"db_name\": \"".concat(dbName, "\",\n            \"entity\": \"CodeableConceptMaster\",\n            \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n            \"filter\": \"CodeableConceptMaster.Type=='GENDER' AND CodeableConceptMaster.activestatus==true\",\n            \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n          }"),
  specialityCodeOrgId: function specialityCodeOrgId(data) {
    return {
      // db_name: dbName,
      // entity: "HealthcareService,CodeableConceptMaster",
      // filter: {
      //   HealthcareService: `HealthcareService.OrgID==${data.id}`,
      //   CodeableConceptMaster:
      //     "CodeableConceptMaster.id IN HealthcareService.SpecialtyID AND CodeableConceptMaster.Type=='SPECIALTY'",
      // },
      // sort: "document(CodeableConceptMaster.coding[0]).display",
      // return_fields:
      //   "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})",
      db_name: dbName,
      entity: "Organization",
      filter: "Organization.id==".concat(data.id, " && Organization.activestatus==true"),
      return_fields: " DOCUMENT(Organization.specialtyDetails[0].specialty)"
    };
  },
  specialityCode: "{\n                    \"db_name\": \"".concat(dbName, "\",\n                    \"entity\": \"HealthcareService,CodeableConceptMaster\",\n                    \"filter\":{\"CodeableConceptMaster\":\"CodeableConceptMaster.id IN HealthcareService.SpecialtyID AND CodeableConceptMaster.Type=='SPECIALTY'\"},\n                    \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n                  }"),
  diagnosis: "{\n                \"db_name\": \"".concat(dbName, "\",\n                \"entity\": \"Diagnosis\",\n                \"filter\": \"Diagnosis.activestatus==true\",\n                \"return_fields\": \"{'_id':Diagnosis._id,'icdcode':Diagnosis.icdcode,'icdname':Diagnosis.icdname,'parenticdcode':Diagnosis.parenticdcode}\"\n              }"),
  ageRanges: "{\n                \"db_name\": \"".concat(dbName, "\",\n                \"entity\": \"AgeRanges\",\n                \"filter\": {\n                \"AgeRanges\":\"AgeRanges.activestatus==true \"\n                },\n                \"sort\":\"AgeRanges.agerangecode\",\n                \"return_fields\": \"{'AgeRangesDtl':AgeRanges,'AgeCategoryDtl':DOCUMENT(AgeRanges.AgeCategory)}\"\n              }"),
  vitalcode: "{\n              \"db_name\": \"".concat(dbName, "\",\n              \"entity\": \"VitalsCodes\",\n              \"sort\":\"VitalsCodes.vitalscode\",\n              \"filter\": \"VitalsCodes.activestatus==true and VitalsCodes.status==true\",\n              \"return_fields\": \"{'id':VitalsCodes._id,'obscode':VitalsCodes.vitalscode,'shortdesc':VitalsCodes.shortdesc,'longdesc':VitalsCodes.longdesc,'_id':VitalsCodes._id}\"\n              }"),
  ageCategory: function ageCategory(ageRangeId) {
    return {
      db_name: dbName,
      entity: "AgeRanges",
      sort: "AgeRanges.agerangecode",
      filter: {
        AgeRanges: "AgeRanges.activestatus==true && AgeRanges._id=='".concat(ageRangeId, "' ")
      },
      return_fields: "DOCUMENT( AgeRanges.AgeCategory)"
    };
  },
  VitalApplicableRead: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"VitalsApplbyPatAtrrib\",\n  \"sort\":\"VitalsApplbyPatAtrrib.createddate\",\n  \"filter\": \"VitalsApplbyPatAtrrib.activestatus==true\",\n  \"return_fields\": \"merge(VitalsApplbyPatAtrrib,{organization_id:(document(VitalsApplbyPatAtrrib.organization_id)),gender:(FOR cod IN CodeableConceptMaster filter cod._id==VitalsApplbyPatAtrrib.gender RETURN MERGE(cod,{coding:(FOR d IN TO_ARRAY(cod.coding) RETURN DOCUMENT(d).display)})),spltycode:(FOR cod IN CodeableConceptMaster filter cod._id==VitalsApplbyPatAtrrib.spltycode RETURN MERGE(cod,{coding:(FOR d IN TO_ARRAY(cod.coding) RETURN DOCUMENT(d))})),diagcode:(document(VitalsApplbyPatAtrrib.diagcode)),agecategorycode:(document(VitalsApplbyPatAtrrib.agecategorycode)),agerangecode:(document(VitalsApplbyPatAtrrib.agerangecode)),orgEntityType:(document(VitalsApplbyPatAtrrib.orgEntityType))})\"\n}"),
  editVitalApplicable: function editVitalApplicable(id) {
    return {
      db_name: dbName,
      entity: "VitalsApplbyPatAtrrib",
      filter: "VitalsApplbyPatAtrrib.activestatus==true && VitalsApplbyPatAtrrib._key=='".concat(id.split("/")[1], "'"),
      return_fields: "merge(VitalsApplbyPatAtrrib,{organization_id:(document(VitalsApplbyPatAtrrib.organization_id)),gender:(FOR cod IN CodeableConceptMaster filter cod._id==VitalsApplbyPatAtrrib.gender RETURN MERGE(cod,{coding:(FOR d IN TO_ARRAY(cod.coding) RETURN DOCUMENT(d).display)})),spltycode:(FOR cod IN CodeableConceptMaster filter cod._id==VitalsApplbyPatAtrrib.spltycode RETURN MERGE(cod,{coding:(FOR d IN TO_ARRAY(cod.coding) RETURN DOCUMENT(d))})),diagcode:(document(VitalsApplbyPatAtrrib.diagcode)),agecategorycode:(document(VitalsApplbyPatAtrrib.agecategorycode)),agerangecode:(document(VitalsApplbyPatAtrrib.agerangecode)),orgEntityType:(document(VitalsApplbyPatAtrrib.orgEntityType))})"
    };
  },
  Diagnosis: function Diagnosis(input_text, encounterId) {
    return {
      db_name: dbName,
      entity: "CA_Diagnosis",
      filter: "CA_Diagnosis.encounter_id=='".concat(encounterId, "' && CA_Diagnosis.activestatus==true"),
      return_fields: "{'_id':CA_Diagnosis._id,'icdcode':document(CA_Diagnosis.diagcode).icdcode,'icdname':document(CA_Diagnosis.diagcode).icdname,'parenticdcode':document(CA_Diagnosis.diagcode).parenticdcode}"
    }; // return {
    //   db_name: dbName,
    //   entity: "Diagnosis",
    //   filter: `Diagnosis.icdname LIKE '%${input_text}%' && CA_Diagnosis.encounter_id=='${encounterId}'`,
    //   return_fields:
    //     "{'_id':Diagnosis._id,'icdcode':Diagnosis.icdcode,'icdname':Diagnosis.icdname,'parenticdcode':Diagnosis.parenticdcode}",
    // };
  }
};

var generateSaveJSON$1 = function generateSaveJSON(data) {
  var diagnosis_arr = [];

  if (data.diagnosisGroup && data.diagnosisGroup.length > 0) {
    diagnosis_arr = data.diagnosisGroup.map(function (v) {
      return v.value;
    });
  }

  var filter = {};

  if (data.editData) {
    filter = {
      filter: {
        _id: data.editData
      }
    };
  }

  return [_objectSpread2(_objectSpread2({
    db_name: dbName,
    entity: "VitalsApplbyPatAtrrib"
  }, filter), {}, {
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
    doc: {
      organization_id: data.entityName.value ? data.entityName.value : "",
      orgEntityType: data.entityType.value ? data.entityType.value : "",
      gender: data.gender.value ? data.gender.value : "",
      spltycode: data.specialCode && data.specialCode.value ? data.specialCode.value : "",
      diagcode: diagnosis_arr,
      agerangecode: data.ageRange.value ? data.ageRange.value : "",
      Observations: generateApplicability(data.applicability) ? generateApplicability(data.applicability) : [],
      id: 0,
      agecategorycode: [data.ageCategory.value],
      status: data.status
    }
  })];
}; //JSON for saving table

var generateApplicability = function generateApplicability(table) {
  var arr = table.map(function (v) {
    return {
      obscode: v.code.value,
      obsseq: v.sequences ? parseInt(v.sequences) : 0,
      mandatoryYN: v.mandatoryBoolean
    };
  });
  return arr;
}; //for table response (readJSon)


var generateApplicableResJson = function generateApplicableResJson(data, state) {
  var TableData = data.sort(function (a, b) {
    return (a === null || a === void 0 ? void 0 : a.createddate) - (b === null || b === void 0 ? void 0 : b.createddate);
  });
  var list = TableData.map(function (val) {
    return {
      specialCode: val.spltycode.length > 0 ? val.spltycode[0].coding[0].display : "",
      diagnosisGroup: GetDiagnosis(val.diagcode),
      gender: val.gender.length > 0 ? val.gender[0].coding[0] : "",
      status: val.status,
      ageRange: val.agerangecode.agerangecode,
      ageCategory: val.agecategorycode[0].code,
      _id: val._id
    };
  });
  return list;
}; //to get Diagnosis value for array

var GetDiagnosis = function GetDiagnosis(diag, state) {
  // let diagnosisGroup = state.dignosis.data.filter(({ value: id1 }) =>
  //   diag.some(({ _id: id2 }) => id2 === id1)
  // );
  var obj = {};
  diag.forEach(function (element) {
    var DigCode = element._id;
    obj[DigCode] = element.icdname;
  });
  var value = Object.values(obj);
  return value.toString();
}; //for status update


var generateApplicableUpdateJSON = function generateApplicableUpdateJSON(editID, Status) {
  return [{
    db_name: dbName,
    entity: "VitalsApplbyPatAtrrib",
    filter: {
      _id: editID
    },
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
    doc: {
      status: Status
    }
  }];
}; //for edit read JSON

var generateApplicableReadResJson = function generateApplicableReadResJson(data, state) {
  var list = data.map(function (v) {
    return {
      entityName: {
        label: v.organization_id.name,
        value: v.organization_id._id
      },
      entityType: v.orgEntityType ? state.entity_type.data.find(function (sys) {
        return v.orgEntityType && v.orgEntityType._id && v.orgEntityType._id.indexOf(sys.value) > -1 ? v.orgEntityType._id.indexOf(sys.value) > -1 : null;
      }) : null,
      specialCode: state.speciality_code.data.find(function (_ref) {
        var id1 = _ref.value;
        return v.spltycode.some(function (_ref2) {
          var id2 = _ref2._id;
          return id2 === id1;
        });
      }),
      gender: state.gender.data.find(function (_ref3) {
        var id1 = _ref3.value;
        return v.gender.some(function (_ref4) {
          var id2 = _ref4._id;
          return id2 === id1;
        });
      }),
      // diagnosisGroup: state.dignosis.data.filter(({ value: id1 }) =>
      //   v.diagcode.some(({ _id: id2 }) => id2 === id1)
      // ),
      diagnosisGroup: getDiagGroup(v.diagcode),
      ageRange: v.agerangecode ? state.ageranges_code.data.find(function (sys) {
        return v.agerangecode._id.indexOf(sys.value) > -1;
      }) : null,
      ageCategoryres: v.agecategorycode,
      status: v.status,
      editData: v._id,
      applicability: generateApplicableTable(v.Observations, state)
    };
  });
  return list;
}; //get diaggroup

var getDiagGroup = function getDiagGroup(data) {
  var arr = data.map(function (v) {
    return {
      label: v.icdname,
      value: v._id
    };
  });
  return arr;
}; //for edit / read form table reference


var generateApplicableTable = function generateApplicableTable(table, state) {
  var arr = table.map(function (v) {
    return {
      code: state.vital_code.data.find(function (sys) {
        return v.obscode.indexOf(sys.value) > -1;
      }),
      sequences: v.obsseq,
      mandatory: v.mandatoryYN === true ? "Yes" : "No",
      mandatoryBoolean: v.mandatoryYN
    };
  });
  return arr;
};

var _extraReducers$k;
var GET_ENTITY_NAME = toolkit.createAsyncThunk("vitalApplicableApiSlice/entityName", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      list,
      data,
      arr,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          list = payload.list;
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(query$5.entityName(list))
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          arr = [];
          data.result.map(function (val) {
            arr.push(_objectSpread2({
              value: val._id,
              label: val.name
            }, val));
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 12]]);
})));
var GET_ENTITY_TYPE_VITALAPP = toolkit.createAsyncThunk("vitalApplicableApiSlice/entityType", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var _ref4,
      rejectWithValue,
      data,
      arr,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          _context2.next = 5;
          return fetchData({
            body: query$5.entityType
          }, __readDocumentUrl__);

        case 5:
          data = _context2.sent;
          arr = [];
          data.result.map(function (val) {
            arr.push({
              value: val.coding[0]._id,
              label: val.coding[0].display
            });
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var VITAL_CODE = toolkit.createAsyncThunk("vitalApplicableApiSlice/vitalCode", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var _ref6,
      rejectWithValue,
      data,
      arr,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          _context3.next = 5;
          return fetchData({
            body: query$5.vitalcode
          }, __readDocumentUrl__);

        case 5:
          data = _context3.sent;
          arr = [];
          data.result.map(function (val) {
            arr.push({
              value: val._id,
              label: val.obscode
            });
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 11]]);
})));
var GENDER = toolkit.createAsyncThunk("vitalApplicableApiSlice/gender", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var _ref8,
      rejectWithValue,
      data,
      arr,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          _context4.next = 5;
          return fetchData({
            body: query$5.gender
          }, __readDocumentUrl__);

        case 5:
          data = _context4.sent;
          arr = [];
          data && data.result.map(function (val) {
            if (val.coding[0] !== null) arr.push({
              value: val._id,
              label: val.coding[0].display
            });
          });
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 11]]);
})));
var SPECIALITY_CODE = toolkit.createAsyncThunk("vitalApplicableApiSlice/specialityCode", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var _ref10,
      rejectWithValue,
      data,
      arr,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          _context5.next = 5;
          return fetchData({
            body: query$5.specialityCode
          }, __readDocumentUrl__);

        case 5:
          data = _context5.sent;
          arr = [];
          data && data.result.map(function (val) {
            if (val.coding[0] !== null) arr.push({
              value: val._id,
              label: val.coding[0].display
            });
          });
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 11]]);
})));
var DIAGNOSIS = toolkit.createAsyncThunk("vitalApplicableApiSlice/diagnosis", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var _ref12,
      rejectWithValue,
      data,
      arr,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          _context6.next = 5;
          return fetchData({
            body: query$5.diagnosis
          }, __readDocumentUrl__);

        case 5:
          data = _context6.sent;
          arr = [];
          data.result.map(function (val) {
            arr.push({
              value: val._id,
              label: val.icdname
            });
          });
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 14:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 11]]);
})));
var DIAGNOSIS_MASTERS = toolkit.createAsyncThunk("vitalApplicableApiSlice/diagnosisMaster", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      input_text,
      enId,
      data,
      arr,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          input_text = payload.input_text, enId = payload.enId;
          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(query$5.Diagnosis(input_text, enId))
          }, __readDocumentUrl__);

        case 6:
          data = _context7.sent;
          arr = [];
          data.result.map(function (val) {
            arr.push({
              value: val._id,
              label: val.icdname
            });
          });
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 15:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 12]]);
})));
var AGE_RANGES_CODE = toolkit.createAsyncThunk("vitalApplicableApiSlice/agerangesCode", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var _ref16,
      rejectWithValue,
      data,
      arr,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _ref16 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref16.rejectWithValue;
          _context8.prev = 2;
          _context8.next = 5;
          return fetchData({
            body: query$5.ageRanges
          }, __readDocumentUrl__);

        case 5:
          data = _context8.sent;
          arr = [];
          data.result.map(function (val) {
            arr.push({
              value: val.AgeRangesDtl._id,
              label: val.AgeRangesDtl.agerangecode
            });
          });
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 14:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 11]]);
})));
var AGE_RANGES_CATEGORY = toolkit.createAsyncThunk("vitalApplicableApiSlice/agerangesCategory", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref18,
      rejectWithValue,
      ageRangeId,
      data,
      arr,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref18 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref18.rejectWithValue;
          _context9.prev = 2;
          ageRangeId = payload.ageRangeId;
          _context9.next = 6;
          return fetchData({
            body: JSON.stringify(query$5.ageCategory(ageRangeId))
          }, __readDocumentUrl__);

        case 6:
          data = _context9.sent;
          arr = [];
          data.result[0].map(function (val) {
            arr.push({
              value: val._id,
              label: val.code,
              minAge: val.age_minimum,
              maxAge: val.age_maximum
            });
          });
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context9.prev = 12;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 15:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 12]]);
})));
var SAVE_VITAL_APPLICABLE = toolkit.createAsyncThunk("vitalApplicableApiSlice/savevitalapplicable", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref20,
      rejectWithValue,
      list,
      body,
      data,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref20 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref20.rejectWithValue;
          _context10.prev = 2;
          list = payload.list;
          body = generateSaveJSON$1(list);
          _context10.next = 7;
          return fetchData({
            body: JSON.stringify(body)
          }, __uspsertUrl__);

        case 7:
          data = _context10.sent;
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context10.prev = 11;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 14:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 11]]);
})));
var READ_VITAL_APPLICABLE = toolkit.createAsyncThunk("vitalApplicableApiSlice/vitalsapplicableread", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var _ref22,
      rejectWithValue,
      getState,
      state,
      data,
      res,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _ref22 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref22.rejectWithValue, getState = _ref22.getState;
          _context11.prev = 2;
          state = getState();
          state.vitalsApplicableSlice; //  const diagnosis = await fetchData(
          //    { body: query.diagnosis },
          //    __readDocumentUrl__
          //  );

          _context11.next = 7;
          return fetchData({
            body: query$5.VitalApplicableRead
          }, __readDocumentUrl__);

        case 7:
          data = _context11.sent;
          res = generateApplicableResJson(data.result);
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 12:
          _context11.prev = 12;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 15:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 12]]);
})));
var UPDATE_VITAL_APPLICABLE_STATUS = toolkit.createAsyncThunk("vitalApplicableApiSlice/vitalsApplicableUpdate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var payload,
      _ref24,
      rejectWithValue,
      editId,
      status,
      body,
      data,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
          _ref24 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref24.rejectWithValue;
          _context12.prev = 2;
          editId = payload.editId, status = payload.status;
          body = generateApplicableUpdateJSON(editId, status);
          _context12.next = 7;
          return fetchData({
            body: JSON.stringify(body)
          }, __uspsertUrl__);

        case 7:
          data = _context12.sent;
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context12.prev = 11;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 14:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 11]]);
})));
var EDIT_VITAL_APPLICABLE = toolkit.createAsyncThunk("vitalsApplicableSlice/editvitalApplicable", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
  var payload,
      _ref26,
      rejectWithValue,
      getState,
      id,
      state,
      ccState,
      data,
      res,
      _args13 = arguments;

  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          payload = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {};
          _ref26 = _args13.length > 1 ? _args13[1] : undefined, rejectWithValue = _ref26.rejectWithValue, getState = _ref26.getState;
          _context13.prev = 2;
          id = payload.id;
          state = getState();
          ccState = state.vitalsApplicableSlice;
          _context13.next = 8;
          return fetchData({
            body: JSON.stringify(query$5.editVitalApplicable(id))
          }, __readDocumentUrl__);

        case 8:
          data = _context13.sent;
          res = generateApplicableReadResJson(data.result, ccState);
          return _context13.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 13:
          _context13.prev = 13;
          _context13.t0 = _context13["catch"](2);
          return _context13.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context13.t0.message
          })));

        case 16:
        case "end":
          return _context13.stop();
      }
    }
  }, _callee13, null, [[2, 13]]);
})));
var SPECIALITY_CODE_ORG_ID = toolkit.createAsyncThunk("vitalApplicableApiSlice/specialityCodeOrgid", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
  var payload,
      _ref28,
      rejectWithValue,
      orgId,
      data,
      arr,
      _args14 = arguments;

  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          payload = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : {};
          _ref28 = _args14.length > 1 ? _args14[1] : undefined, rejectWithValue = _ref28.rejectWithValue;
          _context14.prev = 2;
          orgId = {
            id: payload.org_id
          };
          _context14.next = 6;
          return fetchData({
            body: JSON.stringify(query$5.specialityCodeOrgId(orgId))
          }, __readDocumentUrl__);

        case 6:
          data = _context14.sent;
          arr = [];
          data && data.result.map(function (val) {
            if (val !== "null") arr.push({
              value: val === null || val === void 0 ? void 0 : val._id,
              label: val === null || val === void 0 ? void 0 : val.display
            });
          });
          return _context14.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context14.prev = 12;
          _context14.t0 = _context14["catch"](2);
          return _context14.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context14.t0.message
          })));

        case 15:
        case "end":
          return _context14.stop();
      }
    }
  }, _callee14, null, [[2, 12]]);
})));
var vitalsApplicableSlice = toolkit.createSlice({
  name: "vitalApplicableApiSlice",
  initialState: {
    entity_name: _objectSpread2({}, defaultState.List),
    entity_type: _objectSpread2({}, defaultState.List),
    gender: _objectSpread2({}, defaultState.List),
    speciality_code: _objectSpread2({}, defaultState.List),
    dignosis: _objectSpread2({}, defaultState.List),
    dignosis_master: _objectSpread2({}, defaultState.List),
    ageranges_code: _objectSpread2({}, defaultState.List),
    ageranges_category: _objectSpread2({}, defaultState.List),
    vital_code: _objectSpread2({}, defaultState.List),
    save_vital_applicable: _objectSpread2({}, defaultState.Info),
    read_vital_applicable: _objectSpread2({}, defaultState.List),
    update_applicable_status: _objectSpread2({}, defaultState.List),
    edit_vital_applicable: _objectSpread2({}, defaultState.List),
    speciality_code_org: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$k = {}, _defineProperty(_extraReducers$k, GET_ENTITY_NAME.fulfilled, function (state, action) {
    state.entity_name.loading = false, state.entity_name.error = false, state.entity_name = action.payload;
  }), _defineProperty(_extraReducers$k, GET_ENTITY_NAME.pending, function (state, action) {
    state.entity_name.loading = true, state.entity_name.error = false, state.entity_name.loading = true;
  }), _defineProperty(_extraReducers$k, GET_ENTITY_NAME.rejected, function (state, action) {
    state.entity_name.loading = false, state.entity_name.error = true, state.entity_name = action.payload;
  }), _defineProperty(_extraReducers$k, GET_ENTITY_TYPE_VITALAPP.fulfilled, function (state, action) {
    state.entity_type.loading = false, state.entity_type.error = false, state.entity_type = action.payload;
  }), _defineProperty(_extraReducers$k, GET_ENTITY_TYPE_VITALAPP.pending, function (state, action) {
    state.entity_type.loading = true, state.entity_type.error = false, state.entity_type.loading = true;
  }), _defineProperty(_extraReducers$k, GET_ENTITY_TYPE_VITALAPP.rejected, function (state, action) {
    state.entity_type.loading = false, state.entity_type.error = true, state.entity_type = action.payload;
  }), _defineProperty(_extraReducers$k, GENDER.fulfilled, function (state, action) {
    state.gender.loading = false, state.gender.error = false, state.gender = action.payload;
  }), _defineProperty(_extraReducers$k, GENDER.pending, function (state, action) {
    state.gender.loading = true, state.gender.error = false, state.gender.loading = true;
  }), _defineProperty(_extraReducers$k, GENDER.rejected, function (state, action) {
    state.gender.loading = false, state.gender.error = true, state.gender = action.payload;
  }), _defineProperty(_extraReducers$k, SPECIALITY_CODE.fulfilled, function (state, action) {
    state.speciality_code.loading = false, state.speciality_code.error = false, state.speciality_code = action.payload;
  }), _defineProperty(_extraReducers$k, SPECIALITY_CODE.pending, function (state, action) {
    state.speciality_code.loading = true, state.speciality_code.error = false, state.speciality_code.loading = true;
  }), _defineProperty(_extraReducers$k, SPECIALITY_CODE.rejected, function (state, action) {
    state.speciality_code.loading = false, state.speciality_code.error = true, state.speciality_code = action.payload;
  }), _defineProperty(_extraReducers$k, DIAGNOSIS.fulfilled, function (state, action) {
    state.dignosis.loading = false, state.dignosis.error = false, state.dignosis = action.payload;
  }), _defineProperty(_extraReducers$k, DIAGNOSIS.pending, function (state, action) {
    state.dignosis.loading = true, state.dignosis.error = false, state.dignosis.loading = true;
  }), _defineProperty(_extraReducers$k, DIAGNOSIS.rejected, function (state, action) {
    state.dignosis.loading = false, state.dignosis.error = true, state.dignosis = action.payload;
  }), _defineProperty(_extraReducers$k, DIAGNOSIS_MASTERS.fulfilled, function (state, action) {
    state.dignosis_master.loading = false, state.dignosis_master.error = false, state.dignosis_master = action.payload;
  }), _defineProperty(_extraReducers$k, DIAGNOSIS_MASTERS.pending, function (state, action) {
    state.dignosis_master.loading = true, state.dignosis_master.error = false, state.dignosis_master.loading = true;
  }), _defineProperty(_extraReducers$k, DIAGNOSIS_MASTERS.rejected, function (state, action) {
    state.dignosis_master.loading = false, state.dignosis_master.error = true, state.dignosis_master = action.payload;
  }), _defineProperty(_extraReducers$k, AGE_RANGES_CODE.fulfilled, function (state, action) {
    state.ageranges_code.loading = false, state.ageranges_code.error = false, state.ageranges_code = action.payload;
  }), _defineProperty(_extraReducers$k, AGE_RANGES_CODE.pending, function (state, action) {
    state.ageranges_code.loading = true, state.ageranges_code.error = false, state.ageranges_code.loading = true;
  }), _defineProperty(_extraReducers$k, AGE_RANGES_CODE.rejected, function (state, action) {
    state.ageranges_code.loading = false, state.ageranges_code.error = true, state.ageranges_code = action.payload;
  }), _defineProperty(_extraReducers$k, AGE_RANGES_CATEGORY.fulfilled, function (state, action) {
    state.ageranges_category.loading = false, state.ageranges_category.error = false, state.ageranges_category = action.payload;
  }), _defineProperty(_extraReducers$k, AGE_RANGES_CATEGORY.pending, function (state, action) {
    state.ageranges_category.loading = true, state.ageranges_category.error = false, state.ageranges_category.loading = true;
  }), _defineProperty(_extraReducers$k, AGE_RANGES_CATEGORY.rejected, function (state, action) {
    state.ageranges_category.loading = false, state.ageranges_category.error = true, state.ageranges_category = action.payload;
  }), _defineProperty(_extraReducers$k, VITAL_CODE.fulfilled, function (state, action) {
    state.vital_code.loading = false, state.vital_code.error = false, state.vital_code = action.payload;
  }), _defineProperty(_extraReducers$k, VITAL_CODE.pending, function (state, action) {
    state.vital_code.loading = true, state.vital_code.error = false, state.vital_code.loading = true;
  }), _defineProperty(_extraReducers$k, VITAL_CODE.rejected, function (state, action) {
    state.vital_code.loading = false, state.vital_code.error = true, state.vital_code = action.payload;
  }), _defineProperty(_extraReducers$k, SAVE_VITAL_APPLICABLE.fulfilled, function (state, action) {
    state.save_vital_applicable.loading = false, state.save_vital_applicable.error = false, state.save_vital_applicable = action.payload;
  }), _defineProperty(_extraReducers$k, SAVE_VITAL_APPLICABLE.pending, function (state, action) {
    state.save_vital_applicable.loading = true, state.save_vital_applicable.error = false, state.save_vital_applicable.loading = true;
  }), _defineProperty(_extraReducers$k, SAVE_VITAL_APPLICABLE.rejected, function (state, action) {
    state.save_vital_applicable.loading = false, state.save_vital_applicable.error = true, state.save_vital_applicable = action.payload;
  }), _defineProperty(_extraReducers$k, READ_VITAL_APPLICABLE.fulfilled, function (state, action) {
    state.read_vital_applicable.loading = false, state.read_vital_applicable.error = false, state.read_vital_applicable = action.payload;
  }), _defineProperty(_extraReducers$k, READ_VITAL_APPLICABLE.pending, function (state, action) {
    state.read_vital_applicable.loading = true, state.read_vital_applicable.error = false, state.read_vital_applicable.loading = true;
  }), _defineProperty(_extraReducers$k, READ_VITAL_APPLICABLE.rejected, function (state, action) {
    state.read_vital_applicable.loading = false, state.read_vital_applicable.error = true, state.read_vital_applicable = action.payload;
  }), _defineProperty(_extraReducers$k, UPDATE_VITAL_APPLICABLE_STATUS.fulfilled, function (state, action) {
    state.update_applicable_status.loading = false, state.update_applicable_status.error = false, state.update_applicable_status = action.payload;
  }), _defineProperty(_extraReducers$k, UPDATE_VITAL_APPLICABLE_STATUS.pending, function (state, action) {
    state.update_applicable_status.loading = true, state.update_applicable_status.error = false, state.update_applicable_status.loading = true;
  }), _defineProperty(_extraReducers$k, UPDATE_VITAL_APPLICABLE_STATUS.rejected, function (state, action) {
    state.update_applicable_status.loading = false, state.update_applicable_status.error = true, state.update_applicable_status = action.payload;
  }), _defineProperty(_extraReducers$k, EDIT_VITAL_APPLICABLE.fulfilled, function (state, action) {
    state.edit_vital_applicable.loading = false, state.edit_vital_applicable.error = false, state.edit_vital_applicable = action.payload;
  }), _defineProperty(_extraReducers$k, EDIT_VITAL_APPLICABLE.pending, function (state, action) {
    state.edit_vital_applicable.loading = true, state.edit_vital_applicable.error = false, state.edit_vital_applicable.loading = true;
  }), _defineProperty(_extraReducers$k, EDIT_VITAL_APPLICABLE.rejected, function (state, action) {
    state.edit_vital_applicable.loading = false, state.edit_vital_applicable.error = true, state.edit_vital_applicable = action.payload;
  }), _defineProperty(_extraReducers$k, SPECIALITY_CODE_ORG_ID.fulfilled, function (state, action) {
    state.speciality_code_org.loading = false, state.speciality_code_org.error = false, state.speciality_code_org = action.payload;
  }), _defineProperty(_extraReducers$k, SPECIALITY_CODE_ORG_ID.pending, function (state, action) {
    state.speciality_code_org.loading = true, state.speciality_code_org.error = false, state.speciality_code_org.loading = true;
  }), _defineProperty(_extraReducers$k, SPECIALITY_CODE_ORG_ID.rejected, function (state, action) {
    state.speciality_code_org.loading = false, state.speciality_code_org.error = true, state.speciality_code_org = action.payload;
  }), _extraReducers$k)
});
var vitalsApplicableActions = {
  GET_ENTITY_NAME: GET_ENTITY_NAME,
  GET_ENTITY_TYPE_VITALAPP: GET_ENTITY_TYPE_VITALAPP,
  GENDER: GENDER,
  SPECIALITY_CODE: SPECIALITY_CODE,
  DIAGNOSIS: DIAGNOSIS,
  AGE_RANGES_CODE: AGE_RANGES_CODE,
  AGE_RANGES_CATEGORY: AGE_RANGES_CATEGORY,
  SAVE_VITAL_APPLICABLE: SAVE_VITAL_APPLICABLE,
  READ_VITAL_APPLICABLE: READ_VITAL_APPLICABLE,
  UPDATE_VITAL_APPLICABLE_STATUS: UPDATE_VITAL_APPLICABLE_STATUS,
  EDIT_VITAL_APPLICABLE: EDIT_VITAL_APPLICABLE,
  VITAL_CODE: VITAL_CODE,
  DIAGNOSIS_MASTERS: DIAGNOSIS_MASTERS,
  SPECIALITY_CODE_ORG_ID: SPECIALITY_CODE_ORG_ID
};
var vitalsApplicableSlice$1 = vitalsApplicableSlice.reducer;

var query$4 = {
  gender: "{\n            \"db_name\": \"".concat(dbName, "\",\n            \"entity\": \"CodeableConceptMaster\",\n            \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n            \"filter\": \"CodeableConceptMaster.Type=='GENDER'\",\n            \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n            }"),
  unitAllowed: "{\n                \"db_name\": \"".concat(dbName, "\",\n                \"entity\": \"VitalsMeasureCodes\",\n                \"sort\":\"VitalsMeasureCodes.ObsValMeasCode\",\n                \"filter\": \"VitalsMeasureCodes.activestatus==true && VitalsMeasureCodes.status==true\",\n                \"return_fields\": \"VitalsMeasureCodes\"\n                }"),
  referenceUnitAllowed: "{\n                        \"db_name\": \"".concat(dbName, "\",\n                        \"entity\": \"CodeableConceptMaster\",\n                        \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n                        \"filter\": \"CodeableConceptMaster.Type=='VITALSUOM'\",\n                        \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n                   }"),
  ageRanges: "{\n                \"db_name\": \"".concat(dbName, "\",\n                \"entity\": \"AgeRanges\",\n                \"filter\": {\n                \"AgeRanges\":\"AgeRanges.activestatus==true \"\n                },\n                \"return_fields\": \"{'AgeRangesDtl':AgeRanges,'AgeCategoryDtl':DOCUMENT(AgeRanges.AgeCategory)}\"\n              }"),
  ageCategory: function ageCategory(ageRangeId) {
    return {
      db_name: dbName,
      entity: "AgeRanges",
      filter: {
        AgeRanges: "AgeRanges.activestatus==true && AgeRanges._id=='".concat(ageRangeId, "' ")
      },
      return_fields: "DOCUMENT( AgeRanges.AgeCategory)"
    };
  },
  category: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"AgeCategory\",\n  \"filter\": \"AgeCategory.activestatus==true\",\n  \"return_fields\": \"{_id:AgeCategory._id, id:AgeCategory.id, code:AgeCategory.code, age_minimum:AgeCategory.age_minimum, age_maximum:AgeCategory.age_maximum, UOM:AgeCategory.UOM}\"\n}"),
  defaultUnit: function defaultUnit(AllowedUnit) {
    return {
      db_name: dbName,
      entity: "VitalsMeasureCodes",
      filter: "VitalsMeasureCodes.activestatus==true && VitalsMeasureCodes._id IN ['".concat(AllowedUnit.join("','"), "']"),
      return_fields: "VitalsMeasureCodes"
    };
  },
  VitalRead: "{\n            \"db_name\": \"".concat(dbName, "\",\n            \"entity\": \"VitalsCodes\",\n            \"sort\":\"VitalsCodes.createddate\",\n            \"filter\": \"VitalsCodes.activestatus==true\",\n            \"return_fields\": \"MERGE(VitalsCodes,{VitalsCodesReferenceRanges:(FOR cod IN VitalsCodes.VitalsCodesReferenceRanges RETURN DOCUMENT(cod))})\"\n          }"),
  deleteVitalMaster: function deleteVitalMaster(id) {
    return {
      db_name: dbName,
      entity: "VitalsCodes",
      filter: "VitalsCodes._id=='".concat(id, "'")
    };
  },
  editVitalmaster: function editVitalmaster(id) {
    return {
      db_name: dbName,
      entity: "VitalsCodes",
      filter: "VitalsCodes.activestatus==true && VitalsCodes._id=='".concat(id, "'"),
      return_fields: "MERGE(VitalsCodes,{VitalsCodesReferenceRanges:(FOR cod IN VitalsCodes.VitalsCodesReferenceRanges RETURN DOCUMENT(cod))})"
    };
  }
};

var categoryJson = function categoryJson(data, state, agecategory) {
  var arr = data.map(function (v) {
    return {
      category: agecategory.find(function (sys) {
        return v._id.indexOf(sys._id) > -1;
      }),
      description: v.description,
      ageMin: v.age_minimum,
      ageMax: v.age_maximum,
      unit: state.reference_unit_allowed.data.find(function (sys) {
        return v.UOM.indexOf(sys.value) > -1;
      }),
      normalMin: "",
      normalMax: "",
      validationMin: "",
      validationMax: ""
    };
  });
  return arr;
}; //for saving/upsert Json

var generateJSON = function generateJSON(data) {
  var unit_arr = data.unitAllowed.map(function (v) {
    return v.value;
  });
  var filter = {};

  if (data.editData) {
    filter = {
      filter: {
        _id: data.editData
      }
    };
  }

  return [_objectSpread2(_objectSpread2({
    db_name: dbName,
    entity: "VitalsCodes"
  }, filter), {}, {
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
    doc: {
      _id: "",
      vitalscode: data.code ? data.code : "",
      shortdesc: data.shortdes ? data.shortdes : "",
      longdesc: data.longdes ? data.longdes : "",
      id: 0,
      status: data.status,
      units_allowed: unit_arr,
      default_unit: data.defaultUnit ? data.defaultUnit.value : "",
      VitalsCodesReferenceRanges: data.reference.length > 0 ? generateCodeReference(data.reference) : []
    }
  })];
}; //JSON for saving table

var generateCodeReference = function generateCodeReference(data) {
  var arr = [];
  data.map(function (val) {
    val.table.map(function (v) {
      arr.push({
        _id: val._id ? val._id : "",
        // obscode: "",
        // obscomp: "",
        gender: val.gender ? val.gender.value : "",
        meaningtype: "",
        raceappliesto: "",
        agecategory: v.category ? v.category._id : "",
        age_minimum: v.ageMin ? parseInt(v.ageMin) : 0,
        age_maximum: v.ageMax ? parseInt(v.ageMax) : 0,
        UOM: val.Unit ? val.Unit.value : "",
        valdatatype: "",
        normal_min: v.normalMin ? parseInt(v.normalMin) : 0,
        normal_max: v.normalMax ? parseInt(v.normalMax) : 0,
        RefValUOM: v.unit ? v.unit.value : "",
        id: 0,
        validation_min: v.validationMin ? parseInt(v.validationMin) : 0,
        validation_max: v.validationMax ? parseInt(v.validationMax) : 0,
        agerangecode: val.ageRange ? val.ageRange.value : ""
      });
    });
  });
  return arr;
}; //for table response (readJSon)


var generateResJson$1 = function generateResJson(data) {
  var TableData = data.sort(function (a, b) {
    return (a === null || a === void 0 ? void 0 : a.createddate) - (b === null || b === void 0 ? void 0 : b.createddate);
  });
  var list = TableData.map(function (val) {
    return _objectSpread2({
      code: val.vitalscode ? val.vitalscode : "",
      "short": val.shortdesc ? val.shortdesc : "",
      "long": val.longdesc ? val.longdesc : "",
      status: val.status ? val.status : false
    }, val);
  });
  return list;
}; //for status update

var generateUpdateJSON$1 = function generateUpdateJSON(editID, Status) {
  return [{
    db_name: dbName,
    entity: "VitalsCodes",
    filter: {
      _id: editID
    },
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
    doc: {
      status: Status
    }
  }];
}; //for edit read JSON

var generateReadResJson$1 = function generateReadResJson(data, state, ageCategory) {
  var list = data.map(function (v) {
    return {
      editData: v._id,
      code: v.vitalscode,
      longdes: v.longdesc,
      shortdes: v.shortdesc,
      status: v.status,
      unitAllowed: state.unit_allowed.data.filter(function (sys) {
        return v.units_allowed.indexOf(sys.value) > -1;
      }),
      defaultUnit: state.unit_allowed.data.find(function (sys) {
        return v.default_unit.indexOf(sys.value) > -1;
      }),
      reference: generateReference(v.VitalsCodesReferenceRanges, state, ageCategory)
    };
  });
  return list;
}; //for edit / read form table reference

var generateReference = function generateReference(ref, state, ageCategory) {
  var obj = {};
  ref.forEach(function (element) {
    var ageRange = element.agerangecode;

    if (ageRange in obj) {
      var tableObj = {
        _id: element._id,
        category: ageCategory.find(function (sys) {
          return element.agecategory.indexOf(sys._id) > -1;
        }),
        ageMin: element.age_minimum,
        ageMax: element.age_maximum,
        unit: state.reference_unit_allowed.data.find(function (sys) {
          return element.UOM.indexOf(sys.value) > -1;
        }),
        normalMin: element.normal_min,
        normalMax: element.normal_max,
        validationMin: element.validation_min,
        validationMax: element.validation_max
      };
      obj[ageRange].table.push(tableObj);
    } else {
      obj[ageRange] = {
        ageRange: state.reference_ageranges.data.find(function (sys) {
          return element.agerangecode.indexOf(sys.value) > -1;
        }),
        gender: state.master_gender.data.find(function (sys) {
          return element.gender.indexOf(sys.value) > -1;
        }),
        // Unit: state.reference_unit_allowed.data.find(
        //   (sys) => element.UOM.indexOf(sys.value) > -1
        // ),
        Unit: state.unit_allowed.data.find(function (sys) {
          return element.UOM.indexOf(sys.value) > -1;
        }),
        table: []
      };
      var _tableObj = {
        _id: element._id,
        category: ageCategory.find(function (sys) {
          return element.agecategory.indexOf(sys._id) > -1;
        }),
        ageMin: element.age_minimum,
        ageMax: element.age_maximum,
        unit: state.reference_unit_allowed.data.find(function (sys) {
          return element.UOM.indexOf(sys.value) > -1;
        }),
        normalMin: element.normal_min,
        normalMax: element.normal_max,
        validationMin: element.validation_min,
        validationMax: element.validation_max
      };
      obj[ageRange].table.push(_tableObj);
    }
  });
  return Object.values(obj);
};

var _extraReducers$j;
var MASTER_GENDER = toolkit.createAsyncThunk("vitalsMasterSectionApiSlice/gender", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      data,
      arr,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return fetchData({
            body: query$4.gender
          }, __readDocumentUrl__);

        case 5:
          data = _context.sent;
          arr = [];
          data && data.result.map(function (val) {
            if (val.coding[0] !== null) arr.push({
              value: val._id,
              label: val.coding[0].display
            });
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var REFERENCE_UNIT_ALLOWED = toolkit.createAsyncThunk("vitalsMasterSectionApiSlice/referenceUnitAllowed", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var _ref4,
      rejectWithValue,
      data,
      arr,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          _context2.next = 5;
          return fetchData({
            body: query$4.referenceUnitAllowed
          }, __readDocumentUrl__);

        case 5:
          data = _context2.sent;
          arr = [];
          data && data.result.map(function (val) {
            arr.push({
              value: val._id,
              label: val.coding[0].display
            });
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var UNIT_ALLOWED = toolkit.createAsyncThunk("vitalsMasterSectionApiSlice/unitAllowed", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var _ref6,
      rejectWithValue,
      data,
      arr,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          _context3.next = 5;
          return fetchData({
            body: query$4.unitAllowed
          }, __readDocumentUrl__);

        case 5:
          data = _context3.sent;
          arr = [];
          data && data.result.map(function (val) {
            arr.push({
              value: val._id,
              label: val.ObsValMeasCode
            });
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 11]]);
})));
var REFERENCE_AGERANGES = toolkit.createAsyncThunk("vitalsMasterSectionApiSlice/agerangesCode", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var _ref8,
      rejectWithValue,
      data,
      arr,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          _context4.next = 5;
          return fetchData({
            body: query$4.ageRanges
          }, __readDocumentUrl__);

        case 5:
          data = _context4.sent;
          arr = [];
          data.result.map(function (val) {
            arr.push({
              value: val.AgeRangesDtl._id,
              label: val.AgeRangesDtl.agerangecode
            });
          });
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 11]]);
})));
var REFERENCE_AGERANGES_CATEGORY = toolkit.createAsyncThunk("vitalsMasterSectionApiSlice/referenceCategory", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      getState,
      ageRangeId,
      state,
      ccState,
      category,
      data,
      res,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue, getState = _ref10.getState;
          _context5.prev = 2;
          ageRangeId = payload.ageRangeId;
          state = getState();
          ccState = state.vitalsMasterSectionSlice;
          _context5.next = 8;
          return fetchData({
            body: query$4.category
          }, __readDocumentUrl__);

        case 8:
          category = _context5.sent;
          _context5.next = 11;
          return fetchData({
            body: JSON.stringify(query$4.ageCategory(ageRangeId))
          }, __readDocumentUrl__);

        case 11:
          data = _context5.sent;
          res = categoryJson(data.result[0], ccState, category.result);
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 16:
          _context5.prev = 16;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 19:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 16]]);
})));
var DEFAULT_UNIT = toolkit.createAsyncThunk("vitalsMasterSectionApiSlice/defaultunit", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref12,
      rejectWithValue,
      AllowedUnit,
      data,
      arr,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          AllowedUnit = payload.AllowedUnit;
          _context6.next = 6;
          return fetchData({
            body: JSON.stringify(query$4.defaultUnit(AllowedUnit))
          }, __readDocumentUrl__);

        case 6:
          data = _context6.sent;
          arr = [];
          data && data.result.map(function (val) {
            arr.push({
              value: val._id,
              label: val.ObsValMeasCode
            });
          });
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 15:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 12]]);
})));
var SAVE_VITAL_MASTER = toolkit.createAsyncThunk("vitalsMasterSectionApiSlice/savevitalmaster", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      list,
      body,
      data,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          list = payload.list;
          body = generateJSON(list);
          _context7.next = 7;
          return fetchData({
            body: JSON.stringify(body)
          }, __uspsertUrl__);

        case 7:
          data = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context7.prev = 11;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 14:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 11]]);
})));
var READ_VITAL_MASTER = toolkit.createAsyncThunk("vitalsMasterSectionApiSlice/vitalsMasterread", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var _ref16,
      rejectWithValue,
      data,
      res,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _ref16 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref16.rejectWithValue, _ref16.getState;
          _context8.prev = 2;
          _context8.next = 5;
          return fetchData({
            body: query$4.VitalRead
          }, __readDocumentUrl__);

        case 5:
          data = _context8.sent;
          res = generateResJson$1(data.result);
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 10:
          _context8.prev = 10;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 13:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 10]]);
})));
var UPDATE_VITAL_MASTER_STATUS = toolkit.createAsyncThunk("vitalsMasterSectionApiSlice/vitalsMasterUpdate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref18,
      rejectWithValue,
      editId,
      status,
      body,
      data,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref18 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref18.rejectWithValue;
          _context9.prev = 2;
          editId = payload.editId, status = payload.status;
          body = generateUpdateJSON$1(editId, status);
          _context9.next = 7;
          return fetchData({
            body: JSON.stringify(body)
          }, __uspsertUrl__);

        case 7:
          data = _context9.sent;
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context9.prev = 11;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 14:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 11]]);
})));
var DELETE_VITAL_MASTER = toolkit.createAsyncThunk("vitalsMasterSectionApiSlice/vitalMasterDelete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref20,
      rejectWithValue,
      id,
      data,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref20 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref20.rejectWithValue;
          _context10.prev = 2;
          id = payload.id;
          _context10.next = 6;
          return fetchData({
            body: query$4.deleteVitalMaster(id)
          }, __softDelete__);

        case 6:
          data = _context10.sent;
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context10.prev = 10;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 13:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 10]]);
})));
var EDIT_VITAL_MASTER = toolkit.createAsyncThunk("vitalsMasterSectionApiSlice/editvitalMaster", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var payload,
      _ref22,
      rejectWithValue,
      getState,
      id,
      state,
      ccState,
      category,
      data,
      res,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
          _ref22 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref22.rejectWithValue, getState = _ref22.getState;
          _context11.prev = 2;
          id = payload.id;
          state = getState();
          ccState = state.vitalsMasterSectionSlice;
          _context11.next = 8;
          return fetchData({
            body: query$4.category
          }, __readDocumentUrl__);

        case 8:
          category = _context11.sent;
          _context11.next = 11;
          return fetchData({
            body: JSON.stringify(query$4.editVitalmaster(id))
          }, __readDocumentUrl__);

        case 11:
          data = _context11.sent;
          res = generateReadResJson$1(data.result, ccState, category.result);
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 16:
          _context11.prev = 16;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 19:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 16]]);
})));
var vitalsMasterSectionSlice = toolkit.createSlice({
  name: "vitalsMasterSectionApiSlice",
  initialState: {
    master_gender: _objectSpread2({}, defaultState.List),
    reference_unit_allowed: _objectSpread2({}, defaultState.List),
    unit_allowed: _objectSpread2({}, defaultState.List),
    reference_ageranges: _objectSpread2({}, defaultState.List),
    reference_agerange_category: _objectSpread2({}, defaultState.List),
    default_unit: _objectSpread2({}, defaultState.List),
    save_vital_master: _objectSpread2({}, defaultState.Info),
    vital_master_read: _objectSpread2({}, defaultState.List),
    update_master_status: _objectSpread2({}, defaultState.List),
    delete_vital_master: _objectSpread2({}, defaultState.List),
    edit_vital_master: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$j = {}, _defineProperty(_extraReducers$j, MASTER_GENDER.fulfilled, function (state, action) {
    state.master_gender.loading = false, state.master_gender.error = false, state.master_gender = action.payload;
  }), _defineProperty(_extraReducers$j, MASTER_GENDER.pending, function (state, action) {
    state.master_gender.loading = true, state.master_gender.error = false, state.master_gender.loading = true;
  }), _defineProperty(_extraReducers$j, MASTER_GENDER.rejected, function (state, action) {
    state.master_gender.loading = false, state.master_gender.error = true, state.master_gender = action.payload;
  }), _defineProperty(_extraReducers$j, REFERENCE_UNIT_ALLOWED.fulfilled, function (state, action) {
    state.reference_unit_allowed.loading = false, state.reference_unit_allowed.error = false, state.reference_unit_allowed = action.payload;
  }), _defineProperty(_extraReducers$j, REFERENCE_UNIT_ALLOWED.pending, function (state, action) {
    state.reference_unit_allowed.loading = true, state.reference_unit_allowed.error = false, state.reference_unit_allowed.loading = true;
  }), _defineProperty(_extraReducers$j, REFERENCE_UNIT_ALLOWED.rejected, function (state, action) {
    state.reference_unit_allowed.loading = false, state.reference_unit_allowed.error = true, state.reference_unit_allowed = action.payload;
  }), _defineProperty(_extraReducers$j, UNIT_ALLOWED.fulfilled, function (state, action) {
    state.unit_allowed.loading = false, state.unit_allowed.error = false, state.unit_allowed = action.payload;
  }), _defineProperty(_extraReducers$j, UNIT_ALLOWED.pending, function (state, action) {
    state.unit_allowed.loading = true, state.unit_allowed.error = false, state.unit_allowed.loading = true;
  }), _defineProperty(_extraReducers$j, UNIT_ALLOWED.rejected, function (state, action) {
    state.unit_allowed.loading = false, state.unit_allowed.error = true, state.unit_allowed = action.payload;
  }), _defineProperty(_extraReducers$j, REFERENCE_AGERANGES.fulfilled, function (state, action) {
    state.reference_ageranges.loading = false, state.reference_ageranges.error = false, state.reference_ageranges = action.payload;
  }), _defineProperty(_extraReducers$j, REFERENCE_AGERANGES.pending, function (state, action) {
    state.reference_ageranges.loading = true, state.reference_ageranges.error = false, state.reference_ageranges.loading = true;
  }), _defineProperty(_extraReducers$j, REFERENCE_AGERANGES.rejected, function (state, action) {
    state.reference_ageranges.loading = false, state.reference_ageranges.error = true, state.reference_ageranges = action.payload;
  }), _defineProperty(_extraReducers$j, REFERENCE_AGERANGES_CATEGORY.fulfilled, function (state, action) {
    state.reference_agerange_category.loading = false, state.reference_agerange_category.error = false, state.reference_agerange_category = action.payload;
  }), _defineProperty(_extraReducers$j, REFERENCE_AGERANGES_CATEGORY.pending, function (state, action) {
    state.reference_agerange_category.loading = true, state.reference_agerange_category.error = false, state.reference_agerange_category.loading = true;
  }), _defineProperty(_extraReducers$j, REFERENCE_AGERANGES_CATEGORY.rejected, function (state, action) {
    state.reference_agerange_category.loading = false, state.reference_agerange_category.error = true, state.reference_agerange_category = action.payload;
  }), _defineProperty(_extraReducers$j, DEFAULT_UNIT.fulfilled, function (state, action) {
    state.default_unit.loading = false, state.default_unit.error = false, state.default_unit = action.payload;
  }), _defineProperty(_extraReducers$j, DEFAULT_UNIT.pending, function (state, action) {
    state.default_unit.loading = true, state.default_unit.error = false, state.default_unit.loading = true;
  }), _defineProperty(_extraReducers$j, DEFAULT_UNIT.rejected, function (state, action) {
    state.default_unit.loading = false, state.default_unit.error = true, state.default_unit = action.payload;
  }), _defineProperty(_extraReducers$j, SAVE_VITAL_MASTER.fulfilled, function (state, action) {
    state.save_vital_master.loading = false, state.save_vital_master.error = false, state.save_vital_master = action.payload;
  }), _defineProperty(_extraReducers$j, SAVE_VITAL_MASTER.pending, function (state, action) {
    state.save_vital_master.loading = true, state.save_vital_master.error = false, state.save_vital_master.loading = true;
  }), _defineProperty(_extraReducers$j, SAVE_VITAL_MASTER.rejected, function (state, action) {
    state.save_vital_master.loading = false, state.save_vital_master.error = true, state.save_vital_master = action.payload;
  }), _defineProperty(_extraReducers$j, READ_VITAL_MASTER.fulfilled, function (state, action) {
    state.vital_master_read.loading = false, state.vital_master_read.error = false, state.vital_master_read = action.payload;
  }), _defineProperty(_extraReducers$j, READ_VITAL_MASTER.pending, function (state, action) {
    state.vital_master_read.loading = true, state.vital_master_read.error = false, state.vital_master_read.loading = true;
  }), _defineProperty(_extraReducers$j, READ_VITAL_MASTER.rejected, function (state, action) {
    state.vital_master_read.loading = false, state.vital_master_read.error = true, state.vital_master_read = action.payload;
  }), _defineProperty(_extraReducers$j, UPDATE_VITAL_MASTER_STATUS.fulfilled, function (state, action) {
    state.update_master_status.loading = false, state.update_master_status.error = false, state.update_master_status = action.payload;
  }), _defineProperty(_extraReducers$j, UPDATE_VITAL_MASTER_STATUS.pending, function (state, action) {
    state.update_master_status.loading = true, state.update_master_status.error = false, state.update_master_status.loading = true;
  }), _defineProperty(_extraReducers$j, UPDATE_VITAL_MASTER_STATUS.rejected, function (state, action) {
    state.update_master_status.loading = false, state.update_master_status.error = true, state.update_master_status = action.payload;
  }), _defineProperty(_extraReducers$j, DELETE_VITAL_MASTER.fulfilled, function (state, action) {
    state.delete_vital_master.loading = false, state.delete_vital_master.error = false, state.delete_vital_master = action.payload;
  }), _defineProperty(_extraReducers$j, DELETE_VITAL_MASTER.pending, function (state, action) {
    state.delete_vital_master.loading = true, state.delete_vital_master.error = false, state.delete_vital_master.loading = true;
  }), _defineProperty(_extraReducers$j, DELETE_VITAL_MASTER.rejected, function (state, action) {
    state.delete_vital_master.loading = false, state.delete_vital_master.error = true, state.delete_vital_master = action.payload;
  }), _defineProperty(_extraReducers$j, EDIT_VITAL_MASTER.fulfilled, function (state, action) {
    state.edit_vital_master.loading = false, state.edit_vital_master.error = false, state.edit_vital_master = action.payload;
  }), _defineProperty(_extraReducers$j, EDIT_VITAL_MASTER.pending, function (state, action) {
    state.edit_vital_master.loading = true, state.edit_vital_master.error = false, state.edit_vital_master.loading = true;
  }), _defineProperty(_extraReducers$j, EDIT_VITAL_MASTER.rejected, function (state, action) {
    state.edit_vital_master.loading = false, state.edit_vital_master.error = true, state.edit_vital_master = action.payload;
  }), _extraReducers$j)
});
var vitalsMasterSectionActions = {
  MASTER_GENDER: MASTER_GENDER,
  REFERENCE_UNIT_ALLOWED: REFERENCE_UNIT_ALLOWED,
  UNIT_ALLOWED: UNIT_ALLOWED,
  REFERENCE_AGERANGES: REFERENCE_AGERANGES,
  REFERENCE_AGERANGES_CATEGORY: REFERENCE_AGERANGES_CATEGORY,
  DEFAULT_UNIT: DEFAULT_UNIT,
  SAVE_VITAL_MASTER: SAVE_VITAL_MASTER,
  READ_VITAL_MASTER: READ_VITAL_MASTER,
  UPDATE_VITAL_MASTER_STATUS: UPDATE_VITAL_MASTER_STATUS,
  DELETE_VITAL_MASTER: DELETE_VITAL_MASTER,
  EDIT_VITAL_MASTER: EDIT_VITAL_MASTER
};
var vitalsMasterSectionSlice$1 = vitalsMasterSectionSlice.reducer;

var queries$8 = {
  orderCategoryRead: function orderCategoryRead(_ref) {
    var _ref$isSingle = _ref.isSingle,
        isSingle = _ref$isSingle === void 0 ? false : _ref$isSingle,
        _ref$key = _ref.key,
        key = _ref$key === void 0 ? "" : _ref$key;
    var obj = {
      db_name: dbName,
      entity: "OrderCategory",
      filter: "OrderCategory.activestatus == true",
      return_fields: "OrderCategory",
      sort: "OrderCategory.createddate ASC"
    };

    if (isSingle) {
      obj.filter = "OrderCategory.activestatus == true && OrderCategory._key =='".concat(key, "'");
    }

    return obj;
  },
  orderCategoryUpsert: function orderCategoryUpsert(_ref2) {
    var _ref2$category = _ref2.category,
        category = _ref2$category === void 0 ? "" : _ref2$category,
        _ref2$shortdesc = _ref2.shortdesc,
        shortdesc = _ref2$shortdesc === void 0 ? "" : _ref2$shortdesc,
        _ref2$longdesc = _ref2.longdesc,
        longdesc = _ref2$longdesc === void 0 ? "" : _ref2$longdesc,
        _ref2$status = _ref2.status,
        status = _ref2$status === void 0 ? true : _ref2$status,
        _ref2$id = _ref2.id,
        id = _ref2$id === void 0 ? 0 : _ref2$id,
        _ref2$isUpdate = _ref2.isUpdate,
        isUpdate = _ref2$isUpdate === void 0 ? false : _ref2$isUpdate,
        _ref2$key = _ref2.key,
        key = _ref2$key === void 0 ? "" : _ref2$key;
    var newData = [{
      db_name: dbName,
      entity: "OrderCategory",
      is_metadata: true,
      metadataId: metadataId,
      doc: {
        ordercategory: category,
        shortdesc: shortdesc,
        longdesc: longdesc,
        status: status,
        id: id
      }
    }];

    if (isUpdate) {
      newData[0].filter = {
        _key: key
      };
    }

    return newData;
  },
  orderCategoryStatusUpdate: function orderCategoryStatusUpdate(_ref3) {
    var _ref3$key = _ref3.key,
        key = _ref3$key === void 0 ? "" : _ref3$key,
        _ref3$status = _ref3.status,
        status = _ref3$status === void 0 ? false : _ref3$status;
    var obj = [{
      db_name: dbName,
      entity: "OrderCategory",
      filter: {
        _key: key
      },
      is_metadata: true,
      metadataId: metadataId,
      doc: {
        status: status
      }
    }];
    return obj;
  },
  orderModeRead: function orderModeRead(_ref4) {
    var _ref4$isSingle = _ref4.isSingle,
        isSingle = _ref4$isSingle === void 0 ? false : _ref4$isSingle,
        _ref4$key = _ref4.key,
        key = _ref4$key === void 0 ? "" : _ref4$key;
    var obj = {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      filter: "CodeableConceptMaster.activestatus==true && CodeableConceptMaster.Type=='ORDERMODE'",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };

    if (isSingle) {
      obj.filter = "CodeableConceptMaster.activestatus==true && CodeableConceptMaster._key=='".concat(key, "' && CodeableConceptMaster.Type=='ORDERMODE'");
    }

    return obj;
  },
  orderModeUpsert: function orderModeUpsert(_ref5) {
    var _ref5$code = _ref5.code,
        code = _ref5$code === void 0 ? "" : _ref5$code,
        _ref5$shortdesc = _ref5.shortdesc,
        shortdesc = _ref5$shortdesc === void 0 ? "" : _ref5$shortdesc,
        _ref5$longdesc = _ref5.longdesc,
        longdesc = _ref5$longdesc === void 0 ? "" : _ref5$longdesc,
        _ref5$status = _ref5.status,
        status = _ref5$status === void 0 ? true : _ref5$status,
        _ref5$id = _ref5.id,
        id = _ref5$id === void 0 ? 0 : _ref5$id,
        _ref5$coding_id = _ref5.coding_id,
        coding_id = _ref5$coding_id === void 0 ? 0 : _ref5$coding_id,
        _ref5$isUpdate = _ref5.isUpdate,
        isUpdate = _ref5$isUpdate === void 0 ? false : _ref5$isUpdate,
        _ref5$key = _ref5.key,
        key = _ref5$key === void 0 ? "" : _ref5$key;
    var newData = [{
      db_name: dbName,
      entity: "CodeableConceptMaster",
      is_metadata: true,
      metadataId: metadataId,
      doc: {
        text: "",
        coding: [{
          system: "",
          version: "1",
          code: code,
          display: longdesc,
          userSelected: true,
          id: coding_id,
          Type: "ORDERMODE",
          shortdesc: shortdesc
        }],
        id: id,
        Type: "ORDERMODE",
        status: status
      }
    }];

    if (isUpdate) {
      // newData[0].filter = {
      //   _key: key,
      // };
      newData = [{
        "db_name": dbName,
        "entity": "CodingMaster",
        "is_metadata": true,
        "filter": {
          "_key": key
        },
        "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
        "doc": {
          "system": "",
          "version": "1",
          "code": code,
          "display": longdesc,
          "userSelected": true,
          "id": coding_id,
          "Type": "ORDERMODE",
          shortdesc: shortdesc
        }
      }];
    }

    return newData;
  },
  orderModeStatusUpdate: function orderModeStatusUpdate(_ref6) {
    var _ref6$key = _ref6.key,
        key = _ref6$key === void 0 ? "" : _ref6$key,
        _ref6$status = _ref6.status,
        status = _ref6$status === void 0 ? false : _ref6$status;
    var obj = [{
      db_name: dbName,
      entity: "CodeableConceptMaster",
      filter: {
        _key: key
      },
      is_metadata: true,
      metadataId: metadataId,
      doc: {
        status: status
      }
    }];
    return obj;
  }
};

var modeActions = [{
  name: "GET_ALL_ORDER_MODE",
  sliceName: "getAllOrderMode",
  queryName: "orderModeRead",
  type: "List",
  url: __readDocumentUrl__,
  makeReturnData: function makeReturnData(data) {
    var returnData = [];

    if (Array.isArray(data === null || data === void 0 ? void 0 : data.result)) {
      returnData = data === null || data === void 0 ? void 0 : data.result.map(function (codeable) {
        var _ref = codeable || {},
            id = _ref.id,
            key = _ref._key,
            coding = _ref.coding,
            status = _ref.status;

        var _ref2 = (coding === null || coding === void 0 ? void 0 : coding[0]) || {},
            _ref2$code = _ref2.code,
            code = _ref2$code === void 0 ? "" : _ref2$code,
            _ref2$shortdesc = _ref2.shortdesc,
            shortdesc = _ref2$shortdesc === void 0 ? "" : _ref2$shortdesc,
            _ref2$display = _ref2.display,
            display = _ref2$display === void 0 ? "" : _ref2$display,
            coding_id = _ref2.id;

        return {
          code: code,
          shortdesc: shortdesc,
          longdesc: display,
          status: status,
          id: id,
          coding_id: coding_id,
          key: key,
          codeable: codeable
        };
      });
    }

    return returnData;
  }
}, {
  name: "GET_SINGLE_ORDER_MODE",
  sliceName: "getSingleOrderMode",
  queryName: "orderModeRead",
  type: "List",
  url: __readDocumentUrl__,
  makeReturnData: function makeReturnData(data) {
    var returnData = [];

    if (Array.isArray(data.result)) {
      returnData = data.result.map(function (codeable) {
        var _ref3 = codeable || {},
            id = _ref3.id,
            key = _ref3._key,
            coding = _ref3.coding,
            status = _ref3.status;

        var _ref4 = (coding === null || coding === void 0 ? void 0 : coding[0]) || {},
            _ref4$code = _ref4.code,
            code = _ref4$code === void 0 ? "" : _ref4$code,
            _ref4$shortdesc = _ref4.shortdesc,
            shortdesc = _ref4$shortdesc === void 0 ? "" : _ref4$shortdesc,
            _ref4$display = _ref4.display,
            display = _ref4$display === void 0 ? "" : _ref4$display,
            coding_id = _ref4.id;

        return {
          code: code,
          shortdesc: shortdesc,
          longdesc: display,
          status: status,
          id: id,
          coding_id: coding_id,
          key: key
        };
      });
    }

    return returnData;
  }
}, {
  name: "UPSERT_ORDER_MODE",
  sliceName: "upsertOrderMode",
  queryName: "orderModeUpsert",
  type: "Info",
  url: __uspsertUrl__,
  makeReturnData: function makeReturnData(data) {
    // const { _key } = data?.Result?.[0]?.properties?.doc || {};
    return data; // return {
    //   key: _key,
    //   data: data
    // };
  }
}, {
  name: "UPDATE_ORDER_MODE_STATUS",
  sliceName: "updateOrderModeStatus",
  queryName: "orderModeStatusUpdate",
  type: "Info",
  url: __uspsertUrl__,
  makeReturnData: function makeReturnData(data) {
    return data;
  }
}];

var categoryActions = [{
  name: "GET_ALL_ORDER_CATEGORY",
  sliceName: "getAllOrderCategory",
  queryName: "orderCategoryRead",
  type: "List",
  url: __readDocumentUrl__,
  makeReturnData: function makeReturnData(data) {
    var returnData = [];

    if (Array.isArray(data.result)) {
      returnData = data.result.map(function (_ref) {
        var ordercategory = _ref.ordercategory,
            shortdesc = _ref.shortdesc,
            longdesc = _ref.longdesc,
            id = _ref.id,
            _key = _ref._key,
            status = _ref.status;
        return {
          category: ordercategory,
          shortdesc: shortdesc,
          longdesc: longdesc,
          status: status,
          id: id,
          key: _key
        };
      });
    }

    return returnData;
  }
}, {
  name: "UPSERT_ORDER_CATEGORY",
  sliceName: "upsertOrderCategory",
  queryName: "orderCategoryUpsert",
  type: "Info",
  url: __uspsertUrl__,
  makeReturnData: function makeReturnData(data) {
    var _data$Result, _data$Result$, _data$Result$$propert;

    var _ref2 = (data === null || data === void 0 ? void 0 : (_data$Result = data.Result) === null || _data$Result === void 0 ? void 0 : (_data$Result$ = _data$Result[0]) === null || _data$Result$ === void 0 ? void 0 : (_data$Result$$propert = _data$Result$.properties) === null || _data$Result$$propert === void 0 ? void 0 : _data$Result$$propert.doc) || {},
        category = _ref2.ordercategory,
        shortdesc = _ref2.shortdesc,
        longdesc = _ref2.longdesc,
        status = _ref2.status,
        id = _ref2.id,
        key = _ref2._key;

    return {
      category: category,
      shortdesc: shortdesc,
      longdesc: longdesc,
      status: status,
      id: id,
      key: key
    };
  }
}, {
  name: "UPDATE_ORDER_CATEGORY_STATUS",
  sliceName: "updateOrderCategoryStatus",
  queryName: "orderCategoryStatusUpdate",
  type: "Info",
  url: __uspsertUrl__,
  makeReturnData: function makeReturnData(data) {
    return data;
  }
}];

var actions$1 = [].concat(_toConsumableArray(modeActions), _toConsumableArray(categoryActions));

var actionInfo = {};
var initalState = {};
var extraReducers = {};
actions$1.forEach(function (c) {
  initalState[c.sliceName] = _objectSpread2({}, defaultState[c.type]);
  actionInfo[c.name] = toolkit.createAsyncThunk("orderMasterSlice/".concat(c.sliceName), /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var payload,
        _ref2,
        rejectWithValue,
        getState,
        body,
        data,
        returnData,
        _args = arguments;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue, getState = _ref2.getState;

            if (!c.customFn) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", c.customFn(payload, {
              rejectWithValue: rejectWithValue,
              getState: getState
            }));

          case 4:
            _context.prev = 4;
            body = queries$8[c.queryName || c.sliceName](c.makePayload ? c.makePayload(payload) : payload);
            _context.next = 8;
            return fetchData({
              body: JSON.stringify(body)
            }, c.url);

          case 8:
            data = _context.sent;
            returnData = c.makeReturnData ? c.makeReturnData(data) : data;
            return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState[c.type]), {}, {
              data: returnData
            }));

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](4);
            return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
              message: _context.t0.message
            })));

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 13]]);
  })));

  extraReducers[actionInfo[c.name].fulfilled] = function (state, action) {
    state[c.sliceName] = action !== null && action !== void 0 && action.payload ? action === null || action === void 0 ? void 0 : action.payload : c.type === "List" ? [] : {};
  };

  extraReducers[actionInfo[c.name].pending] = function (state, action) {
    state[c.sliceName].loading = true;
  };

  extraReducers[actionInfo[c.name].rejected] = function (state, action) {
    state[c.sliceName] = action !== null && action !== void 0 && action.payload ? action === null || action === void 0 ? void 0 : action.payload : c.type === "List" ? [] : {};
  };
});
var orderMasterSlice = toolkit.createSlice({
  name: "orderMasterSlice",
  initialState: _objectSpread2({}, initalState),
  extraReducers: _objectSpread2({}, extraReducers)
});

var orderMasterActions = _objectSpread2({}, actionInfo);
var orderMasterSlice$1 = orderMasterSlice.reducer;

var queries$7 = {
  drug_category_read: "{\n      \"db_name\": \"".concat(dbName, "\",\n      \"entity\": \"DrugCategory\",\n      \"filter\":\"DrugCategory.activestatus == true\",\n      \"return_fields\": \"DrugCategory\"\n  }"),
  drug_type_read: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DrugType\",\n    \"filter\":\"DrugType.activestatus == true\",\n    \"sort\":\"DrugType.id\",\n    \"return_fields\": \"DrugType\"\n  }"),
  drug_dosage: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DosageForm\", \n    \"sort\": \"DosageForm.dosageform\",\n    \"filter\": \"DosageForm.activestatus == true\",\n    \"return_fields\": \"DosageForm\"\n  }"),
  drug_dosage_upsert: function drug_dosage_upsert(data) {
    var filter = {};

    if (data._key) {
      filter = {
        filter: {
          _key: data._key
        }
      };
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "DosageForm",
      is_metadata: true
    }, filter), {}, {
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        // "id":0,
        dosageform: data.drug_dosage ? data.drug_dosage : "",
        shortdesc: data.short_description ? data.short_description : "",
        longdesc: data.long_description ? data.long_description : "",
        status: data.status ? data.status : false
      }
    })];
  },
  status_update_drug_dosage: function status_update_drug_dosage(data) {
    return [{
      db_name: dbName,
      entity: "DosageForm",
      filter: {
        _key: data._key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        status: data.status
      }
    }];
  },
  drug_class: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DrugClass\",\n    \"filter\": \"DrugClass.activestatus == true\",\n    \"sort\": \"DrugClass.drugclass\",\n    \"return_fields\": \"DrugClass\"\n  }"),
  drug_class_upsert: function drug_class_upsert(data) {
    var filter = {};

    if (data._key) {
      filter = {
        filter: {
          _key: data._key
        }
      };
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "DrugClass",
      is_metadata: true
    }, filter), {}, {
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        // "id":0,
        drugclass: data.drug_class ? data.drug_class : "",
        shortdesc: data.short_description ? data.short_description : "",
        longdesc: data.long_description ? data.long_description : "",
        status: data.status ? data.status : false
      }
    })];
  },
  status_update_drug_class: function status_update_drug_class(data) {
    return [{
      db_name: dbName,
      entity: "DrugClass",
      filter: {
        _key: data._key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        status: data.status
      }
    }];
  },
  drug_routes: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DrugRoutes\", \n    \"sort\": \"DrugRoutes.routecode\",\n    \"filter\": \"DrugRoutes.activestatus == true\",\n    \"return_fields\": \"DrugRoutes\"  \n  }"),
  status_update_drug_routes: function status_update_drug_routes(data) {
    return [{
      db_name: dbName,
      entity: "DrugRoutes",
      filter: {
        _key: data._key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        status: data.status
      }
    }];
  },
  drug_routes_upsert: function drug_routes_upsert(data) {
    var filter = {};

    if (data._key) {
      filter = {
        filter: {
          _key: data._key
        }
      };
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "DrugRoutes",
      is_metadata: true
    }, filter), {}, {
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        // "id":0,
        routecode: data.drug_routes ? data.drug_routes : "",
        routeadverb: data.route_adverb ? data.route_adverb : "",
        shortdesc: data.short_description ? data.short_description : "",
        longdesc: data.long_description ? data.long_description : "",
        direction: data.direction ? data === null || data === void 0 ? void 0 : data.direction : "",
        directiontaglocal: data.directiontaglocal ? data === null || data === void 0 ? void 0 : data.directiontaglocal : "",
        status: data.status ? data.status : false
      }
    })];
  }
};

var _extraReducers$i;
var DRUG_CATEGORY_READ = toolkit.createAsyncThunk("drugCategorySlice/drug_category_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return fetchData({
            body: queries$7.drug_category_read
          }, __readDocumentUrl__);

        case 5:
          data = _context.sent;
          arry = [];
          data.result.map(function (val) {
            if (val._key) {
              arry.push({
                "drug_category": val.drugcategory ? val.drugcategory : "",
                "short_description": val.shortdesc ? val.shortdesc : "",
                "long_description": val.longdesc ? val.longdesc : "",
                "_key": val._key
              });
            }
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var DRUG_TYPE_READ = toolkit.createAsyncThunk("drugCategorySlice/drug_type_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var _ref4,
      rejectWithValue,
      data,
      arry,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          _context2.next = 5;
          return fetchData({
            body: queries$7.drug_type_read
          }, __readDocumentUrl__);

        case 5:
          data = _context2.sent;
          arry = [];
          data.result.map(function (val) {
            if (val._key) {
              arry.push({
                "drug_type": val.drugtype ? val.drugtype : "",
                "short_description": val.shortdesc ? val.shortdesc : "",
                "long_description": val.longdesc ? val.longdesc : "",
                "_key": val._key
              });
            }
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var drugCategorySlice = toolkit.createSlice({
  name: "drugCategorySlice",
  initialState: {
    drug_category_list: _objectSpread2({}, defaultState.List),
    drug_type_list: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$i = {}, _defineProperty(_extraReducers$i, DRUG_CATEGORY_READ.fulfilled, function (state, action) {
    state.drug_category_list.loading = false, state.drug_category_list.error = false, state.drug_category_list = action.payload;
  }), _defineProperty(_extraReducers$i, DRUG_CATEGORY_READ.pending, function (state, action) {
    state.drug_category_list.loading = true, state.drug_category_list.error = false, state.drug_category_list.loading = true;
  }), _defineProperty(_extraReducers$i, DRUG_CATEGORY_READ.rejected, function (state, action) {
    state.drug_category_list.loading = false, state.drug_category_list.error = true, state.drug_category_list = action.payload;
  }), _defineProperty(_extraReducers$i, DRUG_TYPE_READ.fulfilled, function (state, action) {
    state.drug_type_list.loading = false, state.drug_type_list.error = false, state.drug_type_list = action.payload;
  }), _defineProperty(_extraReducers$i, DRUG_TYPE_READ.pending, function (state, action) {
    state.drug_type_list.loading = true, state.drug_type_list.error = false, state.drug_type_list.loading = true;
  }), _defineProperty(_extraReducers$i, DRUG_TYPE_READ.rejected, function (state, action) {
    state.drug_type_list.loading = false, state.drug_type_list.error = true, state.drug_type_list = action.payload;
  }), _extraReducers$i)
});
var drugCategoryActions = {
  DRUG_CATEGORY_READ: DRUG_CATEGORY_READ,
  DRUG_TYPE_READ: DRUG_TYPE_READ
};
var drugCategorySlice$1 = drugCategorySlice.reducer;

var _extraReducers$h;
var DRUG_DOSAGE_READ = toolkit.createAsyncThunk("drugDosageSlice/drug_dosage_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return fetchData({
            body: queries$7.drug_dosage
          }, __readDocumentUrl__);

        case 5:
          data = _context.sent;
          arry = [];
          data.result.map(function (val) {
            if (val._key) {
              arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
                "drug_dosage": val.dosageform ? val.dosageform : "",
                "short_description": val.shortdesc ? val.shortdesc : "",
                "long_description": val.longdesc ? val.longdesc : "",
                "status": val.status ? val.status : false,
                "_key": val._key
              }));
            }
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var DRUG_DOSAGE_UPSERT = toolkit.createAsyncThunk("drugDosageSlice/drug_dosage_upsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      upsertkey,
      queriesjson,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          upsertkey = {
            drug_dosage: payload.drug_dosage,
            short_description: payload.short_description,
            long_description: payload.long_description,
            status: payload.status,
            _key: payload._key
          };
          queriesjson = queries$7.drug_dosage_upsert(upsertkey);
          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var DRUG_DOSAGE_STATUS_CHANGE = toolkit.createAsyncThunk("drugDosageSlice/drug_dosage_status", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      statuschange,
      queriesjson,
      data,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          statuschange = {
            _key: payload._key,
            status: payload.status
          };
          queriesjson = queries$7.status_update_drug_dosage(statuschange);
          _context3.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 11]]);
})));
var drugDosageSlice = toolkit.createSlice({
  name: "drugDosageSlice",
  initialState: {
    drug_dosage_list: _objectSpread2({}, defaultState.List),
    drug_dosage_upsert: _objectSpread2({}, defaultState.List),
    drug_dosage_status: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$h = {}, _defineProperty(_extraReducers$h, DRUG_DOSAGE_READ.fulfilled, function (state, action) {
    state.drug_dosage_list.loading = false, state.drug_dosage_list.error = false, state.drug_dosage_list = action.payload;
  }), _defineProperty(_extraReducers$h, DRUG_DOSAGE_READ.pending, function (state, action) {
    state.drug_dosage_list.loading = true, state.drug_dosage_list.error = false, state.drug_dosage_list.loading = true;
  }), _defineProperty(_extraReducers$h, DRUG_DOSAGE_READ.rejected, function (state, action) {
    state.drug_dosage_list.loading = false, state.drug_dosage_list.error = true, state.drug_dosage_list = action.payload;
  }), _defineProperty(_extraReducers$h, DRUG_DOSAGE_UPSERT.fulfilled, function (state, action) {
    state.drug_dosage_upsert.loading = false, state.drug_dosage_upsert.error = false, state.drug_dosage_upsert = action.payload;
  }), _defineProperty(_extraReducers$h, DRUG_DOSAGE_UPSERT.pending, function (state, action) {
    state.drug_dosage_upsert.loading = true, state.drug_dosage_upsert.error = false, state.drug_dosage_upsert.loading = true;
  }), _defineProperty(_extraReducers$h, DRUG_DOSAGE_UPSERT.rejected, function (state, action) {
    state.drug_dosage_upsert.loading = false, state.drug_dosage_upsert.error = true, state.drug_dosage_upsert = action.payload;
  }), _defineProperty(_extraReducers$h, DRUG_DOSAGE_STATUS_CHANGE.fulfilled, function (state, action) {
    state.drug_dosage_status.loading = false, state.drug_dosage_status.error = false, state.drug_dosage_status = action.payload;
  }), _defineProperty(_extraReducers$h, DRUG_DOSAGE_STATUS_CHANGE.pending, function (state, action) {
    state.drug_dosage_status.loading = true, state.drug_dosage_status.error = false, state.drug_dosage_status.loading = true;
  }), _defineProperty(_extraReducers$h, DRUG_DOSAGE_STATUS_CHANGE.rejected, function (state, action) {
    state.drug_dosage_status.loading = false, state.drug_dosage_status.error = true, state.drug_dosage_status = action.payload;
  }), _extraReducers$h)
});
var drugDosageActions = {
  DRUG_DOSAGE_READ: DRUG_DOSAGE_READ,
  DRUG_DOSAGE_UPSERT: DRUG_DOSAGE_UPSERT,
  DRUG_DOSAGE_STATUS_CHANGE: DRUG_DOSAGE_STATUS_CHANGE
};
var drugDosageSlice$1 = drugDosageSlice.reducer;

var _extraReducers$g;
var DRUG_CLASS_READ = toolkit.createAsyncThunk("drugClassSlice/drug_class_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return fetchData({
            body: queries$7.drug_class
          }, __readDocumentUrl__);

        case 5:
          data = _context.sent;
          arry = [];
          data.result.map(function (val) {
            if (val._key) {
              arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
                "drug_class": val.drugclass ? val.drugclass : "",
                "short_description": val.shortdesc ? val.shortdesc : "",
                "long_description": val.longdesc ? val.longdesc : "",
                "status": val.status ? val.status : false,
                "_key": val._key
              }));
            }
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var DRUG_CLASS_UPSERT = toolkit.createAsyncThunk("drugClassSlice/drug_class_upsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      upsertkey,
      queriesjson,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          upsertkey = {
            drug_class: payload.drug_class,
            short_description: payload.short_description,
            long_description: payload.long_description,
            status: payload.status,
            _key: payload._key
          };
          queriesjson = queries$7.drug_class_upsert(upsertkey);
          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var DRUG_CLASS_STATUS_CHANGE = toolkit.createAsyncThunk("drugClassSlice/drug_class_status", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      statuschange,
      queriesjson,
      data,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          statuschange = {
            _key: payload._key,
            status: payload.status
          };
          queriesjson = queries$7.status_update_drug_class(statuschange);
          _context3.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 11]]);
})));
var drugClassSlice = toolkit.createSlice({
  name: "drugClassSlice",
  initialState: {
    drug_class_list: _objectSpread2({}, defaultState.List),
    drug_class_upsert: _objectSpread2({}, defaultState.List),
    drug_class_status: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$g = {}, _defineProperty(_extraReducers$g, DRUG_CLASS_READ.fulfilled, function (state, action) {
    state.drug_class_list.loading = false, state.drug_class_list.error = false, state.drug_class_list = action.payload;
  }), _defineProperty(_extraReducers$g, DRUG_CLASS_READ.pending, function (state, action) {
    state.drug_class_list.loading = true, state.drug_class_list.error = false, state.drug_class_list.loading = true;
  }), _defineProperty(_extraReducers$g, DRUG_CLASS_READ.rejected, function (state, action) {
    state.drug_class_list.loading = false, state.drug_class_list.error = true, state.drug_class_list = action.payload;
  }), _defineProperty(_extraReducers$g, DRUG_CLASS_UPSERT.fulfilled, function (state, action) {
    state.drug_class_upsert.loading = false, state.drug_class_upsert.error = false, state.drug_class_upsert = action.payload;
  }), _defineProperty(_extraReducers$g, DRUG_CLASS_UPSERT.pending, function (state, action) {
    state.drug_class_upsert.loading = true, state.drug_class_upsert.error = false, state.drug_class_upsert.loading = true;
  }), _defineProperty(_extraReducers$g, DRUG_CLASS_UPSERT.rejected, function (state, action) {
    state.drug_class_upsert.loading = false, state.drug_class_upsert.error = true, state.drug_class_upsert = action.payload;
  }), _defineProperty(_extraReducers$g, DRUG_CLASS_STATUS_CHANGE.fulfilled, function (state, action) {
    state.drug_class_status.loading = false, state.drug_class_status.error = false, state.drug_class_status = action.payload;
  }), _defineProperty(_extraReducers$g, DRUG_CLASS_STATUS_CHANGE.pending, function (state, action) {
    state.drug_class_status.loading = true, state.drug_class_status.error = false, state.drug_class_status.loading = true;
  }), _defineProperty(_extraReducers$g, DRUG_CLASS_STATUS_CHANGE.rejected, function (state, action) {
    state.drug_class_status.loading = false, state.drug_class_status.error = true, state.drug_class_status = action.payload;
  }), _extraReducers$g)
});
var drugClassActions = {
  DRUG_CLASS_READ: DRUG_CLASS_READ,
  DRUG_CLASS_UPSERT: DRUG_CLASS_UPSERT,
  DRUG_CLASS_STATUS_CHANGE: DRUG_CLASS_STATUS_CHANGE
};
var drugClassSlice$1 = drugClassSlice.reducer;

var _extraReducers$f;
var DRUG_ROUTES_READ = toolkit.createAsyncThunk("drugRoutesSlice/drug_routes_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return fetchData({
            body: queries$7.drug_routes
          }, __readDocumentUrl__);

        case 5:
          data = _context.sent;
          arry = [];
          data.result.map(function (val) {
            if (val._key) {
              arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
                drug_routes: val.routecode ? val.routecode : "-",
                short_description: val.shortdesc ? val.shortdesc : "-",
                long_description: val.longdesc ? val.longdesc : "-",
                route_adverb: val.routeadverb ? val.routeadverb : "-",
                direction: val.direction ? val.direction : "",
                directiontaglocal: val.directiontaglocal ? val.directiontaglocal : "",
                status: val.status ? val.status : false,
                _key: val._key
              }));
            }
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var DRUG_ROUTES_UPSERT = toolkit.createAsyncThunk("drugRoutesSlice/drug_routes_upsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      upsertkey,
      queriesjson,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          upsertkey = {
            drug_routes: payload.drug_routes,
            route_adverb: payload.route_adverb,
            short_description: payload.short_description,
            long_description: payload.long_description,
            status: payload.status,
            direction: payload.direction,
            directiontaglocal: payload.directiontaglocal,
            _key: payload._key
          };
          queriesjson = queries$7.drug_routes_upsert(upsertkey);
          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var DRUG_ROUTES_STATUS_CHANGE = toolkit.createAsyncThunk("drugRoutesSlice/drug_routes_status", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      statuschange,
      queriesjson,
      data,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          statuschange = {
            _key: payload._key,
            status: payload.status
          };
          queriesjson = queries$7.status_update_drug_routes(statuschange);
          _context3.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 11]]);
})));
var drugRoutesSlice = toolkit.createSlice({
  name: "drugRoutesSlice",
  initialState: {
    drug_routes_list: _objectSpread2({}, defaultState.List),
    drug_routes_upsert: _objectSpread2({}, defaultState.List),
    drug_routes_status: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$f = {}, _defineProperty(_extraReducers$f, DRUG_ROUTES_READ.fulfilled, function (state, action) {
    state.drug_routes_list.loading = false, state.drug_routes_list.error = false, state.drug_routes_list = action.payload;
  }), _defineProperty(_extraReducers$f, DRUG_ROUTES_READ.pending, function (state, action) {
    state.drug_routes_list.loading = true, state.drug_routes_list.error = false, state.drug_routes_list.loading = true;
  }), _defineProperty(_extraReducers$f, DRUG_ROUTES_READ.rejected, function (state, action) {
    state.drug_routes_list.loading = false, state.drug_routes_list.error = true, state.drug_routes_list = action.payload;
  }), _defineProperty(_extraReducers$f, DRUG_ROUTES_UPSERT.fulfilled, function (state, action) {
    state.drug_routes_upsert.loading = false, state.drug_routes_upsert.error = false, state.drug_routes_upsert = action.payload;
  }), _defineProperty(_extraReducers$f, DRUG_ROUTES_UPSERT.pending, function (state, action) {
    state.drug_routes_upsert.loading = true, state.drug_routes_upsert.error = false, state.drug_routes_upsert.loading = true;
  }), _defineProperty(_extraReducers$f, DRUG_ROUTES_UPSERT.rejected, function (state, action) {
    state.drug_routes_upsert.loading = false, state.drug_routes_upsert.error = true, state.drug_routes_upsert = action.payload;
  }), _defineProperty(_extraReducers$f, DRUG_ROUTES_STATUS_CHANGE.fulfilled, function (state, action) {
    state.drug_routes_status.loading = false, state.drug_routes_status.error = false, state.drug_routes_status = action.payload;
  }), _defineProperty(_extraReducers$f, DRUG_ROUTES_STATUS_CHANGE.pending, function (state, action) {
    state.drug_routes_status.loading = true, state.drug_routes_status.error = false, state.drug_routes_status.loading = true;
  }), _defineProperty(_extraReducers$f, DRUG_ROUTES_STATUS_CHANGE.rejected, function (state, action) {
    state.drug_routes_status.loading = false, state.drug_routes_status.error = true, state.drug_routes_status = action.payload;
  }), _extraReducers$f)
});
var drugRoutesActions = {
  DRUG_ROUTES_READ: DRUG_ROUTES_READ,
  DRUG_ROUTES_UPSERT: DRUG_ROUTES_UPSERT,
  DRUG_ROUTES_STATUS_CHANGE: DRUG_ROUTES_STATUS_CHANGE
};
var drugRoutesSlice$1 = drugRoutesSlice.reducer;

// import { dbName } from "../../qdm_query_ids";
var queries$6 = {
  fullread: function fullread(type) {
    // return {
    //   db_name: dbName,
    //   entity: "DrugRouteDirection",
    //   sort: "DrugRouteDirection.RouteDirectionCode",
    //   filter: "DrugRouteDirection.activestatus == true ",
    //   return_fields:
    //     "merge(DrugRouteDirection,{DoseForm:DOCUMENT(DrugRouteDirection.DoseForm)})",
    // };
    return {
      "db_name": dbName,
      "entity": "DrugRouteDirection",
      "sort": "DrugRouteDirection.RouteDirectionCode",
      "filter": "DrugRouteDirection.activestatus == true ",
      "return_fields": "merge(DrugRouteDirection,{DoseForm:DOCUMENT(DrugRouteDirection.DoseForm),Action:(DrugRouteDirection.Action)})"
    };
  },
  DosageFormDropDown: function DosageFormDropDown() {
    return {
      db_name: dbName,
      entity: "DosageForm",
      sort: "DosageForm.longdesc",
      filter: "DosageForm.activestatus == true && DosageForm.status == true",
      return_fields: "DosageForm"
    };
  },
  RoutesDirectionActionDropDown: function RoutesDirectionActionDropDown() {
    return {
      "db_name": dbName,
      "entity": "CodingMaster",
      "filter": "CodingMaster.Type== 'ROUTEDIRECTIONACTION' && CodingMaster.activestatus==true && CodingMaster.status==true",
      "return_fields": "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')"
    };
  },
  Insert: function Insert(data) {
    return [{
      db_name: dbName,
      entity: "DrugRouteDirection",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        id: 0,
        RouteDirectionCode: data === null || data === void 0 ? void 0 : data.route_direction_code,
        ShortDesc: data === null || data === void 0 ? void 0 : data.shortdesc,
        LongDesc: data === null || data === void 0 ? void 0 : data.longdesc,
        Action: data === null || data === void 0 ? void 0 : data.action,
        DoseForm: data === null || data === void 0 ? void 0 : data.dose_form,
        Status: data === null || data === void 0 ? void 0 : data.Status
      }
    }];
  },
  StatusUpdate: function StatusUpdate(key, getstatus) {
    return [{
      db_name: dbName,
      entity: "DrugRouteDirection",
      filter: {
        _key: key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        Status: getstatus
      }
    }];
  },
  UpdateORModify: function UpdateORModify(data) {
    return [{
      db_name: dbName,
      entity: "DrugRouteDirection",
      filter: {
        _key: data.key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        RouteDirectionCode: data.route_direction_code,
        ShortDesc: data.shortdesc,
        LongDesc: data.longdesc,
        Action: data.action,
        DoseForm: data.dose_form
      }
    }];
  }
};

var _extraReducers$e;
var DRUG_ROUTES_DIRECTION_READ = toolkit.createAsyncThunk("drugRoutesSlice/drug_routes_direction_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          queriesjson = queries$6.fullread();
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          arry = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._key && val !== null && val !== void 0 && val.LongDesc) {
              var _val$DoseForm, _val$DoseForm2;

              arry.push({
                code: val === null || val === void 0 ? void 0 : val.RouteDirectionCode,
                // action_id: val?.Action?._id,
                // action: val?.Action?.display,
                action: val === null || val === void 0 ? void 0 : val.Action,
                longDesc: val === null || val === void 0 ? void 0 : val.LongDesc,
                shortDesc: val === null || val === void 0 ? void 0 : val.ShortDesc,
                status: val === null || val === void 0 ? void 0 : val.Status,
                key: val === null || val === void 0 ? void 0 : val._key,
                DoseForm_id: val === null || val === void 0 ? void 0 : (_val$DoseForm = val.DoseForm) === null || _val$DoseForm === void 0 ? void 0 : _val$DoseForm._id,
                DoseForm_longdesc: val === null || val === void 0 ? void 0 : (_val$DoseForm2 = val.DoseForm) === null || _val$DoseForm2 === void 0 ? void 0 : _val$DoseForm2.longdesc
              });
            }
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context.t0.message
          })));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 12]]);
})));
var DRUG_ROUTES_DIRECTION_MASTER = toolkit.createAsyncThunk("drugRoutesSlice/drug_routes_master_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var _ref4,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          queriesjson = queries$6.DosageFormDropDown();
          _context2.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context2.sent;
          arry = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._id && val !== null && val !== void 0 && val.longdesc) {
              arry.push({
                label: val === null || val === void 0 ? void 0 : val.longdesc,
                value: val === null || val === void 0 ? void 0 : val._id
              });
            }
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context2.t0.message
          })));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 12]]);
})));
var DRUG_ROUTES_DIRECTION_ACTION_MASTER = toolkit.createAsyncThunk("drugRoutesSlice/drug_routes_action_master_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var _ref6,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          queriesjson = queries$6.RoutesDirectionActionDropDown();
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context3.sent;
          arry = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._id) {
              arry.push(_objectSpread2({
                label: val === null || val === void 0 ? void 0 : val.display,
                value: val === null || val === void 0 ? void 0 : val._id
              }, val));
            }
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context3.t0.message
          })));

        case 15:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 12]]);
})));
var DRUG_ROUTES_DIRECTION_STATUS = toolkit.createAsyncThunk("drugRoutesSlice/drug_routes_status_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      data,
      queriesjson,
      arry,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          data = payload.data;
          queriesjson = queries$6.StatusUpdate(data._key, data.status);
          _context4.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          _context4.sent;
          arry = [];
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context4.t0.message
          })));

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 12]]);
})));
var DRUG_ROUTES_DIRECTION_INSERT = toolkit.createAsyncThunk("drugRoutesSlice/drug_routes_insert_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      Senddata,
      queriesjson,
      Getdata,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          Senddata = payload.Senddata;
          queriesjson = queries$6.Insert(Senddata);
          _context5.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          Getdata = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: Getdata
          }));

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 12]]);
})));
var DRUG_ROUTES_DIRECTION_UPDATE = toolkit.createAsyncThunk("drugRoutesSlice/drug_routes_update_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref12,
      rejectWithValue,
      Senddata,
      queriesjson,
      arry,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          Senddata = payload.Senddata;
          queriesjson = queries$6.UpdateORModify(Senddata);
          _context6.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          _context6.sent;
          arry = [];
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context6.t0.message
          })));

        case 15:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 12]]);
})));
var drugRoutesDirectionSlice = toolkit.createSlice({
  name: "drugRoutesDirectionSlice",
  initialState: {
    drug_routes_direction_list: _objectSpread2({}, defaultState.List),
    drug_routes_master_list: _objectSpread2({}, defaultState.List),
    drug_routes_status_list: _objectSpread2({}, defaultState.List),
    drug_routes_insert_list: _objectSpread2({}, defaultState.List),
    drug_routes_update_list: _objectSpread2({}, defaultState.List),
    drug_routes_action_master_list: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$e = {}, _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_READ.fulfilled, function (state, action) {
    state.drug_routes_direction_list.loading = false, state.drug_routes_direction_list.error = false, state.drug_routes_direction_list = action.payload;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_READ.pending, function (state, action) {
    state.drug_routes_direction_list.loading = true, state.drug_routes_direction_list.error = false, state.drug_routes_direction_list.loading = true;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_READ.rejected, function (state, action) {
    state.drug_routes_direction_list.loading = false, state.drug_routes_direction_list.error = true, state.drug_routes_direction_list = action.payload;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_MASTER.fulfilled, function (state, action) {
    state.drug_routes_master_list.loading = false, state.drug_routes_master_list.error = false, state.drug_routes_master_list = action.payload;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_MASTER.pending, function (state, action) {
    state.drug_routes_master_list.loading = true, state.drug_routes_master_list.error = false, state.drug_routes_master_list.loading = true;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_MASTER.rejected, function (state, action) {
    state.drug_routes_master_list.loading = false, state.drug_routes_master_list.error = true, state.drug_routes_master_list = action.payload;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_STATUS.fulfilled, function (state, action) {
    state.drug_routes_status_list.loading = false, state.drug_routes_status_list.error = false, state.drug_routes_status_list = action.payload;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_STATUS.pending, function (state, action) {
    state.drug_routes_status_list.loading = true, state.drug_routes_status_list.error = false, state.drug_routes_status_list.loading = true;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_STATUS.rejected, function (state, action) {
    state.drug_routes_status_list.loading = false, state.drug_routes_status_list.error = true, state.drug_routes_status_list = action.payload;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_INSERT.fulfilled, function (state, action) {
    state.drug_routes_insert_list.loading = false, state.drug_routes_insert_list.error = false, state.drug_routes_insert_list = action.payload;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_INSERT.pending, function (state, action) {
    state.drug_routes_insert_list.loading = true, state.drug_routes_insert_list.error = false, state.drug_routes_insert_list.loading = true;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_INSERT.rejected, function (state, action) {
    state.drug_routes_insert_list.loading = false, state.drug_routes_insert_list.error = true, state.drug_routes_insert_list = action.payload;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_UPDATE.fulfilled, function (state, action) {
    state.drug_routes_insert_list.loading = false, state.drug_routes_insert_list.error = false, state.drug_routes_insert_list = action.payload;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_UPDATE.pending, function (state, action) {
    state.drug_routes_insert_list.loading = true, state.drug_routes_insert_list.error = false, state.drug_routes_insert_list.loading = true;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_UPDATE.rejected, function (state, action) {
    state.drug_routes_insert_list.loading = false, state.drug_routes_insert_list.error = true, state.drug_routes_insert_list = action.payload;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_ACTION_MASTER.fulfilled, function (state, action) {
    state.drug_routes_action_master_list.loading = false, state.drug_routes_action_master_list.error = false, state.drug_routes_action_master_list = action.payload;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_ACTION_MASTER.pending, function (state, action) {
    state.drug_routes_action_master_list.loading = true, state.drug_routes_action_master_list.error = false, state.drug_routes_action_master_list.loading = true;
  }), _defineProperty(_extraReducers$e, DRUG_ROUTES_DIRECTION_ACTION_MASTER.rejected, function (state, action) {
    state.drug_routes_action_master_list.loading = false, state.drug_routes_action_master_list.error = true, state.drug_routes_action_master_list = action.payload;
  }), _extraReducers$e)
});
var drugDirectionRoutesActions = {
  DRUG_ROUTES_DIRECTION_READ: DRUG_ROUTES_DIRECTION_READ,
  DRUG_ROUTES_DIRECTION_MASTER: DRUG_ROUTES_DIRECTION_MASTER,
  DRUG_ROUTES_DIRECTION_STATUS: DRUG_ROUTES_DIRECTION_STATUS,
  DRUG_ROUTES_DIRECTION_INSERT: DRUG_ROUTES_DIRECTION_INSERT,
  DRUG_ROUTES_DIRECTION_UPDATE: DRUG_ROUTES_DIRECTION_UPDATE,
  DRUG_ROUTES_DIRECTION_ACTION_MASTER: DRUG_ROUTES_DIRECTION_ACTION_MASTER
};
var drugRoutesDirectionSlice$1 = drugRoutesDirectionSlice.reducer;

var masterQuery$4 = {
  orderCategory: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"OrderCategory\",\n  \"filter\": \"OrderCategory.activestatus==true && OrderCategory.status==true\",\n  \"return_fields\": \"OrderCategory\",\n  \"sort\": \"OrderCategory.ordercategory\"\n}"),
  orderType: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"OrderType\",\n  \"filter\": \"OrderType.activestatus==true && OrderType.status==true\",\n  \"return_fields\": \"merge(OrderType,{ordercategory:(document(OrderType.ordercategory))})\",\n  \"sort\":\"OrderType.ordertype\"\n}"),
  // orderType: `{
  //   "db_name": "${dbName}",
  //   "entity": "OrderType",
  //   "filter": "OrderType.activestatus==true && OrderType.status==true && OrderType.ordercategory=='OrderCategory/10013'",
  //   "return_fields": "merge(OrderType,{ordercategory:(document(OrderType.ordercategory))})",
  //   "sort":"OrderType.longdesc"
  // }`,
  healthService: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"HealthcareService\",\n  \"sort\":\"HealthcareService.name\",\n  \"filter\": \"HealthcareService.activestatus==true\",\n  \"return_fields\": \"{id:HealthcareService.id,_id:HealthcareService._id,name:HealthcareService.name}\"\n}"),
  quantity: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"CodeableConceptMaster\",\n  \"filter\": \"CodeableConceptMaster.Type=='UOM' && CodeableConceptMaster.activestatus==true\",\n  \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n  \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n}"),
  entityType: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"CodeableConceptMaster\",\n  \"filter\": \"CodeableConceptMaster.Type=='ORGTYPE' && CodeableConceptMaster.activestatus==true\",\n   \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n  \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n}"),
  entitytName: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"Organization\",\n  \"filter\": \"'Hospital' IN Organization.OrgType\",\n  \"return_fields\": \"{OrgID:Organization.id,name:Organization.name,_id:Organization._id}\"\n}"),
  specimenType: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"CodeableConceptMaster\",\n   \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n  \"filter\": \"CodeableConceptMaster.Type=='SPECIMENTYPE' && CodeableConceptMaster.activestatus==true\",\n  \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n}"),
  bodySite: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"CodeableConceptMaster\",\n  \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n  \"filter\": \"CodeableConceptMaster.Type=='BODYSITE' && CodeableConceptMaster.activestatus==true\",\n  \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n}"),
  specimenContainer: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"CodeableConceptMaster\",\n  \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n  \"filter\": \"CodeableConceptMaster.Type=='SPECCONTAINER' && CodeableConceptMaster.activestatus==true\",\n  \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n}"),
  collectionMethod: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"CodeableConceptMaster\",\n  \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n  \"filter\": \"CodeableConceptMaster.Type=='SPECCOLLMETHOD' && CodeableConceptMaster.activestatus==true\",\n  \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n}"),
  encounterType: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"CodeableConceptMaster\",\n  \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n  \"filter\": \"CodeableConceptMaster.Type=='ENCOUNTERTYPE' && CodeableConceptMaster.activestatus==true\",\n  \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n}"),
  gender: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"CodeableConceptMaster\",\n  \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n  \"filter\": \"CodeableConceptMaster.Type=='GENDER' && CodeableConceptMaster.activestatus==true\",\n  \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n}"),
  ageGroup: "{\n\"db_name\": \"".concat(dbName, "\",\n\"entity\": \"AgeRanges\",\n\"sort\":\"AgeRanges.agerangecode\",\n\"filter\":\"AgeRanges.activestatus == true\",\n\"return_fields\": \"{id:AgeRanges.id, _id:AgeRanges._id, agerangecode:AgeRanges.agerangecode, longdesc:AgeRanges.longdesc, shortdesc:AgeRanges.shortdesc,AgeCategory:DOCUMENT(AgeRanges.AgeCategory)}\"\n}"),
  checkaction: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"CodeableConceptMaster\",\n  \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n  \"filter\": \"CodeableConceptMaster.Type=='CHECKACTION' && CodeableConceptMaster.status==true && CodeableConceptMaster.activestatus==true\",\n  \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n}"),
  attrcode: "{\n  \"db_name\": \"".concat(dbName, "\",\n  \"entity\": \"CA_OrderAttribMaster\",\n  \"sort\":\"CA_OrderAttribMaster.attribcode\",\n  \"filter\": \"CA_OrderAttribMaster.activestatus==true\",\n  \"return_fields\": \"{id:CA_OrderAttribMaster.id,_id:CA_OrderAttribMaster._id,attribcode:CA_OrderAttribMaster.attribcode,attriblabel:CA_OrderAttribMaster.attriblabel,attribtype: document(CA_OrderAttribMaster.attribtype),AttribValidValues:CA_OrderAttribMaster.AttribValidValues}\"\n}")
};
var orderTypedata = {
  ordertype: function ordertype(type) {
    return {
      db_name: dbName,
      entity: "OrderType",
      filter: "OrderType.activestatus==true && OrderType.status==true && OrderType.ordercategory=='".concat(type, "'"),
      return_fields: "merge(OrderType,{ordercategory:(document(OrderType.ordercategory))})",
      sort: "OrderType.ordertype"
    };
  }
};

var Query = {
  ageCategory: function ageCategory(ageRangeId) {
    return {
      db_name: dbName,
      entity: "AgeRanges",
      sort: "AgeRanges.code",
      filter: {
        AgeRanges: "AgeRanges.activestatus==true && AgeRanges._id=='".concat(ageRangeId, "' ")
      },
      return_fields: "DOCUMENT( AgeRanges.AgeCategory)"
    };
  },
  order_catalog_read: function order_catalog_read(_ref) {
    var page = _ref.page,
        perPage = _ref.perPage;
    return {
      "db_name": dbName,
      "entity": "OrderCatalog",
      "sort": "OrderCatalog.createddate ASC",
      "limit": {
        "offset": page,
        "count": perPage
      },
      "filter": "OrderCatalog.activestatus==true",
      "return_fields": "MERGE(OrderCatalog,{TotalCount:COUNT(FOR cnt IN OrderCatalog RETURN cnt._key)},{ordercategory:(document(OrderCatalog.ordercategory)),ordertype:(document(OrderCatalog.ordertype)),healthcareservicecode:(document(OrderCatalog.healthcareservicecode)),OrderCatalogByEncounterTypeAge:(for doc in CA_OrderCatalogByEncounterTypeAge filter doc._id in OrderCatalog.OrderCatalogByEncounterTypeAge return doc),OrderAttribApplicability:(for doc in CA_OrderAttribApplicability filter doc._id in OrderCatalog.OrderAttribApplicability return doc),dfltFastingPeriodUOM:(for doc in CodeableConceptMaster filter doc._id==OrderCatalog.dfltFastingPeriodUOM return merge(doc,{coding:(for cod in CodingMaster filter cod._id in doc.coding return cod.display)})),dfltSpecimenBodySite:(for doc in CodeableConceptMaster filter doc._id==OrderCatalog.dfltSpecimenBodySite return merge(doc,{coding:(for cod in CodingMaster filter cod._id in doc.coding return cod.display)})),dfltSpecimenCollectionMethod:(for doc in CodeableConceptMaster filter doc._id==OrderCatalog.dfltSpecimenCollectionMethod return merge(doc,{coding:(for cod in CodingMaster filter cod._id in doc.coding return cod.display)})),dfltSpecimenType:(for doc in CodeableConceptMaster filter doc._id==OrderCatalog.dfltSpecimenType return merge(doc,{coding:(for cod in CodingMaster filter cod._id in doc.coding return cod.display)})),dfltSpecimenVolumeUOM:(for doc in CodeableConceptMaster filter doc._id==OrderCatalog.dfltSpecimenVolumeUOM return merge(doc,{coding:(for cod in CodingMaster filter cod._id in doc.coding return cod.display)})),dfltqtyUOM:(for doc in CodeableConceptMaster filter doc._id==OrderCatalog.dfltqtyUOM return merge(doc,{coding:(for cod in CodingMaster filter cod._id in doc.coding return cod.display)})),maxorderqtyUOM:(for doc in CodeableConceptMaster filter doc._id==OrderCatalog.maxorderqtyUOM return merge(doc,{coding:(for cod in CodingMaster filter cod._id in doc.coding return cod.display)})),repeatCheckUOM:(for doc in CodeableConceptMaster filter doc._id==OrderCatalog.repeatCheckUOM return merge(doc,{coding:(for cod in CodingMaster filter cod._id in doc.coding return cod.display)})),AvailablebyPerOrganization:(for doc in to_array(OrderCatalog.AvailablebyPerOrganization) return merge(doc,{perforganizationId:(document(doc.perforganizationId)),perfOrganizationEntity:(for docs in CodeableConceptMaster filter docs._id==doc.perfOrganizationEntity return merge(doc,{coding:(for cod in CodingMaster filter cod._id in docs.coding return cod.display)}))})),dfltSpecimenContainer:(for doc in CodeableConceptMaster filter doc._id==OrderCatalog.dfltSpecimenContainer return merge(doc,{coding:(for cod in CodingMaster filter cod._id in doc.coding return cod.display)}))})"
    };
  },
  editOrderCatalog: function editOrderCatalog(id) {
    return {
      db_name: dbName,
      entity: "OrderCatalog",
      filter: "OrderCatalog.activestatus==true && OrderCatalog._key=='".concat(id, "'"),
      return_fields: "MERGE(OrderCatalog,{ordercategory:(document(OrderCatalog.ordercategory)),ordertype:(document(OrderCatalog.ordertype)),healthcareservicecode:(document(OrderCatalog.healthcareservicecode)),OrderCatalogByEncounterTypeAge:(for doc in CA_OrderCatalogByEncounterTypeAge filter doc._id in OrderCatalog.OrderCatalogByEncounterTypeAge return doc),OrderAttribApplicability:(for doc in CA_OrderAttribApplicability filter doc._id in OrderCatalog.OrderAttribApplicability return doc),dfltFastingPeriodUOM:document(OrderCatalog.dfltFastingPeriodUOM),dfltSpecimenBodySite:document(OrderCatalog.dfltSpecimenBodySite),dfltSpecimenCollectionMethod:document(OrderCatalog.dfltSpecimenCollectionMethod),dfltSpecimenType:document(OrderCatalog.dfltSpecimenType),dfltSpecimenVolumeUOM:document(OrderCatalog.dfltSpecimenVolumeUOM),dfltqtyUOM:document(OrderCatalog.dfltqtyUOM),maxorderqtyUOM:document(OrderCatalog.maxorderqtyUOM),repeatCheckUOM:document(OrderCatalog.repeatCheckUOM),AvailablebyPerOrganization:(for doc in to_array(OrderCatalog.AvailablebyPerOrganization) return merge(doc,{perforganizationId:(document(doc.perforganizationId)),perfOrganizationEntity:(document(doc.perfOrganizationEntity))})),dfltSpecimenContainer:document(OrderCatalog.dfltSpecimenContainer),repeatCheckAction:document(OrderCatalog.repeatCheckAction)})"
    };
  },
  attributeDelete: function attributeDelete(id) {
    return {
      db_name: dbName,
      entity: "CA_OrderAttribApplicability",
      filter: "CA_OrderAttribApplicability._key=='".concat(id, "'")
    };
  },
  entityTypeName: function entityTypeName(name) {
    return {
      db_name: dbName,
      entity: "Organization",
      sort: "Organization.name",
      filter: "Organization.OrgType ANY =='".concat(name, "' && Organization.activestatus==true"),
      return_fields: "Organization"
    };
  }
};

var generateSaveJSON = function generateSaveJSON(data) {
  var filter = {};

  if (data.editData) {
    filter = {
      filter: {
        _key: data.editData
      }
    };
  }

  return [_objectSpread2(_objectSpread2({
    db_name: dbName,
    entity: "OrderCatalog",
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
  }, filter), {}, {
    doc: {
      _id: "",
      id: data.id,
      ordercatalog: data.code,
      shortdesc: data.shortdes,
      longdesc: data.longdes,
      catalogsynonym: data.catalogSynonym,
      mappingcodes: [{
        codesystem: "",
        mappedcode: ""
      }],
      ordercategory: data.orderCategory ? data.orderCategory.value : "",
      ordertype: data.orderType ? data.orderType.value : "",
      healthcareservicecode: data.healthcareService ? data.healthcareService.value : "",
      //reflexonresult: "boolean",
      completeonorder: data.characteristicJson[0].checked,
      mappingmoduleId: "",
      mappingitemcode: "",
      AvailablebyPerOrganization: getAvailability(data.FacilityData),
      chargeable: data.characteristicJson[3].checked,
      resultappl: data.characteristicJson[4].checked,
      resultauthreqd: data.characteristicJson[5].checked,
      explanatorynote: data.explantorymsg,
      // promptalertreqd: "boolean",
      // alertmessageCriteria: "string",
      // alertMessageText: "string",
      // alertAction: "string",
      // orderAccessLevel: "number",
      dfltqty: data.Qtyno ? parseInt(data.Qtyno) : 0,
      allowqtychange: data.AllowQtyCheck,
      maxorderqty: data.Qtyno ? parseInt(data.maxno) : 0,
      holdappl: data.characteristicJson[1].checked,
      discontinuappl: data.characteristicJson[2].checked,
      consentreqd: data.consentSwitch,
      consentformid: data.ConsentForm ? data.ConsentForm.value : "",
      checkforrepeatorders: data.checkSwitch,
      repeatcheckperiod: data.no ? parseInt(data.no) : 0,
      repeatCheckUOM: data.DuplicatePeriod ? data.DuplicatePeriod.value : "",
      repeatCheckAction: data.CheckAction ? data.CheckAction.value : "",
      status: data.status,
      dfltqtyUOM: data.DefaultQuantity ? data.DefaultQuantity.value : "",
      maxorderqtyUOM: data.Maxorder ? data.Maxorder.value : "",
      dfltSpecimenType: data.SpecimenType ? data.SpecimenType.value : "",
      dfltSpecimenVolume: data.VolumeQuantity ? parseInt(data.VolumeQuantity) : 0,
      dfltSpecimenVolumeUOM: data.Volume ? data.Volume.value : "",
      dfltSpecimenCollectionMethod: data.CollectionMethod ? data.CollectionMethod.value : "",
      dfltSpecimenContainer: data.SpecimenContainer ? data.SpecimenContainer.value : "",
      dfltSpecimenBodySite: data.BodyType ? data.BodyType.value : "",
      dfltFastingPeriod: data.FastingPeriodQuantity ? parseInt(data.FastingPeriodQuantity) : 0,
      dfltFastingPeriodUOM: data.FastingPeriod ? data.FastingPeriod.value : "",
      OrderCatalogByEncounterTypeAge: getInstructionAndFrequency(data.instructions, data.frequency, data.Frequency_applicability),
      draftstatus: data.draftstatus,
      OrderAttribApplicability: getAttributes(data.AttributeList, data.attribute)
    }
  })];
};

var getAvailability = function getAvailability(data) {
  var arr = data.map(function (v) {
    var _v$entity_name$value, _v$entity_name, _v$appointment, _parseInt, _v$entity_type$value, _v$entity_type;

    return {
      perforganizationId: (_v$entity_name$value = v === null || v === void 0 ? void 0 : (_v$entity_name = v.entity_name) === null || _v$entity_name === void 0 ? void 0 : _v$entity_name.value) !== null && _v$entity_name$value !== void 0 ? _v$entity_name$value : null,
      apptreqd: (_v$appointment = v === null || v === void 0 ? void 0 : v.appointment) !== null && _v$appointment !== void 0 ? _v$appointment : false,
      apptDurnInMinutes: (_parseInt = parseInt(v.duration)) !== null && _parseInt !== void 0 ? _parseInt : null,
      perfOrganizationEntity: (_v$entity_type$value = v === null || v === void 0 ? void 0 : (_v$entity_type = v.entity_type) === null || _v$entity_type === void 0 ? void 0 : _v$entity_type.value) !== null && _v$entity_type$value !== void 0 ? _v$entity_type$value : null,
      EffFrDate: v !== null && v !== void 0 && v.effective_from ? getUtcTime(moment__default["default"](v.effective_from, "DD/MM/YYYY")) : null,
      EffToDate: v !== null && v !== void 0 && v.effective_to ? getUtcTime(moment__default["default"](v === null || v === void 0 ? void 0 : v.effective_to, "DD/MM/YYYY")) : null
    };
  });
  return arr;
};

var getAttributes = function getAttributes(data, attri) {
  var arr = data.map(function (v, i) {
    return {
      _id: v._id,
      id: 0,
      attribusageCriteria: "",
      winlabelName: attri,
      AttribComponents: [{
        attribSeq: i + 1,
        attribCode: v.Attcode.label,
        attribdefaultVal: v.defaultValue.label,
        attribType: v.type,
        attribLabel: v.label
      }]
    };
  });
  return arr;
};

var getInstructionAndFrequency = function getInstructionAndFrequency(insdata, fredata, freapp) {
  var arr = [];
  insdata.map(function (v, i) {
    arr.push({
      _id: v._id,
      id: 0,
      serviceapplicability: "Service",
      setuptypeInd: "Instruction",
      encountertype: v.encounterType ? v.encounterType.value : "",
      gendercode: v.gender ? v.gender.value : "",
      agegroup: v.ageRange ? v.ageRange.value : "",
      agecatgcode: v.agecategory ? v.agecategory.map(function (a) {
        return a.value;
      }) : [],
      OrderInstr: [{
        patientInst: v.patientInstrction,
        practionerInst: v.practitionerInstrction,
        prepInstr: v.prepratoryInstrction,
        deptInstr: v.departmentInstrction
      }]
    });
  });
  fredata.map(function (v) {
    arr.push({
      _id: v._id,
      id: 0,
      serviceapplicability: "Service",
      setuptypeInd: "DefaultValues",
      ordercatalog: "string",
      encountertype: v.encounterType ? v.encounterType.value : "",
      gendercode: v.gender ? v.gender.value : "",
      agegroup: v.ageRange ? v.ageRange.value : "",
      agecatgcode: v.agecategory ? v.agecategory.map(function (a) {
        return a.value;
      }) : [],
      freqappl: freapp,
      dfltfreqValue: v.freqvalue ? parseInt(v.freqvalue) : 0,
      dfltfreqValueUnit: v.freqValSelect ? v.freqValSelect.value : "",
      dfltfreqRate: v.freqrate ? parseInt(v.freqrate) : 0,
      dfltfreqRateUnit: v.freqRatSelect ? v.freqRatSelect.value : "",
      dfltduration: v.freqdura ? parseInt(v.freqdura) : 0,
      dfltdurationType: v.freqDuraSelect ? v.freqDuraSelect.value : "",
      maxdurnallowedinDays: v.freqmax ? parseInt(v.freqmax) : 0
    });
  });
  return arr;
}; //for table response (readJSon)


var generateResJson = function generateResJson(data) {
  var list = data.map(function (val) {
    return _objectSpread2({
      code: val.ordercatalog ? val.ordercatalog : "",
      "short": val.shortdesc ? val.shortdesc : "",
      "long": val.longdesc ? val.longdesc : "",
      status: val.status ? val.status : false,
      draft: val.draftstatus
    }, val);
  });
  return list;
}; //for status update

var generateUpdateJSON = function generateUpdateJSON(editID, Status) {
  return [{
    db_name: dbName,
    entity: "OrderCatalog",
    filter: {
      _key: editID
    },
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
    doc: {
      status: Status
    }
  }];
}; //for edit read JSON

var generateReadResJson = function generateReadResJson(val, state) {
  var _val$catalogsynonym, _val$ordercategory, _val$ordertype, _val$healthcareservic, _val$dfltqtyUOM, _val$maxorderqtyUOM, _val$repeatCheckUOM, _val$repeatCheckActio, _val$dfltSpecimenType, _val$dfltSpecimenVolu, _val$dfltSpecimenBody, _val$dfltFastingPerio, _val$dfltSpecimenCont, _val$dfltSpecimenColl;

  return {
    code: val.ordercatalog,
    longdes: val.longdesc,
    shortdes: val.shortdesc,
    catalogSynonym: (_val$catalogsynonym = val.catalogsynonym) !== null && _val$catalogsynonym !== void 0 ? _val$catalogsynonym : "",
    orderCategory: val !== null && val !== void 0 && val.ordercategory && val !== null && val !== void 0 && (_val$ordercategory = val.ordercategory) !== null && _val$ordercategory !== void 0 && _val$ordercategory._id ? state.order_catalog_masters.data.orderCategory.find(function (sys) {
      return val.ordercategory._id.indexOf(sys.value) > -1;
    }) : null,
    orderType: val.ordertype && (_val$ordertype = val.ordertype) !== null && _val$ordertype !== void 0 && _val$ordertype._id ? state.order_catalog_masters.data.orderType.find(function (sys) {
      return val.ordertype._id.indexOf(sys.value) > -1;
    }) : null,
    healthcareService: val.healthcareservicecode && (_val$healthcareservic = val.healthcareservicecode) !== null && _val$healthcareservic !== void 0 && _val$healthcareservic._id ? state.order_catalog_masters.data.healthService.find(function (sys) {
      return val.healthcareservicecode._id.indexOf(sys.value) > -1;
    }) : null,
    Qtyno: val.dfltqty,
    DefaultQuantity: val.dfltqtyUOM && (_val$dfltqtyUOM = val.dfltqtyUOM) !== null && _val$dfltqtyUOM !== void 0 && _val$dfltqtyUOM._id ? state.order_catalog_masters.data.quantity.find(function (sys) {
      return val.dfltqtyUOM._id.indexOf(sys.value) > -1;
    }) : null,
    AllowQtyCheck: val.allowqtychange,
    maxno: val.maxorderqty,
    Maxorder: val.maxorderqtyUOM && (_val$maxorderqtyUOM = val.maxorderqtyUOM) !== null && _val$maxorderqtyUOM !== void 0 && _val$maxorderqtyUOM._id ? state.order_catalog_masters.data.quantity.find(function (sys) {
      return val.maxorderqtyUOM._id.indexOf(sys.value) > -1;
    }) : null,
    explantorymsg: val.explanatorynote,
    characteristicJson: [{
      label: "Complete On Order",
      checked: val.completeonorder
    }, {
      label: "Hold Applicable",
      checked: val.holdappl
    }, {
      label: "Discontinue Applicable",
      checked: val.discontinuappl
    }, {
      label: "Chargeable",
      checked: val.chargeable
    }, {
      label: "Result Applicable",
      checked: val.resultappl
    }, {
      label: "Result Authentication Required",
      checked: val.resultauthreqd
    }],
    checkSwitch: val.checkforrepeatorders,
    no: val.repeatcheckperiod,
    DuplicatePeriod: val.repeatCheckUOM && (_val$repeatCheckUOM = val.repeatCheckUOM) !== null && _val$repeatCheckUOM !== void 0 && _val$repeatCheckUOM._id ? state.order_catalog_masters.data.quantity.find(function (sys) {
      return val.repeatCheckUOM._id.indexOf(sys.value) > -1;
    }) : null,
    CheckAction: val.repeatCheckAction && (_val$repeatCheckActio = val.repeatCheckAction) !== null && _val$repeatCheckActio !== void 0 && _val$repeatCheckActio._id ? state.order_catalog_masters.data.checkaction.find(function (sys) {
      return val.repeatCheckAction._id.indexOf(sys.value) > -1;
    }) : null,
    consentSwitch: val.consentreqd,
    ConsentForm: null,
    attribute: val.OrderAttribApplicability.length > 0 ? val.OrderAttribApplicability[0].winlabelName : "",
    AttributeList: generateAttribute(val.OrderAttribApplicability, state),
    FacilityData: generatefaciltity(val.AvailablebyPerOrganization, state),
    SpecimenType: val.dfltSpecimenType && (_val$dfltSpecimenType = val.dfltSpecimenType) !== null && _val$dfltSpecimenType !== void 0 && _val$dfltSpecimenType._id ? state.order_catalog_masters.data.specimenType.find(function (sys) {
      return val.dfltSpecimenType._id.indexOf(sys.value) > -1;
    }) : null,
    VolumeQuantity: val.dfltSpecimenVolume,
    Volume: val.dfltSpecimenVolumeUOM && (_val$dfltSpecimenVolu = val.dfltSpecimenVolumeUOM) !== null && _val$dfltSpecimenVolu !== void 0 && _val$dfltSpecimenVolu._id ? state.order_catalog_masters.data.quantity.find(function (sys) {
      return val.dfltSpecimenVolumeUOM._id.indexOf(sys.value) > -1;
    }) : null,
    BodyType: val.dfltSpecimenBodySite && (_val$dfltSpecimenBody = val.dfltSpecimenBodySite) !== null && _val$dfltSpecimenBody !== void 0 && _val$dfltSpecimenBody._id ? state.order_catalog_masters.data.bodySite.find(function (sys) {
      return val.dfltSpecimenBodySite._id.indexOf(sys.value) > -1;
    }) : null,
    FastingPeriodQuantity: val.dfltFastingPeriod,
    FastingPeriod: val.dfltFastingPeriodUOM && (_val$dfltFastingPerio = val.dfltFastingPeriodUOM) !== null && _val$dfltFastingPerio !== void 0 && _val$dfltFastingPerio._id ? state.order_catalog_masters.data.quantity.find(function (sys) {
      return val.dfltFastingPeriodUOM._id.indexOf(sys.value) > -1;
    }) : null,
    SpecimenContainer: val.dfltSpecimenContainer && (_val$dfltSpecimenCont = val.dfltSpecimenContainer) !== null && _val$dfltSpecimenCont !== void 0 && _val$dfltSpecimenCont._id ? state.order_catalog_masters.data.specimenContainer.find(function (sys) {
      return val.dfltSpecimenContainer._id.indexOf(sys.value) > -1;
    }) : null,
    CollectionMethod: val.dfltSpecimenCollectionMethod && (_val$dfltSpecimenColl = val.dfltSpecimenCollectionMethod) !== null && _val$dfltSpecimenColl !== void 0 && _val$dfltSpecimenColl._id ? state.order_catalog_masters.data.collectionMethod.find(function (sys) {
      return val.dfltSpecimenCollectionMethod._id.indexOf(sys.value) > -1;
    }) : null,
    instructions: generateInstruction(val.OrderCatalogByEncounterTypeAge, state),
    Frequency_applicability: generateFrequency(val.OrderCatalogByEncounterTypeAge, state).length > 0 ? true : false,
    frequency: generateFrequency(val.OrderCatalogByEncounterTypeAge, state),
    editData: val._key,
    id: val.id,
    draftstatus: val.draftstatus,
    status: val.status
  };
};

var generateAttribute = function generateAttribute(data, state) {
  var arr = data.map(function (v) {
    return {
      Attcode: state.order_catalog_masters.data.attrcode.find(function (sys) {
        return v.AttribComponents[0].attribCode.indexOf(sys.label) > -1;
      }),
      label: v.AttribComponents[0].attribLabel,
      type: v.AttribComponents[0].attribType,
      defaultValue: v.AttribComponents[0].attribType === "Number" || v.AttribComponents[0].attribType === "Text" ? {
        label: v.AttribComponents[0].attribdefaultVal
      } : getDefautlValue(v, state.order_catalog_masters.data.attrcode),
      _id: v._key
    };
  });
  return arr;
};

var getDefautlValue = function getDefautlValue(v, attr) {
  var obj = attr.find(function (sys) {
    return v.AttribComponents[0].attribCode.indexOf(sys.label) > -1;
  });
  var value = obj.AttribValidValues.find(function (sys) {
    return v.AttribComponents[0].attribdefaultVal.indexOf(sys.label) > -1;
  });
  return value;
};

var generateInstruction = function generateInstruction(data, state) {
  var _obj$Instruction, _obj$Instruction$data;

  var obj = {};
  data.forEach(function (element) {
    var name = element.setuptypeInd;

    if (name in obj) {
      obj[name].data.push(element);
    } else {
      obj[name] = {
        data: []
      };
      obj[name].data.push(element);
    }
  }); //let filterData = Object.values(obj);
  // let instructionArr = [];
  // for (let index = 0; index < obj.Instruction.data.length; index++) {
  //   let v = obj?.Instruction?.data[index];
  //   
  //   let Loopobj = {};
  //   (Loopobj["encounterType"] =
  //     state.order_catalog_masters.data.encounterType.find(
  //       (sys) => v.encountertype.indexOf(sys.value) > -1
  //     )),
  //     (Loopobj["gender"] = state.order_catalog_masters.data.gender.find(
  //       (sys) => v.gendercode.indexOf(sys.value) > -1
  //     )),
  //     (Loopobj["ageRange"] = state.order_catalog_masters.data.ageGroup.find(
  //       (sys) => v.agegroup.indexOf(sys.value) > -1
  //     )),
  //     (Loopobj["agecategory"] = await getCategory(
  //       v.agegroup,
  //       v.agecatgcode,
  //       state
  //     )),
  //     (Loopobj["patientInstrction"] = v.OrderInstr[0].patientInst),
  //     (Loopobj["practitionerInstrction"] = v.OrderInstr[0].practionerInst),
  //     (Loopobj["prepratoryInstrction"] = v.OrderInstr[0].prepInstr),
  //     (Loopobj["departmentInstrction"] = v.OrderInstr[0].deptInstr),
  //     instructionArr.push(Loopobj);
  // }

  var instructionArr = obj === null || obj === void 0 ? void 0 : (_obj$Instruction = obj.Instruction) === null || _obj$Instruction === void 0 ? void 0 : (_obj$Instruction$data = _obj$Instruction.data) === null || _obj$Instruction$data === void 0 ? void 0 : _obj$Instruction$data.map(function (v) {
    return {
      encounterType: v.encountertype ? state.order_catalog_masters.data.encounterType.find(function (sys) {
        return v.encountertype.indexOf(sys.value) > -1;
      }) : null,
      gender: v.gendercode ? state.order_catalog_masters.data.gender.find(function (sys) {
        return v.gendercode.indexOf(sys.value) > -1;
      }) : null,
      ageRange: v.agegroup ? state.order_catalog_masters.data.ageGroup.find(function (sys) {
        return v.agegroup.indexOf(sys.value) > -1;
      }) : null,
      agecategory: v.agecatgcode.map(function (v) {
        return {
          label: "",
          value: v
        };
      }),
      patientInstrction: v.OrderInstr[0].patientInst,
      practitionerInstrction: v.OrderInstr[0].practionerInst,
      prepratoryInstrction: v.OrderInstr[0].prepInstr,
      departmentInstrction: v.OrderInstr[0].deptInstr,
      _id: v._id
    };
  });
  var ActualData = instructionArr !== undefined ? instructionArr : [];
  return ActualData;
};

var generateFrequency = function generateFrequency(data, state) {
  var _obj$DefaultValues, _obj$DefaultValues$da;

  var obj = {};
  data.forEach(function (element) {
    var name = element.setuptypeInd;

    if (name in obj) {
      obj[name].data.push(element);
    } else {
      obj[name] = {
        data: []
      };
      obj[name].data.push(element);
    }
  }); //let filterData = Object.values(obj);
  // let instructionArr = [];
  // for (let index = 0; index < obj.Instruction.data.length; index++) {
  //   let v = obj?.Instruction?.data[index];
  //   
  //   let Loopobj = {};
  //   (Loopobj["encounterType"] =
  //     state.order_catalog_masters.data.encounterType.find(
  //       (sys) => v.encountertype.indexOf(sys.value) > -1
  //     )),
  //     (Loopobj["gender"] = state.order_catalog_masters.data.gender.find(
  //       (sys) => v.gendercode.indexOf(sys.value) > -1
  //     )),
  //     (Loopobj["ageRange"] = state.order_catalog_masters.data.ageGroup.find(
  //       (sys) => v.agegroup.indexOf(sys.value) > -1
  //     )),
  //     (Loopobj["agecategory"] = await getCategory(
  //       v.agegroup,
  //       v.agecatgcode,
  //       state
  //     )),
  //     (Loopobj["patientInstrction"] = v.OrderInstr[0].patientInst),
  //     (Loopobj["practitionerInstrction"] = v.OrderInstr[0].practionerInst),
  //     (Loopobj["prepratoryInstrction"] = v.OrderInstr[0].prepInstr),
  //     (Loopobj["departmentInstrction"] = v.OrderInstr[0].deptInstr),
  //     instructionArr.push(Loopobj);
  // }

  var frequency = [];
  frequency = obj === null || obj === void 0 ? void 0 : (_obj$DefaultValues = obj.DefaultValues) === null || _obj$DefaultValues === void 0 ? void 0 : (_obj$DefaultValues$da = _obj$DefaultValues.data) === null || _obj$DefaultValues$da === void 0 ? void 0 : _obj$DefaultValues$da.map(function (v) {
    return {
      encounterType: v.encountertype ? state.order_catalog_masters.data.encounterType.find(function (sys) {
        return v.encountertype.indexOf(sys.value) > -1;
      }) : null,
      gender: v.gendercode ? state.order_catalog_masters.data.gender.find(function (sys) {
        return v.gendercode.indexOf(sys.value) > -1;
      }) : null,
      ageRange: v.agegroup ? state.order_catalog_masters.data.ageGroup.find(function (sys) {
        return v.agegroup.indexOf(sys.value) > -1;
      }) : null,
      agecategory: v.agecatgcode.map(function (v) {
        return {
          label: "",
          value: v
        };
      }),
      freqvalue: v.dfltfreqValue,
      freqValSelect: v.dfltfreqValueUnit ? state.order_catalog_masters.data.quantity.find(function (sys) {
        return v.dfltfreqValueUnit.indexOf(sys.value) > -1;
      }) : null,
      freqrate: v.dfltfreqRate,
      freqRatSelect: v.dfltfreqRateUnit ? state.order_catalog_masters.data.quantity.find(function (sys) {
        return v.dfltfreqRateUnit.indexOf(sys.value) > -1;
      }) : null,
      freqdura: v.dfltduration,
      freqDuraSelect: v.dfltdurationType ? state.order_catalog_masters.data.quantity.find(function (sys) {
        return v.dfltdurationType.indexOf(sys.value) > -1;
      }) : null,
      freqmax: v.maxdurnallowedinDays,
      _id: v._id
    };
  });
  var ActualData = frequency !== undefined ? frequency : [];
  return ActualData;
};

var generatefaciltity = function generatefaciltity(data, state) {
  var facilityArr = data.map(function (v) {
    var _v$apptreqd, _v$apptDurnInMinutes;

    return {
      entity_type: v.perfOrganizationEntity && v.perfOrganizationEntity._id ? state.order_catalog_masters.data.entityType.find(function (sys) {
        return v.perfOrganizationEntity._id.indexOf(sys.value) > -1;
      }) : null,
      // entity_name: v.perforganizationId
      //   ? state.order_catalog_masters.data.entitytName.find(
      //       (sys) => v.perforganizationId._id.indexOf(sys.value) > -1
      //     )
      //   : null,
      entity_name: v.perforganizationId && v.perforganizationId._id ? {
        label: v.perforganizationId.name,
        value: v.perforganizationId._id
      } : null,
      appointment: (_v$apptreqd = v === null || v === void 0 ? void 0 : v.apptreqd) !== null && _v$apptreqd !== void 0 ? _v$apptreqd : false,
      duration: (_v$apptDurnInMinutes = v === null || v === void 0 ? void 0 : v.apptDurnInMinutes) !== null && _v$apptDurnInMinutes !== void 0 ? _v$apptDurnInMinutes : "",
      effective_from: v !== null && v !== void 0 && v.EffFrDate ? new Date(utcTOLocal(v.EffFrDate)).toLocaleDateString() : "",
      effective_to: v !== null && v !== void 0 && v.EffToDate ? new Date(utcTOLocal(v.EffToDate)).toLocaleDateString() : ""
    };
  });
  return facilityArr;
}; //getCategory(v.agegroup, v.agecatgcode, state)
// const getCategory = (ageGrp, ageCatgry, state) => {
//   let ageRange = state.order_catalog_masters.data.ageGroup.find(
//     (sys) => ageGrp.indexOf(sys.value) > -1
//   );
//   const data = fetchData(
//     { body: JSON.stringify(Query.ageCategory(ageRange.value)) },
//     __readDocumentUrl__
//   );
//   let arr = [];
//   data.result[0].map((val) => {
//     arr.push({
//       value: val._id,
//       label: val.code,
//       minAge: val.age_minimum,
//       maxAge: val.age_maximum,
//     });
//   });
//   let Category = arr.filter((sys) => ageCatgry.indexOf(sys.value) > -1);
//   
//   return Category;
// };

var _extraReducers$d;
var fileds$3 = ["quantity", "gender", "checkaction", "entityType", "specimenType", "bodySite", "specimenContainer", "collectionMethod", "encounterType"];

var loopMasters$4 = function loopMasters() {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject) {
      var calls;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              calls = Object.keys(masterQuery$4).map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return fetchMaster$4(val, masterQuery$4[val]);

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
              es6Promise.Promise.all(calls).then(function (data) {
                var json = {};
                data.map(function (val) {
                  var arr = [];
                  val.data.map(function (value) {
                    if (fileds$3.includes(val.name)) {
                      if (value.coding[0] !== null) {
                        arr.push({
                          label: value.coding[0].display,
                          value: value.coding[0]._id
                        });
                      }
                    } else if ("orderCategory" === val.name) {
                      arr.push({
                        label: value.ordercategory,
                        value: value._id
                      });
                    } else if ("orderType" === val.name) {
                      arr.push({
                        label: value.ordertype,
                        value: value._id
                      });
                    } else if ("healthService" === val.name) {
                      arr.push({
                        label: value.name,
                        value: value._id
                      });
                    } else if ("entitytName" === val.name) {
                      arr.push({
                        label: value.name,
                        value: value._id
                      });
                    } else if ("ageGroup" === val.name) {
                      arr.push({
                        label: value.agerangecode,
                        value: value._id
                      });
                    } else if ("attrcode" === val.name) {
                      var _value$AttribValidVal;

                      arr.push({
                        label: value.attribcode,
                        value: value._id,
                        name: value.attriblabel,
                        type: value.attribtype,
                        AttribValidValues: ((_value$AttribValidVal = value.AttribValidValues) === null || _value$AttribValidVal === void 0 ? void 0 : _value$AttribValidVal.length) > 0 && value.AttribValidValues.map(function (v) {
                          return {
                            label: v.validCode,
                            Dfltflag: v.Dfltflag
                          };
                        })
                      });
                    }
                  });
                  json[val.name] = arr;
                  resolve(json);
                });
              })["catch"](function (err) {
                resolve([]);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var fetchMaster$4 = function fetchMaster(name, query) {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetchData({
                body: query
              }, __readDocumentUrl__);

            case 2:
              data = _context3.sent;
              resolve({
                data: data.result,
                name: name
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }());
};

var ORDER_CATALOG_MASTERS = toolkit.createAsyncThunk("orderCatalogApiSlice/order_catalog_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref5,
      rejectWithValue,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref5 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref5.rejectWithValue;
          _context4.prev = 2;
          payload.type;
          _context4.next = 6;
          return loopMasters$4();

        case 6:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 10]]);
})));
var ENTITY_NAME_DATA = toolkit.createAsyncThunk("orderCatalogApiSlice/entity_name_data", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref7,
      rejectWithValue,
      type,
      queriesjson,
      data,
      arry,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref7 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref7.rejectWithValue;
          _context5.prev = 2;
          type = payload.type;
          queriesjson = Query.entityTypeName(type);
          _context5.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 7:
          data = _context5.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push({
              label: val.name,
              value: val._id
            });
          });
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: arry
          }));

        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 16:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 13]]);
})));
var ORDER_TYPE_DATA = toolkit.createAsyncThunk("orderCatalogApiSlice/order_type_data", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref9,
      rejectWithValue,
      type,
      queriesjson,
      data,
      arry,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref9 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref9.rejectWithValue;
          _context6.prev = 2;
          type = payload.type;
          queriesjson = orderTypedata.ordertype(type);
          _context6.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 7:
          data = _context6.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push({
              label: val.ordertype,
              value: val._id
            });
          });
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: arry
          }));

        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 16:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 13]]);
})));
var AGE_RANGES_CATEGORY_CATALOG = toolkit.createAsyncThunk("orderCatalogApiSlice/ageranges_Category", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref11,
      rejectWithValue,
      ageRangeId,
      data,
      arr,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref11 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref11.rejectWithValue;
          _context7.prev = 2;
          ageRangeId = payload.ageRangeId;
          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(Query.ageCategory(ageRangeId))
          }, __readDocumentUrl__);

        case 6:
          data = _context7.sent;
          arr = [];
          data.result[0].map(function (val) {
            arr.push({
              value: val._id,
              label: val.code,
              minAge: val.age_minimum,
              maxAge: val.age_maximum
            });
          });
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 15:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 12]]);
})));
var SAVE_ORDER_CATALOG = toolkit.createAsyncThunk("orderCatalogApiSlice/saveOrderCatalog", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref13,
      rejectWithValue,
      list,
      body,
      data,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref13 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref13.rejectWithValue;
          _context8.prev = 2;
          list = payload.list;
          body = generateSaveJSON(list);
          _context8.next = 7;
          return fetchData({
            body: JSON.stringify(body)
          }, __uspsertUrl__);

        case 7:
          data = _context8.sent;
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 14:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 11]]);
})));
var READ_ORDER_CATALOG = toolkit.createAsyncThunk("orderCatalogApiSlice/orderCatalogRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref15,
      rejectWithValue,
      page,
      perPage,
      data,
      res,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref15 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref15.rejectWithValue, _ref15.getState;
          _context9.prev = 2;
          // const { encounter_id } = payload;
          // let state = getState();
          // let ccState = state.DiagnosisMasterSlice;
          page = payload.page, perPage = payload.perPage;
          _context9.next = 6;
          return fetchData({
            body: JSON.stringify(Query.order_catalog_read({
              page: page,
              perPage: perPage
            }))
          }, __readDocumentUrl__);

        case 6:
          data = _context9.sent;
          res = generateResJson(data.result);
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 11:
          _context9.prev = 11;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 14:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 11]]);
})));
var UPDATE_ORDER_CATALOG_STATUS = toolkit.createAsyncThunk("orderCatalogApiSlice/orderCatalogUpdate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref17,
      rejectWithValue,
      editId,
      status,
      body,
      data,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref17 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref17.rejectWithValue;
          _context10.prev = 2;
          editId = payload.editId, status = payload.status;
          body = generateUpdateJSON(editId, status);
          _context10.next = 7;
          return fetchData({
            body: JSON.stringify(body)
          }, __uspsertUrl__);

        case 7:
          data = _context10.sent;
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context10.prev = 11;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 14:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 11]]);
})));
var EDIT_ORDER_CATALOG = toolkit.createAsyncThunk("orderCatalogApiSlice/editOrderCatalog", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var payload,
      _ref19,
      rejectWithValue,
      getState,
      id,
      state,
      ccState,
      data,
      res,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
          _ref19 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref19.rejectWithValue, getState = _ref19.getState;
          _context11.prev = 2;
          id = payload.id;
          state = getState();
          ccState = state.orderCatalogSlice;
          _context11.next = 8;
          return fetchData({
            body: JSON.stringify(Query.editOrderCatalog(id))
          }, __readDocumentUrl__);

        case 8:
          data = _context11.sent;
          res = generateReadResJson(data.result[0], ccState);
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 13:
          _context11.prev = 13;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 16:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 13]]);
})));
var DELETE_ATTRIBUTE_DELETE = toolkit.createAsyncThunk("orderCatalogApiSlice/attributesDelete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var payload,
      _ref21,
      rejectWithValue,
      id,
      data,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
          _ref21 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref21.rejectWithValue;
          _context12.prev = 2;
          id = payload.id;
          _context12.next = 6;
          return fetchData({
            body: JSON.stringify(Query.attributeDelete(id))
          }, __softDelete__);

        case 6:
          data = _context12.sent;
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context12.prev = 10;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 13:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 10]]);
})));
var orderCatalogSlice = toolkit.createSlice({
  name: "orderCatalogApiSlice",
  initialState: {
    order_catalog_masters: _objectSpread2({}, defaultState.Info),
    ageranges_category_catalog: _objectSpread2({}, defaultState.List),
    save_order_catalog: _objectSpread2({}, defaultState.Info),
    order_catalog_read: _objectSpread2({}, defaultState.List),
    order_catalog_status_update: _objectSpread2({}, defaultState.List),
    edit_order_catalog: _objectSpread2({}, defaultState.List),
    attribute_delete: _objectSpread2({}, defaultState.List),
    order_type_data: _objectSpread2({}, defaultState.List),
    entityTypeName: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$d = {}, _defineProperty(_extraReducers$d, ENTITY_NAME_DATA.fulfilled, function (state, action) {
    state.entityTypeName.loading = false, state.entityTypeName.error = false, state.entityTypeName = action.payload;
  }), _defineProperty(_extraReducers$d, ENTITY_NAME_DATA.pending, function (state, action) {
    state.entityTypeName.loading = true, state.entityTypeName.error = false, state.entityTypeName.loading = true;
  }), _defineProperty(_extraReducers$d, ENTITY_NAME_DATA.rejected, function (state, action) {
    state.entityTypeName.loading = false, state.entityTypeName.error = true, state.entityTypeName = action.payload;
  }), _defineProperty(_extraReducers$d, ORDER_CATALOG_MASTERS.fulfilled, function (state, action) {
    state.order_catalog_masters.loading = false, state.order_catalog_masters.error = false, state.order_catalog_masters = action.payload;
  }), _defineProperty(_extraReducers$d, ORDER_CATALOG_MASTERS.pending, function (state, action) {
    state.order_catalog_masters.loading = true, state.order_catalog_masters.error = false, state.order_catalog_masters.loading = true;
  }), _defineProperty(_extraReducers$d, ORDER_CATALOG_MASTERS.rejected, function (state, action) {
    state.order_catalog_masters.loading = false, state.order_catalog_masters.error = true, state.order_catalog_masters = action.payload;
  }), _defineProperty(_extraReducers$d, ORDER_TYPE_DATA.fulfilled, function (state, action) {
    state.order_type_data.loading = false, state.order_type_data.error = false, state.order_type_data = action.payload;
  }), _defineProperty(_extraReducers$d, ORDER_TYPE_DATA.pending, function (state, action) {
    state.order_type_data.loading = true, state.order_type_data.error = false, state.order_type_data.loading = true;
  }), _defineProperty(_extraReducers$d, ORDER_TYPE_DATA.rejected, function (state, action) {
    state.order_type_data.loading = false, state.order_type_data.error = true, state.order_type_data = action.payload;
  }), _defineProperty(_extraReducers$d, AGE_RANGES_CATEGORY_CATALOG.fulfilled, function (state, action) {
    state.ageranges_category_catalog.loading = false, state.ageranges_category_catalog.error = false, state.ageranges_category_catalog = action.payload;
  }), _defineProperty(_extraReducers$d, AGE_RANGES_CATEGORY_CATALOG.pending, function (state, action) {
    state.ageranges_category_catalog.loading = true, state.ageranges_category_catalog.error = false, state.ageranges_category_catalog.loading = true;
  }), _defineProperty(_extraReducers$d, AGE_RANGES_CATEGORY_CATALOG.rejected, function (state, action) {
    state.ageranges_category_catalog.loading = false, state.ageranges_category_catalog.error = true, state.ageranges_category_catalog = action.payload;
  }), _defineProperty(_extraReducers$d, SAVE_ORDER_CATALOG.fulfilled, function (state, action) {
    state.save_order_catalog.loading = false, state.save_order_catalog.error = false, state.save_order_catalog = action.payload;
  }), _defineProperty(_extraReducers$d, SAVE_ORDER_CATALOG.pending, function (state, action) {
    state.save_order_catalog.loading = true, state.save_order_catalog.error = false, state.save_order_catalog.loading = true;
  }), _defineProperty(_extraReducers$d, SAVE_ORDER_CATALOG.rejected, function (state, action) {
    state.save_order_catalog.loading = false, state.save_order_catalog.error = true, state.save_order_catalog = action.payload;
  }), _defineProperty(_extraReducers$d, READ_ORDER_CATALOG.fulfilled, function (state, action) {
    state.order_catalog_read.loading = false, state.order_catalog_read.error = false, state.order_catalog_read = action.payload;
  }), _defineProperty(_extraReducers$d, READ_ORDER_CATALOG.pending, function (state, action) {
    state.order_catalog_read.loading = true, state.order_catalog_read.error = false, state.order_catalog_read.loading = true;
  }), _defineProperty(_extraReducers$d, READ_ORDER_CATALOG.rejected, function (state, action) {
    state.order_catalog_read.loading = false, state.order_catalog_read.error = true, state.order_catalog_read = action.payload;
  }), _defineProperty(_extraReducers$d, UPDATE_ORDER_CATALOG_STATUS.fulfilled, function (state, action) {
    state.order_catalog_status_update.loading = false, state.order_catalog_status_update.error = false, state.order_catalog_status_update = action.payload;
  }), _defineProperty(_extraReducers$d, UPDATE_ORDER_CATALOG_STATUS.pending, function (state, action) {
    state.order_catalog_status_update.loading = true, state.order_catalog_status_update.error = false, state.order_catalog_status_update.loading = true;
  }), _defineProperty(_extraReducers$d, UPDATE_ORDER_CATALOG_STATUS.rejected, function (state, action) {
    state.order_catalog_status_update.loading = false, state.order_catalog_status_update.error = true, state.order_catalog_status_update = action.payload;
  }), _defineProperty(_extraReducers$d, EDIT_ORDER_CATALOG.fulfilled, function (state, action) {
    state.edit_order_catalog.loading = false, state.edit_order_catalog.error = false, state.edit_order_catalog = action.payload;
  }), _defineProperty(_extraReducers$d, EDIT_ORDER_CATALOG.pending, function (state, action) {
    state.edit_order_catalog.loading = true, state.edit_order_catalog.error = false, state.edit_order_catalog.loading = true;
  }), _defineProperty(_extraReducers$d, EDIT_ORDER_CATALOG.rejected, function (state, action) {
    state.edit_order_catalog.loading = false, state.edit_order_catalog.error = true, state.edit_order_catalog = action.payload;
  }), _defineProperty(_extraReducers$d, DELETE_ATTRIBUTE_DELETE.fulfilled, function (state, action) {
    state.attribute_delete.loading = false, state.attribute_delete.error = false, state.attribute_delete = action.payload;
  }), _defineProperty(_extraReducers$d, DELETE_ATTRIBUTE_DELETE.pending, function (state, action) {
    state.attribute_delete.loading = true, state.attribute_delete.error = false, state.attribute_delete.loading = true;
  }), _defineProperty(_extraReducers$d, DELETE_ATTRIBUTE_DELETE.rejected, function (state, action) {
    state.attribute_delete.loading = false, state.attribute_delete.error = true, state.attribute_delete = action.payload;
  }), _extraReducers$d)
});
var orderCatalogActions = {
  ORDER_CATALOG_MASTERS: ORDER_CATALOG_MASTERS,
  AGE_RANGES_CATEGORY_CATALOG: AGE_RANGES_CATEGORY_CATALOG,
  SAVE_ORDER_CATALOG: SAVE_ORDER_CATALOG,
  READ_ORDER_CATALOG: READ_ORDER_CATALOG,
  UPDATE_ORDER_CATALOG_STATUS: UPDATE_ORDER_CATALOG_STATUS,
  EDIT_ORDER_CATALOG: EDIT_ORDER_CATALOG,
  DELETE_ATTRIBUTE_DELETE: DELETE_ATTRIBUTE_DELETE,
  ORDER_TYPE_DATA: ORDER_TYPE_DATA,
  ENTITY_NAME_DATA: ENTITY_NAME_DATA
};
var orderCatalogSlice$1 = orderCatalogSlice.reducer;

var queries$5 = {
  sourceLocationType: function sourceLocationType() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.activestatus==true && CodeableConceptMaster.Type == 'LOCATIONTYPE'",
      return_fields: "MERGE(CodeableConceptMaster,{coding: DOCUMENT(CodeableConceptMaster.coding)})"
    };
  },
  orderingFacility: function orderingFacility() {
    return {
      db_name: dbName,
      entity: "Organization",
      sort: "Organization.name",
      filter: "Organization.activestatus==true && Organization.active==true ",
      return_fields: "Organization"
    };
  },
  performingDetails: function performingDetails() {
    return {
      db_name: dbName,
      entity: "AMExtRefProvider",
      filter: "AMExtRefProvider.activestatus==true && AMExtRefProvider.status == true",
      return_fields: "AMExtRefProvider"
    };
  },
  sourceLocation: function sourceLocation(list) {
    return {
      db_name: dbName,
      entity: "LocationMaster",
      sort: "LocationMaster.longdesc",
      filter: "LocationMaster.activestatus==true && lower(LocationMaster.status) != 'in-active' && DOCUMENT(DOCUMENT(LocationMaster.locationType).coding)[*].display ANY =='".concat(list, "'"),
      return_fields: "LocationMaster"
    };
  },
  serviceApplicable: function serviceApplicable() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.activestatus==true && CodeableConceptMaster.Type == 'SERVICEAPPLICABILITY'",
      return_fields: "MERGE(CodeableConceptMaster,{coding: DOCUMENT(CodeableConceptMaster.coding)})"
    };
  }
};

var generateJson$6 = function generateJson(data, _key) {
  var _data$performingData, _data$orderingFacilit, _data$orderingFacilit2, _data$locationType$va, _data$locationType, _data$sourceLocation$, _data$sourceLocation, _data$ServiceApplicab, _data$ServiceApplicab2, _ruleSet, _data$status;

  var filter = {};

  if (_key) {
    filter = {
      filter: {
        _key: _key
      }
    };
  }

  var performing_details_data = data === null || data === void 0 ? void 0 : (_data$performingData = data.performingData) === null || _data$performingData === void 0 ? void 0 : _data$performingData.map(function (v) {
    var _v$performing_facilit, _v$location_type, _v$performing_locatio;

    return {
      performing_org: v === null || v === void 0 ? void 0 : (_v$performing_facilit = v.performing_facility) === null || _v$performing_facilit === void 0 ? void 0 : _v$performing_facilit.value,
      performing_location_role_type: v === null || v === void 0 ? void 0 : (_v$location_type = v.location_type) === null || _v$location_type === void 0 ? void 0 : _v$location_type.value,
      performing_location_code: v === null || v === void 0 ? void 0 : (_v$performing_locatio = v.performing_location) === null || _v$performing_locatio === void 0 ? void 0 : _v$performing_locatio.value
    };
  });
  var ruleSet = [];

  if (data !== null && data !== void 0 && data.ruleSet && Array.isArray(data === null || data === void 0 ? void 0 : data.ruleSet)) {
    ruleSet = data === null || data === void 0 ? void 0 : data.ruleSet.map(function (val) {
      return {
        group: val.group,
        rule: val.rule
      };
    });
  }

  return [_objectSpread2(_objectSpread2({
    "db_name": dbName
  }, filter), {}, {
    "entity": "CA_PerformingLocationforOrdLocn",
    "is_metadata": true,
    "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
    "doc": {
      "id": 0,
      "ordering_org": (_data$orderingFacilit = data === null || data === void 0 ? void 0 : (_data$orderingFacilit2 = data.orderingFacility) === null || _data$orderingFacilit2 === void 0 ? void 0 : _data$orderingFacilit2.value) !== null && _data$orderingFacilit !== void 0 ? _data$orderingFacilit : '',
      "ordering_source_type": (_data$locationType$va = data === null || data === void 0 ? void 0 : (_data$locationType = data.locationType) === null || _data$locationType === void 0 ? void 0 : _data$locationType.value) !== null && _data$locationType$va !== void 0 ? _data$locationType$va : '',
      "ordering_source_code": (_data$sourceLocation$ = data === null || data === void 0 ? void 0 : (_data$sourceLocation = data.sourceLocation) === null || _data$sourceLocation === void 0 ? void 0 : _data$sourceLocation.value) !== null && _data$sourceLocation$ !== void 0 ? _data$sourceLocation$ : '',
      "service_applicability": (_data$ServiceApplicab = data === null || data === void 0 ? void 0 : (_data$ServiceApplicab2 = data.ServiceApplicabiliy) === null || _data$ServiceApplicab2 === void 0 ? void 0 : _data$ServiceApplicab2._id) !== null && _data$ServiceApplicab !== void 0 ? _data$ServiceApplicab : '',
      "order_criteria": (_ruleSet = ruleSet) !== null && _ruleSet !== void 0 ? _ruleSet : [],
      "status": (_data$status = data.status) !== null && _data$status !== void 0 ? _data$status : false,
      "performing_details": performing_details_data.length > 0 ? _toConsumableArray(performing_details_data || []) : []
    }
  })];
};

var _extraReducers$c;
var SOURCELOCATIONTYPE = toolkit.createAsyncThunk("performLocationSlice/sourceLocationType", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          queriesjson = queries$5.sourceLocationType();
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push({
              value: val.coding[0]._id,
              label: val.coding[0].display
            });
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 12]]);
})));
var SOURCELOCATION = toolkit.createAsyncThunk("performLocationSlice/sourceLocation", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      list,
      queriesjson,
      data,
      arry,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          list = payload.list;
          queriesjson = queries$5.sourceLocation(list);
          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 7:
          data = _context2.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push({
              value: val._id,
              label: val.longdesc
            });
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 16:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 13]]);
})));
var ORDERINGFACILITY = toolkit.createAsyncThunk("performLocationSlice/orderingFacility", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var _ref6,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          queriesjson = queries$5.orderingFacility();
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context3.sent;
          arry = [];
          data.result.map(function (val) {
            arry.push({
              value: val._id,
              label: val.name
            });
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 15:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 12]]);
})));
var PERFORMINGDETAILS = toolkit.createAsyncThunk("performLocationSlice/performingDetails", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var _ref8,
      rejectWithValue,
      queriesjson,
      data,
      obj,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          queriesjson = queries$5.performingDetails();
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          obj = {
            locationRole: [],
            performingLocation: []
          };
          data.result.map(function (val) {
            obj.performingLocation.push({
              value: val._id,
              label: val.LongName
            });
            obj.locationRole.push({
              value: val._id,
              label: val.OrgType
            });
          });
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: obj
          }));

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 12]]);
})));
var UPSERT_PERFORMINGLOCATION = toolkit.createAsyncThunk("performLocationSlice/save_performingLocation", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      list,
      _key,
      queriesjson,
      data,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          list = payload.list, _key = payload._key;
          queriesjson = generateJson$6(list, _key); // return

          _context5.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 11]]);
})));
var READ_PERFORMINGLOCATION = toolkit.createAsyncThunk("performLocationSlice/performingLocationRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var _ref12,
      rejectWithValue,
      read,
      data,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue, _ref12.getState;
          _context6.prev = 2;
          read = {
            "db_name": dbName,
            "entity": "CA_PerformingLocationforOrdLocn",
            "sort": "CA_PerformingLocationforOrdLocn.createddate",
            "filter": "CA_PerformingLocationforOrdLocn.activestatus==true",
            "return_fields": "MERGE(CA_PerformingLocationforOrdLocn,{ordering_org:DOCUMENT(CA_PerformingLocationforOrdLocn.ordering_org),ordering_source_type:DOCUMENT(CA_PerformingLocationforOrdLocn.ordering_source_type),ordering_source_code:DOCUMENT(CA_PerformingLocationforOrdLocn.ordering_source_code),service_applicability:DOCUMENT(CA_PerformingLocationforOrdLocn.service_applicability),performing_details:(FOR perdet IN TO_ARRAY(CA_PerformingLocationforOrdLocn.performing_details) RETURN MERGE(perdet,{performing_org:DOCUMENT(perdet.performing_org),performing_location_role_type:DOCUMENT(perdet.performing_location_role_type),performing_location_code:DOCUMENT(perdet.performing_location_code)}))})"
          };
          _context6.next = 6;
          return fetchData({
            body: JSON.stringify(read)
          }, __readDocumentUrl__);

        case 6:
          data = _context6.sent;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context6.prev = 10;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 13:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 10]]);
})));
var STATUS_PERFORMINGLOCATION = toolkit.createAsyncThunk("performLocationSlice/changeStatus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      list,
      _key,
      queriesjson,
      data,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          list = payload.list, _key = payload._key;
          queriesjson = [{
            "db_name": dbName,
            "entity": "CA_PerformingLocationforOrdLocn",
            "is_metadata": true,
            "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
            "filter": {
              "_key": _key
            },
            "doc": {
              "status": list
            }
          }]; // return

          _context7.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context7.prev = 11;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 14:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 11]]);
})));
var performLocationSlice = toolkit.createSlice({
  name: "performLocationApiSlice",
  initialState: {
    source_location_type: _objectSpread2({}, defaultState.List),
    order_facility: _objectSpread2({}, defaultState.List),
    performing_details: _objectSpread2({}, defaultState.List),
    source_location: _objectSpread2({}, defaultState.List),
    save_performing_location: _objectSpread2({}, defaultState.Info),
    read_performing_location: _objectSpread2({}, defaultState.Info),
    read_performing_location_status: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$c = {}, _defineProperty(_extraReducers$c, SOURCELOCATIONTYPE.fulfilled, function (state, action) {
    state.source_location_type.loading = false, state.source_location_type.error = false, state.source_location_type = action.payload;
  }), _defineProperty(_extraReducers$c, SOURCELOCATIONTYPE.pending, function (state, action) {
    state.source_location_type.loading = true, state.source_location_type.error = false, state.source_location_type.loading = true;
  }), _defineProperty(_extraReducers$c, SOURCELOCATIONTYPE.rejected, function (state, action) {
    state.source_location_type.loading = false, state.source_location_type.error = true, state.source_location_type = action.payload;
  }), _defineProperty(_extraReducers$c, ORDERINGFACILITY.fulfilled, function (state, action) {
    state.order_facility.loading = false, state.order_facility.error = false, state.order_facility = action.payload;
  }), _defineProperty(_extraReducers$c, ORDERINGFACILITY.pending, function (state, action) {
    state.order_facility.loading = true, state.order_facility.error = false, state.order_facility.loading = true;
  }), _defineProperty(_extraReducers$c, ORDERINGFACILITY.rejected, function (state, action) {
    state.order_facility.loading = false, state.order_facility.error = true, state.order_facility = action.payload;
  }), _defineProperty(_extraReducers$c, PERFORMINGDETAILS.fulfilled, function (state, action) {
    state.performing_details.loading = false, state.performing_details.error = false, state.performing_details = action.payload;
  }), _defineProperty(_extraReducers$c, PERFORMINGDETAILS.pending, function (state, action) {
    state.performing_details.loading = true, state.performing_details.error = false, state.performing_details.loading = true;
  }), _defineProperty(_extraReducers$c, PERFORMINGDETAILS.rejected, function (state, action) {
    state.performing_details.loading = false, state.performing_details.error = true, state.performing_details = action.payload;
  }), _defineProperty(_extraReducers$c, SOURCELOCATION.fulfilled, function (state, action) {
    state.source_location.loading = false, state.source_location.error = false, state.source_location = action.payload;
  }), _defineProperty(_extraReducers$c, SOURCELOCATION.pending, function (state, action) {
    state.source_location.loading = true, state.source_location.error = false, state.source_location.loading = true;
  }), _defineProperty(_extraReducers$c, SOURCELOCATION.rejected, function (state, action) {
    state.source_location.loading = false, state.source_location.error = true, state.source_location = action.payload;
  }), _defineProperty(_extraReducers$c, UPSERT_PERFORMINGLOCATION.fulfilled, function (state, action) {
    state.save_performing_location.loading = false, state.save_performing_location.error = false, state.save_performing_location = action.payload;
  }), _defineProperty(_extraReducers$c, UPSERT_PERFORMINGLOCATION.pending, function (state, action) {
    state.save_performing_location.loading = true, state.save_performing_location.error = false, state.save_performing_location.loading = true;
  }), _defineProperty(_extraReducers$c, UPSERT_PERFORMINGLOCATION.rejected, function (state, action) {
    state.save_performing_location.loading = false, state.save_performing_location.error = true, state.save_performing_location = action.payload;
  }), _defineProperty(_extraReducers$c, READ_PERFORMINGLOCATION.fulfilled, function (state, action) {
    state.read_performing_location.loading = false, state.read_performing_location.error = false, state.read_performing_location = action.payload;
  }), _defineProperty(_extraReducers$c, READ_PERFORMINGLOCATION.pending, function (state, action) {
    state.read_performing_location.loading = true, state.read_performing_location.error = false, state.read_performing_location.loading = true;
  }), _defineProperty(_extraReducers$c, READ_PERFORMINGLOCATION.rejected, function (state, action) {
    state.read_performing_location.loading = false, state.read_performing_location.error = true, state.read_performing_location = action.payload;
  }), _defineProperty(_extraReducers$c, STATUS_PERFORMINGLOCATION.fulfilled, function (state, action) {
    state.read_performing_location_status.loading = false, state.read_performing_location_status.error = false, state.read_performing_location_status = action.payload;
  }), _defineProperty(_extraReducers$c, STATUS_PERFORMINGLOCATION.pending, function (state, action) {
    state.read_performing_location_status.loading = true, state.read_performing_location_status.error = false, state.read_performing_location_status.loading = true;
  }), _defineProperty(_extraReducers$c, STATUS_PERFORMINGLOCATION.rejected, function (state, action) {
    state.read_performing_location_status.loading = false, state.read_performing_location_status.error = true, state.read_performing_location_status = action.payload;
  }), _extraReducers$c)
});
var performLocationActions = {
  SOURCELOCATIONTYPE: SOURCELOCATIONTYPE,
  ORDERINGFACILITY: ORDERINGFACILITY,
  PERFORMINGDETAILS: PERFORMINGDETAILS,
  SOURCELOCATION: SOURCELOCATION,
  UPSERT_PERFORMINGLOCATION: UPSERT_PERFORMINGLOCATION,
  READ_PERFORMINGLOCATION: READ_PERFORMINGLOCATION,
  STATUS_PERFORMINGLOCATION: STATUS_PERFORMINGLOCATION
};
var performLocationSlice$1 = performLocationSlice.reducer;

// import { dbName } from "../../qdm_query_ids";
var queries$4 = {
  fullread: function fullread() {
    return {
      db_name: dbName,
      entity: "DrugUOM",
      filter: "DrugUOM.activestatus == true",
      sort: "DrugUOM.createddate",
      return_fields: "merge(DrugUOM,{UOMType:(for i in CodingMaster filter i._id == DrugUOM.UOMType return merge(i,{coding:document(i.coding)}))})"
    };
  },
  DRUG_UOM_TYPE: function DRUG_UOM_TYPE() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.activestatus==true && CodeableConceptMaster.Type == 'DRUGUOMTYPE' ",
      return_fields: "MERGE(CodeableConceptMaster,{coding: DOCUMENT(CodeableConceptMaster.coding)})"
    };
  },
  To_UOM_code: function To_UOM_code(id, type) {
    // return {
    //   db_name: dbName,
    //   entity: "CodeableConceptMaster",
    //   sort: "document(CodeableConceptMaster.coding[0]).display",
    //   filter: `CodeableConceptMaster.activestatus==true && CodeableConceptMaster.Type == 'DRUGUOMCODE' &&CodeableConceptMaster.text == '${type}'`,
    //   return_fields:
    //     "MERGE(CodeableConceptMaster,{coding: DOCUMENT(CodeableConceptMaster.coding)})",
    // };
    return {
      db_name: dbName,
      entity: "DrugUOM",
      filter: "DrugUOM.activestatus == true && DrugUOM.UOMType == '".concat(id, "' && LOWER(DrugUOM.UOM) !=LOWER('").concat(type, "') && DrugUOM.status==true"),
      return_fields: "{id:DrugUOM.id, _id:DrugUOM._id, UOM:DrugUOM.UOM, longdesc:DrugUOM.longdesc, shortdesc:DrugUOM.shortdesc}"
    };
  },
  To_UOM_Read_line: function To_UOM_Read_line(key) {
    // return {
    //   db_name: dbName,
    //   entity: "DrugUOM",
    //   filter: `DrugUOM.activestatus == true && DrugUOM._key == '${key}'`,
    //   return_fields:
    //     "merge(DrugUOM,{UOMType:document(DrugUOM.UOMType), ConversionMap:(for j in TO_ARRAY(DrugUOM.ConversionMap) return merge(j,{ConversionMap:document(j.ToUOMCode)}))})",
    //   // return_fields:
    //   //   "merge(DrugUOM,{ConversionMap:(for j in TO_ARRAY(DrugUOM.ConversionMap) return merge(j,{ConversionMap:document(j.ToUOMCode)}))})",
    //   // return_fields:
    //   //   "merge(DrugUOM,{UOMType:(for i in CodingMaster filter i._id == DrugUOM.UOMType return merge(i,{coding:document(i.coding)}))})",
    // };
    return {
      db_name: dbName,
      entity: "DrugUOM",
      filter: "DrugUOM.activestatus == true && DrugUOM._key == '".concat(key, "'"),
      return_fields: "merge(DrugUOM,{UOMType:document(DrugUOM.UOMType), ConversionMap:(for j in TO_ARRAY(DrugUOM.ConversionMap) return merge(j,{ConversionMap:document(j.ToUOMCode)})),periodType:document(DrugUOM.periodType),dosecalcuom:document(DrugUOM.dosecalcuom),doseCalcType:document(DrugUOM.doseCalcType)})"
    };
  },
  To_UOM_UPDATE_STATUS: function To_UOM_UPDATE_STATUS(status, key) {
    return [{
      db_name: dbName,
      entity: "DrugUOM",
      filter: {
        _key: "".concat(key)
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        status: status
      }
    }];
  },
  PERIOD_TYPE_DROPDOWN: function PERIOD_TYPE_DROPDOWN() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='PERIODTYPE' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  DOSE_CALC_TYPE_DROPDOWN: function DOSE_CALC_TYPE_DROPDOWN() {
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type=='DOSECALCTYPE' && CodingMaster.activestatus==true && CodingMaster.status==true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')",
      sort: "CodingMaster.display"
    };
  },
  DOSE_CALC_UOM_DROPDOWN: function DOSE_CALC_UOM_DROPDOWN() {
    return {
      db_name: dbName,
      entity: "DrugUOM",
      filter: "DrugUOM.status==true && DrugUOM.activestatus==true",
      return_fields: "keep(DrugUOM,'_id','UOM','UOMType','longdesc','shortdesc')"
    };
  }
};

var generateJson$5 = {
  insert_json: function insert_json(data, key) {
    var _data$coversionData, _data$periodType$valu, _data$periodType, _data$doseCalcType$va, _data$doseCalcType, _data$dosecalcuom$val, _data$dosecalcuom, _data$directionDtls, _data$directionDtls$, _data$directionDtls2, _data$directionDtls2$;

    var filter = {};

    if (key) {
      filter = {
        filter: {
          _key: "".concat(key)
        }
      };
    }

    var ConversionMaparr = (_data$coversionData = data.coversionData) === null || _data$coversionData === void 0 ? void 0 : _data$coversionData.map(function (v, i) {
      var _v$umoCode;

      return {
        ToUOMCode: v === null || v === void 0 ? void 0 : (_v$umoCode = v.umoCode) === null || _v$umoCode === void 0 ? void 0 : _v$umoCode.value,
        ConversionFactor: parseInt(v === null || v === void 0 ? void 0 : v.coversionFactor)
      };
    });
    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "DrugUOM",
      is_metadata: true
    }, filter), {}, {
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        UOMType: data.umoType.value,
        UOM: data.umoCode,
        shortdesc: data.shortdes,
        longdesc: data.longdes,
        periodType: (_data$periodType$valu = data === null || data === void 0 ? void 0 : (_data$periodType = data.periodType) === null || _data$periodType === void 0 ? void 0 : _data$periodType.value) !== null && _data$periodType$valu !== void 0 ? _data$periodType$valu : "",
        doseCalcType: (_data$doseCalcType$va = data === null || data === void 0 ? void 0 : (_data$doseCalcType = data.doseCalcType) === null || _data$doseCalcType === void 0 ? void 0 : _data$doseCalcType.value) !== null && _data$doseCalcType$va !== void 0 ? _data$doseCalcType$va : "",
        dosecalcuom: (_data$dosecalcuom$val = data === null || data === void 0 ? void 0 : (_data$dosecalcuom = data.dosecalcuom) === null || _data$dosecalcuom === void 0 ? void 0 : _data$dosecalcuom.value) !== null && _data$dosecalcuom$val !== void 0 ? _data$dosecalcuom$val : "",
        IsDosageStrengthUOM: data.uomCheckboxJson[0].checked,
        IsDosageQuantityUOM: data.uomCheckboxJson[1].checked,
        IsDispenseUOM: data.uomCheckboxJson[2].checked,
        IsPurchaseUOM: data.uomCheckboxJson[3].checked,
        IsStockUOM: data.uomCheckboxJson[4].checked,
        IsStoreIssueUOM: data.uomCheckboxJson[5].checked,
        status: true,
        ConversionMap: ConversionMaparr,
        directiontaglocal: data === null || data === void 0 ? void 0 : (_data$directionDtls = data.directionDtls) === null || _data$directionDtls === void 0 ? void 0 : (_data$directionDtls$ = _data$directionDtls[0]) === null || _data$directionDtls$ === void 0 ? void 0 : _data$directionDtls$.directiontaglocal,
        direction: data === null || data === void 0 ? void 0 : (_data$directionDtls2 = data.directionDtls) === null || _data$directionDtls2 === void 0 ? void 0 : (_data$directionDtls2$ = _data$directionDtls2[0]) === null || _data$directionDtls2$ === void 0 ? void 0 : _data$directionDtls2$.directiontag
      }
    })];
  }
};
var generateReadJson$1 = {
  read_json: function read_json(data) {
    var _data$result$0$Conver, _data$result$, _data$result$2, _data$result$3, _data$result$4, _data$result$5, _data$result$6, _data$result$7, _data$result$8, _data$result$9, _data$result$10, _data$result$10$UOMTy, _data$result$11, _data$result$11$UOMTy, _data$result$12, _data$result$12$perio, _data$result$13, _data$result$13$perio, _data$result$14, _data$result$14$doseC, _data$result$15, _data$result$15$doseC, _data$result$16, _data$result$16$dosec, _data$result$17, _data$result$17$dosec, _data$result$18, _data$result$19;

    var ConversionMaparr = (_data$result$0$Conver = data.result[0].ConversionMap) === null || _data$result$0$Conver === void 0 ? void 0 : _data$result$0$Conver.map(function (v, i) {
      var _v$ConversionMap, _v$ConversionMap2;

      return {
        coversionFactor: v === null || v === void 0 ? void 0 : v.ConversionFactor,
        umoCode: {
          // label: v?.ConversionMap?.display,
          label: v === null || v === void 0 ? void 0 : (_v$ConversionMap = v.ConversionMap) === null || _v$ConversionMap === void 0 ? void 0 : _v$ConversionMap.UOM,
          value: v === null || v === void 0 ? void 0 : (_v$ConversionMap2 = v.ConversionMap) === null || _v$ConversionMap2 === void 0 ? void 0 : _v$ConversionMap2._id
        }
      };
    });
    return {
      _key: data === null || data === void 0 ? void 0 : data._key,
      uomCheckboxJson_: [{
        label: "Dosage Strength UOM",
        checked: data === null || data === void 0 ? void 0 : (_data$result$ = data.result[0]) === null || _data$result$ === void 0 ? void 0 : _data$result$.IsDosageStrengthUOM
      }, {
        label: "Dosage Quantity UOM",
        checked: data === null || data === void 0 ? void 0 : (_data$result$2 = data.result[0]) === null || _data$result$2 === void 0 ? void 0 : _data$result$2.IsDosageQuantityUOM
      }, {
        label: "Dispense UOM",
        checked: data === null || data === void 0 ? void 0 : (_data$result$3 = data.result[0]) === null || _data$result$3 === void 0 ? void 0 : _data$result$3.IsDispenseUOM
      }, {
        label: "Purchase UOM",
        checked: data === null || data === void 0 ? void 0 : (_data$result$4 = data.result[0]) === null || _data$result$4 === void 0 ? void 0 : _data$result$4.IsPurchaseUOM
      }, {
        label: "Stock UOM",
        checked: data === null || data === void 0 ? void 0 : (_data$result$5 = data.result[0]) === null || _data$result$5 === void 0 ? void 0 : _data$result$5.IsStockUOM
      }, {
        label: "Store Issue UOM",
        checked: data === null || data === void 0 ? void 0 : (_data$result$6 = data.result[0]) === null || _data$result$6 === void 0 ? void 0 : _data$result$6.IsStoreIssueUOM
      }],
      longdes_: data === null || data === void 0 ? void 0 : (_data$result$7 = data.result[0]) === null || _data$result$7 === void 0 ? void 0 : _data$result$7.longdesc,
      shortdes_: data === null || data === void 0 ? void 0 : (_data$result$8 = data.result[0]) === null || _data$result$8 === void 0 ? void 0 : _data$result$8.shortdesc,
      umoCode_: data === null || data === void 0 ? void 0 : (_data$result$9 = data.result[0]) === null || _data$result$9 === void 0 ? void 0 : _data$result$9.UOM,
      ConversionMaparr_: ConversionMaparr,
      UOMType_: {
        label: data === null || data === void 0 ? void 0 : (_data$result$10 = data.result[0]) === null || _data$result$10 === void 0 ? void 0 : (_data$result$10$UOMTy = _data$result$10.UOMType) === null || _data$result$10$UOMTy === void 0 ? void 0 : _data$result$10$UOMTy.display,
        value: data === null || data === void 0 ? void 0 : (_data$result$11 = data.result[0]) === null || _data$result$11 === void 0 ? void 0 : (_data$result$11$UOMTy = _data$result$11.UOMType) === null || _data$result$11$UOMTy === void 0 ? void 0 : _data$result$11$UOMTy._id
      },
      periodType: {
        label: data === null || data === void 0 ? void 0 : (_data$result$12 = data.result[0]) === null || _data$result$12 === void 0 ? void 0 : (_data$result$12$perio = _data$result$12.periodType) === null || _data$result$12$perio === void 0 ? void 0 : _data$result$12$perio.display,
        value: data === null || data === void 0 ? void 0 : (_data$result$13 = data.result[0]) === null || _data$result$13 === void 0 ? void 0 : (_data$result$13$perio = _data$result$13.periodType) === null || _data$result$13$perio === void 0 ? void 0 : _data$result$13$perio._id
      },
      doseCalcType: {
        label: data === null || data === void 0 ? void 0 : (_data$result$14 = data.result[0]) === null || _data$result$14 === void 0 ? void 0 : (_data$result$14$doseC = _data$result$14.doseCalcType) === null || _data$result$14$doseC === void 0 ? void 0 : _data$result$14$doseC.display,
        value: data === null || data === void 0 ? void 0 : (_data$result$15 = data.result[0]) === null || _data$result$15 === void 0 ? void 0 : (_data$result$15$doseC = _data$result$15.doseCalcType) === null || _data$result$15$doseC === void 0 ? void 0 : _data$result$15$doseC._id
      },
      dosecalcuom: {
        label: data === null || data === void 0 ? void 0 : (_data$result$16 = data.result[0]) === null || _data$result$16 === void 0 ? void 0 : (_data$result$16$dosec = _data$result$16.dosecalcuom) === null || _data$result$16$dosec === void 0 ? void 0 : _data$result$16$dosec.shortdesc,
        value: data === null || data === void 0 ? void 0 : (_data$result$17 = data.result[0]) === null || _data$result$17 === void 0 ? void 0 : (_data$result$17$dosec = _data$result$17.dosecalcuom) === null || _data$result$17$dosec === void 0 ? void 0 : _data$result$17$dosec._id
      },
      directionDtls: [{
        directiontag: data === null || data === void 0 ? void 0 : (_data$result$18 = data.result[0]) === null || _data$result$18 === void 0 ? void 0 : _data$result$18.direction,
        directiontaglocal: data === null || data === void 0 ? void 0 : (_data$result$19 = data.result[0]) === null || _data$result$19 === void 0 ? void 0 : _data$result$19.directiontaglocal
      }]
    };
  }
};

var _extraReducers$b;
var DRUG_UOM_READ = toolkit.createAsyncThunk("drugRoutesSlice/drug_uom_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          queriesjson = queries$4.fullread();
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          arry = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._key && val !== null && val !== void 0 && val.longdesc) {
              var _val$UOMType$;

              arry.push({
                type: val === null || val === void 0 ? void 0 : (_val$UOMType$ = val.UOMType[0]) === null || _val$UOMType$ === void 0 ? void 0 : _val$UOMType$.display,
                longDesc: val === null || val === void 0 ? void 0 : val.longdesc,
                shortDesc: val === null || val === void 0 ? void 0 : val.shortdesc,
                status: val === null || val === void 0 ? void 0 : val.status,
                key: val === null || val === void 0 ? void 0 : val._key,
                UOMCode: val === null || val === void 0 ? void 0 : val.UOM
              });
            }
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context.t0.message
          })));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 12]]);
})));
var DRUG_UOM_TYPE_DROP_DOWN = toolkit.createAsyncThunk("drugRoutesSlice/drug_uom_type_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var _ref4,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          queriesjson = queries$4.DRUG_UOM_TYPE();
          _context2.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context2.sent;
          arry = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._key && val !== null && val !== void 0 && val.activestatus) {
              var _val$coding$;

              arry.push({
                label: val === null || val === void 0 ? void 0 : (_val$coding$ = val.coding[0]) === null || _val$coding$ === void 0 ? void 0 : _val$coding$.display,
                value: val === null || val === void 0 ? void 0 : val.coding[0]._id
              });
            }
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context2.t0.message
          })));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 12]]);
})));
var TO_UDM_CODE_DROPDOWN = toolkit.createAsyncThunk("drugRoutesSlice/drug_uom_code_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      type,
      id,
      queriesjson,
      data,
      arry,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          type = payload.type, id = payload.id;
          queriesjson = queries$4.To_UOM_code(id, type);
          _context3.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 7:
          data = _context3.sent;
          arry = [];
          data.result.map(function (val) {
            // if (val?._key && val?.activestatus) {
            if (val !== null && val !== void 0 && val._id && val !== null && val !== void 0 && val.UOM) {
              arry.push({
                // label: val?.coding[0]?.display,
                // value: val?.coding[0]?._id,
                label: val === null || val === void 0 ? void 0 : val.UOM,
                value: val === null || val === void 0 ? void 0 : val._id
              });
            }
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context3.t0.message
          })));

        case 16:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 13]]);
})));
var UOM_CODE_INSERT = toolkit.createAsyncThunk("drugRoutesSlice/drug_uom_code_insert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      data,
      key,
      queriesjson,
      Insertdata,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          data = payload.data, key = payload.key;
          queriesjson = generateJson$5.insert_json(data, key);
          _context4.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          Insertdata = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: Insertdata
          }));

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 12]]);
})));
var To_UOM_UPDATE_STATUS_FUN = toolkit.createAsyncThunk("drugRoutesSlice/drug_uom_code_status", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      status,
      key,
      queriesjson,
      arry,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          status = payload.status, key = payload.key;
          queriesjson = queries$4.To_UOM_UPDATE_STATUS(status, key);
          _context5.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          _context5.sent;
          arry = [];
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context5.t0.message
          })));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 12]]);
})));
var DRUG_UOM_LINE_READ = toolkit.createAsyncThunk("drugRoutesSlice/drug_uom_read_line", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref12,
      rejectWithValue,
      key,
      queriesjson,
      getdata,
      getreadJson,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          key = payload.key;
          queriesjson = queries$4.To_UOM_Read_line(key);
          _context6.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 7:
          getdata = _context6.sent;
          getreadJson = generateReadJson$1.read_json(getdata);
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: getreadJson
          }));

        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context6.t0.message
          })));

        case 16:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 13]]);
})));
var DRUG_UOM_PERIOD_TYPE_DROPDOWN = toolkit.createAsyncThunk("drugRoutesSlice/drug_uom_period_type_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var _ref14,
      rejectWithValue,
      queriesjson,
      data,
      optionsList,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          queriesjson = queries$4.PERIOD_TYPE_DROPDOWN();
          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context7.sent;
          optionsList = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._id && val !== null && val !== void 0 && val.display) {
              optionsList.push({
                label: val === null || val === void 0 ? void 0 : val.display,
                value: val === null || val === void 0 ? void 0 : val._id
              });
            }
          });
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: optionsList
          }));

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context7.t0.message
          })));

        case 15:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 12]]);
})));
var DRUG_UOM_DOSE_CALC_TYPE_DROPDOWN = toolkit.createAsyncThunk("drugRoutesSlice/drug_uom_dose_calc_type_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var _ref16,
      rejectWithValue,
      queriesjson,
      data,
      optionsList,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _ref16 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref16.rejectWithValue;
          _context8.prev = 2;
          queriesjson = queries$4.DOSE_CALC_TYPE_DROPDOWN();
          _context8.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context8.sent;
          optionsList = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._id && val !== null && val !== void 0 && val.display) {
              optionsList.push({
                label: val === null || val === void 0 ? void 0 : val.display,
                value: val === null || val === void 0 ? void 0 : val._id
              });
            }
          });
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: optionsList
          }));

        case 12:
          _context8.prev = 12;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context8.t0.message
          })));

        case 15:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 12]]);
})));
var DRUG_UOM_DOSE_CALC_UOM_DROPDOWN = toolkit.createAsyncThunk("drugRoutesSlice/drug_uom_dose_calc_uom_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var _ref18,
      rejectWithValue,
      queriesjson,
      data,
      optionsList,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _ref18 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref18.rejectWithValue;
          _context9.prev = 2;
          queriesjson = queries$4.DOSE_CALC_UOM_DROPDOWN();
          _context9.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context9.sent;
          optionsList = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._id && val !== null && val !== void 0 && val.shortdesc) {
              optionsList.push({
                label: val === null || val === void 0 ? void 0 : val.shortdesc,
                value: val === null || val === void 0 ? void 0 : val._id
              });
            }
          });
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: optionsList
          }));

        case 12:
          _context9.prev = 12;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context9.t0.message
          })));

        case 15:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 12]]);
})));
var drugMasterUOMSlice = toolkit.createSlice({
  name: "drug_uom_list",
  initialState: {
    drug_routes_direction_list: _objectSpread2({}, defaultState.List),
    drug_uom_type_master: _objectSpread2({}, defaultState.List),
    drug_uom_code_master: _objectSpread2({}, defaultState.List),
    drug_uom_code_insert: _objectSpread2({}, defaultState.List),
    drug_uom_read_line: _objectSpread2({}, defaultState.List),
    drug_uom_code_status: _objectSpread2({}, defaultState.List),
    drug_uom_period_type_master: _objectSpread2({}, defaultState.List),
    drug_uom_dose_calc_type_master: _objectSpread2({}, defaultState.List),
    drug_uom_dose_calc_uom_master: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$b = {}, _defineProperty(_extraReducers$b, DRUG_UOM_READ.fulfilled, function (state, action) {
    state.drug_routes_direction_list.loading = false, state.drug_routes_direction_list.error = false, state.drug_routes_direction_list = action.payload;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_READ.pending, function (state, action) {
    state.drug_routes_direction_list.loading = true, state.drug_routes_direction_list.error = false, state.drug_routes_direction_list.loading = true;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_READ.rejected, function (state, action) {
    state.drug_routes_direction_list.loading = false, state.drug_routes_direction_list.error = true, state.drug_routes_direction_list = action.payload;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_TYPE_DROP_DOWN.fulfilled, function (state, action) {
    state.drug_uom_type_master.loading = false, state.drug_uom_type_master.error = false, state.drug_uom_type_master = action.payload;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_TYPE_DROP_DOWN.pending, function (state, action) {
    state.drug_uom_type_master.loading = true, state.drug_uom_type_master.error = false, state.drug_uom_type_master.loading = true;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_TYPE_DROP_DOWN.rejected, function (state, action) {
    state.drug_uom_type_master.loading = false, state.drug_uom_type_master.error = true, state.drug_uom_type_master = action.payload;
  }), _defineProperty(_extraReducers$b, TO_UDM_CODE_DROPDOWN.fulfilled, function (state, action) {
    state.drug_uom_code_master.loading = false, state.drug_uom_code_master.error = false, state.drug_uom_code_master = action.payload;
  }), _defineProperty(_extraReducers$b, TO_UDM_CODE_DROPDOWN.pending, function (state, action) {
    state.drug_uom_code_master.loading = true, state.drug_uom_code_master.error = false, state.drug_uom_code_master.loading = true;
  }), _defineProperty(_extraReducers$b, TO_UDM_CODE_DROPDOWN.rejected, function (state, action) {
    state.drug_uom_code_master.loading = false, state.drug_uom_code_master.error = true, state.drug_uom_code_master = action.payload;
  }), _defineProperty(_extraReducers$b, UOM_CODE_INSERT.fulfilled, function (state, action) {
    state.drug_uom_code_insert.loading = false, state.drug_uom_code_insert.error = false, state.drug_uom_code_insert = action.payload;
  }), _defineProperty(_extraReducers$b, UOM_CODE_INSERT.pending, function (state, action) {
    state.drug_uom_code_insert.loading = true, state.drug_uom_code_insert.error = false, state.drug_uom_code_insert.loading = true;
  }), _defineProperty(_extraReducers$b, UOM_CODE_INSERT.rejected, function (state, action) {
    state.drug_uom_code_insert.loading = false, state.drug_uom_code_insert.error = true, state.drug_uom_code_insert = action.payload;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_LINE_READ.fulfilled, function (state, action) {
    state.drug_uom_read_line.loading = false, state.drug_uom_read_line.error = false, state.drug_uom_read_line = action.payload;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_LINE_READ.pending, function (state, action) {
    state.drug_uom_read_line.loading = true, state.drug_uom_read_line.error = false, state.drug_uom_read_line.loading = true;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_LINE_READ.rejected, function (state, action) {
    state.drug_uom_read_line.loading = false, state.drug_uom_read_line.error = true, state.drug_uom_read_line = action.payload;
  }), _defineProperty(_extraReducers$b, To_UOM_UPDATE_STATUS_FUN.fulfilled, function (state, action) {
    state.drug_uom_code_status.loading = false, state.drug_uom_code_status.error = false, state.drug_uom_code_status = action.payload;
  }), _defineProperty(_extraReducers$b, To_UOM_UPDATE_STATUS_FUN.pending, function (state, action) {
    state.drug_uom_code_status.loading = true, state.drug_uom_code_status.error = false, state.drug_uom_code_status.loading = true;
  }), _defineProperty(_extraReducers$b, To_UOM_UPDATE_STATUS_FUN.rejected, function (state, action) {
    state.drug_uom_code_status.loading = false, state.drug_uom_code_status.error = true, state.drug_uom_code_status = action.payload;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_PERIOD_TYPE_DROPDOWN.fulfilled, function (state, action) {
    state.drug_uom_period_type_master.loading = false, state.drug_uom_period_type_master.error = false, state.drug_uom_period_type_master = action.payload;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_PERIOD_TYPE_DROPDOWN.pending, function (state, action) {
    state.drug_uom_period_type_master.loading = true, state.drug_uom_period_type_master.error = false, state.drug_uom_period_type_master.loading = true;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_PERIOD_TYPE_DROPDOWN.rejected, function (state, action) {
    state.drug_uom_period_type_master.loading = false, state.drug_uom_period_type_master.error = true, state.drug_uom_period_type_master = action.payload;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_DOSE_CALC_TYPE_DROPDOWN.fulfilled, function (state, action) {
    state.drug_uom_dose_calc_type_master.loading = false, state.drug_uom_dose_calc_type_master.error = false, state.drug_uom_dose_calc_type_master = action.payload;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_DOSE_CALC_TYPE_DROPDOWN.pending, function (state, action) {
    state.drug_uom_dose_calc_type_master.loading = true, state.drug_uom_dose_calc_type_master.error = false, state.drug_uom_dose_calc_type_master.loading = true;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_DOSE_CALC_TYPE_DROPDOWN.rejected, function (state, action) {
    state.drug_uom_dose_calc_type_master.loading = false, state.drug_uom_dose_calc_type_master.error = true, state.drug_uom_dose_calc_type_master = action.payload;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_DOSE_CALC_UOM_DROPDOWN.fulfilled, function (state, action) {
    state.drug_uom_dose_calc_uom_master.loading = false, state.drug_uom_dose_calc_uom_master.error = false, state.drug_uom_dose_calc_uom_master = action.payload;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_DOSE_CALC_UOM_DROPDOWN.pending, function (state, action) {
    state.drug_uom_dose_calc_uom_master.loading = true, state.drug_uom_dose_calc_uom_master.error = false, state.drug_uom_dose_calc_uom_master.loading = true;
  }), _defineProperty(_extraReducers$b, DRUG_UOM_DOSE_CALC_UOM_DROPDOWN.rejected, function (state, action) {
    state.drug_uom_dose_calc_uom_master.loading = false, state.drug_uom_dose_calc_uom_master.error = true, state.drug_uom_dose_calc_uom_master = action.payload;
  }), _extraReducers$b)
});
var drugMasterUomActions = {
  DRUG_UOM_READ: DRUG_UOM_READ,
  DRUG_UOM_TYPE_DROP_DOWN: DRUG_UOM_TYPE_DROP_DOWN,
  TO_UDM_CODE_DROPDOWN: TO_UDM_CODE_DROPDOWN,
  UOM_CODE_INSERT: UOM_CODE_INSERT,
  DRUG_UOM_LINE_READ: DRUG_UOM_LINE_READ,
  To_UOM_UPDATE_STATUS_FUN: To_UOM_UPDATE_STATUS_FUN,
  DRUG_UOM_PERIOD_TYPE_DROPDOWN: DRUG_UOM_PERIOD_TYPE_DROPDOWN,
  DRUG_UOM_DOSE_CALC_TYPE_DROPDOWN: DRUG_UOM_DOSE_CALC_TYPE_DROPDOWN,
  DRUG_UOM_DOSE_CALC_UOM_DROPDOWN: DRUG_UOM_DOSE_CALC_UOM_DROPDOWN
};
var drugMasterUOMSlice$1 = drugMasterUOMSlice.reducer;

var generateJson$4 = function generateJson(data, _key) {
  var _data$approvalData, _data$orderingFacilit, _data$orderingFacilit2, _data$ServiceApplicab, _data$ServiceApplicab2, _data$orderCriteria, _data$patientCriteria, _data$practitionerCri, _data$ruleType$_id, _data$ruleType, _data$PrivilegeType$_, _data$PrivilegeType, _data$status, _data$alertText;

  var filter = {};

  if (_key) {
    filter = {
      filter: {
        _key: _key
      }
    };
  }

  var appr_leveles_data = data === null || data === void 0 ? void 0 : (_data$approvalData = data.approvalData) === null || _data$approvalData === void 0 ? void 0 : _data$approvalData.map(function (v) {
    var _v$approvalLevel;

    return {
      appr_level: v === null || v === void 0 ? void 0 : (_v$approvalLevel = v.approvalLevel) === null || _v$approvalLevel === void 0 ? void 0 : _v$approvalLevel._id,
      appr_level_description: v === null || v === void 0 ? void 0 : v.approvalDescription
    };
  });
  return [_objectSpread2(_objectSpread2({
    "db_name": dbName
  }, filter), {}, {
    "entity": "CA_OrderCatalogPrivilegeLevel",
    "is_metadata": true,
    "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
    "doc": {
      "id": 0,
      "orgn_code": (_data$orderingFacilit = data === null || data === void 0 ? void 0 : (_data$orderingFacilit2 = data.orderingFacility) === null || _data$orderingFacilit2 === void 0 ? void 0 : _data$orderingFacilit2._id) !== null && _data$orderingFacilit !== void 0 ? _data$orderingFacilit : "",
      "service_applicablity": (_data$ServiceApplicab = data === null || data === void 0 ? void 0 : (_data$ServiceApplicab2 = data.ServiceApplicabiliy) === null || _data$ServiceApplicab2 === void 0 ? void 0 : _data$ServiceApplicab2._id) !== null && _data$ServiceApplicab !== void 0 ? _data$ServiceApplicab : '',
      "order_catalog_criteria": (_data$orderCriteria = data === null || data === void 0 ? void 0 : data.orderCriteria) !== null && _data$orderCriteria !== void 0 ? _data$orderCriteria : [],
      "patient_criteria": (_data$patientCriteria = data === null || data === void 0 ? void 0 : data.patientCriteria) !== null && _data$patientCriteria !== void 0 ? _data$patientCriteria : [],
      "pract_criteria": (_data$practitionerCri = data === null || data === void 0 ? void 0 : data.practitionerCriteria) !== null && _data$practitionerCri !== void 0 ? _data$practitionerCri : [],
      "appr_leveles": (appr_leveles_data === null || appr_leveles_data === void 0 ? void 0 : appr_leveles_data.length) > 0 ? _toConsumableArray(appr_leveles_data || []) : [],
      "rule_type": (_data$ruleType$_id = data === null || data === void 0 ? void 0 : (_data$ruleType = data.ruleType) === null || _data$ruleType === void 0 ? void 0 : _data$ruleType._id) !== null && _data$ruleType$_id !== void 0 ? _data$ruleType$_id : '',
      "privilege_type": (_data$PrivilegeType$_ = data === null || data === void 0 ? void 0 : (_data$PrivilegeType = data.PrivilegeType) === null || _data$PrivilegeType === void 0 ? void 0 : _data$PrivilegeType._id) !== null && _data$PrivilegeType$_ !== void 0 ? _data$PrivilegeType$_ : '',
      "status": (_data$status = data.status) !== null && _data$status !== void 0 ? _data$status : false,
      "alert_test_message": (_data$alertText = data.alertText) !== null && _data$alertText !== void 0 ? _data$alertText : ""
    }
  })];
};

var _extraReducers$a;
var UPSERT_ALERT = toolkit.createAsyncThunk("alertRestictionsMasterSlice/save_alert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      list,
      _key,
      queriesjson,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          list = payload.list, _key = payload._key;
          queriesjson = generateJson$4(list, _key); // return

          _context.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var UPSERT_ALERT_STATUS = toolkit.createAsyncThunk("alertRestictionsMasterSlice/save_alert_status", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      list,
      _key,
      queriesjson,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          list = payload.list, _key = payload._key;
          queriesjson = [{
            "db_name": dbName,
            "entity": "CA_OrderCatalogPrivilegeLevel",
            "is_metadata": true,
            "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
            "filter": {
              "_key": _key
            },
            "doc": {
              "status": list
            }
          }]; // return

          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var GET_ALL_MASTER = toolkit.createAsyncThunk("alertRestictionsMasterSlice/get_all_masters_alert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var _ref6,
      rejectWithValue,
      _facility_data$result,
      _app_level_data$resul,
      _service_applicable_d,
      _rule_type_data$resul,
      _privillage_type_data,
      get_facility,
      get_app_level,
      service_applicable,
      rule_type,
      privillage_type,
      facility_data,
      app_level_data,
      service_applicable_data,
      rule_type_data,
      privillage_type_data,
      Arr_facility,
      Arr_app_level,
      service_applicable_data_arr,
      rule_type_data_arr,
      privillage_type_data_arr,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          get_facility = {
            "db_name": dbName,
            "entity": "Organization",
            "sort": "Organization.name",
            "filter": "Organization.activestatus==true && Organization.active==true ",
            "return_fields": "Organization"
          };
          get_app_level = {
            "db_name": dbName,
            "entity": "CodeableConceptMaster",
            "sort": "document(CodeableConceptMaster.coding[0]).display",
            "filter": "CodeableConceptMaster.activestatus==true && CodeableConceptMaster.Type == 'APPROVALLEVEL'",
            "return_fields": "MERGE(CodeableConceptMaster,{coding: DOCUMENT(CodeableConceptMaster.coding)})"
          };
          service_applicable = {
            "db_name": dbName,
            "entity": "CodeableConceptMaster",
            "sort": "document(CodeableConceptMaster.coding[0]).display",
            "filter": "CodeableConceptMaster.activestatus==true && CodeableConceptMaster.Type == 'SERVICEAPPLICABILITY'",
            "return_fields": "MERGE(CodeableConceptMaster,{coding: DOCUMENT(CodeableConceptMaster.coding)})"
          };
          rule_type = {
            "db_name": dbName,
            "entity": "CodeableConceptMaster",
            "sort": "document(CodeableConceptMaster.coding[0]).display",
            "filter": "CodeableConceptMaster.activestatus==true && CodeableConceptMaster.Type == 'RULETYPE'",
            "return_fields": "MERGE(CodeableConceptMaster,{coding: DOCUMENT(CodeableConceptMaster.coding)})"
          };
          privillage_type = {
            "db_name": dbName,
            "entity": "CodeableConceptMaster",
            "sort": "CodeableConceptMaster.text",
            "filter": "CodeableConceptMaster.activestatus==true && CodeableConceptMaster.Type=='PRIVILEGETYPE'",
            "return_fields": "MERGE(CodeableConceptMaster,{coding: DOCUMENT(CodeableConceptMaster.coding)})"
          };
          _context3.next = 10;
          return fetchData({
            body: JSON.stringify(get_facility)
          }, __readDocumentUrl__);

        case 10:
          facility_data = _context3.sent;
          _context3.next = 13;
          return fetchData({
            body: JSON.stringify(get_app_level)
          }, __readDocumentUrl__);

        case 13:
          app_level_data = _context3.sent;
          _context3.next = 16;
          return fetchData({
            body: JSON.stringify(service_applicable)
          }, __readDocumentUrl__);

        case 16:
          service_applicable_data = _context3.sent;
          _context3.next = 19;
          return fetchData({
            body: JSON.stringify(rule_type)
          }, __readDocumentUrl__);

        case 19:
          rule_type_data = _context3.sent;
          _context3.next = 22;
          return fetchData({
            body: JSON.stringify(privillage_type)
          }, __readDocumentUrl__);

        case 22:
          privillage_type_data = _context3.sent;
          Arr_facility = [];
          (_facility_data$result = facility_data.result) === null || _facility_data$result === void 0 ? void 0 : _facility_data$result.map(function (v) {
            Arr_facility.push({
              value: v.name ? v.name : '',
              label: v.name ? v.name : '',
              _id: v._id ? v._id : ''
            });
          });
          Arr_app_level = [];
          (_app_level_data$resul = app_level_data.result) === null || _app_level_data$resul === void 0 ? void 0 : _app_level_data$resul.map(function (v) {
            Arr_app_level.push({
              value: v.coding[0].display ? v.coding[0].display : '',
              label: v.coding[0].display ? v.coding[0].display : '',
              _id: v.coding[0]._id ? v.coding[0]._id : ''
            });
          });
          service_applicable_data_arr = [];
          service_applicable_data === null || service_applicable_data === void 0 ? void 0 : (_service_applicable_d = service_applicable_data.result) === null || _service_applicable_d === void 0 ? void 0 : _service_applicable_d.map(function (v) {
            service_applicable_data_arr.push({
              value: v.coding[0].display ? v.coding[0].display : '',
              label: v.coding[0].display ? v.coding[0].display : '',
              _id: v.coding[0]._id ? v.coding[0]._id : ''
            });
          });
          rule_type_data_arr = [];
          rule_type_data === null || rule_type_data === void 0 ? void 0 : (_rule_type_data$resul = rule_type_data.result) === null || _rule_type_data$resul === void 0 ? void 0 : _rule_type_data$resul.map(function (v) {
            rule_type_data_arr.push({
              value: v.coding[0].display ? v.coding[0].display : '',
              label: v.coding[0].display ? v.coding[0].display : '',
              _id: v.coding[0]._id ? v.coding[0]._id : ''
            });
          });
          privillage_type_data_arr = [];
          privillage_type_data === null || privillage_type_data === void 0 ? void 0 : (_privillage_type_data = privillage_type_data.result) === null || _privillage_type_data === void 0 ? void 0 : _privillage_type_data.map(function (v) {
            var _v$text;

            privillage_type_data_arr.push({
              value: v.coding[0].display ? v.coding[0].display : '',
              label: v.coding[0].display ? v.coding[0].display : '',
              text: (_v$text = v === null || v === void 0 ? void 0 : v.text) !== null && _v$text !== void 0 ? _v$text : '',
              _id: v.coding[0]._id ? v.coding[0]._id : ''
            });
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: {
              facility: Arr_facility,
              app_level: Arr_app_level,
              service_applicables: service_applicable_data_arr,
              rule_type_datas: rule_type_data_arr,
              privillage_type_datas: privillage_type_data_arr
            }
          }));

        case 36:
          _context3.prev = 36;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 39:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 36]]);
})));
var READ_ALERT = toolkit.createAsyncThunk("orderCatalogApiSlice/orderCatalogRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var _ref8,
      rejectWithValue,
      read,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue, _ref8.getState;
          _context4.prev = 2;
          read = {
            "db_name": dbName,
            "entity": "CA_OrderCatalogPrivilegeLevel",
            "sort": "CA_OrderCatalogPrivilegeLevel.createddate",
            "filter": "CA_OrderCatalogPrivilegeLevel.activestatus==true",
            "return_fields": "MERGE(CA_OrderCatalogPrivilegeLevel,{orgn_code:document(CA_OrderCatalogPrivilegeLevel.orgn_code),service_applicablity:document(CA_OrderCatalogPrivilegeLevel.service_applicablity),rule_type:document(CA_OrderCatalogPrivilegeLevel.rule_type),privilege_type:document(CA_OrderCatalogPrivilegeLevel.privilege_type),appr_leveles:(for i in TO_ARRAY(CA_OrderCatalogPrivilegeLevel.appr_leveles) return merge(i,{appr_level:document(i.appr_level)}))})"
          };
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(read)
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 10]]);
})));
var alertRestictionsMasterSlice = toolkit.createSlice({
  name: "alertRestictionsMasterSlice",
  initialState: {
    get_all_masters: _objectSpread2({}, defaultState.List),
    save_alert: _objectSpread2({}, defaultState.Info),
    read_alert: _objectSpread2({}, defaultState.Info),
    read_alert_status: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$a = {}, _defineProperty(_extraReducers$a, GET_ALL_MASTER.fulfilled, function (state, action) {
    state.get_all_masters.loading = false, state.get_all_masters.error = false, state.get_all_masters = action.payload;
  }), _defineProperty(_extraReducers$a, GET_ALL_MASTER.pending, function (state, action) {
    state.get_all_masters.loading = true, state.get_all_masters.error = false, state.get_all_masters.loading = true;
  }), _defineProperty(_extraReducers$a, GET_ALL_MASTER.rejected, function (state, action) {
    state.get_all_masters.loading = false, state.get_all_masters.error = true, state.get_all_masters = action.payload;
  }), _defineProperty(_extraReducers$a, UPSERT_ALERT.fulfilled, function (state, action) {
    state.save_alert.loading = false, state.save_alert.error = false, state.save_alert = action.payload;
  }), _defineProperty(_extraReducers$a, UPSERT_ALERT.pending, function (state, action) {
    state.save_alert.loading = true, state.save_alert.error = false, state.save_alert.loading = true;
  }), _defineProperty(_extraReducers$a, UPSERT_ALERT.rejected, function (state, action) {
    state.save_alert.loading = false, state.save_alert.error = true, state.save_alert = action.payload;
  }), _defineProperty(_extraReducers$a, READ_ALERT.fulfilled, function (state, action) {
    state.read_alert.loading = false, state.read_alert.error = false, state.read_alert = action.payload;
  }), _defineProperty(_extraReducers$a, READ_ALERT.pending, function (state, action) {
    state.read_alert.loading = true, state.read_alert.error = false, state.read_alert.loading = true;
  }), _defineProperty(_extraReducers$a, READ_ALERT.rejected, function (state, action) {
    state.read_alert.loading = false, state.read_alert.error = true, state.read_alert = action.payload;
  }), _defineProperty(_extraReducers$a, UPSERT_ALERT_STATUS.fulfilled, function (state, action) {
    state.read_alert_status.loading = false, state.read_alert_status.error = false, state.read_alert_status = action.payload;
  }), _defineProperty(_extraReducers$a, UPSERT_ALERT_STATUS.pending, function (state, action) {
    state.read_alert_status.loading = true, state.read_alert_status.error = false, state.read_alert_status.loading = true;
  }), _defineProperty(_extraReducers$a, UPSERT_ALERT_STATUS.rejected, function (state, action) {
    state.read_alert_status.loading = false, state.read_alert_status.error = true, state.read_alert_status = action.payload;
  }), _extraReducers$a)
});
var alertRestrictionsMasterActions = {
  GET_ALL_MASTER: GET_ALL_MASTER,
  UPSERT_ALERT: UPSERT_ALERT,
  READ_ALERT: READ_ALERT,
  UPSERT_ALERT_STATUS: UPSERT_ALERT_STATUS
};
var alertRestictionsMasterSlice$1 = alertRestictionsMasterSlice.reducer;

// import { dbName } from "../../qdm_query_ids";
var queries$3 = {
  fullread: function fullread(page, perPage, search) {
    return {
      db_name: dbName,
      entity: "OrderType",
      sort: "OrderType.createddate",
      filter: "(LIKE(OrderType.ordertype,'%".concat(search, "%',true) || LIKE(OrderType.shortdesc,'%").concat(search, "%',true) || LIKE(OrderType.longdesc,'%").concat(search, "%',true) ) && OrderType.activestatus == true"),
      limit: {
        offset: page,
        count: perPage
      },
      return_fields: "MERGE(OrderType,{TotalCount:COUNT(FOR cnt IN OrderType RETURN cnt._key),ordercategory:(DOCUMENT(OrderType.ordercategory))})"
    };
  },
  OrderCategory: function OrderCategory() {
    return {
      db_name: dbName,
      entity: "OrderCategory",
      sort: "OrderCategory.shortdesc",
      filter: "OrderCategory.activestatus == true && OrderCategory.status==true",
      return_fields: "OrderCategory"
    };
  },
  Insert: function Insert(data) {
    return [{
      db_name: dbName,
      entity: "OrderType",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        id: 0,
        ordertype: data === null || data === void 0 ? void 0 : data.ordertype,
        shortdesc: data === null || data === void 0 ? void 0 : data.shortdesc,
        longdesc: data === null || data === void 0 ? void 0 : data.longdesc,
        ordercategory: data === null || data === void 0 ? void 0 : data.ordercategory,
        registrationReq: data === null || data === void 0 ? void 0 : data.registrationReq,
        status: data === null || data === void 0 ? void 0 : data.status
      }
    }];
  },
  SoftDelete: function SoftDelete() {
    return {
      db_name: dbName,
      entity: "OrderType",
      filter: "OrderType._key == '10018'"
    };
  },
  StatusUpdate: function StatusUpdate(key, getstatus) {
    return [{
      db_name: dbName,
      entity: "OrderType",
      filter: {
        _key: key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        status: getstatus
      }
    }];
  },
  UpdateORModify: function UpdateORModify(data) {
    return [{
      db_name: dbName,
      entity: "OrderType",
      is_metadata: true,
      filter: {
        _key: data === null || data === void 0 ? void 0 : data._key
      },
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        _id: data === null || data === void 0 ? void 0 : data._id,
        id: data === null || data === void 0 ? void 0 : data.id,
        ordertype: data === null || data === void 0 ? void 0 : data.ordertype,
        shortdesc: data === null || data === void 0 ? void 0 : data.shortdesc,
        longdesc: data === null || data === void 0 ? void 0 : data.longdesc,
        ordercategory: data === null || data === void 0 ? void 0 : data.ordercategory,
        registrationReq: data === null || data === void 0 ? void 0 : data.registrationReq,
        status: data === null || data === void 0 ? void 0 : data.status
      }
    }];
  }
};

var _extraReducers$9;
var ORDERTYPEREAD = toolkit.createAsyncThunk("ordertypeSlice/ordertypeRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          queriesjson = queries$3.fullread(payload === null || payload === void 0 ? void 0 : payload.page, payload === null || payload === void 0 ? void 0 : payload.perPage, payload !== null && payload !== void 0 && payload.search ? payload === null || payload === void 0 ? void 0 : payload.search : '');
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          arry = [];
          data.result.map(function (val) {
            var _val$ordercategory, _val$ordercategory2;

            if (val !== null && val !== void 0 && (_val$ordercategory = val.ordercategory) !== null && _val$ordercategory !== void 0 && _val$ordercategory.ordercategory && val !== null && val !== void 0 && (_val$ordercategory2 = val.ordercategory) !== null && _val$ordercategory2 !== void 0 && _val$ordercategory2.longdesc) {
              var _val$ordercategory3, _val$ordercategory4, _val$ordercategory5, _val$ordercategory6;

              arry.push({
                total_count: val === null || val === void 0 ? void 0 : val.TotalCount,
                code: val === null || val === void 0 ? void 0 : (_val$ordercategory3 = val.ordercategory) === null || _val$ordercategory3 === void 0 ? void 0 : _val$ordercategory3.ordercategory,
                "short": val === null || val === void 0 ? void 0 : val.shortdesc,
                "long": val === null || val === void 0 ? void 0 : val.longdesc,
                id: val === null || val === void 0 ? void 0 : (_val$ordercategory4 = val.ordercategory) === null || _val$ordercategory4 === void 0 ? void 0 : _val$ordercategory4.id,
                _key: val === null || val === void 0 ? void 0 : val._key,
                status: val === null || val === void 0 ? void 0 : val.status,
                activestatus: val === null || val === void 0 ? void 0 : (_val$ordercategory5 = val.ordercategory) === null || _val$ordercategory5 === void 0 ? void 0 : _val$ordercategory5.activestatus,
                registrationReq: val === null || val === void 0 ? void 0 : val.registrationReq,
                _id: val === null || val === void 0 ? void 0 : val._id,
                ordercategory_id: val === null || val === void 0 ? void 0 : (_val$ordercategory6 = val.ordercategory) === null || _val$ordercategory6 === void 0 ? void 0 : _val$ordercategory6._id,
                ordertype: val === null || val === void 0 ? void 0 : val.ordertype
              });
            }
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 12]]);
})));
var ORDERCATEGORYMASTER = toolkit.createAsyncThunk("ordertypeSlice/orderCategoryMaster", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var _ref4,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          queriesjson = queries$3.OrderCategory();
          _context2.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context2.sent;
          arry = [];
          data.result.map(function (val) {
            if (val.activestatus && val.status) {
              arry.push({
                label: val.shortdesc,
                value: val
              });
            }
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 12]]);
})));
var UPDATEORDERTABLESTATE = toolkit.createAsyncThunk("ordertypeSlice/updateOrrderTableState", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      data,
      queriesjson,
      res,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          data = payload.data;
          queriesjson = queries$3.StatusUpdate(data._key, data.status);
          _context3.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          res = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 11]]);
})));
var UPDATESETORDERTABLE = toolkit.createAsyncThunk("ordertypeSlice/updatesetOrrderTable", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      data,
      queriesjson,
      res,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          data = payload.data;
          queriesjson = queries$3.UpdateORModify(data);
          _context4.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          res = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 11]]);
})));
var INSERTORDERTABLE = toolkit.createAsyncThunk("ordertypeSlice/insertOrrderTable", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      data,
      queriesjson,
      res,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          data = payload.data;
          queriesjson = queries$3.Insert(data);
          _context5.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          res = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 11]]);
})));
var ordertypeSlice = toolkit.createSlice({
  name: "ordertypeApiSlice",
  initialState: {
    order_type_read: _objectSpread2({}, defaultState.List),
    update_orrder_table_state: _objectSpread2({}, defaultState.List),
    order_category_master: _objectSpread2({}, defaultState.List),
    updateset_orrder_table: _objectSpread2({}, defaultState.List),
    insert_order_type: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$9 = {}, _defineProperty(_extraReducers$9, ORDERTYPEREAD.fulfilled, function (state, action) {
    state.order_type_read.loading = false, state.order_type_read.error = false, state.order_type_read = action.payload;
  }), _defineProperty(_extraReducers$9, ORDERTYPEREAD.pending, function (state, action) {
    state.order_type_read.loading = true, state.order_type_read.error = false, state.order_type_read.loading = true;
  }), _defineProperty(_extraReducers$9, ORDERTYPEREAD.rejected, function (state, action) {
    state.order_type_read.loading = false, state.order_type_read.error = true, state.order_type_read = action.payload;
  }), _defineProperty(_extraReducers$9, ORDERCATEGORYMASTER.fulfilled, function (state, action) {
    state.order_category_master.loading = false, state.order_category_master.error = false, state.order_category_master = action.payload;
  }), _defineProperty(_extraReducers$9, ORDERCATEGORYMASTER.pending, function (state, action) {
    state.order_category_master.loading = true, state.order_category_master.error = false, state.order_category_master.loading = true;
  }), _defineProperty(_extraReducers$9, ORDERCATEGORYMASTER.rejected, function (state, action) {
    state.order_category_master.loading = false, state.order_category_master.error = true, state.order_category_master = action.payload;
  }), _defineProperty(_extraReducers$9, UPDATEORDERTABLESTATE.fulfilled, function (state, action) {
    state.update_orrder_table_state.loading = false, state.update_orrder_table_state.error = false, state.update_orrder_table_state = action.payload;
  }), _defineProperty(_extraReducers$9, UPDATEORDERTABLESTATE.pending, function (state, action) {
    state.update_orrder_table_state.loading = true, state.update_orrder_table_state.error = false, state.update_orrder_table_state.loading = true;
  }), _defineProperty(_extraReducers$9, UPDATEORDERTABLESTATE.rejected, function (state, action) {
    state.update_orrder_table_state.loading = false, state.update_orrder_table_state.error = true, state.update_orrder_table_state = action.payload;
  }), _defineProperty(_extraReducers$9, UPDATESETORDERTABLE.fulfilled, function (state, action) {
    state.updateset_orrder_table.loading = false, state.updateset_orrder_table.error = false, state.updateset_orrder_table = action.payload;
  }), _defineProperty(_extraReducers$9, UPDATESETORDERTABLE.pending, function (state, action) {
    state.updateset_orrder_table.loading = true, state.updateset_orrder_table.error = false, state.updateset_orrder_table.loading = true;
  }), _defineProperty(_extraReducers$9, UPDATESETORDERTABLE.rejected, function (state, action) {
    state.updateset_orrder_table.loading = false, state.updateset_orrder_table.error = true, state.updateset_orrder_table = action.payload;
  }), _defineProperty(_extraReducers$9, INSERTORDERTABLE.fulfilled, function (state, action) {
    state.insert_order_type.loading = false, state.insert_order_type.error = false, state.insert_order_type = action.payload;
  }), _defineProperty(_extraReducers$9, INSERTORDERTABLE.pending, function (state, action) {
    state.insert_order_type.loading = true, state.insert_order_type.error = false, state.insert_order_type.loading = true;
  }), _defineProperty(_extraReducers$9, INSERTORDERTABLE.rejected, function (state, action) {
    state.insert_order_type.loading = false, state.insert_order_type.error = true, state.insert_order_type = action.payload;
  }), _extraReducers$9)
});
var ordertypeActions$1 = {
  ORDERTYPEREAD: ORDERTYPEREAD,
  UPDATEORDERTABLESTATE: UPDATEORDERTABLESTATE,
  ORDERCATEGORYMASTER: ORDERCATEGORYMASTER,
  UPDATESETORDERTABLE: UPDATESETORDERTABLE,
  INSERTORDERTABLE: INSERTORDERTABLE
};
var ordertypeSlice$1 = ordertypeSlice.reducer;

// import { dbName } from "../../qdm_query_ids";
var queries$2 = {
  fullread: function fullread(page, perPage, search) {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "CodeableConceptMaster.createddate",
      filter: "CodeableConceptMaster.Type == 'ORDERNATURE' && (LIKE(CodeableConceptMaster.shortdesc,'%".concat(search, "%',true)|| LIKE(CodeableConceptMaster.longdesc,'%").concat(search, "%',true)) && CodeableConceptMaster.status == true && CodeableConceptMaster.activestatus == true"),
      limit: {
        offset: page,
        count: perPage
      },
      return_fields: "MERGE(CodeableConceptMaster,{TotalCount:COUNT(FOR cnt IN CodeableConceptMaster filter cnt.activestatus==true && cnt.Type=='ORDERNATURE' RETURN cnt._key), coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  Insert: function Insert(data) {
    return [{
      db_name: dbName,
      entity: "CodeableConceptMaster",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        text: "",
        coding: [{
          system: "",
          version: "1",
          code: data.ordertype,
          display: data.longdesc,
          userSelected: true,
          id: 1,
          Type: "ORDERNATURE",
          shortdesc: data.shortdesc
        }],
        id: 1,
        Type: "ORDERNATURE",
        status: data.status
      }
    }];
  },
  StatusUpdate: function StatusUpdate(key, getstatus) {
    return [{
      db_name: dbName,
      entity: "CodeableConceptMaster",
      filter: {
        _key: key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        status: getstatus
      }
    }];
  },
  UpdateORModify: function UpdateORModify(data) {
    // return [
    //   {
    //     db_name: dbName,
    //     entity: "CodeableConceptMaster",
    //     filter: {
    //       _key: data?._key,
    //     },
    //     is_metadata: true,
    //     metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
    //     doc: {
    //       text: "new",
    //       coding: [
    //         {
    //           system: "",
    //           version: "1",
    //           code: data?.code,
    //           display: data?.longdesc,
    //           userSelected: true,
    //           id: 1,
    //           Type: "ORDERNATURE",
    //           shortdesc: data?.shortdesc,
    //         },
    //       ],
    //       id: 1,
    //       Type: "ORDERNATURE",
    //       status: data?.status,
    //     },
    //   },
    // ];
    return [{
      db_name: dbName,
      entity: "CodingMaster",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        system: "",
        version: "1",
        code: data === null || data === void 0 ? void 0 : data.code,
        display: data === null || data === void 0 ? void 0 : data.longdesc,
        userSelected: true,
        id: 1,
        Type: "ORDERNATURE",
        shortdesc: data === null || data === void 0 ? void 0 : data.shortdesc
      },
      filter: {
        _key: data === null || data === void 0 ? void 0 : data._key
      }
    }];
  }
};

var _extraReducers$8;
var ORDERNATUREREAD = toolkit.createAsyncThunk("ordertypeSlice/ordernatureread", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          queriesjson = queries$2.fullread(payload === null || payload === void 0 ? void 0 : payload.page, payload === null || payload === void 0 ? void 0 : payload.perPage, payload !== null && payload !== void 0 && payload.search ? payload === null || payload === void 0 ? void 0 : payload.search : '');
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          arry = [];
          data.result.map(function (val) {
            var _val$coding$, _val$coding$2;

            if (val !== null && val !== void 0 && val.activestatus && val !== null && val !== void 0 && (_val$coding$ = val.coding[0]) !== null && _val$coding$ !== void 0 && _val$coding$.shortdesc && val !== null && val !== void 0 && (_val$coding$2 = val.coding[0]) !== null && _val$coding$2 !== void 0 && _val$coding$2.code) {
              var _val$coding$3, _val$coding$4, _val$coding$5;

              arry.push(_objectSpread2({
                total_count: val === null || val === void 0 ? void 0 : val.TotalCount,
                code: val === null || val === void 0 ? void 0 : (_val$coding$3 = val.coding[0]) === null || _val$coding$3 === void 0 ? void 0 : _val$coding$3.code,
                "short": val === null || val === void 0 ? void 0 : (_val$coding$4 = val.coding[0]) === null || _val$coding$4 === void 0 ? void 0 : _val$coding$4.shortdesc,
                "long": val === null || val === void 0 ? void 0 : val.coding[0].display,
                id: val === null || val === void 0 ? void 0 : (_val$coding$5 = val.coding[0]) === null || _val$coding$5 === void 0 ? void 0 : _val$coding$5.id,
                _key: val === null || val === void 0 ? void 0 : val._key,
                status: val === null || val === void 0 ? void 0 : val.status
              }, val));
            }
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 12]]);
})));
var UPDATEORDERNATURETABLESTATE = toolkit.createAsyncThunk("ordertypeSlice/updateOrrderNatureTableState", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      data,
      queriesjson,
      res,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          data = payload.data;
          queriesjson = queries$2.StatusUpdate(data._key, data.status);
          _context2.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          res = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var UPDATESETORDERNATURETABLE = toolkit.createAsyncThunk("ordertypeSlice/updatesetOrrderNatureTable", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      data,
      queriesjson,
      res,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          data = payload.data;
          queriesjson = queries$2.UpdateORModify(data);
          _context3.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          res = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 11]]);
})));
var INSERTORDERNATURETABLE = toolkit.createAsyncThunk("ordertypeSlice/insertOrrderNarureTable", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      data,
      queriesjson,
      res,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          data = payload.data;
          queriesjson = queries$2.Insert(data);
          _context4.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          res = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: res
          }));

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 11]]);
})));
var ordernatureSlice = toolkit.createSlice({
  name: "ordertypeApiSlice",
  initialState: {
    order_nature_read: _objectSpread2({}, defaultState.List),
    update_orrder_nature_table_state: _objectSpread2({}, defaultState.List),
    updateset_orrder_nature_table: _objectSpread2({}, defaultState.List),
    insert_order_nature_type: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$8 = {}, _defineProperty(_extraReducers$8, ORDERNATUREREAD.fulfilled, function (state, action) {
    state.order_nature_read.loading = false, state.order_nature_read.error = false, state.order_nature_read = action.payload;
  }), _defineProperty(_extraReducers$8, ORDERNATUREREAD.pending, function (state, action) {
    state.order_nature_read.loading = true, state.order_nature_read.error = false, state.order_nature_read.loading = true;
  }), _defineProperty(_extraReducers$8, ORDERNATUREREAD.rejected, function (state, action) {
    state.order_nature_read.loading = false, state.order_nature_read.error = true, state.order_nature_read = action.payload;
  }), _defineProperty(_extraReducers$8, UPDATEORDERNATURETABLESTATE.fulfilled, function (state, action) {
    state.update_orrder_nature_table_state.loading = false, state.update_orrder_nature_table_state.error = false, state.update_orrder_nature_table_state = action.payload;
  }), _defineProperty(_extraReducers$8, UPDATEORDERNATURETABLESTATE.pending, function (state, action) {
    state.update_orrder_nature_table_state.loading = true, state.update_orrder_nature_table_state.error = false, state.update_orrder_nature_table_state.loading = true;
  }), _defineProperty(_extraReducers$8, UPDATEORDERNATURETABLESTATE.rejected, function (state, action) {
    state.update_orrder_nature_table_state.loading = false, state.update_orrder_nature_table_state.error = true, state.update_orrder_nature_table_state = action.payload;
  }), _defineProperty(_extraReducers$8, UPDATESETORDERNATURETABLE.fulfilled, function (state, action) {
    state.updateset_orrder_nature_table.loading = false, state.updateset_orrder_nature_table.error = false, state.updateset_orrder_nature_table = action.payload;
  }), _defineProperty(_extraReducers$8, UPDATESETORDERNATURETABLE.pending, function (state, action) {
    state.updateset_orrder_nature_table.loading = true, state.updateset_orrder_nature_table.error = false, state.updateset_orrder_nature_table.loading = true;
  }), _defineProperty(_extraReducers$8, UPDATESETORDERNATURETABLE.rejected, function (state, action) {
    state.updateset_orrder_nature_table.loading = false, state.updateset_orrder_nature_table.error = true, state.updateset_orrder_nature_table = action.payload;
  }), _defineProperty(_extraReducers$8, INSERTORDERNATURETABLE.fulfilled, function (state, action) {
    state.insert_order_nature_type.loading = false, state.insert_order_nature_type.error = false, state.insert_order_nature_type = action.payload;
  }), _defineProperty(_extraReducers$8, INSERTORDERNATURETABLE.pending, function (state, action) {
    state.insert_order_nature_type.loading = true, state.insert_order_nature_type.error = false, state.insert_order_nature_type.loading = true;
  }), _defineProperty(_extraReducers$8, INSERTORDERNATURETABLE.rejected, function (state, action) {
    state.insert_order_nature_type.loading = false, state.insert_order_nature_type.error = true, state.insert_order_nature_type = action.payload;
  }), _extraReducers$8)
});
var ordernatureActions$1 = {
  ORDERNATUREREAD: ORDERNATUREREAD,
  UPDATEORDERNATURETABLESTATE: UPDATEORDERNATURETABLESTATE,
  UPDATESETORDERNATURETABLE: UPDATESETORDERNATURETABLE,
  INSERTORDERNATURETABLE: INSERTORDERNATURETABLE
};
var ordernatureSlice$1 = ordernatureSlice.reducer;

var query$3 = {
  orderSetList: function orderSetList() {
    return {
      db_name: "".concat(dbName),
      entity: "CA_OrderSet",
      filter: "CA_OrderSet.activestatus == true",
      return_fields: "keep(CA_OrderSet,'id','_key','_id','longDesc','shortDesc','orderSetCode','status')",
      sort: "CA_OrderSet.createddate"
    };
  },
  orderSetListById: function orderSetListById(_key) {
    return {
      db_name: "".concat(dbName),
      entity: "CA_OrderSet",
      filter: "CA_OrderSet._key == '".concat(_key, "' && CA_OrderSet.activestatus == true"),
      return_fields: "merge(CA_OrderSet,{components:(for comp in CA_OrderSet_Components filter comp._id in CA_OrderSet.components return merge(comp,{orderCatalog:document(comp.orderCatalog),ordercategory:document(comp.ordercategory),ordertype:document(comp.ordertype),IVDosDurUOM:document(comp.IVDosDurUOM),IVInfusRateUOM:document(comp.IVInfusRateUOM),IVInfusRateVolUOM:document(comp.IVInfusRateVolUOM),dfltDurUOM:document(comp.dfltDurUOM),dfltDurUOM:document(comp.dfltDurUOM),dfltFreqRateUnit:document(comp.dfltFreqRateUnit),dfltFreqValUnit:document(comp.dfltFreqValUnit),dfltOrderUOM:document(comp.dfltOrderUOM),route:document(comp.route),dosageFreqCode:document(comp.dosageFreqCode)}))})"
    };
  },
  status_update_order_set_master: function status_update_order_set_master(data) {
    return [{
      db_name: "".concat(dbName),
      entity: "CA_OrderSet",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      filter: {
        _key: data === null || data === void 0 ? void 0 : data._key
      },
      doc: {
        status: data === null || data === void 0 ? void 0 : data.status
      }
    }];
  },
  orderSetComponentDelete: function orderSetComponentDelete(_key) {
    return {
      db_name: "".concat(dbName),
      entity: "CA_OrderSet_Components",
      filter: "CA_OrderSet_Components._key== '".concat(_key, "'")
    };
  }
};

var masterQuery$3 = {
  orderCategory: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"OrderCategory\",\n    \"filter\": \"OrderCategory.activestatus == true && OrderCategory.status==true\",\n    \"return_fields\": \"keep(OrderCategory,'id','_id','_key','shortdesc','ordercategory','longdesc')\",\n    \"sort\": \"OrderCategory.shortdesc\"\n  }"),
  commonUOM: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DrugUOM\",\n    \"filter\": \"DrugUOM.status == true && DrugUOM.activestatus == true\",\n    \"return_fields\": \"keep(DrugUOM,'_key','_id','UOM','shortdesc','longdesc','status')\"\n    }"),
  route: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DrugRoutes\",\n    \"filter\": \"DrugRoutes.activestatus==true && DrugRoutes.status==true\",\n    \"return_fields\": \"keep(DrugRoutes,'id','_key','_id','longdesc','routeadverb','routecode','shortdesc')\",\n    \"sort\": \"DrugRoutes.shortdesc\"\n    }"),
  drugFreqCode: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"FrequencyMaster\",\n    \"filter\": \"FrequencyMaster.activestatus == true && FrequencyMaster.status == true\",\n    \"return_fields\": \"keep(FrequencyMaster,'id','_key','_id','longdesc','shortdesc','freqcode')\",\n    \"sort\": \"FrequencyMaster.shortdesc\"\n    }"),
  durationDropDown: "{\n    \"db_name\": \"".concat(dbName, "\", \n    \"entity\": \"DrugUOM\",\n    \"filter\": \"LOWER(DOCUMENT(DrugUOM.UOMType).display) =='time' and DrugUOM.activestatus==true and DrugUOM.status==true\",\n    \"return_fields\": \"keep(DrugUOM,'_key','_id','UOM','shortdesc','longdesc','status')\"\n  }")
};
var orderCategoty = {
  orderCategory: function orderCategory() {
    return {
      db_name: "".concat(dbName),
      entity: "OrderCategory",
      filter: "OrderCategory.activestatus == true && OrderCategory.status==true",
      return_fields: "keep(OrderCategory,'id','_id','_key','shortdesc','ordercategory','longdesc')",
      sort: "OrderCategory.shortdesc"
    };
  }
};
var dynamicMaster$1 = {
  orderDrugType: function orderDrugType(order_category) {
    return {
      db_name: "".concat(dbName),
      entity: "OrderType",
      filter: "OrderType.ordercategory=='".concat(order_category, "' && OrderType.activestatus == true && OrderType.status == true"),
      return_fields: "MERGE(keep(OrderType,'id','_key','_id','shortdesc','ordertype','longdesc','ordercategory'),{ordercategory:(DOCUMENT(OrderType.ordercategory))})",
      sort: "OrderType.shortdesc"
    };
  },
  drugType: function drugType() {
    return {
      db_name: "".concat(dbName),
      entity: "DrugType",
      filter: "DrugType.activestatus == true && DrugType.status == true",
      return_fields: "KEEP(DrugType,'_id','_key','drugtype','longdesc','shortdesc')",
      sort: "DrugType.shortdesc"
    };
  },
  orderCatalog: function orderCatalog(order_category, order_drug_type) {
    return {
      db_name: "".concat(dbName),
      entity: "OrderCatalog",
      filter: "OrderCatalog.ordercategory=='".concat(order_category, "' && OrderCatalog.ordertype=='").concat(order_drug_type, "' && OrderCatalog.activestatus == true && OrderCatalog.status==true"),
      return_fields: "merge(keep(OrderCatalog,'id','_key','_id','shortdesc','ordertype','ordercategory','ordercatalog','longdesc'),{ordertype:document(OrderCatalog.ordertype)},{ordercategory:document(OrderCatalog.ordercategory)},{OrderCatalogByEncounterTypeAge:document(OrderCatalog.OrderCatalogByEncounterTypeAge)[*].freqappl})",
      sort: "OrderCatalog.shortdesc"
    };
  },
  drugCatalog: function drugCatalog(drug_type) {
    return {
      db_name: "".concat(dbName),
      entity: "DrugMaster",
      filter: "DrugMaster.DrugType=='".concat(drug_type, "' && DrugMaster.activestatus == true && DrugMaster.statusactive==true"),
      return_fields: "merge(keep(DrugMaster,'id','_id','_key','ShortDesc','LongDesc','DrugType'),{DrugType:document(DrugMaster.DrugType)})",
      sort: "DrugMaster.ShortDesc"
    };
  }
};

var generateJson$3 = function generateJson(data) {
  var _data$id, _data$orderSetCode, _data$shortdes, _data$longdes;

  var filter = {};

  if (data !== null && data !== void 0 && data._key) {
    filter = {
      filter: {
        _key: data === null || data === void 0 ? void 0 : data._key
      }
    };
  }

  return [_objectSpread2(_objectSpread2({
    db_name: dbName,
    entity: "CA_OrderSet",
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
  }, filter), {}, {
    doc: {
      id: (_data$id = data === null || data === void 0 ? void 0 : data.id) !== null && _data$id !== void 0 ? _data$id : 0,
      status: data === null || data === void 0 ? void 0 : data.status,
      orderSetCode: (_data$orderSetCode = data === null || data === void 0 ? void 0 : data.orderSetCode) !== null && _data$orderSetCode !== void 0 ? _data$orderSetCode : "",
      shortDesc: (_data$shortdes = data === null || data === void 0 ? void 0 : data.shortdes) !== null && _data$shortdes !== void 0 ? _data$shortdes : "",
      longDesc: (_data$longdes = data === null || data === void 0 ? void 0 : data.longdes) !== null && _data$longdes !== void 0 ? _data$longdes : "",
      components: constructComponents(data === null || data === void 0 ? void 0 : data.tableData)
    }
  })];
};

var constructComponents = function constructComponents(data) {
  var arr = [];
  data.map(function (val) {
    var _val$id, _val$seqNo, _val$orderCatalog$val, _val$orderCatalog, _val$orderCategory$va, _val$orderCategory, _val$orderTypeDrugTyp, _val$orderTypeDrugTyp2, _val$explanatoryNote, _val$practitionerInst, _parseInt, _val$quantity_type$va, _val$quantity_type, _parseInt2, _val$route$value, _val$route, _parseInt3, _val$frequency_type$v, _val$frequency_type, _parseInt4, _val$rate_type$value, _val$rate_type, _parseInt5, _val$duration_type$va, _val$duration_type, _parseInt6, _val$dosage_freq_code, _val$dosage_freq_code2, _parseInt7, _val$in_infusion_rate, _val$in_infusion_rate2, _parseInt8, _val$in_infusion_rate3, _val$in_infusion_rate4, _parseInt9, _val$iv_dosage_durati, _val$iv_dosage_durati2, _val$parentordercatal, _val$parentordercatal2;

    var _key = {};

    if (val !== null && val !== void 0 && val._key) {
      _key = {
        _key: val === null || val === void 0 ? void 0 : val._key
      };
    }

    var obj = _objectSpread2(_objectSpread2({
      id: (_val$id = val === null || val === void 0 ? void 0 : val.id) !== null && _val$id !== void 0 ? _val$id : 0
    }, _key), {}, {
      seqNo: (_val$seqNo = val === null || val === void 0 ? void 0 : val.seqNo) !== null && _val$seqNo !== void 0 ? _val$seqNo : 0,
      orderCatalog: (_val$orderCatalog$val = val === null || val === void 0 ? void 0 : (_val$orderCatalog = val.orderCatalog) === null || _val$orderCatalog === void 0 ? void 0 : _val$orderCatalog.value) !== null && _val$orderCatalog$val !== void 0 ? _val$orderCatalog$val : "",
      ordercategory: (_val$orderCategory$va = val === null || val === void 0 ? void 0 : (_val$orderCategory = val.orderCategory) === null || _val$orderCategory === void 0 ? void 0 : _val$orderCategory.value) !== null && _val$orderCategory$va !== void 0 ? _val$orderCategory$va : "",
      ordertype: (_val$orderTypeDrugTyp = val === null || val === void 0 ? void 0 : (_val$orderTypeDrugTyp2 = val.orderTypeDrugType) === null || _val$orderTypeDrugTyp2 === void 0 ? void 0 : _val$orderTypeDrugTyp2.value) !== null && _val$orderTypeDrugTyp !== void 0 ? _val$orderTypeDrugTyp : "",
      explNote: (_val$explanatoryNote = val === null || val === void 0 ? void 0 : val.explanatoryNote) !== null && _val$explanatoryNote !== void 0 ? _val$explanatoryNote : "",
      practInstr: (_val$practitionerInst = val === null || val === void 0 ? void 0 : val.practitionerInstructions) !== null && _val$practitionerInst !== void 0 ? _val$practitionerInst : "",
      required: val === null || val === void 0 ? void 0 : val.required,
      dfltOrderQty: (_parseInt = parseInt(val === null || val === void 0 ? void 0 : val.quantity_number)) !== null && _parseInt !== void 0 ? _parseInt : 0,
      dfltOrderUOM: (_val$quantity_type$va = val === null || val === void 0 ? void 0 : (_val$quantity_type = val.quantity_type) === null || _val$quantity_type === void 0 ? void 0 : _val$quantity_type.value) !== null && _val$quantity_type$va !== void 0 ? _val$quantity_type$va : "",
      startDay: (_parseInt2 = parseInt(val === null || val === void 0 ? void 0 : val.startDay)) !== null && _parseInt2 !== void 0 ? _parseInt2 : 0,
      route: (_val$route$value = val === null || val === void 0 ? void 0 : (_val$route = val.route) === null || _val$route === void 0 ? void 0 : _val$route.value) !== null && _val$route$value !== void 0 ? _val$route$value : "",
      dfltFreqVal: (_parseInt3 = parseInt(val === null || val === void 0 ? void 0 : val.frequency_number)) !== null && _parseInt3 !== void 0 ? _parseInt3 : 0,
      dfltFreqValUnit: (_val$frequency_type$v = val === null || val === void 0 ? void 0 : (_val$frequency_type = val.frequency_type) === null || _val$frequency_type === void 0 ? void 0 : _val$frequency_type.value) !== null && _val$frequency_type$v !== void 0 ? _val$frequency_type$v : "",
      dfltFreqRate: (_parseInt4 = parseInt(val === null || val === void 0 ? void 0 : val.rate_number)) !== null && _parseInt4 !== void 0 ? _parseInt4 : 0,
      dfltFreqRateUnit: (_val$rate_type$value = val === null || val === void 0 ? void 0 : (_val$rate_type = val.rate_type) === null || _val$rate_type === void 0 ? void 0 : _val$rate_type.value) !== null && _val$rate_type$value !== void 0 ? _val$rate_type$value : "",
      dfltDuration: (_parseInt5 = parseInt(val === null || val === void 0 ? void 0 : val.duration_number)) !== null && _parseInt5 !== void 0 ? _parseInt5 : 0,
      dfltDurUOM: (_val$duration_type$va = val === null || val === void 0 ? void 0 : (_val$duration_type = val.duration_type) === null || _val$duration_type === void 0 ? void 0 : _val$duration_type.value) !== null && _val$duration_type$va !== void 0 ? _val$duration_type$va : "",
      additive: val === null || val === void 0 ? void 0 : val.additive,
      parentCatSeqNo: (_parseInt6 = parseInt(val === null || val === void 0 ? void 0 : val.parentSequence)) !== null && _parseInt6 !== void 0 ? _parseInt6 : 0,
      dosageFreqCode: (_val$dosage_freq_code = val === null || val === void 0 ? void 0 : (_val$dosage_freq_code2 = val.dosage_freq_code) === null || _val$dosage_freq_code2 === void 0 ? void 0 : _val$dosage_freq_code2.value) !== null && _val$dosage_freq_code !== void 0 ? _val$dosage_freq_code : "",
      IVInfusRateVol: (_parseInt7 = parseInt(val === null || val === void 0 ? void 0 : val.in_infusion_rate_volume_number)) !== null && _parseInt7 !== void 0 ? _parseInt7 : 0,
      IVInfusRateVolUOM: (_val$in_infusion_rate = val === null || val === void 0 ? void 0 : (_val$in_infusion_rate2 = val.in_infusion_rate_volume_type) === null || _val$in_infusion_rate2 === void 0 ? void 0 : _val$in_infusion_rate2.value) !== null && _val$in_infusion_rate !== void 0 ? _val$in_infusion_rate : "",
      IVInfusRateValue: (_parseInt8 = parseInt(val === null || val === void 0 ? void 0 : val.in_infusion_rate_duration_number)) !== null && _parseInt8 !== void 0 ? _parseInt8 : 0,
      IVInfusRateUOM: (_val$in_infusion_rate3 = val === null || val === void 0 ? void 0 : (_val$in_infusion_rate4 = val.in_infusion_rate_duration_type) === null || _val$in_infusion_rate4 === void 0 ? void 0 : _val$in_infusion_rate4.value) !== null && _val$in_infusion_rate3 !== void 0 ? _val$in_infusion_rate3 : "",
      IVDosDurValue: (_parseInt9 = parseInt(val === null || val === void 0 ? void 0 : val.iv_dosage_duration_number)) !== null && _parseInt9 !== void 0 ? _parseInt9 : 0,
      IVDosDurUOM: (_val$iv_dosage_durati = val === null || val === void 0 ? void 0 : (_val$iv_dosage_durati2 = val.iv_dosage_duration_type) === null || _val$iv_dosage_durati2 === void 0 ? void 0 : _val$iv_dosage_durati2.value) !== null && _val$iv_dosage_durati !== void 0 ? _val$iv_dosage_durati : "",
      parentordercatalog: (_val$parentordercatal = val === null || val === void 0 ? void 0 : (_val$parentordercatal2 = val.parentordercatalog) === null || _val$parentordercatal2 === void 0 ? void 0 : _val$parentordercatal2.value) !== null && _val$parentordercatal !== void 0 ? _val$parentordercatal : ""
    });

    arr === null || arr === void 0 ? void 0 : arr.push(obj);

    if (val !== null && val !== void 0 && val.children && (val === null || val === void 0 ? void 0 : val.children.length) > 0) {
      var _val$children;

      val === null || val === void 0 ? void 0 : (_val$children = val.children) === null || _val$children === void 0 ? void 0 : _val$children.map(function (val_) {
        var _val_$id, _val_$seqNo, _val_$orderCatalog$va, _val_$orderCatalog, _val$orderCategory$va2, _val$orderCategory2, _val$orderTypeDrugTyp3, _val$orderTypeDrugTyp4, _val_$explanatoryNote, _val_$practitionerIns, _parseInt10, _val_$quantity_type$v, _val_$quantity_type, _parseInt11, _val_$route$value, _val_$route, _parseInt12, _val_$frequency_type$, _val_$frequency_type, _parseInt13, _val_$rate_type$value, _val_$rate_type, _parseInt14, _val_$duration_type$v, _val_$duration_type, _parseInt15, _val_$dosage_freq_cod, _val_$dosage_freq_cod2, _parseInt16, _val_$in_infusion_rat, _val_$in_infusion_rat2, _parseInt17, _val_$in_infusion_rat3, _val_$in_infusion_rat4, _parseInt18, _val_$iv_dosage_durat, _val_$iv_dosage_durat2, _val_$parentordercata, _val_$parentordercata2;

        if (val_ !== null && val_ !== void 0 && val_._key) {
          ({
            _key: val_ === null || val_ === void 0 ? void 0 : val_._key
          });
        }

        var obj_ = {
          id: (_val_$id = val_ === null || val_ === void 0 ? void 0 : val_.id) !== null && _val_$id !== void 0 ? _val_$id : 0,
          seqNo: (_val_$seqNo = val_ === null || val_ === void 0 ? void 0 : val_.seqNo) !== null && _val_$seqNo !== void 0 ? _val_$seqNo : 0,
          orderCatalog: (_val_$orderCatalog$va = val_ === null || val_ === void 0 ? void 0 : (_val_$orderCatalog = val_.orderCatalog) === null || _val_$orderCatalog === void 0 ? void 0 : _val_$orderCatalog.value) !== null && _val_$orderCatalog$va !== void 0 ? _val_$orderCatalog$va : "",
          ordercategory: (_val$orderCategory$va2 = val === null || val === void 0 ? void 0 : (_val$orderCategory2 = val.orderCategory) === null || _val$orderCategory2 === void 0 ? void 0 : _val$orderCategory2.value) !== null && _val$orderCategory$va2 !== void 0 ? _val$orderCategory$va2 : "",
          ordertype: (_val$orderTypeDrugTyp3 = val === null || val === void 0 ? void 0 : (_val$orderTypeDrugTyp4 = val.orderTypeDrugType) === null || _val$orderTypeDrugTyp4 === void 0 ? void 0 : _val$orderTypeDrugTyp4.value) !== null && _val$orderTypeDrugTyp3 !== void 0 ? _val$orderTypeDrugTyp3 : "",
          explNote: (_val_$explanatoryNote = val_ === null || val_ === void 0 ? void 0 : val_.explanatoryNote) !== null && _val_$explanatoryNote !== void 0 ? _val_$explanatoryNote : "",
          practInstr: (_val_$practitionerIns = val_ === null || val_ === void 0 ? void 0 : val_.practitionerInstructions) !== null && _val_$practitionerIns !== void 0 ? _val_$practitionerIns : "",
          required: val_ === null || val_ === void 0 ? void 0 : val_.required,
          dfltOrderQty: (_parseInt10 = parseInt(val_ === null || val_ === void 0 ? void 0 : val_.quantity_number)) !== null && _parseInt10 !== void 0 ? _parseInt10 : 0,
          dfltOrderUOM: (_val_$quantity_type$v = val_ === null || val_ === void 0 ? void 0 : (_val_$quantity_type = val_.quantity_type) === null || _val_$quantity_type === void 0 ? void 0 : _val_$quantity_type.value) !== null && _val_$quantity_type$v !== void 0 ? _val_$quantity_type$v : "",
          startDay: (_parseInt11 = parseInt(val_ === null || val_ === void 0 ? void 0 : val_.startDay)) !== null && _parseInt11 !== void 0 ? _parseInt11 : 0,
          route: (_val_$route$value = val_ === null || val_ === void 0 ? void 0 : (_val_$route = val_.route) === null || _val_$route === void 0 ? void 0 : _val_$route.value) !== null && _val_$route$value !== void 0 ? _val_$route$value : "",
          dfltFreqVal: (_parseInt12 = parseInt(val_ === null || val_ === void 0 ? void 0 : val_.frequency_number)) !== null && _parseInt12 !== void 0 ? _parseInt12 : 0,
          dfltFreqValUnit: (_val_$frequency_type$ = val_ === null || val_ === void 0 ? void 0 : (_val_$frequency_type = val_.frequency_type) === null || _val_$frequency_type === void 0 ? void 0 : _val_$frequency_type.value) !== null && _val_$frequency_type$ !== void 0 ? _val_$frequency_type$ : "",
          dfltFreqRate: (_parseInt13 = parseInt(val_ === null || val_ === void 0 ? void 0 : val_.rate_number)) !== null && _parseInt13 !== void 0 ? _parseInt13 : 0,
          dfltFreqRateUnit: (_val_$rate_type$value = val_ === null || val_ === void 0 ? void 0 : (_val_$rate_type = val_.rate_type) === null || _val_$rate_type === void 0 ? void 0 : _val_$rate_type.value) !== null && _val_$rate_type$value !== void 0 ? _val_$rate_type$value : "",
          dfltDuration: (_parseInt14 = parseInt(val_ === null || val_ === void 0 ? void 0 : val_.duration_number)) !== null && _parseInt14 !== void 0 ? _parseInt14 : 0,
          dfltDurUOM: (_val_$duration_type$v = val_ === null || val_ === void 0 ? void 0 : (_val_$duration_type = val_.duration_type) === null || _val_$duration_type === void 0 ? void 0 : _val_$duration_type.value) !== null && _val_$duration_type$v !== void 0 ? _val_$duration_type$v : "",
          additive: val_ === null || val_ === void 0 ? void 0 : val_.additive,
          parentCatSeqNo: (_parseInt15 = parseInt(val_ === null || val_ === void 0 ? void 0 : val_.parentSequence)) !== null && _parseInt15 !== void 0 ? _parseInt15 : 0,
          dosageFreqCode: (_val_$dosage_freq_cod = val_ === null || val_ === void 0 ? void 0 : (_val_$dosage_freq_cod2 = val_.dosage_freq_code) === null || _val_$dosage_freq_cod2 === void 0 ? void 0 : _val_$dosage_freq_cod2.value) !== null && _val_$dosage_freq_cod !== void 0 ? _val_$dosage_freq_cod : "",
          IVInfusRateVol: (_parseInt16 = parseInt(val_ === null || val_ === void 0 ? void 0 : val_.in_infusion_rate_volume_number)) !== null && _parseInt16 !== void 0 ? _parseInt16 : 0,
          IVInfusRateVolUOM: (_val_$in_infusion_rat = val_ === null || val_ === void 0 ? void 0 : (_val_$in_infusion_rat2 = val_.in_infusion_rate_volume_type) === null || _val_$in_infusion_rat2 === void 0 ? void 0 : _val_$in_infusion_rat2.value) !== null && _val_$in_infusion_rat !== void 0 ? _val_$in_infusion_rat : "",
          IVInfusRateValue: (_parseInt17 = parseInt(val_ === null || val_ === void 0 ? void 0 : val_.in_infusion_rate_duration_number)) !== null && _parseInt17 !== void 0 ? _parseInt17 : 0,
          IVInfusRateUOM: (_val_$in_infusion_rat3 = val_ === null || val_ === void 0 ? void 0 : (_val_$in_infusion_rat4 = val_.in_infusion_rate_duration_type) === null || _val_$in_infusion_rat4 === void 0 ? void 0 : _val_$in_infusion_rat4.value) !== null && _val_$in_infusion_rat3 !== void 0 ? _val_$in_infusion_rat3 : "",
          IVDosDurValue: (_parseInt18 = parseInt(val_ === null || val_ === void 0 ? void 0 : val_.iv_dosage_duration_number)) !== null && _parseInt18 !== void 0 ? _parseInt18 : 0,
          IVDosDurUOM: (_val_$iv_dosage_durat = val_ === null || val_ === void 0 ? void 0 : (_val_$iv_dosage_durat2 = val_.iv_dosage_duration_type) === null || _val_$iv_dosage_durat2 === void 0 ? void 0 : _val_$iv_dosage_durat2.value) !== null && _val_$iv_dosage_durat !== void 0 ? _val_$iv_dosage_durat : "",
          parentordercatalog: (_val_$parentordercata = val_ === null || val_ === void 0 ? void 0 : (_val_$parentordercata2 = val_.parentordercatalog) === null || _val_$parentordercata2 === void 0 ? void 0 : _val_$parentordercata2.value) !== null && _val_$parentordercata !== void 0 ? _val_$parentordercata : ""
        };
        arr === null || arr === void 0 ? void 0 : arr.push(obj_);
      });
    }
  });
  return arr;
};

var generateReadJSON$2 = function generateReadJSON(data) {
  var json = {
    //INITAIL STATE
    parentSeqNumber: null,
    open: false,
    isEdit: false,
    modalFormName: "monitoringForm",
    monitoring: {
      seqNo: "",
      orderCategory: {},
      orderTypeDrugType: {},
      orderDrugCatalog: {},
      required: false,
      frequency_number: "",
      frequency_type: {},
      rate_number: "",
      rate_type: {},
      duration_number: "",
      duration_type: {},
      quantity_number: "",
      quantity_type: {},
      startDay: "",
      explanatoryNote: "",
      practitionerInstructions: ""
    },
    pharmacyMedication: {
      seqNo: "",
      orderCategory: {},
      orderTypeDrugType: {},
      orderDrugCatalog: {},
      required: false,
      route: {},
      quantity_number: "",
      quantity_type: {},
      dosage_freq_code: {},
      duration_number: "",
      duration_type: {},
      startDay: "",
      explanatoryNote: "",
      practitionerInstructions: ""
    },
    pharmacyIV: {
      seqNo: "",
      orderCategory: {},
      orderTypeDrugType: {},
      orderDrugCatalog: {},
      required: false,
      route: {},
      quantity_number: "",
      quantity_type: {},
      in_infusion_rate_volume_number: "",
      in_infusion_rate_volume_type: {},
      in_infusion_rate_duration_number: "",
      in_infusion_rate_duration_type: {},
      iv_dosage_duration_number: "",
      iv_dosage_duration_type: "",
      duration_number: "",
      duration_type: {},
      startDay: "",
      explanatoryNote: "",
      practitionerInstructions: "",
      additiveArray: [{
        drugeCatalog: {},
        quantity_number: "",
        quantity_type: {},
        required: false
      }]
    },
    _id: data === null || data === void 0 ? void 0 : data._id,
    _key: data === null || data === void 0 ? void 0 : data._key,
    status: data === null || data === void 0 ? void 0 : data.status,
    id: data === null || data === void 0 ? void 0 : data.id,
    longdes: data === null || data === void 0 ? void 0 : data.longDesc,
    orderSetCode: data === null || data === void 0 ? void 0 : data.orderSetCode,
    shortdes: data === null || data === void 0 ? void 0 : data.shortDesc,
    sequencyNumber: getSeqNumber(data === null || data === void 0 ? void 0 : data.components),
    tableData: constructTabelData(data === null || data === void 0 ? void 0 : data.components)
  };
  return json;
};

var getSeqNumber = function getSeqNumber(components) {
  var maxNum = 0;
  components.forEach(function (c) {
    if (c.seqNo > maxNum) {
      maxNum = c.seqNo;
    }
  });
  return maxNum + 1;
};

var constructTabelData = function constructTabelData(data) {
  var arr = [];

  if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
    data === null || data === void 0 ? void 0 : data.map(function (val) {
      if (!(val !== null && val !== void 0 && val.parentCatSeqNo)) {
        var _val$id, _val$_key, _val$ordercategory$_i, _val$seqNo, _val$ordercategory, _val$ordercategory2, _val$ordercategory3, _val$ordercategory4, _val$ordercategory5, _val$ordertype, _val$ordertype2, _val$ordertype3, _val$ordertype4, _val$orderCatalog, _val$orderCatalog2, _val$orderCatalog3, _val$orderCatalog4, _val$orderCatalog5, _val$orderCatalog6, _val$orderCatalog7, _val$orderCatalog8, _val$dfltOrderUOM, _val$dfltOrderUOM2, _val$dfltOrderUOM3, _val$dfltOrderUOM4, _val$dfltOrderUOM5, _val$dfltOrderUOM6, _val$IVInfusRateVol, _val$IVInfusRateVolUO, _val$IVInfusRateVolUO2, _val$IVInfusRateVolUO3, _val$IVInfusRateVolUO4, _val$IVDosDurValue, _val$IVDosDurUOM, _val$IVDosDurUOM2, _val$IVDosDurUOM3, _val$IVDosDurUOM4, _val$IVDosDurValue2, _val$IVDosDurUOM5, _val$IVDosDurUOM6, _val$IVDosDurUOM7, _val$IVDosDurUOM8, _val$dosageFreqCode, _val$dosageFreqCode2, _val$dosageFreqCode3, _val$dosageFreqCode4, _val$startDay, _val$dfltDuration, _val$dfltDurUOM, _val$dfltDurUOM2, _val$dfltDurUOM3, _val$dfltDurUOM4, _val$dfltDurUOM5, _val$dfltDurUOM6, _val$route, _val$route2, _val$route3, _val$route4, _val$route$shortdesc, _val$route5, _val$dfltFreqVal, _val$dfltFreqValUnit, _val$dfltFreqValUnit2, _val$dfltFreqValUnit3, _val$dfltFreqValUnit4, _val$dfltFreqValUnit5, _val$dfltFreqValUnit6, _val$dfltFreqRate, _val$dfltFreqRateUnit, _val$dfltFreqRateUnit2, _val$dfltFreqRateUnit3, _val$dfltFreqRateUnit4, _val$dfltFreqRateUnit5, _val$dfltFreqRateUnit6, _val$additive, _val$parentSequence, _val$parentSequence2, _val$explNote, _val$practInstr, _constructChildrenTab, _obj;

        var obj = (_obj = {
          id: (_val$id = val === null || val === void 0 ? void 0 : val.id) !== null && _val$id !== void 0 ? _val$id : 0,
          _key: (_val$_key = val === null || val === void 0 ? void 0 : val._key) !== null && _val$_key !== void 0 ? _val$_key : 0,
          typeId: (_val$ordercategory$_i = val === null || val === void 0 ? void 0 : val.ordercategory._id) !== null && _val$ordercategory$_i !== void 0 ? _val$ordercategory$_i : "",
          seqNo: (_val$seqNo = val === null || val === void 0 ? void 0 : val.seqNo) !== null && _val$seqNo !== void 0 ? _val$seqNo : "",
          orderCategory: (_val$ordercategory = val === null || val === void 0 ? void 0 : val.ordercategory) !== null && _val$ordercategory !== void 0 ? _val$ordercategory : {}
        }, _defineProperty(_obj, "orderCategory", val !== null && val !== void 0 && (_val$ordercategory2 = val.ordercategory) !== null && _val$ordercategory2 !== void 0 && _val$ordercategory2._id && val !== null && val !== void 0 && (_val$ordercategory3 = val.ordercategory) !== null && _val$ordercategory3 !== void 0 && _val$ordercategory3.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$ordercategory4 = val.ordercategory) === null || _val$ordercategory4 === void 0 ? void 0 : _val$ordercategory4._id,
          label: val === null || val === void 0 ? void 0 : (_val$ordercategory5 = val.ordercategory) === null || _val$ordercategory5 === void 0 ? void 0 : _val$ordercategory5.shortdesc
        } : {}), _defineProperty(_obj, "orderTypeDrugType", val !== null && val !== void 0 && (_val$ordertype = val.ordertype) !== null && _val$ordertype !== void 0 && _val$ordertype._id && val !== null && val !== void 0 && (_val$ordertype2 = val.ordertype) !== null && _val$ordertype2 !== void 0 && _val$ordertype2.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$ordertype3 = val.ordertype) === null || _val$ordertype3 === void 0 ? void 0 : _val$ordertype3._id,
          label: val === null || val === void 0 ? void 0 : (_val$ordertype4 = val.ordertype) === null || _val$ordertype4 === void 0 ? void 0 : _val$ordertype4.shortdesc
        } : {}), _defineProperty(_obj, "orderCatalog", val !== null && val !== void 0 && (_val$orderCatalog = val.orderCatalog) !== null && _val$orderCatalog !== void 0 && _val$orderCatalog._id && val !== null && val !== void 0 && (_val$orderCatalog2 = val.orderCatalog) !== null && _val$orderCatalog2 !== void 0 && _val$orderCatalog2.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$orderCatalog3 = val.orderCatalog) === null || _val$orderCatalog3 === void 0 ? void 0 : _val$orderCatalog3._id,
          label: val === null || val === void 0 ? void 0 : (_val$orderCatalog4 = val.orderCatalog) === null || _val$orderCatalog4 === void 0 ? void 0 : _val$orderCatalog4.shortdesc
        } : val !== null && val !== void 0 && (_val$orderCatalog5 = val.orderCatalog) !== null && _val$orderCatalog5 !== void 0 && _val$orderCatalog5._id && val !== null && val !== void 0 && (_val$orderCatalog6 = val.orderCatalog) !== null && _val$orderCatalog6 !== void 0 && _val$orderCatalog6.ShortDesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$orderCatalog7 = val.orderCatalog) === null || _val$orderCatalog7 === void 0 ? void 0 : _val$orderCatalog7._id,
          label: val === null || val === void 0 ? void 0 : (_val$orderCatalog8 = val.orderCatalog) === null || _val$orderCatalog8 === void 0 ? void 0 : _val$orderCatalog8.ShortDesc
        } : {}), _defineProperty(_obj, "required", val !== null && val !== void 0 && val.required ? val === null || val === void 0 ? void 0 : val.required : false), _defineProperty(_obj, "requiredT", val !== null && val !== void 0 && val.required ? (val === null || val === void 0 ? void 0 : val.required) === true ? "Yes" : "No" : "No"), _defineProperty(_obj, "quantity_number", val !== null && val !== void 0 && val.dfltOrderQty ? val === null || val === void 0 ? void 0 : val.dfltOrderQty : ""), _defineProperty(_obj, "quantity_type", val !== null && val !== void 0 && (_val$dfltOrderUOM = val.dfltOrderUOM) !== null && _val$dfltOrderUOM !== void 0 && _val$dfltOrderUOM._id && val !== null && val !== void 0 && (_val$dfltOrderUOM2 = val.dfltOrderUOM) !== null && _val$dfltOrderUOM2 !== void 0 && _val$dfltOrderUOM2.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$dfltOrderUOM3 = val.dfltOrderUOM) === null || _val$dfltOrderUOM3 === void 0 ? void 0 : _val$dfltOrderUOM3._id,
          label: val === null || val === void 0 ? void 0 : (_val$dfltOrderUOM4 = val.dfltOrderUOM) === null || _val$dfltOrderUOM4 === void 0 ? void 0 : _val$dfltOrderUOM4.shortdesc
        } : {}), _defineProperty(_obj, "quantityT", val !== null && val !== void 0 && (_val$dfltOrderUOM5 = val.dfltOrderUOM) !== null && _val$dfltOrderUOM5 !== void 0 && _val$dfltOrderUOM5.shortdesc && val !== null && val !== void 0 && val.dfltOrderQty ? (val === null || val === void 0 ? void 0 : val.dfltOrderQty) + " " + (val === null || val === void 0 ? void 0 : (_val$dfltOrderUOM6 = val.dfltOrderUOM) === null || _val$dfltOrderUOM6 === void 0 ? void 0 : _val$dfltOrderUOM6.shortdesc) : "-"), _defineProperty(_obj, "in_infusion_rate_volume_number", (_val$IVInfusRateVol = val === null || val === void 0 ? void 0 : val.IVInfusRateVol) !== null && _val$IVInfusRateVol !== void 0 ? _val$IVInfusRateVol : ""), _defineProperty(_obj, "in_infusion_rate_volume_type", val !== null && val !== void 0 && (_val$IVInfusRateVolUO = val.IVInfusRateVolUOM) !== null && _val$IVInfusRateVolUO !== void 0 && _val$IVInfusRateVolUO._id && val !== null && val !== void 0 && (_val$IVInfusRateVolUO2 = val.IVInfusRateVolUOM) !== null && _val$IVInfusRateVolUO2 !== void 0 && _val$IVInfusRateVolUO2.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$IVInfusRateVolUO3 = val.IVInfusRateVolUOM) === null || _val$IVInfusRateVolUO3 === void 0 ? void 0 : _val$IVInfusRateVolUO3._id,
          label: val === null || val === void 0 ? void 0 : (_val$IVInfusRateVolUO4 = val.IVInfusRateVolUOM) === null || _val$IVInfusRateVolUO4 === void 0 ? void 0 : _val$IVInfusRateVolUO4.shortdesc
        } : {}), _defineProperty(_obj, "in_infusion_rate_duration_number", (_val$IVDosDurValue = val === null || val === void 0 ? void 0 : val.IVDosDurValue) !== null && _val$IVDosDurValue !== void 0 ? _val$IVDosDurValue : ""), _defineProperty(_obj, "in_infusion_rate_duration_type", val !== null && val !== void 0 && (_val$IVDosDurUOM = val.IVDosDurUOM) !== null && _val$IVDosDurUOM !== void 0 && _val$IVDosDurUOM._id && val !== null && val !== void 0 && (_val$IVDosDurUOM2 = val.IVDosDurUOM) !== null && _val$IVDosDurUOM2 !== void 0 && _val$IVDosDurUOM2.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$IVDosDurUOM3 = val.IVDosDurUOM) === null || _val$IVDosDurUOM3 === void 0 ? void 0 : _val$IVDosDurUOM3._id,
          label: val === null || val === void 0 ? void 0 : (_val$IVDosDurUOM4 = val.IVDosDurUOM) === null || _val$IVDosDurUOM4 === void 0 ? void 0 : _val$IVDosDurUOM4.shortdesc
        } : {}), _defineProperty(_obj, "iv_dosage_duration_number", (_val$IVDosDurValue2 = val === null || val === void 0 ? void 0 : val.IVDosDurValue) !== null && _val$IVDosDurValue2 !== void 0 ? _val$IVDosDurValue2 : ""), _defineProperty(_obj, "iv_dosage_duration_type", val !== null && val !== void 0 && (_val$IVDosDurUOM5 = val.IVDosDurUOM) !== null && _val$IVDosDurUOM5 !== void 0 && _val$IVDosDurUOM5._id && val !== null && val !== void 0 && (_val$IVDosDurUOM6 = val.IVDosDurUOM) !== null && _val$IVDosDurUOM6 !== void 0 && _val$IVDosDurUOM6.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$IVDosDurUOM7 = val.IVDosDurUOM) === null || _val$IVDosDurUOM7 === void 0 ? void 0 : _val$IVDosDurUOM7._id,
          label: val === null || val === void 0 ? void 0 : (_val$IVDosDurUOM8 = val.IVDosDurUOM) === null || _val$IVDosDurUOM8 === void 0 ? void 0 : _val$IVDosDurUOM8.shortdesc
        } : {}), _defineProperty(_obj, "dosage_freq_code", val !== null && val !== void 0 && (_val$dosageFreqCode = val.dosageFreqCode) !== null && _val$dosageFreqCode !== void 0 && _val$dosageFreqCode._id && val !== null && val !== void 0 && (_val$dosageFreqCode2 = val.dosageFreqCode) !== null && _val$dosageFreqCode2 !== void 0 && _val$dosageFreqCode2.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$dosageFreqCode3 = val.dosageFreqCode) === null || _val$dosageFreqCode3 === void 0 ? void 0 : _val$dosageFreqCode3._id,
          label: val === null || val === void 0 ? void 0 : (_val$dosageFreqCode4 = val.dosageFreqCode) === null || _val$dosageFreqCode4 === void 0 ? void 0 : _val$dosageFreqCode4.shortdesc
        } : {}), _defineProperty(_obj, "startDay", (_val$startDay = val === null || val === void 0 ? void 0 : val.startDay) !== null && _val$startDay !== void 0 ? _val$startDay : ""), _defineProperty(_obj, "duration_number", (_val$dfltDuration = val === null || val === void 0 ? void 0 : val.dfltDuration) !== null && _val$dfltDuration !== void 0 ? _val$dfltDuration : ""), _defineProperty(_obj, "duration_type", val !== null && val !== void 0 && (_val$dfltDurUOM = val.dfltDurUOM) !== null && _val$dfltDurUOM !== void 0 && _val$dfltDurUOM._id && val !== null && val !== void 0 && (_val$dfltDurUOM2 = val.dfltDurUOM) !== null && _val$dfltDurUOM2 !== void 0 && _val$dfltDurUOM2.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$dfltDurUOM3 = val.dfltDurUOM) === null || _val$dfltDurUOM3 === void 0 ? void 0 : _val$dfltDurUOM3._id,
          label: val === null || val === void 0 ? void 0 : (_val$dfltDurUOM4 = val.dfltDurUOM) === null || _val$dfltDurUOM4 === void 0 ? void 0 : _val$dfltDurUOM4.shortdesc
        } : {}), _defineProperty(_obj, "durationT", val !== null && val !== void 0 && val.dfltDuration && val !== null && val !== void 0 && (_val$dfltDurUOM5 = val.dfltDurUOM) !== null && _val$dfltDurUOM5 !== void 0 && _val$dfltDurUOM5.shortdesc ? (val === null || val === void 0 ? void 0 : val.dfltDuration) + " " + (val === null || val === void 0 ? void 0 : (_val$dfltDurUOM6 = val.dfltDurUOM) === null || _val$dfltDurUOM6 === void 0 ? void 0 : _val$dfltDurUOM6.shortdesc) : "-"), _defineProperty(_obj, "route", val !== null && val !== void 0 && (_val$route = val.route) !== null && _val$route !== void 0 && _val$route._id && val !== null && val !== void 0 && (_val$route2 = val.route) !== null && _val$route2 !== void 0 && _val$route2.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$route3 = val.route) === null || _val$route3 === void 0 ? void 0 : _val$route3._id,
          label: val === null || val === void 0 ? void 0 : (_val$route4 = val.route) === null || _val$route4 === void 0 ? void 0 : _val$route4.shortdesc
        } : {}), _defineProperty(_obj, "routeT", (_val$route$shortdesc = val === null || val === void 0 ? void 0 : (_val$route5 = val.route) === null || _val$route5 === void 0 ? void 0 : _val$route5.shortdesc) !== null && _val$route$shortdesc !== void 0 ? _val$route$shortdesc : "-"), _defineProperty(_obj, "frequency_number", (_val$dfltFreqVal = val === null || val === void 0 ? void 0 : val.dfltFreqVal) !== null && _val$dfltFreqVal !== void 0 ? _val$dfltFreqVal : 0), _defineProperty(_obj, "frequency_type", val !== null && val !== void 0 && (_val$dfltFreqValUnit = val.dfltFreqValUnit) !== null && _val$dfltFreqValUnit !== void 0 && _val$dfltFreqValUnit._id && val !== null && val !== void 0 && (_val$dfltFreqValUnit2 = val.dfltFreqValUnit) !== null && _val$dfltFreqValUnit2 !== void 0 && _val$dfltFreqValUnit2.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$dfltFreqValUnit3 = val.dfltFreqValUnit) === null || _val$dfltFreqValUnit3 === void 0 ? void 0 : _val$dfltFreqValUnit3._id,
          label: val === null || val === void 0 ? void 0 : (_val$dfltFreqValUnit4 = val.dfltFreqValUnit) === null || _val$dfltFreqValUnit4 === void 0 ? void 0 : _val$dfltFreqValUnit4.shortdesc
        } : {}), _defineProperty(_obj, "frequencyT", val !== null && val !== void 0 && val.dfltFreqVal && val !== null && val !== void 0 && (_val$dfltFreqValUnit5 = val.dfltFreqValUnit) !== null && _val$dfltFreqValUnit5 !== void 0 && _val$dfltFreqValUnit5.shortdesc ? (val === null || val === void 0 ? void 0 : val.dfltFreqVal) + " " + (val === null || val === void 0 ? void 0 : (_val$dfltFreqValUnit6 = val.dfltFreqValUnit) === null || _val$dfltFreqValUnit6 === void 0 ? void 0 : _val$dfltFreqValUnit6.shortdesc) : "-"), _defineProperty(_obj, "rate_number", (_val$dfltFreqRate = val === null || val === void 0 ? void 0 : val.dfltFreqRate) !== null && _val$dfltFreqRate !== void 0 ? _val$dfltFreqRate : ""), _defineProperty(_obj, "rate_type", val !== null && val !== void 0 && (_val$dfltFreqRateUnit = val.dfltFreqRateUnit) !== null && _val$dfltFreqRateUnit !== void 0 && _val$dfltFreqRateUnit._id && val !== null && val !== void 0 && (_val$dfltFreqRateUnit2 = val.dfltFreqRateUnit) !== null && _val$dfltFreqRateUnit2 !== void 0 && _val$dfltFreqRateUnit2.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$dfltFreqRateUnit3 = val.dfltFreqRateUnit) === null || _val$dfltFreqRateUnit3 === void 0 ? void 0 : _val$dfltFreqRateUnit3._id,
          label: val === null || val === void 0 ? void 0 : (_val$dfltFreqRateUnit4 = val.dfltFreqRateUnit) === null || _val$dfltFreqRateUnit4 === void 0 ? void 0 : _val$dfltFreqRateUnit4.shortdesc
        } : {}), _defineProperty(_obj, "rateT", val !== null && val !== void 0 && val.dfltFreqRate && val !== null && val !== void 0 && (_val$dfltFreqRateUnit5 = val.dfltFreqRateUnit) !== null && _val$dfltFreqRateUnit5 !== void 0 && _val$dfltFreqRateUnit5.shortdesc ? (val === null || val === void 0 ? void 0 : val.dfltFreqRate) + " " + (val === null || val === void 0 ? void 0 : (_val$dfltFreqRateUnit6 = val.dfltFreqRateUnit) === null || _val$dfltFreqRateUnit6 === void 0 ? void 0 : _val$dfltFreqRateUnit6.shortdesc) : "-"), _defineProperty(_obj, "additive", (_val$additive = val === null || val === void 0 ? void 0 : val.additive) !== null && _val$additive !== void 0 ? _val$additive : false), _defineProperty(_obj, "additivT", val !== null && val !== void 0 && val.additive ? (val === null || val === void 0 ? void 0 : val.additive) === true ? "Yes" : "No" : "No"), _defineProperty(_obj, "parentSequence", (_val$parentSequence = val === null || val === void 0 ? void 0 : val.parentSequence) !== null && _val$parentSequence !== void 0 ? _val$parentSequence : ""), _defineProperty(_obj, "parentSequenceT", (_val$parentSequence2 = val === null || val === void 0 ? void 0 : val.parentSequence) !== null && _val$parentSequence2 !== void 0 ? _val$parentSequence2 : "-"), _defineProperty(_obj, "explanatoryNote", (_val$explNote = val === null || val === void 0 ? void 0 : val.explNote) !== null && _val$explNote !== void 0 ? _val$explNote : ""), _defineProperty(_obj, "practitionerInstructions", (_val$practInstr = val === null || val === void 0 ? void 0 : val.practInstr) !== null && _val$practInstr !== void 0 ? _val$practInstr : ""), _defineProperty(_obj, "children", (_constructChildrenTab = constructChildrenTabelData(data, val === null || val === void 0 ? void 0 : val.seqNo)) !== null && _constructChildrenTab !== void 0 ? _constructChildrenTab : []), _obj);
        arr.push(obj);
      }
    });
  }

  return arr;
};

var constructChildrenTabelData = function constructChildrenTabelData(data, parentCatSeqNo) {
  var arr_ = [];

  if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
    data === null || data === void 0 ? void 0 : data.map(function (val) {
      if ((val === null || val === void 0 ? void 0 : val.parentCatSeqNo) === parentCatSeqNo) {
        var _val$id2, _val$_key2, _val$ordercategory$_i2, _val$seqNo2, _val$ordercategory6, _val$ordercategory7, _val$ordercategory8, _val$ordercategory9, _val$ordercategory10, _val$ordertype5, _val$ordertype6, _val$ordertype7, _val$ordertype8, _val$orderCatalog9, _val$orderCatalog10, _val$orderCatalog11, _val$orderCatalog12, _val$orderCatalog13, _val$orderCatalog14, _val$orderCatalog15, _val$orderCatalog16, _val$dfltOrderUOM7, _val$dfltOrderUOM8, _val$dfltOrderUOM9, _val$dfltOrderUOM10, _val$dfltOrderUOM11, _val$dfltOrderUOM12, _val$IVInfusRateVol2, _val$IVInfusRateVolUO5, _val$IVInfusRateVolUO6, _val$IVInfusRateVolUO7, _val$IVInfusRateVolUO8, _val$IVDosDurValue3, _val$IVDosDurUOM9, _val$IVDosDurUOM10, _val$IVDosDurUOM11, _val$IVDosDurUOM12, _val$IVDosDurValue4, _val$IVDosDurUOM13, _val$IVDosDurUOM14, _val$IVDosDurUOM15, _val$IVDosDurUOM16, _val$dosageFreqCode5, _val$dosageFreqCode6, _val$dosageFreqCode7, _val$dosageFreqCode8, _val$startDay2, _val$dfltDuration2, _val$dfltDurUOM7, _val$dfltDurUOM8, _val$dfltDurUOM9, _val$dfltDurUOM10, _val$dfltDurUOM11, _val$dfltDurUOM12, _val$route6, _val$route7, _val$route8, _val$route9, _val$route$shortdesc2, _val$route10, _val$dfltFreqVal2, _val$dfltFreqValUnit7, _val$dfltFreqValUnit8, _val$dfltFreqValUnit9, _val$dfltFreqValUnit10, _val$dfltFreqValUnit11, _val$dfltFreqValUnit12, _val$dfltFreqRate2, _val$dfltFreqRateUnit7, _val$dfltFreqRateUnit8, _val$dfltFreqRateUnit9, _val$dfltFreqRateUnit10, _val$dfltFreqRateUnit11, _val$dfltFreqRateUnit12, _val$additive2, _val$parentCatSeqNo, _val$parentCatSeqNo2, _val$explNote2, _val$practInstr2, _obj_;

        var obj_ = (_obj_ = {
          id: (_val$id2 = val === null || val === void 0 ? void 0 : val.id) !== null && _val$id2 !== void 0 ? _val$id2 : 0,
          _key: (_val$_key2 = val === null || val === void 0 ? void 0 : val._key) !== null && _val$_key2 !== void 0 ? _val$_key2 : 0,
          typeId: (_val$ordercategory$_i2 = val === null || val === void 0 ? void 0 : val.ordercategory._id) !== null && _val$ordercategory$_i2 !== void 0 ? _val$ordercategory$_i2 : "",
          seqNo: (_val$seqNo2 = val === null || val === void 0 ? void 0 : val.seqNo) !== null && _val$seqNo2 !== void 0 ? _val$seqNo2 : "",
          orderCategory: (_val$ordercategory6 = val === null || val === void 0 ? void 0 : val.ordercategory) !== null && _val$ordercategory6 !== void 0 ? _val$ordercategory6 : {}
        }, _defineProperty(_obj_, "orderCategory", val !== null && val !== void 0 && (_val$ordercategory7 = val.ordercategory) !== null && _val$ordercategory7 !== void 0 && _val$ordercategory7._id && val !== null && val !== void 0 && (_val$ordercategory8 = val.ordercategory) !== null && _val$ordercategory8 !== void 0 && _val$ordercategory8.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$ordercategory9 = val.ordercategory) === null || _val$ordercategory9 === void 0 ? void 0 : _val$ordercategory9._id,
          label: val === null || val === void 0 ? void 0 : (_val$ordercategory10 = val.ordercategory) === null || _val$ordercategory10 === void 0 ? void 0 : _val$ordercategory10.shortdesc
        } : {}), _defineProperty(_obj_, "orderTypeDrugType", val !== null && val !== void 0 && (_val$ordertype5 = val.ordertype) !== null && _val$ordertype5 !== void 0 && _val$ordertype5._id && val !== null && val !== void 0 && (_val$ordertype6 = val.ordertype) !== null && _val$ordertype6 !== void 0 && _val$ordertype6.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$ordertype7 = val.ordertype) === null || _val$ordertype7 === void 0 ? void 0 : _val$ordertype7._id,
          label: val === null || val === void 0 ? void 0 : (_val$ordertype8 = val.ordertype) === null || _val$ordertype8 === void 0 ? void 0 : _val$ordertype8.shortdesc
        } : {}), _defineProperty(_obj_, "orderCatalog", val !== null && val !== void 0 && (_val$orderCatalog9 = val.orderCatalog) !== null && _val$orderCatalog9 !== void 0 && _val$orderCatalog9._id && val !== null && val !== void 0 && (_val$orderCatalog10 = val.orderCatalog) !== null && _val$orderCatalog10 !== void 0 && _val$orderCatalog10.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$orderCatalog11 = val.orderCatalog) === null || _val$orderCatalog11 === void 0 ? void 0 : _val$orderCatalog11._id,
          label: val === null || val === void 0 ? void 0 : (_val$orderCatalog12 = val.orderCatalog) === null || _val$orderCatalog12 === void 0 ? void 0 : _val$orderCatalog12.shortdesc
        } : val !== null && val !== void 0 && (_val$orderCatalog13 = val.orderCatalog) !== null && _val$orderCatalog13 !== void 0 && _val$orderCatalog13._id && val !== null && val !== void 0 && (_val$orderCatalog14 = val.orderCatalog) !== null && _val$orderCatalog14 !== void 0 && _val$orderCatalog14.ShortDesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$orderCatalog15 = val.orderCatalog) === null || _val$orderCatalog15 === void 0 ? void 0 : _val$orderCatalog15._id,
          label: val === null || val === void 0 ? void 0 : (_val$orderCatalog16 = val.orderCatalog) === null || _val$orderCatalog16 === void 0 ? void 0 : _val$orderCatalog16.ShortDesc
        } : {}), _defineProperty(_obj_, "required", val !== null && val !== void 0 && val.required ? val === null || val === void 0 ? void 0 : val.required : false), _defineProperty(_obj_, "requiredT", val !== null && val !== void 0 && val.required ? (val === null || val === void 0 ? void 0 : val.required) === true ? "Yes" : "No" : "No"), _defineProperty(_obj_, "quantity_number", val !== null && val !== void 0 && val.dfltOrderQty ? val === null || val === void 0 ? void 0 : val.dfltOrderQty : ""), _defineProperty(_obj_, "quantity_type", val !== null && val !== void 0 && (_val$dfltOrderUOM7 = val.dfltOrderUOM) !== null && _val$dfltOrderUOM7 !== void 0 && _val$dfltOrderUOM7._id && val !== null && val !== void 0 && (_val$dfltOrderUOM8 = val.dfltOrderUOM) !== null && _val$dfltOrderUOM8 !== void 0 && _val$dfltOrderUOM8.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$dfltOrderUOM9 = val.dfltOrderUOM) === null || _val$dfltOrderUOM9 === void 0 ? void 0 : _val$dfltOrderUOM9._id,
          label: val === null || val === void 0 ? void 0 : (_val$dfltOrderUOM10 = val.dfltOrderUOM) === null || _val$dfltOrderUOM10 === void 0 ? void 0 : _val$dfltOrderUOM10.shortdesc
        } : {}), _defineProperty(_obj_, "quantityT", val !== null && val !== void 0 && (_val$dfltOrderUOM11 = val.dfltOrderUOM) !== null && _val$dfltOrderUOM11 !== void 0 && _val$dfltOrderUOM11.shortdesc && val !== null && val !== void 0 && val.dfltOrderQty ? (val === null || val === void 0 ? void 0 : val.dfltOrderQty) + " " + (val === null || val === void 0 ? void 0 : (_val$dfltOrderUOM12 = val.dfltOrderUOM) === null || _val$dfltOrderUOM12 === void 0 ? void 0 : _val$dfltOrderUOM12.shortdesc) : "-"), _defineProperty(_obj_, "in_infusion_rate_volume_number", (_val$IVInfusRateVol2 = val === null || val === void 0 ? void 0 : val.IVInfusRateVol) !== null && _val$IVInfusRateVol2 !== void 0 ? _val$IVInfusRateVol2 : ""), _defineProperty(_obj_, "in_infusion_rate_volume_type", val !== null && val !== void 0 && (_val$IVInfusRateVolUO5 = val.IVInfusRateVolUOM) !== null && _val$IVInfusRateVolUO5 !== void 0 && _val$IVInfusRateVolUO5._id && val !== null && val !== void 0 && (_val$IVInfusRateVolUO6 = val.IVInfusRateVolUOM) !== null && _val$IVInfusRateVolUO6 !== void 0 && _val$IVInfusRateVolUO6.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$IVInfusRateVolUO7 = val.IVInfusRateVolUOM) === null || _val$IVInfusRateVolUO7 === void 0 ? void 0 : _val$IVInfusRateVolUO7._id,
          label: val === null || val === void 0 ? void 0 : (_val$IVInfusRateVolUO8 = val.IVInfusRateVolUOM) === null || _val$IVInfusRateVolUO8 === void 0 ? void 0 : _val$IVInfusRateVolUO8.shortdesc
        } : {}), _defineProperty(_obj_, "in_infusion_rate_duration_number", (_val$IVDosDurValue3 = val === null || val === void 0 ? void 0 : val.IVDosDurValue) !== null && _val$IVDosDurValue3 !== void 0 ? _val$IVDosDurValue3 : ""), _defineProperty(_obj_, "in_infusion_rate_duration_type", val !== null && val !== void 0 && (_val$IVDosDurUOM9 = val.IVDosDurUOM) !== null && _val$IVDosDurUOM9 !== void 0 && _val$IVDosDurUOM9._id && val !== null && val !== void 0 && (_val$IVDosDurUOM10 = val.IVDosDurUOM) !== null && _val$IVDosDurUOM10 !== void 0 && _val$IVDosDurUOM10.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$IVDosDurUOM11 = val.IVDosDurUOM) === null || _val$IVDosDurUOM11 === void 0 ? void 0 : _val$IVDosDurUOM11._id,
          label: val === null || val === void 0 ? void 0 : (_val$IVDosDurUOM12 = val.IVDosDurUOM) === null || _val$IVDosDurUOM12 === void 0 ? void 0 : _val$IVDosDurUOM12.shortdesc
        } : {}), _defineProperty(_obj_, "iv_dosage_duration_number", (_val$IVDosDurValue4 = val === null || val === void 0 ? void 0 : val.IVDosDurValue) !== null && _val$IVDosDurValue4 !== void 0 ? _val$IVDosDurValue4 : ""), _defineProperty(_obj_, "iv_dosage_duration_type", val !== null && val !== void 0 && (_val$IVDosDurUOM13 = val.IVDosDurUOM) !== null && _val$IVDosDurUOM13 !== void 0 && _val$IVDosDurUOM13._id && val !== null && val !== void 0 && (_val$IVDosDurUOM14 = val.IVDosDurUOM) !== null && _val$IVDosDurUOM14 !== void 0 && _val$IVDosDurUOM14.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$IVDosDurUOM15 = val.IVDosDurUOM) === null || _val$IVDosDurUOM15 === void 0 ? void 0 : _val$IVDosDurUOM15._id,
          label: val === null || val === void 0 ? void 0 : (_val$IVDosDurUOM16 = val.IVDosDurUOM) === null || _val$IVDosDurUOM16 === void 0 ? void 0 : _val$IVDosDurUOM16.shortdesc
        } : {}), _defineProperty(_obj_, "dosage_freq_code", val !== null && val !== void 0 && (_val$dosageFreqCode5 = val.dosageFreqCode) !== null && _val$dosageFreqCode5 !== void 0 && _val$dosageFreqCode5._id && val !== null && val !== void 0 && (_val$dosageFreqCode6 = val.dosageFreqCode) !== null && _val$dosageFreqCode6 !== void 0 && _val$dosageFreqCode6.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$dosageFreqCode7 = val.dosageFreqCode) === null || _val$dosageFreqCode7 === void 0 ? void 0 : _val$dosageFreqCode7._id,
          label: val === null || val === void 0 ? void 0 : (_val$dosageFreqCode8 = val.dosageFreqCode) === null || _val$dosageFreqCode8 === void 0 ? void 0 : _val$dosageFreqCode8.shortdesc
        } : {}), _defineProperty(_obj_, "startDay", (_val$startDay2 = val === null || val === void 0 ? void 0 : val.startDay) !== null && _val$startDay2 !== void 0 ? _val$startDay2 : ""), _defineProperty(_obj_, "duration_number", (_val$dfltDuration2 = val === null || val === void 0 ? void 0 : val.dfltDuration) !== null && _val$dfltDuration2 !== void 0 ? _val$dfltDuration2 : ""), _defineProperty(_obj_, "duration_type", val !== null && val !== void 0 && (_val$dfltDurUOM7 = val.dfltDurUOM) !== null && _val$dfltDurUOM7 !== void 0 && _val$dfltDurUOM7._id && val !== null && val !== void 0 && (_val$dfltDurUOM8 = val.dfltDurUOM) !== null && _val$dfltDurUOM8 !== void 0 && _val$dfltDurUOM8.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$dfltDurUOM9 = val.dfltDurUOM) === null || _val$dfltDurUOM9 === void 0 ? void 0 : _val$dfltDurUOM9._id,
          label: val === null || val === void 0 ? void 0 : (_val$dfltDurUOM10 = val.dfltDurUOM) === null || _val$dfltDurUOM10 === void 0 ? void 0 : _val$dfltDurUOM10.shortdesc
        } : {}), _defineProperty(_obj_, "durationT", val !== null && val !== void 0 && val.dfltDuration && val !== null && val !== void 0 && (_val$dfltDurUOM11 = val.dfltDurUOM) !== null && _val$dfltDurUOM11 !== void 0 && _val$dfltDurUOM11.shortdesc ? (val === null || val === void 0 ? void 0 : val.dfltDuration) + " " + (val === null || val === void 0 ? void 0 : (_val$dfltDurUOM12 = val.dfltDurUOM) === null || _val$dfltDurUOM12 === void 0 ? void 0 : _val$dfltDurUOM12.shortdesc) : "-"), _defineProperty(_obj_, "route", val !== null && val !== void 0 && (_val$route6 = val.route) !== null && _val$route6 !== void 0 && _val$route6._id && val !== null && val !== void 0 && (_val$route7 = val.route) !== null && _val$route7 !== void 0 && _val$route7.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$route8 = val.route) === null || _val$route8 === void 0 ? void 0 : _val$route8._id,
          label: val === null || val === void 0 ? void 0 : (_val$route9 = val.route) === null || _val$route9 === void 0 ? void 0 : _val$route9.shortdesc
        } : {}), _defineProperty(_obj_, "routeT", (_val$route$shortdesc2 = val === null || val === void 0 ? void 0 : (_val$route10 = val.route) === null || _val$route10 === void 0 ? void 0 : _val$route10.shortdesc) !== null && _val$route$shortdesc2 !== void 0 ? _val$route$shortdesc2 : "-"), _defineProperty(_obj_, "frequency_number", (_val$dfltFreqVal2 = val === null || val === void 0 ? void 0 : val.dfltFreqVal) !== null && _val$dfltFreqVal2 !== void 0 ? _val$dfltFreqVal2 : 0), _defineProperty(_obj_, "frequency_type", val !== null && val !== void 0 && (_val$dfltFreqValUnit7 = val.dfltFreqValUnit) !== null && _val$dfltFreqValUnit7 !== void 0 && _val$dfltFreqValUnit7._id && val !== null && val !== void 0 && (_val$dfltFreqValUnit8 = val.dfltFreqValUnit) !== null && _val$dfltFreqValUnit8 !== void 0 && _val$dfltFreqValUnit8.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$dfltFreqValUnit9 = val.dfltFreqValUnit) === null || _val$dfltFreqValUnit9 === void 0 ? void 0 : _val$dfltFreqValUnit9._id,
          label: val === null || val === void 0 ? void 0 : (_val$dfltFreqValUnit10 = val.dfltFreqValUnit) === null || _val$dfltFreqValUnit10 === void 0 ? void 0 : _val$dfltFreqValUnit10.shortdesc
        } : {}), _defineProperty(_obj_, "frequencyT", val !== null && val !== void 0 && val.dfltFreqVal && val !== null && val !== void 0 && (_val$dfltFreqValUnit11 = val.dfltFreqValUnit) !== null && _val$dfltFreqValUnit11 !== void 0 && _val$dfltFreqValUnit11.shortdesc ? (val === null || val === void 0 ? void 0 : val.dfltFreqVal) + " " + (val === null || val === void 0 ? void 0 : (_val$dfltFreqValUnit12 = val.dfltFreqValUnit) === null || _val$dfltFreqValUnit12 === void 0 ? void 0 : _val$dfltFreqValUnit12.shortdesc) : "-"), _defineProperty(_obj_, "rate_number", (_val$dfltFreqRate2 = val === null || val === void 0 ? void 0 : val.dfltFreqRate) !== null && _val$dfltFreqRate2 !== void 0 ? _val$dfltFreqRate2 : ""), _defineProperty(_obj_, "rate_type", val !== null && val !== void 0 && (_val$dfltFreqRateUnit7 = val.dfltFreqRateUnit) !== null && _val$dfltFreqRateUnit7 !== void 0 && _val$dfltFreqRateUnit7._id && val !== null && val !== void 0 && (_val$dfltFreqRateUnit8 = val.dfltFreqRateUnit) !== null && _val$dfltFreqRateUnit8 !== void 0 && _val$dfltFreqRateUnit8.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$dfltFreqRateUnit9 = val.dfltFreqRateUnit) === null || _val$dfltFreqRateUnit9 === void 0 ? void 0 : _val$dfltFreqRateUnit9._id,
          label: val === null || val === void 0 ? void 0 : (_val$dfltFreqRateUnit10 = val.dfltFreqRateUnit) === null || _val$dfltFreqRateUnit10 === void 0 ? void 0 : _val$dfltFreqRateUnit10.shortdesc
        } : {}), _defineProperty(_obj_, "rateT", val !== null && val !== void 0 && val.dfltFreqRate && val !== null && val !== void 0 && (_val$dfltFreqRateUnit11 = val.dfltFreqRateUnit) !== null && _val$dfltFreqRateUnit11 !== void 0 && _val$dfltFreqRateUnit11.shortdesc ? (val === null || val === void 0 ? void 0 : val.dfltFreqRate) + " " + (val === null || val === void 0 ? void 0 : (_val$dfltFreqRateUnit12 = val.dfltFreqRateUnit) === null || _val$dfltFreqRateUnit12 === void 0 ? void 0 : _val$dfltFreqRateUnit12.shortdesc) : "-"), _defineProperty(_obj_, "additive", (_val$additive2 = val === null || val === void 0 ? void 0 : val.additive) !== null && _val$additive2 !== void 0 ? _val$additive2 : false), _defineProperty(_obj_, "additivT", val !== null && val !== void 0 && val.additive ? (val === null || val === void 0 ? void 0 : val.additive) === true ? "Yes" : "No" : "No"), _defineProperty(_obj_, "parentSequence", (_val$parentCatSeqNo = val === null || val === void 0 ? void 0 : val.parentCatSeqNo) !== null && _val$parentCatSeqNo !== void 0 ? _val$parentCatSeqNo : ""), _defineProperty(_obj_, "parentSequenceT", (_val$parentCatSeqNo2 = val === null || val === void 0 ? void 0 : val.parentCatSeqNo) !== null && _val$parentCatSeqNo2 !== void 0 ? _val$parentCatSeqNo2 : "-"), _defineProperty(_obj_, "explanatoryNote", (_val$explNote2 = val === null || val === void 0 ? void 0 : val.explNote) !== null && _val$explNote2 !== void 0 ? _val$explNote2 : ""), _defineProperty(_obj_, "practitionerInstructions", (_val$practInstr2 = val === null || val === void 0 ? void 0 : val.practInstr) !== null && _val$practInstr2 !== void 0 ? _val$practInstr2 : ""), _obj_);
        arr_.push(obj_);
      }
    });
  }

  return arr_;
};

var _extraReducers$7;
var fileds$2 = ["orderCategory", //"orderDrugType",
//"orderDrugCatalog",
//"commonUOM",
"route", "drugFreqCode"];

var loopMasters$3 = function loopMasters() {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject) {
      var calls;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              calls = Object.keys(masterQuery$3).map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return fetchMaster$3(val, masterQuery$3[val]);

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
              es6Promise.Promise.all(calls).then(function (data) {
                var json = {};
                data.map(function (val) {
                  var arr = [];
                  val.data.map(function (value) {
                    if (fileds$2.includes(val.name)) {
                      //   if (value.coding[0] !== null) {
                      //     arr.push({
                      //       label: value.coding[0].display,
                      //       value: value.coding[0]._id,
                      //     });
                      //   }
                      arr.push({
                        label: value.shortdesc,
                        value: value._id
                      });
                    } else if ("commonUOM" === val.name) {
                      arr.push({
                        label: value.shortdesc,
                        value: value._id
                      });
                    } else if ("durationDropDown" === val.name) {
                      arr.push({
                        label: value.shortdesc,
                        value: value._id
                      });
                    }
                  });
                  json[val.name] = arr;
                  resolve(json);
                });
              })["catch"](function (err) {
                resolve([]);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var fetchMaster$3 = function fetchMaster(name, query) {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetchData({
                body: query
              }, __readDocumentUrl__);

            case 2:
              data = _context3.sent;
              resolve({
                data: data.result,
                name: name
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }());
}; //ORDER SET FULL READ


var GET_ORDER_SET_LIST = toolkit.createAsyncThunk("orderSetMasterApiSlice/order_set_master_lis", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var _ref5,
      rejectWithValue,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref5 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref5.rejectWithValue;
          _context4.prev = 2;
          _context4.next = 5;
          return fetchData({
            body: JSON.stringify(query$3.orderSetList())
          }, __readDocumentUrl__);

        case 5:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 9:
          _context4.prev = 9;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 12:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 9]]);
}))); //ORDER_SET_MASTER_STATUS_CHANGE

var ORDER_SET_MASTER_STATUS_CHANGE = toolkit.createAsyncThunk("orderSetMasterApiSlice/order_set_master_status_chang", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref7,
      rejectWithValue,
      statuschange,
      queriesjson,
      data,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref7 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref7.rejectWithValue;
          _context5.prev = 2;
          statuschange = {
            _key: payload._key,
            status: payload.status
          };
          queriesjson = query$3.status_update_order_set_master(statuschange);
          _context5.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 11]]);
}))); //ORDER_SET_MASTER_MASTER

var ORDER_SET_MASTER_MASTER = toolkit.createAsyncThunk("orderSetMasterApiSlice/order_set_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref9,
      rejectWithValue,
      data,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref9 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref9.rejectWithValue;
          _context6.prev = 2;
          payload.type;
          _context6.next = 6;
          return loopMasters$3();

        case 6:
          data = _context6.sent;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 10:
          _context6.prev = 10;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 13:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 10]]);
}))); //ORDER_CATEGORY_MASTER

var ORDER_CATEGORY_MASTER = toolkit.createAsyncThunk("orderSetMasterApiSlice/order_category_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var _ref11,
      rejectWithValue,
      data_arr,
      arry,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _ref11 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref11.rejectWithValue;
          _context7.prev = 2;
          _context7.next = 5;
          return fetchData({
            body: JSON.stringify(orderCategoty.orderCategory())
          }, __readDocumentUrl__);

        case 5:
          data_arr = _context7.sent;
          arry = [];
          _context7.next = 9;
          return data_arr.result.map(function (val) {
            arry.push({
              value: val._id,
              label: val.shortdesc
            });
          });

        case 9:
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 15:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 12]]);
}))); //ORDER__MASTER

var ORDER__MASTER = toolkit.createAsyncThunk("orderSetMasterApiSlice/order__master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref13,
      rejectWithValue,
      order_category,
      data_arr,
      arry,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref13 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref13.rejectWithValue;
          _context8.prev = 2;
          order_category = payload.order_category;
          _context8.next = 6;
          return fetchData({
            body: JSON.stringify(dynamicMaster$1.orderDrugType(order_category))
          }, __readDocumentUrl__);

        case 6:
          data_arr = _context8.sent;
          arry = [];
          _context8.next = 10;
          return data_arr.result.map(function (val) {
            arry.push({
              value: val._id,
              label: val.shortdesc
            });
          });

        case 10:
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context8.prev = 13;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 16:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 13]]);
}))); //DRUG__MASTER

var DRUG__MASTER = toolkit.createAsyncThunk("orderSetMasterApiSlice/drug__master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref15,
      rejectWithValue,
      data_arr,
      arry,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref15 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref15.rejectWithValue;
          _context9.prev = 2;

          _objectDestructuringEmpty(payload);

          _context9.next = 6;
          return fetchData({
            body: JSON.stringify(dynamicMaster$1.drugType())
          }, __readDocumentUrl__);

        case 6:
          data_arr = _context9.sent;
          arry = [];
          _context9.next = 10;
          return data_arr.result.map(function (val) {
            arry.push({
              value: val._id,
              label: val.shortdesc
            });
          });

        case 10:
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 16:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 13]]);
}))); //ORDER__CATALOG_MASTER

var ORDER__CATALOG_MASTER = toolkit.createAsyncThunk("orderSetMasterApiSlice/order__catalog_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref17,
      rejectWithValue,
      order_category,
      order_drug_type,
      data_arr,
      arry,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref17 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref17.rejectWithValue;
          _context10.prev = 2;
          order_category = payload.order_category, order_drug_type = payload.order_drug_type;
          _context10.next = 6;
          return fetchData({
            body: JSON.stringify(dynamicMaster$1.orderCatalog(order_category, order_drug_type))
          }, __readDocumentUrl__);

        case 6:
          data_arr = _context10.sent;
          arry = [];
          _context10.next = 10;
          return data_arr.result.map(function (val) {
            arry.push({
              value: val._id,
              label: val.shortdesc,
              freqApplicable: val !== null && val !== void 0 && val.OrderCatalogByEncounterTypeAge ? constOrderCatalogByEncounterTypeAge(val === null || val === void 0 ? void 0 : val.OrderCatalogByEncounterTypeAge) : false
            });
          });

        case 10:
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 16:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 13]]);
}))); //DRUG__CATALOG_MASTER

var DRUG__CATALOG_MASTER = toolkit.createAsyncThunk("orderSetMasterApiSlice/drug__catalog_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var payload,
      _ref19,
      rejectWithValue,
      drug_type,
      data_arr,
      arry,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
          _ref19 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref19.rejectWithValue;
          _context11.prev = 2;
          drug_type = payload.drug_type;
          _context11.next = 6;
          return fetchData({
            body: JSON.stringify(dynamicMaster$1.drugCatalog(drug_type))
          }, __readDocumentUrl__);

        case 6:
          data_arr = _context11.sent;
          arry = [];
          _context11.next = 10;
          return data_arr.result.map(function (val) {
            arry.push({
              value: val === null || val === void 0 ? void 0 : val._id,
              label: val === null || val === void 0 ? void 0 : val.ShortDesc // freqApplicable: val?.OrderCatalogByEncounterTypeAge
              //   ? constOrderCatalogByEncounterTypeAge(
              //       val?.OrderCatalogByEncounterTypeAge
              //     )
              //   : false,

            });
          });

        case 10:
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context11.prev = 13;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 16:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 13]]);
})));

var constOrderCatalogByEncounterTypeAge = function constOrderCatalogByEncounterTypeAge(data) {
  var _iterator = _createForOfIteratorHelper(data === null || data === void 0 ? void 0 : data.values()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var val = _step.value;
      return val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}; //UPSERT_ORDER_SET


var UPSERT_ORDER_SET = toolkit.createAsyncThunk("orderSetMasterApiSlice/order_set_upsertS", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var payload,
      _ref21,
      rejectWithValue,
      dataList,
      queriesjson,
      data,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
          _ref21 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref21.rejectWithValue;
          _context12.prev = 2;
          dataList = payload.dataList;
          queriesjson = generateJson$3(dataList);
          _context12.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context12.sent;
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context12.prev = 11;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 14:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 11]]);
}))); //ORDER_SET_SINGLE_READ

var ORDER_SET_SINGLE_READ = toolkit.createAsyncThunk("orderSetMasterApiSlice/order_set_single_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
  var payload,
      _ref23,
      rejectWithValue,
      _key,
      data,
      readJSON,
      _args13 = arguments;

  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          payload = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {};
          _ref23 = _args13.length > 1 ? _args13[1] : undefined, rejectWithValue = _ref23.rejectWithValue, _ref23.getState;
          _context13.prev = 2;
          _key = payload._key;
          _context13.next = 6;
          return fetchData({
            body: JSON.stringify(query$3.orderSetListById(_key))
          }, __readDocumentUrl__);

        case 6:
          data = _context13.sent;
          readJSON = generateReadJSON$2(data.result[0] ? data.result[0] : null);
          return _context13.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: readJSON
          }));

        case 11:
          _context13.prev = 11;
          _context13.t0 = _context13["catch"](2);
          alert(_context13.t0.message);
          return _context13.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context13.t0.message
          })));

        case 15:
        case "end":
          return _context13.stop();
      }
    }
  }, _callee13, null, [[2, 11]]);
}))); //DELETE_ORDER_SET_COMPONENT

var DELETE_ORDER_SET_COMPONENT = toolkit.createAsyncThunk("orderSetMasterApiSlice/order_set_component_delete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
  var payload,
      _ref25,
      rejectWithValue,
      _key,
      data,
      _args14 = arguments;

  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          payload = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : {};
          _ref25 = _args14.length > 1 ? _args14[1] : undefined, rejectWithValue = _ref25.rejectWithValue;
          _context14.prev = 2;
          _key = payload._key;
          _context14.next = 6;
          return fetchData({
            body: JSON.stringify(query$3.orderSetComponentDelete(_key))
          }, __softDelete__);

        case 6:
          data = _context14.sent;
          return _context14.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context14.prev = 10;
          _context14.t0 = _context14["catch"](2);
          return _context14.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context14.t0.message
          })));

        case 13:
        case "end":
          return _context14.stop();
      }
    }
  }, _callee14, null, [[2, 10]]);
})));
var orderSetMasterSlice = toolkit.createSlice({
  name: "orderSetMasterApiSlice",
  initialState: {
    order_set_master_list: _objectSpread2({}, defaultState.List),
    order_set_single_read: _objectSpread2({}, defaultState.List),
    order_set_master_status_change: _objectSpread2({}, defaultState.List),
    order_set_masters: _objectSpread2({}, defaultState.List),
    order__masters: _objectSpread2({}, defaultState.List),
    drug__masters: _objectSpread2({}, defaultState.List),
    order__catalog_masters: _objectSpread2({}, defaultState.List),
    drug__catalog_masters: _objectSpread2({}, defaultState.List),
    order_category_masters: _objectSpread2({}, defaultState.List),
    order_set_upsert: _objectSpread2({}, defaultState.List),
    order_set_component_delete: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$7 = {}, _defineProperty(_extraReducers$7, DELETE_ORDER_SET_COMPONENT.fulfilled, function (state, action) {
    state.order_set_component_delete.loading = false, state.order_set_component_delete.error = false, state.order_set_component_delete = action.payload;
  }), _defineProperty(_extraReducers$7, DELETE_ORDER_SET_COMPONENT.pending, function (state, action) {
    state.order_set_component_delete.loading = true, state.order_set_component_delete.error = false, state.order_set_component_delete.loading = true;
  }), _defineProperty(_extraReducers$7, DELETE_ORDER_SET_COMPONENT.rejected, function (state, action) {
    state.order_set_component_delete.loading = false, state.order_set_component_delete.error = true, state.order_set_component_delete = action.payload;
  }), _defineProperty(_extraReducers$7, GET_ORDER_SET_LIST.fulfilled, function (state, action) {
    state.order_set_master_list.loading = false, state.order_set_master_list.error = false, state.order_set_master_list = action.payload;
  }), _defineProperty(_extraReducers$7, GET_ORDER_SET_LIST.pending, function (state, action) {
    state.order_set_master_list.loading = true, state.order_set_master_list.error = false, state.order_set_master_list.loading = true;
  }), _defineProperty(_extraReducers$7, GET_ORDER_SET_LIST.rejected, function (state, action) {
    state.order_set_master_list.loading = false, state.order_set_master_list.error = true, state.order_set_master_list = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER_SET_SINGLE_READ.fulfilled, function (state, action) {
    state.order_set_single_read.loading = false, state.order_set_single_read.error = false, state.order_set_single_read = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER_SET_SINGLE_READ.pending, function (state, action) {
    state.order_set_single_read.loading = true, state.order_set_single_read.error = false, state.order_set_single_read.loading = true;
  }), _defineProperty(_extraReducers$7, ORDER_SET_SINGLE_READ.rejected, function (state, action) {
    state.order_set_single_read.loading = false, state.order_set_single_read.error = true, state.order_set_single_read = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER_SET_MASTER_STATUS_CHANGE.fulfilled, function (state, action) {
    state.order_set_master_status_change.loading = false, state.order_set_master_status_change.error = false, state.order_set_master_status_change = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER_SET_MASTER_STATUS_CHANGE.pending, function (state, action) {
    state.order_set_master_status_change.loading = true, state.order_set_master_status_change.error = false, state.order_set_master_status_change.loading = true;
  }), _defineProperty(_extraReducers$7, ORDER_SET_MASTER_STATUS_CHANGE.rejected, function (state, action) {
    state.order_set_master_status_change.loading = false, state.order_set_master_status_change.error = true, state.order_set_master_status_change = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER_SET_MASTER_MASTER.fulfilled, function (state, action) {
    state.order_set_masters.loading = false, state.order_set_masters.error = false, state.order_set_masters = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER_SET_MASTER_MASTER.pending, function (state, action) {
    state.order_set_masters.loading = true, state.order_set_masters.error = false, state.order_set_masters.loading = true;
  }), _defineProperty(_extraReducers$7, ORDER_SET_MASTER_MASTER.rejected, function (state, action) {
    state.order_set_masters.loading = false, state.order_set_masters.error = true, state.order_set_masters = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER__MASTER.fulfilled, function (state, action) {
    state.order__masters.loading = false, state.order__masters.error = false, state.order__masters = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER__MASTER.pending, function (state, action) {
    state.order__masters.loading = true, state.order__masters.error = false, state.order__masters.loading = true;
  }), _defineProperty(_extraReducers$7, ORDER__MASTER.rejected, function (state, action) {
    state.order__masters.loading = false, state.order__masters.error = true, state.order__masters = action.payload;
  }), _defineProperty(_extraReducers$7, DRUG__MASTER.fulfilled, function (state, action) {
    state.drug__masters.loading = false, state.drug__masters.error = false, state.drug__masters = action.payload;
  }), _defineProperty(_extraReducers$7, DRUG__MASTER.pending, function (state, action) {
    state.drug__masters.loading = true, state.drug__masters.error = false, state.drug__masters.loading = true;
  }), _defineProperty(_extraReducers$7, DRUG__MASTER.rejected, function (state, action) {
    state.drug__masters.loading = false, state.drug__masters.error = true, state.drug__masters = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER__CATALOG_MASTER.fulfilled, function (state, action) {
    state.order__catalog_masters.loading = false, state.order__catalog_masters.error = false, state.order__catalog_masters = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER__CATALOG_MASTER.pending, function (state, action) {
    state.order__catalog_masters.loading = true, state.order__catalog_masters.error = false, state.order__catalog_masters.loading = true;
  }), _defineProperty(_extraReducers$7, ORDER__CATALOG_MASTER.rejected, function (state, action) {
    state.order__catalog_masters.loading = false, state.order__catalog_masters.error = true, state.order__catalog_masters = action.payload;
  }), _defineProperty(_extraReducers$7, DRUG__CATALOG_MASTER.fulfilled, function (state, action) {
    state.drug__catalog_masters.loading = false, state.drug__catalog_masters.error = false, state.drug__catalog_masters = action.payload;
  }), _defineProperty(_extraReducers$7, DRUG__CATALOG_MASTER.pending, function (state, action) {
    state.drug__catalog_masters.loading = true, state.drug__catalog_masters.error = false, state.drug__catalog_masters.loading = true;
  }), _defineProperty(_extraReducers$7, DRUG__CATALOG_MASTER.rejected, function (state, action) {
    state.drug__catalog_masters.loading = false, state.drug__catalog_masters.error = true, state.drug__catalog_masters = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER_CATEGORY_MASTER.fulfilled, function (state, action) {
    state.order_category_masters.loading = false, state.order_category_masters.error = false, state.order_category_masters = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER_CATEGORY_MASTER.pending, function (state, action) {
    state.order_category_masters.loading = true, state.order_category_masters.error = false, state.order_category_masters.loading = true;
  }), _defineProperty(_extraReducers$7, ORDER_CATEGORY_MASTER.rejected, function (state, action) {
    state.order_category_masters.loading = false, state.order_category_masters.error = true, state.order_category_masters = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER_CATEGORY_MASTER.fulfilled, function (state, action) {
    state.order_category_masters.loading = false, state.order_category_masters.error = false, state.order_category_masters = action.payload;
  }), _defineProperty(_extraReducers$7, ORDER_CATEGORY_MASTER.pending, function (state, action) {
    state.order_category_masters.loading = true, state.order_category_masters.error = false, state.order_category_masters.loading = true;
  }), _defineProperty(_extraReducers$7, ORDER_CATEGORY_MASTER.rejected, function (state, action) {
    state.order_category_masters.loading = false, state.order_category_masters.error = true, state.order_category_masters = action.payload;
  }), _defineProperty(_extraReducers$7, UPSERT_ORDER_SET.fulfilled, function (state, action) {
    state.order_set_upsert.loading = false, state.order_set_upsert.error = false, state.order_set_upsert = action.payload;
  }), _defineProperty(_extraReducers$7, UPSERT_ORDER_SET.pending, function (state, action) {
    state.order_set_upsert.loading = true, state.order_set_upsert.error = false, state.order_set_upsert.loading = true;
  }), _defineProperty(_extraReducers$7, UPSERT_ORDER_SET.rejected, function (state, action) {
    state.order_set_upsert.loading = false, state.order_set_upsert.error = true, state.order_set_upsert = action.payload;
  }), _extraReducers$7)
});
var orderSetMasterActions = {
  GET_ORDER_SET_LIST: GET_ORDER_SET_LIST,
  ORDER_SET_MASTER_STATUS_CHANGE: ORDER_SET_MASTER_STATUS_CHANGE,
  ORDER_SET_MASTER_MASTER: ORDER_SET_MASTER_MASTER,
  ORDER__MASTER: ORDER__MASTER,
  DRUG__MASTER: DRUG__MASTER,
  ORDER__CATALOG_MASTER: ORDER__CATALOG_MASTER,
  DRUG__CATALOG_MASTER: DRUG__CATALOG_MASTER,
  ORDER_CATEGORY_MASTER: ORDER_CATEGORY_MASTER,
  UPSERT_ORDER_SET: UPSERT_ORDER_SET,
  ORDER_SET_SINGLE_READ: ORDER_SET_SINGLE_READ,
  DELETE_ORDER_SET_COMPONENT: DELETE_ORDER_SET_COMPONENT
};
var orderSetMasterSlice$1 = orderSetMasterSlice.reducer;

var query$2 = {
  orderSetApplicabilityList: function orderSetApplicabilityList(_id) {
    return {
      db_name: "".concat(dbName),
      entity: "CA_OrderSet_Applicability",
      filter: "CA_OrderSet_Applicability.Ordersetcode=='".concat(_id, "' && CA_OrderSet_Applicability.activestatus==true"),
      return_fields: "merge(CA_OrderSet_Applicability,{Ordersetcode:merge(document(CA_OrderSet_Applicability.Ordersetcode),{components:document(document(CA_OrderSet_Applicability.Ordersetcode).components)}),diagnosisCode:document(CA_OrderSet_Applicability.diagnosisCode),practRoleId:merge(document(CA_OrderSet_Applicability.practRoleId),{name:document(document(CA_OrderSet_Applicability.practRoleId).name)}),practCode:document(CA_OrderSet_Applicability.practCode),specialty:document(CA_OrderSet_Applicability.specialty),locationCode:document(CA_OrderSet_Applicability.locationCode),locationType:document(CA_OrderSet_Applicability.locationType),organizationCode:document(CA_OrderSet_Applicability.organizationCode)},{diagGroup:document(CA_OrderSet_Applicability.diagGroup)})"
    };
  },
  orderSetApplicabilityById: function orderSetApplicabilityById(_key) {
    return {
      db_name: "".concat(dbName),
      entity: "CA_OrderSet_Applicability",
      filter: "CA_OrderSet_Applicability._key=='".concat(_key, "' && CA_OrderSet_Applicability.activestatus==true"),
      return_fields: "merge(CA_OrderSet_Applicability,{diagGroup:document(CA_OrderSet_Applicability.diagGroup),Ordersetcode:merge(document(CA_OrderSet_Applicability.Ordersetcode),{components:document(document(CA_OrderSet_Applicability.Ordersetcode).components)}),diagnosisCode:document(CA_OrderSet_Applicability.diagnosisCode),practRoleId:merge(document(CA_OrderSet_Applicability.practRoleId),{name:document(document(CA_OrderSet_Applicability.practRoleId).name)}),practCode:document(CA_OrderSet_Applicability.practCode),specialty:document(CA_OrderSet_Applicability.specialty),locationCode:document(CA_OrderSet_Applicability.locationCode),locationType:document(CA_OrderSet_Applicability.locationType),organizationCode:document(CA_OrderSet_Applicability.organizationCode)})"
    };
  },
  status_update_order_set_master: function status_update_order_set_master(data) {
    return [{
      db_name: "".concat(dbName),
      entity: "CA_OrderSet",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      filter: {
        _key: data === null || data === void 0 ? void 0 : data._key
      },
      doc: {
        status: data === null || data === void 0 ? void 0 : data.status
      }
    }];
  },
  orderSetApplicabilityDelete: function orderSetApplicabilityDelete(_key) {
    return {
      db_name: "".concat(dbName),
      entity: "CA_OrderSet_Applicability",
      filter: "CA_OrderSet_Applicability._key== '".concat(_key, "'")
    };
  }
};

var masterQuery$2 = {
  //name
  facilityName: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"Organization\",\n    \"filter\": \"lower(first(document(Organization.OrgType)[*].display)) == 'facility' && Organization.activestatus==true && Organization.active == true \",\n    \"return_fields\": \"{_id:Organization._id,_key:Organization._key,id:Organization.id,name:Organization.name,alias:Organization.alias}\",\n    \"sort\": \"Organization.name\"\n  }"),
  // coding[0]?.display
  speciality: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodeableConceptMaster\",\n    \"filter\": \"CodeableConceptMaster.Type=='SPECIALTY' && CodeableConceptMaster.status==true && CodeableConceptMaster.activestatus==true\",\n    \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\",\n    \"sort\": \"first(document(CodeableConceptMaster.coding)[*].display)\"\n  }"),
  // coding[0]?.display
  practitionerType: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodeableConceptMaster\",\n    \"filter\": \"CodeableConceptMaster.Type=='PRACTTYPE' && CodeableConceptMaster.activestatus==true\",\n    \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\",\n    \"sort\": \"first(document(CodeableConceptMaster.coding)[*].display)\"\n  }"),
  //array of string
  codeSet: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"Diagnosis\",\n    \"return_fields\": \"distinct Diagnosis.termcode\",\n    \"sort\": \"Diagnosis.termcode\"\n  }"),
  //coding[0]?.display
  locationType: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodeableConceptMaster\",\n    \"filter\": \"CodeableConceptMaster.Type=='LOCATIONTYPE' && (lower(first(document(CodeableConceptMaster.coding)[*].display)) =='ward' || lower(first(document(CodeableConceptMaster.coding)[*].display)) == 'clinic' ) && CodeableConceptMaster.status==true && CodeableConceptMaster.activestatus==true \",\n    \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\",\n    \"sort\": \"first(document(CodeableConceptMaster.coding)[*].display)\"\n  }")
};
var dynamicMaster = {
  orderSetAppPractitioner: function orderSetAppPractitioner(_id) {
    // return {
    //   db_name: `${dbName}`,
    //   entity: "Practitioner",
    //   filter: `Practitioner.practitioner_type=='${_id}' && Practitioner.activestatus==true && Practitioner.active == true`,
    //   return_fields:
    //     "merge (Practitioner,{name:(for hm in HumanNameMaster filter hm._id in Practitioner.name return merge(hm,{use:(for cod in CodeableConceptMaster filter cod._id== hm.use return document(cod.coding)),prefix:(for cod in CodeableConceptMaster filter cod._id == hm.prefix return document(cod.coding)),suffix:(for cod in CodeableConceptMaster filter cod._id == hm.suffix return document(cod.coding))}))})",
    // };
    return {
      "db_name": "".concat(dbName),
      "entity": "Practitioner",
      "filter": "document(document(Practitioner.practitioner_type).coding)[*]._id any=='".concat(_id, "' && Practitioner.activestatus==true && Practitioner.active == true"),
      "return_fields": "merge (Practitioner,{name:(for hm in HumanNameMaster filter hm._id in Practitioner.name return merge(hm,{use:(for cod in CodeableConceptMaster filter cod._id== hm.use return document(cod.coding)),prefix:(for cod in CodeableConceptMaster filter cod._id == hm.prefix return document(cod.coding)),suffix:(for cod in CodeableConceptMaster filter cod._id == hm.suffix return document(cod.coding))}))})"
    };
  },
  orderSetAppDiagnosisGroup: function orderSetAppDiagnosisGroup(_id) {
    return {
      db_name: "".concat(dbName),
      entity: "Diagnosis",
      filter: "Diagnosis.termcode=='".concat(_id, "' && Diagnosis.icdcode == Diagnosis.parenticdcode && Diagnosis.activestatus==true"),
      return_fields: "KEEP(Diagnosis,'_id','id','_key','icdcode', 'icdname', 'parenticdcode', 'levelnumber')",
      sort: "Diagnosis.icdname"
    };
  },
  orderSetAppDiagnosisCode: function orderSetAppDiagnosisCode(_id, search) {
    return {
      db_name: "".concat(dbName),
      entity: "Diagnosis",
      filter: "((Diagnosis.icdcode != Diagnosis.parenticdcode && like (Diagnosis.icdname,'%".concat(search, "%',true)) || Diagnosis.parenticdcode=='").concat(_id, "') && Diagnosis.activestatus==true"),
      return_fields: "KEEP(Diagnosis,'_id','id','_key','icdcode', 'icdname', 'parenticdcode', 'levelnumber')",
      sort: "Diagnosis.icdname"
    };
  },
  orderSetAppLocation: function orderSetAppLocation(_id) {
    // return {
    //   db_name: `${dbName}`,
    //   entity: "LocationMaster",
    //   filter: `LocationMaster.locationType=='${_id}' && LocationMaster.activestatus==true && LocationMaster.status=='Active'`,
    //   return_fields:
    //     "KEEP(LocationMaster,'id','_id','key','locationID','longdesc','shortdesc')",
    //   sort: "LocationMaster.shortdesc",
    // };
    return {
      "db_name": "".concat(dbName),
      "entity": "LocationMaster",
      "filter": "document(document(LocationMaster.locationType).coding)[*]._id any == '".concat(_id, "' && LocationMaster.activestatus==true && LocationMaster.status=='Active'"),
      "return_fields": "KEEP(LocationMaster,'id','_id','key','locationID','longdesc','shortdesc')",
      "sort": "LocationMaster.shortdesc"
    };
  }
};

var generateJson$2 = function generateJson(data, orderSetKey) {
  var _data$id, _data$facility$value, _data$facility, _data$locationType$va, _data$locationType, _data$location$value, _data$location, _data$specialty$value, _data$specialty, _data$practitionerTyp, _data$practitionerTyp2, _data$practitioner$va, _data$practitioner, _data$codeSet$value, _data$codeSet, _data$diagnosisCode$v, _data$diagnosisCode, _data$diagnosisGroup$, _data$diagnosisGroup;

  var filter = {};

  if (data._key) {
    filter = {
      filter: {
        _key: data._key
      }
    };
  }

  var arr = [_objectSpread2(_objectSpread2({
    db_name: dbName,
    entity: "CA_OrderSet_Applicability",
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
  }, filter), {}, {
    doc: {
      id: (_data$id = data === null || data === void 0 ? void 0 : data.id) !== null && _data$id !== void 0 ? _data$id : 0,
      organizationCode: (_data$facility$value = data === null || data === void 0 ? void 0 : (_data$facility = data.facility) === null || _data$facility === void 0 ? void 0 : _data$facility.value) !== null && _data$facility$value !== void 0 ? _data$facility$value : "",
      locationType: (_data$locationType$va = data === null || data === void 0 ? void 0 : (_data$locationType = data.locationType) === null || _data$locationType === void 0 ? void 0 : _data$locationType.value) !== null && _data$locationType$va !== void 0 ? _data$locationType$va : "",
      locationCode: (_data$location$value = data === null || data === void 0 ? void 0 : (_data$location = data.location) === null || _data$location === void 0 ? void 0 : _data$location.value) !== null && _data$location$value !== void 0 ? _data$location$value : "",
      specialty: (_data$specialty$value = data === null || data === void 0 ? void 0 : (_data$specialty = data.specialty) === null || _data$specialty === void 0 ? void 0 : _data$specialty.value) !== null && _data$specialty$value !== void 0 ? _data$specialty$value : "",
      practCode: (_data$practitionerTyp = data === null || data === void 0 ? void 0 : (_data$practitionerTyp2 = data.practitionerType) === null || _data$practitionerTyp2 === void 0 ? void 0 : _data$practitionerTyp2.value) !== null && _data$practitionerTyp !== void 0 ? _data$practitionerTyp : "",
      practRoleId: (_data$practitioner$va = data === null || data === void 0 ? void 0 : (_data$practitioner = data.practitioner) === null || _data$practitioner === void 0 ? void 0 : _data$practitioner.value) !== null && _data$practitioner$va !== void 0 ? _data$practitioner$va : "",
      healthcareService: "",
      diagcodeSet: (_data$codeSet$value = data === null || data === void 0 ? void 0 : (_data$codeSet = data.codeSet) === null || _data$codeSet === void 0 ? void 0 : _data$codeSet.value) !== null && _data$codeSet$value !== void 0 ? _data$codeSet$value : "",
      diagnosisCode: (_data$diagnosisCode$v = data === null || data === void 0 ? void 0 : (_data$diagnosisCode = data.diagnosisCode) === null || _data$diagnosisCode === void 0 ? void 0 : _data$diagnosisCode.value) !== null && _data$diagnosisCode$v !== void 0 ? _data$diagnosisCode$v : "",
      diagGroup: (_data$diagnosisGroup$ = data === null || data === void 0 ? void 0 : (_data$diagnosisGroup = data.diagnosisGroup) === null || _data$diagnosisGroup === void 0 ? void 0 : _data$diagnosisGroup.value) !== null && _data$diagnosisGroup$ !== void 0 ? _data$diagnosisGroup$ : "",
      Ordersetcode: orderSetKey !== null && orderSetKey !== void 0 ? orderSetKey : ""
    }
  })];
  return arr;
};

var generateReadJSON$1 = function generateReadJSON(data) {
  var arr = [];

  if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
    data === null || data === void 0 ? void 0 : data.map(function (val, i) {
      var _val$Ordersetcode$_id, _val$Ordersetcode, _val$Ordersetcode$_ke, _val$Ordersetcode2, _val$Ordersetcode$id, _val$Ordersetcode3, _val$Ordersetcode$ord, _val$Ordersetcode4, _val$Ordersetcode$sho, _val$Ordersetcode5, _val$Ordersetcode$lon, _val$Ordersetcode6, _val$Ordersetcode$sta, _val$Ordersetcode7, _val$_id, _val$_key, _val$id, _val$locationCode, _val$locationCode2, _val$locationCode3, _val$locationCode4, _val$locationType, _val$locationType2, _val$locationType3, _val$locationType4, _val$diagGroup, _val$diagGroup2, _val$diagGroup3, _val$diagGroup4, _val$diagGroup5, _val$diagnosisCode, _val$diagnosisCode2, _val$diagnosisCode3, _val$diagnosisCode4, _val$organizationCode, _val$organizationCode2, _val$organizationCode3, _val$organizationCode4, _val$practCode, _val$practCode2, _val$practCode3, _val$practCode4, _val$practRoleId, _val$practRoleId2, _val$practRoleId3, _val$practRoleId4, _val$practRoleId4$nam, _val$specialty, _val$specialty2, _val$specialty3, _val$specialty4;

      var obj = {
        //ORDER SET DETAILS
        order_set__id: (_val$Ordersetcode$_id = val === null || val === void 0 ? void 0 : (_val$Ordersetcode = val.Ordersetcode) === null || _val$Ordersetcode === void 0 ? void 0 : _val$Ordersetcode._id) !== null && _val$Ordersetcode$_id !== void 0 ? _val$Ordersetcode$_id : "",
        order_set__key: (_val$Ordersetcode$_ke = val === null || val === void 0 ? void 0 : (_val$Ordersetcode2 = val.Ordersetcode) === null || _val$Ordersetcode2 === void 0 ? void 0 : _val$Ordersetcode2._key) !== null && _val$Ordersetcode$_ke !== void 0 ? _val$Ordersetcode$_ke : "",
        order_set_id: (_val$Ordersetcode$id = val === null || val === void 0 ? void 0 : (_val$Ordersetcode3 = val.Ordersetcode) === null || _val$Ordersetcode3 === void 0 ? void 0 : _val$Ordersetcode3.id) !== null && _val$Ordersetcode$id !== void 0 ? _val$Ordersetcode$id : "",
        order_set_orderSetCode: (_val$Ordersetcode$ord = val === null || val === void 0 ? void 0 : (_val$Ordersetcode4 = val.Ordersetcode) === null || _val$Ordersetcode4 === void 0 ? void 0 : _val$Ordersetcode4.orderSetCode) !== null && _val$Ordersetcode$ord !== void 0 ? _val$Ordersetcode$ord : "",
        order_set_shortDesc: (_val$Ordersetcode$sho = val === null || val === void 0 ? void 0 : (_val$Ordersetcode5 = val.Ordersetcode) === null || _val$Ordersetcode5 === void 0 ? void 0 : _val$Ordersetcode5.shortDesc) !== null && _val$Ordersetcode$sho !== void 0 ? _val$Ordersetcode$sho : "",
        order_set_longDesc: (_val$Ordersetcode$lon = val === null || val === void 0 ? void 0 : (_val$Ordersetcode6 = val.Ordersetcode) === null || _val$Ordersetcode6 === void 0 ? void 0 : _val$Ordersetcode6.longDesc) !== null && _val$Ordersetcode$lon !== void 0 ? _val$Ordersetcode$lon : "",
        order_set_status: (_val$Ordersetcode$sta = val === null || val === void 0 ? void 0 : (_val$Ordersetcode7 = val.Ordersetcode) === null || _val$Ordersetcode7 === void 0 ? void 0 : _val$Ordersetcode7.status) !== null && _val$Ordersetcode$sta !== void 0 ? _val$Ordersetcode$sta : "",
        //ORDER APPLICABILITY DETAILS
        _id: (_val$_id = val === null || val === void 0 ? void 0 : val._id) !== null && _val$_id !== void 0 ? _val$_id : "",
        _key: (_val$_key = val === null || val === void 0 ? void 0 : val._key) !== null && _val$_key !== void 0 ? _val$_key : "",
        id: (_val$id = val === null || val === void 0 ? void 0 : val.id) !== null && _val$id !== void 0 ? _val$id : "",
        location: val !== null && val !== void 0 && (_val$locationCode = val.locationCode) !== null && _val$locationCode !== void 0 && _val$locationCode._id && val !== null && val !== void 0 && (_val$locationCode2 = val.locationCode) !== null && _val$locationCode2 !== void 0 && _val$locationCode2.longdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$locationCode3 = val.locationCode) === null || _val$locationCode3 === void 0 ? void 0 : _val$locationCode3._id,
          label: val === null || val === void 0 ? void 0 : (_val$locationCode4 = val.locationCode) === null || _val$locationCode4 === void 0 ? void 0 : _val$locationCode4.longdesc
        } : {},
        locationType: val !== null && val !== void 0 && (_val$locationType = val.locationType) !== null && _val$locationType !== void 0 && _val$locationType._id && val !== null && val !== void 0 && (_val$locationType2 = val.locationType) !== null && _val$locationType2 !== void 0 && _val$locationType2.display ? {
          value: val === null || val === void 0 ? void 0 : (_val$locationType3 = val.locationType) === null || _val$locationType3 === void 0 ? void 0 : _val$locationType3._id,
          label: val === null || val === void 0 ? void 0 : (_val$locationType4 = val.locationType) === null || _val$locationType4 === void 0 ? void 0 : _val$locationType4.display
        } : {},
        diagnosisGroup: val !== null && val !== void 0 && (_val$diagGroup = val.diagGroup) !== null && _val$diagGroup !== void 0 && _val$diagGroup.icdname && val !== null && val !== void 0 && (_val$diagGroup2 = val.diagGroup) !== null && _val$diagGroup2 !== void 0 && _val$diagGroup2._id ? {
          value: val === null || val === void 0 ? void 0 : (_val$diagGroup3 = val.diagGroup) === null || _val$diagGroup3 === void 0 ? void 0 : _val$diagGroup3._id,
          label: val === null || val === void 0 ? void 0 : (_val$diagGroup4 = val.diagGroup) === null || _val$diagGroup4 === void 0 ? void 0 : _val$diagGroup4.icdname,
          icdcode: val === null || val === void 0 ? void 0 : (_val$diagGroup5 = val.diagGroup) === null || _val$diagGroup5 === void 0 ? void 0 : _val$diagGroup5.icdcode
        } : {},
        diagnosisCode: val !== null && val !== void 0 && (_val$diagnosisCode = val.diagnosisCode) !== null && _val$diagnosisCode !== void 0 && _val$diagnosisCode.icdname && val !== null && val !== void 0 && (_val$diagnosisCode2 = val.diagnosisCode) !== null && _val$diagnosisCode2 !== void 0 && _val$diagnosisCode2._id ? {
          value: val === null || val === void 0 ? void 0 : (_val$diagnosisCode3 = val.diagnosisCode) === null || _val$diagnosisCode3 === void 0 ? void 0 : _val$diagnosisCode3._id,
          label: val === null || val === void 0 ? void 0 : (_val$diagnosisCode4 = val.diagnosisCode) === null || _val$diagnosisCode4 === void 0 ? void 0 : _val$diagnosisCode4.icdname
        } : {},
        diagcodeSet: val !== null && val !== void 0 && val.diagcodeSet ? {
          value: val === null || val === void 0 ? void 0 : val.diagcodeSet,
          label: val === null || val === void 0 ? void 0 : val.diagcodeSet
        } : {},
        facility: val !== null && val !== void 0 && (_val$organizationCode = val.organizationCode) !== null && _val$organizationCode !== void 0 && _val$organizationCode.name && val !== null && val !== void 0 && (_val$organizationCode2 = val.organizationCode) !== null && _val$organizationCode2 !== void 0 && _val$organizationCode2._id ? {
          value: val === null || val === void 0 ? void 0 : (_val$organizationCode3 = val.organizationCode) === null || _val$organizationCode3 === void 0 ? void 0 : _val$organizationCode3._id,
          label: val === null || val === void 0 ? void 0 : (_val$organizationCode4 = val.organizationCode) === null || _val$organizationCode4 === void 0 ? void 0 : _val$organizationCode4.name
        } : {},
        practitionerType: val !== null && val !== void 0 && (_val$practCode = val.practCode) !== null && _val$practCode !== void 0 && _val$practCode.shortdesc && val !== null && val !== void 0 && (_val$practCode2 = val.practCode) !== null && _val$practCode2 !== void 0 && _val$practCode2._id ? {
          value: val === null || val === void 0 ? void 0 : (_val$practCode3 = val.practCode) === null || _val$practCode3 === void 0 ? void 0 : _val$practCode3._id,
          label: val === null || val === void 0 ? void 0 : (_val$practCode4 = val.practCode) === null || _val$practCode4 === void 0 ? void 0 : _val$practCode4.shortdesc
        } : {},
        practitioner: val !== null && val !== void 0 && (_val$practRoleId = val.practRoleId) !== null && _val$practRoleId !== void 0 && _val$practRoleId._id && val !== null && val !== void 0 && (_val$practRoleId2 = val.practRoleId) !== null && _val$practRoleId2 !== void 0 && _val$practRoleId2.name ? {
          value: val === null || val === void 0 ? void 0 : (_val$practRoleId3 = val.practRoleId) === null || _val$practRoleId3 === void 0 ? void 0 : _val$practRoleId3._id,
          label: val === null || val === void 0 ? void 0 : (_val$practRoleId4 = val.practRoleId) === null || _val$practRoleId4 === void 0 ? void 0 : (_val$practRoleId4$nam = _val$practRoleId4.name[0]) === null || _val$practRoleId4$nam === void 0 ? void 0 : _val$practRoleId4$nam.text
        } : {},
        specialty: val !== null && val !== void 0 && (_val$specialty = val.specialty) !== null && _val$specialty !== void 0 && _val$specialty._id && val !== null && val !== void 0 && (_val$specialty2 = val.specialty) !== null && _val$specialty2 !== void 0 && _val$specialty2.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$specialty3 = val.specialty) === null || _val$specialty3 === void 0 ? void 0 : _val$specialty3._id,
          label: val === null || val === void 0 ? void 0 : (_val$specialty4 = val.specialty) === null || _val$specialty4 === void 0 ? void 0 : _val$specialty4.shortdesc
        } : {}
      };
      arr.push(obj);
    });
  }

  return arr;
};
var generateSingleReadJSON = function generateSingleReadJSON(data) {
  var _data$_id, _data$_key, _data$id, _data$locationCode, _data$locationCode2, _data$locationCode3, _data$locationCode4, _data$locationType, _data$locationType2, _data$locationType3, _data$locationType4, _data$diagGroup, _data$diagGroup2, _data$diagGroup3, _data$diagGroup4, _data$diagGroup5, _data$diagnosisCode, _data$diagnosisCode2, _data$diagnosisCode3, _data$diagnosisCode4, _data$organizationCod, _data$organizationCod2, _data$organizationCod3, _data$organizationCod4, _data$practCode, _data$practCode2, _data$practCode3, _data$practCode4, _data$practRoleId, _data$practRoleId2, _data$practRoleId3, _data$practRoleId4, _data$practRoleId4$na, _data$specialty, _data$specialty2, _data$specialty3, _data$specialty4;

  var obj = {
    //ORDER APPLICABILITY DETAILS
    _id: (_data$_id = data === null || data === void 0 ? void 0 : data._id) !== null && _data$_id !== void 0 ? _data$_id : "",
    _key: (_data$_key = data === null || data === void 0 ? void 0 : data._key) !== null && _data$_key !== void 0 ? _data$_key : "",
    id: (_data$id = data === null || data === void 0 ? void 0 : data.id) !== null && _data$id !== void 0 ? _data$id : "",
    location: data !== null && data !== void 0 && (_data$locationCode = data.locationCode) !== null && _data$locationCode !== void 0 && _data$locationCode._id && data !== null && data !== void 0 && (_data$locationCode2 = data.locationCode) !== null && _data$locationCode2 !== void 0 && _data$locationCode2.longdesc ? {
      value: data === null || data === void 0 ? void 0 : (_data$locationCode3 = data.locationCode) === null || _data$locationCode3 === void 0 ? void 0 : _data$locationCode3._id,
      label: data === null || data === void 0 ? void 0 : (_data$locationCode4 = data.locationCode) === null || _data$locationCode4 === void 0 ? void 0 : _data$locationCode4.longdesc
    } : {},
    locationType: data !== null && data !== void 0 && (_data$locationType = data.locationType) !== null && _data$locationType !== void 0 && _data$locationType._id && data !== null && data !== void 0 && (_data$locationType2 = data.locationType) !== null && _data$locationType2 !== void 0 && _data$locationType2.display ? {
      value: data === null || data === void 0 ? void 0 : (_data$locationType3 = data.locationType) === null || _data$locationType3 === void 0 ? void 0 : _data$locationType3._id,
      label: data === null || data === void 0 ? void 0 : (_data$locationType4 = data.locationType) === null || _data$locationType4 === void 0 ? void 0 : _data$locationType4.display
    } : {},
    diagnosisGroup: data !== null && data !== void 0 && (_data$diagGroup = data.diagGroup) !== null && _data$diagGroup !== void 0 && _data$diagGroup.icdname && data !== null && data !== void 0 && (_data$diagGroup2 = data.diagGroup) !== null && _data$diagGroup2 !== void 0 && _data$diagGroup2._id ? {
      value: data === null || data === void 0 ? void 0 : (_data$diagGroup3 = data.diagGroup) === null || _data$diagGroup3 === void 0 ? void 0 : _data$diagGroup3._id,
      label: data === null || data === void 0 ? void 0 : (_data$diagGroup4 = data.diagGroup) === null || _data$diagGroup4 === void 0 ? void 0 : _data$diagGroup4.icdname,
      icdcode: data === null || data === void 0 ? void 0 : (_data$diagGroup5 = data.diagGroup) === null || _data$diagGroup5 === void 0 ? void 0 : _data$diagGroup5.icdcode
    } : {},
    diagnosisCode: data !== null && data !== void 0 && (_data$diagnosisCode = data.diagnosisCode) !== null && _data$diagnosisCode !== void 0 && _data$diagnosisCode.icdname && data !== null && data !== void 0 && (_data$diagnosisCode2 = data.diagnosisCode) !== null && _data$diagnosisCode2 !== void 0 && _data$diagnosisCode2._id ? {
      value: data === null || data === void 0 ? void 0 : (_data$diagnosisCode3 = data.diagnosisCode) === null || _data$diagnosisCode3 === void 0 ? void 0 : _data$diagnosisCode3._id,
      label: data === null || data === void 0 ? void 0 : (_data$diagnosisCode4 = data.diagnosisCode) === null || _data$diagnosisCode4 === void 0 ? void 0 : _data$diagnosisCode4.icdname
    } : {},
    codeSet: data !== null && data !== void 0 && data.diagcodeSet ? {
      value: data === null || data === void 0 ? void 0 : data.diagcodeSet,
      label: data === null || data === void 0 ? void 0 : data.diagcodeSet
    } : {},
    facility: data !== null && data !== void 0 && (_data$organizationCod = data.organizationCode) !== null && _data$organizationCod !== void 0 && _data$organizationCod.name && data !== null && data !== void 0 && (_data$organizationCod2 = data.organizationCode) !== null && _data$organizationCod2 !== void 0 && _data$organizationCod2._id ? {
      value: data === null || data === void 0 ? void 0 : (_data$organizationCod3 = data.organizationCode) === null || _data$organizationCod3 === void 0 ? void 0 : _data$organizationCod3._id,
      label: data === null || data === void 0 ? void 0 : (_data$organizationCod4 = data.organizationCode) === null || _data$organizationCod4 === void 0 ? void 0 : _data$organizationCod4.name
    } : {},
    practitionerType: data !== null && data !== void 0 && (_data$practCode = data.practCode) !== null && _data$practCode !== void 0 && _data$practCode.shortdesc && data !== null && data !== void 0 && (_data$practCode2 = data.practCode) !== null && _data$practCode2 !== void 0 && _data$practCode2._id ? _objectSpread2({
      value: data === null || data === void 0 ? void 0 : (_data$practCode3 = data.practCode) === null || _data$practCode3 === void 0 ? void 0 : _data$practCode3._id,
      label: data === null || data === void 0 ? void 0 : (_data$practCode4 = data.practCode) === null || _data$practCode4 === void 0 ? void 0 : _data$practCode4.shortdesc
    }, data === null || data === void 0 ? void 0 : data.practCode) : {},
    practitioner: data !== null && data !== void 0 && (_data$practRoleId = data.practRoleId) !== null && _data$practRoleId !== void 0 && _data$practRoleId._id && data !== null && data !== void 0 && (_data$practRoleId2 = data.practRoleId) !== null && _data$practRoleId2 !== void 0 && _data$practRoleId2.name ? {
      value: data === null || data === void 0 ? void 0 : (_data$practRoleId3 = data.practRoleId) === null || _data$practRoleId3 === void 0 ? void 0 : _data$practRoleId3._id,
      label: data === null || data === void 0 ? void 0 : (_data$practRoleId4 = data.practRoleId) === null || _data$practRoleId4 === void 0 ? void 0 : (_data$practRoleId4$na = _data$practRoleId4.name[0]) === null || _data$practRoleId4$na === void 0 ? void 0 : _data$practRoleId4$na.text
    } : {},
    specialty: data !== null && data !== void 0 && (_data$specialty = data.specialty) !== null && _data$specialty !== void 0 && _data$specialty._id && data !== null && data !== void 0 && (_data$specialty2 = data.specialty) !== null && _data$specialty2 !== void 0 && _data$specialty2.shortdesc ? {
      value: data === null || data === void 0 ? void 0 : (_data$specialty3 = data.specialty) === null || _data$specialty3 === void 0 ? void 0 : _data$specialty3._id,
      label: data === null || data === void 0 ? void 0 : (_data$specialty4 = data.specialty) === null || _data$specialty4 === void 0 ? void 0 : _data$specialty4.shortdesc
    } : {}
  };
  return obj;
};

var _extraReducers$6;
var fileds$1 = [//"facilityName",
"speciality", "practitionerType", //"codeSet",
"locationType"];

var loopMasters$2 = function loopMasters() {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject) {
      var calls;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              calls = Object.keys(masterQuery$2).map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return fetchMaster$2(val, masterQuery$2[val]);

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
              es6Promise.Promise.all(calls).then(function (data) {
                var json = {};
                data.map(function (val, i) {
                  var arr = [];
                  val.data.map(function (value, i_) {
                    if (fileds$1.includes(val.name)) {
                      if (value.coding[0] !== null) {
                        var _value$coding, _value$coding$, _value$coding2, _value$coding2$;

                        arr.push({
                          label: value === null || value === void 0 ? void 0 : (_value$coding = value.coding) === null || _value$coding === void 0 ? void 0 : (_value$coding$ = _value$coding[0]) === null || _value$coding$ === void 0 ? void 0 : _value$coding$.display,
                          value: value === null || value === void 0 ? void 0 : (_value$coding2 = value.coding) === null || _value$coding2 === void 0 ? void 0 : (_value$coding2$ = _value$coding2[0]) === null || _value$coding2$ === void 0 ? void 0 : _value$coding2$._id,
                          _id: value === null || value === void 0 ? void 0 : value._id
                        });
                      }
                    } else if ("facilityName" === val.name) {
                      arr.push({
                        label: value.name,
                        value: value._id
                      });
                    } else if ("codeSet" === val.name) {
                      var _val$data, _val$data2;

                      var obj = {
                        value: val === null || val === void 0 ? void 0 : (_val$data = val.data) === null || _val$data === void 0 ? void 0 : _val$data[i_],
                        label: val === null || val === void 0 ? void 0 : (_val$data2 = val.data) === null || _val$data2 === void 0 ? void 0 : _val$data2[i_]
                      };
                      arr.push(obj);
                    }
                  });
                  json[val.name] = arr;
                  resolve(json);
                });
              })["catch"](function (err) {
                resolve([]);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var fetchMaster$2 = function fetchMaster(name, query) {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetchData({
                body: query
              }, __readDocumentUrl__);

            case 2:
              data = _context3.sent;
              resolve({
                data: data.result,
                name: name
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }());
}; //GET_ORDER_SET_APPLICABILITY_LIST


var GET_ORDER_SET_APPLICABILITY_LIST = toolkit.createAsyncThunk("orderSetApplicabilitySlice/order_set_applicability_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref5,
      rejectWithValue,
      _id,
      data,
      readJSON,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref5 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref5.rejectWithValue;
          _context4.prev = 2;
          _id = payload._id;
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(query$2.orderSetApplicabilityList(_id))
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          readJSON = generateReadJSON$1(data !== null && data !== void 0 && data.result ? data === null || data === void 0 ? void 0 : data.result : null);
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: readJSON
          }));

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 11]]);
}))); //GET_ORDER_SET_APPLICABILITY_SINGLE_READ

var GET_ORDER_SET_APPLICABILITY_SINGLE_READ = toolkit.createAsyncThunk("orderSetApplicabilitySlice/order_set_applicability_single_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref7,
      rejectWithValue,
      _data$result,
      _data$result2,
      _key,
      data,
      readJSON,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref7 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref7.rejectWithValue;
          _context5.prev = 2;
          _key = payload._key;
          _context5.next = 6;
          return fetchData({
            body: JSON.stringify(query$2.orderSetApplicabilityById(_key))
          }, __readDocumentUrl__);

        case 6:
          data = _context5.sent;
          readJSON = generateSingleReadJSON(data !== null && data !== void 0 && (_data$result = data.result) !== null && _data$result !== void 0 && _data$result[0] ? data === null || data === void 0 ? void 0 : (_data$result2 = data.result) === null || _data$result2 === void 0 ? void 0 : _data$result2[0] : null);
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: readJSON
          }));

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 11]]);
}))); //ORDER_SET_APPLICABILITY_MASTER

var ORDER_SET_APPLICABILITY_MASTER = toolkit.createAsyncThunk("orderSetApplicabilitySlice/order_set_applicability_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var _ref9,
      rejectWithValue,
      data,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _ref9 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref9.rejectWithValue;
          _context6.prev = 2;
          _context6.next = 5;
          return loopMasters$2();

        case 5:
          data = _context6.sent;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 9:
          _context6.prev = 9;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 12:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 9]]);
}))); //ORDER_SET_APP_PRACTITIONER

var ORDER_SET_APP_PRACTITIONER = toolkit.createAsyncThunk("orderSetApplicabilitySlice/order_set_app_practitioner", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref11,
      rejectWithValue,
      _id,
      data_arr,
      arry,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref11 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref11.rejectWithValue;
          _context7.prev = 2;
          _id = payload._id;
          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(dynamicMaster.orderSetAppPractitioner(_id))
          }, __readDocumentUrl__);

        case 6:
          data_arr = _context7.sent;
          arry = [];
          _context7.next = 10;
          return data_arr.result.map(function (val) {
            var _val$_id, _val$name$0$text, _val$name, _val$name$;

            arry.push({
              value: (_val$_id = val === null || val === void 0 ? void 0 : val._id) !== null && _val$_id !== void 0 ? _val$_id : "",
              label: (_val$name$0$text = val === null || val === void 0 ? void 0 : (_val$name = val.name) === null || _val$name === void 0 ? void 0 : (_val$name$ = _val$name[0]) === null || _val$name$ === void 0 ? void 0 : _val$name$.text) !== null && _val$name$0$text !== void 0 ? _val$name$0$text : ""
            });
          });

        case 10:
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context7.prev = 13;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 16:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 13]]);
}))); //ORDER_SET_APP_DIAGNOSIS_GROUP

var ORDER_SET_APP_DIAGNOSIS_GROUP = toolkit.createAsyncThunk("orderSetApplicabilitySlice/order_set_app_diagnosis_group", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref13,
      rejectWithValue,
      _id,
      data_arr,
      arry,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref13 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref13.rejectWithValue;
          _context8.prev = 2;
          _id = payload._id;
          _context8.next = 6;
          return fetchData({
            body: JSON.stringify(dynamicMaster.orderSetAppDiagnosisGroup(_id))
          }, __readDocumentUrl__);

        case 6:
          data_arr = _context8.sent;
          arry = [];
          _context8.next = 10;
          return data_arr.result.map(function (val) {
            var _val$_id2, _val$icdcode;

            arry.push({
              value: (_val$_id2 = val === null || val === void 0 ? void 0 : val._id) !== null && _val$_id2 !== void 0 ? _val$_id2 : "",
              label: (_val$icdcode = val === null || val === void 0 ? void 0 : val.icdcode) !== null && _val$icdcode !== void 0 ? _val$icdcode : ""
            });
          });

        case 10:
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context8.prev = 13;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 16:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 13]]);
}))); //ORDER_SET_APP_DIAGNOSIS_CODE

var ORDER_SET_APP_DIAGNOSIS_CODE = toolkit.createAsyncThunk("orderSetApplicabilitySlice/order_set_app_diagnosis_code", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref15,
      rejectWithValue,
      _id,
      search,
      data_arr,
      arry,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref15 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref15.rejectWithValue;
          _context9.prev = 2;
          _id = payload._id, search = payload.search;
          _context9.next = 6;
          return fetchData({
            body: JSON.stringify(dynamicMaster.orderSetAppDiagnosisCode(_id, search))
          }, __readDocumentUrl__);

        case 6:
          data_arr = _context9.sent;
          arry = [];
          _context9.next = 10;
          return data_arr.result.map(function (val) {
            var _val$_id3, _val$icdname;

            arry.push({
              value: (_val$_id3 = val === null || val === void 0 ? void 0 : val._id) !== null && _val$_id3 !== void 0 ? _val$_id3 : "",
              label: (_val$icdname = val === null || val === void 0 ? void 0 : val.icdname) !== null && _val$icdname !== void 0 ? _val$icdname : ""
            });
          });

        case 10:
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context9.t0.message
          })));

        case 16:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 13]]);
}))); //ORDER_SET_APP_LOCATION

var ORDER_SET_APP_LOCATION = toolkit.createAsyncThunk("orderSetApplicabilitySlice/order_set_app_location", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref17,
      rejectWithValue,
      _id,
      data_arr,
      arry,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref17 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref17.rejectWithValue;
          _context10.prev = 2;
          _id = payload._id;
          _context10.next = 6;
          return fetchData({
            body: JSON.stringify(dynamicMaster.orderSetAppLocation(_id))
          }, __readDocumentUrl__);

        case 6:
          data_arr = _context10.sent;
          arry = [];
          _context10.next = 10;
          return data_arr.result.map(function (val) {
            var _val$_id4, _val$shortdesc;

            arry.push({
              value: (_val$_id4 = val === null || val === void 0 ? void 0 : val._id) !== null && _val$_id4 !== void 0 ? _val$_id4 : "",
              label: (_val$shortdesc = val === null || val === void 0 ? void 0 : val.shortdesc) !== null && _val$shortdesc !== void 0 ? _val$shortdesc : ""
            });
          });

        case 10:
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context10.t0.message
          })));

        case 16:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 13]]);
}))); //DELETE_ORDER_SET_APPLICABILITY

var DELETE_ORDER_SET_APPLICABILITY = toolkit.createAsyncThunk("orderSetApplicabilitySlice/order_set_applicability_delete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var payload,
      _ref19,
      rejectWithValue,
      _key,
      data,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
          _ref19 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref19.rejectWithValue;
          _context11.prev = 2;
          _key = payload._key;
          _context11.next = 6;
          return fetchData({
            body: JSON.stringify(query$2.orderSetApplicabilityDelete(_key))
          }, __softDelete__);

        case 6:
          data = _context11.sent;
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context11.prev = 10;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context11.t0.message
          })));

        case 13:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 10]]);
}))); //ORDER_SET_APPLICABILITY_UPSERT

var ORDER_SET_APPLICABILITY_UPSERT = toolkit.createAsyncThunk("orderSetApplicabilitySlice/order_set_applicability_upsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
  var payload,
      _ref21,
      rejectWithValue,
      dataList,
      orderSetKey,
      queriesjson,
      data,
      _args12 = arguments;

  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
          _ref21 = _args12.length > 1 ? _args12[1] : undefined, rejectWithValue = _ref21.rejectWithValue;
          _context12.prev = 2;
          dataList = payload.dataList, orderSetKey = payload.orderSetKey;
          queriesjson = generateJson$2(dataList, orderSetKey);
          _context12.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context12.sent;
          return _context12.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context12.prev = 11;
          _context12.t0 = _context12["catch"](2);
          return _context12.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context12.t0.message
          })));

        case 14:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, null, [[2, 11]]);
})));
var orderSetApplicabilitySlice = toolkit.createSlice({
  name: "orderSetApplicabilityApiSlice",
  initialState: {
    order_set_applicability_list: _objectSpread2({}, defaultState.List),
    order_set_applicability_single_read: _objectSpread2({}, defaultState.List),
    order_set_applicability_master: _objectSpread2({}, defaultState.List),
    order_set_applicability_delete: _objectSpread2({}, defaultState.List),
    order_set_app_practitioner: _objectSpread2({}, defaultState.List),
    order_set_app_diagnosis_group: _objectSpread2({}, defaultState.List),
    order_set_app_diagnosis_code: _objectSpread2({}, defaultState.List),
    order_set_app_location: _objectSpread2({}, defaultState.List),
    order_set_applicability_upsert: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$6 = {}, _defineProperty(_extraReducers$6, GET_ORDER_SET_APPLICABILITY_LIST.fulfilled, function (state, action) {
    state.order_set_applicability_list.loading = false, state.order_set_applicability_list.error = false, state.order_set_applicability_list = action.payload;
  }), _defineProperty(_extraReducers$6, GET_ORDER_SET_APPLICABILITY_LIST.pending, function (state, action) {
    state.order_set_applicability_list.loading = true, state.order_set_applicability_list.error = false, state.order_set_applicability_list.loading = true;
  }), _defineProperty(_extraReducers$6, GET_ORDER_SET_APPLICABILITY_LIST.rejected, function (state, action) {
    state.order_set_applicability_list.loading = false, state.order_set_applicability_list.error = true, state.order_set_applicability_list = action.payload;
  }), _defineProperty(_extraReducers$6, GET_ORDER_SET_APPLICABILITY_SINGLE_READ.fulfilled, function (state, action) {
    state.order_set_applicability_single_read.loading = false, state.order_set_applicability_single_read.error = false, state.order_set_applicability_single_read = action.payload;
  }), _defineProperty(_extraReducers$6, GET_ORDER_SET_APPLICABILITY_SINGLE_READ.pending, function (state, action) {
    state.order_set_applicability_single_read.loading = true, state.order_set_applicability_single_read.error = false, state.order_set_applicability_single_read.loading = true;
  }), _defineProperty(_extraReducers$6, GET_ORDER_SET_APPLICABILITY_SINGLE_READ.rejected, function (state, action) {
    state.order_set_applicability_single_read.loading = false, state.order_set_applicability_single_read.error = true, state.order_set_applicability_single_read = action.payload;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APPLICABILITY_MASTER.fulfilled, function (state, action) {
    state.order_set_applicability_master.loading = false, state.order_set_applicability_master.error = false, state.order_set_applicability_master = action.payload;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APPLICABILITY_MASTER.pending, function (state, action) {
    state.order_set_applicability_master.loading = true, state.order_set_applicability_master.error = false, state.order_set_applicability_master.loading = true;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APPLICABILITY_MASTER.rejected, function (state, action) {
    state.order_set_applicability_master.loading = false, state.order_set_applicability_master.error = true, state.order_set_applicability_master = action.payload;
  }), _defineProperty(_extraReducers$6, DELETE_ORDER_SET_APPLICABILITY.fulfilled, function (state, action) {
    state.order_set_applicability_delete.loading = false, state.order_set_applicability_delete.error = false, state.order_set_applicability_delete = action.payload;
  }), _defineProperty(_extraReducers$6, DELETE_ORDER_SET_APPLICABILITY.pending, function (state, action) {
    state.order_set_applicability_delete.loading = true, state.order_set_applicability_delete.error = false, state.order_set_applicability_delete.loading = true;
  }), _defineProperty(_extraReducers$6, DELETE_ORDER_SET_APPLICABILITY.rejected, function (state, action) {
    state.order_set_applicability_delete.loading = false, state.order_set_applicability_delete.error = true, state.order_set_applicability_delete = action.payload;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APP_PRACTITIONER.fulfilled, function (state, action) {
    state.order_set_app_practitioner.loading = false, state.order_set_app_practitioner.error = false, state.order_set_app_practitioner = action.payload;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APP_PRACTITIONER.pending, function (state, action) {
    state.order_set_app_practitioner.loading = true, state.order_set_app_practitioner.error = false, state.order_set_app_practitioner.loading = true;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APP_PRACTITIONER.rejected, function (state, action) {
    state.order_set_app_practitioner.loading = false, state.order_set_app_practitioner.error = true, state.order_set_app_practitioner = action.payload;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APP_DIAGNOSIS_GROUP.fulfilled, function (state, action) {
    state.order_set_app_diagnosis_group.loading = false, state.order_set_app_diagnosis_group.error = false, state.order_set_app_diagnosis_group = action.payload;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APP_DIAGNOSIS_GROUP.pending, function (state, action) {
    state.order_set_app_diagnosis_group.loading = true, state.order_set_app_diagnosis_group.error = false, state.order_set_app_diagnosis_group.loading = true;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APP_DIAGNOSIS_GROUP.rejected, function (state, action) {
    state.order_set_app_diagnosis_group.loading = false, state.order_set_app_diagnosis_group.error = true, state.order_set_app_diagnosis_group = action.payload;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APP_DIAGNOSIS_CODE.fulfilled, function (state, action) {
    state.order_set_app_diagnosis_code.loading = false, state.order_set_app_diagnosis_code.error = false, state.order_set_app_diagnosis_code = action.payload;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APP_DIAGNOSIS_CODE.pending, function (state, action) {
    state.order_set_app_diagnosis_code.loading = true, state.order_set_app_diagnosis_code.error = false, state.order_set_app_diagnosis_code.loading = true;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APP_DIAGNOSIS_CODE.rejected, function (state, action) {
    state.order_set_app_diagnosis_code.loading = false, state.order_set_app_diagnosis_code.error = true, state.order_set_app_diagnosis_code = action.payload;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APP_LOCATION.fulfilled, function (state, action) {
    state.order_set_app_location.loading = false, state.order_set_app_location.error = false, state.order_set_app_location = action.payload;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APP_LOCATION.pending, function (state, action) {
    state.order_set_app_location.loading = true, state.order_set_app_location.error = false, state.order_set_app_location.loading = true;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APP_LOCATION.rejected, function (state, action) {
    state.order_set_app_location.loading = false, state.order_set_app_location.error = true, state.order_set_app_location = action.payload;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APPLICABILITY_UPSERT.fulfilled, function (state, action) {
    state.order_set_applicability_upsert.loading = false, state.order_set_applicability_upsert.error = false, state.order_set_applicability_upsert = action.payload;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APPLICABILITY_UPSERT.pending, function (state, action) {
    state.order_set_applicability_upsert.loading = true, state.order_set_applicability_upsert.error = false, state.order_set_applicability_upsert.loading = true;
  }), _defineProperty(_extraReducers$6, ORDER_SET_APPLICABILITY_UPSERT.rejected, function (state, action) {
    state.order_set_applicability_upsert.loading = false, state.order_set_applicability_upsert.error = true, state.order_set_applicability_upsert = action.payload;
  }), _extraReducers$6)
});
var orderSetApplicabilityActions = {
  GET_ORDER_SET_APPLICABILITY_LIST: GET_ORDER_SET_APPLICABILITY_LIST,
  GET_ORDER_SET_APPLICABILITY_SINGLE_READ: GET_ORDER_SET_APPLICABILITY_SINGLE_READ,
  ORDER_SET_APPLICABILITY_MASTER: ORDER_SET_APPLICABILITY_MASTER,
  DELETE_ORDER_SET_APPLICABILITY: DELETE_ORDER_SET_APPLICABILITY,
  ORDER_SET_APP_PRACTITIONER: ORDER_SET_APP_PRACTITIONER,
  ORDER_SET_APP_DIAGNOSIS_GROUP: ORDER_SET_APP_DIAGNOSIS_GROUP,
  ORDER_SET_APP_DIAGNOSIS_CODE: ORDER_SET_APP_DIAGNOSIS_CODE,
  ORDER_SET_APP_LOCATION: ORDER_SET_APP_LOCATION,
  ORDER_SET_APPLICABILITY_UPSERT: ORDER_SET_APPLICABILITY_UPSERT
};
var orderSetApplicabilitySlice$1 = orderSetApplicabilitySlice.reducer;

var query$1 = {
  getList: function getList(page, perpage) {
    return {
      db_name: "".concat(dbName),
      entity: "AllergyMaster",
      filter: "AllergyMaster.activestatus == true",
      limit: {
        offset: page,
        count: perpage
      },
      return_fields: "{TotalCount:COUNT(AllergyMaster),AllergyMaster:merge(AllergyMaster,{extsystemsourceid:document(AllergyMaster.extsystemsourceid)},{conceptidtype:document(AllergyMaster.conceptidtype)},{allergytypeind:document(AllergyMaster.allergytypeind)})}",
      sort: "AllergyMaster.shortdesc"
    };
  }
};

var generateJson$1 = function generateJson(data) {
  var _data$id, _data$extsystemsource, _data$allergytypeind, _data$code, _data$shortdesc, _data$longdesc, _data$conceptidtype;

  var filter = {};

  if (data._key) {
    filter = {
      filter: {
        _key: data === null || data === void 0 ? void 0 : data._key
      }
    };
  }

  return [_objectSpread2(_objectSpread2({
    db_name: "".concat(dbName),
    entity: "AllergyMaster",
    is_metadata: true,
    metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
  }, filter), {}, {
    doc: {
      id: (_data$id = data === null || data === void 0 ? void 0 : data.id) !== null && _data$id !== void 0 ? _data$id : 0,
      extsystemsourceid: (_data$extsystemsource = data === null || data === void 0 ? void 0 : data.extsystemsourceid) !== null && _data$extsystemsource !== void 0 ? _data$extsystemsource : "",
      allergytypeind: (_data$allergytypeind = data === null || data === void 0 ? void 0 : data.allergytypeind) !== null && _data$allergytypeind !== void 0 ? _data$allergytypeind : "",
      code: (_data$code = data === null || data === void 0 ? void 0 : data.code) !== null && _data$code !== void 0 ? _data$code : "",
      shortdesc: (_data$shortdesc = data === null || data === void 0 ? void 0 : data.shortdesc) !== null && _data$shortdesc !== void 0 ? _data$shortdesc : "",
      longdesc: (_data$longdesc = data === null || data === void 0 ? void 0 : data.longdesc) !== null && _data$longdesc !== void 0 ? _data$longdesc : "",
      conceptidtype: (_data$conceptidtype = data === null || data === void 0 ? void 0 : data.conceptidtype) !== null && _data$conceptidtype !== void 0 ? _data$conceptidtype : "",
      status: data === null || data === void 0 ? void 0 : data.status
    }
  })];
};

var generateReadJSON = function generateReadJSON(data) {
  var arr = [];

  if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
    data === null || data === void 0 ? void 0 : data.map(function (val, i) {
      var _val$TotalCount, _val$AllergyMaster$_i, _val$AllergyMaster, _val$AllergyMaster$_k, _val$AllergyMaster2, _val$AllergyMaster3, _val$AllergyMaster3$a, _val$AllergyMaster4, _val$AllergyMaster4$a, _val$AllergyMaster5, _val$AllergyMaster5$a, _val$AllergyMaster6, _val$AllergyMaster6$a, _val$AllergyMaster$co, _val$AllergyMaster7, _val$AllergyMaster8, _val$AllergyMaster8$c, _val$AllergyMaster9, _val$AllergyMaster9$c, _val$AllergyMaster10, _val$AllergyMaster10$, _val$AllergyMaster11, _val$AllergyMaster11$, _val$AllergyMaster12, _val$AllergyMaster12$, _val$AllergyMaster13, _val$AllergyMaster13$, _val$AllergyMaster14, _val$AllergyMaster14$, _val$AllergyMaster15, _val$AllergyMaster15$, _val$AllergyMaster$id, _val$AllergyMaster16, _val$AllergyMaster$lo, _val$AllergyMaster17, _val$AllergyMaster$sh, _val$AllergyMaster18, _val$AllergyMaster$st, _val$AllergyMaster19;

      var obj = {
        TotalCount: (_val$TotalCount = val === null || val === void 0 ? void 0 : val.TotalCount) !== null && _val$TotalCount !== void 0 ? _val$TotalCount : 0,
        _id: (_val$AllergyMaster$_i = val === null || val === void 0 ? void 0 : (_val$AllergyMaster = val.AllergyMaster) === null || _val$AllergyMaster === void 0 ? void 0 : _val$AllergyMaster._id) !== null && _val$AllergyMaster$_i !== void 0 ? _val$AllergyMaster$_i : "",
        _key: (_val$AllergyMaster$_k = val === null || val === void 0 ? void 0 : (_val$AllergyMaster2 = val.AllergyMaster) === null || _val$AllergyMaster2 === void 0 ? void 0 : _val$AllergyMaster2._key) !== null && _val$AllergyMaster$_k !== void 0 ? _val$AllergyMaster$_k : "",
        allergytypeind: val !== null && val !== void 0 && (_val$AllergyMaster3 = val.AllergyMaster) !== null && _val$AllergyMaster3 !== void 0 && (_val$AllergyMaster3$a = _val$AllergyMaster3.allergytypeind) !== null && _val$AllergyMaster3$a !== void 0 && _val$AllergyMaster3$a._id && val !== null && val !== void 0 && (_val$AllergyMaster4 = val.AllergyMaster) !== null && _val$AllergyMaster4 !== void 0 && (_val$AllergyMaster4$a = _val$AllergyMaster4.allergytypeind) !== null && _val$AllergyMaster4$a !== void 0 && _val$AllergyMaster4$a.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$AllergyMaster5 = val.AllergyMaster) === null || _val$AllergyMaster5 === void 0 ? void 0 : (_val$AllergyMaster5$a = _val$AllergyMaster5.allergytypeind) === null || _val$AllergyMaster5$a === void 0 ? void 0 : _val$AllergyMaster5$a._id,
          label: val === null || val === void 0 ? void 0 : (_val$AllergyMaster6 = val.AllergyMaster) === null || _val$AllergyMaster6 === void 0 ? void 0 : (_val$AllergyMaster6$a = _val$AllergyMaster6.allergytypeind) === null || _val$AllergyMaster6$a === void 0 ? void 0 : _val$AllergyMaster6$a.shortdesc
        } : {},
        code: (_val$AllergyMaster$co = val === null || val === void 0 ? void 0 : (_val$AllergyMaster7 = val.AllergyMaster) === null || _val$AllergyMaster7 === void 0 ? void 0 : _val$AllergyMaster7.code) !== null && _val$AllergyMaster$co !== void 0 ? _val$AllergyMaster$co : "",
        conceptidtype: val !== null && val !== void 0 && (_val$AllergyMaster8 = val.AllergyMaster) !== null && _val$AllergyMaster8 !== void 0 && (_val$AllergyMaster8$c = _val$AllergyMaster8.conceptidtype) !== null && _val$AllergyMaster8$c !== void 0 && _val$AllergyMaster8$c._id && val !== null && val !== void 0 && (_val$AllergyMaster9 = val.AllergyMaster) !== null && _val$AllergyMaster9 !== void 0 && (_val$AllergyMaster9$c = _val$AllergyMaster9.conceptidtype) !== null && _val$AllergyMaster9$c !== void 0 && _val$AllergyMaster9$c.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$AllergyMaster10 = val.AllergyMaster) === null || _val$AllergyMaster10 === void 0 ? void 0 : (_val$AllergyMaster10$ = _val$AllergyMaster10.conceptidtype) === null || _val$AllergyMaster10$ === void 0 ? void 0 : _val$AllergyMaster10$._id,
          label: val === null || val === void 0 ? void 0 : (_val$AllergyMaster11 = val.AllergyMaster) === null || _val$AllergyMaster11 === void 0 ? void 0 : (_val$AllergyMaster11$ = _val$AllergyMaster11.conceptidtype) === null || _val$AllergyMaster11$ === void 0 ? void 0 : _val$AllergyMaster11$.shortdesc
        } : {},
        extsystemsourceid: val !== null && val !== void 0 && (_val$AllergyMaster12 = val.AllergyMaster) !== null && _val$AllergyMaster12 !== void 0 && (_val$AllergyMaster12$ = _val$AllergyMaster12.extsystemsourceid) !== null && _val$AllergyMaster12$ !== void 0 && _val$AllergyMaster12$._id && val !== null && val !== void 0 && (_val$AllergyMaster13 = val.AllergyMaster) !== null && _val$AllergyMaster13 !== void 0 && (_val$AllergyMaster13$ = _val$AllergyMaster13.extsystemsourceid) !== null && _val$AllergyMaster13$ !== void 0 && _val$AllergyMaster13$.shortdesc ? {
          value: val === null || val === void 0 ? void 0 : (_val$AllergyMaster14 = val.AllergyMaster) === null || _val$AllergyMaster14 === void 0 ? void 0 : (_val$AllergyMaster14$ = _val$AllergyMaster14.extsystemsourceid) === null || _val$AllergyMaster14$ === void 0 ? void 0 : _val$AllergyMaster14$._id,
          label: val === null || val === void 0 ? void 0 : (_val$AllergyMaster15 = val.AllergyMaster) === null || _val$AllergyMaster15 === void 0 ? void 0 : (_val$AllergyMaster15$ = _val$AllergyMaster15.extsystemsourceid) === null || _val$AllergyMaster15$ === void 0 ? void 0 : _val$AllergyMaster15$.shortdesc
        } : {},
        id: (_val$AllergyMaster$id = val === null || val === void 0 ? void 0 : (_val$AllergyMaster16 = val.AllergyMaster) === null || _val$AllergyMaster16 === void 0 ? void 0 : _val$AllergyMaster16.id) !== null && _val$AllergyMaster$id !== void 0 ? _val$AllergyMaster$id : "",
        longdesc: (_val$AllergyMaster$lo = val === null || val === void 0 ? void 0 : (_val$AllergyMaster17 = val.AllergyMaster) === null || _val$AllergyMaster17 === void 0 ? void 0 : _val$AllergyMaster17.longdesc) !== null && _val$AllergyMaster$lo !== void 0 ? _val$AllergyMaster$lo : "",
        shortdesc: (_val$AllergyMaster$sh = val === null || val === void 0 ? void 0 : (_val$AllergyMaster18 = val.AllergyMaster) === null || _val$AllergyMaster18 === void 0 ? void 0 : _val$AllergyMaster18.shortdesc) !== null && _val$AllergyMaster$sh !== void 0 ? _val$AllergyMaster$sh : "",
        status: (_val$AllergyMaster$st = val === null || val === void 0 ? void 0 : (_val$AllergyMaster19 = val.AllergyMaster) === null || _val$AllergyMaster19 === void 0 ? void 0 : _val$AllergyMaster19.status) !== null && _val$AllergyMaster$st !== void 0 ? _val$AllergyMaster$st : true
      };
      arr.push(obj);
    });
  }

  return arr;
};

var masterQuery$1 = {
  allergyTypeIndicator: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodingMaster\",\n    \"filter\": \"CodingMaster.Type == 'ALTYPE' && CodingMaster.status == true && CodingMaster.activestatus == true\",\n    \"return_fields\": \"keep(CodingMaster,'_key','_id','code','display','Type','status')\",\n    \"sort\": \"CodingMaster.display\"\n  }"),
  conceptIdType: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodingMaster\",\n    \"filter\": \"CodingMaster.Type == 'CONCEPTIDTTYPE' && CodingMaster.status == true && CodingMaster.activestatus == true\",\n    \"return_fields\": \"keep(CodingMaster,'_key','_id','code','display','Type','status')\",\n    \"sort\": \"CodingMaster.display\"\n  }"),
  extSystemSourceId: "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodingMaster\",\n    \"filter\": \"CodingMaster.Type == 'DBSOURCE' && CodingMaster.status == true && CodingMaster.activestatus == true\",\n    \"return_fields\": \"keep(CodingMaster,'_key','_id','code','display','Type','status')\",\n    \"sort\": \"CodingMaster.display\"\n  }")
};

var _extraReducers$5;
var fileds = ["allergyTypeIndicator", "conceptIdType", "extSystemSourceId"];

var loopMasters$1 = function loopMasters() {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject) {
      var calls;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              calls = Object.keys(masterQuery$1).map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return fetchMaster$1(val, masterQuery$1[val]);

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
              es6Promise.Promise.all(calls).then(function (data) {
                var json = {};
                data.map(function (val) {
                  var arr = [];
                  val.data.map(function (value) {
                    if (fileds.includes(val.name)) {
                      arr.push({
                        label: value === null || value === void 0 ? void 0 : value.display,
                        value: value === null || value === void 0 ? void 0 : value._id
                      });
                    }
                  });
                  json[val.name] = arr;
                  resolve(json);
                });
              })["catch"](function (err) {
                resolve([]);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var fetchMaster$1 = function fetchMaster(name, query) {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetchData({
                body: query
              }, __readDocumentUrl__);

            case 2:
              data = _context3.sent;
              resolve({
                data: data.result,
                name: name
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }());
};

var GET_ALLERGEN_MASTER = toolkit.createAsyncThunk("allergenMasterApiSlice/allergen_master_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref5,
      rejectWithValue,
      _page,
      _perpage,
      data,
      readJSON,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {
            page: page,
            perpage: perpage
          };
          _ref5 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref5.rejectWithValue;
          _context4.prev = 2;
          _page = payload.page, _perpage = payload.perpage;
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(query$1.getList(_page, _perpage))
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          readJSON = generateReadJSON(data !== null && data !== void 0 && data.result ? data === null || data === void 0 ? void 0 : data.result : null);
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: readJSON
          }));

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 14:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 11]]);
})));
var UPSERT_ALLERGEN_MASTER = toolkit.createAsyncThunk("allergenMasterApiSlice/save_allergen_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref7,
      rejectWithValue,
      dataList,
      queriesjson,
      data,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref7 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref7.rejectWithValue;
          _context5.prev = 2;
          dataList = payload.dataList;
          queriesjson = generateJson$1(dataList);
          _context5.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](2);
          alert(_context5.t0.message);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 11]]);
})));
var UPDATE_ALLERGEN_MASTER_STATUS = toolkit.createAsyncThunk("allergenMasterApiSlice/update_allergen_master_status", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref9,
      rejectWithValue,
      _key,
      status,
      queriesjson,
      data,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref9 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref9.rejectWithValue;
          _context6.prev = 2;
          _key = payload._key, status = payload.status;
          queriesjson = [{
            db_name: dbName,
            entity: "AllergyMaster",
            is_metadata: true,
            metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
            filter: {
              _key: "".concat(_key)
            },
            doc: {
              status: status
            }
          }];
          _context6.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context6.sent;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](2);
          alert(_context6.t0.message);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 15:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 11]]);
}))); //ALLERGEN_MASTER_MASTER

var ALLERGEN_MASTER_MASTER = toolkit.createAsyncThunk("allergenMasterApiSlice/allergen_master_masters", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var _ref11,
      rejectWithValue,
      data,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _ref11 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref11.rejectWithValue;
          _context7.prev = 2;
          _context7.next = 5;
          return loopMasters$1();

        case 5:
          data = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 12:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 9]]);
})));
var allergenMasterSlice = toolkit.createSlice({
  name: "allergenMasterApiSlice",
  initialState: {
    allergen_master_list: _objectSpread2({}, defaultState.List),
    allergen_master_master: _objectSpread2({}, defaultState.List),
    save_allergen_master: _objectSpread2({}, defaultState.Info),
    update_allergen_master_status: _objectSpread2({}, defaultState.Info)
  },
  extraReducers: (_extraReducers$5 = {}, _defineProperty(_extraReducers$5, GET_ALLERGEN_MASTER.fulfilled, function (state, action) {
    state.allergen_master_list.loading = false, state.allergen_master_list.error = false, state.allergen_master_list = action.payload;
  }), _defineProperty(_extraReducers$5, GET_ALLERGEN_MASTER.pending, function (state, action) {
    state.allergen_master_list.loading = true, state.allergen_master_list.error = false, state.allergen_master_list.loading = true;
  }), _defineProperty(_extraReducers$5, GET_ALLERGEN_MASTER.rejected, function (state, action) {
    state.allergen_master_list.loading = false, state.allergen_master_list.error = true, state.allergen_master_list = action.payload;
  }), _defineProperty(_extraReducers$5, ALLERGEN_MASTER_MASTER.fulfilled, function (state, action) {
    state.allergen_master_master.loading = false, state.allergen_master_master.error = false, state.allergen_master_master = action.payload;
  }), _defineProperty(_extraReducers$5, ALLERGEN_MASTER_MASTER.pending, function (state, action) {
    state.allergen_master_master.loading = true, state.allergen_master_master.error = false, state.allergen_master_master.loading = true;
  }), _defineProperty(_extraReducers$5, ALLERGEN_MASTER_MASTER.rejected, function (state, action) {
    state.allergen_master_master.loading = false, state.allergen_master_master.error = true, state.allergen_master_master = action.payload;
  }), _defineProperty(_extraReducers$5, UPSERT_ALLERGEN_MASTER.fulfilled, function (state, action) {
    state.save_allergen_master.loading = false, state.save_allergen_master.error = false, state.save_allergen_master = action.payload;
  }), _defineProperty(_extraReducers$5, UPSERT_ALLERGEN_MASTER.pending, function (state, action) {
    state.save_allergen_master.loading = true, state.save_allergen_master.error = false, state.save_allergen_master.loading = true;
  }), _defineProperty(_extraReducers$5, UPSERT_ALLERGEN_MASTER.rejected, function (state, action) {
    state.save_allergen_master.loading = false, state.save_allergen_master.error = true, state.save_allergen_master = action.payload;
  }), _defineProperty(_extraReducers$5, UPDATE_ALLERGEN_MASTER_STATUS.fulfilled, function (state, action) {
    state.update_allergen_master_status.loading = false, state.update_allergen_master_status.error = false, state.update_allergen_master_status = action.payload;
  }), _defineProperty(_extraReducers$5, UPDATE_ALLERGEN_MASTER_STATUS.pending, function (state, action) {
    state.update_allergen_master_status.loading = true, state.update_allergen_master_status.error = false, state.update_allergen_master_status.loading = true;
  }), _defineProperty(_extraReducers$5, UPDATE_ALLERGEN_MASTER_STATUS.rejected, function (state, action) {
    state.update_allergen_master_status.loading = false, state.update_allergen_master_status.error = true, state.update_allergen_master_status = action.payload;
  }), _extraReducers$5)
});
var allergenMasterActions = {
  GET_ALLERGEN_MASTER: GET_ALLERGEN_MASTER,
  ALLERGEN_MASTER_MASTER: ALLERGEN_MASTER_MASTER,
  UPSERT_ALLERGEN_MASTER: UPSERT_ALLERGEN_MASTER,
  UPDATE_ALLERGEN_MASTER_STATUS: UPDATE_ALLERGEN_MASTER_STATUS
};
var allergenMasterSlice$1 = allergenMasterSlice.reducer;

var flexQuery = {
  attributeTypeDropDown: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CodingMaster\",\n        \"filter\": \"CodingMaster.Type=='FLEXDATATYPE' && CodingMaster.activestatus==true && CodingMaster.status==true\",\n        \"return_fields\": \"KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')\",\n        \"sort\": \"CodingMaster.display\"\n      }"),
  numUomDropDown: "{\n        \"db_name\":\"".concat(dbName, "\",\n        \"entity\": \"CodingMaster\",\n        \"filter\": \"CodingMaster.Type=='UOM' && CodingMaster.activestatus==true && CodingMaster.status==true\",\n        \"return_fields\": \"KEEP(CodingMaster,'_id','id','_key','code','display','Type','status')\",\n        \"sort\": \"CodingMaster.display\"\n      }"),
  flexAttributeFullRead: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"CA_OrderAttribMaster\",\n        \"filter\": \"CA_OrderAttribMaster.activestatus==true\",\n        \"limit\": {\n          \"offset\": \"page\",\n          \"count\": \"perpage\",\n        },\n        \"return_fields\": \"merge(CA_OrderAttribMaster,{attribtype:document(CA_OrderAttribMaster.attribtype).display},{attribnumUOM:to_array(document(CA_OrderAttribMaster.attribnumUOM).display)})\"\n      }"),
  flexAttrFullRead: function flexAttrFullRead(page, perpage, search) {
    return {
      db_name: dbName,
      entity: "CA_OrderAttribMaster",
      filter: "(like (CA_OrderAttribMaster.attribcode,'%".concat(search, "%',true)) && CA_OrderAttribMaster.activestatus==true"),
      limit: {
        offset: page,
        count: perpage
      },
      return_fields: "merge(CA_OrderAttribMaster,{TotalCount:COUNT(FOR cnt IN CA_OrderAttribMaster RETURN cnt._key),attribtype:document(CA_OrderAttribMaster.attribtype).display},{attribnumUOM:to_array(document(CA_OrderAttribMaster.attribnumUOM).display)})",
      sort: "CA_OrderAttribMaster.createddate desc"
    };
  },
  flexStatusChange: function flexStatusChange(list, key) {
    return [{
      db_name: dbName,
      entity: "CA_OrderAttribMaster",
      is_metadata: true,
      filter: {
        _key: "".concat(key)
      },
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        status: list
      }
    }];
  },
  flexAttrSingleRead: function flexAttrSingleRead(key) {
    return {
      db_name: dbName,
      entity: "CA_OrderAttribMaster",
      filter: "CA_OrderAttribMaster._key=='".concat(key, "' && CA_OrderAttribMaster.activestatus==true"),
      return_fields: "merge(CA_OrderAttribMaster,{attribtype:document(CA_OrderAttribMaster.attribtype)},{attribnumUOM:(document(CA_OrderAttribMaster.attribnumUOM))})"
    };
  },
  flexAttrSearch: function flexAttrSearch(search) {
    return {
      db_name: dbName,
      entity: "CA_OrderAttribMaster",
      filter: "(like (CA_OrderAttribMaster.attribcode,'%".concat(search, "%',true)) && CA_OrderAttribMaster.activestatus==true"),
      return_fields: "merge(CA_OrderAttribMaster,{attribtype:document(CA_OrderAttribMaster.attribtype).display},{attribnumUOM:to_array(document(CA_OrderAttribMaster.attribnumUOM).display)})"
    };
  },
  flexAttrInsert: function flexAttrInsert(list, key) {
    var _list$attributeType, _list$attributeType3, _list$attributeType5, _list$attributeType7;

    var object = {};
    var filter = {};

    if (key) {
      filter = {
        filter: {
          _key: key
        }
      };
    }

    if ((list === null || list === void 0 ? void 0 : (_list$attributeType = list.attributeType) === null || _list$attributeType === void 0 ? void 0 : _list$attributeType.label) === "Numeric") {
      var _list$attributeType2, _list$numberMin, _list$numberMax, _list$numberUOM$value, _list$numberUOM;

      object = {
        id: 1,
        attribcode: list === null || list === void 0 ? void 0 : list.attributeCode,
        attriblabel: list === null || list === void 0 ? void 0 : list.attributeLable,
        attribtype: list === null || list === void 0 ? void 0 : (_list$attributeType2 = list.attributeType) === null || _list$attributeType2 === void 0 ? void 0 : _list$attributeType2.value,
        attribsize: list === null || list === void 0 ? void 0 : list.attributeSize,
        attribnumMin: (_list$numberMin = list === null || list === void 0 ? void 0 : list.numberMin) !== null && _list$numberMin !== void 0 ? _list$numberMin : 0,
        attribnumMax: (_list$numberMax = list === null || list === void 0 ? void 0 : list.numberMax) !== null && _list$numberMax !== void 0 ? _list$numberMax : 0,
        attribnumUOM: (_list$numberUOM$value = list === null || list === void 0 ? void 0 : (_list$numberUOM = list.numberUOM) === null || _list$numberUOM === void 0 ? void 0 : _list$numberUOM.value) !== null && _list$numberUOM$value !== void 0 ? _list$numberUOM$value : "",
        status: true
      };
    }

    if ((list === null || list === void 0 ? void 0 : (_list$attributeType3 = list.attributeType) === null || _list$attributeType3 === void 0 ? void 0 : _list$attributeType3.label) === "Text Box") {
      var _list$attributeType4;

      object = {
        id: 1,
        attribcode: list === null || list === void 0 ? void 0 : list.attributeCode,
        attriblabel: list === null || list === void 0 ? void 0 : list.attributeLable,
        attribtype: list === null || list === void 0 ? void 0 : (_list$attributeType4 = list.attributeType) === null || _list$attributeType4 === void 0 ? void 0 : _list$attributeType4.value,
        attribsize: list === null || list === void 0 ? void 0 : list.attributeSize,
        status: true
      };
    }

    if ((list === null || list === void 0 ? void 0 : (_list$attributeType5 = list.attributeType) === null || _list$attributeType5 === void 0 ? void 0 : _list$attributeType5.label) === "Boolean") {
      var _list$attributeType6;

      object = {
        id: 1,
        attribcode: list === null || list === void 0 ? void 0 : list.attributeCode,
        attriblabel: list === null || list === void 0 ? void 0 : list.attributeLable,
        attribtype: list === null || list === void 0 ? void 0 : (_list$attributeType6 = list.attributeType) === null || _list$attributeType6 === void 0 ? void 0 : _list$attributeType6.value,
        AttribValidValues: list === null || list === void 0 ? void 0 : list["boolean"].map(function (val) {
          return {
            dispSeq: val === null || val === void 0 ? void 0 : val.seqNo,
            validCode: val === null || val === void 0 ? void 0 : val.validCode,
            validdisplayValue: val === null || val === void 0 ? void 0 : val.displayValidCode,
            Dfltflag: val === null || val === void 0 ? void 0 : val.active
          };
        }),
        status: true
      };
    }

    if ((list === null || list === void 0 ? void 0 : (_list$attributeType7 = list.attributeType) === null || _list$attributeType7 === void 0 ? void 0 : _list$attributeType7.label) === "List") {
      var _list$attributeType8;

      object = {
        id: 1,
        attribcode: list === null || list === void 0 ? void 0 : list.attributeCode,
        attriblabel: list === null || list === void 0 ? void 0 : list.attributeLable,
        attribtype: list === null || list === void 0 ? void 0 : (_list$attributeType8 = list.attributeType) === null || _list$attributeType8 === void 0 ? void 0 : _list$attributeType8.value,
        AttribValidValues: list === null || list === void 0 ? void 0 : list.forText.map(function (val) {
          return {
            dispSeq: val === null || val === void 0 ? void 0 : val.seqNo,
            validCode: val === null || val === void 0 ? void 0 : val.validCode,
            validdisplayValue: val === null || val === void 0 ? void 0 : val.displayValidCode,
            Dfltflag: val === null || val === void 0 ? void 0 : val.active
          };
        }),
        status: true
      };
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "CA_OrderAttribMaster",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd"
    }, filter), {}, {
      doc: _objectSpread2({}, object)
    })];
  }
};

var _extraReducers$4;
var ATTRIBUTE_TYPE_DROPDOWN = toolkit.createAsyncThunk("flexAttributeApiSlice/attriuteTypeDropDown", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      data,
      arr,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          _context.next = 5;
          return fetchData({
            body: flexQuery.attributeTypeDropDown
          }, __readDocumentUrl__);

        case 5:
          data = _context.sent;
          arr = [];
          data && data.result.map(function (val) {
            arr.push({
              value: val._id,
              label: val.display
            });
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 11]]);
})));
var UOM_NUM_DROPDOWN = toolkit.createAsyncThunk("flexAttributeApiSlice/numUOMDropDown", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var _ref4,
      rejectWithValue,
      data,
      arr,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          _context2.next = 5;
          return fetchData({
            body: flexQuery.numUomDropDown
          }, __readDocumentUrl__);

        case 5:
          data = _context2.sent;
          arr = [];
          data && data.result.map(function (val) {
            arr.push({
              value: val._id,
              label: val.display
            });
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var FLEX_ATTRIBUTE_READ = toolkit.createAsyncThunk("flexAttributeApiSlice/flexFullRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      page,
      perpage,
      search,
      data,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          page = payload.page, perpage = payload.perpage, search = payload.search;
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(flexQuery.flexAttrFullRead(page, perpage, search))
          }, __readDocumentUrl__);

        case 6:
          data = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 10]]);
})));
var FLEX_ATTRIBUTE_SINGLE_READ = toolkit.createAsyncThunk("flexAttributeApiSlice/flexSingleRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      key,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          key = payload.key;
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(flexQuery.flexAttrSingleRead(key))
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 10]]);
})));
var FLEX_ATTRIBUTE_SEARCH = toolkit.createAsyncThunk("flexAttributeApiSlice/flexSearch", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      search,
      data,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          search = payload.search;
          _context5.next = 6;
          return fetchData({
            body: JSON.stringify(flexQuery.flexAttrSearch(search))
          }, __readDocumentUrl__);

        case 6:
          data = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context5.prev = 10;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 13:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 10]]);
})));
var FLEX_ATTRIBUTE_INSERT = toolkit.createAsyncThunk("flexAttributeApiSlice/flexInsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref12,
      rejectWithValue,
      list,
      key,
      data,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          list = payload.list, key = payload.key;
          _context6.next = 6;
          return fetchData({
            body: JSON.stringify(flexQuery.flexAttrInsert(list, key))
          }, __uspsertUrl__);

        case 6:
          data = _context6.sent;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context6.prev = 10;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 13:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 10]]);
})));
var FLEX_ATTRIBUTE_STATUS = toolkit.createAsyncThunk("flexAttributeApiSlice/flexStatus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      list,
      key,
      data,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          list = payload.list, key = payload.key;
          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(flexQuery.flexStatusChange(list, key))
          }, __uspsertUrl__);

        case 6:
          data = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context7.prev = 10;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 13:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 10]]);
})));
var flexAttributeSlice = toolkit.createSlice({
  name: "flexAttributeApiSlice",
  initialState: {
    attributeType_DropDown: _objectSpread2({}, defaultState.List),
    numUOM_DropDown: _objectSpread2({}, defaultState.List),
    flexFull_Read: _objectSpread2({}, defaultState.List),
    flex_Insert: _objectSpread2({}, defaultState.List),
    flex_single_read: _objectSpread2({}, defaultState.List),
    flex_status_change: _objectSpread2({}, defaultState.List),
    flex_search: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$4 = {}, _defineProperty(_extraReducers$4, ATTRIBUTE_TYPE_DROPDOWN.fulfilled, function (state, action) {
    state.attributeType_DropDown.loading = false, state.attributeType_DropDown.error = false, state.attributeType_DropDown = action.payload;
  }), _defineProperty(_extraReducers$4, ATTRIBUTE_TYPE_DROPDOWN.pending, function (state, action) {
    state.attributeType_DropDown.loading = true, state.attributeType_DropDown.error = false, state.attributeType_DropDown.loading = true;
  }), _defineProperty(_extraReducers$4, ATTRIBUTE_TYPE_DROPDOWN.rejected, function (state, action) {
    state.attributeType_DropDown.loading = false, state.attributeType_DropDown.error = true, state.attributeType_DropDown = action.payload;
  }), _defineProperty(_extraReducers$4, UOM_NUM_DROPDOWN.fulfilled, function (state, action) {
    state.numUOM_DropDown.loading = false, state.numUOM_DropDown.error = false, state.numUOM_DropDown = action.payload;
  }), _defineProperty(_extraReducers$4, UOM_NUM_DROPDOWN.pending, function (state, action) {
    state.numUOM_DropDown.loading = true, state.numUOM_DropDown.error = false, state.numUOM_DropDown.loading = true;
  }), _defineProperty(_extraReducers$4, UOM_NUM_DROPDOWN.rejected, function (state, action) {
    state.numUOM_DropDown.loading = false, state.numUOM_DropDown.error = true, state.numUOM_DropDown = action.payload;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_READ.fulfilled, function (state, action) {
    state.flexFull_Read.loading = false, state.flexFull_Read.error = false, state.flexFull_Read = action.payload;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_READ.pending, function (state, action) {
    state.flexFull_Read.loading = true, state.flexFull_Read.error = false, state.flexFull_Read.loading = true;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_READ.rejected, function (state, action) {
    state.flexFull_Read.loading = false, state.flexFull_Read.error = true, state.flexFull_Read = action.payload;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_INSERT.fulfilled, function (state, action) {
    state.flex_Insert.loading = false, state.flex_Insert.error = false, state.flex_Insert = action.payload;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_INSERT.pending, function (state, action) {
    state.flex_Insert.loading = true, state.flex_Insert.error = false, state.flex_Insert.loading = true;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_INSERT.rejected, function (state, action) {
    state.flex_Insert.loading = false, state.flex_Insert.error = true, state.flex_Insert = action.payload;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_SINGLE_READ.fulfilled, function (state, action) {
    state.flex_single_read.loading = false, state.flex_single_read.error = false, state.flex_single_read = action.payload;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_SINGLE_READ.pending, function (state, action) {
    state.flex_single_read.loading = true, state.flex_single_read.error = false, state.flex_single_read.loading = true;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_SINGLE_READ.rejected, function (state, action) {
    state.flex_single_read.loading = false, state.flex_single_read.error = true, state.flex_single_read = action.payload;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_STATUS.fulfilled, function (state, action) {
    state.flex_status_change.loading = false, state.flex_status_change.error = false, state.flex_status_change = action.payload;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_STATUS.pending, function (state, action) {
    state.flex_status_change.loading = true, state.flex_status_change.error = false, state.flex_status_change.loading = true;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_STATUS.rejected, function (state, action) {
    state.flex_status_change.loading = false, state.flex_status_change.error = true, state.flex_status_change = action.payload;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_SEARCH.fulfilled, function (state, action) {
    state.flex_search.loading = false, state.flex_search.error = false, state.flex_search = action.payload;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_SEARCH.pending, function (state, action) {
    state.flex_search.loading = true, state.flex_search.error = false, state.flex_search.loading = true;
  }), _defineProperty(_extraReducers$4, FLEX_ATTRIBUTE_SEARCH.rejected, function (state, action) {
    state.flex_search.loading = false, state.flex_search.error = true, state.flex_search = action.payload;
  }), _extraReducers$4)
});
var flexAttributeActions = {
  ATTRIBUTE_TYPE_DROPDOWN: ATTRIBUTE_TYPE_DROPDOWN,
  UOM_NUM_DROPDOWN: UOM_NUM_DROPDOWN,
  FLEX_ATTRIBUTE_READ: FLEX_ATTRIBUTE_READ,
  FLEX_ATTRIBUTE_INSERT: FLEX_ATTRIBUTE_INSERT,
  FLEX_ATTRIBUTE_SINGLE_READ: FLEX_ATTRIBUTE_SINGLE_READ,
  FLEX_ATTRIBUTE_STATUS: FLEX_ATTRIBUTE_STATUS
};
var flexAttributeSlice$1 = flexAttributeSlice.reducer;

var flexCriteriaQuery = {
  flexCriteriaDropDown: function flexCriteriaDropDown(list, id) {
    return {
      db_name: dbName,
      entity: "CA_OrderAttribMaster",
      filter: "CA_OrderAttribMaster.attribcode=='".concat(list, "' && CA_OrderAttribMaster.attribtype=='").concat(id, "' && CA_OrderAttribMaster.status==true && CA_OrderAttribMaster.activestatus==true"),
      return_fields: "MERGE(CA_OrderAttribMaster,{AttribValidValues:first((for att in TO_ARRAY(CA_OrderAttribMaster.AttribValidValues) filter att.Dfltflag==true return att.validdisplayValue))},{attribtype:document(CA_OrderAttribMaster.attribtype).display},{attribnumUOM:document(CA_OrderAttribMaster.attribnumUOM).display})"
    };
  },
  flexCriteriaCodeDropDown: function flexCriteriaCodeDropDown() {
    return {
      db_name: dbName,
      entity: "CA_OrderAttribMaster",
      filter: "CA_OrderAttribMaster.status == true && CA_OrderAttribMaster.activestatus == true",
      return_fields: "keep(CA_OrderAttribMaster,'_key','_id','attribcode','attriblabel','status','attribtype')",
      sort: "CA_OrderAttribMaster.attriblabel"
    };
  },
  flexCriteriaFullRead: function flexCriteriaFullRead(page, perpage, search) {
    return {
      db_name: dbName,
      entity: "CA_FlexAttribApplicability",
      filter: "(LIKE (CA_FlexAttribApplicability.winlabelName,'%".concat(search, "%', true)) && CA_FlexAttribApplicability.activestatus == true"),
      limit: {
        offset: page,
        count: perpage
      },
      return_fields: "merge(CA_FlexAttribApplicability, {TotalCount:COUNT(FOR cnt IN CA_FlexAttribApplicability RETURN cnt._key)},{AttribComponents:( for att in CA_FlexAttribApplicability.AttribComponents return merge(att,{attribCode:merge(document(att.attribCode),{attribtype:document(document(att.attribCode).attribtype)})}) )})",
      sort: "CA_FlexAttribApplicability.createddate desc"
    };
  },
  flexCriteriaSingleRead: function flexCriteriaSingleRead(key) {
    return {
      db_name: dbName,
      entity: "CA_FlexAttribApplicability",
      filter: "CA_FlexAttribApplicability._key == '".concat(key, "' && CA_FlexAttribApplicability.activestatus == true"),
      return_fields: "merge(CA_FlexAttribApplicability,{AttribComponents:(for att in CA_FlexAttribApplicability.AttribComponents return merge(att,{attribCode:document((CA_FlexAttribApplicability.AttribComponents)[*].attribCode)}))})"
    };
  },
  flexCriteriaInsert: function flexCriteriaInsert(list) {
    var _list$attributeLableN, _list$attributeCompon;

    return [{
      db_name: dbName,
      entity: "CA_FlexAttribApplicability",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        id: 1,
        attribusageCriteria: [list === null || list === void 0 ? void 0 : list.attributeLableName],
        winlabelName: (_list$attributeLableN = list === null || list === void 0 ? void 0 : list.attributeLableName) !== null && _list$attributeLableN !== void 0 ? _list$attributeLableN : "",
        AttribComponents: list === null || list === void 0 ? void 0 : (_list$attributeCompon = list.attributeComponents) === null || _list$attributeCompon === void 0 ? void 0 : _list$attributeCompon.map(function (val) {
          var _val$code, _val$defaultValue$lab, _val$defaultValue;

          return {
            attribSeq: val === null || val === void 0 ? void 0 : val.seqNo,
            attribCode: val === null || val === void 0 ? void 0 : (_val$code = val.code) === null || _val$code === void 0 ? void 0 : _val$code.value,
            attribdefaultVal: (_val$defaultValue$lab = val === null || val === void 0 ? void 0 : (_val$defaultValue = val.defaultValue) === null || _val$defaultValue === void 0 ? void 0 : _val$defaultValue.label) !== null && _val$defaultValue$lab !== void 0 ? _val$defaultValue$lab : ""
          };
        }),
        status: true
      }
    }];
  },
  flexCriteriaStatus: function flexCriteriaStatus(status, key) {
    return [{
      db_name: dbName,
      entity: "CA_FlexAttribApplicability",
      filter: {
        _key: key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        status: status
      }
    }];
  },
  flexCriteriaEdit: function flexCriteriaEdit(list) {
    var _list$attributeLableN2, _list$status;

    return [{
      db_name: dbName,
      entity: "CA_FlexAttribApplicability",
      filter: {
        _key: list === null || list === void 0 ? void 0 : list.key
      },
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        winlabelName: (_list$attributeLableN2 = list === null || list === void 0 ? void 0 : list.attributeLableName) !== null && _list$attributeLableN2 !== void 0 ? _list$attributeLableN2 : "",
        // AttribComponents: [
        //   {
        //     attribCode: "string",
        //     attribdefaultVal: "string",
        //   },
        // ],
        AttribComponents: list === null || list === void 0 ? void 0 : list.attributeComponents.map(function (val) {
          var _val$code2, _val$defaultValue$lab2, _val$defaultValue2;

          return {
            attribCode: val === null || val === void 0 ? void 0 : (_val$code2 = val.code) === null || _val$code2 === void 0 ? void 0 : _val$code2.value,
            attribdefaultVal: (_val$defaultValue$lab2 = val === null || val === void 0 ? void 0 : (_val$defaultValue2 = val.defaultValue) === null || _val$defaultValue2 === void 0 ? void 0 : _val$defaultValue2.label) !== null && _val$defaultValue$lab2 !== void 0 ? _val$defaultValue$lab2 : ""
          };
        }),
        status: (_list$status = list === null || list === void 0 ? void 0 : list.status) !== null && _list$status !== void 0 ? _list$status : true
      }
    }];
  },
  flexCriteriaSearch: function flexCriteriaSearch(search) {
    return {
      db_name: dbName,
      entity: "CA_FlexAttribApplicability",
      filter: "(LIKE (CA_FlexAttribApplicability.winlabelName,'%".concat(search, "%', true)) && CA_FlexAttribApplicability.activestatus == true"),
      return_fields: "merge(CA_FlexAttribApplicability,{AttribComponents:(for att in CA_FlexAttribApplicability.AttribComponents return merge(att,{attribCode:document((CA_FlexAttribApplicability.AttribComponents)[*].attribCode)}))})"
    };
  }
};

var _extraReducers$3;
var FLEX_CRITERIA_DEFAULT_DROPDOWN = toolkit.createAsyncThunk("flexCriteriaSlice/flexCriteriaDropDown", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      list,
      id,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          list = payload.list, id = payload.id;
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(flexCriteriaQuery.flexCriteriaDropDown(list, id))
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data === null || data === void 0 ? void 0 : data.result
          }));

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 10]]);
})));
var FLEX_CRITERIA_CODE = toolkit.createAsyncThunk("flexCriteriaSlice/flexCriteriaCodeDropDown", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var _ref4,
      rejectWithValue,
      data,
      arr,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          _context2.next = 5;
          return fetchData({
            body: JSON.stringify(flexCriteriaQuery.flexCriteriaCodeDropDown())
          }, __readDocumentUrl__);

        case 5:
          data = _context2.sent;
          arr = [];
          data && data.result.map(function (val) {
            arr.push({
              label: (val === null || val === void 0 ? void 0 : val.attriblabel) + " (" + (val === null || val === void 0 ? void 0 : val.attribcode) + ")",
              value: val === null || val === void 0 ? void 0 : val._id,
              type: val === null || val === void 0 ? void 0 : val.attribtype,
              code: val === null || val === void 0 ? void 0 : val.attribcode
            });
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arr
          }));

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 11]]);
})));
var FLEX_CRITERIA_FULL_READ = toolkit.createAsyncThunk("flexCriteriaSlice/flexCriteriaFullRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      page,
      perpage,
      search,
      data,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          page = payload.page, perpage = payload.perpage, search = payload.search;
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(flexCriteriaQuery.flexCriteriaFullRead(page, perpage, search))
          }, __readDocumentUrl__);

        case 6:
          data = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data === null || data === void 0 ? void 0 : data.result
          }));

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 10]]);
})));
var FLEX_CRITERIA_SINGLE_READ = toolkit.createAsyncThunk("flexCriteriaSlice/flexCriteriaSigleRead", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      key,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          key = payload.key;
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(flexCriteriaQuery.flexCriteriaSingleRead(key))
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data === null || data === void 0 ? void 0 : data.result
          }));

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 10]]);
})));
var FLEX_CRITERIA_INSERT = toolkit.createAsyncThunk("flexCriteriaSlice/flexCriteriaInsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref10,
      rejectWithValue,
      list,
      data,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          list = payload.list;
          _context5.next = 6;
          return fetchData({
            body: JSON.stringify(flexCriteriaQuery.flexCriteriaInsert(list))
          }, __uspsertUrl__);

        case 6:
          data = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context5.prev = 10;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 13:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 10]]);
})));
var FLEX_CRITERIA_STATUS = toolkit.createAsyncThunk("flexCriteriaSlice/flexCriteriaStatus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref12,
      rejectWithValue,
      status,
      key,
      data,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          status = payload.status, key = payload.key;
          _context6.next = 6;
          return fetchData({
            body: JSON.stringify(flexCriteriaQuery.flexCriteriaStatus(status, key))
          }, __uspsertUrl__);

        case 6:
          data = _context6.sent;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context6.prev = 10;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 13:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 10]]);
})));
var FLEX_CRITERIA_EDIT = toolkit.createAsyncThunk("flexCriteriaSlice/flexCriteriaEdit", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      list,
      data,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          list = payload.list;
          _context7.next = 6;
          return fetchData({
            body: JSON.stringify(flexCriteriaQuery.flexCriteriaEdit(list))
          }, __uspsertUrl__);

        case 6:
          data = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 10:
          _context7.prev = 10;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 13:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 10]]);
})));
var FLEX_CRITERIA_SEARCH = toolkit.createAsyncThunk("flexCriteriaSlice/flexCriteriaSearch", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref16,
      rejectWithValue,
      search,
      data,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref16 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref16.rejectWithValue;
          _context8.prev = 2;
          search = payload.search;
          _context8.next = 6;
          return fetchData({
            body: JSON.stringify(flexCriteriaQuery.flexCriteriaSearch(search))
          }, __readDocumentUrl__);

        case 6:
          data = _context8.sent;
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 10:
          _context8.prev = 10;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 13:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 10]]);
})));
var flexCriteriaSlice = toolkit.createSlice({
  name: "flexCriteriaSlice",
  initialState: {
    flex_criteria_dropdown: _objectSpread2({}, defaultState.List),
    flex_criteria_code_dropdown: _objectSpread2({}, defaultState.List),
    flex_criteria_fullRead: _objectSpread2({}, defaultState.List),
    flex_criteria_singleRead: _objectSpread2({}, defaultState.List),
    flex_criteria_insert: _objectSpread2({}, defaultState.List),
    flex_criteria_status: _objectSpread2({}, defaultState.List),
    flex_criteria_edit: _objectSpread2({}, defaultState.List),
    flex_criteria_search: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$3 = {}, _defineProperty(_extraReducers$3, FLEX_CRITERIA_DEFAULT_DROPDOWN.fulfilled, function (state, action) {
    state.flex_criteria_dropdown.loading = false, state.flex_criteria_dropdown.error = false, state.flex_criteria_dropdown = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_DEFAULT_DROPDOWN.pending, function (state, action) {
    state.flex_criteria_dropdown.loading = true, state.flex_criteria_dropdown.error = false, state.flex_criteria_dropdown.loading = true;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_DEFAULT_DROPDOWN.rejected, function (state, action) {
    state.flex_criteria_dropdown.loading = false, state.flex_criteria_dropdown.error = true, state.flex_criteria_dropdown = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_CODE.fulfilled, function (state, action) {
    state.flex_criteria_code_dropdown.loading = false, state.flex_criteria_code_dropdown.error = false, state.flex_criteria_code_dropdown = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_CODE.pending, function (state, action) {
    state.flex_criteria_code_dropdown.loading = true, state.flex_criteria_code_dropdown.error = false, state.flex_criteria_code_dropdown.loading = true;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_CODE.rejected, function (state, action) {
    state.flex_criteria_code_dropdown.loading = false, state.flex_criteria_code_dropdown.error = true, state.flex_criteria_code_dropdown = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_FULL_READ.fulfilled, function (state, action) {
    state.flex_criteria_fullRead.loading = false, state.flex_criteria_fullRead.error = false, state.flex_criteria_fullRead = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_FULL_READ.pending, function (state, action) {
    state.flex_criteria_fullRead.loading = true, state.flex_criteria_fullRead.error = false, state.flex_criteria_fullRead.loading = true;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_FULL_READ.rejected, function (state, action) {
    state.flex_criteria_fullRead.loading = false, state.flex_criteria_fullRead.error = true, state.flex_criteria_fullRead = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_SINGLE_READ.fulfilled, function (state, action) {
    state.flex_criteria_singleRead.loading = false, state.flex_criteria_singleRead.error = false, state.flex_criteria_singleRead = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_SINGLE_READ.pending, function (state, action) {
    state.flex_criteria_singleRead.loading = true, state.flex_criteria_singleRead.error = false, state.flex_criteria_singleRead.loading = true;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_SINGLE_READ.rejected, function (state, action) {
    state.flex_criteria_singleRead.loading = false, state.flex_criteria_singleRead.error = true, state.flex_criteria_singleRead = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_INSERT.fulfilled, function (state, action) {
    state.flex_criteria_insert.loading = false, state.flex_criteria_insert.error = false, state.flex_criteria_insert = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_INSERT.pending, function (state, action) {
    state.flex_criteria_insert.loading = true, state.flex_criteria_insert.error = false, state.flex_criteria_insert.loading = true;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_INSERT.rejected, function (state, action) {
    state.flex_criteria_insert.loading = false, state.flex_criteria_insert.error = true, state.flex_criteria_insert = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_STATUS.fulfilled, function (state, action) {
    state.flex_criteria_status.loading = false, state.flex_criteria_status.error = false, state.flex_criteria_status = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_STATUS.pending, function (state, action) {
    state.flex_criteria_status.loading = true, state.flex_criteria_status.error = false, state.flex_criteria_status.loading = true;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_STATUS.rejected, function (state, action) {
    state.flex_criteria_status.loading = false, state.flex_criteria_status.error = true, state.flex_criteria_status = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_EDIT.fulfilled, function (state, action) {
    state.flex_criteria_edit.loading = false, state.flex_criteria_edit.error = false, state.flex_criteria_edit = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_EDIT.pending, function (state, action) {
    state.flex_criteria_edit.loading = true, state.flex_criteria_edit.error = false, state.flex_criteria_edit.loading = true;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_EDIT.rejected, function (state, action) {
    state.flex_criteria_edit.loading = false, state.flex_criteria_edit.error = true, state.flex_criteria_edit = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_SEARCH.fulfilled, function (state, action) {
    state.flex_criteria_search.loading = false, state.flex_criteria_search.error = false, state.flex_criteria_search = action.payload;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_SEARCH.pending, function (state, action) {
    state.flex_criteria_search.loading = true, state.flex_criteria_search.error = false, state.flex_criteria_search.loading = true;
  }), _defineProperty(_extraReducers$3, FLEX_CRITERIA_SEARCH.rejected, function (state, action) {
    state.flex_criteria_search.loading = false, state.flex_criteria_search.error = true, state.flex_criteria_search = action.payload;
  }), _extraReducers$3)
});
var flexCriteriaActions = {
  FLEX_CRITERIA_DEFAULT_DROPDOWN: FLEX_CRITERIA_DEFAULT_DROPDOWN,
  FLEX_CRITERIA_CODE: FLEX_CRITERIA_CODE,
  FLEX_CRITERIA_FULL_READ: FLEX_CRITERIA_FULL_READ,
  FLEX_CRITERIA_SINGLE_READ: FLEX_CRITERIA_SINGLE_READ,
  FLEX_CRITERIA_INSERT: FLEX_CRITERIA_INSERT,
  FLEX_CRITERIA_STATUS: FLEX_CRITERIA_STATUS,
  FLEX_CRITERIA_EDIT: FLEX_CRITERIA_EDIT,
  FLEX_CRITERIA_SEARCH: FLEX_CRITERIA_SEARCH
};
var flexCriteriaSlice$1 = flexCriteriaSlice.reducer;

var query = {
  diagnosisList: function diagnosisList(level, code) {
    //         "db_name": `${dbName}`,
    //         "filter": {
    //             "icdcode": code??"",
    //             "parentlvnum": parentvl,
    //             "childlvnum": childvl
    //         },
    //         "queryid": "9fabdc11-1864-432d-9916-bf36c5d9cc57"
    //     }

    return {
      "db_name": "".concat(dbName),
      "entity": "Diagnosis",
      "filter": "Diagnosis.levelnumber == -1 && Diagnosis.activestatus == true",
      "return_fields": "Diagnosis",
      "sort": "Diagnosis.icdname"
    };
  },
  diagnosisListChild: function diagnosisListChild(level, code) {
    var childvl = level + 1;
    return {
      "db_name": "".concat(dbName),
      "entity": "Diagnosis",
      "filter": "Diagnosis.parenticdcode=='".concat(code, "' && Diagnosis.levelnumber == ").concat(childvl, " && Diagnosis.activestatus==true"),
      "return_fields": "Diagnosis",
      "sort": "Diagnosis.icdname"
    };
  },
  updateListeffTo: function updateListeffTo(data) {
    var _data$effTo;

    return [{
      "db_name": "".concat(dbName),
      "entity": "Diagnosis",
      "is_metadata": true,
      "filter": {
        "_key": "".concat(data === null || data === void 0 ? void 0 : data.key)
      },
      "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
      "doc": {
        "effTo": (_data$effTo = data === null || data === void 0 ? void 0 : data.effTo) !== null && _data$effTo !== void 0 ? _data$effTo : null
      }
    }];
  },
  searchList: function searchList(text) {
    return {
      "db_name": "".concat(dbName),
      "entity": "Diagnosis",
      "filter": "(LIKE (Diagnosis.icdcode, '%".concat(text, "%', true) || LIKE (Diagnosis.icdname, '%").concat(text, "%', true)) && Diagnosis.activestatus==true limit 50"),
      "return_fields": "Diagnosis",
      "sort": "Diagnosis.icdname"
    };
  }
};

var _extraReducers$2;

var GET_DIAGNOSIS_LIST = toolkit.createAsyncThunk("diagnosisMasterApiSlice/diagnosis_master_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var payload,
      _ref2,
      rejectWithValue,
      _data$result,
      code,
      level,
      data,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          code = payload.code, level = payload.level;
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(query.diagnosisList(level, code))
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: (_data$result = data === null || data === void 0 ? void 0 : data.result) !== null && _data$result !== void 0 ? _data$result : null
          }));

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context.t0.message
          })));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 10]]);
}))); // GET_DIAGNOSIS_LIST_CHILD

var GET_DIAGNOSIS_LIST_CHILD = toolkit.createAsyncThunk("diagnosisMasterApiSlice/diagnosis_master_list_child", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var payload,
      _ref4,
      rejectWithValue,
      _data$result2,
      code,
      level,
      data,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          code = payload.code, level = payload.level;
          _context2.next = 6;
          return fetchData({
            body: JSON.stringify(query.diagnosisListChild(level, code))
          }, __readDocumentUrl__);

        case 6:
          data = _context2.sent;
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: (_data$result2 = data === null || data === void 0 ? void 0 : data.result) !== null && _data$result2 !== void 0 ? _data$result2 : null
          }));

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context2.t0.message
          })));

        case 13:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 10]]);
}))); // UPDATE_DIAGNOSIS_LIST

var UPDATE_DIAGNOSIS_LIST = toolkit.createAsyncThunk("diagnosisMasterApiSlice/update_diagnosis_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var payload,
      _ref6,
      rejectWithValue,
      _data$Result,
      dataPay,
      data,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          payload = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          dataPay = payload;
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(query.updateListeffTo(dataPay))
          }, __uspsertUrl__);

        case 6:
          data = _context3.sent;
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: (_data$Result = data === null || data === void 0 ? void 0 : data.Result) !== null && _data$Result !== void 0 ? _data$Result : null
          }));

        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context3.t0.message
          })));

        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 10]]);
}))); // SEARCH_LIST

var SEARCH_LIST = toolkit.createAsyncThunk("diagnosisMasterApiSlice/diagnosis_master_list_search", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref8,
      rejectWithValue,
      _data$result3,
      text,
      data,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          text = payload.text;
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(query.searchList(text))
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: (_data$result3 = data === null || data === void 0 ? void 0 : data.result) !== null && _data$result3 !== void 0 ? _data$result3 : null
          }));

        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context4.t0.message
          })));

        case 13:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 10]]);
})));
var diagnosisMasterSlice = toolkit.createSlice({
  name: "diagnosisMasterApiSlice",
  initialState: {
    diagnosis_master_list: _objectSpread2({}, defaultState.List),
    diagnosis_master_list_child: _objectSpread2({}, defaultState.List),
    update_diagnosis_list: _objectSpread2({}, defaultState.List),
    diagnosis_master_list_search: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$2 = {}, _defineProperty(_extraReducers$2, GET_DIAGNOSIS_LIST.fulfilled, function (state, action) {
    state.diagnosis_master_list.loading = false, state.diagnosis_master_list.error = false, state.diagnosis_master_list = action.payload;
  }), _defineProperty(_extraReducers$2, GET_DIAGNOSIS_LIST.pending, function (state, action) {
    state.diagnosis_master_list.loading = true, state.diagnosis_master_list.error = false, state.diagnosis_master_list.loading = true;
  }), _defineProperty(_extraReducers$2, GET_DIAGNOSIS_LIST.rejected, function (state, action) {
    state.diagnosis_master_list.loading = false, state.diagnosis_master_list.error = true, state.diagnosis_master_list = action.payload;
  }), _defineProperty(_extraReducers$2, GET_DIAGNOSIS_LIST_CHILD.fulfilled, function (state, action) {
    state.diagnosis_master_list_child.loading = false, state.diagnosis_master_list_child.error = false, state.diagnosis_master_list_child = action.payload;
  }), _defineProperty(_extraReducers$2, GET_DIAGNOSIS_LIST_CHILD.pending, function (state, action) {
    state.diagnosis_master_list_child.loading = true, state.diagnosis_master_list_child.error = false, state.diagnosis_master_list_child.loading = true;
  }), _defineProperty(_extraReducers$2, GET_DIAGNOSIS_LIST_CHILD.rejected, function (state, action) {
    state.diagnosis_master_list_child.loading = false, state.diagnosis_master_list_child.error = true, state.diagnosis_master_list_child = action.payload;
  }), _defineProperty(_extraReducers$2, UPDATE_DIAGNOSIS_LIST.fulfilled, function (state, action) {
    state.update_diagnosis_list.loading = false, state.update_diagnosis_list.error = false, state.update_diagnosis_list = action.payload;
  }), _defineProperty(_extraReducers$2, UPDATE_DIAGNOSIS_LIST.pending, function (state, action) {
    state.update_diagnosis_list.loading = true, state.update_diagnosis_list.error = false, state.update_diagnosis_list.loading = true;
  }), _defineProperty(_extraReducers$2, UPDATE_DIAGNOSIS_LIST.rejected, function (state, action) {
    state.update_diagnosis_list.loading = false, state.update_diagnosis_list.error = true, state.update_diagnosis_list = action.payload;
  }), _defineProperty(_extraReducers$2, SEARCH_LIST.fulfilled, function (state, action) {
    state.diagnosis_master_list_search.loading = false, state.diagnosis_master_list_search.error = false, state.diagnosis_master_list_search = action.payload;
  }), _defineProperty(_extraReducers$2, SEARCH_LIST.pending, function (state, action) {
    state.diagnosis_master_list_search.loading = true, state.diagnosis_master_list_search.error = false, state.diagnosis_master_list_search.loading = true;
  }), _defineProperty(_extraReducers$2, SEARCH_LIST.rejected, function (state, action) {
    state.diagnosis_master_list_search.loading = false, state.diagnosis_master_list_search.error = true, state.diagnosis_master_list_search = action.payload;
  }), _extraReducers$2)
});
var diagnosisMasterActions = {
  GET_DIAGNOSIS_LIST: GET_DIAGNOSIS_LIST,
  GET_DIAGNOSIS_LIST_CHILD: GET_DIAGNOSIS_LIST_CHILD,
  UPDATE_DIAGNOSIS_LIST: UPDATE_DIAGNOSIS_LIST,
  SEARCH_LIST: SEARCH_LIST
};
var diagnosisMasterSlice$1 = diagnosisMasterSlice.reducer;

var index = redux.combineReducers({
  Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJReducer: Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJReducer$1,
  Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJReducer: Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJReducer$1,
  Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXXReducer: Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXXReducer$1,
  editcontactpointpharmacy_contact_contactmode_dropdown_zorJVReducer: editcontactpointpharmacy_contact_contactmode_dropdown_zorJVReducer$1,
  editcontactpointpharmacy_contact_use_dropdown_zorJVReducer: editcontactpointpharmacy_contact_use_dropdown_zorJVReducer$1,
  editcontactpointpharmacy_contact_priority_dropdown_zorJVReducer: editcontactpointpharmacy_contact_priority_dropdown_zorJVReducer$1,
  EditNewPharmacypharmacy_update_a0GKUReducer: EditNewPharmacypharmacy_update_a0GKUReducer$1,
  EditNewPharmacypharmacy_singleread_kbnjkReducer: EditNewPharmacypharmacy_singleread_kbnjkReducer$1,
  EditNewPharmacypharmacy_entitytype_dropdown_kbnjkReducer: EditNewPharmacypharmacy_entitytype_dropdown_kbnjkReducer$1,
  EditNewPharmacypharmacy_entityname_dropdown_kbnjkReducer: EditNewPharmacypharmacy_entityname_dropdown_kbnjkReducer$1,
  EditNewPharmacypharmacy_locationtype_dropdown_kbnjkReducer: EditNewPharmacypharmacy_locationtype_dropdown_kbnjkReducer$1,
  EditNewPharmacypharmacy_operationstatus_dropdown_kbnjkReducer: EditNewPharmacypharmacy_operationstatus_dropdown_kbnjkReducer$1,
  EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjkReducer: EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjkReducer$1,
  EditNewPharmacypharmacy_locationroletype_dropdown_kbnjkReducer: EditNewPharmacypharmacy_locationroletype_dropdown_kbnjkReducer$1,
  EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjkReducer: EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjkReducer$1,
  contactpointpharmacy_contact_contactmode_dropdown_VqEMpReducer: contactpointpharmacy_contact_contactmode_dropdown_VqEMpReducer$1,
  contactpointpharmacy_contact_use_dropdown_VqEMpReducer: contactpointpharmacy_contact_use_dropdown_VqEMpReducer$1,
  contactpointpharmacy_contact_priority_dropdown_VqEMpReducer: contactpointpharmacy_contact_priority_dropdown_VqEMpReducer$1,
  addnewpharmacypharmacy_entitytype_dropdown_3YRAVReducer: addnewpharmacypharmacy_entitytype_dropdown_3YRAVReducer$1,
  addnewpharmacypharmacy_entityname_dropdown_3YRAVReducer: addnewpharmacypharmacy_entityname_dropdown_3YRAVReducer$1,
  addnewpharmacypharmacy_locationtype_dropdown_3YRAVReducer: addnewpharmacypharmacy_locationtype_dropdown_3YRAVReducer$1,
  addnewpharmacypharmacy_operationstatus_dropdown_3YRAVReducer: addnewpharmacypharmacy_operationstatus_dropdown_3YRAVReducer$1,
  addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAVReducer: addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAVReducer$1,
  addnewpharmacypharmacy_locationroletype_dropdown_3YRAVReducer: addnewpharmacypharmacy_locationroletype_dropdown_3YRAVReducer$1,
  addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAVReducer: addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAVReducer$1,
  addnewpharmacypharmacy_insert_nDuhJReducer: addnewpharmacypharmacy_insert_nDuhJReducer$1,
  orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1Reducer: orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1Reducer$1,
  orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1Reducer: orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1Reducer$1,
  orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoMReducer: orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoMReducer$1,
  pharmacytablepharmacy_fullread_pnrrOReducer: pharmacytablepharmacy_fullread_pnrrOReducer$1,
  schedulelinesfrequencymaster_days_dropdown_m1WbyReducer: schedulelinesfrequencymaster_days_dropdown_m1WbyReducer$1,
  tablerowfrequencymaster_fullread_aFir7Reducer: tablerowfrequencymaster_fullread_aFir7Reducer$1,
  edit_schedulelinesfrequencymaster_days_dropdown_ZifnBReducer: edit_schedulelinesfrequencymaster_days_dropdown_ZifnBReducer$1,
  addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55YReducer: addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55YReducer$1,
  addnewfrequency_orgfrequencymaster_uom_dropdown_OE55YReducer: addnewfrequency_orgfrequencymaster_uom_dropdown_OE55YReducer$1,
  addnewfrequency_orgfrequencymaster_insert_lHc7nReducer: addnewfrequency_orgfrequencymaster_insert_lHc7nReducer$1,
  addnewfrequency_orgfrequencymaster_days_dropdown_j5qvCReducer: addnewfrequency_orgfrequencymaster_days_dropdown_j5qvCReducer$1,
  EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrnReducer: EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrnReducer$1,
  EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrnReducer: EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrnReducer$1,
  EditNewFrequency_orgfrequencymaster_singleread_7zRrnReducer: EditNewFrequency_orgfrequencymaster_singleread_7zRrnReducer$1,
  EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrnReducer: EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrnReducer$1,
  EditNewFrequency_orgfrequencymaster_update_wiw9RReducer: EditNewFrequency_orgfrequencymaster_update_wiw9RReducer$1,
  drugReducer: drugReducer$1,
  EditNewFrequency_orgbase_frequency_dropdownReducer: EditNewFrequency_orgbase_frequency_dropdownReducer$1,
  frequency_schedule_status_updataReducer: frequency_schedule_status_updataReducer$1,
  schedule_line_day_dropdownReducer: schedule_line_day_dropdownReducer$1,
  phramcyFrameworkApiSlice: signInReducer,
  signInReducer: signInReducer,
  drugCatalogMasterSlice: drugCatalogMasterSlice$1,
  ruleExistReducer: ruleExistReducer$1,
  MedicationMastersSlice: MedicationMastersSlice$1,
  signInReducerApiSlice: signInReducerApiSlice$1,
  cartDefinitionMasterSlice: cartDefinitionMasterSlice$1,
  frequencyMasterSlice: frequencyMasterSlice$1,
  // Primarycare
  organizationConfigSlice: organizationConfigSlice$1,
  organizationConfigMasterSlice: organizationConfigMasterSlice$1,
  organizationSlice: organizationSlice$1,
  pendingRescheduleListSlice: pendingRescheduleListSlice,
  geoGraphicSlice: geoGraphicSlice$1,
  generalMasterSlice: generalMasterSlice$1,
  symptomAndSpecialtySlice: symptomAndSpecialtySlice$1,
  encounterTypeSlice: encounterTypeSlice,
  locationSlice: locationSlice$1,
  locationMasterSlice: locationMasterSlice$1,
  rolesSlice: rolesSlice$1,
  repositorySlice: repositorySlice$1,
  permissionSlice: permissionSlice$1,
  personSlice: personSlice$1,
  userSlice: userSlice$1,
  practitionerSlice: practitionerSlice$1,
  practitionerMasterSlice: practitionerMasterSlice$1,
  ageRangeMasterSlice: ageRangeMasterSlice$1,
  vitalsMeasureCodeSlice: vitalsMeasureCodeSlice$1,
  vitalsApplicableSlice: vitalsApplicableSlice$1,
  vitalsMasterSectionSlice: vitalsMasterSectionSlice$1,
  orderMasterSlice: orderMasterSlice$1,
  drugCategorySlice: drugCategorySlice$1,
  drugDosageSlice: drugDosageSlice$1,
  drugClassSlice: drugClassSlice$1,
  drugRoutesSlice: drugRoutesSlice$1,
  // drugMasterSlice,
  drugRoutesDirectionSlice: drugRoutesDirectionSlice$1,
  orderCatalogSlice: orderCatalogSlice$1,
  ordertypeSlice: ordertypeSlice$1,
  ordernatureSlice: ordernatureSlice$1,
  performLocationSlice: performLocationSlice$1,
  drugMasterUOMSlice: drugMasterUOMSlice$1,
  alertRestictionsMasterSlice: alertRestictionsMasterSlice$1,
  // drugFrequencySlice,
  orderSetMasterSlice: orderSetMasterSlice$1,
  orderSetApplicabilitySlice: orderSetApplicabilitySlice$1,
  allergenMasterSlice: allergenMasterSlice$1,
  flexAttributeSlice: flexAttributeSlice$1,
  flexCriteriaSlice: flexCriteriaSlice$1,
  diagnosisMasterSlice: diagnosisMasterSlice$1
});

var organization_config_actions = _objectSpread2({}, organizationConfigActions);
var organization_config_master_action = _objectSpread2({}, organizationConfigMasterActions);

var organization_role_actions = _objectSpread2({}, organizationActions);

var ordertype_role_actions = _objectSpread2({}, ordertypeActions$1);

var ordernature_role_actions = _objectSpread2({}, ordernatureActions$1);

var pendingRescheduleListMasters = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, pendingRescheduleListActions), geoGraphicActions), generalMasterActions), symptomAndSpecialtyActions), encouterTypeActions);

var location_master_actions = _objectSpread2(_objectSpread2({}, locationActions$1), locationMasterActions);

var practitioner_role_actions = _objectSpread2(_objectSpread2({}, practitionerActions$1), practitionerMasterActions);

var orderMasters = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, orderMasterActions), orderCatalogActions), alertRestrictionsMasterActions), performLocationActions);

var vitalsMasters = _objectSpread2(_objectSpread2(_objectSpread2({}, vitalsMeasureCodeActions), vitalsApplicableActions), vitalsMasterSectionActions);

var _doc;
var queries$1 = {
  // drug_master: `{
  //   "db_name": "${dbName}",
  //   "entity": "DrugMaster",
  //   "sort": "DrugMaster.DrugCode",
  //   "filter": "DrugMaster.activestatus==true ",
  //   "return_fields": "{id:DrugMaster.id,_id:DrugMaster._id,DrugCode:DrugMaster.DrugCode,ShortDesc:DrugMaster.ShortDesc,LongDesc:DrugMaster.LongDesc,statusactive:DrugMaster.statusactive,draftstatus:DrugMaster.draftstatus}"
  // }`,
  drug_master: function drug_master(page, perpage) {
    return {
      db_name: dbName,
      entity: "DrugMaster",
      sort: "DrugMaster.DrugCode",
      filter: "DrugMaster.activestatus==true ",
      limit: {
        offset: page,
        count: perpage
      },
      return_fields: "{TotalCount:COUNT(FOR cnt IN DrugMaster RETURN cnt._key),id:DrugMaster.id,_id:DrugMaster._id,DrugCode:DrugMaster.DrugCode,ShortDesc:DrugMaster.ShortDesc,LongDesc:DrugMaster.LongDesc,statusactive:DrugMaster.statusactive,draftstatus:DrugMaster.draftstatus}"
    };
  },
  drug_master_upsert: [{
    "db_name": dbName,
    "entity": "DrugMaster",
    "is_metadata": true,
    "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
    "doc": (_doc = {
      "_id": "string",
      "id": "number",
      "DrugCode": "string",
      "ShortDesc": "string",
      "LongDesc": "string",
      "Formulary": "boolean",
      "DrugSynonyms": "string",
      //Array of string
      "DrugClass": "string",
      "DrugCategory": "string",
      "DrugType": "string",
      "FormCode": "string",
      "RoutesAllowed": "array",
      "DefaultRouteCode": "string",
      //AVAILABLE STRENGTHS
      "StrengthValuesPossible": [{
        "StrengthValue": "number",
        "StrengthUOM": "string",
        "StrengthVolume": "number",
        "StrengthVolumeUoM": "string",
        "OrderUOMAllowed": [{
          "AllowedOrderDoseVal": "number",
          "AllowedOrderDoseUOM": "string",
          "AllowedOrderDoseVolVal": "number",
          "AllowedOrderDoseVolUoM": "string"
        }]
      }],
      //Drug Other Attributes
      "TrialDrug": "boolean",
      "Additive": "boolean",
      "ApplicableForCompounding": "boolean",
      "DispenseviaprescriptionOnly": "boolean",
      "CounsellingRequired": "boolean",
      //Alternate drugs
      "AlternateDrugs": "array",
      //INSTRUCTIONS
      "Instruction_FrequencyRules": [{
        "_id": "string",
        "id": "number",
        "encountertype": "string",
        "gendercode": "string",
        "agegroup": "string",
        "agecatgcode": "array",
        "OrderInstr": [{
          "patientInst": "string",
          "practionerInst": "string",
          "prepInstr": "string",
          "deptInstr": "string"
        }],
        "setuptypeInd": "string",
        //No use
        "serviceapplicability": "string",
        "ordercatalog": "string",
        "freqappl": "boolean",
        "dfltfreqValue": "number",
        //Default Frequency number
        "dfltfreqValueUnit": "string",
        //Default Frequency sel
        "dfltfreqRate": "number",
        //Dose number
        "dfltfreqRateUnit": "string",
        //Dose select
        "dfltduration": "number",
        //valu
        "dfltdurationType": "string",
        //select
        "maxdurnallowedinDays": "number"
      }],
      //FREQUENCY RULES
      //DISPENSE RULES
      "DrugDispRules": [{
        "_id": "string",
        "id": "number",
        "DrugCode": "string",
        "MaxDispDurnRulebyEnctype": [{
          "EncounterType": "string",
          "MaxDispDurationVal": "number",
          "MaxDispDurationUOM": "string",
          "Action": "string",
          "ActionMessage": "string",
          "Status": "boolean"
        }]
      }],
      //STATUS
      "Status": "string",
      "EffectiveFrom": "number",
      "EffectiveTo": "number",
      "InactiveReason": "string",
      "draftstatus": "boolean",
      //No use
      "Charge": "boolean",
      "OrderUOMAllowed": "string",
      "DoseRoundUpVal": "number",
      "AdminUOM": "string",
      "TotalVolContent": "string",
      "TotalVolContentUoM": "string"
    }, _defineProperty(_doc, "FormCode", "string"), _defineProperty(_doc, "IVFluid", "boolean"), _defineProperty(_doc, "DfltInfuseOverDurationvalue", "number"), _defineProperty(_doc, "DfltInfuseOverDurationType", "string"), _defineProperty(_doc, "DfltFluidCode", "string"), _defineProperty(_doc, "InactiveDate", "number"), _defineProperty(_doc, "InactiveByid", "string"), _defineProperty(_doc, "DispenseAlternateDrug", "boolean"), _defineProperty(_doc, "SpecialInstructionText", "array"), _defineProperty(_doc, "DrugImageID", "number"), _defineProperty(_doc, "DrugItem", "boolean"), _defineProperty(_doc, "SourceOfDrugOrderCatalog", "string"), _defineProperty(_doc, "DrugGenericId", "string"), _defineProperty(_doc, "IngredientListId", "string"), _defineProperty(_doc, "statusactive", "boolean"), _doc)
  }],
  status_update_drug_master: function status_update_drug_master(data) {
    return [{
      "db_name": dbName,
      "entity": "DrugMaster",
      "filter": {
        "_id": data._id
      },
      "is_metadata": true,
      "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
      "doc": {
        "statusactive": data.status
      }
    }];
  },
  drug_form_type: "{\n        \"db_name\": \"".concat(dbName, "\",\n        \"entity\": \"ParamsMapping\",\n        \"filter\":\"ParamsMapping.paraCode=='SOURCEOFDRUGORDERCATALOG'\",\n        \"return_fields\": \"{id:ParamsMapping.id,_id:ParamsMapping._id,paraCode:ParamsMapping.paraCode,paraVal:ParamsMapping.paraVal,paraDef:ParamsMapping.paraDef}\"\n    }"),
  drug_form_read: function drug_form_read(_id) {
    // return {
    //   "db_name": dbName,
    //   "entity": "DrugMaster",
    //   "filter": `DrugMaster.activestatus==true && DrugMaster._id=='${_id}'`,
    //   "return_fields": "merge(DrugMaster,{Status:document(DrugMaster.Status).display},{DrugClass:document(DrugMaster.DrugClass)},{DrugType:document(DrugMaster.DrugType)},{DrugCategory:document(DrugMaster.DrugCategory)},{FormCode:document(DrugMaster.FormCode)},{DefaultRouteCode:document(DrugMaster.DefaultRouteCode)},{RoutesAllowed:document(DrugMaster.RoutesAllowed)},{DfltInfuseOverDurationType:document(DrugMaster.DfltInfuseOverDurationType)},{Instruction: (for i in CA_OrderCatalogByEncounterTypeAge filter i._id in DrugMaster.Instruction  return merge(i,{encountertype: (for en in CodingMaster filter en._id == i.encountertype return en)},{gendercode:(for gen in CodingMaster filter gen._id == i.gendercode return gen)},{agegroup:(for ag in AgeRanges filter ag._id == i.agegroup return ag)},{agecatgcode:(for ac in AgeCategory filter ac._id in i.agecatgcode return ac)},{dfltfreqValueUnit:(for df in FrequencyMaster filter df._id == i.dfltfreqValueUnit return df)},{dfltfreqRateUnit:(for dfr in DrugUOM filter dfr._id == i.dfltfreqRateUnit return dfr)},{dfltdurationType:(for ddt in DrugUOM filter ddt._id == i.dfltdurationType return ddt)}))},{FrequencyRules: (for fr in DrugDefaultFeqRules filter fr._id in DrugMaster.FrequencyRules return merge(fr,{DfltFreqbyPatAttrib:(for dfpa in fr.DfltFreqbyPatAttrib return merge(dfpa,{encountertype:document(dfpa.encountertype)},{AgeCatgCode:document(dfpa.AgeCatgCode)},{DfltInfuseOverDurationType:document(dfpa.DfltInfuseOverDurationType)},{agegroup:document(dfpa.agegroup)},{ageunit:document(dfpa.ageunit)},{dfltdoseUOM:document(dfpa.dfltdoseUOM)},{dfltdurnUOM:document(dfpa.dfltdurnUOM)},{dfltfreqcode:document(dfpa.dfltfreqcode)}))}))},{DrugDispRules:(for dd in DrugDispRules filter dd._id in DrugMaster.DrugDispRules return merge(dd,{MaxDispDurnRulebyEnctype: (for mdd in dd.MaxDispDurnRulebyEnctype return merge(mdd,{Action:(document(mdd.Action).display)},{EncounterType:(for etype in CodingMaster filter etype._id == mdd.EncounterType return etype)},{MaxDispDurationUOM:(for mduom in DrugUOM filter mduom._id == mdd.MaxDispDurationUOM return mduom)}))}))},{StrengthValuesPossible:(for dr in DrugMaster.StrengthValuesPossible return merge(dr,{StrengthUOM:(document(dr.StrengthUOM))},{StrengthVolumeUoM:(document(dr.StrengthVolumeUoM))},{OrderUOMAllowed:(for od in dr.OrderUOMAllowed return merge(od,{AllowedOrderDoseUOM:(document(od.AllowedOrderDoseUOM))},{AllowedOrderDoseVolUoM:(document(od.AllowedOrderDoseVolUoM))}))}))})"
    // }
    return {
      "db_name": dbName,
      "entity": "DrugMaster",
      "filter": "DrugMaster.activestatus==true && DrugMaster._id=='".concat(_id, "'"),
      "return_fields": "merge(DrugMaster,{Status:document(DrugMaster.Status).display},{DrugClass:document(DrugMaster.DrugClass)},{DrugType:document(DrugMaster.DrugType)},{DrugCategory:document(DrugMaster.DrugCategory)},{FormCode:document(DrugMaster.FormCode)},{DefaultRouteCode:document(DrugMaster.DefaultRouteCode)},{RoutesAllowed:document(DrugMaster.RoutesAllowed)},{DfltInfuseOverDurationType:document(DrugMaster.DfltInfuseOverDurationType)},{Instruction: (for i in CA_OrderCatalogByEncounterTypeAge filter i._id in DrugMaster.Instruction  return merge(i,{encountertype: (for en in CodingMaster filter en._id == i.encountertype return en)},{gendercode:(for gen in CodingMaster filter gen._id == i.gendercode return gen)},{agegroup:(for ag in AgeRanges filter ag._id == i.agegroup return ag)},{agecatgcode:(for ac in AgeCategory filter ac._id in i.agecatgcode return ac)},{dfltfreqValueUnit:(for df in FrequencyMaster filter df._id == i.dfltfreqValueUnit return df)},{dfltfreqRateUnit:(for dfr in DrugUOM filter dfr._id == i.dfltfreqRateUnit return dfr)},{dfltdurationType:(for ddt in DrugUOM filter ddt._id == i.dfltdurationType return ddt)}))},{FrequencyRules: (for fr in DrugDefaultFeqRules filter fr._id in DrugMaster.FrequencyRules return merge(fr,{DfltFreqbyPatAttrib:(for dfpa in fr.DfltFreqbyPatAttrib return merge(dfpa,{encountertype:document(dfpa.encountertype)},{AgeCatgCode:document(dfpa.AgeCatgCode)},{DfltInfuseOverDurationType:document(dfpa.DfltInfuseOverDurationType)},{agegroup:document(dfpa.agegroup)},{ageunit:document(dfpa.ageunit)},{dfltdoseUOM:document(dfpa.dfltdoseUOM)},{dfltdurnUOM:document(dfpa.dfltdurnUOM)},{dfltfreqcode:document(dfpa.dfltfreqcode)}))}))},{mappedItems:(for SIDC in  StockItemsbyDrugCode filter SIDC._id in DrugMaster.mappedItems return merge(SIDC, {StockItemCodes:(for ssidc in SIDC.StockItemCodes return merge (ssidc,{stkitemcode:(for sic in DrugItemMaster filter sic._id ==ssidc.stkitemcode return {_id:sic._id,id:sic.id,itemcode:sic.itemcode,shortdesc:sic.shortdesc,longdesc:sic.longdesc})} ))}))},{DrugDispRules:(for dd in DrugDispRules filter dd._id in DrugMaster.DrugDispRules return merge(dd,{MaxDispDurnRulebyEnctype: (for mdd in dd.MaxDispDurnRulebyEnctype return merge(mdd,{Action:(document(mdd.Action).display)},{EncounterType:(for etype in CodingMaster filter etype._id == mdd.EncounterType return etype)},{MaxDispDurationUOM:(for mduom in DrugUOM filter mduom._id == mdd.MaxDispDurationUOM return mduom)}))}))},{StrengthValuesPossible:(for dr in DrugMaster.StrengthValuesPossible return merge(dr,{StrengthUOM:(document(dr.StrengthUOM))},{StrengthVolumeUoM:(document(dr.StrengthVolumeUoM))},{OrderUOMAllowed:(for od in dr.OrderUOMAllowed return merge(od,{AllowedOrderDoseUOM:(document(od.AllowedOrderDoseUOM))},{AllowedOrderDoseVolUoM:(document(od.AllowedOrderDoseVolUoM))}))}))})"
    };
  },
  age_category_by_id: function age_category_by_id(ids) {
    // ['${AllowedUnit.join("','")}']
    return {
      "db_name": dbName,
      "entity": "AgeCategory",
      "filter": "AgeCategory.activestatus == true && AgeCategory._id in ['".concat(ids.join("','"), "']"),
      "return_fields": "{id:AgeCategory.id, _id:AgeCategory._id, code:AgeCategory.code, age_minimum:AgeCategory.age_minimum, age_maximum:AgeCategory.age_maximum, description:AgeCategory.description,UOM:document(document(AgeCategory.UOM).coding)}",
      "sort": "AgeCategory.description"
    };
  },
  ageCategory: function ageCategory(ageRangeId) {
    return {
      db_name: dbName,
      entity: "AgeRanges",
      filter: {
        AgeRanges: "AgeRanges.activestatus==true && AgeRanges._id=='".concat(ageRangeId, "' ")
      },
      return_fields: "DOCUMENT( AgeRanges.AgeCategory)"
    };
  }
};
var masterQuery = {
  "drug_class": "{ \n     \"db_name\": \"".concat(dbName, "\",\n     \"entity\": \"DrugClass\",\n     \"filter\": \"DrugClass.activestatus == true && DrugClass.status == true\", \n     \"return_fields\": \"{id:DrugClass.id, _id:DrugClass._id, drugclass:DrugClass.drugclass, longdesc:DrugClass.longdesc, shortdesc:DrugClass.shortdesc}\",\n     \"sort\": \"DrugClass.longdesc\"\n  }"),
  "drug_category": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DrugCategory\",\n    \"filter\":\"DrugCategory.activestatus == true && DrugCategory.status==true\",\n    \"return_fields\":  \"{id:DrugCategory.id, _id:DrugCategory._id, drugcategory:DrugCategory.drugcategory, longdesc:DrugCategory.longdesc, shortdesc:DrugCategory.shortdesc}\",\n    \"sort\": \"DrugCategory.longdesc\"\n  }"),
  "drug_type": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DrugType\",\n    \"filter\":\"DrugType.activestatus == true && DrugType.status==true\",\n    \"return_fields\": \"{id:DrugType.id, _id:DrugType._id, drugtype:DrugType.drugtype, longdesc:DrugType.longdesc, shortdesc:DrugType.shortdesc}\",\n    \"sort\": \"DrugType.longdesc\"\n  }"),
  "form": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DosageForm\", \n    \"filter\": \"DosageForm.activestatus == true && DosageForm.status==true\",\n    \"return_fields\": \"{id:DosageForm.id, _id:DosageForm._id, dosageform:DosageForm.dosageform, longdesc:DosageForm.longdesc, shortdesc:DosageForm.shortdesc}\",\n    \"sort\": \"DosageForm.longdesc\"\n  }"),
  // "routes_allowed": `{
  //   "db_name": "${dbName}",
  //   "entity": "CodeableConceptMaster",
  //   "filter": "CodeableConceptMaster.Type=='ROUTE'  && CodeableConceptMaster.activestatus==true",
  //   "return_fields": "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
  // }`,
  // "default_route": `{
  //   "db_name": "${dbName}",
  //   "entity": "CodeableConceptMaster",
  //   "filter": "CodeableConceptMaster.Type=='ROUTE'  && CodeableConceptMaster.activestatus==true",
  //   "return_fields": "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
  // }`,
  "routes_allowed": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DrugRoutes\",\n    \"sort\": \"DrugRoutes.shortdesc\",\n    \"filter\": \"DrugRoutes.activestatus==true && DrugRoutes.status==true\",\n    \"return_fields\": \"KEEP(DrugRoutes,'id','_id','_key','routecode','shortdesc','longdesc','routeadverb')\"\n  }"),
  "default_route": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DrugRoutes\",\n    \"sort\": \"DrugRoutes.shortdesc\",\n    \"filter\": \"DrugRoutes.activestatus==true && DrugRoutes.status==true\",\n    \"return_fields\": \"KEEP(DrugRoutes,'id','_id','_key','routecode','shortdesc','longdesc','routeadverb')\"\n  }"),
  "drug_UOM": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DrugUOM\",\n     \"sort\": \"DrugUOM.shortdesc\",\n    \"filter\": \"DrugUOM.activestatus == true && DrugUOM.status==true\", \n    \"return_fields\": \"{id:DrugUOM.id, _id:DrugUOM._id, UOM:DrugUOM.UOM, longdesc:DrugUOM.longdesc, shortdesc:DrugUOM.shortdesc}\"\n  }"),
  "alternate_drug_code": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DrugMaster\",\n    \"sort\": \"DrugMaster.ShortDesc\",\n    \"filter\": \"DrugMaster.activestatus == true && DrugMaster.DrugCode != 'MA007'\",\n    \"return_fields\": \"{_id:DrugMaster._id,id:DrugMaster.id,DrugCode:DrugMaster.DrugCode,ShortDesc:DrugMaster.ShortDesc,LongDesc:DrugMaster.LongDesc}\"\n  }"),
  "encounter_type": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodeableConceptMaster\",\n    \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n    \"filter\": \"CodeableConceptMaster.Type=='ENCOUNTERTYPE'  && CodeableConceptMaster.activestatus==true\",\n    \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n  }"),
  "gender": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodeableConceptMaster\",\n    \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n    \"filter\": \"CodeableConceptMaster.Type=='GENDER' && CodeableConceptMaster.activestatus==true\",\n    \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n  }"),
  // "age_range_group": `{
  //   "db_name": "${dbName}",
  //   "entity": "AgeRanges",
  //   "filter":"AgeRanges.activestatus == true && AgeRanges.status==true",
  //   "return_fields": "{id:AgeRanges.id, _id:AgeRanges._id, agerangecode:AgeRanges.agerangecode, longdesc:AgeRanges.longdesc, shortdesc:AgeRanges.shortdesc}"
  // }`,
  "age_range_group": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"AgeRanges\",\n    \"sort\":\"AgeRanges.agerangecode\",\n    \"filter\":\"AgeRanges.activestatus == true && AgeRanges.status==true\",\n    \"return_fields\": \"{id:AgeRanges.id, _id:AgeRanges._id, agerangecode:AgeRanges.agerangecode, longdesc:AgeRanges.longdesc, shortdesc:AgeRanges.shortdesc,AgeCategory:AgeRanges.AgeCategory}\"\n  }"),
  "age_category": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"AgeCategory\",\n    \"filter\":\"AgeCategory.activestatus == true\",\n    \"return_fields\": \"{id:AgeCategory.id, _id:AgeCategory._id, code:AgeCategory.code, age_minimum:AgeCategory.age_minimum, age_maximum:AgeCategory.age_maximum, description:AgeCategory.description,UOM:document(document(AgeCategory.UOM).coding)}\",\n    \"sort\": \"AgeCategory.description\"\n  }"),
  "default_frequency": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"FrequencyMaster\",\n    \"sort\": \"FrequencyMaster.shortdesc\",\n    \"filter\": \"FrequencyMaster._key != null && FrequencyMaster.longdesc != null && FrequencyMaster.activestatus==true && FrequencyMaster.status==true\",\n    \"return_fields\": \"{_id:FrequencyMaster._id,id:FrequencyMaster.id,freqcode:FrequencyMaster.freqcode,longdesc:FrequencyMaster.longdesc,shortdesc:FrequencyMaster.shortdesc}\"\n  }"),
  "actions": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodeableConceptMaster\",\n    \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n    \"filter\": \"CodeableConceptMaster.Type=='DRUGACTION'  && CodeableConceptMaster.activestatus==true\",\n    \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n  }"),
  "status": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"CodeableConceptMaster\",\n    \"sort\": \"document(CodeableConceptMaster.coding[0]).display\",\n    \"filter\": \"CodeableConceptMaster.Type=='DRUGSTATUS'  && CodeableConceptMaster.activestatus==true\",\n    \"return_fields\": \"MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})\"\n  }"),
  "drug_item_master": "{\n    \"db_name\": \"".concat(dbName, "\",\n    \"entity\": \"DrugItemMaster\",\n   \"sort\": \"DrugItemMaster.shortdesc\",\n    \"filter\": \"DrugItemMaster.activestatus==true && DrugItemMaster.effectivefrom <= DATE_TIMESTAMP(DATE_NOW()/1000) && (DrugItemMaster.effectiveto == 0 || DrugItemMaster.effectiveto == null ? DrugItemMaster.effectiveto==0: DrugItemMaster.effectiveto >= DATE_TIMESTAMP(DATE_NOW()/1000))\",\n    \"return_fields\": \"{_id:DrugItemMaster._id,id:DrugItemMaster.id,itemcode:DrugItemMaster.itemcode,shortdesc:DrugItemMaster.shortdesc,longdesc:DrugItemMaster.longdesc,effectivefrom:DrugItemMaster.effectivefrom,effectiveto:DrugItemMaster.effectiveto}\"\n  }")
};

var allowedJsonFun = function allowedJsonFun(val) {
  var dataJson = [];
  val === null || val === void 0 ? void 0 : val.map(function (allVal) {
    var _allVal$allowedValue, _allVal$allowedValue2, _allVal$allowedValue$, _allVal$allowedValue3, _allVal$allowedValue4, _allVal$allowedVolume, _allVal$allowedVolume2, _allVal$allowedVolume3, _allVal$allowedVolume4, _allVal$allowedVolume5;

    var data = {
      "AllowedOrderDoseVal": allVal !== null && allVal !== void 0 && (_allVal$allowedValue = allVal.allowedValue) !== null && _allVal$allowedValue !== void 0 && _allVal$allowedValue.value ? parseInt(allVal === null || allVal === void 0 ? void 0 : (_allVal$allowedValue2 = allVal.allowedValue) === null || _allVal$allowedValue2 === void 0 ? void 0 : _allVal$allowedValue2.value) : null,
      "AllowedOrderDoseUOM": (_allVal$allowedValue$ = allVal === null || allVal === void 0 ? void 0 : (_allVal$allowedValue3 = allVal.allowedValue) === null || _allVal$allowedValue3 === void 0 ? void 0 : (_allVal$allowedValue4 = _allVal$allowedValue3.type) === null || _allVal$allowedValue4 === void 0 ? void 0 : _allVal$allowedValue4.value) !== null && _allVal$allowedValue$ !== void 0 ? _allVal$allowedValue$ : "",
      "AllowedOrderDoseVolVal": allVal !== null && allVal !== void 0 && (_allVal$allowedVolume = allVal.allowedVolume) !== null && _allVal$allowedVolume !== void 0 && _allVal$allowedVolume.value ? parseInt(allVal === null || allVal === void 0 ? void 0 : (_allVal$allowedVolume2 = allVal.allowedVolume) === null || _allVal$allowedVolume2 === void 0 ? void 0 : _allVal$allowedVolume2.value) : null,
      "AllowedOrderDoseVolUoM": (_allVal$allowedVolume3 = allVal === null || allVal === void 0 ? void 0 : (_allVal$allowedVolume4 = allVal.allowedVolume) === null || _allVal$allowedVolume4 === void 0 ? void 0 : (_allVal$allowedVolume5 = _allVal$allowedVolume4.type) === null || _allVal$allowedVolume5 === void 0 ? void 0 : _allVal$allowedVolume5.value) !== null && _allVal$allowedVolume3 !== void 0 ? _allVal$allowedVolume3 : ""
    };
    dataJson.push(data);
  });
  return dataJson;
};

var DfltFreqbyPatAttribFun = function DfltFreqbyPatAttribFun(val, dataval) {
  var dataJson = [];
  val === null || val === void 0 ? void 0 : val.map(function (valfry) {
    var _dataval$encounterTyp, _dataval$encounterTyp2, _dataval$ageRangeGrou, _dataval$ageRangeGrou2, _dataval$gender, _valfry$_id, _valfry$unit, _valfry$defaultFreque, _valfry$defaultFreque2, _valfry$defaultDurati, _valfry$defaultDurati2, _valfry$defaultDurati3, _valfry$defaultDurati4, _valfry$defaultDurati5, _valfry$defaultDose, _valfry$defaultDose2, _valfry$defaultDose$t, _valfry$defaultDose3, _valfry$defaultDose3$, _valfry$infuseOverDur, _valfry$infuseOverDur2, _valfry$infuseOverDur3, _valfry$infuseOverDur4, _valfry$infuseOverDur5;

    var data = {
      "encountertype": (_dataval$encounterTyp = dataval === null || dataval === void 0 ? void 0 : (_dataval$encounterTyp2 = dataval.encounterType) === null || _dataval$encounterTyp2 === void 0 ? void 0 : _dataval$encounterTyp2.value) !== null && _dataval$encounterTyp !== void 0 ? _dataval$encounterTyp : "",
      "agegroup": (_dataval$ageRangeGrou = dataval === null || dataval === void 0 ? void 0 : (_dataval$ageRangeGrou2 = dataval.ageRangeGroup) === null || _dataval$ageRangeGrou2 === void 0 ? void 0 : _dataval$ageRangeGrou2.value) !== null && _dataval$ageRangeGrou !== void 0 ? _dataval$ageRangeGrou : "",
      "gender": (_dataval$gender = dataval === null || dataval === void 0 ? void 0 : dataval.gender) !== null && _dataval$gender !== void 0 ? _dataval$gender : "",
      "AgeCatgCode": (_valfry$_id = valfry === null || valfry === void 0 ? void 0 : valfry._id) !== null && _valfry$_id !== void 0 ? _valfry$_id : "",
      // "fromage": "number",
      // "toage": "number",
      "ageunit": (_valfry$unit = valfry === null || valfry === void 0 ? void 0 : valfry.unit) !== null && _valfry$unit !== void 0 ? _valfry$unit : "",
      "dfltfreqcode": (_valfry$defaultFreque = valfry === null || valfry === void 0 ? void 0 : (_valfry$defaultFreque2 = valfry.defaultFrequency) === null || _valfry$defaultFreque2 === void 0 ? void 0 : _valfry$defaultFreque2.value) !== null && _valfry$defaultFreque !== void 0 ? _valfry$defaultFreque : "",
      "dfltdurationcode": valfry !== null && valfry !== void 0 && (_valfry$defaultDurati = valfry.defaultDuration) !== null && _valfry$defaultDurati !== void 0 && _valfry$defaultDurati.value ? parseInt(valfry === null || valfry === void 0 ? void 0 : (_valfry$defaultDurati2 = valfry.defaultDuration) === null || _valfry$defaultDurati2 === void 0 ? void 0 : _valfry$defaultDurati2.value) : null,
      "dfltdurnUOM": (_valfry$defaultDurati3 = valfry === null || valfry === void 0 ? void 0 : (_valfry$defaultDurati4 = valfry.defaultDuration) === null || _valfry$defaultDurati4 === void 0 ? void 0 : (_valfry$defaultDurati5 = _valfry$defaultDurati4.type) === null || _valfry$defaultDurati5 === void 0 ? void 0 : _valfry$defaultDurati5.value) !== null && _valfry$defaultDurati3 !== void 0 ? _valfry$defaultDurati3 : "",
      "dfltdoseval": valfry !== null && valfry !== void 0 && (_valfry$defaultDose = valfry.defaultDose) !== null && _valfry$defaultDose !== void 0 && _valfry$defaultDose.value ? parseInt(valfry === null || valfry === void 0 ? void 0 : (_valfry$defaultDose2 = valfry.defaultDose) === null || _valfry$defaultDose2 === void 0 ? void 0 : _valfry$defaultDose2.value) : null,
      "dfltdoseUOM": (_valfry$defaultDose$t = valfry === null || valfry === void 0 ? void 0 : (_valfry$defaultDose3 = valfry.defaultDose) === null || _valfry$defaultDose3 === void 0 ? void 0 : (_valfry$defaultDose3$ = _valfry$defaultDose3.type) === null || _valfry$defaultDose3$ === void 0 ? void 0 : _valfry$defaultDose3$.value) !== null && _valfry$defaultDose$t !== void 0 ? _valfry$defaultDose$t : "",
      "DfltInfuseOverDurationval": valfry !== null && valfry !== void 0 && (_valfry$infuseOverDur = valfry.infuseOverDuration) !== null && _valfry$infuseOverDur !== void 0 && _valfry$infuseOverDur.value ? parseInt(valfry === null || valfry === void 0 ? void 0 : (_valfry$infuseOverDur2 = valfry.infuseOverDuration) === null || _valfry$infuseOverDur2 === void 0 ? void 0 : _valfry$infuseOverDur2.value) : null,
      "DfltInfuseOverDurationType": (_valfry$infuseOverDur3 = valfry === null || valfry === void 0 ? void 0 : (_valfry$infuseOverDur4 = valfry.infuseOverDuration) === null || _valfry$infuseOverDur4 === void 0 ? void 0 : (_valfry$infuseOverDur5 = _valfry$infuseOverDur4.type) === null || _valfry$infuseOverDur5 === void 0 ? void 0 : _valfry$infuseOverDur5.value) !== null && _valfry$infuseOverDur3 !== void 0 ? _valfry$infuseOverDur3 : ""
    };
    dataJson.push(data);
  });
  return dataJson;
};

var generateDrugMasterJSON = function generateDrugMasterJSON(data, _key, draft) {
  var _data$phDrugMaster, _data$phDrugMaster$ro, _data$phDrugMaster2, _data$alternateDrugs, _data$phDrugMaster4, _data$availableStreng, _data$phDrugMaster5, _data$instructions, _data$frequencyRules, _data$dispensesRules, _data$phDrugMaster6, _data$phDrugMaster6$s, _data$mappedStack, _data$phDrugMaster$co, _data$phDrugMaster8, _data$phDrugMaster$sh, _data$phDrugMaster9, _data$phDrugMaster$lo, _data$phDrugMaster10, _data$phDrugMaster$in, _data$phDrugMaster11, _data$phDrugMaster$dr, _data$phDrugMaster12, _data$phDrugMaster$cl, _data$phDrugMaster13, _data$phDrugMaster13$, _data$phDrugMaster$ty, _data$phDrugMaster14, _data$phDrugMaster14$, _data$phDrugMaster$ca, _data$phDrugMaster15, _data$phDrugMaster15$, _data$phDrugMaster16, _data$phDrugMaster16$, _data$phDrugMaster17, _data$phDrugMaster18, _data$phDrugMaster18$, _data$phDrugMaster19, _data$phDrugMaster19$, _data$phDrugMaster20, _data$phDrugMaster21, _data$phDrugMaster21$, _data$drugOtherAttrib, _data$phDrugMaster22, _data$drugOtherAttrib2, _data$drugOtherAttrib3, _data$phDrugMaster23, _data$drugOtherAttrib4, _data$drugOtherAttrib5, _data$phDrugMaster24, _data$drugOtherAttrib6, _data$drugOtherAttrib7, _data$phDrugMaster25, _data$drugOtherAttrib8, _data$drugOtherAttrib9, _data$phDrugMaster26, _data$drugOtherAttrib10, _data$status$status$v, _data$status, _data$status$status, _data$status2, _getUtcTime, _data$status3, _data$status4, _getUtcTime2, _data$status5, _data$status$reason, _data$status6;

  var statusactive = true;
  var filter = {};

  if (_key) {
    filter = {
      "filter": {
        "_id": _key
      }
    };
    statusactive = data === null || data === void 0 ? void 0 : data.statusactive;
  }

  var draftstatus = false;

  if (draft) {
    draftstatus = true;
    statusactive = false;
  }

  var routesAllowed = [];

  if ((data === null || data === void 0 ? void 0 : (_data$phDrugMaster = data.phDrugMaster) === null || _data$phDrugMaster === void 0 ? void 0 : (_data$phDrugMaster$ro = _data$phDrugMaster.routesAllowed) === null || _data$phDrugMaster$ro === void 0 ? void 0 : _data$phDrugMaster$ro.length) > 0 && data !== null && data !== void 0 && (_data$phDrugMaster2 = data.phDrugMaster) !== null && _data$phDrugMaster2 !== void 0 && _data$phDrugMaster2.drug) {
    var _data$phDrugMaster$ro2, _data$phDrugMaster3, _data$phDrugMaster3$r;

    routesAllowed = (_data$phDrugMaster$ro2 = data === null || data === void 0 ? void 0 : (_data$phDrugMaster3 = data.phDrugMaster) === null || _data$phDrugMaster3 === void 0 ? void 0 : (_data$phDrugMaster3$r = _data$phDrugMaster3.routesAllowed) === null || _data$phDrugMaster3$r === void 0 ? void 0 : _data$phDrugMaster3$r.map(function (val) {
      return val === null || val === void 0 ? void 0 : val.value;
    })) !== null && _data$phDrugMaster$ro2 !== void 0 ? _data$phDrugMaster$ro2 : [];
  }

  var alternateDrugs = [];

  if ((data === null || data === void 0 ? void 0 : (_data$alternateDrugs = data.alternateDrugs) === null || _data$alternateDrugs === void 0 ? void 0 : _data$alternateDrugs.length) > 0 && data !== null && data !== void 0 && (_data$phDrugMaster4 = data.phDrugMaster) !== null && _data$phDrugMaster4 !== void 0 && _data$phDrugMaster4.drug) {
    var _data$alternateDrugs$;

    alternateDrugs = (_data$alternateDrugs$ = data === null || data === void 0 ? void 0 : data.alternateDrugs.map(function (val) {
      return val === null || val === void 0 ? void 0 : val.value;
    })) !== null && _data$alternateDrugs$ !== void 0 ? _data$alternateDrugs$ : [];
  }

  var StrengthValuesPossible = [];

  if ((data === null || data === void 0 ? void 0 : (_data$availableStreng = data.availableStrengths) === null || _data$availableStreng === void 0 ? void 0 : _data$availableStreng.length) > 0 && data !== null && data !== void 0 && (_data$phDrugMaster5 = data.phDrugMaster) !== null && _data$phDrugMaster5 !== void 0 && _data$phDrugMaster5.drug) {
    var _data$availableStreng2;

    data === null || data === void 0 ? void 0 : (_data$availableStreng2 = data.availableStrengths) === null || _data$availableStreng2 === void 0 ? void 0 : _data$availableStreng2.map(function (val) {
      var _val$strength, _val$strength$strengt, _val$strength2, _val$strength2$streng, _val$strength$strengt2, _val$strength3, _val$strength3$streng, _val$strength3$streng2, _val$strength4, _val$strength4$streng, _val$strength5, _val$strength5$streng, _val$strength$strengt3, _val$strength6, _val$strength6$streng, _val$strength6$streng2, _val$allowed;

      var dataJson = {
        "StrengthValue": val !== null && val !== void 0 && (_val$strength = val.strength) !== null && _val$strength !== void 0 && (_val$strength$strengt = _val$strength.strengthValue) !== null && _val$strength$strengt !== void 0 && _val$strength$strengt.value ? parseInt(val === null || val === void 0 ? void 0 : (_val$strength2 = val.strength) === null || _val$strength2 === void 0 ? void 0 : (_val$strength2$streng = _val$strength2.strengthValue) === null || _val$strength2$streng === void 0 ? void 0 : _val$strength2$streng.value) : null,
        "StrengthUOM": (_val$strength$strengt2 = val === null || val === void 0 ? void 0 : (_val$strength3 = val.strength) === null || _val$strength3 === void 0 ? void 0 : (_val$strength3$streng = _val$strength3.strengthValue) === null || _val$strength3$streng === void 0 ? void 0 : (_val$strength3$streng2 = _val$strength3$streng.type) === null || _val$strength3$streng2 === void 0 ? void 0 : _val$strength3$streng2.value) !== null && _val$strength$strengt2 !== void 0 ? _val$strength$strengt2 : "",
        "StrengthVolume": val !== null && val !== void 0 && (_val$strength4 = val.strength) !== null && _val$strength4 !== void 0 && (_val$strength4$streng = _val$strength4.strengthVolume) !== null && _val$strength4$streng !== void 0 && _val$strength4$streng.value ? parseInt(val === null || val === void 0 ? void 0 : (_val$strength5 = val.strength) === null || _val$strength5 === void 0 ? void 0 : (_val$strength5$streng = _val$strength5.strengthVolume) === null || _val$strength5$streng === void 0 ? void 0 : _val$strength5$streng.value) : null,
        "StrengthVolumeUoM": (_val$strength$strengt3 = val === null || val === void 0 ? void 0 : (_val$strength6 = val.strength) === null || _val$strength6 === void 0 ? void 0 : (_val$strength6$streng = _val$strength6.strengthVolume) === null || _val$strength6$streng === void 0 ? void 0 : (_val$strength6$streng2 = _val$strength6$streng.type) === null || _val$strength6$streng2 === void 0 ? void 0 : _val$strength6$streng2.value) !== null && _val$strength$strengt3 !== void 0 ? _val$strength$strengt3 : "",
        "OrderUOMAllowed": (val === null || val === void 0 ? void 0 : (_val$allowed = val.allowed) === null || _val$allowed === void 0 ? void 0 : _val$allowed.length) > 0 ? allowedJsonFun(val === null || val === void 0 ? void 0 : val.allowed) : []
      };
      StrengthValuesPossible.push(dataJson);
    });
  }

  var Instruction = [];

  if ((data === null || data === void 0 ? void 0 : (_data$instructions = data.instructions) === null || _data$instructions === void 0 ? void 0 : _data$instructions.length) > 0) {
    var _data$instructions2;

    data === null || data === void 0 ? void 0 : (_data$instructions2 = data.instructions) === null || _data$instructions2 === void 0 ? void 0 : _data$instructions2.map(function (val) {
      var _val$encounterType$va, _val$encounterType, _val$gender, _val$ageGroup$value, _val$ageGroup, _val$ageCategory, _val$patientInstructi, _val$practitionerInst, _val$prepratoryInstru, _val$departmentInstru;

      var dataJson = {
        // "_id": "string",
        "id": 0,
        "encountertype": (_val$encounterType$va = val === null || val === void 0 ? void 0 : (_val$encounterType = val.encounterType) === null || _val$encounterType === void 0 ? void 0 : _val$encounterType.value) !== null && _val$encounterType$va !== void 0 ? _val$encounterType$va : "",
        "gendercode": (_val$gender = val === null || val === void 0 ? void 0 : val.gender) !== null && _val$gender !== void 0 ? _val$gender : "",
        "agegroup": (_val$ageGroup$value = val === null || val === void 0 ? void 0 : (_val$ageGroup = val.ageGroup) === null || _val$ageGroup === void 0 ? void 0 : _val$ageGroup.value) !== null && _val$ageGroup$value !== void 0 ? _val$ageGroup$value : "",
        "agecatgcode": ((_val$ageCategory = val.ageCategory) === null || _val$ageCategory === void 0 ? void 0 : _val$ageCategory.length) > 0 ? val.ageCategory.map(function (val) {
          return val.value;
        }) : [],
        "OrderInstr": [{
          "patientInst": (_val$patientInstructi = val === null || val === void 0 ? void 0 : val.patientInstructions) !== null && _val$patientInstructi !== void 0 ? _val$patientInstructi : "",
          "practionerInst": (_val$practitionerInst = val === null || val === void 0 ? void 0 : val.practitionerInstructions) !== null && _val$practitionerInst !== void 0 ? _val$practitionerInst : "",
          "prepInstr": (_val$prepratoryInstru = val === null || val === void 0 ? void 0 : val.prepratoryInstructions) !== null && _val$prepratoryInstru !== void 0 ? _val$prepratoryInstru : "",
          "deptInstr": (_val$departmentInstru = val === null || val === void 0 ? void 0 : val.departmentInstructions) !== null && _val$departmentInstru !== void 0 ? _val$departmentInstru : ""
        }],
        "setuptypeInd": "2" //no use key
        // "serviceapplicability": "string",
        // "ordercatalog": "string",
        // "freqappl": "boolean",
        // "dfltfreqValue": "number",
        // "dfltfreqValueUnit": "string",
        // "dfltfreqRate": "number",
        // "dfltfreqRateUnit": "string",
        // "dfltduration": "number",
        // "dfltdurationType": "string",
        // "maxdurnallowedinDays": "number"   

      };
      Instruction.push(dataJson);
    });
  }

  var FrequencyRulesData = [];

  if ((data === null || data === void 0 ? void 0 : (_data$frequencyRules = data.frequencyRules) === null || _data$frequencyRules === void 0 ? void 0 : _data$frequencyRules.length) > 0) {
    var _data$frequencyRules2;

    data === null || data === void 0 ? void 0 : (_data$frequencyRules2 = data.frequencyRules) === null || _data$frequencyRules2 === void 0 ? void 0 : _data$frequencyRules2.map(function (vl) {
      var _vl$tableData;

      var dataJson = {
        //   "_id": "string",
        "id": 0,
        // "drugcode": "string",
        "DfltFreqbyPatAttrib": (vl === null || vl === void 0 ? void 0 : (_vl$tableData = vl.tableData) === null || _vl$tableData === void 0 ? void 0 : _vl$tableData.length) > 0 ? DfltFreqbyPatAttribFun(vl === null || vl === void 0 ? void 0 : vl.tableData, vl) : []
      };
      FrequencyRulesData.push(dataJson);
    });
  }

  var DrugDispRulesData = [];

  if ((data === null || data === void 0 ? void 0 : (_data$dispensesRules = data.dispensesRules) === null || _data$dispensesRules === void 0 ? void 0 : _data$dispensesRules.length) > 0) {
    var _data$dispensesRules2;

    data === null || data === void 0 ? void 0 : (_data$dispensesRules2 = data.dispensesRules) === null || _data$dispensesRules2 === void 0 ? void 0 : _data$dispensesRules2.map(function (valdrug) {
      var _valdrug$encounterTyp, _valdrug$encounterTyp2, _valdrug$maxDispenseD, _valdrug$maxDispenseD2, _valdrug$maxDispenseD3, _valdrug$maxDispenseD4, _valdrug$maxDispenseD5, _valdrug$actions$valu, _valdrug$actions, _valdrug$actionMessag;

      var dataJson = {
        //"_id": "string",
        "id": 0,
        // "DrugCode": "string",
        "MaxDispDurnRulebyEnctype": [{
          "EncounterType": (_valdrug$encounterTyp = valdrug === null || valdrug === void 0 ? void 0 : (_valdrug$encounterTyp2 = valdrug.encounterType) === null || _valdrug$encounterTyp2 === void 0 ? void 0 : _valdrug$encounterTyp2.value) !== null && _valdrug$encounterTyp !== void 0 ? _valdrug$encounterTyp : "",
          "MaxDispDurationVal": valdrug !== null && valdrug !== void 0 && (_valdrug$maxDispenseD = valdrug.maxDispenseDurationValue) !== null && _valdrug$maxDispenseD !== void 0 && _valdrug$maxDispenseD.value ? parseInt(valdrug === null || valdrug === void 0 ? void 0 : (_valdrug$maxDispenseD2 = valdrug.maxDispenseDurationValue) === null || _valdrug$maxDispenseD2 === void 0 ? void 0 : _valdrug$maxDispenseD2.value) : 0,
          "MaxDispDurationUOM": (_valdrug$maxDispenseD3 = valdrug === null || valdrug === void 0 ? void 0 : (_valdrug$maxDispenseD4 = valdrug.maxDispenseDurationValue) === null || _valdrug$maxDispenseD4 === void 0 ? void 0 : (_valdrug$maxDispenseD5 = _valdrug$maxDispenseD4.type) === null || _valdrug$maxDispenseD5 === void 0 ? void 0 : _valdrug$maxDispenseD5.value) !== null && _valdrug$maxDispenseD3 !== void 0 ? _valdrug$maxDispenseD3 : "",
          "Action": (_valdrug$actions$valu = valdrug === null || valdrug === void 0 ? void 0 : (_valdrug$actions = valdrug.actions) === null || _valdrug$actions === void 0 ? void 0 : _valdrug$actions.value) !== null && _valdrug$actions$valu !== void 0 ? _valdrug$actions$valu : "",
          "ActionMessage": (_valdrug$actionMessag = valdrug === null || valdrug === void 0 ? void 0 : valdrug.actionMessage) !== null && _valdrug$actionMessag !== void 0 ? _valdrug$actionMessag : "",
          "Status": true
        }]
      };
      DrugDispRulesData.push(dataJson);
    });
  }

  var synonymData = [];

  if ((data === null || data === void 0 ? void 0 : (_data$phDrugMaster6 = data.phDrugMaster) === null || _data$phDrugMaster6 === void 0 ? void 0 : (_data$phDrugMaster6$s = _data$phDrugMaster6.synonym) === null || _data$phDrugMaster6$s === void 0 ? void 0 : _data$phDrugMaster6$s.length) > 0) {
    var _data$phDrugMaster$sy, _data$phDrugMaster7;

    // synonymData = data?.phDrugMaster?.synonym?.map(val => val.value)??[]
    synonymData = (_data$phDrugMaster$sy = data === null || data === void 0 ? void 0 : (_data$phDrugMaster7 = data.phDrugMaster) === null || _data$phDrugMaster7 === void 0 ? void 0 : _data$phDrugMaster7.synonym) !== null && _data$phDrugMaster$sy !== void 0 ? _data$phDrugMaster$sy : [];
  }

  var mappedItemsData = [];

  if ((data === null || data === void 0 ? void 0 : (_data$mappedStack = data.mappedStack) === null || _data$mappedStack === void 0 ? void 0 : _data$mappedStack.length) > 0) {
    var _data$mappedStack2;

    data === null || data === void 0 ? void 0 : (_data$mappedStack2 = data.mappedStack) === null || _data$mappedStack2 === void 0 ? void 0 : _data$mappedStack2.map(function (val) {
      var _val$itemCodeDesc$val, _val$itemCodeDesc, _val$preferredSeq, _val$alternate;

      var dataJson = {
        // "_id": "string",
        "id": 0,
        // "drugcode": "string",
        "StockItemCodes": [{
          "stkitemcode": (_val$itemCodeDesc$val = val === null || val === void 0 ? void 0 : (_val$itemCodeDesc = val.itemCodeDesc) === null || _val$itemCodeDesc === void 0 ? void 0 : _val$itemCodeDesc.value) !== null && _val$itemCodeDesc$val !== void 0 ? _val$itemCodeDesc$val : "",
          "prefferedseqno": (_val$preferredSeq = val === null || val === void 0 ? void 0 : val.preferredSeq) !== null && _val$preferredSeq !== void 0 ? _val$preferredSeq : "",
          "Alternate": (_val$alternate = val === null || val === void 0 ? void 0 : val.alternate) !== null && _val$alternate !== void 0 ? _val$alternate : false
        }]
      };
      mappedItemsData.push(dataJson);
    });
  }

  var json = [_objectSpread2(_objectSpread2({
    "db_name": dbName,
    "entity": "DrugMaster",
    "is_metadata": true
  }, filter), {}, {
    "metadataId": "04ecb73d-f048-44ce-8563-c9be015812dd",
    "doc": {
      // "_id": "string",
      "id": 0,
      "DrugCode": (_data$phDrugMaster$co = data === null || data === void 0 ? void 0 : (_data$phDrugMaster8 = data.phDrugMaster) === null || _data$phDrugMaster8 === void 0 ? void 0 : _data$phDrugMaster8.code) !== null && _data$phDrugMaster$co !== void 0 ? _data$phDrugMaster$co : "",
      "ShortDesc": (_data$phDrugMaster$sh = data === null || data === void 0 ? void 0 : (_data$phDrugMaster9 = data.phDrugMaster) === null || _data$phDrugMaster9 === void 0 ? void 0 : _data$phDrugMaster9.shortDescription) !== null && _data$phDrugMaster$sh !== void 0 ? _data$phDrugMaster$sh : "",
      "LongDesc": (_data$phDrugMaster$lo = data === null || data === void 0 ? void 0 : (_data$phDrugMaster10 = data.phDrugMaster) === null || _data$phDrugMaster10 === void 0 ? void 0 : _data$phDrugMaster10.longDescription) !== null && _data$phDrugMaster$lo !== void 0 ? _data$phDrugMaster$lo : "",
      "DrugSynonyms": synonymData,
      "Formulary": (_data$phDrugMaster$in = data === null || data === void 0 ? void 0 : (_data$phDrugMaster11 = data.phDrugMaster) === null || _data$phDrugMaster11 === void 0 ? void 0 : _data$phDrugMaster11.inFormulary) !== null && _data$phDrugMaster$in !== void 0 ? _data$phDrugMaster$in : false,
      "Charge": (_data$phDrugMaster$dr = data === null || data === void 0 ? void 0 : (_data$phDrugMaster12 = data.phDrugMaster) === null || _data$phDrugMaster12 === void 0 ? void 0 : _data$phDrugMaster12.drug) !== null && _data$phDrugMaster$dr !== void 0 ? _data$phDrugMaster$dr : false,
      "DrugClass": (_data$phDrugMaster$cl = data === null || data === void 0 ? void 0 : (_data$phDrugMaster13 = data.phDrugMaster) === null || _data$phDrugMaster13 === void 0 ? void 0 : (_data$phDrugMaster13$ = _data$phDrugMaster13["class"]) === null || _data$phDrugMaster13$ === void 0 ? void 0 : _data$phDrugMaster13$.value) !== null && _data$phDrugMaster$cl !== void 0 ? _data$phDrugMaster$cl : "",
      "DrugType": (_data$phDrugMaster$ty = data === null || data === void 0 ? void 0 : (_data$phDrugMaster14 = data.phDrugMaster) === null || _data$phDrugMaster14 === void 0 ? void 0 : (_data$phDrugMaster14$ = _data$phDrugMaster14.type) === null || _data$phDrugMaster14$ === void 0 ? void 0 : _data$phDrugMaster14$.value) !== null && _data$phDrugMaster$ty !== void 0 ? _data$phDrugMaster$ty : "",
      "DrugCategory": (_data$phDrugMaster$ca = data === null || data === void 0 ? void 0 : (_data$phDrugMaster15 = data.phDrugMaster) === null || _data$phDrugMaster15 === void 0 ? void 0 : (_data$phDrugMaster15$ = _data$phDrugMaster15.category) === null || _data$phDrugMaster15$ === void 0 ? void 0 : _data$phDrugMaster15$.value) !== null && _data$phDrugMaster$ca !== void 0 ? _data$phDrugMaster$ca : "",
      "RoutesAllowed": routesAllowed,
      "DefaultRouteCode": data !== null && data !== void 0 && (_data$phDrugMaster16 = data.phDrugMaster) !== null && _data$phDrugMaster16 !== void 0 && (_data$phDrugMaster16$ = _data$phDrugMaster16.defaultRoute) !== null && _data$phDrugMaster16$ !== void 0 && _data$phDrugMaster16$.value && data !== null && data !== void 0 && (_data$phDrugMaster17 = data.phDrugMaster) !== null && _data$phDrugMaster17 !== void 0 && _data$phDrugMaster17.drug ? data === null || data === void 0 ? void 0 : (_data$phDrugMaster18 = data.phDrugMaster) === null || _data$phDrugMaster18 === void 0 ? void 0 : (_data$phDrugMaster18$ = _data$phDrugMaster18.defaultRoute) === null || _data$phDrugMaster18$ === void 0 ? void 0 : _data$phDrugMaster18$.value : "",
      "FormCode": data !== null && data !== void 0 && (_data$phDrugMaster19 = data.phDrugMaster) !== null && _data$phDrugMaster19 !== void 0 && (_data$phDrugMaster19$ = _data$phDrugMaster19.form) !== null && _data$phDrugMaster19$ !== void 0 && _data$phDrugMaster19$.value && data !== null && data !== void 0 && (_data$phDrugMaster20 = data.phDrugMaster) !== null && _data$phDrugMaster20 !== void 0 && _data$phDrugMaster20.drug ? data === null || data === void 0 ? void 0 : (_data$phDrugMaster21 = data.phDrugMaster) === null || _data$phDrugMaster21 === void 0 ? void 0 : (_data$phDrugMaster21$ = _data$phDrugMaster21.form) === null || _data$phDrugMaster21$ === void 0 ? void 0 : _data$phDrugMaster21$.value : "",
      //AVAILABLE STRENGTHS
      "StrengthValuesPossible": StrengthValuesPossible,
      //Drug Other Attributes
      "TrialDrug": data !== null && data !== void 0 && (_data$drugOtherAttrib = data.drugOtherAttributes) !== null && _data$drugOtherAttrib !== void 0 && _data$drugOtherAttrib.trailDrug && data !== null && data !== void 0 && (_data$phDrugMaster22 = data.phDrugMaster) !== null && _data$phDrugMaster22 !== void 0 && _data$phDrugMaster22.drug ? data === null || data === void 0 ? void 0 : (_data$drugOtherAttrib2 = data.drugOtherAttributes) === null || _data$drugOtherAttrib2 === void 0 ? void 0 : _data$drugOtherAttrib2.trailDrug : false,
      "Additive": data !== null && data !== void 0 && (_data$drugOtherAttrib3 = data.drugOtherAttributes) !== null && _data$drugOtherAttrib3 !== void 0 && _data$drugOtherAttrib3.usedAsAddictive && data !== null && data !== void 0 && (_data$phDrugMaster23 = data.phDrugMaster) !== null && _data$phDrugMaster23 !== void 0 && _data$phDrugMaster23.drug ? data === null || data === void 0 ? void 0 : (_data$drugOtherAttrib4 = data.drugOtherAttributes) === null || _data$drugOtherAttrib4 === void 0 ? void 0 : _data$drugOtherAttrib4.usedAsAddictive : false,
      "ApplicableForCompounding": data !== null && data !== void 0 && (_data$drugOtherAttrib5 = data.drugOtherAttributes) !== null && _data$drugOtherAttrib5 !== void 0 && _data$drugOtherAttrib5.usedForCompoundPreparation && data !== null && data !== void 0 && (_data$phDrugMaster24 = data.phDrugMaster) !== null && _data$phDrugMaster24 !== void 0 && _data$phDrugMaster24.drug ? data === null || data === void 0 ? void 0 : (_data$drugOtherAttrib6 = data.drugOtherAttributes) === null || _data$drugOtherAttrib6 === void 0 ? void 0 : _data$drugOtherAttrib6.usedForCompoundPreparation : false,
      "DispenseviaprescriptionOnly": data !== null && data !== void 0 && (_data$drugOtherAttrib7 = data.drugOtherAttributes) !== null && _data$drugOtherAttrib7 !== void 0 && _data$drugOtherAttrib7.dispenseViaRxOnly && data !== null && data !== void 0 && (_data$phDrugMaster25 = data.phDrugMaster) !== null && _data$phDrugMaster25 !== void 0 && _data$phDrugMaster25.drug ? data === null || data === void 0 ? void 0 : (_data$drugOtherAttrib8 = data.drugOtherAttributes) === null || _data$drugOtherAttrib8 === void 0 ? void 0 : _data$drugOtherAttrib8.dispenseViaRxOnly : false,
      "CounsellingRequired": data !== null && data !== void 0 && (_data$drugOtherAttrib9 = data.drugOtherAttributes) !== null && _data$drugOtherAttrib9 !== void 0 && _data$drugOtherAttrib9.counsellingRequired && data !== null && data !== void 0 && (_data$phDrugMaster26 = data.phDrugMaster) !== null && _data$phDrugMaster26 !== void 0 && _data$phDrugMaster26.drug ? data === null || data === void 0 ? void 0 : (_data$drugOtherAttrib10 = data.drugOtherAttributes) === null || _data$drugOtherAttrib10 === void 0 ? void 0 : _data$drugOtherAttrib10.counsellingRequired : false,
      //Alternate drugs
      "AlternateDrugs": alternateDrugs,
      //INSTRUCTIONS
      "Instruction": Instruction,
      //FREQUENCY RULES
      "FrequencyRules": FrequencyRulesData,
      //DISPENSE RULES
      "DrugDispRules": DrugDispRulesData,
      //STATUS
      "Status": (_data$status$status$v = data === null || data === void 0 ? void 0 : (_data$status = data.status) === null || _data$status === void 0 ? void 0 : (_data$status$status = _data$status.status) === null || _data$status$status === void 0 ? void 0 : _data$status$status.value) !== null && _data$status$status$v !== void 0 ? _data$status$status$v : "",
      "EffectiveFrom": data !== null && data !== void 0 && (_data$status2 = data.status) !== null && _data$status2 !== void 0 && _data$status2.effectiveFrom ? (_getUtcTime = getUtcTime(moment__default["default"](data === null || data === void 0 ? void 0 : (_data$status3 = data.status) === null || _data$status3 === void 0 ? void 0 : _data$status3.effectiveFrom))) !== null && _getUtcTime !== void 0 ? _getUtcTime : null : null,
      "EffectiveTo": data !== null && data !== void 0 && (_data$status4 = data.status) !== null && _data$status4 !== void 0 && _data$status4.effectiveTo ? (_getUtcTime2 = getUtcTime(moment__default["default"](data === null || data === void 0 ? void 0 : (_data$status5 = data.status) === null || _data$status5 === void 0 ? void 0 : _data$status5.effectiveTo))) !== null && _getUtcTime2 !== void 0 ? _getUtcTime2 : null : null,
      "InactiveReason": (_data$status$reason = data === null || data === void 0 ? void 0 : (_data$status6 = data.status) === null || _data$status6 === void 0 ? void 0 : _data$status6.reason) !== null && _data$status$reason !== void 0 ? _data$status$reason : "",
      "statusactive": statusactive,
      // save type
      "draftstatus": draftstatus,
      // SourceOfDrugOrderCatalog type
      "SourceOfDrugOrderCatalog": data !== null && data !== void 0 && data.SourceOfDrugOrderCatalog ? "".concat(data === null || data === void 0 ? void 0 : data.SourceOfDrugOrderCatalog) : "",
      "mappedItems": mappedItemsData //No use keys
      // "OrderUOMAllowed": "string",
      // "DoseRoundUpVal": "number",
      // "AdminUOM": "string",
      // "TotalVolContent": "string",
      // "TotalVolContentUoM": "string",
      // "IVFluid": "boolean",
      // "DfltInfuseOverDurationvalue": "number",
      // "DfltInfuseOverDurationType": "string",
      // "DfltFluidCode": "string",
      // "InactiveDate": "number",
      // "InactiveByid": "string",
      // "DispenseAlternateDrug": "boolean",
      // "SpecialInstructionText": "array",
      // "DrugImageID": "number",
      // "DrugItem": "boolean",
      // "DrugGenericId": "string",
      // "IngredientListId": "string",

    }
  })];
  return json;
};

var optionValues = function optionValues(data) {
  var option = _objectSpread2({
    value: data === null || data === void 0 ? void 0 : data._id,
    label: data === null || data === void 0 ? void 0 : data.shortdesc
  }, data);

  return option;
};

var allowedData = function allowedData(data) {
  var ary = [];

  if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
    data === null || data === void 0 ? void 0 : data.map(function (v) {
      var data = {
        "allowedValue": {
          "value": v !== null && v !== void 0 && v.AllowedOrderDoseVal ? "".concat(v === null || v === void 0 ? void 0 : v.AllowedOrderDoseVal) : "",
          "type": v !== null && v !== void 0 && v.AllowedOrderDoseUOM ? optionValues(v === null || v === void 0 ? void 0 : v.AllowedOrderDoseUOM) : null
        },
        "allowedVolume": {
          "value": v !== null && v !== void 0 && v.AllowedOrderDoseVolVal ? "".concat(v === null || v === void 0 ? void 0 : v.AllowedOrderDoseVolVal) : "",
          "type": v !== null && v !== void 0 && v.AllowedOrderDoseVolUoM ? optionValues(v === null || v === void 0 ? void 0 : v.AllowedOrderDoseVolUoM) : null
        }
      };
      ary.push(data);
    });
  }

  return ary;
};

var readDrugMasterJSON = function readDrugMasterJSON(data, state) {
  var _data$StrengthValuesP, _data$AlternateDrugs, _data$Instruction, _data$DrugDispRules, _data$FrequencyRules, _data$mappedItems, _data$DrugCode, _data$ShortDesc, _data$LongDesc, _data$Formulary, _data$DrugSynonyms, _state$drug_master9, _state$drug_master9$d, _state$drug_master10, _state$drug_master10$, _state$drug_master11, _state$drug_master11$, _data$InactiveReason, _data$TrialDrug, _data$Additive, _data$ApplicableForCo, _data$Dispenseviapres, _data$counsellingRequ;

  var multipleOption = function multipleOption(data, list) {
    var arry = [];

    if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
      var _list$filter;

      arry = (_list$filter = list.filter(function (val) {
        return data.map(function (va) {
          return va._id;
        }).includes(val.value);
      })) !== null && _list$filter !== void 0 ? _list$filter : [];
    }

    return arry;
  };

  var singelOption = function singelOption(data, list) {
    var object = {};

    if (data) {
      var _list$filter$, _list$filter2;

      object = (_list$filter$ = (_list$filter2 = list.filter(function (val) {
        return val.value === data._id;
      })) === null || _list$filter2 === void 0 ? void 0 : _list$filter2[0]) !== null && _list$filter$ !== void 0 ? _list$filter$ : {};
    }

    return object;
  };

  var singelOptionComLable = function singelOptionComLable(data, list) {
    var object = {};

    if (data) {
      var _list$filter$2, _list$filter3;

      object = (_list$filter$2 = (_list$filter3 = list.filter(function (val) {
        return val.label === data;
      })) === null || _list$filter3 === void 0 ? void 0 : _list$filter3[0]) !== null && _list$filter$2 !== void 0 ? _list$filter$2 : {};
    }

    return object;
  };

  var StrengthValuesPossibleRead = [];

  if ((data === null || data === void 0 ? void 0 : (_data$StrengthValuesP = data.StrengthValuesPossible) === null || _data$StrengthValuesP === void 0 ? void 0 : _data$StrengthValuesP.length) > 0) {
    var _data$StrengthValuesP2;

    data === null || data === void 0 ? void 0 : (_data$StrengthValuesP2 = data.StrengthValuesPossible) === null || _data$StrengthValuesP2 === void 0 ? void 0 : _data$StrengthValuesP2.map(function (vl) {
      var data = {
        "strength": {
          "strengthValue": {
            "value": vl !== null && vl !== void 0 && vl.StrengthValue ? "".concat(vl === null || vl === void 0 ? void 0 : vl.StrengthValue) : "",
            "type": vl !== null && vl !== void 0 && vl.StrengthUOM ? optionValues(vl === null || vl === void 0 ? void 0 : vl.StrengthUOM) : null
          },
          "strengthVolume": {
            "value": vl !== null && vl !== void 0 && vl.StrengthVolume ? "".concat(vl === null || vl === void 0 ? void 0 : vl.StrengthVolume) : "",
            "type": vl !== null && vl !== void 0 && vl.StrengthVolumeUoM ? optionValues(vl === null || vl === void 0 ? void 0 : vl.StrengthVolumeUoM) : null
          }
        },
        "allowed": vl !== null && vl !== void 0 && vl.OrderUOMAllowed ? allowedData(vl === null || vl === void 0 ? void 0 : vl.OrderUOMAllowed) : []
      };
      StrengthValuesPossibleRead.push(data);
    });
  }

  var alternateDrugsData = [];

  if ((data === null || data === void 0 ? void 0 : (_data$AlternateDrugs = data.AlternateDrugs) === null || _data$AlternateDrugs === void 0 ? void 0 : _data$AlternateDrugs.length) > 0) {
    var _state$drug_master$da, _state$drug_master, _state$drug_master$da2, _state$drug_master$da3;

    alternateDrugsData = (_state$drug_master$da = state === null || state === void 0 ? void 0 : (_state$drug_master = state.drug_master) === null || _state$drug_master === void 0 ? void 0 : (_state$drug_master$da2 = _state$drug_master.data) === null || _state$drug_master$da2 === void 0 ? void 0 : (_state$drug_master$da3 = _state$drug_master$da2.alternate_drug_code) === null || _state$drug_master$da3 === void 0 ? void 0 : _state$drug_master$da3.filter(function (val) {
      var _data$AlternateDrugs2;

      return data === null || data === void 0 ? void 0 : (_data$AlternateDrugs2 = data.AlternateDrugs) === null || _data$AlternateDrugs2 === void 0 ? void 0 : _data$AlternateDrugs2.map(function (va) {
        return va;
      }).includes(val.value);
    })) !== null && _state$drug_master$da !== void 0 ? _state$drug_master$da : [];
  }

  var instructionsData = [];

  if ((data === null || data === void 0 ? void 0 : (_data$Instruction = data.Instruction) === null || _data$Instruction === void 0 ? void 0 : _data$Instruction.length) > 0) {
    var _data$Instruction2;

    data === null || data === void 0 ? void 0 : (_data$Instruction2 = data.Instruction) === null || _data$Instruction2 === void 0 ? void 0 : _data$Instruction2.map(function (val) {
      var _val$encountertype, _val$encountertype2, _state$drug_master2, _state$drug_master2$d, _val$gendercode, _val$gendercode$, _val$agegroup, _val$agegroup2, _val$agecatgcode, _state$drug_master3, _state$drug_master3$d, _val$OrderInstr$0$pat, _val$OrderInstr, _val$OrderInstr$, _val$OrderInstr$0$pra, _val$OrderInstr2, _val$OrderInstr2$, _val$OrderInstr$0$pre, _val$OrderInstr3, _val$OrderInstr3$, _val$OrderInstr$0$dep, _val$OrderInstr4, _val$OrderInstr4$;

      var dataJson = {
        "encounterType": (val === null || val === void 0 ? void 0 : (_val$encountertype = val.encountertype) === null || _val$encountertype === void 0 ? void 0 : _val$encountertype.length) > 0 ? singelOption(val === null || val === void 0 ? void 0 : (_val$encountertype2 = val.encountertype) === null || _val$encountertype2 === void 0 ? void 0 : _val$encountertype2[0], state === null || state === void 0 ? void 0 : (_state$drug_master2 = state.drug_master) === null || _state$drug_master2 === void 0 ? void 0 : (_state$drug_master2$d = _state$drug_master2.data) === null || _state$drug_master2$d === void 0 ? void 0 : _state$drug_master2$d.encounter_type) : null,
        "gender": val !== null && val !== void 0 && val.gendercode ? val === null || val === void 0 ? void 0 : (_val$gendercode = val.gendercode) === null || _val$gendercode === void 0 ? void 0 : (_val$gendercode$ = _val$gendercode[0]) === null || _val$gendercode$ === void 0 ? void 0 : _val$gendercode$._id : null,
        "ageGroup": val !== null && val !== void 0 && (_val$agegroup = val.agegroup) !== null && _val$agegroup !== void 0 && _val$agegroup[0] ? optionValues(val === null || val === void 0 ? void 0 : (_val$agegroup2 = val.agegroup) === null || _val$agegroup2 === void 0 ? void 0 : _val$agegroup2[0]) : null,
        "ageCategory": (val === null || val === void 0 ? void 0 : (_val$agecatgcode = val.agecatgcode) === null || _val$agecatgcode === void 0 ? void 0 : _val$agecatgcode.length) > 0 ? multipleOption(val === null || val === void 0 ? void 0 : val.agecatgcode, state === null || state === void 0 ? void 0 : (_state$drug_master3 = state.drug_master) === null || _state$drug_master3 === void 0 ? void 0 : (_state$drug_master3$d = _state$drug_master3.data) === null || _state$drug_master3$d === void 0 ? void 0 : _state$drug_master3$d.age_category) : [],
        "patientInstructions": (_val$OrderInstr$0$pat = val === null || val === void 0 ? void 0 : (_val$OrderInstr = val.OrderInstr) === null || _val$OrderInstr === void 0 ? void 0 : (_val$OrderInstr$ = _val$OrderInstr[0]) === null || _val$OrderInstr$ === void 0 ? void 0 : _val$OrderInstr$.patientInst) !== null && _val$OrderInstr$0$pat !== void 0 ? _val$OrderInstr$0$pat : "",
        "practitionerInstructions": (_val$OrderInstr$0$pra = val === null || val === void 0 ? void 0 : (_val$OrderInstr2 = val.OrderInstr) === null || _val$OrderInstr2 === void 0 ? void 0 : (_val$OrderInstr2$ = _val$OrderInstr2[0]) === null || _val$OrderInstr2$ === void 0 ? void 0 : _val$OrderInstr2$.practionerInst) !== null && _val$OrderInstr$0$pra !== void 0 ? _val$OrderInstr$0$pra : "",
        "prepratoryInstructions": (_val$OrderInstr$0$pre = val === null || val === void 0 ? void 0 : (_val$OrderInstr3 = val.OrderInstr) === null || _val$OrderInstr3 === void 0 ? void 0 : (_val$OrderInstr3$ = _val$OrderInstr3[0]) === null || _val$OrderInstr3$ === void 0 ? void 0 : _val$OrderInstr3$.prepInstr) !== null && _val$OrderInstr$0$pre !== void 0 ? _val$OrderInstr$0$pre : "",
        "departmentInstructions": (_val$OrderInstr$0$dep = val === null || val === void 0 ? void 0 : (_val$OrderInstr4 = val.OrderInstr) === null || _val$OrderInstr4 === void 0 ? void 0 : (_val$OrderInstr4$ = _val$OrderInstr4[0]) === null || _val$OrderInstr4$ === void 0 ? void 0 : _val$OrderInstr4$.deptInstr) !== null && _val$OrderInstr$0$dep !== void 0 ? _val$OrderInstr$0$dep : ""
      };
      instructionsData.push(dataJson);
    });
  }

  var dispensesRulesData = [];

  if ((data === null || data === void 0 ? void 0 : (_data$DrugDispRules = data.DrugDispRules) === null || _data$DrugDispRules === void 0 ? void 0 : _data$DrugDispRules.length) > 0) {
    var _data$DrugDispRules2;

    data === null || data === void 0 ? void 0 : (_data$DrugDispRules2 = data.DrugDispRules) === null || _data$DrugDispRules2 === void 0 ? void 0 : _data$DrugDispRules2.map(function (val) {
      var _val$MaxDispDurnRuleb, _val$MaxDispDurnRuleb2, _val$MaxDispDurnRuleb3, _val$MaxDispDurnRuleb4, _val$MaxDispDurnRuleb5, _val$MaxDispDurnRuleb6, _state$drug_master4, _state$drug_master4$d, _val$MaxDispDurnRuleb7, _val$MaxDispDurnRuleb8, _val$MaxDispDurnRuleb9, _val$MaxDispDurnRuleb10, _val$MaxDispDurnRuleb11, _val$MaxDispDurnRuleb12, _val$MaxDispDurnRuleb13, _val$MaxDispDurnRuleb14, _val$MaxDispDurnRuleb15, _val$MaxDispDurnRuleb16, _val$MaxDispDurnRuleb17, _val$MaxDispDurnRuleb18, _val$MaxDispDurnRuleb19, _val$MaxDispDurnRuleb20, _val$MaxDispDurnRuleb21, _state$drug_master5, _state$drug_master5$d, _val$MaxDispDurnRuleb22, _val$MaxDispDurnRuleb23, _val$MaxDispDurnRuleb24;

      var dataJson = {
        "encounterType": (val === null || val === void 0 ? void 0 : (_val$MaxDispDurnRuleb = val.MaxDispDurnRulebyEnctype) === null || _val$MaxDispDurnRuleb === void 0 ? void 0 : (_val$MaxDispDurnRuleb2 = _val$MaxDispDurnRuleb[0]) === null || _val$MaxDispDurnRuleb2 === void 0 ? void 0 : (_val$MaxDispDurnRuleb3 = _val$MaxDispDurnRuleb2.EncounterType) === null || _val$MaxDispDurnRuleb3 === void 0 ? void 0 : _val$MaxDispDurnRuleb3.length) > 0 ? singelOption(val === null || val === void 0 ? void 0 : (_val$MaxDispDurnRuleb4 = val.MaxDispDurnRulebyEnctype) === null || _val$MaxDispDurnRuleb4 === void 0 ? void 0 : (_val$MaxDispDurnRuleb5 = _val$MaxDispDurnRuleb4[0]) === null || _val$MaxDispDurnRuleb5 === void 0 ? void 0 : (_val$MaxDispDurnRuleb6 = _val$MaxDispDurnRuleb5.EncounterType) === null || _val$MaxDispDurnRuleb6 === void 0 ? void 0 : _val$MaxDispDurnRuleb6[0], state === null || state === void 0 ? void 0 : (_state$drug_master4 = state.drug_master) === null || _state$drug_master4 === void 0 ? void 0 : (_state$drug_master4$d = _state$drug_master4.data) === null || _state$drug_master4$d === void 0 ? void 0 : _state$drug_master4$d.encounter_type) : null,
        "maxDispenseDurationValue": {
          "type": (val === null || val === void 0 ? void 0 : (_val$MaxDispDurnRuleb7 = val.MaxDispDurnRulebyEnctype) === null || _val$MaxDispDurnRuleb7 === void 0 ? void 0 : (_val$MaxDispDurnRuleb8 = _val$MaxDispDurnRuleb7[0]) === null || _val$MaxDispDurnRuleb8 === void 0 ? void 0 : (_val$MaxDispDurnRuleb9 = _val$MaxDispDurnRuleb8.MaxDispDurationUOM) === null || _val$MaxDispDurnRuleb9 === void 0 ? void 0 : _val$MaxDispDurnRuleb9.length) > 0 ? optionValues(val === null || val === void 0 ? void 0 : (_val$MaxDispDurnRuleb10 = val.MaxDispDurnRulebyEnctype) === null || _val$MaxDispDurnRuleb10 === void 0 ? void 0 : (_val$MaxDispDurnRuleb11 = _val$MaxDispDurnRuleb10[0]) === null || _val$MaxDispDurnRuleb11 === void 0 ? void 0 : (_val$MaxDispDurnRuleb12 = _val$MaxDispDurnRuleb11.MaxDispDurationUOM) === null || _val$MaxDispDurnRuleb12 === void 0 ? void 0 : _val$MaxDispDurnRuleb12[0]) : {},
          "value": val !== null && val !== void 0 && (_val$MaxDispDurnRuleb13 = val.MaxDispDurnRulebyEnctype) !== null && _val$MaxDispDurnRuleb13 !== void 0 && (_val$MaxDispDurnRuleb14 = _val$MaxDispDurnRuleb13[0]) !== null && _val$MaxDispDurnRuleb14 !== void 0 && _val$MaxDispDurnRuleb14.MaxDispDurationVal ? "".concat(val === null || val === void 0 ? void 0 : (_val$MaxDispDurnRuleb15 = val.MaxDispDurnRulebyEnctype) === null || _val$MaxDispDurnRuleb15 === void 0 ? void 0 : (_val$MaxDispDurnRuleb16 = _val$MaxDispDurnRuleb15[0]) === null || _val$MaxDispDurnRuleb16 === void 0 ? void 0 : _val$MaxDispDurnRuleb16.MaxDispDurationVal) : ""
        },
        "actions": (val === null || val === void 0 ? void 0 : (_val$MaxDispDurnRuleb17 = val.MaxDispDurnRulebyEnctype) === null || _val$MaxDispDurnRuleb17 === void 0 ? void 0 : (_val$MaxDispDurnRuleb18 = _val$MaxDispDurnRuleb17[0]) === null || _val$MaxDispDurnRuleb18 === void 0 ? void 0 : (_val$MaxDispDurnRuleb19 = _val$MaxDispDurnRuleb18.Action) === null || _val$MaxDispDurnRuleb19 === void 0 ? void 0 : _val$MaxDispDurnRuleb19.length) > 0 ? singelOptionComLable(val === null || val === void 0 ? void 0 : (_val$MaxDispDurnRuleb20 = val.MaxDispDurnRulebyEnctype) === null || _val$MaxDispDurnRuleb20 === void 0 ? void 0 : (_val$MaxDispDurnRuleb21 = _val$MaxDispDurnRuleb20[0]) === null || _val$MaxDispDurnRuleb21 === void 0 ? void 0 : _val$MaxDispDurnRuleb21.Action, state === null || state === void 0 ? void 0 : (_state$drug_master5 = state.drug_master) === null || _state$drug_master5 === void 0 ? void 0 : (_state$drug_master5$d = _state$drug_master5.data) === null || _state$drug_master5$d === void 0 ? void 0 : _state$drug_master5$d.actions) : {},
        "actionMessage": (_val$MaxDispDurnRuleb22 = val === null || val === void 0 ? void 0 : (_val$MaxDispDurnRuleb23 = val.MaxDispDurnRulebyEnctype) === null || _val$MaxDispDurnRuleb23 === void 0 ? void 0 : (_val$MaxDispDurnRuleb24 = _val$MaxDispDurnRuleb23[0]) === null || _val$MaxDispDurnRuleb24 === void 0 ? void 0 : _val$MaxDispDurnRuleb24.ActionMessage) !== null && _val$MaxDispDurnRuleb22 !== void 0 ? _val$MaxDispDurnRuleb22 : ""
      };
      dispensesRulesData.push(dataJson);
    });
  }

  var tableDtat = function tableDtat(data) {
    var datatable = [];
    data === null || data === void 0 ? void 0 : data.map(function (val) {
      var _state$drug_master6, _state$drug_master6$d, _cat$label, _cat$age_minimum, _cat$age_maximum, _cat$UOM$0$display, _cat$UOM, _cat$UOM$, _state$drug_master7, _state$drug_master7$d;

      var cat = val !== null && val !== void 0 && val.AgeCatgCode ? singelOption(val === null || val === void 0 ? void 0 : val.AgeCatgCode, state === null || state === void 0 ? void 0 : (_state$drug_master6 = state.drug_master) === null || _state$drug_master6 === void 0 ? void 0 : (_state$drug_master6$d = _state$drug_master6.data) === null || _state$drug_master6$d === void 0 ? void 0 : _state$drug_master6$d.age_category) : null;

      var json = _objectSpread2({
        "ageCategory": (_cat$label = cat === null || cat === void 0 ? void 0 : cat.label) !== null && _cat$label !== void 0 ? _cat$label : "",
        "ageMin": (_cat$age_minimum = cat === null || cat === void 0 ? void 0 : cat.age_minimum) !== null && _cat$age_minimum !== void 0 ? _cat$age_minimum : "",
        "ageMax": (_cat$age_maximum = cat === null || cat === void 0 ? void 0 : cat.age_maximum) !== null && _cat$age_maximum !== void 0 ? _cat$age_maximum : "",
        "unit": (_cat$UOM$0$display = cat === null || cat === void 0 ? void 0 : (_cat$UOM = cat.UOM) === null || _cat$UOM === void 0 ? void 0 : (_cat$UOM$ = _cat$UOM[0]) === null || _cat$UOM$ === void 0 ? void 0 : _cat$UOM$.display) !== null && _cat$UOM$0$display !== void 0 ? _cat$UOM$0$display : "",
        "defaultFrequency": val !== null && val !== void 0 && val.dfltfreqcode ? singelOption(val === null || val === void 0 ? void 0 : val.dfltfreqcode, state === null || state === void 0 ? void 0 : (_state$drug_master7 = state.drug_master) === null || _state$drug_master7 === void 0 ? void 0 : (_state$drug_master7$d = _state$drug_master7.data) === null || _state$drug_master7$d === void 0 ? void 0 : _state$drug_master7$d.default_frequency) : {},
        "defaultDuration": {
          "value": val !== null && val !== void 0 && val.dfltdurationcode ? "".concat(val === null || val === void 0 ? void 0 : val.dfltdurationcode) : "",
          "type": val !== null && val !== void 0 && val.dfltdurnUOM ? optionValues(val === null || val === void 0 ? void 0 : val.dfltdurnUOM) : {}
        },
        "defaultDose": {
          "value": val !== null && val !== void 0 && val.dfltdoseval ? "".concat(val === null || val === void 0 ? void 0 : val.dfltdoseval) : "",
          "type": val !== null && val !== void 0 && val.dfltdoseUOM ? optionValues(val === null || val === void 0 ? void 0 : val.dfltdoseUOM) : {}
        },
        "infuseOverDuration": {
          "value": val !== null && val !== void 0 && val.DfltInfuseOverDurationval ? "".concat(val === null || val === void 0 ? void 0 : val.DfltInfuseOverDurationval) : "",
          "type": val !== null && val !== void 0 && val.DfltInfuseOverDurationType ? optionValues(val === null || val === void 0 ? void 0 : val.DfltInfuseOverDurationType) : {}
        }
      }, cat);

      datatable.push(json);
    });
    return datatable;
  };

  var frequencyRulesData = [];

  if ((data === null || data === void 0 ? void 0 : (_data$FrequencyRules = data.FrequencyRules) === null || _data$FrequencyRules === void 0 ? void 0 : _data$FrequencyRules.length) > 0) {
    var _data$FrequencyRules2;

    data === null || data === void 0 ? void 0 : (_data$FrequencyRules2 = data.FrequencyRules) === null || _data$FrequencyRules2 === void 0 ? void 0 : _data$FrequencyRules2.map(function (val) {
      var _val$DfltFreqbyPatAtt;

      if ((val === null || val === void 0 ? void 0 : (_val$DfltFreqbyPatAtt = val.DfltFreqbyPatAttrib) === null || _val$DfltFreqbyPatAtt === void 0 ? void 0 : _val$DfltFreqbyPatAtt.length) > 0) {
        var _val$DfltFreqbyPatAtt2, _val$DfltFreqbyPatAtt3, _val$DfltFreqbyPatAtt4, _val$DfltFreqbyPatAtt5, _state$drug_master8, _state$drug_master8$d, _val$DfltFreqbyPatAtt6, _val$DfltFreqbyPatAtt7, _val$DfltFreqbyPatAtt8, _val$DfltFreqbyPatAtt9, _val$DfltFreqbyPatAtt10, _val$DfltFreqbyPatAtt11, _val$DfltFreqbyPatAtt12, _val$DfltFreqbyPatAtt13, _tableDtat;

        var dataJson = {
          "encounterType": val !== null && val !== void 0 && (_val$DfltFreqbyPatAtt2 = val.DfltFreqbyPatAttrib) !== null && _val$DfltFreqbyPatAtt2 !== void 0 && (_val$DfltFreqbyPatAtt3 = _val$DfltFreqbyPatAtt2[0]) !== null && _val$DfltFreqbyPatAtt3 !== void 0 && _val$DfltFreqbyPatAtt3.encountertype ? singelOption(val === null || val === void 0 ? void 0 : (_val$DfltFreqbyPatAtt4 = val.DfltFreqbyPatAttrib) === null || _val$DfltFreqbyPatAtt4 === void 0 ? void 0 : (_val$DfltFreqbyPatAtt5 = _val$DfltFreqbyPatAtt4[0]) === null || _val$DfltFreqbyPatAtt5 === void 0 ? void 0 : _val$DfltFreqbyPatAtt5.encountertype, state === null || state === void 0 ? void 0 : (_state$drug_master8 = state.drug_master) === null || _state$drug_master8 === void 0 ? void 0 : (_state$drug_master8$d = _state$drug_master8.data) === null || _state$drug_master8$d === void 0 ? void 0 : _state$drug_master8$d.encounter_type) : null,
          "gender": val !== null && val !== void 0 && (_val$DfltFreqbyPatAtt6 = val.DfltFreqbyPatAttrib) !== null && _val$DfltFreqbyPatAtt6 !== void 0 && (_val$DfltFreqbyPatAtt7 = _val$DfltFreqbyPatAtt6[0]) !== null && _val$DfltFreqbyPatAtt7 !== void 0 && _val$DfltFreqbyPatAtt7.gender ? val === null || val === void 0 ? void 0 : (_val$DfltFreqbyPatAtt8 = val.DfltFreqbyPatAttrib) === null || _val$DfltFreqbyPatAtt8 === void 0 ? void 0 : (_val$DfltFreqbyPatAtt9 = _val$DfltFreqbyPatAtt8[0]) === null || _val$DfltFreqbyPatAtt9 === void 0 ? void 0 : _val$DfltFreqbyPatAtt9.gender : null,
          "ageRangeGroup": val !== null && val !== void 0 && (_val$DfltFreqbyPatAtt10 = val.DfltFreqbyPatAttrib) !== null && _val$DfltFreqbyPatAtt10 !== void 0 && (_val$DfltFreqbyPatAtt11 = _val$DfltFreqbyPatAtt10[0]) !== null && _val$DfltFreqbyPatAtt11 !== void 0 && _val$DfltFreqbyPatAtt11.agegroup ? optionValues(val === null || val === void 0 ? void 0 : (_val$DfltFreqbyPatAtt12 = val.DfltFreqbyPatAttrib) === null || _val$DfltFreqbyPatAtt12 === void 0 ? void 0 : (_val$DfltFreqbyPatAtt13 = _val$DfltFreqbyPatAtt12[0]) === null || _val$DfltFreqbyPatAtt13 === void 0 ? void 0 : _val$DfltFreqbyPatAtt13.agegroup) : null,
          "tableData": (_tableDtat = tableDtat(val === null || val === void 0 ? void 0 : val.DfltFreqbyPatAttrib)) !== null && _tableDtat !== void 0 ? _tableDtat : []
        };
        frequencyRulesData.push(dataJson);
      }
    });
  } // let drugSynonymsData = [];
  // if(data?.DrugSynonyms?.length > 0){
  //   data?.DrugSynonyms?.map(val => {
  //     let dataJson = {
  //       "value": val,
  //       "label": val
  //     }
  //     drugSynonymsData.push(dataJson)
  //   })
  // }


  var mappedStackReadData = [];

  if ((data === null || data === void 0 ? void 0 : (_data$mappedItems = data.mappedItems) === null || _data$mappedItems === void 0 ? void 0 : _data$mappedItems.length) > 0) {
    var _data$mappedItems2;

    data === null || data === void 0 ? void 0 : (_data$mappedItems2 = data.mappedItems) === null || _data$mappedItems2 === void 0 ? void 0 : _data$mappedItems2.map(function (val) {
      var _val$StockItemCodes, _val$StockItemCodes$, _val$StockItemCodes2, _val$StockItemCodes2$, _val$StockItemCodes2$2, _val$StockItemCodes$2, _val$StockItemCodes3, _val$StockItemCodes3$, _val$StockItemCodes$3, _val$StockItemCodes4, _val$StockItemCodes4$;

      var dataJson = {
        "itemCodeDesc": val !== null && val !== void 0 && (_val$StockItemCodes = val.StockItemCodes) !== null && _val$StockItemCodes !== void 0 && (_val$StockItemCodes$ = _val$StockItemCodes[0]) !== null && _val$StockItemCodes$ !== void 0 && _val$StockItemCodes$.stkitemcode ? optionValues(val === null || val === void 0 ? void 0 : (_val$StockItemCodes2 = val.StockItemCodes) === null || _val$StockItemCodes2 === void 0 ? void 0 : (_val$StockItemCodes2$ = _val$StockItemCodes2[0]) === null || _val$StockItemCodes2$ === void 0 ? void 0 : (_val$StockItemCodes2$2 = _val$StockItemCodes2$.stkitemcode) === null || _val$StockItemCodes2$2 === void 0 ? void 0 : _val$StockItemCodes2$2[0]) : {},
        "preferredSeq": (_val$StockItemCodes$2 = val === null || val === void 0 ? void 0 : (_val$StockItemCodes3 = val.StockItemCodes) === null || _val$StockItemCodes3 === void 0 ? void 0 : (_val$StockItemCodes3$ = _val$StockItemCodes3[0]) === null || _val$StockItemCodes3$ === void 0 ? void 0 : _val$StockItemCodes3$.prefferedseqno) !== null && _val$StockItemCodes$2 !== void 0 ? _val$StockItemCodes$2 : "",
        "alternate": (_val$StockItemCodes$3 = val === null || val === void 0 ? void 0 : (_val$StockItemCodes4 = val.StockItemCodes) === null || _val$StockItemCodes4 === void 0 ? void 0 : (_val$StockItemCodes4$ = _val$StockItemCodes4[0]) === null || _val$StockItemCodes4$ === void 0 ? void 0 : _val$StockItemCodes4$.Alternate) !== null && _val$StockItemCodes$3 !== void 0 ? _val$StockItemCodes$3 : false // "data": val

      };
      mappedStackReadData.push(dataJson);
    });
  }

  var json = {
    "phDrugMaster": {
      "drug": data === null || data === void 0 ? void 0 : data.Charge,
      "code": (_data$DrugCode = data === null || data === void 0 ? void 0 : data.DrugCode) !== null && _data$DrugCode !== void 0 ? _data$DrugCode : "",
      "shortDescription": (_data$ShortDesc = data === null || data === void 0 ? void 0 : data.ShortDesc) !== null && _data$ShortDesc !== void 0 ? _data$ShortDesc : "",
      "longDescription": (_data$LongDesc = data === null || data === void 0 ? void 0 : data.LongDesc) !== null && _data$LongDesc !== void 0 ? _data$LongDesc : "",
      "inFormulary": (_data$Formulary = data === null || data === void 0 ? void 0 : data.Formulary) !== null && _data$Formulary !== void 0 ? _data$Formulary : false,
      "synonym": (data === null || data === void 0 ? void 0 : (_data$DrugSynonyms = data.DrugSynonyms) === null || _data$DrugSynonyms === void 0 ? void 0 : _data$DrugSynonyms.length) > 0 ? data === null || data === void 0 ? void 0 : data.DrugSynonyms : [],
      "class": data !== null && data !== void 0 && data.DrugClass ? optionValues(data === null || data === void 0 ? void 0 : data.DrugClass) : null,
      "category": data !== null && data !== void 0 && data.DrugCategory ? optionValues(data === null || data === void 0 ? void 0 : data.DrugCategory) : null,
      "type": data !== null && data !== void 0 && data.DrugType ? optionValues(data === null || data === void 0 ? void 0 : data.DrugType) : null,
      "form": data !== null && data !== void 0 && data.FormCode ? optionValues(data === null || data === void 0 ? void 0 : data.FormCode) : null,
      "routesAllowed": data !== null && data !== void 0 && data.RoutesAllowed ? multipleOption(data === null || data === void 0 ? void 0 : data.RoutesAllowed, state === null || state === void 0 ? void 0 : (_state$drug_master9 = state.drug_master) === null || _state$drug_master9 === void 0 ? void 0 : (_state$drug_master9$d = _state$drug_master9.data) === null || _state$drug_master9$d === void 0 ? void 0 : _state$drug_master9$d.routes_allowed) : [],
      "defaultRoute": data !== null && data !== void 0 && data.DefaultRouteCode ? singelOption(data === null || data === void 0 ? void 0 : data.DefaultRouteCode, state === null || state === void 0 ? void 0 : (_state$drug_master10 = state.drug_master) === null || _state$drug_master10 === void 0 ? void 0 : (_state$drug_master10$ = _state$drug_master10.data) === null || _state$drug_master10$ === void 0 ? void 0 : _state$drug_master10$.default_route) : []
    },
    "draftstatus": data === null || data === void 0 ? void 0 : data.draftstatus,
    "statusactive": data === null || data === void 0 ? void 0 : data.statusactive,
    "SourceOfDrugOrderCatalog": data === null || data === void 0 ? void 0 : data.SourceOfDrugOrderCatalog,
    "status": {
      "status": data !== null && data !== void 0 && data.Status ? singelOptionComLable(data === null || data === void 0 ? void 0 : data.Status, state === null || state === void 0 ? void 0 : (_state$drug_master11 = state.drug_master) === null || _state$drug_master11 === void 0 ? void 0 : (_state$drug_master11$ = _state$drug_master11.data) === null || _state$drug_master11$ === void 0 ? void 0 : _state$drug_master11$.status) : [],
      "effectiveFrom": data !== null && data !== void 0 && data.EffectiveFrom ? utcTOLocal(data === null || data === void 0 ? void 0 : data.EffectiveFrom, "YYYY-MM-DD") : null,
      "effectiveTo": data !== null && data !== void 0 && data.EffectiveTo ? utcTOLocal(data === null || data === void 0 ? void 0 : data.EffectiveTo, "YYYY-MM-DD") : null,
      "reason": (_data$InactiveReason = data === null || data === void 0 ? void 0 : data.InactiveReason) !== null && _data$InactiveReason !== void 0 ? _data$InactiveReason : ""
    },
    "drugOtherAttributes": {
      "trailDrug": (_data$TrialDrug = data === null || data === void 0 ? void 0 : data.TrialDrug) !== null && _data$TrialDrug !== void 0 ? _data$TrialDrug : false,
      "usedAsAddictive": (_data$Additive = data === null || data === void 0 ? void 0 : data.Additive) !== null && _data$Additive !== void 0 ? _data$Additive : false,
      "usedForCompoundPreparation": (_data$ApplicableForCo = data === null || data === void 0 ? void 0 : data.ApplicableForCompounding) !== null && _data$ApplicableForCo !== void 0 ? _data$ApplicableForCo : false,
      "dispenseViaRxOnly": (_data$Dispenseviapres = data === null || data === void 0 ? void 0 : data.DispenseviaprescriptionOnly) !== null && _data$Dispenseviapres !== void 0 ? _data$Dispenseviapres : false,
      "counsellingRequired": (_data$counsellingRequ = data === null || data === void 0 ? void 0 : data.counsellingRequired) !== null && _data$counsellingRequ !== void 0 ? _data$counsellingRequ : false
    },
    "availableStrengths": StrengthValuesPossibleRead,
    "mappedStack": mappedStackReadData,
    "alternateDrugs": alternateDrugsData,
    "instructions": instructionsData,
    "dispensesRules": dispensesRulesData,
    "frequencyRules": frequencyRulesData // [
    //   {
    //     "encounterType": {
    //       "label": "Emergency",
    //       "value": "CodeableConceptMaster/11189",
    //       "Type": "ENCOUNTERTYPE",
    //       "_id": "CodeableConceptMaster/11189",
    //       "_key": "11189",
    //       "_rev": "_cmRdm8O---",
    //       "activestatus": true,
    //       "coding": [
    //         {
    //           "_key": "10957",
    //           "_id": "CodingMaster/10957",
    //           "_rev": "_cwsxyxq--Q",
    //           "system": "",
    //           "version": "1",
    //           "code": "ET001",
    //           "display": "Emergency",
    //           "userSelected": true,
    //           "id": 890,
    //           "Type": "Encounter Type",
    //           "createdby": "",
    //           "updatedby": "",
    //           "activestatus": true
    //         }
    //       ],
    //       "createdby": "",
    //       "createddate": "08/07/2021 06:41:51",
    //       "id": 1110,
    //       "text": "",
    //       "updatedate": "08/07/2021 06:41:51",
    //       "updatedby": ""
    //     },
    //     "gender": "CodeableConceptMaster/11236",
    //     "ageRangeGroup": {
    //       "label": "Short",
    //       "value": "AgeRanges/10029",
    //       "id": null,
    //       "_id": "AgeRanges/10029",
    //       "agerangecode": "Code",
    //       "longdesc": "Long",
    //       "shortdesc": "Short"
    //     },
    //     "tableData": [
    //       {
    //         "ageCategory": "Category",
    //         "ageMin": "0",
    //         "ageMax": "12",
    //         "unit": "Months",
    //         "defaultFrequency": {
    //           "label": "test",
    //           "value": "FrequencyMaster/10153",
    //           "_id": "FrequencyMaster/10153",
    //           "id": null,
    //           "freqcode": "12",
    //           "longdesc": "test",
    //           "shortdesc": "test"
    //         },
    //         "defaultDuration": {
    //           "value": "1",
    //           "type": {
    //             "label": "mg",
    //             "value": "DrugUOM/10062",
    //             "id": 8,
    //             "_id": "DrugUOM/10062",
    //             "UOM": "mg",
    //             "longdesc": "miligram",
    //             "shortdesc": "mg"
    //           }
    //         },
    //         "defaultDose": {
    //           "value": "2",
    //           "type": {
    //             "label": "kg",
    //             "value": "DrugUOM/10064",
    //             "id": 10,
    //             "_id": "DrugUOM/10064",
    //             "UOM": "kg",
    //             "longdesc": "kilogram",
    //             "shortdesc": "kg"
    //           }
    //         },
    //         "infuseOverDuration": {
    //           "value": "3",
    //           "type": {
    //             "label": "kg",
    //             "value": "DrugUOM/10064",
    //             "id": 10,
    //             "_id": "DrugUOM/10064",
    //             "UOM": "kg",
    //             "longdesc": "kilogram",
    //             "shortdesc": "kg"
    //           }
    //         }
    //       }
    //     ]
    //   }
    // ]

  };
  return json;
};

var _extraReducers$1;

var loopMasters = function loopMasters() {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject) {
      var calls;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              calls = Object.keys(masterQuery).map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return fetchMaster(val, masterQuery[val]);

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
              es6Promise.Promise.all(calls).then(function (data) {
                var json = {};
                data.map(function (val) {
                  var arr = [];
                  val.data.map(function (value) {
                    var _value$coding;

                    switch (val.name) {
                      case "status":
                      case "actions":
                        (_value$coding = value.coding) === null || _value$coding === void 0 ? void 0 : _value$coding.map(function (dat) {
                          arr.push(_objectSpread2({
                            label: dat !== null && dat !== void 0 && dat.display ? dat === null || dat === void 0 ? void 0 : dat.display : "",
                            value: dat !== null && dat !== void 0 && dat._id ? dat === null || dat === void 0 ? void 0 : dat._id : ""
                          }, dat));
                        });
                        break;

                      case "encounter_type":
                      case "gender":
                        arr.push(_objectSpread2({
                          label: value.coding ? value.coding[0] ? value.coding[0].display : "" : val,
                          value: value.coding ? value.coding[0] ? value.coding[0]._id : "" : val
                        }, value));
                        break;

                      case "alternate_drug_code":
                        arr.push(_objectSpread2({
                          label: value.ShortDesc ? value.ShortDesc : "",
                          value: value._id
                        }, value));
                        break;

                      case "age_range_group":
                        arr.push(_objectSpread2({
                          label: value.agerangecode,
                          value: value._id
                        }, value));
                        break;

                      case "default_route":
                      case "routes_allowed":
                      case "default_frequency":
                      case "drug_item_master":
                      case "drug_class":
                      case "drug_category":
                      case "drug_type":
                      case "form":
                      case "drug_UOM":
                        arr.push(_objectSpread2({
                          label: value.shortdesc ? value.shortdesc : "",
                          value: value._id
                        }, value));
                        break;

                      case "age_category":
                        arr.push(_objectSpread2({
                          label: value.code ? value.code : "",
                          value: value._id
                        }, value));
                        break;

                      default:
                        arr.push(_objectSpread2({
                          label: value,
                          value: value._id
                        }, value));
                        break;
                    }
                  });
                  json[val.name] = arr;
                  resolve(json);
                });
              })["catch"](function (err) {
                resolve([]);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var fetchMaster = function fetchMaster(name, query) {
  return new es6Promise.Promise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject) {
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetchData({
                body: query
              }, __readDocumentUrl__);

            case 2:
              data = _context3.sent;
              resolve({
                data: data.result,
                name: name
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }());
};

var DRUG_MASTER_READ = toolkit.createAsyncThunk("drugMasterSlice/drug_master_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var payload,
      _ref5,
      rejectWithValue,
      page,
      perpage,
      data,
      arry,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          payload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
          _ref5 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref5.rejectWithValue;
          _context4.prev = 2;
          page = payload.page, perpage = payload.perpage;
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(queries$1.drug_master(page, perpage))
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          arry = [];
          data.result.map(function (val) {
            if (val._id) {
              arry.push(_objectSpread2(_objectSpread2({}, val), {}, {
                "drug_code": val.DrugCode ? val.DrugCode : "",
                "short_description": val.ShortDesc ? val.ShortDesc : "",
                "long_description": val.LongDesc ? val.LongDesc : "",
                "status_active": val.statusactive ? val.statusactive : false,
                "draft_status": val.draftstatus ? val.draftstatus : false,
                "_id": val._id
              }));
            }
          });
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context4.t0.message
          })));

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 12]]);
})));
var DRUG_MASTER_UPSERT = toolkit.createAsyncThunk("drugMasterSlice/drug_master_upsert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var payload,
      _ref7,
      rejectWithValue,
      upsertkey,
      queriesjson,
      data,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          payload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _ref7 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref7.rejectWithValue;
          _context5.prev = 2;
          upsertkey = {
            drug_dosage: payload.drug_dosage,
            short_description: payload.short_description,
            long_description: payload.long_description,
            status: payload.status,
            _key: payload._key
          };
          queriesjson = queries$1.drug_master_upsert(upsertkey);
          _context5.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context5.sent;
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context5.t0.message
          })));

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 11]]);
})));
var DRUG_MASTER_STATUS_CHANGE = toolkit.createAsyncThunk("drugMasterSlice/drug_master_status", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var payload,
      _ref9,
      rejectWithValue,
      statuschange,
      queriesjson,
      data,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          payload = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _ref9 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref9.rejectWithValue;
          _context6.prev = 2;
          statuschange = {
            _id: payload._id,
            status: payload.status
          };
          queriesjson = queries$1.status_update_drug_master(statuschange);
          _context6.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          data = _context6.sent;
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data
          }));

        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context6.t0.message
          })));

        case 14:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 11]]);
})));
var DRUG_MASTERS = toolkit.createAsyncThunk("drugMasterSlice/masterlist", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref11,
      rejectWithValue,
      data,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref11 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref11.rejectWithValue;
          _context7.prev = 2;
          payload.type;
          _context7.next = 6;
          return loopMasters();

        case 6:
          data = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.Info), {}, {
            data: data
          }));

        case 10:
          _context7.prev = 10;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 13:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 10]]);
})));
var SAVE_DRUG_MASTER = toolkit.createAsyncThunk("drugMasterSlice/create_drug_master", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref13,
      rejectWithValue,
      data,
      _key,
      draft,
      queriesjson,
      dataRes,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref13 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref13.rejectWithValue;
          _context8.prev = 2;
          data = payload.data, _key = payload._key, draft = payload.draft;
          queriesjson = generateDrugMasterJSON(data, _key, draft);
          _context8.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          dataRes = _context8.sent;
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: dataRes
          }));

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context8.t0.message
          })));

        case 14:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 11]]);
})));
var DRUG_FORM_TYPE = toolkit.createAsyncThunk("drugMasterSlice/drug_form_type", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var _ref15,
      rejectWithValue,
      data,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _ref15 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref15.rejectWithValue;
          _context9.prev = 2;
          _context9.next = 5;
          return fetchData({
            body: queries$1.drug_form_type
          }, __readDocumentUrl__);

        case 5:
          data = _context9.sent;
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: data.result
          }));

        case 9:
          _context9.prev = 9;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context9.t0.message
          })));

        case 12:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 9]]);
})));
var DRUG_READ_FORM = toolkit.createAsyncThunk("drugMasterSlice/drug_form_read", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
  var payload,
      _ref17,
      rejectWithValue,
      getState,
      _data$result$,
      _data$result,
      state,
      drugState,
      _id,
      data,
      readData,
      _args10 = arguments;

  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {};
          _ref17 = _args10.length > 1 ? _args10[1] : undefined, rejectWithValue = _ref17.rejectWithValue, getState = _ref17.getState;
          _context10.prev = 2;
          state = getState();
          drugState = state.drugMasterSlice;
          _id = payload._id;
          _context10.next = 8;
          return fetchData({
            body: JSON.stringify(queries$1.drug_form_read(_id))
          }, __readDocumentUrl__);

        case 8:
          data = _context10.sent;
          readData = readDrugMasterJSON((_data$result$ = data === null || data === void 0 ? void 0 : (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result[0]) !== null && _data$result$ !== void 0 ? _data$result$ : null, drugState);
          return _context10.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: readData
          }));

        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10["catch"](2);
          return _context10.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context10.t0.message
          })));

        case 16:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[2, 13]]);
})));
var AGE_CATEGORY_BY_ID = toolkit.createAsyncThunk("drugMasterSlice/age_category_by_id", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
  var payload,
      _ref19,
      rejectWithValue,
      _data$result2,
      _ids,
      queriesjson,
      data,
      arry,
      _args11 = arguments;

  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
          _ref19 = _args11.length > 1 ? _args11[1] : undefined, rejectWithValue = _ref19.rejectWithValue;
          _context11.prev = 2;
          _ids = payload._ids;
          queriesjson = queries$1.age_category_by_id(_ids);
          _context11.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 7:
          data = _context11.sent;
          arry = [];
          data === null || data === void 0 ? void 0 : (_data$result2 = data.result) === null || _data$result2 === void 0 ? void 0 : _data$result2.map(function (val) {
            var _val$UOM$0$display, _val$UOM, _val$UOM$;

            arry.push(_objectSpread2({
              value: val._id,
              label: val.code,
              minAge: val.age_minimum,
              maxAge: val.age_maximum,
              unit: (_val$UOM$0$display = val === null || val === void 0 ? void 0 : (_val$UOM = val.UOM) === null || _val$UOM === void 0 ? void 0 : (_val$UOM$ = _val$UOM[0]) === null || _val$UOM$ === void 0 ? void 0 : _val$UOM$.display) !== null && _val$UOM$0$display !== void 0 ? _val$UOM$0$display : ""
            }, val));
          });
          return _context11.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 13:
          _context11.prev = 13;
          _context11.t0 = _context11["catch"](2);
          return _context11.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context11.t0.message
          })));

        case 16:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, null, [[2, 13]]);
})));
var drugMasterSlice = toolkit.createSlice({
  name: "drugMasterSlice",
  initialState: {
    drug_master_list: _objectSpread2({}, defaultState.List),
    drug_master_upsert: _objectSpread2({}, defaultState.List),
    drug_master_status: _objectSpread2({}, defaultState.List),
    drug_master: _objectSpread2({}, defaultState.Info),
    upsert_drug_master: _objectSpread2({}, defaultState.List),
    drug_form_type: _objectSpread2({}, defaultState.List),
    drug_form_read: _objectSpread2({}, defaultState.List),
    age_category_by_id: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers$1 = {}, _defineProperty(_extraReducers$1, DRUG_MASTER_READ.fulfilled, function (state, action) {
    state.drug_master_list.loading = false, state.drug_master_list.error = false, state.drug_master_list = action.payload;
  }), _defineProperty(_extraReducers$1, DRUG_MASTER_READ.pending, function (state, action) {
    state.drug_master_list.loading = true, state.drug_master_list.error = false, state.drug_master_list.loading = true;
  }), _defineProperty(_extraReducers$1, DRUG_MASTER_READ.rejected, function (state, action) {
    state.drug_master_list.loading = false, state.drug_master_list.error = true, state.drug_master_list = action.payload;
  }), _defineProperty(_extraReducers$1, DRUG_MASTER_UPSERT.fulfilled, function (state, action) {
    state.drug_master_upsert.loading = false, state.drug_master_upsert.error = false, state.drug_master_upsert = action.payload;
  }), _defineProperty(_extraReducers$1, DRUG_MASTER_UPSERT.pending, function (state, action) {
    state.drug_master_upsert.loading = true, state.drug_master_upsert.error = false, state.drug_master_upsert.loading = true;
  }), _defineProperty(_extraReducers$1, DRUG_MASTER_UPSERT.rejected, function (state, action) {
    state.drug_master_upsert.loading = false, state.drug_master_upsert.error = true, state.drug_master_upsert = action.payload;
  }), _defineProperty(_extraReducers$1, DRUG_MASTER_STATUS_CHANGE.fulfilled, function (state, action) {
    state.drug_master_status.loading = false, state.drug_master_status.error = false, state.drug_master_status = action.payload;
  }), _defineProperty(_extraReducers$1, DRUG_MASTER_STATUS_CHANGE.pending, function (state, action) {
    state.drug_master_status.loading = true, state.drug_master_status.error = false, state.drug_master_status.loading = true;
  }), _defineProperty(_extraReducers$1, DRUG_MASTER_STATUS_CHANGE.rejected, function (state, action) {
    state.drug_master_status.loading = false, state.drug_master_status.error = true, state.drug_master_status = action.payload;
  }), _defineProperty(_extraReducers$1, DRUG_MASTERS.fulfilled, function (state, action) {
    state.drug_master.loading = false, state.drug_master.error = false, state.drug_master = action.payload;
  }), _defineProperty(_extraReducers$1, DRUG_MASTERS.pending, function (state, action) {
    state.drug_master.loading = true, state.drug_master.error = false, state.drug_master.loading = true;
  }), _defineProperty(_extraReducers$1, DRUG_MASTERS.rejected, function (state, action) {
    state.drug_master.loading = false, state.drug_master.error = true, state.drug_master = action.payload;
  }), _defineProperty(_extraReducers$1, SAVE_DRUG_MASTER.fulfilled, function (state, action) {
    state.upsert_drug_master.loading = false, state.upsert_drug_master.error = false, state.upsert_drug_master = action.payload;
  }), _defineProperty(_extraReducers$1, SAVE_DRUG_MASTER.pending, function (state, action) {
    state.upsert_drug_master.loading = true, state.upsert_drug_master.error = false, state.upsert_drug_master.loading = true;
  }), _defineProperty(_extraReducers$1, SAVE_DRUG_MASTER.rejected, function (state, action) {
    state.upsert_drug_master.loading = false, state.upsert_drug_master.error = true, state.upsert_drug_master = action.payload;
  }), _defineProperty(_extraReducers$1, DRUG_FORM_TYPE.fulfilled, function (state, action) {
    state.drug_form_type.loading = false, state.drug_form_type.error = false, state.drug_form_type = action.payload;
  }), _defineProperty(_extraReducers$1, DRUG_FORM_TYPE.pending, function (state, action) {
    state.drug_form_type.loading = true, state.drug_form_type.error = false, state.drug_form_type.loading = true;
  }), _defineProperty(_extraReducers$1, DRUG_FORM_TYPE.rejected, function (state, action) {
    state.drug_form_type.loading = false, state.drug_form_type.error = true, state.drug_form_type = action.payload;
  }), _defineProperty(_extraReducers$1, DRUG_READ_FORM.fulfilled, function (state, action) {
    state.drug_form_read.loading = false, state.drug_form_read.error = false, state.drug_form_read = action.payload;
  }), _defineProperty(_extraReducers$1, DRUG_READ_FORM.pending, function (state, action) {
    state.drug_form_read.loading = true, state.drug_form_read.error = false, state.drug_form_read.loading = true;
  }), _defineProperty(_extraReducers$1, DRUG_READ_FORM.rejected, function (state, action) {
    state.drug_form_read.loading = false, state.drug_form_read.error = true, state.drug_form_read = action.payload;
  }), _defineProperty(_extraReducers$1, AGE_CATEGORY_BY_ID.fulfilled, function (state, action) {
    state.age_category_by_id.loading = false, state.age_category_by_id.error = false, state.age_category_by_id = action.payload;
  }), _defineProperty(_extraReducers$1, AGE_CATEGORY_BY_ID.pending, function (state, action) {
    state.age_category_by_id.loading = true, state.age_category_by_id.error = false, state.age_category_by_id.loading = true;
  }), _defineProperty(_extraReducers$1, AGE_CATEGORY_BY_ID.rejected, function (state, action) {
    state.age_category_by_id.loading = false, state.age_category_by_id.error = true, state.age_category_by_id = action.payload;
  }), _extraReducers$1)
});
drugMasterSlice.reducer;

// import { dbName } from "../../qdm_query_ids";
var queries = {
  fullread: function fullread(type) {
    return {
      db_name: dbName,
      entity: "FrequencyMaster",
      sort: "FrequencyMaster.freqcode",
      return_fields: "MERGE(FrequencyMaster,{scheduleby:DOCUMENT(FrequencyMaster.scheduleby),dosefreqrateUOM:DOCUMENT(FrequencyMaster.dosefreqrateUOM),dosefreqvalUOM:DOCUMENT(FrequencyMaster.dosefreqvalUOM),fixeddurationtype:DOCUMENT(FrequencyMaster.fixeddurationtype),frequencytype:DOCUMENT(FrequencyMaster.frequencytype),startday:DOCUMENT(FrequencyMaster.startday)})"
    };
  },
  SCHEDULEBY: function SCHEDULEBY() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.activestatus==true && CodeableConceptMaster.Type=='SCHEDULEBY'",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  UOM: function UOM() {
    // return {
    //   db_name: dbName,
    //   entity: "DrugUOM",
    //   sort: "DrugUOM.UOM",
    //   return_fields: "DrugUOM",
    // };
    return {
      "db_name": dbName,
      "entity": "CodingMaster",
      "filter": "CodingMaster.Type == 'UOM' && CodingMaster.status == true && CodingMaster.activestatus == true",
      "return_fields": "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status','shortdesc','longdesc','activestatus')",
      "sort": "CodingMaster.shortdesc"
    };
  },
  WEEKDAYS: function WEEKDAYS() {
    // return {
    //   db_name: dbName,
    //   entity: "CodeableConceptMaster",
    //   filter:
    //     "CodeableConceptMaster.activestatus==true && CodeableConceptMaster.Type=='WEEKDAYS'",
    //   return_fields:
    //     "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})",
    // };
    return {
      db_name: dbName,
      entity: "CodingMaster",
      filter: "CodingMaster.Type == 'WEEKDAYS' && CodingMaster.status == true && CodingMaster.activestatus == true",
      return_fields: "KEEP(CodingMaster,'_id','id','_key','code','display','Type','status','activestatus')",
      sort: "CodingMaster.code"
    };
  },
  FIXEDDURATIONTYPE: function FIXEDDURATIONTYPE() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.activestatus==true && CodeableConceptMaster.Type=='FIXEDDURATIONTYPE'",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  FREQUENCYTYPE: function FREQUENCYTYPE() {
    return {
      db_name: dbName,
      entity: "CodeableConceptMaster",
      sort: "document(CodeableConceptMaster.coding[0]).display",
      filter: "CodeableConceptMaster.activestatus==true && CodeableConceptMaster.Type=='FREQUENCYTYPE'",
      return_fields: "MERGE(CodeableConceptMaster,{coding:(FOR cod IN CodeableConceptMaster.coding RETURN DOCUMENT(cod))})"
    };
  },
  FREQUENCYTYPESTATUS: function FREQUENCYTYPESTATUS(data, key) {
    return [{
      db_name: dbName,
      entity: "FrequencyMaster",
      is_metadata: true,
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      filter: {
        _key: "".concat(key)
      },
      doc: {
        status: data
      }
    }];
  },
  SINGLEREADDOC: function SINGLEREADDOC(key) {
    return {
      db_name: dbName,
      entity: "FrequencyMaster",
      filter: "FrequencyMaster._key=='".concat(key, "'"),
      return_fields: "MERGE(FrequencyMaster,{scheduleby:DOCUMENT(FrequencyMaster.scheduleby),dosefreqrateUOM:DOCUMENT(FrequencyMaster.dosefreqrateUOM),dosefreqvalUOM:DOCUMENT(FrequencyMaster.dosefreqvalUOM),fixeddurationtype:DOCUMENT(FrequencyMaster.fixeddurationtype),frequencytype:DOCUMENT(FrequencyMaster.frequencytype),startday:DOCUMENT(FrequencyMaster.startday)})"
    };
  }
};

var generateJson = {
  insert_json: function insert_json(data, key) {
    var _data$frequencyDefini, _data$frequencyDefini2, _data$frequencyDefini3, _data$frequencyDescri, _data$frequencyDescri2, _data$frequencyDescri3, _data$frequencyDescri4, _data$frequencyDescri5, _data$frequencyDescri6, _data$frequencyDescri7, _data$frequencyDescri8, _data$frequencyDescri9, _data$frequencyDescri10, _data$frequencyDescri11, _data$frequencyDescri12, _data$frequencyDescri13, _data$frequencyDescri14, _data$frequencyDescri15;

    var filter = {};

    if (key) {
      filter = {
        filter: {
          _key: "".concat(key)
        }
      };
    }

    return [_objectSpread2(_objectSpread2({
      db_name: dbName,
      entity: "FrequencyMaster",
      is_metadata: true
    }, filter), {}, {
      metadataId: "04ecb73d-f048-44ce-8563-c9be015812dd",
      doc: {
        freqcode: data === null || data === void 0 ? void 0 : (_data$frequencyDefini = data.frequencyDefinition) === null || _data$frequencyDefini === void 0 ? void 0 : _data$frequencyDefini.frequencyCode,
        shortdesc: data === null || data === void 0 ? void 0 : (_data$frequencyDefini2 = data.frequencyDefinition) === null || _data$frequencyDefini2 === void 0 ? void 0 : _data$frequencyDefini2.shortDescription,
        longdesc: data === null || data === void 0 ? void 0 : (_data$frequencyDefini3 = data.frequencyDefinition) === null || _data$frequencyDefini3 === void 0 ? void 0 : _data$frequencyDefini3.longDescription,
        scheduleby: data === null || data === void 0 ? void 0 : (_data$frequencyDescri = data.frequencyDescription) === null || _data$frequencyDescri === void 0 ? void 0 : (_data$frequencyDescri2 = _data$frequencyDescri.scheduleBy) === null || _data$frequencyDescri2 === void 0 ? void 0 : _data$frequencyDescri2.value,
        dosefreqval: parseFloat(data === null || data === void 0 ? void 0 : (_data$frequencyDescri3 = data.frequencyDescription) === null || _data$frequencyDescri3 === void 0 ? void 0 : (_data$frequencyDescri4 = _data$frequencyDescri3.doseFrequencyValue) === null || _data$frequencyDescri4 === void 0 ? void 0 : _data$frequencyDescri4.value),
        dosefreqvalUOM: data === null || data === void 0 ? void 0 : (_data$frequencyDescri5 = data.frequencyDescription) === null || _data$frequencyDescri5 === void 0 ? void 0 : (_data$frequencyDescri6 = _data$frequencyDescri5.doseFrequencyValue) === null || _data$frequencyDescri6 === void 0 ? void 0 : (_data$frequencyDescri7 = _data$frequencyDescri6.type) === null || _data$frequencyDescri7 === void 0 ? void 0 : _data$frequencyDescri7.value,
        dosefreqrateval: parseFloat(data === null || data === void 0 ? void 0 : (_data$frequencyDescri8 = data.frequencyDescription) === null || _data$frequencyDescri8 === void 0 ? void 0 : (_data$frequencyDescri9 = _data$frequencyDescri8.doseFrequencyRateValue) === null || _data$frequencyDescri9 === void 0 ? void 0 : _data$frequencyDescri9.value),
        dosefreqrateUOM: data === null || data === void 0 ? void 0 : (_data$frequencyDescri10 = data.frequencyDescription) === null || _data$frequencyDescri10 === void 0 ? void 0 : (_data$frequencyDescri11 = _data$frequencyDescri10.doseFrequencyRateValue) === null || _data$frequencyDescri11 === void 0 ? void 0 : (_data$frequencyDescri12 = _data$frequencyDescri11.type) === null || _data$frequencyDescri12 === void 0 ? void 0 : _data$frequencyDescri12.value,
        startday: data === null || data === void 0 ? void 0 : (_data$frequencyDescri13 = data.frequencyDescription) === null || _data$frequencyDescri13 === void 0 ? void 0 : (_data$frequencyDescri14 = _data$frequencyDescri13.startDay) === null || _data$frequencyDescri14 === void 0 ? void 0 : _data$frequencyDescri14.value,
        starttime: parseInt(moment__default["default"](data === null || data === void 0 ? void 0 : (_data$frequencyDescri15 = data.frequencyDescription) === null || _data$frequencyDescri15 === void 0 ? void 0 : _data$frequencyDescri15.startTime).format("X")),
        graceperiod: parseFloat(data.frequencyDescription.gracePeriod),
        fixedduration: parseFloat(data.frequencyDescription.fixedDuration),
        fixeddurationtype: data.frequencyDescription.fixedDurationType.value,
        frequencypattern: data.frequencyDescription.frequencyPattern,
        frequencytype: data.frequencyDescription.frequencyType.value,
        dosagedirection: data.frequencyDescription.dosageDirection,
        Isfirstdose: data.frequencyDescription.firstDone,
        status: true
      }
    })];
  }
};
var generateReadJson = {
  read_json: function read_json(data) {
    var _data$scheduleby$_id, _data$scheduleby, _data$dosefreqvalUOM, _data$dosefreqvalUOM$, _data$dosefreqvalUOM2, _data$dosefreqrateUOM, _data$dosefreqrateUOM2, _data$dosefreqrateUOM3, _data$startday, _data$startday$_id, _data$startday2, _data$fixeddurationty, _data$fixeddurationty2, _data$fixeddurationty3, _data$frequencytype$_, _data$frequencytype, _data$frequencytype2;

    return {
      key: data === null || data === void 0 ? void 0 : data._key,
      frequencyDefinition_: {
        frequencyCode_: data === null || data === void 0 ? void 0 : data.freqcode,
        shortDescription_: data === null || data === void 0 ? void 0 : data.shortdesc,
        longDescription_: data === null || data === void 0 ? void 0 : data.longdesc
      },
      frequencyDescription_: {
        scheduleBy_: {
          label: data.scheduleby.display,
          value: (_data$scheduleby$_id = (_data$scheduleby = data.scheduleby) === null || _data$scheduleby === void 0 ? void 0 : _data$scheduleby._id) !== null && _data$scheduleby$_id !== void 0 ? _data$scheduleby$_id : null
        },
        doseFrequencyValue: {
          value: data === null || data === void 0 ? void 0 : data.dosefreqval,
          type: {
            label: data === null || data === void 0 ? void 0 : (_data$dosefreqvalUOM = data.dosefreqvalUOM) === null || _data$dosefreqvalUOM === void 0 ? void 0 : _data$dosefreqvalUOM.UOM,
            value: (_data$dosefreqvalUOM$ = data === null || data === void 0 ? void 0 : (_data$dosefreqvalUOM2 = data.dosefreqvalUOM) === null || _data$dosefreqvalUOM2 === void 0 ? void 0 : _data$dosefreqvalUOM2._id) !== null && _data$dosefreqvalUOM$ !== void 0 ? _data$dosefreqvalUOM$ : null
          }
        },
        doseFrequencyRateValue: {
          value: data === null || data === void 0 ? void 0 : data.dosefreqrateval,
          type: {
            label: data === null || data === void 0 ? void 0 : (_data$dosefreqrateUOM = data.dosefreqrateUOM) === null || _data$dosefreqrateUOM === void 0 ? void 0 : _data$dosefreqrateUOM.UOM,
            value: (_data$dosefreqrateUOM2 = data === null || data === void 0 ? void 0 : (_data$dosefreqrateUOM3 = data.dosefreqrateUOM) === null || _data$dosefreqrateUOM3 === void 0 ? void 0 : _data$dosefreqrateUOM3._id) !== null && _data$dosefreqrateUOM2 !== void 0 ? _data$dosefreqrateUOM2 : null
          }
        },
        startDay: {
          label: data === null || data === void 0 ? void 0 : (_data$startday = data.startday) === null || _data$startday === void 0 ? void 0 : _data$startday.display,
          value: (_data$startday$_id = data === null || data === void 0 ? void 0 : (_data$startday2 = data.startday) === null || _data$startday2 === void 0 ? void 0 : _data$startday2._id) !== null && _data$startday$_id !== void 0 ? _data$startday$_id : null
        },
        startTime_: moment__default["default"](data === null || data === void 0 ? void 0 : data.starttime, "X").format(),
        gracePeriod_: data === null || data === void 0 ? void 0 : data.graceperiod,
        fixedDuration_: data === null || data === void 0 ? void 0 : data.fixedduration,
        fixedDurationType_: {
          label: data === null || data === void 0 ? void 0 : (_data$fixeddurationty = data.fixeddurationtype) === null || _data$fixeddurationty === void 0 ? void 0 : _data$fixeddurationty.display,
          value: (_data$fixeddurationty2 = data === null || data === void 0 ? void 0 : (_data$fixeddurationty3 = data.fixeddurationtype) === null || _data$fixeddurationty3 === void 0 ? void 0 : _data$fixeddurationty3._id) !== null && _data$fixeddurationty2 !== void 0 ? _data$fixeddurationty2 : null
        },
        frequencyPattern_: data === null || data === void 0 ? void 0 : data.frequencypattern,
        frequencyType_: {
          value: (_data$frequencytype$_ = data === null || data === void 0 ? void 0 : (_data$frequencytype = data.frequencytype) === null || _data$frequencytype === void 0 ? void 0 : _data$frequencytype._id) !== null && _data$frequencytype$_ !== void 0 ? _data$frequencytype$_ : null,
          label: data === null || data === void 0 ? void 0 : (_data$frequencytype2 = data.frequencytype) === null || _data$frequencytype2 === void 0 ? void 0 : _data$frequencytype2.display
        },
        dosageDirection_: data === null || data === void 0 ? void 0 : data.dosagedirection,
        firstDone_: data === null || data === void 0 ? void 0 : data.Isfirstdose
      }
    };
  }
};

var _extraReducers;
var DRUG_FREQUENCY_READ = toolkit.createAsyncThunk("drugMasterFREQUENCYSlice/drug_frequncy_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
  var _ref2,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args = arguments;

  return _regeneratorRuntime().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 1 ? _args[1] : undefined, rejectWithValue = _ref2.rejectWithValue;
          _context.prev = 2;
          queriesjson = queries.fullread();
          _context.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context.sent;
          arry = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._key && val !== null && val !== void 0 && val.longdesc) {
              arry.push({
                code: val === null || val === void 0 ? void 0 : val.freqcode,
                longDesc: val === null || val === void 0 ? void 0 : val.longdesc,
                shortDesc: val === null || val === void 0 ? void 0 : val.shortdesc,
                status: val === null || val === void 0 ? void 0 : val.status,
                key: val === null || val === void 0 ? void 0 : val._key
              });
            }
          });
          return _context.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context.t0.message
          })));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[2, 12]]);
})));
var DRUG_SCHEDULEBY_READ = toolkit.createAsyncThunk("drugMasterFREQUENCYSlice/drug_schedule_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
  var _ref4,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args2 = arguments;

  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref4 = _args2.length > 1 ? _args2[1] : undefined, rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          queriesjson = queries.SCHEDULEBY();
          _context2.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context2.sent;
          arry = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._key && val !== null && val !== void 0 && val.activestatus) {
              var _val$coding$, _val$coding$2;

              arry.push({
                label: val === null || val === void 0 ? void 0 : (_val$coding$ = val.coding[0]) === null || _val$coding$ === void 0 ? void 0 : _val$coding$.display,
                value: val === null || val === void 0 ? void 0 : (_val$coding$2 = val.coding[0]) === null || _val$coding$2 === void 0 ? void 0 : _val$coding$2._id
              });
            }
          });
          return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context2.t0.message
          })));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2, null, [[2, 12]]);
})));
var DRUG_WEEKDAYS_READ = toolkit.createAsyncThunk("drugMasterFREQUENCYSlice/drug_weekdays_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
  var _ref6,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args3 = arguments;

  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref6 = _args3.length > 1 ? _args3[1] : undefined, rejectWithValue = _ref6.rejectWithValue;
          _context3.prev = 2;
          queriesjson = queries.WEEKDAYS();
          _context3.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context3.sent;
          arry = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._key && val !== null && val !== void 0 && val.activestatus) {
              arry.push({
                label: val === null || val === void 0 ? void 0 : val.display,
                value: val === null || val === void 0 ? void 0 : val._id
              });
            }
          });
          return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context3.t0.message
          })));

        case 15:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee3, null, [[2, 12]]);
})));
var DRUG_FIXEDDURATIONTYPE_READ = toolkit.createAsyncThunk("drugMasterFREQUENCYSlice/drug_fixeddurationType_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
  var _ref8,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args4 = arguments;

  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref8 = _args4.length > 1 ? _args4[1] : undefined, rejectWithValue = _ref8.rejectWithValue;
          _context4.prev = 2;
          queriesjson = queries.FIXEDDURATIONTYPE();
          _context4.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context4.sent;
          arry = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._key && val !== null && val !== void 0 && val.activestatus) {
              var _val$coding$3, _val$coding$4;

              arry.push({
                label: val === null || val === void 0 ? void 0 : (_val$coding$3 = val.coding[0]) === null || _val$coding$3 === void 0 ? void 0 : _val$coding$3.display,
                value: val === null || val === void 0 ? void 0 : (_val$coding$4 = val.coding[0]) === null || _val$coding$4 === void 0 ? void 0 : _val$coding$4._id
              });
            }
          });
          return _context4.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context4.t0.message
          })));

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, null, [[2, 12]]);
})));
var DRUG_FREQUENCYTYPE_READ = toolkit.createAsyncThunk("drugMasterFREQUENCYSlice/drug_frequnecyType_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
  var _ref10,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args5 = arguments;

  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _ref10 = _args5.length > 1 ? _args5[1] : undefined, rejectWithValue = _ref10.rejectWithValue;
          _context5.prev = 2;
          queriesjson = queries.FREQUENCYTYPE();
          _context5.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context5.sent;
          arry = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._key && val !== null && val !== void 0 && val.activestatus) {
              var _val$coding$5, _val$coding$6;

              arry.push({
                label: val === null || val === void 0 ? void 0 : (_val$coding$5 = val.coding[0]) === null || _val$coding$5 === void 0 ? void 0 : _val$coding$5.display,
                value: val === null || val === void 0 ? void 0 : (_val$coding$6 = val.coding[0]) === null || _val$coding$6 === void 0 ? void 0 : _val$coding$6._id
              });
            }
          });
          return _context5.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](2);
          return _context5.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context5.t0.message
          })));

        case 15:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5, null, [[2, 12]]);
})));
var DRUG_FREQUENCY_UOM_READ = toolkit.createAsyncThunk("drugMasterFREQUENCYSlice/drug_frequncy_uom_list", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
  var _ref12,
      rejectWithValue,
      queriesjson,
      data,
      arry,
      _args6 = arguments;

  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _ref12 = _args6.length > 1 ? _args6[1] : undefined, rejectWithValue = _ref12.rejectWithValue;
          _context6.prev = 2;
          queriesjson = queries.UOM();
          _context6.next = 6;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 6:
          data = _context6.sent;
          arry = [];
          data.result.map(function (val) {
            if (val !== null && val !== void 0 && val._key && val !== null && val !== void 0 && val.activestatus) {
              arry.push({
                label: val === null || val === void 0 ? void 0 : val.display,
                value: val === null || val === void 0 ? void 0 : val._id
              });
            }
          });
          return _context6.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6["catch"](2);
          return _context6.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context6.t0.message
          })));

        case 15:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, null, [[2, 12]]);
})));
var UOM_DRUG_FREQ_INSERT = toolkit.createAsyncThunk("drugMasterFREQUENCYSlice/drug_uom_freq_insert", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
  var payload,
      _ref14,
      rejectWithValue,
      data,
      key,
      queriesjson,
      Insertdata,
      _args7 = arguments;

  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          payload = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
          _ref14 = _args7.length > 1 ? _args7[1] : undefined, rejectWithValue = _ref14.rejectWithValue;
          _context7.prev = 2;
          data = payload.data, key = payload.key;
          queriesjson = generateJson.insert_json(data, key);
          _context7.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          Insertdata = _context7.sent;
          return _context7.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: Insertdata
          }));

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7["catch"](2);
          return _context7.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject), {}, {
            message: _context7.t0.message
          })));

        case 15:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, null, [[2, 12]]);
})));
var UOM_DRUG_FREQ_STATUS = toolkit.createAsyncThunk("drugMasterFREQUENCYSlice/drug_uom_freq_status", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
  var payload,
      _ref16,
      rejectWithValue,
      key,
      data,
      queriesjson,
      arry,
      _args8 = arguments;

  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          payload = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
          _ref16 = _args8.length > 1 ? _args8[1] : undefined, rejectWithValue = _ref16.rejectWithValue;
          _context8.prev = 2;
          key = payload.key, data = payload.data;
          queriesjson = queries.FREQUENCYTYPESTATUS(data, key);
          _context8.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __uspsertUrl__);

        case 7:
          _context8.sent;
          arry = [];
          return _context8.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: arry
          }));

        case 12:
          _context8.prev = 12;
          _context8.t0 = _context8["catch"](2);
          return _context8.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context8.t0.message
          })));

        case 15:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, null, [[2, 12]]);
})));
var DRUG_FREQ_READ_SINGLE = toolkit.createAsyncThunk("drugMasterFREQUENCYSlice/drug_freq_read_single_yt", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
  var payload,
      _ref18,
      rejectWithValue,
      key,
      queriesjson,
      data,
      read_json,
      _args9 = arguments;

  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          payload = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
          _ref18 = _args9.length > 1 ? _args9[1] : undefined, rejectWithValue = _ref18.rejectWithValue;
          _context9.prev = 2;
          key = payload.key;
          queriesjson = queries.SINGLEREADDOC(key);
          _context9.next = 7;
          return fetchData({
            body: JSON.stringify(queriesjson)
          }, __readDocumentUrl__);

        case 7:
          data = _context9.sent;
          read_json = generateReadJson.read_json(data.result[0]);
          return _context9.abrupt("return", _objectSpread2(_objectSpread2({}, defaultState.List), {}, {
            data: read_json
          }));

        case 12:
          _context9.prev = 12;
          _context9.t0 = _context9["catch"](2);
          return _context9.abrupt("return", rejectWithValue(_objectSpread2(_objectSpread2({}, defaultReject.List), {}, {
            message: _context9.t0.message
          })));

        case 15:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, null, [[2, 12]]);
})));
var drugMasterFREQUENCYSlice = toolkit.createSlice({
  name: "drug_frequncy_list",
  initialState: {
    drug_frequncy_list: _objectSpread2({}, defaultState.List),
    drug_schedule_list: _objectSpread2({}, defaultState.List),
    drug_frequncy_uom_list: _objectSpread2({}, defaultState.List),
    drug_weekdays_list: _objectSpread2({}, defaultState.List),
    drug_fixeddurationType_list: _objectSpread2({}, defaultState.List),
    drug_frequnecyType_list: _objectSpread2({}, defaultState.List),
    drug_uom_freq_insert: _objectSpread2({}, defaultState.List),
    drug_uom_freq_status: _objectSpread2({}, defaultState.List),
    drug_freq_read_single_yt: _objectSpread2({}, defaultState.List)
  },
  extraReducers: (_extraReducers = {}, _defineProperty(_extraReducers, DRUG_FREQUENCY_READ.fulfilled, function (state, action) {
    state.drug_frequncy_list.loading = false, state.drug_frequncy_list.error = false, state.drug_frequncy_list = action.payload;
  }), _defineProperty(_extraReducers, DRUG_FREQUENCY_READ.pending, function (state, action) {
    state.drug_frequncy_list.loading = true, state.drug_frequncy_list.error = false, state.drug_frequncy_list.loading = true;
  }), _defineProperty(_extraReducers, DRUG_FREQUENCY_READ.rejected, function (state, action) {
    state.drug_frequncy_list.loading = false, state.drug_frequncy_list.error = true, state.drug_frequncy_list = action.payload;
  }), _defineProperty(_extraReducers, DRUG_SCHEDULEBY_READ.fulfilled, function (state, action) {
    state.drug_schedule_list.loading = false, state.drug_schedule_list.error = false, state.drug_schedule_list = action.payload;
  }), _defineProperty(_extraReducers, DRUG_SCHEDULEBY_READ.pending, function (state, action) {
    state.drug_schedule_list.loading = true, state.drug_schedule_list.error = false, state.drug_schedule_list.loading = true;
  }), _defineProperty(_extraReducers, DRUG_SCHEDULEBY_READ.rejected, function (state, action) {
    state.drug_schedule_list.loading = false, state.drug_schedule_list.error = true, state.drug_schedule_list = action.payload;
  }), _defineProperty(_extraReducers, DRUG_FREQUENCY_UOM_READ.fulfilled, function (state, action) {
    state.drug_frequncy_uom_list.loading = false, state.drug_frequncy_uom_list.error = false, state.drug_frequncy_uom_list = action.payload;
  }), _defineProperty(_extraReducers, DRUG_FREQUENCY_UOM_READ.pending, function (state, action) {
    state.drug_frequncy_uom_list.loading = true, state.drug_frequncy_uom_list.error = false, state.drug_frequncy_uom_list.loading = true;
  }), _defineProperty(_extraReducers, DRUG_FREQUENCY_UOM_READ.rejected, function (state, action) {
    state.drug_frequncy_uom_list.loading = false, state.drug_frequncy_uom_list.error = true, state.drug_frequncy_uom_list = action.payload;
  }), _defineProperty(_extraReducers, DRUG_WEEKDAYS_READ.fulfilled, function (state, action) {
    state.drug_weekdays_list.loading = false, state.drug_weekdays_list.error = false, state.drug_weekdays_list = action.payload;
  }), _defineProperty(_extraReducers, DRUG_WEEKDAYS_READ.pending, function (state, action) {
    state.drug_weekdays_list.loading = true, state.drug_weekdays_list.error = false, state.drug_weekdays_list.loading = true;
  }), _defineProperty(_extraReducers, DRUG_WEEKDAYS_READ.rejected, function (state, action) {
    state.drug_weekdays_list.loading = false, state.drug_weekdays_list.error = true, state.drug_weekdays_list = action.payload;
  }), _defineProperty(_extraReducers, DRUG_FIXEDDURATIONTYPE_READ.fulfilled, function (state, action) {
    state.drug_fixeddurationType_list.loading = false, state.drug_fixeddurationType_list.error = false, state.drug_fixeddurationType_list = action.payload;
  }), _defineProperty(_extraReducers, DRUG_FIXEDDURATIONTYPE_READ.pending, function (state, action) {
    state.drug_fixeddurationType_list.loading = true, state.drug_fixeddurationType_list.error = false, state.drug_fixeddurationType_list.loading = true;
  }), _defineProperty(_extraReducers, DRUG_FIXEDDURATIONTYPE_READ.rejected, function (state, action) {
    state.drug_fixeddurationType_list.loading = false, state.drug_fixeddurationType_list.error = true, state.drug_fixeddurationType_list = action.payload;
  }), _defineProperty(_extraReducers, DRUG_FREQUENCYTYPE_READ.fulfilled, function (state, action) {
    state.drug_frequnecyType_list.loading = false, state.drug_frequnecyType_list.error = false, state.drug_frequnecyType_list = action.payload;
  }), _defineProperty(_extraReducers, DRUG_FREQUENCYTYPE_READ.pending, function (state, action) {
    state.drug_frequnecyType_list.loading = true, state.drug_frequnecyType_list.error = false, state.drug_frequnecyType_list.loading = true;
  }), _defineProperty(_extraReducers, DRUG_FREQUENCYTYPE_READ.rejected, function (state, action) {
    state.drug_frequnecyType_list.loading = false, state.drug_frequnecyType_list.error = true, state.drug_frequnecyType_list = action.payload;
  }), _defineProperty(_extraReducers, UOM_DRUG_FREQ_INSERT.fulfilled, function (state, action) {
    state.drug_uom_freq_insert.loading = false, state.drug_uom_freq_insert.error = false, state.drug_uom_freq_insert = action.payload;
  }), _defineProperty(_extraReducers, UOM_DRUG_FREQ_INSERT.pending, function (state, action) {
    state.drug_uom_freq_insert.loading = true, state.drug_uom_freq_insert.error = false, state.drug_uom_freq_insert.loading = true;
  }), _defineProperty(_extraReducers, UOM_DRUG_FREQ_INSERT.rejected, function (state, action) {
    state.drug_uom_freq_insert.loading = false, state.drug_uom_freq_insert.error = true, state.drug_uom_freq_insert = action.payload;
  }), _defineProperty(_extraReducers, UOM_DRUG_FREQ_STATUS.fulfilled, function (state, action) {
    state.drug_uom_freq_status.loading = false, state.drug_uom_freq_status.error = false, state.drug_uom_freq_status = action.payload;
  }), _defineProperty(_extraReducers, UOM_DRUG_FREQ_STATUS.pending, function (state, action) {
    state.drug_uom_freq_status.loading = true, state.drug_uom_freq_status.error = false, state.drug_uom_freq_status.loading = true;
  }), _defineProperty(_extraReducers, UOM_DRUG_FREQ_STATUS.rejected, function (state, action) {
    state.drug_uom_freq_status.loading = false, state.drug_uom_freq_status.error = true, state.drug_uom_freq_status = action.payload;
  }), _defineProperty(_extraReducers, DRUG_FREQ_READ_SINGLE.fulfilled, function (state, action) {
    state.drug_freq_read_single_yt.loading = false, state.drug_freq_read_single_yt.error = false, state.drug_freq_read_single_yt = action.payload;
  }), _defineProperty(_extraReducers, DRUG_FREQ_READ_SINGLE.pending, function (state, action) {
    state.drug_freq_read_single_yt.loading = true, state.drug_freq_read_single_yt.error = false, state.drug_freq_read_single_yt.loading = true;
  }), _defineProperty(_extraReducers, DRUG_FREQ_READ_SINGLE.rejected, function (state, action) {
    state.drug_freq_read_single_yt.loading = false, state.drug_freq_read_single_yt.error = true, state.drug_freq_read_single_yt = action.payload;
  }), _extraReducers)
});
drugMasterFREQUENCYSlice.reducer;

var drug_actions = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, drugCategoryActions), drugDosageActions), drugClassActions), drugRoutesActions), drugDirectionRoutesActions), drugMasterUomActions);

var flexMaster = _objectSpread2({}, flexAttributeActions);

var flexCriteriaApp = _objectSpread2({}, flexCriteriaActions);

var consultActions = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, ageRangeMasterActions), vitalsMasters), orderMasters), drug_actions), orderSetMasterActions), orderSetApplicabilityActions), allergenMasterActions), flexMaster), flexCriteriaApp), diagnosisMasterActions);

var roles_actions = _objectSpread2({}, roleActions);

var repository_actions = _objectSpread2({}, repositoryActions);

var permission_actions = _objectSpread2({}, permissionActions);

var person_actions = _objectSpread2({}, personActions);

var user_actions = _objectSpread2({}, userActions);

var user_management_actions = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, roles_actions), repository_actions), permission_actions), person_actions), user_actions);

var organizationConfiActions = _objectSpread2({}, organization_config_actions);
var ordernatureActions = _objectSpread2({}, ordernature_role_actions);
var ordertypeActions = _objectSpread2({}, ordertype_role_actions);
var organizationConfigMasterAction = _objectSpread2({}, organization_config_master_action);
var organizationMasterActions = _objectSpread2({}, organization_role_actions);
var locationActions = _objectSpread2({}, location_master_actions);
var practitionerActions = _objectSpread2({}, practitioner_role_actions);
var userManagementActions = _objectSpread2({}, user_management_actions);

var actions = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, Edit_Orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_ZBjTJActions), Edit_Orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_ZBjTJActions), Edit_Orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_a8JXXActions), editcontactpointpharmacy_contact_contactmode_dropdown_zorJVActions), editcontactpointpharmacy_contact_use_dropdown_zorJVActions), editcontactpointpharmacy_contact_priority_dropdown_zorJVActions), EditNewPharmacypharmacy_update_a0GKUActions), EditNewPharmacypharmacy_singleread_kbnjkActions), EditNewPharmacypharmacy_entitytype_dropdown_kbnjkActions), EditNewPharmacypharmacy_entityname_dropdown_kbnjkActions), EditNewPharmacypharmacy_locationtype_dropdown_kbnjkActions), EditNewPharmacypharmacy_operationstatus_dropdown_kbnjkActions), EditNewPharmacypharmacy_parentlocationid_description_dropdown_kbnjkActions), EditNewPharmacypharmacy_locationroletype_dropdown_kbnjkActions), EditNewPharmacypharmacy_inventrysubtype_dropdown_kbnjkActions), contactpointpharmacy_contact_contactmode_dropdown_VqEMpActions), contactpointpharmacy_contact_use_dropdown_VqEMpActions), contactpointpharmacy_contact_priority_dropdown_VqEMpActions), addnewpharmacypharmacy_entitytype_dropdown_3YRAVActions), addnewpharmacypharmacy_entityname_dropdown_3YRAVActions), addnewpharmacypharmacy_locationtype_dropdown_3YRAVActions), addnewpharmacypharmacy_operationstatus_dropdown_3YRAVActions), addnewpharmacypharmacy_parentlocationid_description_dropdown_3YRAVActions), addnewpharmacypharmacy_locationroletype_dropdown_3YRAVActions), addnewpharmacypharmacy_inventrysubtype_dropdown_3YRAVActions), addnewpharmacypharmacy_insert_nDuhJActions), orderingdetailspharmacy_orderrouting_orderingfacility_dropdown_BtPu1Actions), orderingdetailspharmacy_orderrouting_sourcelocationtype_dropdown_BtPu1Actions), orderingdetailspharmacy_orderrouting_sourcelocation_dropdown_pGqoMActions), pharmacytablepharmacy_fullread_pnrrOActions), schedulelinesfrequencymaster_days_dropdown_m1WbyActions), tablerowfrequencymaster_fullread_aFir7Actions), edit_schedulelinesfrequencymaster_days_dropdown_ZifnBActions), addnewfrequency_orgfrequencymaster_frequencytype_dropdown_OE55YActions), addnewfrequency_orgfrequencymaster_uom_dropdown_OE55YActions), addnewfrequency_orgfrequencymaster_insert_lHc7nActions), addnewfrequency_orgfrequencymaster_days_dropdown_j5qvCActions), EditNewFrequency_orgfrequencymaster_frequencytype_dropdown_7zRrnActions), EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrnActions), EditNewFrequency_orgfrequencymaster_singleread_7zRrnActions), EditNewFrequency_orgfrequencymaster_days_dropdown_7zRrnActions), EditNewFrequency_orgfrequencymaster_update_wiw9RActions), drugActions), EditNewFrequency_orgbase_frequency_dropdownActions), frequency_schedule_status_updataActions), schedule_line_day_dropdownActions), phramcyFrameworkActions), signInActions), drugCatalogMasterActions), group_dropdownActions), MedicationMastersActions), cartDefinitionMasterActions), frequencyMasterActions), organizationConfiActions), organizationConfigMasterAction), organizationMasterActions), pendingRescheduleListMasters), locationActions), userManagementActions), practitionerActions), consultActions), ordertypeActions), ordernatureActions);

exports.actions = actions;
exports.rootReducer = index;
